'use strict';
var $linkingInfo = Object.freeze({
  "esVersion": 6,
  "assumingES6": true,
  "productionMode": false,
  "linkerVersion": "1.10.0",
  "fileLevelThis": this
});
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)))
  };
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = {};
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, {
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      });
      i = ((i + 1) | 0)
    };
    return descriptors
  })
})());
var $L0;
function $propertyName(arg0) {
  for (var prop in arg0) {
    return prop
  }
}
function $Char(c) {
  this.c = c
}
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c)
});
function $throwClassCastException(arg0, arg1) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError(new $c_jl_ClassCastException(((arg0 + " is not an instance of ") + arg1)))
}
function $throwArrayCastException(arg0, arg1, arg2) {
  while ((--arg2)) {
    arg1 = ("[" + arg1)
  };
  $throwClassCastException(arg0, arg1)
}
function $throwArrayIndexOutOfBoundsException(arg0) {
  throw new $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError($ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((arg0 === null) ? null : ("" + arg0))))
}
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object")
}
function $newArrayObject(arg0, arg1) {
  return $newArrayObjectInternal(arg0, arg1, 0)
}
function $newArrayObjectInternal(arg0, arg1, arg2) {
  var result = new arg0.constr(arg1[arg2]);
  if ((arg2 < (arg1.length - 1))) {
    var subArrayClassData = arg0.componentData;
    var subLengthIndex = (arg2 + 1);
    var underlying = result.u;
    for (var i = 0; (i < underlying.length); (i++)) {
      underlying[i] = $newArrayObjectInternal(subArrayClassData, arg1, subLengthIndex)
    }
  };
  return result
}
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0))
}
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0))
}
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf()
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf()
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf()
        } else {
          return $d_jl_Integer.getClassOf()
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.getClassOf()
      } else {
        return $d_jl_Double.getClassOf()
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf()
    }
    case "undefined": {
      return $d_jl_Void.getClassOf()
    }
    default: {
      if ((arg0 === null)) {
        return arg0.getClass__jl_Class()
      } else if ((arg0 instanceof $c_RTLong)) {
        return $d_jl_Long.getClassOf()
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf()
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf()
      } else {
        return null
      }
    }
  }
}
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String"
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte"
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short"
        } else {
          return "java.lang.Integer"
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float"
      } else {
        return "java.lang.Double"
      }
    }
    case "boolean": {
      return "java.lang.Boolean"
    }
    case "undefined": {
      return "java.lang.Void"
    }
    default: {
      if ((arg0 === null)) {
        return arg0.getClass__jl_Class()
      } else if ((arg0 instanceof $c_RTLong)) {
        return "java.lang.Long"
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character"
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name
      } else {
        return null.getName__T()
      }
    }
  }
}
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0)
  } else {
    return instance.codePointAt__I__I(x0)
  }
}
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0)
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0)
    }
    default: {
      if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__compareTo__O__I(instance, x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I(instance, x0)
      } else {
        return instance.compareTo__O__I(x0)
      }
    }
  }
}
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0)
  } else {
    return instance.compareTo__T__I(x0)
  }
}
function $dp_endsWith__T__Z(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__endsWith__T__Z(instance, x0)
  } else {
    return instance.endsWith__T__Z(x0)
  }
}
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0)
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0)
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0)
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0)
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__equals__O__Z(instance, x0)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z(instance, x0)
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0)
      }
    }
  }
}
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3)
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3)
  }
}
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance)
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance)
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance)
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I()
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__hashCode__I(instance)
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I(instance)
      } else {
        return $c_O.prototype.hashCode__I.call(instance)
      }
    }
  }
}
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0)
  } else {
    return instance.indexOf__I__I(x0)
  }
}
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1)
  } else {
    return instance.replaceAll__T__T__T(x0, x1)
  }
}
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1)
  } else {
    return instance.split__T__I__AT(x0, x1)
  }
}
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance)
  } else {
    return instance.toCharArray__AC()
  }
}
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString())
}
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance)
  } else {
    return instance.trim__T()
  }
}
function $intDiv(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 / arg1) | 0)
  }
}
function $intMod(arg0, arg1) {
  if ((arg1 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  } else {
    return ((arg0 % arg1) | 0)
  }
}
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)))
}
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc
    };
    superProto = getPrototypeOf(superProto)
  }
}
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value)
  }
}
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0)
    }
  };
  throw new TypeError((("super has no setter '" + arg2) + "'."))
}
function $moduleDefault(arg0) {
  return (((arg0 && ((typeof arg0) === "object")) && ("default" in arg0)) ? arg0["default"] : arg0)
}
function $arraycopyCheckBounds(arg0, arg1, arg2, arg3, arg4) {
  if ((((((arg1 < 0) || (arg3 < 0)) || (arg4 < 0)) || (arg1 > ((arg0 - arg4) | 0))) || (arg3 > ((arg2 - arg4) | 0)))) {
    $throwArrayIndexOutOfBoundsException(null)
  }
}
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  $arraycopyCheckBounds(arg0.length, arg1, arg2.length, arg3, arg4);
  if ((((arg0 !== arg2) || (arg3 < arg1)) || (((arg1 + arg4) | 0) < arg3))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)]
    }
  }
}
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj)
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj)
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj)
      };
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32))
      };
      return biHash
    }
    case "boolean": {
      return (obj ? 1231 : 1237)
    }
    case "undefined": {
      return 0
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description))
    }
    default: {
      if ((obj === null)) {
        return 0
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash)
        };
        return hash
      }
    }
  }
}
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))))
}
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)))
}
function $bC(arg0) {
  return new $Char(arg0)
}
var $bC0 = $bC(0);
function $uV(arg0) {
  return (((arg0 === (void 0)) || (arg0 === null)) ? (void 0) : $throwClassCastException(arg0, "java.lang.Void"))
}
function $uZ(arg0) {
  return ((((typeof arg0) === "boolean") || (arg0 === null)) ? (!(!arg0)) : $throwClassCastException(arg0, "java.lang.Boolean"))
}
function $uC(arg0) {
  return (((arg0 instanceof $Char) || (arg0 === null)) ? ((arg0 === null) ? 0 : arg0.c) : $throwClassCastException(arg0, "java.lang.Character"))
}
function $uB(arg0) {
  return (($isByte(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Byte"))
}
function $uS(arg0) {
  return (($isShort(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Short"))
}
function $uI(arg0) {
  return (($isInt(arg0) || (arg0 === null)) ? (arg0 | 0) : $throwClassCastException(arg0, "java.lang.Integer"))
}
function $uJ(arg0) {
  return (((arg0 instanceof $c_RTLong) || (arg0 === null)) ? ((arg0 === null) ? $L0 : arg0) : $throwClassCastException(arg0, "java.lang.Long"))
}
function $uF(arg0) {
  return (($isFloat(arg0) || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Float"))
}
function $uD(arg0) {
  return ((((typeof arg0) === "number") || (arg0 === null)) ? (+arg0) : $throwClassCastException(arg0, "java.lang.Double"))
}
function $uT(arg0) {
  return ((((typeof arg0) === "string") || (arg0 === null)) ? ((arg0 === null) ? "" : arg0) : $throwClassCastException(arg0, "java.lang.String"))
}
function $ct_O__($thiz) {
  return $thiz
}
/** @constructor */
function $c_O() {
  /*<skip>*/
}
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
  /*<skip>*/
}
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + $as_T($uD((i >>> 0)).toString(16)))
});
$c_O.prototype.toString = (function() {
  return this.toString__T()
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null
    }
  } else {
    this.u = arg
  }
}
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_O.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_O.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice())
});
function $ah_O() {
  /*<skip>*/
}
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false
    }
  } else {
    this.u = arg
  }
}
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_Z.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_Z.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice())
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Uint16Array(arg)
  } else {
    this.u = arg
  }
}
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_C.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_C.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice())
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int8Array(arg)
  } else {
    this.u = arg
  }
}
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_B.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_B.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice())
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int16Array(arg)
  } else {
    this.u = arg
  }
}
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_S.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_S.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice())
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int32Array(arg)
  } else {
    this.u = arg
  }
}
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_I.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_I.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice())
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = $L0
    }
  } else {
    this.u = arg
  }
}
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_J.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_J.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice())
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Float32Array(arg)
  } else {
    this.u = arg
  }
}
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_F.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_F.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice())
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Float64Array(arg)
  } else {
    this.u = arg
  }
}
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.get = (function(i) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  return this.u[i]
});
$ac_D.prototype.set = (function(i, v) {
  if (((i < 0) || (i >= this.u.length))) {
    $throwArrayIndexOutOfBoundsException(i)
  };
  this.u[i] = v
});
$ac_D.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyCheckBounds(this.u.length, srcPos, dest.u.length, destPos, length);
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos)
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice())
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isJSClass = false;
  this.isInstance = (void 0)
}
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = {};
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = ((that) => (that === self));
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass)
  };
  return this
});
$TypeData.prototype.initClass = (function(internalNameObj, isInterface, fullName, ancestors, isJSType, parentData, isInstance) {
  var internalName = $propertyName(internalNameObj);
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = ((that) => (!(!that.ancestors[internalName])));
  this.isJSType = (!(!isJSType));
  this.name = fullName;
  this.isInterface = isInterface;
  this.isInstance = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))));
  return this
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || ((that) => (self === that)));
  this.wrapArray = (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array)));
  this.isInstance = ((obj) => (obj instanceof arrayClass));
  return this
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null
      }
    } else {
      this.u = arg
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.copyTo = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length)
  });
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice())
  });
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  ArrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = {
    O: 1,
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  };
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)))
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = ((array) => new ArrayClass(array));
  var self = this;
  this.isInstance = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)))
  });
  return this
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this)
  };
  return this._arrayOf
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this)
  };
  return this._classOf
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that))
});
$TypeData.prototype.checkCast = (function(obj) {
  if ((((obj !== null) && (!this.isJSType)) && (!this.isInstance(obj)))) {
    $throwClassCastException(obj, this.name)
  }
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null)
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null)
});
$TypeData.prototype.newArrayOfThisClass = (function(lengths) {
  var arrayClassData = this;
  for (var i = 0; (i < lengths.length); (i++)) {
    arrayClassData = arrayClassData.getArrayOf()
  };
  return $newArrayObject(arrayClassData, lengths)
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth))
  }
}
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))))
}
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))))
}
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))))
}
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))))
}
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))))
}
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))))
}
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))))
}
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))))
}
function $asArrayOf_O(obj, depth) {
  if (($isArrayOf_O(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Ljava.lang.Object;", depth)
  }
}
function $asArrayOf_Z(obj, depth) {
  if (($isArrayOf_Z(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "Z", depth)
  }
}
function $asArrayOf_C(obj, depth) {
  if (($isArrayOf_C(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "C", depth)
  }
}
function $asArrayOf_B(obj, depth) {
  if (($isArrayOf_B(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "B", depth)
  }
}
function $asArrayOf_S(obj, depth) {
  if (($isArrayOf_S(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "S", depth)
  }
}
function $asArrayOf_I(obj, depth) {
  if (($isArrayOf_I(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "I", depth)
  }
}
function $asArrayOf_J(obj, depth) {
  if (($isArrayOf_J(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "J", depth)
  }
}
function $asArrayOf_F(obj, depth) {
  if (($isArrayOf_F(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "F", depth)
  }
}
function $asArrayOf_D(obj, depth) {
  if (($isArrayOf_D(obj, depth) || (obj === null))) {
    return obj
  } else {
    $throwArrayCastException(obj, "D", depth)
  }
}
var $d_O = new $TypeData();
$d_O.ancestors = {
  O: 1
};
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = ((that) => (!that.isPrimitive));
$d_O.name = "java.lang.Object";
$d_O.isInstance = ((obj) => (obj !== null));
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), ((that) => {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1))
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, Uint16Array);
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, Int8Array);
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, Int16Array);
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, Int32Array);
var $d_J = new $TypeData().initPrim(null, "J", "long", $ac_J, (void 0));
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, Float32Array);
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, Float64Array);
/** @constructor */
function $c_Lcats_Always$() {
  /*<skip>*/
}
$c_Lcats_Always$.prototype = new $h_O();
$c_Lcats_Always$.prototype.constructor = $c_Lcats_Always$;
/** @constructor */
function $h_Lcats_Always$() {
  /*<skip>*/
}
$h_Lcats_Always$.prototype = $c_Lcats_Always$.prototype;
$c_Lcats_Always$.prototype.apply__F0__Lcats_Always = (function(a) {
  return new $c_Lcats_Always(new $c_sjsr_AnonFunction0(((a$2) => (() => a$2.apply__O()))(a)))
});
var $d_Lcats_Always$ = new $TypeData().initClass({
  Lcats_Always$: 0
}, false, "cats.Always$", {
  Lcats_Always$: 1,
  O: 1
});
$c_Lcats_Always$.prototype.$classData = $d_Lcats_Always$;
var $n_Lcats_Always$;
function $m_Lcats_Always$() {
  if ((!$n_Lcats_Always$)) {
    $n_Lcats_Always$ = new $c_Lcats_Always$()
  };
  return $n_Lcats_Always$
}
/** @constructor */
function $c_Lcats_Eval$FnStack() {
  /*<skip>*/
}
$c_Lcats_Eval$FnStack.prototype = new $h_O();
$c_Lcats_Eval$FnStack.prototype.constructor = $c_Lcats_Eval$FnStack;
/** @constructor */
function $h_Lcats_Eval$FnStack() {
  /*<skip>*/
}
$h_Lcats_Eval$FnStack.prototype = $c_Lcats_Eval$FnStack.prototype;
/** @constructor */
function $c_Lcats_EvalInstances1() {
  /*<skip>*/
}
$c_Lcats_EvalInstances1.prototype = new $h_O();
$c_Lcats_EvalInstances1.prototype.constructor = $c_Lcats_EvalInstances1;
/** @constructor */
function $h_Lcats_EvalInstances1() {
  /*<skip>*/
}
$h_Lcats_EvalInstances1.prototype = $c_Lcats_EvalInstances1.prototype;
function $p_Lcats_Foldable$__loop$2__Lcats_Eval__F2__sc_Iterator__Lcats_Eval($thiz, lb$2, f$19, it) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((this$1, lb$2$2, f$19$2, it$2) => (() => (it$2.hasNext__Z() ? $as_Lcats_Eval(f$19$2.apply__O__O__O(it$2.next__O(), $p_Lcats_Foldable$__loop$2__Lcats_Eval__F2__sc_Iterator__Lcats_Eval(this$1, lb$2$2, f$19$2, it$2))) : lb$2$2)))($thiz, lb$2, f$19, it));
  return new $c_Lcats_Eval$$anon$5(a)
}
/** @constructor */
function $c_Lcats_Foldable$() {
  this.Lcats_Foldable$__f_cats$Foldable$$$sentinel = null;
  $n_Lcats_Foldable$ = this;
  this.Lcats_Foldable$__f_cats$Foldable$$$sentinel = new $c_Lcats_Foldable$$anon$2()
}
$c_Lcats_Foldable$.prototype = new $h_O();
$c_Lcats_Foldable$.prototype.constructor = $c_Lcats_Foldable$;
/** @constructor */
function $h_Lcats_Foldable$() {
  /*<skip>*/
}
$h_Lcats_Foldable$.prototype = $c_Lcats_Foldable$.prototype;
$c_Lcats_Foldable$.prototype.iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval = (function(iterable, lb, f) {
  return $m_Lcats_Eval$().always__F0__Lcats_Eval(new $c_sjsr_AnonFunction0(((iterable$2) => (() => iterable$2.iterator__sc_Iterator()))(iterable))).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2, lb$2, f$2) => ((it) => {
    var it$1 = $as_sc_Iterator(it);
    return $p_Lcats_Foldable$__loop$2__Lcats_Eval__F2__sc_Iterator__Lcats_Eval(this$2, lb$2, f$2, it$1)
  }))(this, lb, f)))
});
var $d_Lcats_Foldable$ = new $TypeData().initClass({
  Lcats_Foldable$: 0
}, false, "cats.Foldable$", {
  Lcats_Foldable$: 1,
  O: 1
});
$c_Lcats_Foldable$.prototype.$classData = $d_Lcats_Foldable$;
var $n_Lcats_Foldable$;
function $m_Lcats_Foldable$() {
  if ((!$n_Lcats_Foldable$)) {
    $n_Lcats_Foldable$ = new $c_Lcats_Foldable$()
  };
  return $n_Lcats_Foldable$
}
function $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f, semigroupal, functor) {
  return functor.map__O__F1__O(semigroupal.product__O__O__O(f0, f1), new $c_sjsr_AnonFunction1(((f$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a0 = x$1$1._1__O();
      var a1 = x$1$1._2__O();
      return f$2.apply__O__O__O(a0, a1)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(f)))
}
function $f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O($thiz, f0, f1, f2, f3, f, semigroupal, functor) {
  return functor.map__O__F1__O(semigroupal.product__O__O__O(f0, semigroupal.product__O__O__O(f1, semigroupal.product__O__O__O(f2, f3))), new $c_sjsr_AnonFunction1(((f$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x41 = $as_T2(x$1$1._2__O());
      var a0 = x$1$1._1__O();
      if ((x41 !== null)) {
        var x43 = $as_T2(x41._2__O());
        var a1 = x41._1__O();
        if ((x43 !== null)) {
          var a2 = x43._1__O();
          var a3 = x43._2__O();
          return f$2.apply__O__O__O__O__O(a0, a1, a2, a3)
        }
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))(f)))
}
/** @constructor */
function $c_Lcats_data_Chain() {
  /*<skip>*/
}
$c_Lcats_data_Chain.prototype = new $h_O();
$c_Lcats_data_Chain.prototype.constructor = $c_Lcats_data_Chain;
/** @constructor */
function $h_Lcats_data_Chain() {
  /*<skip>*/
}
$h_Lcats_data_Chain.prototype = $c_Lcats_data_Chain.prototype;
$c_Lcats_data_Chain.prototype.uncons__s_Option = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(this);
    var c = non;
    var rights = null;
    var result = null;
    while ((result === null)) {
      var x3 = c;
      if ((x3 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x3);
        var x13 = x$1.Lcats_data_Chain$Singleton__f_a;
        var next = ((rights === null) ? $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil : rights);
        result = new $c_T2(x13, next);
        continue
      };
      if ((x3 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x3);
        var x9 = x$1$1.Lcats_data_Chain$Append__f_leftNE;
        var x10 = x$1$1.Lcats_data_Chain$Append__f_rightNE;
        if ((rights === null)) {
          rights = x10
        } else {
          var rightNE = rights;
          rights = new $c_Lcats_data_Chain$Append(x10, rightNE)
        };
        c = x9;
        continue
      };
      if ((x3 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x3);
        var x6 = x$1$2.Lcats_data_Chain$Wrap__f_seq;
        var tail = $m_Lcats_data_Chain$().fromSeq__sci_Seq__Lcats_data_Chain($as_sci_Seq(x6.tail__O()));
        if ((rights === null)) {
          var next$2 = tail
        } else if ((tail instanceof $c_Lcats_data_Chain$NonEmpty)) {
          var non$2 = $as_Lcats_data_Chain$NonEmpty(tail);
          var rightNE$1 = rights;
          var next$2 = new $c_Lcats_data_Chain$Append(non$2, rightNE$1)
        } else {
          var next$2 = rights
        };
        var _1 = x6.head__O();
        result = new $c_T2(_1, next$2);
        continue
      };
      throw new $c_s_MatchError(x3)
    };
    var value = result;
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_data_Chain.prototype.isEmpty__Z = (function() {
  return (!(this instanceof $c_Lcats_data_Chain$NonEmpty))
});
$c_Lcats_data_Chain.prototype.prepend__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)), this)
});
$c_Lcats_data_Chain.prototype.append__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this, ($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)))
});
$c_Lcats_data_Chain.prototype.map__F1__Lcats_data_Chain = (function(f) {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x34 = x$1.Lcats_data_Chain$Wrap__f_seq;
    var seq = $as_sci_Seq(x34.map__F1__O(f));
    return new $c_Lcats_data_Chain$Wrap(seq)
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$3 = this.iterator__sc_Iterator();
    var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
    return $$x1.fromSeq__sci_Seq__Lcats_data_Chain($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$4))
  }
});
$c_Lcats_data_Chain.prototype.flatMap__F1__Lcats_data_Chain = (function(f) {
  var this$1 = $m_Lcats_data_Chain$();
  var result = this$1.Lcats_data_Chain$__f_nil;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var this$2 = result;
    var c = $as_Lcats_data_Chain(f.apply__O__O(iter.next__O()));
    result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c)
  };
  return result
});
$c_Lcats_data_Chain.prototype.foldLeft__O__F2__O = (function(z, f) {
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    result = f.apply__O__O__O(result, iter.next__O())
  };
  return result
});
$c_Lcats_data_Chain.prototype.collect__s_PartialFunction__Lcats_data_Chain = (function(pf) {
  var z = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var arg1 = result;
    var arg2 = iter.next__O();
    var acc = $as_Lcats_data_Chain(arg1);
    var x = pf.applyOrElse__O__F1__O(arg2, $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel);
    result = ((x !== $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel) ? acc.append__O__Lcats_data_Chain(x) : acc)
  };
  return $as_Lcats_data_Chain(result)
});
$c_Lcats_data_Chain.prototype.iterator__sc_Iterator = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x84 = x$1.Lcats_data_Chain$Wrap__f_seq;
    return x84.iterator__sc_Iterator()
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var x81 = x$1$1.Lcats_data_Chain$Singleton__f_a;
    $m_s_package$();
    return new $c_sc_Iterator$$anon$20(x81)
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    return new $c_Lcats_data_Chain$ChainIterator(app)
  } else {
    return $m_s_package$().s_package$__f_Iterator.sc_Iterator$__f_scala$collection$Iterator$$_empty
  }
});
$c_Lcats_data_Chain.prototype.toList__sci_List = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x100 = x$1.Lcats_data_Chain$Wrap__f_seq;
    return x100.toList__sci_List()
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var x97 = x$1$1.Lcats_data_Chain$Singleton__f_a;
    var this$3 = $m_s_package$().s_package$__f_Nil;
    return new $c_sci_$colon$colon(x97, this$3)
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$4 = new $c_Lcats_data_Chain$ChainIterator(app);
    $m_sci_List$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4)
  } else {
    return $m_s_package$().s_package$__f_Nil
  }
});
$c_Lcats_data_Chain.prototype.toVector__sci_Vector = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x$1 = $as_Lcats_data_Chain$Wrap(this);
    var x108 = x$1.Lcats_data_Chain$Wrap__f_seq;
    return x108.toVector__sci_Vector()
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x$1$1 = $as_Lcats_data_Chain$Singleton(this);
    var x105 = x$1$1.Lcats_data_Chain$Singleton__f_a;
    $m_s_package$();
    var this$4 = $m_sci_Vector0$();
    return this$4.appended__O__sci_Vector(x105)
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var app = $as_Lcats_data_Chain$Append(this);
    var this$5 = new $c_Lcats_data_Chain$ChainIterator(app);
    return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$5)
  } else {
    $m_s_package$();
    return $m_sci_Vector0$()
  }
});
$c_Lcats_data_Chain.prototype.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z = (function(that, A) {
  if ((this === that)) {
    return true
  } else {
    var iterX = this.iterator__sc_Iterator();
    var iterY = that.iterator__sc_Iterator();
    while ((iterX.hasNext__Z() && iterY.hasNext__Z())) {
      if ((!A.eqv__O__O__Z(iterX.next__O(), iterY.next__O()))) {
        return false
      }
    };
    return (iterX.hasNext__Z() === iterY.hasNext__Z())
  }
});
$c_Lcats_data_Chain.prototype.show__Lcats_Show__T = (function(AA) {
  var builder = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), "Chain(");
  var first = new $c_sr_BooleanRef(true);
  var f = ((AA$2, builder$2, first$2) => ((a) => {
    if (first$2.sr_BooleanRef__f_elem) {
      var s = AA$2.show__O__T(a);
      builder$2.addAll__T__scm_StringBuilder(s);
      first$2.sr_BooleanRef__f_elem = false
    } else {
      var s$1 = (", " + AA$2.show__O__T(a));
      builder$2.addAll__T__scm_StringBuilder(s$1)
    };
    return false
  }))(AA, builder, first);
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non = $as_Lcats_data_Chain$NonEmpty(this);
      var c = non;
      var rights = $m_s_package$().s_package$__f_Nil;
      while ((c !== null)) {
        var x64 = c;
        if ((x64 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x$1 = $as_Lcats_data_Chain$Singleton(x64);
          var x74 = x$1.Lcats_data_Chain$Singleton__f_a;
          var b = $uZ(f(x74));
          if (b) {
            break
          };
          if (rights.isEmpty__Z()) {
            c = null
          } else {
            var head = $as_Lcats_data_Chain$NonEmpty(rights.head__O());
            rights = $as_sci_List(rights.tail__O());
            c = head
          };
          continue
        };
        if ((x64 instanceof $c_Lcats_data_Chain$Append)) {
          var x$1$1 = $as_Lcats_data_Chain$Append(x64);
          var x70 = x$1$1.Lcats_data_Chain$Append__f_leftNE;
          var x71 = x$1$1.Lcats_data_Chain$Append__f_rightNE;
          var this$4 = rights;
          rights = new $c_sci_$colon$colon(x71, this$4);
          c = x70;
          continue
        };
        if ((x64 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x$1$2 = $as_Lcats_data_Chain$Wrap(x64);
          var x67 = x$1$2.Lcats_data_Chain$Wrap__f_seq;
          var iterator = x67.iterator__sc_Iterator();
          while (iterator.hasNext__Z()) {
            var arg1 = iterator.next__O();
            var b$2 = $uZ(f(arg1));
            if (b$2) {
              break _return
            }
          };
          if (rights.isEmpty__Z()) {
            c = null
          } else {
            var head$2 = $as_Lcats_data_Chain$NonEmpty(rights.head__O());
            rights = $as_sci_List(rights.tail__O());
            c = head$2
          };
          continue
        };
        throw new $c_s_MatchError(x64)
      }
    }
  };
  builder.addOne__C__scm_StringBuilder(41);
  return builder.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lcats_data_Chain.prototype.toString__T = (function() {
  $m_Lcats_Show$();
  var f = new $c_sjsr_AnonFunction1(((_$4) => $dp_toString__T(_$4)));
  return this.show__Lcats_Show__T(new $c_Lcats_Show$$anon$3(f))
});
$c_Lcats_data_Chain.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_Lcats_data_Chain)) {
    var thatChain = $as_Lcats_data_Chain(o);
    return this.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z(thatChain, ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$5()))
  } else {
    return false
  }
});
$c_Lcats_data_Chain.prototype.hashCode__I = (function() {
  $m_Lcats_package$();
  var hashA = new $c_Lcats_kernel_Hash$$anon$3();
  return $m_Lcats_kernel_instances_StaticMethods$().orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I(this.iterator__sc_Iterator(), hashA)
});
function $as_Lcats_data_Chain(obj) {
  return (((obj instanceof $c_Lcats_data_Chain) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain"))
}
function $isArrayOf_Lcats_data_Chain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain)))
}
function $asArrayOf_Lcats_data_Chain(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain;", depth))
}
/** @constructor */
function $c_Lcats_data_ChainInstances3() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances3.prototype = new $h_O();
$c_Lcats_data_ChainInstances3.prototype.constructor = $c_Lcats_data_ChainInstances3;
/** @constructor */
function $h_Lcats_data_ChainInstances3() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances3.prototype = $c_Lcats_data_ChainInstances3.prototype;
function $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli($thiz, x) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((x$2) => ((_$14) => x$2))(x));
  return new $c_Lcats_data_Kleisli(run)
}
function $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli($thiz, x, F) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((x$2, F$2) => ((_$21) => F$2.pure__O__O(x$2)))(x, F));
  return new $c_Lcats_data_Kleisli(run)
}
/** @constructor */
function $c_Lcats_data_KleisliInstances9() {
  /*<skip>*/
}
$c_Lcats_data_KleisliInstances9.prototype = new $h_O();
$c_Lcats_data_KleisliInstances9.prototype.constructor = $c_Lcats_data_KleisliInstances9;
/** @constructor */
function $h_Lcats_data_KleisliInstances9() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances9.prototype = $c_Lcats_data_KleisliInstances9.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances1() {
  /*<skip>*/
}
$c_Lcats_data_NonEmptyListInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptyListInstances1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances1() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances1.prototype = $c_Lcats_data_NonEmptyListInstances1.prototype;
function $ct_Lcats_effect_ArrayStack__AO__I__($thiz, buffer, index) {
  $thiz.Lcats_effect_ArrayStack__f_buffer = buffer;
  $thiz.Lcats_effect_ArrayStack__f_index = index;
  return $thiz
}
function $ct_Lcats_effect_ArrayStack__I__($thiz, initBound) {
  var dimensions = new $ac_I(new Int32Array([initBound]));
  $ct_Lcats_effect_ArrayStack__AO__I__($thiz, $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1), 0);
  return $thiz
}
function $ct_Lcats_effect_ArrayStack__($thiz) {
  $ct_Lcats_effect_ArrayStack__AO__I__($thiz, null, 0);
  return $thiz
}
function $p_Lcats_effect_ArrayStack__checkAndGrow__V($thiz) {
  if (($thiz.Lcats_effect_ArrayStack__f_index >= $thiz.Lcats_effect_ArrayStack__f_buffer.u.length)) {
    var len = $thiz.Lcats_effect_ArrayStack__f_buffer.u.length;
    var dimensions = new $ac_I(new Int32Array([(len << 1)]));
    var buffer2 = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
    var src = $thiz.Lcats_effect_ArrayStack__f_buffer;
    src.copyTo(0, buffer2, 0, len);
    $thiz.Lcats_effect_ArrayStack__f_buffer = buffer2
  }
}
/** @constructor */
function $c_Lcats_effect_ArrayStack() {
  this.Lcats_effect_ArrayStack__f_buffer = null;
  this.Lcats_effect_ArrayStack__f_index = 0
}
$c_Lcats_effect_ArrayStack.prototype = new $h_O();
$c_Lcats_effect_ArrayStack.prototype.constructor = $c_Lcats_effect_ArrayStack;
/** @constructor */
function $h_Lcats_effect_ArrayStack() {
  /*<skip>*/
}
$h_Lcats_effect_ArrayStack.prototype = $c_Lcats_effect_ArrayStack.prototype;
$c_Lcats_effect_ArrayStack.prototype.init__I__V = (function(bound) {
  var dimensions = new $ac_I(new Int32Array([bound]));
  this.Lcats_effect_ArrayStack__f_buffer = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
  this.Lcats_effect_ArrayStack__f_index = 0
});
$c_Lcats_effect_ArrayStack.prototype.push__O__V = (function(a) {
  $p_Lcats_effect_ArrayStack__checkAndGrow__V(this);
  this.Lcats_effect_ArrayStack__f_buffer.set(this.Lcats_effect_ArrayStack__f_index, a);
  this.Lcats_effect_ArrayStack__f_index = ((1 + this.Lcats_effect_ArrayStack__f_index) | 0)
});
$c_Lcats_effect_ArrayStack.prototype.pop__O = (function() {
  this.Lcats_effect_ArrayStack__f_index = (((-1) + this.Lcats_effect_ArrayStack__f_index) | 0);
  var back = this.Lcats_effect_ArrayStack__f_buffer.get(this.Lcats_effect_ArrayStack__f_index);
  this.Lcats_effect_ArrayStack__f_buffer.set(this.Lcats_effect_ArrayStack__f_index, null);
  return back
});
$c_Lcats_effect_ArrayStack.prototype.isEmpty__Z = (function() {
  return (this.Lcats_effect_ArrayStack__f_index <= 0)
});
$c_Lcats_effect_ArrayStack.prototype.invalidate__V = (function() {
  this.Lcats_effect_ArrayStack__f_index = 0;
  this.Lcats_effect_ArrayStack__f_buffer = null
});
var $d_Lcats_effect_ArrayStack = new $TypeData().initClass({
  Lcats_effect_ArrayStack: 0
}, false, "cats.effect.ArrayStack", {
  Lcats_effect_ArrayStack: 1,
  O: 1
});
$c_Lcats_effect_ArrayStack.prototype.$classData = $d_Lcats_effect_ArrayStack;
/** @constructor */
function $c_Lcats_effect_ByteStack$() {
  /*<skip>*/
}
$c_Lcats_effect_ByteStack$.prototype = new $h_O();
$c_Lcats_effect_ByteStack$.prototype.constructor = $c_Lcats_effect_ByteStack$;
/** @constructor */
function $h_Lcats_effect_ByteStack$() {
  /*<skip>*/
}
$h_Lcats_effect_ByteStack$.prototype = $c_Lcats_effect_ByteStack$.prototype;
$c_Lcats_effect_ByteStack$.prototype.create__I__AI = (function(initialMaxOps) {
  var dimensions = new $ac_I(new Int32Array([((2 + ((((-1) + initialMaxOps) | 0) >> 3)) | 0)]));
  return $asArrayOf_I($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_I.getClassOf(), dimensions), 1)
});
$c_Lcats_effect_ByteStack$.prototype.growIfNeeded__AI__I__AI = (function(stack, count) {
  if ((((1 + (((1 + count) | 0) >> 3)) | 0) < stack.u.length)) {
    return stack
  } else {
    var dimensions = new $ac_I(new Int32Array([(stack.u.length << 1)]));
    var bigger = $asArrayOf_I($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_I.getClassOf(), dimensions), 1);
    var length = stack.u.length;
    stack.copyTo(0, bigger, 0, length);
    return bigger
  }
});
$c_Lcats_effect_ByteStack$.prototype.push__AI__B__AI = (function(stack, op) {
  var c = stack.get(0);
  var use = this.growIfNeeded__AI__I__AI(stack, c);
  var s = ((1 + (c >> 3)) | 0);
  var shift = ((7 & c) << 2);
  use.set(s, ((use.get(s) & (~((-1) << shift))) | (op << shift)));
  use.set(0, ((1 + use.get(0)) | 0));
  return use
});
$c_Lcats_effect_ByteStack$.prototype.peek__AI__B = (function(stack) {
  var c = (((-1) + stack.get(0)) | 0);
  if ((c < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  return (((15 & ((stack.get(((1 + (c >> 3)) | 0)) >>> ((7 & c) << 2)) | 0)) << 24) >> 24)
});
$c_Lcats_effect_ByteStack$.prototype.pop__AI__B = (function(stack) {
  var op = this.peek__AI__B(stack);
  stack.set(0, (((-1) + stack.get(0)) | 0));
  return op
});
var $d_Lcats_effect_ByteStack$ = new $TypeData().initClass({
  Lcats_effect_ByteStack$: 0
}, false, "cats.effect.ByteStack$", {
  Lcats_effect_ByteStack$: 1,
  O: 1
});
$c_Lcats_effect_ByteStack$.prototype.$classData = $d_Lcats_effect_ByteStack$;
var $n_Lcats_effect_ByteStack$;
function $m_Lcats_effect_ByteStack$() {
  if ((!$n_Lcats_effect_ByteStack$)) {
    $n_Lcats_effect_ByteStack$ = new $c_Lcats_effect_ByteStack$()
  };
  return $n_Lcats_effect_ByteStack$
}
/** @constructor */
function $c_Lcats_effect_IOCompanionPlatform() {
  /*<skip>*/
}
$c_Lcats_effect_IOCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_IOCompanionPlatform.prototype.constructor = $c_Lcats_effect_IOCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_IOCompanionPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_IOCompanionPlatform.prototype = $c_Lcats_effect_IOCompanionPlatform.prototype;
$c_Lcats_effect_IOCompanionPlatform.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO = (function(hint, thunk) {
  var this$1 = $as_Lcats_effect_IO$(this);
  return this$1.delay__F0__Lcats_effect_IO(thunk)
});
/** @constructor */
function $c_Lcats_effect_IOFiber$() {
  this.Lcats_effect_IOFiber$__f_TypeBlocking = null;
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = null;
  this.Lcats_effect_IOFiber$__f_RightUnit = null;
  $n_Lcats_effect_IOFiber$ = this;
  this.Lcats_effect_IOFiber$__f_TypeBlocking = ($m_Lcats_effect_package$(), $m_Lcats_effect_kernel_Sync$Type$Blocking$());
  this.Lcats_effect_IOFiber$__f_OutcomeCanceled = ($m_Lcats_effect_package$(), new $c_Lcats_effect_kernel_Outcome$Canceled());
  this.Lcats_effect_IOFiber$__f_RightUnit = ($m_s_package$(), new $c_s_util_Right((void 0)))
}
$c_Lcats_effect_IOFiber$.prototype = new $h_O();
$c_Lcats_effect_IOFiber$.prototype.constructor = $c_Lcats_effect_IOFiber$;
/** @constructor */
function $h_Lcats_effect_IOFiber$() {
  /*<skip>*/
}
$h_Lcats_effect_IOFiber$.prototype = $c_Lcats_effect_IOFiber$.prototype;
var $d_Lcats_effect_IOFiber$ = new $TypeData().initClass({
  Lcats_effect_IOFiber$: 0
}, false, "cats.effect.IOFiber$", {
  Lcats_effect_IOFiber$: 1,
  O: 1
});
$c_Lcats_effect_IOFiber$.prototype.$classData = $d_Lcats_effect_IOFiber$;
var $n_Lcats_effect_IOFiber$;
function $m_Lcats_effect_IOFiber$() {
  if ((!$n_Lcats_effect_IOFiber$)) {
    $n_Lcats_effect_IOFiber$ = new $c_Lcats_effect_IOFiber$()
  };
  return $n_Lcats_effect_IOFiber$
}
/** @constructor */
function $c_Lcats_effect_IOPlatform() {
  /*<skip>*/
}
$c_Lcats_effect_IOPlatform.prototype = new $h_O();
$c_Lcats_effect_IOPlatform.prototype.constructor = $c_Lcats_effect_IOPlatform;
/** @constructor */
function $h_Lcats_effect_IOPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_IOPlatform.prototype = $c_Lcats_effect_IOPlatform.prototype;
function $ps_Lcats_effect_SyncIO__runLoop$1__sr_ObjectRef__Lcats_effect_ArrayStack__Lcats_effect_SyncIO__O(conts$1, objectState$1, cur0) {
  var cur0$tailLocal1 = cur0;
  while (true) {
    var x37 = cur0$tailLocal1.tag__B();
    switch (x37) {
      case 0: {
        var cur = $as_Lcats_effect_SyncIO$Pure(cur0$tailLocal1);
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, cur.Lcats_effect_SyncIO$Pure__f_value, 0);
        break
      }
      case 1: {
        var cur$2 = $as_Lcats_effect_SyncIO$Suspend(cur0$tailLocal1);
        var error = null;
        try {
          var r = cur$2.Lcats_effect_SyncIO$Suspend__f_thunk.apply__O()
        } catch (e) {
          var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
          matchResult2: {
            if ((e$2 !== null)) {
              var x34 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
              if ((!x34.isEmpty__Z())) {
                var x35 = $as_jl_Throwable(x34.get__O());
                error = x35;
                break matchResult2
              }
            };
            throw e$2
          };
          var r = (void 0)
        };
        var next = ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, r, 0) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, error, 0));
        cur0$tailLocal1 = next;
        break
      }
      case 2: {
        var cur$3 = $as_Lcats_effect_SyncIO$Error(cur0$tailLocal1);
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, cur$3.Lcats_effect_SyncIO$Error__f_t, 0);
        break
      }
      case 3: {
        var cur$4 = $as_Lcats_effect_SyncIO$Map(cur0$tailLocal1);
        objectState$1.push__O__V(cur$4.f__F1());
        var ev$5 = $m_Lcats_effect_ByteStack$().push__AI__B__AI($asArrayOf_I(conts$1.sr_ObjectRef__f_elem, 1), $m_Lcats_effect_SyncIOConstants$().Lcats_effect_SyncIOConstants$__f_MapK);
        conts$1.sr_ObjectRef__f_elem = ev$5;
        cur0$tailLocal1 = cur$4.ioe__Lcats_effect_SyncIO();
        break
      }
      case 4: {
        var cur$5 = $as_Lcats_effect_SyncIO$FlatMap(cur0$tailLocal1);
        objectState$1.push__O__V(cur$5.Lcats_effect_SyncIO$FlatMap__f_f);
        var ev$6 = $m_Lcats_effect_ByteStack$().push__AI__B__AI($asArrayOf_I(conts$1.sr_ObjectRef__f_elem, 1), $m_Lcats_effect_SyncIOConstants$().Lcats_effect_SyncIOConstants$__f_FlatMapK);
        conts$1.sr_ObjectRef__f_elem = ev$6;
        cur0$tailLocal1 = cur$5.Lcats_effect_SyncIO$FlatMap__f_ioe;
        break
      }
      case 5: {
        var cur$6 = $as_Lcats_effect_SyncIO$HandleErrorWith(cur0$tailLocal1);
        objectState$1.push__O__V(cur$6.Lcats_effect_SyncIO$HandleErrorWith__f_f);
        var ev$7 = $m_Lcats_effect_ByteStack$().push__AI__B__AI($asArrayOf_I(conts$1.sr_ObjectRef__f_elem, 1), $m_Lcats_effect_SyncIOConstants$().Lcats_effect_SyncIOConstants$__f_HandleErrorWithK);
        conts$1.sr_ObjectRef__f_elem = ev$7;
        cur0$tailLocal1 = cur$6.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
        break
      }
      case 6: {
        var cur$7 = $as_Lcats_effect_SyncIO$Success(cur0$tailLocal1);
        return cur$7.Lcats_effect_SyncIO$Success__f_value;
        break
      }
      case 7: {
        var cur$8 = $as_Lcats_effect_SyncIO$Failure(cur0$tailLocal1);
        throw cur$8.Lcats_effect_SyncIO$Failure__f_t;
        break
      }
      case 8: {
        var cur$9 = $as_Lcats_effect_SyncIO$Attempt(cur0$tailLocal1);
        var ev$8 = $m_Lcats_effect_ByteStack$().push__AI__B__AI($asArrayOf_I(conts$1.sr_ObjectRef__f_elem, 1), $m_Lcats_effect_SyncIOConstants$().Lcats_effect_SyncIOConstants$__f_AttemptK);
        conts$1.sr_ObjectRef__f_elem = ev$8;
        cur0$tailLocal1 = cur$9.Lcats_effect_SyncIO$Attempt__f_ioa;
        break
      }
      case 9: {
        var this$2 = $m_RTLong$();
        var value = $uD(new Date().getTime());
        var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
        var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$4 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
        var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
        var t = this$4.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
        var lo$1 = t.RTLong__f_lo;
        var hi$1 = t.RTLong__f_hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit), 0);
        break
      }
      case 10: {
        var this$8 = $m_RTLong$();
        var value$1 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
        var lo$2 = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
        var hi$2 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$10 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$2, hi$2));
        var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        var t$1 = this$10.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$3 = t$1.RTLong__f_hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1), 0);
        break
      }
      default: {
        throw new $c_s_MatchError(x37)
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var x38 = $m_Lcats_effect_ByteStack$().pop__AI__B($asArrayOf_I(conts$2.sr_ObjectRef__f_elem, 1));
    switch (x38) {
      case 0: {
        return $ps_Lcats_effect_SyncIO__mapK$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result$tailLocal1, depth$tailLocal1);
        break
      }
      case 1: {
        return $ps_Lcats_effect_SyncIO__flatMapK$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result$tailLocal1, depth$tailLocal1);
        break
      }
      case 2: {
        objectState$2.pop__O();
        break
      }
      case 3: {
        var value = result$tailLocal1;
        return new $c_Lcats_effect_SyncIO$Success(value);
        break
      }
      case 4: {
        $m_s_package$();
        var value$1 = result$tailLocal1;
        var result$tailLocal1$tmp1 = new $c_s_util_Right(value$1);
        var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
        result$tailLocal1 = result$tailLocal1$tmp1;
        depth$tailLocal1 = depth$tailLocal1$tmp1;
        break
      }
      default: {
        throw new $c_s_MatchError(x38)
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$3, objectState$3, error, depth) {
  while (true) {
    var x39 = $m_Lcats_effect_ByteStack$().pop__AI__B($asArrayOf_I(conts$3.sr_ObjectRef__f_elem, 1));
    switch (x39) {
      case 0:
      case 1: {
        objectState$3.pop__O();
        break
      }
      case 2: {
        return $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$3, objectState$3, error, depth);
        break
      }
      case 3: {
        return new $c_Lcats_effect_SyncIO$Failure(error);
        break
      }
      case 4: {
        return $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$3, objectState$3, ($m_s_package$(), new $c_s_util_Left(error)), ((1 + depth) | 0));
        break
      }
      default: {
        throw new $c_s_MatchError(x39)
      }
    }
  }
}
function $ps_Lcats_effect_SyncIO__mapK$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$4, objectState$4, result, depth) {
  var f = $as_F1(objectState$4.pop__O());
  var error = null;
  try {
    var transformed = f.apply__O__O(result)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    matchResult6: {
      if ((e$2 !== null)) {
        var x41 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x41.isEmpty__Z())) {
          var x42 = $as_jl_Throwable(x41.get__O());
          error = x42;
          break matchResult6
        }
      };
      throw e$2
    };
    var transformed = (void 0)
  };
  if ((depth > $m_Lcats_effect_SyncIOConstants$().Lcats_effect_SyncIOConstants$__f_MaxStackDepth)) {
    if ((error === null)) {
      var $$x1 = new $c_Lcats_effect_SyncIO$Pure(transformed)
    } else {
      var t = error;
      var $$x1 = new $c_Lcats_effect_SyncIO$Error(t)
    };
    return $as_Lcats_effect_SyncIO($$x1)
  } else {
    return ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$4, objectState$4, transformed, ((1 + depth) | 0)) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$4, objectState$4, error, ((1 + depth) | 0)))
  }
}
function $ps_Lcats_effect_SyncIO__flatMapK$1__sr_ObjectRef__Lcats_effect_ArrayStack__O__I__Lcats_effect_SyncIO(conts$5, objectState$5, result, depth) {
  var f = $as_F1(objectState$5.pop__O());
  try {
    return $as_Lcats_effect_SyncIO(f.apply__O__O(result))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x45 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x45.isEmpty__Z())) {
        var x46 = $as_jl_Throwable(x45.get__O());
        return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$5, objectState$5, x46, ((1 + depth) | 0))
      }
    };
    throw e$2
  }
}
function $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$6, objectState$6, t, depth) {
  var f = $as_F1(objectState$6.pop__O());
  try {
    return $as_Lcats_effect_SyncIO(f.apply__O__O(t))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x49 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x49.isEmpty__Z())) {
        var x50 = $as_jl_Throwable(x49.get__O());
        return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__Lcats_effect_ArrayStack__jl_Throwable__I__Lcats_effect_SyncIO(conts$6, objectState$6, x50, ((1 + depth) | 0))
      }
    };
    throw e$2
  }
}
/** @constructor */
function $c_Lcats_effect_SyncIO() {
  /*<skip>*/
}
$c_Lcats_effect_SyncIO.prototype = new $h_O();
$c_Lcats_effect_SyncIO.prototype.constructor = $c_Lcats_effect_SyncIO;
/** @constructor */
function $h_Lcats_effect_SyncIO() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO.prototype = $c_Lcats_effect_SyncIO.prototype;
$c_Lcats_effect_SyncIO.prototype.productR__Lcats_effect_SyncIO__Lcats_effect_SyncIO = (function(that) {
  var f = new $c_sjsr_AnonFunction1(((that$2) => ((_$4) => that$2))(that));
  return new $c_Lcats_effect_SyncIO$FlatMap(this, f)
});
$c_Lcats_effect_SyncIO.prototype.toString__T = (function() {
  return "SyncIO(...)"
});
$c_Lcats_effect_SyncIO.prototype.unsafeRunSync__O = (function() {
  var elem = $m_Lcats_effect_ByteStack$().create__I__AI(8);
  var conts = new $c_sr_ObjectRef(elem);
  var objectState = $ct_Lcats_effect_ArrayStack__I__(new $c_Lcats_effect_ArrayStack(), 16);
  var ev$4 = $m_Lcats_effect_ByteStack$().push__AI__B__AI($asArrayOf_I(conts.sr_ObjectRef__f_elem, 1), $m_Lcats_effect_SyncIOConstants$().Lcats_effect_SyncIOConstants$__f_RunTerminusK);
  conts.sr_ObjectRef__f_elem = ev$4;
  return $ps_Lcats_effect_SyncIO__runLoop$1__sr_ObjectRef__Lcats_effect_ArrayStack__Lcats_effect_SyncIO__O(conts, objectState, this)
});
function $as_Lcats_effect_SyncIO(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO"))
}
function $isArrayOf_Lcats_effect_SyncIO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO)))
}
function $asArrayOf_Lcats_effect_SyncIO(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO;", depth))
}
/** @constructor */
function $c_Lcats_effect_SyncIOConstants$() {
  this.Lcats_effect_SyncIOConstants$__f_MaxStackDepth = 0;
  this.Lcats_effect_SyncIOConstants$__f_MapK = 0;
  this.Lcats_effect_SyncIOConstants$__f_FlatMapK = 0;
  this.Lcats_effect_SyncIOConstants$__f_HandleErrorWithK = 0;
  this.Lcats_effect_SyncIOConstants$__f_RunTerminusK = 0;
  this.Lcats_effect_SyncIOConstants$__f_AttemptK = 0;
  this.Lcats_effect_SyncIOConstants$__f_MaxStackDepth = 512;
  this.Lcats_effect_SyncIOConstants$__f_MapK = 0;
  this.Lcats_effect_SyncIOConstants$__f_FlatMapK = 1;
  this.Lcats_effect_SyncIOConstants$__f_HandleErrorWithK = 2;
  this.Lcats_effect_SyncIOConstants$__f_RunTerminusK = 3;
  this.Lcats_effect_SyncIOConstants$__f_AttemptK = 4
}
$c_Lcats_effect_SyncIOConstants$.prototype = new $h_O();
$c_Lcats_effect_SyncIOConstants$.prototype.constructor = $c_Lcats_effect_SyncIOConstants$;
/** @constructor */
function $h_Lcats_effect_SyncIOConstants$() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIOConstants$.prototype = $c_Lcats_effect_SyncIOConstants$.prototype;
var $d_Lcats_effect_SyncIOConstants$ = new $TypeData().initClass({
  Lcats_effect_SyncIOConstants$: 0
}, false, "cats.effect.SyncIOConstants$", {
  Lcats_effect_SyncIOConstants$: 1,
  O: 1
});
$c_Lcats_effect_SyncIOConstants$.prototype.$classData = $d_Lcats_effect_SyncIOConstants$;
var $n_Lcats_effect_SyncIOConstants$;
function $m_Lcats_effect_SyncIOConstants$() {
  if ((!$n_Lcats_effect_SyncIOConstants$)) {
    $n_Lcats_effect_SyncIOConstants$ = new $c_Lcats_effect_SyncIOConstants$()
  };
  return $n_Lcats_effect_SyncIOConstants$
}
/** @constructor */
function $c_Lcats_effect_Thunk$() {
  this.Lcats_effect_Thunk$__f_impl = null;
  $n_Lcats_effect_Thunk$ = this;
  this.Lcats_effect_Thunk$__f_impl = new $c_sjsr_AnonFunction1(((x) => x))
}
$c_Lcats_effect_Thunk$.prototype = new $h_O();
$c_Lcats_effect_Thunk$.prototype.constructor = $c_Lcats_effect_Thunk$;
/** @constructor */
function $h_Lcats_effect_Thunk$() {
  /*<skip>*/
}
$h_Lcats_effect_Thunk$.prototype = $c_Lcats_effect_Thunk$.prototype;
$c_Lcats_effect_Thunk$.prototype.asFunction0__F0__F0 = (function(thunk) {
  return $as_F0(this.Lcats_effect_Thunk$__f_impl.apply__O__O(thunk))
});
var $d_Lcats_effect_Thunk$ = new $TypeData().initClass({
  Lcats_effect_Thunk$: 0
}, false, "cats.effect.Thunk$", {
  Lcats_effect_Thunk$: 1,
  O: 1
});
$c_Lcats_effect_Thunk$.prototype.$classData = $d_Lcats_effect_Thunk$;
var $n_Lcats_effect_Thunk$;
function $m_Lcats_effect_Thunk$() {
  if ((!$n_Lcats_effect_Thunk$)) {
    $n_Lcats_effect_Thunk$ = new $c_Lcats_effect_Thunk$()
  };
  return $n_Lcats_effect_Thunk$
}
function $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T($thiz, ste) {
  return (((((((ste.jl_StackTraceElement__f_declaringClass + ".") + ste.jl_StackTraceElement__f_methodName) + " (") + ste.jl_StackTraceElement__f_fileName) + ":") + ste.jl_StackTraceElement__f_lineNumber) + ")")
}
/** @constructor */
function $c_Lcats_effect_Trace(frames) {
  this.Lcats_effect_Trace__f_frames = null;
  this.Lcats_effect_Trace__f_frames = frames
}
$c_Lcats_effect_Trace.prototype = new $h_O();
$c_Lcats_effect_Trace.prototype.constructor = $c_Lcats_effect_Trace;
/** @constructor */
function $h_Lcats_effect_Trace() {
  /*<skip>*/
}
$h_Lcats_effect_Trace.prototype = $c_Lcats_effect_Trace.prototype;
$c_Lcats_effect_Trace.prototype.compact__T = (function() {
  var this$2 = this.Lcats_effect_Trace__f_frames;
  var f = ((this$1) => ((ste) => {
    var ste$1 = $as_jl_StackTraceElement(ste);
    return $p_Lcats_effect_Trace__renderStackTraceElement__jl_StackTraceElement__T(this$1, ste$1)
  }))(this);
  if ((this$2 === $m_sci_Nil$())) {
    var this$3 = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var this$3 = h
  };
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ", ", "")
});
$c_Lcats_effect_Trace.prototype.toString__T = (function() {
  return this.compact__T()
});
var $d_Lcats_effect_Trace = new $TypeData().initClass({
  Lcats_effect_Trace: 0
}, false, "cats.effect.Trace", {
  Lcats_effect_Trace: 1,
  O: 1
});
$c_Lcats_effect_Trace.prototype.$classData = $d_Lcats_effect_Trace;
/** @constructor */
function $c_Lcats_effect_Trace$() {
  /*<skip>*/
}
$c_Lcats_effect_Trace$.prototype = new $h_O();
$c_Lcats_effect_Trace$.prototype.constructor = $c_Lcats_effect_Trace$;
/** @constructor */
function $h_Lcats_effect_Trace$() {
  /*<skip>*/
}
$h_Lcats_effect_Trace$.prototype = $c_Lcats_effect_Trace$.prototype;
$c_Lcats_effect_Trace$.prototype.apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace = (function(events) {
  return new $c_Lcats_effect_Trace($m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events))
});
var $d_Lcats_effect_Trace$ = new $TypeData().initClass({
  Lcats_effect_Trace$: 0
}, false, "cats.effect.Trace$", {
  Lcats_effect_Trace$: 1,
  O: 1
});
$c_Lcats_effect_Trace$.prototype.$classData = $d_Lcats_effect_Trace$;
var $n_Lcats_effect_Trace$;
function $m_Lcats_effect_Trace$() {
  if ((!$n_Lcats_effect_Trace$)) {
    $n_Lcats_effect_Trace$ = new $c_Lcats_effect_Trace$()
  };
  return $n_Lcats_effect_Trace$
}
/** @constructor */
function $c_Lcats_effect_kernel_Async$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Async$.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$.prototype.constructor = $c_Lcats_effect_kernel_Async$;
/** @constructor */
function $h_Lcats_effect_kernel_Async$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Async$.prototype = $c_Lcats_effect_kernel_Async$.prototype;
var $d_Lcats_effect_kernel_Async$ = new $TypeData().initClass({
  Lcats_effect_kernel_Async$: 0
}, false, "cats.effect.kernel.Async$", {
  Lcats_effect_kernel_Async$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Async$.prototype.$classData = $d_Lcats_effect_kernel_Async$;
var $n_Lcats_effect_kernel_Async$;
function $m_Lcats_effect_kernel_Async$() {
  if ((!$n_Lcats_effect_kernel_Async$)) {
    $n_Lcats_effect_kernel_Async$ = new $c_Lcats_effect_kernel_Async$()
  };
  return $n_Lcats_effect_kernel_Async$
}
/** @constructor */
function $c_Lcats_effect_kernel_Clock$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Clock$.prototype = new $h_O();
$c_Lcats_effect_kernel_Clock$.prototype.constructor = $c_Lcats_effect_kernel_Clock$;
/** @constructor */
function $h_Lcats_effect_kernel_Clock$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Clock$.prototype = $c_Lcats_effect_kernel_Clock$.prototype;
var $d_Lcats_effect_kernel_Clock$ = new $TypeData().initClass({
  Lcats_effect_kernel_Clock$: 0
}, false, "cats.effect.kernel.Clock$", {
  Lcats_effect_kernel_Clock$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Clock$.prototype.$classData = $d_Lcats_effect_kernel_Clock$;
var $n_Lcats_effect_kernel_Clock$;
function $m_Lcats_effect_kernel_Clock$() {
  if ((!$n_Lcats_effect_kernel_Clock$)) {
    $n_Lcats_effect_kernel_Clock$ = new $c_Lcats_effect_kernel_Clock$()
  };
  return $n_Lcats_effect_kernel_Clock$
}
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Deferred$.prototype = new $h_O();
$c_Lcats_effect_kernel_Deferred$.prototype.constructor = $c_Lcats_effect_kernel_Deferred$;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$.prototype = $c_Lcats_effect_kernel_Deferred$.prototype;
var $d_Lcats_effect_kernel_Deferred$ = new $TypeData().initClass({
  Lcats_effect_kernel_Deferred$: 0
}, false, "cats.effect.kernel.Deferred$", {
  Lcats_effect_kernel_Deferred$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Deferred$.prototype.$classData = $d_Lcats_effect_kernel_Deferred$;
var $n_Lcats_effect_kernel_Deferred$;
function $m_Lcats_effect_kernel_Deferred$() {
  if ((!$n_Lcats_effect_kernel_Deferred$)) {
    $n_Lcats_effect_kernel_Deferred$ = new $c_Lcats_effect_kernel_Deferred$()
  };
  return $n_Lcats_effect_kernel_Deferred$
}
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$State() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Deferred$State.prototype = new $h_O();
$c_Lcats_effect_kernel_Deferred$State.prototype.constructor = $c_Lcats_effect_kernel_Deferred$State;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$State() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$State.prototype = $c_Lcats_effect_kernel_Deferred$State.prototype;
function $as_Lcats_effect_kernel_Deferred$State(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Deferred$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Deferred$State"))
}
function $isArrayOf_Lcats_effect_kernel_Deferred$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Deferred$State)))
}
function $asArrayOf_Lcats_effect_kernel_Deferred$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Deferred$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Deferred$State;", depth))
}
function $is_Lcats_effect_kernel_Fiber(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Fiber)))
}
function $as_Lcats_effect_kernel_Fiber(obj) {
  return (($is_Lcats_effect_kernel_Fiber(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Fiber"))
}
function $isArrayOf_Lcats_effect_kernel_Fiber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Fiber)))
}
function $asArrayOf_Lcats_effect_kernel_Fiber(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Fiber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Fiber;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_GenConcurrent$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_GenConcurrent$.prototype = new $h_O();
$c_Lcats_effect_kernel_GenConcurrent$.prototype.constructor = $c_Lcats_effect_kernel_GenConcurrent$;
/** @constructor */
function $h_Lcats_effect_kernel_GenConcurrent$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_GenConcurrent$.prototype = $c_Lcats_effect_kernel_GenConcurrent$.prototype;
var $d_Lcats_effect_kernel_GenConcurrent$ = new $TypeData().initClass({
  Lcats_effect_kernel_GenConcurrent$: 0
}, false, "cats.effect.kernel.GenConcurrent$", {
  Lcats_effect_kernel_GenConcurrent$: 1,
  O: 1
});
$c_Lcats_effect_kernel_GenConcurrent$.prototype.$classData = $d_Lcats_effect_kernel_GenConcurrent$;
var $n_Lcats_effect_kernel_GenConcurrent$;
function $m_Lcats_effect_kernel_GenConcurrent$() {
  if ((!$n_Lcats_effect_kernel_GenConcurrent$)) {
    $n_Lcats_effect_kernel_GenConcurrent$ = new $c_Lcats_effect_kernel_GenConcurrent$()
  };
  return $n_Lcats_effect_kernel_GenConcurrent$
}
/** @constructor */
function $c_Lcats_effect_kernel_GenSpawn$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_GenSpawn$.prototype = new $h_O();
$c_Lcats_effect_kernel_GenSpawn$.prototype.constructor = $c_Lcats_effect_kernel_GenSpawn$;
/** @constructor */
function $h_Lcats_effect_kernel_GenSpawn$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_GenSpawn$.prototype = $c_Lcats_effect_kernel_GenSpawn$.prototype;
var $d_Lcats_effect_kernel_GenSpawn$ = new $TypeData().initClass({
  Lcats_effect_kernel_GenSpawn$: 0
}, false, "cats.effect.kernel.GenSpawn$", {
  Lcats_effect_kernel_GenSpawn$: 1,
  O: 1
});
$c_Lcats_effect_kernel_GenSpawn$.prototype.$classData = $d_Lcats_effect_kernel_GenSpawn$;
var $n_Lcats_effect_kernel_GenSpawn$;
function $m_Lcats_effect_kernel_GenSpawn$() {
  if ((!$n_Lcats_effect_kernel_GenSpawn$)) {
    $n_Lcats_effect_kernel_GenSpawn$ = new $c_Lcats_effect_kernel_GenSpawn$()
  };
  return $n_Lcats_effect_kernel_GenSpawn$
}
/** @constructor */
function $c_Lcats_effect_kernel_GenTemporal$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_GenTemporal$.prototype = new $h_O();
$c_Lcats_effect_kernel_GenTemporal$.prototype.constructor = $c_Lcats_effect_kernel_GenTemporal$;
/** @constructor */
function $h_Lcats_effect_kernel_GenTemporal$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_GenTemporal$.prototype = $c_Lcats_effect_kernel_GenTemporal$.prototype;
var $d_Lcats_effect_kernel_GenTemporal$ = new $TypeData().initClass({
  Lcats_effect_kernel_GenTemporal$: 0
}, false, "cats.effect.kernel.GenTemporal$", {
  Lcats_effect_kernel_GenTemporal$: 1,
  O: 1
});
$c_Lcats_effect_kernel_GenTemporal$.prototype.$classData = $d_Lcats_effect_kernel_GenTemporal$;
var $n_Lcats_effect_kernel_GenTemporal$;
function $m_Lcats_effect_kernel_GenTemporal$() {
  if ((!$n_Lcats_effect_kernel_GenTemporal$)) {
    $n_Lcats_effect_kernel_GenTemporal$ = new $c_Lcats_effect_kernel_GenTemporal$()
  };
  return $n_Lcats_effect_kernel_GenTemporal$
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_MonadCancel$.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_MonadCancel$.prototype = $c_Lcats_effect_kernel_MonadCancel$.prototype;
var $d_Lcats_effect_kernel_MonadCancel$ = new $TypeData().initClass({
  Lcats_effect_kernel_MonadCancel$: 0
}, false, "cats.effect.kernel.MonadCancel$", {
  Lcats_effect_kernel_MonadCancel$: 1,
  O: 1
});
$c_Lcats_effect_kernel_MonadCancel$.prototype.$classData = $d_Lcats_effect_kernel_MonadCancel$;
var $n_Lcats_effect_kernel_MonadCancel$;
function $m_Lcats_effect_kernel_MonadCancel$() {
  if ((!$n_Lcats_effect_kernel_MonadCancel$)) {
    $n_Lcats_effect_kernel_MonadCancel$ = new $c_Lcats_effect_kernel_MonadCancel$()
  };
  return $n_Lcats_effect_kernel_MonadCancel$
}
function $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O($thiz, fa, fin) {
  return fa
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$() {
  this.Lcats_effect_kernel_Par$__f_instance = null;
  $n_Lcats_effect_kernel_Par$ = this;
  this.Lcats_effect_kernel_Par$__f_instance = new $c_Lcats_effect_kernel_Par$$anon$1()
}
$c_Lcats_effect_kernel_Par$.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$.prototype.constructor = $c_Lcats_effect_kernel_Par$;
/** @constructor */
function $h_Lcats_effect_kernel_Par$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Par$.prototype = $c_Lcats_effect_kernel_Par$.prototype;
var $d_Lcats_effect_kernel_Par$ = new $TypeData().initClass({
  Lcats_effect_kernel_Par$: 0
}, false, "cats.effect.kernel.Par$", {
  Lcats_effect_kernel_Par$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Par$.prototype.$classData = $d_Lcats_effect_kernel_Par$;
var $n_Lcats_effect_kernel_Par$;
function $m_Lcats_effect_kernel_Par$() {
  if ((!$n_Lcats_effect_kernel_Par$)) {
    $n_Lcats_effect_kernel_Par$ = new $c_Lcats_effect_kernel_Par$()
  };
  return $n_Lcats_effect_kernel_Par$
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$ParallelF$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Par$ParallelF$.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$ParallelF$.prototype.constructor = $c_Lcats_effect_kernel_Par$ParallelF$;
/** @constructor */
function $h_Lcats_effect_kernel_Par$ParallelF$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Par$ParallelF$.prototype = $c_Lcats_effect_kernel_Par$ParallelF$.prototype;
var $d_Lcats_effect_kernel_Par$ParallelF$ = new $TypeData().initClass({
  Lcats_effect_kernel_Par$ParallelF$: 0
}, false, "cats.effect.kernel.Par$ParallelF$", {
  Lcats_effect_kernel_Par$ParallelF$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Par$ParallelF$.prototype.$classData = $d_Lcats_effect_kernel_Par$ParallelF$;
var $n_Lcats_effect_kernel_Par$ParallelF$;
function $m_Lcats_effect_kernel_Par$ParallelF$() {
  if ((!$n_Lcats_effect_kernel_Par$ParallelF$)) {
    $n_Lcats_effect_kernel_Par$ParallelF$ = new $c_Lcats_effect_kernel_Par$ParallelF$()
  };
  return $n_Lcats_effect_kernel_Par$ParallelF$
}
/** @constructor */
function $c_Lcats_effect_kernel_Par$ParallelFImpl() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Par$ParallelFImpl.prototype = new $h_O();
$c_Lcats_effect_kernel_Par$ParallelFImpl.prototype.constructor = $c_Lcats_effect_kernel_Par$ParallelFImpl;
/** @constructor */
function $h_Lcats_effect_kernel_Par$ParallelFImpl() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Par$ParallelFImpl.prototype = $c_Lcats_effect_kernel_Par$ParallelFImpl.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Ref$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Ref$.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$.prototype.constructor = $c_Lcats_effect_kernel_Ref$;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Ref$.prototype = $c_Lcats_effect_kernel_Ref$.prototype;
$c_Lcats_effect_kernel_Ref$.prototype.unsafe__O__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Ref = (function(a, F) {
  return new $c_Lcats_effect_kernel_Ref$SyncRef($ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), a), F)
});
var $d_Lcats_effect_kernel_Ref$ = new $TypeData().initClass({
  Lcats_effect_kernel_Ref$: 0
}, false, "cats.effect.kernel.Ref$", {
  Lcats_effect_kernel_Ref$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Ref$.prototype.$classData = $d_Lcats_effect_kernel_Ref$;
var $n_Lcats_effect_kernel_Ref$;
function $m_Lcats_effect_kernel_Ref$() {
  if ((!$n_Lcats_effect_kernel_Ref$)) {
    $n_Lcats_effect_kernel_Ref$ = new $c_Lcats_effect_kernel_Ref$()
  };
  return $n_Lcats_effect_kernel_Ref$
}
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$1$(Nil$lzy1$1) {
  if ((Nil$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_kernel_Resource$Nil$1$((Nil$lzy1$1.sr_LazyRef__f__initialized ? Nil$lzy1$1.sr_LazyRef__f__value : Nil$lzy1$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$1$())))
}
function $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$1$(Nil$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$Nil$1$((Nil$lzy1$2.sr_LazyRef__f__initialized ? Nil$lzy1$2.sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$1$(Nil$lzy1$2)))
}
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$2$($thiz, Frame$lzy1$1) {
  if ((Frame$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_kernel_Resource$Frame$2$((Frame$lzy1$1.sr_LazyRef__f__initialized ? Frame$lzy1$1.sr_LazyRef__f__value : Frame$lzy1$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$2$($thiz))))
}
function $p_Lcats_effect_kernel_Resource__Frame$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$2$($thiz, Frame$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$Frame$2$((Frame$lzy1$2.sr_LazyRef__f__initialized ? Frame$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT1$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$2$($thiz, Frame$lzy1$2)))
}
function $p_Lcats_effect_kernel_Resource__loop$1__F1__F1__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O($thiz, onOutput$1, onRelease$1, F$5, Nil$lzy1$3, Frame$lzy1$3, current, stack) {
  var stack$tailLocal1 = stack;
  var current$tailLocal1 = current;
  while (true) {
    var x25 = current$tailLocal1;
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(x25);
      var x38 = x$1.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var stack$tailLocal1$2$1 = stack$tailLocal1;
      return F$5.bracketFull__F1__F1__F2__O(x38, new $c_sjsr_AnonFunction1(((this$2, onOutput$1$2, onRelease$1$2, F$5$2, Nil$lzy1$3$2, Frame$lzy1$3$2, stack$tailLocal1$2) => ((x$1$1) => {
        var x$1$2 = $as_T2(x$1$1);
        if ((x$1$2 !== null)) {
          var a = x$1$2._1__O();
          var x = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$1$(Nil$lzy1$3$2);
          if ((x === stack$tailLocal1$2)) {
            return onOutput$1$2.apply__O__O(a)
          };
          if ((stack$tailLocal1$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
            $p_Lcats_effect_kernel_Resource__Frame$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$2$(this$2, Frame$lzy1$3$2);
            var x$1$3 = $as_Lcats_effect_kernel_Resource$Frame$1(stack$tailLocal1$2);
            var x10 = x$1$3.Lcats_effect_kernel_Resource$Frame$1__f_head;
            var x11 = x$1$3.Lcats_effect_kernel_Resource$Frame$1__f_tail;
            var current$1 = $as_Lcats_effect_kernel_Resource(x10.apply__O__O(a));
            return $p_Lcats_effect_kernel_Resource__loop$1__F1__F1__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O(this$2, onOutput$1$2, onRelease$1$2, F$5$2, Nil$lzy1$3$2, Frame$lzy1$3$2, current$1, x11)
          };
          throw new $c_s_MatchError(stack$tailLocal1$2)
        };
        throw new $c_s_MatchError(x$1$2)
      }))($thiz, onOutput$1, onRelease$1, F$5, Nil$lzy1$3, Frame$lzy1$3, stack$tailLocal1$2$1)), new $c_sjsr_AnonFunction2(((onRelease$1$3) => ((x$1$2$1, x$2) => {
        var x$1$4 = $as_T2(x$1$2$1);
        var x$2$1 = $as_Lcats_effect_kernel_Outcome(x$2);
        var x15 = new $c_T2(x$1$4, x$2$1);
        var x16 = $as_T2(x15.T2__f__1);
        if ((x16 !== null)) {
          var release = $as_F1(x16._2__O());
          var outcome = $as_Lcats_effect_kernel_Outcome(x15.T2__f__2);
          return onRelease$1$3.apply__O__O(release.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(outcome)))
        };
        throw new $c_s_MatchError(x15)
      }))(onRelease$1)))
    };
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
      var x$1$5 = $as_Lcats_effect_kernel_Resource$Bind(x25);
      var x34 = x$1$5.Lcats_effect_kernel_Resource$Bind__f_source;
      var x35 = x$1$5.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal1$tmp1 = $p_Lcats_effect_kernel_Resource__Frame$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$2$($thiz, Frame$lzy1$3).apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1(x35, stack$tailLocal1);
      current$tailLocal1 = x34;
      stack$tailLocal1 = stack$tailLocal1$tmp1;
      continue
    };
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x$1$6 = $as_Lcats_effect_kernel_Resource$Pure(x25);
      var x31 = x$1$6.Lcats_effect_kernel_Resource$Pure__f_a;
      var x20 = stack$tailLocal1;
      var x$3 = $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$1$(Nil$lzy1$3);
      if ((x$3 === x20)) {
        return onOutput$1.apply__O__O(x31)
      };
      if ((x20 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
        $p_Lcats_effect_kernel_Resource__Frame$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$2$($thiz, Frame$lzy1$3);
        var x$1$7 = $as_Lcats_effect_kernel_Resource$Frame$1(x20);
        var x23 = x$1$7.Lcats_effect_kernel_Resource$Frame$1__f_head;
        var x24 = x$1$7.Lcats_effect_kernel_Resource$Frame$1__f_tail;
        var current$tailLocal1$tmp2 = $as_Lcats_effect_kernel_Resource(x23.apply__O__O(x31));
        current$tailLocal1 = current$tailLocal1$tmp2;
        stack$tailLocal1 = x24;
        continue
      };
      throw new $c_s_MatchError(x20)
    };
    if ((x25 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x$1$8 = $as_Lcats_effect_kernel_Resource$Eval(x25);
      var x28 = x$1$8.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$12 = new $c_Lcats_FlatMap$$anon$2(x28, F$5);
      var stack$tailLocal1$3$1 = stack$tailLocal1;
      var f = new $c_sjsr_AnonFunction1(((this$2$1, onOutput$1$3, onRelease$1$4, F$5$3, Nil$lzy1$3$3, Frame$lzy1$3$3, stack$tailLocal1$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$1__F1__F1__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O(this$2$1, onOutput$1$3, onRelease$1$4, F$5$3, Nil$lzy1$3$3, Frame$lzy1$3$3, current$2, stack$tailLocal1$3)
      }))($thiz, onOutput$1, onRelease$1, F$5, Nil$lzy1$3, Frame$lzy1$3, stack$tailLocal1$3$1));
      return this$12.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$$anon$2__f_self, f)
    };
    throw new $c_s_MatchError(x25)
  }
}
function $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy2$1) {
  if ((Nil$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_kernel_Resource$Nil$2$((Nil$lzy2$1.sr_LazyRef__f__initialized ? Nil$lzy2$1.sr_LazyRef__f__value : Nil$lzy2$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$Nil$2$())))
}
function $ps_Lcats_effect_kernel_Resource__Nil$2__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy2$2) {
  return $as_Lcats_effect_kernel_Resource$Nil$2$((Nil$lzy2$2.sr_LazyRef__f__initialized ? Nil$lzy2$2.sr_LazyRef__f__value : $ps_Lcats_effect_kernel_Resource__Nil$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy2$2)))
}
function $p_Lcats_effect_kernel_Resource__Frame$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$4$($thiz, Frame$lzy2$1) {
  if ((Frame$lzy2$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_kernel_Resource$Frame$4$((Frame$lzy2$1.sr_LazyRef__f__initialized ? Frame$lzy2$1.sr_LazyRef__f__value : Frame$lzy2$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$Frame$4$($thiz))))
}
function $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$4$($thiz, Frame$lzy2$2) {
  return $as_Lcats_effect_kernel_Resource$Frame$4$((Frame$lzy2$2.sr_LazyRef__f__initialized ? Frame$lzy2$2.sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__Frame$lzyINIT2$1__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$4$($thiz, Frame$lzy2$2)))
}
function $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O($thiz, F$21, Nil$lzy2$3, Frame$lzy2$3, current, stack, release) {
  var stack$tailLocal2 = stack;
  var current$tailLocal2 = current;
  while (true) {
    var x77 = current$tailLocal2;
    if ((x77 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
      var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(x77);
      var x90 = x$1.Lcats_effect_kernel_Resource$Allocate__f_resource;
      var stack$tailLocal2$2$1 = stack$tailLocal2;
      return F$21.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$2, F$21$2, release$2, resource$2, Nil$lzy2$3$2, Frame$lzy2$3$2, stack$tailLocal2$2) => ((poll) => {
        var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
        var target = resource$2.apply__O__O(poll$1);
        var this$14 = new $c_Lcats_FlatMap$$anon$2(target, F$21$2);
        var f = new $c_sjsr_AnonFunction1(((this$4, F$22$2, release$3$2, poll$2, Nil$lzy2$4$2, Frame$lzy2$4$2, stack$tailLocal2$1$2) => ((x$1$1) => {
          var x$1$2 = $as_T2(x$1$1);
          if ((x$1$2 !== null)) {
            var b = x$1$2._1__O();
            var rel = $as_F1(x$1$2._2__O());
            var rel2 = new $c_sjsr_AnonFunction1(((F$24$2, release$5$2, rel$2) => ((ec) => {
              var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
              var wrapped = rel$2.apply__O__O(ec$1);
              var fa = F$24$2.unit__O();
              var fin = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((release$4$2, ec$2) => (() => release$4$2.apply__O__O(ec$2)))(release$5$2, ec$1)), F$24$2);
              return F$24$2.guarantee__O__O__O(wrapped, fin)
            }))(F$22$2, release$3$2, rel));
            var x = $ps_Lcats_effect_kernel_Resource__Nil$2__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy2$4$2);
            if ((x === stack$tailLocal2$1$2)) {
              return F$22$2.pure__O__O(new $c_T2(b, rel2))
            };
            if ((stack$tailLocal2$1$2 instanceof $c_Lcats_effect_kernel_Resource$Frame$3)) {
              $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$4$(this$4, Frame$lzy2$4$2);
              var x$1$3 = $as_Lcats_effect_kernel_Resource$Frame$3(stack$tailLocal2$1$2);
              var x67 = x$1$3.Lcats_effect_kernel_Resource$Frame$3__f_head;
              var x68 = x$1$3.Lcats_effect_kernel_Resource$Frame$3__f_tail;
              var current$1 = $as_Lcats_effect_kernel_Resource(x67.apply__O__O(b));
              var wrapped$1 = poll$2.apply__O__O($p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O(this$4, F$22$2, Nil$lzy2$4$2, Frame$lzy2$4$2, current$1, x68, rel2));
              var fin$1 = rel.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
              var fa$1 = F$22$2.onCancel__O__O__O(wrapped$1, fin$1);
              var pf = new $c_Lcats_effect_kernel_Resource$$anon$3(F$22$2, rel);
              return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(F$22$2, fa$1, pf)
            };
            throw new $c_s_MatchError(stack$tailLocal2$1$2)
          };
          throw new $c_s_MatchError(x$1$2)
        }))(this$2, F$21$2, release$2, poll$1, Nil$lzy2$3$2, Frame$lzy2$3$2, stack$tailLocal2$2));
        return this$14.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$$anon$2__f_self, f)
      }))($thiz, F$21, release, x90, Nil$lzy2$3, Frame$lzy2$3, stack$tailLocal2$2$1)))
    };
    if ((x77 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
      var x$1$4 = $as_Lcats_effect_kernel_Resource$Bind(x77);
      var x86 = x$1$4.Lcats_effect_kernel_Resource$Bind__f_source;
      var x87 = x$1$4.Lcats_effect_kernel_Resource$Bind__f_fs;
      var stack$tailLocal2$tmp1 = $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$4$($thiz, Frame$lzy2$3).apply__F1__Lcats_effect_kernel_Resource$Stack$2__Lcats_effect_kernel_Resource$Frame$3(x87, stack$tailLocal2);
      current$tailLocal2 = x86;
      stack$tailLocal2 = stack$tailLocal2$tmp1;
      continue
    };
    if ((x77 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
      var x$1$5 = $as_Lcats_effect_kernel_Resource$Pure(x77);
      var x83 = x$1$5.Lcats_effect_kernel_Resource$Pure__f_a;
      var x72 = stack$tailLocal2;
      var x$2 = $ps_Lcats_effect_kernel_Resource__Nil$2__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy2$3);
      if ((x$2 === x72)) {
        var a = new $c_T2(x83, release);
        return F$21.pure__O__O(a)
      };
      if ((x72 instanceof $c_Lcats_effect_kernel_Resource$Frame$3)) {
        $p_Lcats_effect_kernel_Resource__Frame$2__sr_LazyRef__Lcats_effect_kernel_Resource$Frame$4$($thiz, Frame$lzy2$3);
        var x$1$6 = $as_Lcats_effect_kernel_Resource$Frame$3(x72);
        var x75 = x$1$6.Lcats_effect_kernel_Resource$Frame$3__f_head;
        var x76 = x$1$6.Lcats_effect_kernel_Resource$Frame$3__f_tail;
        var current$tailLocal2$tmp2 = $as_Lcats_effect_kernel_Resource(x75.apply__O__O(x83));
        current$tailLocal2 = current$tailLocal2$tmp2;
        stack$tailLocal2 = x76;
        continue
      };
      throw new $c_s_MatchError(x72)
    };
    if ((x77 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
      var x$1$7 = $as_Lcats_effect_kernel_Resource$Eval(x77);
      var x80 = x$1$7.Lcats_effect_kernel_Resource$Eval__f_fa;
      var this$25 = new $c_Lcats_FlatMap$$anon$2(x80, F$21);
      var stack$tailLocal2$3$1 = stack$tailLocal2;
      var f$1 = new $c_sjsr_AnonFunction1(((this$2$1, F$21$3, release$3, Nil$lzy2$3$3, Frame$lzy2$3$3, stack$tailLocal2$3) => ((a$1) => {
        var current$2 = new $c_Lcats_effect_kernel_Resource$Pure(a$1);
        return $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O(this$2$1, F$21$3, Nil$lzy2$3$3, Frame$lzy2$3$3, current$2, stack$tailLocal2$3, release$3)
      }))($thiz, F$21, release, Nil$lzy2$3, Frame$lzy2$3, stack$tailLocal2$3$1));
      return this$25.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$25.Lcats_FlatMap$$anon$2__f_self, f$1)
    };
    throw new $c_s_MatchError(x77)
  }
}
function $p_Lcats_effect_kernel_Resource__State$lzyINIT1$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$($thiz, F$36, State$lzy1$1) {
  if ((State$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_kernel_Resource$State$1$((State$lzy1$1.sr_LazyRef__f__initialized ? State$lzy1$1.sr_LazyRef__f__value : State$lzy1$1.initialize__O__O(new $c_Lcats_effect_kernel_Resource$State$1$(F$36, $thiz))))
}
function $p_Lcats_effect_kernel_Resource__State$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$($thiz, F$37, State$lzy1$2) {
  return $as_Lcats_effect_kernel_Resource$State$1$((State$lzy1$2.sr_LazyRef__f__initialized ? State$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_kernel_Resource__State$lzyINIT1$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$($thiz, F$37, State$lzy1$2)))
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource.prototype.constructor = $c_Lcats_effect_kernel_Resource;
/** @constructor */
function $h_Lcats_effect_kernel_Resource() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource.prototype = $c_Lcats_effect_kernel_Resource.prototype;
$c_Lcats_effect_kernel_Resource.prototype.fold__F1__F1__Lcats_effect_kernel_MonadCancel__O = (function(onOutput, onRelease, F) {
  var Nil$lzy1 = new $c_sr_LazyRef();
  var Frame$lzy1 = new $c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$1__F1__F1__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$1__O(this, onOutput, onRelease, F, Nil$lzy1, Frame$lzy1, this, $ps_Lcats_effect_kernel_Resource__Nil$1__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$1$(Nil$lzy1))
});
$c_Lcats_effect_kernel_Resource.prototype.use__F1__Lcats_effect_kernel_MonadCancel__O = (function(f, F) {
  return this.fold__F1__F1__Lcats_effect_kernel_MonadCancel__O(f, new $c_sjsr_AnonFunction1(((x) => x)), F)
});
$c_Lcats_effect_kernel_Resource.prototype.useForever__Lcats_effect_kernel_GenSpawn__O = (function(F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((F$2) => ((_$2) => F$2.never__O()))(F)), F)
});
$c_Lcats_effect_kernel_Resource.prototype.use___Lcats_effect_kernel_MonadCancel__O = (function(F) {
  return this.use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((F$2) => ((_$3) => F$2.unit__O()))(F)), F)
});
$c_Lcats_effect_kernel_Resource.prototype.map__F1__Lcats_effect_kernel_Resource = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((f$2) => ((a) => {
    var a$1 = f$2.apply__O__O(a);
    return new $c_Lcats_effect_kernel_Resource$Pure(a$1)
  }))(f));
  return new $c_Lcats_effect_kernel_Resource$Bind(this, f$1)
});
$c_Lcats_effect_kernel_Resource.prototype.allocatedCase__Lcats_effect_kernel_MonadCancel__O = (function(F) {
  var Nil$lzy2 = new $c_sr_LazyRef();
  var Frame$lzy2 = new $c_sr_LazyRef();
  return $p_Lcats_effect_kernel_Resource__loop$2__Lcats_effect_kernel_MonadCancel__sr_LazyRef__sr_LazyRef__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource$Stack$2__F1__O(this, F, Nil$lzy2, Frame$lzy2, this, $ps_Lcats_effect_kernel_Resource__Nil$2__sr_LazyRef__Lcats_effect_kernel_Resource$Nil$2$(Nil$lzy2), new $c_sjsr_AnonFunction1(((F$2) => ((_$19) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$19);
    return F$2.unit__O()
  }))(F)))
});
$c_Lcats_effect_kernel_Resource.prototype.allocated__Lcats_effect_kernel_MonadCancel__O = (function(F) {
  return F.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = poll$1.apply__O__O(this$1.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F$2));
    var this$4 = new $c_Lcats_Functor$$anon$4(target, F$2);
    var f = new $c_sjsr_AnonFunction1(((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var b = x$1$1._1__O();
        var fin = $as_F1(x$1$1._2__O());
        var _2 = fin.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
        return new $c_T2(b, _2)
      };
      throw new $c_s_MatchError(x$1$1)
    }));
    return this$4.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$$anon$4__f_self, f)
  }))(this, F)))
});
$c_Lcats_effect_kernel_Resource.prototype.evalMap__F1__Lcats_effect_kernel_Resource = (function(f) {
  var f$1 = new $c_sjsr_AnonFunction1(((f$2) => ((a) => {
    var fa = f$2.apply__O__O(a);
    return new $c_Lcats_effect_kernel_Resource$Eval(fa)
  }))(f));
  return new $c_Lcats_effect_kernel_Resource$Bind(this, f$1)
});
$c_Lcats_effect_kernel_Resource.prototype.forceR__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(that, F) {
  var resource = new $c_sjsr_AnonFunction1(((this$1, that$2, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var wrapped = this$1.use___Lcats_effect_kernel_MonadCancel__O(F$2);
    var fb = that$2.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F$2);
    return poll$1.apply__O__O(F$2.forceR__O__O__O(wrapped, fb))
  }))(this, that, F));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
});
$c_Lcats_effect_kernel_Resource.prototype.onCancel__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(fin, F) {
  var resource = new $c_sjsr_AnonFunction1(((this$1, fin$2, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var wrapped = poll$1.apply__O__O(this$1.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F$2));
    var fin$1 = fin$2.use___Lcats_effect_kernel_MonadCancel__O(F$2);
    return F$2.onCancel__O__O__O(wrapped, fin$1)
  }))(this, fin, F));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
});
$c_Lcats_effect_kernel_Resource.prototype.guaranteeCase__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(fin, F) {
  var resource = new $c_sjsr_AnonFunction1(((this$1, fin$2, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$2 = $m_Lcats_effect_kernel_implicits$();
    var wrapped = poll$1.apply__O__O(this$1.allocatedCase__Lcats_effect_kernel_MonadCancel__O(F$2));
    var ev$18 = $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O(this$2, wrapped, F$2);
    var fin$1 = new $c_sjsr_AnonFunction1(((fin$2$2, F$32$2) => ((x$1) => {
      var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
      if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
        var x101 = x$1$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var this$5 = new $c_Lcats_Functor$$anon$4(x101, F$32$2);
        var f = new $c_sjsr_AnonFunction1(((_$23) => {
          var _$23$1 = $as_T2(_$23);
          return _$23$1._1__O()
        }));
        var fa = this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f);
        var fa$1 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
        var fa$2 = $as_Lcats_effect_kernel_Resource(fin$2$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1))).use___Lcats_effect_kernel_MonadCancel__O(F$32$2);
        var f$3 = new $c_sjsr_AnonFunction1(((F$33$2, ft$2) => ((e) => {
          var e$1 = $as_jl_Throwable(e);
          var this$12 = new $c_Lcats_FlatMap$$anon$2(ft$2, F$33$2);
          var f$1 = new $c_sjsr_AnonFunction1(((e$2) => ((_$24) => {
            var _$24$1 = $as_T2(_$24);
            return $as_F1(_$24$1._2__O()).apply__O__O(new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e$2))
          }))(e$1));
          var fa$3 = this$12.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$$anon$2__f_self, f$1);
          var f$2 = new $c_sjsr_AnonFunction1(((_$25) => {
            $as_jl_Throwable(_$25)
          }));
          var fa$4 = F$33$2.handleError__O__F1__O(fa$3, f$2);
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$4, new $c_sjsr_AnonFunction0(((F$34$2, e$3) => (() => F$34$2.raiseError__O__O(e$3)))(F$33$2, e$1)), F$33$2)
        }))(F$32$2, x101));
        return F$32$2.handleErrorWith__O__F1__O(fa$2, f$3)
      };
      if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
        var x98 = $as_jl_Throwable(x$1$3.Lcats_effect_kernel_Outcome$Errored__f_e);
        var fa$5 = $as_Lcats_effect_kernel_Resource(fin$2$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x98))).use___Lcats_effect_kernel_MonadCancel__O(F$32$2);
        var f$4 = new $c_sjsr_AnonFunction1(((_$26) => {
          $as_jl_Throwable(_$26)
        }));
        return F$32$2.handleError__O__F1__O(fa$5, f$4)
      };
      if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
        return $as_Lcats_effect_kernel_Resource(fin$2$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled())).use___Lcats_effect_kernel_MonadCancel__O(F$32$2)
      };
      throw new $c_s_MatchError(x$1$1)
    }))(fin$2, F$2));
    return F$2.guaranteeCase__O__F1__O(ev$18, fin$1)
  }))(this, fin, F));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
});
$c_Lcats_effect_kernel_Resource.prototype.start__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  var State$lzy1 = new $c_sr_LazyRef();
  var $$x1 = $m_Lcats_effect_kernel_Resource$();
  var target = F.ref__O__O($p_Lcats_effect_kernel_Resource__State$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$(this, F, State$lzy1).apply__O__Z__Z__Lcats_effect_kernel_Resource$State$2($p_Lcats_effect_kernel_Resource__State$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$(this, F, State$lzy1).$lessinit$greater$default$1__O(), ($p_Lcats_effect_kernel_Resource__State$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$(this, F, State$lzy1), false), ($p_Lcats_effect_kernel_Resource__State$1__Lcats_effect_kernel_GenConcurrent__sr_LazyRef__Lcats_effect_kernel_Resource$State$1$(this, F, State$lzy1), false)));
  var this$22 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f$3 = new $c_sjsr_AnonFunction1(((this$2, F$2) => ((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    var finalized = F$2.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$3, F$39$2, state$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var wrapped = poll$1.apply__O__O(this$3.allocated__Lcats_effect_kernel_MonadCancel__O(F$39$2));
      var fin = state$2.update__F1__O(new $c_sjsr_AnonFunction1(((s) => {
        var s$1 = $as_Lcats_effect_kernel_Resource$State$2(s);
        return (s$1.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete ? s$1.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$2(s$1.Lcats_effect_kernel_Resource$State$2__f_fin, s$1.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete, true) : s$1)
      })));
      var target$1 = F$39$2.guarantee__O__O__O(wrapped, fin);
      var this$15 = new $c_Lcats_FlatMap$$anon$2(target$1, F$39$2);
      var f$1 = new $c_sjsr_AnonFunction1(((F$40$2, state$1$2) => ((x$1) => {
        var x$1$1 = $as_T2(x$1);
        if ((x$1$1 !== null)) {
          var a = x$1$1._1__O();
          var rel = x$1$1._2__O();
          var action = state$1$2.modify__F1__O(new $c_sjsr_AnonFunction1(((F$41$2, rel$2) => ((s$2) => {
            var s$3 = $as_Lcats_effect_kernel_Resource$State$2(s$2);
            if (s$3.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete) {
              var f = new $c_sjsr_AnonFunction1(((_$28) => {
                $as_jl_Throwable(_$28)
              }));
              var _2 = F$41$2.handleError__O__F1__O(rel$2, f);
              return new $c_T2(s$3, _2)
            } else {
              var _1 = s$3.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$2(rel$2, s$3.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete, s$3.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete);
              var _2$1 = F$41$2.pure__O__O((void 0));
              return new $c_T2(_1, _2$1)
            }
          }))(F$40$2, rel)));
          var target$2 = $f_Lcats_FlatMap__flatten__O__O(F$40$2, action);
          var this$14 = new $c_Lcats_Functor$$anon$4(target$2, F$40$2);
          return this$14.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$14.Lcats_Functor$$anon$4__f_self, a)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(F$39$2, state$2));
      return this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, f$1)
    }))(this$2, F$2, state$1)));
    var target$3 = F$2.start__O__O(finalized);
    var this$21 = new $c_Lcats_Functor$$anon$4(target$3, F$2);
    var f$2 = new $c_sjsr_AnonFunction1(((F$39$3, state$3) => ((outer) => {
      var outer$1 = $as_Lcats_effect_kernel_Fiber(outer);
      var fiber = new $c_Lcats_effect_kernel_Resource$$anon$4(F$39$3, state$3, outer$1);
      var ffa = state$3.modify__F1__O(new $c_sjsr_AnonFunction1(((s$4) => {
        var s$5 = $as_Lcats_effect_kernel_Resource$State$2(s$4);
        var _1$1 = s$5.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$2(s$5.Lcats_effect_kernel_Resource$State$2__f_fin, true, s$5.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete);
        var _2$2 = s$5.Lcats_effect_kernel_Resource$State$2__f_fin;
        return new $c_T2(_1$1, _2$2)
      })));
      var finalizeOuter = $f_Lcats_FlatMap__flatten__O__O(F$39$3, ffa);
      return new $c_T2(fiber, finalizeOuter)
    }))(F$2, state$1));
    return this$21.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$21.Lcats_Functor$$anon$4__f_self, f$2)
  }))(this, F));
  return $$x1.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource(this$22.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$22.Lcats_FlatMap$$anon$2__f_self, f$3), F)
});
$c_Lcats_effect_kernel_Resource.prototype.attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(F) {
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x$1 = $as_Lcats_effect_kernel_Resource$Allocate(this);
    var x142 = x$1.Lcats_effect_kernel_Resource$Allocate__f_resource;
    var resource = new $c_sjsr_AnonFunction1(((F$2, resource$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var fa = resource$2.apply__O__O(poll$1);
      var target = F$2.attempt__O__O(fa);
      var this$9 = new $c_Lcats_Functor$$anon$4(target, F$2);
      var f = new $c_sjsr_AnonFunction1(((F$46$2) => ((x$1$1) => {
        var x$1$2 = $as_s_util_Either(x$1$1);
        if ((x$1$2 instanceof $c_s_util_Left)) {
          var error = $as_s_util_Left(x$1$2).s_util_Left__f_value;
          $m_s_package$();
          var _1 = new $c_s_util_Left(error);
          var _2 = new $c_sjsr_AnonFunction1(((F$47$2) => ((_$35) => {
            $as_Lcats_effect_kernel_Resource$ExitCase(_$35);
            return F$47$2.unit__O()
          }))(F$46$2));
          return new $c_T2(_1, _2)
        };
        if ((x$1$2 instanceof $c_s_util_Right)) {
          var x119 = $as_T2($as_s_util_Right(x$1$2).s_util_Right__f_value);
          if ((x119 !== null)) {
            var a = x119._1__O();
            var release = $as_F1(x119._2__O());
            $m_s_package$();
            var _1$1 = new $c_s_util_Right(a);
            return new $c_T2(_1$1, release)
          }
        };
        throw new $c_s_MatchError(x$1$2)
      }))(F$2));
      return this$9.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$9.Lcats_Functor$$anon$4__f_self, f)
    }))(F, x142));
    return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
  };
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
    var x$1$3 = $as_Lcats_effect_kernel_Resource$Bind(this);
    var x138 = x$1$3.Lcats_effect_kernel_Resource$Bind__f_source;
    var x139 = x$1$3.Lcats_effect_kernel_Resource$Bind__f_fs;
    var this$15 = new $c_Lcats_effect_kernel_Resource$Pure((void 0));
    var f$1 = new $c_sjsr_AnonFunction1(((F$3, source$2) => ((_$36) => {
      $as_jl_Void(_$36);
      return source$2.attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(F$3)
    }))(F, x138));
    var this$22 = new $c_Lcats_effect_kernel_Resource$Bind(this$15, f$1);
    var f$3 = new $c_sjsr_AnonFunction1(((F$4, f$2) => ((x$1$4) => {
      var x$1$5 = $as_s_util_Either(x$1$4);
      if ((x$1$5 instanceof $c_s_util_Left)) {
        var error$1 = $as_s_util_Left(x$1$5).s_util_Left__f_value;
        $m_s_package$();
        var a$1 = new $c_s_util_Left(error$1);
        return new $c_Lcats_effect_kernel_Resource$Pure(a$1)
      };
      if ((x$1$5 instanceof $c_s_util_Right)) {
        var s = $as_s_util_Right(x$1$5).s_util_Right__f_value;
        return $as_Lcats_effect_kernel_Resource(f$2.apply__O__O(s)).attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(F$4)
      };
      throw new $c_s_MatchError(x$1$5)
    }))(F, x139));
    return new $c_Lcats_effect_kernel_Resource$Bind(this$22, f$3)
  };
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x$1$6 = $as_Lcats_effect_kernel_Resource$Pure(this);
    var p = $as_Lcats_effect_kernel_Resource$Pure(this);
    var a$2 = p.Lcats_effect_kernel_Resource$Pure__f_a;
    $m_s_package$();
    var a$3 = new $c_s_util_Right(a$2);
    return new $c_Lcats_effect_kernel_Resource$Pure(a$3)
  };
  if ((this instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x$1$7 = $as_Lcats_effect_kernel_Resource$Eval(this);
    var e = $as_Lcats_effect_kernel_Resource$Eval(this);
    var fa$1 = e.Lcats_effect_kernel_Resource$Eval__f_fa;
    var fa$2 = F.attempt__O__O(fa$1);
    return new $c_Lcats_effect_kernel_Resource$Eval(fa$2)
  };
  throw new $c_s_MatchError(this)
});
$c_Lcats_effect_kernel_Resource.prototype.handleErrorWith__F1__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(f, F) {
  var this$3 = this.attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(F);
  var f$1 = new $c_sjsr_AnonFunction1(((f$2) => ((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var a = $as_s_util_Right(x$1$1).s_util_Right__f_value;
      return new $c_Lcats_effect_kernel_Resource$Pure(a)
    };
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var e = $as_s_util_Left(x$1$1).s_util_Left__f_value;
      return $as_Lcats_effect_kernel_Resource(f$2.apply__O__O(e))
    };
    throw new $c_s_MatchError(x$1$1)
  }))(f));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$3, f$1)
});
function $as_Lcats_effect_kernel_Resource(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource"))
}
function $isArrayOf_Lcats_effect_kernel_Resource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource)))
}
function $asArrayOf_Lcats_effect_kernel_Resource(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances1() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype = new $h_O();
$c_Lcats_effect_kernel_ResourceFOInstances1.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances1;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceFOInstances1.prototype = $c_Lcats_effect_kernel_ResourceFOInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Sync$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Sync$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$.prototype.constructor = $c_Lcats_effect_kernel_Sync$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Sync$.prototype = $c_Lcats_effect_kernel_Sync$.prototype;
var $d_Lcats_effect_kernel_Sync$ = new $TypeData().initClass({
  Lcats_effect_kernel_Sync$: 0
}, false, "cats.effect.kernel.Sync$", {
  Lcats_effect_kernel_Sync$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Sync$.prototype.$classData = $d_Lcats_effect_kernel_Sync$;
var $n_Lcats_effect_kernel_Sync$;
function $m_Lcats_effect_kernel_Sync$() {
  if ((!$n_Lcats_effect_kernel_Sync$)) {
    $n_Lcats_effect_kernel_Sync$ = new $c_Lcats_effect_kernel_Sync$()
  };
  return $n_Lcats_effect_kernel_Sync$
}
/** @constructor */
function $c_Lcats_effect_kernel_Unique$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Unique$.prototype = new $h_O();
$c_Lcats_effect_kernel_Unique$.prototype.constructor = $c_Lcats_effect_kernel_Unique$;
/** @constructor */
function $h_Lcats_effect_kernel_Unique$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Unique$.prototype = $c_Lcats_effect_kernel_Unique$.prototype;
var $d_Lcats_effect_kernel_Unique$ = new $TypeData().initClass({
  Lcats_effect_kernel_Unique$: 0
}, false, "cats.effect.kernel.Unique$", {
  Lcats_effect_kernel_Unique$: 1,
  O: 1
});
$c_Lcats_effect_kernel_Unique$.prototype.$classData = $d_Lcats_effect_kernel_Unique$;
var $n_Lcats_effect_kernel_Unique$;
function $m_Lcats_effect_kernel_Unique$() {
  if ((!$n_Lcats_effect_kernel_Unique$)) {
    $n_Lcats_effect_kernel_Unique$ = new $c_Lcats_effect_kernel_Unique$()
  };
  return $n_Lcats_effect_kernel_Unique$
}
/** @constructor */
function $c_Lcats_effect_kernel_Unique$Token() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Unique$Token.prototype = new $h_O();
$c_Lcats_effect_kernel_Unique$Token.prototype.constructor = $c_Lcats_effect_kernel_Unique$Token;
/** @constructor */
function $h_Lcats_effect_kernel_Unique$Token() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Unique$Token.prototype = $c_Lcats_effect_kernel_Unique$Token.prototype;
function $as_Lcats_effect_kernel_Unique$Token(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Unique$Token) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Unique$Token"))
}
function $isArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Unique$Token)))
}
function $asArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Unique$Token(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Unique$Token;", depth))
}
var $d_Lcats_effect_kernel_Unique$Token = new $TypeData().initClass({
  Lcats_effect_kernel_Unique$Token: 0
}, false, "cats.effect.kernel.Unique$Token", {
  Lcats_effect_kernel_Unique$Token: 1,
  O: 1
});
$c_Lcats_effect_kernel_Unique$Token.prototype.$classData = $d_Lcats_effect_kernel_Unique$Token;
/** @constructor */
function $c_Lcats_effect_kernel_package$() {
  this.Lcats_effect_kernel_package$__f_MonadCancelThrow = null;
  this.Lcats_effect_kernel_package$__f_Spawn = null;
  this.Lcats_effect_kernel_package$__f_Temporal = null;
  this.Lcats_effect_kernel_package$__f_Concurrent = null;
  this.Lcats_effect_kernel_package$__f_ParallelF = null;
  $n_Lcats_effect_kernel_package$ = this;
  this.Lcats_effect_kernel_package$__f_MonadCancelThrow = $m_Lcats_effect_kernel_MonadCancel$();
  this.Lcats_effect_kernel_package$__f_Spawn = $m_Lcats_effect_kernel_GenSpawn$();
  this.Lcats_effect_kernel_package$__f_Temporal = $m_Lcats_effect_kernel_GenTemporal$();
  this.Lcats_effect_kernel_package$__f_Concurrent = $m_Lcats_effect_kernel_GenConcurrent$();
  this.Lcats_effect_kernel_package$__f_ParallelF = $m_Lcats_effect_kernel_Par$ParallelF$()
}
$c_Lcats_effect_kernel_package$.prototype = new $h_O();
$c_Lcats_effect_kernel_package$.prototype.constructor = $c_Lcats_effect_kernel_package$;
/** @constructor */
function $h_Lcats_effect_kernel_package$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_package$.prototype = $c_Lcats_effect_kernel_package$.prototype;
var $d_Lcats_effect_kernel_package$ = new $TypeData().initClass({
  Lcats_effect_kernel_package$: 0
}, false, "cats.effect.kernel.package$", {
  Lcats_effect_kernel_package$: 1,
  O: 1
});
$c_Lcats_effect_kernel_package$.prototype.$classData = $d_Lcats_effect_kernel_package$;
var $n_Lcats_effect_kernel_package$;
function $m_Lcats_effect_kernel_package$() {
  if ((!$n_Lcats_effect_kernel_package$)) {
    $n_Lcats_effect_kernel_package$ = new $c_Lcats_effect_kernel_package$()
  };
  return $n_Lcats_effect_kernel_package$
}
function $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O($thiz, wrapped, F) {
  return wrapped
}
/** @constructor */
function $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype = new $h_O();
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype.constructor = $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$;
/** @constructor */
function $h_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype = $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype;
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype.uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O = (function(this$, F) {
  return F.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((\u03b4this) => ((_$4) => {
    $as_Lcats_effect_kernel_Poll(_$4);
    return \u03b4this
  }))(this$)))
});
var $d_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ = new $TypeData().initClass({
  Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$: 0
}, false, "cats.effect.kernel.syntax.MonadCancelOps_$", {
  Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$: 1,
  O: 1
});
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype.$classData = $d_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$;
var $n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$;
function $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$() {
  if ((!$n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$)) {
    $n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ = new $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$()
  };
  return $n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$
}
function $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O($thiz, wrapped, F) {
  return wrapped
}
/** @constructor */
function $c_Lcats_effect_package$() {
  this.Lcats_effect_package$__f_Outcome = null;
  this.Lcats_effect_package$__f_MonadCancel = null;
  this.Lcats_effect_package$__f_GenSpawn = null;
  this.Lcats_effect_package$__f_GenConcurrent = null;
  this.Lcats_effect_package$__f_Clock = null;
  this.Lcats_effect_package$__f_GenTemporal = null;
  this.Lcats_effect_package$__f_Unique = null;
  this.Lcats_effect_package$__f_Sync = null;
  this.Lcats_effect_package$__f_Async = null;
  this.Lcats_effect_package$__f_MonadCancelThrow = null;
  this.Lcats_effect_package$__f_Spawn = null;
  this.Lcats_effect_package$__f_Concurrent = null;
  this.Lcats_effect_package$__f_Temporal = null;
  this.Lcats_effect_package$__f_ParallelF = null;
  this.Lcats_effect_package$__f_Resource = null;
  this.Lcats_effect_package$__f_Deferred = null;
  this.Lcats_effect_package$__f_Ref = null;
  $n_Lcats_effect_package$ = this;
  this.Lcats_effect_package$__f_Outcome = $m_Lcats_effect_kernel_Outcome$();
  this.Lcats_effect_package$__f_MonadCancel = $m_Lcats_effect_kernel_MonadCancel$();
  this.Lcats_effect_package$__f_GenSpawn = $m_Lcats_effect_kernel_GenSpawn$();
  this.Lcats_effect_package$__f_GenConcurrent = $m_Lcats_effect_kernel_GenConcurrent$();
  this.Lcats_effect_package$__f_Clock = $m_Lcats_effect_kernel_Clock$();
  this.Lcats_effect_package$__f_GenTemporal = $m_Lcats_effect_kernel_GenTemporal$();
  this.Lcats_effect_package$__f_Unique = $m_Lcats_effect_kernel_Unique$();
  this.Lcats_effect_package$__f_Sync = $m_Lcats_effect_kernel_Sync$();
  this.Lcats_effect_package$__f_Async = $m_Lcats_effect_kernel_Async$();
  this.Lcats_effect_package$__f_MonadCancelThrow = $m_Lcats_effect_kernel_package$().Lcats_effect_kernel_package$__f_MonadCancelThrow;
  this.Lcats_effect_package$__f_Spawn = $m_Lcats_effect_kernel_package$().Lcats_effect_kernel_package$__f_Spawn;
  this.Lcats_effect_package$__f_Concurrent = $m_Lcats_effect_kernel_package$().Lcats_effect_kernel_package$__f_Concurrent;
  this.Lcats_effect_package$__f_Temporal = $m_Lcats_effect_kernel_package$().Lcats_effect_kernel_package$__f_Temporal;
  this.Lcats_effect_package$__f_ParallelF = $m_Lcats_effect_kernel_Par$ParallelF$();
  this.Lcats_effect_package$__f_Resource = $m_Lcats_effect_kernel_Resource$();
  this.Lcats_effect_package$__f_Deferred = $m_Lcats_effect_kernel_Deferred$();
  this.Lcats_effect_package$__f_Ref = $m_Lcats_effect_kernel_Ref$()
}
$c_Lcats_effect_package$.prototype = new $h_O();
$c_Lcats_effect_package$.prototype.constructor = $c_Lcats_effect_package$;
/** @constructor */
function $h_Lcats_effect_package$() {
  /*<skip>*/
}
$h_Lcats_effect_package$.prototype = $c_Lcats_effect_package$.prototype;
var $d_Lcats_effect_package$ = new $TypeData().initClass({
  Lcats_effect_package$: 0
}, false, "cats.effect.package$", {
  Lcats_effect_package$: 1,
  O: 1
});
$c_Lcats_effect_package$.prototype.$classData = $d_Lcats_effect_package$;
var $n_Lcats_effect_package$;
function $m_Lcats_effect_package$() {
  if ((!$n_Lcats_effect_package$)) {
    $n_Lcats_effect_package$ = new $c_Lcats_effect_package$()
  };
  return $n_Lcats_effect_package$
}
/** @constructor */
function $c_Lcats_effect_process$() {
  /*<skip>*/
}
$c_Lcats_effect_process$.prototype = new $h_O();
$c_Lcats_effect_process$.prototype.constructor = $c_Lcats_effect_process$;
/** @constructor */
function $h_Lcats_effect_process$() {
  /*<skip>*/
}
$h_Lcats_effect_process$.prototype = $c_Lcats_effect_process$.prototype;
$c_Lcats_effect_process$.prototype.env__T__s_Option = (function(key) {
  try {
    var $$x1 = new $c_s_util_Success(process.env[key])
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      matchEnd8: {
        var $$x1;
        if ((e$2 !== null)) {
          var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
          if ((!o11.isEmpty__Z())) {
            var e$3 = $as_jl_Throwable(o11.get__O());
            var $$x1 = new $c_s_util_Failure(e$3);
            break matchEnd8
          }
        };
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
      }
    } else {
      var $$x1;
      throw e
    }
  };
  var target = $$x1.orElse__F0__s_util_Try(new $c_sjsr_AnonFunction0(((key$3) => (() => {
    try {
      return new $c_s_util_Success(process.env[("REACT_APP_" + key$3)])
    } catch (e$1) {
      var e$2$1 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$1);
      if ((e$2$1 !== null)) {
        if ((e$2$1 !== null)) {
          var o11$1 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$1);
          if ((!o11$1.isEmpty__Z())) {
            var e$3$1 = $as_jl_Throwable(o11$1.get__O());
            return new $c_s_util_Failure(e$3$1)
          }
        };
        throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$1)
      } else {
        throw e$1
      }
    }
  }))(key)));
  $m_Lcats_Invariant$();
  var tc = new $c_Lcats_instances_TryInstances$$anon$1();
  var this$7 = new $c_Lcats_Functor$$anon$4(target, tc);
  var fa = this$7.Lcats_Functor$$anon$4__f_self;
  return $as_s_util_Try(fa).collect__s_PartialFunction__s_util_Try(new $c_Lcats_effect_process$$anon$1()).toOption__s_Option()
});
var $d_Lcats_effect_process$ = new $TypeData().initClass({
  Lcats_effect_process$: 0
}, false, "cats.effect.process$", {
  Lcats_effect_process$: 1,
  O: 1
});
$c_Lcats_effect_process$.prototype.$classData = $d_Lcats_effect_process$;
var $n_Lcats_effect_process$;
function $m_Lcats_effect_process$() {
  if ((!$n_Lcats_effect_process$)) {
    $n_Lcats_effect_process$ = new $c_Lcats_effect_process$()
  };
  return $n_Lcats_effect_process$
}
function $p_Lcats_effect_std_Dispatcher$__Registration$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Registration$2$($thiz, Registration$lzy1$1) {
  if ((Registration$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_std_Dispatcher$Registration$2$((Registration$lzy1$1.sr_LazyRef__f__initialized ? Registration$lzy1$1.sr_LazyRef__f__value : Registration$lzy1$1.initialize__O__O(new $c_Lcats_effect_std_Dispatcher$Registration$2$())))
}
function $p_Lcats_effect_std_Dispatcher$__CancelInit$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelInit$1$($thiz, CancelInit$lzy1$1) {
  if ((CancelInit$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_std_Dispatcher$CancelInit$1$((CancelInit$lzy1$1.sr_LazyRef__f__initialized ? CancelInit$lzy1$1.sr_LazyRef__f__value : CancelInit$lzy1$1.initialize__O__O(new $c_Lcats_effect_std_Dispatcher$CancelInit$1$())))
}
function $p_Lcats_effect_std_Dispatcher$__CanceledNoToken$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CanceledNoToken$2$($thiz, CanceledNoToken$lzy1$1) {
  if ((CanceledNoToken$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_std_Dispatcher$CanceledNoToken$2$((CanceledNoToken$lzy1$1.sr_LazyRef__f__initialized ? CanceledNoToken$lzy1$1.sr_LazyRef__f__value : CanceledNoToken$lzy1$1.initialize__O__O(new $c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$())))
}
function $p_Lcats_effect_std_Dispatcher$__CancelToken$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelToken$2$($thiz, CancelToken$lzy1$1) {
  if ((CancelToken$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lcats_effect_std_Dispatcher$CancelToken$2$((CancelToken$lzy1$1.sr_LazyRef__f__initialized ? CancelToken$lzy1$1.sr_LazyRef__f__value : CancelToken$lzy1$1.initialize__O__O(new $c_Lcats_effect_std_Dispatcher$CancelToken$2$())))
}
function $p_Lcats_effect_std_Dispatcher$__supervise$4__Lcats_effect_kernel_Async__Lcats_effect_std_Supervisor__O__F1__O($thiz, F$11, supervisor$9, action$1, prepareCancel$1) {
  var target = supervisor$9.supervise__O__O(action$1);
  var this$4 = new $c_Lcats_FlatMap$$anon$2(target, F$11);
  var f$3 = new $c_sjsr_AnonFunction1(((F$11$2, prepareCancel$1$2) => ((f) => {
    var f$1 = $as_Lcats_effect_kernel_Fiber(f);
    return F$11$2.delay__F0__O(new $c_sjsr_AnonFunction0(((prepareCancel$2$2, f$2) => (() => {
      prepareCancel$2$2.apply__O__O(f$2.cancel__O())
    }))(prepareCancel$1$2, f$1)))
  }))(F$11, prepareCancel$1));
  return this$4.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$$anon$2__f_self, f$3)
}
function $p_Lcats_effect_std_Dispatcher$__dispatcher$13__Lcats_effect_kernel_Async__Lcats_effect_std_Supervisor__sr_LazyRef__ju_concurrent_atomic_AtomicReference__Aju_concurrent_atomic_AtomicReference__O($thiz, F$7, supervisor$5, Registration$lzy1$8, latch, state) {
  var target = F$7.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, latch$2) => (() => {
    latch$2.ju_concurrent_atomic_AtomicReference__f_value = this$1.Lcats_effect_std_Dispatcher$__f_Noop
  }))($thiz, latch)));
  var this$16 = new $c_Lcats_FlatMap$$anon$2(target, F$7);
  var f$3 = new $c_sjsr_AnonFunction1(((this$2$1, F$7$2, supervisor$5$2, latch$3, state$2, Registration$lzy1$8$2) => ((x$1) => {
    $as_jl_Void(x$1);
    var target$1 = F$7$2.delay__F0__O(new $c_sjsr_AnonFunction0(((this$3, state$1$2) => (() => {
      var buffer = new $c_scm_ListBuffer();
      var i = 0;
      while ((i < this$3.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus)) {
        var st = state$1$2.get(i);
        if ((st.ju_concurrent_atomic_AtomicReference__f_value !== $m_s_package$().s_package$__f_Nil)) {
          var list = $as_sci_List(st.getAndSet__O__O($m_s_package$().s_package$__f_Nil));
          var xs = list.reverse__sci_List();
          buffer.addAll__sc_IterableOnce__scm_ListBuffer(xs)
        };
        i = ((1 + i) | 0)
      };
      return buffer.toList__sci_List()
    }))(this$2$1, state$2)));
    var this$15 = new $c_Lcats_FlatMap$$anon$2(target$1, F$7$2);
    var f$2 = new $c_sjsr_AnonFunction1(((this$2$2, F$8$2, supervisor$6$2, latch$2$2, Registration$lzy1$9$2) => ((regs) => {
      var regs$1 = $as_sci_List(regs);
      if (regs$1.isEmpty__Z()) {
        var target$2 = F$8$2.async___F1__O(new $c_sjsr_AnonFunction1(((this$6, latch$3$2) => ((cb) => {
          var cb$1 = $as_F1(cb);
          if ((!latch$3$2.compareAndSet__O__O__Z(this$6.Lcats_effect_std_Dispatcher$__f_Noop, new $c_sjsr_AnonFunction0(((this$7, cb$2) => (() => {
            cb$2.apply__O__O(this$7.Lcats_effect_std_Dispatcher$__f_Completed)
          }))(this$6, cb$1))))) {
            cb$1.apply__O__O(this$6.Lcats_effect_std_Dispatcher$__f_Completed)
          }
        }))(this$2$2, latch$2$2)))
      } else {
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
        var this$11 = new $c_Lcats_Foldable$$anon$6(regs$1, tc);
        var f = new $c_sjsr_AnonFunction1(((this$2$3, F$9$2, supervisor$7$2, Registration$lzy1$10$2) => ((x$1$2) => {
          var x$1$3 = $as_Lcats_effect_std_Dispatcher$Registration$1(x$1$2);
          if ((x$1$3 !== null)) {
            this$2$3.cats$effect$std$Dispatcher$$$_$Registration$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Registration$2$(Registration$lzy1$10$2);
            var x17 = x$1$3.Lcats_effect_std_Dispatcher$Registration$1__f_action;
            var x18 = x$1$3.Lcats_effect_std_Dispatcher$Registration$1__f_prepareCancel;
            return (x$1$3.ju_concurrent_atomic_AtomicBoolean__f_value ? $p_Lcats_effect_std_Dispatcher$__supervise$4__Lcats_effect_kernel_Async__Lcats_effect_std_Supervisor__O__F1__O(this$2$3, F$9$2, supervisor$7$2, x17, x18) : F$9$2.pure__O__O((void 0)))
          };
          throw new $c_s_MatchError(x$1$3)
        }))(this$2$2, F$8$2, supervisor$6$2, Registration$lzy1$9$2));
        var wrapped = this$11.Lcats_Foldable$$anon$6__f_typeClassInstance.traverse___O__F1__Lcats_Applicative__O(this$11.Lcats_Foldable$$anon$6__f_self, f, F$8$2);
        var target$2 = $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped, F$8$2)
      };
      var this$14 = new $c_Lcats_Functor$$anon$4(target$2, F$8$2);
      var f$1 = new $c_sjsr_AnonFunction1(((x$1$2$1) => {
        $as_jl_Void(x$1$2$1)
      }));
      return this$14.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$14.Lcats_Functor$$anon$4__f_self, f$1)
    }))(this$2$1, F$7$2, supervisor$5$2, latch$3, Registration$lzy1$8$2));
    return this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, f$2)
  }))($thiz, F$7, supervisor$5, latch, state, Registration$lzy1$8));
  return this$16.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$16.Lcats_FlatMap$$anon$2__f_self, f$3)
}
function $s_Lcats_effect_std_Dispatcher$__cats$effect$std$Dispatcher$$anon$2$$_$enqueue$1__ju_concurrent_atomic_AtomicReference__Lcats_effect_std_Dispatcher$Registration$1__V(state, reg) {
  while (true) {
    var curr = $as_sci_List(state.ju_concurrent_atomic_AtomicReference__f_value);
    var next = new $c_sci_$colon$colon(reg, curr);
    if ((!state.compareAndSet__O__O__Z(curr, next))) {
      continue
    };
    return (void 0)
  }
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$() {
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus = 0;
  this.Lcats_effect_std_Dispatcher$__f_Noop = null;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Open = null;
  this.Lcats_effect_std_Dispatcher$__f_Completed = null;
  $n_Lcats_effect_std_Dispatcher$ = this;
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus = ($m_jl_Runtime$(), 1);
  this.Lcats_effect_std_Dispatcher$__f_Noop = new $c_sjsr_AnonFunction0((() => (void 0)));
  this.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Open = new $c_sjsr_AnonFunction0((() => (void 0)));
  this.Lcats_effect_std_Dispatcher$__f_Completed = ($m_s_package$(), new $c_s_util_Right((void 0)))
}
$c_Lcats_effect_std_Dispatcher$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$.prototype = $c_Lcats_effect_std_Dispatcher$.prototype;
$c_Lcats_effect_std_Dispatcher$.prototype.apply__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(F) {
  var Registration$lzy1 = new $c_sr_LazyRef();
  var CancelInit$lzy1 = new $c_sr_LazyRef();
  var CanceledNoToken$lzy1 = new $c_sr_LazyRef();
  var CancelToken$lzy1 = new $c_sr_LazyRef();
  var this$39 = $m_Lcats_effect_std_Supervisor$().apply__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(F);
  var Registration$lzy1$2$1 = Registration$lzy1;
  var CancelInit$lzy1$2$1 = CancelInit$lzy1;
  var CanceledNoToken$lzy1$2$1 = CanceledNoToken$lzy1;
  var CancelToken$lzy1$2$1 = CancelToken$lzy1;
  var f$5 = new $c_sjsr_AnonFunction1(((this$1, F$2, Registration$lzy1$2, CancelInit$lzy1$2, CanceledNoToken$lzy1$2, CancelToken$lzy1$2) => ((supervisor) => {
    var supervisor$1 = $as_Lcats_effect_std_Supervisor(supervisor);
    var fa = F$2.delay__F0__O(new $c_sjsr_AnonFunction0(((this$2) => (() => {
      var dimensions = new $ac_I(new Int32Array([this$2.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus]));
      var latches = $asArrayOf_ju_concurrent_atomic_AtomicReference($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_ju_concurrent_atomic_AtomicReference.getClassOf(), dimensions), 1);
      var i = 0;
      while ((i < this$2.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus)) {
        latches.set(i, $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), this$2.Lcats_effect_std_Dispatcher$__f_Noop));
        i = ((1 + i) | 0)
      };
      return latches
    }))(this$1)));
    var this$37 = new $c_Lcats_effect_kernel_Resource$Eval(fa);
    var f$4 = new $c_sjsr_AnonFunction1(((this$2$1, F$1$2, supervisor$2, Registration$lzy1$3$2, CancelInit$lzy1$3$2, CanceledNoToken$lzy1$3$2, CancelToken$lzy1$3$2) => ((latches$1) => {
      var latches$2 = $asArrayOf_ju_concurrent_atomic_AtomicReference(latches$1, 1);
      var fa$1 = F$1$2.delay__F0__O(new $c_sjsr_AnonFunction0(((this$6) => (() => {
        var dimensions$1 = new $ac_I(new Int32Array([this$6.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus, this$6.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus]));
        var states = $asArrayOf_ju_concurrent_atomic_AtomicReference($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_ju_concurrent_atomic_AtomicReference.getClassOf(), dimensions$1), 2);
        var i$1 = 0;
        while ((i$1 < this$6.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus)) {
          var j = 0;
          while ((j < this$6.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus)) {
            states.get(i$1).set(j, $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), $m_s_package$().s_package$__f_Nil));
            j = ((1 + j) | 0)
          };
          i$1 = ((1 + i$1) | 0)
        };
        return states
      }))(this$2$1)));
      var this$35 = new $c_Lcats_effect_kernel_Resource$Eval(fa$1);
      var f$3 = new $c_sjsr_AnonFunction1(((this$2$2, F$2$2, supervisor$1$2, latches$2$1, Registration$lzy1$4$2, CancelInit$lzy1$4$2, CanceledNoToken$lzy1$4$2, CancelToken$lzy1$4$2) => ((states$1) => {
        var states$2 = $asArrayOf_ju_concurrent_atomic_AtomicReference(states$1, 2);
        var fa$2 = F$2$2.executionContext__O();
        var this$33 = new $c_Lcats_effect_kernel_Resource$Eval(fa$2);
        var f$2 = new $c_sjsr_AnonFunction1(((this$12, F$3$2, supervisor$2$2, latches$1$2, states$2$1, Registration$lzy1$5$2, CancelInit$lzy1$5$2, CanceledNoToken$lzy1$5$2, CancelToken$lzy1$5$2) => ((ec) => {
          var ec$1 = $as_s_concurrent_ExecutionContext(ec);
          var this$31 = $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource(F$3$2.delay__F0__O(new $c_sjsr_AnonFunction0((() => $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), true)))), new $c_sjsr_AnonFunction1(((F$4$2) => ((ref) => {
            var ref$1 = $as_ju_concurrent_atomic_AtomicBoolean(ref);
            return F$4$2.delay__F0__O(new $c_sjsr_AnonFunction0(((ref$2) => (() => {
              ref$2.ju_concurrent_atomic_AtomicBoolean__f_value = false
            }))(ref$1)))
          }))(F$3$2)), F$3$2);
          var f$1 = new $c_sjsr_AnonFunction1(((this$3$1, F$4$3, supervisor$3$2, latches$2$2, states$1$2, ec$2, Registration$lzy1$6$2, CancelInit$lzy1$6$2, CanceledNoToken$lzy1$6$2, CancelToken$lzy1$6$2) => ((alive) => {
            var alive$1 = $as_ju_concurrent_atomic_AtomicBoolean(alive);
            var end = this$3$1.Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus;
            var isEmpty = (end <= 0);
            if (isEmpty) {
              var scala$collection$immutable$Range$$numRangeElements = 0
            } else {
              var hi = (end >> 31);
              var scala$collection$immutable$Range$$numRangeElements = (((hi === 0) ? (((-2147483648) ^ end) > (-1)) : (hi > 0)) ? (-1) : end)
            };
            var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
            $m_sci_List$();
            var this$21 = $m_sci_Nil$();
            if ((scala$collection$immutable$Range$$numRangeElements < 0)) {
              $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(0, end, 1, false)
            };
            if ((scala$collection$immutable$Range$$numRangeElements === 0)) {
              var target = this$21
            } else {
              var iter = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
              if (iter.sci_RangeIterator__f__hasNext) {
                var result = new $c_sci_$colon$colon(iter.next__I(), this$21);
                var curr = result;
                while (iter.sci_RangeIterator__f__hasNext) {
                  var temp = new $c_sci_$colon$colon(iter.next__I(), this$21);
                  curr.sci_$colon$colon__f_next = temp;
                  curr = temp
                };
                var target = result
              } else {
                var target = this$21
              }
            };
            $m_Lcats_UnorderedFoldable$();
            var tc = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
            var this$30 = new $c_Lcats_Foldable$$anon$6(target, tc);
            var f = new $c_sjsr_AnonFunction1(((this$24, F$6$2, supervisor$4$2, latches$3$2, states$2$2, Registration$lzy1$7$2) => ((n) => {
              var n$1 = $uI(n);
              var this$27 = $m_Lcats_effect_kernel_implicits$();
              var fa$3 = $p_Lcats_effect_std_Dispatcher$__dispatcher$13__Lcats_effect_kernel_Async__Lcats_effect_std_Supervisor__sr_LazyRef__ju_concurrent_atomic_AtomicReference__Aju_concurrent_atomic_AtomicReference__O(this$24, F$6$2, supervisor$4$2, Registration$lzy1$7$2, latches$3$2.get(n$1), states$2$2.get(n$1));
              var wrapped = $f_Lcats_FlatMap__foreverM__O__O(F$6$2, fa$3);
              var ev$3 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$27, wrapped, F$6$2);
              return $f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource(F$6$2, ev$3)
            }))(this$3$1, F$4$3, supervisor$3$2, latches$2$2, states$1$2, Registration$lzy1$6$2));
            var G = new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1(F$4$3);
            return $as_Lcats_effect_kernel_Resource(this$30.Lcats_Foldable$$anon$6__f_typeClassInstance.traverse___O__F1__Lcats_Applicative__O(this$30.Lcats_Foldable$$anon$6__f_self, f, G)).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((F$6$3, latches$3$3, states$2$3, ec$1$2, alive$2, Registration$lzy1$7$3, CancelInit$lzy1$7$2, CanceledNoToken$lzy1$7$2, CancelToken$lzy1$7$2) => ((x$1) => {
              $as_jl_Void(x$1);
              return new $c_Lcats_effect_std_Dispatcher$$anon$2(F$6$3, latches$3$3, states$2$3, ec$1$2, alive$2, Registration$lzy1$7$3, CancelInit$lzy1$7$2, CanceledNoToken$lzy1$7$2, CancelToken$lzy1$7$2)
            }))(F$4$3, latches$2$2, states$1$2, ec$2, alive$1, Registration$lzy1$6$2, CancelInit$lzy1$6$2, CanceledNoToken$lzy1$6$2, CancelToken$lzy1$6$2)))
          }))(this$12, F$3$2, supervisor$2$2, latches$1$2, states$2$1, ec$1, Registration$lzy1$5$2, CancelInit$lzy1$5$2, CanceledNoToken$lzy1$5$2, CancelToken$lzy1$5$2));
          return new $c_Lcats_effect_kernel_Resource$Bind(this$31, f$1)
        }))(this$2$2, F$2$2, supervisor$1$2, latches$2$1, states$2, Registration$lzy1$4$2, CancelInit$lzy1$4$2, CanceledNoToken$lzy1$4$2, CancelToken$lzy1$4$2));
        return new $c_Lcats_effect_kernel_Resource$Bind(this$33, f$2)
      }))(this$2$1, F$1$2, supervisor$2, latches$2, Registration$lzy1$3$2, CancelInit$lzy1$3$2, CanceledNoToken$lzy1$3$2, CancelToken$lzy1$3$2));
      return new $c_Lcats_effect_kernel_Resource$Bind(this$35, f$3)
    }))(this$1, F$2, supervisor$1, Registration$lzy1$2, CancelInit$lzy1$2, CanceledNoToken$lzy1$2, CancelToken$lzy1$2));
    return new $c_Lcats_effect_kernel_Resource$Bind(this$37, f$4)
  }))(this, F, Registration$lzy1$2$1, CancelInit$lzy1$2$1, CanceledNoToken$lzy1$2$1, CancelToken$lzy1$2$1));
  return new $c_Lcats_effect_kernel_Resource$Bind(this$39, f$5)
});
$c_Lcats_effect_std_Dispatcher$.prototype.cats$effect$std$Dispatcher$$$_$Registration$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Registration$2$ = (function(Registration$lzy1$2) {
  return $as_Lcats_effect_std_Dispatcher$Registration$2$((Registration$lzy1$2.sr_LazyRef__f__initialized ? Registration$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$__Registration$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Registration$2$(this, Registration$lzy1$2)))
});
$c_Lcats_effect_std_Dispatcher$.prototype.cats$effect$std$Dispatcher$$$_$CancelInit$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelInit$1$ = (function(CancelInit$lzy1$2) {
  return $as_Lcats_effect_std_Dispatcher$CancelInit$1$((CancelInit$lzy1$2.sr_LazyRef__f__initialized ? CancelInit$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$__CancelInit$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelInit$1$(this, CancelInit$lzy1$2)))
});
$c_Lcats_effect_std_Dispatcher$.prototype.cats$effect$std$Dispatcher$$$_$CanceledNoToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CanceledNoToken$2$ = (function(CanceledNoToken$lzy1$2) {
  return $as_Lcats_effect_std_Dispatcher$CanceledNoToken$2$((CanceledNoToken$lzy1$2.sr_LazyRef__f__initialized ? CanceledNoToken$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$__CanceledNoToken$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CanceledNoToken$2$(this, CanceledNoToken$lzy1$2)))
});
$c_Lcats_effect_std_Dispatcher$.prototype.cats$effect$std$Dispatcher$$$_$CancelToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelToken$2$ = (function(CancelToken$lzy1$2) {
  return $as_Lcats_effect_std_Dispatcher$CancelToken$2$((CancelToken$lzy1$2.sr_LazyRef__f__initialized ? CancelToken$lzy1$2.sr_LazyRef__f__value : $p_Lcats_effect_std_Dispatcher$__CancelToken$lzyINIT1$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelToken$2$(this, CancelToken$lzy1$2)))
});
var $d_Lcats_effect_std_Dispatcher$ = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$: 0
}, false, "cats.effect.std.Dispatcher$", {
  Lcats_effect_std_Dispatcher$: 1,
  O: 1
});
$c_Lcats_effect_std_Dispatcher$.prototype.$classData = $d_Lcats_effect_std_Dispatcher$;
var $n_Lcats_effect_std_Dispatcher$;
function $m_Lcats_effect_std_Dispatcher$() {
  if ((!$n_Lcats_effect_std_Dispatcher$)) {
    $n_Lcats_effect_std_Dispatcher$ = new $c_Lcats_effect_std_Dispatcher$()
  };
  return $n_Lcats_effect_std_Dispatcher$
}
function $is_Lcats_effect_std_Dispatcher$CancelState$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Dispatcher$CancelState$1)))
}
function $as_Lcats_effect_std_Dispatcher$CancelState$1(obj) {
  return (($is_Lcats_effect_std_Dispatcher$CancelState$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$CancelState$1"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$CancelState$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$CancelState$1)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$CancelState$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$CancelState$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$CancelState$1;", depth))
}
function $p_Lcats_effect_std_Queue$__assertNonNegative__I__V($thiz, capacity) {
  if ((capacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Bounded queue capacity must be non-negative, was: " + capacity))
  }
}
/** @constructor */
function $c_Lcats_effect_std_Queue$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Queue$.prototype = new $h_O();
$c_Lcats_effect_std_Queue$.prototype.constructor = $c_Lcats_effect_std_Queue$;
/** @constructor */
function $h_Lcats_effect_std_Queue$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Queue$.prototype = $c_Lcats_effect_std_Queue$.prototype;
$c_Lcats_effect_std_Queue$.prototype.bounded__I__Lcats_effect_kernel_GenConcurrent__O = (function(capacity, F) {
  $p_Lcats_effect_std_Queue$__assertNonNegative__I__V(this, capacity);
  var queue = $m_sci_Queue$EmptyQueue$();
  var takers = $m_sci_Queue$EmptyQueue$();
  var offerers = $m_sci_Queue$EmptyQueue$();
  var target = F.ref__O__O(new $c_Lcats_effect_std_Queue$State(queue, 0, takers, offerers));
  var this$8 = new $c_Lcats_Functor$$anon$4(target, F);
  var f = new $c_sjsr_AnonFunction1(((capacity$2, F$2) => ((_$4) => {
    var _$4$1 = $as_Lcats_effect_kernel_Ref(_$4);
    return new $c_Lcats_effect_std_Queue$BoundedQueue(capacity$2, _$4$1, F$2)
  }))(capacity, F));
  return this$8.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$$anon$4__f_self, f)
});
var $d_Lcats_effect_std_Queue$ = new $TypeData().initClass({
  Lcats_effect_std_Queue$: 0
}, false, "cats.effect.std.Queue$", {
  Lcats_effect_std_Queue$: 1,
  O: 1
});
$c_Lcats_effect_std_Queue$.prototype.$classData = $d_Lcats_effect_std_Queue$;
var $n_Lcats_effect_std_Queue$;
function $m_Lcats_effect_std_Queue$() {
  if ((!$n_Lcats_effect_std_Queue$)) {
    $n_Lcats_effect_std_Queue$ = new $c_Lcats_effect_std_Queue$()
  };
  return $n_Lcats_effect_std_Queue$
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore() {
  /*<skip>*/
}
$c_Lcats_effect_std_Semaphore.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore.prototype.constructor = $c_Lcats_effect_std_Semaphore;
/** @constructor */
function $h_Lcats_effect_std_Semaphore() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore.prototype = $c_Lcats_effect_std_Semaphore.prototype;
function $as_Lcats_effect_std_Semaphore(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Semaphore) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore"))
}
function $isArrayOf_Lcats_effect_std_Semaphore(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore)))
}
function $asArrayOf_Lcats_effect_std_Semaphore(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore;", depth))
}
function $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3(n, requests, wakeup) {
  var wakeup$tailLocal1 = wakeup;
  var requests$tailLocal1 = requests;
  var lo = n.RTLong__f_lo;
  var hi = n.RTLong__f_hi;
  var n$tailLocal1__lo = lo;
  var n$tailLocal1__hi = hi;
  while (true) {
    matchResult15: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x25 = requests$tailLocal1.dequeue__T2();
      if ((x25 !== null)) {
        var req = $as_Lcats_effect_std_Semaphore$impl$Request(x25._1__O());
        var tail = $as_sci_Queue(x25._2__O());
        var \u03b42$___1 = req;
        var \u03b42$___2 = tail;
        break matchResult15
      };
      throw new $c_s_MatchError(x25)
    };
    var req$2 = $as_Lcats_effect_std_Semaphore$impl$Request(\u03b42$___1);
    var tail$2 = $as_sci_Queue(\u03b42$___2);
    var this$2__lo = n$tailLocal1__lo;
    var this$2__hi = n$tailLocal1__hi;
    var b = req$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
    var ahi = this$2__hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi === bhi) ? (((-2147483648) ^ this$2__lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
      var this$3 = req$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
      var b$1__lo = n$tailLocal1__lo;
      var b$1__hi = n$tailLocal1__hi;
      var alo = this$3.RTLong__f_lo;
      var ahi$1 = this$3.RTLong__f_hi;
      var bhi$1 = b$1__hi;
      var lo$1 = ((alo - b$1__lo) | 0);
      var hi$1 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi$1 - bhi$1) | 0)) | 0) : ((ahi$1 - bhi$1) | 0));
      var elem$1 = req$2.of__J__Lcats_effect_std_Semaphore$impl$Request(new $c_RTLong(lo$1, hi$1));
      var _2 = tail$2.prepended__O__sci_Queue(elem$1);
      var _3 = wakeup$tailLocal1;
      return new $c_T3($L0, _2, _3)
    } else {
      var this$6__lo = n$tailLocal1__lo;
      var this$6__hi = n$tailLocal1__hi;
      var b$2 = req$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
      var alo$1 = this$6__lo;
      var ahi$2 = this$6__hi;
      var bhi$2 = b$2.RTLong__f_hi;
      var lo$2 = ((alo$1 - b$2.RTLong__f_lo) | 0);
      var hi$2 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ alo$1)) ? (((-1) + ((ahi$2 - bhi$2) | 0)) | 0) : ((ahi$2 - bhi$2) | 0));
      var newWakeup = wakeup$tailLocal1.enqueue__O__sci_Queue(req$2);
      if ((tail$2.isEmpty__Z() || ((lo$2 === 0) && (hi$2 === 0)))) {
        return new $c_T3(new $c_RTLong(lo$2, hi$2), tail$2, newWakeup)
      } else {
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$2;
        n$tailLocal1__lo = $$x1__lo;
        n$tailLocal1__hi = $$x1__hi;
        requests$tailLocal1 = tail$2;
        wakeup$tailLocal1 = newWakeup
      }
    }
  }
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Semaphore$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$.prototype.constructor = $c_Lcats_effect_std_Semaphore$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$.prototype = $c_Lcats_effect_std_Semaphore$.prototype;
$c_Lcats_effect_std_Semaphore$.prototype.apply__J__Lcats_effect_kernel_GenConcurrent__O = (function(n, F) {
  var impl = new $c_Lcats_effect_std_Semaphore$impl(n, F);
  var target = F.ref__O__O(impl.initialState__Lcats_effect_std_Semaphore$impl$State());
  var this$3 = new $c_Lcats_Functor$$anon$4(target, F);
  var f = new $c_sjsr_AnonFunction1(((impl$2) => ((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lcats_effect_std_Semaphore$$anon$1(state$1, impl$2)
  }))(impl));
  return this$3.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$$anon$4__f_self, f)
});
var $d_Lcats_effect_std_Semaphore$ = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$: 0
}, false, "cats.effect.std.Semaphore$", {
  Lcats_effect_std_Semaphore$: 1,
  O: 1
});
$c_Lcats_effect_std_Semaphore$.prototype.$classData = $d_Lcats_effect_std_Semaphore$;
var $n_Lcats_effect_std_Semaphore$;
function $m_Lcats_effect_std_Semaphore$() {
  if ((!$n_Lcats_effect_std_Semaphore$)) {
    $n_Lcats_effect_std_Semaphore$ = new $c_Lcats_effect_std_Semaphore$()
  };
  return $n_Lcats_effect_std_Semaphore$
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl(n, F) {
  this.Lcats_effect_std_Semaphore$impl__f_n = $L0;
  this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F = null;
  this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_State$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1 = false;
  this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1 = null;
  this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1 = false;
  this.Lcats_effect_std_Semaphore$impl__f_n = n;
  this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F = F;
  this.Lcats_effect_std_Semaphore$impl__f_Request$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Request$(this);
  this.Lcats_effect_std_Semaphore$impl__f_State$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$State$(this);
  this.requireNonNegative__J__V(n)
}
$c_Lcats_effect_std_Semaphore$impl.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl.prototype = $c_Lcats_effect_std_Semaphore$impl.prototype;
$c_Lcats_effect_std_Semaphore$impl.prototype.requireNonNegative__J__V = (function(n) {
  var ahi = n.RTLong__f_hi;
  var requirement = (ahi >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "n must be nonnegative, was: ") + n))
  }
});
$c_Lcats_effect_std_Semaphore$impl.prototype.newRequest__O = (function() {
  var target = this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F.deferred__O();
  var tc = this.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
  var this$3 = new $c_Lcats_Functor$$anon$4(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((_$7) => {
    var _$7$1 = $as_Lcats_effect_kernel_Deferred(_$7);
    return this$2.Lcats_effect_std_Semaphore$impl__f_Request$lzy1.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request($L0, _$7$1)
  }))(this));
  return this$3.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$$anon$4__f_self, f)
});
$c_Lcats_effect_std_Semaphore$impl.prototype.initialState__Lcats_effect_std_Semaphore$impl$State = (function() {
  var $$x2 = this.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
  var $$x1 = this.Lcats_effect_std_Semaphore$impl__f_n;
  var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  return $$x2.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($$x1, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), ($m_sci_List$(), $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs))))
});
$c_Lcats_effect_std_Semaphore$impl.prototype.Wait__Lcats_effect_std_Semaphore$impl$Wait$ = (function() {
  if ((!this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1)) {
    this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Wait$();
    this.Lcats_effect_std_Semaphore$impl__f_Waitbitmap$1 = true
  };
  return this.Lcats_effect_std_Semaphore$impl__f_Wait$lzy1
});
$c_Lcats_effect_std_Semaphore$impl.prototype.Done__Lcats_effect_std_Semaphore$impl$Done$ = (function() {
  if ((!this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1)) {
    this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1 = new $c_Lcats_effect_std_Semaphore$impl$Done$();
    this.Lcats_effect_std_Semaphore$impl__f_Donebitmap$1 = true
  };
  return this.Lcats_effect_std_Semaphore$impl__f_Done$lzy1
});
var $d_Lcats_effect_std_Semaphore$impl = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl: 0
}, false, "cats.effect.std.Semaphore$impl", {
  Lcats_effect_std_Semaphore$impl: 1,
  O: 1
});
$c_Lcats_effect_std_Semaphore$impl.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl;
function $is_Lcats_effect_std_Semaphore$impl$Action(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Semaphore$impl$Action)))
}
function $as_Lcats_effect_std_Semaphore$impl$Action(obj) {
  return (($is_Lcats_effect_std_Semaphore$impl$Action(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore$impl$Action"))
}
function $isArrayOf_Lcats_effect_std_Semaphore$impl$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$Action)))
}
function $asArrayOf_Lcats_effect_std_Semaphore$impl$Action(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore$impl$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore$impl$Action;", depth))
}
function $is_Lcats_effect_std_Supervisor(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Supervisor)))
}
function $as_Lcats_effect_std_Supervisor(obj) {
  return (($is_Lcats_effect_std_Supervisor(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Supervisor"))
}
function $isArrayOf_Lcats_effect_std_Supervisor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Supervisor)))
}
function $asArrayOf_Lcats_effect_std_Supervisor(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Supervisor(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Supervisor;", depth))
}
function $p_Lcats_effect_std_Supervisor$__supervisor__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource($thiz, mkState, F) {
  return $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource(mkState, new $c_sjsr_AnonFunction1(((_$5) => {
    var _$5$1 = $as_Lcats_effect_std_Supervisor$State(_$5);
    return _$5$1.cancelAll__O()
  })), F).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((F$2) => ((state) => {
    var state$1 = $as_Lcats_effect_std_Supervisor$State(state);
    return new $c_Lcats_effect_std_Supervisor$$anon$1(F$2, state$1)
  }))(F)))
}
function $p_Lcats_effect_std_Supervisor$__applyForConcurrent__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource($thiz, F) {
  var target = F.ref__O__O($m_sci_Map$EmptyMap$());
  var this$4 = new $c_Lcats_Functor$$anon$4(target, F);
  var f = new $c_sjsr_AnonFunction1(((F$2) => ((stateRef) => {
    var stateRef$1 = $as_Lcats_effect_kernel_Ref(stateRef);
    return new $c_Lcats_effect_std_Supervisor$$anon$2(F$2, stateRef$1)
  }))(F));
  var mkState = this$4.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$$anon$4__f_self, f);
  return $p_Lcats_effect_std_Supervisor$__supervisor__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource($thiz, mkState, F)
}
function $p_Lcats_effect_std_Supervisor$__applyForAsync__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource($thiz, F) {
  var mkState = F.delay__F0__O(new $c_sjsr_AnonFunction0(((F$2) => (() => {
    var state = $ct_ju_concurrent_ConcurrentHashMap__(new $c_ju_concurrent_ConcurrentHashMap());
    return new $c_Lcats_effect_std_Supervisor$$anon$3(F$2, state)
  }))(F)));
  return $p_Lcats_effect_std_Supervisor$__supervisor__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource($thiz, mkState, F)
}
/** @constructor */
function $c_Lcats_effect_std_Supervisor$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Supervisor$.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$.prototype.constructor = $c_Lcats_effect_std_Supervisor$;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Supervisor$.prototype = $c_Lcats_effect_std_Supervisor$.prototype;
$c_Lcats_effect_std_Supervisor$.prototype.apply__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  if ($is_Lcats_effect_kernel_Async(F)) {
    var asyncF = $as_Lcats_effect_kernel_Async(F);
    return $p_Lcats_effect_std_Supervisor$__applyForAsync__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(this, asyncF)
  } else {
    return $p_Lcats_effect_std_Supervisor$__applyForConcurrent__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this, F)
  }
});
var $d_Lcats_effect_std_Supervisor$ = new $TypeData().initClass({
  Lcats_effect_std_Supervisor$: 0
}, false, "cats.effect.std.Supervisor$", {
  Lcats_effect_std_Supervisor$: 1,
  O: 1
});
$c_Lcats_effect_std_Supervisor$.prototype.$classData = $d_Lcats_effect_std_Supervisor$;
var $n_Lcats_effect_std_Supervisor$;
function $m_Lcats_effect_std_Supervisor$() {
  if ((!$n_Lcats_effect_std_Supervisor$)) {
    $n_Lcats_effect_std_Supervisor$ = new $c_Lcats_effect_std_Supervisor$()
  };
  return $n_Lcats_effect_std_Supervisor$
}
function $is_Lcats_effect_std_Supervisor$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Supervisor$State)))
}
function $as_Lcats_effect_std_Supervisor$State(obj) {
  return (($is_Lcats_effect_std_Supervisor$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Supervisor$State"))
}
function $isArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Supervisor$State)))
}
function $asArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Supervisor$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Supervisor$State;", depth))
}
/** @constructor */
function $c_Lcats_effect_tracing_RingBuffer(logSize) {
  this.Lcats_effect_tracing_RingBuffer__f_length = 0;
  this.Lcats_effect_tracing_RingBuffer__f_mask = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null;
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_length = (1 << logSize);
  this.Lcats_effect_tracing_RingBuffer__f_mask = (((-1) + this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
  var dimensions = new $ac_I(new Int32Array([this.Lcats_effect_tracing_RingBuffer__f_length]));
  this.Lcats_effect_tracing_RingBuffer__f_buffer = $asArrayOf_Lcats_effect_tracing_TracingEvent($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_tracing_TracingEvent.getClassOf(), dimensions), 1);
  this.Lcats_effect_tracing_RingBuffer__f_index = 0
}
$c_Lcats_effect_tracing_RingBuffer.prototype = new $h_O();
$c_Lcats_effect_tracing_RingBuffer.prototype.constructor = $c_Lcats_effect_tracing_RingBuffer;
/** @constructor */
function $h_Lcats_effect_tracing_RingBuffer() {
  /*<skip>*/
}
$h_Lcats_effect_tracing_RingBuffer.prototype = $c_Lcats_effect_tracing_RingBuffer.prototype;
$c_Lcats_effect_tracing_RingBuffer.prototype.push__Lcats_effect_tracing_TracingEvent__V = (function(te) {
  var idx = (this.Lcats_effect_tracing_RingBuffer__f_index & this.Lcats_effect_tracing_RingBuffer__f_mask);
  this.Lcats_effect_tracing_RingBuffer__f_buffer.set(idx, te);
  this.Lcats_effect_tracing_RingBuffer__f_index = ((1 + this.Lcats_effect_tracing_RingBuffer__f_index) | 0)
});
$c_Lcats_effect_tracing_RingBuffer.prototype.toList__sci_List = (function() {
  $m_s_package$();
  var result = $m_sci_Nil$();
  var msk = this.Lcats_effect_tracing_RingBuffer__f_mask;
  var idx = this.Lcats_effect_tracing_RingBuffer__f_index;
  var x = ((idx - this.Lcats_effect_tracing_RingBuffer__f_length) | 0);
  var start = ((x > 0) ? x : 0);
  var i = start;
  while ((i < idx)) {
    var this$4 = result;
    var elem = this.Lcats_effect_tracing_RingBuffer__f_buffer.get((i & msk));
    result = new $c_sci_$colon$colon(elem, this$4);
    i = ((1 + i) | 0)
  };
  return result
});
$c_Lcats_effect_tracing_RingBuffer.prototype.invalidate__V = (function() {
  this.Lcats_effect_tracing_RingBuffer__f_index = 0;
  this.Lcats_effect_tracing_RingBuffer__f_buffer = null
});
var $d_Lcats_effect_tracing_RingBuffer = new $TypeData().initClass({
  Lcats_effect_tracing_RingBuffer: 0
}, false, "cats.effect.tracing.RingBuffer", {
  Lcats_effect_tracing_RingBuffer: 1,
  O: 1
});
$c_Lcats_effect_tracing_RingBuffer.prototype.$classData = $d_Lcats_effect_tracing_RingBuffer;
/** @constructor */
function $c_Lcats_effect_tracing_TracingConstants$() {
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = false;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = false;
  $n_Lcats_effect_tracing_TracingConstants$ = this;
  var this$1 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_MODE");
  if (this$1.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$1.get__O();
    var _$1 = $as_T(arg1);
    var $$x1 = (!(_$1 === ""))
  };
  if ($$x1) {
    var this$2 = this$1
  } else {
    var this$2 = $m_s_None$()
  };
  var stackTracingMode = $as_T((this$2.isEmpty__Z() ? "cached" : this$2.get__O()));
  _return: {
    var len = $uI(stackTracingMode.length);
    if (($uI("cached".length) === len)) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = (65535 & $uI(stackTracingMode.charCodeAt(index)));
        var $$x3 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = (65535 & $uI("cached".charCodeAt(index$1)));
        if (($$x3 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          var $$x2 = false;
          break _return
        };
        i = ((1 + i) | 0)
      };
      var $$x2 = true
    } else {
      var $$x2 = false
    }
  };
  this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing = $$x2;
  _return$1: {
    var len$1 = $uI(stackTracingMode.length);
    if (($uI("full".length) === len$1)) {
      var i$1 = 0;
      while ((i$1 !== len$1)) {
        var index$2 = i$1;
        var c$2 = (65535 & $uI(stackTracingMode.charCodeAt(index$2)));
        var $$x5 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$2));
        var index$3 = i$1;
        var c$3 = (65535 & $uI("full".charCodeAt(index$3)));
        if (($$x5 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$3)))) {
          var $$x4 = false;
          break _return$1
        };
        i$1 = ((1 + i$1) | 0)
      };
      var $$x4 = true
    } else {
      var $$x4 = false
    }
  };
  this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing = $$x4;
  this.Lcats_effect_tracing_TracingConstants$__f_isStackTracing = (this.Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing || this.Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing)
}
$c_Lcats_effect_tracing_TracingConstants$.prototype = new $h_O();
$c_Lcats_effect_tracing_TracingConstants$.prototype.constructor = $c_Lcats_effect_tracing_TracingConstants$;
/** @constructor */
function $h_Lcats_effect_tracing_TracingConstants$() {
  /*<skip>*/
}
$h_Lcats_effect_tracing_TracingConstants$.prototype = $c_Lcats_effect_tracing_TracingConstants$.prototype;
var $d_Lcats_effect_tracing_TracingConstants$ = new $TypeData().initClass({
  Lcats_effect_tracing_TracingConstants$: 0
}, false, "cats.effect.tracing.TracingConstants$", {
  Lcats_effect_tracing_TracingConstants$: 1,
  O: 1
});
$c_Lcats_effect_tracing_TracingConstants$.prototype.$classData = $d_Lcats_effect_tracing_TracingConstants$;
var $n_Lcats_effect_tracing_TracingConstants$;
function $m_Lcats_effect_tracing_TracingConstants$() {
  if ((!$n_Lcats_effect_tracing_TracingConstants$)) {
    $n_Lcats_effect_tracing_TracingConstants$ = new $c_Lcats_effect_tracing_TracingConstants$()
  };
  return $n_Lcats_effect_tracing_TracingConstants$
}
function $is_Lcats_effect_tracing_TracingEvent(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_tracing_TracingEvent)))
}
function $as_Lcats_effect_tracing_TracingEvent(obj) {
  return (($is_Lcats_effect_tracing_TracingEvent(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.TracingEvent"))
}
function $isArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent)))
}
function $asArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_TracingEvent(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.TracingEvent;", depth))
}
var $d_Lcats_effect_tracing_TracingEvent = new $TypeData().initClass({
  Lcats_effect_tracing_TracingEvent: 0
}, true, "cats.effect.tracing.TracingEvent", {
  Lcats_effect_tracing_TracingEvent: 1,
  O: 1
});
function $ct_Lcats_effect_tracing_TracingPlatform__($thiz) {
  var this$1 = $as_scm_Map($m_scm_Map$().empty__O());
  $thiz.Lcats_effect_tracing_TracingPlatform__f_cache = $f_scm_Map__withDefaultValue__O__scm_Map(this$1, null);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function0Property = $as_T(Object.getOwnPropertyNames(new $c_sjsr_AnonFunction0((() => (void 0))))[0]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_function1Property = $as_T(Object.getOwnPropertyNames(new $c_sjsr_AnonFunction1(((_$1) => {
    $as_jl_Void(_$1)
  })))[0]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isCachedStackTracing ? new $c_sjsr_AnonFunction1(((this$3) => ((key) => {
    var current = $as_Lcats_effect_tracing_TracingEvent(this$3.Lcats_effect_tracing_TracingPlatform__f_cache.apply__O__O(key));
    if ((current === null)) {
      $as_Lcats_effect_tracing_Tracing$(this$3);
      var event = new $c_Lcats_effect_tracing_TracingEvent$StackTrace();
      this$3.Lcats_effect_tracing_TracingPlatform__f_cache.update__O__O__V(key, event);
      return event
    } else {
      return current
    }
  }))($thiz)) : ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isFullStackTracing ? new $c_sjsr_AnonFunction1(((this$2$1) => ((_$3) => {
    $as_Lcats_effect_tracing_Tracing$(this$2$1);
    return new $c_Lcats_effect_tracing_TracingEvent$StackTrace()
  }))($thiz)) : new $c_sjsr_AnonFunction1(((_$4) => null))));
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = new ($d_T.getArrayOf().constr)(["githubusercontent.com/typelevel/cats-effect/", "githubusercontent.com/typelevel/cats/", "githubusercontent.com/scala-js/", "githubusercontent.com/scala/", "MacrotaskExecutor.scala"]);
  $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = new ($d_T.getArrayOf().constr)(["_Lcats_effect_", "_jl_", "_Lorg_scalajs_"]);
  return $thiz
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, fileName) {
  var i = 0;
  var len = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter.u.length;
  while ((i < len)) {
    var s = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter.get(i);
    if (($uI(fileName.indexOf(s)) !== (-1))) {
      return true
    };
    i = ((1 + i) | 0)
  };
  return false
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, methodName) {
  var i = 0;
  var len = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter.u.length;
  while ((i < len)) {
    var s = $thiz.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter.get(i);
    if (($uI(methodName.indexOf(s)) !== (-1))) {
      return true
    };
    i = ((1 + i) | 0)
  };
  return false
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$1) {
  return ((!$f_T__endsWith__T__Z(callSiteFileName$1, ".js")) && $p_Lcats_effect_tracing_TracingPlatform__isInternalFile__T__Z($thiz, callSiteFileName$1))
}
function $p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z($thiz, callSiteClassName$1, callSiteMethodName$1, callSiteFileName$2) {
  return ((callSiteClassName$1 === "<jscode>") && ($p_Lcats_effect_tracing_TracingPlatform__isInternalScalaFile$1__T__Z($thiz, callSiteFileName$2) || $p_Lcats_effect_tracing_TracingPlatform__isInternalMethod__T__Z($thiz, callSiteMethodName$1)))
}
/** @constructor */
function $c_Lcats_effect_tracing_TracingPlatform() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null
}
$c_Lcats_effect_tracing_TracingPlatform.prototype = new $h_O();
$c_Lcats_effect_tracing_TracingPlatform.prototype.constructor = $c_Lcats_effect_tracing_TracingPlatform;
/** @constructor */
function $h_Lcats_effect_tracing_TracingPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_tracing_TracingPlatform.prototype = $c_Lcats_effect_tracing_TracingPlatform.prototype;
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent = (function(f) {
  return $as_Lcats_effect_tracing_TracingEvent(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent.apply__O__O($dp_toString__T(f[this.Lcats_effect_tracing_TracingPlatform__f_function0Property])))
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent = (function(f) {
  return $as_Lcats_effect_tracing_TracingEvent(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent.apply__O__O($dp_toString__T(f[this.Lcats_effect_tracing_TracingPlatform__f_function1Property])))
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.calculateTracingEvent__Lcats_effect_kernel_Cont__Lcats_effect_tracing_TracingEvent = (function(cont) {
  return $as_Lcats_effect_tracing_TracingEvent(this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent.apply__O__O($objectGetClass(cont)))
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.applyStackTraceFilter__T__T__T__Z = (function(callSiteClassName, callSiteMethodName, callSiteFileName) {
  return ($p_Lcats_effect_tracing_TracingPlatform__isInternalJSCode$1__T__T__T__Z(this, callSiteClassName, callSiteMethodName, callSiteFileName) || $as_Lcats_effect_tracing_Tracing$(this).isInternalClass__T__Z(callSiteClassName))
});
$c_Lcats_effect_tracing_TracingPlatform.prototype.decodeMethodName__T__T = (function(name) {
  var junk = $uI(name.indexOf("__"));
  return $m_s_reflect_NameTransformer$().decode__T__T(((junk === (-1)) ? name : $as_T(name.substring(0, junk))))
});
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor$() {
  /*<skip>*/
}
$c_Lcats_effect_unsafe_FiberMonitor$.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor$;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_FiberMonitor$.prototype = $c_Lcats_effect_unsafe_FiberMonitor$.prototype;
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor = (function(compute) {
  if (this.weakRefsAvailable__Z()) {
    if ((compute instanceof $c_Lcats_effect_unsafe_FiberAwareExecutionContext)) {
      var faec = $as_Lcats_effect_unsafe_FiberAwareExecutionContext(compute);
      return new $c_Lcats_effect_unsafe_ES2021FiberMonitor(faec)
    } else {
      return new $c_Lcats_effect_unsafe_ES2021FiberMonitor(null)
    }
  } else {
    return new $c_Lcats_effect_unsafe_NoOpFiberMonitor()
  }
});
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.weakRefsAvailable__Z = (function() {
  return (($as_T((typeof WeakRef)) !== "undefined") && ($as_T((typeof FinalizationRegistry)) !== "undefined"))
});
var $d_Lcats_effect_unsafe_FiberMonitor$ = new $TypeData().initClass({
  Lcats_effect_unsafe_FiberMonitor$: 0
}, false, "cats.effect.unsafe.FiberMonitor$", {
  Lcats_effect_unsafe_FiberMonitor$: 1,
  O: 1
});
$c_Lcats_effect_unsafe_FiberMonitor$.prototype.$classData = $d_Lcats_effect_unsafe_FiberMonitor$;
var $n_Lcats_effect_unsafe_FiberMonitor$;
function $m_Lcats_effect_unsafe_FiberMonitor$() {
  if ((!$n_Lcats_effect_unsafe_FiberMonitor$)) {
    $n_Lcats_effect_unsafe_FiberMonitor$ = new $c_Lcats_effect_unsafe_FiberMonitor$()
  };
  return $n_Lcats_effect_unsafe_FiberMonitor$
}
function $ct_Lcats_effect_unsafe_FiberMonitorShared__($thiz) {
  $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline = "\n";
  $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = (($thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline + " ") + $thiz.Lcats_effect_unsafe_FiberMonitorShared__f_newline);
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitorShared() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null
}
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberMonitorShared.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitorShared;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitorShared() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_FiberMonitorShared.prototype = $c_Lcats_effect_unsafe_FiberMonitorShared.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, fiberMonitor, shutdown, config) {
  this.Lcats_effect_unsafe_IORuntime__f_compute = null;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = null;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = null;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = null;
  this.Lcats_effect_unsafe_IORuntime__f_config = null;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = null;
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntime__f_compute = compute;
  this.Lcats_effect_unsafe_IORuntime__f_blocking = blocking;
  this.Lcats_effect_unsafe_IORuntime__f_scheduler = scheduler;
  this.Lcats_effect_unsafe_IORuntime__f_fiberMonitor = fiberMonitor;
  this.Lcats_effect_unsafe_IORuntime__f_shutdown = shutdown;
  this.Lcats_effect_unsafe_IORuntime__f_config = config;
  this.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs = new $c_Lcats_effect_unsafe_StripedHashtable();
  this.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold = config.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold = config.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions = config.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize = config.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize
}
$c_Lcats_effect_unsafe_IORuntime.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntime.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_IORuntime.prototype = $c_Lcats_effect_unsafe_IORuntime.prototype;
$c_Lcats_effect_unsafe_IORuntime.prototype.toString__T = (function() {
  return (((((("IORuntime(" + this.Lcats_effect_unsafe_IORuntime__f_compute) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_scheduler) + ", ") + this.Lcats_effect_unsafe_IORuntime__f_config) + ")")
});
var $d_Lcats_effect_unsafe_IORuntime = new $TypeData().initClass({
  Lcats_effect_unsafe_IORuntime: 0
}, false, "cats.effect.unsafe.IORuntime", {
  Lcats_effect_unsafe_IORuntime: 1,
  O: 1
});
$c_Lcats_effect_unsafe_IORuntime.prototype.$classData = $d_Lcats_effect_unsafe_IORuntime;
function $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__($thiz) {
  $thiz.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_global$lzy1 = null;
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_globalbitmap$1 = false
}
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.defaultComputeExecutionContext__s_concurrent_ExecutionContext = (function() {
  return (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && $m_Lcats_effect_unsafe_FiberMonitor$().weakRefsAvailable__Z()) ? new $c_Lcats_effect_unsafe_FiberAwareExecutionContext($m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()) : $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$())
});
$c_Lcats_effect_unsafe_IORuntimeCompanionPlatform.prototype.global__Lcats_effect_unsafe_IORuntime = (function() {
  if ((!this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_globalbitmap$1)) {
    if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
      if ((this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global === null)) {
        var $$x5 = $m_Lcats_effect_unsafe_IORuntime$();
        var $$x4 = this.defaultComputeExecutionContext__s_concurrent_ExecutionContext();
        var $$x3 = this.defaultComputeExecutionContext__s_concurrent_ExecutionContext();
        var $$x2 = $as_Lcats_effect_unsafe_Scheduler($m_Lcats_effect_unsafe_Scheduler$().createDefaultScheduler__T2()._1__O());
        var $$x1 = new $c_sjsr_AnonFunction0((() => (void 0)));
        var this$1 = $m_Lcats_effect_unsafe_IORuntimeConfig$();
        this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = $$x5.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime($$x4, $$x3, $$x2, $$x1, this$1.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default)
      }
    };
    this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_global$lzy1 = this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global;
    this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_globalbitmap$1 = true
  };
  return this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_global$lzy1
});
function $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__($thiz) {
  var this$1 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_CANCELATION_CHECK_THRESHOLD");
  if (this$1.isEmpty__Z()) {
    var this$6 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var x = $as_T(arg1);
    try {
      var this$5 = $m_jl_Integer$();
      var $$x1 = new $c_s_util_Success(this$5.parseInt__T__I__I(x, 10))
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if ((e$2 !== null)) {
        matchEnd8: {
          var $$x1;
          if ((e$2 !== null)) {
            var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
            if ((!o11.isEmpty__Z())) {
              var e$3 = $as_jl_Throwable(o11.get__O());
              var $$x1 = new $c_s_util_Failure(e$3);
              break matchEnd8
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
        }
      } else {
        var $$x1;
        throw e
      }
    };
    var this$6 = $$x1.toOption__s_Option()
  };
  var cancelationCheckThreshold = $uI((this$6.isEmpty__Z() ? 512 : this$6.get__O()));
  var this$7 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_AUTO_YIELD_THRESHOLD_MULTIPLIER");
  if (this$7.isEmpty__Z()) {
    var this$12 = $m_s_None$()
  } else {
    var arg1$1 = this$7.get__O();
    var x$1 = $as_T(arg1$1);
    try {
      var this$11 = $m_jl_Integer$();
      var $$x2 = new $c_s_util_Success(this$11.parseInt__T__I__I(x$1, 10))
    } catch (e$1) {
      var e$2$1 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$1);
      if ((e$2$1 !== null)) {
        matchEnd8$1: {
          var $$x2;
          if ((e$2$1 !== null)) {
            var o11$1 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$1);
            if ((!o11$1.isEmpty__Z())) {
              var e$3$1 = $as_jl_Throwable(o11$1.get__O());
              var $$x2 = new $c_s_util_Failure(e$3$1);
              break matchEnd8$1
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$1)
        }
      } else {
        var $$x2;
        throw e$1
      }
    };
    var this$12 = $$x2.toOption__s_Option()
  };
  var autoYieldThreshold = Math.imul($uI((this$12.isEmpty__Z() ? 2 : this$12.get__O())), cancelationCheckThreshold);
  var this$13 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_EXCEPTIONS_ENHANCED");
  if (this$13.isEmpty__Z()) {
    var this$17 = $m_s_None$()
  } else {
    var arg1$2 = this$13.get__O();
    var x$2 = $as_T(arg1$2);
    try {
      var $$x3 = new $c_s_util_Success($m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(x$2, x$2))
    } catch (e$4) {
      var e$2$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$4);
      if ((e$2$2 !== null)) {
        matchEnd8$2: {
          var $$x3;
          if ((e$2$2 !== null)) {
            var o11$2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$2);
            if ((!o11$2.isEmpty__Z())) {
              var e$3$2 = $as_jl_Throwable(o11$2.get__O());
              var $$x3 = new $c_s_util_Failure(e$3$2);
              break matchEnd8$2
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$2)
        }
      } else {
        var $$x3;
        throw e$4
      }
    };
    var this$17 = $$x3.toOption__s_Option()
  };
  var enhancedExceptions = $uZ((this$17.isEmpty__Z() ? ($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz), true) : this$17.get__O()));
  var this$18 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_TRACING_BUFFER_SIZE");
  if (this$18.isEmpty__Z()) {
    var this$23 = $m_s_None$()
  } else {
    var arg1$3 = this$18.get__O();
    var x$3 = $as_T(arg1$3);
    try {
      var this$22 = $m_jl_Integer$();
      var $$x4 = new $c_s_util_Success(this$22.parseInt__T__I__I(x$3, 10))
    } catch (e$5) {
      var e$2$3 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$5);
      if ((e$2$3 !== null)) {
        matchEnd8$3: {
          var $$x4;
          if ((e$2$3 !== null)) {
            var o11$3 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$3);
            if ((!o11$3.isEmpty__Z())) {
              var e$3$3 = $as_jl_Throwable(o11$3.get__O());
              var $$x4 = new $c_s_util_Failure(e$3$3);
              break matchEnd8$3
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$3)
        }
      } else {
        var $$x4;
        throw e$5
      }
    };
    var this$23 = $$x4.toOption__s_Option()
  };
  var traceBufferSize = $uI((this$23.isEmpty__Z() ? ($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz), 16) : this$23.get__O()));
  var this$24 = $m_Lcats_effect_process$().env__T__s_Option("CATS_EFFECT_SHUTDOWN_HOOK_TIMEOUT");
  if (this$24.isEmpty__Z()) {
    var this$26 = $m_s_None$()
  } else {
    var arg1$4 = this$24.get__O();
    var x$4 = $as_T(arg1$4);
    try {
      var $$x5 = new $c_s_util_Success($m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(x$4))
    } catch (e$6) {
      var e$2$4 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$6);
      if ((e$2$4 !== null)) {
        matchEnd8$4: {
          var $$x5;
          if ((e$2$4 !== null)) {
            var o11$4 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2$4);
            if ((!o11$4.isEmpty__Z())) {
              var e$3$4 = $as_jl_Throwable(o11$4.get__O());
              var $$x5 = new $c_s_util_Failure(e$3$4);
              break matchEnd8$4
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2$4)
        }
      } else {
        var $$x5;
        throw e$6
      }
    };
    var this$26 = $$x5.toOption__s_Option()
  };
  var shutdownHookTimeout = $as_s_concurrent_duration_Duration((this$26.isEmpty__Z() ? ($as_Lcats_effect_unsafe_IORuntimeConfig$($thiz), $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Inf) : this$26.get__O()));
  $thiz.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = $as_Lcats_effect_unsafe_IORuntimeConfig$($thiz).apply__I__I__Z__I__s_concurrent_duration_Duration__Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout);
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null
}
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype = $c_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform.prototype;
function $is_Lcats_effect_unsafe_Scheduler(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_unsafe_Scheduler)))
}
function $as_Lcats_effect_unsafe_Scheduler(obj) {
  return (($is_Lcats_effect_unsafe_Scheduler(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.Scheduler"))
}
function $isArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_Scheduler)))
}
function $asArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_Scheduler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.Scheduler;", depth))
}
function $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__($thiz) {
  var this$2 = new $c_s_concurrent_duration_package$DurationInt(2147483647);
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var this$ = this$2.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  $m_s_concurrent_duration_Duration$();
  var hi = (this$ >> 31);
  $thiz.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi), unit);
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform.prototype.createDefaultScheduler__T2 = (function() {
  var _1 = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(this);
  var _2 = new $c_sjsr_AnonFunction0((() => (void 0)));
  return new $c_T2(_1, _2)
});
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable() {
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = null;
  this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_StripedHashtable__f_mask = (((-1) + this.numTables__I()) | 0);
  var dimensions = new $ac_I(new Int32Array([this.numTables__I()]));
  var array = $asArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_ThreadSafeHashtable.getClassOf(), dimensions), 1);
  var i = 0;
  while ((i < this.numTables__I())) {
    array.set(i, new $c_Lcats_effect_unsafe_ThreadSafeHashtable(8));
    i = ((1 + i) | 0)
  };
  this.Lcats_effect_unsafe_StripedHashtable__f_tables = array
}
$c_Lcats_effect_unsafe_StripedHashtable.prototype = new $h_O();
$c_Lcats_effect_unsafe_StripedHashtable.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_StripedHashtable.prototype = $c_Lcats_effect_unsafe_StripedHashtable.prototype;
$c_Lcats_effect_unsafe_StripedHashtable.prototype.numTables__I = (function() {
  return (1 << this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables)
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.put__F1__V = (function(cb) {
  var hash = $systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  this.Lcats_effect_unsafe_StripedHashtable__f_tables.get(idx).put__F1__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables))
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.remove__F1__V = (function(cb) {
  var hash = $systemIdentityHashCode(cb);
  var idx = (hash & this.Lcats_effect_unsafe_StripedHashtable__f_mask);
  this.Lcats_effect_unsafe_StripedHashtable__f_tables.get(idx).remove__F1__I__V(cb, (hash >> this.Lcats_effect_unsafe_StripedHashtable__f_log2NumTables))
});
var $d_Lcats_effect_unsafe_StripedHashtable = new $TypeData().initClass({
  Lcats_effect_unsafe_StripedHashtable: 0
}, false, "cats.effect.unsafe.StripedHashtable", {
  Lcats_effect_unsafe_StripedHashtable: 1,
  O: 1
});
$c_Lcats_effect_unsafe_StripedHashtable.prototype.$classData = $d_Lcats_effect_unsafe_StripedHashtable;
function $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I($thiz) {
  return (($m_jl_Runtime$(), 1) << 2)
}
/** @constructor */
function $c_Lcats_effect_unsafe_StripedHashtable$() {
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = 0;
  $n_Lcats_effect_unsafe_StripedHashtable$ = this;
  var result = 0;
  var x = $p_Lcats_effect_unsafe_StripedHashtable$__minNumTables__I(this);
  while ((x !== 0)) {
    result = ((1 + result) | 0);
    x = (x >> 1)
  };
  this.Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables = result
}
$c_Lcats_effect_unsafe_StripedHashtable$.prototype = new $h_O();
$c_Lcats_effect_unsafe_StripedHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_StripedHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_StripedHashtable$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_StripedHashtable$.prototype = $c_Lcats_effect_unsafe_StripedHashtable$.prototype;
var $d_Lcats_effect_unsafe_StripedHashtable$ = new $TypeData().initClass({
  Lcats_effect_unsafe_StripedHashtable$: 0
}, false, "cats.effect.unsafe.StripedHashtable$", {
  Lcats_effect_unsafe_StripedHashtable$: 1,
  O: 1
});
$c_Lcats_effect_unsafe_StripedHashtable$.prototype.$classData = $d_Lcats_effect_unsafe_StripedHashtable$;
var $n_Lcats_effect_unsafe_StripedHashtable$;
function $m_Lcats_effect_unsafe_StripedHashtable$() {
  if ((!$n_Lcats_effect_unsafe_StripedHashtable$)) {
    $n_Lcats_effect_unsafe_StripedHashtable$ = new $c_Lcats_effect_unsafe_StripedHashtable$()
  };
  return $n_Lcats_effect_unsafe_StripedHashtable$
}
function $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AF1__I__F1__I__V($thiz, table, mask, cb, hash) {
  var idx = (hash & mask);
  var remaining = mask;
  while ((remaining >= 0)) {
    var cur = table.get(idx);
    if (((cur === null) || (cur === $thiz.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone))) {
      table.set(idx, cb);
      return (void 0)
    } else {
      idx = (((1 + idx) | 0) & mask)
    };
    remaining = (((-1) + remaining) | 0)
  }
}
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable(initialCapacity) {
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = null;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity = initialCapacity;
  var dimensions = new $ac_I(new Int32Array([initialCapacity]));
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = $asArrayOf_F1($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_F1.getClassOf(), dimensions), 1);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = 0;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = (((-1) + initialCapacity) | 0);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = initialCapacity;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables = $m_Lcats_effect_unsafe_StripedHashtable$().Lcats_effect_unsafe_StripedHashtable$__f_log2NumTables;
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone = $m_Lcats_effect_unsafe_ThreadSafeHashtable$().Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone
}
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = new $h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_ThreadSafeHashtable.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype;
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.put__F1__I__V = (function(cb, hash) {
  var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
  var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
  if (((sz << 1) >= cap)) {
    var newCap = (cap << 1);
    var newMask = (((-1) + newCap) | 0);
    var dimensions = new $ac_I(new Int32Array([newCap]));
    var newHashtable = $asArrayOf_F1($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_F1.getClassOf(), dimensions), 1);
    var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var i = 0;
    while ((i < cap)) {
      var cur = table.get(i);
      if (((cur !== null) && (cur !== this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone))) {
        $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AF1__I__F1__I__V(this, newHashtable, newMask, cur, ($systemIdentityHashCode(cur) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables))
      };
      i = ((1 + i) | 0)
    };
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
    this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap
  };
  $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AF1__I__F1__I__V(this, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask, cb, hash);
  this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = ((1 + sz) | 0)
});
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.remove__F1__I__V = (function(cb, hash) {
  var msk = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask;
  var init = (hash & msk);
  var idx = init;
  var table = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
  var remaining = msk;
  while ((remaining >= 0)) {
    var cur = table.get(idx);
    if ((cb === cur)) {
      table.set(idx, this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone);
      this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size = (((-1) + this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size) | 0);
      var sz = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_size;
      var cap = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity;
      if (((cap > this.Lcats_effect_unsafe_ThreadSafeHashtable__f_initialCapacity) && ((sz << 2) < cap))) {
        var newCap = ((cap >>> 1) | 0);
        var newMask = (((-1) + newCap) | 0);
        var dimensions = new $ac_I(new Int32Array([newCap]));
        var newHashtable = $asArrayOf_F1($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_F1.getClassOf(), dimensions), 1);
        var table$2 = this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
        var i = 0;
        while ((i < cap)) {
          var cur$2 = table$2.get(i);
          if (((cur$2 !== null) && (cur$2 !== this.Lcats_effect_unsafe_ThreadSafeHashtable__f_Tombstone))) {
            $p_Lcats_effect_unsafe_ThreadSafeHashtable__insert__AF1__I__F1__I__V(this, newHashtable, newMask, cur$2, ($systemIdentityHashCode(cur$2) >> this.Lcats_effect_unsafe_ThreadSafeHashtable__f_log2NumTables))
          };
          i = ((1 + i) | 0)
        };
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable = newHashtable;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_mask = newMask;
        this.Lcats_effect_unsafe_ThreadSafeHashtable__f_capacity = newCap
      };
      return (void 0)
    } else if ((cur !== null)) {
      idx = (((1 + idx) | 0) & msk)
    } else {
      return (void 0)
    };
    remaining = (((-1) + remaining) | 0)
  }
});
function $as_Lcats_effect_unsafe_ThreadSafeHashtable(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_ThreadSafeHashtable) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.ThreadSafeHashtable"))
}
function $isArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_ThreadSafeHashtable)))
}
function $asArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_ThreadSafeHashtable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.ThreadSafeHashtable;", depth))
}
var $d_Lcats_effect_unsafe_ThreadSafeHashtable = new $TypeData().initClass({
  Lcats_effect_unsafe_ThreadSafeHashtable: 0
}, false, "cats.effect.unsafe.ThreadSafeHashtable", {
  Lcats_effect_unsafe_ThreadSafeHashtable: 1,
  O: 1
});
$c_Lcats_effect_unsafe_ThreadSafeHashtable.prototype.$classData = $d_Lcats_effect_unsafe_ThreadSafeHashtable;
/** @constructor */
function $c_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = null;
  $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = this;
  this.Lcats_effect_unsafe_ThreadSafeHashtable$__f_Tombstone = new $c_sjsr_AnonFunction1(((_$1) => {
    $as_jl_Throwable(_$1)
  }))
}
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = new $h_O();
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype.constructor = $c_Lcats_effect_unsafe_ThreadSafeHashtable$;
/** @constructor */
function $h_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype = $c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype;
var $d_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $TypeData().initClass({
  Lcats_effect_unsafe_ThreadSafeHashtable$: 0
}, false, "cats.effect.unsafe.ThreadSafeHashtable$", {
  Lcats_effect_unsafe_ThreadSafeHashtable$: 1,
  O: 1
});
$c_Lcats_effect_unsafe_ThreadSafeHashtable$.prototype.$classData = $d_Lcats_effect_unsafe_ThreadSafeHashtable$;
var $n_Lcats_effect_unsafe_ThreadSafeHashtable$;
function $m_Lcats_effect_unsafe_ThreadSafeHashtable$() {
  if ((!$n_Lcats_effect_unsafe_ThreadSafeHashtable$)) {
    $n_Lcats_effect_unsafe_ThreadSafeHashtable$ = new $c_Lcats_effect_unsafe_ThreadSafeHashtable$()
  };
  return $n_Lcats_effect_unsafe_ThreadSafeHashtable$
}
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag() {
  this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2 = 0;
  this.Lcats_effect_unsafe_WeakBag__f_queue = null;
  this.Lcats_effect_unsafe_WeakBag__f_capacity = 0;
  this.Lcats_effect_unsafe_WeakBag__f_table = null;
  this.Lcats_effect_unsafe_WeakBag__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag__f_synchronizationPoint = null;
  this.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2 = 1073741824;
  this.Lcats_effect_unsafe_WeakBag__f_queue = new $c_Lcats_effect_unsafe_ref_ReferenceQueue();
  this.Lcats_effect_unsafe_WeakBag__f_capacity = 256;
  var dimensions = new $ac_I(new Int32Array([this.Lcats_effect_unsafe_WeakBag__f_capacity]));
  this.Lcats_effect_unsafe_WeakBag__f_table = $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_WeakBag$Entry.getClassOf(), dimensions), 1);
  this.Lcats_effect_unsafe_WeakBag__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag__f_synchronizationPoint = $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), true)
}
$c_Lcats_effect_unsafe_WeakBag.prototype = new $h_O();
$c_Lcats_effect_unsafe_WeakBag.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_WeakBag.prototype = $c_Lcats_effect_unsafe_WeakBag.prototype;
$c_Lcats_effect_unsafe_WeakBag.prototype.insert__O__Lcats_effect_unsafe_WeakBag$Handle = (function(a) {
  var this$ = this;
  while (true) {
    var oldEntry = $as_Lcats_effect_unsafe_WeakBag$Entry(this$.Lcats_effect_unsafe_WeakBag__f_queue.poll__Lcats_effect_unsafe_ref_Reference());
    var cap = this$.Lcats_effect_unsafe_WeakBag__f_capacity;
    var idx = this$.Lcats_effect_unsafe_WeakBag__f_index;
    if ((oldEntry !== null)) {
      var oldIndex = oldEntry.Lcats_effect_unsafe_WeakBag$Entry__f_index;
      var entry = new $c_Lcats_effect_unsafe_WeakBag$Entry(a, oldIndex, this$.Lcats_effect_unsafe_WeakBag__f_queue);
      this$.Lcats_effect_unsafe_WeakBag__f_table.set(oldIndex, entry);
      return entry
    } else if ((idx < cap)) {
      var entry$2 = new $c_Lcats_effect_unsafe_WeakBag$Entry(a, idx, this$.Lcats_effect_unsafe_WeakBag__f_queue);
      this$.Lcats_effect_unsafe_WeakBag__f_table.set(idx, entry$2);
      this$.Lcats_effect_unsafe_WeakBag__f_index = ((1 + this$.Lcats_effect_unsafe_WeakBag__f_index) | 0);
      return entry$2
    } else {
      if ((cap === 2147483647)) {
        return new $c_Lcats_effect_unsafe_WeakBag$$anon$1(this$)
      };
      var oldTable = this$.Lcats_effect_unsafe_WeakBag__f_table;
      var newCap = ((cap === this$.Lcats_effect_unsafe_WeakBag__f_MaxSizePow2) ? 2147483647 : (cap << 1));
      var dimensions = new $ac_I(new Int32Array([newCap]));
      var newTable = $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lcats_effect_unsafe_WeakBag$Entry.getClassOf(), dimensions), 1);
      oldTable.copyTo(0, newTable, 0, idx);
      this$.Lcats_effect_unsafe_WeakBag__f_table = newTable;
      this$.Lcats_effect_unsafe_WeakBag__f_capacity = newCap;
      this$ = this$
    }
  }
});
var $d_Lcats_effect_unsafe_WeakBag = new $TypeData().initClass({
  Lcats_effect_unsafe_WeakBag: 0
}, false, "cats.effect.unsafe.WeakBag", {
  Lcats_effect_unsafe_WeakBag: 1,
  O: 1
});
$c_Lcats_effect_unsafe_WeakBag.prototype.$classData = $d_Lcats_effect_unsafe_WeakBag;
function $is_Lcats_effect_unsafe_WeakBag$Handle(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_unsafe_WeakBag$Handle)))
}
function $as_Lcats_effect_unsafe_WeakBag$Handle(obj) {
  return (($is_Lcats_effect_unsafe_WeakBag$Handle(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WeakBag$Handle"))
}
function $isArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WeakBag$Handle)))
}
function $asArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WeakBag$Handle(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WeakBag$Handle;", depth))
}
/** @constructor */
function $c_Lcats_effect_unsafe_implicits$() {
  this.Lcats_effect_unsafe_implicits$__f_global = null;
  $n_Lcats_effect_unsafe_implicits$ = this;
  this.Lcats_effect_unsafe_implicits$__f_global = $m_Lcats_effect_unsafe_IORuntime$().global__Lcats_effect_unsafe_IORuntime()
}
$c_Lcats_effect_unsafe_implicits$.prototype = new $h_O();
$c_Lcats_effect_unsafe_implicits$.prototype.constructor = $c_Lcats_effect_unsafe_implicits$;
/** @constructor */
function $h_Lcats_effect_unsafe_implicits$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_implicits$.prototype = $c_Lcats_effect_unsafe_implicits$.prototype;
var $d_Lcats_effect_unsafe_implicits$ = new $TypeData().initClass({
  Lcats_effect_unsafe_implicits$: 0
}, false, "cats.effect.unsafe.implicits$", {
  Lcats_effect_unsafe_implicits$: 1,
  O: 1
});
$c_Lcats_effect_unsafe_implicits$.prototype.$classData = $d_Lcats_effect_unsafe_implicits$;
var $n_Lcats_effect_unsafe_implicits$;
function $m_Lcats_effect_unsafe_implicits$() {
  if ((!$n_Lcats_effect_unsafe_implicits$)) {
    $n_Lcats_effect_unsafe_implicits$ = new $c_Lcats_effect_unsafe_implicits$()
  };
  return $n_Lcats_effect_unsafe_implicits$
}
function $ct_Lcats_effect_unsafe_ref_Reference__O__Lcats_effect_unsafe_ref_ReferenceQueue__($thiz, referent, queue) {
  $thiz.Lcats_effect_unsafe_ref_Reference__f_queue = queue;
  $thiz.Lcats_effect_unsafe_ref_Reference__f_weakRef = new WeakRef(referent);
  $thiz.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
  if ((queue !== null)) {
    queue.register__Lcats_effect_unsafe_ref_Reference__O__V($thiz, referent)
  };
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_Reference() {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_weakRef = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false
}
$c_Lcats_effect_unsafe_ref_Reference.prototype = new $h_O();
$c_Lcats_effect_unsafe_ref_Reference.prototype.constructor = $c_Lcats_effect_unsafe_ref_Reference;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_Reference() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_ref_Reference.prototype = $c_Lcats_effect_unsafe_ref_Reference.prototype;
$c_Lcats_effect_unsafe_ref_Reference.prototype.enqueue__Z = (function() {
  return (((this.Lcats_effect_unsafe_ref_Reference__f_queue !== null) && this.Lcats_effect_unsafe_ref_Reference__f_queue.enqueue__Lcats_effect_unsafe_ref_Reference__Z(this)) && (this.Lcats_effect_unsafe_ref_Reference__f_queue.unregister__Lcats_effect_unsafe_ref_Reference__V(this), true))
});
function $as_Lcats_effect_unsafe_ref_Reference(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_ref_Reference) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.ref.Reference"))
}
function $isArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_ref_Reference)))
}
function $asArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_ref_Reference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.ref.Reference;", depth))
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_ReferenceQueue() {
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs = null;
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry = null;
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs = [];
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry = new FinalizationRegistry(((this$1) => ((ref) => {
    var ref$1 = $as_Lcats_effect_unsafe_ref_Reference(ref);
    return this$1.enqueue__Lcats_effect_unsafe_ref_Reference__Z(ref$1)
  }))(this))
}
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype = new $h_O();
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.constructor = $c_Lcats_effect_unsafe_ref_ReferenceQueue;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_ReferenceQueue() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_ref_ReferenceQueue.prototype = $c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype;
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.register__Lcats_effect_unsafe_ref_Reference__O__V = (function(ref, referent) {
  this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry.register(referent, ref, ref)
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.unregister__Lcats_effect_unsafe_ref_Reference__V = (function(ref) {
  $uZ(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_finalizationRegistry.unregister(ref))
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.enqueue__Lcats_effect_unsafe_ref_Reference__Z = (function(ref) {
  if ((!ref.Lcats_effect_unsafe_ref_Reference__f_enqueued)) {
    ref.Lcats_effect_unsafe_ref_Reference__f_enqueued = true;
    this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.push(ref);
    return true
  } else {
    return false
  }
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.poll__Lcats_effect_unsafe_ref_Reference = (function() {
  return (($uI(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.length) === 0) ? null : $as_Lcats_effect_unsafe_ref_Reference(this.Lcats_effect_unsafe_ref_ReferenceQueue__f_enqueuedRefs.pop()))
});
var $d_Lcats_effect_unsafe_ref_ReferenceQueue = new $TypeData().initClass({
  Lcats_effect_unsafe_ref_ReferenceQueue: 0
}, false, "cats.effect.unsafe.ref.ReferenceQueue", {
  Lcats_effect_unsafe_ref_ReferenceQueue: 1,
  O: 1
});
$c_Lcats_effect_unsafe_ref_ReferenceQueue.prototype.$classData = $d_Lcats_effect_unsafe_ref_ReferenceQueue;
function $ct_Lcats_evidence_AsInstances__($thiz) {
  $thiz.Lcats_evidence_AsInstances__f_liskov = new $c_Lcats_evidence_AsInstances$$anon$1();
  return $thiz
}
/** @constructor */
function $c_Lcats_evidence_AsInstances() {
  this.Lcats_evidence_AsInstances__f_liskov = null
}
$c_Lcats_evidence_AsInstances.prototype = new $h_O();
$c_Lcats_evidence_AsInstances.prototype.constructor = $c_Lcats_evidence_AsInstances;
/** @constructor */
function $h_Lcats_evidence_AsInstances() {
  /*<skip>*/
}
$h_Lcats_evidence_AsInstances.prototype = $c_Lcats_evidence_AsInstances.prototype;
function $f_Lcats_instances_InvariantInstances__$init$__V($thiz) {
  $thiz.Lcats_instances_package$invariant$__f_catsInvariantForNumeric = new $c_Lcats_instances_InvariantInstances$$anon$1();
  $thiz.Lcats_instances_package$invariant$__f_catsInvariantForIntegral = new $c_Lcats_instances_InvariantInstances$$anon$2()
}
function $f_Lcats_instances_InvariantMonoidalInstances__$init$__V($thiz) {
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$1());
  $thiz.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V(new $c_Lcats_instances_InvariantMonoidalInstances$$anon$2())
}
/** @constructor */
function $c_Lcats_kernel_EqFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_EqFunctions.prototype = new $h_O();
$c_Lcats_kernel_EqFunctions.prototype.constructor = $c_Lcats_kernel_EqFunctions;
/** @constructor */
function $h_Lcats_kernel_EqFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_EqFunctions.prototype = $c_Lcats_kernel_EqFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_SemigroupFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_SemigroupFunctions.prototype = new $h_O();
$c_Lcats_kernel_SemigroupFunctions.prototype.constructor = $c_Lcats_kernel_SemigroupFunctions;
/** @constructor */
function $h_Lcats_kernel_SemigroupFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_SemigroupFunctions.prototype = $c_Lcats_kernel_SemigroupFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_compat_HashCompat() {
  /*<skip>*/
}
$c_Lcats_kernel_compat_HashCompat.prototype = new $h_O();
$c_Lcats_kernel_compat_HashCompat.prototype.constructor = $c_Lcats_kernel_compat_HashCompat;
/** @constructor */
function $h_Lcats_kernel_compat_HashCompat() {
  /*<skip>*/
}
$h_Lcats_kernel_compat_HashCompat.prototype = $c_Lcats_kernel_compat_HashCompat.prototype;
$c_Lcats_kernel_compat_HashCompat.prototype.orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I = (function(xs, A) {
  var it = xs.iterator__sc_Iterator();
  var h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_seqSeed;
  if ((!it.hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 0)
  };
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, A.hash__O__I(x0)), 1)
  };
  var x1 = it.next__O();
  var initial = A.hash__O__I(x0);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, initial);
  var h0 = h;
  var prev = A.hash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, prev);
    var hash = A.hash__O__I(it.next__O());
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, A.hash__O__I(it.next__O()));
        i = ((1 + i) | 0)
      };
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, i)
    };
    prev = hash;
    i = ((1 + i) | 0)
  };
  return this.avalanche__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h0, rangeDiff), prev))
});
$c_Lcats_kernel_compat_HashCompat.prototype.avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
function $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForBigDecimal = new $c_Lcats_kernel_instances_BigDecimalOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForBigDecimal = new $c_Lcats_kernel_instances_BigDecimalGroup()
}
function $f_Lcats_kernel_instances_BigIntInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForBigInt = new $c_Lcats_kernel_instances_BigIntOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForBigInt = new $c_Lcats_kernel_instances_BigIntGroup()
}
function $f_Lcats_kernel_instances_BitSetInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForBitSet = new $c_Lcats_kernel_instances_BitSetPartialOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdSemilatticeForBitSet = new $c_Lcats_kernel_instances_BitSetSemilattice()
}
function $f_Lcats_kernel_instances_ByteInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForByte = new $c_Lcats_kernel_instances_ByteOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForByte = new $c_Lcats_kernel_instances_ByteGroup()
}
function $f_Lcats_kernel_instances_DoubleInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForDouble = new $c_Lcats_kernel_instances_DoubleOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForDouble = new $c_Lcats_kernel_instances_DoubleGroup()
}
function $f_Lcats_kernel_instances_DurationInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForDuration = new $c_Lcats_kernel_instances_DurationOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForDuration = new $c_Lcats_kernel_instances_DurationGroup()
}
function $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForFiniteDuration = new $c_Lcats_kernel_instances_FiniteDurationOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForFiniteDuration = new $c_Lcats_kernel_instances_FiniteDurationGroup()
}
function $f_Lcats_kernel_instances_FloatInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForFloat = new $c_Lcats_kernel_instances_FloatOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForFloat = new $c_Lcats_kernel_instances_FloatGroup()
}
function $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForInt = new $c_Lcats_kernel_instances_IntOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForInt = new $c_Lcats_kernel_instances_IntGroup()
}
function $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_LongOrder());
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_LongGroup())
}
function $f_Lcats_kernel_instances_ShortInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForShort = new $c_Lcats_kernel_instances_ShortOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdGroupForShort = new $c_Lcats_kernel_instances_ShortGroup()
}
function $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForString = new $c_Lcats_kernel_instances_StringOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdMonoidForString = new $c_Lcats_kernel_instances_StringMonoid()
}
function $f_Lcats_kernel_instances_UnitInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsKernelStdOrderForUnit = new $c_Lcats_kernel_instances_UnitOrder();
  $thiz.Lcats_implicits$__f_catsKernelStdAlgebraForUnit = new $c_Lcats_kernel_instances_UnitAlgebra()
}
/** @constructor */
function $c_Lcats_package$() {
  this.Lcats_package$__f_catsInstancesForId = null;
  this.Lcats_package$__f_catsRepresentableForId = null;
  this.Lcats_package$__f_catsParallelForId = null;
  this.Lcats_package$__f_Eq = null;
  this.Lcats_package$__f_PartialOrder = null;
  this.Lcats_package$__f_Order = null;
  this.Lcats_package$__f_Comparison = null;
  this.Lcats_package$__f_Hash = null;
  this.Lcats_package$__f_Semigroup = null;
  this.Lcats_package$__f_Monoid = null;
  this.Lcats_package$__f_Group = null;
  $n_Lcats_package$ = this;
  this.Lcats_package$__f_catsInstancesForId = new $c_Lcats_package$$anon$1();
  this.Lcats_package$__f_catsRepresentableForId = new $c_Lcats_package$$anon$2();
  $m_Lcats_Invariant$();
  var evidence$31 = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  this.Lcats_package$__f_catsParallelForId = new $c_Lcats_Parallel$$anon$2(evidence$31);
  this.Lcats_package$__f_Eq = $m_Lcats_kernel_Eq$();
  this.Lcats_package$__f_PartialOrder = $m_Lcats_kernel_PartialOrder$();
  this.Lcats_package$__f_Order = $m_Lcats_kernel_Order$();
  this.Lcats_package$__f_Comparison = $m_Lcats_kernel_Comparison$();
  this.Lcats_package$__f_Hash = $m_Lcats_kernel_Hash$();
  this.Lcats_package$__f_Semigroup = $m_Lcats_kernel_Semigroup$();
  this.Lcats_package$__f_Monoid = $m_Lcats_kernel_Monoid$();
  this.Lcats_package$__f_Group = $m_Lcats_kernel_Group$()
}
$c_Lcats_package$.prototype = new $h_O();
$c_Lcats_package$.prototype.constructor = $c_Lcats_package$;
/** @constructor */
function $h_Lcats_package$() {
  /*<skip>*/
}
$h_Lcats_package$.prototype = $c_Lcats_package$.prototype;
var $d_Lcats_package$ = new $TypeData().initClass({
  Lcats_package$: 0
}, false, "cats.package$", {
  Lcats_package$: 1,
  O: 1
});
$c_Lcats_package$.prototype.$classData = $d_Lcats_package$;
var $n_Lcats_package$;
function $m_Lcats_package$() {
  if ((!$n_Lcats_package$)) {
    $n_Lcats_package$ = new $c_Lcats_package$()
  };
  return $n_Lcats_package$
}
/** @constructor */
function $c_Lcats_syntax_ApplicativeErrorOps$() {
  /*<skip>*/
}
$c_Lcats_syntax_ApplicativeErrorOps$.prototype = new $h_O();
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.constructor = $c_Lcats_syntax_ApplicativeErrorOps$;
/** @constructor */
function $h_Lcats_syntax_ApplicativeErrorOps$() {
  /*<skip>*/
}
$h_Lcats_syntax_ApplicativeErrorOps$.prototype = $c_Lcats_syntax_ApplicativeErrorOps$.prototype;
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.orElse$extension__O__F0__Lcats_ApplicativeError__O = (function(this$, other, F) {
  return F.handleErrorWith__O__F1__O(this$, new $c_sjsr_AnonFunction1(((other$2) => ((_$6) => other$2.apply__O()))(other)))
});
var $d_Lcats_syntax_ApplicativeErrorOps$ = new $TypeData().initClass({
  Lcats_syntax_ApplicativeErrorOps$: 0
}, false, "cats.syntax.ApplicativeErrorOps$", {
  Lcats_syntax_ApplicativeErrorOps$: 1,
  O: 1
});
$c_Lcats_syntax_ApplicativeErrorOps$.prototype.$classData = $d_Lcats_syntax_ApplicativeErrorOps$;
var $n_Lcats_syntax_ApplicativeErrorOps$;
function $m_Lcats_syntax_ApplicativeErrorOps$() {
  if ((!$n_Lcats_syntax_ApplicativeErrorOps$)) {
    $n_Lcats_syntax_ApplicativeErrorOps$ = new $c_Lcats_syntax_ApplicativeErrorOps$()
  };
  return $n_Lcats_syntax_ApplicativeErrorOps$
}
/** @constructor */
function $c_Lcats_syntax_EitherUtil$() {
  this.Lcats_syntax_EitherUtil$__f_unit = null;
  $n_Lcats_syntax_EitherUtil$ = this;
  this.Lcats_syntax_EitherUtil$__f_unit = ($m_s_package$(), new $c_s_util_Right((void 0)))
}
$c_Lcats_syntax_EitherUtil$.prototype = new $h_O();
$c_Lcats_syntax_EitherUtil$.prototype.constructor = $c_Lcats_syntax_EitherUtil$;
/** @constructor */
function $h_Lcats_syntax_EitherUtil$() {
  /*<skip>*/
}
$h_Lcats_syntax_EitherUtil$.prototype = $c_Lcats_syntax_EitherUtil$.prototype;
var $d_Lcats_syntax_EitherUtil$ = new $TypeData().initClass({
  Lcats_syntax_EitherUtil$: 0
}, false, "cats.syntax.EitherUtil$", {
  Lcats_syntax_EitherUtil$: 1,
  O: 1
});
$c_Lcats_syntax_EitherUtil$.prototype.$classData = $d_Lcats_syntax_EitherUtil$;
var $n_Lcats_syntax_EitherUtil$;
function $m_Lcats_syntax_EitherUtil$() {
  if ((!$n_Lcats_syntax_EitherUtil$)) {
    $n_Lcats_syntax_EitherUtil$ = new $c_Lcats_syntax_EitherUtil$()
  };
  return $n_Lcats_syntax_EitherUtil$
}
/** @constructor */
function $c_Lcats_syntax_FlatMapOps$() {
  /*<skip>*/
}
$c_Lcats_syntax_FlatMapOps$.prototype = new $h_O();
$c_Lcats_syntax_FlatMapOps$.prototype.constructor = $c_Lcats_syntax_FlatMapOps$;
/** @constructor */
function $h_Lcats_syntax_FlatMapOps$() {
  /*<skip>*/
}
$h_Lcats_syntax_FlatMapOps$.prototype = $c_Lcats_syntax_FlatMapOps$.prototype;
$c_Lcats_syntax_FlatMapOps$.prototype.$greater$greater$extension__O__F0__Lcats_FlatMap__O = (function(this$, fb, F) {
  return F.flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1(((fb$2) => ((_$5) => fb$2.apply__O()))(fb)))
});
var $d_Lcats_syntax_FlatMapOps$ = new $TypeData().initClass({
  Lcats_syntax_FlatMapOps$: 0
}, false, "cats.syntax.FlatMapOps$", {
  Lcats_syntax_FlatMapOps$: 1,
  O: 1
});
$c_Lcats_syntax_FlatMapOps$.prototype.$classData = $d_Lcats_syntax_FlatMapOps$;
var $n_Lcats_syntax_FlatMapOps$;
function $m_Lcats_syntax_FlatMapOps$() {
  if ((!$n_Lcats_syntax_FlatMapOps$)) {
    $n_Lcats_syntax_FlatMapOps$ = new $c_Lcats_syntax_FlatMapOps$()
  };
  return $n_Lcats_syntax_FlatMapOps$
}
/** @constructor */
function $c_Lcats_syntax_MonadErrorRethrowOps$() {
  /*<skip>*/
}
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype = new $h_O();
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.constructor = $c_Lcats_syntax_MonadErrorRethrowOps$;
/** @constructor */
function $h_Lcats_syntax_MonadErrorRethrowOps$() {
  /*<skip>*/
}
$h_Lcats_syntax_MonadErrorRethrowOps$.prototype = $c_Lcats_syntax_MonadErrorRethrowOps$.prototype;
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.rethrow$extension__O__Lcats_MonadError__O = (function(this$, F) {
  return F.flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1(((F$2) => ((_$5) => {
    var _$5$1 = $as_s_util_Either(_$5);
    if ((_$5$1 instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(_$5$1);
      var b = x2.s_util_Right__f_value;
      return F$2.pure__O__O(b)
    } else if ((_$5$1 instanceof $c_s_util_Left)) {
      var x3 = $as_s_util_Left(_$5$1);
      var a = x3.s_util_Left__f_value;
      return F$2.raiseError__O__O(a)
    } else {
      throw new $c_s_MatchError(_$5$1)
    }
  }))(F)))
});
var $d_Lcats_syntax_MonadErrorRethrowOps$ = new $TypeData().initClass({
  Lcats_syntax_MonadErrorRethrowOps$: 0
}, false, "cats.syntax.MonadErrorRethrowOps$", {
  Lcats_syntax_MonadErrorRethrowOps$: 1,
  O: 1
});
$c_Lcats_syntax_MonadErrorRethrowOps$.prototype.$classData = $d_Lcats_syntax_MonadErrorRethrowOps$;
var $n_Lcats_syntax_MonadErrorRethrowOps$;
function $m_Lcats_syntax_MonadErrorRethrowOps$() {
  if ((!$n_Lcats_syntax_MonadErrorRethrowOps$)) {
    $n_Lcats_syntax_MonadErrorRethrowOps$ = new $c_Lcats_syntax_MonadErrorRethrowOps$()
  };
  return $n_Lcats_syntax_MonadErrorRethrowOps$
}
/** @constructor */
function $c_Lfs2_Chunk$Queue$() {
  this.Lfs2_Chunk$Queue$__f_empty_ = null;
  $n_Lfs2_Chunk$Queue$ = this;
  this.Lfs2_Chunk$Queue$__f_empty_ = new $c_Lfs2_Chunk$Queue($m_sci_Queue$EmptyQueue$(), 0)
}
$c_Lfs2_Chunk$Queue$.prototype = new $h_O();
$c_Lfs2_Chunk$Queue$.prototype.constructor = $c_Lfs2_Chunk$Queue$;
/** @constructor */
function $h_Lfs2_Chunk$Queue$() {
  /*<skip>*/
}
$h_Lfs2_Chunk$Queue$.prototype = $c_Lfs2_Chunk$Queue$.prototype;
var $d_Lfs2_Chunk$Queue$ = new $TypeData().initClass({
  Lfs2_Chunk$Queue$: 0
}, false, "fs2.Chunk$Queue$", {
  Lfs2_Chunk$Queue$: 1,
  O: 1
});
$c_Lfs2_Chunk$Queue$.prototype.$classData = $d_Lfs2_Chunk$Queue$;
var $n_Lfs2_Chunk$Queue$;
function $m_Lfs2_Chunk$Queue$() {
  if ((!$n_Lfs2_Chunk$Queue$)) {
    $n_Lfs2_Chunk$Queue$ = new $c_Lfs2_Chunk$Queue$()
  };
  return $n_Lfs2_Chunk$Queue$
}
function $f_Lfs2_ChunkCompanionPlatform__platformIterable__sc_Iterable__s_Option($thiz, i) {
  if ((i instanceof $c_sci_ArraySeq)) {
    var a = $as_sci_ArraySeq(i);
    var value = $f_Lfs2_ChunkCompanionPlatform__arraySeq__sci_ArraySeq__Lfs2_Chunk($thiz, a);
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
}
function $f_Lfs2_ChunkCompanionPlatform__arraySeq__sci_ArraySeq__Lfs2_Chunk($thiz, arraySeq) {
  var arr = arraySeq.unsafeArray__O();
  return $as_Lfs2_Chunk$($thiz).array__O__s_reflect_ClassTag__Lfs2_Chunk(arr, $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(arr).getComponentType__jl_Class()))
}
/** @constructor */
function $c_Lfs2_Pull() {
  /*<skip>*/
}
$c_Lfs2_Pull.prototype = new $h_O();
$c_Lfs2_Pull.prototype.constructor = $c_Lfs2_Pull;
/** @constructor */
function $h_Lfs2_Pull() {
  /*<skip>*/
}
$h_Lfs2_Pull.prototype = $c_Lfs2_Pull.prototype;
function $as_Lfs2_Pull(obj) {
  return (((obj instanceof $c_Lfs2_Pull) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull"))
}
function $isArrayOf_Lfs2_Pull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull)))
}
function $asArrayOf_Lfs2_Pull(obj, depth) {
  return (($isArrayOf_Lfs2_Pull(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$IdOps$() {
  /*<skip>*/
}
$c_Lfs2_Pull$IdOps$.prototype = new $h_O();
$c_Lfs2_Pull$IdOps$.prototype.constructor = $c_Lfs2_Pull$IdOps$;
/** @constructor */
function $h_Lfs2_Pull$IdOps$() {
  /*<skip>*/
}
$h_Lfs2_Pull$IdOps$.prototype = $c_Lfs2_Pull$IdOps$.prototype;
$c_Lfs2_Pull$IdOps$.prototype.covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull = (function(this$, evidence$4) {
  return $m_Lfs2_Pull$().translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull(this$, new $c_Lfs2_Pull$$anon$10(evidence$4))
});
var $d_Lfs2_Pull$IdOps$ = new $TypeData().initClass({
  Lfs2_Pull$IdOps$: 0
}, false, "fs2.Pull$IdOps$", {
  Lfs2_Pull$IdOps$: 1,
  O: 1
});
$c_Lfs2_Pull$IdOps$.prototype.$classData = $d_Lfs2_Pull$IdOps$;
var $n_Lfs2_Pull$IdOps$;
function $m_Lfs2_Pull$IdOps$() {
  if ((!$n_Lfs2_Pull$IdOps$)) {
    $n_Lfs2_Pull$IdOps$ = new $c_Lfs2_Pull$IdOps$()
  };
  return $n_Lfs2_Pull$IdOps$
}
function $is_Lfs2_Pull$Run$1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_Pull$Run$1)))
}
function $as_Lfs2_Pull$Run$1(obj) {
  return (($is_Lfs2_Pull$Run$1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Run$1"))
}
function $isArrayOf_Lfs2_Pull$Run$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Run$1)))
}
function $asArrayOf_Lfs2_Pull$Run$1(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Run$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Run$1;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$StreamPullOps$() {
  /*<skip>*/
}
$c_Lfs2_Pull$StreamPullOps$.prototype = new $h_O();
$c_Lfs2_Pull$StreamPullOps$.prototype.constructor = $c_Lfs2_Pull$StreamPullOps$;
/** @constructor */
function $h_Lfs2_Pull$StreamPullOps$() {
  /*<skip>*/
}
$h_Lfs2_Pull$StreamPullOps$.prototype = $c_Lfs2_Pull$StreamPullOps$.prototype;
$c_Lfs2_Pull$StreamPullOps$.prototype.stream$extension__Lfs2_Pull__Lfs2_Stream = (function(this$) {
  return new $c_Lfs2_Stream(($m_Lfs2_Pull$(), new $c_Lfs2_Pull$InScope(this$, false)))
});
var $d_Lfs2_Pull$StreamPullOps$ = new $TypeData().initClass({
  Lfs2_Pull$StreamPullOps$: 0
}, false, "fs2.Pull$StreamPullOps$", {
  Lfs2_Pull$StreamPullOps$: 1,
  O: 1
});
$c_Lfs2_Pull$StreamPullOps$.prototype.$classData = $d_Lfs2_Pull$StreamPullOps$;
var $n_Lfs2_Pull$StreamPullOps$;
function $m_Lfs2_Pull$StreamPullOps$() {
  if ((!$n_Lfs2_Pull$StreamPullOps$)) {
    $n_Lfs2_Pull$StreamPullOps$ = new $c_Lfs2_Pull$StreamPullOps$()
  };
  return $n_Lfs2_Pull$StreamPullOps$
}
function $p_Lfs2_Stream__parEvalMapAction__I__F1__F2__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream($thiz, maxConcurrent, f, initFork, F) {
  if ((maxConcurrent === 1)) {
    return $thiz.evalMap__F1__Lfs2_Stream(f)
  } else {
    if ((maxConcurrent <= 0)) {
      $m_sr_Scala3RunTime$().assertFailed__O__E(("maxConcurrent must be > 0, was: " + maxConcurrent))
    };
    var concurrency = ((maxConcurrent === 2147483647) ? 2147483647 : ((1 + maxConcurrent) | 0));
    var $$x1 = $m_Lcats_effect_std_Semaphore$();
    var hi = (concurrency >> 31);
    var _1 = $$x1.apply__J__Lcats_effect_kernel_GenConcurrent__O(new $c_RTLong(concurrency, hi), F);
    var _2 = $m_Lfs2_concurrent_Channel$().bounded__I__Lcats_effect_kernel_GenConcurrent__O(concurrency, F);
    var _3 = F.deferred__O();
    var _4 = F.deferred__O();
    var t4 = new $c_T4(_1, _2, _3, _4);
    var action = new $c_Lcats_syntax_Tuple4SemigroupalOps(t4).mapN__F4__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction4(((this$6, f$2, initFork$2, F$2, concurrency$2) => ((semaphore, channel, stop, end) => {
      var semaphore$1 = $as_Lcats_effect_std_Semaphore(semaphore);
      var channel$1 = $as_Lfs2_concurrent_Channel(channel);
      var stop$1 = $as_Lcats_effect_kernel_Deferred(stop);
      var end$1 = $as_Lcats_effect_kernel_Deferred(end);
      var fa = semaphore$1.releaseN__J__O(new $c_RTLong(1, 0));
      var this$18 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$2);
      var target = semaphore$1.available__O();
      var this$17 = new $c_Lcats_FlatMap$$anon$2(target, F$2);
      var f$1 = new $c_sjsr_AnonFunction1(((F$77$2, concurrency$1$2, channel$2, end$2) => ((x$1) => {
        var t = $uJ(x$1);
        var lo = t.RTLong__f_lo;
        var hi$1 = t.RTLong__f_hi;
        var hi$2 = (concurrency$1$2 >> 31);
        if (((concurrency$1$2 === lo) && (hi$2 === hi$1))) {
          var fa$1 = channel$2.close__O();
          var this$13 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F$77$2);
          var target$1 = end$2.complete__O__O((void 0));
          var this$12 = new $c_Lcats_Functor$$anon$4(target$1, F$77$2);
          var fb = this$12.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$12.Lcats_Functor$$anon$4__f_self);
          var this$14 = this$13.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
          var fa$2 = this$13.Lcats_syntax_ApplySyntax$$anon$1__f_self;
          return this$14.productR__O__O__O(fa$2, fb)
        } else {
          return F$77$2.pure__O__O((void 0))
        }
      }))(F$2, concurrency$2, channel$1, end$1));
      var fb$1 = this$17.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$17.Lcats_FlatMap$$anon$2__f_self, f$1);
      var this$19 = this$18.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
      var fa$3 = this$18.Lcats_syntax_ApplySyntax$$anon$1__f_self;
      var releaseAndCheckCompletion = this$19.productR__O__O__O(fa$3, fb$1);
      var background = $m_Lfs2_Stream$().exec__O__Lfs2_Stream(semaphore$1.acquireN__J__O(new $c_RTLong(1, 0))).$plus$plus__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0(((this$20, f$55$2, initFork$1$2, F$77$3, semaphore$2, channel$3, stop$2, releaseAndCheckCompletion$2) => (() => {
        var target$2 = stop$2.get__O();
        var this$25 = new $c_Lcats_Functor$$anon$4(target$2, F$77$3);
        var f$3 = new $c_sjsr_AnonFunction1(((_$53) => {
          var _$53$1 = $as_jl_Void(_$53);
          $m_s_package$();
          return new $c_s_util_Right(_$53$1)
        }));
        return this$20.interruptWhen__O__Lfs2_Stream(this$25.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$25.Lcats_Functor$$anon$4__f_self, f$3)).foreach__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((f$61$2, initFork$5$2, F$83$2, semaphore$3$2, channel$5$2, stop$5$2, releaseAndCheckCompletion$5$2) => ((el) => $ps_Lfs2_Stream__forkOnElem$1__F1__F2__Lcats_effect_kernel_GenConcurrent__Lcats_effect_std_Semaphore__Lfs2_concurrent_Channel__Lcats_effect_kernel_Deferred__O__O__O(f$61$2, initFork$5$2, F$83$2, semaphore$3$2, channel$5$2, stop$5$2, releaseAndCheckCompletion$5$2, el)))(f$55$2, initFork$1$2, F$77$3, semaphore$2, channel$3, stop$2, releaseAndCheckCompletion$2))).onFinalizeCase__F1__Lcats_Applicative__Lfs2_Stream(new $c_sjsr_AnonFunction1(((F$83$3, stop$5$3, releaseAndCheckCompletion$5$3) => ((x$1$1) => {
          var x$1$2 = $as_Lcats_effect_kernel_Resource$ExitCase(x$1$1);
          $m_Lcats_effect_package$();
          var x = $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$();
          if ((x === x$1$2)) {
            return releaseAndCheckCompletion$5$3
          } else {
            var fa$4 = stop$5$3.complete__O__O((void 0));
            var this$27 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$4, F$83$3);
            var this$28 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
            var fa$5 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$28.productR__O__O__O(fa$5, releaseAndCheckCompletion$5$3)
          }
        }))(F$77$3, stop$2, releaseAndCheckCompletion$2)), F$77$3)
      }))(this$6, f$2, initFork$2, F$2, semaphore$1, channel$1, stop$1, releaseAndCheckCompletion)));
      var foreground = channel$1.stream__Lfs2_Stream().evalMap__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((F$77$4) => ((_$54) => $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(_$54, F$77$4)))(F$2)));
      var fa$6 = stop$1.complete__O__O((void 0));
      var this$31 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$6, F$2);
      var fb$2 = end$1.get__O();
      var this$32 = this$31.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
      var fa$7 = this$31.Lcats_syntax_ApplySyntax$$anon$1__f_self;
      return foreground.onFinalize__O__Lcats_Applicative__Lfs2_Stream(this$32.productR__O__O__O(fa$7, fb$2), F$2).concurrently__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream(background, F$2)
    }))($thiz, f, initFork, F, concurrency)), F, F);
    return $m_Lfs2_Stream$().force__O__Lfs2_Stream(action)
  }
}
function $ps_Lfs2_Stream__watch$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Deferred__Lfs2_Stream__Lfs2_Stream(F$3, interrupt$2, str) {
  var fa = interrupt$2.get__O();
  return str.interruptWhen__O__Lfs2_Stream(F$3.attempt__O__O(fa))
}
function $ps_Lfs2_Stream__init$2__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__O__O(F$69, ch, release) {
  var target = F$69.deferred__O();
  var this$6 = new $c_Lcats_FlatMap$$anon$2(target, F$69);
  var f = new $c_sjsr_AnonFunction1(((F$69$2, ch$2, release$2) => ((value) => {
    var value$1 = $as_Lcats_effect_kernel_Deferred(value);
    var this$4 = new $c_Lcats_syntax_ApplySyntax$$anon$1(release$2, F$69$2);
    var fb = value$1.get__O();
    var this$5 = this$4.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
    var fa = this$4.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    return ch$2.send__O__O(this$5.productR__O__O__O(fa, fb))
  }))(F$69, ch, release));
  var this$7 = this$6.Lcats_FlatMap$$anon$2__f_typeClassInstance;
  var fa$1 = this$6.Lcats_FlatMap$$anon$2__f_self;
  return $f_Lcats_FlatMap__flatTap__O__F1__O(this$7, fa$1, f)
}
function $ps_Lfs2_Stream__send$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Deferred__F1(F$72, v) {
  return new $c_sjsr_AnonFunction1(((F$72$2, v$2) => ((el) => {
    var el$1 = $as_s_util_Either(el);
    var target = v$2.complete__O__O(el$1);
    var this$2 = new $c_Lcats_Functor$$anon$4(target, F$72$2);
    return this$2.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$2.Lcats_Functor$$anon$4__f_self)
  }))(F$72, v))
}
function $ps_Lfs2_Stream__forkOnElem$1__F1__F2__Lcats_effect_kernel_GenConcurrent__Lcats_effect_std_Semaphore__Lfs2_concurrent_Channel__Lcats_effect_kernel_Deferred__O__O__O(f$56, initFork$2, F$79, semaphore$1, channel$2, stop$1, releaseAndCheckCompletion$1, el) {
  return F$79.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((f$56$2, initFork$2$2, F$79$2, semaphore$1$2, channel$2$2, stop$1$2, releaseAndCheckCompletion$1$2, el$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var fa = poll$1.apply__O__O(semaphore$1$2.acquireN__J__O(new $c_RTLong(1, 0)));
    var this$26 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$79$2);
    var target = F$79$2.deferred__O();
    var this$25 = new $c_Lcats_FlatMap$$anon$2(target, F$79$2);
    var f$1 = new $c_sjsr_AnonFunction1(((f$57$2, initFork$3$2, F$80$2, channel$3$2, stop$2$2, releaseAndCheckCompletion$2$2, el$1$2, poll$2) => ((pushed) => {
      var pushed$1 = $as_Lcats_effect_kernel_Deferred(pushed);
      var target$1 = pushed$1.complete__O__O((void 0));
      var this$5 = new $c_Lcats_Functor$$anon$4(target$1, F$80$2);
      var init = initFork$3$2.apply__O__O__O(channel$3$2, this$5.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$5.Lcats_Functor$$anon$4__f_self));
      var wrapped = poll$2.apply__O__O(init);
      var target$2 = F$80$2.onCancel__O__O__O(wrapped, releaseAndCheckCompletion$2$2);
      var this$24 = new $c_Lcats_FlatMap$$anon$2(target$2, F$80$2);
      var f = new $c_sjsr_AnonFunction1(((f$58$2, F$81$2, stop$3$2, releaseAndCheckCompletion$3$2, el$2$2, pushed$2) => ((send) => {
        var send$1 = $as_F1(send);
        $m_s_$less$colon$less$();
        try {
          var ffa = F$81$2.pure__O__O(f$58$2.apply__O__O(el$2$2))
        } catch (e) {
          var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
          matchResult3: {
            var ffa;
            if ((e$2 !== null)) {
              var x10 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
              if ((!x10.isEmpty__Z())) {
                var x11 = $as_jl_Throwable(x10.get__O());
                var ffa = F$81$2.raiseError__O__O(x11);
                break matchResult3
              }
            };
            throw e$2
          }
        };
        var fa$1 = $f_Lcats_FlatMap__flatten__O__O(F$81$2, ffa);
        var target$3 = F$81$2.attempt__O__O(fa$1);
        var this$15 = new $c_Lcats_FlatMap$$anon$2(target$3, F$81$2);
        var fa$2 = this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, send$1);
        var this$17 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$2, F$81$2);
        var fb = pushed$2.get__O();
        var this$18 = this$17.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
        var fa$3 = this$17.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        var action = this$18.productR__O__O__O(fa$3, fb);
        var wrapped$1 = stop$3$2.get__O();
        var fa$4 = $f_Lcats_effect_kernel_GenSpawn__race__O__O__O(F$81$2, wrapped$1, action);
        var this$22 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$4, F$81$2);
        var this$23 = this$22.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
        var fa$5 = this$22.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        return F$81$2.start__O__O(this$23.productR__O__O__O(fa$5, releaseAndCheckCompletion$3$2))
      }))(f$57$2, F$80$2, stop$2$2, releaseAndCheckCompletion$2$2, el$1$2, pushed$1));
      return this$24.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$24.Lcats_FlatMap$$anon$2__f_self, f)
    }))(f$56$2, initFork$2$2, F$79$2, channel$2$2, stop$1$2, releaseAndCheckCompletion$1$2, el$2, poll$1));
    var fb$1 = this$25.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$25.Lcats_FlatMap$$anon$2__f_self, f$1);
    var this$27 = this$26.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
    var fa$6 = this$26.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    return this$27.productL__O__O__O(fa$6, fb$1)
  }))(f$56, initFork$2, F$79, semaphore$1, channel$2, stop$1, releaseAndCheckCompletion$1, el)))
}
/** @constructor */
function $c_Lfs2_Stream(underlying) {
  this.Lfs2_Stream__f_underlying = null;
  this.Lfs2_Stream__f_underlying = underlying
}
$c_Lfs2_Stream.prototype = new $h_O();
$c_Lfs2_Stream.prototype.constructor = $c_Lfs2_Stream;
/** @constructor */
function $h_Lfs2_Stream() {
  /*<skip>*/
}
$h_Lfs2_Stream.prototype = $c_Lfs2_Stream.prototype;
$c_Lfs2_Stream.prototype.$plus$plus__F0__Lfs2_Stream = (function(s2) {
  var this$1 = this.Lfs2_Stream__f_underlying;
  var post = new $c_sjsr_AnonFunction0(((s2$2) => (() => $as_Lfs2_Stream(s2$2.apply__O()).Lfs2_Stream__f_underlying))(s2));
  return new $c_Lfs2_Stream(new $c_Lfs2_Pull$$anon$2(post, this$1))
});
$c_Lfs2_Stream.prototype.concurrently__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream = (function(that, F) {
  var target = F.deferred__O();
  var this$26 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f$2 = new $c_sjsr_AnonFunction1(((this$2, that$2, F$2) => ((interrupt) => {
    var interrupt$1 = $as_Lcats_effect_kernel_Deferred(interrupt);
    var target$1 = F$2.deferred__O();
    var this$25 = new $c_Lcats_Functor$$anon$4(target$1, F$2);
    var f$1 = new $c_sjsr_AnonFunction1(((this$4, that$1$2, F$1$2, interrupt$2) => ((backResult) => {
      var backResult$1 = $as_Lcats_effect_kernel_Deferred(backResult);
      var this$8 = $m_Lcats_effect_kernel_implicits$();
      var this$7 = $ps_Lfs2_Stream__watch$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Deferred__Lfs2_Stream__Lfs2_Stream(F$1$2, interrupt$2, that$1$2);
      $m_Lfs2_Compiler$();
      var F$1 = new $c_Lfs2_Compiler$Target$ConcurrentTarget(F$1$2);
      var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F$1);
      var wrapped = new $c_Lfs2_Stream$CompileOps(this$7.Lfs2_Stream__f_underlying, compiler).drain__O();
      var ev$23 = $f_Lcats_effect_kernel_syntax_MonadCancelSyntax__monadCancelOps__O__Lcats_effect_kernel_MonadCancel__O(this$8, wrapped, F$1$2);
      var fin = new $c_sjsr_AnonFunction1(((F$2$2, interrupt$1$2, backResult$2) => ((x$1) => {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
        if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
          var x62 = $as_jl_Throwable(x$1$2.Lcats_effect_kernel_Outcome$Errored__f_e);
          var fa = backResult$2.complete__O__O(($m_s_package$(), new $c_s_util_Left(x62)));
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((F$4$2, interrupt$3$2) => (() => {
            var target$2 = interrupt$3$2.complete__O__O((void 0));
            var this$13 = new $c_Lcats_Functor$$anon$4(target$2, F$4$2);
            return this$13.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$13.Lcats_Functor$$anon$4__f_self)
          }))(F$2$2, interrupt$1$2)), F$2$2)
        } else {
          var target$3 = backResult$2.complete__O__O(($m_s_package$(), new $c_s_util_Right((void 0))));
          var this$16 = new $c_Lcats_Functor$$anon$4(target$3, F$2$2);
          return this$16.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$16.Lcats_Functor$$anon$4__f_self)
        }
      }))(F$1$2, interrupt$2, backResult$1));
      var compileBack = F$1$2.guaranteeCase__O__F1__O(ev$23, fin);
      var fa$1 = interrupt$2.complete__O__O((void 0));
      var stopBack = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0(((F$2$3, backResult$3) => (() => {
        var target$4 = backResult$3.get__O();
        var this$20 = new $c_Lcats_FlatMap$$anon$2(target$4, F$2$3);
        var f = new $c_sjsr_AnonFunction1(((F$6$2) => ((x) => {
          var x$2 = $as_s_util_Either(x);
          return $f_Lcats_ApplicativeError__fromEither__s_util_Either__O(F$6$2, x$2)
        }))(F$2$3));
        return this$20.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$$anon$2__f_self, f)
      }))(F$1$2, backResult$1)), F$1$2);
      var $$x1 = $m_Lfs2_Stream$();
      var this$21 = $m_Lcats_effect_kernel_implicits$();
      var ev$25 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$21, compileBack, F$1$2);
      return $$x1.bracket__O__F1__Lfs2_Stream(F$1$2.start__O__O(ev$25), new $c_sjsr_AnonFunction1(((stopBack$2) => ((_$12) => {
        $as_Lcats_effect_kernel_Fiber(_$12);
        return stopBack$2
      }))(stopBack))).$greater$greater__F0__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction0(((this$23, F$2$4, interrupt$1$3) => (() => $ps_Lfs2_Stream__watch$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Deferred__Lfs2_Stream__Lfs2_Stream(F$2$4, interrupt$1$3, this$23)))(this$4, F$1$2, interrupt$2)), new $c_s_util_NotGiven())
    }))(this$2, that$2, F$2, interrupt$1));
    return this$25.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$25.Lcats_Functor$$anon$4__f_self, f$1)
  }))(this, that, F));
  var fstream = this$26.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$26.Lcats_FlatMap$$anon$2__f_self, f$2);
  var $$x2 = $m_Lfs2_Stream$().eval__O__Lfs2_Stream(fstream);
  var this$27 = $m_s_$less$colon$less$();
  return $$x2.flatten__s_$less$colon$less__Lfs2_Stream(this$27.s_$less$colon$less$__f_singleton)
});
$c_Lfs2_Stream.prototype.evalMap__F1__Lfs2_Stream = (function(f) {
  return this.flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((f$2) => ((o) => $m_Lfs2_Stream$().eval__O__Lfs2_Stream(f$2.apply__O__O(o))))(f)), new $c_s_util_NotGiven())
});
$c_Lfs2_Stream.prototype.flatMap__F1__s_util_NotGiven__Lfs2_Stream = (function(f, ev) {
  return new $c_Lfs2_Stream($m_Lfs2_Pull$().flatMapOutput__Lfs2_Pull__F1__Lfs2_Pull(this.Lfs2_Stream__f_underlying, new $c_sjsr_AnonFunction1(((f$2) => ((o) => $as_Lfs2_Stream(f$2.apply__O__O(o)).Lfs2_Stream__f_underlying))(f))))
});
$c_Lfs2_Stream.prototype.$greater$greater__F0__s_util_NotGiven__Lfs2_Stream = (function(s2, ev) {
  return this.flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((s2$2) => ((_$32) => $as_Lfs2_Stream(s2$2.apply__O())))(s2)), new $c_s_util_NotGiven())
});
$c_Lfs2_Stream.prototype.flatten__s_$less$colon$less__Lfs2_Stream = (function(ev) {
  return this.flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((i) => $as_Lfs2_Stream(i))), new $c_s_util_NotGiven())
});
$c_Lfs2_Stream.prototype.foreach__F1__Lfs2_Stream = (function(f) {
  return this.flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((f$2) => ((o) => $m_Lfs2_Stream$().exec__O__Lfs2_Stream(f$2.apply__O__O(o))))(f)), new $c_s_util_NotGiven())
});
$c_Lfs2_Stream.prototype.interruptWhen__O__Lfs2_Stream = (function(haltOnSignal) {
  $m_Lfs2_Pull$();
  $m_Lfs2_Pull$();
  var this$7 = new $c_Lfs2_Pull$InterruptWhen(haltOnSignal);
  var post = new $c_sjsr_AnonFunction0(((this$3) => (() => {
    var ev$101 = ($m_Lfs2_Stream$(), new $c_Lfs2_Stream$ToPull(this$3)).Lfs2_Stream$ToPull__f_self;
    return ev$101.Lfs2_Stream__f_underlying
  }))(this));
  var self = new $c_Lfs2_Pull$$anon$2(post, this$7);
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self).interruptScope__Lfs2_Stream()
});
$c_Lfs2_Stream.prototype.interruptScope__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  var s = this.Lfs2_Stream__f_underlying;
  return new $c_Lfs2_Stream(new $c_Lfs2_Pull$InScope(s, true))
});
$c_Lfs2_Stream.prototype.onFinalize__O__Lcats_Applicative__Lfs2_Stream = (function(f, F2) {
  return $m_Lfs2_Stream$().bracket__O__F1__Lfs2_Stream(F2.unit__O(), new $c_sjsr_AnonFunction1(((f$2) => ((_$48) => {
    $as_jl_Void(_$48);
    return f$2
  }))(f))).$greater$greater__F0__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction0(((this$1) => (() => this$1))(this)), new $c_s_util_NotGiven())
});
$c_Lfs2_Stream.prototype.onFinalizeCase__F1__Lcats_Applicative__Lfs2_Stream = (function(f, F2) {
  return $m_Lfs2_Stream$().bracketCase__O__F2__Lfs2_Stream(F2.unit__O(), new $c_sjsr_AnonFunction2(((f$2) => ((_$50, ec) => {
    $as_jl_Void(_$50);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    return f$2.apply__O__O(ec$1)
  }))(f))).$greater$greater__F0__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction0(((this$1) => (() => this$1))(this)), new $c_s_util_NotGiven())
});
$c_Lfs2_Stream.prototype.parEvalMap__I__F1__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream = (function(maxConcurrent, f, F) {
  return $p_Lfs2_Stream__parEvalMapAction__I__F1__F2__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream(this, maxConcurrent, f, new $c_sjsr_AnonFunction2(((F$2) => ((ch, release) => {
    var ch$1 = $as_Lfs2_concurrent_Channel(ch);
    var target = $ps_Lfs2_Stream__init$2__Lcats_effect_kernel_GenConcurrent__Lfs2_concurrent_Channel__O__O(F$2, ch$1, release);
    var this$2 = new $c_Lcats_Functor$$anon$4(target, F$2);
    var f$1 = new $c_sjsr_AnonFunction1(((F$73$2) => ((v) => {
      var v$1 = $as_Lcats_effect_kernel_Deferred(v);
      return $ps_Lfs2_Stream__send$1__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Deferred__F1(F$73$2, v$1)
    }))(F$2));
    return this$2.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$$anon$4__f_self, f$1)
  }))(F)), F)
});
$c_Lfs2_Stream.prototype.scope__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  var s = this.Lfs2_Stream__f_underlying;
  return new $c_Lfs2_Stream(new $c_Lfs2_Pull$InScope(s, false))
});
$c_Lfs2_Stream.prototype.toString__T = (function() {
  return "Stream(..)"
});
function $as_Lfs2_Stream(obj) {
  return (((obj instanceof $c_Lfs2_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Stream"))
}
function $isArrayOf_Lfs2_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream)))
}
function $asArrayOf_Lfs2_Stream(obj, depth) {
  return (($isArrayOf_Lfs2_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Stream;", depth))
}
var $d_Lfs2_Stream = new $TypeData().initClass({
  Lfs2_Stream: 0
}, false, "fs2.Stream", {
  Lfs2_Stream: 1,
  O: 1
});
$c_Lfs2_Stream.prototype.$classData = $d_Lfs2_Stream;
/** @constructor */
function $c_Lfs2_Stream$CompileOps(underlying, compiler) {
  this.Lfs2_Stream$CompileOps__f_underlying = null;
  this.Lfs2_Stream$CompileOps__f_compiler = null;
  this.Lfs2_Stream$CompileOps__f_underlying = underlying;
  this.Lfs2_Stream$CompileOps__f_compiler = compiler
}
$c_Lfs2_Stream$CompileOps.prototype = new $h_O();
$c_Lfs2_Stream$CompileOps.prototype.constructor = $c_Lfs2_Stream$CompileOps;
/** @constructor */
function $h_Lfs2_Stream$CompileOps() {
  /*<skip>*/
}
$h_Lfs2_Stream$CompileOps.prototype = $c_Lfs2_Stream$CompileOps.prototype;
$c_Lfs2_Stream$CompileOps.prototype.drain__O = (function() {
  return this.foldChunks__O__F2__O((void 0), new $c_sjsr_AnonFunction2(((_$189, _$190) => {
    $as_jl_Void(_$189);
    $as_Lfs2_Chunk(_$190)
  })))
});
$c_Lfs2_Stream$CompileOps.prototype.foldChunks__O__F2__O = (function(init, f) {
  return this.Lfs2_Stream$CompileOps__f_compiler.apply__Lfs2_Pull__O__F2__O(this.Lfs2_Stream$CompileOps__f_underlying, init, f)
});
$c_Lfs2_Stream$CompileOps.prototype.last__O = (function() {
  return this.foldChunks__O__F2__O($m_s_None$(), new $c_sjsr_AnonFunction2(((acc, c) => {
    var acc$1 = $as_s_Option(acc);
    var c$1 = $as_Lfs2_Chunk(c);
    var this$3 = c$1.last__s_Option();
    return (this$3.isEmpty__Z() ? acc$1 : this$3)
  })))
});
$c_Lfs2_Stream$CompileOps.prototype.lastOrError__Lcats_MonadError__O = (function(G) {
  var target = this.last__O();
  var this$3 = new $c_Lcats_FlatMap$$anon$2(target, G);
  var f = new $c_sjsr_AnonFunction1(((G$2) => ((_$192) => {
    var _$192$1 = $as_s_Option(_$192);
    if (_$192$1.isEmpty__Z()) {
      return G$2.raiseError__O__O($ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException()))
    } else {
      var arg1 = _$192$1.get__O();
      return G$2.pure__O__O(arg1)
    }
  }))(G));
  return this$3.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$$anon$2__f_self, f)
});
var $d_Lfs2_Stream$CompileOps = new $TypeData().initClass({
  Lfs2_Stream$CompileOps: 0
}, false, "fs2.Stream$CompileOps", {
  Lfs2_Stream$CompileOps: 1,
  O: 1
});
$c_Lfs2_Stream$CompileOps.prototype.$classData = $d_Lfs2_Stream$CompileOps;
/** @constructor */
function $c_Lfs2_Stream$StepLeg(head, scopeId, next) {
  this.Lfs2_Stream$StepLeg__f_head = null;
  this.Lfs2_Stream$StepLeg__f_scopeId = null;
  this.Lfs2_Stream$StepLeg__f_next = null;
  this.Lfs2_Stream$StepLeg__f_head = head;
  this.Lfs2_Stream$StepLeg__f_scopeId = scopeId;
  this.Lfs2_Stream$StepLeg__f_next = next
}
$c_Lfs2_Stream$StepLeg.prototype = new $h_O();
$c_Lfs2_Stream$StepLeg.prototype.constructor = $c_Lfs2_Stream$StepLeg;
/** @constructor */
function $h_Lfs2_Stream$StepLeg() {
  /*<skip>*/
}
$h_Lfs2_Stream$StepLeg.prototype = $c_Lfs2_Stream$StepLeg.prototype;
var $d_Lfs2_Stream$StepLeg = new $TypeData().initClass({
  Lfs2_Stream$StepLeg: 0
}, false, "fs2.Stream$StepLeg", {
  Lfs2_Stream$StepLeg: 1,
  O: 1
});
$c_Lfs2_Stream$StepLeg.prototype.$classData = $d_Lfs2_Stream$StepLeg;
/** @constructor */
function $c_Lfs2_Stream$ToPull(self) {
  this.Lfs2_Stream$ToPull__f_self = null;
  this.Lfs2_Stream$ToPull__f_self = self
}
$c_Lfs2_Stream$ToPull.prototype = new $h_O();
$c_Lfs2_Stream$ToPull.prototype.constructor = $c_Lfs2_Stream$ToPull;
/** @constructor */
function $h_Lfs2_Stream$ToPull() {
  /*<skip>*/
}
$h_Lfs2_Stream$ToPull.prototype = $c_Lfs2_Stream$ToPull.prototype;
$c_Lfs2_Stream$ToPull.prototype.hashCode__I = (function() {
  var this$ = this.Lfs2_Stream$ToPull__f_self;
  return $systemIdentityHashCode(this$)
});
$c_Lfs2_Stream$ToPull.prototype.equals__O__Z = (function(x$0) {
  return $m_Lfs2_Stream$ToPull$().equals$extension__Lfs2_Stream__O__Z(this.Lfs2_Stream$ToPull__f_self, x$0)
});
function $as_Lfs2_Stream$ToPull(obj) {
  return (((obj instanceof $c_Lfs2_Stream$ToPull) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Stream$ToPull"))
}
function $isArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Stream$ToPull)))
}
function $asArrayOf_Lfs2_Stream$ToPull(obj, depth) {
  return (($isArrayOf_Lfs2_Stream$ToPull(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Stream$ToPull;", depth))
}
var $d_Lfs2_Stream$ToPull = new $TypeData().initClass({
  Lfs2_Stream$ToPull: 0
}, false, "fs2.Stream$ToPull", {
  Lfs2_Stream$ToPull: 1,
  O: 1
});
$c_Lfs2_Stream$ToPull.prototype.$classData = $d_Lfs2_Stream$ToPull;
/** @constructor */
function $c_Lfs2_Stream$ToPull$() {
  /*<skip>*/
}
$c_Lfs2_Stream$ToPull$.prototype = new $h_O();
$c_Lfs2_Stream$ToPull$.prototype.constructor = $c_Lfs2_Stream$ToPull$;
/** @constructor */
function $h_Lfs2_Stream$ToPull$() {
  /*<skip>*/
}
$h_Lfs2_Stream$ToPull$.prototype = $c_Lfs2_Stream$ToPull$.prototype;
$c_Lfs2_Stream$ToPull$.prototype.equals$extension__Lfs2_Stream__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lfs2_Stream$ToPull)) {
    var x$0$2 = ((x$0 === null) ? null : $as_Lfs2_Stream$ToPull(x$0).Lfs2_Stream$ToPull__f_self);
    return (this$ === x$0$2)
  } else {
    return false
  }
});
var $d_Lfs2_Stream$ToPull$ = new $TypeData().initClass({
  Lfs2_Stream$ToPull$: 0
}, false, "fs2.Stream$ToPull$", {
  Lfs2_Stream$ToPull$: 1,
  O: 1
});
$c_Lfs2_Stream$ToPull$.prototype.$classData = $d_Lfs2_Stream$ToPull$;
var $n_Lfs2_Stream$ToPull$;
function $m_Lfs2_Stream$ToPull$() {
  if ((!$n_Lfs2_Stream$ToPull$)) {
    $n_Lfs2_Stream$ToPull$ = new $c_Lfs2_Stream$ToPull$()
  };
  return $n_Lfs2_Stream$ToPull$
}
function $is_Lfs2_concurrent_Channel(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_concurrent_Channel)))
}
function $as_Lfs2_concurrent_Channel(obj) {
  return (($is_Lfs2_concurrent_Channel(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.concurrent.Channel"))
}
function $isArrayOf_Lfs2_concurrent_Channel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_concurrent_Channel)))
}
function $asArrayOf_Lfs2_concurrent_Channel(obj, depth) {
  return (($isArrayOf_Lfs2_concurrent_Channel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.concurrent.Channel;", depth))
}
function $p_Lfs2_concurrent_Channel$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_Channel$State$3$($thiz, State$lzy1$1) {
  if ((State$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lfs2_concurrent_Channel$State$3$((State$lzy1$1.sr_LazyRef__f__initialized ? State$lzy1$1.sr_LazyRef__f__value : State$lzy1$1.initialize__O__O(new $c_Lfs2_concurrent_Channel$State$3$())))
}
/** @constructor */
function $c_Lfs2_concurrent_Channel$() {
  this.Lfs2_concurrent_Channel$__f__closed = null;
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit = null;
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightTrue = null;
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightFalse = null;
  $n_Lfs2_concurrent_Channel$ = this;
  $m_s_package$();
  var value = $m_Lfs2_concurrent_Channel$Closed$();
  this.Lfs2_concurrent_Channel$__f__closed = new $c_s_util_Left(value);
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit = ($m_s_package$(), new $c_s_util_Right((void 0)));
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightTrue = ($m_s_package$(), new $c_s_util_Right(true));
  this.Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightFalse = ($m_s_package$(), new $c_s_util_Right(false))
}
$c_Lfs2_concurrent_Channel$.prototype = new $h_O();
$c_Lfs2_concurrent_Channel$.prototype.constructor = $c_Lfs2_concurrent_Channel$;
/** @constructor */
function $h_Lfs2_concurrent_Channel$() {
  /*<skip>*/
}
$h_Lfs2_concurrent_Channel$.prototype = $c_Lfs2_concurrent_Channel$.prototype;
$c_Lfs2_concurrent_Channel$.prototype.bounded__I__Lcats_effect_kernel_GenConcurrent__O = (function(capacity, F) {
  var State$lzy1 = new $c_sr_LazyRef();
  this.fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(State$lzy1);
  $m_s_package$();
  var values = $m_sci_Nil$();
  var waiting = $m_s_None$();
  $m_s_package$();
  var producers = $m_sci_Nil$();
  var open = new $c_Lfs2_concurrent_Channel$State$1(values, 0, waiting, producers, false);
  var _1 = F.ref__O__O(open);
  var _2 = F.deferred__O();
  var t2 = new $c_T2(_1, _2);
  var $$x1 = new $c_Lcats_syntax_Tuple2SemigroupalOps(t2);
  var State$lzy1$2$1 = State$lzy1;
  return $$x1.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O(new $c_sjsr_AnonFunction2(((capacity$2, F$2, open$2, State$lzy1$2) => ((state, closedGate) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    var closedGate$1 = $as_Lcats_effect_kernel_Deferred(closedGate);
    return new $c_Lfs2_concurrent_Channel$$anon$1(capacity$2, F$2, open$2, state$1, closedGate$1, State$lzy1$2)
  }))(capacity, F, open, State$lzy1$2$1)), F, F)
});
$c_Lfs2_concurrent_Channel$.prototype.fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$ = (function(State$lzy1$2) {
  return $as_Lfs2_concurrent_Channel$State$3$((State$lzy1$2.sr_LazyRef__f__initialized ? State$lzy1$2.sr_LazyRef__f__value : $p_Lfs2_concurrent_Channel$__State$lzyINIT1$1__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this, State$lzy1$2)))
});
$c_Lfs2_concurrent_Channel$.prototype.fs2$concurrent$Channel$$$_$empty$1__Lfs2_concurrent_Channel$State$1__sr_LazyRef__Z__Lfs2_concurrent_Channel$State$1 = (function(open$1, State$lzy1$3, isClosed) {
  if (isClosed) {
    this.fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(State$lzy1$3);
    $m_s_package$();
    var values = $m_sci_Nil$();
    var waiting = $m_s_None$();
    $m_s_package$();
    var producers = $m_sci_Nil$();
    return new $c_Lfs2_concurrent_Channel$State$1(values, 0, waiting, producers, true)
  } else {
    return open$1
  }
});
var $d_Lfs2_concurrent_Channel$ = new $TypeData().initClass({
  Lfs2_concurrent_Channel$: 0
}, false, "fs2.concurrent.Channel$", {
  Lfs2_concurrent_Channel$: 1,
  O: 1
});
$c_Lfs2_concurrent_Channel$.prototype.$classData = $d_Lfs2_concurrent_Channel$;
var $n_Lfs2_concurrent_Channel$;
function $m_Lfs2_concurrent_Channel$() {
  if ((!$n_Lfs2_concurrent_Channel$)) {
    $n_Lfs2_concurrent_Channel$ = new $c_Lfs2_concurrent_Channel$()
  };
  return $n_Lfs2_concurrent_Channel$
}
/** @constructor */
function $c_Lfs2_concurrent_Channel$Closed$() {
  /*<skip>*/
}
$c_Lfs2_concurrent_Channel$Closed$.prototype = new $h_O();
$c_Lfs2_concurrent_Channel$Closed$.prototype.constructor = $c_Lfs2_concurrent_Channel$Closed$;
/** @constructor */
function $h_Lfs2_concurrent_Channel$Closed$() {
  /*<skip>*/
}
$h_Lfs2_concurrent_Channel$Closed$.prototype = $c_Lfs2_concurrent_Channel$Closed$.prototype;
var $d_Lfs2_concurrent_Channel$Closed$ = new $TypeData().initClass({
  Lfs2_concurrent_Channel$Closed$: 0
}, false, "fs2.concurrent.Channel$Closed$", {
  Lfs2_concurrent_Channel$Closed$: 1,
  O: 1
});
$c_Lfs2_concurrent_Channel$Closed$.prototype.$classData = $d_Lfs2_concurrent_Channel$Closed$;
var $n_Lfs2_concurrent_Channel$Closed$;
function $m_Lfs2_concurrent_Channel$Closed$() {
  if ((!$n_Lfs2_concurrent_Channel$Closed$)) {
    $n_Lfs2_concurrent_Channel$Closed$ = new $c_Lfs2_concurrent_Channel$Closed$()
  };
  return $n_Lfs2_concurrent_Channel$Closed$
}
/** @constructor */
function $c_Lfs2_internal_InterruptContext$() {
  /*<skip>*/
}
$c_Lfs2_internal_InterruptContext$.prototype = new $h_O();
$c_Lfs2_internal_InterruptContext$.prototype.constructor = $c_Lfs2_internal_InterruptContext$;
/** @constructor */
function $h_Lfs2_internal_InterruptContext$() {
  /*<skip>*/
}
$h_Lfs2_internal_InterruptContext$.prototype = $c_Lfs2_internal_InterruptContext$.prototype;
$c_Lfs2_internal_InterruptContext$.prototype.toString__T = (function() {
  return "InterruptContext"
});
$c_Lfs2_internal_InterruptContext$.prototype.apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O = (function(newScopeId, cancelParent, F) {
  var target = F.ref__O__O($m_s_None$());
  var this$7 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1(((newScopeId$2, cancelParent$2, F$2) => ((ref) => {
    var ref$1 = $as_Lcats_effect_kernel_Ref(ref);
    var target$1 = F$2.deferred__O();
    var this$6 = new $c_Lcats_Functor$$anon$4(target$1, F$2);
    var f = new $c_sjsr_AnonFunction1(((newScopeId$2$2, cancelParent$2$2, F$1$2, ref$2) => ((deferred) => {
      var deferred$1 = $as_Lcats_effect_kernel_Deferred(deferred);
      return new $c_Lfs2_internal_InterruptContext(deferred$1, ref$2, newScopeId$2$2, cancelParent$2$2, F$1$2)
    }))(newScopeId$2, cancelParent$2, F$2, ref$1));
    return this$6.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$6.Lcats_Functor$$anon$4__f_self, f)
  }))(newScopeId, cancelParent, F));
  return this$7.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$7.Lcats_FlatMap$$anon$2__f_self, f$1)
});
var $d_Lfs2_internal_InterruptContext$ = new $TypeData().initClass({
  Lfs2_internal_InterruptContext$: 0
}, false, "fs2.internal.InterruptContext$", {
  Lfs2_internal_InterruptContext$: 1,
  O: 1
});
$c_Lfs2_internal_InterruptContext$.prototype.$classData = $d_Lfs2_internal_InterruptContext$;
var $n_Lfs2_internal_InterruptContext$;
function $m_Lfs2_internal_InterruptContext$() {
  if ((!$n_Lfs2_internal_InterruptContext$)) {
    $n_Lfs2_internal_InterruptContext$ = new $c_Lfs2_internal_InterruptContext$()
  };
  return $n_Lfs2_internal_InterruptContext$
}
function $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O($thiz, resource) {
  return $thiz.Lfs2_internal_Scope__f_state.modify__F1__O(new $c_sjsr_AnonFunction1(((resource$2) => ((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      var this$1 = s.Lfs2_internal_Scope$State$Open__f_resources;
      var resources = this$1.prepend__O__Lcats_data_Chain(resource$2);
      var children = s.Lfs2_internal_Scope$State$Open__f_children;
      var _1 = new $c_Lfs2_internal_Scope$State$Open(resources, children);
      return new $c_T2(_1, true)
    };
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var s$2 = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
      return new $c_T2(s$2, false)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(resource)))
}
function $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O($thiz, id) {
  return $thiz.Lfs2_internal_Scope__f_state.update__F1__O(new $c_sjsr_AnonFunction1(((id$2) => ((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      return s.unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State(id$2)
    };
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var s$2 = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
      return s$2
    };
    throw new $c_s_MatchError(x$1$1)
  }))(id)))
}
function $p_Lfs2_internal_Scope__openScope__O($thiz) {
  var target = $thiz.Lfs2_internal_Scope__f_state.get__O();
  var tc = $thiz.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var this$3 = this$2.Lfs2_internal_Scope__f_F;
      return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(this$2)
    };
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      return this$2.openAncestor__O()
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz));
  return this$4.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$$anon$2__f_self, f)
}
function $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($thiz, scopeId) {
  var x = $thiz.Lfs2_internal_Scope__f_id;
  if ((x === scopeId)) {
    var this$2 = $thiz.Lfs2_internal_Scope__f_F;
    var a = new $c_s_Some($thiz);
    return this$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
  } else {
    var target = $thiz.Lfs2_internal_Scope__f_state.get__O();
    var tc = $thiz.Lfs2_internal_Scope__f_F;
    var this$6 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1(((this$4, scopeId$2) => ((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
        return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O(this$4, scopeId$2, s.Lfs2_internal_Scope$State$Open__f_children)
      };
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var this$5 = this$4.Lfs2_internal_Scope__f_F;
        var a$1 = $m_s_None$();
        return this$5.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1)
      };
      throw new $c_s_MatchError(x$1$1)
    }))($thiz, scopeId));
    return this$6.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$$anon$2__f_self, f)
  }
}
function $ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(scope, acc) {
  var acc$tailLocal1 = acc;
  var scope$tailLocal1 = scope;
  while (true) {
    var x1 = scope$tailLocal1.Lfs2_internal_Scope__f_parent;
    var x = $m_s_None$();
    if ((x === x1)) {
      return acc$tailLocal1
    };
    if ((x1 instanceof $c_s_Some)) {
      var s = $as_Lfs2_internal_Scope($as_s_Some(x1).s_Some__f_value);
      var acc$tailLocal1$tmp1 = ((1 + acc$tailLocal1) | 0);
      scope$tailLocal1 = s;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      continue
    };
    throw new $c_s_MatchError(x1)
  }
}
function $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId$1, curr) {
  var curr$tailLocal2 = curr;
  while (true) {
    var x = curr$tailLocal2.Lfs2_internal_Scope__f_id;
    if ((x === scopeId$1)) {
      var value = curr$tailLocal2;
      return new $c_s_Some(value)
    } else {
      var x68 = curr$tailLocal2.Lfs2_internal_Scope__f_parent;
      if ((x68 instanceof $c_s_Some)) {
        var scope = $as_Lfs2_internal_Scope($as_s_Some(x68).s_Some__f_value);
        curr$tailLocal2 = scope;
        continue
      };
      var x$3 = $m_s_None$();
      if ((x$3 === x68)) {
        return $m_s_None$()
      };
      throw new $c_s_MatchError(x68)
    }
  }
}
function $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O($thiz, scopeId$3, scopes) {
  var x77 = scopes.uncons__s_Option();
  var x = $m_s_None$();
  if ((x === x77)) {
    var this$1 = $thiz.Lfs2_internal_Scope__f_F;
    var a = $m_s_None$();
    return this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
  };
  if ((x77 instanceof $c_s_Some)) {
    var x79 = $as_T2($as_s_Some(x77).s_Some__f_value);
    if ((x79 !== null)) {
      var scope = $as_Lfs2_internal_Scope(x79._1__O());
      var tail = $as_Lcats_data_Chain(x79._2__O());
      var x$3 = scope.Lfs2_internal_Scope__f_id;
      if ((x$3 === scopeId$3)) {
        var this$3 = $thiz.Lfs2_internal_Scope__f_F;
        var a$1 = new $c_s_Some(scope);
        return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1)
      } else {
        var target = scope.Lfs2_internal_Scope__f_state.get__O();
        var tc = $thiz.Lfs2_internal_Scope__f_F;
        var this$11 = new $c_Lcats_FlatMap$$anon$2(target, tc);
        var f$1 = new $c_sjsr_AnonFunction1(((this$5, scopeId$3$2, tail$2) => ((x$1) => {
          var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
          if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
            var s = $as_Lfs2_internal_Scope$State$Open(x$1$1);
            if (s.Lfs2_internal_Scope$State$Open__f_children.isEmpty__Z()) {
              return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O(this$5, scopeId$3$2, tail$2)
            } else {
              var target$1 = $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O(this$5, scopeId$3$2, s.Lfs2_internal_Scope$State$Open__f_children);
              var tc$1 = this$5.Lfs2_internal_Scope__f_F;
              var this$10 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
              var f = new $c_sjsr_AnonFunction1(((this$7, scopeId$4$2, tail$1$2) => ((x$1$2) => {
                var x$1$3 = $as_s_Option(x$1$2);
                var x$2 = $m_s_None$();
                if ((x$2 === x$1$3)) {
                  return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O(this$7, scopeId$4$2, tail$1$2)
                };
                if ((x$1$3 instanceof $c_s_Some)) {
                  var scope$1 = $as_Lfs2_internal_Scope($as_s_Some(x$1$3).s_Some__f_value);
                  var this$9 = this$7.Lfs2_internal_Scope__f_F;
                  var a$2 = new $c_s_Some(scope$1);
                  return this$9.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$2)
                };
                throw new $c_s_MatchError(x$1$3)
              }))(this$5, scopeId$3$2, tail$2));
              return this$10.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$$anon$2__f_self, f)
            }
          };
          if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
            return $p_Lfs2_internal_Scope__go$4__Lcats_effect_kernel_Unique$Token__Lcats_data_Chain__O(this$5, scopeId$3$2, tail$2)
          };
          throw new $c_s_MatchError(x$1$1)
        }))($thiz, scopeId$3, tail));
        return this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f$1)
      }
    }
  };
  throw new $c_s_MatchError(x77)
}
function $ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(scope) {
  var scope$tailLocal2 = scope;
  while (true) {
    var x88 = scope$tailLocal2.Lfs2_internal_Scope__f_parent;
    var x = $m_s_None$();
    if ((x === x88)) {
      return scope$tailLocal2
    };
    if ((x88 instanceof $c_s_Some)) {
      var parent = $as_Lfs2_internal_Scope($as_s_Some(x88).s_Some__f_value);
      scope$tailLocal2 = parent;
      continue
    };
    throw new $c_s_MatchError(x88)
  }
}
/** @constructor */
function $c_Lfs2_internal_Scope(id, parent, interruptible, state, F) {
  this.Lfs2_internal_Scope__f_id = null;
  this.Lfs2_internal_Scope__f_parent = null;
  this.Lfs2_internal_Scope__f_interruptible = null;
  this.Lfs2_internal_Scope__f_state = null;
  this.Lfs2_internal_Scope__f_F = null;
  this.Lfs2_internal_Scope__f_id = id;
  this.Lfs2_internal_Scope__f_parent = parent;
  this.Lfs2_internal_Scope__f_interruptible = interruptible;
  this.Lfs2_internal_Scope__f_state = state;
  this.Lfs2_internal_Scope__f_F = F
}
$c_Lfs2_internal_Scope.prototype = new $h_O();
$c_Lfs2_internal_Scope.prototype.constructor = $c_Lfs2_internal_Scope;
/** @constructor */
function $h_Lfs2_internal_Scope() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope.prototype = $c_Lfs2_internal_Scope.prototype;
$c_Lfs2_internal_Scope.prototype.open__Z__O = (function(interruptible) {
  var target = this.Lfs2_internal_Scope__f_F.unique__O();
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$16 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$2 = new $c_sjsr_AnonFunction1(((this$2, interruptible$2) => ((newScopeId) => {
    var newScopeId$1 = $as_Lcats_effect_kernel_Unique$Token(newScopeId);
    var x7 = this$2.Lfs2_internal_Scope__f_interruptible;
    var x = $m_s_None$();
    if ((x === x7)) {
      var optFCtx = (interruptible$2 ? this$2.Lfs2_internal_Scope__f_F.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option(newScopeId$1) : $m_s_None$());
      $m_Lcats_UnorderedFoldable$();
      var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
      var this$6 = new $c_Lcats_Traverse$$anon$3(optFCtx, tc$1);
      $m_s_$less$colon$less$();
      var ev$2 = this$2.Lfs2_internal_Scope__f_F;
      var this$7 = this$6.Lcats_Traverse$$anon$3__f_typeClassInstance;
      var fga = this$6.Lcats_Traverse$$anon$3__f_self;
      var target$1 = $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O(this$7, fga, ev$2);
      var tc$2 = this$2.Lfs2_internal_Scope__f_F;
      var this$11 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$2);
      var f = new $c_sjsr_AnonFunction1(((this$9, newScopeId$2) => ((iCtx) => {
        var iCtx$1 = $as_s_Option(iCtx);
        return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$2, new $c_s_Some(this$9), iCtx$1, this$9.Lfs2_internal_Scope__f_F)
      }))(this$2, newScopeId$1));
      return this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f)
    };
    if ((x7 instanceof $c_s_Some)) {
      var parentICtx = $as_Lfs2_internal_InterruptContext($as_s_Some(x7).s_Some__f_value);
      var target$2 = parentICtx.childContext__Z__Lcats_effect_kernel_Unique$Token__O(interruptible$2, newScopeId$1);
      var tc$3 = this$2.Lfs2_internal_Scope__f_F;
      var this$15 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$3);
      var f$1 = new $c_sjsr_AnonFunction1(((this$2$1, newScopeId$3) => ((iCtx$2) => {
        var iCtx$3 = $as_Lfs2_internal_InterruptContext(iCtx$2);
        return $m_Lfs2_internal_Scope$().fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(newScopeId$3, new $c_s_Some(this$2$1), new $c_s_Some(iCtx$3), this$2$1.Lfs2_internal_Scope__f_F)
      }))(this$2, newScopeId$1));
      return this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, f$1)
    };
    throw new $c_s_MatchError(x7)
  }))(this, interruptible));
  var createScope = this$16.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$16.Lcats_FlatMap$$anon$2__f_self, f$2);
  var tc$4 = this.Lfs2_internal_Scope__f_F;
  var this$33 = new $c_Lcats_FlatMap$$anon$2(createScope, tc$4);
  var f$4 = new $c_sjsr_AnonFunction1(((this$2$2, interruptible$3) => ((scope) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var target$3 = this$2$2.Lfs2_internal_Scope__f_state.modify__F1__O(new $c_sjsr_AnonFunction1(((scope$2) => ((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        var s = $as_Lfs2_internal_Scope$State$Closed(x$1$1);
        var _2 = $m_s_None$();
        return new $c_T2(s, _2)
      };
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var s$2 = $as_Lfs2_internal_Scope$State$Open(x$1$1);
        var this$19 = s$2.Lfs2_internal_Scope$State$Open__f_children;
        var children$1 = this$19.prepend__O__Lcats_data_Chain(scope$2);
        var resources$1 = s$2.Lfs2_internal_Scope$State$Open__f_resources;
        var _1 = new $c_Lfs2_internal_Scope$State$Open(resources$1, children$1);
        var _2$1 = new $c_s_Some(scope$2);
        return new $c_T2(_1, _2$1)
      };
      throw new $c_s_MatchError(x$1$1)
    }))(scope$1)));
    var tc$5 = this$2$2.Lfs2_internal_Scope__f_F;
    var this$32 = new $c_Lcats_FlatMap$$anon$2(target$3, tc$5);
    var f$3 = new $c_sjsr_AnonFunction1(((this$23, interruptible$3$2) => ((x$1$2) => {
      var x$1$3 = $as_s_Option(x$1$2);
      if ((x$1$3 instanceof $c_s_Some)) {
        var s$1 = $as_Lfs2_internal_Scope($as_s_Some(x$1$3).s_Some__f_value);
        var this$25 = this$23.Lfs2_internal_Scope__f_F;
        $m_s_package$();
        var a = new $c_s_util_Right(s$1);
        return this$25.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
      };
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$3)) {
        var x13 = this$23.Lfs2_internal_Scope__f_parent;
        if ((x13 instanceof $c_s_Some)) {
          var parent = $as_Lfs2_internal_Scope($as_s_Some(x13).s_Some__f_value);
          var this$26 = this$23.Lfs2_internal_Scope__f_interruptible;
          if (this$26.isEmpty__Z()) {
            var this$27 = $m_s_None$()
          } else {
            var arg1 = this$26.get__O();
            var _$2 = $as_Lfs2_internal_InterruptContext(arg1);
            var this$27 = new $c_s_Some(_$2.Lfs2_internal_InterruptContext__f_cancelParent)
          };
          if (this$27.isEmpty__Z()) {
            var this$28 = this$23.Lfs2_internal_Scope__f_F;
            var fa = this$28.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0))
          } else {
            var fa = this$27.get__O()
          };
          return $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((interruptible$4$2, parent$2) => (() => parent$2.open__Z__O(interruptible$4$2)))(interruptible$3$2, parent)), this$23.Lfs2_internal_Scope__f_F)
        };
        var x$3 = $m_s_None$();
        if ((x$3 === x13)) {
          var this$31 = this$23.Lfs2_internal_Scope__f_F;
          $m_s_package$();
          var value = $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "cannot re-open root scope");
          var a$1 = new $c_s_util_Left(value);
          return this$31.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1)
        };
        throw new $c_s_MatchError(x13)
      };
      throw new $c_s_MatchError(x$1$3)
    }))(this$2$2, interruptible$3));
    return this$32.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$32.Lcats_FlatMap$$anon$2__f_self, f$3)
  }))(this, interruptible));
  return this$33.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$33.Lcats_FlatMap$$anon$2__f_self, f$4)
});
$c_Lfs2_internal_Scope.prototype.acquireResource__F1__F2__O = (function(acquire, release) {
  var target = $m_Lfs2_internal_ScopedResource$().create__Lfs2_Compiler$Target__O(this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$26 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$3 = new $c_sjsr_AnonFunction1(((this$2, acquire$2, release$2) => ((resource) => {
    var resource$1 = $as_Lfs2_internal_ScopedResource(resource);
    var this$25 = this$2.Lfs2_internal_Scope__f_F;
    var f$2 = new $c_sjsr_AnonFunction1(((this$3, acquire$1$2, release$1$2, resource$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var fa = acquire$1$2.apply__O__O(poll$1);
      var recover = new $c_sjsr_AnonFunction1(((this$5) => ((t) => {
        var t$1 = $as_jl_Throwable(t);
        var this$7 = this$5.Lfs2_internal_Scope__f_F;
        $m_s_package$();
        var a = new $c_s_util_Left(t$1);
        return this$7.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
      }))(this$3));
      var bind = new $c_sjsr_AnonFunction1(((this$2$1, release$2$2, resource$2$2) => ((r) => {
        var finalizer = new $c_sjsr_AnonFunction1(((release$3$2, r$2) => ((ec) => {
          var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
          return release$3$2.apply__O__O__O(r$2, ec$1)
        }))(release$2$2, r));
        var target$1 = resource$2$2.acquired__F1__O(finalizer);
        var tc$1 = this$2$1.Lfs2_internal_Scope__f_F;
        var this$23 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
        var f$1 = new $c_sjsr_AnonFunction1(((this$9, resource$3$2, r$3, finalizer$2) => ((result) => {
          var result$1 = $as_s_util_Either(result);
          if ((result$1 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(result$1);
            var b = x2.s_util_Right__f_value;
            var x = $uZ(b);
            var $$x1 = x
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            var target$2 = $p_Lfs2_internal_Scope__register__Lfs2_internal_ScopedResource__O(this$9, resource$3$2);
            var tc$2 = this$9.Lfs2_internal_Scope__f_F;
            var this$18 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$2);
            var f = new $c_sjsr_AnonFunction1(((this$12, r$2$2, finalizer$1$2) => ((x$1) => {
              var x$1$1 = $uZ(x$1);
              if ((x$1$1 === false)) {
                var target$3 = finalizer$1$2.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
                var tc$3 = this$12.Lfs2_internal_Scope__f_F;
                var this$15 = new $c_Lcats_Functor$$anon$4(target$3, tc$3);
                $m_s_package$();
                var value = $m_Lfs2_internal_AcquireAfterScopeClosed$();
                var b$1 = new $c_s_util_Left(value);
                return this$15.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$15.Lcats_Functor$$anon$4__f_self, b$1)
              };
              if ((x$1$1 === true)) {
                var this$17 = this$12.Lfs2_internal_Scope__f_F;
                $m_s_package$();
                var a$1 = new $c_s_util_Right(r$2$2);
                return this$17.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1)
              };
              throw new $c_s_MatchError(x$1$1)
            }))(this$9, r$3, finalizer$2));
            return this$18.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$18.Lcats_FlatMap$$anon$2__f_self, f)
          } else {
            var target$4 = finalizer$2.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Canceled$());
            var tc$4 = this$9.Lfs2_internal_Scope__f_F;
            var this$22 = new $c_Lcats_Functor$$anon$4(target$4, tc$4);
            $m_s_package$();
            var this$20 = result$1.swap__s_util_Either();
            if ((this$20 instanceof $c_s_util_Right)) {
              var x2$1 = $as_s_util_Right(this$20);
              var b$2 = x2$1.s_util_Right__f_value;
              var value$1 = b$2
            } else {
              var value$1 = $m_Lfs2_internal_AcquireAfterScopeClosed$()
            };
            var b$3 = new $c_s_util_Left(value$1);
            return this$22.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$22.Lcats_Functor$$anon$4__f_self, b$3)
          }
        }))(this$2$1, resource$2$2, r, finalizer));
        return this$23.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$23.Lcats_FlatMap$$anon$2__f_self, f$1)
      }))(this$3, release$1$2, resource$2));
      var F$1 = this$3.Lfs2_internal_Scope__f_F;
      return $f_Lcats_MonadError__redeemWith__O__F1__F1__O(F$1, fa, recover, bind)
    }))(this$2, acquire$2, release$2, resource$1));
    return this$25.F__Lcats_effect_kernel_MonadCancel().uncancelable__F1__O(f$2)
  }))(this, acquire, release));
  var target$5 = this.interruptibleEval__O__O(this$26.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$26.Lcats_FlatMap$$anon$2__f_self, f$3));
  var tc$5 = this.Lfs2_internal_Scope__f_F;
  var this$37 = new $c_Lcats_Functor$$anon$4(target$5, tc$5);
  var f$4 = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1$3 = $as_s_util_Either(x$1$2);
    if ((x$1$3 instanceof $c_s_util_Left)) {
      var x38 = $as_Lcats_effect_kernel_Outcome($as_s_util_Left(x$1$3).s_util_Left__f_value);
      if ((x38 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$4 = $as_Lcats_effect_kernel_Outcome$Errored(x38);
        var x41 = $as_jl_Throwable(x$1$4.Lcats_effect_kernel_Outcome$Errored__f_e);
        return new $c_Lcats_effect_kernel_Outcome$Errored(x41)
      };
      if (((x38 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x38), true))) {
        return new $c_Lcats_effect_kernel_Outcome$Canceled()
      };
      if ((x38 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(x38);
        var x33 = $as_Lcats_effect_kernel_Unique$Token(x$1$5.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        $m_s_package$();
        var fa$1 = new $c_s_util_Left(x33);
        return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1)
      }
    };
    if ((x$1$3 instanceof $c_s_util_Right)) {
      var x26 = $as_s_util_Either($as_s_util_Right(x$1$3).s_util_Right__f_value);
      if ((x26 instanceof $c_s_util_Left)) {
        var t$2 = $as_jl_Throwable($as_s_util_Left(x26).s_util_Left__f_value);
        return new $c_Lcats_effect_kernel_Outcome$Errored(t$2)
      };
      if ((x26 instanceof $c_s_util_Right)) {
        var r$1 = $as_s_util_Right(x26).s_util_Right__f_value;
        $m_s_package$();
        var fa$2 = new $c_s_util_Right(r$1);
        return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$2)
      }
    };
    throw new $c_s_MatchError(x$1$3)
  }));
  return this$37.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$37.Lcats_Functor$$anon$4__f_self, f$4)
});
$c_Lfs2_internal_Scope.prototype.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O = (function(ca, f) {
  var instance = $as_Lcats_Traverse($m_Lcats_data_Chain$().Lcats_data_ChainInstances__f_catsDataInstancesForChain);
  var target = instance.traverse__O__F1__Lcats_Applicative__O(ca, f, this.Lfs2_internal_Scope__f_F);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$6 = new $c_Lcats_Functor$$anon$4(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((results) => {
    var results$1 = $as_Lcats_data_Chain(results);
    var this$3 = $m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option(results$1.collect__s_PartialFunction__Lcats_data_Chain(new $c_Lfs2_internal_Scope$$anon$1()).toList__sci_List());
    if (this$3.isEmpty__Z()) {
      $m_s_package$();
      return new $c_s_util_Right((void 0))
    } else {
      $m_s_package$();
      var value = this$3.get__O();
      return new $c_s_util_Left(value)
    }
  }));
  return this$6.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$6.Lcats_Functor$$anon$4__f_self, f$1)
});
$c_Lfs2_internal_Scope.prototype.close__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  var target = this.Lfs2_internal_Scope__f_state.modify__F1__O(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_Lfs2_internal_Scope$State(s);
    var this$1 = $m_Lfs2_internal_Scope$State$();
    var self = this$1.Lfs2_internal_Scope$State$__f_closed_;
    return new $c_T2(self, s$1)
  })));
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$29 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$4 = new $c_sjsr_AnonFunction1(((this$5, ec$2) => ((x$1) => {
    var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
      var previous = $as_Lfs2_internal_Scope$State$Open(x$1$1);
      var target$1 = this$5.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O(previous.Lfs2_internal_Scope$State$Open__f_children, new $c_sjsr_AnonFunction1(((ec$1$2) => ((_$3) => {
        var _$3$1 = $as_Lfs2_internal_Scope(_$3);
        return _$3$1.close__Lcats_effect_kernel_Resource$ExitCase__O(ec$1$2)
      }))(ec$2)));
      var tc$1 = this$5.Lfs2_internal_Scope__f_F;
      var this$26 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
      var f$3 = new $c_sjsr_AnonFunction1(((this$7, ec$1$3, previous$2) => ((resultChildren) => {
        var resultChildren$1 = $as_s_util_Either(resultChildren);
        var target$2 = this$7.fs2$internal$Scope$$traverseError__Lcats_data_Chain__F1__O(previous$2.Lfs2_internal_Scope$State$Open__f_resources, new $c_sjsr_AnonFunction1(((ec$3$2) => ((_$4) => {
          var _$4$1 = $as_Lfs2_internal_ScopedResource(_$4);
          return _$4$1.release__Lcats_effect_kernel_Resource$ExitCase__O(ec$3$2)
        }))(ec$1$3)));
        var tc$2 = this$7.Lfs2_internal_Scope__f_F;
        var this$25 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$2);
        var f$2 = new $c_sjsr_AnonFunction1(((this$9, resultChildren$2) => ((resultResources) => {
          var resultResources$1 = $as_s_util_Either(resultResources);
          var this$10 = this$9.Lfs2_internal_Scope__f_interruptible;
          if (this$10.isEmpty__Z()) {
            var this$11 = $m_s_None$()
          } else {
            var arg1 = this$10.get__O();
            var _$5 = $as_Lfs2_internal_InterruptContext(arg1);
            var this$11 = new $c_s_Some(_$5.Lfs2_internal_InterruptContext__f_cancelParent)
          };
          if (this$11.isEmpty__Z()) {
            var this$12 = this$9.Lfs2_internal_Scope__f_F;
            var target$3 = this$12.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0))
          } else {
            var target$3 = this$11.get__O()
          };
          var tc$3 = this$9.Lfs2_internal_Scope__f_F;
          var this$24 = new $c_Lcats_FlatMap$$anon$2(target$3, tc$3);
          var f$1 = new $c_sjsr_AnonFunction1(((this$2$1, resultChildren$1$2, resultResources$2) => ((x$1$2) => {
            $as_jl_Void(x$1$2);
            var this$14 = this$2$1.Lfs2_internal_Scope__f_parent;
            if (this$14.isEmpty__Z()) {
              var this$15 = this$2$1.Lfs2_internal_Scope__f_F;
              var target$4 = this$15.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0))
            } else {
              var arg1$1 = this$14.get__O();
              var _$6 = $as_Lfs2_internal_Scope(arg1$1);
              var target$4 = $p_Lfs2_internal_Scope__releaseChildScope__Lcats_effect_kernel_Unique$Token__O(_$6, this$2$1.Lfs2_internal_Scope__f_id)
            };
            var tc$4 = this$2$1.Lfs2_internal_Scope__f_F;
            var this$23 = new $c_Lcats_Functor$$anon$4(target$4, tc$4);
            var f = new $c_sjsr_AnonFunction1(((resultChildren$2$2, resultResources$1$2) => ((x$1$2$1) => {
              $as_jl_Void(x$1$2$1);
              if ((resultChildren$2$2 instanceof $c_s_util_Right)) {
                var x2 = $as_s_util_Right(resultChildren$2$2);
                var b = x2.s_util_Right__f_value;
                $as_jl_Void(b);
                var $$x1 = $m_s_package$().s_package$__f_Nil
              } else {
                if ((!(resultChildren$2$2 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(resultChildren$2$2)
                };
                var x3 = $as_s_util_Left(resultChildren$2$2);
                var a = x3.s_util_Left__f_value;
                var _$7 = $as_jl_Throwable(a);
                $m_s_package$();
                var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_jl_Throwable.getArrayOf().constr)([_$7]));
                var $$x1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
              };
              var this$19 = $as_sc_IterableOps($$x1);
              if ((resultResources$1$2 instanceof $c_s_util_Right)) {
                var x2$1 = $as_s_util_Right(resultResources$1$2);
                var b$1 = x2$1.s_util_Right__f_value;
                $as_jl_Void(b$1);
                var $$x2 = $m_s_package$().s_package$__f_Nil
              } else {
                if ((!(resultResources$1$2 instanceof $c_s_util_Left))) {
                  throw new $c_s_MatchError(resultResources$1$2)
                };
                var x3$1 = $as_s_util_Left(resultResources$1$2);
                var a$1 = x3$1.s_util_Left__f_value;
                var _$9 = $as_jl_Throwable(a$1);
                $m_s_package$();
                var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_jl_Throwable.getArrayOf().constr)([_$9]));
                var $$x2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1)
              };
              var suffix = $as_sc_IterableOnce($$x2);
              var results = $as_sci_List(this$19.concat__sc_IterableOnce__O(suffix));
              var this$20 = $m_Lfs2_CompositeFailure$().fromList__sci_List__s_Option(results);
              if (this$20.isEmpty__Z()) {
                $m_s_package$();
                return new $c_s_util_Right((void 0))
              } else {
                $m_s_package$();
                var value = this$20.get__O();
                return new $c_s_util_Left(value)
              }
            }))(resultChildren$1$2, resultResources$2));
            return this$23.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$23.Lcats_Functor$$anon$4__f_self, f)
          }))(this$9, resultChildren$2, resultResources$1));
          return this$24.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$24.Lcats_FlatMap$$anon$2__f_self, f$1)
        }))(this$7, resultChildren$1));
        return this$25.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$25.Lcats_FlatMap$$anon$2__f_self, f$2)
      }))(this$5, ec$2, previous));
      return this$26.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$26.Lcats_FlatMap$$anon$2__f_self, f$3)
    };
    if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
      var this$28 = this$5.Lfs2_internal_Scope__f_F;
      $m_s_package$();
      var a$2 = new $c_s_util_Right((void 0));
      return this$28.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$2)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, ec));
  return this$29.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$29.Lcats_FlatMap$$anon$2__f_self, f$4)
});
$c_Lfs2_internal_Scope.prototype.openAncestor__O = (function() {
  var this$1 = this.Lfs2_internal_Scope__f_parent;
  if (this$1.isEmpty__Z()) {
    var this$2 = this.Lfs2_internal_Scope__f_F;
    return this$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(this)
  } else {
    var arg1 = this$1.get__O();
    var parent = $as_Lfs2_internal_Scope(arg1);
    var target = parent.Lfs2_internal_Scope__f_state.get__O();
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$6 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f = new $c_sjsr_AnonFunction1(((this$4, parent$2) => ((x$1) => {
      var x$1$1 = $as_Lfs2_internal_Scope$State(x$1);
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Open)) {
        var this$5 = this$4.Lfs2_internal_Scope__f_F;
        return this$5.F__Lcats_effect_kernel_MonadCancel().pure__O__O(parent$2)
      };
      if ((x$1$1 instanceof $c_Lfs2_internal_Scope$State$Closed)) {
        return parent$2.openAncestor__O()
      };
      throw new $c_s_MatchError(x$1$1)
    }))(this, parent));
    return this$6.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$$anon$2__f_self, f)
  }
});
$c_Lfs2_internal_Scope.prototype.descendsFrom__Lcats_effect_kernel_Unique$Token__Z = (function(scopeId) {
  var this$1 = $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this);
  return (!this$1.isEmpty__Z())
});
$c_Lfs2_internal_Scope.prototype.findInLineage__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var a = $ps_Lfs2_internal_Scope__go$3__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope__s_Option(scopeId, this);
  var F = this.Lfs2_internal_Scope__f_F;
  var fa = F.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
  return $m_Lcats_syntax_ApplicativeErrorOps$().orElse$extension__O__F0__Lcats_ApplicativeError__O(fa, new $c_sjsr_AnonFunction0(((this$4, scopeId$2) => (() => $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this$4, scopeId$2)))(this, scopeId)), this.Lfs2_internal_Scope__f_F)
});
$c_Lfs2_internal_Scope.prototype.shiftScope__Lcats_effect_kernel_Unique$Token__F0__O = (function(scopeId, context) {
  var target = this.findStepScope__Lcats_effect_kernel_Unique$Token__O(scopeId);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$7 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2, context$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var scope = $as_Lfs2_internal_Scope($as_s_Some(x$1$1).s_Some__f_value);
      var this$3 = this$2.Lfs2_internal_Scope__f_F;
      return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(scope)
    };
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var x$2 = ((("|Scope lookup failure!\n              |\n              |This is typically caused by uncons-ing from two or more streams in the same Pull.\n              |To do this safely, use `s.pull.stepLeg` instead of `s.pull.uncons` or a variant\n              |thereof. See the implementation of `Stream#zipWith_` for an example.\n              |\n              |Scope id: " + this$2.Lfs2_internal_Scope__f_id) + "\n              |Step: ") + context$2.apply__O());
      var msg = $m_sc_StringOps$().stripMargin$extension__T__C__T(x$2, 124);
      var this$6 = this$2.Lfs2_internal_Scope__f_F;
      var e = $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), msg);
      return this$6.F__Lcats_effect_kernel_MonadCancel().raiseError__O__O(e)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, context));
  return this$7.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$7.Lcats_FlatMap$$anon$2__f_self, f)
});
$c_Lfs2_internal_Scope.prototype.findStepScope__Lcats_effect_kernel_Unique$Token__O = (function(scopeId) {
  var x$2 = this.Lfs2_internal_Scope__f_id;
  if ((scopeId === x$2)) {
    var this$2 = this.Lfs2_internal_Scope__f_F;
    var a = new $c_s_Some(this);
    return this$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
  } else {
    var x94 = this.Lfs2_internal_Scope__f_parent;
    var x$3 = $m_s_None$();
    if ((x$3 === x94)) {
      return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(this, scopeId)
    };
    if ((x94 instanceof $c_s_Some)) {
      var parent = $as_Lfs2_internal_Scope($as_s_Some(x94).s_Some__f_value);
      var target = $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O(parent, scopeId);
      var tc = this.Lfs2_internal_Scope__f_F;
      var this$7 = new $c_Lcats_FlatMap$$anon$2(target, tc);
      var f = new $c_sjsr_AnonFunction1(((this$4, scopeId$2) => ((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var scope = $as_Lfs2_internal_Scope($as_s_Some(x$1$1).s_Some__f_value);
          var this$6 = this$4.Lfs2_internal_Scope__f_F;
          var a$1 = new $c_s_Some(scope);
          return this$6.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a$1)
        };
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return $p_Lfs2_internal_Scope__findSelfOrChild__Lcats_effect_kernel_Unique$Token__O($ps_Lfs2_internal_Scope__go$5__Lfs2_internal_Scope__Lfs2_internal_Scope(this$4), scopeId$2)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(this, scopeId));
      return this$7.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$7.Lcats_FlatMap$$anon$2__f_self, f)
    };
    throw new $c_s_MatchError(x94)
  }
});
$c_Lfs2_internal_Scope.prototype.interruptWhen__O__O = (function(haltWhen) {
  var x97 = this.Lfs2_internal_Scope__f_interruptible;
  var x = $m_s_None$();
  if ((x === x97)) {
    var this$1 = this.Lfs2_internal_Scope__f_F;
    var a = new $c_Lfs2_internal_Scope$$anon$2(this);
    return this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
  };
  if ((x97 instanceof $c_s_Some)) {
    var iCtx = $as_Lfs2_internal_InterruptContext($as_s_Some(x97).s_Some__f_value);
    var tc = this.Lfs2_internal_Scope__f_F;
    var this$5 = new $c_Lcats_Functor$$anon$4(haltWhen, tc);
    var f = new $c_sjsr_AnonFunction1(((iCtx$2) => ((_$11) => {
      var _$11$1 = $as_s_util_Either(_$11);
      if ((_$11$1 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(_$11$1);
        var b = x2.s_util_Right__f_value;
        $as_jl_Void(b);
        var fa = iCtx$2.Lfs2_internal_InterruptContext__f_interruptRoot;
        var $$x1 = new $c_Lcats_effect_kernel_Outcome$Succeeded(fa)
      } else {
        if ((!(_$11$1 instanceof $c_s_util_Left))) {
          throw new $c_s_MatchError(_$11$1)
        };
        var x3 = $as_s_util_Left(_$11$1);
        var a$1 = x3.s_util_Left__f_value;
        var t = $as_jl_Throwable(a$1);
        var $$x1 = new $c_Lcats_effect_kernel_Outcome$Errored(t)
      };
      return $as_Lcats_effect_kernel_Outcome($$x1)
    }))(iCtx));
    var outcome = this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f);
    return iCtx.completeWhen__O__O(outcome)
  };
  throw new $c_s_MatchError(x97)
});
$c_Lfs2_internal_Scope.prototype.isInterrupted__O = (function() {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$4 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((scope) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var x100 = scope$1.Lfs2_internal_Scope__f_interruptible;
    var x = $m_s_None$();
    if ((x === x100)) {
      var this$3 = this$2.Lfs2_internal_Scope__f_F;
      var a = $m_s_None$();
      return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
    };
    if ((x100 instanceof $c_s_Some)) {
      var iCtx = $as_Lfs2_internal_InterruptContext($as_s_Some(x100).s_Some__f_value);
      return iCtx.Lfs2_internal_InterruptContext__f_ref.get__O()
    };
    throw new $c_s_MatchError(x100)
  }))(this));
  return this$4.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$$anon$2__f_self, f)
});
$c_Lfs2_internal_Scope.prototype.interruptibleEval__O__O = (function(f) {
  var target = $p_Lfs2_internal_Scope__openScope__O(this);
  var tc = this.Lfs2_internal_Scope__f_F;
  var this$2 = new $c_Lcats_Functor$$anon$4(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((_$13) => {
    var _$13$1 = $as_Lfs2_internal_Scope(_$13);
    return _$13$1.Lfs2_internal_Scope__f_interruptible
  }));
  var target$1 = this$2.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$$anon$4__f_self, f$1);
  var tc$1 = this.Lfs2_internal_Scope__f_F;
  var this$14 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
  var f$4 = new $c_sjsr_AnonFunction1(((this$4, f$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var F$1 = this$4.Lfs2_internal_Scope__f_F;
      var target$2 = $f_Lcats_ApplicativeError__attempt__O__O(F$1, f$2);
      var tc$2 = this$4.Lfs2_internal_Scope__f_F;
      var this$13 = new $c_Lcats_Functor$$anon$4(target$2, tc$2);
      var f$3 = new $c_sjsr_AnonFunction1(((_$14) => {
        var _$14$1 = $as_s_util_Either(_$14);
        if ((_$14$1 instanceof $c_s_util_Left)) {
          var a = $as_s_util_Left(_$14$1).s_util_Left__f_value;
          $m_s_package$();
          var t = $as_jl_Throwable(a);
          var value = new $c_Lcats_effect_kernel_Outcome$Errored(t);
          return new $c_s_util_Left(value)
        };
        if ((_$14$1 instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(_$14$1);
          $m_Lcats_syntax_EitherUtil$();
          return r
        };
        throw new $c_s_MatchError(_$14$1)
      }));
      return this$13.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$13.Lcats_Functor$$anon$4__f_self, f$3)
    };
    if ((x$1$1 instanceof $c_s_Some)) {
      var iCtx = $as_Lfs2_internal_InterruptContext($as_s_Some(x$1$1).s_Some__f_value);
      return iCtx.eval__O__O(f$2)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, f));
  return this$14.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$$anon$2__f_self, f$4)
});
$c_Lfs2_internal_Scope.prototype.toString__T = (function() {
  var $$x1 = this.Lfs2_internal_Scope__f_id;
  var this$1 = this.Lfs2_internal_Scope__f_interruptible;
  return (((("Scope(id=" + $$x1) + ",interruptible=") + (!this$1.isEmpty__Z())) + ")")
});
function $as_Lfs2_internal_Scope(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope"))
}
function $isArrayOf_Lfs2_internal_Scope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope)))
}
function $asArrayOf_Lfs2_internal_Scope(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope;", depth))
}
var $d_Lfs2_internal_Scope = new $TypeData().initClass({
  Lfs2_internal_Scope: 0
}, false, "fs2.internal.Scope", {
  Lfs2_internal_Scope: 1,
  O: 1
});
$c_Lfs2_internal_Scope.prototype.$classData = $d_Lfs2_internal_Scope;
/** @constructor */
function $c_Lfs2_internal_Scope$() {
  /*<skip>*/
}
$c_Lfs2_internal_Scope$.prototype = new $h_O();
$c_Lfs2_internal_Scope$.prototype.constructor = $c_Lfs2_internal_Scope$;
/** @constructor */
function $h_Lfs2_internal_Scope$() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope$.prototype = $c_Lfs2_internal_Scope$.prototype;
$c_Lfs2_internal_Scope$.prototype.fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O = (function(id, parent, interruptible, F) {
  var this$1 = $m_Lfs2_internal_Scope$State$();
  var target = F.ref__O__O(this$1.Lfs2_internal_Scope$State$__f_initial_);
  var this$4 = new $c_Lcats_Functor$$anon$4(target, F);
  var f = new $c_sjsr_AnonFunction1(((id$2, parent$2, interruptible$2, F$2) => ((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    return new $c_Lfs2_internal_Scope(id$2, parent$2, interruptible$2, state$1, F$2)
  }))(id, parent, interruptible, F));
  return this$4.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$$anon$4__f_self, f)
});
$c_Lfs2_internal_Scope$.prototype.newRoot__Lfs2_Compiler$Target__O = (function(F) {
  var target = F.unique__O();
  var this$3 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1(((this$2, F$2) => ((_$20) => {
    var _$20$1 = $as_Lcats_effect_kernel_Unique$Token(_$20);
    return this$2.fs2$internal$Scope$$$apply__Lcats_effect_kernel_Unique$Token__s_Option__s_Option__Lfs2_Compiler$Target__O(_$20$1, $m_s_None$(), $m_s_None$(), F$2)
  }))(this, F));
  return this$3.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$$anon$2__f_self, f)
});
var $d_Lfs2_internal_Scope$ = new $TypeData().initClass({
  Lfs2_internal_Scope$: 0
}, false, "fs2.internal.Scope$", {
  Lfs2_internal_Scope$: 1,
  O: 1
});
$c_Lfs2_internal_Scope$.prototype.$classData = $d_Lfs2_internal_Scope$;
var $n_Lfs2_internal_Scope$;
function $m_Lfs2_internal_Scope$() {
  if ((!$n_Lfs2_internal_Scope$)) {
    $n_Lfs2_internal_Scope$ = new $c_Lfs2_internal_Scope$()
  };
  return $n_Lfs2_internal_Scope$
}
function $is_Lfs2_internal_Scope$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_internal_Scope$State)))
}
function $as_Lfs2_internal_Scope$State(obj) {
  return (($is_Lfs2_internal_Scope$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State"))
}
function $isArrayOf_Lfs2_internal_Scope$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State)))
}
function $asArrayOf_Lfs2_internal_Scope$State(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State;", depth))
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource() {
  /*<skip>*/
}
$c_Lfs2_internal_ScopedResource.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource.prototype.constructor = $c_Lfs2_internal_ScopedResource;
/** @constructor */
function $h_Lfs2_internal_ScopedResource() {
  /*<skip>*/
}
$h_Lfs2_internal_ScopedResource.prototype = $c_Lfs2_internal_ScopedResource.prototype;
function $as_Lfs2_internal_ScopedResource(obj) {
  return (((obj instanceof $c_Lfs2_internal_ScopedResource) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.ScopedResource"))
}
function $isArrayOf_Lfs2_internal_ScopedResource(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource)))
}
function $asArrayOf_Lfs2_internal_ScopedResource(obj, depth) {
  return (($isArrayOf_Lfs2_internal_ScopedResource(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.ScopedResource;", depth))
}
/** @constructor */
function $c_Lfs2_internal_ScopedResource$() {
  this.Lfs2_internal_ScopedResource$__f_initial = null;
  $n_Lfs2_internal_ScopedResource$ = this;
  var finalizer = $m_s_None$();
  this.Lfs2_internal_ScopedResource$__f_initial = new $c_Lfs2_internal_ScopedResource$State(true, finalizer, 0)
}
$c_Lfs2_internal_ScopedResource$.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource$.prototype.constructor = $c_Lfs2_internal_ScopedResource$;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$() {
  /*<skip>*/
}
$h_Lfs2_internal_ScopedResource$.prototype = $c_Lfs2_internal_ScopedResource$.prototype;
$c_Lfs2_internal_ScopedResource$.prototype.create__Lfs2_Compiler$Target__O = (function(F) {
  $m_Lcats_implicits$();
  var target = F.ref__O__O(this.Lfs2_internal_ScopedResource$__f_initial);
  var this$6 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f$1 = new $c_sjsr_AnonFunction1(((F$2) => ((state) => {
    var state$1 = $as_Lcats_effect_kernel_Ref(state);
    $m_Lcats_implicits$();
    var target$1 = F$2.unique__O();
    var this$5 = new $c_Lcats_Functor$$anon$4(target$1, F$2);
    var f = new $c_sjsr_AnonFunction1(((F$1$2, state$2) => ((token) => {
      var token$1 = $as_Lcats_effect_kernel_Unique$Token(token);
      return new $c_Lfs2_internal_ScopedResource$$anon$1(F$1$2, state$2, token$1)
    }))(F$2, state$1));
    return this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f)
  }))(F));
  return this$6.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$$anon$2__f_self, f$1)
});
var $d_Lfs2_internal_ScopedResource$ = new $TypeData().initClass({
  Lfs2_internal_ScopedResource$: 0
}, false, "fs2.internal.ScopedResource$", {
  Lfs2_internal_ScopedResource$: 1,
  O: 1
});
$c_Lfs2_internal_ScopedResource$.prototype.$classData = $d_Lfs2_internal_ScopedResource$;
var $n_Lfs2_internal_ScopedResource$;
function $m_Lfs2_internal_ScopedResource$() {
  if ((!$n_Lfs2_internal_ScopedResource$)) {
    $n_Lfs2_internal_ScopedResource$ = new $c_Lfs2_internal_ScopedResource$()
  };
  return $n_Lfs2_internal_ScopedResource$
}
/** @constructor */
function $c_jl_Class(data0) {
  this.jl_Class__f_data = null;
  this.jl_Class__f_cachedSimpleName = null;
  this.jl_Class__f_data = data0
}
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
  /*<skip>*/
}
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.isInterface__Z() ? "interface " : (this.isPrimitive__Z() ? "" : "class ")) + this.getName__T())
});
$c_jl_Class.prototype.isAssignableFrom__jl_Class__Z = (function(that) {
  return $uZ(this.jl_Class__f_data.isAssignableFrom(that.jl_Class__f_data))
});
$c_jl_Class.prototype.isInterface__Z = (function() {
  return $uZ(this.jl_Class__f_data.isInterface)
});
$c_jl_Class.prototype.isArray__Z = (function() {
  return $uZ(this.jl_Class__f_data.isArrayClass)
});
$c_jl_Class.prototype.isPrimitive__Z = (function() {
  return $uZ(this.jl_Class__f_data.isPrimitive)
});
$c_jl_Class.prototype.getName__T = (function() {
  return $as_T(this.jl_Class__f_data.name)
});
$c_jl_Class.prototype.getComponentType__jl_Class = (function() {
  return $as_jl_Class(this.jl_Class__f_data.getComponentType())
});
$c_jl_Class.prototype.newArrayOfThisClass__O__O = (function(dimensions) {
  return this.jl_Class__f_data.newArrayOfThisClass(dimensions)
});
function $as_jl_Class(obj) {
  return (((obj instanceof $c_jl_Class) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Class"))
}
function $isArrayOf_jl_Class(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Class)))
}
function $asArrayOf_jl_Class(obj, depth) {
  return (($isArrayOf_jl_Class(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Class;", depth))
}
var $d_jl_Class = new $TypeData().initClass({
  jl_Class: 0
}, false, "java.lang.Class", {
  jl_Class: 1,
  O: 1
});
$c_jl_Class.prototype.$classData = $d_jl_Class;
function $is_jl_Comparable(obj) {
  return ((((((!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Comparable))) || ((typeof obj) === "string")) || ((typeof obj) === "number")) || ((typeof obj) === "boolean")) || (obj instanceof $c_RTLong)) || (obj instanceof $Char))
}
function $as_jl_Comparable(obj) {
  return (($is_jl_Comparable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Comparable"))
}
function $isArrayOf_jl_Comparable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Comparable)))
}
function $asArrayOf_jl_Comparable(obj, depth) {
  return (($isArrayOf_jl_Comparable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Comparable;", depth))
}
/** @constructor */
function $c_jl_FloatingPointBits$() {
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = false;
  this.jl_FloatingPointBits$__f_arrayBuffer = null;
  this.jl_FloatingPointBits$__f_int32Array = null;
  this.jl_FloatingPointBits$__f_float32Array = null;
  this.jl_FloatingPointBits$__f_float64Array = null;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = false;
  this.jl_FloatingPointBits$__f_highOffset = 0;
  this.jl_FloatingPointBits$__f_lowOffset = 0;
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null;
  $n_jl_FloatingPointBits$ = this;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$_areTypedArraysSupported = true;
  this.jl_FloatingPointBits$__f_arrayBuffer = new ArrayBuffer(8);
  this.jl_FloatingPointBits$__f_int32Array = new Int32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float32Array = new Float32Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 2);
  this.jl_FloatingPointBits$__f_float64Array = new Float64Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 1);
  this.jl_FloatingPointBits$__f_int32Array[0] = 16909060;
  this.jl_FloatingPointBits$__f_areTypedArraysBigEndian = ($uB(new Int8Array(this.jl_FloatingPointBits$__f_arrayBuffer, 0, 8)[0]) === 1);
  this.jl_FloatingPointBits$__f_highOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 0 : 1);
  this.jl_FloatingPointBits$__f_lowOffset = (this.jl_FloatingPointBits$__f_areTypedArraysBigEndian ? 1 : 0);
  this.jl_FloatingPointBits$__f_floatPowsOf2 = null;
  this.jl_FloatingPointBits$__f_java$lang$FloatingPointBits$$doublePowsOf2 = null
}
$c_jl_FloatingPointBits$.prototype = new $h_O();
$c_jl_FloatingPointBits$.prototype.constructor = $c_jl_FloatingPointBits$;
/** @constructor */
function $h_jl_FloatingPointBits$() {
  /*<skip>*/
}
$h_jl_FloatingPointBits$.prototype = $c_jl_FloatingPointBits$.prototype;
$c_jl_FloatingPointBits$.prototype.numberHashCode__D__I = (function(value) {
  var iv = $uI((value | 0));
  if (((iv === value) && ((1.0 / value) !== (-Infinity)))) {
    return iv
  } else {
    this.jl_FloatingPointBits$__f_float64Array[0] = value;
    return ($uI(this.jl_FloatingPointBits$__f_int32Array[0]) ^ $uI(this.jl_FloatingPointBits$__f_int32Array[1]))
  }
});
$c_jl_FloatingPointBits$.prototype.intBitsToFloat__I__F = (function(bits) {
  this.jl_FloatingPointBits$__f_int32Array[0] = bits;
  return $uF(this.jl_FloatingPointBits$__f_float32Array[0])
});
$c_jl_FloatingPointBits$.prototype.floatToIntBits__F__I = (function(value) {
  this.jl_FloatingPointBits$__f_float32Array[0] = value;
  return $uI(this.jl_FloatingPointBits$__f_int32Array[0])
});
$c_jl_FloatingPointBits$.prototype.longBitsToDouble__J__D = (function(bits) {
  var $$x2 = this.jl_FloatingPointBits$__f_int32Array;
  var $$x1 = this.jl_FloatingPointBits$__f_highOffset;
  var hi = bits.RTLong__f_hi;
  $$x2[$$x1] = hi;
  this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset] = bits.RTLong__f_lo;
  return $uD(this.jl_FloatingPointBits$__f_float64Array[0])
});
$c_jl_FloatingPointBits$.prototype.doubleToLongBits__D__J = (function(value) {
  this.jl_FloatingPointBits$__f_float64Array[0] = value;
  var value$1 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_highOffset]);
  var value$2 = $uI(this.jl_FloatingPointBits$__f_int32Array[this.jl_FloatingPointBits$__f_lowOffset]);
  return new $c_RTLong(value$2, value$1)
});
var $d_jl_FloatingPointBits$ = new $TypeData().initClass({
  jl_FloatingPointBits$: 0
}, false, "java.lang.FloatingPointBits$", {
  jl_FloatingPointBits$: 1,
  O: 1
});
$c_jl_FloatingPointBits$.prototype.$classData = $d_jl_FloatingPointBits$;
var $n_jl_FloatingPointBits$;
function $m_jl_FloatingPointBits$() {
  if ((!$n_jl_FloatingPointBits$)) {
    $n_jl_FloatingPointBits$ = new $c_jl_FloatingPointBits$()
  };
  return $n_jl_FloatingPointBits$
}
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, paddingZeros, overflowBarrier) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = $L0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = $L0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = overflowBarrier
}
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
  /*<skip>*/
}
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
function $as_jl_Long$StringRadixInfo(obj) {
  return (((obj instanceof $c_jl_Long$StringRadixInfo) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long$StringRadixInfo"))
}
function $isArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long$StringRadixInfo)))
}
function $asArrayOf_jl_Long$StringRadixInfo(obj, depth) {
  return (($isArrayOf_jl_Long$StringRadixInfo(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long$StringRadixInfo;", depth))
}
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass({
  jl_Long$StringRadixInfo: 0
}, false, "java.lang.Long$StringRadixInfo", {
  jl_Long$StringRadixInfo: 1,
  O: 1
});
$c_jl_Long$StringRadixInfo.prototype.$classData = $d_jl_Long$StringRadixInfo;
/** @constructor */
function $c_jl_Math$() {
  /*<skip>*/
}
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
  /*<skip>*/
}
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  if (((a !== a) || (a === Infinity))) {
    return a
  } else if ((a === (-0))) {
    return 1.401298464324817E-45
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? ((1 + abits) | 0) : (((-1) + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  if (((a !== a) || (a === (-Infinity)))) {
    return a
  } else if ((a === 0.0)) {
    return (-1.401298464324817E-45)
  } else {
    var abits = $m_jl_FloatingPointBits$().floatToIntBits__F__I(a);
    var rbits = ((a > 0.0) ? (((-1) + abits) | 0) : ((1 + abits) | 0));
    return $m_jl_FloatingPointBits$().intBitsToFloat__I__F(rbits)
  }
});
var $d_jl_Math$ = new $TypeData().initClass({
  jl_Math$: 0
}, false, "java.lang.Math$", {
  jl_Math$: 1,
  O: 1
});
$c_jl_Math$.prototype.$classData = $d_jl_Math$;
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$()
  };
  return $n_jl_Math$
}
function $is_jl_Runnable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.jl_Runnable)))
}
function $as_jl_Runnable(obj) {
  return (($is_jl_Runnable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Runnable"))
}
function $isArrayOf_jl_Runnable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Runnable)))
}
function $asArrayOf_jl_Runnable(obj, depth) {
  return (($isArrayOf_jl_Runnable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Runnable;", depth))
}
var $d_jl_Runnable = new $TypeData().initClass({
  jl_Runnable: 0
}, true, "java.lang.Runnable", {
  jl_Runnable: 1,
  O: 1
});
/** @constructor */
function $c_jl_Runtime() {
  /*<skip>*/
}
$c_jl_Runtime.prototype = new $h_O();
$c_jl_Runtime.prototype.constructor = $c_jl_Runtime;
/** @constructor */
function $h_jl_Runtime() {
  /*<skip>*/
}
$h_jl_Runtime.prototype = $c_jl_Runtime.prototype;
var $d_jl_Runtime = new $TypeData().initClass({
  jl_Runtime: 0
}, false, "java.lang.Runtime", {
  jl_Runtime: 1,
  O: 1
});
$c_jl_Runtime.prototype.$classData = $d_jl_Runtime;
/** @constructor */
function $c_jl_Runtime$() {
  this.jl_Runtime$__f_currentRuntime = null;
  $n_jl_Runtime$ = this;
  this.jl_Runtime$__f_currentRuntime = new $c_jl_Runtime()
}
$c_jl_Runtime$.prototype = new $h_O();
$c_jl_Runtime$.prototype.constructor = $c_jl_Runtime$;
/** @constructor */
function $h_jl_Runtime$() {
  /*<skip>*/
}
$h_jl_Runtime$.prototype = $c_jl_Runtime$.prototype;
var $d_jl_Runtime$ = new $TypeData().initClass({
  jl_Runtime$: 0
}, false, "java.lang.Runtime$", {
  jl_Runtime$: 1,
  O: 1
});
$c_jl_Runtime$.prototype.$classData = $d_jl_Runtime$;
var $n_jl_Runtime$;
function $m_jl_Runtime$() {
  if ((!$n_jl_Runtime$)) {
    $n_jl_Runtime$ = new $c_jl_Runtime$()
  };
  return $n_jl_Runtime$
}
function $p_jl_StackTrace$__extract__O__Ajl_StackTraceElement($thiz, stackdata) {
  var lines = $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, stackdata);
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines)
}
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().re$extension__T__O("^([^\\@]*)\\@(.*):([0-9]+)$");
  var NormalizedFrameLineWithColumn = $m_jl_StackTrace$StringRE$().re$extension__T__O("^([^\\@]*)\\@(.*):([0-9]+):([0-9]+)$");
  var trace = [];
  var i = 0;
  while ((i < $uI(lines.length))) {
    var line = $as_T(lines[i]);
    if ((line !== "")) {
      var mtch1 = NormalizedFrameLineWithColumn.exec(line);
      if ((mtch1 !== null)) {
        var x = mtch1[1];
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x));
        var $$x3 = $as_T(classAndMethodName[0]);
        var $$x2 = $as_T(classAndMethodName[1]);
        var x$1 = mtch1[2];
        var $$x1 = $as_T(x$1);
        var x$2 = mtch1[3];
        var s = $as_T(x$2);
        var elem = new $c_jl_StackTraceElement($$x3, $$x2, $$x1, $uI(parseInt(s)));
        var x$3 = mtch1[4];
        var s$1 = $as_T(x$3);
        elem.jl_StackTraceElement__f_columnNumber = $uI(parseInt(s$1));
        $uI(trace.push(elem))
      } else {
        var mtch2 = NormalizedFrameLine.exec(line);
        if ((mtch2 !== null)) {
          var x$4 = mtch2[1];
          var classAndMethodName$2 = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, $as_T(x$4));
          var $$x7 = $as_T(classAndMethodName$2[0]);
          var $$x6 = $as_T(classAndMethodName$2[1]);
          var x$5 = mtch2[2];
          var $$x5 = $as_T(x$5);
          var x$6 = mtch2[3];
          var s$2 = $as_T(x$6);
          var $$x4 = trace.push(new $c_jl_StackTraceElement($$x7, $$x6, $$x5, $uI(parseInt(s$2))));
          $uI($$x4)
        } else {
          $uI(trace.push(new $c_jl_StackTraceElement("<jscode>", line, null, (-1))))
        }
      }
    };
    i = ((1 + i) | 0)
  };
  var len = $uI(trace.length);
  var result = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
  i = 0;
  while ((i < len)) {
    result.set(i, $as_jl_StackTraceElement(trace[i]));
    i = ((1 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().re$extension__T__O("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    var x = matchBCOrS[1];
    var $$x1 = $p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x));
    var x$1 = matchBCOrS[2];
    return [$$x1, $p_jl_StackTrace$__decodeMethodName__T__T($thiz, $as_T(x$1))]
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      var x$2 = matchCTOrN[1];
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$2)), "<init>"]
    } else {
      var matchM = PatM.exec(functionName);
      if ((matchM !== null)) {
        var x$3 = matchM[1];
        return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, $as_T(x$3)), "<clinit>"]
      } else {
        return ["<jscode>", functionName]
      }
    }
  }
}
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, encodedName))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = $as_T(dict$1[encodedName])
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName)
  };
  var this$4 = $as_T(base.split("_").join("."));
  return $as_T(this$4.split("\uff3f").join("_"))
}
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = {};
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value
      };
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0)
    };
    $thiz.jl_StackTrace$__f_decompressedClasses = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((1 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_decompressedClasses
}
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedClasses)
}
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = {};
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.jl_StackTrace$__f_decompressedPrefixes = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((2 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_decompressedPrefixes
}
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedPrefixes)
}
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_StackTrace$__f_compressedPrefixes = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.jl_StackTrace$__f_bitmap$0 = (((4 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_StackTrace$__f_compressedPrefixes
}
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_compressedPrefixes)
}
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  if ((($uI(encodedName.length) >= 0) && ($as_T(encodedName.substring(0, $uI("init___".length))) === "init___"))) {
    return "<init>"
  } else {
    var methodNameLen = $uI(encodedName.indexOf("__"));
    return ((methodNameLen < 0) ? encodedName : $as_T(encodedName.substring(0, methodNameLen)))
  }
}
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  var x = (!e);
  if ($uZ((!(!x)))) {
    return []
  } else {
    var x$1 = (e.arguments && e.stack);
    if ($uZ((!(!x$1)))) {
      return $p_jl_StackTrace$__extractChrome__O__O($thiz, e)
    } else {
      var x$2 = (e.stack && e.sourceURL);
      if ($uZ((!(!x$2)))) {
        return $p_jl_StackTrace$__extractSafari__O__O($thiz, e)
      } else {
        var x$3 = (e.stack && e.number);
        if ($uZ((!(!x$3)))) {
          return $p_jl_StackTrace$__extractIE__O__O($thiz, e)
        } else {
          var x$4 = (e.stack && e.fileName);
          if ($uZ((!(!x$4)))) {
            return $p_jl_StackTrace$__extractFirefox__O__O($thiz, e)
          } else {
            var x$5 = (e.message && e["opera#sourceloc"]);
            if ($uZ((!(!x$5)))) {
              var x$6 = (!e.stacktrace);
              if ($uZ((!(!x$6)))) {
                return $p_jl_StackTrace$__extractOpera9__O__O($thiz, e)
              } else {
                var x$7 = ((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length));
                if ($uZ((!(!x$7)))) {
                  return $p_jl_StackTrace$__extractOpera9__O__O($thiz, e)
                } else {
                  return $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e)
                }
              }
            } else {
              var x$8 = ((e.message && e.stack) && e.stacktrace);
              if ($uZ((!(!x$8)))) {
                var x$9 = (e.stacktrace.indexOf("called from line") < 0.0);
                if ($uZ((!(!x$9)))) {
                  return $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e)
                } else {
                  return $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)
                }
              } else {
                var x$10 = (e.stack && (!e.fileName));
                if ($uZ((!(!x$10)))) {
                  return $p_jl_StackTrace$__extractChrome__O__O($thiz, e)
                } else {
                  return $p_jl_StackTrace$__extractOther__O__O($thiz, e)
                }
              }
            }
          }
        }
      }
    }
  }
}
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  var x = ($as_T(e.stack) + "\n");
  var $$x6 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__O("^[\\s\\S]+?\\s+at\\s+"), " at ");
  var x$1 = $as_T($$x6);
  var $$x5 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^\\s+(at eval )?at\\s+", "gm"), "");
  var x$2 = $as_T($$x5);
  var $$x4 = x$2.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2");
  var x$3 = $as_T($$x4);
  var $$x3 = x$3.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)");
  var x$4 = $as_T($$x3);
  var $$x2 = x$4.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2");
  var x$5 = $as_T($$x2);
  var $$x1 = x$5.split("\n");
  return $$x1.slice(0, (-1))
}
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  var x = $as_T(e.stack);
  var $$x2 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("(?:\\n@:0)?\\s+$", "m"), "");
  var x$1 = $as_T($$x2);
  var $$x1 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@");
  var x$2 = $as_T($$x1);
  return x$2.split("\n")
}
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var x = $as_T(e.stack);
  var $$x3 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^\\s*at\\s+(.*)$", "gm"), "$1");
  var x$1 = $as_T($$x3);
  var $$x2 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^Anonymous function\\s+", "gm"), "{anonymous}() ");
  var x$2 = $as_T($$x2);
  var $$x1 = x$2.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2");
  var x$3 = $as_T($$x1);
  var qual$1 = x$3.split("\n");
  return qual$1.slice(1)
}
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  var x = $as_T(e.stack);
  var $$x3 = x.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("\\[native code\\]\\n", "m"), "");
  var x$1 = $as_T($$x3);
  var $$x2 = x$1.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^(?=\\w+Error\\:).*$\\n", "m"), "");
  var x$2 = $as_T($$x2);
  var $$x1 = x$2.replace($m_jl_StackTrace$StringRE$().re$extension__T__T__O("^@", "gm"), "{anonymous}()@");
  var x$3 = $as_T($$x1);
  return x$3.split("\n")
}
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__T__O("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var x = $as_T(e.message);
  var lines = x.split("\n");
  var result = [];
  var i = 2;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[2];
      var x$2 = mtch[1];
      var $$x1 = result.push(((("{anonymous}()@" + x$1) + ":") + x$2));
      $uI($$x1)
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__T__O("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var x = $as_T(e.stacktrace);
  var lines = x.split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[3];
      var fnName = $as_T(((x$1 !== (void 0)) ? x$1 : "{anonymous}"));
      var x$2 = mtch[2];
      var x$3 = mtch[1];
      var $$x1 = result.push(((((fnName + "()@") + x$2) + ":") + x$3));
      $uI($$x1)
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__O("^(.*)@(.+):(\\d+)$");
  var x = $as_T(e.stacktrace);
  var lines = x.split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[1];
      if ((x$1 !== (void 0))) {
        var arg1 = $as_T(x$1);
        var $$x1 = $m_jl_StackTrace$().java$lang$StackTrace$$$anonfun$extractOpera10b$1__T__T(arg1)
      } else {
        var $$x1 = "global code"
      };
      var fnName = $as_T($$x1);
      var x$2 = mtch[2];
      var x$3 = mtch[3];
      var $$x2 = result.push(((((fnName + "@") + x$2) + ":") + x$3));
      $uI($$x2)
    };
    i = ((1 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension__T__O("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var x = $as_T(e.stacktrace);
  var lines = x.split("\n");
  var result = [];
  var i = 0;
  var len = $uI(lines.length);
  while ((i < len)) {
    var mtch = lineRE.exec($as_T(lines[i]));
    if ((mtch !== null)) {
      var x$1 = mtch[4];
      var $$x1 = $as_T(x$1);
      var x$2 = mtch[1];
      var x$3 = mtch[2];
      var location = (((($$x1 + ":") + x$2) + ":") + x$3);
      var x$4 = mtch[2];
      var fnName0 = $as_T(((x$4 !== (void 0)) ? x$4 : "global code"));
      var x$5 = $as_T(fnName0.replace($m_jl_StackTrace$StringRE$().re$extension__T__O("<anonymous function: (\\S+)>"), "$1"));
      var $$x2 = x$5.replace($m_jl_StackTrace$StringRE$().re$extension__T__O("<anonymous function>"), "{anonymous}");
      var fnName = $as_T($$x2);
      $uI(result.push(((fnName + "@") + location)))
    };
    i = ((2 + i) | 0)
  };
  return result
}
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return []
}
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < $uI($p_jl_StackTrace$__compressedPrefixes__O($thiz).length))) {
      var prefix = $as_T($p_jl_StackTrace$__compressedPrefixes__O($thiz)[i]);
      if ((($uI(encodedName$1.length) >= 0) && ($as_T(encodedName$1.substring(0, $uI(prefix.length))) === prefix))) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        var $$x1 = $as_T(dict[prefix]);
        var beginIndex = $uI(prefix.length);
        return (("" + $$x1) + $as_T(encodedName$1.substring(beginIndex)))
      } else {
        i = ((1 + i) | 0)
      }
    } else {
      return ((($uI(encodedName$1.length) >= 0) && ($as_T(encodedName$1.substring(0, $uI("L".length))) === "L")) ? $as_T(encodedName$1.substring(1)) : encodedName$1)
    }
  }
}
/** @constructor */
function $c_jl_StackTrace$() {
  this.jl_StackTrace$__f_decompressedClasses = null;
  this.jl_StackTrace$__f_decompressedPrefixes = null;
  this.jl_StackTrace$__f_compressedPrefixes = null;
  this.jl_StackTrace$__f_bitmap$0 = 0
}
$c_jl_StackTrace$.prototype = new $h_O();
$c_jl_StackTrace$.prototype.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
  /*<skip>*/
}
$h_jl_StackTrace$.prototype = $c_jl_StackTrace$.prototype;
$c_jl_StackTrace$.prototype.java$lang$StackTrace$$$anonfun$extractOpera10b$1__T__T = (function(x$1) {
  return (x$1 + "()")
});
var $d_jl_StackTrace$ = new $TypeData().initClass({
  jl_StackTrace$: 0
}, false, "java.lang.StackTrace$", {
  jl_StackTrace$: 1,
  O: 1
});
$c_jl_StackTrace$.prototype.$classData = $d_jl_StackTrace$;
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$()
  };
  return $n_jl_StackTrace$
}
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
  /*<skip>*/
}
$c_jl_StackTrace$StringRE$.prototype = new $h_O();
$c_jl_StackTrace$StringRE$.prototype.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
  /*<skip>*/
}
$h_jl_StackTrace$StringRE$.prototype = $c_jl_StackTrace$StringRE$.prototype;
$c_jl_StackTrace$StringRE$.prototype.re$extension__T__O = (function(this$) {
  return new RegExp(this$)
});
$c_jl_StackTrace$StringRE$.prototype.re$extension__T__T__O = (function(this$, mods) {
  return new RegExp(this$, mods)
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().initClass({
  jl_StackTrace$StringRE$: 0
}, false, "java.lang.StackTrace$StringRE$", {
  jl_StackTrace$StringRE$: 1,
  O: 1
});
$c_jl_StackTrace$StringRE$.prototype.$classData = $d_jl_StackTrace$StringRE$;
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$()
  };
  return $n_jl_StackTrace$StringRE$
}
/** @constructor */
function $c_jl_System$NanoTime$() {
  this.jl_System$NanoTime$__f_getHighPrecisionTime = null;
  $n_jl_System$NanoTime$ = this;
  if (($as_T((typeof performance)) !== "undefined")) {
    var x = performance.now;
    if ($uZ((!(!x)))) {
      var $$x1 = (() => $m_jl_System$NanoTime$().java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$1__D())
    } else {
      var x$1 = performance.webkitNow;
      if ($uZ((!(!x$1)))) {
        var $$x1 = (() => $m_jl_System$NanoTime$().java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$2__D())
      } else {
        var $$x1 = (() => $m_jl_System$NanoTime$().java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$3__D())
      }
    }
  } else {
    var $$x1 = (() => $m_jl_System$NanoTime$().java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$4__D())
  };
  this.jl_System$NanoTime$__f_getHighPrecisionTime = $$x1
}
$c_jl_System$NanoTime$.prototype = new $h_O();
$c_jl_System$NanoTime$.prototype.constructor = $c_jl_System$NanoTime$;
/** @constructor */
function $h_jl_System$NanoTime$() {
  /*<skip>*/
}
$h_jl_System$NanoTime$.prototype = $c_jl_System$NanoTime$.prototype;
$c_jl_System$NanoTime$.prototype.java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$1__D = (function() {
  return $uD(performance.now())
});
$c_jl_System$NanoTime$.prototype.java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$2__D = (function() {
  return $uD(performance.webkitNow())
});
$c_jl_System$NanoTime$.prototype.java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$3__D = (function() {
  return $uD(new Date().getTime())
});
$c_jl_System$NanoTime$.prototype.java$lang$System$NanoTime$$$anonfun$getHighPrecisionTime$4__D = (function() {
  return $uD(new Date().getTime())
});
var $d_jl_System$NanoTime$ = new $TypeData().initClass({
  jl_System$NanoTime$: 0
}, false, "java.lang.System$NanoTime$", {
  jl_System$NanoTime$: 1,
  O: 1
});
$c_jl_System$NanoTime$.prototype.$classData = $d_jl_System$NanoTime$;
var $n_jl_System$NanoTime$;
function $m_jl_System$NanoTime$() {
  if ((!$n_jl_System$NanoTime$)) {
    $n_jl_System$NanoTime$ = new $c_jl_System$NanoTime$()
  };
  return $n_jl_System$NanoTime$
}
/** @constructor */
function $c_jl_System$Streams$() {
  this.jl_System$Streams$__f_out = null;
  this.jl_System$Streams$__f_err = null;
  this.jl_System$Streams$__f_in = null;
  $n_jl_System$Streams$ = this;
  this.jl_System$Streams$__f_out = new $c_jl_JSConsoleBasedPrintStream(false);
  this.jl_System$Streams$__f_err = new $c_jl_JSConsoleBasedPrintStream(true);
  this.jl_System$Streams$__f_in = null
}
$c_jl_System$Streams$.prototype = new $h_O();
$c_jl_System$Streams$.prototype.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
  /*<skip>*/
}
$h_jl_System$Streams$.prototype = $c_jl_System$Streams$.prototype;
var $d_jl_System$Streams$ = new $TypeData().initClass({
  jl_System$Streams$: 0
}, false, "java.lang.System$Streams$", {
  jl_System$Streams$: 1,
  O: 1
});
$c_jl_System$Streams$.prototype.$classData = $d_jl_System$Streams$;
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$()
  };
  return $n_jl_System$Streams$
}
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = {};
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  var value = $as_T($linkingInfo.linkerVersion);
  result["java.vm.version"] = value;
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result
}
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null
}
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
  /*<skip>*/
}
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  return ((this.jl_System$SystemProperties$__f_dict !== null) ? $as_T($m_jl_Utils$().dictGetOrElse__O__T__O__O(this.jl_System$SystemProperties$__f_dict, key, default$1)) : this.jl_System$SystemProperties$__f_properties.getProperty__T__T__T(key, default$1))
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass({
  jl_System$SystemProperties$: 0
}, false, "java.lang.System$SystemProperties$", {
  jl_System$SystemProperties$: 1,
  O: 1
});
$c_jl_System$SystemProperties$.prototype.$classData = $d_jl_System$SystemProperties$;
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$()
  };
  return $n_jl_System$SystemProperties$
}
/** @constructor */
function $c_jl_Thread$() {
  this.jl_Thread$__f_SingleThread = null;
  $n_jl_Thread$ = this;
  this.jl_Thread$__f_SingleThread = new $c_jl_Thread((void 0))
}
$c_jl_Thread$.prototype = new $h_O();
$c_jl_Thread$.prototype.constructor = $c_jl_Thread$;
/** @constructor */
function $h_jl_Thread$() {
  /*<skip>*/
}
$h_jl_Thread$.prototype = $c_jl_Thread$.prototype;
$c_jl_Thread$.prototype.interrupted__Z = (function() {
  var this$1 = this.jl_Thread$__f_SingleThread;
  var ret = this$1.jl_Thread__f_java$lang$Thread$$interruptedState;
  this.jl_Thread$__f_SingleThread.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  return ret
});
var $d_jl_Thread$ = new $TypeData().initClass({
  jl_Thread$: 0
}, false, "java.lang.Thread$", {
  jl_Thread$: 1,
  O: 1
});
$c_jl_Thread$.prototype.$classData = $d_jl_Thread$;
var $n_jl_Thread$;
function $m_jl_Thread$() {
  if ((!$n_jl_Thread$)) {
    $n_jl_Thread$ = new $c_jl_Thread$()
  };
  return $n_jl_Thread$
}
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  this.jl_ThreadLocal__f_hasValue = false
}
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
  /*<skip>*/
}
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(null)
  };
  return this.jl_ThreadLocal__f_v
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true
});
var $d_jl_ThreadLocal = new $TypeData().initClass({
  jl_ThreadLocal: 0
}, false, "java.lang.ThreadLocal", {
  jl_ThreadLocal: 1,
  O: 1
});
$c_jl_ThreadLocal.prototype.$classData = $d_jl_ThreadLocal;
/** @constructor */
function $c_jl_Utils$() {
  /*<skip>*/
}
$c_jl_Utils$.prototype = new $h_O();
$c_jl_Utils$.prototype.constructor = $c_jl_Utils$;
/** @constructor */
function $h_jl_Utils$() {
  /*<skip>*/
}
$h_jl_Utils$.prototype = $c_jl_Utils$.prototype;
$c_jl_Utils$.prototype.dictGetOrElse__O__T__O__O = (function(dict, key, default$1) {
  return ($uZ($m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key)) ? dict[key] : default$1)
});
var $d_jl_Utils$ = new $TypeData().initClass({
  jl_Utils$: 0
}, false, "java.lang.Utils$", {
  jl_Utils$: 1,
  O: 1
});
$c_jl_Utils$.prototype.$classData = $d_jl_Utils$;
var $n_jl_Utils$;
function $m_jl_Utils$() {
  if ((!$n_jl_Utils$)) {
    $n_jl_Utils$ = new $c_jl_Utils$()
  };
  return $n_jl_Utils$
}
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
  /*<skip>*/
}
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass({
  jl_Utils$Cache$: 0
}, false, "java.lang.Utils$Cache$", {
  jl_Utils$Cache$: 1,
  O: 1
});
$c_jl_Utils$Cache$.prototype.$classData = $d_jl_Utils$Cache$;
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$()
  };
  return $n_jl_Utils$Cache$
}
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Void__hashCode__I($thiz) {
  return 0
}
function $f_jl_Void__toString__T($thiz) {
  return "undefined"
}
function $as_jl_Void(obj) {
  return (((obj === (void 0)) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Void"))
}
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)))
}
function $asArrayOf_jl_Void(obj, depth) {
  return (($isArrayOf_jl_Void(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Void;", depth))
}
var $d_jl_Void = new $TypeData().initClass({
  jl_Void: 0
}, false, "java.lang.Void", {
  jl_Void: 1,
  O: 1
}, (void 0), (void 0), ((x) => (x === (void 0))));
/** @constructor */
function $c_jl_reflect_Array$() {
  /*<skip>*/
}
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
  /*<skip>*/
}
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__I__O = (function(componentType, length) {
  return componentType.newArrayOfThisClass__O__O([length])
});
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__AI__O = (function(componentType, dimensions) {
  var jsDims = [];
  var len = dimensions.u.length;
  var i = 0;
  while ((i !== len)) {
    jsDims.push(dimensions.get(i));
    i = ((1 + i) | 0)
  };
  return componentType.newArrayOfThisClass__O__O(jsDims)
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  if ((array instanceof $ac_O)) {
    var x2 = $asArrayOf_O(array, 1);
    return x2.u.length
  } else if ((array instanceof $ac_Z)) {
    var x3 = $asArrayOf_Z(array, 1);
    return x3.u.length
  } else if ((array instanceof $ac_C)) {
    var x4 = $asArrayOf_C(array, 1);
    return x4.u.length
  } else if ((array instanceof $ac_B)) {
    var x5 = $asArrayOf_B(array, 1);
    return x5.u.length
  } else if ((array instanceof $ac_S)) {
    var x6 = $asArrayOf_S(array, 1);
    return x6.u.length
  } else if ((array instanceof $ac_I)) {
    var x7 = $asArrayOf_I(array, 1);
    return x7.u.length
  } else if ((array instanceof $ac_J)) {
    var x8 = $asArrayOf_J(array, 1);
    return x8.u.length
  } else if ((array instanceof $ac_F)) {
    var x9 = $asArrayOf_F(array, 1);
    return x9.u.length
  } else if ((array instanceof $ac_D)) {
    var x10 = $asArrayOf_D(array, 1);
    return x10.u.length
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch")
  }
});
var $d_jl_reflect_Array$ = new $TypeData().initClass({
  jl_reflect_Array$: 0
}, false, "java.lang.reflect.Array$", {
  jl_reflect_Array$: 1,
  O: 1
});
$c_jl_reflect_Array$.prototype.$classData = $d_jl_reflect_Array$;
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$()
  };
  return $n_jl_reflect_Array$
}
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem
}
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem])
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass({
  Ljava_math_BigInteger$QuotAndRem: 0
}, false, "java.math.BigInteger$QuotAndRem", {
  Ljava_math_BigInteger$QuotAndRem: 1,
  O: 1
});
$c_Ljava_math_BigInteger$QuotAndRem.prototype.$classData = $d_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $c_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
  /*<skip>*/
}
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if ((bi.Ljava_math_BigInteger__f_sign === 0)) {
    return 0
  } else {
    var bLength = (bi.Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = bi.Ljava_math_BigInteger__f_digits.get((((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0));
    if ((bi.Ljava_math_BigInteger__f_sign < 0)) {
      var i = bi.getFirstNonzeroDigit__I();
      if ((i === (((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0))) {
        highDigit = (((-1) + highDigit) | 0)
      }
    };
    var $$x1 = bLength;
    var i$1 = highDigit;
    bLength = (($$x1 - Math.clz32(i$1)) | 0);
    return bLength
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = (count >> 5);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = ((((source.Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var length = ((result.u.length - intCount) | 0);
    source.copyTo(0, result, intCount, length)
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.set((((-1) + result.u.length) | 0), 0);
    var i = (((-1) + result.u.length) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.set(ev$1, (result.get(ev$1) | ((source.get((((-1) + ((i - intCount) | 0)) | 0)) >>> rightShiftCount) | 0)));
      result.set((((-1) + i) | 0), (source.get((((-1) + ((i - intCount) | 0)) | 0)) << count));
      i = (((-1) + i) | 0)
    }
  };
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var arg1 = i$1;
    result.set(arg1, 0);
    i$1 = ((1 + i$1) | 0)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = source.Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var arg1 = i;
    var iVal = source.get(arg1);
    result.set(arg1, ((iVal << 1) | elem));
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0)
  };
  if ((elem !== 0)) {
    result.set(srcLen, elem)
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = (count >> 5);
  var andCount = (31 & count);
  if ((intCount >= source.Ljava_math_BigInteger__f_numberLength)) {
    return ((source.Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO)
  } else {
    var resLength = ((source.Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
    if ((source.Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && (source.Ljava_math_BigInteger__f_digits.get(i) === 0))) {
        i = ((1 + i) | 0)
      };
      var cmp = ((source.Ljava_math_BigInteger__f_digits.get(i) << ((32 - andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.get(i) === (-1)))) {
          resDigits.set(i, 0);
          i = ((1 + i) | 0)
        };
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0)
        };
        var ev$1 = i;
        resDigits.set(ev$1, ((1 + resDigits.get(ev$1)) | 0))
      }
    };
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.get(i) === 0))));
    i = ((1 + i) | 0)
  };
  if ((count === 0)) {
    source.copyTo(intCount, result, 0, resultLen)
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.get(i) << leftShiftCount) === 0))));
    i = 0;
    while ((i < (((-1) + resultLen) | 0))) {
      result.set(i, (((source.get(((i + intCount) | 0)) >>> count) | 0) | (source.get(((1 + ((i + intCount) | 0)) | 0)) << leftShiftCount)));
      i = ((1 + i) | 0)
    };
    result.set(i, ((source.get(((i + intCount) | 0)) >>> count) | 0));
    i = ((1 + i) | 0)
  };
  return allZero
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass({
  Ljava_math_BitLevel$: 0
}, false, "java.math.BitLevel$", {
  Ljava_math_BitLevel$: 1,
  O: 1
});
$c_Ljava_math_BitLevel$.prototype.$classData = $d_Ljava_math_BitLevel$;
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$()
  };
  return $n_Ljava_math_BitLevel$
}
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = $uI(s.length);
  while (true) {
    if ((zeroPrefixLength < len)) {
      var index = zeroPrefixLength;
      var $$x1 = ((65535 & $uI(s.charCodeAt(index))) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0)
    } else {
      break
    }
  };
  var beginIndex = zeroPrefixLength;
  return $as_T(s.substring(beginIndex))
}
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I(new Int32Array([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]));
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I(new Int32Array([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176]))
}
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
  /*<skip>*/
}
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0"
  } else if ((numberLength === 1)) {
    var i = digits.get(0);
    var absStr = $as_T($uD((i >>> 0)).toString(10));
    return ((sign < 0) ? ("-" + absStr) : absStr)
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var length = tempLen;
    digits.copyTo(0, temp, 0, length);
    while (true) {
      var rem = 0;
      var i$1 = (((-1) + tempLen) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.get(i$1);
        var this$5 = $m_RTLong$();
        var lo = this$5.divideUnsignedImpl__I__I__I__I__I(value$1, value, 1000000000, 0);
        temp.set(i$1, lo);
        var hi$3 = (lo >> 31);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(51712, b0);
        var a1b0 = Math.imul(15258, b0);
        var a0b1 = Math.imul(51712, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$4 = ((((((Math.imul(1000000000, hi$3) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((value$1 - lo$1) | 0);
        rem = lo$2;
        i$1 = (((-1) + i$1) | 0)
      };
      var this$8 = rem;
      var remStr = ("" + this$8);
      var beginIndex = $uI(remStr.length);
      var padding = $as_T("000000000".substring(beginIndex));
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.get((((-1) + tempLen) | 0)) === 0))) {
        tempLen = (((-1) + tempLen) | 0)
      };
      if ((tempLen !== 0)) {
        /*<skip>*/
      } else {
        break
      }
    };
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result)
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value, scale) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === 0))) {
    switch (scale) {
      case 0: {
        return "0";
        break
      }
      case 1: {
        return "0.0";
        break
      }
      case 2: {
        return "0.00";
        break
      }
      case 3: {
        return "0.000";
        break
      }
      case 4: {
        return "0.0000";
        break
      }
      case 5: {
        return "0.00000";
        break
      }
      case 6: {
        return "0.000000";
        break
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648"
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i)
        };
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal)
      }
    }
  } else {
    var ahi = value.RTLong__f_hi;
    var negNumber = (ahi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var t = new $c_RTLong(x__lo, x__hi)
    } else {
      var t = value
    };
    var lo$2 = t.RTLong__f_lo;
    var hi$2 = t.RTLong__f_hi;
    var v__lo = lo$2;
    var v__hi = hi$2;
    while (true) {
      var prev__lo = v__lo;
      var prev__hi = v__hi;
      var this$5__lo = v__lo;
      var this$5__hi = v__hi;
      var this$6 = $m_RTLong$();
      var lo$3 = this$6.divideImpl__I__I__I__I__I(this$5__lo, this$5__hi, 10, 0);
      var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $$x1__lo = lo$3;
      var $$x1__hi = hi$3;
      v__lo = $$x1__lo;
      v__hi = $$x1__hi;
      currentChar = (((-1) + currentChar) | 0);
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((Math.imul(10, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var alo = prev__lo;
      var ahi$1 = prev__hi;
      var lo$5 = ((alo - lo$4) | 0);
      elem = (("" + lo$5) + $as_T(elem));
      var this$9__lo = v__lo;
      var this$9__hi = v__hi;
      if ((!((this$9__lo === 0) && (this$9__hi === 0)))) {
        /*<skip>*/
      } else {
        break
      }
    };
    var value$1 = ((18 - currentChar) | 0);
    var hi$6 = (value$1 >> 31);
    var hi$7 = (scale >> 31);
    var lo$6 = ((value$1 - scale) | 0);
    var hi$8 = ((((-2147483648) ^ lo$6) > ((-2147483648) ^ value$1)) ? (((-1) + ((hi$6 - hi$7) | 0)) | 0) : ((hi$6 - hi$7) | 0));
    var lo$7 = (((-1) + lo$6) | 0);
    var hi$9 = ((lo$7 !== (-1)) ? hi$8 : (((-1) + hi$8) | 0));
    if (((scale > 0) && ((hi$9 === (-1)) ? (((-2147483648) ^ lo$7) >= 2147483642) : (hi$9 > (-1))))) {
      var index = ((1 + lo$7) | 0);
      if ((index > 0)) {
        var this$14 = $as_T(elem);
        var $$x2 = $as_T(this$14.substring(0, index));
        var this$15 = $as_T(elem);
        elem = (($$x2 + ".") + $as_T(this$15.substring(index)))
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + $as_T(elem));
          i$1 = ((1 + i$1) | 0)
        };
        elem = ("0." + $as_T(elem))
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$9 === 0) ? (lo$7 !== 0) : (hi$9 > 0)) ? ("E+" + new $c_RTLong(lo$7, hi$9)) : ("E" + new $c_RTLong(lo$7, hi$9)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$19 = $as_T(elem);
        var $$x3 = $as_T(this$19.substring(0, 1));
        var this$20 = $as_T(elem);
        elem = ((($$x3 + ".") + $as_T(this$20.substring(1))) + exponentStr)
      } else {
        elem = ($as_T(elem) + exponentStr)
      }
    };
    return (negNumber ? ("-" + $as_T(elem)) : $as_T(elem))
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass({
  Ljava_math_Conversion$: 0
}, false, "java.math.Conversion$", {
  Ljava_math_Conversion$: 1,
  O: 1
});
$c_Ljava_math_Conversion$.prototype.$classData = $d_Ljava_math_Conversion$;
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$()
  };
  return $n_Ljava_math_Conversion$
}
/** @constructor */
function $c_Ljava_math_Division$() {
  /*<skip>*/
}
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
  /*<skip>*/
}
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = b.get((((-1) + bLength) | 0));
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift)
  } else {
    a.copyTo(0, normA, 0, aLength);
    b.copyTo(0, normB, 0, bLength)
  };
  var firstDivisorDigit = normB.get((((-1) + bLength) | 0));
  var i$1 = (((-1) + quotLength) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.get(elem) === firstDivisorDigit)) {
      elem$1 = (-1)
    } else {
      var value = normA.get(elem);
      var value$1 = normA.get((((-1) + elem) | 0));
      var this$7 = $m_RTLong$();
      var lo = this$7.divideUnsignedImpl__I__I__I__I__I(value$1, value, firstDivisorDigit, 0);
      var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      elem$1 = lo;
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((Math.imul(hi$3, firstDivisorDigit) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((value$1 - lo$1) | 0);
      var elem$2 = 0;
      elem$2 = lo$2;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.get((((-2) + bLength) | 0));
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$8 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.get((((-2) + elem) | 0));
          var value$6 = elem$2;
          var lo$4 = ((value$6 + firstDivisorDigit) | 0);
          var hi$13 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$6)) ? 1 : 0);
          if ((hi$13 === 0)) {
            elem$2 = lo$4;
            var hi$14 = ((-2147483648) ^ hi$8);
            var hi$15 = ((-2147483648) ^ value$4);
            if (((hi$14 === hi$15) ? (((-2147483648) ^ lo$3) > ((-2147483648) ^ value$5)) : (hi$14 > hi$15))) {
              continue
            }
          };
          break
        }
      }
    };
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = (((-1) + elem$1) | 0);
        var elem$3__lo = 0;
        var elem$3__hi = 0;
        var $$x1__lo = 0;
        var $$x1__hi = 0;
        elem$3__lo = $$x1__lo;
        elem$3__hi = $$x1__hi;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var arg1 = i$2;
          var this$24__lo = elem$3__lo;
          var this$24__hi = elem$3__hi;
          var value$7 = normA.get(((((elem - bLength) | 0) + arg1) | 0));
          var value$8 = normB.get(arg1);
          var lo$5 = ((value$7 + value$8) | 0);
          var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ value$7)) ? 1 : 0);
          var alo = this$24__lo;
          var ahi = this$24__hi;
          var lo$6 = ((alo + lo$5) | 0);
          var hi$19 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + hi$18) | 0)) | 0) : ((ahi + hi$18) | 0));
          var $$x2__lo = lo$6;
          var $$x2__hi = hi$19;
          elem$3__lo = $$x2__lo;
          elem$3__hi = $$x2__hi;
          var $$x3 = elem;
          var this$26__lo = elem$3__lo;
          var this$26__hi = elem$3__hi;
          normA.set((((($$x3 - bLength) | 0) + arg1) | 0), this$26__lo);
          var this$27__lo = elem$3__lo;
          var this$27__hi = elem$3__hi;
          var hi$20 = this$27__hi;
          var $$x4__lo = hi$20;
          var $$x4__hi = 0;
          elem$3__lo = $$x4__lo;
          elem$3__hi = $$x4__hi;
          i$2 = ((1 + i$2) | 0)
        }
      }
    };
    if ((quot !== null)) {
      quot.set(i$1, elem$1)
    };
    elem = (((-1) + elem) | 0);
    i$1 = (((-1) + i$1) | 0)
  };
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB
  } else {
    normA.copyTo(0, normB, 0, bLength);
    return normA
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = bi.Ljava_math_BigInteger__f_digits;
  var valLen = bi.Ljava_math_BigInteger__f_numberLength;
  var valSign = bi.Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = valDigits.get(0);
    if ((divisor === 0)) {
      var value = $intDiv(0, 0)
    } else {
      var n = ($uD((valDigit >>> 0)) / $uD((divisor >>> 0)));
      var value = $uI((n | 0))
    };
    var quo__lo = value;
    var quo__hi = 0;
    if ((divisor === 0)) {
      var value$1 = $intMod(0, 0)
    } else {
      var n$1 = ($uD((valDigit >>> 0)) % $uD((divisor >>> 0)));
      var value$1 = $uI((n$1 | 0))
    };
    var rem__lo = value$1;
    var rem__hi = 0;
    if ((valSign !== divisorSign)) {
      var this$5__lo = quo__lo;
      var this$5__hi = quo__hi;
      var lo = this$5__lo;
      var hi$2 = this$5__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      quo__lo = $$x1__lo;
      quo__hi = $$x1__hi
    };
    if ((valSign < 0)) {
      var this$8__lo = rem__lo;
      var this$8__hi = rem__hi;
      var lo$2 = this$8__lo;
      var hi$4 = this$8__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      rem__lo = $$x2__lo;
      rem__hi = $$x2__hi
    };
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(quo__lo, quo__hi)), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(rem__lo, rem__hi)))
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = (((-1) + srcLength) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.get(i);
    var this$4 = $m_RTLong$();
    var lo = this$4.divideUnsignedImpl__I__I__I__I__I(value$1, value, divisor, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((Math.imul(hi$3, divisor) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$2 = ((value$1 - lo$1) | 0);
    rem = lo$2;
    dest.set(i, lo);
    i = (((-1) + i) | 0)
  };
  return rem
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var arg1 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.get(arg1);
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    var value = a.get(((start + arg1) | 0));
    var lo$2 = ((value - lo$1) | 0);
    var hi$6 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$1 = elem$1;
    var hi$7 = (value$1 >> 31);
    var lo$3 = ((lo$2 + value$1) | 0);
    var hi$8 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ lo$2)) ? ((1 + ((hi$6 + hi$7) | 0)) | 0) : ((hi$6 + hi$7) | 0));
    a.set(((start + arg1) | 0), lo$3);
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  var value$2 = a.get(((start + bLen) | 0));
  var value$3 = elem;
  var lo$4 = ((value$2 - value$3) | 0);
  var hi$13 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ value$2)) ? (-1) : 0);
  var value$4 = elem$1;
  var hi$14 = (value$4 >> 31);
  var lo$5 = ((lo$4 + value$4) | 0);
  var hi$15 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + ((hi$13 + hi$14) | 0)) | 0) : ((hi$13 + hi$14) | 0));
  a.set(((start + bLen) | 0), lo$5);
  return hi$15
});
var $d_Ljava_math_Division$ = new $TypeData().initClass({
  Ljava_math_Division$: 0
}, false, "java.math.Division$", {
  Ljava_math_Division$: 1,
  O: 1
});
$c_Ljava_math_Division$.prototype.$classData = $d_Ljava_math_Division$;
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$()
  };
  return $n_Ljava_math_Division$
}
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.get(0);
  var value$1 = b.get(0);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
  res.set(0, lo);
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.get(i);
      var value$3 = b.get(i);
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ value$2)) ? 1 : 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$6) | 0) : hi$6);
      res.set(i, lo$2);
      carry = hi$8;
      i = ((1 + i) | 0)
    };
    while ((i < aSize)) {
      var value$5 = a.get(i);
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((-2147483648) ^ lo$3) < ((-2147483648) ^ value$5)) ? 1 : 0);
      res.set(i, lo$3);
      carry = hi$12;
      i = ((1 + i) | 0)
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.get(i);
      var value$8 = b.get(i);
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ value$7)) ? 1 : 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$16) | 0) : hi$16);
      res.set(i, lo$5);
      carry = hi$18;
      i = ((1 + i) | 0)
    };
    while ((i < bSize)) {
      var value$10 = b.get(i);
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ value$10)) ? 1 : 0);
      res.set(i, lo$6);
      carry = hi$22;
      i = ((1 + i) | 0)
    }
  };
  if ((carry !== 0)) {
    res.set(i, carry)
  }
}
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res
}
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.get(i);
    var value$1 = b.get(i);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (-1) : 0);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$2 + hi$3) | 0)) | 0) : ((hi$2 + hi$3) | 0));
    res.set(i, lo$1);
    borrow = hi$4;
    i = ((1 + i) | 0)
  };
  while ((i < aSize)) {
    var value$3 = a.get(i);
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ value$3)) ? ((1 + hi$7) | 0) : hi$7);
    res.set(i, lo$2);
    borrow = hi$8;
    i = ((1 + i) | 0)
  }
}
/** @constructor */
function $c_Ljava_math_Elementary$() {
  /*<skip>*/
}
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
  /*<skip>*/
}
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2
  } else if ((op2Sign === 0)) {
    return op1
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.get(0);
    var value$1 = op2.Ljava_math_BigInteger__f_digits.get(0);
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
    } else {
      var $$x1 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value$1)) ? (-1) : 0);
        var x__lo = lo$1;
        var x__hi = hi$3
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ value)) ? (-1) : 0);
        var x__lo = lo$2;
        var x__hi = hi$4
      };
      return $$x1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(x__lo, x__hi))
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      };
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1
      }
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = (((-1) + size) | 0);
  while (((i >= 0) && (a.get(i) === b.get(i)))) {
    i = (((-1) + i) | 0)
  };
  if ((i < 0)) {
    return 0
  } else {
    var value = a.get(i);
    var value$1 = b.get(i);
    if ((((-2147483648) ^ value) < ((-2147483648) ^ value$1))) {
      return (-1)
    } else {
      return 1
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.get(i);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? 1 : 0);
    a.set(i, lo);
    carry = hi$2;
    i = ((1 + i) | 0)
  };
  return carry
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1
  } else if ((op1Sign === 0)) {
    return op2.negate__Ljava_math_BigInteger()
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.get(0);
    var a__lo = value;
    var a__hi = 0;
    var value$1 = op2.Ljava_math_BigInteger__f_digits.get(0);
    var b__lo = value$1;
    var b__hi = 0;
    if ((op1Sign < 0)) {
      var this$3__lo = a__lo;
      var this$3__hi = a__hi;
      var lo = this$3__lo;
      var hi$2 = this$3__hi;
      var lo$1 = ((-lo) | 0);
      var hi$3 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      var $$x1__lo = lo$1;
      var $$x1__hi = hi$3;
      a__lo = $$x1__lo;
      a__hi = $$x1__hi
    };
    if ((op2Sign < 0)) {
      var this$6__lo = b__lo;
      var this$6__hi = b__hi;
      var lo$2 = this$6__lo;
      var hi$4 = this$6__hi;
      var lo$3 = ((-lo$2) | 0);
      var hi$5 = ((lo$2 !== 0) ? (~hi$4) : ((-hi$4) | 0));
      var $$x2__lo = lo$3;
      var $$x2__hi = hi$5;
      b__lo = $$x2__lo;
      b__hi = $$x2__hi
    };
    var $$x3 = $m_Ljava_math_BigInteger$();
    var this$9__lo = a__lo;
    var this$9__hi = a__hi;
    var b$1__lo = b__lo;
    var b$1__hi = b__hi;
    var alo = this$9__lo;
    var ahi = this$9__hi;
    var bhi = b$1__hi;
    var lo$4 = ((alo - b$1__lo) | 0);
    var hi$6 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0));
    return $$x3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$6))
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
    if (((op1Sign === op2Sign) && (cmp === 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
    };
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1
    };
    var resSign = $uI(x1___1);
    var resDigits = $asArrayOf_I(x1___2, 1);
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass({
  Ljava_math_Elementary$: 0
}, false, "java.math.Elementary$", {
  Ljava_math_Elementary$: 1,
  O: 1
});
$c_Ljava_math_Elementary$.prototype.$classData = $d_Ljava_math_Elementary$;
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$()
  };
  return $n_Ljava_math_Elementary$
}
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = setRoundingMode
}
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
  /*<skip>*/
}
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    var x2 = $as_Ljava_math_MathContext(x);
    if ((this.Ljava_math_MathContext__f_precision === x2.Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = x2.Ljava_math_MathContext__f_roundingMode;
      return (x$2 === x$3)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | this.Ljava_math_MathContext__f_roundingMode.jl_Enum__f__ordinal)
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode)
});
function $as_Ljava_math_MathContext(obj) {
  return (((obj instanceof $c_Ljava_math_MathContext) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.MathContext"))
}
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)))
}
function $asArrayOf_Ljava_math_MathContext(obj, depth) {
  return (($isArrayOf_Ljava_math_MathContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.MathContext;", depth))
}
var $d_Ljava_math_MathContext = new $TypeData().initClass({
  Ljava_math_MathContext: 0
}, false, "java.math.MathContext", {
  Ljava_math_MathContext: 1,
  O: 1
});
$c_Ljava_math_MathContext.prototype.$classData = $d_Ljava_math_MathContext;
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  this.Ljava_math_MathContext$__f_DECIMAL32 = null;
  this.Ljava_math_MathContext$__f_DECIMAL64 = null;
  this.Ljava_math_MathContext$__f_UNLIMITED = null;
  $n_Ljava_math_MathContext$ = this;
  $m_Ljava_math_MathContext$();
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  $m_Ljava_math_MathContext$();
  var roundingMode$1 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL32 = new $c_Ljava_math_MathContext(7, roundingMode$1);
  $m_Ljava_math_MathContext$();
  var roundingMode$2 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL64 = new $c_Ljava_math_MathContext(16, roundingMode$2);
  $m_Ljava_math_MathContext$();
  var roundingMode$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
  this.Ljava_math_MathContext$__f_UNLIMITED = new $c_Ljava_math_MathContext(0, roundingMode$3)
}
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
  /*<skip>*/
}
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass({
  Ljava_math_MathContext$: 0
}, false, "java.math.MathContext$", {
  Ljava_math_MathContext$: 1,
  O: 1
});
$c_Ljava_math_MathContext$.prototype.$classData = $d_Ljava_math_MathContext$;
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$()
  };
  return $n_Ljava_math_MathContext$
}
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem__lo = 0;
  var elem__hi = 0;
  var $$x1__lo = 1;
  var $$x1__hi = 0;
  elem__lo = $$x1__lo;
  elem__hi = $$x1__hi;
  var i = 0;
  while ((i < 32)) {
    var arg1 = i;
    if ((arg1 <= 18)) {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.set(arg1, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(elem__lo, elem__hi)));
      var $$x3 = $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows;
      var $$x2 = $m_Ljava_math_BigInteger$();
      var this$4__lo = elem__lo;
      var this$4__hi = elem__hi;
      var lo = this$4__lo;
      var lo$1 = (((32 & arg1) === 0) ? (lo << arg1) : 0);
      var hi = (((32 & arg1) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - arg1) | 0)) | 0) | (this$4__hi << arg1)) : (lo << arg1));
      $$x3.set(arg1, $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$1, hi)));
      var b__lo = elem__lo;
      var b__hi = elem__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$1;
      elem__lo = $$x4__lo;
      elem__hi = $$x4__hi
    } else {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.set(arg1, $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.get((((-1) + arg1) | 0)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.get(1)));
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.set(arg1, $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.get((((-1) + arg1) | 0)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN))
    };
    i = ((1 + i) | 0)
  }
}
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var arg1 = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.get(arg1);
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
    res.set(arg1, lo$1);
    elem = hi$4;
    i = ((1 + i) | 0)
  };
  return elem
}
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t)
  } else {
    var i = 0;
    while ((i < aLen)) {
      var arg1 = i;
      var elem = 0;
      elem = 0;
      var aI = a.get(arg1);
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var arg1$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.get(arg1$1);
        var c = t.get(((arg1 + arg1$1) | 0));
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
        t.set(((arg1 + arg1$1) | 0), lo$2);
        elem = hi$6;
        i$1 = ((1 + i$1) | 0)
      };
      t.set(((arg1 + bLen) | 0), elem);
      i = ((1 + i) | 0)
    }
  }
}
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((len > 0)) {
    var array = new $ac_I(len);
    var acc = 1;
    var i = 1;
    array.set(0, $uI(acc));
    while ((i < len)) {
      var arg1 = acc;
      var x$2 = $uI(arg1);
      acc = Math.imul(x$2, pow);
      array.set(i, $uI(acc));
      i = ((1 + i) | 0)
    };
    return array
  } else {
    return new $ac_I(0)
  }
}
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_FivePows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  this.Ljava_math_Multiplication$__f_FivePows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this)
}
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
  /*<skip>*/
}
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(bi, factor) {
  var resSign = bi.Ljava_math_BigInteger__f_sign;
  var aNumberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var aDigits = bi.Ljava_math_BigInteger__f_digits;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else if ((aNumberLength === 1)) {
    var a = aDigits.get(0);
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    resDigits.set(aNumberLength, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor));
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger = (function(bi, exp) {
  var value = this.Ljava_math_Multiplication$__f_TenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger(bi, this.Ljava_math_Multiplication$__f_TenPows.get(exp.RTLong__f_lo))
  } else {
    return bi.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.powerOf10__J__Ljava_math_BigInteger(exp))
  }
});
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var arg1 = i;
    elem = 0;
    var _\uff3fself = ((1 + arg1) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var arg1$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.get(arg1);
      var b = a.get(arg1$1);
      var c = res.get(((arg1 + arg1$1) | 0));
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + hi$2) | 0) : hi$2);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$4) | 0) : hi$4);
      res.set(((arg1 + arg1$1) | 0), lo$2);
      elem = hi$6;
      i$1 = ((1 + i$1) | 0)
    };
    res.set(((arg1 + aLen) | 0), elem);
    i = ((1 + i) | 0)
  };
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$3 = 0;
  var index = 0;
  while ((i$3 < aLen)) {
    var a$2 = a.get(i$3);
    var b$1 = a.get(i$3);
    var c$1 = res.get(index);
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((((-2147483648) ^ lo$4) < ((-2147483648) ^ lo$3)) ? ((1 + hi$9) | 0) : hi$9);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$11) | 0) : hi$11);
    res.set(index, lo$5);
    index = ((1 + index) | 0);
    var value = res.get(index);
    var lo$6 = ((hi$13 + value) | 0);
    var hi$15 = ((((-2147483648) ^ lo$6) < ((-2147483648) ^ hi$13)) ? 1 : 0);
    res.set(index, lo$6);
    elem = hi$15;
    i$3 = ((1 + i$3) | 0);
    index = ((1 + index) | 0)
  };
  return res
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if ((val2.Ljava_math_BigInteger__f_numberLength > val1.Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1
  } else {
    var x1___1 = val1;
    var x1___2 = val2
  };
  var op1 = $as_Ljava_math_BigInteger(x1___1);
  var op2 = $as_Ljava_math_BigInteger(x1___2);
  if ((op2.Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2)
  } else {
    var ndiv2 = (((-2) & op1.Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = op1.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = op2.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var bi = upperOp1.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, bi);
    var bi$1 = upperOp2.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp2, upperOp2));
    var this$1 = middle;
    var bi$2 = upper;
    var this$2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi$2);
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, lower);
    middle = middle.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = upper.shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$3 = upper;
    var bi$3 = middle;
    var this$4 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi$3);
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, lower)
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.set(bLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.get(0)))
    } else if ((bLen === 1)) {
      resDigits.set(aLen, $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.get(0)))
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen)
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = a.Ljava_math_BigInteger__f_numberLength;
  var bLen = b.Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.Ljava_math_BigInteger__f_sign !== b.Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.Ljava_math_BigInteger__f_digits.get(0);
    var b$1 = b.Ljava_math_BigInteger__f_digits.get(0);
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))))
  } else {
    var aDigits = a.Ljava_math_BigInteger__f_digits;
    var bDigits = b.Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if ((acc.Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = acc.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
    } else {
      var a = new $ac_I((acc.Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI(acc.Ljava_math_BigInteger__f_digits, acc.Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq)
    };
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2
  };
  return res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc)
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp) {
  var value = this.Ljava_math_Multiplication$__f_BigTenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? (((-2147483648) ^ exp.RTLong__f_lo) < ((-2147483648) ^ value)) : (ahi < hi))) {
    return this.Ljava_math_Multiplication$__f_BigTenPows.get(exp.RTLong__f_lo)
  } else {
    var ahi$1 = exp.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-2147483598)) : (ahi$1 < 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
    } else {
      var ahi$2 = exp.RTLong__f_hi;
      if (((ahi$2 === 0) ? (((-2147483648) ^ exp.RTLong__f_lo) <= (-1)) : (ahi$2 < 0))) {
        return this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo).shiftLeft__I__Ljava_math_BigInteger(exp.RTLong__f_lo)
      } else {
        var powerOfFive = this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(2147483647);
        var res = powerOfFive;
        var bhi = exp.RTLong__f_hi;
        var lo = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$1 = ((((-2147483648) ^ lo) < 1) ? bhi : (((-1) + bhi) | 0));
        var longExp__lo = lo;
        var longExp__hi = hi$1;
        var this$3 = $m_RTLong$();
        var lo$1 = this$3.remainderImpl__I__I__I__I__I(exp.RTLong__f_lo, exp.RTLong__f_hi, 2147483647, 0);
        while (true) {
          var this$4__lo = longExp__lo;
          var this$4__hi = longExp__hi;
          var ahi$3 = this$4__hi;
          if (((ahi$3 === 0) ? (((-2147483648) ^ this$4__lo) > (-1)) : (ahi$3 > 0))) {
            res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
            var b__lo = longExp__lo;
            var b__hi = longExp__hi;
            var bhi$1 = b__hi;
            var lo$2 = (((-2147483647) + b__lo) | 0);
            var hi$3 = ((((-2147483648) ^ lo$2) < 1) ? bhi$1 : (((-1) + bhi$1) | 0));
            var $$x1__lo = lo$2;
            var $$x1__hi = hi$3;
            longExp__lo = $$x1__lo;
            longExp__hi = $$x1__hi
          } else {
            break
          }
        };
        res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.Ljava_math_Multiplication$__f_BigFivePows.get(1).pow__I__Ljava_math_BigInteger(lo$1));
        res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var bhi$2 = exp.RTLong__f_hi;
        var lo$3 = (((-2147483647) + exp.RTLong__f_lo) | 0);
        var hi$4 = ((((-2147483648) ^ lo$3) < 1) ? bhi$2 : (((-1) + bhi$2) | 0));
        var $$x2__lo = lo$3;
        var $$x2__hi = hi$4;
        longExp__lo = $$x2__lo;
        longExp__hi = $$x2__hi;
        while (true) {
          var this$7__lo = longExp__lo;
          var this$7__hi = longExp__hi;
          var ahi$4 = this$7__hi;
          if (((ahi$4 === 0) ? (((-2147483648) ^ this$7__lo) > (-1)) : (ahi$4 > 0))) {
            res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
            var b$1__lo = longExp__lo;
            var b$1__hi = longExp__hi;
            var bhi$3 = b$1__hi;
            var lo$4 = (((-2147483647) + b$1__lo) | 0);
            var hi$5 = ((((-2147483648) ^ lo$4) < 1) ? bhi$3 : (((-1) + bhi$3) | 0));
            var $$x3__lo = lo$4;
            var $$x3__hi = hi$5;
            longExp__lo = $$x3__lo;
            longExp__hi = $$x3__hi
          } else {
            break
          }
        };
        return res.shiftLeft__I__Ljava_math_BigInteger(lo$1)
      }
    }
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass({
  Ljava_math_Multiplication$: 0
}, false, "java.math.Multiplication$", {
  Ljava_math_Multiplication$: 1,
  O: 1
});
$c_Ljava_math_Multiplication$.prototype.$classData = $d_Ljava_math_Multiplication$;
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$()
  };
  return $n_Ljava_math_Multiplication$
}
function $ct_Ljava_nio_Buffer__I__($thiz, _capacity) {
  $thiz.Ljava_nio_Buffer__f__capacity = _capacity;
  $thiz.Ljava_nio_Buffer__f__limit = $thiz.Ljava_nio_Buffer__f__capacity;
  $thiz.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  $thiz.Ljava_nio_Buffer__f__mark = (-1);
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_Buffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0
}
$c_Ljava_nio_Buffer.prototype = new $h_O();
$c_Ljava_nio_Buffer.prototype.constructor = $c_Ljava_nio_Buffer;
/** @constructor */
function $h_Ljava_nio_Buffer() {
  /*<skip>*/
}
$h_Ljava_nio_Buffer.prototype = $c_Ljava_nio_Buffer.prototype;
$c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer = (function(newPosition) {
  if (((newPosition < 0) || (newPosition > this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPosition;
  if ((this.Ljava_nio_Buffer__f__mark > newPosition)) {
    this.Ljava_nio_Buffer__f__mark = (-1)
  };
  return this
});
$c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer = (function(newLimit) {
  if (((newLimit < 0) || (newLimit > this.Ljava_nio_Buffer__f__capacity))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  this.Ljava_nio_Buffer__f__limit = newLimit;
  if ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position > newLimit)) {
    this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newLimit;
    if ((this.Ljava_nio_Buffer__f__mark > newLimit)) {
      this.Ljava_nio_Buffer__f__mark = (-1)
    }
  };
  return this
});
$c_Ljava_nio_Buffer.prototype.toString__T = (function() {
  return ((((((($objectClassName(this) + "[pos=") + this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) + " lim=") + this.Ljava_nio_Buffer__f__limit) + " cap=") + this.Ljava_nio_Buffer__f__capacity) + "]")
});
/** @constructor */
function $c_Ljava_nio_ByteBuffer$() {
  /*<skip>*/
}
$c_Ljava_nio_ByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_ByteBuffer$.prototype.constructor = $c_Ljava_nio_ByteBuffer$;
/** @constructor */
function $h_Ljava_nio_ByteBuffer$() {
  /*<skip>*/
}
$h_Ljava_nio_ByteBuffer$.prototype = $c_Ljava_nio_ByteBuffer$.prototype;
$c_Ljava_nio_ByteBuffer$.prototype.allocate__I__Ljava_nio_ByteBuffer = (function(capacity) {
  var array = new $ac_B(capacity);
  var length = array.u.length;
  return $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false)
});
var $d_Ljava_nio_ByteBuffer$ = new $TypeData().initClass({
  Ljava_nio_ByteBuffer$: 0
}, false, "java.nio.ByteBuffer$", {
  Ljava_nio_ByteBuffer$: 1,
  O: 1
});
$c_Ljava_nio_ByteBuffer$.prototype.$classData = $d_Ljava_nio_ByteBuffer$;
var $n_Ljava_nio_ByteBuffer$;
function $m_Ljava_nio_ByteBuffer$() {
  if ((!$n_Ljava_nio_ByteBuffer$)) {
    $n_Ljava_nio_ByteBuffer$ = new $c_Ljava_nio_ByteBuffer$()
  };
  return $n_Ljava_nio_ByteBuffer$
}
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer$() {
  /*<skip>*/
}
$c_Ljava_nio_HeapByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_HeapByteBuffer$.prototype.constructor = $c_Ljava_nio_HeapByteBuffer$;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer$() {
  /*<skip>*/
}
$h_Ljava_nio_HeapByteBuffer$.prototype = $c_Ljava_nio_HeapByteBuffer$.prototype;
$c_Ljava_nio_HeapByteBuffer$.prototype.wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer = (function(array, arrayOffset, capacity, initialPosition, initialLength, isReadOnly) {
  if ((((arrayOffset < 0) || (capacity < 0)) || (((arrayOffset + capacity) | 0) > array.u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  return new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, initialLimit, isReadOnly)
});
var $d_Ljava_nio_HeapByteBuffer$ = new $TypeData().initClass({
  Ljava_nio_HeapByteBuffer$: 0
}, false, "java.nio.HeapByteBuffer$", {
  Ljava_nio_HeapByteBuffer$: 1,
  O: 1
});
$c_Ljava_nio_HeapByteBuffer$.prototype.$classData = $d_Ljava_nio_HeapByteBuffer$;
var $n_Ljava_nio_HeapByteBuffer$;
function $m_Ljava_nio_HeapByteBuffer$() {
  if ((!$n_Ljava_nio_HeapByteBuffer$)) {
    $n_Ljava_nio_HeapByteBuffer$ = new $c_Ljava_nio_HeapByteBuffer$()
  };
  return $n_Ljava_nio_HeapByteBuffer$
}
/** @constructor */
function $c_ju_Arrays$() {
  /*<skip>*/
}
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
  /*<skip>*/
}
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.sort__AI__V = (function(a) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  var evidence$3 = $m_s_math_Ordering$Int$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_I(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AJ__V = (function(a) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  var evidence$3 = $m_s_math_Ordering$Long$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_J(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AS__V = (function(a) {
  $m_s_reflect_ManifestFactory$ShortManifest$();
  var evidence$3 = $m_s_math_Ordering$Short$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_S(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AC__V = (function(a) {
  $m_s_reflect_ManifestFactory$CharManifest$();
  var evidence$3 = $m_s_math_Ordering$Char$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_C(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AB__V = (function(a) {
  $m_s_reflect_ManifestFactory$ByteManifest$();
  var evidence$3 = $m_s_math_Ordering$Byte$();
  var end = a.u.length;
  if ((end > 16)) {
    var len = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, new $ac_B(len), 0, end, evidence$3)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, 0, end, evidence$3)
  }
});
$c_ju_Arrays$.prototype.sort__AO__ju_Comparator__V = (function(array, comparator) {
  var ord = ((comparator === null) ? new $c_ju_Arrays$$anon$1() : new $c_ju_Arrays$$anon$3(comparator));
  var end = array.u.length;
  if ((end > 16)) {
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(array, new $ac_O(array.u.length), 0, end, ord)
  } else {
    this.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V(array, 0, end, ord)
  }
});
$c_ju_Arrays$.prototype.sort__AO__I__I__ju_Comparator__V = (function(array, fromIndex, toIndex, comparator) {
  var ord = ((comparator === null) ? new $c_ju_Arrays$$anon$1() : new $c_ju_Arrays$$anon$3(comparator));
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    array.get(fromIndex)
  };
  if ((toIndex > 0)) {
    array.get((((-1) + toIndex) | 0))
  };
  if ((((toIndex - fromIndex) | 0) > 16)) {
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(array, new $ac_O(array.u.length), fromIndex, toIndex, ord)
  } else {
    this.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V(array, fromIndex, toIndex, ord)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V = (function(a, temp, start, end, ord) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, temp, start, middle, ord);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__s_math_Ordering__V(a, temp, middle, end, ord);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ord.lteq__O__O__Z($m_sr_ScalaRunTime$().array_apply__O__I__O(a, leftInIndex), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, rightInIndex))))) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(temp, outIndex, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0)
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(temp, outIndex, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0)
      };
      outIndex = ((1 + outIndex) | 0)
    };
    temp.copyTo(start, a, start, length)
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V(a, start, end, ord)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, start, end, ord) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, start), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + start) | 0))) > 0)) {
      var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, start);
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, start, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + start) | 0)));
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + start) | 0), temp)
    };
    var m = 2;
    while ((m < n)) {
      var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((start + m) | 0));
      if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
            iB = ix
          } else {
            iA = ix
          }
        };
        var ix$2 = ((iA + ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
          i = (((-1) + i) | 0)
        };
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next)
      };
      m = ((1 + m) | 0)
    }
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V = (function(a, temp, start, end, ord) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(a, temp, start, middle, ord);
    this.java$util$Arrays$$stableSplitMergeAnyRef__AO__AO__I__I__s_math_Ordering__V(a, temp, middle, end, ord);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || ord.lteq__O__O__Z(a.get(leftInIndex), a.get(rightInIndex))))) {
        temp.set(outIndex, a.get(leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0)
      } else {
        temp.set(outIndex, a.get(rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0)
      };
      outIndex = ((1 + outIndex) | 0)
    };
    temp.copyTo(start, a, start, length)
  } else {
    this.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V(a, start, end, ord)
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSortAnyRef__AO__I__I__s_math_Ordering__V = (function(a, start, end, ord) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    if ((ord.compare__O__O__I(a.get(start), a.get(((1 + start) | 0))) > 0)) {
      var temp = a.get(start);
      a.set(start, a.get(((1 + start) | 0)));
      a.set(((1 + start) | 0), temp)
    };
    var m = 2;
    while ((m < n)) {
      var next = a.get(((start + m) | 0));
      if ((ord.compare__O__O__I(next, a.get((((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((ord.compare__O__O__I(next, a.get(ix)) < 0)) {
            iB = ix
          } else {
            iA = ix
          }
        };
        var ix$2 = ((iA + ((ord.compare__O__O__I(next, a.get(iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          a.set(i, a.get((((-1) + i) | 0)));
          i = (((-1) + i) | 0)
        };
        a.set(ix$2, next)
      };
      m = ((1 + m) | 0)
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var t = a.get(mid);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = $uJ(new $c_RTLong(lo, hi));
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var ahi = key.RTLong__f_hi;
      if (((ahi === hi$1) ? (((-2147483648) ^ key.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi < hi$1))) {
        endIndex = mid
      } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, new $c_RTLong(lo, hi))) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0)
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.get(mid);
      if ((key < elem)) {
        endIndex = mid
      } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, elem)) {
        return mid
      } else {
        startIndex = ((1 + mid) | 0)
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var t = a.get(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = b.get(i);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($bC(x), $bC(y)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AD__AD__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.equals__AF__AF__Z = (function(a, b) {
  if ((a === b)) {
    return true
  };
  if (((a === null) || (b === null))) {
    return false
  };
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false
  };
  var i = 0;
  while ((i !== len)) {
    var x = a.get(i);
    var y = b.get(i);
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_ju_Arrays$.prototype.fill__AJ__I__I__J__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"))
  };
  if ((fromIndex < 0)) {
    a.get(fromIndex)
  };
  if ((toIndex > 0)) {
    a.get((((-1) + toIndex) | 0))
  };
  var i = fromIndex;
  while ((i !== toIndex)) {
    a.set(i, value);
    i = ((1 + i) | 0)
  }
});
$c_ju_Arrays$.prototype.fill__AO__O__V = (function(a, value) {
  var toIndex = a.u.length;
  var i = 0;
  while ((i !== toIndex)) {
    a.set(i, value);
    i = ((1 + i) | 0)
  }
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  var tagT = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(original).getComponentType__jl_Class());
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = tagT.newArray__I__O(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOf__AO__I__jl_Class__AO = (function(original, newLength, newType) {
  var tag = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag(newType.getComponentType__jl_Class());
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = tag.newArray__I__O(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOf__AB__I__AB = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$ByteManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AS__I__AS = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$ShortManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AI__I__AI = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AJ__I__AJ = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AC__I__AC = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$CharManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AF__I__AF = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$FloatManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AD__I__AD = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$DoubleManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOf__AZ__I__AZ = (function(original, newLength) {
  $m_s_reflect_ManifestFactory$BooleanManifest$();
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  var evidence$6 = $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(original).getComponentType__jl_Class());
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to))
  };
  var retLength = ((to - from) | 0);
  var b = ((original.u.length - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = evidence$6.newArray__I__O(retLength);
  original.copyTo(from, ret, 0, copyLength);
  return $asArrayOf_O(ret, 1)
});
$c_ju_Arrays$.prototype.copyOfRange__AB__I__I__AB = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$ByteManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AS__I__I__AS = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$ShortManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AI__I__I__AI = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AJ__I__I__AJ = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AC__I__I__AC = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$CharManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AF__I__I__AF = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$FloatManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AD__I__I__AD = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$DoubleManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
$c_ju_Arrays$.prototype.copyOfRange__AZ__I__I__AZ = (function(original, start, end) {
  $m_s_reflect_ManifestFactory$BooleanManifest$();
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end))
  };
  var retLength = ((end - start) | 0);
  var b = ((original.u.length - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret
});
var $d_ju_Arrays$ = new $TypeData().initClass({
  ju_Arrays$: 0
}, false, "java.util.Arrays$", {
  ju_Arrays$: 1,
  O: 1
});
$c_ju_Arrays$.prototype.$classData = $d_ju_Arrays$;
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$()
  };
  return $n_ju_Arrays$
}
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)))
}
function $as_ju_Map(obj) {
  return (($is_ju_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map"))
}
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)))
}
function $asArrayOf_ju_Map(obj, depth) {
  return (($isArrayOf_ju_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map;", depth))
}
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)))
}
function $as_ju_Map$Entry(obj) {
  return (($is_ju_Map$Entry(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Map$Entry"))
}
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)))
}
function $asArrayOf_ju_Map$Entry(obj, depth) {
  return (($isArrayOf_ju_Map$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Map$Entry;", depth))
}
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.ju_regex_PatternCompiler__f_pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex)
}
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp.exec($thiz.ju_regex_PatternCompiler__f_pattern);
  if ((m !== null)) {
    var value = m[1];
    if ((value !== (void 0))) {
      var chars = $as_T(value);
      var end = $uI(chars.length);
      var i = 0;
      while ((i < end)) {
        var arg1 = i;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags | $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$charToFlag__C__I((65535 & $uI(chars.charCodeAt(arg1)))));
        i = ((1 + i) | 0)
      }
    };
    if (((256 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags)
    };
    var value$1 = m[2];
    if ((value$1 !== (void 0))) {
      var chars$3 = $as_T(value$1);
      var end$1 = $uI(chars$3.length);
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var arg1$1 = i$1;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags & (~$m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$charToFlag__C__I((65535 & $uI(chars$3.charCodeAt(arg1$1))))));
        i$1 = ((1 + i$1) | 0)
      }
    };
    var $$x1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var value$2 = m[0];
    if ((value$2 === (void 0))) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
    };
    var this$19 = $as_T(value$2);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($$x1 + $uI(this$19.length)) | 0)
  }
}
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var len = $uI(s.length);
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I(s, i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0)
  };
  return result
}
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break
      }
      default: {
        return (((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 2) ? s : (((cp >= 65) && (cp <= 90)) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + cp) | 0))) + "]") : (((cp >= 97) && (cp <= 122)) ? ((("[" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + cp) | 0))) + s) + "]") : s)))
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s)
  }
}
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = (65535 & $uI(pattern.charCodeAt(index)));
      switch (x1) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          continue;
          break
        }
        case 35: {
          $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          continue;
          break
        }
      }
    };
    break
  }
}
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var repeaterDispatchChar = ((startOfRepeater === len) ? 46 : (65535 & $uI(pattern.charCodeAt(startOfRepeater))));
  if (((((repeaterDispatchChar === 63) || (repeaterDispatchChar === 42)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = (65535 & $uI(pattern.charCodeAt(index)));
      switch (x1) {
        case 43: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater);
          break
        }
        case 63: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return ((("" + compiledToken) + baseRepeater) + "?");
          break
        }
        default: {
          return (("" + compiledToken) + baseRepeater)
        }
      }
    } else {
      return (("" + compiledToken) + baseRepeater)
    }
  } else {
    return compiledToken
  }
}
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((repeaterDispatchChar === 123)) {
    var len = $uI(pattern.length);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $$x1 = true
    } else {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = (65535 & $uI(pattern.charCodeAt(index)));
      var $$x1 = (!((c >= 48) && (c <= 57)))
    };
    if ($$x1) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    while (true) {
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
        var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var c$1 = (65535 & $uI(pattern.charCodeAt(index$1)));
        var $$x2 = ((c$1 >= 48) && (c$1 <= 57))
      } else {
        var $$x2 = false
      };
      if ($$x2) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
      } else {
        break
      }
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    if (((65535 & $uI(pattern.charCodeAt(index$2))) === 44)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      while (true) {
        if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
          var index$3 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c$2 = (65535 & $uI(pattern.charCodeAt(index$3)));
          var $$x3 = ((c$2 >= 48) && (c$2 <= 57))
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
        } else {
          break
        }
      }
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $$x4 = true
    } else {
      var index$4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var $$x4 = ((65535 & $uI(pattern.charCodeAt(index$4))) !== 125)
    };
    if ($$x4) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition")
    };
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
  };
  var endIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  return $as_T(pattern.substring(startOfRepeater, endIndex))
}
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length);
  var i = 0;
  while ((i < end)) {
    var arg1 = i;
    var mapped = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[arg1]);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[arg1] = ((1 + mapped) | 0)
    };
    i = ((1 + i) | 0)
  };
  var amendedToken = $as_T(compiledToken.replace($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp, ((arg$outer, compiledGroupCountBeforeThisToken$1) => ((arg1$2, arg2$2, arg3$2) => {
    var arg1$1 = $as_T(arg1$2);
    var arg2 = $as_T(arg2$2);
    var arg3 = $as_T(arg3$2);
    return arg$outer.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T(arg1$1, arg2, arg3, compiledGroupCountBeforeThisToken$1)
  }))($thiz, compiledGroupCountBeforeThisToken)));
  $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")")
}
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  if ((((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern")
  };
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var dispatchChar = (65535 & $uI(pattern.charCodeAt(index)));
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = cls.ju_regex_PatternCompiler$CompiledCharClass__f_kind;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break
        }
        case 1: {
          return (("\\P{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break
        }
        case 2: {
          return (("[" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "]");
          break
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(cls.ju_regex_PatternCompiler$CompiledCharClass__f_data);
          break
        }
        default: {
          throw new $c_s_MatchError(x1$2)
        }
      };
      break
    }
    case 98: {
      var beginIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var endIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($as_T(pattern.substring(beginIndex, endIndex)) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported")
      } else if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\b with UNICODE_CASE", "2018")
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\b"
      };
      break
    }
    case 66: {
      if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\B with UNICODE_CASE", "2018")
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\B"
      };
      break
    }
    case 65: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:^)";
      break
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break
    }
    case 90: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var lineTerminator = (((1 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])");
      return (("(?=" + lineTerminator) + "?$)");
      break
    }
    case 122: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:$)";
      break
    }
    case 82: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var end = ((1 + start) | 0);
      while (true) {
        if ((end !== len)) {
          var index$1 = end;
          var c = (65535 & $uI(pattern.charCodeAt(index$1)));
          var $$x2 = ((c >= 48) && (c <= 57))
        } else {
          var $$x2 = false
        };
        if ($$x2) {
          var endIndex$1 = ((1 + end) | 0);
          var s = $as_T(pattern.substring(start, endIndex$1));
          var $$x1 = ($uI(parseInt(s, 10)) <= (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          end = ((1 + end) | 0)
        } else {
          break
        }
      };
      var endIndex$2 = end;
      var groupString = $as_T(pattern.substring(start, endIndex$2));
      var groupNumber = $uI(parseInt(groupString, 10));
      if ((groupNumber > (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"))
      };
      var compiledGroupNumber = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break
    }
    case 107: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
        var $$x3 = true
      } else {
        var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var $$x3 = ((65535 & $uI(pattern.charCodeAt(index$2))) !== 60)
      };
      if ($$x3) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
      var x1 = ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, groupName)) ? new $c_s_Some(dict[groupName]) : $m_s_None$());
      if ((!(x1 instanceof $c_s_Some))) {
        var x = $m_s_None$();
        if ((x === x1)) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"))
        };
        throw new $c_s_MatchError(x1)
      };
      var x2 = $as_s_Some(x1);
      var v = x2.s_Some__f_value;
      var groupNumber$2 = $uI(v);
      var compiledGroupNumber$2 = $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber$2]);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break
    }
    case 81: {
      var start$2 = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var end$2 = $uI(pattern.indexOf("\\E", start$2));
      if ((end$2 < 0)) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = $uI(pattern.length);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2)))
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, $as_T(pattern.substring(start$2, end$2)))
      };
      break
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz))
    }
  }
}
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var x1 = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break
    }
    case 97: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 7;
      break
    }
    case 116: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 9;
      break
    }
    case 110: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 10;
      break
    }
    case 102: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 12;
      break
    }
    case 114: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 13;
      break
    }
    case 101: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 27;
      break
    }
    case 99: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === $uI(pattern.length))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence")
      };
      var cp = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break
    }
    default: {
      if ((((x1 >= 65) && (x1 <= 90)) || ((x1 >= 97) && (x1 <= 122)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence")
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1
    }
  }
}
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) < len)) {
    var index = ((1 + start) | 0);
    var d1 = (((-48) + (65535 & $uI(pattern.charCodeAt(index)))) | 0)
  } else {
    var d1 = (-1)
  };
  if (((d1 < 0) || (d1 > 7))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence")
  };
  if ((((2 + start) | 0) < len)) {
    var index$1 = ((2 + start) | 0);
    var d2 = (((-48) + (65535 & $uI(pattern.charCodeAt(index$1)))) | 0)
  } else {
    var d2 = (-1)
  };
  if (((d2 < 0) || (d2 > 7))) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return d1
  } else if ((d1 > 3)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return (((d1 << 3) + d2) | 0)
  } else {
    if ((((3 + start) | 0) < len)) {
      var index$2 = ((3 + start) | 0);
      var d3 = (((-48) + (65535 & $uI(pattern.charCodeAt(index$2)))) | 0)
    } else {
      var d3 = (-1)
    };
    if (((d3 < 0) || (d3 > 7))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((d1 << 3) + d2) | 0)
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0)
    }
  }
}
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (((start !== len) && ((65535 & $uI(pattern.charCodeAt(start))) === 123))) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = $uI(pattern.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence")
    };
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + innerEnd) | 0);
    return cp
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + start) | 0);
    return cp$2
  }
}
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && ($as_T(pattern.substring(end, lowStart)) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low))
    } else {
      return codeUnit
    }
  } else {
    return codeUnit
  }
}
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  if (((start === end) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"))
  };
  var i = start;
  while ((i < end)) {
    var arg1 = i;
    var c = (65535 & $uI(pattern.charCodeAt(arg1)));
    if ((!((((c >= 48) && (c <= 57)) || ((c >= 65) && (c <= 70))) || ((c >= 97) && (c <= 102))))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"))
    };
    i = ((1 + i) | 0)
  };
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112
  } else {
    var s = $as_T(pattern.substring(start, end));
    var cp = $uI(parseInt(s, 16))
  };
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big")
  };
  return cp
}
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit;
      break
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace;
      break
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace;
      break
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace;
      break
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar;
      break
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break
    }
    default: {
      var positive;
      throw new $c_s_MatchError($bC(dispatchChar))
    }
  };
  return ((dispatchChar >= 97) ? positive : positive.negated__ju_regex_PatternCompiler$CompiledCharClass())
}
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((start === len)) {
    var property = "?"
  } else if (((65535 & $uI(pattern.charCodeAt(start))) === 123)) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = $uI(pattern.indexOf("}", innerStart));
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family")
    };
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = innerEnd;
    var property = $as_T(pattern.substring(innerStart, innerEnd))
  } else {
    var endIndex = ((1 + start) | 0);
    var property = $as_T(pattern.substring(start, endIndex))
  };
  var dict = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, property)))) {
    $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Unicode character family", "2018")
  };
  var property2 = ((((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!$uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict$1, property2)))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + property2))
  };
  var result = $as_ju_regex_PatternCompiler$CompiledCharClass(dict$1[property2]);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  return result
}
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var isNegated = ((65535 & $uI(pattern.charCodeAt(index))) === 94)
  } else {
    var isNegated = false
  };
  if (isNegated) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
  };
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2), isNegated);
  while (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var x1 = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return builder.finish__T();
          break
        }
        case 38: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
            var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
            var $$x1 = ((65535 & $uI(pattern.charCodeAt(index$1))) === 38)
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            builder.startNewConjunct__V()
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder)
          };
          break matchResult;
          break
        }
        case 91: {
          var cls = $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz);
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, cls);
          break matchResult;
          break
        }
        case 92: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence")
          };
          var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c2 = (65535 & $uI(pattern.charCodeAt(index$2)));
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break
            }
            case 81: {
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
              var fromIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
              var end = $uI(pattern.indexOf("\\E", fromIndex));
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
              };
              builder.addCodePointsInString__T__I__I__V(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, end);
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end) | 0);
              break
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder)
            }
          };
          break matchResult;
          break
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
          } else {
            break
          };
          break matchResult;
          break
        }
        case 35: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V()
          } else {
            break
          };
          break matchResult;
          break
        }
      };
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder)
    }
  };
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
}
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) === len)) {
    var $$x1 = true
  } else {
    var index = ((1 + start) | 0);
    var $$x1 = ((65535 & $uI(pattern.charCodeAt(index))) !== 63)
  };
  if ($$x1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + start) | 0);
    $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
    return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group")
    };
    var index$1 = ((2 + start) | 0);
    var c1 = (65535 & $uI(pattern.charCodeAt(index$1)));
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      var endIndex = ((3 + start) | 0);
      return ((("" + $as_T(pattern.substring(start, endIndex))) + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group")
      };
      var index$2 = ((3 + start) | 0);
      var c2 = (65535 & $uI(pattern.charCodeAt(index$2)));
      if ((((c2 >= 65) && (c2 <= 90)) || ((c2 >= 97) && (c2 <= 122)))) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, name))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"))
        };
        $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
        var dict$1 = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        var value = (((-1) + $uI($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0);
        dict$1[name] = value;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")")
      } else {
        if (((c2 !== 61) && (c2 !== 33))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group")
        };
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Look-behind group", "2018")
      }
    } else if ((c1 === 62)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
      var groupNumber = $thiz.ju_regex_PatternCompiler__f_compiledGroupCount;
      return (((("(?:(?=(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + "))\\") + groupNumber) + ")")
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported")
    }
  }
}
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = (65535 & $uI(pattern.charCodeAt(index)));
      var $$x1 = ((((c >= 65) && (c <= 90)) || ((c >= 97) && (c <= 122))) || ((c >= 48) && (c <= 57)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    } else {
      break
    }
  };
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
    var $$x2 = true
  } else {
    var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $$x2 = ((65535 & $uI(pattern.charCodeAt(index$1))) !== 62)
  };
  if ($$x2) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'")
  };
  var endIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  return $as_T(pattern.substring(start, endIndex))
}
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz)
  };
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len$2)) {
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $$x1 = ((65535 & $uI(pattern$3.charCodeAt(index))) === 45)
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz)
    };
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class")
    };
    var cpEnd = $f_T__codePointAt__I__I(pattern$3, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      builder$1.addSingleCodePoint__I__V(startCodePoint);
      builder$1.addSingleCodePoint__I__V(45)
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range")
      };
      builder$1.addCodePointRange__I__I__V(startCodePoint, endCodePoint)
    }
  } else {
    builder$1.addSingleCodePoint__I__V(startCodePoint)
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.ju_regex_PatternCompiler__f_pattern = null;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = 0;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = null;
  this.ju_regex_PatternCompiler__f_namedGroups = null;
  this.ju_regex_PatternCompiler__f_pattern = pattern;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = flags;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = [0];
  this.ju_regex_PatternCompiler__f_namedGroups = {}
}
$c_ju_regex_PatternCompiler.prototype = new $h_O();
$c_ju_regex_PatternCompiler.prototype.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler.prototype = $c_ju_regex_PatternCompiler.prototype;
$c_ju_regex_PatternCompiler.prototype.compile__ju_regex_Pattern = (function() {
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags)
  };
  var isLiteral = ((16 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this)
  };
  if (((128 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported")
  };
  if (((8 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("MULTILINE", "2018")
  };
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("UNICODE_CHARACTER_CLASS", "2018")
  };
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.ju_regex_PatternCompiler__f_pattern)
  } else {
    var this$5 = this.ju_regex_PatternCompiler__f_pattern;
    var beginIndex = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var endIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (($as_T(this$5.substring(beginIndex, endIndex)) === "\\G")) {
      this.ju_regex_PatternCompiler__f_sticky = true;
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    };
    var jsPattern = this.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(false)
  };
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "us" : "u");
  var jsFlags = (((66 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.ju_regex_PatternCompiler__f_pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags, jsPattern, jsFlags, this.ju_regex_PatternCompiler__f_sticky, (((-1) + $uI(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length)) | 0), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap, this.ju_regex_PatternCompiler__f_namedGroups)
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."))
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T = (function(insideGroup) {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  var result = "";
  while ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I(pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'")
          };
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return result;
          break
        }
        case 124: {
          if ((this.ju_regex_PatternCompiler__f_sticky && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level")
          };
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          result = (result + "|");
          break matchResult;
          break
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
          } else {
            break
          };
          break matchResult;
          break
        }
        case 35: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.java$util$regex$PatternCompiler$$skipSharpComment__V()
          } else {
            break
          };
          break matchResult;
          break
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(dispatchCP)) + "'"));
          break
        }
      };
      var compiledGroupCountBeforeThisToken = this.ju_regex_PatternCompiler__f_compiledGroupCount;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break
        }
        case 94: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "(?:^)";
          break
        }
        case 36: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "(?:$)";
          break
        }
        case 46: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var rejected = (((32 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "" : (((1 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(rejected);
          break
        }
        default: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP)
        }
      };
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken))
    }
  };
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group")
  };
  return result
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$skipSharpComment__V = (function() {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var len = $uI(pattern.length);
  while (true) {
    if ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = (65535 & $uI(pattern.charCodeAt(index)));
      var $$x1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)
    } else {
      break
    }
  }
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$$anonfun$buildPossessiveQuantifier$2__T__T__T__I__T = (function(str, backslashes, groupString, compiledGroupCountBeforeThisToken$1) {
  if (((($uI(backslashes.length) % 2) | 0) === 0)) {
    return str
  } else {
    var groupNumber = $uI(parseInt(groupString, 10));
    return ((groupNumber > compiledGroupCountBeforeThisToken$1) ? (("" + backslashes) + ((1 + groupNumber) | 0)) : str)
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().initClass({
  ju_regex_PatternCompiler: 0
}, false, "java.util.regex.PatternCompiler", {
  ju_regex_PatternCompiler: 1,
  O: 1
});
$c_ju_regex_PatternCompiler.prototype.$classData = $d_ju_regex_PatternCompiler;
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 instanceof $c_sjs_js_JavaScriptException)) {
      return false
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$predefinedPCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$canonicalizedScriptNameCache = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = null;
  this.ju_regex_PatternCompiler$__f_bitmap$0 = 0;
  $n_ju_regex_PatternCompiler$ = this;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = new RegExp("(\\\\+)(\\d+)", "g");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsIndices = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var array = [new $c_T2("Lower", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z")), new $c_T2("Upper", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z")), new $c_T2("ASCII", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f")), new $c_T2("Alpha", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z")), new $c_T2("Digit", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9")), new $c_T2("Alnum", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z")), new $c_T2("Punct", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~")), new $c_T2("Graph", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~")), new $c_T2("Print", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~")), new $c_T2("Blank", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ")), new $c_T2("Cntrl", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f")), new $c_T2("XDigit", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f")), new $c_T2("Space", new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r "))];
  var properties = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = $m_sjs_js_special_package$().objectLiteral__sci_Seq__sjs_js_Object(properties);
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = new RegExp("(?:^|_)[a-z]", "g")
}
$c_ju_regex_PatternCompiler$.prototype = new $h_O();
$c_ju_regex_PatternCompiler$.prototype.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$.prototype = $c_ju_regex_PatternCompiler$.prototype;
$c_ju_regex_PatternCompiler$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).compile__ju_regex_Pattern()
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break
    }
    case 100: {
      return 1;
      break
    }
    case 109: {
      return 8;
      break
    }
    case 115: {
      return 32;
      break
    }
    case 117: {
      return 64;
      break
    }
    case 120: {
      return 4;
      break
    }
    case 85: {
      return 256;
      break
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag")
    }
  }
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointNotAmong__T__T = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "." : "[\\d\\D]"))
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointToString__I__T = (function(codePoint) {
  return $as_T(String.fromCodePoint(codePoint))
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().initClass({
  ju_regex_PatternCompiler$: 0
}, false, "java.util.regex.PatternCompiler$", {
  ju_regex_PatternCompiler$: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$.prototype.$classData = $d_ju_regex_PatternCompiler$;
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$()
  };
  return $n_ju_regex_PatternCompiler$
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "")) {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = alt
  } else {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct + "|") + alt)
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? negThisSegment : (((("(?:(?!" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")") + negThisSegment) + ")"))
  } else {
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment === "") ? (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")")) : (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? (("[" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "]") : (((("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + "|[") + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "])")))
  }
}
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(codePoint);
  return (((((codePoint === 93) || (codePoint === 92)) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s)
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = asciiCaseInsensitive;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = isNegated;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ""
}
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype;
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.finish__T = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction === "") ? conjunct : ((("(?:" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction) + conjunct) + ")"))
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.startNewConjunct__V = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction + (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ""
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V = (function(cls) {
  var x1 = cls.ju_regex_PatternCompiler$CompiledCharClass__f_kind;
  switch (x1) {
    case 0: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\p{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break
    }
    case 1: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\P{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break
    }
    case 2: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data);
      break
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(cls.ju_regex_PatternCompiler$CompiledCharClass__f_data));
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointsInString__T__I__I__V = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I(str, i);
    this.addSingleCodePoint__I__V(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0)
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addSingleCodePoint__I__V = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + s) + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment)
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + s)
  };
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    if (((codePoint >= 65) && (codePoint <= 90))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + codePoint) | 0)))
    } else if (((codePoint >= 97) && (codePoint <= 122))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + codePoint) | 0)))
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointRange__I__I__V = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (s + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment)
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + s)
  };
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $$x1 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($$x1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)))
    };
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $$x2 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$3 = (((-32) + start$2) | 0);
      var end$3 = (((-32) + end$2) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($$x2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)))
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().initClass({
  ju_regex_PatternCompiler$CharacterClassBuilder: 0
}, false, "java.util.regex.PatternCompiler$CharacterClassBuilder", {
  ju_regex_PatternCompiler$CharacterClassBuilder: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.$classData = $d_ju_regex_PatternCompiler$CharacterClassBuilder;
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0)) {
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_kind), $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_data);
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = true
  };
  return $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated
}
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.ju_regex_PatternCompiler$CompiledCharClass__f_negated = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = 0;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = false;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = kind;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = data
}
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
  /*<skip>*/
}
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype;
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.negated__ju_regex_PatternCompiler$CompiledCharClass = (function() {
  return ((!this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.ju_regex_PatternCompiler$CompiledCharClass__f_negated)
});
function $as_ju_regex_PatternCompiler$CompiledCharClass(obj) {
  return (((obj instanceof $c_ju_regex_PatternCompiler$CompiledCharClass) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.regex.PatternCompiler$CompiledCharClass"))
}
function $isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_regex_PatternCompiler$CompiledCharClass)))
}
function $asArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) {
  return (($isArrayOf_ju_regex_PatternCompiler$CompiledCharClass(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.regex.PatternCompiler$CompiledCharClass;", depth))
}
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().initClass({
  ju_regex_PatternCompiler$CompiledCharClass: 0
}, false, "java.util.regex.PatternCompiler$CompiledCharClass", {
  ju_regex_PatternCompiler$CompiledCharClass: 1,
  O: 1
});
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.$classData = $d_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $c_RTLong(lo, hi) {
  this.RTLong__f_lo = 0;
  this.RTLong__f_hi = 0;
  this.RTLong__f_lo = lo;
  this.RTLong__f_hi = hi
}
$c_RTLong.prototype = new $h_O();
$c_RTLong.prototype.constructor = $c_RTLong;
/** @constructor */
function $h_RTLong() {
  /*<skip>*/
}
$h_RTLong.prototype = $c_RTLong.prototype;
$c_RTLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_RTLong(that);
    return ((this.RTLong__f_lo === x2.RTLong__f_lo) && (this.RTLong__f_hi === x2.RTLong__f_hi))
  } else {
    return false
  }
});
$c_RTLong.prototype.hashCode__I = (function() {
  return (this.RTLong__f_lo ^ this.RTLong__f_hi)
});
$c_RTLong.prototype.toString__T = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toInt__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.toFloat__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.toDouble__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.byteValue__B = (function() {
  return ((this.RTLong__f_lo << 24) >> 24)
});
$c_RTLong.prototype.shortValue__S = (function() {
  return ((this.RTLong__f_lo << 16) >> 16)
});
$c_RTLong.prototype.intValue__I = (function() {
  return this.RTLong__f_lo
});
$c_RTLong.prototype.longValue__J = (function() {
  return $uJ(this)
});
$c_RTLong.prototype.floatValue__F = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.doubleValue__D = (function() {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this.RTLong__f_lo, this.RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__O__I = (function(that) {
  var b = $as_RTLong(that);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi)
});
$c_RTLong.prototype.compareTo__jl_Long__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi)
});
$c_RTLong.prototype.equals__RTLong__Z = (function(b) {
  return ((this.RTLong__f_lo === b.RTLong__f_lo) && (this.RTLong__f_hi === b.RTLong__f_hi))
});
$c_RTLong.prototype.notEquals__RTLong__Z = (function(b) {
  return (!((this.RTLong__f_lo === b.RTLong__f_lo) && (this.RTLong__f_hi === b.RTLong__f_hi)))
});
$c_RTLong.prototype.$less__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$less$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) <= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))
});
$c_RTLong.prototype.$greater__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) > ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.$greater$eq__RTLong__Z = (function(b) {
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? (((-2147483648) ^ this.RTLong__f_lo) >= ((-2147483648) ^ b.RTLong__f_lo)) : (ahi > bhi))
});
$c_RTLong.prototype.unary_$tilde__RTLong = (function() {
  return new $c_RTLong((~this.RTLong__f_lo), (~this.RTLong__f_hi))
});
$c_RTLong.prototype.$bar__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo | b.RTLong__f_lo), (this.RTLong__f_hi | b.RTLong__f_hi))
});
$c_RTLong.prototype.$amp__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo & b.RTLong__f_lo), (this.RTLong__f_hi & b.RTLong__f_hi))
});
$c_RTLong.prototype.$up__RTLong__RTLong = (function(b) {
  return new $c_RTLong((this.RTLong__f_lo ^ b.RTLong__f_lo), (this.RTLong__f_hi ^ b.RTLong__f_hi))
});
$c_RTLong.prototype.$less$less__I__RTLong = (function(n) {
  var lo = this.RTLong__f_lo;
  return new $c_RTLong((((32 & n) === 0) ? (lo << n) : 0), (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this.RTLong__f_hi << n)) : (lo << n)))
});
$c_RTLong.prototype.$greater$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : ((hi >>> n) | 0)), (((32 & n) === 0) ? ((hi >>> n) | 0) : 0))
});
$c_RTLong.prototype.$greater$greater__I__RTLong = (function(n) {
  var hi = this.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((this.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n)), (((32 & n) === 0) ? (hi >> n) : (hi >> 31)))
});
$c_RTLong.prototype.unary_$minus__RTLong = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  return new $c_RTLong(((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))
});
$c_RTLong.prototype.$plus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo + b.RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0)))
});
$c_RTLong.prototype.$minus__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var ahi = this.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  var lo = ((alo - b.RTLong__f_lo) | 0);
  return new $c_RTLong(lo, ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi) | 0)) | 0) : ((ahi - bhi) | 0)))
});
$c_RTLong.prototype.$times__RTLong__RTLong = (function(b) {
  var alo = this.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi)
});
$c_RTLong.prototype.$div__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong.prototype.$percent__RTLong__RTLong = (function(b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
function $as_RTLong(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "org.scalajs.linker.runtime.RuntimeLong"))
}
function $isArrayOf_RTLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.RTLong)))
}
function $asArrayOf_RTLong(obj, depth) {
  return (($isArrayOf_RTLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lorg.scalajs.linker.runtime.RuntimeLong;", depth))
}
var $d_RTLong = new $TypeData().initClass({
  RTLong: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong", {
  RTLong: 1,
  O: 1
});
$c_RTLong.prototype.$classData = $d_RTLong;
function $p_RTLong$__toUnsignedString__I__I__T($thiz, lo, hi) {
  if ((((-2097152) & hi) === 0)) {
    var this$1 = ((4.294967296E9 * hi) + $uD((lo >>> 0)));
    return ("" + this$1)
  } else {
    return $as_T($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, lo, hi, 1000000000, 0, 2))
  }
}
function $p_RTLong$__unsigned_$div__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
      var rDouble = (aDouble / bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0));
      return $uI((rDouble | 0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    var pow = ((31 - Math.clz32(blo)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((ahi >>> pow) | 0);
    return (((alo >>> pow) | 0) | ((ahi << 1) << ((31 - pow) | 0)))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    var pow$2 = ((31 - Math.clz32(bhi)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return ((ahi >>> pow$2) | 0)
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 0))
  }
}
function $p_RTLong$__unsigned_$percent__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + $uD((alo >>> 0)));
      var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
      var rDouble = (aDouble % bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = $uI((x | 0));
      return $uI((rDouble | 0))
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return (alo & (((-1) + blo) | 0))
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (ahi & (((-1) + bhi) | 0));
    return alo
  } else {
    return $uI($p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, 1))
  }
}
function $p_RTLong$__unsignedDivModHelper__I__I__I__I__I__O($thiz, alo, ahi, blo, bhi, ask) {
  var shift = ((((bhi !== 0) ? Math.clz32(bhi) : ((32 + Math.clz32(blo)) | 0)) - ((ahi !== 0) ? Math.clz32(ahi) : ((32 + Math.clz32(alo)) | 0))) | 0);
  var n = shift;
  var lo = (((32 & n) === 0) ? (blo << n) : 0);
  var hi = (((32 & n) === 0) ? (((((blo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (bhi << n)) : (blo << n));
  var bShiftLo = lo;
  var bShiftHi = hi;
  var remLo = alo;
  var remHi = ahi;
  var quotLo = 0;
  var quotHi = 0;
  while (((shift >= 0) && (((-2097152) & remHi) !== 0))) {
    var alo$1 = remLo;
    var ahi$1 = remHi;
    var blo$1 = bShiftLo;
    var bhi$1 = bShiftHi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ alo$1) >= ((-2147483648) ^ blo$1)) : (((-2147483648) ^ ahi$1) >= ((-2147483648) ^ bhi$1)))) {
      var lo$1 = remLo;
      var hi$1 = remHi;
      var lo$2 = bShiftLo;
      var hi$2 = bShiftHi;
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      remLo = lo$3;
      remHi = hi$3;
      if ((shift < 32)) {
        quotLo = (quotLo | (1 << shift))
      } else {
        quotHi = (quotHi | (1 << shift))
      }
    };
    shift = (((-1) + shift) | 0);
    var lo$4 = bShiftLo;
    var hi$4 = bShiftHi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    bShiftLo = lo$5;
    bShiftHi = hi$5
  };
  var alo$2 = remLo;
  var ahi$2 = remHi;
  if (((ahi$2 === bhi) ? (((-2147483648) ^ alo$2) >= ((-2147483648) ^ blo)) : (((-2147483648) ^ ahi$2) >= ((-2147483648) ^ bhi)))) {
    var lo$6 = remLo;
    var hi$6 = remHi;
    var remDouble = ((4.294967296E9 * hi$6) + $uD((lo$6 >>> 0)));
    var bDouble = ((4.294967296E9 * bhi) + $uD((blo >>> 0)));
    if ((ask !== 1)) {
      var x = (remDouble / bDouble);
      var lo$7 = $uI((x | 0));
      var x$1 = (x / 4.294967296E9);
      var hi$7 = $uI((x$1 | 0));
      var lo$8 = quotLo;
      var hi$8 = quotHi;
      var lo$9 = ((lo$8 + lo$7) | 0);
      var hi$9 = ((((-2147483648) ^ lo$9) < ((-2147483648) ^ lo$8)) ? ((1 + ((hi$8 + hi$7) | 0)) | 0) : ((hi$8 + hi$7) | 0));
      quotLo = lo$9;
      quotHi = hi$9
    };
    if ((ask !== 0)) {
      var rem_mod_bDouble = (remDouble % bDouble);
      remLo = $uI((rem_mod_bDouble | 0));
      var x$2 = (rem_mod_bDouble / 4.294967296E9);
      remHi = $uI((x$2 | 0))
    }
  };
  if ((ask === 0)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = quotHi;
    return quotLo
  } else if ((ask === 1)) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = remHi;
    return remLo
  } else {
    var lo$10 = quotLo;
    var hi$10 = quotHi;
    var quot = ((4.294967296E9 * hi$10) + $uD((lo$10 >>> 0)));
    var this$3 = remLo;
    var remStr = ("" + this$3);
    var start = $uI(remStr.length);
    return ((("" + quot) + $as_T("000000000".substring(start))) + remStr)
  }
}
/** @constructor */
function $c_RTLong$() {
  this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0
}
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
  /*<skip>*/
}
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T = (function(lo, hi) {
  return ((hi === (lo >> 31)) ? ("" + lo) : ((hi < 0) ? ("-" + $p_RTLong$__toUnsignedString__I__I__T(this, ((-lo) | 0), ((lo !== 0) ? (~hi) : ((-hi) | 0)))) : $p_RTLong$__toUnsignedString__I__I__T(this, lo, hi)))
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D = (function(lo, hi) {
  if ((hi < 0)) {
    var x = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var $$x1 = $uD((x >>> 0));
    var x$1 = ((-lo) | 0);
    return (-((4.294967296E9 * $$x1) + $uD((x$1 >>> 0))))
  } else {
    return ((4.294967296E9 * hi) + $uD((lo >>> 0)))
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F = (function(lo, hi) {
  if ((hi < 0)) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var abs__lo = lo$1;
    var abs__hi = hi$1
  } else {
    var abs__lo = lo;
    var abs__hi = hi
  };
  var hi$2 = abs__hi;
  if (((((-2097152) & hi$2) === 0) || ((65535 & abs__lo) === 0))) {
    var compressedAbsLo = abs__lo
  } else {
    var compressedAbsLo = (32768 | ((-65536) & abs__lo))
  };
  var x = abs__hi;
  var absRes = ((4.294967296E9 * $uD((x >>> 0))) + $uD((compressedAbsLo >>> 0)));
  return Math.fround(((hi < 0) ? (-absRes) : absRes))
});
$c_RTLong$.prototype.fromInt__I__RTLong = (function(value) {
  return new $c_RTLong(value, (value >> 31))
});
$c_RTLong$.prototype.fromDouble__D__RTLong = (function(value) {
  var lo = this.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_RTLong(lo, this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn)
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-2147483648);
    return 0
  } else if ((value >= 9.223372036854776E18)) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 2147483647;
    return (-1)
  } else {
    var rawLo = $uI((value | 0));
    var x = (value / 4.294967296E9);
    var rawHi = $uI((x | 0));
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (((value < 0.0) && (rawLo !== 0)) ? (((-1) + rawHi) | 0) : rawHi);
    return rawLo
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo === blo) ? 0 : ((((-2147483648) ^ alo) < ((-2147483648) ^ blo)) ? (-1) : 1)) : ((ahi < bhi) ? (-1) : 1))
});
$c_RTLong$.prototype.divideImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if (((alo === (-2147483648)) && (blo === (-1)))) {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return (-2147483648)
      } else {
        var lo = $intDiv(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-1);
      return (-1)
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$div__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if (((ahi ^ bhi) >= 0)) {
      return absRLo
    } else {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    }
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      if ((blo === 0)) {
        return $intDiv(0, 0)
      } else {
        var n = ($uD((alo >>> 0)) / $uD((blo >>> 0)));
        return $uI((n | 0))
      }
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    }
  } else {
    return $p_RTLong$__unsigned_$div__I__I__I__I__I(this, alo, ahi, blo, bhi)
  }
});
$c_RTLong$.prototype.remainderImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero")
  };
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if ((blo !== (-1))) {
        var lo = $intMod(alo, blo);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo
      } else {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return 0
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo
    }
  } else {
    if ((ahi < 0)) {
      var lo$1 = ((-alo) | 0);
      var hi = ((alo !== 0) ? (~ahi) : ((-ahi) | 0));
      var aAbs__lo = lo$1;
      var aAbs__hi = hi
    } else {
      var aAbs__lo = alo;
      var aAbs__hi = ahi
    };
    if ((bhi < 0)) {
      var lo$2 = ((-blo) | 0);
      var hi$1 = ((blo !== 0) ? (~bhi) : ((-bhi) | 0));
      var bAbs__lo = lo$2;
      var bAbs__hi = hi$1
    } else {
      var bAbs__lo = blo;
      var bAbs__hi = bhi
    };
    var absRLo = $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, aAbs__lo, aAbs__hi, bAbs__lo, bAbs__hi);
    if ((ahi < 0)) {
      var hi$2 = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((absRLo !== 0) ? (~hi$2) : ((-hi$2) | 0));
      return ((-absRLo) | 0)
    } else {
      return absRLo
    }
  }
});
var $d_RTLong$ = new $TypeData().initClass({
  RTLong$: 0
}, false, "org.scalajs.linker.runtime.RuntimeLong$", {
  RTLong$: 1,
  O: 1
});
$c_RTLong$.prototype.$classData = $d_RTLong$;
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$()
  };
  return $n_RTLong$
}
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyBooleanArray = null;
  this.s_Array$EmptyArrays$__f_emptyByteArray = null;
  this.s_Array$EmptyArrays$__f_emptyCharArray = null;
  this.s_Array$EmptyArrays$__f_emptyDoubleArray = null;
  this.s_Array$EmptyArrays$__f_emptyFloatArray = null;
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyLongArray = null;
  this.s_Array$EmptyArrays$__f_emptyShortArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyBooleanArray = new $ac_Z(0);
  this.s_Array$EmptyArrays$__f_emptyByteArray = new $ac_B(0);
  this.s_Array$EmptyArrays$__f_emptyCharArray = new $ac_C(0);
  this.s_Array$EmptyArrays$__f_emptyDoubleArray = new $ac_D(0);
  this.s_Array$EmptyArrays$__f_emptyFloatArray = new $ac_F(0);
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyLongArray = new $ac_J(0);
  this.s_Array$EmptyArrays$__f_emptyShortArray = new $ac_S(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0)
}
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
  /*<skip>*/
}
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass({
  s_Array$EmptyArrays$: 0
}, false, "scala.Array$EmptyArrays$", {
  s_Array$EmptyArrays$: 1,
  O: 1
});
$c_s_Array$EmptyArrays$.prototype.$classData = $d_s_Array$EmptyArrays$;
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$()
  };
  return $n_s_Array$EmptyArrays$
}
/** @constructor */
function $c_s_DummyImplicit() {
  /*<skip>*/
}
$c_s_DummyImplicit.prototype = new $h_O();
$c_s_DummyImplicit.prototype.constructor = $c_s_DummyImplicit;
/** @constructor */
function $h_s_DummyImplicit() {
  /*<skip>*/
}
$h_s_DummyImplicit.prototype = $c_s_DummyImplicit.prototype;
var $d_s_DummyImplicit = new $TypeData().initClass({
  s_DummyImplicit: 0
}, false, "scala.DummyImplicit", {
  s_DummyImplicit: 1,
  O: 1
});
$c_s_DummyImplicit.prototype.$classData = $d_s_DummyImplicit;
/** @constructor */
function $c_s_DummyImplicit$() {
  this.s_DummyImplicit$__f_dummyImplicit = null;
  $n_s_DummyImplicit$ = this;
  this.s_DummyImplicit$__f_dummyImplicit = new $c_s_DummyImplicit()
}
$c_s_DummyImplicit$.prototype = new $h_O();
$c_s_DummyImplicit$.prototype.constructor = $c_s_DummyImplicit$;
/** @constructor */
function $h_s_DummyImplicit$() {
  /*<skip>*/
}
$h_s_DummyImplicit$.prototype = $c_s_DummyImplicit$.prototype;
var $d_s_DummyImplicit$ = new $TypeData().initClass({
  s_DummyImplicit$: 0
}, false, "scala.DummyImplicit$", {
  s_DummyImplicit$: 1,
  O: 1
});
$c_s_DummyImplicit$.prototype.$classData = $d_s_DummyImplicit$;
var $n_s_DummyImplicit$;
function $m_s_DummyImplicit$() {
  if ((!$n_s_DummyImplicit$)) {
    $n_s_DummyImplicit$ = new $c_s_DummyImplicit$()
  };
  return $n_s_DummyImplicit$
}
function $is_F0(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F0)))
}
function $as_F0(obj) {
  return (($is_F0(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function0"))
}
function $isArrayOf_F0(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F0)))
}
function $asArrayOf_F0(obj, depth) {
  return (($isArrayOf_F0(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function0;", depth))
}
function $f_F1__andThen__F1__F1($thiz, g) {
  return new $c_sjsr_AnonFunction1(((this$1, g$1) => ((x$2) => g$1.apply__O__O(this$1.apply__O__O(x$2))))($thiz, g))
}
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)))
}
function $as_F1(obj) {
  return (($is_F1(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function1"))
}
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)))
}
function $asArrayOf_F1(obj, depth) {
  return (($isArrayOf_F1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function1;", depth))
}
var $d_F1 = new $TypeData().initClass({
  F1: 0
}, true, "scala.Function1", {
  F1: 1,
  O: 1
});
function $is_F2(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F2)))
}
function $as_F2(obj) {
  return (($is_F2(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Function2"))
}
function $isArrayOf_F2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F2)))
}
function $asArrayOf_F2(obj, depth) {
  return (($isArrayOf_F2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Function2;", depth))
}
/** @constructor */
function $c_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sjsr_AnonFunction1(((x$2$2) => $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sjsr_AnonFunction1(((x$3$2) => false));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1()
}
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
  /*<skip>*/
}
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.scala$PartialFunction$$fallbackOccurred__O__Z = (function(x) {
  return (this.s_PartialFunction$__f_fallback_fn === x)
});
var $d_s_PartialFunction$ = new $TypeData().initClass({
  s_PartialFunction$: 0
}, false, "scala.PartialFunction$", {
  s_PartialFunction$: 1,
  O: 1
});
$c_s_PartialFunction$.prototype.$classData = $d_s_PartialFunction$;
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$()
  };
  return $n_s_PartialFunction$
}
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.sr_RichLong__f_self)
}
function $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O($thiz, len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().array_clone__O__O(\u03b4this$2);
    var this$1 = $m_s_util_Sorting$();
    this$1.stableSort__O__I__I__s_math_Ordering__V(a, 0, $m_sr_ScalaRunTime$().array_length__O__I(a), ord$1);
    return a
  } else {
    var this$4 = $m_s_Array$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(\u03b4this$2).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $$x1 = this$4.copyOf__O__I__O(\u03b4this$2, len$1)
      } else {
        var original = $asArrayOf_O(\u03b4this$2, 1);
        var $$x1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, len$1, $d_O.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().copy__O__I__O__I__I__V(\u03b4this$2, 0, dest, 0, $m_sr_ScalaRunTime$().array_length__O__I(\u03b4this$2));
      var $$x1 = dest
    };
    var a$2 = $asArrayOf_O($$x1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a$2, ord$1);
    return $m_s_Array$().copyAs__O__I__s_reflect_ClassTag__O(a$2, len$1, $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(\u03b4this$2).getComponentType__jl_Class()))
  }
}
/** @constructor */
function $c_sc_ArrayOps$() {
  /*<skip>*/
}
$c_sc_ArrayOps$.prototype = new $h_O();
$c_sc_ArrayOps$.prototype.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
  /*<skip>*/
}
$h_sc_ArrayOps$.prototype = $c_sc_ArrayOps$.prototype;
$c_sc_ArrayOps$.prototype.last$extension__O__O = (function(this$) {
  try {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, (((-1) + $m_sr_ScalaRunTime$().array_length__O__I(this$)) | 0))
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty array")
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$.prototype.slice$extension__O__I__I__O = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_sr_ScalaRunTime$().array_length__O__I(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      var x2 = $asArrayOf_O(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AO__I__I__AO(x2, lo, hi)
    } else if ((this$ instanceof $ac_I)) {
      var x3 = $asArrayOf_I(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AI__I__I__AI(x3, lo, hi)
    } else if ((this$ instanceof $ac_D)) {
      var x4 = $asArrayOf_D(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AD__I__I__AD(x4, lo, hi)
    } else if ((this$ instanceof $ac_J)) {
      var x5 = $asArrayOf_J(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(x5, lo, hi)
    } else if ((this$ instanceof $ac_F)) {
      var x6 = $asArrayOf_F(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AF__I__I__AF(x6, lo, hi)
    } else if ((this$ instanceof $ac_C)) {
      var x7 = $asArrayOf_C(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AC__I__I__AC(x7, lo, hi)
    } else if ((this$ instanceof $ac_B)) {
      var x8 = $asArrayOf_B(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AB__I__I__AB(x8, lo, hi)
    } else if ((this$ instanceof $ac_S)) {
      var x9 = $asArrayOf_S(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AS__I__I__AS(x9, lo, hi)
    } else if ((this$ instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(this$, 1);
      return $m_ju_Arrays$().copyOfRange__AZ__I__I__AZ(x10, lo, hi)
    } else {
      throw new $c_s_MatchError(this$)
    }
  } else {
    return $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$).getComponentType__jl_Class()).newArray__I__O(0)
  }
});
$c_sc_ArrayOps$.prototype.tail$extension__O__O = (function(this$) {
  if (($m_sr_ScalaRunTime$().array_length__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array")
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 1, $m_sr_ScalaRunTime$().array_length__O__I(this$))
  }
});
$c_sc_ArrayOps$.prototype.drop$extension__O__I__O = (function(this$, n) {
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, n, $m_sr_ScalaRunTime$().array_length__O__I(this$))
});
$c_sc_ArrayOps$.prototype.sorted$extension__O__s_math_Ordering__O = (function(this$, ord) {
  var len = $m_sr_ScalaRunTime$().array_length__O__I(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().array_clone__O__O(this$)
  } else if ((this$ instanceof $ac_O)) {
    var x2 = $asArrayOf_O(this$, 1);
    var a = $m_ju_Arrays$().copyOf__AO__I__AO(x2, len);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return a
  } else if ((this$ instanceof $ac_I)) {
    var x3 = $asArrayOf_I(this$, 1);
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().copyOf__AI__I__AI(x3, len);
      $m_ju_Arrays$().sort__AI__V(a$2);
      return a$2
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_J)) {
    var x4 = $asArrayOf_J(this$, 1);
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().copyOf__AJ__I__AJ(x4, len);
      $m_ju_Arrays$().sort__AJ__V(a$3);
      return a$3
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_C)) {
    var x5 = $asArrayOf_C(this$, 1);
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().copyOf__AC__I__AC(x5, len);
      $m_ju_Arrays$().sort__AC__V(a$4);
      return a$4
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_B)) {
    var x6 = $asArrayOf_B(this$, 1);
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().copyOf__AB__I__AB(x6, len);
      $m_ju_Arrays$().sort__AB__V(a$5);
      return a$5
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_S)) {
    var x7 = $asArrayOf_S(this$, 1);
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().copyOf__AS__I__AS(x7, len);
      $m_ju_Arrays$().sort__AS__V(a$6);
      return a$6
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else if ((this$ instanceof $ac_Z)) {
    var x8 = $asArrayOf_Z(this$, 1);
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().copyOf__AZ__I__AZ(x8, len);
      var this$1 = $m_s_util_Sorting$();
      var evidence$3 = $m_s_math_Ordering$Boolean$();
      this$1.stableSort__O__I__I__s_math_Ordering__V(a$7, 0, a$7.u.length, evidence$3);
      return a$7
    } else {
      return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
    }
  } else {
    return $p_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(this, len, this$, ord)
  }
});
$c_sc_ArrayOps$.prototype.zipWithIndex$extension__O__AT2 = (function(this$) {
  var b = new ($d_T2.getArrayOf().constr)($m_sr_ScalaRunTime$().array_length__O__I(this$));
  var i = 0;
  while ((i < $m_sr_ScalaRunTime$().array_length__O__I(this$))) {
    b.set(i, new $c_T2($m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i), i));
    i = ((1 + i) | 0)
  };
  return b
});
var $d_sc_ArrayOps$ = new $TypeData().initClass({
  sc_ArrayOps$: 0
}, false, "scala.collection.ArrayOps$", {
  sc_ArrayOps$: 1,
  O: 1
});
$c_sc_ArrayOps$.prototype.$classData = $d_sc_ArrayOps$;
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$()
  };
  return $n_sc_ArrayOps$
}
/** @constructor */
function $c_sc_BitSetOps$() {
  /*<skip>*/
}
$c_sc_BitSetOps$.prototype = new $h_O();
$c_sc_BitSetOps$.prototype.constructor = $c_sc_BitSetOps$;
/** @constructor */
function $h_sc_BitSetOps$() {
  /*<skip>*/
}
$h_sc_BitSetOps$.prototype = $c_sc_BitSetOps$.prototype;
$c_sc_BitSetOps$.prototype.updateArray__AJ__I__J__AJ = (function(elems, idx, w) {
  var len = elems.u.length;
  while (true) {
    if ((len > 0)) {
      var this$1 = elems.get((((-1) + len) | 0));
      if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
        var $$x1 = true
      } else {
        var $$x1 = (((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)) && (idx === (((-1) + len) | 0)))
      }
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      len = (((-1) + len) | 0)
    } else {
      break
    }
  };
  var newlen = len;
  if (((idx >= newlen) && (!((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0))))) {
    newlen = ((1 + idx) | 0)
  };
  var newelems = new $ac_J(newlen);
  $m_s_Array$().copy__O__I__O__I__I__V(elems, 0, newelems, 0, len);
  if ((idx < newlen)) {
    newelems.set(idx, w)
  } else {
    $m_s_Predef$().assert__Z__V(((w.RTLong__f_lo === 0) && (w.RTLong__f_hi === 0)))
  };
  return newelems
});
var $d_sc_BitSetOps$ = new $TypeData().initClass({
  sc_BitSetOps$: 0
}, false, "scala.collection.BitSetOps$", {
  sc_BitSetOps$: 1,
  O: 1
});
$c_sc_BitSetOps$.prototype.$classData = $d_sc_BitSetOps$;
var $n_sc_BitSetOps$;
function $m_sc_BitSetOps$() {
  if ((!$n_sc_BitSetOps$)) {
    $n_sc_BitSetOps$ = new $c_sc_BitSetOps$()
  };
  return $n_sc_BitSetOps$
}
/** @constructor */
function $c_sc_Hashing$() {
  /*<skip>*/
}
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
  /*<skip>*/
}
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0))
});
var $d_sc_Hashing$ = new $TypeData().initClass({
  sc_Hashing$: 0
}, false, "scala.collection.Hashing$", {
  sc_Hashing$: 1,
  O: 1
});
$c_sc_Hashing$.prototype.$classData = $d_sc_Hashing$;
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$()
  };
  return $n_sc_Hashing$
}
function $is_sc_IterableOnce(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOnce)))
}
function $as_sc_IterableOnce(obj) {
  return (($is_sc_IterableOnce(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOnce"))
}
function $isArrayOf_sc_IterableOnce(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOnce)))
}
function $asArrayOf_sc_IterableOnce(obj, depth) {
  return (($isArrayOf_sc_IterableOnce(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOnce;", depth))
}
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    f.apply__O__O(it.next__O())
  }
}
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while ((res && it.hasNext__Z())) {
    res = $uZ(p.apply__O__O(it.next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (((!res) && it.hasNext__Z())) {
    res = $uZ(p.apply__O__O(it.next__O()))
  };
  return res
}
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  var result = z;
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    result = op.apply__O__O__O(result, it.next__O())
  };
  return result
}
function $f_sc_IterableOnceOps__reduceLeft__F2__O($thiz, op) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  if ((!it.hasNext__Z())) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  };
  var first = true;
  var acc = null;
  while (it.hasNext__Z()) {
    var x = it.next__O();
    if (first) {
      acc = x;
      first = false
    } else {
      acc = op.apply__O__O__O(acc, x)
    }
  };
  return acc
}
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  return (!$as_sc_IterableOnce($thiz).iterator__sc_Iterator().hasNext__Z())
}
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($as_sc_IterableOnce($thiz).knownSize__I() >= 0)) {
    return $as_sc_IterableOnce($thiz).knownSize__I()
  } else {
    var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
    var len = 0;
    while (it.hasNext__Z()) {
      len = ((1 + len) | 0);
      it.next__O()
    };
    return len
  }
}
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, xs, start, len) {
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  var i = start;
  var y = (($m_sr_ScalaRunTime$().array_length__O__I(xs) - start) | 0);
  var end = ((start + ((len < y) ? len : y)) | 0);
  while (((i < end) && it.hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(xs, i, it.next__O());
    i = ((1 + i) | 0)
  };
  return ((i - start) | 0)
}
function $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max")
  };
  return $thiz.reduceLeft__F2__O(new $c_sjsr_AnonFunction2(((ord$1) => ((x$2, y$2) => ord$1.max__O__O__O(x$2, y$2)))(ord)))
}
function $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option($thiz, ord) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.max__s_math_Ordering__O(ord)))
}
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if ($thiz.isEmpty__Z()) {
    return (("" + start) + end)
  } else {
    var this$1 = $thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end);
    return this$1.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
}
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = b.scm_StringBuilder__f_underlying;
  if (($uI(start.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var obj = it.next__O();
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while (it.hasNext__Z()) {
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      var obj$1 = it.next__O();
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1)
    }
  };
  if (($uI(end.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return b
}
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($as_sc_IterableOnce($thiz).knownSize__I() >= 0)) {
    var destination = evidence$2.newArray__I__O($as_sc_IterableOnce($thiz).knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$2.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var xs = $as_sc_IterableOnce($thiz);
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
}
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $as_sc_IterableOnce($thiz).iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var rassoc$1 = it.next__O();
    var this$1 = xs;
    xs = new $c_sci_$colon$colon(rassoc$1, this$1)
  };
  return xs
}
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail
}
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return $as_sc_IterableOnce(this.sc_Iterator$ConcatIteratorCell__f_head.apply__O()).iterator__sc_Iterator()
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass({
  sc_Iterator$ConcatIteratorCell: 0
}, false, "scala.collection.Iterator$ConcatIteratorCell", {
  sc_Iterator$ConcatIteratorCell: 1,
  O: 1
});
$c_sc_Iterator$ConcatIteratorCell.prototype.$classData = $d_sc_Iterator$ConcatIteratorCell;
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $as_sc_LinearSeqOps($thiz.sc_LinearSeqIterator$LazyCell__f_st.apply__O());
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true
  };
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v
}
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st
}
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v)
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass({
  sc_LinearSeqIterator$LazyCell: 0
}, false, "scala.collection.LinearSeqIterator$LazyCell", {
  sc_LinearSeqIterator$LazyCell: 1,
  O: 1
});
$c_sc_LinearSeqIterator$LazyCell.prototype.$classData = $d_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $c_sc_StringOps$() {
  /*<skip>*/
}
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
  /*<skip>*/
}
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.slice$extension__T__I__I__T = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var that = $uI(this$.length);
  var end = ((until < that) ? until : that);
  return ((start >= end) ? "" : $as_T(this$.substring(start, end)))
});
$c_sc_StringOps$.prototype.stripSuffix$extension__T__T__T = (function(this$, suffix) {
  if ($f_T__endsWith__T__Z(this$, suffix)) {
    var endIndex = (($uI(this$.length) - $uI(suffix.length)) | 0);
    return $as_T(this$.substring(0, endIndex))
  } else {
    return this$
  }
});
$c_sc_StringOps$.prototype.stripMargin$extension__T__C__T = (function(this$, marginChar) {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), $uI(this$.length));
  var this$3 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$3.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$3.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var arg1 = this$3.next__T();
    var len = $uI(arg1.length);
    var index = 0;
    while (true) {
      if ((index < len)) {
        var index$1 = index;
        var $$x1 = ((65535 & $uI(arg1.charCodeAt(index$1))) <= 32)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        index = ((1 + index) | 0)
      } else {
        break
      }
    };
    if ((index < len)) {
      var index$2 = index;
      var $$x2 = ((65535 & $uI(arg1.charCodeAt(index$2))) === marginChar)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var beginIndex = ((1 + index) | 0);
      var stripped = $as_T(arg1.substring(beginIndex))
    } else {
      var stripped = arg1
    };
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + stripped)
  };
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.toBooleanImpl$extension__T__T__Z = (function(this$, s) {
  if ((s === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "For input string: \"null\"")
  } else {
    _return: {
      var len = $uI(s.length);
      if (($uI("true".length) === len)) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = (65535 & $uI(s.charCodeAt(index)));
          var $$x2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = (65535 & $uI("true".charCodeAt(index$1)));
          if (($$x2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $$x1 = false;
            break _return
          };
          i = ((1 + i) | 0)
        };
        var $$x1 = true
      } else {
        var $$x1 = false
      }
    };
    if ($$x1) {
      return true
    } else {
      _return$1: {
        var len$1 = $uI(s.length);
        if (($uI("false".length) === len$1)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var index$2 = i$1;
            var c$2 = (65535 & $uI(s.charCodeAt(index$2)));
            var $$x4 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$2));
            var index$3 = i$1;
            var c$3 = (65535 & $uI("false".charCodeAt(index$3)));
            if (($$x4 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$3)))) {
              var $$x3 = false;
              break _return$1
            };
            i$1 = ((1 + i$1) | 0)
          };
          var $$x3 = true
        } else {
          var $$x3 = false
        }
      };
      if ($$x3) {
        return false
      } else {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("For input string: \"" + s) + "\""))
      }
    }
  }
});
$c_sc_StringOps$.prototype.reverse$extension__T__T = (function(this$) {
  return $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).reverse__jl_StringBuilder().jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sc_StringOps$.prototype.take$extension__T__I__T = (function(this$, n) {
  var $$x1 = $m_sc_StringOps$();
  var y = $uI(this$.length);
  return $$x1.slice$extension__T__I__I__T(this$, 0, ((n < y) ? n : y))
});
$c_sc_StringOps$.prototype.dropRight$extension__T__I__T = (function(this$, n) {
  return $m_sc_StringOps$().take$extension__T__I__T(this$, (($uI(this$.length) - ((n > 0) ? n : 0)) | 0))
});
var $d_sc_StringOps$ = new $TypeData().initClass({
  sc_StringOps$: 0
}, false, "scala.collection.StringOps$", {
  sc_StringOps$: 1,
  O: 1
});
$c_sc_StringOps$.prototype.$classData = $d_sc_StringOps$;
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$()
  };
  return $n_sc_StringOps$
}
function $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option($thiz, i, agg, isPositive, len$2, from$2) {
  while (true) {
    if ((i === len$2)) {
      return ((!isPositive) ? new $c_s_Some(agg) : ((agg === (-2147483648)) ? $m_s_None$() : new $c_s_Some(((-agg) | 0))))
    } else if ((agg < (-214748364))) {
      return $m_s_None$()
    } else {
      var index = i;
      var ch = (65535 & $uI(from$2.charCodeAt(index)));
      var this$1 = $m_jl_Character$();
      var codePoint = ch;
      var digit = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
      if (((digit === (-1)) || ((agg === (-214748364)) && (digit === 9)))) {
        return $m_s_None$()
      } else {
        var temp$i = ((1 + i) | 0);
        var temp$agg = ((Math.imul(10, agg) - digit) | 0);
        i = temp$i;
        agg = temp$agg
      }
    }
  }
}
function $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option($thiz, i, agg, isPositive, len$3, from$3) {
  while (true) {
    if ((i === len$3)) {
      if (isPositive) {
        var this$1 = agg;
        var $$x1 = ((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648)))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        return $m_s_None$()
      } else if (isPositive) {
        var this$2 = agg;
        var lo = this$2.RTLong__f_lo;
        var hi = this$2.RTLong__f_hi;
        var lo$1 = ((-lo) | 0);
        var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
        return new $c_s_Some(new $c_RTLong(lo$1, hi$1))
      } else {
        return new $c_s_Some(agg)
      }
    } else {
      var this$5 = agg;
      var ahi = this$5.RTLong__f_hi;
      if (((ahi === (-214748365)) ? (((-2147483648) ^ this$5.RTLong__f_lo) < (-1288490188)) : (ahi < (-214748365)))) {
        return $m_s_None$()
      } else {
        var index = i;
        var ch = (65535 & $uI(from$3.charCodeAt(index)));
        var this$6 = $m_jl_Character$();
        var codePoint = ch;
        var digit = this$6.digitWithValidRadix__I__I__I(codePoint, 10);
        if ((digit === (-1))) {
          var $$x2 = true
        } else {
          var this$7 = agg;
          if (((this$7.RTLong__f_lo === 858993460) && (this$7.RTLong__f_hi === (-214748365)))) {
            var $$x2 = (digit === 9)
          } else {
            var $$x2 = false
          }
        };
        if ($$x2) {
          return $m_s_None$()
        } else {
          var temp$i = ((1 + i) | 0);
          var b = agg;
          var blo = b.RTLong__f_lo;
          var b0 = (65535 & blo);
          var b1 = ((blo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$2 = ((Math.imul(10, b.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$3 = (digit >> 31);
          var lo$3 = ((lo$2 - digit) | 0);
          var hi$4 = ((((-2147483648) ^ lo$3) > ((-2147483648) ^ lo$2)) ? (((-1) + ((hi$2 - hi$3) | 0)) | 0) : ((hi$2 - hi$3) | 0));
          i = temp$i;
          agg = new $c_RTLong(lo$3, hi$4)
        }
      }
    }
  }
}
/** @constructor */
function $c_sc_StringParsers$() {
  /*<skip>*/
}
$c_sc_StringParsers$.prototype = new $h_O();
$c_sc_StringParsers$.prototype.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
  /*<skip>*/
}
$h_sc_StringParsers$.prototype = $c_sc_StringParsers$.prototype;
$c_sc_StringParsers$.prototype.parseInt__T__s_Option = (function(from) {
  var len = $uI(from.length);
  if ((len === 0)) {
    return $m_s_None$()
  } else {
    var first = (65535 & $uI(from.charCodeAt(0)));
    var this$1 = $m_jl_Character$();
    var codePoint = first;
    var v = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
    return ((len === 1) ? ((v > (-1)) ? new $c_s_Some(v) : $m_s_None$()) : ((v > (-1)) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, ((-v) | 0), true, len, from) : ((first === 43) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, 0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, 0, false, len, from) : $m_s_None$()))))
  }
});
$c_sc_StringParsers$.prototype.parseLong__T__s_Option = (function(from) {
  var len = $uI(from.length);
  if ((len === 0)) {
    return $m_s_None$()
  } else {
    var first = (65535 & $uI(from.charCodeAt(0)));
    var this$1 = $m_jl_Character$();
    var codePoint = first;
    var value = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
    var hi = (value >> 31);
    if ((len === 1)) {
      return ((hi > (-1)) ? new $c_s_Some(new $c_RTLong(value, hi)) : $m_s_None$())
    } else if ((hi > (-1))) {
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      return $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, new $c_RTLong(lo, hi$1), true, len, from)
    } else {
      return ((first === 43) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, $L0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, $L0, false, len, from) : $m_s_None$()))
    }
  }
});
var $d_sc_StringParsers$ = new $TypeData().initClass({
  sc_StringParsers$: 0
}, false, "scala.collection.StringParsers$", {
  sc_StringParsers$: 1,
  O: 1
});
$c_sc_StringParsers$.prototype.$classData = $d_sc_StringParsers$;
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$()
  };
  return $n_sc_StringParsers$
}
function $f_scg_BitOperations$Long__zero__J__J__Z($thiz, i, mask) {
  var lo = (i.RTLong__f_lo & mask.RTLong__f_lo);
  var hi = (i.RTLong__f_hi & mask.RTLong__f_hi);
  return ((lo === 0) && (hi === 0))
}
function $f_scg_BitOperations$Long__mask__J__J__J($thiz, i, mask) {
  var bhi = mask.RTLong__f_hi;
  var lo = (((-1) + mask.RTLong__f_lo) | 0);
  var hi = ((lo !== (-1)) ? bhi : (((-1) + bhi) | 0));
  var this$2 = $f_scg_BitOperations$Long__complement__J__J($thiz, new $c_RTLong(lo, hi));
  var lo$1 = (this$2.RTLong__f_lo ^ mask.RTLong__f_lo);
  var hi$1 = (this$2.RTLong__f_hi ^ mask.RTLong__f_hi);
  var lo$2 = (i.RTLong__f_lo & lo$1);
  var hi$2 = (i.RTLong__f_hi & hi$1);
  return new $c_RTLong(lo$2, hi$2)
}
function $f_scg_BitOperations$Long__hasMatch__J__J__J__Z($thiz, key, prefix, m) {
  var this$1 = $f_scg_BitOperations$Long__mask__J__J__J($thiz, key, m);
  return ((this$1.RTLong__f_lo === prefix.RTLong__f_lo) && (this$1.RTLong__f_hi === prefix.RTLong__f_hi))
}
function $f_scg_BitOperations$Long__complement__J__J($thiz, i) {
  var lo = (~i.RTLong__f_lo);
  var hi = (~i.RTLong__f_hi);
  return new $c_RTLong(lo, hi)
}
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth)
  }
}
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = node.payloadArity__I()
}
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $thiz.sci_ChampBaseIterator__f_nodes.set($thiz.sci_ChampBaseIterator__f_currentStackLevel, node);
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.set(cursorIndex, 0);
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.set(lengthIndex, node.nodeArity__I())
}
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.get(cursorIndex);
    var nodeLength = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.get(lengthIndex);
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      ev$1.set(cursorIndex, ((1 + ev$1.get(cursorIndex)) | 0));
      var nextNode = $thiz.sci_ChampBaseIterator__f_nodes.get($thiz.sci_ChampBaseIterator__f_currentStackLevel).getNode__I__sci_Node(nodeCursor);
      if (nextNode.hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode)
      };
      if (nextNode.hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz)
    }
  };
  return false
}
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz
}
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if (rootNode.hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode)
  };
  if (rootNode.hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode)
  };
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null
}
$c_sci_ChampBaseIterator.prototype = new $h_O();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this))
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + node.payloadArity__I()) | 0)
}
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, node);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + node.nodeArity__I()) | 0))
}
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0)
}
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
    $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.set($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel, (((-1) + nodeCursor) | 0));
    if ((nodeCursor >= 0)) {
      var nextNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel).getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode)
    } else {
      var currNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.get($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel);
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if (currNode.hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true
      }
    }
  };
  return false
}
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz
}
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz
}
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null
}
$c_sci_ChampBaseReverseIterator.prototype = new $h_O();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
  /*<skip>*/
}
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this))
});
function $p_sci_IndexedSeqDefaults$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 64
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $p_sci_IndexedSeqDefaults$__liftedTree1$1__I(this)
}
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
  /*<skip>*/
}
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass({
  sci_IndexedSeqDefaults$: 0
}, false, "scala.collection.immutable.IndexedSeqDefaults$", {
  sci_IndexedSeqDefaults$: 1,
  O: 1
});
$c_sci_IndexedSeqDefaults$.prototype.$classData = $d_sci_IndexedSeqDefaults$;
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$()
  };
  return $n_sci_IndexedSeqDefaults$
}
/** @constructor */
function $c_sci_LazyList$Deferrer$() {
  /*<skip>*/
}
$c_sci_LazyList$Deferrer$.prototype = new $h_O();
$c_sci_LazyList$Deferrer$.prototype.constructor = $c_sci_LazyList$Deferrer$;
/** @constructor */
function $h_sci_LazyList$Deferrer$() {
  /*<skip>*/
}
$h_sci_LazyList$Deferrer$.prototype = $c_sci_LazyList$Deferrer$.prototype;
$c_sci_LazyList$Deferrer$.prototype.$hash$colon$colon$extension__F0__F0__sci_LazyList = (function(this$, elem) {
  $m_sci_LazyList$();
  var state$1 = new $c_sjsr_AnonFunction0(((elem$1, this$$1) => (() => {
    $m_sci_LazyList$();
    var hd = elem$1.apply__O();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0(((\u03b4this$1) => (() => $as_sci_LazyList(\u03b4this$1.apply__O()).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))(this$$1));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  }))(elem, this$));
  return new $c_sci_LazyList(state$1)
});
var $d_sci_LazyList$Deferrer$ = new $TypeData().initClass({
  sci_LazyList$Deferrer$: 0
}, false, "scala.collection.immutable.LazyList$Deferrer$", {
  sci_LazyList$Deferrer$: 1,
  O: 1
});
$c_sci_LazyList$Deferrer$.prototype.$classData = $d_sci_LazyList$Deferrer$;
var $n_sci_LazyList$Deferrer$;
function $m_sci_LazyList$Deferrer$() {
  if ((!$n_sci_LazyList$Deferrer$)) {
    $n_sci_LazyList$Deferrer$ = new $c_sci_LazyList$Deferrer$()
  };
  return $n_sci_LazyList$Deferrer$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = null
}
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList$State = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__state;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized")
  };
  return $as_sci_LazyList$State(state.apply__O())
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__state !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized")
  };
  this.sci_LazyList$LazyBuilder$DeferredState__f__state = state
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass({
  sci_LazyList$LazyBuilder$DeferredState: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", {
  sci_LazyList$LazyBuilder$DeferredState: 1,
  O: 1
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.$classData = $d_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
  /*<skip>*/
}
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass({
  sci_MapNode$: 0
}, false, "scala.collection.immutable.MapNode$", {
  sci_MapNode$: 1,
  O: 1
});
$c_sci_MapNode$.prototype.$classData = $d_sci_MapNode$;
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$()
  };
  return $n_sci_MapNode$
}
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (((-1) + $m_sr_ScalaRunTime$().array_length__O__I(as)) | 0)))
}
/** @constructor */
function $c_sci_Node() {
  /*<skip>*/
}
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
  /*<skip>*/
}
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  if ((ix > (((-1) + as.u.length) | 0))) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  var result = new $ac_I((((-1) + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((-1) + ((as.u.length - ix) | 0)) | 0);
  as.copyTo(srcPos, result, ix, length);
  return result
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  if ((ix > as.u.length)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix)
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result
});
var $d_sci_Node = new $TypeData().initClass({
  sci_Node: 0
}, false, "scala.collection.immutable.Node", {
  sci_Node: 1,
  O: 1
});
$c_sci_Node.prototype.$classData = $d_sci_Node;
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt($uD(Math.ceil(6.4)))
}
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
  /*<skip>*/
}
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0))
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask)
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos))
});
var $d_sci_Node$ = new $TypeData().initClass({
  sci_Node$: 0
}, false, "scala.collection.immutable.Node$", {
  sci_Node$: 1,
  O: 1
});
$c_sci_Node$.prototype.$classData = $d_sci_Node$;
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$()
  };
  return $n_sci_Node$
}
function $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, tree, f) {
  while (true) {
    var this$1 = tree;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = tree;
      $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V($thiz, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, f)
    };
    var this$3 = tree;
    f.apply__O__O(this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    var this$4 = tree;
    if ((this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$5 = tree;
      tree = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      continue
    };
    return (void 0)
  }
}
function $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, t) {
  return ((t === null) ? null : t.black__sci_RedBlackTree$Tree())
}
function $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, isBlack, key, value, left, right) {
  var sizeAndColour = (((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0) | (isBlack ? (-2147483648) : 0));
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, sizeAndColour)
}
function $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft) {
  if ((tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return tree
  } else if ((newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newLeft_left = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var newLeft_right = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((newLeft_left !== null) && (newLeft_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = newLeft_left.black__sci_RedBlackTree$Tree();
      var resultRight = tree.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return newLeft.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else if (((newLeft_right !== null) && (newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var newLeft_right_right = newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var resultLeft$2 = newLeft.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight$2 = tree.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
      return newLeft_right.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
    } else {
      return tree.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
    }
  } else {
    return tree.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
  }
}
function $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newRight) {
  if ((tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return tree
  } else if ((newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newRight_left = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (((newRight_left !== null) && (newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var resultLeft = tree.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight = newRight.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return newRight_left.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else {
      var newRight_right = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if (((newRight_right !== null) && (newRight_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var resultLeft$2 = tree.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = newRight_right.black__sci_RedBlackTree$Tree();
        return newRight.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
      } else {
        return tree.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
      }
    }
  } else {
    return tree.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
  }
}
function $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, v, overwrite, ordering) {
  if ((tree === null)) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, null, null)
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return (overwrite ? tree.withV__O__sci_RedBlackTree$Tree(v) : tree)
  } else {
    var cmp = ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? $p_sci_RedBlackTree$__balanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, v, overwrite, ordering)) : ((cmp > 0) ? $p_sci_RedBlackTree$__balanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, overwrite, ordering)) : ((overwrite && (!Object.is(v, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value))) ? tree.withV__O__sci_RedBlackTree$Tree(v) : tree)))
  }
}
function $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, tree, n) {
  while (true) {
    if (((tree === null) || (n <= 0))) {
      return tree
    } else {
      var $$x1 = n;
      var this$1 = tree;
      if (($$x1 >= (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) {
        return null
      } else {
        var this$2 = tree;
        var l = $thiz.count__sci_RedBlackTree$Tree__I(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        if ((n > l)) {
          var this$3 = tree;
          var temp$tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var temp$n = (((-1) + ((n - l) | 0)) | 0);
          tree = temp$tree;
          n = temp$n
        } else if ((n === l)) {
          var this$4 = tree;
          var $$x3 = this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$5 = tree;
          var $$x2 = this$5.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$6 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(null, $$x3, $$x2, this$6.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        } else {
          var this$7 = tree;
          var $$x6 = $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree($thiz, this$7.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, n);
          var this$8 = tree;
          var $$x5 = this$8.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
          var this$9 = tree;
          var $$x4 = this$9.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value;
          var this$10 = tree;
          return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x6, $$x5, $$x4, this$10.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        }
      }
    }
  }
}
function $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree, k, ordering) {
  if ((tree === null)) {
    return null
  } else {
    var cmp = ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp < 0)) {
      var newLeft = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k, ordering);
      if ((newLeft === tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
        return tree
      } else {
        var tree$1 = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        if (((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
          return $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, newLeft, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
        } else {
          return tree.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
        }
      }
    } else if ((cmp > 0)) {
      var newRight = $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, ordering);
      if ((newRight === tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
        return tree
      } else {
        var tree$2 = tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if (((tree$2 !== null) && (tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
          return $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight)
        } else {
          return tree.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
        }
      }
    } else {
      return $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  }
}
function $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.black__sci_RedBlackTree$Tree(), tr.black__sci_RedBlackTree$Tree())
    } else {
      var tree$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if (((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        return tl.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.black__sci_RedBlackTree$Tree(), tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
      } else {
        var tree$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
        if (((tree$2 !== null) && (tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
          var $$x2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var this$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          var $$x1 = tl.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
          var this$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
          return $$x2.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x1, tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
        } else {
          return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
        }
      }
    }
  } else if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    var tree$3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (((tree$3 !== null) && (tree$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      return tr.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.black__sci_RedBlackTree$Tree())
    } else {
      var tree$4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      if (((tree$4 !== null) && (tree$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
        var $$x4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        var this$3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        var $$x3 = tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
        var this$4 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
        return $$x4.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x3, tr.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
      } else {
        return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
      }
    }
  } else {
    return tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr)
  }
}
function $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.black__sci_RedBlackTree$Tree(), tr)
  } else if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr.red__sci_RedBlackTree$Tree())
  } else {
    if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var $$x3 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$1 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x2 = tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$2 = tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      return $$x3.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x2, $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tr, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.red__sci_RedBlackTree$Tree()))
    } else {
      $m_s_sys_package$().error__T__E("Defect: invariance violation")
    }
  }
}
function $p_sci_RedBlackTree$__balRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl, tr) {
  if (((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return tree.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, tr.black__sci_RedBlackTree$Tree())
  } else if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tree, tl.red__sci_RedBlackTree$Tree(), tr)
  } else {
    if (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var $$x4 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x3 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.red__sci_RedBlackTree$Tree();
      var this$1 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x2 = $p_sci_RedBlackTree$__balance__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, $$x3, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var this$2 = tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      return $$x4.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($$x2, tree.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
    } else {
      $m_s_sys_package$().error__T__E("Defect: invariance violation")
    }
  }
}
function $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr) {
  if ((tl === null)) {
    return tr
  } else if ((tr === null)) {
    return tl
  } else if ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    if ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
      var bc = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      return (((bc !== null) && (bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) ? bc.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) : tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc)))
    } else {
      return tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr))
    }
  } else if ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    var bc$2 = $p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
    return (((bc$2 !== null) && (bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) ? bc$2.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) : $p_sci_RedBlackTree$__balLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(bc$2)))
  } else {
    return tr.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($p_sci_RedBlackTree$__append__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left))
  }
}
function $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, bhtl, rtr) {
  var rtl = ((tl === null) ? 0 : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtl) | 0) << 1) : (((-1) + (bhtl << 1)) | 0)));
  if ((rtl === (((rtr / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr)
  } else {
    var tlBlack = ((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    var bhtlr = (tlBlack ? (((-1) + bhtl) | 0) : bhtl);
    var ttr = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k, v, tr, bhtlr, rtr);
    if ((tlBlack && ((ttr !== null) && (ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var tree = ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left), ttr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.black__sci_RedBlackTree$Tree())
    } else {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, tlBlack, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ttr)
    }
  }
}
function $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr, rtl, bhtr) {
  var rtr = ((tr === null) ? 0 : ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtr) | 0) << 1) : (((-1) + (bhtr << 1)) | 0)));
  if ((rtr === (((rtl / 2) | 0) << 1))) {
    return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(k, v, tl, tr)
  } else {
    var trBlack = ((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0));
    var bhtrl = (trBlack ? (((-1) + bhtr) | 0) : bhtr);
    var ttl = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree($thiz, tl, k, v, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, rtl, bhtrl);
    if ((trBlack && ((ttl !== null) && (ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var tree = ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $thiz.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.black__sci_RedBlackTree$Tree(), $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))
    } else {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, trBlack, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, ttl, tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  }
}
function $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t, k2, ordering) {
  if ((t === null)) {
    return new $c_T4(null, null, null, k2)
  } else {
    var cmp = ordering.compare__O__O__I(k2, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    if ((cmp === 0)) {
      return new $c_T4(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
    } else if ((cmp < 0)) {
      var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k2, ordering);
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1)
      };
      var ll = $as_sci_RedBlackTree$Tree(x1.T4__f__1);
      var b = $as_sci_RedBlackTree$Tree(x1.T4__f__2);
      var lr = $as_sci_RedBlackTree$Tree(x1.T4__f__3);
      var k1 = x1.T4__f__4;
      return new $c_T4(ll, b, $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(lr, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right), k1)
    } else {
      var x1$2 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k2, ordering);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var rl = $as_sci_RedBlackTree$Tree(x1$2.T4__f__1);
      var b$3 = $as_sci_RedBlackTree$Tree(x1$2.T4__f__2);
      var rr = $as_sci_RedBlackTree$Tree(x1$2.T4__f__3);
      var k1$3 = x1$2.T4__f__4;
      return new $c_T4($thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, t.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, rl), b$3, rr, k1$3)
    }
  }
}
function $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, t1, t2, ordering) {
  if (((t1 === null) || (t1 === t2))) {
    return t2
  } else if ((t2 === null)) {
    return t1
  } else {
    var x1 = $p_sci_RedBlackTree$__split__sci_RedBlackTree$Tree__O__s_math_Ordering__T4($thiz, t1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, ordering);
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var l1 = $as_sci_RedBlackTree$Tree(x1.T4__f__1);
    var r1 = $as_sci_RedBlackTree$Tree(x1.T4__f__3);
    var k1 = x1.T4__f__4;
    var tl = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, l1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, ordering);
    var tr = $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree($thiz, r1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ordering);
    return $thiz.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tl, k1, t2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, tr)
  }
}
function $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, level, size, maxUsedDepth$1, xs$1) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree($thiz, ((level !== maxUsedDepth$1) || (level === 1)), xs$1.next__O(), null, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), leftSize, maxUsedDepth$1, xs$1);
      var x = xs$1.next__O();
      var right = $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), maxUsedDepth$1, xs$1);
      return $thiz.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(x, null, left, right)
    }
  }
}
function $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I($thiz, t, i) {
  while (true) {
    if ((t === null)) {
      return ((1 + i) | 0)
    } else {
      var this$1 = t;
      var temp$t = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var this$2 = t;
      if ((this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
        var temp$i = ((1 + i) | 0)
      } else {
        var temp$i = i
      };
      t = temp$t;
      i = temp$i
    }
  }
}
/** @constructor */
function $c_sci_RedBlackTree$() {
  this.sci_RedBlackTree$__f_null2 = null;
  $n_sci_RedBlackTree$ = this;
  this.sci_RedBlackTree$__f_null2 = new $c_T2(null, null)
}
$c_sci_RedBlackTree$.prototype = new $h_O();
$c_sci_RedBlackTree$.prototype.constructor = $c_sci_RedBlackTree$;
/** @constructor */
function $h_sci_RedBlackTree$() {
  /*<skip>*/
}
$h_sci_RedBlackTree$.prototype = $c_sci_RedBlackTree$.prototype;
$c_sci_RedBlackTree$.prototype.contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, x, evidence$1) {
  return (this.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(tree, x, evidence$1) !== null)
});
$c_sci_RedBlackTree$.prototype.lookup__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, x, ordering) {
  while (true) {
    if ((tree === null)) {
      return null
    } else {
      var this$1 = tree;
      var cmp = ordering.compare__O__O__I(x, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
      if ((cmp < 0)) {
        var this$2 = tree;
        tree = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      } else if ((cmp > 0)) {
        var this$3 = tree;
        tree = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
      } else {
        return tree
      }
    }
  }
});
$c_sci_RedBlackTree$.prototype.count__sci_RedBlackTree$Tree__I = (function(tree) {
  return ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
});
$c_sci_RedBlackTree$.prototype.update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, v, overwrite, evidence$3) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__upd__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, v, overwrite, evidence$3))
});
$c_sci_RedBlackTree$.prototype.delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, k, evidence$4) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__del__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this, tree, k, evidence$4))
});
$c_sci_RedBlackTree$.prototype.drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree = (function(tree, n, evidence$10) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$__doDrop__sci_RedBlackTree$Tree__I__sci_RedBlackTree$Tree(this, tree, n))
});
$c_sci_RedBlackTree$.prototype.smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  };
  var result = tree;
  while (true) {
    var this$1 = result;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      var this$2 = result;
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
    } else {
      break
    }
  };
  return result
});
$c_sci_RedBlackTree$.prototype.greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty tree")
  };
  var result = tree;
  while (true) {
    var this$1 = result;
    if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      var this$2 = result;
      result = this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
    } else {
      break
    }
  };
  return result
});
$c_sci_RedBlackTree$.prototype.keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z = (function(a, b, evidence$13) {
  return ((a === b) || ((a !== null) && ((b !== null) && (((2147483647 & a.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === (2147483647 & b.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) && new $c_sci_RedBlackTree$EqualsIterator(a, evidence$13).sameKeys__sci_RedBlackTree$EqualsIterator__Z(new $c_sci_RedBlackTree$EqualsIterator(b, evidence$13))))))
});
$c_sci_RedBlackTree$.prototype.foreachKey__sci_RedBlackTree$Tree__F1__V = (function(tree, f) {
  if ((tree !== null)) {
    $p_sci_RedBlackTree$___foreachKey__sci_RedBlackTree$Tree__F1__V(this, tree, f)
  }
});
$c_sci_RedBlackTree$.prototype.RedTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  var size = ((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, size)
});
$c_sci_RedBlackTree$.prototype.BlackTree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(key, value, left, right) {
  var size = ((1 + ((((left === null) ? 0 : (2147483647 & left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((right === null) ? 0 : (2147483647 & right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
  return new $c_sci_RedBlackTree$Tree(key, value, left, right, ((-2147483648) | size))
});
$c_sci_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - Math.clz32(size)) | 0);
  return $p_sci_RedBlackTree$__f$1__I__I__I__sc_Iterator__sci_RedBlackTree$Tree(this, 1, size, maxUsedDepth, xs)
});
$c_sci_RedBlackTree$.prototype.union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree = (function(t1, t2, ordering) {
  return $p_sci_RedBlackTree$__blacken__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, $p_sci_RedBlackTree$___union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this, t1, t2, ordering))
});
$c_sci_RedBlackTree$.prototype.scala$collection$immutable$RedBlackTree$$join__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tl, k, v, tr) {
  var bhtl = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tl, 0);
  var bhtr = $p_sci_RedBlackTree$__h$1__sci_RedBlackTree$Tree__I__I(this, tr, 0);
  if ((bhtl > bhtr)) {
    var tt = $p_sci_RedBlackTree$__joinRight__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, bhtl, ((tr === null) ? 0 : ((tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtr) | 0) << 1) : (((-1) + (bhtr << 1)) | 0))));
    if (((tt !== null) && (tt.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree = tt.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var $$x1 = ((tree !== null) && (tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return tt.black__sci_RedBlackTree$Tree()
    } else {
      return tt
    }
  } else if ((bhtr > bhtl)) {
    var tt$2 = $p_sci_RedBlackTree$__joinLeft__sci_RedBlackTree$Tree__O__O__sci_RedBlackTree$Tree__I__I__sci_RedBlackTree$Tree(this, tl, k, v, tr, ((tl === null) ? 0 : ((tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? ((((-1) + bhtl) | 0) << 1) : (((-1) + (bhtl << 1)) | 0))), bhtr);
    if (((tt$2 !== null) && (tt$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
      var tree$1 = tt$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      var $$x2 = ((tree$1 !== null) && (tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      return tt$2.black__sci_RedBlackTree$Tree()
    } else {
      return tt$2
    }
  } else {
    return $p_sci_RedBlackTree$__mkTree__Z__O__O__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this, (((tl !== null) && (tl.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) || ((tr !== null) && (tr.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))), k, v, tl, tr)
  }
});
var $d_sci_RedBlackTree$ = new $TypeData().initClass({
  sci_RedBlackTree$: 0
}, false, "scala.collection.immutable.RedBlackTree$", {
  sci_RedBlackTree$: 1,
  O: 1
});
$c_sci_RedBlackTree$.prototype.$classData = $d_sci_RedBlackTree$;
var $n_sci_RedBlackTree$;
function $m_sci_RedBlackTree$() {
  if ((!$n_sci_RedBlackTree$)) {
    $n_sci_RedBlackTree$ = new $c_sci_RedBlackTree$()
  };
  return $n_sci_RedBlackTree$
}
function $ct_sci_RedBlackTree$Helper__s_math_Ordering__($thiz, ordering) {
  $thiz.sci_RedBlackTree$Helper__f_ordering = ordering;
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$Helper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$Helper.prototype = new $h_O();
$c_sci_RedBlackTree$Helper.prototype.constructor = $c_sci_RedBlackTree$Helper;
/** @constructor */
function $h_sci_RedBlackTree$Helper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$Helper.prototype = $c_sci_RedBlackTree$Helper.prototype;
$c_sci_RedBlackTree$Helper.prototype.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  if ((tree === null)) {
    return tree
  } else if (((2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var res = tree.mutableBlack__sci_RedBlackTree$Tree().makeImmutable__sci_RedBlackTree$Tree();
    return res
  } else {
    return tree.black__sci_RedBlackTree$Tree()
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newLeft) {
  if ((newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newLeft_left = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var newLeft_right = newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    if (($m_sci_RedBlackTree$(), ((newLeft_left !== null) && (newLeft_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var resultLeft = newLeft_left.mutableBlack__sci_RedBlackTree$Tree();
      var resultRight = tree.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right);
      return newLeft.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else if (($m_sci_RedBlackTree$(), ((newLeft_right !== null) && (newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var newLeft_right_right = newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      var resultLeft$2 = newLeft.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight$2 = tree.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft_right_right);
      return newLeft_right.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
    } else {
      return tree.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
    }
  } else {
    return tree.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newLeft)
  }
});
$c_sci_RedBlackTree$Helper.prototype.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree, newRight) {
  if ((newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)) {
    var newRight_left = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    if (($m_sci_RedBlackTree$(), ((newRight_left !== null) && (newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
      var resultLeft = tree.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left);
      var resultRight = newRight.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      return newRight_left.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft, resultRight)
    } else {
      var newRight_right = newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      if (($m_sci_RedBlackTree$(), ((newRight_right !== null) && (newRight_right.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0)))) {
        var resultLeft$2 = tree.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight_left);
        var resultRight$2 = newRight_right.mutableBlack__sci_RedBlackTree$Tree();
        return newRight.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(resultLeft$2, resultRight$2)
      } else {
        return tree.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
      }
    }
  } else {
    return tree.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(newRight)
  }
});
function $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__sci_RedBlackTree$Tree($thiz) {
  if (((2147483647 & $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    var size = 1;
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left !== null)) {
      $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left.makeImmutable__sci_RedBlackTree$Tree();
      var $$x1 = size;
      var this$1 = $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
      size = (($$x1 + (2147483647 & this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0)
    };
    if (($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right !== null)) {
      $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right.makeImmutable__sci_RedBlackTree$Tree();
      var $$x2 = size;
      var this$2 = $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
      size = (($$x2 + (2147483647 & this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0)
    };
    $thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = ($thiz.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count | size)
  };
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$Tree(_key, _value, _left, _right, _count) {
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = null;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = 0;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key = _key;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value = _value;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = _left;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = _right;
  this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = _count
}
$c_sci_RedBlackTree$Tree.prototype = new $h_O();
$c_sci_RedBlackTree$Tree.prototype.constructor = $c_sci_RedBlackTree$Tree;
/** @constructor */
function $h_sci_RedBlackTree$Tree() {
  /*<skip>*/
}
$h_sci_RedBlackTree$Tree.prototype = $c_sci_RedBlackTree$Tree.prototype;
$c_sci_RedBlackTree$Tree.prototype.toString__T = (function() {
  return (((((((((((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? "RedTree" : "BlackTree") + "(") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) + ", ") + this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) + ")")
});
$c_sci_RedBlackTree$Tree.prototype.makeImmutable__sci_RedBlackTree$Tree = (function() {
  $p_sci_RedBlackTree$Tree__makeImmutableImpl$1__sci_RedBlackTree$Tree(this);
  return this
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlack__sci_RedBlackTree$Tree = (function() {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight)) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === newLeft) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left = newLeft;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.mutableBlackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right === newRight) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else if (((2147483647 & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) === 0)) {
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count = (-2147483648);
    this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right = newRight;
    return this
  } else {
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (-2147483648))
  }
});
$c_sci_RedBlackTree$Tree.prototype.black__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)))
});
$c_sci_RedBlackTree$Tree.prototype.red__sci_RedBlackTree$Tree = (function() {
  return ((this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) ^ this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)))
});
$c_sci_RedBlackTree$Tree.prototype.withV__O__sci_RedBlackTree$Tree = (function(newValue) {
  return (Object.is(newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value) ? this : new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, newValue, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))
});
$c_sci_RedBlackTree$Tree.prototype.withLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if ((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left)) {
    return this
  } else {
    var $$x1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($$x1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.withRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if ((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var $$x1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($$x1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, ((-2147483648) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var $$x1 = ((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count));
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right;
    var size = ((1 + (($$x1 + ((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, ((-2147483648) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newRight) {
  if (((newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var tree = this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left;
    var size = ((1 + ((((tree === null) ? 0 : (2147483647 & tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, newRight, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.withLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if (((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right))) {
    return this
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, (((-2147483648) & this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count) | size))
  }
});
$c_sci_RedBlackTree$Tree.prototype.redWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count >= 0))) {
    return this
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, size)
  }
});
$c_sci_RedBlackTree$Tree.prototype.blackWithLeftRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(newLeft, newRight) {
  if ((((newLeft === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left) && (newRight === this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)) && (this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count < 0))) {
    return this
  } else {
    var size = ((1 + ((((newLeft === null) ? 0 : (2147483647 & newLeft.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) + ((newRight === null) ? 0 : (2147483647 & newRight.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count))) | 0)) | 0);
    return new $c_sci_RedBlackTree$Tree(this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key, this.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_value, newLeft, newRight, ((-2147483648) | size))
  }
});
function $as_sci_RedBlackTree$Tree(obj) {
  return (((obj instanceof $c_sci_RedBlackTree$Tree) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.RedBlackTree$Tree"))
}
function $isArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_RedBlackTree$Tree)))
}
function $asArrayOf_sci_RedBlackTree$Tree(obj, depth) {
  return (($isArrayOf_sci_RedBlackTree$Tree(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.RedBlackTree$Tree;", depth))
}
var $d_sci_RedBlackTree$Tree = new $TypeData().initClass({
  sci_RedBlackTree$Tree: 0
}, false, "scala.collection.immutable.RedBlackTree$Tree", {
  sci_RedBlackTree$Tree: 1,
  O: 1
});
$c_sci_RedBlackTree$Tree.prototype.$classData = $d_sci_RedBlackTree$Tree;
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, ($m_s_reflect_ManifestFactory$AnyManifest$(), new $ac_O(0)), ($m_s_reflect_ManifestFactory$IntManifest$(), new $ac_I(0)), 0, 0)
}
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
  /*<skip>*/
}
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass({
  sci_SetNode$: 0
}, false, "scala.collection.immutable.SetNode$", {
  sci_SetNode$: 1,
  O: 1
});
$c_sci_SetNode$.prototype.$classData = $d_sci_SetNode$;
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$()
  };
  return $n_sci_SetNode$
}
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === a$1.u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)))
    } else {
      var bitsN = Math.imul(5, (((-1) + n) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & (((-1) + widthN) | 0));
      var hiRest = (hi & (((-1) + widthN) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $$x1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x1, (((loN === 0) && (hiN === a$2.u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)))
        } else {
          if ((hiN > loN)) {
            var $$x2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x2, (((loN === 0) && (hiN === a$3.u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)))
          };
          var temp$n = (((-1) + n) | 0);
          var temp$a = $asArrayOf_O(a.get(hiN), 1);
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = (((-1) + n) | 0);
        var temp$a$2 = $asArrayOf_O(a.get(loN), 1);
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, (((-1) + n) | 0), $asArrayOf_O(a.get(loN), 1), loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x3, (((start$1 === 0) && (hiN === a$4.u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)))
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $$x4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $$x4, (((start$2 === 0) && (hiN === a$5.u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)))
          };
          var temp$n$3 = (((-1) + n) | 0);
          var temp$a$3 = $asArrayOf_O(a.get(hiN), 1);
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue
        }
      }
    };
    return (void 0)
  }
}
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0)
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = (((-1) + n) | 0)
  };
  $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(idx, a)
}
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get((((-1) + n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(((11 - n) | 0)));
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $asArrayOf_O($$x1.get((((-1) + n$1) | 0)), 2);
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), preN1.get(0));
      if ((preN1.u.length === 1)) {
        var $$x2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $$x2.set((((-1) + n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($$x4.get(((11 - n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = preN1.u.length;
        $$x5.set((((-1) + n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to))
      }
    }
  }
}
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(((11 - n) | 0)) === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get((((-1) + n) | 0)));
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set((((-1) + n) | 0), null)
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $$x1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $asArrayOf_O($$x1.get(((11 - n$1) | 0)), 2);
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.set(((11 - n) | 0), sufN1.get((((-1) + sufN1.u.length) | 0)));
      if ((sufN1.u.length === 1)) {
        var $$x2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $$x2.set(((11 - n$2) | 0), null);
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $$x4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $$x3 = ($$x4.get((((-1) + n$3) | 0)) === null)
        } else {
          var $$x3 = false
        };
        if ($$x3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n
        }
      } else {
        var $$x5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = (((-1) + sufN1.u.length) | 0);
        $$x5.set(((11 - n$4) | 0), $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to))
      }
    }
  }
}
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0
}
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
  /*<skip>*/
}
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = Math.imul(a.u.length, (1 << Math.imul(5, (((-1) + n) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0)
  };
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0)
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$()
    } else {
      var prefix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(0);
      var suffix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(10);
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = ((prefix1.u.length + suffix1.u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = prefix1.u.length;
          var length = suffix1.u.length;
          suffix1.copyTo(0, dest, destPos, length);
          var a = dest
        } else {
          var a = prefix1
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1
      } else {
        var prefix2 = $asArrayOf_O(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1), 2);
        if ((prefix2 !== null)) {
          var a = prefix2.get(0)
        } else {
          var suffix2 = $asArrayOf_O(this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9), 2);
          var a = suffix2.get(0)
        }
      };
      return new $c_sci_Vector1(a)
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $$x1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $$x1.get((((-1) + n) | 0));
      var $$x2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $$x2.get(((11 - n$1) | 0));
      if (((pre !== null) && (suf !== null))) {
        if ((((pre.u.length + suf.u.length) | 0) <= 30)) {
          var $$x3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = ((pre.u.length + suf.u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = pre.u.length;
          var length$1 = suf.u.length;
          suf.copyTo(0, dest$1, destPos$1, length$1);
          $$x3.set((((-1) + n$2) | 0), dest$1);
          var $$x4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $$x4.set(((11 - n$3) | 0), null)
        } else {
          resultDim = ((1 + resultDim) | 0)
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if ((one.u.length > 30)) {
          resultDim = ((1 + resultDim) | 0)
        }
      }
    };
    var prefix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(0);
    var suffix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(10);
    var len1 = prefix1$2.u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        if ((p !== null)) {
          var $$x5 = p
        } else {
          var s = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
          var $$x5 = ((s !== null) ? s : a$1)
        };
        var data2 = $asArrayOf_O($$x5, 2);
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$2 = $asArrayOf_O(((p$1 !== null) ? p$1 : a$2), 2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        if ((p$2 !== null)) {
          var $$x6 = p$2
        } else {
          var s$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
          var $$x6 = ((s$1 !== null) ? s$1 : a$3)
        };
        var data3 = $asArrayOf_O($$x6, 3);
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$2 = $asArrayOf_O(((s$2 !== null) ? s$2 : a$4), 2);
        var len12 = ((len1 + (prefix2$2.u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$3 = $asArrayOf_O(((p$3 !== null) ? p$3 : a$5), 2);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3 = $asArrayOf_O(((p$4 !== null) ? p$4 : a$6), 3);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        if ((p$5 !== null)) {
          var $$x7 = p$5
        } else {
          var s$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
          var $$x7 = ((s$3 !== null) ? s$3 : a$7)
        };
        var data4 = $asArrayOf_O($$x7, 4);
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3 = $asArrayOf_O(((s$4 !== null) ? s$4 : a$8), 3);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$3 = $asArrayOf_O(((s$5 !== null) ? s$5 : a$9), 2);
        var len12$2 = ((len1 + (prefix2$3.u.length << 5)) | 0);
        var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$4 = $asArrayOf_O(((p$6 !== null) ? p$6 : a$10), 2);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3$2 = $asArrayOf_O(((p$7 !== null) ? p$7 : a$11), 3);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        var prefix4 = $asArrayOf_O(((p$8 !== null) ? p$8 : a$12), 4);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(4);
        if ((p$9 !== null)) {
          var $$x8 = p$9
        } else {
          var s$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(6);
          var $$x8 = ((s$6 !== null) ? s$6 : a$13)
        };
        var data5 = $asArrayOf_O($$x8, 5);
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
        var suffix4 = $asArrayOf_O(((s$7 !== null) ? s$7 : a$14), 4);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3$2 = $asArrayOf_O(((s$8 !== null) ? s$8 : a$15), 3);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$4 = $asArrayOf_O(((s$9 !== null) ? s$9 : a$16), 2);
        var len12$3 = ((len1 + (prefix2$4.u.length << 5)) | 0);
        var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
        var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(1);
        var prefix2$5 = $asArrayOf_O(((p$10 !== null) ? p$10 : a$17), 2);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(2);
        var prefix3$3 = $asArrayOf_O(((p$11 !== null) ? p$11 : a$18), 3);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(3);
        var prefix4$2 = $asArrayOf_O(((p$12 !== null) ? p$12 : a$19), 4);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(4);
        var prefix5 = $asArrayOf_O(((p$13 !== null) ? p$13 : a$20), 5);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(5);
        if ((p$14 !== null)) {
          var $$x9 = p$14
        } else {
          var s$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(5);
          var $$x9 = ((s$10 !== null) ? s$10 : a$21)
        };
        var data6 = $asArrayOf_O($$x9, 6);
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(6);
        var suffix5 = $asArrayOf_O(((s$11 !== null) ? s$11 : a$22), 5);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(7);
        var suffix4$2 = $asArrayOf_O(((s$12 !== null) ? s$12 : a$23), 4);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(8);
        var suffix3$3 = $asArrayOf_O(((s$13 !== null) ? s$13 : a$24), 3);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.get(9);
        var suffix2$5 = $asArrayOf_O(((s$14 !== null) ? s$14 : a$25), 2);
        var len12$4 = ((len1 + (prefix2$5.u.length << 5)) | 0);
        var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
        var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1)
      }
    };
    return res
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")")
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass({
  sci_VectorSliceBuilder: 0
}, false, "scala.collection.immutable.VectorSliceBuilder", {
  sci_VectorSliceBuilder: 1,
  O: 1
});
$c_sci_VectorSliceBuilder.prototype.$classData = $d_sci_VectorSliceBuilder;
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0)
}
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
  /*<skip>*/
}
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = a.u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  a.copyTo(0, ac, 0, alen);
  ac.set(alen, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + a.u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  ac.set((((-1) + ac.u.length) | 0), elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + a.u.length) | 0));
  var length = a.u.length;
  a.copyTo(0, ac, 1, length);
  ac.set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  var length = ((1 + a.u.length) | 0);
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  var length$1 = a.u.length;
  a.copyTo(0, ac, 1, length$1);
  ac.set(0, elem);
  return ac
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = a.u.length;
  if ((level === 0)) {
    while ((i < len)) {
      f.apply__O__O(a.get(i));
      i = ((1 + i) | 0)
    }
  } else {
    var l = (((-1) + level) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, $asArrayOf_O(a.get(i), 1), f);
      i = ((1 + i) | 0)
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < a.u.length)) {
    var v1 = a.get(i);
    var v2 = f.apply__O__O(v1);
    if ((!Object.is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2)
    };
    i = ((1 + i) | 0)
  };
  return a
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O(a.u.length);
  if ((at > 0)) {
    a.copyTo(0, ac, 0, at)
  };
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.set(i, f.apply__O__O(a.get(i)));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f)
  } else {
    var i = 0;
    while ((i < a.u.length)) {
      var v1 = a.get(i);
      var v2 = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(v1, 1), f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2)
      };
      i = ((1 + i) | 0)
    };
    return a
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var componentType = $objectGetClass(a).getComponentType__jl_Class();
  var length = a.u.length;
  var ac = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, length), 1);
  if ((at > 0)) {
    a.copyTo(0, ac, 0, at)
  };
  ac.set(at, v2);
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.set(i, this.mapElems__I__AO__F1__AO((((-1) + n) | 0), $asArrayOf_O(a.get(i), 1), f));
    i = ((1 + i) | 0)
  };
  return ac
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    var x2 = $as_sci_Iterable(xs);
    if ((x2.sizeCompare__I__I(((32 - suffix1.u.length) | 0)) <= 0)) {
      var x1$2 = x2.size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, x2.head__O());
          break
        }
        default: {
          var newLength = ((suffix1.u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var start = suffix1.u.length;
          x2.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b
        }
      }
    } else {
      return null
    }
  } else {
    var s = xs.knownSize__I();
    if (((s > 0) && (s <= ((32 - suffix1.u.length) | 0)))) {
      var newLength$1 = ((suffix1.u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$1 = xs.iterator__sc_Iterator();
      var start$1 = suffix1.u.length;
      this$1.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2
    } else {
      return null
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass({
  sci_VectorStatics$: 0
}, false, "scala.collection.immutable.VectorStatics$", {
  sci_VectorStatics$: 1,
  O: 1
});
$c_sci_VectorStatics$.prototype.$classData = $d_sci_VectorStatics$;
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$()
  };
  return $n_sci_VectorStatics$
}
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next
}
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
  /*<skip>*/
}
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashMap$Node__f__key))) {
      return _$this
    } else if (((_$this.scm_HashMap$Node__f__next === null) || (_$this.scm_HashMap$Node__f__hash > h))) {
      return null
    } else {
      _$this = _$this.scm_HashMap$Node__f__next
    }
  }
});
$c_scm_HashMap$Node.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    f.apply__O__O__O(_$this.scm_HashMap$Node__f__key, _$this.scm_HashMap$Node__f__value);
    if ((_$this.scm_HashMap$Node__f__next !== null)) {
      _$this = _$this.scm_HashMap$Node__f__next;
      continue
    };
    break
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next)
});
function $as_scm_HashMap$Node(obj) {
  return (((obj instanceof $c_scm_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap$Node"))
}
function $isArrayOf_scm_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap$Node)))
}
function $asArrayOf_scm_HashMap$Node(obj, depth) {
  return (($isArrayOf_scm_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap$Node;", depth))
}
var $d_scm_HashMap$Node = new $TypeData().initClass({
  scm_HashMap$Node: 0
}, false, "scala.collection.mutable.HashMap$Node", {
  scm_HashMap$Node: 1,
  O: 1
});
$c_scm_HashMap$Node.prototype.$classData = $d_scm_HashMap$Node;
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.scm_HashSet$Node__f__key = null;
  this.scm_HashSet$Node__f__hash = 0;
  this.scm_HashSet$Node__f__next = null;
  this.scm_HashSet$Node__f__key = _key;
  this.scm_HashSet$Node__f__hash = _hash;
  this.scm_HashSet$Node__f__next = _next
}
$c_scm_HashSet$Node.prototype = new $h_O();
$c_scm_HashSet$Node.prototype.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
  /*<skip>*/
}
$h_scm_HashSet$Node.prototype = $c_scm_HashSet$Node.prototype;
$c_scm_HashSet$Node.prototype.findNode__O__I__scm_HashSet$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashSet$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashSet$Node__f__key))) {
      return _$this
    } else if (((_$this.scm_HashSet$Node__f__next === null) || (_$this.scm_HashSet$Node__f__hash > h))) {
      return null
    } else {
      _$this = _$this.scm_HashSet$Node__f__next
    }
  }
});
$c_scm_HashSet$Node.prototype.toString__T = (function() {
  return ((((("Node(" + this.scm_HashSet$Node__f__key) + ", ") + this.scm_HashSet$Node__f__hash) + ") -> ") + this.scm_HashSet$Node__f__next)
});
function $as_scm_HashSet$Node(obj) {
  return (((obj instanceof $c_scm_HashSet$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet$Node"))
}
function $isArrayOf_scm_HashSet$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet$Node)))
}
function $asArrayOf_scm_HashSet$Node(obj, depth) {
  return (($isArrayOf_scm_HashSet$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet$Node;", depth))
}
var $d_scm_HashSet$Node = new $TypeData().initClass({
  scm_HashSet$Node: 0
}, false, "scala.collection.mutable.HashSet$Node", {
  scm_HashSet$Node: 1,
  O: 1
});
$c_scm_HashSet$Node.prototype.$classData = $d_scm_HashSet$Node;
/** @constructor */
function $c_scm_MutationTracker$() {
  /*<skip>*/
}
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
  /*<skip>*/
}
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message)
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass({
  scm_MutationTracker$: 0
}, false, "scala.collection.mutable.MutationTracker$", {
  scm_MutationTracker$: 1,
  O: 1
});
$c_scm_MutationTracker$.prototype.$classData = $d_scm_MutationTracker$;
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$()
  };
  return $n_scm_MutationTracker$
}
function $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node($thiz, node, key, ord) {
  while (true) {
    if ((node === null)) {
      return null
    } else {
      var cmp = ord.compare__O__O__I(key, node.scm_RedBlackTree$Node__f_key);
      if ((cmp < 0)) {
        node = node.scm_RedBlackTree$Node__f_left
      } else if ((cmp > 0)) {
        node = node.scm_RedBlackTree$Node__f_right
      } else {
        return node
      }
    }
  }
}
function $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node($thiz, node) {
  return ((node === null) ? null : $thiz.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node))
}
function $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, node) {
  var z = node;
  while ($thiz.isRed__scm_RedBlackTree$Node__Z(z.scm_RedBlackTree$Node__f_parent)) {
    if ((z.scm_RedBlackTree$Node__f_parent === z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
      var y = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y)) {
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        y.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        z = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent
      } else {
        if ((z === z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right)) {
          z = z.scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z)
        };
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent)
      }
    } else {
      var y$2 = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left;
      if ($thiz.isRed__scm_RedBlackTree$Node__Z(y$2)) {
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        y$2.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        z = z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent
      } else {
        if ((z === z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
          z = z.scm_RedBlackTree$Node__f_parent;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z)
        };
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = false;
        z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, z.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_parent)
      }
    }
  };
  tree.scm_RedBlackTree$Tree__f_root.scm_RedBlackTree$Node__f_red = false
}
function $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, node, parent) {
  var x = node;
  var xParent = parent;
  while (((x !== tree.scm_RedBlackTree$Tree__f_root) && $thiz.isBlack__scm_RedBlackTree$Node__Z(x))) {
    if ((x === xParent.scm_RedBlackTree$Node__f_left)) {
      var w = xParent.scm_RedBlackTree$Node__f_right;
      if (w.scm_RedBlackTree$Node__f_red) {
        w.scm_RedBlackTree$Node__f_red = false;
        xParent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w = xParent.scm_RedBlackTree$Node__f_right
      };
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z(w.scm_RedBlackTree$Node__f_left) && $thiz.isBlack__scm_RedBlackTree$Node__Z(w.scm_RedBlackTree$Node__f_right))) {
        w.scm_RedBlackTree$Node__f_red = true;
        x = xParent
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z(w.scm_RedBlackTree$Node__f_right)) {
          w.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_red = false;
          w.scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w);
          w = xParent.scm_RedBlackTree$Node__f_right
        };
        w.scm_RedBlackTree$Node__f_red = xParent.scm_RedBlackTree$Node__f_red;
        xParent.scm_RedBlackTree$Node__f_red = false;
        w.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = tree.scm_RedBlackTree$Tree__f_root
      }
    } else {
      var w$2 = xParent.scm_RedBlackTree$Node__f_left;
      if (w$2.scm_RedBlackTree$Node__f_red) {
        w$2.scm_RedBlackTree$Node__f_red = false;
        xParent.scm_RedBlackTree$Node__f_red = true;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        w$2 = xParent.scm_RedBlackTree$Node__f_left
      };
      if (($thiz.isBlack__scm_RedBlackTree$Node__Z(w$2.scm_RedBlackTree$Node__f_right) && $thiz.isBlack__scm_RedBlackTree$Node__Z(w$2.scm_RedBlackTree$Node__f_left))) {
        w$2.scm_RedBlackTree$Node__f_red = true;
        x = xParent
      } else {
        if ($thiz.isBlack__scm_RedBlackTree$Node__Z(w$2.scm_RedBlackTree$Node__f_left)) {
          w$2.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_red = false;
          w$2.scm_RedBlackTree$Node__f_red = true;
          $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, w$2);
          w$2 = xParent.scm_RedBlackTree$Node__f_left
        };
        w$2.scm_RedBlackTree$Node__f_red = xParent.scm_RedBlackTree$Node__f_red;
        xParent.scm_RedBlackTree$Node__f_red = false;
        w$2.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_red = false;
        $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, xParent);
        x = tree.scm_RedBlackTree$Tree__f_root
      }
    };
    xParent = x.scm_RedBlackTree$Node__f_parent
  };
  if ((x !== null)) {
    x.scm_RedBlackTree$Node__f_red = false
  }
}
function $p_scm_RedBlackTree$__rotateLeft__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = x.scm_RedBlackTree$Node__f_right;
    x.scm_RedBlackTree$Node__f_right = y.scm_RedBlackTree$Node__f_left;
    if ((y.scm_RedBlackTree$Node__f_left !== null)) {
      y.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_parent = x
    };
    y.scm_RedBlackTree$Node__f_parent = x.scm_RedBlackTree$Node__f_parent;
    if ((x.scm_RedBlackTree$Node__f_parent === null)) {
      tree.scm_RedBlackTree$Tree__f_root = y
    } else if ((x === x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left = y
    } else {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right = y
    };
    y.scm_RedBlackTree$Node__f_left = x;
    x.scm_RedBlackTree$Node__f_parent = y
  }
}
function $p_scm_RedBlackTree$__rotateRight__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V($thiz, tree, x) {
  if ((x !== null)) {
    var y = x.scm_RedBlackTree$Node__f_left;
    x.scm_RedBlackTree$Node__f_left = y.scm_RedBlackTree$Node__f_right;
    if ((y.scm_RedBlackTree$Node__f_right !== null)) {
      y.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_parent = x
    };
    y.scm_RedBlackTree$Node__f_parent = x.scm_RedBlackTree$Node__f_parent;
    if ((x.scm_RedBlackTree$Node__f_parent === null)) {
      tree.scm_RedBlackTree$Tree__f_root = y
    } else if ((x === x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right)) {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right = y
    } else {
      x.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left = y
    };
    y.scm_RedBlackTree$Node__f_right = x;
    x.scm_RedBlackTree$Node__f_parent = y
  }
}
function $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V($thiz, tree, to, from) {
  if ((to.scm_RedBlackTree$Node__f_parent === null)) {
    tree.scm_RedBlackTree$Tree__f_root = from
  } else if ((to === to.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left)) {
    to.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_left = from
  } else {
    to.scm_RedBlackTree$Node__f_parent.scm_RedBlackTree$Node__f_right = from
  };
  if ((from !== null)) {
    from.scm_RedBlackTree$Node__f_parent = to.scm_RedBlackTree$Node__f_parent
  }
}
function $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, level, size, xs$1, maxUsedDepth$1) {
  switch (size) {
    case 0: {
      return null;
      break
    }
    case 1: {
      return new $c_scm_RedBlackTree$Node(xs$1.next__O(), null, ((level === maxUsedDepth$1) && (level !== 1)), null, null, null);
      break
    }
    default: {
      var leftSize = (((((-1) + size) | 0) / 2) | 0);
      var left = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), leftSize, xs$1, maxUsedDepth$1);
      var x = xs$1.next__O();
      var right = $p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node($thiz, ((1 + level) | 0), (((((-1) + size) | 0) - leftSize) | 0), xs$1, maxUsedDepth$1);
      var n = new $c_scm_RedBlackTree$Node(x, null, false, left, right, null);
      if ((left !== null)) {
        left.scm_RedBlackTree$Node__f_parent = n
      };
      right.scm_RedBlackTree$Node__f_parent = n;
      return n
    }
  }
}
/** @constructor */
function $c_scm_RedBlackTree$() {
  /*<skip>*/
}
$c_scm_RedBlackTree$.prototype = new $h_O();
$c_scm_RedBlackTree$.prototype.constructor = $c_scm_RedBlackTree$;
/** @constructor */
function $h_scm_RedBlackTree$() {
  /*<skip>*/
}
$h_scm_RedBlackTree$.prototype = $c_scm_RedBlackTree$.prototype;
$c_scm_RedBlackTree$.prototype.isRed__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node !== null) && node.scm_RedBlackTree$Node__f_red)
});
$c_scm_RedBlackTree$.prototype.isBlack__scm_RedBlackTree$Node__Z = (function(node) {
  return ((node === null) || (!node.scm_RedBlackTree$Node__f_red))
});
$c_scm_RedBlackTree$.prototype.isEmpty__scm_RedBlackTree$Tree__Z = (function(tree) {
  return (tree.scm_RedBlackTree$Tree__f_root === null)
});
$c_scm_RedBlackTree$.prototype.contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z = (function(tree, key, evidence$2) {
  return ($p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, tree.scm_RedBlackTree$Tree__f_root, key, evidence$2) !== null)
});
$c_scm_RedBlackTree$.prototype.minKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = this.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(tree.scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.scm_RedBlackTree$Node__f_key))
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  return ((node === null) ? null : this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node))
});
$c_scm_RedBlackTree$.prototype.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if ((node.scm_RedBlackTree$Node__f_left === null)) {
      return node
    } else {
      node = node.scm_RedBlackTree$Node__f_left
    }
  }
});
$c_scm_RedBlackTree$.prototype.maxKey__scm_RedBlackTree$Tree__s_Option = (function(tree) {
  var x1 = $p_scm_RedBlackTree$__maxNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this, tree.scm_RedBlackTree$Tree__f_root);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.scm_RedBlackTree$Node__f_key))
});
$c_scm_RedBlackTree$.prototype.maxNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  while (true) {
    if ((node.scm_RedBlackTree$Node__f_right === null)) {
      return node
    } else {
      node = node.scm_RedBlackTree$Node__f_right
    }
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node = (function(node, key, ord) {
  if ((node === null)) {
    return null
  } else {
    var y = null;
    var x = node;
    var cmp = 1;
    while (((x !== null) && (cmp !== 0))) {
      y = x;
      cmp = ord.compare__O__O__I(key, x.scm_RedBlackTree$Node__f_key);
      x = ((cmp < 0) ? x.scm_RedBlackTree$Node__f_left : x.scm_RedBlackTree$Node__f_right)
    };
    return ((cmp <= 0) ? y : this.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(y))
  }
});
$c_scm_RedBlackTree$.prototype.insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V = (function(tree, key, value, ord) {
  var y = null;
  var x = tree.scm_RedBlackTree$Tree__f_root;
  var cmp = 1;
  while (((x !== null) && (cmp !== 0))) {
    y = x;
    cmp = ord.compare__O__O__I(key, x.scm_RedBlackTree$Node__f_key);
    x = ((cmp < 0) ? x.scm_RedBlackTree$Node__f_left : x.scm_RedBlackTree$Node__f_right)
  };
  if ((cmp === 0)) {
    y.scm_RedBlackTree$Node__f_value = value
  } else {
    var parent = y;
    var z = new $c_scm_RedBlackTree$Node(key, value, true, null, null, parent);
    if ((y === null)) {
      tree.scm_RedBlackTree$Tree__f_root = z
    } else if ((cmp < 0)) {
      y.scm_RedBlackTree$Node__f_left = z
    } else {
      y.scm_RedBlackTree$Node__f_right = z
    };
    $p_scm_RedBlackTree$__fixAfterInsert__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__V(this, tree, z);
    tree.scm_RedBlackTree$Tree__f_size = ((1 + tree.scm_RedBlackTree$Tree__f_size) | 0)
  }
});
$c_scm_RedBlackTree$.prototype.delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V = (function(tree, key, ord) {
  var z = $p_scm_RedBlackTree$__getNode__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(this, tree.scm_RedBlackTree$Tree__f_root, key, ord);
  if ((z !== null)) {
    var y = z;
    var yIsRed = y.scm_RedBlackTree$Node__f_red;
    var x = null;
    var xParent = null;
    if ((z.scm_RedBlackTree$Node__f_left === null)) {
      x = z.scm_RedBlackTree$Node__f_right;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, z.scm_RedBlackTree$Node__f_right);
      xParent = z.scm_RedBlackTree$Node__f_parent
    } else if ((z.scm_RedBlackTree$Node__f_right === null)) {
      x = z.scm_RedBlackTree$Node__f_left;
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, z.scm_RedBlackTree$Node__f_left);
      xParent = z.scm_RedBlackTree$Node__f_parent
    } else {
      y = this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(z.scm_RedBlackTree$Node__f_right);
      yIsRed = y.scm_RedBlackTree$Node__f_red;
      x = y.scm_RedBlackTree$Node__f_right;
      if ((y.scm_RedBlackTree$Node__f_parent === z)) {
        xParent = y
      } else {
        xParent = y.scm_RedBlackTree$Node__f_parent;
        $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, y, y.scm_RedBlackTree$Node__f_right);
        y.scm_RedBlackTree$Node__f_right = z.scm_RedBlackTree$Node__f_right;
        y.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_parent = y
      };
      $p_scm_RedBlackTree$__transplant__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, z, y);
      y.scm_RedBlackTree$Node__f_left = z.scm_RedBlackTree$Node__f_left;
      y.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_parent = y;
      y.scm_RedBlackTree$Node__f_red = z.scm_RedBlackTree$Node__f_red
    };
    if ((!yIsRed)) {
      $p_scm_RedBlackTree$__fixAfterDelete__scm_RedBlackTree$Tree__scm_RedBlackTree$Node__scm_RedBlackTree$Node__V(this, tree, x, xParent)
    };
    tree.scm_RedBlackTree$Tree__f_size = (((-1) + tree.scm_RedBlackTree$Tree__f_size) | 0)
  }
});
$c_scm_RedBlackTree$.prototype.scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(node) {
  if ((node.scm_RedBlackTree$Node__f_right !== null)) {
    return this.minNodeNonNull__scm_RedBlackTree$Node__scm_RedBlackTree$Node(node.scm_RedBlackTree$Node__f_right)
  } else {
    var x = node;
    var y = x.scm_RedBlackTree$Node__f_parent;
    while (((y !== null) && (x === y.scm_RedBlackTree$Node__f_right))) {
      x = y;
      y = y.scm_RedBlackTree$Node__f_parent
    };
    return y
  }
});
$c_scm_RedBlackTree$.prototype.fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree = (function(xs, size) {
  var maxUsedDepth = ((32 - Math.clz32(size)) | 0);
  return new $c_scm_RedBlackTree$Tree($p_scm_RedBlackTree$__f$3__I__I__sc_Iterator__I__scm_RedBlackTree$Node(this, 1, size, xs, maxUsedDepth), size)
});
$c_scm_RedBlackTree$.prototype.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node = (function(n) {
  if ((n === null)) {
    return null
  } else {
    var c = new $c_scm_RedBlackTree$Node(n.scm_RedBlackTree$Node__f_key, n.scm_RedBlackTree$Node__f_value, n.scm_RedBlackTree$Node__f_red, this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(n.scm_RedBlackTree$Node__f_left), this.copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(n.scm_RedBlackTree$Node__f_right), null);
    if ((c.scm_RedBlackTree$Node__f_left !== null)) {
      c.scm_RedBlackTree$Node__f_left.scm_RedBlackTree$Node__f_parent = c
    };
    if ((c.scm_RedBlackTree$Node__f_right !== null)) {
      c.scm_RedBlackTree$Node__f_right.scm_RedBlackTree$Node__f_parent = c
    };
    return c
  }
});
var $d_scm_RedBlackTree$ = new $TypeData().initClass({
  scm_RedBlackTree$: 0
}, false, "scala.collection.mutable.RedBlackTree$", {
  scm_RedBlackTree$: 1,
  O: 1
});
$c_scm_RedBlackTree$.prototype.$classData = $d_scm_RedBlackTree$;
var $n_scm_RedBlackTree$;
function $m_scm_RedBlackTree$() {
  if ((!$n_scm_RedBlackTree$)) {
    $n_scm_RedBlackTree$ = new $c_scm_RedBlackTree$()
  };
  return $n_scm_RedBlackTree$
}
/** @constructor */
function $c_scm_RedBlackTree$Node(key, value, red, left, right, parent) {
  this.scm_RedBlackTree$Node__f_key = null;
  this.scm_RedBlackTree$Node__f_value = null;
  this.scm_RedBlackTree$Node__f_red = false;
  this.scm_RedBlackTree$Node__f_left = null;
  this.scm_RedBlackTree$Node__f_right = null;
  this.scm_RedBlackTree$Node__f_parent = null;
  this.scm_RedBlackTree$Node__f_key = key;
  this.scm_RedBlackTree$Node__f_value = value;
  this.scm_RedBlackTree$Node__f_red = red;
  this.scm_RedBlackTree$Node__f_left = left;
  this.scm_RedBlackTree$Node__f_right = right;
  this.scm_RedBlackTree$Node__f_parent = parent
}
$c_scm_RedBlackTree$Node.prototype = new $h_O();
$c_scm_RedBlackTree$Node.prototype.constructor = $c_scm_RedBlackTree$Node;
/** @constructor */
function $h_scm_RedBlackTree$Node() {
  /*<skip>*/
}
$h_scm_RedBlackTree$Node.prototype = $c_scm_RedBlackTree$Node.prototype;
$c_scm_RedBlackTree$Node.prototype.toString__T = (function() {
  return (((((((((("Node(" + this.scm_RedBlackTree$Node__f_key) + ", ") + this.scm_RedBlackTree$Node__f_value) + ", ") + this.scm_RedBlackTree$Node__f_red) + ", ") + this.scm_RedBlackTree$Node__f_left) + ", ") + this.scm_RedBlackTree$Node__f_right) + ")")
});
var $d_scm_RedBlackTree$Node = new $TypeData().initClass({
  scm_RedBlackTree$Node: 0
}, false, "scala.collection.mutable.RedBlackTree$Node", {
  scm_RedBlackTree$Node: 1,
  O: 1
});
$c_scm_RedBlackTree$Node.prototype.$classData = $d_scm_RedBlackTree$Node;
/** @constructor */
function $c_scm_RedBlackTree$Tree(root, size) {
  this.scm_RedBlackTree$Tree__f_root = null;
  this.scm_RedBlackTree$Tree__f_size = 0;
  this.scm_RedBlackTree$Tree__f_root = root;
  this.scm_RedBlackTree$Tree__f_size = size
}
$c_scm_RedBlackTree$Tree.prototype = new $h_O();
$c_scm_RedBlackTree$Tree.prototype.constructor = $c_scm_RedBlackTree$Tree;
/** @constructor */
function $h_scm_RedBlackTree$Tree() {
  /*<skip>*/
}
$h_scm_RedBlackTree$Tree.prototype = $c_scm_RedBlackTree$Tree.prototype;
$c_scm_RedBlackTree$Tree.prototype.treeCopy__scm_RedBlackTree$Tree = (function() {
  return new $c_scm_RedBlackTree$Tree($m_scm_RedBlackTree$().copyTree__scm_RedBlackTree$Node__scm_RedBlackTree$Node(this.scm_RedBlackTree$Tree__f_root), this.scm_RedBlackTree$Tree__f_size)
});
var $d_scm_RedBlackTree$Tree = new $TypeData().initClass({
  scm_RedBlackTree$Tree: 0
}, false, "scala.collection.mutable.RedBlackTree$Tree", {
  scm_RedBlackTree$Tree: 1,
  O: 1
});
$c_scm_RedBlackTree$Tree.prototype.$classData = $d_scm_RedBlackTree$Tree;
/** @constructor */
function $c_sc_package$$colon$plus$() {
  /*<skip>*/
}
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
  /*<skip>*/
}
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
var $d_sc_package$$colon$plus$ = new $TypeData().initClass({
  sc_package$$colon$plus$: 0
}, false, "scala.collection.package$$colon$plus$", {
  sc_package$$colon$plus$: 1,
  O: 1
});
$c_sc_package$$colon$plus$.prototype.$classData = $d_sc_package$$colon$plus$;
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$()
  };
  return $n_sc_package$$colon$plus$
}
/** @constructor */
function $c_sc_package$$plus$colon$() {
  /*<skip>*/
}
$c_sc_package$$plus$colon$.prototype = new $h_O();
$c_sc_package$$plus$colon$.prototype.constructor = $c_sc_package$$plus$colon$;
/** @constructor */
function $h_sc_package$$plus$colon$() {
  /*<skip>*/
}
$h_sc_package$$plus$colon$.prototype = $c_sc_package$$plus$colon$.prototype;
var $d_sc_package$$plus$colon$ = new $TypeData().initClass({
  sc_package$$plus$colon$: 0
}, false, "scala.collection.package$$plus$colon$", {
  sc_package$$plus$colon$: 1,
  O: 1
});
$c_sc_package$$plus$colon$.prototype.$classData = $d_sc_package$$plus$colon$;
var $n_sc_package$$plus$colon$;
function $m_sc_package$$plus$colon$() {
  if ((!$n_sc_package$$plus$colon$)) {
    $n_sc_package$$plus$colon$ = new $c_sc_package$$plus$colon$()
  };
  return $n_sc_package$$plus$colon$
}
function $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable($thiz, curSize) {
  var curOther = $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
  var curLen = curOther.u.length;
  if ((curSize <= curLen)) {
    return curOther
  } else {
    var newLen = ((curLen === 0) ? 4 : (curLen << 1));
    if ((newLen <= curLen)) {
      throw new $c_jl_StackOverflowError(("Space limit of asynchronous stack reached: " + curLen))
    };
    var newOther = new ($d_jl_Runnable.getArrayOf().constr)(newLen);
    curOther.copyTo(0, newOther, 0, curLen);
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = newOther;
    return newOther
  }
}
function $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__($thiz, outer, first, other, size) {
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_first = first;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_other = other;
  $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_size = size;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = outer
  };
  return $thiz
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$AbstractBatch() {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null
}
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype = new $h_O();
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$AbstractBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$AbstractBatch() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutor$AbstractBatch.prototype = $c_s_concurrent_BatchingExecutor$AbstractBatch.prototype;
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.push__jl_Runnable__V = (function(r) {
  var sz = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
  if ((sz === 0)) {
    this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = r
  } else {
    $p_s_concurrent_BatchingExecutor$AbstractBatch__ensureCapacity__I__Ajl_Runnable(this, sz).set((((-1) + sz) | 0), r)
  };
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = ((1 + sz) | 0)
});
$c_s_concurrent_BatchingExecutor$AbstractBatch.prototype.runN__I__V = (function(n) {
  while (true) {
    if ((n > 0)) {
      var x1 = this.s_concurrent_BatchingExecutor$AbstractBatch__f_size;
      switch (x1) {
        case 0: {
          break
        }
        case 1: {
          var next = this.s_concurrent_BatchingExecutor$AbstractBatch__f_first;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
          next.run__V();
          n = (((-1) + n) | 0);
          continue;
          break
        }
        default: {
          var o = this.s_concurrent_BatchingExecutor$AbstractBatch__f_other;
          var next$2 = o.get((((-2) + x1) | 0));
          o.set((((-2) + x1) | 0), null);
          this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = (((-1) + x1) | 0);
          next$2.run__V();
          n = (((-1) + n) | 0);
          continue
        }
      }
    };
    return (void 0)
  }
});
/** @constructor */
function $c_s_concurrent_BatchingExecutorStatics$() {
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = null;
  $n_s_concurrent_BatchingExecutorStatics$ = this;
  this.s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray = new ($d_jl_Runnable.getArrayOf().constr)(0)
}
$c_s_concurrent_BatchingExecutorStatics$.prototype = new $h_O();
$c_s_concurrent_BatchingExecutorStatics$.prototype.constructor = $c_s_concurrent_BatchingExecutorStatics$;
/** @constructor */
function $h_s_concurrent_BatchingExecutorStatics$() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutorStatics$.prototype = $c_s_concurrent_BatchingExecutorStatics$.prototype;
var $d_s_concurrent_BatchingExecutorStatics$ = new $TypeData().initClass({
  s_concurrent_BatchingExecutorStatics$: 0
}, false, "scala.concurrent.BatchingExecutorStatics$", {
  s_concurrent_BatchingExecutorStatics$: 1,
  O: 1
});
$c_s_concurrent_BatchingExecutorStatics$.prototype.$classData = $d_s_concurrent_BatchingExecutorStatics$;
var $n_s_concurrent_BatchingExecutorStatics$;
function $m_s_concurrent_BatchingExecutorStatics$() {
  if ((!$n_s_concurrent_BatchingExecutorStatics$)) {
    $n_s_concurrent_BatchingExecutorStatics$ = new $c_s_concurrent_BatchingExecutorStatics$()
  };
  return $n_s_concurrent_BatchingExecutorStatics$
}
function $is_s_concurrent_BlockContext(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_BlockContext)))
}
function $as_s_concurrent_BlockContext(obj) {
  return (($is_s_concurrent_BlockContext(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BlockContext"))
}
function $isArrayOf_s_concurrent_BlockContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BlockContext)))
}
function $asArrayOf_s_concurrent_BlockContext(obj, depth) {
  return (($isArrayOf_s_concurrent_BlockContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BlockContext;", depth))
}
function $p_s_concurrent_BlockContext$__prefer__s_concurrent_BlockContext__s_concurrent_BlockContext($thiz, candidate) {
  if ((candidate !== null)) {
    return candidate
  } else {
    var t = $m_jl_Thread$().jl_Thread$__f_SingleThread;
    return ($is_s_concurrent_BlockContext(t) ? $as_s_concurrent_BlockContext(t) : $m_s_concurrent_BlockContext$DefaultBlockContext$())
  }
}
/** @constructor */
function $c_s_concurrent_BlockContext$() {
  this.s_concurrent_BlockContext$__f_contextLocal = null;
  $n_s_concurrent_BlockContext$ = this;
  this.s_concurrent_BlockContext$__f_contextLocal = new $c_jl_ThreadLocal()
}
$c_s_concurrent_BlockContext$.prototype = new $h_O();
$c_s_concurrent_BlockContext$.prototype.constructor = $c_s_concurrent_BlockContext$;
/** @constructor */
function $h_s_concurrent_BlockContext$() {
  /*<skip>*/
}
$h_s_concurrent_BlockContext$.prototype = $c_s_concurrent_BlockContext$.prototype;
$c_s_concurrent_BlockContext$.prototype.current__s_concurrent_BlockContext = (function() {
  return $p_s_concurrent_BlockContext$__prefer__s_concurrent_BlockContext__s_concurrent_BlockContext(this, $as_s_concurrent_BlockContext(this.s_concurrent_BlockContext$__f_contextLocal.get__O()))
});
var $d_s_concurrent_BlockContext$ = new $TypeData().initClass({
  s_concurrent_BlockContext$: 0
}, false, "scala.concurrent.BlockContext$", {
  s_concurrent_BlockContext$: 1,
  O: 1
});
$c_s_concurrent_BlockContext$.prototype.$classData = $d_s_concurrent_BlockContext$;
var $n_s_concurrent_BlockContext$;
function $m_s_concurrent_BlockContext$() {
  if ((!$n_s_concurrent_BlockContext$)) {
    $n_s_concurrent_BlockContext$ = new $c_s_concurrent_BlockContext$()
  };
  return $n_s_concurrent_BlockContext$
}
function $is_s_concurrent_ExecutionContext(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_ExecutionContext)))
}
function $as_s_concurrent_ExecutionContext(obj) {
  return (($is_s_concurrent_ExecutionContext(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.ExecutionContext"))
}
function $isArrayOf_s_concurrent_ExecutionContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_ExecutionContext)))
}
function $asArrayOf_s_concurrent_ExecutionContext(obj, depth) {
  return (($isArrayOf_s_concurrent_ExecutionContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.ExecutionContext;", depth))
}
/** @constructor */
function $c_s_concurrent_ExecutionContext$() {
  this.s_concurrent_ExecutionContext$__f_global = null;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = null;
  this.s_concurrent_ExecutionContext$__f_bitmap$0 = false;
  $n_s_concurrent_ExecutionContext$ = this;
  this.s_concurrent_ExecutionContext$__f_defaultReporter = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_jl_Throwable(x$1$2);
    x$1.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
  }))
}
$c_s_concurrent_ExecutionContext$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$.prototype.constructor = $c_s_concurrent_ExecutionContext$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$() {
  /*<skip>*/
}
$h_s_concurrent_ExecutionContext$.prototype = $c_s_concurrent_ExecutionContext$.prototype;
var $d_s_concurrent_ExecutionContext$ = new $TypeData().initClass({
  s_concurrent_ExecutionContext$: 0
}, false, "scala.concurrent.ExecutionContext$", {
  s_concurrent_ExecutionContext$: 1,
  O: 1
});
$c_s_concurrent_ExecutionContext$.prototype.$classData = $d_s_concurrent_ExecutionContext$;
var $n_s_concurrent_ExecutionContext$;
function $m_s_concurrent_ExecutionContext$() {
  if ((!$n_s_concurrent_ExecutionContext$)) {
    $n_s_concurrent_ExecutionContext$ = new $c_s_concurrent_ExecutionContext$()
  };
  return $n_s_concurrent_ExecutionContext$
}
/** @constructor */
function $c_s_concurrent_Future$() {
  this.s_concurrent_Future$__f_toBoxed = null;
  this.s_concurrent_Future$__f__cachedId = null;
  this.s_concurrent_Future$__f_collectFailed = null;
  this.s_concurrent_Future$__f_filterFailure = null;
  this.s_concurrent_Future$__f_failedFailure = null;
  this.s_concurrent_Future$__f_failedFailureFuture = null;
  this.s_concurrent_Future$__f__failedFun = null;
  this.s_concurrent_Future$__f_recoverWithFailedMarker = null;
  this.s_concurrent_Future$__f_recoverWithFailed = null;
  this.s_concurrent_Future$__f__zipWithTuple2 = null;
  this.s_concurrent_Future$__f__addToBuilderFun = null;
  this.s_concurrent_Future$__f_unit = null;
  $n_s_concurrent_Future$ = this;
  var this$22 = $m_s_Predef$().s_Predef$__f_Map;
  var array = [new $c_T2($d_Z.getClassOf(), $d_jl_Boolean.getClassOf()), new $c_T2($d_B.getClassOf(), $d_jl_Byte.getClassOf()), new $c_T2($d_C.getClassOf(), $d_jl_Character.getClassOf()), new $c_T2($d_S.getClassOf(), $d_jl_Short.getClassOf()), new $c_T2($d_I.getClassOf(), $d_jl_Integer.getClassOf()), new $c_T2($d_J.getClassOf(), $d_jl_Long.getClassOf()), new $c_T2($d_F.getClassOf(), $d_jl_Float.getClassOf()), new $c_T2($d_D.getClassOf(), $d_jl_Double.getClassOf()), new $c_T2($d_V.getClassOf(), $d_jl_Void.getClassOf())];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_Future$__f_toBoxed = this$22.from__sc_IterableOnce__sci_Map(elems);
  this.s_concurrent_Future$__f__cachedId = new $c_sjsr_AnonFunction1(((x$2) => x$2));
  this.s_concurrent_Future$__f_collectFailed = new $c_sjsr_AnonFunction1(((t$2) => {
    throw new $c_s_concurrent_Future$$anon$1(t$2)
  }));
  this.s_concurrent_Future$__f_filterFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$2());
  this.s_concurrent_Future$__f_failedFailure = new $c_s_util_Failure(new $c_s_concurrent_Future$$anon$3());
  this.s_concurrent_Future$__f_failedFailureFuture = $m_s_concurrent_Future$().fromTry__s_util_Try__s_concurrent_Future(this.s_concurrent_Future$__f_failedFailure);
  this.s_concurrent_Future$__f__failedFun = new $c_sjsr_AnonFunction1(((v$2) => {
    var v = $as_s_util_Try(v$2);
    return ((v instanceof $c_s_util_Failure) ? new $c_s_util_Success($as_s_util_Failure(v).s_util_Failure__f_exception) : $m_s_concurrent_Future$().s_concurrent_Future$__f_failedFailure)
  }));
  this.s_concurrent_Future$__f_recoverWithFailedMarker = $m_s_concurrent_Future$().failed__jl_Throwable__s_concurrent_Future(new $c_s_concurrent_Future$$anon$4());
  this.s_concurrent_Future$__f_recoverWithFailed = new $c_sjsr_AnonFunction1(((t$3$2) => {
    $as_jl_Throwable(t$3$2);
    return $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker
  }));
  this.s_concurrent_Future$__f__zipWithTuple2 = new $c_sjsr_AnonFunction2(((_1$2, _2$2) => new $c_T2(_1$2, _2$2)));
  this.s_concurrent_Future$__f__addToBuilderFun = new $c_sjsr_AnonFunction2(((b$2, e$2) => {
    var b = $as_scm_Builder(b$2);
    return $as_scm_Builder(b.addOne__O__scm_Growable(e$2))
  }));
  this.s_concurrent_Future$__f_unit = this.fromTry__s_util_Try__s_concurrent_Future(new $c_s_util_Success((void 0)))
}
$c_s_concurrent_Future$.prototype = new $h_O();
$c_s_concurrent_Future$.prototype.constructor = $c_s_concurrent_Future$;
/** @constructor */
function $h_s_concurrent_Future$() {
  /*<skip>*/
}
$h_s_concurrent_Future$.prototype = $c_s_concurrent_Future$.prototype;
$c_s_concurrent_Future$.prototype.failed__jl_Throwable__s_concurrent_Future = (function(exception) {
  return $m_s_concurrent_Promise$().failed__jl_Throwable__s_concurrent_Promise(exception)
});
$c_s_concurrent_Future$.prototype.fromTry__s_util_Try__s_concurrent_Future = (function(result) {
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result)
});
var $d_s_concurrent_Future$ = new $TypeData().initClass({
  s_concurrent_Future$: 0
}, false, "scala.concurrent.Future$", {
  s_concurrent_Future$: 1,
  O: 1
});
$c_s_concurrent_Future$.prototype.$classData = $d_s_concurrent_Future$;
var $n_s_concurrent_Future$;
function $m_s_concurrent_Future$() {
  if ((!$n_s_concurrent_Future$)) {
    $n_s_concurrent_Future$ = new $c_s_concurrent_Future$()
  };
  return $n_s_concurrent_Future$
}
function $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result) {
  if ($thiz.tryComplete__s_util_Try__Z(result)) {
    return $thiz
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Promise already completed.")
  }
}
function $f_s_concurrent_Promise__success__O__s_concurrent_Promise($thiz, value) {
  var result = new $c_s_util_Success(value);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result)
}
function $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise($thiz, cause) {
  var result = new $c_s_util_Failure(cause);
  return $f_s_concurrent_Promise__complete__s_util_Try__s_concurrent_Promise($thiz, result)
}
/** @constructor */
function $c_s_concurrent_Promise$() {
  /*<skip>*/
}
$c_s_concurrent_Promise$.prototype = new $h_O();
$c_s_concurrent_Promise$.prototype.constructor = $c_s_concurrent_Promise$;
/** @constructor */
function $h_s_concurrent_Promise$() {
  /*<skip>*/
}
$h_s_concurrent_Promise$.prototype = $c_s_concurrent_Promise$.prototype;
$c_s_concurrent_Promise$.prototype.failed__jl_Throwable__s_concurrent_Promise = (function(exception) {
  var result = new $c_s_util_Failure(exception);
  return $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__(new $c_s_concurrent_impl_Promise$DefaultPromise(), result)
});
var $d_s_concurrent_Promise$ = new $TypeData().initClass({
  s_concurrent_Promise$: 0
}, false, "scala.concurrent.Promise$", {
  s_concurrent_Promise$: 1,
  O: 1
});
$c_s_concurrent_Promise$.prototype.$classData = $d_s_concurrent_Promise$;
var $n_s_concurrent_Promise$;
function $m_s_concurrent_Promise$() {
  if ((!$n_s_concurrent_Promise$)) {
    $n_s_concurrent_Promise$ = new $c_s_concurrent_Promise$()
  };
  return $n_s_concurrent_Promise$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = $as_s_concurrent_duration_package$DurationInt(x$1).s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1)
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt$: 0
}, false, "scala.concurrent.duration.package$DurationInt$", {
  s_concurrent_duration_package$DurationInt$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationInt$.prototype.$classData = $d_s_concurrent_duration_package$DurationInt$;
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$()
  };
  return $n_s_concurrent_duration_package$DurationInt$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong$() {
  /*<skip>*/
}
$c_s_concurrent_duration_package$DurationLong$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong$.prototype.constructor = $c_s_concurrent_duration_package$DurationLong$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong$() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationLong$.prototype = $c_s_concurrent_duration_package$DurationLong$.prototype;
$c_s_concurrent_duration_package$DurationLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationLong)) {
    var t = $as_s_concurrent_duration_package$DurationLong(x$1).s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi))
  } else {
    return false
  }
});
var $d_s_concurrent_duration_package$DurationLong$ = new $TypeData().initClass({
  s_concurrent_duration_package$DurationLong$: 0
}, false, "scala.concurrent.duration.package$DurationLong$", {
  s_concurrent_duration_package$DurationLong$: 1,
  O: 1
});
$c_s_concurrent_duration_package$DurationLong$.prototype.$classData = $d_s_concurrent_duration_package$DurationLong$;
var $n_s_concurrent_duration_package$DurationLong$;
function $m_s_concurrent_duration_package$DurationLong$() {
  if ((!$n_s_concurrent_duration_package$DurationLong$)) {
    $n_s_concurrent_duration_package$DurationLong$ = new $c_s_concurrent_duration_package$DurationLong$()
  };
  return $n_s_concurrent_duration_package$DurationLong$
}
/** @constructor */
function $c_s_concurrent_impl_Promise$() {
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = null;
  $n_s_concurrent_impl_Promise$ = this;
  this.s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop = $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 0, null, $m_s_concurrent_ExecutionContext$parasitic$())
}
$c_s_concurrent_impl_Promise$.prototype = new $h_O();
$c_s_concurrent_impl_Promise$.prototype.constructor = $c_s_concurrent_impl_Promise$;
/** @constructor */
function $h_s_concurrent_impl_Promise$() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$.prototype = $c_s_concurrent_impl_Promise$.prototype;
$c_s_concurrent_impl_Promise$.prototype.scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try = (function(value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ((value instanceof $c_s_util_Success)) {
    return value
  } else {
    var t = $as_s_util_Failure(value).s_util_Failure__f_exception;
    return (((false || false) || (t instanceof $c_jl_Error)) ? (false ? new $c_s_util_Success($as_sr_NonLocalReturnControl(t).value__O()) : new $c_s_util_Failure(new $c_ju_concurrent_ExecutionException("Boxed Exception", t))) : value)
  }
});
var $d_s_concurrent_impl_Promise$ = new $TypeData().initClass({
  s_concurrent_impl_Promise$: 0
}, false, "scala.concurrent.impl.Promise$", {
  s_concurrent_impl_Promise$: 1,
  O: 1
});
$c_s_concurrent_impl_Promise$.prototype.$classData = $d_s_concurrent_impl_Promise$;
var $n_s_concurrent_impl_Promise$;
function $m_s_concurrent_impl_Promise$() {
  if ((!$n_s_concurrent_impl_Promise$)) {
    $n_s_concurrent_impl_Promise$ = new $c_s_concurrent_impl_Promise$()
  };
  return $n_s_concurrent_impl_Promise$
}
function $is_s_concurrent_impl_Promise$Callbacks(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_impl_Promise$Callbacks)))
}
function $as_s_concurrent_impl_Promise$Callbacks(obj) {
  return (($is_s_concurrent_impl_Promise$Callbacks(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Callbacks"))
}
function $isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Callbacks)))
}
function $asArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Callbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Callbacks;", depth))
}
/** @constructor */
function $c_s_math_Ordered$() {
  /*<skip>*/
}
$c_s_math_Ordered$.prototype = new $h_O();
$c_s_math_Ordered$.prototype.constructor = $c_s_math_Ordered$;
/** @constructor */
function $h_s_math_Ordered$() {
  /*<skip>*/
}
$h_s_math_Ordered$.prototype = $c_s_math_Ordered$.prototype;
var $d_s_math_Ordered$ = new $TypeData().initClass({
  s_math_Ordered$: 0
}, false, "scala.math.Ordered$", {
  s_math_Ordered$: 1,
  O: 1
});
$c_s_math_Ordered$.prototype.$classData = $d_s_math_Ordered$;
var $n_s_math_Ordered$;
function $m_s_math_Ordered$() {
  if ((!$n_s_math_Ordered$)) {
    $n_s_math_Ordered$ = new $c_s_math_Ordered$()
  };
  return $n_s_math_Ordered$
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var t = $thiz.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((((hi === (-1)) ? (((-2147483648) ^ lo) >= 0) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-1)) : (hi < 0))) ? lo : $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi)))
}
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2))
  } else if ($isByte(x)) {
    var x3 = $uB(x);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3))
  } else if ($isShort(x)) {
    var x4 = $uS(x);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4))
  } else if ($isInt(x)) {
    var x5 = $uI(x);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5))
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$1 = $thiz.longValue__J();
    return ((this$1.RTLong__f_lo === lo) && (this$1.RTLong__f_hi === hi))
  } else if ($isFloat(x)) {
    var x7 = $uF(x);
    return ($thiz.floatValue__F() === x7)
  } else if (((typeof x) === "number")) {
    var x8 = $uD(x);
    return ($thiz.doubleValue__D() === x8)
  } else {
    return false
  }
}
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigDecimal
}
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigInt = $m_s_math_BigInt$();
    $thiz.s_package$__f_bitmap$0 = (((2 | $thiz.s_package$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.s_package$__f_BigInt
}
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_AnyRef = null;
  this.s_package$__f_Traversable = null;
  this.s_package$__f_Iterable = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_IndexedSeq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$colon$colon = null;
  this.s_package$__f_$plus$colon = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_StringBuilder = null;
  this.s_package$__f_Range = null;
  this.s_package$__f_Equiv = null;
  this.s_package$__f_Fractional = null;
  this.s_package$__f_Integral = null;
  this.s_package$__f_Numeric = null;
  this.s_package$__f_Ordered = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Either = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  this.s_package$__f_AnyRef = new $c_s_package$$anon$1();
  this.s_package$__f_Traversable = $m_sc_Iterable$();
  this.s_package$__f_Iterable = $m_sc_Iterable$();
  this.s_package$__f_Seq = $m_sci_Seq$();
  this.s_package$__f_IndexedSeq = $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$colon$colon = $m_sci_$colon$colon$();
  this.s_package$__f_$plus$colon = $m_sc_package$$plus$colon$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_StringBuilder = $m_scm_StringBuilder$();
  this.s_package$__f_Range = $m_sci_Range$();
  this.s_package$__f_Equiv = $m_s_math_Equiv$();
  this.s_package$__f_Fractional = $m_s_math_Fractional$();
  this.s_package$__f_Integral = $m_s_math_Integral$();
  this.s_package$__f_Numeric = $m_s_math_Numeric$();
  this.s_package$__f_Ordered = $m_s_math_Ordered$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Either = $m_s_util_Either$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$()
}
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
  /*<skip>*/
}
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal)
});
$c_s_package$.prototype.BigInt__s_math_BigInt$ = (function() {
  return (((((2 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.s_package$__f_BigInt)
});
var $d_s_package$ = new $TypeData().initClass({
  s_package$: 0
}, false, "scala.package$", {
  s_package$: 1,
  O: 1
});
$c_s_package$.prototype.$classData = $d_s_package$;
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$()
  };
  return $n_s_package$
}
/** @constructor */
function $c_s_package$$hash$colon$colon$() {
  /*<skip>*/
}
$c_s_package$$hash$colon$colon$.prototype = new $h_O();
$c_s_package$$hash$colon$colon$.prototype.constructor = $c_s_package$$hash$colon$colon$;
/** @constructor */
function $h_s_package$$hash$colon$colon$() {
  /*<skip>*/
}
$h_s_package$$hash$colon$colon$.prototype = $c_s_package$$hash$colon$colon$.prototype;
$c_s_package$$hash$colon$colon$.prototype.unapply__sci_Stream__s_Option = (function(s) {
  return ((!s.isEmpty__Z()) ? new $c_s_Some(new $c_T2(s.head__O(), s.tail__O())) : $m_s_None$())
});
var $d_s_package$$hash$colon$colon$ = new $TypeData().initClass({
  s_package$$hash$colon$colon$: 0
}, false, "scala.package$$hash$colon$colon$", {
  s_package$$hash$colon$colon$: 1,
  O: 1
});
$c_s_package$$hash$colon$colon$.prototype.$classData = $d_s_package$$hash$colon$colon$;
var $n_s_package$$hash$colon$colon$;
function $m_s_package$$hash$colon$colon$() {
  if ((!$n_s_package$$hash$colon$colon$)) {
    $n_s_package$$hash$colon$colon$ = new $c_s_package$$hash$colon$colon$()
  };
  return $n_s_package$$hash$colon$colon$
}
function $p_s_reflect_NameTransformer$__enterOp__C__T__V($thiz, op, code) {
  $thiz.s_reflect_NameTransformer$__f_op2code.set(op, code);
  var c = (((-97) + ((Math.imul(26, (((-97) + (65535 & $uI(code.charCodeAt(1)))) | 0)) + (65535 & $uI(code.charCodeAt(2)))) | 0)) | 0);
  $thiz.s_reflect_NameTransformer$__f_code2op.set(c, new $c_s_reflect_NameTransformer$OpCodes(op, code, $thiz.s_reflect_NameTransformer$__f_code2op.get(c)))
}
/** @constructor */
function $c_s_reflect_NameTransformer$() {
  this.s_reflect_NameTransformer$__f_nops = 0;
  this.s_reflect_NameTransformer$__f_ncodes = 0;
  this.s_reflect_NameTransformer$__f_op2code = null;
  this.s_reflect_NameTransformer$__f_code2op = null;
  $n_s_reflect_NameTransformer$ = this;
  this.s_reflect_NameTransformer$__f_nops = 128;
  this.s_reflect_NameTransformer$__f_ncodes = 676;
  this.s_reflect_NameTransformer$__f_op2code = new ($d_T.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_nops);
  this.s_reflect_NameTransformer$__f_code2op = new ($d_s_reflect_NameTransformer$OpCodes.getArrayOf().constr)(this.s_reflect_NameTransformer$__f_ncodes);
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 126, "$tilde");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 61, "$eq");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 60, "$less");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 62, "$greater");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 33, "$bang");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 35, "$hash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 37, "$percent");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 94, "$up");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 38, "$amp");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 124, "$bar");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 42, "$times");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 47, "$div");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 43, "$plus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 45, "$minus");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 58, "$colon");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 92, "$bslash");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 63, "$qmark");
  $p_s_reflect_NameTransformer$__enterOp__C__T__V(this, 64, "$at")
}
$c_s_reflect_NameTransformer$.prototype = new $h_O();
$c_s_reflect_NameTransformer$.prototype.constructor = $c_s_reflect_NameTransformer$;
/** @constructor */
function $h_s_reflect_NameTransformer$() {
  /*<skip>*/
}
$h_s_reflect_NameTransformer$.prototype = $c_s_reflect_NameTransformer$.prototype;
$c_s_reflect_NameTransformer$.prototype.decode__T__T = (function(name0) {
  var name = ($f_T__endsWith__T__Z(name0, "<init>") ? ($m_sc_StringOps$().stripSuffix$extension__T__T__T(name0, "<init>") + "this") : name0);
  var buf = null;
  var len = $uI(name.length);
  var i = 0;
  while ((i < len)) {
    var ops = null;
    var unicode = false;
    var index = i;
    var c = (65535 & $uI(name.charCodeAt(index)));
    if (((c === 36) && (((2 + i) | 0) < len))) {
      var index$1 = ((1 + i) | 0);
      var ch1 = (65535 & $uI(name.charCodeAt(index$1)));
      if (((ch1 >= 97) && (ch1 <= 122))) {
        var index$2 = ((2 + i) | 0);
        var ch2 = (65535 & $uI(name.charCodeAt(index$2)));
        if (((ch2 >= 97) && (ch2 <= 122))) {
          ops = this.s_reflect_NameTransformer$__f_code2op.get((((-97) + ((Math.imul(26, (((-97) + ch1) | 0)) + ch2) | 0)) | 0));
          while (true) {
            if ((ops !== null)) {
              var prefix = ops.s_reflect_NameTransformer$OpCodes__f_code;
              var toffset = i;
              var $$x1 = (!(((toffset <= $uI(name.length)) && (toffset >= 0)) && ($as_T(name.substring(toffset, ((toffset + $uI(prefix.length)) | 0))) === prefix)))
            } else {
              var $$x1 = false
            };
            if ($$x1) {
              ops = ops.s_reflect_NameTransformer$OpCodes__f_next
            } else {
              break
            }
          };
          if ((ops !== null)) {
            if ((buf === null)) {
              buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
              var $$x2 = buf;
              var endIndex = i;
              $$x2.append__T__scm_StringBuilder($as_T(name.substring(0, endIndex)))
            };
            buf.append__C__scm_StringBuilder(ops.s_reflect_NameTransformer$OpCodes__f_op);
            var $$x3 = i;
            var this$3 = ops.s_reflect_NameTransformer$OpCodes__f_code;
            i = (($$x3 + $uI(this$3.length)) | 0)
          }
        } else {
          if (((((len - i) | 0) >= 6) && (ch1 === 117))) {
            var this$4 = $m_jl_Character$();
            if (this$4.isDigit__I__Z(ch2)) {
              var $$x4 = true
            } else {
              var $$x4 = ((ch2 >= 65) && (ch2 <= 70))
            }
          } else {
            var $$x4 = false
          };
          if ($$x4) {
            var beginIndex = ((2 + i) | 0);
            var endIndex$1 = ((6 + i) | 0);
            var hex = $as_T(name.substring(beginIndex, endIndex$1));
            try {
              var str = (65535 & $m_jl_Integer$().parseInt__T__I__I(hex, 16));
              if ((buf === null)) {
                buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
                var $$x5 = buf;
                var endIndex$2 = i;
                $$x5.append__T__scm_StringBuilder($as_T(name.substring(0, endIndex$2)))
              };
              buf.append__C__scm_StringBuilder(str);
              i = ((6 + i) | 0);
              unicode = true
            } catch (e) {
              if ((!(e instanceof $c_jl_NumberFormatException))) {
                throw e
              }
            }
          }
        }
      }
    };
    if (((ops === null) && (!unicode))) {
      if ((buf !== null)) {
        buf.append__C__scm_StringBuilder(c)
      };
      i = ((1 + i) | 0)
    }
  };
  if ((buf === null)) {
    return name
  } else {
    var this$5 = buf;
    return this$5.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
  }
});
var $d_s_reflect_NameTransformer$ = new $TypeData().initClass({
  s_reflect_NameTransformer$: 0
}, false, "scala.reflect.NameTransformer$", {
  s_reflect_NameTransformer$: 1,
  O: 1
});
$c_s_reflect_NameTransformer$.prototype.$classData = $d_s_reflect_NameTransformer$;
var $n_s_reflect_NameTransformer$;
function $m_s_reflect_NameTransformer$() {
  if ((!$n_s_reflect_NameTransformer$)) {
    $n_s_reflect_NameTransformer$ = new $c_s_reflect_NameTransformer$()
  };
  return $n_s_reflect_NameTransformer$
}
/** @constructor */
function $c_s_reflect_NameTransformer$OpCodes(op, code, next) {
  this.s_reflect_NameTransformer$OpCodes__f_op = 0;
  this.s_reflect_NameTransformer$OpCodes__f_code = null;
  this.s_reflect_NameTransformer$OpCodes__f_next = null;
  this.s_reflect_NameTransformer$OpCodes__f_op = op;
  this.s_reflect_NameTransformer$OpCodes__f_code = code;
  this.s_reflect_NameTransformer$OpCodes__f_next = next
}
$c_s_reflect_NameTransformer$OpCodes.prototype = new $h_O();
$c_s_reflect_NameTransformer$OpCodes.prototype.constructor = $c_s_reflect_NameTransformer$OpCodes;
/** @constructor */
function $h_s_reflect_NameTransformer$OpCodes() {
  /*<skip>*/
}
$h_s_reflect_NameTransformer$OpCodes.prototype = $c_s_reflect_NameTransformer$OpCodes.prototype;
var $d_s_reflect_NameTransformer$OpCodes = new $TypeData().initClass({
  s_reflect_NameTransformer$OpCodes: 0
}, false, "scala.reflect.NameTransformer$OpCodes", {
  s_reflect_NameTransformer$OpCodes: 1,
  O: 1
});
$c_s_reflect_NameTransformer$OpCodes.prototype.$classData = $d_s_reflect_NameTransformer$OpCodes;
/** @constructor */
function $c_sr_BoxesRunTime$() {
  /*<skip>*/
}
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
  /*<skip>*/
}
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  if ((x === y)) {
    return true
  } else if ($is_jl_Number(x)) {
    var x2 = $as_jl_Number(x);
    return this.equalsNumObject__jl_Number__O__Z(x2, y)
  } else if ((x instanceof $Char)) {
    var x3 = $as_jl_Character(x);
    return this.equalsCharObject__jl_Character__O__Z(x3, y)
  } else {
    return ((x === null) ? (y === null) : $dp_equals__O__Z(x, y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    var x2 = $as_jl_Number(y);
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, x2)
  } else if ((y instanceof $Char)) {
    var x3 = $as_jl_Character(y);
    if (((typeof xn) === "number")) {
      var x2$1 = $uD(xn);
      return (x2$1 === $uC(x3))
    } else if ((xn instanceof $c_RTLong)) {
      var t = $uJ(xn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = $uC(x3);
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((xn === null) ? (x3 === null) : $dp_equals__O__Z(xn, x3))
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = $uD(xn);
    if (((typeof yn) === "number")) {
      var x2$2 = $uD(yn);
      return (x2 === x2$2)
    } else if ((yn instanceof $c_RTLong)) {
      var t = $uJ(yn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return (x2 === $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi))
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4 = $as_s_math_ScalaNumber(yn);
      return x4.equals__O__Z(x2)
    } else {
      return false
    }
  } else if ((xn instanceof $c_RTLong)) {
    var t$1 = $uJ(xn);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((yn instanceof $c_RTLong)) {
      var t$2 = $uJ(yn);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return ((lo$1 === lo$2) && (hi$1 === hi$2))
    } else if (((typeof yn) === "number")) {
      var x3$3 = $uD(yn);
      return ($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo$1, hi$1) === x3$3)
    } else if ((yn instanceof $c_s_math_ScalaNumber)) {
      var x4$2 = $as_s_math_ScalaNumber(yn);
      return x4$2.equals__O__Z(new $c_RTLong(lo$1, hi$1))
    } else {
      return false
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z(xn, yn))
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var x2 = $as_jl_Character(y);
    return ($uC(xc) === $uC(x2))
  } else if ($is_jl_Number(y)) {
    var x3 = $as_jl_Number(y);
    if (((typeof x3) === "number")) {
      var x2$1 = $uD(x3);
      return (x2$1 === $uC(xc))
    } else if ((x3 instanceof $c_RTLong)) {
      var t = $uJ(x3);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = $uC(xc);
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1))
    } else {
      return ((x3 === null) ? (xc === null) : $dp_equals__O__Z(x3, xc))
    }
  } else {
    return ((xc === null) && (y === null))
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass({
  sr_BoxesRunTime$: 0
}, false, "scala.runtime.BoxesRunTime$", {
  sr_BoxesRunTime$: 1,
  O: 1
});
$c_sr_BoxesRunTime$.prototype.$classData = $d_sr_BoxesRunTime$;
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$()
  };
  return $n_sr_BoxesRunTime$
}
var $d_sr_Null$ = new $TypeData().initClass({
  sr_Null$: 0
}, false, "scala.runtime.Null$", {
  sr_Null$: 1,
  O: 1
});
/** @constructor */
function $c_sr_RichLong$() {
  /*<skip>*/
}
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
  /*<skip>*/
}
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 24) >> 24);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 16) >> 16);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$) {
  var value = (65535 & this$.RTLong__f_lo);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$) {
  var value = this$.RTLong__f_lo;
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi))
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var t = $as_sr_RichLong(x$1).sr_RichLong__f_self;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi))
  } else {
    return false
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass({
  sr_RichLong$: 0
}, false, "scala.runtime.RichLong$", {
  sr_RichLong$: 1,
  O: 1
});
$c_sr_RichLong$.prototype.$classData = $d_sr_RichLong$;
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$()
  };
  return $n_sr_RichLong$
}
/** @constructor */
function $c_sr_Scala3RunTime$() {
  /*<skip>*/
}
$c_sr_Scala3RunTime$.prototype = new $h_O();
$c_sr_Scala3RunTime$.prototype.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
  /*<skip>*/
}
$h_sr_Scala3RunTime$.prototype = $c_sr_Scala3RunTime$.prototype;
$c_sr_Scala3RunTime$.prototype.assertFailed__O__E = (function(message) {
  throw new $c_jl_AssertionError(("assertion failed: " + message))
});
$c_sr_Scala3RunTime$.prototype.assertFailed__E = (function() {
  throw new $c_jl_AssertionError("assertion failed")
});
var $d_sr_Scala3RunTime$ = new $TypeData().initClass({
  sr_Scala3RunTime$: 0
}, false, "scala.runtime.Scala3RunTime$", {
  sr_Scala3RunTime$: 1,
  O: 1
});
$c_sr_Scala3RunTime$.prototype.$classData = $d_sr_Scala3RunTime$;
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$()
  };
  return $n_sr_Scala3RunTime$
}
/** @constructor */
function $c_sr_ScalaRunTime$() {
  /*<skip>*/
}
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return x2.get(idx)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return x3.get(idx)
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return x4.get(idx)
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return x5.get(idx)
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return x6.get(idx)
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return $bC(x7.get(idx))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return x8.get(idx)
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return x9.get(idx)
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return x10.get(idx)
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    x2.set(idx, value)
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    x3.set(idx, $uI(value))
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    x4.set(idx, $uD(value))
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    x5.set(idx, $uJ(value))
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    x6.set(idx, $uF(value))
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    x7.set(idx, $uC(value))
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    x8.set(idx, $uB(value))
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    x9.set(idx, $uS(value))
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    x10.set(idx, $uZ(value))
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype.array_length__O__I = (function(xs) {
  return $m_jl_reflect_Array$().getLength__O__I(xs)
});
$c_sr_ScalaRunTime$.prototype.array_clone__O__O = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var x2 = $asArrayOf_O(xs, 1);
    return x2.clone__O()
  } else if ((xs instanceof $ac_I)) {
    var x3 = $asArrayOf_I(xs, 1);
    return x3.clone__O()
  } else if ((xs instanceof $ac_D)) {
    var x4 = $asArrayOf_D(xs, 1);
    return x4.clone__O()
  } else if ((xs instanceof $ac_J)) {
    var x5 = $asArrayOf_J(xs, 1);
    return x5.clone__O()
  } else if ((xs instanceof $ac_F)) {
    var x6 = $asArrayOf_F(xs, 1);
    return x6.clone__O()
  } else if ((xs instanceof $ac_C)) {
    var x7 = $asArrayOf_C(xs, 1);
    return x7.clone__O()
  } else if ((xs instanceof $ac_B)) {
    var x8 = $asArrayOf_B(xs, 1);
    return x8.clone__O()
  } else if ((xs instanceof $ac_S)) {
    var x9 = $asArrayOf_S(xs, 1);
    return x9.clone__O()
  } else if ((xs instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(xs, 1);
    return x10.clone__O()
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(xs)
  }
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  var this$1 = x.productIterator__sc_Iterator();
  var start = (x.productPrefix__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, start, ",", ")")
});
$c_sr_ScalaRunTime$.prototype.genericWrapArray__O__sci_ArraySeq = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(xs))
});
$c_sr_ScalaRunTime$.prototype.wrapRefArray__AO__sci_ArraySeq = (function(xs) {
  if ((xs === null)) {
    return null
  } else if ((xs.u.length === 0)) {
    var this$3 = $m_sci_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$3)
  } else {
    return new $c_sci_ArraySeq$ofRef(xs)
  }
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass({
  sr_ScalaRunTime$: 0
}, false, "scala.runtime.ScalaRunTime$", {
  sr_ScalaRunTime$: 1,
  O: 1
});
$c_sr_ScalaRunTime$.prototype.$classData = $d_sr_ScalaRunTime$;
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$()
  };
  return $n_sr_ScalaRunTime$
}
/** @constructor */
function $c_sr_Statics$() {
  /*<skip>*/
}
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
  /*<skip>*/
}
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0)
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k)
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length))
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv) {
  var lo = lv.RTLong__f_lo;
  var hi = lv.RTLong__f_hi;
  return ((hi === (lo >> 31)) ? lo : (lo ^ hi))
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv
  } else {
    var this$1 = $m_RTLong$();
    var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(dv);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return (($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi) === dv) ? (lo ^ hi) : $m_jl_FloatingPointBits$().numberHashCode__D__I(dv))
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0
  } else if (((typeof x) === "number")) {
    var x3 = $uD(x);
    return this.doubleHash__D__I(x3)
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return this.longHash__J__I(new $c_RTLong(lo, hi))
  } else {
    return $dp_hashCode__I(x)
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_sr_Statics$ = new $TypeData().initClass({
  sr_Statics$: 0
}, false, "scala.runtime.Statics$", {
  sr_Statics$: 1,
  O: 1
});
$c_sr_Statics$.prototype.$classData = $d_sr_Statics$;
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$()
  };
  return $n_sr_Statics$
}
/** @constructor */
function $c_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
  /*<skip>*/
}
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass({
  sr_Statics$PFMarker$: 0
}, false, "scala.runtime.Statics$PFMarker$", {
  sr_Statics$PFMarker$: 1,
  O: 1
});
$c_sr_Statics$PFMarker$.prototype.$classData = $d_sr_Statics$PFMarker$;
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$()
  };
  return $n_sr_Statics$PFMarker$
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$Cache$() {
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = null;
  $n_sjs_js_WrappedDictionary$Cache$ = this;
  this.sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty
}
$c_sjs_js_WrappedDictionary$Cache$.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$Cache$.prototype.constructor = $c_sjs_js_WrappedDictionary$Cache$;
/** @constructor */
function $h_sjs_js_WrappedDictionary$Cache$() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$Cache$.prototype = $c_sjs_js_WrappedDictionary$Cache$.prototype;
var $d_sjs_js_WrappedDictionary$Cache$ = new $TypeData().initClass({
  sjs_js_WrappedDictionary$Cache$: 0
}, false, "scala.scalajs.js.WrappedDictionary$Cache$", {
  sjs_js_WrappedDictionary$Cache$: 1,
  O: 1
});
$c_sjs_js_WrappedDictionary$Cache$.prototype.$classData = $d_sjs_js_WrappedDictionary$Cache$;
var $n_sjs_js_WrappedDictionary$Cache$;
function $m_sjs_js_WrappedDictionary$Cache$() {
  if ((!$n_sjs_js_WrappedDictionary$Cache$)) {
    $n_sjs_js_WrappedDictionary$Cache$ = new $c_sjs_js_WrappedDictionary$Cache$()
  };
  return $n_sjs_js_WrappedDictionary$Cache$
}
/** @constructor */
function $c_sjs_js_special_package$() {
  /*<skip>*/
}
$c_sjs_js_special_package$.prototype = new $h_O();
$c_sjs_js_special_package$.prototype.constructor = $c_sjs_js_special_package$;
/** @constructor */
function $h_sjs_js_special_package$() {
  /*<skip>*/
}
$h_sjs_js_special_package$.prototype = $c_sjs_js_special_package$.prototype;
$c_sjs_js_special_package$.prototype.objectLiteral__sci_Seq__sjs_js_Object = (function(properties) {
  var result = {};
  properties.foreach__F1__V(new $c_sjsr_AnonFunction1(((result$1) => ((pair$2) => {
    var pair = $as_T2(pair$2);
    result$1[pair._1__O()] = pair._2__O()
  }))(result)));
  return result
});
var $d_sjs_js_special_package$ = new $TypeData().initClass({
  sjs_js_special_package$: 0
}, false, "scala.scalajs.js.special.package$", {
  sjs_js_special_package$: 1,
  O: 1
});
$c_sjs_js_special_package$.prototype.$classData = $d_sjs_js_special_package$;
var $n_sjs_js_special_package$;
function $m_sjs_js_special_package$() {
  if ((!$n_sjs_js_special_package$)) {
    $n_sjs_js_special_package$ = new $c_sjs_js_special_package$()
  };
  return $n_sjs_js_special_package$
}
/** @constructor */
function $c_sjs_js_timers_package$() {
  /*<skip>*/
}
$c_sjs_js_timers_package$.prototype = new $h_O();
$c_sjs_js_timers_package$.prototype.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
  /*<skip>*/
}
$h_sjs_js_timers_package$.prototype = $c_sjs_js_timers_package$.prototype;
$c_sjs_js_timers_package$.prototype.setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  var $$x1 = setTimeout;
  var this$2 = interval.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(interval.s_concurrent_duration_FiniteDuration__f_length);
  return $$x1(((body$2) => (() => {
    body$2.apply__O()
  }))(body), $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$2.RTLong__f_lo, this$2.RTLong__f_hi))
});
$c_sjs_js_timers_package$.prototype.clearTimeout__sjs_js_timers_SetTimeoutHandle__V = (function(handle) {
  clearTimeout(handle)
});
var $d_sjs_js_timers_package$ = new $TypeData().initClass({
  sjs_js_timers_package$: 0
}, false, "scala.scalajs.js.timers.package$", {
  sjs_js_timers_package$: 1,
  O: 1
});
$c_sjs_js_timers_package$.prototype.$classData = $d_sjs_js_timers_package$;
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$()
  };
  return $n_sjs_js_timers_package$
}
/** @constructor */
function $c_sjsr_package$() {
  /*<skip>*/
}
$c_sjsr_package$.prototype = new $h_O();
$c_sjsr_package$.prototype.constructor = $c_sjsr_package$;
/** @constructor */
function $h_sjsr_package$() {
  /*<skip>*/
}
$h_sjsr_package$.prototype = $c_sjsr_package$.prototype;
$c_sjsr_package$.prototype.wrapJavaScriptException__O__jl_Throwable = (function(e) {
  if ((e instanceof $c_jl_Throwable)) {
    var x2 = $as_jl_Throwable(e);
    return x2
  } else {
    return new $c_sjs_js_JavaScriptException(e)
  }
});
$c_sjsr_package$.prototype.unwrapJavaScriptException__jl_Throwable__O = (function(th) {
  if ((th instanceof $c_sjs_js_JavaScriptException)) {
    var x2 = $as_sjs_js_JavaScriptException(th);
    var e = x2.sjs_js_JavaScriptException__f_exception;
    return e
  } else {
    return th
  }
});
var $d_sjsr_package$ = new $TypeData().initClass({
  sjsr_package$: 0
}, false, "scala.scalajs.runtime.package$", {
  sjsr_package$: 1,
  O: 1
});
$c_sjsr_package$.prototype.$classData = $d_sjsr_package$;
var $n_sjsr_package$;
function $m_sjsr_package$() {
  if ((!$n_sjsr_package$)) {
    $n_sjsr_package$ = new $c_sjsr_package$()
  };
  return $n_sjsr_package$
}
/** @constructor */
function $c_s_sys_package$() {
  /*<skip>*/
}
$c_s_sys_package$.prototype = new $h_O();
$c_s_sys_package$.prototype.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
  /*<skip>*/
}
$h_s_sys_package$.prototype = $c_s_sys_package$.prototype;
$c_s_sys_package$.prototype.error__T__E = (function(message) {
  throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message))
});
var $d_s_sys_package$ = new $TypeData().initClass({
  s_sys_package$: 0
}, false, "scala.sys.package$", {
  s_sys_package$: 1,
  O: 1
});
$c_s_sys_package$.prototype.$classData = $d_s_sys_package$;
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$()
  };
  return $n_s_sys_package$
}
/** @constructor */
function $c_s_util_NotGiven() {
  /*<skip>*/
}
$c_s_util_NotGiven.prototype = new $h_O();
$c_s_util_NotGiven.prototype.constructor = $c_s_util_NotGiven;
/** @constructor */
function $h_s_util_NotGiven() {
  /*<skip>*/
}
$h_s_util_NotGiven.prototype = $c_s_util_NotGiven.prototype;
var $d_s_util_NotGiven = new $TypeData().initClass({
  s_util_NotGiven: 0
}, false, "scala.util.NotGiven", {
  s_util_NotGiven: 1,
  O: 1
});
$c_s_util_NotGiven.prototype.$classData = $d_s_util_NotGiven;
/** @constructor */
function $c_s_util_Sorting$() {
  /*<skip>*/
}
$c_s_util_Sorting$.prototype = new $h_O();
$c_s_util_Sorting$.prototype.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
  /*<skip>*/
}
$h_s_util_Sorting$.prototype = $c_s_util_Sorting$.prototype;
$c_s_util_Sorting$.prototype.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0)
  };
  if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0);
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i0, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + i0) | 0), temp)
  };
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i0 + m) | 0));
    if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((i0 + m) | 0)) | 0))) < 0)) {
      var iA = i0;
      var iB = (((-1) + ((i0 + m) | 0)) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
          iB = ix
        } else {
          iA = ix
        }
      };
      var ix$2 = ((iA + ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
        i = (((-1) + i) | 0)
      };
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next)
    };
    m = ((1 + m) | 0)
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, i0, iN, ord)
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? evidence$2.newArray__I__O(((iK - i0) | 0)) : scratch);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, i0, iK, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iN, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, i0, iK, iN, ord, sc)
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V = (function(a, i0, iK, iN, ord, scratch) {
  if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + iK) | 0)), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(scratch, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0)
    };
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i), $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
        i = ((1 + i) | 0)
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
        j = ((1 + j) | 0)
      };
      k = ((1 + k) | 0)
    };
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0)
    }
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$booleanSort__AZ__V = (function(a) {
  var i = 0;
  var n = 0;
  while ((i < a.u.length)) {
    if ((!a.get(i))) {
      n = ((1 + n) | 0)
    };
    i = ((1 + i) | 0)
  };
  i = 0;
  while ((i < n)) {
    a.set(i, false);
    i = ((1 + i) | 0)
  };
  while ((i < a.u.length)) {
    a.set(i, true);
    i = ((1 + i) | 0)
  }
});
$c_s_util_Sorting$.prototype.stableSort__O__I__I__s_math_Ordering__V = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_sr_ScalaRunTime$().array_length__O__I(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering")
    };
    var array = $asArrayOf_O(a, 1);
    $m_ju_Arrays$().sort__AO__I__I__ju_Comparator__V(array, from, until, evidence$4)
  } else if ((a instanceof $ac_I)) {
    var x3 = $asArrayOf_I(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().sort__AI__V(x3)
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, until, evidence$4)
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var len = ((iK - from) | 0);
        var sc = new $ac_I(len);
        if ((((iK - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, from, iK, evidence$4)
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, from, iK$1, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$1, iK, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK$1, iK, evidence$4, sc)
        };
        if ((((until - iK) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x3, iK, until, evidence$4)
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK, iK$2, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x3, iK$2, until, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, iK, iK$2, until, evidence$4, sc)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x3, from, iK, until, evidence$4, sc)
      }
    }
  } else if ((a instanceof $ac_D)) {
    var x4 = $asArrayOf_D(a, 1);
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, until, evidence$4)
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var len$1 = ((iK$3 - from) | 0);
      var sc$1 = new $ac_D(len$1);
      if ((((iK$3 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, from, iK$3, evidence$4)
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$4, iK$3, evidence$4, sc$1)
      };
      if ((((until - iK$3) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x4, iK$3, until, evidence$4)
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x4, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, iK$3, iK$5, until, evidence$4, sc$1)
      };
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x4, from, iK$3, until, evidence$4, sc$1)
    }
  } else if ((a instanceof $ac_J)) {
    var x5 = $asArrayOf_J(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().sort__AJ__V(x5)
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, until, evidence$4)
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var len$2 = ((iK$6 - from) | 0);
        var sc$2 = new $ac_J(len$2);
        if ((((iK$6 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, from, iK$6, evidence$4)
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$7, iK$6, evidence$4, sc$2)
        };
        if ((((until - iK$6) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x5, iK$6, until, evidence$4)
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x5, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, iK$6, iK$8, until, evidence$4, sc$2)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x5, from, iK$6, until, evidence$4, sc$2)
      }
    }
  } else if ((a instanceof $ac_F)) {
    var x6 = $asArrayOf_F(a, 1);
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, until, evidence$4)
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var len$3 = ((iK$9 - from) | 0);
      var sc$3 = new $ac_F(len$3);
      if ((((iK$9 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, from, iK$9, evidence$4)
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$10, iK$9, evidence$4, sc$3)
      };
      if ((((until - iK$9) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x6, iK$9, until, evidence$4)
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x6, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, iK$9, iK$11, until, evidence$4, sc$3)
      };
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x6, from, iK$9, until, evidence$4, sc$3)
    }
  } else if ((a instanceof $ac_C)) {
    var x7 = $asArrayOf_C(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().sort__AC__V(x7)
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, until, evidence$4)
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var len$4 = ((iK$12 - from) | 0);
        var sc$4 = new $ac_C(len$4);
        if ((((iK$12 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, from, iK$12, evidence$4)
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$13, iK$12, evidence$4, sc$4)
        };
        if ((((until - iK$12) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x7, iK$12, until, evidence$4)
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x7, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, iK$12, iK$14, until, evidence$4, sc$4)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x7, from, iK$12, until, evidence$4, sc$4)
      }
    }
  } else if ((a instanceof $ac_B)) {
    var x8 = $asArrayOf_B(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().sort__AB__V(x8)
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, until, evidence$4)
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var len$5 = ((iK$15 - from) | 0);
        var sc$5 = new $ac_B(len$5);
        if ((((iK$15 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, from, iK$15, evidence$4)
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$16, iK$15, evidence$4, sc$5)
        };
        if ((((until - iK$15) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x8, iK$15, until, evidence$4)
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x8, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, iK$15, iK$17, until, evidence$4, sc$5)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x8, from, iK$15, until, evidence$4, sc$5)
      }
    }
  } else if ((a instanceof $ac_S)) {
    var x9 = $asArrayOf_S(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().sort__AS__V(x9)
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, until, evidence$4)
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var len$6 = ((iK$18 - from) | 0);
        var sc$6 = new $ac_S(len$6);
        if ((((iK$18 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, from, iK$18, evidence$4)
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$19, iK$18, evidence$4, sc$6)
        };
        if ((((until - iK$18) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x9, iK$18, until, evidence$4)
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x9, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, iK$18, iK$20, until, evidence$4, sc$6)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x9, from, iK$18, until, evidence$4, sc$6)
      }
    }
  } else if ((a instanceof $ac_Z)) {
    var x10 = $asArrayOf_Z(a, 1);
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.scala$util$Sorting$$booleanSort__AZ__V(x10)
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, until, evidence$4)
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var len$7 = ((iK$21 - from) | 0);
        var sc$7 = new $ac_Z(len$7);
        if ((((iK$21 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, from, iK$21, evidence$4)
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$22, iK$21, evidence$4, sc$7)
        };
        if ((((until - iK$21) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(x10, iK$21, until, evidence$4)
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(x10, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, iK$21, iK$23, until, evidence$4, sc$7)
        };
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(x10, from, iK$21, until, evidence$4, sc$7)
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  } else {
    throw new $c_s_MatchError(a)
  }
});
var $d_s_util_Sorting$ = new $TypeData().initClass({
  s_util_Sorting$: 0
}, false, "scala.util.Sorting$", {
  s_util_Sorting$: 1,
  O: 1
});
$c_s_util_Sorting$.prototype.$classData = $d_s_util_Sorting$;
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$()
  };
  return $n_s_util_Sorting$
}
function $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable($thiz) {
  var this$1 = $m_s_util_control_NoStackTrace$();
  if (this$1.s_util_control_NoStackTrace$__f__noSuppression) {
    return $c_jl_Throwable.prototype.fillInStackTrace__jl_Throwable.call($thiz)
  } else {
    return $as_jl_Throwable($thiz)
  }
}
/** @constructor */
function $c_s_util_control_NonFatal$() {
  /*<skip>*/
}
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
  /*<skip>*/
}
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || false)))))
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$())
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass({
  s_util_control_NonFatal$: 0
}, false, "scala.util.control.NonFatal$", {
  s_util_control_NonFatal$: 1,
  O: 1
});
$c_s_util_control_NonFatal$.prototype.$classData = $d_s_util_control_NonFatal$;
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$()
  };
  return $n_s_util_control_NonFatal$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0)
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k)
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length))
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2)
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = x.productArity__I();
  if ((arr === 0)) {
    return $f_T__hashCode__I(x.productPrefix__T())
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I(x.productPrefix__T()))
    };
    var i = 0;
    while ((i < arr)) {
      var $$x1 = h;
      var x$1 = x.productElement__I__O(i);
      h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0)
    };
    return this.finalizeHash__I__I__I(h, arr)
  }
});
$c_s_util_hashing_MurmurHash3.prototype.stringHash__T__I__I = (function(str, seed) {
  var h = seed;
  var i = 0;
  while ((((1 + i) | 0) < $uI(str.length))) {
    var index = i;
    var $$x1 = $uI(str.charCodeAt(index));
    var index$1 = ((1 + i) | 0);
    var data = ((((65535 & $$x1) << 16) + (65535 & $uI(str.charCodeAt(index$1)))) | 0);
    h = this.mix__I__I__I(h, data);
    i = ((2 + i) | 0)
  };
  if ((i < $uI(str.length))) {
    var $$x2 = h;
    var index$2 = i;
    h = this.mixLast__I__I__I($$x2, (65535 & $uI(str.charCodeAt(index$2))))
  };
  return this.finalizeHash__I__I__I(h, $uI(str.length))
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = xs.iterator__sc_Iterator();
  while (iterator.hasNext__Z()) {
    var x = iterator.next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0)
  };
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n)
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = xs.iterator__sc_Iterator();
  var h = seed;
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0)
  };
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1)
  };
  var x1 = it.next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = it.next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        var $$x1 = h;
        var x$1 = it.next__O();
        h = this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0)
      };
      return this.finalizeHash__I__I__I(h, i)
    };
    prev = hash;
    i = ((1 + i) | 0)
  };
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_sr_ScalaRunTime$().array_length__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last))
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = a.length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var x = a.apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break
    }
    default: {
      var x$1 = a.apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = a.apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = a.apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var x$4 = a.apply__I__O(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!elems.isEmpty__Z())) {
    var head = elems.head__O();
    var tail = $as_sci_List(elems.tail__O());
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break
      }
      case 2: {
        if ((rangeDiff !== ((hash - prev) | 0))) {
          rangeState = 3
        };
        break
      }
    };
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail
  };
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n))
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, (a.get(0) ? 1231 : 1237)), 1);
      break
    }
    default: {
      var initial = (a.get(0) ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = (a.get(1) ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = (a.get(i) ? 1231 : 1237);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, (a.get(i) ? 1231 : 1237));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var dv = a.get(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break
    }
    default: {
      var dv$1 = a.get(0);
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = a.get(1);
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = a.get(i);
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var dv$4 = a.get(i);
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var fv = a.get(0);
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, this$1.doubleHash__D__I(fv)), 1);
      break
    }
    default: {
      var fv$1 = a.get(0);
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = a.get(1);
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = a.get(i);
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var fv$4 = a.get(i);
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($$x2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      var $$x1 = h;
      var t = a.get(0);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this.finalizeHash__I__I__I(this.mix__I__I__I($$x1, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi))), 1);
      break
    }
    default: {
      var t$1 = a.get(0);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var initial = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var t$2 = a.get(1);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var prev = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var t$3 = a.get(i);
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var hash = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $$x2 = h;
            var t$4 = a.get(i);
            var lo$4 = t$4.RTLong__f_lo;
            var hi$4 = t$4.RTLong__f_hi;
            h = this.mix__I__I__I($$x2, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4)));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.get(0)), 1);
      break
    }
    default: {
      var initial = a.get(0);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.get(1);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.get(i);
        if ((rangeDiff !== ((hash - prev) | 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.get(i));
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = hash;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if ((rangeDiff !== ((-prev) | 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0)
          };
          return this.finalizeHash__I__I__I(h, l)
        };
        prev = 0;
        i = ((1 + i) | 0)
      };
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev))
    }
  }
});
function $is_Lsnabbdom_CreateHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_CreateHook)))
}
function $as_Lsnabbdom_CreateHook(obj) {
  return (($is_Lsnabbdom_CreateHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.CreateHook"))
}
function $isArrayOf_Lsnabbdom_CreateHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_CreateHook)))
}
function $asArrayOf_Lsnabbdom_CreateHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_CreateHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.CreateHook;", depth))
}
function $is_Lsnabbdom_DestroyHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_DestroyHook)))
}
function $as_Lsnabbdom_DestroyHook(obj) {
  return (($is_Lsnabbdom_DestroyHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.DestroyHook"))
}
function $isArrayOf_Lsnabbdom_DestroyHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_DestroyHook)))
}
function $asArrayOf_Lsnabbdom_DestroyHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_DestroyHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.DestroyHook;", depth))
}
function $is_Lsnabbdom_DomApi(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_DomApi)))
}
function $as_Lsnabbdom_DomApi(obj) {
  return (($is_Lsnabbdom_DomApi(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.DomApi"))
}
function $isArrayOf_Lsnabbdom_DomApi(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_DomApi)))
}
function $asArrayOf_Lsnabbdom_DomApi(obj, depth) {
  return (($isArrayOf_Lsnabbdom_DomApi(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.DomApi;", depth))
}
/** @constructor */
function $c_Lsnabbdom_EventHandler(cbs) {
  this.Lsnabbdom_EventHandler__f_cbs = null;
  this.Lsnabbdom_EventHandler__f_cbs = cbs
}
$c_Lsnabbdom_EventHandler.prototype = new $h_O();
$c_Lsnabbdom_EventHandler.prototype.constructor = $c_Lsnabbdom_EventHandler;
/** @constructor */
function $h_Lsnabbdom_EventHandler() {
  /*<skip>*/
}
$h_Lsnabbdom_EventHandler.prototype = $c_Lsnabbdom_EventHandler.prototype;
function $as_Lsnabbdom_EventHandler(obj) {
  return (((obj instanceof $c_Lsnabbdom_EventHandler) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.EventHandler"))
}
function $isArrayOf_Lsnabbdom_EventHandler(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_EventHandler)))
}
function $asArrayOf_Lsnabbdom_EventHandler(obj, depth) {
  return (($isArrayOf_Lsnabbdom_EventHandler(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.EventHandler;", depth))
}
var $d_Lsnabbdom_EventHandler = new $TypeData().initClass({
  Lsnabbdom_EventHandler: 0
}, false, "snabbdom.EventHandler", {
  Lsnabbdom_EventHandler: 1,
  O: 1
});
$c_Lsnabbdom_EventHandler.prototype.$classData = $d_Lsnabbdom_EventHandler;
/** @constructor */
function $c_Lsnabbdom_EventHandler$() {
  /*<skip>*/
}
$c_Lsnabbdom_EventHandler$.prototype = new $h_O();
$c_Lsnabbdom_EventHandler$.prototype.constructor = $c_Lsnabbdom_EventHandler$;
/** @constructor */
function $h_Lsnabbdom_EventHandler$() {
  /*<skip>*/
}
$h_Lsnabbdom_EventHandler$.prototype = $c_Lsnabbdom_EventHandler$.prototype;
$c_Lsnabbdom_EventHandler$.prototype.apply__sci_Seq__Lsnabbdom_EventHandler = (function(cbs) {
  return new $c_Lsnabbdom_EventHandler($as_sci_Seq(cbs.map__F1__O(new $c_sjsr_AnonFunction1(((cb) => {
    var cb$1 = $as_F1(cb);
    return new $c_sjsr_AnonFunction2(((cb$2) => ((ev, _$1) => {
      $as_Lsnabbdom_VNode(_$1);
      cb$2.apply__O__O(ev)
    }))(cb$1))
  })))))
});
var $d_Lsnabbdom_EventHandler$ = new $TypeData().initClass({
  Lsnabbdom_EventHandler$: 0
}, false, "snabbdom.EventHandler$", {
  Lsnabbdom_EventHandler$: 1,
  O: 1
});
$c_Lsnabbdom_EventHandler$.prototype.$classData = $d_Lsnabbdom_EventHandler$;
var $n_Lsnabbdom_EventHandler$;
function $m_Lsnabbdom_EventHandler$() {
  if ((!$n_Lsnabbdom_EventHandler$)) {
    $n_Lsnabbdom_EventHandler$ = new $c_Lsnabbdom_EventHandler$()
  };
  return $n_Lsnabbdom_EventHandler$
}
function $is_Lsnabbdom_InitHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_InitHook)))
}
function $as_Lsnabbdom_InitHook(obj) {
  return (($is_Lsnabbdom_InitHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.InitHook"))
}
function $isArrayOf_Lsnabbdom_InitHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_InitHook)))
}
function $asArrayOf_Lsnabbdom_InitHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_InitHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.InitHook;", depth))
}
function $is_Lsnabbdom_InsertHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_InsertHook)))
}
function $as_Lsnabbdom_InsertHook(obj) {
  return (($is_Lsnabbdom_InsertHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.InsertHook"))
}
function $isArrayOf_Lsnabbdom_InsertHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_InsertHook)))
}
function $asArrayOf_Lsnabbdom_InsertHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_InsertHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.InsertHook;", depth))
}
/** @constructor */
function $c_Lsnabbdom_Listener(vnode) {
  this.Lsnabbdom_Listener__f_vnode = null;
  this.Lsnabbdom_Listener__f_jsFun = null;
  this.Lsnabbdom_Listener__f_vnode = vnode;
  this.Lsnabbdom_Listener__f_jsFun = ((this$1) => ((event) => {
    this$1.handleEvent__Lorg_scalajs_dom_Event__V(event)
  }))(this)
}
$c_Lsnabbdom_Listener.prototype = new $h_O();
$c_Lsnabbdom_Listener.prototype.constructor = $c_Lsnabbdom_Listener;
/** @constructor */
function $h_Lsnabbdom_Listener() {
  /*<skip>*/
}
$h_Lsnabbdom_Listener.prototype = $c_Lsnabbdom_Listener.prototype;
$c_Lsnabbdom_Listener.prototype.handleEvent__Lorg_scalajs_dom_Event__V = (function(event) {
  var name = $as_T(event.type);
  var this$1 = this.Lsnabbdom_Listener__f_vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_on.get__O__s_Option(name);
  if ((!this$1.isEmpty__Z())) {
    var arg1 = this$1.get__O();
    var handler = $as_Lsnabbdom_EventHandler(arg1);
    handler.Lsnabbdom_EventHandler__f_cbs.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$2, event$1$2) => ((cb) => {
      var cb$1 = $as_F2(cb);
      cb$1.apply__O__O__O(event$1$2, this$2.Lsnabbdom_Listener__f_vnode)
    }))(this, event)))
  }
});
function $as_Lsnabbdom_Listener(obj) {
  return (((obj instanceof $c_Lsnabbdom_Listener) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Listener"))
}
function $isArrayOf_Lsnabbdom_Listener(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Listener)))
}
function $asArrayOf_Lsnabbdom_Listener(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Listener(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Listener;", depth))
}
var $d_Lsnabbdom_Listener = new $TypeData().initClass({
  Lsnabbdom_Listener: 0
}, false, "snabbdom.Listener", {
  Lsnabbdom_Listener: 1,
  O: 1
});
$c_Lsnabbdom_Listener.prototype.$classData = $d_Lsnabbdom_Listener;
function $is_Lsnabbdom_PostHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PostHook)))
}
function $as_Lsnabbdom_PostHook(obj) {
  return (($is_Lsnabbdom_PostHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PostHook"))
}
function $isArrayOf_Lsnabbdom_PostHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PostHook)))
}
function $asArrayOf_Lsnabbdom_PostHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PostHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PostHook;", depth))
}
function $is_Lsnabbdom_PostPatchHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PostPatchHook)))
}
function $as_Lsnabbdom_PostPatchHook(obj) {
  return (($is_Lsnabbdom_PostPatchHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PostPatchHook"))
}
function $isArrayOf_Lsnabbdom_PostPatchHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PostPatchHook)))
}
function $asArrayOf_Lsnabbdom_PostPatchHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PostPatchHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PostPatchHook;", depth))
}
function $is_Lsnabbdom_PreHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PreHook)))
}
function $as_Lsnabbdom_PreHook(obj) {
  return (($is_Lsnabbdom_PreHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PreHook"))
}
function $isArrayOf_Lsnabbdom_PreHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PreHook)))
}
function $asArrayOf_Lsnabbdom_PreHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PreHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PreHook;", depth))
}
function $is_Lsnabbdom_PrePatchHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_PrePatchHook)))
}
function $as_Lsnabbdom_PrePatchHook(obj) {
  return (($is_Lsnabbdom_PrePatchHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.PrePatchHook"))
}
function $isArrayOf_Lsnabbdom_PrePatchHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_PrePatchHook)))
}
function $asArrayOf_Lsnabbdom_PrePatchHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_PrePatchHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.PrePatchHook;", depth))
}
function $is_Lsnabbdom_RemoveHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_RemoveHook)))
}
function $as_Lsnabbdom_RemoveHook(obj) {
  return (($is_Lsnabbdom_RemoveHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.RemoveHook"))
}
function $isArrayOf_Lsnabbdom_RemoveHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_RemoveHook)))
}
function $asArrayOf_Lsnabbdom_RemoveHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_RemoveHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.RemoveHook;", depth))
}
function $is_Lsnabbdom_UpdateHook(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsnabbdom_UpdateHook)))
}
function $as_Lsnabbdom_UpdateHook(obj) {
  return (($is_Lsnabbdom_UpdateHook(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.UpdateHook"))
}
function $isArrayOf_Lsnabbdom_UpdateHook(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_UpdateHook)))
}
function $asArrayOf_Lsnabbdom_UpdateHook(obj, depth) {
  return (($isArrayOf_Lsnabbdom_UpdateHook(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.UpdateHook;", depth))
}
/** @constructor */
function $c_Lsnabbdom_VNode(sel, data, children, elm, text, key, listener) {
  this.Lsnabbdom_VNode__f_sel = null;
  this.Lsnabbdom_VNode__f_data = null;
  this.Lsnabbdom_VNode__f_children = null;
  this.Lsnabbdom_VNode__f_elm = null;
  this.Lsnabbdom_VNode__f_text = null;
  this.Lsnabbdom_VNode__f_key = null;
  this.Lsnabbdom_VNode__f_listener = null;
  this.Lsnabbdom_VNode__f_sel = sel;
  this.Lsnabbdom_VNode__f_data = data;
  this.Lsnabbdom_VNode__f_children = children;
  this.Lsnabbdom_VNode__f_elm = elm;
  this.Lsnabbdom_VNode__f_text = text;
  this.Lsnabbdom_VNode__f_key = key;
  this.Lsnabbdom_VNode__f_listener = listener
}
$c_Lsnabbdom_VNode.prototype = new $h_O();
$c_Lsnabbdom_VNode.prototype.constructor = $c_Lsnabbdom_VNode;
/** @constructor */
function $h_Lsnabbdom_VNode() {
  /*<skip>*/
}
$h_Lsnabbdom_VNode.prototype = $c_Lsnabbdom_VNode.prototype;
$c_Lsnabbdom_VNode.prototype.toString__T = (function() {
  return ((((((((((("sel=" + this.Lsnabbdom_VNode__f_sel) + ", data=") + this.Lsnabbdom_VNode__f_data) + ", text=") + this.Lsnabbdom_VNode__f_text) + ", key=") + this.Lsnabbdom_VNode__f_key) + ", children=") + this.Lsnabbdom_VNode__f_children) + ", elm=") + this.Lsnabbdom_VNode__f_elm)
});
$c_Lsnabbdom_VNode.prototype.isTextNode__Z = (function() {
  if ((this.Lsnabbdom_VNode__f_sel.isEmpty__Z() && this.Lsnabbdom_VNode__f_children.isEmpty__Z())) {
    var this$1 = this.Lsnabbdom_VNode__f_text;
    return (!this$1.isEmpty__Z())
  } else {
    return false
  }
});
function $as_Lsnabbdom_VNode(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNode) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNode"))
}
function $isArrayOf_Lsnabbdom_VNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNode)))
}
function $asArrayOf_Lsnabbdom_VNode(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNode;", depth))
}
var $d_Lsnabbdom_VNode = new $TypeData().initClass({
  Lsnabbdom_VNode: 0
}, false, "snabbdom.VNode", {
  Lsnabbdom_VNode: 1,
  O: 1
});
$c_Lsnabbdom_VNode.prototype.$classData = $d_Lsnabbdom_VNode;
/** @constructor */
function $c_Lsnabbdom_VNode$() {
  /*<skip>*/
}
$c_Lsnabbdom_VNode$.prototype = new $h_O();
$c_Lsnabbdom_VNode$.prototype.constructor = $c_Lsnabbdom_VNode$;
/** @constructor */
function $h_Lsnabbdom_VNode$() {
  /*<skip>*/
}
$h_Lsnabbdom_VNode$.prototype = $c_Lsnabbdom_VNode$.prototype;
$c_Lsnabbdom_VNode$.prototype.create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode = (function(sel, data, children, text, elm) {
  if (children.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = children.get__O();
    var _$1 = $asArrayOf_Lsnabbdom_VNode(arg1, 1);
    var $$x1 = (_$1.u.length !== 0)
  };
  return new $c_Lsnabbdom_VNode(sel, data, ($$x1 ? children : $m_s_None$()), elm, text, data.Lsnabbdom_VNodeData__f_key, $m_s_None$())
});
$c_Lsnabbdom_VNode$.prototype.text__T__Lsnabbdom_VNode = (function(text) {
  return new $c_Lsnabbdom_VNode($m_s_None$(), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), new $c_s_Some(text), $m_s_None$(), $m_s_None$())
});
var $d_Lsnabbdom_VNode$ = new $TypeData().initClass({
  Lsnabbdom_VNode$: 0
}, false, "snabbdom.VNode$", {
  Lsnabbdom_VNode$: 1,
  O: 1
});
$c_Lsnabbdom_VNode$.prototype.$classData = $d_Lsnabbdom_VNode$;
var $n_Lsnabbdom_VNode$;
function $m_Lsnabbdom_VNode$() {
  if ((!$n_Lsnabbdom_VNode$)) {
    $n_Lsnabbdom_VNode$ = new $c_Lsnabbdom_VNode$()
  };
  return $n_Lsnabbdom_VNode$
}
function $p_Lsnabbdom_h$__apply__T__s_Option__s_Option__s_Option__Lsnabbdom_VNode($thiz, sel, data, children, text) {
  var vnode = $m_Lsnabbdom_VNode$().create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some(sel), $as_Lsnabbdom_VNodeData((data.isEmpty__Z() ? $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty : data.get__O())), children, text, $m_s_None$());
  if (((($uI(sel.length) >= 0) && ($as_T(sel.substring(0, $uI("svg".length))) === "svg")) && ((($uI(sel.length) === 3) || ((65535 & $uI(sel.charCodeAt(3))) === 46)) || ((65535 & $uI(sel.charCodeAt(3))) === 35)))) {
    $thiz.addNS__Lsnabbdom_VNode__V(vnode)
  };
  return vnode
}
/** @constructor */
function $c_Lsnabbdom_h$() {
  /*<skip>*/
}
$c_Lsnabbdom_h$.prototype = new $h_O();
$c_Lsnabbdom_h$.prototype.constructor = $c_Lsnabbdom_h$;
/** @constructor */
function $h_Lsnabbdom_h$() {
  /*<skip>*/
}
$h_Lsnabbdom_h$.prototype = $c_Lsnabbdom_h$.prototype;
$c_Lsnabbdom_h$.prototype.apply__T__Lsnabbdom_VNodeData__ALsnabbdom_VNode__Lsnabbdom_VNode = (function(sel, data, children) {
  return $p_Lsnabbdom_h$__apply__T__s_Option__s_Option__s_Option__Lsnabbdom_VNode(this, sel, new $c_s_Some(data), new $c_s_Some(children), $m_s_None$())
});
$c_Lsnabbdom_h$.prototype.addNS__Lsnabbdom_VNode__V = (function(vnode) {
  var \u03b41$ = vnode.Lsnabbdom_VNode__f_data;
  var ns$1 = new $c_s_Some("http://www.w3.org/2000/svg");
  var props$1 = \u03b41$.Lsnabbdom_VNodeData__f_props;
  var attrs$1 = \u03b41$.Lsnabbdom_VNodeData__f_attrs;
  var classes$1 = \u03b41$.Lsnabbdom_VNodeData__f_classes;
  var style$1 = \u03b41$.Lsnabbdom_VNodeData__f_style;
  var dataset$1 = \u03b41$.Lsnabbdom_VNodeData__f_dataset;
  var on$1 = \u03b41$.Lsnabbdom_VNodeData__f_on;
  var hook$1 = \u03b41$.Lsnabbdom_VNodeData__f_hook;
  var key$1 = \u03b41$.Lsnabbdom_VNodeData__f_key;
  var fn$1 = \u03b41$.Lsnabbdom_VNodeData__f_fn;
  var args$1 = \u03b41$.Lsnabbdom_VNodeData__f_args;
  var is$1 = \u03b41$.Lsnabbdom_VNodeData__f_is;
  vnode.Lsnabbdom_VNode__f_data = new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key$1, ns$1, fn$1, args$1, is$1);
  var this$2 = vnode.Lsnabbdom_VNode__f_sel;
  if (this$2.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$2.get__O();
    var _$1 = $as_T(arg1);
    var $$x1 = (_$1 !== "foreignObject")
  };
  if ($$x1) {
    var this$3 = vnode.Lsnabbdom_VNode__f_children;
    if ((!this$3.isEmpty__Z())) {
      var arg1$1 = this$3.get__O();
      var _$2 = $asArrayOf_Lsnabbdom_VNode(arg1$1, 1);
      var f = ((this$5) => ((vnode$1) => {
        var vnode$2 = $as_Lsnabbdom_VNode(vnode$1);
        this$5.addNS__Lsnabbdom_VNode__V(vnode$2)
      }))(this);
      $m_s_reflect_ManifestFactory$UnitManifest$();
      var len = _$2.u.length;
      var ys = new ($d_jl_Void.getArrayOf().constr)(len);
      if ((len > 0)) {
        var i = 0;
        if ((_$2 !== null)) {
          while ((i < len)) {
            var $$x2 = i;
            var arg1$2 = _$2.get(i);
            ys.set($$x2, f(arg1$2));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_I)) {
          var x3 = $asArrayOf_I(_$2, 1);
          while ((i < len)) {
            var $$x3 = i;
            var arg1$3 = x3.get(i);
            ys.set($$x3, f(arg1$3));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_D)) {
          var x4 = $asArrayOf_D(_$2, 1);
          while ((i < len)) {
            var $$x4 = i;
            var arg1$4 = x4.get(i);
            ys.set($$x4, f(arg1$4));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_J)) {
          var x5 = $asArrayOf_J(_$2, 1);
          while ((i < len)) {
            var $$x5 = i;
            var t = x5.get(i);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            ys.set($$x5, f(new $c_RTLong(lo, hi)));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_F)) {
          var x6 = $asArrayOf_F(_$2, 1);
          while ((i < len)) {
            var $$x6 = i;
            var arg1$5 = x6.get(i);
            ys.set($$x6, f(arg1$5));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_C)) {
          var x7 = $asArrayOf_C(_$2, 1);
          while ((i < len)) {
            var $$x7 = i;
            var arg1$6 = x7.get(i);
            ys.set($$x7, f($bC(arg1$6)));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_B)) {
          var x8 = $asArrayOf_B(_$2, 1);
          while ((i < len)) {
            var $$x8 = i;
            var arg1$7 = x8.get(i);
            ys.set($$x8, f(arg1$7));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_S)) {
          var x9 = $asArrayOf_S(_$2, 1);
          while ((i < len)) {
            var $$x9 = i;
            var arg1$8 = x9.get(i);
            ys.set($$x9, f(arg1$8));
            i = ((1 + i) | 0)
          }
        } else if ((_$2 instanceof $ac_Z)) {
          var x10 = $asArrayOf_Z(_$2, 1);
          while ((i < len)) {
            var $$x10 = i;
            var arg1$9 = x10.get(i);
            ys.set($$x10, f(arg1$9));
            i = ((1 + i) | 0)
          }
        } else {
          throw new $c_s_MatchError(_$2)
        }
      }
    }
  }
});
var $d_Lsnabbdom_h$ = new $TypeData().initClass({
  Lsnabbdom_h$: 0
}, false, "snabbdom.h$", {
  Lsnabbdom_h$: 1,
  O: 1
});
$c_Lsnabbdom_h$.prototype.$classData = $d_Lsnabbdom_h$;
var $n_Lsnabbdom_h$;
function $m_Lsnabbdom_h$() {
  if ((!$n_Lsnabbdom_h$)) {
    $n_Lsnabbdom_h$ = new $c_Lsnabbdom_h$()
  };
  return $n_Lsnabbdom_h$
}
function $p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, vnode1, vnode2) {
  var x = vnode1.Lsnabbdom_VNode__f_key;
  var x$2 = vnode2.Lsnabbdom_VNode__f_key;
  if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
    var x$3 = vnode1.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_is;
    var x$4 = vnode2.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_is;
    var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var x$5 = vnode1.Lsnabbdom_VNode__f_sel;
    var x$6 = vnode2.Lsnabbdom_VNode__f_sel;
    return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
  } else {
    return false
  }
}
function $p_Lsnabbdom_init$__createKeyToOldIdx__ALsnabbdom_VNode__I__I__sci_Map($thiz, children, beginIdx, endIdx) {
  var $$x10 = $m_s_Predef$();
  var xs = $m_sc_ArrayOps$().zipWithIndex$extension__O__AT2(children);
  var f = ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var ch = $as_Lsnabbdom_VNode(x$1$1._1__O());
      var i = $uI(x$1$1._2__O());
      var this$4 = ch.Lsnabbdom_VNode__f_key;
      if (this$4.isEmpty__Z()) {
        return $m_s_None$()
      } else {
        var arg1 = this$4.get__O();
        var key = $as_T(arg1);
        return new $c_s_Some(new $c_T2(key, i))
      }
    };
    throw new $c_s_MatchError(x$1$1)
  });
  var len = xs.u.length;
  var ys = new ($d_s_Option.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i$1 = 0;
    if ((xs !== null)) {
      while ((i$1 < len)) {
        var $$x1 = i$1;
        var arg1$1 = xs.get(i$1);
        ys.set($$x1, f(arg1$1));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_I)) {
      var x3 = $asArrayOf_I(xs, 1);
      while ((i$1 < len)) {
        var $$x2 = i$1;
        var arg1$2 = x3.get(i$1);
        ys.set($$x2, f(arg1$2));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_D)) {
      var x4 = $asArrayOf_D(xs, 1);
      while ((i$1 < len)) {
        var $$x3 = i$1;
        var arg1$3 = x4.get(i$1);
        ys.set($$x3, f(arg1$3));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_J)) {
      var x5 = $asArrayOf_J(xs, 1);
      while ((i$1 < len)) {
        var $$x4 = i$1;
        var t = x5.get(i$1);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.set($$x4, f(new $c_RTLong(lo, hi)));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_F)) {
      var x6 = $asArrayOf_F(xs, 1);
      while ((i$1 < len)) {
        var $$x5 = i$1;
        var arg1$4 = x6.get(i$1);
        ys.set($$x5, f(arg1$4));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_C)) {
      var x7 = $asArrayOf_C(xs, 1);
      while ((i$1 < len)) {
        var $$x6 = i$1;
        var arg1$5 = x7.get(i$1);
        ys.set($$x6, f($bC(arg1$5)));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_B)) {
      var x8 = $asArrayOf_B(xs, 1);
      while ((i$1 < len)) {
        var $$x7 = i$1;
        var arg1$6 = x8.get(i$1);
        ys.set($$x7, f(arg1$6));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_S)) {
      var x9 = $asArrayOf_S(xs, 1);
      while ((i$1 < len)) {
        var $$x8 = i$1;
        var arg1$7 = x9.get(i$1);
        ys.set($$x8, f(arg1$7));
        i$1 = ((1 + i$1) | 0)
      }
    } else if ((xs instanceof $ac_Z)) {
      var x10 = $asArrayOf_Z(xs, 1);
      while ((i$1 < len)) {
        var $$x9 = i$1;
        var arg1$8 = x10.get(i$1);
        ys.set($$x9, f(arg1$8));
        i$1 = ((1 + i$1) | 0)
      }
    } else {
      throw new $c_s_MatchError(xs)
    }
  };
  new $c_Lsnabbdom_init$$anon$2();
  var i$2 = 0;
  var elem = false;
  elem = true;
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  while ((i$2 < ys.u.length)) {
    elem = true;
    var x = ys.get(i$2);
    var x$2 = $as_s_Option(x);
    if ((x$2 instanceof $c_s_Some)) {
      var a = $as_T2($as_s_Some(x$2).s_Some__f_value);
      var v = a
    } else {
      elem = false;
      var v = null
    };
    if (elem) {
      var unboxedElem = ((v === null) ? null : v);
      jsElems.push(unboxedElem)
    };
    i$2 = ((1 + i$2) | 0)
  };
  var this$16 = $$x10.wrapRefArray__AO__scm_ArraySeq$ofRef(new ($d_T2.getArrayOf().constr)(jsElems));
  $m_s_$less$colon$less$();
  return $as_sci_Map($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$16).filter__F1__O(new $c_sjsr_AnonFunction1(((beginIdx$2, endIdx$2) => ((kv) => {
    var kv$1 = $as_T2(kv);
    return (($uI(kv$1._2__O()) >= beginIdx$2) && ($uI(kv$1._2__O()) <= endIdx$2))
  }))(beginIdx, endIdx))))
}
function $p_Lsnabbdom_init$__createRmCb$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__I__F0($thiz, api$3, childElm, listeners) {
  var listeners0 = new $c_sr_IntRef(listeners);
  return new $c_sjsr_AnonFunction0(((api$3$2, childElm$2, listeners0$2) => (() => {
    var ev$10 = (((-1) + listeners0$2.sr_IntRef__f_elem) | 0);
    listeners0$2.sr_IntRef__f_elem = ev$10;
    if ((listeners0$2.sr_IntRef__f_elem === 0)) {
      var parent = api$3$2.parentNode__Lorg_scalajs_dom_Node__s_Option(childElm$2);
      if ((!parent.isEmpty__Z())) {
        var arg1 = parent.get__O();
        api$3$2.removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(arg1, childElm$2)
      }
    }
  }))(api$3, childElm, listeners0))
}
function $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$5, cbs$1, vnode, insertedVNodeQueue) {
  var elem = vnode.Lsnabbdom_VNode__f_data;
  var elem$1 = null;
  elem$1 = elem;
  var this$2 = $as_Lsnabbdom_VNodeData(elem$1).Lsnabbdom_VNodeData__f_hook;
  if ((!this$2.isEmpty__Z())) {
    var arg1 = this$2.get__O();
    var h = $as_Lsnabbdom_Hooks(arg1);
    var this$3 = h.init__s_Option();
    if (this$3.isEmpty__Z()) {
      /*<skip>*/
    } else {
      var arg1$1 = this$3.get__O();
      var init0 = $as_Lsnabbdom_InitHook(arg1$1);
      init0.apply__Lsnabbdom_VNode__O(vnode);
      var ev$11 = vnode.Lsnabbdom_VNode__f_data;
      elem$1 = ev$11;
      ev$11 = null;
      new $c_s_Some((void 0))
    }
  };
  var sel = vnode.Lsnabbdom_VNode__f_sel;
  matchResult5: {
    if ((sel instanceof $c_s_Some)) {
      var x17 = $as_T($as_s_Some(sel).s_Some__f_value);
      if ((x17 === "!")) {
        var this$4 = vnode.Lsnabbdom_VNode__f_text;
        var value = (this$4.isEmpty__Z() ? "" : this$4.get__O());
        vnode.Lsnabbdom_VNode__f_text = new $c_s_Some(value);
        var value$1 = api$5.createComment__T__Lorg_scalajs_dom_Comment($as_T(vnode.Lsnabbdom_VNode__f_text.get__O()));
        vnode.Lsnabbdom_VNode__f_elm = new $c_s_Some(value$1);
        break matchResult5
      };
      var hashIdx = $uI(x17.indexOf("#"));
      var dotIdx = $uI(x17.indexOf(".", hashIdx));
      var hash = ((hashIdx > 0) ? hashIdx : $uI(x17.length));
      var dot = ((dotIdx > 0) ? dotIdx : $uI(x17.length));
      var tag = (((hashIdx !== (-1)) || (dotIdx !== (-1))) ? $m_sc_StringOps$().slice$extension__T__I__I__T(x17, 0, ((hash < dot) ? hash : dot)) : x17);
      var this$12 = $as_Lsnabbdom_VNodeData(elem$1).Lsnabbdom_VNodeData__f_ns;
      if ((!this$12.isEmpty__Z())) {
        var elm = api$5.createElementNS__T__T__Lorg_scalajs_dom_Element($as_T($as_Lsnabbdom_VNodeData(elem$1).Lsnabbdom_VNodeData__f_ns.get__O()), tag)
      } else {
        var elm = api$5.createElement__T__Lorg_scalajs_dom_HTMLElement(tag)
      };
      vnode.Lsnabbdom_VNode__f_elm = new $c_s_Some(elm);
      if ((hash < dot)) {
        elm.setAttribute("id", $m_sc_StringOps$().slice$extension__T__I__I__T(x17, ((1 + hash) | 0), dot))
      };
      if ((dotIdx > 0)) {
        elm.setAttribute("class", $f_T__replaceAll__T__T__T($m_sc_StringOps$().slice$extension__T__I__I__T(x17, ((1 + dot) | 0), $uI(x17.length)), "\\.", " "))
      };
      var this$16 = cbs$1.Lsnabbdom_ModuleHooks__f_create;
      var these = this$16;
      while ((!these.isEmpty__Z())) {
        var arg1$2 = these.head__O();
        var _$10 = $as_Lsnabbdom_CreateHook(arg1$2);
        _$10.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O($thiz.Lsnabbdom_init$__f_emptyNode, vnode);
        these = $as_sci_List(these.tail__O())
      };
      matchResult3: {
        var x7 = vnode.Lsnabbdom_VNode__f_children;
        var x = $m_s_None$();
        if ((x === x7)) {
          matchResult2: {
            var x4 = vnode.Lsnabbdom_VNode__f_text;
            var x$3 = $m_s_None$();
            if ((x$3 === x4)) {
              break matchResult2
            };
            if ((x4 instanceof $c_s_Some)) {
              var text = $as_T($as_s_Some(x4).s_Some__f_value);
              api$5.appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(elm, api$5.createTextNode__T__Lorg_scalajs_dom_Text(text));
              break matchResult2
            };
            throw new $c_s_MatchError(x4)
          };
          break matchResult3
        };
        if ((x7 instanceof $c_s_Some)) {
          var children = $asArrayOf_Lsnabbdom_VNode($as_s_Some(x7).s_Some__f_value, 1);
          var f = ((this$4$1, api$5$2, cbs$1$2, insertedVNodeQueue$2, elm$2) => ((child) => {
            var child$1 = $as_Lsnabbdom_VNode(child);
            api$5$2.appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(elm$2, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node(this$4$1, api$5$2, cbs$1$2, child$1, insertedVNodeQueue$2))
          }))($thiz, api$5, cbs$1, insertedVNodeQueue, elm);
          var len = children.u.length;
          var i = 0;
          if ((children !== null)) {
            while ((i < len)) {
              var arg1$3 = children.get(i);
              f(arg1$3);
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_I)) {
            var x3 = $asArrayOf_I(children, 1);
            while ((i < len)) {
              var arg1$4 = x3.get(i);
              f(arg1$4);
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_D)) {
            var x4$1 = $asArrayOf_D(children, 1);
            while ((i < len)) {
              var arg1$5 = x4$1.get(i);
              f(arg1$5);
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_J)) {
            var x5 = $asArrayOf_J(children, 1);
            while ((i < len)) {
              var t = x5.get(i);
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              f(new $c_RTLong(lo, hi));
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_F)) {
            var x6 = $asArrayOf_F(children, 1);
            while ((i < len)) {
              var arg1$6 = x6.get(i);
              f(arg1$6);
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_C)) {
            var x7$1 = $asArrayOf_C(children, 1);
            while ((i < len)) {
              var arg1$7 = x7$1.get(i);
              f($bC(arg1$7));
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_B)) {
            var x8 = $asArrayOf_B(children, 1);
            while ((i < len)) {
              var arg1$8 = x8.get(i);
              f(arg1$8);
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_S)) {
            var x9 = $asArrayOf_S(children, 1);
            while ((i < len)) {
              var arg1$9 = x9.get(i);
              f(arg1$9);
              i = ((1 + i) | 0)
            }
          } else if ((children instanceof $ac_Z)) {
            var x10 = $asArrayOf_Z(children, 1);
            while ((i < len)) {
              var arg1$10 = x10.get(i);
              f(arg1$10);
              i = ((1 + i) | 0)
            }
          } else {
            throw new $c_s_MatchError(children)
          };
          break matchResult3
        };
        throw new $c_s_MatchError(x7)
      };
      var this$19 = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_hook;
      if (this$19.isEmpty__Z()) {
        $m_s_None$();
        break matchResult5
      } else {
        var arg1$11 = this$19.get__O();
        var hooks = $as_Lsnabbdom_Hooks(arg1$11);
        var this$20 = hooks.create__s_Option();
        if ((!this$20.isEmpty__Z())) {
          var arg1$12 = this$20.get__O();
          var hook = $as_Lsnabbdom_CreateHook(arg1$12);
          hook.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O($thiz.Lsnabbdom_init$__f_emptyNode, vnode)
        };
        var this$21 = hooks.insert__s_Option();
        if ((!this$21.isEmpty__Z())) {
          var arg1$13 = this$21.get__O();
          $as_Lsnabbdom_InsertHook(arg1$13);
          insertedVNodeQueue.addOne__O__scm_ArrayBuffer(vnode)
        };
        new $c_s_Some((void 0));
        break matchResult5
      }
    };
    var x$5 = $m_s_None$();
    if ((x$5 === sel)) {
      matchResult4: {
        var x10$1 = vnode.Lsnabbdom_VNode__f_children;
        var x$7 = $m_s_None$();
        if ((x$7 === x10$1)) {
          var this$22 = vnode.Lsnabbdom_VNode__f_text;
          var value$2 = api$5.createTextNode__T__Lorg_scalajs_dom_Text($as_T((this$22.isEmpty__Z() ? "" : this$22.get__O())));
          vnode.Lsnabbdom_VNode__f_elm = new $c_s_Some(value$2);
          break matchResult4
        };
        if ((x10$1 instanceof $c_s_Some)) {
          var children$2 = $asArrayOf_Lsnabbdom_VNode($as_s_Some(x10$1).s_Some__f_value, 1);
          var elm$3 = api$5.createDocumentFragment__Lorg_scalajs_dom_DocumentFragment();
          vnode.Lsnabbdom_VNode__f_elm = new $c_s_Some(elm$3);
          var this$25 = cbs$1.Lsnabbdom_ModuleHooks__f_create;
          var these$1 = this$25;
          while ((!these$1.isEmpty__Z())) {
            var arg1$14 = these$1.head__O();
            var hook$1 = $as_Lsnabbdom_CreateHook(arg1$14);
            hook$1.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O($thiz.Lsnabbdom_init$__f_emptyNode, vnode);
            these$1 = $as_sci_List(these$1.tail__O())
          };
          var f$1 = ((this$8$1, api$5$3, cbs$1$3, insertedVNodeQueue$4, elm$4) => ((child$2) => {
            var child$3 = $as_Lsnabbdom_VNode(child$2);
            api$5$3.appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(elm$4, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node(this$8$1, api$5$3, cbs$1$3, child$3, insertedVNodeQueue$4))
          }))($thiz, api$5, cbs$1, insertedVNodeQueue, elm$3);
          var len$1 = children$2.u.length;
          var i$1 = 0;
          if ((children$2 !== null)) {
            while ((i$1 < len$1)) {
              var arg1$15 = children$2.get(i$1);
              f$1(arg1$15);
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_I)) {
            var x3$1 = $asArrayOf_I(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$16 = x3$1.get(i$1);
              f$1(arg1$16);
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_D)) {
            var x4$2 = $asArrayOf_D(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$17 = x4$2.get(i$1);
              f$1(arg1$17);
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_J)) {
            var x5$1 = $asArrayOf_J(children$2, 1);
            while ((i$1 < len$1)) {
              var t$1 = x5$1.get(i$1);
              var lo$1 = t$1.RTLong__f_lo;
              var hi$1 = t$1.RTLong__f_hi;
              f$1(new $c_RTLong(lo$1, hi$1));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_F)) {
            var x6$1 = $asArrayOf_F(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$18 = x6$1.get(i$1);
              f$1(arg1$18);
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_C)) {
            var x7$2 = $asArrayOf_C(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$19 = x7$2.get(i$1);
              f$1($bC(arg1$19));
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_B)) {
            var x8$1 = $asArrayOf_B(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$20 = x8$1.get(i$1);
              f$1(arg1$20);
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_S)) {
            var x9$1 = $asArrayOf_S(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$21 = x9$1.get(i$1);
              f$1(arg1$21);
              i$1 = ((1 + i$1) | 0)
            }
          } else if ((children$2 instanceof $ac_Z)) {
            var x10$2 = $asArrayOf_Z(children$2, 1);
            while ((i$1 < len$1)) {
              var arg1$22 = x10$2.get(i$1);
              f$1(arg1$22);
              i$1 = ((1 + i$1) | 0)
            }
          } else {
            throw new $c_s_MatchError(children$2)
          };
          break matchResult4
        };
        throw new $c_s_MatchError(x10$1)
      };
      break matchResult5
    };
    throw new $c_s_MatchError(sel)
  };
  return vnode.Lsnabbdom_VNode__f_elm.get__O()
}
function $p_Lsnabbdom_init$__addVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__s_Option__ALsnabbdom_VNode__I__I__scm_ArrayBuffer__V($thiz, api$8, cbs$4, parentElm, before, vnodes, startIdx, endIdx, insertedVNodeQueue) {
  var i = startIdx;
  while ((i <= endIdx)) {
    var ch = vnodes.get(i);
    api$8.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$8, cbs$4, ch, insertedVNodeQueue), before);
    i = ((1 + i) | 0)
  }
}
function $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__V($thiz, cbs$5, vnode) {
  if ((!vnode.isTextNode__Z())) {
    var this$1 = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_hook;
    if (this$1.isEmpty__Z()) {
      var this$2 = $m_s_None$()
    } else {
      var arg1 = this$1.get__O();
      var _$12 = $as_Lsnabbdom_Hooks(arg1);
      var this$2 = _$12.destroy__s_Option()
    };
    if ((!this$2.isEmpty__Z())) {
      var arg1$1 = this$2.get__O();
      $as_Lsnabbdom_DestroyHook(arg1$1);
      $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(vnode, $m_s_None$())
    };
    var this$3 = cbs$5.Lsnabbdom_ModuleHooks__f_destroy;
    var these = this$3;
    while ((!these.isEmpty__Z())) {
      var arg1$2 = these.head__O();
      $as_Lsnabbdom_DestroyHook(arg1$2);
      $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(vnode, $m_s_None$());
      these = $as_sci_List(these.tail__O())
    };
    var this$4 = vnode.Lsnabbdom_VNode__f_children;
    if ((!this$4.isEmpty__Z())) {
      var arg1$3 = this$4.get__O();
      var _$13 = $asArrayOf_Lsnabbdom_VNode(arg1$3, 1);
      var f = ((this$6, cbs$13$2) => ((child) => {
        var child$1 = $as_Lsnabbdom_VNode(child);
        $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__V(this$6, cbs$13$2, child$1)
      }))($thiz, cbs$5);
      var len = _$13.u.length;
      var i = 0;
      if ((_$13 !== null)) {
        while ((i < len)) {
          var arg1$4 = _$13.get(i);
          f(arg1$4);
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_I)) {
        var x3 = $asArrayOf_I(_$13, 1);
        while ((i < len)) {
          var arg1$5 = x3.get(i);
          f(arg1$5);
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_D)) {
        var x4 = $asArrayOf_D(_$13, 1);
        while ((i < len)) {
          var arg1$6 = x4.get(i);
          f(arg1$6);
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_J)) {
        var x5 = $asArrayOf_J(_$13, 1);
        while ((i < len)) {
          var t = x5.get(i);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_F)) {
        var x6 = $asArrayOf_F(_$13, 1);
        while ((i < len)) {
          var arg1$7 = x6.get(i);
          f(arg1$7);
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_C)) {
        var x7 = $asArrayOf_C(_$13, 1);
        while ((i < len)) {
          var arg1$8 = x7.get(i);
          f($bC(arg1$8));
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_B)) {
        var x8 = $asArrayOf_B(_$13, 1);
        while ((i < len)) {
          var arg1$9 = x8.get(i);
          f(arg1$9);
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_S)) {
        var x9 = $asArrayOf_S(_$13, 1);
        while ((i < len)) {
          var arg1$10 = x9.get(i);
          f(arg1$10);
          i = ((1 + i) | 0)
        }
      } else if ((_$13 instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(_$13, 1);
        while ((i < len)) {
          var arg1$11 = x10.get(i);
          f(arg1$11);
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(_$13)
      }
    }
  }
}
function $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$9, cbs$6, parentElm, vnodes, startIdx, endIdx) {
  var i = startIdx;
  while ((i <= endIdx)) {
    var ch = vnodes.get(i);
    matchResult6: {
      var x18 = ch.Lsnabbdom_VNode__f_sel;
      if ((x18 instanceof $c_s_Some)) {
        $p_Lsnabbdom_init$__invokeDestroyHook$1__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__V($thiz, cbs$6, ch);
        var listeners = ((1 + cbs$6.Lsnabbdom_ModuleHooks__f_remove.length__I()) | 0);
        var rm = $p_Lsnabbdom_init$__createRmCb$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Node__I__F0($thiz, api$9, ch.Lsnabbdom_VNode__f_elm.get__O(), listeners);
        var this$1 = cbs$6.Lsnabbdom_ModuleHooks__f_remove;
        var these = this$1;
        while ((!these.isEmpty__Z())) {
          var arg1 = these.head__O();
          var hook = $as_Lsnabbdom_RemoveHook(arg1);
          hook.apply__Lsnabbdom_VNode__F0__O(ch, rm);
          these = $as_sci_List(these.tail__O())
        };
        var this$2 = ch.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_hook;
        if (this$2.isEmpty__Z()) {
          var this$3 = $m_s_None$()
        } else {
          var arg1$1 = this$2.get__O();
          var _$14 = $as_Lsnabbdom_Hooks(arg1$1);
          var this$3 = _$14.remove__s_Option()
        };
        if (this$3.isEmpty__Z()) {
          rm.apply__O()
        } else {
          var arg1$2 = this$3.get__O();
          var hook$1 = $as_Lsnabbdom_RemoveHook(arg1$2);
          hook$1.apply__Lsnabbdom_VNode__F0__O(ch, rm)
        };
        break matchResult6
      };
      var x = $m_s_None$();
      if ((x === x18)) {
        api$9.removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V(parentElm, ch.Lsnabbdom_VNode__f_elm.get__O());
        break matchResult6
      };
      throw new $c_s_MatchError(x18)
    };
    i = ((1 + i) | 0)
  }
}
function $p_Lsnabbdom_init$__updateChildren$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__ALsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, parentElm, oldCh, newCh, insertedVnodeQueue) {
  if ((oldCh.u.length === 0)) {
    $m_sr_Scala3RunTime$().assertFailed__E()
  };
  if ((newCh.u.length === 0)) {
    $m_sr_Scala3RunTime$().assertFailed__E()
  };
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = (((-1) + oldCh.u.length) | 0);
  var oldStartVnode = oldCh.get(0);
  var oldEndVnode = oldCh.get(oldEndIdx);
  var newEndIdx = (((-1) + newCh.u.length) | 0);
  var newStartVnode = newCh.get(0);
  var newEndVnode = newCh.get(newEndIdx);
  var elem = null;
  elem = null;
  while (((oldStartIdx <= oldEndIdx) && (newStartIdx <= newEndIdx))) {
    if ((oldStartVnode === null)) {
      oldStartIdx = ((1 + oldStartIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldStartVnode = oldCh.get(oldStartIdx)
      }
    } else if ((oldEndVnode === null)) {
      oldEndIdx = (((-1) + oldEndIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldEndVnode = oldCh.get(oldEndIdx)
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldStartVnode, newStartVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldStartVnode, newStartVnode, insertedVnodeQueue);
      oldStartIdx = ((1 + oldStartIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldStartVnode = oldCh.get(oldStartIdx)
      };
      newStartIdx = ((1 + newStartIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newStartVnode = newCh.get(newStartIdx)
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldEndVnode, newEndVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldEndVnode, newEndVnode, insertedVnodeQueue);
      oldEndIdx = (((-1) + oldEndIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldEndVnode = oldCh.get(oldEndIdx)
      };
      newEndIdx = (((-1) + newEndIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newEndVnode = newCh.get(newEndIdx)
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldStartVnode, newEndVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldStartVnode, newEndVnode, insertedVnodeQueue);
      api$10.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, oldStartVnode.Lsnabbdom_VNode__f_elm.get__O(), api$10.nextSibling__Lorg_scalajs_dom_Node__s_Option(oldEndVnode.Lsnabbdom_VNode__f_elm.get__O()));
      oldStartIdx = ((1 + oldStartIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldStartVnode = oldCh.get(oldStartIdx)
      };
      newEndIdx = (((-1) + newEndIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newEndVnode = newCh.get(newEndIdx)
      }
    } else if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z($thiz, oldEndVnode, newStartVnode)) {
      $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, oldEndVnode, newStartVnode, insertedVnodeQueue);
      api$10.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, oldEndVnode.Lsnabbdom_VNode__f_elm.get__O(), oldStartVnode.Lsnabbdom_VNode__f_elm);
      oldEndIdx = (((-1) + oldEndIdx) | 0);
      if ((oldStartIdx <= oldEndIdx)) {
        oldEndVnode = oldCh.get(oldEndIdx)
      };
      newStartIdx = ((1 + newStartIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newStartVnode = newCh.get(newStartIdx)
      }
    } else {
      if (($as_sci_Map(elem) === null)) {
        var ev$12 = $p_Lsnabbdom_init$__createKeyToOldIdx__ALsnabbdom_VNode__I__I__sci_Map($thiz, oldCh, oldStartIdx, oldEndIdx);
        elem = ev$12;
        ev$12 = null
      };
      var this$6 = newStartVnode.Lsnabbdom_VNode__f_key;
      if (this$6.isEmpty__Z()) {
        var idxInOld = $m_s_None$()
      } else {
        var arg1 = this$6.get__O();
        var key = $as_T(arg1);
        var idxInOld = $as_sci_Map(elem).get__O__s_Option(key)
      };
      matchResult7: {
        var x = $m_s_None$();
        if ((x === idxInOld)) {
          api$10.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$10, cbs$7, newStartVnode, insertedVnodeQueue), oldStartVnode.Lsnabbdom_VNode__f_elm);
          break matchResult7
        };
        if ((idxInOld instanceof $c_s_Some)) {
          var idxInOld$2 = $uI($as_s_Some(idxInOld).s_Some__f_value);
          var elmToMove = oldCh.get(idxInOld$2);
          var x$3 = elmToMove.Lsnabbdom_VNode__f_sel;
          var x$4 = newStartVnode.Lsnabbdom_VNode__f_sel;
          if ((!((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4)))) {
            api$10.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node($thiz, api$10, cbs$7, newStartVnode, insertedVnodeQueue), oldStartVnode.Lsnabbdom_VNode__f_elm)
          } else {
            $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$10, cbs$7, elmToMove, newStartVnode, insertedVnodeQueue);
            oldCh.set(idxInOld$2, null);
            api$10.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parentElm, elmToMove.Lsnabbdom_VNode__f_elm.get__O(), oldStartVnode.Lsnabbdom_VNode__f_elm)
          };
          break matchResult7
        };
        throw new $c_s_MatchError(idxInOld)
      };
      newStartIdx = ((1 + newStartIdx) | 0);
      if ((newStartIdx <= newEndIdx)) {
        newStartVnode = newCh.get(newStartIdx)
      }
    }
  };
  if ((newStartIdx <= newEndIdx)) {
    var before = ((newCh.u.length > ((1 + newEndIdx) | 0)) ? newCh.get(((1 + newEndIdx) | 0)).Lsnabbdom_VNode__f_elm : $m_s_None$());
    $p_Lsnabbdom_init$__addVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__s_Option__ALsnabbdom_VNode__I__I__scm_ArrayBuffer__V($thiz, api$10, cbs$7, parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue)
  };
  if ((oldStartIdx <= oldEndIdx)) {
    $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$10, cbs$7, parentElm, oldCh, oldStartIdx, oldEndIdx)
  }
}
function $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$11, cbs$8, oldVnode, vnode, insertedVNodeQueue) {
  var hook = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_hook;
  if (hook.isEmpty__Z()) {
    var this$1 = $m_s_None$()
  } else {
    var arg1 = hook.get__O();
    var _$15 = $as_Lsnabbdom_Hooks(arg1);
    var this$1 = _$15.prepatch__s_Option()
  };
  if ((!this$1.isEmpty__Z())) {
    var arg1$1 = this$1.get__O();
    var hook$1 = $as_Lsnabbdom_PrePatchHook(arg1$1);
    hook$1.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode)
  };
  var elm = oldVnode.Lsnabbdom_VNode__f_elm.get__O();
  vnode.Lsnabbdom_VNode__f_elm = new $c_s_Some(elm);
  var oldCh = oldVnode.Lsnabbdom_VNode__f_children;
  var ch = vnode.Lsnabbdom_VNode__f_children;
  if ((oldVnode !== vnode)) {
    var this$3 = cbs$8.Lsnabbdom_ModuleHooks__f_update;
    var these = this$3;
    while ((!these.isEmpty__Z())) {
      var arg1$2 = these.head__O();
      var hook$2 = $as_Lsnabbdom_UpdateHook(arg1$2);
      hook$2.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode);
      these = $as_sci_List(these.tail__O())
    };
    var this$4 = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_hook;
    if (this$4.isEmpty__Z()) {
      var this$5 = $m_s_None$()
    } else {
      var arg1$3 = this$4.get__O();
      var _$16 = $as_Lsnabbdom_Hooks(arg1$3);
      var this$5 = _$16.update__s_Option()
    };
    if ((!this$5.isEmpty__Z())) {
      var arg1$4 = this$5.get__O();
      var hook$3 = $as_Lsnabbdom_UpdateHook(arg1$4);
      hook$3.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode)
    };
    matchResult9: {
      var x41 = vnode.Lsnabbdom_VNode__f_text;
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        matchResult8: {
          var x24 = new $c_T2(oldCh, ch);
          var x35 = $as_s_Option(x24.T2__f__1);
          var x36 = $as_s_Option(x24.T2__f__2);
          if ((x35 instanceof $c_s_Some)) {
            var oldCh$2 = $asArrayOf_Lsnabbdom_VNode($as_s_Some(x35).s_Some__f_value, 1);
            if ((x36 instanceof $c_s_Some)) {
              var ch$2 = $asArrayOf_Lsnabbdom_VNode($as_s_Some(x36).s_Some__f_value, 1);
              if ((oldCh$2 !== ch$2)) {
                $p_Lsnabbdom_init$__updateChildren$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__ALsnabbdom_VNode__scm_ArrayBuffer__V($thiz, api$11, cbs$8, elm, oldCh$2, ch$2, insertedVNodeQueue)
              };
              break matchResult8
            }
          };
          var x$7 = $m_s_None$();
          if (((x$7 === x35) && (x36 instanceof $c_s_Some))) {
            var ch$3 = $asArrayOf_Lsnabbdom_VNode($as_s_Some(x36).s_Some__f_value, 1);
            var this$7 = oldVnode.Lsnabbdom_VNode__f_text;
            if ((!this$7.isEmpty__Z())) {
              var arg1$5 = this$7.get__O();
              $as_T(arg1$5);
              api$11.setTextContent__Lorg_scalajs_dom_Node__s_Option__V(elm, new $c_s_Some(""))
            };
            $p_Lsnabbdom_init$__addVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__s_Option__ALsnabbdom_VNode__I__I__scm_ArrayBuffer__V($thiz, api$11, cbs$8, elm, $m_s_None$(), ch$3, 0, (((-1) + ch$3.u.length) | 0), insertedVNodeQueue);
            break matchResult8
          };
          if ((x35 instanceof $c_s_Some)) {
            var oldCh$3 = $asArrayOf_Lsnabbdom_VNode($as_s_Some(x35).s_Some__f_value, 1);
            var x$9 = $m_s_None$();
            if ((x$9 === x36)) {
              $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$11, cbs$8, elm, oldCh$3, 0, (((-1) + oldCh$3.u.length) | 0));
              break matchResult8
            }
          };
          var x$11 = $m_s_None$();
          if ((x$11 === x35)) {
            var x$13 = $m_s_None$();
            var $$x1 = (x$13 === x36)
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            var this$9 = oldVnode.Lsnabbdom_VNode__f_text;
            if ((!this$9.isEmpty__Z())) {
              var arg1$6 = this$9.get__O();
              $as_T(arg1$6);
              api$11.setTextContent__Lorg_scalajs_dom_Node__s_Option__V(elm, new $c_s_Some(""))
            };
            break matchResult8
          };
          throw new $c_s_MatchError(x24)
        };
        break matchResult9
      };
      if ((x41 instanceof $c_s_Some)) {
        var text = $as_T($as_s_Some(x41).s_Some__f_value);
        var this$11 = oldVnode.Lsnabbdom_VNode__f_text;
        if (this$11.isEmpty__Z()) {
          var $$x2 = true
        } else {
          var arg1$7 = this$11.get__O();
          var _$19 = $as_T(arg1$7);
          var $$x2 = (_$19 !== text)
        };
        if ($$x2) {
          if ((!oldCh.isEmpty__Z())) {
            var arg1$8 = oldCh.get__O();
            var oldChildren = $asArrayOf_Lsnabbdom_VNode(arg1$8, 1);
            $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V($thiz, api$11, cbs$8, elm, oldChildren, 0, (((-1) + oldChildren.u.length) | 0))
          };
          api$11.setTextContent__Lorg_scalajs_dom_Node__s_Option__V(elm, new $c_s_Some(text));
          break matchResult9
        };
        break matchResult9
      };
      throw new $c_s_MatchError(x41)
    };
    if (hook.isEmpty__Z()) {
      var this$13 = $m_s_None$()
    } else {
      var arg1$9 = hook.get__O();
      var _$20 = $as_Lsnabbdom_Hooks(arg1$9);
      var this$13 = _$20.postpatch__s_Option()
    };
    if ((!this$13.isEmpty__Z())) {
      var arg1$10 = this$13.get__O();
      var hook$4 = $as_Lsnabbdom_PostPatchHook(arg1$10);
      hook$4.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O(oldVnode, vnode)
    }
  }
}
/** @constructor */
function $c_Lsnabbdom_init$() {
  this.Lsnabbdom_init$__f_emptyNode = null;
  $n_Lsnabbdom_init$ = this;
  this.Lsnabbdom_init$__f_emptyNode = $m_Lsnabbdom_VNode$().create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some(""), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), $m_s_None$())
}
$c_Lsnabbdom_init$.prototype = new $h_O();
$c_Lsnabbdom_init$.prototype.constructor = $c_Lsnabbdom_init$;
/** @constructor */
function $h_Lsnabbdom_init$() {
  /*<skip>*/
}
$h_Lsnabbdom_init$.prototype = $c_Lsnabbdom_init$.prototype;
$c_Lsnabbdom_init$.prototype.apply__sci_Seq__s_Option__Lsnabbdom_Patch = (function(modules, domApi) {
  var api = $as_Lsnabbdom_DomApi((domApi.isEmpty__Z() ? new $c_Lsnabbdom_DomApi$$anon$1() : domApi.get__O()));
  var create = $m_s_package$().s_package$__f_Nil;
  var update = $m_s_package$().s_package$__f_Nil;
  var remove = $m_s_package$().s_package$__f_Nil;
  var destroy = $m_s_package$().s_package$__f_Nil;
  var pre = $m_s_package$().s_package$__f_Nil;
  var post = $m_s_package$().s_package$__f_Nil;
  var cbs = $as_Lsnabbdom_ModuleHooks(modules.foldLeft__O__F2__O(new $c_Lsnabbdom_ModuleHooks(create, update, remove, destroy, pre, post), new $c_sjsr_AnonFunction2(((x$1, x$2) => {
    var x$1$1 = $as_Lsnabbdom_ModuleHooks(x$1);
    var x$2$1 = $as_Lsnabbdom_Module(x$2);
    var this$5 = x$2$1.Lsnabbdom_Module__f_create;
    if (this$5.isEmpty__Z()) {
      var $$x1 = x$1$1.Lsnabbdom_ModuleHooks__f_create
    } else {
      var arg1 = this$5.get__O();
      var _$1 = $as_Lsnabbdom_CreateHook(arg1);
      var this$6 = x$1$1.Lsnabbdom_ModuleHooks__f_create;
      var $$x1 = new $c_sci_$colon$colon(_$1, this$6)
    };
    var create$1 = $as_sci_List($$x1);
    var this$7 = x$2$1.Lsnabbdom_Module__f_update;
    if (this$7.isEmpty__Z()) {
      var $$x2 = x$1$1.Lsnabbdom_ModuleHooks__f_update
    } else {
      var arg1$1 = this$7.get__O();
      var _$2 = $as_Lsnabbdom_UpdateHook(arg1$1);
      var this$8 = x$1$1.Lsnabbdom_ModuleHooks__f_update;
      var $$x2 = new $c_sci_$colon$colon(_$2, this$8)
    };
    var update$1 = $as_sci_List($$x2);
    var this$9 = x$2$1.Lsnabbdom_Module__f_remove;
    if (this$9.isEmpty__Z()) {
      var $$x3 = x$1$1.Lsnabbdom_ModuleHooks__f_remove
    } else {
      var arg1$2 = this$9.get__O();
      var _$3 = $as_Lsnabbdom_RemoveHook(arg1$2);
      var this$10 = x$1$1.Lsnabbdom_ModuleHooks__f_remove;
      var $$x3 = new $c_sci_$colon$colon(_$3, this$10)
    };
    var remove$1 = $as_sci_List($$x3);
    var this$11 = x$2$1.Lsnabbdom_Module__f_destroy;
    if (this$11.isEmpty__Z()) {
      var $$x4 = x$1$1.Lsnabbdom_ModuleHooks__f_destroy
    } else {
      var arg1$3 = this$11.get__O();
      var _$4 = $as_Lsnabbdom_DestroyHook(arg1$3);
      var this$12 = x$1$1.Lsnabbdom_ModuleHooks__f_destroy;
      var $$x4 = new $c_sci_$colon$colon(_$4, this$12)
    };
    var destroy$1 = $as_sci_List($$x4);
    var this$13 = x$2$1.Lsnabbdom_Module__f_pre;
    if (this$13.isEmpty__Z()) {
      var $$x5 = x$1$1.Lsnabbdom_ModuleHooks__f_pre
    } else {
      var arg1$4 = this$13.get__O();
      var _$5 = $as_Lsnabbdom_PreHook(arg1$4);
      var this$14 = x$1$1.Lsnabbdom_ModuleHooks__f_pre;
      var $$x5 = new $c_sci_$colon$colon(_$5, this$14)
    };
    var pre$1 = $as_sci_List($$x5);
    var this$15 = x$2$1.Lsnabbdom_Module__f_post;
    if (this$15.isEmpty__Z()) {
      var $$x6 = x$1$1.Lsnabbdom_ModuleHooks__f_post
    } else {
      var arg1$5 = this$15.get__O();
      var _$6 = $as_Lsnabbdom_PostHook(arg1$5);
      var this$16 = x$1$1.Lsnabbdom_ModuleHooks__f_post;
      var $$x6 = new $c_sci_$colon$colon(_$6, this$16)
    };
    var post$1 = $as_sci_List($$x6);
    return new $c_Lsnabbdom_ModuleHooks(create$1, update$1, remove$1, destroy$1, pre$1, post$1)
  }))));
  return new $c_Lsnabbdom_init$$anon$1(api, cbs)
});
$c_Lsnabbdom_init$.prototype.snabbdom$init$$$_$emptyNodeAt$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Element__Lsnabbdom_VNode = (function(api$1, elm) {
  var this$1 = $m_s_Option$().apply__O__s_Option($as_T(elm.id));
  if (this$1.isEmpty__Z()) {
    var $$x1 = true
  } else {
    var arg1 = this$1.get__O();
    var _$7 = $as_T(arg1);
    var $$x1 = (_$7 !== "")
  };
  if ($$x1) {
    var this$4 = this$1
  } else {
    var this$4 = $m_s_None$()
  };
  if (this$4.isEmpty__Z()) {
    var id = ""
  } else {
    var arg1$1 = this$4.get__O();
    var _$8 = $as_T(arg1$1);
    var id = ("#" + _$8)
  };
  var classes = $m_s_Option$().apply__O__s_Option($as_T(elm.getAttribute("class")));
  if (classes.isEmpty__Z()) {
    var this$6 = $m_s_None$()
  } else {
    var arg1$2 = classes.get__O();
    var _$9 = $as_T(arg1$2);
    var this$5 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(_$9, " ", 0));
    var this$6 = new $c_s_Some(("." + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$5, "", ".", "")))
  };
  var c = $as_T((this$6.isEmpty__Z() ? "" : this$6.get__O()));
  var $$x2 = $m_Lsnabbdom_VNode$();
  var this$7 = api$1.tagName__Lorg_scalajs_dom_Element__T(elm);
  var value = (($as_T(this$7.toLowerCase()) + id) + c);
  return $$x2.create__s_Option__Lsnabbdom_VNodeData__s_Option__s_Option__s_Option__Lsnabbdom_VNode(new $c_s_Some(value), $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty, $m_s_None$(), $m_s_None$(), new $c_s_Some(elm))
});
$c_Lsnabbdom_init$.prototype.snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(api$15, cbs$10, oldVnode, vnode) {
  var insertedVNodeQueue = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var this$2 = cbs$10.Lsnabbdom_ModuleHooks__f_pre;
  var these = this$2;
  while ((!these.isEmpty__Z())) {
    var arg1 = these.head__O();
    var hook = $as_Lsnabbdom_PreHook(arg1);
    hook.apply__O();
    these = $as_sci_List(these.tail__O())
  };
  if ($p_Lsnabbdom_init$__sameVnode__Lsnabbdom_VNode__Lsnabbdom_VNode__Z(this, oldVnode, vnode)) {
    $p_Lsnabbdom_init$__patchVnode$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__scm_ArrayBuffer__V(this, api$15, cbs$10, oldVnode, vnode, insertedVNodeQueue)
  } else {
    var elm = oldVnode.Lsnabbdom_VNode__f_elm.get__O();
    var parent = api$15.parentNode__Lorg_scalajs_dom_Node__s_Option(elm);
    $p_Lsnabbdom_init$__createElm$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__scm_ArrayBuffer__Lorg_scalajs_dom_Node(this, api$15, cbs$10, vnode, insertedVNodeQueue);
    matchResult10: {
      if ((parent instanceof $c_s_Some)) {
        var parent$2 = $as_s_Some(parent).s_Some__f_value;
        api$15.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V(parent$2, vnode.Lsnabbdom_VNode__f_elm.get__O(), api$15.nextSibling__Lorg_scalajs_dom_Node__s_Option(elm));
        $p_Lsnabbdom_init$__removeVnodes$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lorg_scalajs_dom_Node__ALsnabbdom_VNode__I__I__V(this, api$15, cbs$10, parent$2, new ($d_Lsnabbdom_VNode.getArrayOf().constr)([oldVnode]), 0, 0);
        break matchResult10
      };
      var x = $m_s_None$();
      if ((x === parent)) {
        break matchResult10
      };
      throw new $c_s_MatchError(parent)
    }
  };
  var it = insertedVNodeQueue.view__scm_ArrayBufferView().iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var arg1$1 = it.next__O();
    var vnode$1 = $as_Lsnabbdom_VNode(arg1$1);
    var this$3 = vnode$1.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_hook;
    if (this$3.isEmpty__Z()) {
      var this$4 = $m_s_None$()
    } else {
      var arg1$2 = this$3.get__O();
      var _$21 = $as_Lsnabbdom_Hooks(arg1$2);
      var this$4 = _$21.insert__s_Option()
    };
    if ((!this$4.isEmpty__Z())) {
      var arg1$3 = this$4.get__O();
      var hook$1 = $as_Lsnabbdom_InsertHook(arg1$3);
      hook$1.apply__Lsnabbdom_VNode__O(vnode$1)
    }
  };
  var this$5 = cbs$10.Lsnabbdom_ModuleHooks__f_post;
  var these$1 = this$5;
  while ((!these$1.isEmpty__Z())) {
    var arg1$4 = these$1.head__O();
    var hook$2 = $as_Lsnabbdom_PostHook(arg1$4);
    hook$2.apply__O();
    these$1 = $as_sci_List(these$1.tail__O())
  };
  return vnode
});
var $d_Lsnabbdom_init$ = new $TypeData().initClass({
  Lsnabbdom_init$: 0
}, false, "snabbdom.init$", {
  Lsnabbdom_init$: 1,
  O: 1
});
$c_Lsnabbdom_init$.prototype.$classData = $d_Lsnabbdom_init$;
var $n_Lsnabbdom_init$;
function $m_Lsnabbdom_init$() {
  if ((!$n_Lsnabbdom_init$)) {
    $n_Lsnabbdom_init$ = new $c_Lsnabbdom_init$()
  };
  return $n_Lsnabbdom_init$
}
function $p_Lsnabbdom_modules_Attributes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V($thiz, elm$2, oldAttrs, attrs) {
  attrs.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$1, elm$2$2, oldAttrs$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var key = $as_T(x$1$1._1__O());
        var cur = x$1$1._2__O();
        var old = oldAttrs$2.get__O__s_Option(key);
        if (old.isEmpty__Z()) {
          var $$x1 = true
        } else {
          var arg1 = old.get__O();
          var $$x1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(arg1, cur))
        };
        if ($$x1) {
          if ($m_sr_BoxesRunTime$().equals__O__O__Z(cur, true)) {
            elm$2$2.setAttribute(key, "")
          } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(cur, false)) {
            elm$2$2.removeAttribute(key)
          } else if (((65535 & $uI(key.charCodeAt(0))) !== 120)) {
            elm$2$2.setAttribute(key, $dp_toString__T(cur))
          } else if ((($uI(key.length) > 3) && ((65535 & $uI(key.charCodeAt(3))) === 58))) {
            elm$2$2.setAttributeNS(this$1.Lsnabbdom_modules_Attributes$__f_xmlNS, key, $dp_toString__T(cur))
          } else if ((($uI(key.length) > 5) && ((65535 & $uI(key.charCodeAt(5))) === 58))) {
            elm$2$2.setAttributeNS(this$1.Lsnabbdom_modules_Attributes$__f_xlinkNS, key, $dp_toString__T(cur))
          } else {
            elm$2$2.setAttribute(key, $dp_toString__T(cur))
          }
        };
        break matchResult1
      };
      throw new $c_s_MatchError(x$1$1)
    }
  }))($thiz, elm$2, oldAttrs)));
  oldAttrs.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2$3, attrs$2) => ((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult2: {
      if ((x$1$3 !== null)) {
        var key$1 = $as_T(x$1$3._1__O());
        if ((!attrs$2.contains__O__Z(key$1))) {
          elm$2$3.removeAttribute(key$1)
        };
        break matchResult2
      };
      throw new $c_s_MatchError(x$1$3)
    }
  }))(elm$2, attrs)))
}
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$() {
  this.Lsnabbdom_modules_Attributes$__f_module = null;
  this.Lsnabbdom_modules_Attributes$__f_xlinkNS = null;
  this.Lsnabbdom_modules_Attributes$__f_xmlNS = null;
  $n_Lsnabbdom_modules_Attributes$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Attributes$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Attributes$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Attributes$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
  this.Lsnabbdom_modules_Attributes$__f_xlinkNS = "http://www.w3.org/1999/xlink";
  this.Lsnabbdom_modules_Attributes$__f_xmlNS = "http://www.w3.org/XML/1998/namespace"
}
$c_Lsnabbdom_modules_Attributes$.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$.prototype.constructor = $c_Lsnabbdom_modules_Attributes$;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Attributes$.prototype = $c_Lsnabbdom_modules_Attributes$.prototype;
$c_Lsnabbdom_modules_Attributes$.prototype.snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = vnode.Lsnabbdom_VNode__f_elm.get__O();
  var oldAttrs = oldVnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_attrs;
  var attrs = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_attrs;
  if ((!((oldAttrs === null) ? (attrs === null) : oldAttrs.equals__O__Z(attrs)))) {
    $p_Lsnabbdom_modules_Attributes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V(this, elm, oldAttrs, attrs)
  }
});
var $d_Lsnabbdom_modules_Attributes$ = new $TypeData().initClass({
  Lsnabbdom_modules_Attributes$: 0
}, false, "snabbdom.modules.Attributes$", {
  Lsnabbdom_modules_Attributes$: 1,
  O: 1
});
$c_Lsnabbdom_modules_Attributes$.prototype.$classData = $d_Lsnabbdom_modules_Attributes$;
var $n_Lsnabbdom_modules_Attributes$;
function $m_Lsnabbdom_modules_Attributes$() {
  if ((!$n_Lsnabbdom_modules_Attributes$)) {
    $n_Lsnabbdom_modules_Attributes$ = new $c_Lsnabbdom_modules_Attributes$()
  };
  return $n_Lsnabbdom_modules_Attributes$
}
function $p_Lsnabbdom_modules_Classes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V($thiz, elm$2, oldClass, klass) {
  oldClass.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2$2, klass$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var name = $as_T(x$1$1._1__O());
        var flag = $uZ(x$1$1._2__O());
        if ((flag && (!klass$2.contains__O__Z(name)))) {
          elm$2$2.classList.remove(name)
        };
        break matchResult1
      };
      throw new $c_s_MatchError(x$1$1)
    }
  }))(elm$2, klass)));
  klass.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2$3, oldClass$2) => ((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult2: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T(x$1$3._1__O());
        var cur = $uZ(x$1$3._2__O());
        var this$3 = oldClass$2.get__O__s_Option(name$1);
        if (this$3.isEmpty__Z()) {
          var $$x1 = true
        } else {
          var arg1 = this$3.get__O();
          var _$1 = $uZ(arg1);
          var $$x1 = (_$1 !== cur)
        };
        if ($$x1) {
          if (cur) {
            elm$2$3.classList.add(name$1)
          } else {
            elm$2$3.classList.remove(name$1)
          }
        };
        break matchResult2
      };
      throw new $c_s_MatchError(x$1$3)
    }
  }))(elm$2, oldClass)))
}
/** @constructor */
function $c_Lsnabbdom_modules_Classes$() {
  this.Lsnabbdom_modules_Classes$__f_module = null;
  $n_Lsnabbdom_modules_Classes$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Classes$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Classes$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Classes$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1)
}
$c_Lsnabbdom_modules_Classes$.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$.prototype.constructor = $c_Lsnabbdom_modules_Classes$;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Classes$.prototype = $c_Lsnabbdom_modules_Classes$.prototype;
$c_Lsnabbdom_modules_Classes$.prototype.snabbdom$modules$Classes$$$updateClasses__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = vnode.Lsnabbdom_VNode__f_elm.get__O();
  var oldClasses = oldVnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_classes;
  var classes = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_classes;
  if ((!((oldClasses === null) ? (classes === null) : oldClasses.equals__O__Z(classes)))) {
    $p_Lsnabbdom_modules_Classes$__update$2__Lorg_scalajs_dom_Element__sci_Map__sci_Map__V(this, elm, oldClasses, classes)
  }
});
var $d_Lsnabbdom_modules_Classes$ = new $TypeData().initClass({
  Lsnabbdom_modules_Classes$: 0
}, false, "snabbdom.modules.Classes$", {
  Lsnabbdom_modules_Classes$: 1,
  O: 1
});
$c_Lsnabbdom_modules_Classes$.prototype.$classData = $d_Lsnabbdom_modules_Classes$;
var $n_Lsnabbdom_modules_Classes$;
function $m_Lsnabbdom_modules_Classes$() {
  if ((!$n_Lsnabbdom_modules_Classes$)) {
    $n_Lsnabbdom_modules_Classes$ = new $c_Lsnabbdom_modules_Classes$()
  };
  return $n_Lsnabbdom_modules_Classes$
}
function $p_Lsnabbdom_modules_Dataset$__update$2__Lorg_scalajs_dom_HTMLElement__sjs_js_Dictionary__sci_Map__sci_Map__V($thiz, elm$2, d$2, oldDataset, dataset) {
  oldDataset.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$1, elm$2$2, d$2$2, dataset$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var key = $as_T(x$1$1._1__O());
      var x1 = dataset$2.get__O__s_Option(key);
      var x = $m_s_None$();
      if ((x === x1)) {
        if ((d$2$2 !== (void 0))) {
          var this$4 = new $c_sjs_js_WrappedDictionary(d$2$2);
          return this$4.subtractOne__T__sjs_js_WrappedDictionary(key)
        } else {
          var this$5 = $f_T__replaceAll__T__T__T(key, this$1.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&");
          elm$2$2.removeAttribute(("data-" + $as_T(this$5.toLowerCase())));
          return (void 0)
        }
      };
      if ((x1 instanceof $c_s_Some)) {
        return (void 0)
      };
      throw new $c_s_MatchError(x1)
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, elm$2, d$2, dataset)));
  dataset.foreach__F1__V(new $c_sjsr_AnonFunction1(((this$2$1, elm$2$3, d$2$3, oldDataset$2) => ((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult3: {
      if ((x$1$3 !== null)) {
        var key$1 = $as_T(x$1$3._1__O());
        var value = $as_T(x$1$3._2__O());
        var this$6 = oldDataset$2.get__O__s_Option(key$1);
        if (this$6.isEmpty__Z()) {
          var $$x1 = true
        } else {
          var arg1 = this$6.get__O();
          var _$1 = $as_T(arg1);
          var $$x1 = (_$1 !== value)
        };
        if ($$x1) {
          if ((d$2$3 !== (void 0))) {
            d$2$3[key$1] = value
          } else {
            var this$12 = $f_T__replaceAll__T__T__T(key$1, this$2$1.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX, "-$&");
            elm$2$3.setAttribute(("data-" + $as_T(this$12.toLowerCase())), value)
          }
        };
        break matchResult3
      };
      throw new $c_s_MatchError(x$1$3)
    }
  }))($thiz, elm$2, d$2, oldDataset)))
}
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$() {
  this.Lsnabbdom_modules_Dataset$__f_module = null;
  this.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX = null;
  $n_Lsnabbdom_modules_Dataset$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Dataset$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Dataset$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Dataset$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1);
  this.Lsnabbdom_modules_Dataset$__f_CAPS_REGEX = "[A-Z]"
}
$c_Lsnabbdom_modules_Dataset$.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$.prototype.constructor = $c_Lsnabbdom_modules_Dataset$;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Dataset$.prototype = $c_Lsnabbdom_modules_Dataset$.prototype;
$c_Lsnabbdom_modules_Dataset$.prototype.snabbdom$modules$Dataset$$$updateDataset__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = vnode.Lsnabbdom_VNode__f_elm.get__O();
  var oldDataset = oldVnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_dataset;
  var dataset = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_dataset;
  var d = elm.dataset;
  if ((!((oldDataset === null) ? (dataset === null) : oldDataset.equals__O__Z(dataset)))) {
    $p_Lsnabbdom_modules_Dataset$__update$2__Lorg_scalajs_dom_HTMLElement__sjs_js_Dictionary__sci_Map__sci_Map__V(this, elm, d, oldDataset, dataset)
  }
});
var $d_Lsnabbdom_modules_Dataset$ = new $TypeData().initClass({
  Lsnabbdom_modules_Dataset$: 0
}, false, "snabbdom.modules.Dataset$", {
  Lsnabbdom_modules_Dataset$: 1,
  O: 1
});
$c_Lsnabbdom_modules_Dataset$.prototype.$classData = $d_Lsnabbdom_modules_Dataset$;
var $n_Lsnabbdom_modules_Dataset$;
function $m_Lsnabbdom_modules_Dataset$() {
  if ((!$n_Lsnabbdom_modules_Dataset$)) {
    $n_Lsnabbdom_modules_Dataset$ = new $c_Lsnabbdom_modules_Dataset$()
  };
  return $n_Lsnabbdom_modules_Dataset$
}
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$() {
  this.Lsnabbdom_modules_EventListeners$__f_module = null;
  $n_Lsnabbdom_modules_EventListeners$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_EventListeners$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_EventListeners$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var value$2 = new $c_Lsnabbdom_modules_EventListeners$$anon$3();
  var destroy$1 = new $c_s_Some(value$2);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_EventListeners$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1)
}
$c_Lsnabbdom_modules_EventListeners$.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_EventListeners$.prototype = $c_Lsnabbdom_modules_EventListeners$.prototype;
$c_Lsnabbdom_modules_EventListeners$.prototype.snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V = (function(oldVnode, vnode) {
  var oldOn = oldVnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_on;
  var oldListener = oldVnode.Lsnabbdom_VNode__f_listener;
  var this$1 = oldVnode.Lsnabbdom_VNode__f_elm;
  if (this$1.isEmpty__Z()) {
    var oldElm = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var oldElm = new $c_s_Some(arg1)
  };
  if (vnode.isEmpty__Z()) {
    var this$2 = $m_s_None$()
  } else {
    var arg1$1 = vnode.get__O();
    var _$2 = $as_Lsnabbdom_VNode(arg1$1);
    var this$2 = new $c_s_Some(_$2.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_on)
  };
  var on = $as_sci_Map((this$2.isEmpty__Z() ? $m_sci_Map$EmptyMap$() : this$2.get__O()));
  if (vnode.isEmpty__Z()) {
    var this$4 = $m_s_None$()
  } else {
    var arg1$2 = vnode.get__O();
    var _$3 = $as_Lsnabbdom_VNode(arg1$2);
    var this$4 = _$3.Lsnabbdom_VNode__f_elm
  };
  if (this$4.isEmpty__Z()) {
    var elm = $m_s_None$()
  } else {
    var arg1$3 = this$4.get__O();
    var elm = new $c_s_Some(arg1$3)
  };
  if ((!((oldOn === null) ? (on === null) : oldOn.equals__O__Z(on)))) {
    if (((!oldOn.isEmpty__Z()) && (!oldListener.isEmpty__Z()))) {
      var ol = $as_Lsnabbdom_Listener(oldListener.get__O());
      if (on.isEmpty__Z()) {
        oldOn.foreach__F1__V(new $c_sjsr_AnonFunction1(((oldElm$2, ol$2) => ((x$1) => {
          var x$1$1 = $as_T2(x$1);
          matchResult1: {
            if ((x$1$1 !== null)) {
              var name = $as_T(x$1$1._1__O());
              if ((!oldElm$2.isEmpty__Z())) {
                var arg1$4 = oldElm$2.get__O();
                arg1$4.removeEventListener(name, ol$2.Lsnabbdom_Listener__f_jsFun, false)
              };
              break matchResult1
            };
            throw new $c_s_MatchError(x$1$1)
          }
        }))(oldElm, ol)))
      } else {
        oldOn.foreach__F1__V(new $c_sjsr_AnonFunction1(((oldElm$3, on$2, ol$3) => ((x$1$2) => {
          var x$1$3 = $as_T2(x$1$2);
          matchResult2: {
            if ((x$1$3 !== null)) {
              var name$1 = $as_T(x$1$3._1__O());
              if (on$2.get__O__s_Option(name$1).isEmpty__Z()) {
                if ((!oldElm$3.isEmpty__Z())) {
                  var arg1$5 = oldElm$3.get__O();
                  arg1$5.removeEventListener(name$1, ol$3.Lsnabbdom_Listener__f_jsFun, false)
                }
              };
              break matchResult2
            };
            throw new $c_s_MatchError(x$1$3)
          }
        }))(oldElm, on, ol)))
      }
    };
    if ((!on.isEmpty__Z())) {
      if (oldListener.isEmpty__Z()) {
        var vnode$1 = $as_Lsnabbdom_VNode(vnode.get__O());
        var $$x1 = new $c_Lsnabbdom_Listener(vnode$1)
      } else {
        var $$x1 = oldListener.get__O()
      };
      var listener = $as_Lsnabbdom_Listener($$x1);
      listener.Lsnabbdom_Listener__f_vnode = $as_Lsnabbdom_VNode(vnode.get__O());
      if ((!vnode.isEmpty__Z())) {
        var arg1$6 = vnode.get__O();
        var _$6 = $as_Lsnabbdom_VNode(arg1$6);
        _$6.Lsnabbdom_VNode__f_listener = new $c_s_Some(listener)
      };
      if (oldOn.isEmpty__Z()) {
        on.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2, listener$3) => ((x$1$3$1) => {
          var x$1$4 = $as_T2(x$1$3$1);
          matchResult3: {
            if ((x$1$4 !== null)) {
              var name$2 = $as_T(x$1$4._1__O());
              if ((!elm$2.isEmpty__Z())) {
                var arg1$7 = elm$2.get__O();
                arg1$7.addEventListener(name$2, listener$3.Lsnabbdom_Listener__f_jsFun, false)
              };
              break matchResult3
            };
            throw new $c_s_MatchError(x$1$4)
          }
        }))(elm, listener)))
      } else {
        on.foreach__F1__V(new $c_sjsr_AnonFunction1(((oldOn$2, elm$3, listener$4) => ((x$1$4$1) => {
          var x$1$5 = $as_T2(x$1$4$1);
          matchResult4: {
            if ((x$1$5 !== null)) {
              var name$3 = $as_T(x$1$5._1__O());
              if ((!oldOn$2.contains__O__Z(name$3))) {
                if ((!elm$3.isEmpty__Z())) {
                  var arg1$8 = elm$3.get__O();
                  arg1$8.addEventListener(name$3, listener$4.Lsnabbdom_Listener__f_jsFun, false)
                }
              };
              break matchResult4
            };
            throw new $c_s_MatchError(x$1$5)
          }
        }))(oldOn, elm, listener)))
      }
    }
  }
});
var $d_Lsnabbdom_modules_EventListeners$ = new $TypeData().initClass({
  Lsnabbdom_modules_EventListeners$: 0
}, false, "snabbdom.modules.EventListeners$", {
  Lsnabbdom_modules_EventListeners$: 1,
  O: 1
});
$c_Lsnabbdom_modules_EventListeners$.prototype.$classData = $d_Lsnabbdom_modules_EventListeners$;
var $n_Lsnabbdom_modules_EventListeners$;
function $m_Lsnabbdom_modules_EventListeners$() {
  if ((!$n_Lsnabbdom_modules_EventListeners$)) {
    $n_Lsnabbdom_modules_EventListeners$ = new $c_Lsnabbdom_modules_EventListeners$()
  };
  return $n_Lsnabbdom_modules_EventListeners$
}
function $p_Lsnabbdom_modules_Props$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V($thiz, elm$2, oldProps, props) {
  props.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2$2, oldProps$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    matchResult1: {
      if ((x$1$1 !== null)) {
        var key = $as_T(x$1$1._1__O());
        var cur = x$1$1._2__O();
        var this$2 = oldProps$2.get__O__s_Option(key);
        if (this$2.isEmpty__Z()) {
          var $$x2 = true
        } else {
          var arg1 = this$2.get__O();
          var $$x2 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(arg1, cur))
        };
        if ($$x2) {
          if ((key !== "value")) {
            var $$x1 = true
          } else {
            var this$5 = ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(elm$2$2, key)) ? new $c_s_Some(elm$2$2[key]) : $m_s_None$());
            if (this$5.isEmpty__Z()) {
              var $$x1 = true
            } else {
              var arg1$1 = this$5.get__O();
              var $$x1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(arg1$1, cur))
            }
          }
        } else {
          var $$x1 = false
        };
        if ($$x1) {
          elm$2$2[key] = cur
        };
        break matchResult1
      };
      throw new $c_s_MatchError(x$1$1)
    }
  }))(elm$2, oldProps)))
}
/** @constructor */
function $c_Lsnabbdom_modules_Props$() {
  this.Lsnabbdom_modules_Props$__f_module = null;
  $n_Lsnabbdom_modules_Props$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Props$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Props$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Props$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1)
}
$c_Lsnabbdom_modules_Props$.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$.prototype.constructor = $c_Lsnabbdom_modules_Props$;
/** @constructor */
function $h_Lsnabbdom_modules_Props$() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Props$.prototype = $c_Lsnabbdom_modules_Props$.prototype;
$c_Lsnabbdom_modules_Props$.prototype.snabbdom$modules$Props$$$updateProps__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = vnode.Lsnabbdom_VNode__f_elm.get__O();
  var oldProps = oldVnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_props;
  var props = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_props;
  if ((!((oldProps === null) ? (props === null) : oldProps.equals__O__Z(props)))) {
    $p_Lsnabbdom_modules_Props$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V(this, elm, oldProps, props)
  }
});
var $d_Lsnabbdom_modules_Props$ = new $TypeData().initClass({
  Lsnabbdom_modules_Props$: 0
}, false, "snabbdom.modules.Props$", {
  Lsnabbdom_modules_Props$: 1,
  O: 1
});
$c_Lsnabbdom_modules_Props$.prototype.$classData = $d_Lsnabbdom_modules_Props$;
var $n_Lsnabbdom_modules_Props$;
function $m_Lsnabbdom_modules_Props$() {
  if ((!$n_Lsnabbdom_modules_Props$)) {
    $n_Lsnabbdom_modules_Props$ = new $c_Lsnabbdom_modules_Props$()
  };
  return $n_Lsnabbdom_modules_Props$
}
function $p_Lsnabbdom_modules_Styles$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V($thiz, elm$2, oldStyle, style) {
  oldStyle.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2$2, style$2) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var name = $as_T(x$1$1._1__O());
      var x1 = style$2.get__O__s_Option(name);
      if ((x1 instanceof $c_s_Some)) {
        return (void 0)
      };
      var x = $m_s_None$();
      if ((x === x1)) {
        if ((((65535 & $uI(name.charCodeAt(0))) === 45) && ((65535 & $uI(name.charCodeAt(1))) === 45))) {
          return $as_T(elm$2$2.style.removeProperty(name))
        } else {
          var dict = elm$2$2.style;
          dict[name] = "";
          return (void 0)
        }
      };
      throw new $c_s_MatchError(x1)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(elm$2, style)));
  style.foreach__F1__V(new $c_sjsr_AnonFunction1(((elm$2$3, oldStyle$2) => ((x$1$2) => {
    var x$1$3 = $as_T2(x$1$2);
    matchResult3: {
      if ((x$1$3 !== null)) {
        var name$1 = $as_T(x$1$3._1__O());
        var cur = $as_T(x$1$3._2__O());
        var this$7 = oldStyle$2.get__O__s_Option(name$1);
        if (this$7.isEmpty__Z()) {
          var $$x1 = true
        } else {
          var arg1 = this$7.get__O();
          var _$1 = $as_T(arg1);
          var $$x1 = (_$1 !== cur)
        };
        if ($$x1) {
          if ((((65535 & $uI(name$1.charCodeAt(0))) === 45) && ((65535 & $uI(name$1.charCodeAt(1))) === 45))) {
            var \u03b42$ = elm$2$3.style;
            \u03b42$.setProperty(name$1, cur)
          } else {
            var dict$1 = elm$2$3.style;
            dict$1[name$1] = cur
          }
        };
        break matchResult3
      };
      throw new $c_s_MatchError(x$1$3)
    }
  }))(elm$2, oldStyle)))
}
/** @constructor */
function $c_Lsnabbdom_modules_Styles$() {
  this.Lsnabbdom_modules_Styles$__f_module = null;
  $n_Lsnabbdom_modules_Styles$ = this;
  var pre = $m_s_None$();
  var create = $m_s_None$();
  var update = $m_s_None$();
  var destroy = $m_s_None$();
  var remove = $m_s_None$();
  var post = $m_s_None$();
  var \u03b41$ = new $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post);
  var value = new $c_Lsnabbdom_modules_Styles$$anon$1();
  var create$1 = new $c_s_Some(value);
  var value$1 = new $c_Lsnabbdom_modules_Styles$$anon$2();
  var update$1 = new $c_s_Some(value$1);
  var pre$1 = \u03b41$.Lsnabbdom_Module__f_pre;
  var destroy$1 = \u03b41$.Lsnabbdom_Module__f_destroy;
  var remove$1 = \u03b41$.Lsnabbdom_Module__f_remove;
  var post$1 = \u03b41$.Lsnabbdom_Module__f_post;
  this.Lsnabbdom_modules_Styles$__f_module = new $c_Lsnabbdom_Module(pre$1, create$1, update$1, destroy$1, remove$1, post$1)
}
$c_Lsnabbdom_modules_Styles$.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$.prototype.constructor = $c_Lsnabbdom_modules_Styles$;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Styles$.prototype = $c_Lsnabbdom_modules_Styles$.prototype;
$c_Lsnabbdom_modules_Styles$.prototype.snabbdom$modules$Styles$$$updateStyle__Lsnabbdom_VNode__Lsnabbdom_VNode__V = (function(oldVnode, vnode) {
  var elm = vnode.Lsnabbdom_VNode__f_elm.get__O();
  var oldStyle = oldVnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_style;
  var style = vnode.Lsnabbdom_VNode__f_data.Lsnabbdom_VNodeData__f_style;
  if ((!((oldStyle === null) ? (style === null) : oldStyle.equals__O__Z(style)))) {
    $p_Lsnabbdom_modules_Styles$__update$2__Lorg_scalajs_dom_Node__sci_Map__sci_Map__V(this, elm, oldStyle, style)
  }
});
var $d_Lsnabbdom_modules_Styles$ = new $TypeData().initClass({
  Lsnabbdom_modules_Styles$: 0
}, false, "snabbdom.modules.Styles$", {
  Lsnabbdom_modules_Styles$: 1,
  O: 1
});
$c_Lsnabbdom_modules_Styles$.prototype.$classData = $d_Lsnabbdom_modules_Styles$;
var $n_Lsnabbdom_modules_Styles$;
function $m_Lsnabbdom_modules_Styles$() {
  if ((!$n_Lsnabbdom_modules_Styles$)) {
    $n_Lsnabbdom_modules_Styles$ = new $c_Lsnabbdom_modules_Styles$()
  };
  return $n_Lsnabbdom_modules_Styles$
}
function $is_Ltyrian_Attr(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Attr)))
}
function $as_Ltyrian_Attr(obj) {
  return (($is_Ltyrian_Attr(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attr"))
}
function $isArrayOf_Ltyrian_Attr(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attr)))
}
function $asArrayOf_Ltyrian_Attr(obj, depth) {
  return (($isArrayOf_Ltyrian_Attr(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attr;", depth))
}
var $d_Ltyrian_Attr = new $TypeData().initClass({
  Ltyrian_Attr: 0
}, true, "tyrian.Attr", {
  Ltyrian_Attr: 1,
  O: 1
});
function $is_Ltyrian_Cmd(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Cmd)))
}
function $as_Ltyrian_Cmd(obj) {
  return (($is_Ltyrian_Cmd(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd"))
}
function $isArrayOf_Ltyrian_Cmd(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd)))
}
function $asArrayOf_Ltyrian_Cmd(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd;", depth))
}
var $d_Ltyrian_Cmd = new $TypeData().initClass({
  Ltyrian_Cmd: 0
}, true, "tyrian.Cmd", {
  Ltyrian_Cmd: 1,
  O: 1
});
function $is_Ltyrian_Elem(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Elem)))
}
function $as_Ltyrian_Elem(obj) {
  return (($is_Ltyrian_Elem(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Elem"))
}
function $isArrayOf_Ltyrian_Elem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Elem)))
}
function $asArrayOf_Ltyrian_Elem(obj, depth) {
  return (($isArrayOf_Ltyrian_Elem(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Elem;", depth))
}
var $d_Ltyrian_Elem = new $TypeData().initClass({
  Ltyrian_Elem: 0
}, true, "tyrian.Elem", {
  Ltyrian_Elem: 1,
  O: 1
});
function $f_Ltyrian_HtmlAttributes__$init$__V($thiz) {
  $thiz.Ltyrian_Html$__f_accept$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "accept");
  $thiz.Ltyrian_Html$__f_accessKey$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "accesskey");
  $thiz.Ltyrian_Html$__f_action$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "action");
  $thiz.Ltyrian_Html$__f_alt$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "alt");
  $thiz.Ltyrian_Html$__f_autoComplete$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "autocomplete");
  $thiz.Ltyrian_Html$__f_charset$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "charset");
  $thiz.Ltyrian_Html$__f_cite$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "cite");
  $thiz.Ltyrian_Html$__f_$u0060class$u0060$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_cls$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_className$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_classname$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f__class$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "class");
  $thiz.Ltyrian_Html$__f_cols$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "cols");
  $thiz.Ltyrian_Html$__f_cols$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "cols");
  $thiz.Ltyrian_Html$__f_colSpan$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "colspan");
  $thiz.Ltyrian_Html$__f_colSpan$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "colspan");
  $thiz.Ltyrian_Html$__f_colspan$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "colspan");
  $thiz.Ltyrian_Html$__f_colspan$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "colspan");
  $thiz.Ltyrian_Html$__f_content$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "content");
  $thiz.Ltyrian_Html$__f_contentEditable$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "contenteditable");
  $thiz.Ltyrian_Html$__f_contentEditable$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "contenteditable");
  $thiz.Ltyrian_Html$__f_contenteditable$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "contenteditable");
  $thiz.Ltyrian_Html$__f_contenteditable$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "contenteditable");
  $thiz.Ltyrian_Html$__f_coords$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "coords");
  $thiz.Ltyrian_Html$__f_data$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "data");
  $thiz.Ltyrian_Html$__f_dateTime$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "datetime");
  $thiz.Ltyrian_Html$__f_datetime$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "datetime");
  $thiz.Ltyrian_Html$__f_dir$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "dir");
  $thiz.Ltyrian_Html$__f_dirname$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "dirname");
  $thiz.Ltyrian_Html$__f_draggable$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "draggable");
  $thiz.Ltyrian_Html$__f_draggable$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "draggable");
  $thiz.Ltyrian_Html$__f_encType$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "enctype");
  $thiz.Ltyrian_Html$__f_enctype$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "enctype");
  $thiz.Ltyrian_Html$__f__for$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  $thiz.Ltyrian_Html$__f_forId$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  $thiz.Ltyrian_Html$__f_htmlFor$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "for");
  $thiz.Ltyrian_Html$__f_form$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "form");
  $thiz.Ltyrian_Html$__f_formAction$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "formaction");
  $thiz.Ltyrian_Html$__f_formaction$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "formaction");
  $thiz.Ltyrian_Html$__f_headers$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "headers");
  $thiz.Ltyrian_Html$__f_height$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "height");
  $thiz.Ltyrian_Html$__f_height$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "height");
  $thiz.Ltyrian_Html$__f_high$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "high");
  $thiz.Ltyrian_Html$__f_high$minusDouble = new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "high");
  $thiz.Ltyrian_Html$__f_href$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "href");
  $thiz.Ltyrian_Html$__f_hrefLang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "hreflang");
  $thiz.Ltyrian_Html$__f_hreflang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "hreflang");
  $thiz.Ltyrian_Html$__f_http$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "http");
  $thiz.Ltyrian_Html$__f_id$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "id");
  $thiz.Ltyrian_Html$__f_kind$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "kind");
  $thiz.Ltyrian_Html$__f_label$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "label");
  $thiz.Ltyrian_Html$__f_lang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "lang");
  $thiz.Ltyrian_Html$__f_list$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "list");
  $thiz.Ltyrian_Html$__f_low$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "low");
  $thiz.Ltyrian_Html$__f_low$minusDouble = new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "low");
  $thiz.Ltyrian_Html$__f_max$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "max");
  $thiz.Ltyrian_Html$__f_max$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "max");
  $thiz.Ltyrian_Html$__f_maxLength$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "maxlength");
  $thiz.Ltyrian_Html$__f_maxLength$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "maxlength");
  $thiz.Ltyrian_Html$__f_maxlength$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "maxlength");
  $thiz.Ltyrian_Html$__f_maxlength$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "maxlength");
  $thiz.Ltyrian_Html$__f_media$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "media");
  $thiz.Ltyrian_Html$__f_method$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "method");
  $thiz.Ltyrian_Html$__f_min$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "min");
  $thiz.Ltyrian_Html$__f_min$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "min");
  $thiz.Ltyrian_Html$__f_multiple$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "multiple");
  $thiz.Ltyrian_Html$__f_muted$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "muted");
  $thiz.Ltyrian_Html$__f_name$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "name");
  $thiz.Ltyrian_Html$__f_optimum$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "optimum");
  $thiz.Ltyrian_Html$__f_optimum$minusDouble = new $c_Ltyrian_HtmlAttributes$AttributeNameDouble($thiz, "optimum");
  $thiz.Ltyrian_Html$__f_pattern$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "pattern");
  $thiz.Ltyrian_Html$__f_placeholder$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "placeholder");
  $thiz.Ltyrian_Html$__f_poster$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "poster");
  $thiz.Ltyrian_Html$__f_preload$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "preload");
  $thiz.Ltyrian_Html$__f_rel$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rel");
  $thiz.Ltyrian_Html$__f_rows$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rows");
  $thiz.Ltyrian_Html$__f_rows$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rows");
  $thiz.Ltyrian_Html$__f_rowSpan$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rowspan");
  $thiz.Ltyrian_Html$__f_rowSpan$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rowspan");
  $thiz.Ltyrian_Html$__f_rowspan$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "rowspan");
  $thiz.Ltyrian_Html$__f_rowspan$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "rowspan");
  $thiz.Ltyrian_Html$__f_scope$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "scope");
  $thiz.Ltyrian_Html$__f_shape$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "shape");
  $thiz.Ltyrian_Html$__f_size$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "size");
  $thiz.Ltyrian_Html$__f_size$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "size");
  $thiz.Ltyrian_Html$__f_sizes$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "sizes");
  $thiz.Ltyrian_Html$__f_span$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "span");
  $thiz.Ltyrian_Html$__f_span$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "span");
  $thiz.Ltyrian_Html$__f_spellCheck$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "spellcheck");
  $thiz.Ltyrian_Html$__f_spellCheck$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "spellcheck");
  $thiz.Ltyrian_Html$__f_spellcheck$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "spellcheck");
  $thiz.Ltyrian_Html$__f_spellcheck$minusBoolean = new $c_Ltyrian_HtmlAttributes$AttributeNameBoolean($thiz, "spellcheck");
  $thiz.Ltyrian_Html$__f_src$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "src");
  $thiz.Ltyrian_Html$__f_srcDoc$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcdoc");
  $thiz.Ltyrian_Html$__f_srcdoc$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcdoc");
  $thiz.Ltyrian_Html$__f_srcLang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srclang");
  $thiz.Ltyrian_Html$__f_srclang$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srclang");
  $thiz.Ltyrian_Html$__f_srcSet$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcset");
  $thiz.Ltyrian_Html$__f_srcset$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "srcset");
  $thiz.Ltyrian_Html$__f_start$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "start");
  $thiz.Ltyrian_Html$__f_start$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "start");
  $thiz.Ltyrian_Html$__f_step$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "step");
  $thiz.Ltyrian_Html$__f_step$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "step");
  $thiz.Ltyrian_Html$__f_style$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "style");
  $thiz.Ltyrian_Html$__f_tabIndex$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "tabindex");
  $thiz.Ltyrian_Html$__f_tabIndex$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "tabindex");
  $thiz.Ltyrian_Html$__f_tabindex$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "tabindex");
  $thiz.Ltyrian_Html$__f_tabindex$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "tabindex");
  $thiz.Ltyrian_Html$__f_target$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "target");
  $thiz.Ltyrian_Html$__f_title$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "title");
  $thiz.Ltyrian_Html$__f_translate$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "translate");
  $thiz.Ltyrian_Html$__f_$u0060type$u0060$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f__type$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f_typ$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f_tpe$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "type");
  $thiz.Ltyrian_Html$__f_useMap$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "usemap");
  $thiz.Ltyrian_Html$__f_usemap$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "usemap");
  $thiz.Ltyrian_Html$__f_width$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "width");
  $thiz.Ltyrian_Html$__f_width$minusInt = new $c_Ltyrian_HtmlAttributes$AttributeNameInt($thiz, "width");
  $thiz.Ltyrian_Html$__f_wrap$minusString = new $c_Ltyrian_HtmlAttributes$AttributeNameString($thiz, "wrap");
  $thiz.Ltyrian_Html$__f_value$minusString = new $c_Ltyrian_HtmlAttributes$PropertyNameString($thiz, "value");
  $thiz.Ltyrian_Html$__f_value$minusDouble = new $c_Ltyrian_HtmlAttributes$PropertyNameDouble($thiz, "value");
  $thiz.Ltyrian_Html$__f_value$minusBoolean = new $c_Ltyrian_HtmlAttributes$PropertyNameBoolean($thiz, "value")
}
function $f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Attr($thiz, msg) {
  var msg$1 = new $c_sjsr_AnonFunction1(((msg$2) => ((_$9) => msg$2))(msg));
  return new $c_Ltyrian_Event("click", msg$1)
}
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameBoolean(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameBoolean__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameBoolean;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameBoolean() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameBoolean = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameBoolean: 0
}, false, "tyrian.HtmlAttributes$AttributeNameBoolean", {
  Ltyrian_HtmlAttributes$AttributeNameBoolean: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameBoolean.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameBoolean;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameDouble(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameDouble__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameDouble;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameDouble() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameDouble = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameDouble: 0
}, false, "tyrian.HtmlAttributes$AttributeNameDouble", {
  Ltyrian_HtmlAttributes$AttributeNameDouble: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameDouble.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameDouble;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameInt(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameInt__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameInt;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameInt() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameInt.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype;
var $d_Ltyrian_HtmlAttributes$AttributeNameInt = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameInt: 0
}, false, "tyrian.HtmlAttributes$AttributeNameInt", {
  Ltyrian_HtmlAttributes$AttributeNameInt: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameInt.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameInt;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$AttributeNameString(outer, name) {
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_name = null;
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_$outer = null;
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$AttributeNameString__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.constructor = $c_Ltyrian_HtmlAttributes$AttributeNameString;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$AttributeNameString() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$AttributeNameString.prototype = $c_Ltyrian_HtmlAttributes$AttributeNameString.prototype;
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.$colon$eq__T__Ltyrian_Attribute = (function(value) {
  $m_Ltyrian_Attribute$();
  var this$1 = this.Ltyrian_HtmlAttributes$AttributeNameString__f_name;
  return new $c_Ltyrian_Attribute(this$1, value)
});
var $d_Ltyrian_HtmlAttributes$AttributeNameString = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$AttributeNameString: 0
}, false, "tyrian.HtmlAttributes$AttributeNameString", {
  Ltyrian_HtmlAttributes$AttributeNameString: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$AttributeNameString.prototype.$classData = $d_Ltyrian_HtmlAttributes$AttributeNameString;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameBoolean(outer, name) {
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_name = null;
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_$outer = null;
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$PropertyNameBoolean__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameBoolean;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameBoolean() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameBoolean = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$PropertyNameBoolean: 0
}, false, "tyrian.HtmlAttributes$PropertyNameBoolean", {
  Ltyrian_HtmlAttributes$PropertyNameBoolean: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$PropertyNameBoolean.prototype.$classData = $d_Ltyrian_HtmlAttributes$PropertyNameBoolean;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameDouble(outer, name) {
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_name = null;
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_$outer = null;
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$PropertyNameDouble__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameDouble;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameDouble() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameDouble = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$PropertyNameDouble: 0
}, false, "tyrian.HtmlAttributes$PropertyNameDouble", {
  Ltyrian_HtmlAttributes$PropertyNameDouble: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$PropertyNameDouble.prototype.$classData = $d_Ltyrian_HtmlAttributes$PropertyNameDouble;
/** @constructor */
function $c_Ltyrian_HtmlAttributes$PropertyNameString(outer, name) {
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_name = null;
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_$outer = null;
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_name = name;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Ltyrian_HtmlAttributes$PropertyNameString__f_$outer = outer
}
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype = new $h_O();
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype.constructor = $c_Ltyrian_HtmlAttributes$PropertyNameString;
/** @constructor */
function $h_Ltyrian_HtmlAttributes$PropertyNameString() {
  /*<skip>*/
}
$h_Ltyrian_HtmlAttributes$PropertyNameString.prototype = $c_Ltyrian_HtmlAttributes$PropertyNameString.prototype;
var $d_Ltyrian_HtmlAttributes$PropertyNameString = new $TypeData().initClass({
  Ltyrian_HtmlAttributes$PropertyNameString: 0
}, false, "tyrian.HtmlAttributes$PropertyNameString", {
  Ltyrian_HtmlAttributes$PropertyNameString: 1,
  O: 1
});
$c_Ltyrian_HtmlAttributes$PropertyNameString.prototype.$classData = $d_Ltyrian_HtmlAttributes$PropertyNameString;
function $f_Ltyrian_HtmlTags__blockquote$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("blockquote", attributes, children)
}
function $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = attributes.toList__sci_List();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("button", attributes$1, children)
}
function $f_Ltyrian_HtmlTags__h3$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("h3", attributes, children)
}
function $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("h5", attributes, children)
}
function $f_Ltyrian_HtmlTags__label$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = attributes.toList__sci_List();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("label", attributes$1, children)
}
function $f_Ltyrian_HtmlTags__li$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html($thiz, attributes, plainText) {
  var attributes$1 = attributes.toList__sci_List();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("li", attributes$1, children)
}
function $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("p", attributes, children)
}
function $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("td", attributes, children)
}
function $f_Ltyrian_HtmlTags__th$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html($thiz, plainText) {
  var attributes = $m_s_package$().s_package$__f_Nil;
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Text.getArrayOf().constr)([($m_Ltyrian_Html$(), new $c_Ltyrian_Text(plainText))]));
  var children = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  return new $c_Ltyrian_Tag("th", attributes, children)
}
function $is_Ltyrian_Sub(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Sub)))
}
function $as_Ltyrian_Sub(obj) {
  return (($is_Ltyrian_Sub(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub"))
}
function $isArrayOf_Ltyrian_Sub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub)))
}
function $asArrayOf_Ltyrian_Sub(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub;", depth))
}
var $d_Ltyrian_Sub = new $TypeData().initClass({
  Ltyrian_Sub: 0
}, true, "tyrian.Sub", {
  Ltyrian_Sub: 1,
  O: 1
});
/** @constructor */
function $c_Ltyrian_Tyrian$() {
  /*<skip>*/
}
$c_Ltyrian_Tyrian$.prototype = new $h_O();
$c_Ltyrian_Tyrian$.prototype.constructor = $c_Ltyrian_Tyrian$;
/** @constructor */
function $h_Ltyrian_Tyrian$() {
  /*<skip>*/
}
$h_Ltyrian_Tyrian$.prototype = $c_Ltyrian_Tyrian$.prototype;
$c_Ltyrian_Tyrian$.prototype.start__Lorg_scalajs_dom_Element__T2__F1__F1__F1__I__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(node, init, update, view, subscriptions, maxConcurrentTasks, evidence$1) {
  var ffa = $m_Lcats_effect_std_Dispatcher$().apply__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(evidence$1).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((node$2, init$2, update$2, view$2, subscriptions$2, maxConcurrentTasks$2, evidence$1$2) => ((dispatcher) => {
    var dispatcher$1 = $as_Lcats_effect_std_Dispatcher(dispatcher);
    var this$2 = $m_Lcats_effect_std_Queue$();
    var target = this$2.bounded__I__Lcats_effect_kernel_GenConcurrent__O(2147483647, evidence$1$2);
    var this$7 = new $c_Lcats_Functor$$anon$4(target, evidence$1$2);
    var f = new $c_sjsr_AnonFunction1(((init$1$2) => ((queue) => {
      var queue$1 = $as_Lcats_effect_std_Queue(queue);
      matchResult1: {
        var \u03b42$___1;
        var \u03b42$___2;
        var \u03b42$___3;
        if ((init$1$2 !== null)) {
          var initialModel = init$1$2._1__O();
          var initialCmd = $as_Ltyrian_Cmd(init$1$2._2__O());
          var \u03b42$___1 = init$1$2;
          var \u03b42$___2 = initialModel;
          var \u03b42$___3 = initialCmd;
          break matchResult1
        };
        throw new $c_s_MatchError(init$1$2)
      };
      var \u03b41$$2 = $as_T2(\u03b42$___1);
      $as_Ltyrian_Cmd(\u03b42$___3);
      return new $c_T2(queue$1, \u03b41$$2)
    }))(init$2));
    var target$1 = this$7.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$7.Lcats_Functor$$anon$4__f_self, f);
    var this$31 = new $c_Lcats_FlatMap$$anon$2(target$1, evidence$1$2);
    var f$4 = new $c_sjsr_AnonFunction1(((node$1$2, update$1$2, view$1$2, subscriptions$1$2, maxConcurrentTasks$1$2, evidence$1$1$2, dispatcher$2) => ((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var x6 = $as_T2(x$1$1._2__O());
        var queue$2 = $as_Lcats_effect_std_Queue(x$1$1._1__O());
        if ((x6 !== null)) {
          var initialModel$1 = x6._1__O();
          var initialCmd$1 = $as_Ltyrian_Cmd(x6._2__O());
          var target$2 = evidence$1$1$2.ref__O__O(new $c_Ltyrian_runtime_ModelHolder(initialModel$1, true));
          var this$30 = new $c_Lcats_FlatMap$$anon$2(target$2, evidence$1$1$2);
          var f$3 = new $c_sjsr_AnonFunction1(((node$2$2, update$2$2, view$2$2, subscriptions$2$2, maxConcurrentTasks$2$2, evidence$1$2$2, dispatcher$1$2, queue$2$1, initialCmd$2$1) => ((model) => {
            var model$1 = $as_Lcats_effect_kernel_Ref(model);
            var target$3 = evidence$1$2$2.ref__O__O(node$2$2);
            var this$29 = new $c_Lcats_FlatMap$$anon$2(target$3, evidence$1$2$2);
            var f$2 = new $c_sjsr_AnonFunction1(((update$3$2, view$3$2, subscriptions$3$2, maxConcurrentTasks$3$2, evidence$1$3$2, dispatcher$2$2, queue$1$2, initialCmd$1$2, model$2) => ((vnode) => {
              var vnode$1 = $as_Lcats_effect_kernel_Ref(vnode);
              var target$4 = evidence$1$3$2.delay__F0__O(new $c_sjsr_AnonFunction0(((update$4$2, view$4$2, subscriptions$4$2, evidence$1$4$2, dispatcher$3$2, queue$2$2, initialCmd$2$2, model$1$2, vnode$2) => (() => new $c_Ltyrian_runtime_TyrianRuntime(initialCmd$2$2, update$4$2, view$4$2, subscriptions$4$2, model$1$2, vnode$2, new $c_sjsr_AnonFunction0(((queue$3$2) => (() => queue$3$2))(queue$2$2)), new $c_sjsr_AnonFunction0(((dispatcher$4$2) => (() => dispatcher$4$2))(dispatcher$3$2)), evidence$1$4$2)))(update$3$2, view$3$2, subscriptions$3$2, evidence$1$3$2, dispatcher$2$2, queue$1$2, initialCmd$1$2, model$2, vnode$1)));
              var this$28 = new $c_Lcats_Functor$$anon$4(target$4, evidence$1$3$2);
              var f$1 = new $c_sjsr_AnonFunction1(((maxConcurrentTasks$4$2, evidence$1$4$3, queue$2$3) => ((runtime) => {
                var runtime$1 = $as_Ltyrian_runtime_TyrianRuntime(runtime);
                var this$23 = $m_Lfs2_Stream$().emit__O__Lfs2_Stream(runtime$1).concurrently__Lfs2_Stream__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream($m_Lfs2_Stream$().fromQueueUnterminated__Lcats_effect_std_QueueSource__I__Lcats_Functor__Lfs2_Stream(queue$2$3, ($m_Lfs2_Stream$(), 2147483647), evidence$1$4$3).parEvalMap__I__F1__Lcats_effect_kernel_GenConcurrent__Lfs2_Stream(maxConcurrentTasks$4$2, new $c_sjsr_AnonFunction1(((x) => x)), evidence$1$4$3), evidence$1$4$3);
                $m_Lfs2_Compiler$();
                var F = new $c_Lfs2_Compiler$Target$ConcurrentTarget(evidence$1$4$3);
                var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F);
                var this$26 = new $c_Lfs2_Stream$CompileOps(this$23.Lfs2_Stream__f_underlying, compiler);
                $m_Lfs2_Compiler$();
                var evidence$1$1 = new $c_Lfs2_Compiler$Target$ConcurrentTarget(evidence$1$4$3);
                var compiler$1 = new $c_Lfs2_CompilerLowPriority2$$anon$1(evidence$1$1);
                return $as_Lcats_effect_kernel_Resource(new $c_Lfs2_Stream$CompileOps(this$26.Lfs2_Stream$CompileOps__f_underlying, compiler$1).lastOrError__Lcats_MonadError__O(new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1(evidence$1$4$3)))
              }))(maxConcurrentTasks$3$2, evidence$1$3$2, queue$1$2));
              return this$28.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$28.Lcats_Functor$$anon$4__f_self, f$1)
            }))(update$2$2, view$2$2, subscriptions$2$2, maxConcurrentTasks$2$2, evidence$1$2$2, dispatcher$1$2, queue$2$1, initialCmd$2$1, model$1));
            return this$29.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$29.Lcats_FlatMap$$anon$2__f_self, f$2)
          }))(node$1$2, update$1$2, view$1$2, subscriptions$1$2, maxConcurrentTasks$1$2, evidence$1$1$2, dispatcher$2, queue$2, initialCmd$1));
          return this$30.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$30.Lcats_FlatMap$$anon$2__f_self, f$3)
        }
      };
      throw new $c_s_MatchError(x$1$1)
    }))(node$2, update$2, view$2, subscriptions$2, maxConcurrentTasks$2, evidence$1$2, dispatcher$1));
    return this$31.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$31.Lcats_FlatMap$$anon$2__f_self, f$4)
  }))(node, init, update, view, subscriptions, maxConcurrentTasks, evidence$1)));
  new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1(evidence$1);
  var F$1 = new $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1(evidence$1);
  return $as_Lcats_effect_kernel_Resource($f_Lcats_FlatMap__flatten__O__O(F$1, ffa))
});
var $d_Ltyrian_Tyrian$ = new $TypeData().initClass({
  Ltyrian_Tyrian$: 0
}, false, "tyrian.Tyrian$", {
  Ltyrian_Tyrian$: 1,
  O: 1
});
$c_Ltyrian_Tyrian$.prototype.$classData = $d_Ltyrian_Tyrian$;
var $n_Ltyrian_Tyrian$;
function $m_Ltyrian_Tyrian$() {
  if ((!$n_Ltyrian_Tyrian$)) {
    $n_Ltyrian_Tyrian$ = new $c_Ltyrian_Tyrian$()
  };
  return $n_Ltyrian_Tyrian$
}
function $f_Ltyrian_TyrianAppF__launch__T__V($thiz, containerId) {
  var this$1 = $m_s_Predef$().s_Predef$__f_Map;
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  var flags = this$1.from__sc_IterableOnce__sci_Map(elems);
  $f_Ltyrian_TyrianAppF__ready__T__sci_Map__V($thiz, containerId, flags)
}
function $f_Ltyrian_TyrianAppF__launch__T__sjs_js_Dictionary__V($thiz, containerId, flags) {
  var this$3 = new $c_sjs_js_WrappedDictionary(flags);
  $m_s_$less$colon$less$();
  var flags$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  $f_Ltyrian_TyrianAppF__ready__T__sci_Map__V($thiz, containerId, flags$1)
}
function $f_Ltyrian_TyrianAppF__ready__T__sci_Map__V($thiz, parentElementId, flags) {
  $thiz.Lnet_andimiller_ProbabilisticPlayground$__f_run.apply__O__O($m_Ltyrian_Tyrian$().start__Lorg_scalajs_dom_Element__T2__F1__F1__F1__I__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(document.getElementById(parentElementId), $thiz.init__sci_Map__T2(flags), new $c_sjsr_AnonFunction1(((this$1) => ((model) => this$1.update__Lnet_andimiller_Model__F1($as_Lnet_andimiller_Model(model))))($thiz)), new $c_sjsr_AnonFunction1(((this$2) => ((model$2) => this$2.view__Lnet_andimiller_Model__Ltyrian_Html($as_Lnet_andimiller_Model(model$2))))($thiz)), new $c_sjsr_AnonFunction1(((model$3) => {
    $as_Lnet_andimiller_Model(model$3);
    return $m_Ltyrian_Sub$None$()
  })), 1024, $thiz.Lnet_andimiller_ProbabilisticPlayground$__f_tyrian$TyrianAppF$$evidence$1))
}
function $p_Ltyrian_runtime_CmdHelper$__rec$1__Lcats_effect_kernel_GenConcurrent__sci_List__sci_List__sci_List($thiz, evidence$1$1, remaining, acc) {
  var acc$tailLocal1 = acc;
  var remaining$tailLocal1 = remaining;
  while (true) {
    var x19 = remaining$tailLocal1;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x19 === null) : x.equals__O__Z(x19))) {
      return acc$tailLocal1.reverse__sci_List()
    };
    if ((x19 instanceof $c_sci_$colon$colon)) {
      var x20 = $as_sci_$colon$colon(x19);
      var x22 = x20.sci_$colon$colon__f_next;
      var cmd = $as_Ltyrian_Cmd(x20.sci_$colon$colon__f_head);
      var x$3 = $m_Ltyrian_Cmd$None$();
      if ((x$3 === cmd)) {
        remaining$tailLocal1 = x22;
        continue
      };
      if ((cmd instanceof $c_Ltyrian_Cmd$Emit)) {
        var x$1 = $as_Ltyrian_Cmd$Emit(cmd);
        var x18 = x$1.Ltyrian_Cmd$Emit__f_msg;
        var elem$1 = ($m_Lcats_effect_kernel_package$(), $m_s_DummyImplicit$(), evidence$1$1).pure__O__O($m_s_Option$().apply__O__s_Option(x18));
        var this$3 = acc$tailLocal1;
        var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(elem$1, this$3);
        remaining$tailLocal1 = x22;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue
      };
      if ((cmd instanceof $c_Ltyrian_Cmd$SideEffect)) {
        var x$1$1 = $as_Ltyrian_Cmd$SideEffect(cmd);
        var x15 = x$1$1.Ltyrian_Cmd$SideEffect__f_task;
        var elem$2 = ($m_Lcats_effect_kernel_package$(), $m_s_DummyImplicit$(), evidence$1$1).map__O__F1__O(x15, new $c_sjsr_AnonFunction1(((_$2) => {
          $as_jl_Void(_$2);
          return $m_s_None$()
        })));
        var this$8 = acc$tailLocal1;
        var acc$tailLocal1$tmp2 = new $c_sci_$colon$colon(elem$2, this$8);
        remaining$tailLocal1 = x22;
        acc$tailLocal1 = acc$tailLocal1$tmp2;
        continue
      };
      if (false) {
        var x$1$2 = $as_Ltyrian_Cmd$Run(cmd);
        var x11 = x$1$2._1__O();
        var x12 = x$1$2._2__F1();
        var elem$3 = ($m_Lcats_effect_kernel_package$(), $m_s_DummyImplicit$(), evidence$1$1).map__O__F1__O(x11, new $c_sjsr_AnonFunction1(((f$2) => ((p) => $m_s_Option$().apply__O__s_Option(f$2.apply__O__O(p))))(x12)));
        var this$11 = acc$tailLocal1;
        var acc$tailLocal1$tmp3 = new $c_sci_$colon$colon(elem$3, this$11);
        remaining$tailLocal1 = x22;
        acc$tailLocal1 = acc$tailLocal1$tmp3;
        continue
      };
      if ((cmd instanceof $c_Ltyrian_Cmd$Combine)) {
        var x$1$3 = $as_Ltyrian_Cmd$Combine(cmd);
        var x7 = x$1$3.Ltyrian_Cmd$Combine__f_cmd1;
        var x8 = x$1$3.Ltyrian_Cmd$Combine__f_cmd2;
        var this$13 = new $c_sci_$colon$colon(x8, x22);
        remaining$tailLocal1 = new $c_sci_$colon$colon(x7, this$13);
        continue
      };
      if ((cmd instanceof $c_Ltyrian_Cmd$Batch)) {
        var x$1$4 = $as_Ltyrian_Cmd$Batch(cmd);
        var x4 = x$1$4.Ltyrian_Cmd$Batch__f_cmds;
        remaining$tailLocal1 = x4.appendedAll__sc_IterableOnce__sci_List(x22);
        continue
      };
      throw new $c_s_MatchError(cmd)
    };
    throw new $c_s_MatchError(x19)
  }
}
/** @constructor */
function $c_Ltyrian_runtime_CmdHelper$() {
  /*<skip>*/
}
$c_Ltyrian_runtime_CmdHelper$.prototype = new $h_O();
$c_Ltyrian_runtime_CmdHelper$.prototype.constructor = $c_Ltyrian_runtime_CmdHelper$;
/** @constructor */
function $h_Ltyrian_runtime_CmdHelper$() {
  /*<skip>*/
}
$h_Ltyrian_runtime_CmdHelper$.prototype = $c_Ltyrian_runtime_CmdHelper$.prototype;
$c_Ltyrian_runtime_CmdHelper$.prototype.cmdToTaskList__Ltyrian_Cmd__Lcats_effect_kernel_GenConcurrent__sci_List = (function(cmd, evidence$1) {
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([cmd]));
  return $p_Ltyrian_runtime_CmdHelper$__rec$1__Lcats_effect_kernel_GenConcurrent__sci_List__sci_List__sci_List(this, evidence$1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), $m_s_package$().s_package$__f_Nil)
});
var $d_Ltyrian_runtime_CmdHelper$ = new $TypeData().initClass({
  Ltyrian_runtime_CmdHelper$: 0
}, false, "tyrian.runtime.CmdHelper$", {
  Ltyrian_runtime_CmdHelper$: 1,
  O: 1
});
$c_Ltyrian_runtime_CmdHelper$.prototype.$classData = $d_Ltyrian_runtime_CmdHelper$;
var $n_Ltyrian_runtime_CmdHelper$;
function $m_Ltyrian_runtime_CmdHelper$() {
  if ((!$n_Ltyrian_runtime_CmdHelper$)) {
    $n_Ltyrian_runtime_CmdHelper$ = new $c_Ltyrian_runtime_CmdHelper$()
  };
  return $n_Ltyrian_runtime_CmdHelper$
}
/** @constructor */
function $c_Ltyrian_runtime_ModelHolder(model, updated) {
  this.Ltyrian_runtime_ModelHolder__f_model = null;
  this.Ltyrian_runtime_ModelHolder__f_updated = false;
  this.Ltyrian_runtime_ModelHolder__f_model = model;
  this.Ltyrian_runtime_ModelHolder__f_updated = updated
}
$c_Ltyrian_runtime_ModelHolder.prototype = new $h_O();
$c_Ltyrian_runtime_ModelHolder.prototype.constructor = $c_Ltyrian_runtime_ModelHolder;
/** @constructor */
function $h_Ltyrian_runtime_ModelHolder() {
  /*<skip>*/
}
$h_Ltyrian_runtime_ModelHolder.prototype = $c_Ltyrian_runtime_ModelHolder.prototype;
function $as_Ltyrian_runtime_ModelHolder(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_ModelHolder) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.ModelHolder"))
}
function $isArrayOf_Ltyrian_runtime_ModelHolder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_ModelHolder)))
}
function $asArrayOf_Ltyrian_runtime_ModelHolder(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_ModelHolder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.ModelHolder;", depth))
}
var $d_Ltyrian_runtime_ModelHolder = new $TypeData().initClass({
  Ltyrian_runtime_ModelHolder: 0
}, false, "tyrian.runtime.ModelHolder", {
  Ltyrian_runtime_ModelHolder: 1,
  O: 1
});
$c_Ltyrian_runtime_ModelHolder.prototype.$classData = $d_Ltyrian_runtime_ModelHolder;
function $p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch($thiz) {
  if ((!$thiz.Ltyrian_runtime_Rendering$__f_patchbitmap$1)) {
    $thiz.Ltyrian_runtime_Rendering$__f_patch$lzy1 = $m_Lsnabbdom_init$().apply__sci_Seq__s_Option__Lsnabbdom_Patch($as_sci_Seq($m_s_package$().s_package$__f_Seq.apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsnabbdom_Module.getArrayOf().constr)([$m_Lsnabbdom_modules_Attributes$().Lsnabbdom_modules_Attributes$__f_module, $m_Lsnabbdom_modules_Classes$().Lsnabbdom_modules_Classes$__f_module, $m_Lsnabbdom_modules_Props$().Lsnabbdom_modules_Props$__f_module, $m_Lsnabbdom_modules_Styles$().Lsnabbdom_modules_Styles$__f_module, $m_Lsnabbdom_modules_EventListeners$().Lsnabbdom_modules_EventListeners$__f_module, $m_Lsnabbdom_modules_Dataset$().Lsnabbdom_modules_Dataset$__f_module])))), ($m_Lsnabbdom_init$(), $m_s_None$()));
    $thiz.Ltyrian_runtime_Rendering$__f_patchbitmap$1 = true
  };
  return $thiz.Ltyrian_runtime_Rendering$__f_patch$lzy1
}
/** @constructor */
function $c_Ltyrian_runtime_Rendering$() {
  this.Ltyrian_runtime_Rendering$__f_patch$lzy1 = null;
  this.Ltyrian_runtime_Rendering$__f_patchbitmap$1 = false
}
$c_Ltyrian_runtime_Rendering$.prototype = new $h_O();
$c_Ltyrian_runtime_Rendering$.prototype.constructor = $c_Ltyrian_runtime_Rendering$;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$() {
  /*<skip>*/
}
$h_Ltyrian_runtime_Rendering$.prototype = $c_Ltyrian_runtime_Rendering$.prototype;
$c_Ltyrian_runtime_Rendering$.prototype.toVNode__Ltyrian_Html__F1__Lsnabbdom_VNode = (function(html, onMsg) {
  if ((html instanceof $c_Ltyrian_Tag)) {
    var x$1 = $as_Ltyrian_Tag(html);
    var x43 = x$1.Ltyrian_Tag__f_name;
    var x44 = x$1.Ltyrian_Tag__f_attributes;
    var x45 = x$1.Ltyrian_Tag__f_children;
    var as = x44.collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$1());
    var props = x44.collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$2());
    var events = x44.collect__s_PartialFunction__sci_List(new $c_Ltyrian_runtime_Rendering$$anon$3(onMsg));
    $m_s_$less$colon$less$();
    var props$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(props);
    $m_s_$less$colon$less$();
    var attrs$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(as);
    $m_s_$less$colon$less$();
    var on$1 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(events);
    var this$5 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var classes$1 = this$5.Lsnabbdom_VNodeData__f_classes;
    var this$6 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var style$1 = this$6.Lsnabbdom_VNodeData__f_style;
    var this$7 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var dataset$1 = this$7.Lsnabbdom_VNodeData__f_dataset;
    var this$8 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var hook$1 = this$8.Lsnabbdom_VNodeData__f_hook;
    var this$9 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var key$1 = this$9.Lsnabbdom_VNodeData__f_key;
    var this$10 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var ns$1 = this$10.Lsnabbdom_VNodeData__f_ns;
    var this$11 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var fn$1 = this$11.Lsnabbdom_VNodeData__f_fn;
    var this$12 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var args$1 = this$12.Lsnabbdom_VNodeData__f_args;
    var this$13 = $m_Lsnabbdom_VNodeData$().Lsnabbdom_VNodeData$__f_empty;
    var is$1 = this$13.Lsnabbdom_VNodeData__f_is;
    $m_Lsnabbdom_VNodeData$();
    var data = new $c_Lsnabbdom_VNodeData(props$1, attrs$1, classes$1, style$1, dataset$1, on$1, hook$1, key$1, ns$1, fn$1, args$1, is$1);
    if ((x45.knownSize__I() >= 0)) {
      var len = x45.knownSize__I();
      var destination = new ($d_Ltyrian_Elem.getArrayOf().constr)(len);
      $f_sc_IterableOnceOps__copyToArray__O__I__I__I(x45, destination, 0, 2147483647);
      var xs = destination
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = x45.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var elem = it.next__O();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem)
      };
      var xs = new ($d_Ltyrian_Elem.getArrayOf().constr)(jsElems)
    };
    var f = ((this$19, onMsg$2) => ((x$1$1) => {
      var x$1$2 = $as_Ltyrian_Elem(x$1$1);
      if ((x$1$2 instanceof $c_Ltyrian_Text)) {
        var t = $as_Ltyrian_Text(x$1$2);
        return $m_Lsnabbdom_VNode$().text__T__Lsnabbdom_VNode(t.Ltyrian_Text__f_value)
      };
      if ($is_Ltyrian_Html(x$1$2)) {
        var subHtml = $as_Ltyrian_Html(x$1$2);
        return this$19.toVNode__Ltyrian_Html__F1__Lsnabbdom_VNode(subHtml, onMsg$2)
      };
      throw new $c_s_MatchError(x$1$2)
    }))(this, onMsg);
    var len$1 = xs.u.length;
    var ys = new ($d_Lsnabbdom_VNode.getArrayOf().constr)(len$1);
    if ((len$1 > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len$1)) {
          var $$x1 = i;
          var arg1 = xs.get(i);
          ys.set($$x1, f(arg1));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_I)) {
        var x3 = $asArrayOf_I(xs, 1);
        while ((i < len$1)) {
          var $$x2 = i;
          var arg1$1 = x3.get(i);
          ys.set($$x2, f(arg1$1));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_D)) {
        var x4 = $asArrayOf_D(xs, 1);
        while ((i < len$1)) {
          var $$x3 = i;
          var arg1$2 = x4.get(i);
          ys.set($$x3, f(arg1$2));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_J)) {
        var x5 = $asArrayOf_J(xs, 1);
        while ((i < len$1)) {
          var $$x4 = i;
          var t$1 = x5.get(i);
          var lo = t$1.RTLong__f_lo;
          var hi = t$1.RTLong__f_hi;
          ys.set($$x4, f(new $c_RTLong(lo, hi)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_F)) {
        var x6 = $asArrayOf_F(xs, 1);
        while ((i < len$1)) {
          var $$x5 = i;
          var arg1$3 = x6.get(i);
          ys.set($$x5, f(arg1$3));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_C)) {
        var x7 = $asArrayOf_C(xs, 1);
        while ((i < len$1)) {
          var $$x6 = i;
          var arg1$4 = x7.get(i);
          ys.set($$x6, f($bC(arg1$4)));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_B)) {
        var x8 = $asArrayOf_B(xs, 1);
        while ((i < len$1)) {
          var $$x7 = i;
          var arg1$5 = x8.get(i);
          ys.set($$x7, f(arg1$5));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_S)) {
        var x9 = $asArrayOf_S(xs, 1);
        while ((i < len$1)) {
          var $$x8 = i;
          var arg1$6 = x9.get(i);
          ys.set($$x8, f(arg1$6));
          i = ((1 + i) | 0)
        }
      } else if ((xs instanceof $ac_Z)) {
        var x10 = $asArrayOf_Z(xs, 1);
        while ((i < len$1)) {
          var $$x9 = i;
          var arg1$7 = x10.get(i);
          ys.set($$x9, f(arg1$7));
          i = ((1 + i) | 0)
        }
      } else {
        throw new $c_s_MatchError(xs)
      }
    };
    return $m_Lsnabbdom_h$().apply__T__Lsnabbdom_VNodeData__ALsnabbdom_VNode__Lsnabbdom_VNode(x43, data, ys)
  };
  throw new $c_s_MatchError(html)
});
$c_Ltyrian_runtime_Rendering$.prototype.render__O__O__F1__F1__Lsnabbdom_VNode = (function(oldNode, model, view, onMsg) {
  if ($uZ((oldNode instanceof Element))) {
    return $p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch(this).apply__Lorg_scalajs_dom_Element__Lsnabbdom_VNode__Lsnabbdom_VNode(oldNode, $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__Lsnabbdom_VNode($as_Ltyrian_Html(view.apply__O__O(model)), onMsg))
  };
  if ((oldNode instanceof $c_Lsnabbdom_VNode)) {
    var vn = $as_Lsnabbdom_VNode(oldNode);
    return $p_Ltyrian_runtime_Rendering$__patch__Lsnabbdom_Patch(this).apply__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode(vn, $m_Ltyrian_runtime_Rendering$().toVNode__Ltyrian_Html__F1__Lsnabbdom_VNode($as_Ltyrian_Html(view.apply__O__O(model)), onMsg))
  };
  throw new $c_s_MatchError(oldNode)
});
var $d_Ltyrian_runtime_Rendering$ = new $TypeData().initClass({
  Ltyrian_runtime_Rendering$: 0
}, false, "tyrian.runtime.Rendering$", {
  Ltyrian_runtime_Rendering$: 1,
  O: 1
});
$c_Ltyrian_runtime_Rendering$.prototype.$classData = $d_Ltyrian_runtime_Rendering$;
var $n_Ltyrian_runtime_Rendering$;
function $m_Ltyrian_runtime_Rendering$() {
  if ((!$n_Ltyrian_runtime_Rendering$)) {
    $n_Ltyrian_runtime_Rendering$ = new $c_Ltyrian_runtime_Rendering$()
  };
  return $n_Ltyrian_runtime_Rendering$
}
function $p_Ltyrian_runtime_SubHelper$__rec$1__sci_List__sci_List__sci_List($thiz, remaining, acc) {
  var acc$tailLocal1 = acc;
  var remaining$tailLocal1 = remaining;
  while (true) {
    var x1 = remaining$tailLocal1;
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x1 === null) : x.equals__O__Z(x1))) {
      return acc$tailLocal1
    };
    if ((x1 instanceof $c_sci_$colon$colon)) {
      var x19 = $as_sci_$colon$colon(x1);
      var x20 = $as_Ltyrian_Sub(x19.sci_$colon$colon__f_head);
      var x21 = x19.sci_$colon$colon__f_next;
      var x$3 = $m_Ltyrian_Sub$None$();
      if ((x$3 === x20)) {
        remaining$tailLocal1 = x21;
        continue
      };
      if (false) {
        var x$1 = $as_Ltyrian_Sub$Combine(x20);
        var x17 = x$1._1__Ltyrian_Sub();
        var x18 = x$1._2__Ltyrian_Sub();
        var this$2 = new $c_sci_$colon$colon(x18, x21);
        remaining$tailLocal1 = new $c_sci_$colon$colon(x17, this$2);
        continue
      };
      if (false) {
        var x$1$1 = $as_Ltyrian_Sub$Batch(x20);
        var x11 = x$1$1._1__sci_List();
        remaining$tailLocal1 = x11.appendedAll__sc_IterableOnce__sci_List(x21);
        continue
      };
      if (false) {
        var s = $as_Ltyrian_Sub$Observe(x20);
        var this$4 = acc$tailLocal1;
        var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(s, this$4);
        remaining$tailLocal1 = x21;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue
      }
    };
    throw new $c_s_MatchError(x1)
  }
}
/** @constructor */
function $c_Ltyrian_runtime_SubHelper$() {
  /*<skip>*/
}
$c_Ltyrian_runtime_SubHelper$.prototype = new $h_O();
$c_Ltyrian_runtime_SubHelper$.prototype.constructor = $c_Ltyrian_runtime_SubHelper$;
/** @constructor */
function $h_Ltyrian_runtime_SubHelper$() {
  /*<skip>*/
}
$h_Ltyrian_runtime_SubHelper$.prototype = $c_Ltyrian_runtime_SubHelper$.prototype;
$c_Ltyrian_runtime_SubHelper$.prototype.flatten__Ltyrian_Sub__Lcats_effect_kernel_GenConcurrent__sci_List = (function(sub, evidence$1) {
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Sub.getArrayOf().constr)([sub]));
  return $p_Ltyrian_runtime_SubHelper$__rec$1__sci_List__sci_List__sci_List(this, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems), $m_s_package$().s_package$__f_Nil)
});
$c_Ltyrian_runtime_SubHelper$.prototype.aliveAndDead__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__T2 = (function(subs, current, evidence$2) {
  matchResult3: {
    var \u03b41$___1;
    var \u03b41$___2;
    if (current.isEmpty__Z()) {
      var x25 = $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil
    } else {
      $m_sci_List$();
      var l = new $c_scm_ListBuffer();
      $m_sci_List$();
      var r = new $c_scm_ListBuffer();
      var this$3 = current.iterator__sc_Iterator();
      while (this$3.hasNext__Z()) {
        var arg1 = this$3.next__O();
        var x$1 = $as_T2(arg1);
        matchResult2: {
          var $$x1;
          if ((x$1 !== null)) {
            var id = $as_T(x$1._1__O());
            var these = subs;
            while ((!these.isEmpty__Z())) {
              var arg1$1 = these.head__O();
              var _$3 = $as_Ltyrian_Sub$Observe(arg1$1);
              if ((_$3.id__T() === id)) {
                var $$x1 = true;
                break matchResult2
              };
              these = $as_sci_List(these.tail__O())
            };
            var $$x1 = false;
            break matchResult2
          };
          throw new $c_s_MatchError(x$1)
        };
        if ($$x1) {
          var this$4 = l
        } else {
          var this$4 = r
        };
        this$4.addOne__O__scm_ListBuffer(arg1)
      };
      var x1 = new $c_T2(l.toList__sci_List(), r.toList__sci_List());
      matchEnd7$1: {
        var x25;
        var p2 = $as_sci_List(x1.T2__f__1);
        var x = $m_sci_Nil$();
        if (x.equals__O__Z(p2)) {
          var x25 = new $c_T2($m_sci_Nil$(), current);
          break matchEnd7$1
        };
        var p4 = $as_sci_List(x1.T2__f__2);
        var x$3 = $m_sci_Nil$();
        if (x$3.equals__O__Z(p4)) {
          var x25 = new $c_T2(current, $m_sci_Nil$());
          break matchEnd7$1
        };
        var x25 = x1
      }
    };
    if ((x25 !== null)) {
      var a = $as_sci_List(x25._1__O());
      var d = $as_sci_List(x25._2__O());
      var \u03b41$___1 = a;
      var \u03b41$___2 = d;
      break matchResult3
    };
    throw new $c_s_MatchError(x25)
  };
  var a$2 = $as_sci_List(\u03b41$___1);
  var d$2 = $as_sci_List(\u03b41$___2);
  var f = ((_$4) => {
    var _$4$1 = $as_T2(_$4);
    return _$4$1._2__O()
  });
  if ((d$2 === $m_sci_Nil$())) {
    var _2 = $m_sci_Nil$()
  } else {
    var arg1$2 = d$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1$2), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(d$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$3 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$3), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var _2 = h
  };
  return new $c_T2(a$2, _2)
});
$c_Ltyrian_runtime_SubHelper$.prototype.findNewSubs__sci_List__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__sci_List = (function(subs, alive, inProgress, evidence$3) {
  var f = ((alive$2, inProgress$2) => ((s) => {
    var s$1 = $as_Ltyrian_Sub$Observe(s);
    _return: {
      var these = alive$2;
      while ((!these.isEmpty__Z())) {
        var arg1 = these.head__O();
        var _$6 = $as_T(arg1);
        if ((!(_$6 !== s$1.id__T()))) {
          var $$x1 = false;
          break _return
        };
        these = $as_sci_List(these.tail__O())
      };
      var $$x1 = true
    };
    if ($$x1) {
      return (!inProgress$2.contains__O__Z(s$1.id__T()))
    } else {
      return false
    }
  }))(alive, inProgress);
  var l = subs;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = l.head__O();
        var t = $as_sci_List(l.tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue
        };
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = remaining.head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List(remaining.tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List(start.tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List(toProcess.tail__O())
            };
            var next = $as_sci_List(firstMiss.tail__O());
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List(next.tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List(nextToCopy.tail__O())
                };
                nextToCopy = $as_sci_List(next.tail__O());
                next = $as_sci_List(next.tail__O())
              }
            };
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  return result
});
$c_Ltyrian_runtime_SubHelper$.prototype.toRun__sci_List__F1__Lcats_effect_kernel_GenConcurrent__sci_List = (function(newSubs, callback, evidence$4) {
  var f$2 = ((callback$2, evidence$4$2) => ((x$1) => {
    var x$1$1 = $as_Ltyrian_Sub$Observe(x$1);
    if ((x$1$1 !== null)) {
      var x39 = x$1$1._1__T();
      var x40 = x$1$1._2__O();
      var x41 = x$1$1._3__F1();
      var this$9 = new $c_Lcats_FlatMap$$anon$2(x40, evidence$4$2);
      var f$1 = new $c_sjsr_AnonFunction1(((callback$1$2, evidence$4$1$2, id$2, toMsg$2) => ((run) => {
        var run$1 = $as_F1(run);
        var cancelable = run$1.apply__O__O(new $c_sjsr_AnonFunction1(((callback$2$2, toMsg$1$2) => ((x$1$2) => {
          var x$1$3 = $as_s_util_Either(x$1$2);
          matchResult5: {
            if ((x$1$3 instanceof $c_s_util_Left)) {
              var e = $as_jl_Throwable($as_s_util_Left(x$1$3).s_util_Left__f_value);
              throw e
            };
            if ((x$1$3 instanceof $c_s_util_Right)) {
              var m = $as_s_util_Right(x$1$3).s_util_Right__f_value;
              matchResult4: {
                var x28 = $as_s_Option(toMsg$1$2.apply__O__O(m));
                if ((x28 instanceof $c_s_Some)) {
                  var msg = $as_s_Some(x28).s_Some__f_value;
                  callback$2$2.apply__O__O(msg);
                  break matchResult4
                }
              };
              break matchResult5
            };
            throw new $c_s_MatchError(x$1$3)
          }
        }))(callback$1$2, toMsg$2)));
        var this$8 = new $c_Lcats_Functor$$anon$4(cancelable, evidence$4$1$2);
        var f = new $c_sjsr_AnonFunction1(((evidence$4$2$2, id$2$2) => ((_$8) => {
          var _$8$1 = $as_s_Option(_$8);
          if (_$8$1.isEmpty__Z()) {
            return $m_s_None$()
          } else {
            var arg1 = _$8$1.get__O();
            return new $c_s_Some(new $c_Ltyrian_runtime_SubHelper$CancelableSub(id$2$2, arg1, evidence$4$2$2))
          }
        }))(evidence$4$1$2, id$2));
        var cancel = this$8.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$$anon$4__f_self, f);
        return cancel
      }))(callback$2, evidence$4$2, x39, x41));
      return this$9.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$$anon$2__f_self, f$1)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(callback, evidence$4);
  if ((newSubs === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var arg1$1 = newSubs.head__O();
    var h = new $c_sci_$colon$colon(f$2(arg1$1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(newSubs.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$2 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$2(arg1$2), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    return h
  }
});
var $d_Ltyrian_runtime_SubHelper$ = new $TypeData().initClass({
  Ltyrian_runtime_SubHelper$: 0
}, false, "tyrian.runtime.SubHelper$", {
  Ltyrian_runtime_SubHelper$: 1,
  O: 1
});
$c_Ltyrian_runtime_SubHelper$.prototype.$classData = $d_Ltyrian_runtime_SubHelper$;
var $n_Ltyrian_runtime_SubHelper$;
function $m_Ltyrian_runtime_SubHelper$() {
  if ((!$n_Ltyrian_runtime_SubHelper$)) {
    $n_Ltyrian_runtime_SubHelper$ = new $c_Ltyrian_runtime_SubHelper$()
  };
  return $n_Ltyrian_runtime_SubHelper$
}
function $p_Ltyrian_runtime_TyrianRuntime__onMsg__O__V($thiz, msg) {
  var target = $thiz.Ltyrian_runtime_TyrianRuntime__f_model.get__O();
  var tc = $thiz.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
  var this$5 = new $c_Lcats_Functor$$anon$4(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2, msg$2) => ((currentModel) => {
    var currentModel$1 = $as_Ltyrian_runtime_ModelHolder(currentModel);
    matchResult1: {
      var \u03b42$___1;
      var \u03b42$___2;
      var \u03b42$___3;
      var x1 = $as_T2($as_F1(this$2.Ltyrian_runtime_TyrianRuntime__f_update.apply__O__O(currentModel$1.Ltyrian_runtime_ModelHolder__f_model)).apply__O__O(msg$2));
      if ((x1 !== null)) {
        var updatedState = x1._1__O();
        var cmd = $as_Ltyrian_Cmd(x1._2__O());
        var \u03b42$___1 = x1;
        var \u03b42$___2 = updatedState;
        var \u03b42$___3 = cmd;
        break matchResult1
      };
      throw new $c_s_MatchError(x1)
    };
    var \u03b41$$2 = $as_T2(\u03b42$___1);
    $as_Ltyrian_Cmd(\u03b42$___3);
    return new $c_T2(currentModel$1, \u03b41$$2)
  }))($thiz, msg));
  var target$1 = this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f);
  var tc$1 = $thiz.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
  var this$9 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
  var f$2 = new $c_sjsr_AnonFunction1(((this$2$1) => ((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var x7 = $as_T2(x$1$1._2__O());
      $as_Ltyrian_runtime_ModelHolder(x$1$1._1__O());
      if ((x7 !== null)) {
        var updatedState$1 = x7._1__O();
        var cmd$1 = $as_Ltyrian_Cmd(x7._2__O());
        var target$2 = $p_Ltyrian_runtime_TyrianRuntime__completeUpdate__Ltyrian_Cmd__O__O(this$2$1, cmd$1, updatedState$1);
        var tc$2 = this$2$1.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
        var this$8 = new $c_Lcats_Functor$$anon$4(target$2, tc$2);
        var f$1 = new $c_sjsr_AnonFunction1(((x$1$2) => {
          $as_jl_Void(x$1$2)
        }));
        return this$8.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$$anon$4__f_self, f$1)
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz));
  var res = this$9.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$$anon$2__f_self, f$2);
  var this$10 = $as_Lcats_effect_std_Dispatcher($thiz.Ltyrian_runtime_TyrianRuntime__f_dispatcher.apply__O());
  this$10.unsafeToFutureCancelable__O__T2(res)
}
function $p_Ltyrian_runtime_TyrianRuntime__completeUpdate__Ltyrian_Cmd__O__O($thiz, cmd, updatedState) {
  var target = $thiz.Ltyrian_runtime_TyrianRuntime__f_model.set__O__O(new $c_Ltyrian_runtime_ModelHolder(updatedState, true));
  var tc = $thiz.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
  var this$11 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$2 = new $c_sjsr_AnonFunction1(((this$2, cmd$2, updatedState$2) => ((x$1) => {
    $as_jl_Void(x$1);
    var target$1 = $p_Ltyrian_runtime_TyrianRuntime__gatherSideEffects__Ltyrian_Cmd__Ltyrian_Sub__O(this$2, cmd$2, $as_Ltyrian_Sub(this$2.Ltyrian_runtime_TyrianRuntime__f_subscriptions.apply__O__O(updatedState$2)));
    var tc$1 = this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
    var this$10 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
    var f$1 = new $c_sjsr_AnonFunction1(((this$4) => ((sideEffects) => {
      var sideEffects$1 = $as_sci_List(sideEffects);
      var $$x1 = $m_Lfs2_Stream$().emits__sc_Seq__Lfs2_Stream(sideEffects$1);
      var \u03b43$ = $as_Lcats_effect_std_Queue(this$4.Ltyrian_runtime_TyrianRuntime__f_queue.apply__O());
      var this$7 = $$x1.foreach__F1__Lfs2_Stream(new $c_sjsr_AnonFunction1(((\u03b43$$2) => ((a) => \u03b43$$2.offer__O__O(a)))(\u03b43$)));
      $m_Lfs2_Compiler$();
      var evidence$2 = this$4.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      var F = new $c_Lfs2_Compiler$Target$ConcurrentTarget(evidence$2);
      var compiler = new $c_Lfs2_CompilerLowPriority1$$anon$2(F);
      var target$2 = new $c_Lfs2_Stream$CompileOps(this$7.Lfs2_Stream__f_underlying, compiler).drain__O();
      var tc$2 = this$4.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      var this$9 = new $c_Lcats_Functor$$anon$4(target$2, tc$2);
      var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
        $as_jl_Void(x$1$2)
      }));
      return this$9.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$9.Lcats_Functor$$anon$4__f_self, f)
    }))(this$2));
    return this$10.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$$anon$2__f_self, f$1)
  }))($thiz, cmd, updatedState));
  return this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f$2)
}
function $p_Ltyrian_runtime_TyrianRuntime__gatherSideEffects__Ltyrian_Cmd__Ltyrian_Sub__O($thiz, cmd, sub) {
  var F = $thiz.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
  return F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$2, cmd$2, sub$2) => (() => {
    var cmdsToRun = $m_Ltyrian_runtime_CmdHelper$().cmdToTaskList__Ltyrian_Cmd__Lcats_effect_kernel_GenConcurrent__sci_List(cmd$2, this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1);
    var allSubs = $m_Ltyrian_runtime_SubHelper$().flatten__Ltyrian_Sub__Lcats_effect_kernel_GenConcurrent__sci_List(sub$2, this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1);
    matchResult6: {
      var \u03b44$___1;
      var \u03b44$___2;
      var x12 = $m_Ltyrian_runtime_SubHelper$().aliveAndDead__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__T2(allSubs, this$2.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions, this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1);
      if ((x12 !== null)) {
        var stillAlive = $as_sci_List(x12._1__O());
        var discarded = $as_sci_List(x12._2__O());
        var \u03b44$___1 = stillAlive;
        var \u03b44$___2 = discarded;
        break matchResult6
      };
      throw new $c_s_MatchError(x12)
    };
    var stillAlive$2 = $as_sci_List(\u03b44$___1);
    var discarded$2 = $as_sci_List(\u03b44$___2);
    var $$x2 = $m_Ltyrian_runtime_SubHelper$();
    var f = ((_$2) => {
      var _$2$1 = $as_T2(_$2);
      return $as_T(_$2$1._1__O())
    });
    if ((stillAlive$2 === $m_sci_Nil$())) {
      var $$x1 = $m_sci_Nil$()
    } else {
      var arg1 = stillAlive$2.head__O();
      var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
      var t = h;
      var rest = $as_sci_List(stillAlive$2.tail__O());
      while ((rest !== $m_sci_Nil$())) {
        var arg1$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List(rest.tail__O())
      };
      var $$x1 = h
    };
    var this$4 = this$2.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions;
    $m_sci_List$();
    var newSubs = $$x2.findNewSubs__sci_List__sci_List__sci_List__Lcats_effect_kernel_GenConcurrent__sci_List(allSubs, $$x1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4), this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1);
    var this$6 = this$2.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions;
    var f$1 = ((_$3) => {
      var _$3$1 = $as_Ltyrian_Sub$Observe(_$3);
      return _$3$1.id__T()
    });
    if ((newSubs === $m_sci_Nil$())) {
      var that = $m_sci_Nil$()
    } else {
      var arg1$2 = newSubs.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(newSubs.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$3 = rest$1.head__O();
        var nx$1 = new $c_sci_$colon$colon(f$1(arg1$3), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx$1;
        t$1 = nx$1;
        rest$1 = $as_sci_List(rest$1.tail__O())
      };
      var that = h$1
    };
    this$2.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = $as_sci_Set(this$6.concat__sc_IterableOnce__sc_SetOps(that));
    this$2.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = stillAlive$2;
    var this$16 = $m_Ltyrian_runtime_SubHelper$().toRun__sci_List__F1__Lcats_effect_kernel_GenConcurrent__sci_List(newSubs, new $c_sjsr_AnonFunction1(((this$7) => ((msg) => {
      $p_Ltyrian_runtime_TyrianRuntime__onMsg__O__V(this$7, msg)
    }))(this$2)), this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1);
    var f$2 = ((this$2$1) => ((s) => {
      var F$1 = this$2$1.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      return F$1.map__O__F1__O(s, new $c_sjsr_AnonFunction1(((this$9) => ((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var sub$1 = $as_Ltyrian_runtime_SubHelper$CancelableSub($as_s_Some(x$1$1).s_Some__f_value);
          var this$10 = this$9.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions;
          var elem = sub$1.Ltyrian_runtime_SubHelper$CancelableSub__f_id;
          this$9.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = $as_sci_Set(this$10.excl__O__sci_SetOps(elem));
          var self = sub$1.Ltyrian_runtime_SubHelper$CancelableSub__f_id;
          var y = sub$1.Ltyrian_runtime_SubHelper$CancelableSub__f_cancel;
          var elem$1 = new $c_T2(self, y);
          var this$13 = this$9.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions;
          this$9.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = new $c_sci_$colon$colon(elem$1, this$13);
          return $m_s_None$()
        };
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return $m_s_None$()
        };
        throw new $c_s_MatchError(x$1$1)
      }))(this$2$1)))
    }))(this$2);
    if ((this$16 === $m_sci_Nil$())) {
      var subsToRun = $m_sci_Nil$()
    } else {
      var arg1$4 = this$16.head__O();
      var h$2 = new $c_sci_$colon$colon(f$2(arg1$4), $m_sci_Nil$());
      var t$2 = h$2;
      var rest$2 = $as_sci_List(this$16.tail__O());
      while ((rest$2 !== $m_sci_Nil$())) {
        var arg1$5 = rest$2.head__O();
        var nx$2 = new $c_sci_$colon$colon(f$2(arg1$5), $m_sci_Nil$());
        t$2.sci_$colon$colon__f_next = nx$2;
        t$2 = nx$2;
        rest$2 = $as_sci_List(rest$2.tail__O())
      };
      var subsToRun = h$2
    };
    var f$3 = ((this$3$1) => ((d) => {
      var F$2 = this$3$1.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      return F$2.map__O__F1__O(d, new $c_sjsr_AnonFunction1(((_$4) => {
        $as_jl_Void(_$4);
        return $m_s_None$()
      })))
    }))(this$2);
    if ((discarded$2 === $m_sci_Nil$())) {
      var subsToDiscard = $m_sci_Nil$()
    } else {
      var arg1$6 = discarded$2.head__O();
      var h$3 = new $c_sci_$colon$colon(f$3(arg1$6), $m_sci_Nil$());
      var t$3 = h$3;
      var rest$3 = $as_sci_List(discarded$2.tail__O());
      while ((rest$3 !== $m_sci_Nil$())) {
        var arg1$7 = rest$3.head__O();
        var nx$3 = new $c_sci_$colon$colon(f$3(arg1$7), $m_sci_Nil$());
        t$3.sci_$colon$colon__f_next = nx$3;
        t$3 = nx$3;
        rest$3 = $as_sci_List(rest$3.tail__O())
      };
      var subsToDiscard = h$3
    };
    var this$19 = cmdsToRun.appendedAll__sc_IterableOnce__sci_List(subsToRun);
    var this$22 = this$19.appendedAll__sc_IterableOnce__sci_List(subsToDiscard);
    var f$4 = ((this$4$1) => ((task) => {
      var F$3 = this$4$1.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      return F$3.map__O__F1__O(task, new $c_sjsr_AnonFunction1(((this$21) => ((x$1$2) => {
        var x$1$3 = $as_s_Option(x$1$2);
        matchResult8: {
          if ((x$1$3 instanceof $c_s_Some)) {
            var msg$1 = $as_s_Some(x$1$3).s_Some__f_value;
            $p_Ltyrian_runtime_TyrianRuntime__onMsg__O__V(this$21, msg$1);
            break matchResult8
          };
          var x$2 = $m_s_None$();
          if ((x$2 === x$1$3)) {
            break matchResult8
          };
          throw new $c_s_MatchError(x$1$3)
        }
      }))(this$4$1)))
    }))(this$2);
    if ((this$22 === $m_sci_Nil$())) {
      return $m_sci_Nil$()
    } else {
      var arg1$8 = this$22.head__O();
      var h$4 = new $c_sci_$colon$colon(f$4(arg1$8), $m_sci_Nil$());
      var t$4 = h$4;
      var rest$4 = $as_sci_List(this$22.tail__O());
      while ((rest$4 !== $m_sci_Nil$())) {
        var arg1$9 = rest$4.head__O();
        var nx$4 = new $c_sci_$colon$colon(f$4(arg1$9), $m_sci_Nil$());
        t$4.sci_$colon$colon__f_next = nx$4;
        t$4 = nx$4;
        rest$4 = $as_sci_List(rest$4.tail__O())
      };
      return h$4
    }
  }))($thiz, cmd, sub)))
}
function $p_Ltyrian_runtime_TyrianRuntime__renderLoop__V($thiz) {
  window.requestAnimationFrame(((this$1) => ((_$5) => {
    $uD(_$5);
    var this$2 = $as_Lcats_effect_std_Dispatcher(this$1.Ltyrian_runtime_TyrianRuntime__f_dispatcher.apply__O());
    var fa = $p_Ltyrian_runtime_TyrianRuntime__redraw$1__O(this$1);
    this$2.unsafeToFutureCancelable__O__T2(fa);
    $p_Ltyrian_runtime_TyrianRuntime__renderLoop__V(this$1)
  }))($thiz))
}
function $p_Ltyrian_runtime_TyrianRuntime__redraw$1__O($thiz) {
  var F = $thiz.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
  return F.flatMap__O__F1__O($thiz.Ltyrian_runtime_TyrianRuntime__f_model.get__O(), new $c_sjsr_AnonFunction1(((this$2) => ((m) => {
    var m$1 = $as_Ltyrian_runtime_ModelHolder(m);
    if (m$1.Ltyrian_runtime_ModelHolder__f_updated) {
      var target = this$2.Ltyrian_runtime_TyrianRuntime__f_vnode.updateAndGet__F1__O(new $c_sjsr_AnonFunction1(((this$3, m$2) => ((n) => $m_Ltyrian_runtime_Rendering$().render__O__O__F1__F1__Lsnabbdom_VNode(n, m$2.Ltyrian_runtime_ModelHolder__f_model, this$3.Ltyrian_runtime_TyrianRuntime__f_view, new $c_sjsr_AnonFunction1(((this$4) => ((msg) => {
        $p_Ltyrian_runtime_TyrianRuntime__onMsg__O__V(this$4, msg)
      }))(this$3)))))(this$2, m$1)));
      var tc = this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      var this$8 = new $c_Lcats_FlatMap$$anon$2(target, tc);
      var f$1 = new $c_sjsr_AnonFunction1(((this$2$1, m$3) => ((x$1) => {
        var target$1 = this$2$1.Ltyrian_runtime_TyrianRuntime__f_model.set__O__O(new $c_Ltyrian_runtime_ModelHolder(m$3.Ltyrian_runtime_ModelHolder__f_model, false));
        var tc$1 = this$2$1.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
        var this$7 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
        var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
          $as_jl_Void(x$1$2)
        }));
        return this$7.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$7.Lcats_Functor$$anon$4__f_self, f)
      }))(this$2, m$1));
      return this$8.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$8.Lcats_FlatMap$$anon$2__f_self, f$1)
    } else {
      var F$1 = this$2.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
      return F$1.pure__O__O((void 0))
    }
  }))($thiz)))
}
/** @constructor */
function $c_Ltyrian_runtime_TyrianRuntime(initCmd, update, view, subscriptions, model, vnode, queue, dispatcher, evidence$1) {
  this.Ltyrian_runtime_TyrianRuntime__f_initCmd = null;
  this.Ltyrian_runtime_TyrianRuntime__f_update = null;
  this.Ltyrian_runtime_TyrianRuntime__f_view = null;
  this.Ltyrian_runtime_TyrianRuntime__f_subscriptions = null;
  this.Ltyrian_runtime_TyrianRuntime__f_model = null;
  this.Ltyrian_runtime_TyrianRuntime__f_vnode = null;
  this.Ltyrian_runtime_TyrianRuntime__f_queue = null;
  this.Ltyrian_runtime_TyrianRuntime__f_dispatcher = null;
  this.Ltyrian_runtime_TyrianRuntime__f_evidence$1 = null;
  this.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = null;
  this.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = null;
  this.Ltyrian_runtime_TyrianRuntime__f_initCmd = initCmd;
  this.Ltyrian_runtime_TyrianRuntime__f_update = update;
  this.Ltyrian_runtime_TyrianRuntime__f_view = view;
  this.Ltyrian_runtime_TyrianRuntime__f_subscriptions = subscriptions;
  this.Ltyrian_runtime_TyrianRuntime__f_model = model;
  this.Ltyrian_runtime_TyrianRuntime__f_vnode = vnode;
  this.Ltyrian_runtime_TyrianRuntime__f_queue = queue;
  this.Ltyrian_runtime_TyrianRuntime__f_dispatcher = dispatcher;
  this.Ltyrian_runtime_TyrianRuntime__f_evidence$1 = evidence$1;
  this.Ltyrian_runtime_TyrianRuntime__f_currentSubscriptions = $m_s_package$().s_package$__f_Nil;
  this.Ltyrian_runtime_TyrianRuntime__f_aboutToRunSubscriptions = $m_sci_Set$EmptySet$()
}
$c_Ltyrian_runtime_TyrianRuntime.prototype = new $h_O();
$c_Ltyrian_runtime_TyrianRuntime.prototype.constructor = $c_Ltyrian_runtime_TyrianRuntime;
/** @constructor */
function $h_Ltyrian_runtime_TyrianRuntime() {
  /*<skip>*/
}
$h_Ltyrian_runtime_TyrianRuntime.prototype = $c_Ltyrian_runtime_TyrianRuntime.prototype;
$c_Ltyrian_runtime_TyrianRuntime.prototype.start__V = (function() {
  $p_Ltyrian_runtime_TyrianRuntime__renderLoop__V(this);
  var this$4 = $as_Lcats_effect_std_Dispatcher(this.Ltyrian_runtime_TyrianRuntime__f_dispatcher.apply__O());
  var target = this.Ltyrian_runtime_TyrianRuntime__f_model.get__O();
  var tc = this.Ltyrian_runtime_TyrianRuntime__f_evidence$1;
  var this$3 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((m) => {
    var m$1 = $as_Ltyrian_runtime_ModelHolder(m);
    return $p_Ltyrian_runtime_TyrianRuntime__completeUpdate__Ltyrian_Cmd__O__O(this$2, this$2.Ltyrian_runtime_TyrianRuntime__f_initCmd, m$1.Ltyrian_runtime_ModelHolder__f_model)
  }))(this));
  var fa = this$3.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$$anon$2__f_self, f);
  this$4.unsafeToFutureCancelable__O__T2(fa)
});
function $as_Ltyrian_runtime_TyrianRuntime(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_TyrianRuntime) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.TyrianRuntime"))
}
function $isArrayOf_Ltyrian_runtime_TyrianRuntime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_TyrianRuntime)))
}
function $asArrayOf_Ltyrian_runtime_TyrianRuntime(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_TyrianRuntime(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.TyrianRuntime;", depth))
}
var $d_Ltyrian_runtime_TyrianRuntime = new $TypeData().initClass({
  Ltyrian_runtime_TyrianRuntime: 0
}, false, "tyrian.runtime.TyrianRuntime", {
  Ltyrian_runtime_TyrianRuntime: 1,
  O: 1
});
$c_Ltyrian_runtime_TyrianRuntime.prototype.$classData = $d_Ltyrian_runtime_TyrianRuntime;
/** @constructor */
function $c_Lcats_Eval() {
  /*<skip>*/
}
$c_Lcats_Eval.prototype = new $h_O();
$c_Lcats_Eval.prototype.constructor = $c_Lcats_Eval;
/** @constructor */
function $h_Lcats_Eval() {
  /*<skip>*/
}
$h_Lcats_Eval.prototype = $c_Lcats_Eval.prototype;
$c_Lcats_Eval.prototype.map__F1__Lcats_Eval = (function(f) {
  return this.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$2) => ((a) => {
    var value = f$2.apply__O__O(a);
    return new $c_Lcats_Now(value)
  }))(f)))
});
$c_Lcats_Eval.prototype.flatMap__F1__Lcats_Eval = (function(f) {
  if ((this instanceof $c_Lcats_Eval$FlatMap)) {
    var c = $as_Lcats_Eval$FlatMap(this);
    return new $c_Lcats_Eval$$anon$1(f, c)
  } else if ((this instanceof $c_Lcats_Eval$Defer)) {
    var c$2 = $as_Lcats_Eval$Defer(this);
    return new $c_Lcats_Eval$$anon$2(f, c$2)
  } else {
    return new $c_Lcats_Eval$$anon$3(f, this)
  }
});
function $as_Lcats_Eval(obj) {
  return (((obj instanceof $c_Lcats_Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval"))
}
function $isArrayOf_Lcats_Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval)))
}
function $asArrayOf_Lcats_Eval(obj, depth) {
  return (($isArrayOf_Lcats_Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval;", depth))
}
/** @constructor */
function $c_Lcats_EvalInstances0() {
  /*<skip>*/
}
$c_Lcats_EvalInstances0.prototype = new $h_Lcats_EvalInstances1();
$c_Lcats_EvalInstances0.prototype.constructor = $c_Lcats_EvalInstances0;
/** @constructor */
function $h_Lcats_EvalInstances0() {
  /*<skip>*/
}
$h_Lcats_EvalInstances0.prototype = $c_Lcats_EvalInstances0.prototype;
/** @constructor */
function $c_Lcats_ParallelArityFunctions2() {
  /*<skip>*/
}
$c_Lcats_ParallelArityFunctions2.prototype = new $h_O();
$c_Lcats_ParallelArityFunctions2.prototype.constructor = $c_Lcats_ParallelArityFunctions2;
/** @constructor */
function $h_Lcats_ParallelArityFunctions2() {
  /*<skip>*/
}
$h_Lcats_ParallelArityFunctions2.prototype = $c_Lcats_ParallelArityFunctions2.prototype;
function $is_Lcats_arrow_FunctionK(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_arrow_FunctionK)))
}
function $as_Lcats_arrow_FunctionK(obj) {
  return (($is_Lcats_arrow_FunctionK(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.arrow.FunctionK"))
}
function $isArrayOf_Lcats_arrow_FunctionK(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_arrow_FunctionK)))
}
function $asArrayOf_Lcats_arrow_FunctionK(obj, depth) {
  return (($isArrayOf_Lcats_arrow_FunctionK(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.arrow.FunctionK;", depth))
}
/** @constructor */
function $c_Lcats_data_Chain$NonEmpty() {
  /*<skip>*/
}
$c_Lcats_data_Chain$NonEmpty.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$NonEmpty.prototype.constructor = $c_Lcats_data_Chain$NonEmpty;
/** @constructor */
function $h_Lcats_data_Chain$NonEmpty() {
  /*<skip>*/
}
$h_Lcats_data_Chain$NonEmpty.prototype = $c_Lcats_data_Chain$NonEmpty.prototype;
function $as_Lcats_data_Chain$NonEmpty(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$NonEmpty) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$NonEmpty"))
}
function $isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$NonEmpty)))
}
function $asArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$NonEmpty;", depth))
}
/** @constructor */
function $c_Lcats_data_ChainInstances2() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances2.prototype = new $h_Lcats_data_ChainInstances3();
$c_Lcats_data_ChainInstances2.prototype.constructor = $c_Lcats_data_ChainInstances2;
/** @constructor */
function $h_Lcats_data_ChainInstances2() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances2.prototype = $c_Lcats_data_ChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances8() {
  /*<skip>*/
}
$c_Lcats_data_KleisliInstances8.prototype = new $h_Lcats_data_KleisliInstances9();
$c_Lcats_data_KleisliInstances8.prototype.constructor = $c_Lcats_data_KleisliInstances8;
/** @constructor */
function $h_Lcats_data_KleisliInstances8() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances8.prototype = $c_Lcats_data_KleisliInstances8.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances0() {
  /*<skip>*/
}
$c_Lcats_data_NonEmptyListInstances0.prototype = new $h_Lcats_data_NonEmptyListInstances1();
$c_Lcats_data_NonEmptyListInstances0.prototype.constructor = $c_Lcats_data_NonEmptyListInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances0() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances0.prototype = $c_Lcats_data_NonEmptyListInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_IO() {
  /*<skip>*/
}
$c_Lcats_effect_IO.prototype = new $h_Lcats_effect_IOPlatform();
$c_Lcats_effect_IO.prototype.constructor = $c_Lcats_effect_IO;
/** @constructor */
function $h_Lcats_effect_IO() {
  /*<skip>*/
}
$h_Lcats_effect_IO.prototype = $c_Lcats_effect_IO.prototype;
$c_Lcats_effect_IO.prototype.as__O__Lcats_effect_IO = (function(b) {
  return this.map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((b$2) => ((_$2) => b$2))(b)))
});
$c_Lcats_effect_IO.prototype.forceR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.handleError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$11) => {
    $as_jl_Throwable(_$11)
  }))).productR__Lcats_effect_IO__Lcats_effect_IO(that)
});
$c_Lcats_effect_IO.prototype.flatMap__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$FlatMap(this, f, event)
});
$c_Lcats_effect_IO.prototype.flatTap__F1__Lcats_effect_IO = (function(f) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((f$2) => ((a) => $as_Lcats_effect_IO(f$2.apply__O__O(a)).as__O__Lcats_effect_IO(a)))(f)))
});
$c_Lcats_effect_IO.prototype.guarantee__Lcats_effect_IO__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((this$1, finalizer$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var handled = finalizer$2.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t) => {
      var t$1 = $as_jl_Throwable(t);
      return ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t$2) => ((ec) => {
        var ec$1 = $as_s_concurrent_ExecutionContext(ec);
        var this$3 = $m_Lcats_effect_IO$();
        var thunk = new $c_sjsr_AnonFunction0(((t$2$2, ec$2) => (() => {
          ec$2.reportFailure__jl_Throwable__V(t$2$2)
        }))(t$2, ec$1));
        return this$3.delay__F0__Lcats_effect_IO(thunk)
      }))(t$1)))
    })));
    var this$4 = $as_Lcats_effect_IO(poll$1.apply__O__O(this$1));
    return new $c_Lcats_effect_IO$OnCancel(this$4, finalizer$2).onError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((handled$2) => ((_$12) => {
      $as_jl_Throwable(_$12);
      return handled$2
    }))(handled))).flatTap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((finalizer$1$2) => ((_$13) => finalizer$1$2))(finalizer$2)))
  }))(this, finalizer)))
});
$c_Lcats_effect_IO.prototype.guaranteeCase__F1__Lcats_effect_IO = (function(finalizer) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((this$1, finalizer$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var this$4 = $as_Lcats_effect_IO(poll$1.apply__O__O(this$1));
    var fin = $as_Lcats_effect_IO(finalizer$2.apply__O__O(($m_Lcats_effect_package$(), new $c_Lcats_effect_kernel_Outcome$Canceled())));
    var finalized = new $c_Lcats_effect_IO$OnCancel(this$4, fin);
    var handled = finalized.onError__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((finalizer$3$2) => ((e) => {
      var e$1 = $as_jl_Throwable(e);
      return $as_Lcats_effect_IO(finalizer$3$2.apply__O__O(($m_Lcats_effect_package$(), new $c_Lcats_effect_kernel_Outcome$Errored(e$1)))).handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t) => {
        var t$1 = $as_jl_Throwable(t);
        return ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((t$2) => ((ec) => {
          var ec$1 = $as_s_concurrent_ExecutionContext(ec);
          var this$9 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0(((t$4$2, ec$2) => (() => {
            ec$2.reportFailure__jl_Throwable__V(t$4$2)
          }))(t$2, ec$1));
          return this$9.delay__F0__Lcats_effect_IO(thunk)
        }))(t$1)))
      })))
    }))(finalizer$2)));
    return handled.flatTap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((finalizer$3$3) => ((a) => {
      $m_Lcats_effect_package$();
      $m_Lcats_effect_IO$();
      var fa = new $c_Lcats_effect_IO$Pure(a);
      return $as_Lcats_effect_IO(finalizer$3$3.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa)))
    }))(finalizer$2)))
  }))(this, finalizer)))
});
$c_Lcats_effect_IO.prototype.handleError__F1__Lcats_effect_IO = (function(f) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((f$2) => ((t) => {
    var t$1 = $as_jl_Throwable(t);
    $m_Lcats_effect_IO$();
    var value = f$2.apply__O__O(t$1);
    return new $c_Lcats_effect_IO$Pure(value)
  }))(f)))
});
$c_Lcats_effect_IO.prototype.handleErrorWith__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$HandleErrorWith(this, f, event)
});
$c_Lcats_effect_IO.prototype.map__F1__Lcats_effect_IO = (function(f) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(f);
  return new $c_Lcats_effect_IO$Map(this, f, event)
});
$c_Lcats_effect_IO.prototype.onError__F1__Lcats_effect_IO = (function(f) {
  return this.handleErrorWith__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((f$2) => ((t) => {
    var t$1 = $as_jl_Throwable(t);
    var this$1 = $as_Lcats_effect_IO(f$2.apply__O__O(t$1));
    var this$5 = new $c_Lcats_effect_IO$Attempt(this$1);
    $m_Lcats_effect_IO$();
    var that = new $c_Lcats_effect_IO$Error(t$1);
    return this$5.productR__Lcats_effect_IO__Lcats_effect_IO(that)
  }))(f)))
});
$c_Lcats_effect_IO.prototype.productL__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((that$2) => ((a) => that$2.as__O__Lcats_effect_IO(a)))(that)))
});
$c_Lcats_effect_IO.prototype.productR__Lcats_effect_IO__Lcats_effect_IO = (function(that) {
  return this.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((that$2) => ((_$19) => that$2))(that)))
});
$c_Lcats_effect_IO.prototype.void__Lcats_effect_IO = (function() {
  return this.map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((_$21) => (void 0))))
});
$c_Lcats_effect_IO.prototype.toString__T = (function() {
  return "IO(...)"
});
$c_Lcats_effect_IO.prototype.unsafeRunAsync__F1__Lcats_effect_unsafe_IORuntime__V = (function(cb, runtime) {
  this.unsafeRunFiber__F0__F1__F1__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber(new $c_sjsr_AnonFunction0(((cb$2) => (() => {
    $m_s_package$();
    var value = new $c_ju_concurrent_CancellationException("The fiber was canceled");
    cb$2.apply__O__O(new $c_s_util_Left(value))
  }))(cb)), new $c_sjsr_AnonFunction1(((cb$3) => ((t) => {
    var t$1 = $as_jl_Throwable(t);
    cb$3.apply__O__O(($m_s_package$(), new $c_s_util_Left(t$1)))
  }))(cb)), new $c_sjsr_AnonFunction1(((cb$4) => ((a) => {
    cb$4.apply__O__O(($m_s_package$(), new $c_s_util_Right(a)))
  }))(cb)), runtime)
});
$c_Lcats_effect_IO.prototype.unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V = (function(runtime) {
  this.unsafeRunAsync__F1__Lcats_effect_unsafe_IORuntime__V(new $c_sjsr_AnonFunction1(((_$23) => {
    $as_s_util_Either(_$23)
  })), runtime)
});
$c_Lcats_effect_IO.prototype.unsafeRunFiber__F0__F1__F1__Lcats_effect_unsafe_IORuntime__Lcats_effect_IOFiber = (function(canceled, failure, success, runtime) {
  var fiber = $ct_Lcats_effect_IOFiber__sci_Map__F1__Lcats_effect_IO__s_concurrent_ExecutionContext__Lcats_effect_unsafe_IORuntime__(new $c_Lcats_effect_IOFiber(), $m_sci_Map$EmptyMap$(), new $c_sjsr_AnonFunction1(((canceled$2, failure$2, success$2, runtime$2) => ((oc) => {
    var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
    matchResult1: {
      if (((oc$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc$1), true))) {
        runtime$2.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.remove__F1__V(failure$2);
        canceled$2.apply__O();
        break matchResult1
      };
      if ((oc$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(oc$1);
        var x7 = x$1.Lcats_effect_kernel_Outcome$Errored__f_e;
        var t = $as_jl_Throwable(x7);
        runtime$2.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.remove__F1__V(failure$2);
        failure$2.apply__O__O(t);
        break matchResult1
      };
      if ((oc$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc$1);
        var x4 = x$1$1.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
        var ioa = $as_Lcats_effect_IO(x4);
        runtime$2.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.remove__F1__V(failure$2);
        success$2.apply__O__O($as_Lcats_effect_IO$Pure(ioa).Lcats_effect_IO$Pure__f_value);
        break matchResult1
      };
      throw new $c_s_MatchError(oc$1)
    }
  }))(canceled, failure, success, runtime)), this, runtime.Lcats_effect_unsafe_IORuntime__f_compute, runtime);
  runtime.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.put__F1__V(failure);
  runtime.Lcats_effect_unsafe_IORuntime__f_compute.execute__jl_Runnable__V(fiber);
  return fiber
});
function $as_Lcats_effect_IO(obj) {
  return (((obj instanceof $c_Lcats_effect_IO) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO"))
}
function $isArrayOf_Lcats_effect_IO(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO)))
}
function $asArrayOf_Lcats_effect_IO(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO;", depth))
}
/** @constructor */
function $c_Lcats_effect_IO$$anon$3(k$3) {
  this.Lcats_effect_IO$$anon$3__f_k$1 = null;
  this.Lcats_effect_IO$$anon$3__f_k$1 = k$3
}
$c_Lcats_effect_IO$$anon$3.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$3.prototype.constructor = $c_Lcats_effect_IO$$anon$3;
/** @constructor */
function $h_Lcats_effect_IO$$anon$3() {
  /*<skip>*/
}
$h_Lcats_effect_IO$$anon$3.prototype = $c_Lcats_effect_IO$$anon$3.prototype;
$c_Lcats_effect_IO$$anon$3.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((this$1, G$2) => ((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return G$2.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$2, G$1$2, resume$2, get$2, lift$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = lift$2.apply__O__O(this$2.Lcats_effect_IO$$anon$3__f_k$1.apply__O__O(resume$2));
      var this$4 = new $c_Lcats_FlatMap$$anon$2(target, G$1$2);
      var f = new $c_sjsr_AnonFunction1(((G$2$2, get$1$2, lift$1$2, poll$2) => ((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var fin = $as_Lcats_effect_IO($as_s_Some(x$1$1).s_Some__f_value);
          return G$2$2.onCancel__O__O__O(poll$2.apply__O__O(get$1$2), lift$1$2.apply__O__O(fin))
        };
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return poll$2.apply__O__O(get$1$2)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(G$1$2, get$2, lift$2, poll$1));
      return this$4.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$$anon$2__f_self, f)
    }))(this$1, G$2, resume$1, get, lift$1)))
  }))(this, G))
});
var $d_Lcats_effect_IO$$anon$3 = new $TypeData().initClass({
  Lcats_effect_IO$$anon$3: 0
}, false, "cats.effect.IO$$anon$3", {
  Lcats_effect_IO$$anon$3: 1,
  O: 1,
  Lcats_effect_kernel_Cont: 1
});
$c_Lcats_effect_IO$$anon$3.prototype.$classData = $d_Lcats_effect_IO$$anon$3;
/** @constructor */
function $c_Lcats_effect_IO$$anon$4(k$4) {
  this.Lcats_effect_IO$$anon$4__f_k$1 = null;
  this.Lcats_effect_IO$$anon$4__f_k$1 = k$4
}
$c_Lcats_effect_IO$$anon$4.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$4.prototype.constructor = $c_Lcats_effect_IO$$anon$4;
/** @constructor */
function $h_Lcats_effect_IO$$anon$4() {
  /*<skip>*/
}
$h_Lcats_effect_IO$$anon$4.prototype = $c_Lcats_effect_IO$$anon$4.prototype;
$c_Lcats_effect_IO$$anon$4.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((this$1, G$2) => ((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return G$2.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$2, G$4$2, resume$2, get$2, lift$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = lift$2.apply__O__O($m_Lcats_effect_IO$().delay__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0(((this$3, resume$2$2) => (() => {
        this$3.Lcats_effect_IO$$anon$4__f_k$1.apply__O__O(resume$2$2)
      }))(this$2, resume$2))));
      var this$5 = new $c_Lcats_FlatMap$$anon$2(target, G$4$2);
      var f = new $c_sjsr_AnonFunction1(((get$3$2, poll$2) => ((_$32) => {
        $as_jl_Void(_$32);
        return poll$2.apply__O__O(get$3$2)
      }))(get$2, poll$1));
      return this$5.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$5.Lcats_FlatMap$$anon$2__f_self, f)
    }))(this$1, G$2, resume$1, get, lift$1)))
  }))(this, G))
});
var $d_Lcats_effect_IO$$anon$4 = new $TypeData().initClass({
  Lcats_effect_IO$$anon$4: 0
}, false, "cats.effect.IO$$anon$4", {
  Lcats_effect_IO$$anon$4: 1,
  O: 1,
  Lcats_effect_kernel_Cont: 1
});
$c_Lcats_effect_IO$$anon$4.prototype.$classData = $d_Lcats_effect_IO$$anon$4;
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$2(cb$12, \u03b4this$13, outer) {
  this.Lcats_effect_IOFiber$$anon$2__f_cb$1 = null;
  this.Lcats_effect_IOFiber$$anon$2__f_$this$1 = null;
  this.Lcats_effect_IOFiber$$anon$2__f_cb$1 = cb$12;
  this.Lcats_effect_IOFiber$$anon$2__f_$this$1 = \u03b4this$13;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lcats_effect_IOFiber$$anon$2.prototype = new $h_O();
$c_Lcats_effect_IOFiber$$anon$2.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$2;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_IOFiber$$anon$2.prototype = $c_Lcats_effect_IOFiber$$anon$2.prototype;
$c_Lcats_effect_IOFiber$$anon$2.prototype.run__V = (function() {
  var cb$7 = this.Lcats_effect_IOFiber$$anon$2__f_cb$1;
  var \u03b4this$10 = this.Lcats_effect_IOFiber$$anon$2__f_$this$1;
  cb$7.apply__O__O(\u03b4this$10.Lcats_effect_IOFiber__f_RightUnit)
});
var $d_Lcats_effect_IOFiber$$anon$2 = new $TypeData().initClass({
  Lcats_effect_IOFiber$$anon$2: 0
}, false, "cats.effect.IOFiber$$anon$2", {
  Lcats_effect_IOFiber$$anon$2: 1,
  O: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_IOFiber$$anon$2.prototype.$classData = $d_Lcats_effect_IOFiber$$anon$2;
/** @constructor */
function $c_Lcats_effect_instances_package$spawn$() {
  /*<skip>*/
}
$c_Lcats_effect_instances_package$spawn$.prototype = new $h_O();
$c_Lcats_effect_instances_package$spawn$.prototype.constructor = $c_Lcats_effect_instances_package$spawn$;
/** @constructor */
function $h_Lcats_effect_instances_package$spawn$() {
  /*<skip>*/
}
$h_Lcats_effect_instances_package$spawn$.prototype = $c_Lcats_effect_instances_package$spawn$.prototype;
var $d_Lcats_effect_instances_package$spawn$ = new $TypeData().initClass({
  Lcats_effect_instances_package$spawn$: 0
}, false, "cats.effect.instances.package$spawn$", {
  Lcats_effect_instances_package$spawn$: 1,
  O: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1
});
$c_Lcats_effect_instances_package$spawn$.prototype.$classData = $d_Lcats_effect_instances_package$spawn$;
var $n_Lcats_effect_instances_package$spawn$;
function $m_Lcats_effect_instances_package$spawn$() {
  if ((!$n_Lcats_effect_instances_package$spawn$)) {
    $n_Lcats_effect_instances_package$spawn$ = new $c_Lcats_effect_instances_package$spawn$()
  };
  return $n_Lcats_effect_instances_package$spawn$
}
/** @constructor */
function $c_Lcats_effect_kernel_Async$$anon$1(k$4) {
  this.Lcats_effect_kernel_Async$$anon$1__f_k$1 = null;
  this.Lcats_effect_kernel_Async$$anon$1__f_k$1 = k$4
}
$c_Lcats_effect_kernel_Async$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Async$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Async$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Async$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Async$$anon$1.prototype = $c_Lcats_effect_kernel_Async$$anon$1.prototype;
$c_Lcats_effect_kernel_Async$$anon$1.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((this$1, G$2) => ((resume, get, lift) => {
    var resume$1 = $as_F1(resume);
    var lift$1 = $as_Lcats_arrow_FunctionK(lift);
    return G$2.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$2, G$1$2, resume$2, get$2, lift$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      $m_Lcats_implicits$();
      var target = lift$2.apply__O__O(this$2.Lcats_effect_kernel_Async$$anon$1__f_k$1.apply__O__O(resume$2));
      var this$4 = new $c_Lcats_FlatMap$$anon$2(target, G$1$2);
      var f = new $c_sjsr_AnonFunction1(((G$2$2, get$1$2, lift$1$2, poll$2) => ((x$1) => {
        var x$1$1 = $as_s_Option(x$1);
        if ((x$1$1 instanceof $c_s_Some)) {
          var fin = $as_s_Some(x$1$1).s_Some__f_value;
          return G$2$2.onCancel__O__O__O(poll$2.apply__O__O(get$1$2), lift$1$2.apply__O__O(fin))
        };
        var x = $m_s_None$();
        if ((x === x$1$1)) {
          return poll$2.apply__O__O(get$1$2)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(G$1$2, get$2, lift$2, poll$1));
      return this$4.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$$anon$2__f_self, f)
    }))(this$1, G$2, resume$1, get, lift$1)))
  }))(this, G))
});
var $d_Lcats_effect_kernel_Async$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_Async$$anon$1: 0
}, false, "cats.effect.kernel.Async$$anon$1", {
  Lcats_effect_kernel_Async$$anon$1: 1,
  O: 1,
  Lcats_effect_kernel_Cont: 1
});
$c_Lcats_effect_kernel_Async$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_Async$$anon$1;
/** @constructor */
function $c_Lcats_effect_kernel_Par$$anon$1() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Par$$anon$1.prototype = new $h_Lcats_effect_kernel_Par$ParallelFImpl();
$c_Lcats_effect_kernel_Par$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Par$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Par$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Par$$anon$1.prototype = $c_Lcats_effect_kernel_Par$$anon$1.prototype;
var $d_Lcats_effect_kernel_Par$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_Par$$anon$1: 0
}, false, "cats.effect.kernel.Par$$anon$1", {
  Lcats_effect_kernel_Par$$anon$1: 1,
  Lcats_effect_kernel_Par$ParallelFImpl: 1,
  O: 1
});
$c_Lcats_effect_kernel_Par$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_Par$$anon$1;
/** @constructor */
function $c_Lcats_effect_kernel_Ref$$anon$1(F$7) {
  this.Lcats_effect_kernel_Ref$$anon$1__f_F$1 = null;
  this.Lcats_effect_kernel_Ref$$anon$1__f_F$1 = F$7
}
$c_Lcats_effect_kernel_Ref$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Ref$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Ref$$anon$1.prototype = $c_Lcats_effect_kernel_Ref$$anon$1.prototype;
$c_Lcats_effect_kernel_Ref$$anon$1.prototype.refOf__O__O = (function(a) {
  return this.Lcats_effect_kernel_Ref$$anon$1__f_F$1.ref__O__O(a)
});
var $d_Lcats_effect_kernel_Ref$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_Ref$$anon$1: 0
}, false, "cats.effect.kernel.Ref$$anon$1", {
  Lcats_effect_kernel_Ref$$anon$1: 1,
  O: 1,
  Lcats_effect_kernel_Ref$Make: 1
});
$c_Lcats_effect_kernel_Ref$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_Ref$$anon$1;
/** @constructor */
function $c_Lcats_effect_kernel_Ref$$anon$2(F$8) {
  this.Lcats_effect_kernel_Ref$$anon$2__f_F$1 = null;
  this.Lcats_effect_kernel_Ref$$anon$2__f_F$1 = F$8
}
$c_Lcats_effect_kernel_Ref$$anon$2.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_Ref$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Ref$$anon$2.prototype = $c_Lcats_effect_kernel_Ref$$anon$2.prototype;
$c_Lcats_effect_kernel_Ref$$anon$2.prototype.refOf__O__O = (function(a) {
  return this.Lcats_effect_kernel_Ref$$anon$2__f_F$1.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => $m_Lcats_effect_kernel_Ref$().unsafe__O__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Ref(a$2, this$1.Lcats_effect_kernel_Ref$$anon$2__f_F$1)))(this, a)))
});
var $d_Lcats_effect_kernel_Ref$$anon$2 = new $TypeData().initClass({
  Lcats_effect_kernel_Ref$$anon$2: 0
}, false, "cats.effect.kernel.Ref$$anon$2", {
  Lcats_effect_kernel_Ref$$anon$2: 1,
  O: 1,
  Lcats_effect_kernel_Ref$Make: 1
});
$c_Lcats_effect_kernel_Ref$$anon$2.prototype.$classData = $d_Lcats_effect_kernel_Ref$$anon$2;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$4(F$75, state$5, outer$2) {
  this.Lcats_effect_kernel_Resource$$anon$4__f_F$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_state$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$4__f_F$1 = F$75;
  this.Lcats_effect_kernel_Resource$$anon$4__f_state$1 = state$5;
  this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1 = outer$2
}
$c_Lcats_effect_kernel_Resource$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$4() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$$anon$4.prototype = $c_Lcats_effect_kernel_Resource$$anon$4.prototype;
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.cancel__Lcats_effect_kernel_Resource = (function() {
  var fa$2 = this.Lcats_effect_kernel_Resource$$anon$4__f_F$1.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var fa = poll$1.apply__O__O(this$1.Lcats_effect_kernel_Resource$$anon$4__f_outer$1.cancel__O());
    var F = this$1.Lcats_effect_kernel_Resource$$anon$4__f_F$1;
    var this$3 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
    var fb = this$1.Lcats_effect_kernel_Resource$$anon$4__f_state$1.update__F1__O(new $c_sjsr_AnonFunction1(((_$30) => {
      var _$30$1 = $as_Lcats_effect_kernel_Resource$State$2(_$30);
      return _$30$1.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$2(_$30$1.Lcats_effect_kernel_Resource$State$2__f_fin, true, _$30$1.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete)
    })));
    var this$4 = this$3.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
    var fa$1 = this$3.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    return this$4.productR__O__O__O(fa$1, fb)
  }))(this)));
  return new $c_Lcats_effect_kernel_Resource$Eval(fa$2)
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.join__Lcats_effect_kernel_Resource = (function() {
  var target = this.Lcats_effect_kernel_Resource$$anon$4__f_outer$1.join__O();
  var tc = this.Lcats_effect_kernel_Resource$$anon$4__f_F$1;
  var this$21 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((this$2) => ((x$1) => {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
    if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
      var a = new $c_Lcats_effect_kernel_Outcome$Canceled();
      var F = this$2.Lcats_effect_kernel_Resource$$anon$4__f_F$1;
      return F.pure__O__O(a)
    };
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
      var x115 = $as_jl_Throwable(x$1$2.Lcats_effect_kernel_Outcome$Errored__f_e);
      var a$1 = new $c_Lcats_effect_kernel_Outcome$Errored(x115);
      var F$1 = this$2.Lcats_effect_kernel_Resource$$anon$4__f_F$1;
      return F$1.pure__O__O(a$1)
    };
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
      var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
      var x112 = x$1$3.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
      var target$1 = this$2.Lcats_effect_kernel_Resource$$anon$4__f_state$1.get__O();
      var tc$1 = this$2.Lcats_effect_kernel_Resource$$anon$4__f_F$1;
      var this$20 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
      var f = new $c_sjsr_AnonFunction1(((fp$2) => ((s) => {
        var s$1 = $as_Lcats_effect_kernel_Resource$State$2(s);
        if (s$1.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete) {
          return new $c_Lcats_effect_kernel_Outcome$Canceled()
        } else {
          var fa = new $c_Lcats_effect_kernel_Resource$Eval(fp$2);
          return new $c_Lcats_effect_kernel_Outcome$Succeeded(fa)
        }
      }))(x112));
      return this$20.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$20.Lcats_Functor$$anon$4__f_self, f)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this));
  var fa$1 = this$21.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$21.Lcats_FlatMap$$anon$2__f_self, f$1);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa$1)
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_kernel_Resource()
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.join__O = (function() {
  return this.join__Lcats_effect_kernel_Resource()
});
var $d_Lcats_effect_kernel_Resource$$anon$4 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$$anon$4: 0
}, false, "cats.effect.kernel.Resource$$anon$4", {
  Lcats_effect_kernel_Resource$$anon$4: 1,
  O: 1,
  Lcats_effect_kernel_Fiber: 1
});
$c_Lcats_effect_kernel_Resource$$anon$4.prototype.$classData = $d_Lcats_effect_kernel_Resource$$anon$4;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$7(body$4, F$77) {
  this.Lcats_effect_kernel_Resource$$anon$7__f_body$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$7__f_body$1 = body$4;
  this.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1 = F$77
}
$c_Lcats_effect_kernel_Resource$$anon$7.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$7;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$7() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$$anon$7.prototype = $c_Lcats_effect_kernel_Resource$$anon$7.prototype;
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.apply__Lcats_effect_kernel_MonadCancel__F3 = (function(G) {
  return new $c_sjsr_AnonFunction3(((this$1, G$2) => ((cb, ga, nt) => {
    var cb$1 = $as_F1(cb);
    var nt$1 = $as_Lcats_arrow_FunctionK(nt);
    var nt2 = new $c_Lcats_effect_kernel_Resource$$anon$7$$anon$1(G$2, nt$1, this$1);
    var target = this$1.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1.ref__O__O(new $c_sjsr_AnonFunction1(((this$2) => ((_$83) => {
      $as_Lcats_effect_kernel_Resource$ExitCase(_$83);
      var this$3 = this$2.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1;
      return this$3.pure__O__O((void 0))
    }))(this$1)));
    var tc = this$1.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1;
    var this$5 = new $c_Lcats_Functor$$anon$4(target, tc);
    var f = new $c_sjsr_AnonFunction1(((this$2$1, nt$2) => ((_$84) => {
      var _$84$1 = $as_Lcats_effect_kernel_Ref(_$84);
      var F = this$2$1.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1;
      return new $c_Lcats_effect_kernel_Ref$TransformedRef(_$84$1, nt$2, F)
    }))(this$1, nt$1));
    var target$1 = nt$1.apply__O__O(this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f));
    var this$17 = new $c_Lcats_FlatMap$$anon$2(target$1, G$2);
    var f$4 = new $c_sjsr_AnonFunction1(((this$3$1, G$5$2, cb$2, ga$2, nt$3, nt2$2) => ((r) => {
      var r$1 = $as_Lcats_effect_kernel_Ref(r);
      var $$x1 = this$3$1.Lcats_effect_kernel_Resource$$anon$7__f_body$1.apply__Lcats_effect_kernel_MonadCancel__F3(new $c_Lcats_effect_kernel_MonadCancel$$anon$4(G$5$2));
      var this$8 = $m_Lcats_data_Kleisli$();
      var target$3 = G$5$2.guaranteeCase__O__F1__O($as_Lcats_data_Kleisli($$x1.apply__O__O__O__O(cb$2, $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$8, ga$2), nt2$2)).Lcats_data_Kleisli__f_run.apply__O__O(r$1), new $c_sjsr_AnonFunction1(((G$6$2, nt$3$2, r$2) => ((x$1) => {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
        if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
          return G$6$2.unit__O()
        } else {
          var target$2 = r$2.get__O();
          var this$11 = new $c_Lcats_FlatMap$$anon$2(target$2, G$6$2);
          var f$1 = new $c_sjsr_AnonFunction1(((nt$4$2, oc$2) => ((fin) => {
            var fin$1 = $as_F1(fin);
            return nt$4$2.apply__O__O(fin$1.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$().fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase(oc$2)))
          }))(nt$3$2, x$1$1));
          return this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f$1)
        }
      }))(G$5$2, nt$3, r$1)));
      var this$16 = new $c_Lcats_FlatMap$$anon$2(target$3, G$5$2);
      var f$3 = new $c_sjsr_AnonFunction1(((G$6$3, r$3) => ((a) => {
        var target$4 = r$3.get__O();
        var this$15 = new $c_Lcats_Functor$$anon$4(target$4, G$6$3);
        var f$2 = new $c_sjsr_AnonFunction1(((a$2) => ((fin$2) => {
          var fin$3 = $as_F1(fin$2);
          return new $c_T2(a$2, fin$3)
        }))(a));
        return this$15.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$15.Lcats_Functor$$anon$4__f_self, f$2)
      }))(G$5$2, r$1));
      return this$16.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$16.Lcats_FlatMap$$anon$2__f_self, f$3)
    }))(this$1, G$2, cb$1, ga, nt$1, nt2));
    return this$17.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$17.Lcats_FlatMap$$anon$2__f_self, f$4)
  }))(this, G))
});
var $d_Lcats_effect_kernel_Resource$$anon$7 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$$anon$7: 0
}, false, "cats.effect.kernel.Resource$$anon$7", {
  Lcats_effect_kernel_Resource$$anon$7: 1,
  O: 1,
  Lcats_effect_kernel_Cont: 1
});
$c_Lcats_effect_kernel_Resource$$anon$7.prototype.$classData = $d_Lcats_effect_kernel_Resource$$anon$7;
/** @constructor */
function $c_Lcats_effect_kernel_ResourceFOInstances0() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances1();
$c_Lcats_effect_kernel_ResourceFOInstances0.prototype.constructor = $c_Lcats_effect_kernel_ResourceFOInstances0;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceFOInstances0() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceFOInstances0.prototype = $c_Lcats_effect_kernel_ResourceFOInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_std_Console$SyncConsole(F) {
  this.Lcats_effect_std_Console$SyncConsole__f_F = null;
  this.Lcats_effect_std_Console$SyncConsole__f_F = F
}
$c_Lcats_effect_std_Console$SyncConsole.prototype = new $h_O();
$c_Lcats_effect_std_Console$SyncConsole.prototype.constructor = $c_Lcats_effect_std_Console$SyncConsole;
/** @constructor */
function $h_Lcats_effect_std_Console$SyncConsole() {
  /*<skip>*/
}
$h_Lcats_effect_std_Console$SyncConsole.prototype = $c_Lcats_effect_std_Console$SyncConsole.prototype;
var $d_Lcats_effect_std_Console$SyncConsole = new $TypeData().initClass({
  Lcats_effect_std_Console$SyncConsole: 0
}, false, "cats.effect.std.Console$SyncConsole", {
  Lcats_effect_std_Console$SyncConsole: 1,
  O: 1,
  Lcats_effect_std_Console: 1
});
$c_Lcats_effect_std_Console$SyncConsole.prototype.$classData = $d_Lcats_effect_std_Console$SyncConsole;
function $f_Lcats_effect_std_Dispatcher__unsafeToFuture__O__s_concurrent_Future($thiz, fa) {
  return $as_s_concurrent_Future($thiz.unsafeToFutureCancelable__O__T2(fa)._1__O())
}
function $is_Lcats_effect_std_Dispatcher(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_std_Dispatcher)))
}
function $as_Lcats_effect_std_Dispatcher(obj) {
  return (($is_Lcats_effect_std_Dispatcher(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher;", depth))
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$$anon$1(state$2, outer) {
  this.Lcats_effect_std_Semaphore$$anon$1__f_state$1 = null;
  this.Lcats_effect_std_Semaphore$$anon$1__f_$outer = null;
  this.Lcats_effect_std_Semaphore$$anon$1__f_state$1 = state$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_std_Semaphore$$anon$1__f_$outer = outer
}
$c_Lcats_effect_std_Semaphore$$anon$1.prototype = new $h_Lcats_effect_std_Semaphore();
$c_Lcats_effect_std_Semaphore$$anon$1.prototype.constructor = $c_Lcats_effect_std_Semaphore$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$$anon$1.prototype = $c_Lcats_effect_std_Semaphore$$anon$1.prototype;
$c_Lcats_effect_std_Semaphore$$anon$1.prototype.acquireN__J__O = (function(n) {
  this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.requireNonNegative__J__V(n);
  if (((n.RTLong__f_lo === 0) && (n.RTLong__f_hi === 0))) {
    var this$1 = this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
    return this$1.pure__O__O((void 0))
  } else {
    return this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$2, n$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var target = this$2.Lcats_effect_std_Semaphore$$anon$1__f_$outer.newRequest__O();
      var tc = this$2.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
      var this$44 = new $c_Lcats_FlatMap$$anon$2(target, tc);
      var f$1 = new $c_sjsr_AnonFunction1(((this$4, n$3$2, poll$2) => ((req) => {
        var req$1 = $as_Lcats_effect_std_Semaphore$impl$Request(req);
        var ffa$1 = this$4.Lcats_effect_std_Semaphore$$anon$1__f_state$1.modify__F1__O(new $c_sjsr_AnonFunction1(((this$5, n$4$2, poll$2$2, req$2) => ((x$1) => {
          var x$1$1 = $as_Lcats_effect_std_Semaphore$impl$State(x$1);
          if ((x$1$1 !== null)) {
            var t = x$1$1.Lcats_effect_std_Semaphore$impl$State__f_permits;
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var x24 = x$1$1.Lcats_effect_std_Semaphore$impl$State__f_waiting;
            if ((!x24.isEmpty__Z())) {
              var self = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($L0, x24.enqueue__O__sci_Queue(req$2.of__J__Lcats_effect_std_Semaphore$impl$Request(n$4$2)));
              var y = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Wait__Lcats_effect_std_Semaphore$impl$Wait$();
              var x13___1 = self;
              var x13___2 = y
            } else {
              var bhi = n$4$2.RTLong__f_hi;
              var lo$1 = ((lo - n$4$2.RTLong__f_lo) | 0);
              var hi$1 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ lo)) ? (((-1) + ((hi - bhi) | 0)) | 0) : ((hi - bhi) | 0));
              if ((hi$1 >= 0)) {
                var $$x2 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
                var $$x1 = new $c_RTLong(lo$1, hi$1);
                var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
                var self$1 = $$x2.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($$x1, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), ($m_sci_List$(), $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs))));
                var y$1 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Done__Lcats_effect_std_Semaphore$impl$Done$();
                var x13___1 = self$1;
                var x13___2 = y$1
              } else {
                var $$x3 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
                if ((hi$1 < 0)) {
                  var lo$2 = ((-lo$1) | 0);
                  var hi$2 = ((lo$1 !== 0) ? (~hi$1) : ((-hi$1) | 0));
                  var x__lo = lo$2;
                  var x__hi = hi$2
                } else {
                  var x__lo = lo$1;
                  var x__hi = hi$1
                };
                var a = req$2.of__J__Lcats_effect_std_Semaphore$impl$Request(new $c_RTLong(x__lo, x__hi));
                $m_Lcats_Invariant$();
                var F = $m_Lcats_instances_package$queue$().Lcats_instances_package$queue$__f_catsStdInstancesForQueue;
                var self$2 = $$x3.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State($L0, $as_sci_Queue(F.pure__O__O(a)));
                var y$2 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Wait__Lcats_effect_std_Semaphore$impl$Wait$();
                var x13___1 = self$2;
                var x13___2 = y$2
              }
            };
            var newState = $as_Lcats_effect_std_Semaphore$impl$State(x13___1);
            var decision = $as_Lcats_effect_std_Semaphore$impl$Action(x13___2);
            var \u03b41$___1 = newState;
            var \u03b41$___2 = decision;
            var newState$2 = $as_Lcats_effect_std_Semaphore$impl$State(\u03b41$___1);
            var decision$2 = $as_Lcats_effect_std_Semaphore$impl$Action(\u03b41$___2);
            var ffa = this$5.Lcats_effect_std_Semaphore$$anon$1__f_state$1.modify__F1__O(new $c_sjsr_AnonFunction1(((this$26, n$2$2, req$1$2) => ((x$1$2) => {
              var x$1$3 = $as_Lcats_effect_std_Semaphore$impl$State(x$1$2);
              if ((x$1$3 !== null)) {
                var t$1 = x$1$3.Lcats_effect_std_Semaphore$impl$State__f_permits;
                var lo$3 = t$1.RTLong__f_lo;
                var hi$3 = t$1.RTLong__f_hi;
                var x19 = x$1$3.Lcats_effect_std_Semaphore$impl$State__f_waiting;
                _return: {
                  var these = x19;
                  while ((!these.isEmpty__Z())) {
                    var arg1 = these.head__O();
                    var _$8 = $as_Lcats_effect_std_Semaphore$impl$Request(arg1);
                    if (_$8.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z(req$1$2)) {
                      var target$1 = new $c_s_Some(these.head__O());
                      break _return
                    };
                    these = $as_sc_LinearSeq(these.tail__O())
                  };
                  var target$1 = $m_s_None$()
                };
                $m_Lcats_UnorderedFoldable$();
                var tc$1 = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
                var this$31 = new $c_Lcats_Foldable$$anon$6(target$1, tc$1);
                var f = new $c_sjsr_AnonFunction1(((_$9) => {
                  var _$9$1 = $as_Lcats_effect_std_Semaphore$impl$Request(_$9);
                  return _$9$1.Lcats_effect_std_Semaphore$impl$Request__f_n
                }));
                var B = $m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong;
                var b = $uJ(this$31.Lcats_Foldable$$anon$6__f_typeClassInstance.foldMap__O__F1__Lcats_kernel_Monoid__O(this$31.Lcats_Foldable$$anon$6__f_self, f, B));
                var alo = n$2$2.RTLong__f_lo;
                var ahi = n$2$2.RTLong__f_hi;
                var bhi$1 = b.RTLong__f_hi;
                var lo$4 = ((alo - b.RTLong__f_lo) | 0);
                var hi$4 = ((((-2147483648) ^ lo$4) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - bhi$1) | 0)) | 0) : ((ahi - bhi$1) | 0));
                var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
                var it = x19.iterator__sc_Iterator();
                while (it.hasNext__Z()) {
                  var elem = it.next__O();
                  var _$10 = $as_Lcats_effect_std_Semaphore$impl$Request(elem);
                  if ((_$10.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z(req$1$2) !== true)) {
                    b$1.addOne__O__scm_Growable(elem)
                  }
                };
                var waitingNow = $as_sci_Queue(b$1.result__O());
                var self$3 = this$26.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(new $c_RTLong(lo$3, hi$3), waitingNow);
                var y$3 = this$26.releaseN__J__O(new $c_RTLong(lo$4, hi$4));
                return new $c_T2(self$3, y$3)
              };
              throw new $c_s_MatchError(x$1$3)
            }))(this$5, n$4$2, req$2)));
            var F$1 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
            var cleanup = $f_Lcats_FlatMap__flatten__O__O(F$1, ffa);
            matchResult13: {
              var action;
              var x$2 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Done__Lcats_effect_std_Semaphore$impl$Done$();
              if ((x$2 === decision$2)) {
                var this$37 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
                var action = this$37.pure__O__O((void 0));
                break matchResult13
              };
              var x$3 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Wait__Lcats_effect_std_Semaphore$impl$Wait$();
              if ((x$3 === decision$2)) {
                var wrapped = poll$2$2.apply__O__O(req$2.Lcats_effect_std_Semaphore$impl$Request__f_gate.get__O());
                var F$2 = this$5.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
                var action = F$2.onCancel__O__O__O(wrapped, cleanup);
                break matchResult13
              };
              throw new $c_s_MatchError(decision$2)
            };
            return new $c_T2(newState$2, action)
          };
          throw new $c_s_MatchError(x$1$1)
        }))(this$4, n$3$2, poll$2, req$1)));
        var F$3 = this$4.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
        return $f_Lcats_FlatMap__flatten__O__O(F$3, ffa$1)
      }))(this$2, n$2, poll$1));
      return this$44.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$44.Lcats_FlatMap$$anon$2__f_self, f$1)
    }))(this, n)))
  }
});
$c_Lcats_effect_std_Semaphore$$anon$1.prototype.releaseN__J__O = (function(n) {
  this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.requireNonNegative__J__V(n);
  if (((n.RTLong__f_lo === 0) && (n.RTLong__f_hi === 0))) {
    var this$1 = this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
    return this$1.pure__O__O((void 0))
  } else {
    var ffa = this.Lcats_effect_std_Semaphore$$anon$1__f_state$1.modify__F1__O(new $c_sjsr_AnonFunction1(((this$2, n$2) => ((x$1) => {
      var x$1$1 = $as_Lcats_effect_std_Semaphore$impl$State(x$1);
      if ((x$1$1 !== null)) {
        var t = x$1$1.Lcats_effect_std_Semaphore$impl$State__f_permits;
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var x35 = x$1$1.Lcats_effect_std_Semaphore$impl$State__f_waiting;
        if (x35.isEmpty__Z()) {
          var $$x1 = this$2.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1;
          var bhi = n$2.RTLong__f_hi;
          var lo$1 = ((lo + n$2.RTLong__f_lo) | 0);
          var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi + bhi) | 0)) | 0) : ((hi + bhi) | 0));
          var self = $$x1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(new $c_RTLong(lo$1, hi$1), x35);
          var this$6 = this$2.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
          var y = this$6.pure__O__O((void 0));
          return new $c_T2(self, y)
        } else {
          matchResult16: {
            var \u03b43$___1;
            var \u03b43$___2;
            var \u03b43$___3;
            var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
            var x28 = $s_Lcats_effect_std_Semaphore$__cats$effect$std$Semaphore$$anon$1$$_$fulfil$1__J__sci_Queue__sci_Queue__T3(n$2, x35, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), ($m_sci_List$(), $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs))));
            if ((x28 !== null)) {
              var t$1 = $uJ(x28.T3__f__1);
              var lo$2 = t$1.RTLong__f_lo;
              var hi$2 = t$1.RTLong__f_hi;
              var waitingNow = $as_sci_Queue(x28.T3__f__2);
              var wakeup = $as_sci_Queue(x28.T3__f__3);
              var \u03b43$___1 = new $c_RTLong(lo$2, hi$2);
              var \u03b43$___2 = waitingNow;
              var \u03b43$___3 = wakeup;
              break matchResult16
            };
            throw new $c_s_MatchError(x28)
          };
          var t$2 = $uJ(\u03b43$___1);
          var lo$3 = t$2.RTLong__f_lo;
          var hi$3 = t$2.RTLong__f_hi;
          var waitingNow$2 = $as_sci_Queue(\u03b43$___2);
          var wakeup$2 = $as_sci_Queue(\u03b43$___3);
          var self$1 = this$2.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_State$lzy1.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State(new $c_RTLong(lo$3, hi$3), waitingNow$2);
          $m_Lcats_UnorderedFoldable$();
          var tc = $as_Lcats_Traverse($m_Lcats_instances_package$queue$().Lcats_instances_package$queue$__f_catsStdInstancesForQueue);
          var this$14 = new $c_Lcats_Foldable$$anon$6(wakeup$2, tc);
          var f = new $c_sjsr_AnonFunction1(((_$11) => {
            var _$11$1 = $as_Lcats_effect_std_Semaphore$impl$Request(_$11);
            return _$11$1.Lcats_effect_std_Semaphore$impl$Request__f_gate.complete__O__O((void 0))
          }));
          var G = this$2.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
          var y$1 = this$14.Lcats_Foldable$$anon$6__f_typeClassInstance.traverse___O__F1__Lcats_Applicative__O(this$14.Lcats_Foldable$$anon$6__f_self, f, G);
          return new $c_T2(self$1, y$1)
        }
      };
      throw new $c_s_MatchError(x$1$1)
    }))(this, n)));
    var F = this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
    var wrapped = $f_Lcats_FlatMap__flatten__O__O(F, ffa);
    return $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped, this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F)
  }
});
$c_Lcats_effect_std_Semaphore$$anon$1.prototype.available__O = (function() {
  var target = this.Lcats_effect_std_Semaphore$$anon$1__f_state$1.get__O();
  var tc = this.Lcats_effect_std_Semaphore$$anon$1__f_$outer.Lcats_effect_std_Semaphore$impl__f_cats$effect$std$Semaphore$impl$$F;
  var this$2 = new $c_Lcats_Functor$$anon$4(target, tc);
  var f = new $c_sjsr_AnonFunction1(((_$12) => {
    var _$12$1 = $as_Lcats_effect_std_Semaphore$impl$State(_$12);
    return _$12$1.Lcats_effect_std_Semaphore$impl$State__f_permits
  }));
  return this$2.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$2.Lcats_Functor$$anon$4__f_self, f)
});
var $d_Lcats_effect_std_Semaphore$$anon$1 = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$$anon$1: 0
}, false, "cats.effect.std.Semaphore$$anon$1", {
  Lcats_effect_std_Semaphore$$anon$1: 1,
  Lcats_effect_std_Semaphore: 1,
  O: 1
});
$c_Lcats_effect_std_Semaphore$$anon$1.prototype.$classData = $d_Lcats_effect_std_Semaphore$$anon$1;
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$1(F$7, state$3) {
  this.Lcats_effect_std_Supervisor$$anon$1__f_F$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_state$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$1__f_F$1 = F$7;
  this.Lcats_effect_std_Supervisor$$anon$1__f_state$1 = state$3
}
$c_Lcats_effect_std_Supervisor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_std_Supervisor$$anon$1.prototype = $c_Lcats_effect_std_Supervisor$$anon$1.prototype;
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.supervise__O__O = (function(fa) {
  return this.Lcats_effect_std_Supervisor$$anon$1__f_F$1.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, fa$2) => ((_$6) => {
    $as_Lcats_effect_kernel_Poll(_$6);
    var F = this$1.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
    var mk = new $c_Lcats_effect_kernel_Ref$$anon$1(F);
    var target = mk.refOf__O__O(false);
    var tc = this$1.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
    var this$27 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f$5 = new $c_sjsr_AnonFunction1(((this$5, fa$1$2) => ((done) => {
      var done$1 = $as_Lcats_effect_kernel_Ref(done);
      var target$1 = this$5.Lcats_effect_std_Supervisor$$anon$1__f_F$1.unique__O();
      var tc$1 = this$5.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
      var this$12 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
      var f = new $c_sjsr_AnonFunction1(((this$7, fa$2$2, done$2) => ((token) => {
        var token$1 = $as_Lcats_effect_kernel_Unique$Token(token);
        var cleanup = this$7.Lcats_effect_std_Supervisor$$anon$1__f_state$1.remove__Lcats_effect_kernel_Unique$Token__O(token$1);
        var fa$1 = done$2.set__O__O(true);
        var fin = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0(((cleanup$2) => (() => cleanup$2))(cleanup)), this$7.Lcats_effect_std_Supervisor$$anon$1__f_F$1);
        var F$1 = this$7.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
        var action = F$1.guarantee__O__O__O(fa$2$2, fin);
        return new $c_T3(token$1, cleanup, action)
      }))(this$5, fa$1$2, done$1));
      var target$2 = this$12.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$12.Lcats_Functor$$anon$4__f_self, f);
      var tc$2 = this$5.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
      var this$26 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$2);
      var f$4 = new $c_sjsr_AnonFunction1(((this$2$1, done$3) => ((x$1) => {
        var x$1$1 = $as_T3(x$1);
        if ((x$1$1 !== null)) {
          var token$2 = $as_Lcats_effect_kernel_Unique$Token(x$1$1.T3__f__1);
          var cleanup$1 = x$1$1.T3__f__2;
          var action$1 = x$1$1.T3__f__3;
          var target$3 = this$2$1.Lcats_effect_std_Supervisor$$anon$1__f_F$1.start__O__O(action$1);
          var tc$3 = this$2$1.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
          var this$25 = new $c_Lcats_FlatMap$$anon$2(target$3, tc$3);
          var f$3 = new $c_sjsr_AnonFunction1(((this$15, done$3$2, token$2$1, cleanup$2$1) => ((fiber) => {
            var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
            var target$4 = this$15.Lcats_effect_std_Supervisor$$anon$1__f_state$1.add__Lcats_effect_kernel_Unique$Token__O__O(token$2$1, fiber$1.cancel__O());
            var tc$4 = this$15.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
            var this$24 = new $c_Lcats_FlatMap$$anon$2(target$4, tc$4);
            var f$2 = new $c_sjsr_AnonFunction1(((this$17, done$2$2, cleanup$2$2, fiber$2) => ((x$1$2) => {
              $as_jl_Void(x$1$2);
              var fa$3 = done$2$2.get__O();
              var ifTrue = new $c_sjsr_AnonFunction0(((cleanup$3$2) => (() => cleanup$3$2))(cleanup$2$2));
              var ifFalse = new $c_sjsr_AnonFunction0(((this$19) => (() => {
                var this$20 = this$19.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
                return this$20.pure__O__O((void 0))
              }))(this$17));
              var F$2 = this$17.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
              var target$5 = $f_Lcats_FlatMap__ifM__O__F0__F0__O(F$2, fa$3, ifTrue, ifFalse);
              var tc$5 = this$17.Lcats_effect_std_Supervisor$$anon$1__f_F$1;
              var this$23 = new $c_Lcats_Functor$$anon$4(target$5, tc$5);
              var f$1 = new $c_sjsr_AnonFunction1(((fiber$1$2) => ((x$1$2$1) => {
                $as_jl_Void(x$1$2$1);
                return fiber$1$2
              }))(fiber$2));
              return this$23.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$23.Lcats_Functor$$anon$4__f_self, f$1)
            }))(this$15, done$3$2, cleanup$2$1, fiber$1));
            return this$24.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$24.Lcats_FlatMap$$anon$2__f_self, f$2)
          }))(this$2$1, done$3, token$2, cleanup$1));
          return this$25.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$25.Lcats_FlatMap$$anon$2__f_self, f$3)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(this$5, done$1));
      return this$26.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$26.Lcats_FlatMap$$anon$2__f_self, f$4)
    }))(this$1, fa$2));
    return this$27.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$27.Lcats_FlatMap$$anon$2__f_self, f$5)
  }))(this, fa)))
});
var $d_Lcats_effect_std_Supervisor$$anon$1 = new $TypeData().initClass({
  Lcats_effect_std_Supervisor$$anon$1: 0
}, false, "cats.effect.std.Supervisor$$anon$1", {
  Lcats_effect_std_Supervisor$$anon$1: 1,
  O: 1,
  Lcats_effect_std_Supervisor: 1
});
$c_Lcats_effect_std_Supervisor$$anon$1.prototype.$classData = $d_Lcats_effect_std_Supervisor$$anon$1;
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$2(F$8, stateRef$2) {
  this.Lcats_effect_std_Supervisor$$anon$2__f_F$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_stateRef$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$2__f_F$1 = F$8;
  this.Lcats_effect_std_Supervisor$$anon$2__f_stateRef$1 = stateRef$2
}
$c_Lcats_effect_std_Supervisor$$anon$2.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_std_Supervisor$$anon$2.prototype = $c_Lcats_effect_std_Supervisor$$anon$2.prototype;
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.remove__Lcats_effect_kernel_Unique$Token__O = (function(token) {
  return this.Lcats_effect_std_Supervisor$$anon$2__f_stateRef$1.update__F1__O(new $c_sjsr_AnonFunction1(((token$2) => ((_$8) => {
    var _$8$1 = $as_sci_Map(_$8);
    return $as_sci_Map(_$8$1.removed__O__sci_MapOps(token$2))
  }))(token)))
});
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.add__Lcats_effect_kernel_Unique$Token__O__O = (function(token, cancel) {
  return this.Lcats_effect_std_Supervisor$$anon$2__f_stateRef$1.update__F1__O(new $c_sjsr_AnonFunction1(((token$2, cancel$2) => ((_$9) => {
    var _$9$1 = $as_sci_Map(_$9);
    return $as_sci_Map(_$9$1.$plus__T2__sci_MapOps(new $c_T2(token$2, cancel$2)))
  }))(token, cancel)))
});
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.cancelAll__O = (function() {
  var target = this.Lcats_effect_std_Supervisor$$anon$2__f_stateRef$1.get__O();
  var tc = this.Lcats_effect_std_Supervisor$$anon$2__f_F$1;
  var this$12 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((fibers) => {
    var fibers$1 = $as_sci_Map(fibers);
    var this$3 = new $c_sc_MapOps$$anon$1(fibers$1);
    $m_sci_List$();
    var tma = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$3);
    var this$6 = $m_Lcats_effect_kernel_implicits$();
    var M = this$2.Lcats_effect_std_Supervisor$$anon$2__f_F$1;
    var P = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M, this$6);
    var F = this$2.Lcats_effect_std_Supervisor$$anon$2__f_F$1;
    var F$1 = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2(F);
    $m_Lcats_UnorderedFoldable$();
    var Tutraverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var target$1 = $m_Lcats_Parallel$().parUnorderedSequence__O__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(tma, Tutraverse, F$1, P);
    var tc$1 = this$2.Lcats_effect_std_Supervisor$$anon$2__f_F$1;
    var this$11 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
    return this$11.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$11.Lcats_Functor$$anon$4__f_self)
  }))(this));
  return this$12.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$$anon$2__f_self, f)
});
var $d_Lcats_effect_std_Supervisor$$anon$2 = new $TypeData().initClass({
  Lcats_effect_std_Supervisor$$anon$2: 0
}, false, "cats.effect.std.Supervisor$$anon$2", {
  Lcats_effect_std_Supervisor$$anon$2: 1,
  O: 1,
  Lcats_effect_std_Supervisor$State: 1
});
$c_Lcats_effect_std_Supervisor$$anon$2.prototype.$classData = $d_Lcats_effect_std_Supervisor$$anon$2;
/** @constructor */
function $c_Lcats_effect_std_Supervisor$$anon$3(F$9, state$4) {
  this.Lcats_effect_std_Supervisor$$anon$3__f_F$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_state$1 = null;
  this.Lcats_effect_std_Supervisor$$anon$3__f_F$1 = F$9;
  this.Lcats_effect_std_Supervisor$$anon$3__f_state$1 = state$4
}
$c_Lcats_effect_std_Supervisor$$anon$3.prototype = new $h_O();
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.constructor = $c_Lcats_effect_std_Supervisor$$anon$3;
/** @constructor */
function $h_Lcats_effect_std_Supervisor$$anon$3() {
  /*<skip>*/
}
$h_Lcats_effect_std_Supervisor$$anon$3.prototype = $c_Lcats_effect_std_Supervisor$$anon$3.prototype;
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.remove__Lcats_effect_kernel_Unique$Token__O = (function(token) {
  var target = this.Lcats_effect_std_Supervisor$$anon$3__f_F$1.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, token$2) => (() => this$1.Lcats_effect_std_Supervisor$$anon$3__f_state$1.remove__O__O(token$2)))(this, token)));
  var tc = this.Lcats_effect_std_Supervisor$$anon$3__f_F$1;
  var this$3 = new $c_Lcats_Functor$$anon$4(target, tc);
  return this$3.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$3.Lcats_Functor$$anon$4__f_self)
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.add__Lcats_effect_kernel_Unique$Token__O__O = (function(token, cancel) {
  var target = this.Lcats_effect_std_Supervisor$$anon$3__f_F$1.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, token$2, cancel$2) => (() => this$1.Lcats_effect_std_Supervisor$$anon$3__f_state$1.put__O__O__O(token$2, cancel$2)))(this, token, cancel)));
  var tc = this.Lcats_effect_std_Supervisor$$anon$3__f_F$1;
  var this$3 = new $c_Lcats_Functor$$anon$4(target, tc);
  return this$3.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$3.Lcats_Functor$$anon$4__f_self)
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.cancelAll__O = (function() {
  var this$10 = this.Lcats_effect_std_Supervisor$$anon$3__f_F$1;
  var thunk = new $c_sjsr_AnonFunction0(((this$1) => (() => {
    var fibersToCancel = new $c_scm_ListBuffer();
    this$1.Lcats_effect_std_Supervisor$$anon$3__f_state$1.size__I();
    var values = this$1.Lcats_effect_std_Supervisor$$anon$3__f_state$1.values__ju_Collection().iterator__ju_Iterator();
    while (values.hasNext__Z()) {
      var elem = values.next__O();
      fibersToCancel.addOne__O__scm_ListBuffer(elem)
    };
    var tma = fibersToCancel.toList__sci_List();
    var this$4 = $m_Lcats_effect_kernel_implicits$();
    var M = this$1.Lcats_effect_std_Supervisor$$anon$3__f_F$1;
    var P = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M, this$4);
    var F = this$1.Lcats_effect_std_Supervisor$$anon$3__f_F$1;
    var F$1 = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2(F);
    $m_Lcats_UnorderedFoldable$();
    var Tutraverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    var target = $m_Lcats_Parallel$().parUnorderedSequence__O__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(tma, Tutraverse, F$1, P);
    var tc = this$1.Lcats_effect_std_Supervisor$$anon$3__f_F$1;
    var this$9 = new $c_Lcats_Functor$$anon$4(target, tc);
    return this$9.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$9.Lcats_Functor$$anon$4__f_self)
  }))(this));
  return $f_Lcats_effect_kernel_Sync__defer__F0__O(this$10, thunk)
});
var $d_Lcats_effect_std_Supervisor$$anon$3 = new $TypeData().initClass({
  Lcats_effect_std_Supervisor$$anon$3: 0
}, false, "cats.effect.std.Supervisor$$anon$3", {
  Lcats_effect_std_Supervisor$$anon$3: 1,
  O: 1,
  Lcats_effect_std_Supervisor$State: 1
});
$c_Lcats_effect_std_Supervisor$$anon$3.prototype.$classData = $d_Lcats_effect_std_Supervisor$$anon$3;
function $p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, ste) {
  var name = ste.jl_StackTraceElement__f_declaringClass;
  var i = 0;
  var len = $thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter.u.length;
  while ((i < len)) {
    var prefix = $thiz.Lcats_effect_tracing_Tracing$__f_runLoopFilter.get(i);
    if ((($uI(name.length) >= 0) && ($as_T(name.substring(0, $uI(prefix.length))) === prefix))) {
      return true
    };
    i = ((1 + i) | 0)
  };
  return false
}
function $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement($thiz, frames) {
  var buffer = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
  var i = 0;
  var len = frames.u.length;
  while ((i < len)) {
    var frame = frames.get(i);
    if ((!$p_Lcats_effect_tracing_Tracing$__applyRunLoopFilter$1__jl_StackTraceElement__Z($thiz, frame))) {
      buffer.addOne__O__scm_ArrayBuffer(frame)
    } else if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
      var len$1 = buffer.scm_ArrayBuffer__f_size0;
      var destination = new ($d_jl_StackTraceElement.getArrayOf().constr)(len$1);
      buffer.copyToArray__O__I__I__I(destination, 0, 2147483647);
      return destination
    } else {
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var it = buffer.view__scm_ArrayBufferView().iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var elem = it.next__O();
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem)
      };
      return new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems)
    };
    i = ((1 + i) | 0)
  };
  if ((buffer.scm_ArrayBuffer__f_size0 >= 0)) {
    var len$2 = buffer.scm_ArrayBuffer__f_size0;
    var destination$1 = new ($d_jl_StackTraceElement.getArrayOf().constr)(len$2);
    buffer.copyToArray__O__I__I__I(destination$1, 0, 2147483647);
    return destination$1
  } else {
    var capacity$1 = 0;
    var size$1 = 0;
    var jsElems$1 = null;
    capacity$1 = 0;
    size$1 = 0;
    jsElems$1 = [];
    var it$1 = buffer.view__scm_ArrayBufferView().iterator__sc_Iterator();
    while (it$1.hasNext__Z()) {
      var elem$1 = it$1.next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems$1.push(unboxedElem$1)
    };
    return new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems$1)
  }
}
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$() {
  this.Lcats_effect_tracing_TracingPlatform__f_cache = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function0Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_function1Property = null;
  this.Lcats_effect_tracing_TracingPlatform__f_calculateTracingEvent = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceFileNameFilter = null;
  this.Lcats_effect_tracing_TracingPlatform__f_stackTraceMethodNameFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_TurnRight = null;
  this.Lcats_effect_tracing_Tracing$__f_Junction = null;
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = null;
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = null;
  $ct_Lcats_effect_tracing_TracingPlatform__(this);
  $n_Lcats_effect_tracing_Tracing$ = this;
  this.Lcats_effect_tracing_Tracing$__f_TurnRight = "\u2570";
  this.Lcats_effect_tracing_Tracing$__f_Junction = "\u251c";
  this.Lcats_effect_tracing_Tracing$__f_runLoopFilter = new ($d_T.getArrayOf().constr)(["cats.effect.", "scala.runtime.", "scala.scalajs.runtime."]);
  this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter = new ($d_T.getArrayOf().constr)(["cats.", "sbt.", "java.", "jdk.", "sun.", "scala.", "org.scalajs."])
}
$c_Lcats_effect_tracing_Tracing$.prototype = new $h_Lcats_effect_tracing_TracingPlatform();
$c_Lcats_effect_tracing_Tracing$.prototype.constructor = $c_Lcats_effect_tracing_Tracing$;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$() {
  /*<skip>*/
}
$h_Lcats_effect_tracing_Tracing$.prototype = $c_Lcats_effect_tracing_Tracing$.prototype;
$c_Lcats_effect_tracing_Tracing$.prototype.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement = (function(methodSite, callSite) {
  var methodSiteMethodName = methodSite.jl_StackTraceElement__f_methodName;
  var op = this.decodeMethodName__T__T(methodSiteMethodName);
  return new $c_jl_StackTraceElement(((op + " @ ") + callSite.jl_StackTraceElement__f_declaringClass), callSite.jl_StackTraceElement__f_methodName, callSite.jl_StackTraceElement__f_fileName, callSite.jl_StackTraceElement__f_lineNumber)
});
$c_Lcats_effect_tracing_Tracing$.prototype.isInternalClass__T__Z = (function(className) {
  var i = 0;
  var len = this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter.u.length;
  while ((i < len)) {
    var prefix = this.Lcats_effect_tracing_Tracing$__f_stackTraceClassNameFilter.get(i);
    if ((($uI(className.length) >= 0) && ($as_T(className.substring(0, $uI(prefix.length))) === prefix))) {
      return true
    };
    i = ((1 + i) | 0)
  };
  return false
});
$c_Lcats_effect_tracing_Tracing$.prototype.cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement = (function(stackTrace) {
  var len = stackTrace.u.length;
  var idx = 1;
  while ((idx < len)) {
    var methodSite = stackTrace.get((((-1) + idx) | 0));
    var callSite = stackTrace.get(idx);
    var callSiteClassName = callSite.jl_StackTraceElement__f_declaringClass;
    var callSiteMethodName = callSite.jl_StackTraceElement__f_methodName;
    var callSiteFileName = callSite.jl_StackTraceElement__f_fileName;
    if ((!this.applyStackTraceFilter__T__T__T__Z(callSiteClassName, callSiteMethodName, callSiteFileName))) {
      return this.combineOpAndCallSite__jl_StackTraceElement__jl_StackTraceElement__jl_StackTraceElement(methodSite, callSite)
    };
    idx = ((1 + idx) | 0)
  };
  return null
});
$c_Lcats_effect_tracing_Tracing$.prototype.augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V = (function(enhancedExceptions, t, events) {
  if (($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing && enhancedExceptions)) {
    var stackTrace = t.getStackTrace__Ajl_StackTraceElement();
    if ((stackTrace.u.length !== 0)) {
      var augmented = ($f_T__indexOf__I__I($as_jl_StackTraceElement($m_sc_ArrayOps$().last$extension__O__O(stackTrace)).jl_StackTraceElement__f_declaringClass, 64) !== (-1));
      if ((!augmented)) {
        var prefix = $p_Lcats_effect_tracing_Tracing$__dropRunLoopFrames$1__Ajl_StackTraceElement__Ajl_StackTraceElement(this, stackTrace);
        var this$5 = this.getFrames__Lcats_effect_tracing_RingBuffer__sci_List(events);
        if ((this$5.knownSize__I() >= 0)) {
          var len = this$5.knownSize__I();
          var destination = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
          $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$5, destination, 0, 2147483647);
          var suffix = destination
        } else {
          var capacity = 0;
          var size = 0;
          var jsElems = null;
          capacity = 0;
          size = 0;
          jsElems = [];
          var it = this$5.iterator__sc_Iterator();
          while (it.hasNext__Z()) {
            var elem = it.next__O();
            var unboxedElem = ((elem === null) ? null : elem);
            jsElems.push(unboxedElem)
          };
          var suffix = new ($d_jl_StackTraceElement.getArrayOf().constr)(jsElems)
        };
        var this$12 = $m_s_Array$();
        var newLength = ((prefix.u.length + suffix.u.length) | 0);
        if ($d_jl_StackTraceElement.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(prefix).getComponentType__jl_Class())) {
          var dest$1 = ($d_jl_StackTraceElement.getClassOf().isPrimitive__Z() ? this$12.copyOf__O__I__O(prefix, newLength) : $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(prefix, newLength, $d_jl_StackTraceElement.getArrayOf().getClassOf()))
        } else {
          var dest = new ($d_jl_StackTraceElement.getArrayOf().constr)(newLength);
          $m_s_Array$().copy__O__I__O__I__I__V(prefix, 0, dest, 0, prefix.u.length);
          var dest$1 = dest
        };
        $m_s_Array$().copy__O__I__O__I__I__V(suffix, 0, dest$1, prefix.u.length, suffix.u.length);
        t.setStackTrace__Ajl_StackTraceElement__V($asArrayOf_jl_StackTraceElement(dest$1, 1))
      }
    }
  }
});
$c_Lcats_effect_tracing_Tracing$.prototype.getFrames__Lcats_effect_tracing_RingBuffer__sci_List = (function(events) {
  var this$2 = events.toList__sci_List().collect__s_PartialFunction__sci_List(new $c_Lcats_effect_tracing_Tracing$$anon$1());
  var f = ((_$1) => {
    var _$1$1 = $as_jl_StackTraceElement(_$1);
    return (_$1$1 !== null)
  });
  var l = this$2;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = l.head__O();
        var t = $as_sci_List(l.tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue
        };
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = remaining.head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List(remaining.tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List(start.tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List(toProcess.tail__O())
            };
            var next = $as_sci_List(firstMiss.tail__O());
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List(next.tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List(nextToCopy.tail__O())
                };
                nextToCopy = $as_sci_List(next.tail__O());
                next = $as_sci_List(next.tail__O())
              }
            };
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  return result
});
function $as_Lcats_effect_tracing_Tracing$(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_Tracing$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.Tracing$"))
}
function $isArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_Tracing$)))
}
function $asArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_Tracing$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.Tracing$;", depth))
}
var $d_Lcats_effect_tracing_Tracing$ = new $TypeData().initClass({
  Lcats_effect_tracing_Tracing$: 0
}, false, "cats.effect.tracing.Tracing$", {
  Lcats_effect_tracing_Tracing$: 1,
  Lcats_effect_tracing_TracingPlatform: 1,
  O: 1
});
$c_Lcats_effect_tracing_Tracing$.prototype.$classData = $d_Lcats_effect_tracing_Tracing$;
var $n_Lcats_effect_tracing_Tracing$;
function $m_Lcats_effect_tracing_Tracing$() {
  if ((!$n_Lcats_effect_tracing_Tracing$)) {
    $n_Lcats_effect_tracing_Tracing$ = new $c_Lcats_effect_tracing_Tracing$()
  };
  return $n_Lcats_effect_tracing_Tracing$
}
/** @constructor */
function $c_Lcats_effect_unsafe_FiberAwareExecutionContext(ec) {
  this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_ec = null;
  this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_fiberBag = null;
  this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_ec = ec;
  this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_fiberBag = $as_scm_Set($m_scm_Set$().empty__O())
}
$c_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype.constructor = $c_Lcats_effect_unsafe_FiberAwareExecutionContext;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberAwareExecutionContext() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype = $c_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype;
$c_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype.execute__jl_Runnable__V = (function(runnable) {
  if ((runnable instanceof $c_Lcats_effect_IOFiber)) {
    var r = $as_Lcats_effect_IOFiber(runnable);
    var this$1 = this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_fiberBag;
    this$1.addOne__O__scm_Growable(r);
    this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_ec.execute__jl_Runnable__V(new $c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1(r, this))
  } else {
    runnable.run__V()
  }
});
$c_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype.reportFailure__jl_Throwable__V = (function(cause) {
  this.Lcats_effect_unsafe_FiberAwareExecutionContext__f_ec.reportFailure__jl_Throwable__V(cause)
});
function $as_Lcats_effect_unsafe_FiberAwareExecutionContext(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_FiberAwareExecutionContext) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.FiberAwareExecutionContext"))
}
function $isArrayOf_Lcats_effect_unsafe_FiberAwareExecutionContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_FiberAwareExecutionContext)))
}
function $asArrayOf_Lcats_effect_unsafe_FiberAwareExecutionContext(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_FiberAwareExecutionContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.FiberAwareExecutionContext;", depth))
}
var $d_Lcats_effect_unsafe_FiberAwareExecutionContext = new $TypeData().initClass({
  Lcats_effect_unsafe_FiberAwareExecutionContext: 0
}, false, "cats.effect.unsafe.FiberAwareExecutionContext", {
  Lcats_effect_unsafe_FiberAwareExecutionContext: 1,
  O: 1,
  s_concurrent_ExecutionContext: 1
});
$c_Lcats_effect_unsafe_FiberAwareExecutionContext.prototype.$classData = $d_Lcats_effect_unsafe_FiberAwareExecutionContext;
/** @constructor */
function $c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1(r$3, outer) {
  this.Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1__f_r$1 = null;
  this.Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1__f_$outer = null;
  this.Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1__f_r$1 = r$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1__f_$outer = outer
}
$c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1.prototype = $c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1.prototype;
$c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1.prototype.run__V = (function() {
  var this$1 = this.Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1__f_$outer;
  var r$1 = this.Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1__f_r$1;
  var this$2 = this$1.Lcats_effect_unsafe_FiberAwareExecutionContext__f_fiberBag;
  this$2.subtractOne__O__scm_Shrinkable(r$1);
  r$1.run__V()
});
var $d_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1 = new $TypeData().initClass({
  Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1: 0
}, false, "cats.effect.unsafe.FiberAwareExecutionContext$$anon$1", {
  Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1: 1,
  O: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1.prototype.$classData = $d_Lcats_effect_unsafe_FiberAwareExecutionContext$$anon$1;
/** @constructor */
function $c_Lcats_effect_unsafe_FiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null
}
$c_Lcats_effect_unsafe_FiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitorShared();
$c_Lcats_effect_unsafe_FiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_FiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_FiberMonitor() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_FiberMonitor.prototype = $c_Lcats_effect_unsafe_FiberMonitor.prototype;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntime$() {
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f__global = null;
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_global$lzy1 = null;
  this.Lcats_effect_unsafe_IORuntimeCompanionPlatform__f_globalbitmap$1 = false;
  $ct_Lcats_effect_unsafe_IORuntimeCompanionPlatform__(this)
}
$c_Lcats_effect_unsafe_IORuntime$.prototype = new $h_Lcats_effect_unsafe_IORuntimeCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntime$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntime$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntime$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_IORuntime$.prototype = $c_Lcats_effect_unsafe_IORuntime$.prototype;
$c_Lcats_effect_unsafe_IORuntime$.prototype.apply__s_concurrent_ExecutionContext__s_concurrent_ExecutionContext__Lcats_effect_unsafe_Scheduler__F0__Lcats_effect_unsafe_IORuntimeConfig__Lcats_effect_unsafe_IORuntime = (function(compute, blocking, scheduler, shutdown, config) {
  return new $c_Lcats_effect_unsafe_IORuntime(compute, blocking, scheduler, $m_Lcats_effect_unsafe_FiberMonitor$().apply__s_concurrent_ExecutionContext__Lcats_effect_unsafe_FiberMonitor(compute), shutdown, config)
});
var $d_Lcats_effect_unsafe_IORuntime$ = new $TypeData().initClass({
  Lcats_effect_unsafe_IORuntime$: 0
}, false, "cats.effect.unsafe.IORuntime$", {
  Lcats_effect_unsafe_IORuntime$: 1,
  Lcats_effect_unsafe_IORuntimeCompanionPlatform: 1,
  O: 1
});
$c_Lcats_effect_unsafe_IORuntime$.prototype.$classData = $d_Lcats_effect_unsafe_IORuntime$;
var $n_Lcats_effect_unsafe_IORuntime$;
function $m_Lcats_effect_unsafe_IORuntime$() {
  if ((!$n_Lcats_effect_unsafe_IORuntime$)) {
    $n_Lcats_effect_unsafe_IORuntime$ = new $c_Lcats_effect_unsafe_IORuntime$()
  };
  return $n_Lcats_effect_unsafe_IORuntime$
}
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.deregister__V = (function() {
  /*<skip>*/
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1 = new $TypeData().initClass({
  Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1: 0
}, false, "cats.effect.unsafe.NoOpFiberMonitor$$anon$1", {
  Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1: 1,
  O: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
});
$c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1.prototype.$classData = $d_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1;
/** @constructor */
function $c_Lcats_effect_unsafe_Scheduler$() {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout = null;
  $ct_Lcats_effect_unsafe_SchedulerCompanionPlatform__(this)
}
$c_Lcats_effect_unsafe_Scheduler$.prototype = new $h_Lcats_effect_unsafe_SchedulerCompanionPlatform();
$c_Lcats_effect_unsafe_Scheduler$.prototype.constructor = $c_Lcats_effect_unsafe_Scheduler$;
/** @constructor */
function $h_Lcats_effect_unsafe_Scheduler$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_Scheduler$.prototype = $c_Lcats_effect_unsafe_Scheduler$.prototype;
var $d_Lcats_effect_unsafe_Scheduler$ = new $TypeData().initClass({
  Lcats_effect_unsafe_Scheduler$: 0
}, false, "cats.effect.unsafe.Scheduler$", {
  Lcats_effect_unsafe_Scheduler$: 1,
  Lcats_effect_unsafe_SchedulerCompanionPlatform: 1,
  O: 1
});
$c_Lcats_effect_unsafe_Scheduler$.prototype.$classData = $d_Lcats_effect_unsafe_Scheduler$;
var $n_Lcats_effect_unsafe_Scheduler$;
function $m_Lcats_effect_unsafe_Scheduler$() {
  if ((!$n_Lcats_effect_unsafe_Scheduler$)) {
    $n_Lcats_effect_unsafe_Scheduler$ = new $c_Lcats_effect_unsafe_Scheduler$()
  };
  return $n_Lcats_effect_unsafe_Scheduler$
}
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1(outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_$outer = outer
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable = (function(delay, task) {
  var that = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout;
  if ($f_s_math_Ordered__$less$eq__O__Z(delay, that)) {
    var handle = $m_sjs_js_timers_package$().setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle(delay, new $c_sjsr_AnonFunction0(((task$2) => (() => {
      task$2.run__V()
    }))(task)));
    return new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2(handle, this)
  } else {
    var elem = new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(this);
    var cancel = new $c_sr_ObjectRef(elem);
    var ev$2 = this.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout, new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(delay, task, cancel, this));
    cancel.sr_ObjectRef__f_elem = ev$2;
    return new $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(cancel, this)
  }
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1 = new $TypeData().initClass({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1: 0
}, false, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$1", {
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1: 1,
  O: 1,
  Lcats_effect_unsafe_Scheduler: 1
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1.prototype.$classData = $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1;
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2(handle$3, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2__f_handle$1 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2__f_handle$1 = handle$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.run__V = (function() {
  var handle$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2__f_handle$1;
  $m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(handle$1)
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2 = new $TypeData().initClass({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2: 0
}, false, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$2", {
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2: 1,
  O: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2.prototype.$classData = $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$2;
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.run__V = (function() {
  /*<skip>*/
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3 = new $TypeData().initClass({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3: 0
}, false, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$3", {
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3: 1,
  O: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3.prototype.$classData = $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$3;
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4(delay$3, task$5, cancel$5, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_delay$1 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_task$1 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_cancel$1 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_$outer = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_delay$1 = delay$3;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_task$1 = task$5;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_cancel$1 = cancel$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_$outer = outer
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.run__V = (function() {
  var this$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_$outer;
  var delay$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_delay$1;
  var task$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_task$1;
  var cancel$1 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4__f_cancel$1;
  var ev$1 = this$1.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(delay$1.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration(this$1.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$1__f_$outer.Lcats_effect_unsafe_SchedulerCompanionPlatform__f_cats$effect$unsafe$SchedulerCompanionPlatform$$maxTimeout), task$2);
  cancel$1.sr_ObjectRef__f_elem = ev$1
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4 = new $TypeData().initClass({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4: 0
}, false, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$4", {
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4: 1,
  O: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4.prototype.$classData = $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$4;
/** @constructor */
function $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5(cancel$6, outer) {
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$1 = null;
  this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$1 = cancel$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = new $h_O();
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.constructor = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5;
/** @constructor */
function $h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype = $c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype;
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.run__V = (function() {
  var cancel$2 = this.Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5__f_cancel$1;
  $as_jl_Runnable(cancel$2.sr_ObjectRef__f_elem).run__V()
});
var $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5 = new $TypeData().initClass({
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5: 0
}, false, "cats.effect.unsafe.SchedulerCompanionPlatform$$anon$5", {
  Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5: 1,
  O: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5.prototype.$classData = $d_Lcats_effect_unsafe_SchedulerCompanionPlatform$$anon$5;
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  }
}
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype = new $h_O();
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag$$anon$1;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_WeakBag$$anon$1.prototype = $c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype;
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.deregister__V = (function() {
  /*<skip>*/
});
var $d_Lcats_effect_unsafe_WeakBag$$anon$1 = new $TypeData().initClass({
  Lcats_effect_unsafe_WeakBag$$anon$1: 0
}, false, "cats.effect.unsafe.WeakBag$$anon$1", {
  Lcats_effect_unsafe_WeakBag$$anon$1: 1,
  O: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
});
$c_Lcats_effect_unsafe_WeakBag$$anon$1.prototype.$classData = $d_Lcats_effect_unsafe_WeakBag$$anon$1;
function $as_Lcats_effect_unsafe_WorkStealingThreadPool(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WorkStealingThreadPool"))
}
function $isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WorkStealingThreadPool)))
}
function $asArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WorkStealingThreadPool(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WorkStealingThreadPool;", depth))
}
/** @constructor */
function $c_Lcats_effect_unsafe_ref_WeakReference() {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_weakRef = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false
}
$c_Lcats_effect_unsafe_ref_WeakReference.prototype = new $h_Lcats_effect_unsafe_ref_Reference();
$c_Lcats_effect_unsafe_ref_WeakReference.prototype.constructor = $c_Lcats_effect_unsafe_ref_WeakReference;
/** @constructor */
function $h_Lcats_effect_unsafe_ref_WeakReference() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_ref_WeakReference.prototype = $c_Lcats_effect_unsafe_ref_WeakReference.prototype;
/** @constructor */
function $c_Lcats_evidence_As() {
  /*<skip>*/
}
$c_Lcats_evidence_As.prototype = new $h_O();
$c_Lcats_evidence_As.prototype.constructor = $c_Lcats_evidence_As;
/** @constructor */
function $h_Lcats_evidence_As() {
  /*<skip>*/
}
$h_Lcats_evidence_As.prototype = $c_Lcats_evidence_As.prototype;
function $ps_Lcats_instances_Function0Instances__loop$1__F1__O__O(fn$4, thisA) {
  var thisA$tailLocal1 = thisA;
  while (true) {
    var x17 = $as_s_util_Either($as_F0(fn$4.apply__O__O(thisA$tailLocal1)).apply__O());
    if ((x17 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x17).s_util_Right__f_value;
      return b
    };
    if ((x17 instanceof $c_s_util_Left)) {
      var nextA = $as_s_util_Left(x17).s_util_Left__f_value;
      thisA$tailLocal1 = nextA;
      continue
    };
    throw new $c_s_MatchError(x17)
  }
}
function $f_Lcats_instances_Function1Instances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsStdInstancesForFunction1 = new $c_Lcats_instances_Function1Instances$$anon$1();
  $thiz.Lcats_implicits$__f_catsStdMonoidKForFunction1 = new $c_Lcats_instances_Function1Instances$$anon$2($thiz)
}
/** @constructor */
function $c_Lcats_instances_package$equiv$() {
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = null;
  $n_Lcats_instances_package$equiv$ = this;
  this.Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1()
}
$c_Lcats_instances_package$equiv$.prototype = new $h_O();
$c_Lcats_instances_package$equiv$.prototype.constructor = $c_Lcats_instances_package$equiv$;
/** @constructor */
function $h_Lcats_instances_package$equiv$() {
  /*<skip>*/
}
$h_Lcats_instances_package$equiv$.prototype = $c_Lcats_instances_package$equiv$.prototype;
var $d_Lcats_instances_package$equiv$ = new $TypeData().initClass({
  Lcats_instances_package$equiv$: 0
}, false, "cats.instances.package$equiv$", {
  Lcats_instances_package$equiv$: 1,
  O: 1,
  Lcats_instances_EquivInstances: 1
});
$c_Lcats_instances_package$equiv$.prototype.$classData = $d_Lcats_instances_package$equiv$;
var $n_Lcats_instances_package$equiv$;
function $m_Lcats_instances_package$equiv$() {
  if ((!$n_Lcats_instances_package$equiv$)) {
    $n_Lcats_instances_package$equiv$ = new $c_Lcats_instances_package$equiv$()
  };
  return $n_Lcats_instances_package$equiv$
}
/** @constructor */
function $c_Lcats_instances_package$ordering$() {
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = null;
  $n_Lcats_instances_package$ordering$ = this;
  this.Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1()
}
$c_Lcats_instances_package$ordering$.prototype = new $h_O();
$c_Lcats_instances_package$ordering$.prototype.constructor = $c_Lcats_instances_package$ordering$;
/** @constructor */
function $h_Lcats_instances_package$ordering$() {
  /*<skip>*/
}
$h_Lcats_instances_package$ordering$.prototype = $c_Lcats_instances_package$ordering$.prototype;
var $d_Lcats_instances_package$ordering$ = new $TypeData().initClass({
  Lcats_instances_package$ordering$: 0
}, false, "cats.instances.package$ordering$", {
  Lcats_instances_package$ordering$: 1,
  O: 1,
  Lcats_instances_OrderingInstances: 1
});
$c_Lcats_instances_package$ordering$.prototype.$classData = $d_Lcats_instances_package$ordering$;
var $n_Lcats_instances_package$ordering$;
function $m_Lcats_instances_package$ordering$() {
  if ((!$n_Lcats_instances_package$ordering$)) {
    $n_Lcats_instances_package$ordering$ = new $c_Lcats_instances_package$ordering$()
  };
  return $n_Lcats_instances_package$ordering$
}
/** @constructor */
function $c_Lcats_instances_package$partialOrdering$() {
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = null;
  $n_Lcats_instances_package$partialOrdering$ = this;
  this.Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1()
}
$c_Lcats_instances_package$partialOrdering$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrdering$.prototype.constructor = $c_Lcats_instances_package$partialOrdering$;
/** @constructor */
function $h_Lcats_instances_package$partialOrdering$() {
  /*<skip>*/
}
$h_Lcats_instances_package$partialOrdering$.prototype = $c_Lcats_instances_package$partialOrdering$.prototype;
var $d_Lcats_instances_package$partialOrdering$ = new $TypeData().initClass({
  Lcats_instances_package$partialOrdering$: 0
}, false, "cats.instances.package$partialOrdering$", {
  Lcats_instances_package$partialOrdering$: 1,
  O: 1,
  Lcats_instances_PartialOrderingInstances: 1
});
$c_Lcats_instances_package$partialOrdering$.prototype.$classData = $d_Lcats_instances_package$partialOrdering$;
var $n_Lcats_instances_package$partialOrdering$;
function $m_Lcats_instances_package$partialOrdering$() {
  if ((!$n_Lcats_instances_package$partialOrdering$)) {
    $n_Lcats_instances_package$partialOrdering$ = new $c_Lcats_instances_package$partialOrdering$()
  };
  return $n_Lcats_instances_package$partialOrdering$
}
function $is_Lcats_kernel_Eq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Eq)))
}
function $as_Lcats_kernel_Eq(obj) {
  return (($is_Lcats_kernel_Eq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Eq"))
}
function $isArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Eq)))
}
function $asArrayOf_Lcats_kernel_Eq(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Eq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Eq;", depth))
}
/** @constructor */
function $c_Lcats_kernel_HashFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_HashFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_HashFunctions.prototype.constructor = $c_Lcats_kernel_HashFunctions;
/** @constructor */
function $h_Lcats_kernel_HashFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_HashFunctions.prototype = $c_Lcats_kernel_HashFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_MonoidFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_MonoidFunctions.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_MonoidFunctions.prototype.constructor = $c_Lcats_kernel_MonoidFunctions;
/** @constructor */
function $h_Lcats_kernel_MonoidFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_MonoidFunctions.prototype = $c_Lcats_kernel_MonoidFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_PartialOrderFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_PartialOrderFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_PartialOrderFunctions.prototype.constructor = $c_Lcats_kernel_PartialOrderFunctions;
/** @constructor */
function $h_Lcats_kernel_PartialOrderFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrderFunctions.prototype = $c_Lcats_kernel_PartialOrderFunctions.prototype;
function $is_Lcats_kernel_Semigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Semigroup)))
}
function $as_Lcats_kernel_Semigroup(obj) {
  return (($is_Lcats_kernel_Semigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Semigroup"))
}
function $isArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Semigroup)))
}
function $asArrayOf_Lcats_kernel_Semigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Semigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Semigroup;", depth))
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StaticMethods$.prototype = new $h_Lcats_kernel_compat_HashCompat();
$c_Lcats_kernel_instances_StaticMethods$.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StaticMethods$.prototype = $c_Lcats_kernel_instances_StaticMethods$.prototype;
var $d_Lcats_kernel_instances_StaticMethods$ = new $TypeData().initClass({
  Lcats_kernel_instances_StaticMethods$: 0
}, false, "cats.kernel.instances.StaticMethods$", {
  Lcats_kernel_instances_StaticMethods$: 1,
  Lcats_kernel_compat_HashCompat: 1,
  O: 1
});
$c_Lcats_kernel_instances_StaticMethods$.prototype.$classData = $d_Lcats_kernel_instances_StaticMethods$;
var $n_Lcats_kernel_instances_StaticMethods$;
function $m_Lcats_kernel_instances_StaticMethods$() {
  if ((!$n_Lcats_kernel_instances_StaticMethods$)) {
    $n_Lcats_kernel_instances_StaticMethods$ = new $c_Lcats_kernel_instances_StaticMethods$()
  };
  return $n_Lcats_kernel_instances_StaticMethods$
}
/** @constructor */
function $c_Lcats_kernel_instances_long_package$() {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong = null;
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = null;
  $n_Lcats_kernel_instances_long_package$ = this;
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this)
}
$c_Lcats_kernel_instances_long_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_long_package$.prototype.constructor = $c_Lcats_kernel_instances_long_package$;
/** @constructor */
function $h_Lcats_kernel_instances_long_package$() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_long_package$.prototype = $c_Lcats_kernel_instances_long_package$.prototype;
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong = x$0
});
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = x$0
});
var $d_Lcats_kernel_instances_long_package$ = new $TypeData().initClass({
  Lcats_kernel_instances_long_package$: 0
}, false, "cats.kernel.instances.long.package$", {
  Lcats_kernel_instances_long_package$: 1,
  O: 1,
  Lcats_kernel_instances_LongInstances: 1
});
$c_Lcats_kernel_instances_long_package$.prototype.$classData = $d_Lcats_kernel_instances_long_package$;
var $n_Lcats_kernel_instances_long_package$;
function $m_Lcats_kernel_instances_long_package$() {
  if ((!$n_Lcats_kernel_instances_long_package$)) {
    $n_Lcats_kernel_instances_long_package$ = new $c_Lcats_kernel_instances_long_package$()
  };
  return $n_Lcats_kernel_instances_long_package$
}
/** @constructor */
function $c_Lcats_syntax_Tuple2SemigroupalOps(t2) {
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t2 = null;
  this.Lcats_syntax_Tuple2SemigroupalOps__f_t2 = t2
}
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple2SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple2SemigroupalOps() {
  /*<skip>*/
}
$h_Lcats_syntax_Tuple2SemigroupalOps.prototype = $c_Lcats_syntax_Tuple2SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.mapN__F2__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = this.Lcats_syntax_Tuple2SemigroupalOps__f_t2._1__O();
  var f1 = this.Lcats_syntax_Tuple2SemigroupalOps__f_t2._2__O();
  return $f_Lcats_SemigroupalArityFunctions__map2__O__O__F2__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f, semigroupal, functor)
});
var $d_Lcats_syntax_Tuple2SemigroupalOps = new $TypeData().initClass({
  Lcats_syntax_Tuple2SemigroupalOps: 0
}, false, "cats.syntax.Tuple2SemigroupalOps", {
  Lcats_syntax_Tuple2SemigroupalOps: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_syntax_Tuple2SemigroupalOps.prototype.$classData = $d_Lcats_syntax_Tuple2SemigroupalOps;
/** @constructor */
function $c_Lcats_syntax_Tuple4SemigroupalOps(t4) {
  this.Lcats_syntax_Tuple4SemigroupalOps__f_t4 = null;
  this.Lcats_syntax_Tuple4SemigroupalOps__f_t4 = t4
}
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype = new $h_O();
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.constructor = $c_Lcats_syntax_Tuple4SemigroupalOps;
/** @constructor */
function $h_Lcats_syntax_Tuple4SemigroupalOps() {
  /*<skip>*/
}
$h_Lcats_syntax_Tuple4SemigroupalOps.prototype = $c_Lcats_syntax_Tuple4SemigroupalOps.prototype;
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.mapN__F4__Lcats_Functor__Lcats_Semigroupal__O = (function(f, functor, semigroupal) {
  var this$1 = $m_Lcats_Semigroupal$();
  var f0 = this.Lcats_syntax_Tuple4SemigroupalOps__f_t4.T4__f__1;
  var f1 = this.Lcats_syntax_Tuple4SemigroupalOps__f_t4.T4__f__2;
  var f2 = this.Lcats_syntax_Tuple4SemigroupalOps__f_t4.T4__f__3;
  var f3 = this.Lcats_syntax_Tuple4SemigroupalOps__f_t4.T4__f__4;
  return $f_Lcats_SemigroupalArityFunctions__map4__O__O__O__O__F4__Lcats_Semigroupal__Lcats_Functor__O(this$1, f0, f1, f2, f3, f, semigroupal, functor)
});
var $d_Lcats_syntax_Tuple4SemigroupalOps = new $TypeData().initClass({
  Lcats_syntax_Tuple4SemigroupalOps: 0
}, false, "cats.syntax.Tuple4SemigroupalOps", {
  Lcats_syntax_Tuple4SemigroupalOps: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_syntax_Tuple4SemigroupalOps.prototype.$classData = $d_Lcats_syntax_Tuple4SemigroupalOps;
/** @constructor */
function $c_Lfs2_Compiler$$anon$5() {
  this.Lfs2_Compiler$$anon$5__f_target = null;
  $m_Lcats_Invariant$();
  var e = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  this.Lfs2_Compiler$$anon$5__f_target = e
}
$c_Lfs2_Compiler$$anon$5.prototype = new $h_O();
$c_Lfs2_Compiler$$anon$5.prototype.constructor = $c_Lfs2_Compiler$$anon$5;
/** @constructor */
function $h_Lfs2_Compiler$$anon$5() {
  /*<skip>*/
}
$h_Lfs2_Compiler$$anon$5.prototype = $c_Lfs2_Compiler$$anon$5.prototype;
$c_Lfs2_Compiler$$anon$5.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var evidence$3 = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F = new $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(evidence$3);
  return $as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk)).unsafeRunSync__O()
});
var $d_Lfs2_Compiler$$anon$5 = new $TypeData().initClass({
  Lfs2_Compiler$$anon$5: 0
}, false, "fs2.Compiler$$anon$5", {
  Lfs2_Compiler$$anon$5: 1,
  O: 1,
  Lfs2_Compiler: 1
});
$c_Lfs2_Compiler$$anon$5.prototype.$classData = $d_Lfs2_Compiler$$anon$5;
/** @constructor */
function $c_Lfs2_CompilerLowPriority$$anon$4() {
  this.Lfs2_CompilerLowPriority$$anon$4__f_target = null;
  $m_Lcats_Invariant$();
  $m_Lcats_instances_package$either$();
  var e = new $c_Lcats_instances_EitherInstances$$anon$2();
  this.Lfs2_CompilerLowPriority$$anon$4__f_target = e
}
$c_Lfs2_CompilerLowPriority$$anon$4.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.constructor = $c_Lfs2_CompilerLowPriority$$anon$4;
/** @constructor */
function $h_Lfs2_CompilerLowPriority$$anon$4() {
  /*<skip>*/
}
$h_Lfs2_CompilerLowPriority$$anon$4.prototype = $c_Lfs2_CompilerLowPriority$$anon$4.prototype;
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__s_util_Either = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var evidence$3 = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F = new $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(evidence$3);
  var this$3 = $as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F).apply__Lfs2_Pull__O__F2__O(stream, init, foldChunk));
  return $as_s_util_Either(new $c_Lcats_effect_SyncIO$Attempt(this$3).unsafeRunSync__O())
});
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, fold) {
  return this.apply__Lfs2_Pull__O__F2__s_util_Either(stream, init, fold)
});
var $d_Lfs2_CompilerLowPriority$$anon$4 = new $TypeData().initClass({
  Lfs2_CompilerLowPriority$$anon$4: 0
}, false, "fs2.CompilerLowPriority$$anon$4", {
  Lfs2_CompilerLowPriority$$anon$4: 1,
  O: 1,
  Lfs2_Compiler: 1
});
$c_Lfs2_CompilerLowPriority$$anon$4.prototype.$classData = $d_Lfs2_CompilerLowPriority$$anon$4;
/** @constructor */
function $c_Lfs2_CompilerLowPriority0$$anon$3() {
  this.Lfs2_CompilerLowPriority0$$anon$3__f_target = null;
  $m_Lcats_Invariant$();
  var e = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  this.Lfs2_CompilerLowPriority0$$anon$3__f_target = e
}
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.constructor = $c_Lfs2_CompilerLowPriority0$$anon$3;
/** @constructor */
function $h_Lfs2_CompilerLowPriority0$$anon$3() {
  /*<skip>*/
}
$h_Lfs2_CompilerLowPriority0$$anon$3.prototype = $c_Lfs2_CompilerLowPriority0$$anon$3.prototype;
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  $m_Lfs2_Compiler$();
  var evidence$3 = $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO;
  var F = new $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(evidence$3);
  return $as_Lcats_effect_SyncIO(new $c_Lfs2_CompilerLowPriority1$$anon$2(F).apply__Lfs2_Pull__O__F2__O(($m_Lfs2_Pull$(), $m_Lfs2_Pull$IdOps$().covaryId$extension__Lfs2_Pull__Lcats_Applicative__Lfs2_Pull(stream, $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__syncForSyncIO)), init, foldChunk)).unsafeRunSync__O()
});
var $d_Lfs2_CompilerLowPriority0$$anon$3 = new $TypeData().initClass({
  Lfs2_CompilerLowPriority0$$anon$3: 0
}, false, "fs2.CompilerLowPriority0$$anon$3", {
  Lfs2_CompilerLowPriority0$$anon$3: 1,
  O: 1,
  Lfs2_Compiler: 1
});
$c_Lfs2_CompilerLowPriority0$$anon$3.prototype.$classData = $d_Lfs2_CompilerLowPriority0$$anon$3;
/** @constructor */
function $c_Lfs2_CompilerLowPriority1$$anon$2(F$1) {
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = null;
  this.Lfs2_CompilerLowPriority1$$anon$2__f_target = null;
  this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2 = F$1;
  this.Lfs2_CompilerLowPriority1$$anon$2__f_target = F$1
}
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.constructor = $c_Lfs2_CompilerLowPriority1$$anon$2;
/** @constructor */
function $h_Lfs2_CompilerLowPriority1$$anon$2() {
  /*<skip>*/
}
$h_Lfs2_CompilerLowPriority1$$anon$2.prototype = $c_Lfs2_CompilerLowPriority1$$anon$2.prototype;
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, foldChunk) {
  var this$1 = this.Lfs2_CompilerLowPriority1$$anon$2__f_F$2;
  return $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O(this$1, stream, init, foldChunk)
});
var $d_Lfs2_CompilerLowPriority1$$anon$2 = new $TypeData().initClass({
  Lfs2_CompilerLowPriority1$$anon$2: 0
}, false, "fs2.CompilerLowPriority1$$anon$2", {
  Lfs2_CompilerLowPriority1$$anon$2: 1,
  O: 1,
  Lfs2_Compiler: 1
});
$c_Lfs2_CompilerLowPriority1$$anon$2.prototype.$classData = $d_Lfs2_CompilerLowPriority1$$anon$2;
/** @constructor */
function $c_Lfs2_CompilerLowPriority2$$anon$1(evidence$1$1) {
  this.Lfs2_CompilerLowPriority2$$anon$1__f_evidence$1$2 = null;
  this.Lfs2_CompilerLowPriority2$$anon$1__f_target = null;
  this.Lfs2_CompilerLowPriority2$$anon$1__f_evidence$1$2 = evidence$1$1;
  var e = new $c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1(evidence$1$1);
  this.Lfs2_CompilerLowPriority2$$anon$1__f_target = e
}
$c_Lfs2_CompilerLowPriority2$$anon$1.prototype = new $h_O();
$c_Lfs2_CompilerLowPriority2$$anon$1.prototype.constructor = $c_Lfs2_CompilerLowPriority2$$anon$1;
/** @constructor */
function $h_Lfs2_CompilerLowPriority2$$anon$1() {
  /*<skip>*/
}
$h_Lfs2_CompilerLowPriority2$$anon$1.prototype = $c_Lfs2_CompilerLowPriority2$$anon$1.prototype;
$c_Lfs2_CompilerLowPriority2$$anon$1.prototype.apply__Lfs2_Pull__O__F2__Lcats_effect_kernel_Resource = (function(stream, init, foldChunk) {
  return $m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($m_Lfs2_internal_Scope$().newRoot__Lfs2_Compiler$Target__O(this.Lfs2_CompilerLowPriority2$$anon$1__f_evidence$1$2), new $c_sjsr_AnonFunction2(((this$1) => ((scope, ec) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    var fea = scope$1.close__Lcats_effect_kernel_Resource$ExitCase__O(ec$1);
    return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, this$1.Lfs2_CompilerLowPriority2$$anon$1__f_evidence$1$2)
  }))(this)), this.Lfs2_CompilerLowPriority2$$anon$1__f_evidence$1$2).evalMap__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((this$2$1, stream$2, init$2, foldChunk$2) => ((scope$2) => {
    var scope$3 = $as_Lfs2_internal_Scope(scope$2);
    return $m_Lfs2_Pull$().compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O(stream$2, scope$3, true, init$2, foldChunk$2, this$2$1.Lfs2_CompilerLowPriority2$$anon$1__f_evidence$1$2)
  }))(this, stream, init, foldChunk)))
});
$c_Lfs2_CompilerLowPriority2$$anon$1.prototype.apply__Lfs2_Pull__O__F2__O = (function(stream, init, fold) {
  return this.apply__Lfs2_Pull__O__F2__Lcats_effect_kernel_Resource(stream, init, fold)
});
var $d_Lfs2_CompilerLowPriority2$$anon$1 = new $TypeData().initClass({
  Lfs2_CompilerLowPriority2$$anon$1: 0
}, false, "fs2.CompilerLowPriority2$$anon$1", {
  Lfs2_CompilerLowPriority2$$anon$1: 1,
  O: 1,
  Lfs2_Compiler: 1
});
$c_Lfs2_CompilerLowPriority2$$anon$1.prototype.$classData = $d_Lfs2_CompilerLowPriority2$$anon$1;
function $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$($thiz, F$8, TheBuildR$lzy1$1) {
  if ((TheBuildR$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $as_Lfs2_Pull$TheBuildR$2$((TheBuildR$lzy1$1.sr_LazyRef__f__initialized ? TheBuildR$lzy1$1.sr_LazyRef__f__value : TheBuildR$lzy1$1.initialize__O__O(new $c_Lfs2_Pull$TheBuildR$2$(F$8))))
}
function $p_Lfs2_Pull$__TheBuildR$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$($thiz, F$9, TheBuildR$lzy1$2) {
  return $as_Lfs2_Pull$TheBuildR$2$((TheBuildR$lzy1$2.sr_LazyRef__f__initialized ? TheBuildR$lzy1$2.sr_LazyRef__f__value : $p_Lfs2_Pull$__TheBuildR$lzyINIT1$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$($thiz, F$9, TheBuildR$lzy1$2)))
}
function $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head$2, scope$7, acc, pred) {
  var pred$tailLocal1 = pred;
  var acc$tailLocal1 = acc;
  while (true) {
    var x170 = pred$tailLocal1;
    if ((x170 instanceof $c_Lfs2_Pull$ViewRunner$1)) {
      var vrun = $as_Lfs2_Pull$ViewRunner$1(x170);
      var acc$tailLocal1$tmp1 = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(acc$tailLocal1, vrun.Lfs2_Pull$ViewRunner$1__f_view);
      var pred$tailLocal1$tmp1 = vrun.Lfs2_Pull$ViewRunner$1__f_prevRunner;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
      pred$tailLocal1 = pred$tailLocal1$tmp1;
      continue
    };
    return pred$tailLocal1.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head$2, scope$7, acc$tailLocal1)
  }
}
function $p_Lfs2_Pull$__goEval$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Eval__F1__O($thiz, extendLastTopLevelScope$12, F$22, contP$14, scope$14, extendedTopLevelScope$11, TheBuildR$lzy1$14, translation$tailLocal1$11, runner$tailLocal1$11, eval$1, view) {
  var target = scope$14.interruptibleEval__O__O(translation$tailLocal1$11.apply__O__O(eval$1.Lfs2_Pull$Eval__f_value));
  var this$9 = new $c_Lcats_FlatMap$$anon$2(target, F$22);
  var f = new $c_sjsr_AnonFunction1(((this$2, extendLastTopLevelScope$12$2, F$22$2, contP$14$2, scope$14$2, extendedTopLevelScope$11$2, view$2, TheBuildR$lzy1$14$2, translation$tailLocal1$11$2, runner$tailLocal1$11$2) => ((eitherOutcome) => {
    var eitherOutcome$1 = $as_s_util_Either(eitherOutcome);
    matchResult77: {
      var $$x1;
      if ((eitherOutcome$1 instanceof $c_s_util_Right)) {
        var r = $as_s_util_Right(eitherOutcome$1).s_util_Right__f_value;
        var $$x1 = new $c_Lfs2_Pull$Succeeded(r);
        break matchResult77
      };
      if ((eitherOutcome$1 instanceof $c_s_util_Left)) {
        var x201 = $as_Lcats_effect_kernel_Outcome($as_s_util_Left(eitherOutcome$1).s_util_Left__f_value);
        if ((x201 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(x201);
          var x204 = $as_jl_Throwable(x$1.Lcats_effect_kernel_Outcome$Errored__f_e);
          var $$x1 = new $c_Lfs2_Pull$Fail(x204);
          break matchResult77
        };
        if (((x201 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x201), true))) {
          var context = scope$14$2.Lfs2_internal_Scope__f_id;
          var deferredError = $m_s_None$();
          var $$x1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult77
        };
        if ((x201 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(x201);
          var x196 = $as_Lcats_effect_kernel_Unique$Token(x$1$1.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
          var deferredError$1 = $m_s_None$();
          var $$x1 = new $c_Lfs2_Pull$Interrupted(x196, deferredError$1);
          break matchResult77
        }
      };
      throw new $c_s_MatchError(eitherOutcome$1)
    };
    var result = $as_Lfs2_Pull$Terminal($$x1);
    return this$2.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$12$2, F$22$2, contP$14$2, TheBuildR$lzy1$14$2, scope$14$2, extendedTopLevelScope$11$2, translation$tailLocal1$11$2, runner$tailLocal1$11$2, $as_Lfs2_Pull(view$2.apply__O__O(result)))
  }))($thiz, extendLastTopLevelScope$12, F$22, contP$14, scope$14, extendedTopLevelScope$11, view, TheBuildR$lzy1$14, translation$tailLocal1$11, runner$tailLocal1$11));
  return this$9.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$$anon$2__f_self, f)
}
function $p_Lfs2_Pull$__goAcquire$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Acquire__F1__O($thiz, extendLastTopLevelScope$14, F$24, contP$16, scope$16, extendedTopLevelScope$13, TheBuildR$lzy1$16, translation$tailLocal1$13, runner$tailLocal1$13, acquire, view) {
  var onScope = scope$16.acquireResource__F1__F2__O(new $c_sjsr_AnonFunction1(((acquire$2, translation$tailLocal1$13$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return (acquire$2.Lfs2_Pull$Acquire__f_cancelable ? poll$1.apply__O__O(translation$tailLocal1$13$2.apply__O__O(acquire$2.Lfs2_Pull$Acquire__f_resource)) : translation$tailLocal1$13$2.apply__O__O(acquire$2.Lfs2_Pull$Acquire__f_resource))
  }))(acquire, translation$tailLocal1$13)), new $c_sjsr_AnonFunction2(((acquire$3, translation$tailLocal1$13$3) => ((resource, exit) => {
    var exit$1 = $as_Lcats_effect_kernel_Resource$ExitCase(exit);
    return translation$tailLocal1$13$3.apply__O__O(acquire$3.Lfs2_Pull$Acquire__f_release.apply__O__O__O(resource, exit$1))
  }))(acquire, translation$tailLocal1$13)));
  var this$10 = new $c_Lcats_FlatMap$$anon$2(onScope, F$24);
  var f = new $c_sjsr_AnonFunction1(((this$3$1, extendLastTopLevelScope$14$2, F$24$2, contP$16$2, scope$16$2, extendedTopLevelScope$13$2, view$2, TheBuildR$lzy1$16$2, translation$tailLocal1$13$4, runner$tailLocal1$13$2) => ((outcome) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome);
    matchResult78: {
      var $$x1;
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome$1);
        var x219 = $as_s_util_Either(x$1.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        if ((x219 instanceof $c_s_util_Right)) {
          var r = $as_s_util_Right(x219).s_util_Right__f_value;
          var $$x1 = new $c_Lfs2_Pull$Succeeded(r);
          break matchResult78
        };
        if ((x219 instanceof $c_s_util_Left)) {
          var scopeId = $as_Lcats_effect_kernel_Unique$Token($as_s_util_Left(x219).s_util_Left__f_value);
          var deferredError = $m_s_None$();
          var $$x1 = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult78
        }
      };
      if (((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome$1), true))) {
        var context = scope$16$2.Lfs2_internal_Scope__f_id;
        var deferredError$1 = $m_s_None$();
        var $$x1 = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult78
      };
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome$1);
        var x210 = $as_jl_Throwable(x$1$1.Lcats_effect_kernel_Outcome$Errored__f_e);
        var $$x1 = new $c_Lfs2_Pull$Fail(x210);
        break matchResult78
      };
      throw new $c_s_MatchError(outcome$1)
    };
    var result = $as_Lfs2_Pull$Terminal($$x1);
    return this$3$1.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$14$2, F$24$2, contP$16$2, TheBuildR$lzy1$16$2, scope$16$2, extendedTopLevelScope$13$2, translation$tailLocal1$13$4, runner$tailLocal1$13$2, $as_Lfs2_Pull(view$2.apply__O__O(result)))
  }))($thiz, extendLastTopLevelScope$14, F$24, contP$16, scope$16, extendedTopLevelScope$13, view, TheBuildR$lzy1$16, translation$tailLocal1$13, runner$tailLocal1$13));
  var cont = this$10.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$$anon$2__f_self, f);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$14, F$24, contP$16, extendedTopLevelScope$13, TheBuildR$lzy1$16, translation$tailLocal1$13, runner$tailLocal1$13, scope$16, view, new $c_sjsr_AnonFunction0(((cont$2) => (() => cont$2))(cont)))
}
function $p_Lfs2_Pull$__goInterruptWhen$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__O__F1__O($thiz, extendLastTopLevelScope$16, F$26, contP$18, scope$18, extendedTopLevelScope$15, TheBuildR$lzy1$18, translation$tailLocal1$17, runner$tailLocal1$15, haltOnSignal, view) {
  var onScope = scope$18.acquireResource__F1__F2__O(new $c_sjsr_AnonFunction1(((scope$18$2, haltOnSignal$2) => ((_$63) => {
    $as_Lcats_effect_kernel_Poll(_$63);
    return scope$18$2.interruptWhen__O__O(haltOnSignal$2)
  }))(scope$18, haltOnSignal)), new $c_sjsr_AnonFunction2(((f, _$64) => {
    var f$1 = $as_Lcats_effect_kernel_Fiber(f);
    $as_Lcats_effect_kernel_Resource$ExitCase(_$64);
    return f$1.cancel__O()
  })));
  var this$10 = new $c_Lcats_FlatMap$$anon$2(onScope, F$26);
  var f$2 = new $c_sjsr_AnonFunction1(((this$3$1, extendLastTopLevelScope$16$2, F$26$2, contP$18$2, scope$18$3, extendedTopLevelScope$15$2, view$2, TheBuildR$lzy1$18$2, translation$tailLocal1$17$2, runner$tailLocal1$15$2) => ((outcome) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome);
    matchResult79: {
      var $$x1;
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
        var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome$1);
        var x234 = $as_s_util_Either(x$1.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
        if ((x234 instanceof $c_s_util_Right)) {
          var $$x1 = new $c_Lfs2_Pull$Succeeded((void 0));
          break matchResult79
        };
        if ((x234 instanceof $c_s_util_Left)) {
          var scopeId = $as_Lcats_effect_kernel_Unique$Token($as_s_util_Left(x234).s_util_Left__f_value);
          var deferredError = $m_s_None$();
          var $$x1 = new $c_Lfs2_Pull$Interrupted(scopeId, deferredError);
          break matchResult79
        }
      };
      if (((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome$1), true))) {
        var context = scope$18$3.Lfs2_internal_Scope__f_id;
        var deferredError$1 = $m_s_None$();
        var $$x1 = new $c_Lfs2_Pull$Interrupted(context, deferredError$1);
        break matchResult79
      };
      if ((outcome$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome$1);
        var x225 = $as_jl_Throwable(x$1$1.Lcats_effect_kernel_Outcome$Errored__f_e);
        var $$x1 = new $c_Lfs2_Pull$Fail(x225);
        break matchResult79
      };
      throw new $c_s_MatchError(outcome$1)
    };
    var result = $as_Lfs2_Pull$Terminal($$x1);
    return this$3$1.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$16$2, F$26$2, contP$18$2, TheBuildR$lzy1$18$2, scope$18$3, extendedTopLevelScope$15$2, translation$tailLocal1$17$2, runner$tailLocal1$15$2, $as_Lfs2_Pull(view$2.apply__O__O(result)))
  }))($thiz, extendLastTopLevelScope$16, F$26, contP$18, scope$18, extendedTopLevelScope$15, view, TheBuildR$lzy1$18, translation$tailLocal1$17, runner$tailLocal1$15));
  var cont = this$10.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$10.Lcats_FlatMap$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$16, F$26, contP$18, extendedTopLevelScope$15, TheBuildR$lzy1$18, translation$tailLocal1$17, runner$tailLocal1$15, scope$18, view, new $c_sjsr_AnonFunction0(((cont$2) => (() => cont$2))(cont)))
}
function $p_Lfs2_Pull$__goInScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__Z__F1__O($thiz, extendLastTopLevelScope$18, F$28, contP$20, scope$21, extendedTopLevelScope$17, TheBuildR$lzy1$20, translation$tailLocal1$19, runner$tailLocal1$17, stream, useInterruption, view) {
  if ((scope$21.Lfs2_internal_Scope__f_parent.isEmpty__Z() && (!extendedTopLevelScope$17.isEmpty__Z()))) {
    $m_Lcats_UnorderedFoldable$();
    var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
    var this$5 = new $c_Lcats_Foldable$$anon$6(extendedTopLevelScope$17, tc);
    var f = new $c_sjsr_AnonFunction1(((F$28$2) => ((_$65) => {
      var _$65$1 = $as_Lfs2_internal_Scope(_$65);
      var fea = _$65$1.close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$28$2)
    }))(F$28));
    var target = this$5.Lcats_Foldable$$anon$6__f_typeClassInstance.traverse___O__F1__Lcats_Applicative__O(this$5.Lcats_Foldable$$anon$6__f_self, f, F$28);
    var this$7 = new $c_Lcats_Functor$$anon$4(target, F$28);
    var b = $m_s_None$();
    var maybeCloseExtendedScope = this$7.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$7.Lcats_Functor$$anon$4__f_self, b)
  } else {
    var maybeCloseExtendedScope = F$28.pure__O__O(extendedTopLevelScope$17)
  };
  var this$13 = new $c_Lcats_FlatMap$$anon$2(maybeCloseExtendedScope, F$28);
  var f$2 = new $c_sjsr_AnonFunction1(((this$2$1, extendLastTopLevelScope$18$2, F$28$3, contP$20$2, scope$21$2, extendedTopLevelScope$17$2, stream$2, useInterruption$2, view$2, TheBuildR$lzy1$20$2, translation$tailLocal1$19$2, runner$tailLocal1$17$2) => ((newExtendedScope) => {
    var newExtendedScope$1 = $as_s_Option(newExtendedScope);
    var fea$1 = scope$21$2.open__Z__O(useInterruption$2);
    var target$1 = $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea$1, F$28$3);
    var this$12 = new $c_Lcats_FlatMap$$anon$2(target$1, F$28$3);
    var f$1 = new $c_sjsr_AnonFunction1(((this$11, extendLastTopLevelScope$19$2, F$30$2, contP$21$2, scope$22$2, extendedTopLevelScope$18$2, stream$1$2, view$7$2, newExtendedScope$2, TheBuildR$lzy1$21$2, translation$tailLocal1$20$2, runner$tailLocal1$18$2) => ((childScope) => {
      var childScope$1 = $as_Lfs2_internal_Scope(childScope);
      var bb = new $c_Lfs2_Pull$$anon$8(stream$1$2, childScope$1);
      return this$11.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$19$2, F$30$2, contP$21$2, TheBuildR$lzy1$21$2, childScope$1, newExtendedScope$2, translation$tailLocal1$20$2, new $c_Lfs2_Pull$ViewRunner$1(extendLastTopLevelScope$19$2, F$30$2, contP$21$2, scope$22$2, extendedTopLevelScope$18$2, TheBuildR$lzy1$21$2, translation$tailLocal1$20$2, runner$tailLocal1$18$2, view$7$2), bb)
    }))(this$2$1, extendLastTopLevelScope$18$2, F$28$3, contP$20$2, scope$21$2, extendedTopLevelScope$17$2, stream$2, view$2, newExtendedScope$1, TheBuildR$lzy1$20$2, translation$tailLocal1$19$2, runner$tailLocal1$17$2));
    return this$12.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$12.Lcats_FlatMap$$anon$2__f_self, f$1)
  }))($thiz, extendLastTopLevelScope$18, F$28, contP$20, scope$21, extendedTopLevelScope$17, stream, useInterruption, view, TheBuildR$lzy1$20, translation$tailLocal1$19, runner$tailLocal1$17));
  var tail = this$13.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$13.Lcats_FlatMap$$anon$2__f_self, f$2);
  return $thiz.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$18, F$28, contP$20, extendedTopLevelScope$17, TheBuildR$lzy1$20, translation$tailLocal1$19, runner$tailLocal1$17, scope$21, view, new $c_sjsr_AnonFunction0(((tail$2) => (() => tail$2))(tail)))
}
function $p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, err, res) {
  if ((res instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(res);
    $as_jl_Void(x$1.Lfs2_Pull$Succeeded__f_r);
    return new $c_Lfs2_Pull$Fail(err)
  };
  if ((res instanceof $c_Lfs2_Pull$Fail)) {
    var x$1$1 = $as_Lfs2_Pull$Fail(res);
    var x255 = x$1$1.Lfs2_Pull$Fail__f_error;
    var error = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(err, x255, $m_s_package$().s_package$__f_Nil);
    return new $c_Lfs2_Pull$Fail(error)
  };
  if ((res instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$1$2 = $as_Lfs2_Pull$Interrupted(res);
    $m_s_sys_package$().error__T__E("Impossible, cannot interrupt here")
  };
  throw new $c_s_MatchError(res)
}
function $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull($thiz, close$1, view$9, res) {
  var x259 = close$1.exitCase__Lcats_effect_kernel_Resource$ExitCase();
  if ((x259 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x$1 = $as_Lcats_effect_kernel_Resource$ExitCase$Errored(x259);
    var x262 = x$1.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return $as_Lfs2_Pull(view$9.apply__O__O($p_Lfs2_Pull$__addError$1__jl_Throwable__Lfs2_Pull$Terminal__Lfs2_Pull$Terminal($thiz, x262, res)))
  };
  return $as_Lfs2_Pull(view$9.apply__O__O(res))
}
function $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r$1, err$1) {
  var $$x1 = $m_Lfs2_CompositeFailure$();
  var this$1 = r$1.swap__s_util_Either().toOption__s_Option().toList__sci_List();
  var suffix = err$1.toList__sci_List();
  return $$x1.fromList__sci_List__s_Option(this$1.appendedAll__sc_IterableOnce__sci_List(suffix))
}
function $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal($thiz, close$2, r, ancestor) {
  var x266 = close$2.interruption__s_Option();
  var x = $m_s_None$();
  if ((x === x266)) {
    if ((r instanceof $c_s_util_Right)) {
      var x2 = $as_s_util_Right(r);
      var b = x2.s_util_Right__f_value;
      var _$67 = $as_jl_Void(b);
      var $$x1 = new $c_Lfs2_Pull$Succeeded(_$67)
    } else {
      if ((!(r instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(r)
      };
      var x3 = $as_s_util_Left(r);
      var a = x3.s_util_Left__f_value;
      var _$66 = $as_jl_Throwable(a);
      var $$x1 = new $c_Lfs2_Pull$Fail(_$66)
    };
    return $as_Lfs2_Pull$Terminal($$x1)
  };
  if ((x266 instanceof $c_s_Some)) {
    var x268 = $as_Lfs2_Pull$Interrupted($as_s_Some(x266).s_Some__f_value);
    if ((x268 !== null)) {
      var x270 = x268.Lfs2_Pull$Interrupted__f_context;
      var x271 = x268.Lfs2_Pull$Interrupted__f_deferredError;
      if (ancestor.descendsFrom__Lcats_effect_kernel_Unique$Token__Z(x270)) {
        var deferredError = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x271);
        return new $c_Lfs2_Pull$Interrupted(x270, deferredError)
      } else {
        var x263 = $p_Lfs2_Pull$__err1$1__s_util_Either__s_Option__s_Option($thiz, r, x271);
        var x$3 = $m_s_None$();
        if ((x$3 === x263)) {
          return $thiz.Lfs2_Pull$__f_fs2$Pull$$$unit
        };
        if ((x263 instanceof $c_s_Some)) {
          var err$2 = $as_jl_Throwable($as_s_Some(x263).s_Some__f_value);
          return new $c_Lfs2_Pull$Fail(err$2)
        };
        throw new $c_s_MatchError(x263)
      }
    }
  };
  throw new $c_s_MatchError(x266)
}
function $p_Lfs2_Pull$__goCloseScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$CloseScope__F1__O($thiz, extendLastTopLevelScope$21, F$32, contP$23, scope$24, extendedTopLevelScope$20, TheBuildR$lzy1$23, translation$tailLocal1$22, runner$tailLocal1$20, close, view) {
  var target = scope$24.findInLineage__Lcats_effect_kernel_Unique$Token__O(close.scopeId__Lcats_effect_kernel_Unique$Token());
  var this$20 = new $c_Lcats_FlatMap$$anon$2(target, F$32);
  var f$4 = new $c_sjsr_AnonFunction1(((this$2, extendLastTopLevelScope$21$2, F$32$2, contP$23$2, scope$24$2, extendedTopLevelScope$20$2, close$2, view$2, TheBuildR$lzy1$23$2, translation$tailLocal1$22$2, runner$tailLocal1$20$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var x278 = $as_Lfs2_internal_Scope($as_s_Some(x$1$1).s_Some__f_value);
      if (x278.Lfs2_internal_Scope__f_parent.isEmpty__Z()) {
        return this$2.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$21$2, F$32$2, contP$23$2, TheBuildR$lzy1$23$2, scope$24$2, extendedTopLevelScope$20$2, translation$tailLocal1$22$2, runner$tailLocal1$20$2, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull(this$2, close$2, view$2, this$2.Lfs2_Pull$__f_fs2$Pull$$$unit))
      };
      if ((extendLastTopLevelScope$21$2 && ($ps_Lfs2_internal_Scope__go$1__Lfs2_internal_Scope__I__I(x278, 0) === 1))) {
        $m_Lcats_UnorderedFoldable$();
        var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
        var this$7 = new $c_Lcats_Foldable$$anon$6(extendedTopLevelScope$20$2, tc);
        var f = new $c_sjsr_AnonFunction1(((F$33$2) => ((_$68) => {
          var _$68$1 = $as_Lfs2_internal_Scope(_$68);
          var fea = _$68$1.close__Lcats_effect_kernel_Resource$ExitCase__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
          return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, F$33$2)
        }))(F$32$2));
        var fa = this$7.Lcats_Foldable$$anon$6__f_typeClassInstance.traverse___O__F1__Lcats_Applicative__O(this$7.Lcats_Foldable$$anon$6__f_self, f, F$32$2);
        var this$12 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$32$2);
        var target$1 = x278.openAncestor__O();
        var this$11 = new $c_Lcats_FlatMap$$anon$2(target$1, F$32$2);
        var f$1 = new $c_sjsr_AnonFunction1(((this$2$1, extendLastTopLevelScope$22$2, F$33$3, contP$24$2, close$3$2, view$10$2, toClose$3, TheBuildR$lzy1$24$2, translation$tailLocal1$23$2, runner$tailLocal1$21$2) => ((ancestor) => {
          var ancestor$1 = $as_Lfs2_internal_Scope(ancestor);
          return this$2$1.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$22$2, F$33$3, contP$24$2, TheBuildR$lzy1$24$2, ancestor$1, new $c_s_Some(toClose$3), translation$tailLocal1$23$2, runner$tailLocal1$21$2, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull(this$2$1, close$3$2, view$10$2, this$2$1.Lfs2_Pull$__f_fs2$Pull$$$unit))
        }))(this$2, extendLastTopLevelScope$21$2, F$32$2, contP$23$2, close$2, view$2, x278, TheBuildR$lzy1$23$2, translation$tailLocal1$22$2, runner$tailLocal1$20$2));
        var fb = this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f$1);
        var this$13 = this$12.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
        var fa$1 = this$12.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        return this$13.productR__O__O__O(fa$1, fb)
      };
      var target$2 = x278.close__Lcats_effect_kernel_Resource$ExitCase__O(close$2.exitCase__Lcats_effect_kernel_Resource$ExitCase());
      var this$18 = new $c_Lcats_FlatMap$$anon$2(target$2, F$32$2);
      var f$3 = new $c_sjsr_AnonFunction1(((this$3$1, extendLastTopLevelScope$22$3, F$33$4, contP$24$3, extendedTopLevelScope$21$2, close$3$3, view$10$3, toClose$5, TheBuildR$lzy1$24$3, translation$tailLocal1$23$3, runner$tailLocal1$21$3) => ((r) => {
        var r$1 = $as_s_util_Either(r);
        var target$3 = toClose$5.openAncestor__O();
        var this$17 = new $c_Lcats_FlatMap$$anon$2(target$3, F$33$4);
        var f$2 = new $c_sjsr_AnonFunction1(((this$16, extendLastTopLevelScope$24$2, F$36$2, contP$26$2, extendedTopLevelScope$22$2, close$5$2, view$12$2, r$2, TheBuildR$lzy1$26$2, translation$tailLocal1$25$2, runner$tailLocal1$23$2) => ((ancestor$2) => {
          var ancestor$3 = $as_Lfs2_internal_Scope(ancestor$2);
          var res = $p_Lfs2_Pull$__closeTerminal$1__Lfs2_Pull$CloseScope__s_util_Either__Lfs2_internal_Scope__Lfs2_Pull$Terminal(this$16, close$5$2, r$2, ancestor$3);
          return this$16.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$24$2, F$36$2, contP$26$2, TheBuildR$lzy1$26$2, ancestor$3, extendedTopLevelScope$22$2, translation$tailLocal1$25$2, runner$tailLocal1$23$2, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull(this$16, close$5$2, view$12$2, res))
        }))(this$3$1, extendLastTopLevelScope$22$3, F$33$4, contP$24$3, extendedTopLevelScope$21$2, close$3$3, view$10$3, r$1, TheBuildR$lzy1$24$3, translation$tailLocal1$23$3, runner$tailLocal1$21$3));
        return this$17.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$17.Lcats_FlatMap$$anon$2__f_self, f$2)
      }))(this$2, extendLastTopLevelScope$21$2, F$32$2, contP$23$2, extendedTopLevelScope$20$2, close$2, view$2, x278, TheBuildR$lzy1$23$2, translation$tailLocal1$22$2, runner$tailLocal1$20$2));
      return this$18.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$18.Lcats_FlatMap$$anon$2__f_self, f$3)
    };
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var this$19 = close$2.interruption__s_Option();
      var result = $as_Lfs2_Pull$Terminal((this$19.isEmpty__Z() ? this$2.Lfs2_Pull$__f_fs2$Pull$$$unit : this$19.get__O()));
      return this$2.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$21$2, F$32$2, contP$23$2, TheBuildR$lzy1$23$2, scope$24$2, extendedTopLevelScope$20$2, translation$tailLocal1$22$2, runner$tailLocal1$20$2, $p_Lfs2_Pull$__viewCont$1__Lfs2_Pull$CloseScope__F1__Lfs2_Pull$Terminal__Lfs2_Pull(this$2, close$2, view$2, result))
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, extendLastTopLevelScope$21, F$32, contP$23, scope$24, extendedTopLevelScope$20, close, view, TheBuildR$lzy1$23, translation$tailLocal1$22, runner$tailLocal1$20));
  return this$20.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$$anon$2__f_self, f$4)
}
/** @constructor */
function $c_Lfs2_Pull$() {
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = null;
  this.Lfs2_Pull$__f_done = null;
  $n_Lfs2_Pull$ = this;
  this.Lfs2_Pull$__f_fs2$Pull$$$unit = new $c_Lfs2_Pull$Succeeded((void 0));
  this.Lfs2_Pull$__f_done = this.Lfs2_Pull$__f_fs2$Pull$$$unit
}
$c_Lfs2_Pull$.prototype = new $h_O();
$c_Lfs2_Pull$.prototype.constructor = $c_Lfs2_Pull$;
/** @constructor */
function $h_Lfs2_Pull$() {
  /*<skip>*/
}
$h_Lfs2_Pull$.prototype = $c_Lfs2_Pull$.prototype;
$c_Lfs2_Pull$.prototype.output1__O__Lfs2_Pull = (function(o) {
  $m_Lfs2_Chunk$();
  var values = new $c_Lfs2_Chunk$Singleton(o);
  return new $c_Lfs2_Pull$Output(values)
});
$c_Lfs2_Pull$.prototype.output__Lfs2_Chunk__Lfs2_Pull = (function(os) {
  return (os.isEmpty__Z() ? $m_Lfs2_Pull$().Lfs2_Pull$__f_done : new $c_Lfs2_Pull$Output(os))
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull = (function(fmoc, view) {
  var x = $m_Lfs2_Pull$IdContP$();
  if ((x === view)) {
    return fmoc
  } else if ((view instanceof $c_Lfs2_Pull$Bind)) {
    var bv = $as_Lfs2_Pull$Bind(view);
    if ((fmoc instanceof $c_Lfs2_Pull$Terminal)) {
      var r = $as_Lfs2_Pull$Terminal(fmoc);
      try {
        return bv.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r)
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if ((e$2 !== null)) {
          var x78 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
          if ((!x78.isEmpty__Z())) {
            var x79 = $as_jl_Throwable(x78.get__O());
            return new $c_Lfs2_Pull$Fail(x79)
          }
        };
        throw e$2
      }
    } else {
      return new $c_Lfs2_Pull$DelegateBind(fmoc, bv.delegate__Lfs2_Pull$Bind())
    }
  } else {
    return new $c_Lfs2_Pull$$anon$7(fmoc, view)
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull = (function(py, del) {
  var del$tailLocal1 = del;
  var py$tailLocal1 = py;
  while (true) {
    var x91 = py$tailLocal1;
    if ((x91 instanceof $c_Lfs2_Pull$Terminal)) {
      var ty = $as_Lfs2_Pull$Terminal(x91);
      var x89 = del$tailLocal1;
      if ((x89 instanceof $c_Lfs2_Pull$BindBind)) {
        var cici = $as_Lfs2_Pull$BindBind(x89);
        var py$tailLocal1$tmp1 = cici.Lfs2_Pull$BindBind__f_bb.cont__Lfs2_Pull$Terminal__Lfs2_Pull(ty);
        var del$tailLocal1$tmp1 = cici.Lfs2_Pull$BindBind__f_del;
        py$tailLocal1 = py$tailLocal1$tmp1;
        del$tailLocal1 = del$tailLocal1$tmp1;
        continue
      };
      return del$tailLocal1.cont__Lfs2_Pull$Terminal__Lfs2_Pull(ty)
    };
    return new $c_Lfs2_Pull$DelegateBind(x91, del$tailLocal1)
  }
});
$c_Lfs2_Pull$.prototype.compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O = (function(stream, initScope, extendLastTopLevelScope, init, foldChunk, F) {
  var TheBuildR$lzy1 = new $c_sr_LazyRef();
  var contP = new $c_sr_ObjectRef(null);
  var initFk = new $c_Lcats_arrow_FunctionK$$anon$4();
  return this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope, F, contP, TheBuildR$lzy1, initScope, $m_s_None$(), initFk, new $c_Lfs2_Pull$OuterRun$1(extendLastTopLevelScope, foldChunk, F, contP, initFk, TheBuildR$lzy1, init), stream)
});
$c_Lfs2_Pull$.prototype.flatMapOutput__Lfs2_Pull__F1__Lfs2_Pull = (function(p, f) {
  if ((p instanceof $c_Lfs2_Pull$AlgEffect)) {
    var a = $as_Lfs2_Pull$AlgEffect(p);
    var $$x1 = a
  } else if ((p instanceof $c_Lfs2_Pull$Terminal)) {
    var r = $as_Lfs2_Pull$Terminal(p);
    var $$x1 = r
  } else {
    var $$x1 = new $c_Lfs2_Pull$FlatMapOutput(p, f)
  };
  return $as_Lfs2_Pull($$x1)
});
$c_Lfs2_Pull$.prototype.translate__Lfs2_Pull__Lcats_arrow_FunctionK__Lfs2_Pull = (function(stream, fK) {
  var fK$tailLocal1 = fK;
  var stream$tailLocal2 = stream;
  while (true) {
    var x313 = stream$tailLocal2;
    if ((x313 instanceof $c_Lfs2_Pull$Translate)) {
      var t = $as_Lfs2_Pull$Translate(x313);
      var stream$tailLocal2$tmp1 = t.Lfs2_Pull$Translate__f_stream;
      var this$1 = t.Lfs2_Pull$Translate__f_fk;
      var f = fK$tailLocal1;
      var fK$tailLocal1$tmp1 = new $c_Lcats_arrow_FunctionK$$anon$1(this$1, f);
      stream$tailLocal2 = stream$tailLocal2$tmp1;
      fK$tailLocal1 = fK$tailLocal1$tmp1;
      continue
    };
    if ((x313 instanceof $c_Lfs2_Pull$Output)) {
      var o = $as_Lfs2_Pull$Output(x313);
      return o
    };
    if ((x313 instanceof $c_Lfs2_Pull$Terminal)) {
      var r = $as_Lfs2_Pull$Terminal(x313);
      return r
    };
    var stream$1 = stream$tailLocal2;
    var fk = fK$tailLocal1;
    return new $c_Lfs2_Pull$Translate(stream$1, fk)
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull = (function(p, f) {
  if ((p instanceof $c_Lfs2_Pull$Terminal)) {
    var r = $as_Lfs2_Pull$Terminal(p);
    try {
      return $as_Lfs2_Pull(f.apply__O__O(r))
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if ((e$2 !== null)) {
        var x323 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x323.isEmpty__Z())) {
          var x324 = $as_jl_Throwable(x323.get__O());
          return new $c_Lfs2_Pull$Fail(x324)
        }
      };
      throw e$2
    }
  } else {
    return new $c_Lfs2_Pull$$anon$9(p, f)
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL = (function(contP$2, free) {
  var free$tailLocal1 = free;
  while (true) {
    var x149 = free$tailLocal1;
    if ((x149 instanceof $c_Lfs2_Pull$Action)) {
      var e = $as_Lfs2_Pull$Action(x149);
      var ev$13 = $m_Lfs2_Pull$IdContP$();
      contP$2.sr_ObjectRef__f_elem = ev$13;
      return e
    };
    if ((x149 instanceof $c_Lfs2_Pull$Bind)) {
      var b = $as_Lfs2_Pull$Bind(x149);
      var x145 = b.Lfs2_Pull$Bind__f_step;
      if ((x145 instanceof $c_Lfs2_Pull$Bind)) {
        var c = $as_Lfs2_Pull$Bind(x145);
        free$tailLocal1 = new $c_Lfs2_Pull$BindBind(c.Lfs2_Pull$Bind__f_step, c.delegate__Lfs2_Pull$Bind(), b.delegate__Lfs2_Pull$Bind());
        continue
      };
      if ((x145 instanceof $c_Lfs2_Pull$Action)) {
        var e$2 = $as_Lfs2_Pull$Action(x145);
        var ev$14 = b.delegate__Lfs2_Pull$Bind();
        contP$2.sr_ObjectRef__f_elem = ev$14;
        return e$2
      };
      if ((x145 instanceof $c_Lfs2_Pull$Terminal)) {
        var r = $as_Lfs2_Pull$Terminal(x145);
        free$tailLocal1 = b.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r);
        continue
      };
      throw new $c_s_MatchError(x145)
    };
    if ((x149 instanceof $c_Lfs2_Pull$Terminal)) {
      var r$2 = $as_Lfs2_Pull$Terminal(x149);
      return r$2
    };
    throw new $c_s_MatchError(x149)
  }
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull = (function(contP$38, stream, interruption) {
  var x153 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$38, stream);
  if ((x153 instanceof $c_Lfs2_Pull$CloseScope)) {
    var cs = $as_Lfs2_Pull$CloseScope(x153);
    var scopeId = cs.scopeId__Lcats_effect_kernel_Unique$Token();
    var cl = new $c_Lfs2_Pull$CanceledScope(scopeId, interruption);
    return this.fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull(cl, $as_Lfs2_Pull$ContP(contP$38.sr_ObjectRef__f_elem))
  };
  if ((x153 instanceof $c_Lfs2_Pull$Action)) {
    var this$2 = $as_Lfs2_Pull$ContP(contP$38.sr_ObjectRef__f_elem);
    return this$2.cont__Lfs2_Pull$Terminal__Lfs2_Pull(interruption)
  };
  if ((x153 instanceof $c_Lfs2_Pull$Interrupted)) {
    var interrupted = $as_Lfs2_Pull$Interrupted(x153);
    return interrupted
  };
  if ((x153 instanceof $c_Lfs2_Pull$Succeeded)) {
    return interruption
  };
  if ((x153 instanceof $c_Lfs2_Pull$Fail)) {
    var failed = $as_Lfs2_Pull$Fail(x153);
    var $$x1 = $m_Lfs2_CompositeFailure$();
    var this$3 = interruption.Lfs2_Pull$Interrupted__f_deferredError.toList__sci_List();
    var elem = failed.Lfs2_Pull$Fail__f_error;
    var this$4 = $$x1.fromList__sci_List__s_Option($as_sci_List($f_sc_StrictOptimizedSeqOps__appended__O__O(this$3, elem)));
    var mixed = $as_jl_Throwable((this$4.isEmpty__Z() ? failed.Lfs2_Pull$Fail__f_error : this$4.get__O()));
    return new $c_Lfs2_Pull$Fail(mixed)
  };
  throw new $c_s_MatchError(x153)
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O = (function(extendLastTopLevelScope$2, F$12, contP$4, extendedTopLevelScope$1, TheBuildR$lzy1$4, translation$tailLocal1$1, runner$tailLocal1$1, scope, view, next) {
  var target = scope.isInterrupted__O();
  var this$8 = new $c_Lcats_FlatMap$$anon$2(target, F$12);
  var f = new $c_sjsr_AnonFunction1(((this$2, extendLastTopLevelScope$2$2, F$12$2, contP$4$2, extendedTopLevelScope$1$2, scope$2, view$2, next$2, TheBuildR$lzy1$4$2, translation$tailLocal1$1$2, runner$tailLocal1$1$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return next$2.apply__O()
    };
    if ((x$1$1 instanceof $c_s_Some)) {
      var outcome = $as_Lcats_effect_kernel_Outcome($as_s_Some(x$1$1).s_Some__f_value);
      matchResult71: {
        var $$x1;
        if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
          var x$1$2 = $as_Lcats_effect_kernel_Outcome$Errored(outcome);
          var x166 = $as_jl_Throwable(x$1$2.Lcats_effect_kernel_Outcome$Errored__f_e);
          var $$x1 = new $c_Lfs2_Pull$Fail(x166);
          break matchResult71
        };
        if (((outcome instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome), true))) {
          var context = scope$2.Lfs2_internal_Scope__f_id;
          var deferredError = $m_s_None$();
          var $$x1 = new $c_Lfs2_Pull$Interrupted(context, deferredError);
          break matchResult71
        };
        if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
          var x$1$3 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome);
          var x162 = $as_Lcats_effect_kernel_Unique$Token(x$1$3.Lcats_effect_kernel_Outcome$Succeeded__f_fa);
          var deferredError$1 = $m_s_None$();
          var $$x1 = new $c_Lfs2_Pull$Interrupted(x162, deferredError$1);
          break matchResult71
        };
        throw new $c_s_MatchError(outcome)
      };
      var result = $as_Lfs2_Pull$Terminal($$x1);
      return this$2.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$2$2, F$12$2, contP$4$2, TheBuildR$lzy1$4$2, scope$2, extendedTopLevelScope$1$2, translation$tailLocal1$1$2, runner$tailLocal1$1$2, $as_Lfs2_Pull(view$2.apply__O__O(result)))
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, extendLastTopLevelScope$2, F$12, contP$4, extendedTopLevelScope$1, scope, view, next, TheBuildR$lzy1$4, translation$tailLocal1$1, runner$tailLocal1$1));
  return this$8.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$8.Lcats_FlatMap$$anon$2__f_self, f)
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O = (function(extendLastTopLevelScope$4, F$14, contP$6, scope$4, extendedTopLevelScope$3, TheBuildR$lzy1$6, translation$tailLocal1$3, runner$tailLocal1$3, err, view) {
  return this.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$4, F$14, contP$6, TheBuildR$lzy1$6, scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runner$tailLocal1$3, $as_Lfs2_Pull(view.apply__O__O(new $c_Lfs2_Pull$Fail(err))))
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull = (function(scopeId, result) {
  matchResult80: {
    var $$x1;
    if ((result instanceof $c_Lfs2_Pull$Succeeded)) {
      var x$1 = $as_Lfs2_Pull$Succeeded(result);
      $as_jl_Void(x$1.Lfs2_Pull$Succeeded__f_r);
      var $$x1 = new $c_Lfs2_Pull$SucceedScope(scopeId);
      break matchResult80
    };
    if ((result instanceof $c_Lfs2_Pull$Interrupted)) {
      var x$1$1 = $as_Lfs2_Pull$Interrupted(result);
      var inter = $as_Lfs2_Pull$Interrupted(result);
      var $$x1 = new $c_Lfs2_Pull$CanceledScope(scopeId, inter);
      break matchResult80
    };
    if ((result instanceof $c_Lfs2_Pull$Fail)) {
      var x$1$2 = $as_Lfs2_Pull$Fail(result);
      var x240 = x$1$2.Lfs2_Pull$Fail__f_error;
      var $$x1 = new $c_Lfs2_Pull$FailedScope(scopeId, x240);
      break matchResult80
    };
    throw new $c_s_MatchError(result)
  };
  return $as_Lfs2_Pull($$x1)
});
$c_Lfs2_Pull$.prototype.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O = (function(extendLastTopLevelScope$1, F$11, contP$3, TheBuildR$lzy1$3, scope, extendedTopLevelScope, translation, runner, stream) {
  var stream$tailLocal1 = stream;
  var runner$tailLocal1 = runner;
  var translation$tailLocal1 = translation;
  while (true) {
    var x279 = this.fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(contP$3, stream$tailLocal1);
    if ((x279 instanceof $c_Lfs2_Pull$Translate)) {
      var tst = $as_Lfs2_Pull$Translate(x279);
      var translateRunner = new $c_Lfs2_Pull$TranslateRunner$1(extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, tst.Lfs2_Pull$Translate__f_fk, $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem));
      var this$1 = translation$tailLocal1;
      var f = tst.Lfs2_Pull$Translate__f_fk;
      var composed = new $c_Lcats_arrow_FunctionK$$anon$1(f, this$1);
      var stream$tailLocal1$tmp1 = tst.Lfs2_Pull$Translate__f_stream;
      translation$tailLocal1 = composed;
      runner$tailLocal1 = translateRunner;
      stream$tailLocal1 = stream$tailLocal1$tmp1;
      continue
    };
    if ((x279 instanceof $c_Lfs2_Pull$Output)) {
      var output = $as_Lfs2_Pull$Output(x279);
      var view = $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem);
      var $$x2 = translation$tailLocal1;
      var $$x1 = runner$tailLocal1;
      var runner$tailLocal1$2$1 = runner$tailLocal1;
      return this.fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(extendLastTopLevelScope$1, F$11, contP$3, extendedTopLevelScope, TheBuildR$lzy1$3, $$x2, $$x1, scope, view, new $c_sjsr_AnonFunction0(((this$2, scope$2, output$2, view$2, runner$tailLocal1$2) => (() => runner$tailLocal1$2.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(output$2.Lfs2_Pull$Output__f_values, scope$2, $as_Lfs2_Pull(view$2.apply__O__O(this$2.Lfs2_Pull$__f_fs2$Pull$$$unit)))))(this, scope, output, view, runner$tailLocal1$2$1)))
    };
    if ((x279 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
      var fmout = $as_Lfs2_Pull$FlatMapOutput(x279);
      var fmrunr = new $c_Lfs2_Pull$FlatMapR$1(extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem), fmout.Lfs2_Pull$FlatMapOutput__f_fun);
      var fa = F$11.unit__O();
      var $$x3 = $m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$2$1 = translation$tailLocal1;
      return $$x3.$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((this$2$1, extendLastTopLevelScope$1$2, F$11$2, contP$3$2, scope$3, extendedTopLevelScope$2, fmout$2, fmrunr$2, TheBuildR$lzy1$3$2, translation$tailLocal1$2) => (() => this$2$1.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$1$2, F$11$2, contP$3$2, TheBuildR$lzy1$3$2, scope$3, extendedTopLevelScope$2, translation$tailLocal1$2, fmrunr$2, fmout$2.Lfs2_Pull$FlatMapOutput__f_stream)))(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, fmout, fmrunr, TheBuildR$lzy1$3, translation$tailLocal1$2$1)), F$11)
    };
    if (false) {
      var u = $as_Lfs2_Pull$Uncons(x279);
      var v = $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem);
      var runr = $p_Lfs2_Pull$__TheBuildR$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$(this, F$11, TheBuildR$lzy1$3);
      var fa$1 = F$11.unit__O();
      var $$x4 = $m_Lcats_syntax_FlatMapOps$();
      var translation$tailLocal1$3$1 = translation$tailLocal1;
      var runner$tailLocal1$3$1 = runner$tailLocal1;
      return $$x4.$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa$1, new $c_sjsr_AnonFunction0(((this$3$1, extendLastTopLevelScope$1$3, F$11$3, contP$3$3, scope$4, extendedTopLevelScope$3, u$2, v$2, runr$2, TheBuildR$lzy1$3$3, translation$tailLocal1$3, runner$tailLocal1$3) => (() => {
        var fa$2 = this$3$1.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$1$3, F$11$3, contP$3$3, TheBuildR$lzy1$3$3, scope$4, extendedTopLevelScope$3, translation$tailLocal1$3, runr$2, u$2.stream__Lfs2_Pull());
        var target = F$11$3.attempt__O__O(fa$2);
        var this$9 = new $c_Lcats_FlatMap$$anon$2(target, F$11$3);
        var f$1 = new $c_sjsr_AnonFunction1(((this$8, extendLastTopLevelScope$27$2, F$39$2, contP$29$2, scope$28$2, extendedTopLevelScope$25$2, v$1$2, TheBuildR$lzy1$29$2, translation$tailLocal1$28$2, runner$tailLocal1$26$2) => ((_$69) => {
          var _$69$1 = $as_s_util_Either(_$69);
          if ((_$69$1 instanceof $c_s_util_Right)) {
            var x2 = $as_s_util_Right(_$69$1);
            var b = x2.s_util_Right__f_value;
            var _$71 = $as_F1(b);
            return _$71.apply__O__O(new $c_Lfs2_Pull$UnconsRunR$1(extendLastTopLevelScope$27$2, F$39$2, contP$29$2, scope$28$2, extendedTopLevelScope$25$2, TheBuildR$lzy1$29$2, translation$tailLocal1$28$2, runner$tailLocal1$26$2, v$1$2))
          } else if ((_$69$1 instanceof $c_s_util_Left)) {
            var x3 = $as_s_util_Left(_$69$1);
            var a = x3.s_util_Left__f_value;
            var _$70 = $as_jl_Throwable(a);
            return this$8.fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(extendLastTopLevelScope$27$2, F$39$2, contP$29$2, scope$28$2, extendedTopLevelScope$25$2, TheBuildR$lzy1$29$2, translation$tailLocal1$28$2, runner$tailLocal1$26$2, _$70, v$1$2)
          } else {
            throw new $c_s_MatchError(_$69$1)
          }
        }))(this$3$1, extendLastTopLevelScope$1$3, F$11$3, contP$3$3, scope$4, extendedTopLevelScope$3, v$2, TheBuildR$lzy1$3$3, translation$tailLocal1$3, runner$tailLocal1$3));
        return this$9.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$$anon$2__f_self, f$1)
      }))(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, u, v, runr, TheBuildR$lzy1$3, translation$tailLocal1$3$1, runner$tailLocal1$3$1)), F$11)
    };
    if (false) {
      var s = $as_Lfs2_Pull$StepLeg(x279);
      var v$3 = $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem);
      var runr$3 = $p_Lfs2_Pull$__TheBuildR$1__Lcats_MonadError__sr_LazyRef__Lfs2_Pull$TheBuildR$2$(this, F$11, TheBuildR$lzy1$3);
      var target$1 = scope.shiftScope__Lcats_effect_kernel_Unique$Token__F0__O(s.scope__Lcats_effect_kernel_Unique$Token(), new $c_sjsr_AnonFunction0(((s$2) => (() => s$2.toString__T()))(s)));
      var this$13 = new $c_Lcats_FlatMap$$anon$2(target$1, F$11);
      var translation$tailLocal1$4$1 = translation$tailLocal1;
      var f$2 = new $c_sjsr_AnonFunction1(((this$5$1, extendLastTopLevelScope$1$4, F$11$4, contP$3$4, extendedTopLevelScope$4, s$3, runr$4, TheBuildR$lzy1$3$4, translation$tailLocal1$4) => ((_$72) => {
        var _$72$1 = $as_Lfs2_internal_Scope(_$72);
        var fa$3 = this$5$1.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(extendLastTopLevelScope$1$4, F$11$4, contP$3$4, TheBuildR$lzy1$3$4, _$72$1, extendedTopLevelScope$4, translation$tailLocal1$4, runr$4, s$3.stream__Lfs2_Pull());
        return F$11$4.attempt__O__O(fa$3)
      }))(this, extendLastTopLevelScope$1, F$11, contP$3, extendedTopLevelScope, s, runr$3, TheBuildR$lzy1$3, translation$tailLocal1$4$1));
      var target$2 = this$13.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$13.Lcats_FlatMap$$anon$2__f_self, f$2);
      var this$15 = new $c_Lcats_FlatMap$$anon$2(target$2, F$11);
      var translation$tailLocal1$5$1 = translation$tailLocal1;
      var runner$tailLocal1$4$1 = runner$tailLocal1;
      var f$3 = new $c_sjsr_AnonFunction1(((this$6$1, extendLastTopLevelScope$1$5, F$11$5, contP$3$5, scope$5, extendedTopLevelScope$5, v$4, TheBuildR$lzy1$3$5, translation$tailLocal1$5, runner$tailLocal1$4) => ((_$73) => {
        var _$73$1 = $as_s_util_Either(_$73);
        if ((_$73$1 instanceof $c_s_util_Right)) {
          var x2$1 = $as_s_util_Right(_$73$1);
          var b$1 = x2$1.s_util_Right__f_value;
          var _$75 = $as_F1(b$1);
          return _$75.apply__O__O(new $c_Lfs2_Pull$StepLegRunR$1(extendLastTopLevelScope$1$5, F$11$5, contP$3$5, scope$5, extendedTopLevelScope$5, TheBuildR$lzy1$3$5, translation$tailLocal1$5, runner$tailLocal1$4, v$4))
        } else if ((_$73$1 instanceof $c_s_util_Left)) {
          var x3$1 = $as_s_util_Left(_$73$1);
          var a$1 = x3$1.s_util_Left__f_value;
          var _$74 = $as_jl_Throwable(a$1);
          return this$6$1.fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(extendLastTopLevelScope$1$5, F$11$5, contP$3$5, scope$5, extendedTopLevelScope$5, TheBuildR$lzy1$3$5, translation$tailLocal1$5, runner$tailLocal1$4, _$74, v$4)
        } else {
          throw new $c_s_MatchError(_$73$1)
        }
      }))(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, v$3, TheBuildR$lzy1$3, translation$tailLocal1$5$1, runner$tailLocal1$4$1));
      return this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, f$3)
    };
    if (false) {
      var this$17 = $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem);
      var v1 = new $c_Lfs2_Pull$Succeeded(scope);
      stream$tailLocal1 = this$17.cont__Lfs2_Pull$Terminal__Lfs2_Pull(v1);
      continue
    };
    if ((x279 instanceof $c_Lfs2_Pull$Eval)) {
      var eval$1 = $as_Lfs2_Pull$Eval(x279);
      return $p_Lfs2_Pull$__goEval$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Eval__F1__O(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, eval$1, $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem))
    };
    if ((x279 instanceof $c_Lfs2_Pull$Acquire)) {
      var acquire = $as_Lfs2_Pull$Acquire(x279);
      return $p_Lfs2_Pull$__goAcquire$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$Acquire__F1__O(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, acquire, $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem))
    };
    if ((x279 instanceof $c_Lfs2_Pull$InScope)) {
      var inScope = $as_Lfs2_Pull$InScope(x279);
      return $p_Lfs2_Pull$__goInScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__Z__F1__O(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, inScope.Lfs2_Pull$InScope__f_stream, inScope.Lfs2_Pull$InScope__f_useInterruption, $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem))
    };
    if ((x279 instanceof $c_Lfs2_Pull$InterruptWhen)) {
      var int = $as_Lfs2_Pull$InterruptWhen(x279);
      return $p_Lfs2_Pull$__goInterruptWhen$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__O__F1__O(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, translation$tailLocal1.apply__O__O(int.Lfs2_Pull$InterruptWhen__f_haltOnSignal), $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem))
    };
    if ((x279 instanceof $c_Lfs2_Pull$CloseScope)) {
      var close = $as_Lfs2_Pull$CloseScope(x279);
      return $p_Lfs2_Pull$__goCloseScope$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull$CloseScope__F1__O(this, extendLastTopLevelScope$1, F$11, contP$3, scope, extendedTopLevelScope, TheBuildR$lzy1$3, translation$tailLocal1, runner$tailLocal1, close, $as_Lfs2_Pull$ContP(contP$3.sr_ObjectRef__f_elem))
    };
    if ((x279 instanceof $c_Lfs2_Pull$Succeeded)) {
      return runner$tailLocal1.done__Lfs2_internal_Scope__O(scope)
    };
    if ((x279 instanceof $c_Lfs2_Pull$Fail)) {
      var failed = $as_Lfs2_Pull$Fail(x279);
      return runner$tailLocal1.fail__jl_Throwable__O(failed.Lfs2_Pull$Fail__f_error)
    };
    if ((x279 instanceof $c_Lfs2_Pull$Interrupted)) {
      var int$2 = $as_Lfs2_Pull$Interrupted(x279);
      return runner$tailLocal1.interrupted__Lfs2_Pull$Interrupted__O(int$2)
    };
    throw new $c_s_MatchError(x279)
  }
});
var $d_Lfs2_Pull$ = new $TypeData().initClass({
  Lfs2_Pull$: 0
}, false, "fs2.Pull$", {
  Lfs2_Pull$: 1,
  O: 1,
  Lfs2_PullLowPriority: 1
});
$c_Lfs2_Pull$.prototype.$classData = $d_Lfs2_Pull$;
var $n_Lfs2_Pull$;
function $m_Lfs2_Pull$() {
  if ((!$n_Lfs2_Pull$)) {
    $n_Lfs2_Pull$ = new $c_Lfs2_Pull$()
  };
  return $n_Lfs2_Pull$
}
function $is_Lfs2_Pull$ContP(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lfs2_Pull$ContP)))
}
function $as_Lfs2_Pull$ContP(obj) {
  return (($is_Lfs2_Pull$ContP(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$ContP"))
}
function $isArrayOf_Lfs2_Pull$ContP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ContP)))
}
function $asArrayOf_Lfs2_Pull$ContP(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$ContP(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$ContP;", depth))
}
function $p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull($thiz, chunk, tail) {
  if (((chunk.size__I() === 1) && (tail instanceof $c_Lfs2_Pull$Succeeded))) {
    try {
      return $as_Lfs2_Pull($thiz.Lfs2_Pull$FlatMapR$1__f_fun.apply__O__O(chunk.apply__I__O(0)))
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if ((e$2 !== null)) {
        var x173 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x173.isEmpty__Z())) {
          var x174 = $as_jl_Throwable(x173.get__O());
          return new $c_Lfs2_Pull$Fail(x174)
        }
      };
      throw e$2
    }
  } else {
    return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk, tail, 0)
  }
}
function $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull($thiz, chunk$1, tail$4, idx) {
  if ((idx === chunk$1.size__I())) {
    return $m_Lfs2_Pull$().flatMapOutput__Lfs2_Pull__F1__Lfs2_Pull(tail$4, $thiz.Lfs2_Pull$FlatMapR$1__f_fun)
  } else {
    try {
      return $m_Lfs2_Pull$().fs2$Pull$$$transformWith__Lfs2_Pull__F1__Lfs2_Pull($as_Lfs2_Pull($thiz.Lfs2_Pull$FlatMapR$1__f_fun.apply__O__O(chunk$1.apply__I__O(idx))), new $c_sjsr_AnonFunction1(((this$1, chunk$1$2, tail$4$2, idx$2) => ((x$1) => {
        var x$1$1 = $as_Lfs2_Pull$Terminal(x$1);
        if ((x$1$1 instanceof $c_Lfs2_Pull$Succeeded)) {
          var x$1$2 = $as_Lfs2_Pull$Succeeded(x$1$1);
          $as_jl_Void(x$1$2.Lfs2_Pull$Succeeded__f_r);
          return $p_Lfs2_Pull$FlatMapR$1__go$2__Lfs2_Chunk__Lfs2_Pull__I__Lfs2_Pull(this$1, chunk$1$2, tail$4$2, ((1 + idx$2) | 0))
        };
        if ((x$1$1 instanceof $c_Lfs2_Pull$Fail)) {
          var x$1$3 = $as_Lfs2_Pull$Fail(x$1$1);
          var x183 = x$1$3.Lfs2_Pull$Fail__f_error;
          return new $c_Lfs2_Pull$Fail(x183)
        };
        if ((x$1$1 instanceof $c_Lfs2_Pull$Interrupted)) {
          var x$1$4 = $as_Lfs2_Pull$Interrupted(x$1$1);
          var interruption = $as_Lfs2_Pull$Interrupted(x$1$1);
          return $m_Lfs2_Pull$().flatMapOutput__Lfs2_Pull__F1__Lfs2_Pull($m_Lfs2_Pull$().fs2$Pull$$$_$interruptBoundary$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$Interrupted__Lfs2_Pull(this$1.Lfs2_Pull$FlatMapR$1__f_contP$13, tail$4$2, interruption), this$1.Lfs2_Pull$FlatMapR$1__f_fun)
        };
        throw new $c_s_MatchError(x$1$1)
      }))($thiz, chunk$1, tail$4, idx)))
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if ((e$2 !== null)) {
        var x188 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x188.isEmpty__Z())) {
          var x189 = $as_jl_Throwable(x188.get__O());
          return new $c_Lfs2_Pull$Fail(x189)
        }
      };
      throw e$2
    }
  }
}
/** @constructor */
function $c_Lfs2_Pull$FlatMapR$1(extendLastTopLevelScope$40, F$54, contP$43, scope$39, extendedTopLevelScope$37, TheBuildR$lzy1$43, translation$tailLocal1$40, runner$tailLocal1$37, view, fun) {
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = false;
  this.Lfs2_Pull$FlatMapR$1__f_F$21 = null;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = null;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = null;
  this.Lfs2_Pull$FlatMapR$1__f_view = null;
  this.Lfs2_Pull$FlatMapR$1__f_fun = null;
  this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11 = extendLastTopLevelScope$40;
  this.Lfs2_Pull$FlatMapR$1__f_F$21 = F$54;
  this.Lfs2_Pull$FlatMapR$1__f_contP$13 = contP$43;
  this.Lfs2_Pull$FlatMapR$1__f_scope$13 = scope$39;
  this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10 = extendedTopLevelScope$37;
  this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13 = TheBuildR$lzy1$43;
  this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10 = translation$tailLocal1$40;
  this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10 = runner$tailLocal1$37;
  this.Lfs2_Pull$FlatMapR$1__f_view = view;
  this.Lfs2_Pull$FlatMapR$1__f_fun = fun
}
$c_Lfs2_Pull$FlatMapR$1.prototype = new $h_O();
$c_Lfs2_Pull$FlatMapR$1.prototype.constructor = $c_Lfs2_Pull$FlatMapR$1;
/** @constructor */
function $h_Lfs2_Pull$FlatMapR$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$FlatMapR$1.prototype = $c_Lfs2_Pull$FlatMapR$1.prototype;
$c_Lfs2_Pull$FlatMapR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$21, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, scope, this.Lfs2_Pull$FlatMapR$1__f_view, new $c_sjsr_AnonFunction0(((this$1, scope$2) => (() => $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this$1.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this$1.Lfs2_Pull$FlatMapR$1__f_F$21, this$1.Lfs2_Pull$FlatMapR$1__f_contP$13, this$1.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, scope$2, this$1.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this$1.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this$1.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, $as_Lfs2_Pull(this$1.Lfs2_Pull$FlatMapR$1__f_view.apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)))))(this, scope)))
});
$c_Lfs2_Pull$FlatMapR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  var next = $m_Lfs2_Pull$().fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull($p_Lfs2_Pull$FlatMapR$1__unconsed__Lfs2_Chunk__Lfs2_Pull__Lfs2_Pull(this, head, tail), this.Lfs2_Pull$FlatMapR$1__f_view);
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$21, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, outScope, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, next)
});
$c_Lfs2_Pull$FlatMapR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$21, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, $as_Lfs2_Pull(this.Lfs2_Pull$FlatMapR$1__f_view.apply__O__O(inter)))
});
$c_Lfs2_Pull$FlatMapR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$FlatMapR$1__f_extendLastTopLevelScope$11, this.Lfs2_Pull$FlatMapR$1__f_F$21, this.Lfs2_Pull$FlatMapR$1__f_contP$13, this.Lfs2_Pull$FlatMapR$1__f_scope$13, this.Lfs2_Pull$FlatMapR$1__f_extendedTopLevelScope$10, this.Lfs2_Pull$FlatMapR$1__f_TheBuildR$lzy1$13, this.Lfs2_Pull$FlatMapR$1__f_translation$tailLocal1$10, this.Lfs2_Pull$FlatMapR$1__f_runner$tailLocal1$10, e, this.Lfs2_Pull$FlatMapR$1__f_view)
});
var $d_Lfs2_Pull$FlatMapR$1 = new $TypeData().initClass({
  Lfs2_Pull$FlatMapR$1: 0
}, false, "fs2.Pull$FlatMapR$1", {
  Lfs2_Pull$FlatMapR$1: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$FlatMapR$1.prototype.$classData = $d_Lfs2_Pull$FlatMapR$1;
/** @constructor */
function $c_Lfs2_Pull$OuterRun$1(extendLastTopLevelScope$41, foldChunk$2, F$55, contP$44, initFk$2, TheBuildR$lzy1$44, initB) {
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = false;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_F$47 = null;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = null;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = null;
  this.Lfs2_Pull$OuterRun$1__f_accB = null;
  this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35 = extendLastTopLevelScope$41;
  this.Lfs2_Pull$OuterRun$1__f_foldChunk$1 = foldChunk$2;
  this.Lfs2_Pull$OuterRun$1__f_F$47 = F$55;
  this.Lfs2_Pull$OuterRun$1__f_contP$37 = contP$44;
  this.Lfs2_Pull$OuterRun$1__f_initFk$1 = initFk$2;
  this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37 = TheBuildR$lzy1$44;
  this.Lfs2_Pull$OuterRun$1__f_accB = initB
}
$c_Lfs2_Pull$OuterRun$1.prototype = new $h_O();
$c_Lfs2_Pull$OuterRun$1.prototype.constructor = $c_Lfs2_Pull$OuterRun$1;
/** @constructor */
function $h_Lfs2_Pull$OuterRun$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$OuterRun$1.prototype = $c_Lfs2_Pull$OuterRun$1.prototype;
$c_Lfs2_Pull$OuterRun$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return this.Lfs2_Pull$OuterRun$1__f_F$47.pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB)
});
$c_Lfs2_Pull$OuterRun$1.prototype.fail__jl_Throwable__O = (function(e) {
  return this.Lfs2_Pull$OuterRun$1__f_F$47.raiseError__O__O(e)
});
$c_Lfs2_Pull$OuterRun$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  var this$1 = inter.Lfs2_Pull$Interrupted__f_deferredError;
  if (this$1.isEmpty__Z()) {
    return this.Lfs2_Pull$OuterRun$1__f_F$47.pure__O__O(this.Lfs2_Pull$OuterRun$1__f_accB)
  } else {
    var arg1 = this$1.get__O();
    var e = $as_jl_Throwable(arg1);
    return this.Lfs2_Pull$OuterRun$1__f_F$47.raiseError__O__O(e)
  }
});
$c_Lfs2_Pull$OuterRun$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  try {
    this.Lfs2_Pull$OuterRun$1__f_accB = this.Lfs2_Pull$OuterRun$1__f_foldChunk$1.apply__O__O__O(this.Lfs2_Pull$OuterRun$1__f_accB, head);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35, this.Lfs2_Pull$OuterRun$1__f_F$47, this.Lfs2_Pull$OuterRun$1__f_contP$37, this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37, scope, $m_s_None$(), this.Lfs2_Pull$OuterRun$1__f_initFk$1, this, tail)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x307 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x307.isEmpty__Z())) {
        var x308 = $as_jl_Throwable(x307.get__O());
        var x294 = $m_Lfs2_Pull$().fs2$Pull$$$_$viewL$1__sr_ObjectRef__Lfs2_Pull__Lfs2_Pull$ViewL(this.Lfs2_Pull$OuterRun$1__f_contP$37, tail);
        if ((x294 instanceof $c_Lfs2_Pull$Action)) {
          var v = $as_Lfs2_Pull$ContP(this.Lfs2_Pull$OuterRun$1__f_contP$37.sr_ObjectRef__f_elem);
          var $$x7 = $m_Lfs2_Pull$();
          var $$x6 = this.Lfs2_Pull$OuterRun$1__f_extendLastTopLevelScope$35;
          var $$x5 = this.Lfs2_Pull$OuterRun$1__f_F$47;
          var $$x4 = this.Lfs2_Pull$OuterRun$1__f_contP$37;
          var $$x3 = this.Lfs2_Pull$OuterRun$1__f_TheBuildR$lzy1$37;
          var $$x2 = $m_s_None$();
          var $$x1 = this.Lfs2_Pull$OuterRun$1__f_initFk$1;
          var r = new $c_Lfs2_Pull$Fail(x308);
          return $$x7.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($$x6, $$x5, $$x4, $$x3, scope, $$x2, $$x1, this, v.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r))
        };
        if ((x294 instanceof $c_Lfs2_Pull$Succeeded)) {
          var x$1 = $as_Lfs2_Pull$Succeeded(x294);
          return this.Lfs2_Pull$OuterRun$1__f_F$47.raiseError__O__O(x308)
        };
        if ((x294 instanceof $c_Lfs2_Pull$Fail)) {
          var x$1$1 = $as_Lfs2_Pull$Fail(x294);
          var x301 = x$1$1.Lfs2_Pull$Fail__f_error;
          return this.Lfs2_Pull$OuterRun$1__f_F$47.raiseError__O__O($m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x301, x308, ($m_s_package$(), $m_sci_Nil$())))
        };
        if ((x294 instanceof $c_Lfs2_Pull$Interrupted)) {
          var x$1$2 = $as_Lfs2_Pull$Interrupted(x294);
          var x298 = x$1$2.Lfs2_Pull$Interrupted__f_deferredError;
          var $$x9 = this.Lfs2_Pull$OuterRun$1__f_F$47;
          if (x298.isEmpty__Z()) {
            var $$x8 = x308
          } else {
            var arg1 = x298.get__O();
            var t = $as_jl_Throwable(arg1);
            var $$x8 = $m_Lfs2_CompositeFailure$().apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x308, t, ($m_s_package$(), $m_sci_Nil$()))
          };
          return $$x9.raiseError__O__O($$x8)
        };
        throw new $c_s_MatchError(x294)
      }
    };
    throw e$2
  }
});
var $d_Lfs2_Pull$OuterRun$1 = new $TypeData().initClass({
  Lfs2_Pull$OuterRun$1: 0
}, false, "fs2.Pull$OuterRun$1", {
  Lfs2_Pull$OuterRun$1: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$OuterRun$1.prototype.$classData = $d_Lfs2_Pull$OuterRun$1;
function $ct_Lfs2_Pull$StepRunR$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__F1__($thiz, extendLastTopLevelScope$37, F$51, contP$40, scope$36, extendedTopLevelScope$34, TheBuildR$lzy1$40, translation$tailLocal1$37, runner$tailLocal1$34, view) {
  $thiz.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = extendLastTopLevelScope$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_F$18 = F$51;
  $thiz.Lfs2_Pull$StepRunR$1__f_contP$10 = contP$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_scope$10 = scope$36;
  $thiz.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = extendedTopLevelScope$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = TheBuildR$lzy1$40;
  $thiz.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = translation$tailLocal1$37;
  $thiz.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = runner$tailLocal1$34;
  $thiz.Lfs2_Pull$StepRunR$1__f_view = view;
  return $thiz
}
/** @constructor */
function $c_Lfs2_Pull$StepRunR$1() {
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_F$18 = null;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null
}
$c_Lfs2_Pull$StepRunR$1.prototype = new $h_O();
$c_Lfs2_Pull$StepRunR$1.prototype.constructor = $c_Lfs2_Pull$StepRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepRunR$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$StepRunR$1.prototype = $c_Lfs2_Pull$StepRunR$1.prototype;
$c_Lfs2_Pull$StepRunR$1.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_F$18, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, scope, this.Lfs2_Pull$StepRunR$1__f_view, new $c_sjsr_AnonFunction0(((this$1, scope$2) => (() => {
    var $$x9 = $m_Lfs2_Pull$();
    var $$x8 = this$1.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8;
    var $$x7 = this$1.Lfs2_Pull$StepRunR$1__f_F$18;
    var $$x6 = this$1.Lfs2_Pull$StepRunR$1__f_contP$10;
    var $$x5 = this$1.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10;
    var $$x4 = this$1.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7;
    var $$x3 = this$1.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7;
    var $$x2 = this$1.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7;
    var $$x1 = this$1.Lfs2_Pull$StepRunR$1__f_view;
    var r = $m_s_None$();
    return $$x9.fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O($$x8, $$x7, $$x6, $$x5, scope$2, $$x4, $$x3, $$x2, $as_Lfs2_Pull($$x1.apply__O__O(new $c_Lfs2_Pull$Succeeded(r))))
  }))(this, scope)))
});
$c_Lfs2_Pull$StepRunR$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_F$18, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, $as_Lfs2_Pull(this.Lfs2_Pull$StepRunR$1__f_view.apply__O__O(inter)))
});
$c_Lfs2_Pull$StepRunR$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8, this.Lfs2_Pull$StepRunR$1__f_F$18, this.Lfs2_Pull$StepRunR$1__f_contP$10, this.Lfs2_Pull$StepRunR$1__f_scope$10, this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7, this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10, this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7, this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7, e, this.Lfs2_Pull$StepRunR$1__f_view)
});
/** @constructor */
function $c_Lfs2_Pull$TheBuildR$2$(F$48) {
  this.Lfs2_Pull$TheBuildR$2$__f_F$10 = null;
  this.Lfs2_Pull$TheBuildR$2$__f_F$10 = F$48
}
$c_Lfs2_Pull$TheBuildR$2$.prototype = new $h_O();
$c_Lfs2_Pull$TheBuildR$2$.prototype.constructor = $c_Lfs2_Pull$TheBuildR$2$;
/** @constructor */
function $h_Lfs2_Pull$TheBuildR$2$() {
  /*<skip>*/
}
$h_Lfs2_Pull$TheBuildR$2$.prototype = $c_Lfs2_Pull$TheBuildR$2$.prototype;
$c_Lfs2_Pull$TheBuildR$2$.prototype.fail__jl_Throwable__O = (function(e) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$10.raiseError__O__O(e)
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.done__Lfs2_internal_Scope__O = (function(scope) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$10.pure__O__O(new $c_sjsr_AnonFunction1(((scope$2) => ((cont) => {
    var cont$1 = $as_Lfs2_Pull$Run$1(cont);
    return cont$1.done__Lfs2_internal_Scope__O(scope$2)
  }))(scope)))
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$10.pure__O__O(new $c_sjsr_AnonFunction1(((head$2, scope$2, tail$2) => ((cont) => {
    var cont$1 = $as_Lfs2_Pull$Run$1(cont);
    return cont$1.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head$2, scope$2, tail$2)
  }))(head, scope, tail)))
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(i) {
  return this.Lfs2_Pull$TheBuildR$2$__f_F$10.pure__O__O(new $c_sjsr_AnonFunction1(((i$2) => ((cont) => {
    var cont$1 = $as_Lfs2_Pull$Run$1(cont);
    return cont$1.interrupted__Lfs2_Pull$Interrupted__O(i$2)
  }))(i)))
});
function $as_Lfs2_Pull$TheBuildR$2$(obj) {
  return (((obj instanceof $c_Lfs2_Pull$TheBuildR$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$TheBuildR$2$"))
}
function $isArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$TheBuildR$2$)))
}
function $asArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$TheBuildR$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$TheBuildR$2$;", depth))
}
var $d_Lfs2_Pull$TheBuildR$2$ = new $TypeData().initClass({
  Lfs2_Pull$TheBuildR$2$: 0
}, false, "fs2.Pull$TheBuildR$2$", {
  Lfs2_Pull$TheBuildR$2$: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$TheBuildR$2$.prototype.$classData = $d_Lfs2_Pull$TheBuildR$2$;
/** @constructor */
function $c_Lfs2_Pull$TranslateRunner$1(extendLastTopLevelScope$36, F$50, contP$39, scope$35, extendedTopLevelScope$33, TheBuildR$lzy1$39, translation$tailLocal1$36, runner$tailLocal1$33, fk, view) {
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = false;
  this.Lfs2_Pull$TranslateRunner$1__f_F$17 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = null;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = null;
  this.Lfs2_Pull$TranslateRunner$1__f_view = null;
  this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7 = extendLastTopLevelScope$36;
  this.Lfs2_Pull$TranslateRunner$1__f_F$17 = F$50;
  this.Lfs2_Pull$TranslateRunner$1__f_contP$9 = contP$39;
  this.Lfs2_Pull$TranslateRunner$1__f_scope$8 = scope$35;
  this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6 = extendedTopLevelScope$33;
  this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9 = TheBuildR$lzy1$39;
  this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6 = translation$tailLocal1$36;
  this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6 = runner$tailLocal1$33;
  this.Lfs2_Pull$TranslateRunner$1__f_fk = fk;
  this.Lfs2_Pull$TranslateRunner$1__f_view = view
}
$c_Lfs2_Pull$TranslateRunner$1.prototype = new $h_O();
$c_Lfs2_Pull$TranslateRunner$1.prototype.constructor = $c_Lfs2_Pull$TranslateRunner$1;
/** @constructor */
function $h_Lfs2_Pull$TranslateRunner$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$TranslateRunner$1.prototype = $c_Lfs2_Pull$TranslateRunner$1.prototype;
$c_Lfs2_Pull$TranslateRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_F$17, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, doneScope, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, $as_Lfs2_Pull(this.Lfs2_Pull$TranslateRunner$1__f_view.apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)))
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  var $$x1 = $m_Lfs2_Pull$();
  var fk = this.Lfs2_Pull$TranslateRunner$1__f_fk;
  var next = $$x1.fs2$Pull$$$bindView__Lfs2_Pull__F1__Lfs2_Pull(new $c_Lfs2_Pull$Translate(tail, fk), this.Lfs2_Pull$TranslateRunner$1__f_view);
  return this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O(head, scope, next)
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_F$17, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, $as_Lfs2_Pull(this.Lfs2_Pull$TranslateRunner$1__f_view.apply__O__O(inter)))
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$TranslateRunner$1__f_extendLastTopLevelScope$7, this.Lfs2_Pull$TranslateRunner$1__f_F$17, this.Lfs2_Pull$TranslateRunner$1__f_contP$9, this.Lfs2_Pull$TranslateRunner$1__f_scope$8, this.Lfs2_Pull$TranslateRunner$1__f_extendedTopLevelScope$6, this.Lfs2_Pull$TranslateRunner$1__f_TheBuildR$lzy1$9, this.Lfs2_Pull$TranslateRunner$1__f_translation$tailLocal1$6, this.Lfs2_Pull$TranslateRunner$1__f_runner$tailLocal1$6, e, this.Lfs2_Pull$TranslateRunner$1__f_view)
});
var $d_Lfs2_Pull$TranslateRunner$1 = new $TypeData().initClass({
  Lfs2_Pull$TranslateRunner$1: 0
}, false, "fs2.Pull$TranslateRunner$1", {
  Lfs2_Pull$TranslateRunner$1: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$TranslateRunner$1.prototype.$classData = $d_Lfs2_Pull$TranslateRunner$1;
/** @constructor */
function $c_Lfs2_Pull$ViewRunner$1(extendLastTopLevelScope$5, F$15, contP$7, scope$5, extendedTopLevelScope$4, TheBuildR$lzy1$7, translation$tailLocal1$4, runner$tailLocal1$4, view) {
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = false;
  this.Lfs2_Pull$ViewRunner$1__f_F$16 = null;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = null;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = null;
  this.Lfs2_Pull$ViewRunner$1__f_view = null;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = null;
  this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6 = extendLastTopLevelScope$5;
  this.Lfs2_Pull$ViewRunner$1__f_F$16 = F$15;
  this.Lfs2_Pull$ViewRunner$1__f_contP$8 = contP$7;
  this.Lfs2_Pull$ViewRunner$1__f_scope$6 = scope$5;
  this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5 = extendedTopLevelScope$4;
  this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8 = TheBuildR$lzy1$7;
  this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5 = translation$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5 = runner$tailLocal1$4;
  this.Lfs2_Pull$ViewRunner$1__f_view = view;
  this.Lfs2_Pull$ViewRunner$1__f_prevRunner = runner$tailLocal1$4
}
$c_Lfs2_Pull$ViewRunner$1.prototype = new $h_O();
$c_Lfs2_Pull$ViewRunner$1.prototype.constructor = $c_Lfs2_Pull$ViewRunner$1;
/** @constructor */
function $h_Lfs2_Pull$ViewRunner$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$ViewRunner$1.prototype = $c_Lfs2_Pull$ViewRunner$1.prototype;
$c_Lfs2_Pull$ViewRunner$1.prototype.done__Lfs2_internal_Scope__O = (function(doneScope) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_F$16, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, doneScope, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, $as_Lfs2_Pull(this.Lfs2_Pull$ViewRunner$1__f_view.apply__O__O($m_Lfs2_Pull$().Lfs2_Pull$__f_fs2$Pull$$$unit)))
});
$c_Lfs2_Pull$ViewRunner$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, scope, tail) {
  return $s_Lfs2_Pull$__fs2$Pull$ViewRunner$1$$_$outLoop$1__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__Lfs2_Pull$Run$1__O(head, scope, tail, this)
});
$c_Lfs2_Pull$ViewRunner$1.prototype.interrupted__Lfs2_Pull$Interrupted__O = (function(inter) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_F$16, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_prevRunner, $as_Lfs2_Pull(this.Lfs2_Pull$ViewRunner$1__f_view.apply__O__O(inter)))
});
$c_Lfs2_Pull$ViewRunner$1.prototype.fail__jl_Throwable__O = (function(e) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$goErr$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__jl_Throwable__F1__O(this.Lfs2_Pull$ViewRunner$1__f_extendLastTopLevelScope$6, this.Lfs2_Pull$ViewRunner$1__f_F$16, this.Lfs2_Pull$ViewRunner$1__f_contP$8, this.Lfs2_Pull$ViewRunner$1__f_scope$6, this.Lfs2_Pull$ViewRunner$1__f_extendedTopLevelScope$5, this.Lfs2_Pull$ViewRunner$1__f_TheBuildR$lzy1$8, this.Lfs2_Pull$ViewRunner$1__f_translation$tailLocal1$5, this.Lfs2_Pull$ViewRunner$1__f_runner$tailLocal1$5, e, this.Lfs2_Pull$ViewRunner$1__f_view)
});
function $as_Lfs2_Pull$ViewRunner$1(obj) {
  return (((obj instanceof $c_Lfs2_Pull$ViewRunner$1) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$ViewRunner$1"))
}
function $isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$ViewRunner$1)))
}
function $asArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$ViewRunner$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$ViewRunner$1;", depth))
}
var $d_Lfs2_Pull$ViewRunner$1 = new $TypeData().initClass({
  Lfs2_Pull$ViewRunner$1: 0
}, false, "fs2.Pull$ViewRunner$1", {
  Lfs2_Pull$ViewRunner$1: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$ViewRunner$1.prototype.$classData = $d_Lfs2_Pull$ViewRunner$1;
function $p_Lfs2_Stream$__await$1__O__O__I__Lfs2_Stream($thiz, take$1, tryTake$1, limit$6) {
  return $m_Lfs2_Stream$().eval__O__Lfs2_Stream(take$1).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((this$1, take$1$2, tryTake$1$2, limit$6$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $m_Lfs2_Stream$().Lfs2_Stream$__f_empty
    };
    if ((x$1$1 instanceof $c_s_Some)) {
      var c = $as_s_Some(x$1$1).s_Some__f_value;
      var builder = $m_scm_Buffer$().newBuilder__scm_Builder();
      builder.addOne__O__scm_Growable(c);
      return $p_Lfs2_Stream$__pump$1__O__O__I__I__scm_Builder__Lfs2_Stream(this$1, take$1$2, tryTake$1$2, limit$6$2, 1, builder)
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, take$1, tryTake$1, limit$6)), new $c_s_util_NotGiven())
}
function $p_Lfs2_Stream$__pump$1__O__O__I__I__scm_Builder__Lfs2_Stream($thiz, take$2, tryTake$2, limit$7, currSize, acc) {
  return ((currSize === limit$7) ? $m_Lfs2_Stream$().emits__sc_Seq__Lfs2_Stream($as_sc_Seq(acc.result__O())).$plus$plus__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0(((this$1, take$2$2, tryTake$2$2, limit$7$2) => (() => $p_Lfs2_Stream$__await$1__O__O__I__Lfs2_Stream(this$1, take$2$2, tryTake$2$2, limit$7$2)))($thiz, take$2, tryTake$2, limit$7))) : $m_Lfs2_Stream$().eval__O__Lfs2_Stream(tryTake$2).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((this$2, take$2$3, tryTake$2$3, limit$7$3, currSize$2, acc$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      return $m_Lfs2_Stream$().emits__sc_Seq__Lfs2_Stream($as_sc_Seq(acc$2.result__O())).$plus$plus__F0__Lfs2_Stream(new $c_sjsr_AnonFunction0(((this$3, take$3$2, tryTake$3$2, limit$8$2) => (() => $p_Lfs2_Stream$__await$1__O__O__I__Lfs2_Stream(this$3, take$3$2, tryTake$3$2, limit$8$2)))(this$2, take$2$3, tryTake$2$3, limit$7$3)))
    };
    if ((x$1$1 instanceof $c_s_Some)) {
      var x411 = $as_s_Option($as_s_Some(x$1$1).s_Some__f_value);
      if ((x411 instanceof $c_s_Some)) {
        var c = $as_s_Some(x411).s_Some__f_value;
        acc$2.addOne__O__scm_Growable(c);
        return $p_Lfs2_Stream$__pump$1__O__O__I__I__scm_Builder__Lfs2_Stream(this$2, take$2$3, tryTake$2$3, limit$7$3, ((1 + currSize$2) | 0), acc$2)
      };
      var x$3 = $m_s_None$();
      if ((x$3 === x411)) {
        return $m_Lfs2_Stream$().emits__sc_Seq__Lfs2_Stream($as_sc_Seq(acc$2.result__O()))
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, take$2, tryTake$2, limit$7, currSize, acc)), new $c_s_util_NotGiven()))
}
/** @constructor */
function $c_Lfs2_Stream$() {
  this.Lfs2_Stream$__f_empty = null;
  $n_Lfs2_Stream$ = this;
  this.Lfs2_Stream$__f_empty = new $c_Lfs2_Stream($m_Lfs2_Pull$().Lfs2_Pull$__f_done)
}
$c_Lfs2_Stream$.prototype = new $h_O();
$c_Lfs2_Stream$.prototype.constructor = $c_Lfs2_Stream$;
/** @constructor */
function $h_Lfs2_Stream$() {
  /*<skip>*/
}
$h_Lfs2_Stream$.prototype = $c_Lfs2_Stream$.prototype;
$c_Lfs2_Stream$.prototype.bracket__O__F1__Lfs2_Stream = (function(acquire, release) {
  return this.bracketCase__O__F2__Lfs2_Stream(acquire, new $c_sjsr_AnonFunction2(((release$2) => ((r, _$80) => {
    $as_Lcats_effect_kernel_Resource$ExitCase(_$80);
    return release$2.apply__O__O(r)
  }))(release)))
});
$c_Lfs2_Stream$.prototype.bracketCase__O__F2__Lfs2_Stream = (function(acquire, release) {
  return this.bracketCaseWeak__O__F2__Lfs2_Stream(acquire, release).scope__Lfs2_Stream()
});
$c_Lfs2_Stream$.prototype.bracketCaseWeak__O__F2__Lfs2_Stream = (function(acquire, release) {
  $m_Lfs2_Pull$();
  var this$4 = new $c_Lfs2_Pull$Acquire(acquire, release, false);
  var f = new $c_sjsr_AnonFunction1(((_$82) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(_$82)));
  return new $c_Lfs2_Stream(new $c_Lfs2_Pull$$anon$1(f, this$4))
});
$c_Lfs2_Stream$.prototype.emit__O__Lfs2_Stream = (function(o) {
  return new $c_Lfs2_Stream($m_Lfs2_Pull$().output1__O__Lfs2_Pull(o))
});
$c_Lfs2_Stream$.prototype.emits__sc_Seq__Lfs2_Stream = (function(os) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (os === null) : x.equals__O__Z(os))) {
    return this.Lfs2_Stream$__f_empty
  };
  if ((os !== null)) {
    $m_sc_Seq$();
    if ((os.lengthCompare__I__I(1) === 0)) {
      var x394 = os.apply__I__O(0);
      return this.emit__O__Lfs2_Stream(x394)
    }
  };
  var $$x1 = $m_Lfs2_Pull$();
  var this$4 = $m_Lfs2_Chunk$();
  return new $c_Lfs2_Stream($$x1.output__Lfs2_Chunk__Lfs2_Pull(this$4.iterable__sc_Iterable__Lfs2_Chunk(os)))
});
$c_Lfs2_Stream$.prototype.eval__O__Lfs2_Stream = (function(fo) {
  $m_Lfs2_Pull$();
  var this$4 = new $c_Lfs2_Pull$Eval(fo);
  var f = new $c_sjsr_AnonFunction1(((o) => $m_Lfs2_Pull$().output1__O__Lfs2_Pull(o)));
  return new $c_Lfs2_Stream(new $c_Lfs2_Pull$$anon$1(f, this$4))
});
$c_Lfs2_Stream$.prototype.exec__O__Lfs2_Stream = (function(action) {
  return new $c_Lfs2_Stream(($m_Lfs2_Pull$(), new $c_Lfs2_Pull$Eval(action)))
});
$c_Lfs2_Stream$.prototype.fromQueueUnterminated__Lcats_effect_std_QueueSource__I__Lcats_Functor__Lfs2_Stream = (function(queue, limit, evidence$35) {
  var target = queue.Lcats_effect_std_Queue$AbstractQueue__f_take;
  var this$4 = new $c_Lcats_Functor$$anon$4(target, evidence$35);
  var f = new $c_sjsr_AnonFunction1(((a) => new $c_s_Some(a)));
  var take = this$4.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$$anon$4__f_self, f);
  var target$1 = queue.Lcats_effect_std_Queue$AbstractQueue__f_tryTake;
  var this$7 = new $c_Lcats_Functor$$anon$4(target$1, evidence$35);
  var f$1 = new $c_sjsr_AnonFunction1(((_$107) => {
    var _$107$1 = $as_s_Option(_$107);
    if (_$107$1.isEmpty__Z()) {
      return $m_s_None$()
    } else {
      var arg1 = _$107$1.get__O();
      return new $c_s_Some(new $c_s_Some(arg1))
    }
  }));
  var tryTake = this$7.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$7.Lcats_Functor$$anon$4__f_self, f$1);
  return $p_Lfs2_Stream$__await$1__O__O__I__Lfs2_Stream(this, take, tryTake, limit)
});
$c_Lfs2_Stream$.prototype.force__O__Lfs2_Stream = (function(f) {
  return this.eval__O__Lfs2_Stream(f).flatMap__F1__s_util_NotGiven__Lfs2_Stream(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_Lfs2_Stream(s);
    return s$1
  })), new $c_s_util_NotGiven())
});
var $d_Lfs2_Stream$ = new $TypeData().initClass({
  Lfs2_Stream$: 0
}, false, "fs2.Stream$", {
  Lfs2_Stream$: 1,
  O: 1,
  Lfs2_StreamLowPriority: 1
});
$c_Lfs2_Stream$.prototype.$classData = $d_Lfs2_Stream$;
var $n_Lfs2_Stream$;
function $m_Lfs2_Stream$() {
  if ((!$n_Lfs2_Stream$)) {
    $n_Lfs2_Stream$ = new $c_Lfs2_Stream$()
  };
  return $n_Lfs2_Stream$
}
function $p_Lfs2_concurrent_Channel$$anon$1__makeChunk__sci_List__I__Lfs2_Chunk($thiz, allValues, size) {
  var dimensions = new $ac_I(new Int32Array([size]));
  var arr = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
  var i = (((-1) + size) | 0);
  var values = allValues;
  while ((i >= 0)) {
    arr.set(i, values.head__O());
    values = $as_sci_List(values.tail__O());
    i = (((-1) + i) | 0)
  };
  var this$4 = $m_Lfs2_Chunk$();
  var evidence$2 = $m_s_reflect_ManifestFactory$AnyManifest$();
  var length = arr.u.length;
  if ((length === 0)) {
    return this$4.Lfs2_Chunk$__f_empty_
  } else if ((length === 1)) {
    var o = arr.get(0);
    return new $c_Lfs2_Chunk$Singleton(o)
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(arr, 0, length, evidence$2)
  }
}
/** @constructor */
function $c_Lfs2_concurrent_Channel$$anon$1(capacity$3, F$3, open$4, state$2, closedGate$2, State$lzy1$6) {
  this.Lfs2_concurrent_Channel$$anon$1__f_capacity$2 = 0;
  this.Lfs2_concurrent_Channel$$anon$1__f_F$2 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_open$3 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_state$1 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_closedGate$1 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5 = null;
  this.Lfs2_concurrent_Channel$$anon$1__f_capacity$2 = capacity$3;
  this.Lfs2_concurrent_Channel$$anon$1__f_F$2 = F$3;
  this.Lfs2_concurrent_Channel$$anon$1__f_open$3 = open$4;
  this.Lfs2_concurrent_Channel$$anon$1__f_state$1 = state$2;
  this.Lfs2_concurrent_Channel$$anon$1__f_closedGate$1 = closedGate$2;
  this.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5 = State$lzy1$6
}
$c_Lfs2_concurrent_Channel$$anon$1.prototype = new $h_O();
$c_Lfs2_concurrent_Channel$$anon$1.prototype.constructor = $c_Lfs2_concurrent_Channel$$anon$1;
/** @constructor */
function $h_Lfs2_concurrent_Channel$$anon$1() {
  /*<skip>*/
}
$h_Lfs2_concurrent_Channel$$anon$1.prototype = $c_Lfs2_concurrent_Channel$$anon$1.prototype;
$c_Lfs2_concurrent_Channel$$anon$1.prototype.send__O__O = (function(a) {
  var target = this.Lfs2_concurrent_Channel$$anon$1__f_F$2.deferred__O();
  var tc = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  var this$23 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2, a$2) => ((producer) => {
    var producer$1 = $as_Lcats_effect_kernel_Deferred(producer);
    return this$2.Lfs2_concurrent_Channel$$anon$1__f_F$2.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$3, a$1$2, producer$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var ffa = this$3.Lfs2_concurrent_Channel$$anon$1__f_state$1.modify__F1__O(new $c_sjsr_AnonFunction1(((this$4, a$2$2, producer$1$2, poll$2) => ((x$1) => {
        var x$1$1 = $as_Lfs2_concurrent_Channel$State$1(x$1);
        if ((x$1$1 !== null)) {
          $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this$4.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
          var x13 = x$1$1.Lfs2_concurrent_Channel$State$1__f_values;
          var x14 = x$1$1.Lfs2_concurrent_Channel$State$1__f_size;
          var x15 = x$1$1.Lfs2_concurrent_Channel$State$1__f_waiting;
          var x16 = x$1$1.Lfs2_concurrent_Channel$State$1__f_producers;
          var x17 = x$1$1.Lfs2_concurrent_Channel$State$1__f_closed;
          if ((x17 === true)) {
            var a$1 = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f__closed;
            var F = this$4.Lfs2_concurrent_Channel$$anon$1__f_F$2;
            var _2 = F.pure__O__O(a$1);
            return new $c_T2(x$1$1, _2)
          };
          if ((x17 === false)) {
            if ((x14 < this$4.Lfs2_concurrent_Channel$$anon$1__f_capacity$2)) {
              $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this$4.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
              var values = new $c_sci_$colon$colon(a$2$2, x13);
              var size = ((1 + x14) | 0);
              var waiting = $m_s_None$();
              var _1 = new $c_Lfs2_concurrent_Channel$State$1(values, size, waiting, x16, false);
              var target$1 = this$4.notifyStream__s_Option__O(x15);
              var tc$1 = this$4.Lfs2_concurrent_Channel$$anon$1__f_F$2;
              var this$11 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
              var b = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit;
              var _2$1 = this$11.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$11.Lcats_Functor$$anon$4__f_self, b);
              return new $c_T2(_1, _2$1)
            } else {
              $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this$4.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
              var waiting$1 = $m_s_None$();
              var elem$1 = new $c_T2(a$2$2, producer$1$2);
              var producers = new $c_sci_$colon$colon(elem$1, x16);
              var _1$1 = new $c_Lfs2_concurrent_Channel$State$1(x13, x14, waiting$1, producers, false);
              var target$2 = this$4.notifyStream__s_Option__O(x15);
              var tc$2 = this$4.Lfs2_concurrent_Channel$$anon$1__f_F$2;
              var this$16 = new $c_Lcats_Functor$$anon$4(target$2, tc$2);
              var b$1 = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit;
              var fa = this$16.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$16.Lcats_Functor$$anon$4__f_self, b$1);
              var F$1 = this$4.Lfs2_concurrent_Channel$$anon$1__f_F$2;
              var this$18 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$1);
              var fb = this$4.waitOnBound__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O(producer$1$2, poll$2);
              var this$19 = this$18.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
              var fa$1 = this$18.Lcats_syntax_ApplySyntax$$anon$1__f_self;
              var _2$2 = this$19.productL__O__O__O(fa$1, fb);
              return new $c_T2(_1$1, _2$2)
            }
          }
        };
        throw new $c_s_MatchError(x$1$1)
      }))(this$3, a$1$2, producer$2, poll$1)));
      var F$2 = this$3.Lfs2_concurrent_Channel$$anon$1__f_F$2;
      return $f_Lcats_FlatMap__flatten__O__O(F$2, ffa)
    }))(this$2, a$2, producer$1)))
  }))(this, a));
  return this$23.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$23.Lcats_FlatMap$$anon$2__f_self, f)
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.close__O = (function() {
  var ffa = this.Lfs2_concurrent_Channel$$anon$1__f_state$1.modify__F1__O(new $c_sjsr_AnonFunction1(((this$1) => ((x$1) => {
    var x$1$1 = $as_Lfs2_concurrent_Channel$State$1(x$1);
    if ((x$1$1 !== null)) {
      $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this$1.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
      var x39 = x$1$1.Lfs2_concurrent_Channel$State$1__f_values;
      var x40 = x$1$1.Lfs2_concurrent_Channel$State$1__f_size;
      var x41 = x$1$1.Lfs2_concurrent_Channel$State$1__f_waiting;
      var x42 = x$1$1.Lfs2_concurrent_Channel$State$1__f_producers;
      var x43 = x$1$1.Lfs2_concurrent_Channel$State$1__f_closed;
      if ((x43 === true)) {
        var a = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f__closed;
        var F = this$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
        var _2 = F.pure__O__O(a);
        return new $c_T2(x$1$1, _2)
      };
      if ((x43 === false)) {
        $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this$1.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
        var waiting = $m_s_None$();
        var _1 = new $c_Lfs2_concurrent_Channel$State$1(x39, x40, waiting, x42, true);
        var target = this$1.notifyStream__s_Option__O(x41);
        var tc = this$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
        var this$8 = new $c_Lcats_Functor$$anon$4(target, tc);
        var b = $m_Lfs2_concurrent_Channel$().Lfs2_concurrent_Channel$__f_fs2$concurrent$Channel$$$rightUnit;
        var fa = this$8.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$8.Lcats_Functor$$anon$4__f_self, b);
        var F$1 = this$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
        var this$10 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F$1);
        var fb = this$1.signalClosure__O();
        var this$11 = this$10.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
        var fa$1 = this$10.Lcats_syntax_ApplySyntax$$anon$1__f_self;
        var _2$1 = this$11.productL__O__O__O(fa$1, fb);
        return new $c_T2(_1, _2$1)
      }
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this)));
  var F$2 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  var wrapped = $f_Lcats_FlatMap__flatten__O__O(F$2, ffa);
  return $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped, this.Lfs2_concurrent_Channel$$anon$1__f_F$2)
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.stream__Lfs2_Stream = (function() {
  $m_Lfs2_Pull$();
  var self = this.consumeLoop__Lfs2_Pull();
  return $m_Lfs2_Pull$StreamPullOps$().stream$extension__Lfs2_Pull__Lfs2_Stream(self)
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.consumeLoop__Lfs2_Pull = (function() {
  $m_Lfs2_Pull$();
  var target = this.Lfs2_concurrent_Channel$$anon$1__f_F$2.deferred__O();
  var tc = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  var this$31 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((this$2) => ((waiting) => {
    var waiting$1 = $as_Lcats_effect_kernel_Deferred(waiting);
    var target$1 = this$2.Lfs2_concurrent_Channel$$anon$1__f_state$1.modify__F1__O(new $c_sjsr_AnonFunction1(((this$3, waiting$2) => ((state) => {
      var state$1 = $as_Lfs2_concurrent_Channel$State$1(state);
      var this$4 = state$1.Lfs2_concurrent_Channel$State$1__f_values;
      if ((!this$4.isEmpty__Z())) {
        var $$x1 = true
      } else {
        var this$5 = state$1.Lfs2_concurrent_Channel$State$1__f_producers;
        var $$x1 = (!this$5.isEmpty__Z())
      };
      if ($$x1) {
        var _1 = $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$empty$1__Lfs2_concurrent_Channel$State$1__sr_LazyRef__Z__Lfs2_concurrent_Channel$State$1(this$3.Lfs2_concurrent_Channel$$anon$1__f_open$3, this$3.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5, state$1.Lfs2_concurrent_Channel$State$1__f_closed);
        return new $c_T2(_1, state$1)
      } else {
        var waiting$2$1 = new $c_s_Some(waiting$2);
        var values$2 = state$1.Lfs2_concurrent_Channel$State$1__f_values;
        var size$2 = state$1.Lfs2_concurrent_Channel$State$1__f_size;
        var producers$2 = state$1.Lfs2_concurrent_Channel$State$1__f_producers;
        var closed$2 = state$1.Lfs2_concurrent_Channel$State$1__f_closed;
        var _1$1 = new $c_Lfs2_concurrent_Channel$State$1(values$2, size$2, waiting$2$1, producers$2, closed$2);
        return new $c_T2(_1$1, state$1)
      }
    }))(this$2, waiting$1)));
    var tc$1 = this$2.Lfs2_concurrent_Channel$$anon$1__f_F$2;
    var this$29 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
    var f = new $c_sjsr_AnonFunction1(((this$2$1, waiting$3) => ((x$1) => {
      var x$1$1 = $as_Lfs2_concurrent_Channel$State$1(x$1);
      if ((x$1$1 !== null)) {
        $m_Lfs2_concurrent_Channel$().fs2$concurrent$Channel$$$_$State$2__sr_LazyRef__Lfs2_concurrent_Channel$State$3$(this$2$1.Lfs2_concurrent_Channel$$anon$1__f_State$lzy1$5);
        var x49 = x$1$1.Lfs2_concurrent_Channel$State$1__f_values;
        var x50 = x$1$1.Lfs2_concurrent_Channel$State$1__f_size;
        var x52 = x$1$1.Lfs2_concurrent_Channel$State$1__f_producers;
        var x53 = x$1$1.Lfs2_concurrent_Channel$State$1__f_closed;
        var this$13 = x$1$1.Lfs2_concurrent_Channel$State$1__f_values;
        if ((!this$13.isEmpty__Z())) {
          var $$x2 = true
        } else {
          var this$14 = x$1$1.Lfs2_concurrent_Channel$State$1__f_producers;
          var $$x2 = (!this$14.isEmpty__Z())
        };
        if ($$x2) {
          var elem = 0;
          elem = x50;
          var elem$1 = null;
          elem$1 = x49;
          var this$17 = this$2$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
          var elem$2 = this$17.pure__O__O((void 0));
          var elem$3 = null;
          elem$3 = elem$2;
          var these = x52;
          while ((!these.isEmpty__Z())) {
            var arg1 = these.head__O();
            var x$1$2 = $as_T2(arg1);
            matchResult7: {
              if ((x$1$2 !== null)) {
                var value = x$1$2._1__O();
                var producer = $as_Lcats_effect_kernel_Deferred(x$1$2._2__O());
                var ev$14 = ((1 + elem) | 0);
                elem = ev$14;
                var this$19 = $as_sci_List(elem$1);
                var ev$15 = new $c_sci_$colon$colon(value, this$19);
                elem$1 = ev$15;
                var fa = elem$3;
                var F = this$2$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
                var this$21 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa, F);
                var fb = producer.complete__O__O((void 0));
                var this$22 = this$21.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$1 = this$21.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                var ev$16 = this$22.productL__O__O__O(fa$1, fb);
                elem$3 = ev$16;
                break matchResult7
              };
              throw new $c_s_MatchError(x$1$2)
            };
            these = $as_sci_List(these.tail__O())
          };
          var toEmit = $p_Lfs2_concurrent_Channel$$anon$1__makeChunk__sci_List__I__Lfs2_Chunk(this$2$1, $as_sci_List(elem$1), elem);
          var target$2 = elem$3;
          var tc$2 = this$2$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
          var this$25 = new $c_Lcats_Functor$$anon$4(target$2, tc$2);
          var this$24 = $m_Lfs2_Pull$().output__Lfs2_Chunk__Lfs2_Pull(toEmit);
          var post = new $c_sjsr_AnonFunction0(((this$2$2) => (() => this$2$2.consumeLoop__Lfs2_Pull()))(this$2$1));
          var b = new $c_Lfs2_Pull$$anon$2(post, this$24);
          return this$25.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$25.Lcats_Functor$$anon$4__f_self, b)
        } else {
          var $$x4 = this$2$1.Lfs2_concurrent_Channel$$anon$1__f_F$2;
          if (x53) {
            var $$x3 = $m_Lfs2_Pull$().Lfs2_Pull$__f_done
          } else {
            $m_Lfs2_Pull$();
            var fr = waiting$3.get__O();
            var this$28 = new $c_Lfs2_Pull$Eval(fr);
            var post$1 = new $c_sjsr_AnonFunction0(((this$3$1) => (() => this$3$1.consumeLoop__Lfs2_Pull()))(this$2$1));
            var $$x3 = new $c_Lfs2_Pull$$anon$2(post$1, this$28)
          };
          return $$x4.pure__O__O($$x3)
        }
      };
      throw new $c_s_MatchError(x$1$1)
    }))(this$2, waiting$1));
    var wrapped = this$29.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$29.Lcats_FlatMap$$anon$2__f_self, f);
    return $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped, this$2.Lfs2_concurrent_Channel$$anon$1__f_F$2)
  }))(this));
  var fr$1 = this$31.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$31.Lcats_FlatMap$$anon$2__f_self, f$1);
  var ffa = new $c_Lfs2_Pull$Eval(fr$1);
  $m_Lfs2_Pull$();
  new $c_Lfs2_PullMonadErrorInstance();
  $m_Lfs2_Pull$();
  var F$1 = new $c_Lfs2_PullMonadErrorInstance();
  return $as_Lfs2_Pull($f_Lcats_FlatMap__flatten__O__O(F$1, ffa))
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.notifyStream__s_Option__O = (function(waitForChanges) {
  $m_Lcats_UnorderedFoldable$();
  var tc = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption);
  var this$3 = new $c_Lcats_Traverse$$anon$3(waitForChanges, tc);
  var f = new $c_sjsr_AnonFunction1(((_$7) => {
    var _$7$1 = $as_Lcats_effect_kernel_Deferred(_$7);
    return _$7$1.complete__O__O((void 0))
  }));
  var ev$1 = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  return this$3.Lcats_Traverse$$anon$3__f_typeClassInstance.traverse__O__F1__Lcats_Applicative__O(this$3.Lcats_Traverse$$anon$3__f_self, f, ev$1)
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.waitOnBound__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__O = (function(producer, poll) {
  var wrapped = poll.apply__O__O(producer.get__O());
  var fin = this.Lfs2_concurrent_Channel$$anon$1__f_state$1.update__F1__O(new $c_sjsr_AnonFunction1(((producer$2) => ((s) => {
    var s$1 = $as_Lfs2_concurrent_Channel$State$1(s);
    var this$2 = s$1.Lfs2_concurrent_Channel$State$1__f_producers;
    var f = ((producer$3$2) => ((_$8) => {
      var _$8$1 = $as_T2(_$8);
      return (_$8$1._2__O() !== producer$3$2)
    }))(producer$2);
    var l = this$2;
    block: {
      var result;
      while (true) {
        if (l.isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break
        } else {
          var h = l.head__O();
          var t = $as_sci_List(l.tail__O());
          if (($uZ(f(h)) === false)) {
            l = t;
            continue
          };
          var start = l;
          var remaining = t;
          while (true) {
            if (remaining.isEmpty__Z()) {
              var result = start;
              break block
            } else {
              var x = remaining.head__O();
              if (($uZ(f(x)) !== false)) {
                remaining = $as_sci_List(remaining.tail__O());
                continue
              };
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
              var toProcess = $as_sci_List(start.tail__O());
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
                currentLast.sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = $as_sci_List(toProcess.tail__O())
              };
              var next = $as_sci_List(firstMiss.tail__O());
              var nextToCopy = next;
              while ((!next.isEmpty__Z())) {
                var head = next.head__O();
                if (($uZ(f(head)) !== false)) {
                  next = $as_sci_List(next.tail__O())
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                    currentLast.sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = $as_sci_List(nextToCopy.tail__O())
                  };
                  nextToCopy = $as_sci_List(next.tail__O());
                  next = $as_sci_List(next.tail__O())
                }
              };
              if ((!nextToCopy.isEmpty__Z())) {
                currentLast.sci_$colon$colon__f_next = nextToCopy
              };
              var result = newHead;
              break block
            }
          }
        }
      }
    };
    var values$1 = s$1.Lfs2_concurrent_Channel$State$1__f_values;
    var size$1 = s$1.Lfs2_concurrent_Channel$State$1__f_size;
    var waiting$1 = s$1.Lfs2_concurrent_Channel$State$1__f_waiting;
    var closed$1 = s$1.Lfs2_concurrent_Channel$State$1__f_closed;
    return new $c_Lfs2_concurrent_Channel$State$1(values$1, size$1, waiting$1, result, closed$1)
  }))(producer)));
  var F = this.Lfs2_concurrent_Channel$$anon$1__f_F$2;
  return F.onCancel__O__O__O(wrapped, fin)
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.signalClosure__O = (function() {
  return this.Lfs2_concurrent_Channel$$anon$1__f_closedGate$1.complete__O__O((void 0))
});
var $d_Lfs2_concurrent_Channel$$anon$1 = new $TypeData().initClass({
  Lfs2_concurrent_Channel$$anon$1: 0
}, false, "fs2.concurrent.Channel$$anon$1", {
  Lfs2_concurrent_Channel$$anon$1: 1,
  O: 1,
  Lfs2_concurrent_Channel: 1
});
$c_Lfs2_concurrent_Channel$$anon$1.prototype.$classData = $d_Lfs2_concurrent_Channel$$anon$1;
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$2(outer) {
  this.Lfs2_internal_Scope$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lfs2_internal_Scope$$anon$2__f_$outer = outer
}
$c_Lfs2_internal_Scope$$anon$2.prototype = new $h_O();
$c_Lfs2_internal_Scope$$anon$2.prototype.constructor = $c_Lfs2_internal_Scope$$anon$2;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$2() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope$$anon$2.prototype = $c_Lfs2_internal_Scope$$anon$2.prototype;
$c_Lfs2_internal_Scope$$anon$2.prototype.cancel__O = (function() {
  var this$1 = this.Lfs2_internal_Scope$$anon$2__f_$outer.Lfs2_internal_Scope__f_F;
  return this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0))
});
$c_Lfs2_internal_Scope$$anon$2.prototype.join__O = (function() {
  var this$3 = this.Lfs2_internal_Scope$$anon$2__f_$outer.Lfs2_internal_Scope__f_F;
  var this$1 = this.Lfs2_internal_Scope$$anon$2__f_$outer.Lfs2_internal_Scope__f_F;
  var fa = this$1.F__Lcats_effect_kernel_MonadCancel().pure__O__O((void 0));
  var a = new $c_Lcats_effect_kernel_Outcome$Succeeded(fa);
  return this$3.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
});
var $d_Lfs2_internal_Scope$$anon$2 = new $TypeData().initClass({
  Lfs2_internal_Scope$$anon$2: 0
}, false, "fs2.internal.Scope$$anon$2", {
  Lfs2_internal_Scope$$anon$2: 1,
  O: 1,
  Lcats_effect_kernel_Fiber: 1
});
$c_Lfs2_internal_Scope$$anon$2.prototype.$classData = $d_Lfs2_internal_Scope$$anon$2;
/** @constructor */
function $c_Lfs2_internal_ScopedResource$$anon$1(F$2, state$1, token$1) {
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_id = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_TheLease$lzy1 = null;
  this.Lfs2_internal_ScopedResource$$anon$1__f_TheLeasebitmap$1 = false;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4 = F$2;
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3 = state$1;
  this.Lfs2_internal_ScopedResource$$anon$1__f_id = token$1;
  $m_Lcats_implicits$();
  $m_s_package$();
  var a = new $c_s_util_Right((void 0));
  this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru = F$2.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a)
}
$c_Lfs2_internal_ScopedResource$$anon$1.prototype = new $h_Lfs2_internal_ScopedResource();
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.constructor = $c_Lfs2_internal_ScopedResource$$anon$1;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$$anon$1() {
  /*<skip>*/
}
$h_Lfs2_internal_ScopedResource$$anon$1.prototype = $c_Lfs2_internal_ScopedResource$$anon$1.prototype;
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.release__Lcats_effect_kernel_Resource$ExitCase__O = (function(ec) {
  $m_Lcats_implicits$();
  var target = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3.modify__F1__O(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_Lfs2_internal_ScopedResource$State(s);
    if ((s$1.Lfs2_internal_ScopedResource$State__f_leases !== 0)) {
      var finalizer = s$1.Lfs2_internal_ScopedResource$State__f_finalizer;
      var leases = s$1.Lfs2_internal_ScopedResource$State__f_leases;
      var _1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer, leases);
      var _2 = $m_s_None$();
      return new $c_T2(_1, _2)
    } else {
      var finalizer$1 = $m_s_None$();
      var leases$1 = s$1.Lfs2_internal_ScopedResource$State__f_leases;
      var _1$1 = new $c_Lfs2_internal_ScopedResource$State(false, finalizer$1, leases$1);
      var _2$1 = s$1.Lfs2_internal_ScopedResource$State__f_finalizer;
      return new $c_T2(_1$1, _2$1)
    }
  })));
  var tc = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
  var this$6 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$4, ec$2) => ((finalizer$2) => {
    var finalizer$3 = $as_s_Option(finalizer$2);
    if (finalizer$3.isEmpty__Z()) {
      var this$5 = $m_s_None$()
    } else {
      var arg1 = finalizer$3.get__O();
      var _$4 = $as_F1(arg1);
      var this$5 = new $c_s_Some(_$4.apply__O__O(ec$2))
    };
    return (this$5.isEmpty__Z() ? this$4.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$pru : this$5.get__O())
  }))(this, ec));
  return this$6.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$6.Lcats_FlatMap$$anon$2__f_self, f)
});
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.acquired__F1__O = (function(finalizer) {
  $m_Lcats_implicits$();
  var ffa = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$state$3.modify__F1__O(new $c_sjsr_AnonFunction1(((this$1, finalizer$2) => ((s) => {
    var s$1 = $as_Lfs2_internal_ScopedResource$State(s);
    if (((!s$1.Lfs2_internal_ScopedResource$State__f_open) && (s$1.Lfs2_internal_ScopedResource$State__f_leases === 0))) {
      $m_Lcats_implicits$();
      $m_Lcats_implicits$();
      var target = finalizer$2.apply__O__O($m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$());
      var tc = this$1.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var this$4 = new $c_Lcats_Functor$$anon$4(target, tc);
      var fa = this$4.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$4.Lcats_Functor$$anon$4__f_self, false);
      var F$1 = this$1.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var y = $f_Lcats_ApplicativeError__attempt__O__O(F$1, fa);
      return new $c_T2(s$1, y)
    } else {
      var attemptFinalizer = new $c_sjsr_AnonFunction1(((this$8, finalizer$5$2) => ((ec) => {
        var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
        $m_Lcats_implicits$();
        var fa$1 = finalizer$5$2.apply__O__O(ec$1);
        var F$3 = this$8.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
        return $f_Lcats_ApplicativeError__attempt__O__O(F$3, fa$1)
      }))(this$1, finalizer$2));
      var finalizer$1 = new $c_s_Some(attemptFinalizer);
      var open$1 = s$1.Lfs2_internal_ScopedResource$State__f_open;
      var leases$1 = s$1.Lfs2_internal_ScopedResource$State__f_leases;
      var self = new $c_Lfs2_internal_ScopedResource$State(open$1, finalizer$1, leases$1);
      $m_Lcats_implicits$();
      $m_s_package$();
      var a = new $c_s_util_Right(true);
      var F$4 = this$1.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
      var y$1 = F$4.F__Lcats_effect_kernel_MonadCancel().pure__O__O(a);
      return new $c_T2(self, y$1)
    }
  }))(this, finalizer)));
  var F$5 = this.Lfs2_internal_ScopedResource$$anon$1__f_fs2$internal$ScopedResource$$anon$1$$F$4;
  return $f_Lcats_FlatMap__flatten__O__O(F$5, ffa)
});
var $d_Lfs2_internal_ScopedResource$$anon$1 = new $TypeData().initClass({
  Lfs2_internal_ScopedResource$$anon$1: 0
}, false, "fs2.internal.ScopedResource$$anon$1", {
  Lfs2_internal_ScopedResource$$anon$1: 1,
  Lfs2_internal_ScopedResource: 1,
  O: 1
});
$c_Lfs2_internal_ScopedResource$$anon$1.prototype.$classData = $d_Lfs2_internal_ScopedResource$$anon$1;
function $p_jl_Character$__getTypeGE256__I__I($thiz, codePoint) {
  return $p_jl_Character$__charTypes__AI($thiz).get($p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, $p_jl_Character$__charTypeIndices__AI($thiz), codePoint, false))
}
function $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI($thiz) {
  if (((((1 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256 = new $ac_I(new Int32Array([15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 24, 24, 26, 24, 24, 24, 21, 22, 24, 25, 24, 20, 24, 24, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 24, 24, 25, 25, 25, 24, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 21, 24, 22, 27, 23, 27, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 21, 25, 22, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 26, 26, 26, 26, 28, 24, 27, 28, 5, 29, 25, 16, 28, 27, 28, 25, 11, 11, 27, 2, 24, 24, 27, 11, 5, 30, 11, 11, 11, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 25, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 25, 2, 2, 2, 2, 2, 2, 2, 2]));
    $thiz.jl_Character$__f_bitmap$0 = (((1 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256
}
function $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) {
  if (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    var deltas = new $ac_I(new Int32Array([257, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 3, 2, 1, 1, 1, 2, 1, 3, 2, 4, 1, 2, 1, 3, 3, 2, 1, 2, 1, 1, 1, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1, 3, 1, 1, 1, 2, 2, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 2, 1, 2, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 69, 1, 27, 18, 4, 12, 14, 5, 7, 1, 1, 1, 17, 112, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 3, 1, 5, 2, 1, 1, 3, 1, 1, 1, 2, 1, 17, 1, 9, 35, 1, 2, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 2, 2, 51, 48, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 38, 2, 1, 6, 1, 39, 1, 1, 1, 4, 1, 1, 45, 1, 1, 1, 2, 1, 2, 1, 1, 8, 27, 5, 3, 2, 11, 5, 1, 3, 2, 1, 2, 2, 11, 1, 2, 2, 32, 1, 10, 21, 10, 4, 2, 1, 99, 1, 1, 7, 1, 1, 6, 2, 2, 1, 4, 2, 10, 3, 2, 1, 14, 1, 1, 1, 1, 30, 27, 2, 89, 11, 1, 14, 10, 33, 9, 2, 1, 3, 1, 5, 22, 4, 1, 9, 1, 3, 1, 5, 2, 15, 1, 25, 3, 2, 1, 65, 1, 1, 11, 55, 27, 1, 3, 1, 54, 1, 1, 1, 1, 3, 8, 4, 1, 2, 1, 7, 10, 2, 2, 10, 1, 1, 6, 1, 7, 1, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 1, 3, 4, 2, 1, 1, 3, 4, 2, 2, 2, 2, 1, 1, 8, 1, 4, 2, 1, 3, 2, 2, 10, 2, 2, 6, 1, 1, 5, 2, 1, 1, 6, 4, 2, 2, 22, 1, 7, 1, 2, 1, 2, 1, 2, 2, 1, 1, 3, 2, 4, 2, 2, 3, 3, 1, 7, 4, 1, 1, 7, 10, 2, 3, 1, 11, 2, 1, 1, 9, 1, 3, 1, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 3, 5, 1, 2, 1, 1, 2, 1, 2, 1, 15, 2, 2, 2, 10, 1, 1, 15, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 1, 1, 1, 4, 2, 2, 2, 2, 1, 8, 1, 1, 4, 2, 1, 3, 2, 2, 10, 1, 1, 6, 10, 1, 1, 1, 6, 3, 3, 1, 4, 3, 2, 1, 1, 1, 2, 3, 2, 3, 3, 3, 12, 4, 2, 1, 2, 3, 3, 1, 3, 1, 2, 1, 6, 1, 14, 10, 3, 6, 1, 1, 6, 3, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 3, 1, 3, 4, 1, 3, 1, 4, 7, 2, 1, 2, 6, 2, 2, 2, 10, 8, 7, 1, 2, 2, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 2, 1, 1, 1, 1, 5, 1, 1, 2, 1, 2, 2, 7, 2, 7, 1, 1, 2, 2, 2, 10, 1, 2, 15, 2, 1, 8, 1, 3, 1, 41, 2, 1, 3, 4, 1, 3, 1, 3, 1, 1, 8, 1, 8, 2, 2, 2, 10, 6, 3, 1, 6, 2, 2, 1, 18, 3, 24, 1, 9, 1, 1, 2, 7, 3, 1, 4, 3, 3, 1, 1, 1, 8, 18, 2, 1, 12, 48, 1, 2, 7, 4, 1, 6, 1, 8, 1, 10, 2, 37, 2, 1, 1, 2, 2, 1, 1, 2, 1, 6, 4, 1, 7, 1, 3, 1, 1, 1, 1, 2, 2, 1, 4, 1, 2, 6, 1, 2, 1, 2, 5, 1, 1, 1, 6, 2, 10, 2, 4, 32, 1, 3, 15, 1, 1, 3, 2, 6, 10, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 8, 1, 36, 4, 14, 1, 5, 1, 2, 5, 11, 1, 36, 1, 8, 1, 6, 1, 2, 5, 4, 2, 37, 43, 2, 4, 1, 6, 1, 2, 2, 2, 1, 10, 6, 6, 2, 2, 4, 3, 1, 3, 2, 7, 3, 4, 13, 1, 2, 2, 6, 1, 1, 1, 10, 3, 1, 2, 38, 1, 1, 5, 1, 2, 43, 1, 1, 332, 1, 4, 2, 7, 1, 1, 1, 4, 2, 41, 1, 4, 2, 33, 1, 4, 2, 7, 1, 1, 1, 4, 2, 15, 1, 57, 1, 4, 2, 67, 2, 3, 9, 20, 3, 16, 10, 6, 85, 11, 1, 620, 2, 17, 1, 26, 1, 1, 3, 75, 3, 3, 15, 13, 1, 4, 3, 11, 18, 3, 2, 9, 18, 2, 12, 13, 1, 3, 1, 2, 12, 52, 2, 1, 7, 8, 1, 2, 11, 3, 1, 3, 1, 1, 1, 2, 10, 6, 10, 6, 6, 1, 4, 3, 1, 1, 10, 6, 35, 1, 52, 8, 41, 1, 1, 5, 70, 10, 29, 3, 3, 4, 2, 3, 4, 2, 1, 6, 3, 4, 1, 3, 2, 10, 30, 2, 5, 11, 44, 4, 17, 7, 2, 6, 10, 1, 3, 34, 23, 2, 3, 2, 2, 53, 1, 1, 1, 7, 1, 1, 1, 1, 2, 8, 6, 10, 2, 1, 10, 6, 10, 6, 7, 1, 6, 82, 4, 1, 47, 1, 1, 5, 1, 1, 5, 1, 2, 7, 4, 10, 7, 10, 9, 9, 3, 2, 1, 30, 1, 4, 2, 2, 1, 1, 2, 2, 10, 44, 1, 1, 2, 3, 1, 1, 3, 2, 8, 4, 36, 8, 8, 2, 2, 3, 5, 10, 3, 3, 10, 30, 6, 2, 64, 8, 8, 3, 1, 13, 1, 7, 4, 1, 4, 2, 1, 2, 9, 44, 63, 13, 1, 34, 37, 39, 21, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 8, 6, 2, 6, 2, 8, 8, 8, 8, 6, 2, 6, 2, 8, 1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 14, 2, 8, 8, 8, 8, 8, 8, 5, 1, 2, 4, 1, 1, 1, 3, 3, 1, 2, 4, 1, 3, 4, 2, 2, 4, 1, 3, 8, 5, 3, 2, 3, 1, 2, 4, 1, 2, 1, 11, 5, 6, 2, 1, 1, 1, 2, 1, 1, 1, 8, 1, 1, 5, 1, 9, 1, 1, 4, 2, 3, 1, 1, 1, 11, 1, 1, 1, 10, 1, 5, 5, 6, 1, 1, 2, 6, 3, 1, 1, 1, 10, 3, 1, 1, 1, 13, 3, 32, 16, 13, 4, 1, 3, 12, 15, 2, 1, 4, 1, 2, 1, 3, 2, 3, 1, 1, 1, 2, 1, 5, 6, 1, 1, 1, 1, 1, 1, 4, 1, 1, 4, 1, 4, 1, 2, 2, 2, 5, 1, 4, 1, 1, 2, 1, 1, 16, 35, 1, 1, 4, 1, 6, 5, 5, 2, 4, 1, 2, 1, 2, 1, 7, 1, 31, 2, 2, 1, 1, 1, 31, 268, 8, 4, 20, 2, 7, 1, 1, 81, 1, 30, 25, 40, 6, 18, 12, 39, 25, 11, 21, 60, 78, 22, 183, 1, 9, 1, 54, 8, 111, 1, 144, 1, 103, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 30, 44, 5, 1, 1, 31, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 256, 131, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 63, 1, 1, 1, 1, 32, 1, 1, 258, 48, 21, 2, 6, 3, 10, 166, 47, 1, 47, 1, 1, 1, 3, 2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 1, 6, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 6, 1, 1, 1, 1, 3, 1, 1, 5, 4, 1, 2, 38, 1, 1, 5, 1, 2, 56, 7, 1, 1, 14, 1, 23, 9, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 32, 2, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 9, 1, 2, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 10, 2, 68, 26, 1, 89, 12, 214, 26, 12, 4, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 9, 4, 2, 1, 5, 2, 3, 1, 1, 1, 2, 1, 86, 2, 2, 2, 2, 1, 1, 90, 1, 3, 1, 5, 41, 3, 94, 1, 2, 4, 10, 27, 5, 36, 12, 16, 31, 1, 10, 30, 8, 1, 15, 32, 10, 39, 15, 320, 6582, 10, 64, 20941, 51, 21, 1, 1143, 3, 55, 9, 40, 6, 2, 268, 1, 3, 16, 10, 2, 20, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 1, 70, 10, 2, 6, 8, 23, 9, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 12, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 77, 2, 1, 7, 1, 3, 1, 4, 1, 23, 2, 2, 1, 4, 4, 6, 2, 1, 1, 6, 52, 4, 8, 2, 50, 16, 1, 9, 2, 10, 6, 18, 6, 3, 1, 4, 10, 28, 8, 2, 23, 11, 2, 11, 1, 29, 3, 3, 1, 47, 1, 2, 4, 2, 1, 4, 13, 1, 1, 10, 4, 2, 32, 41, 6, 2, 2, 2, 2, 9, 3, 1, 8, 1, 1, 2, 10, 2, 4, 16, 1, 6, 3, 1, 1, 4, 48, 1, 1, 3, 2, 2, 5, 2, 1, 1, 1, 24, 2, 1, 2, 11, 1, 2, 2, 2, 1, 2, 1, 1, 10, 6, 2, 6, 2, 6, 9, 7, 1, 7, 145, 35, 2, 1, 2, 1, 2, 1, 1, 1, 2, 10, 6, 11172, 12, 23, 4, 49, 4, 2048, 6400, 366, 2, 106, 38, 7, 12, 5, 5, 1, 1, 10, 1, 13, 1, 5, 1, 1, 1, 2, 1, 2, 1, 108, 16, 17, 363, 1, 1, 16, 64, 2, 54, 40, 12, 1, 1, 2, 16, 7, 1, 1, 1, 6, 7, 9, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 4, 3, 3, 1, 4, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 3, 1, 1, 1, 2, 4, 5, 1, 135, 2, 1, 1, 3, 1, 3, 1, 1, 1, 1, 1, 1, 2, 10, 2, 3, 2, 26, 1, 1, 1, 1, 1, 1, 26, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 10, 1, 45, 2, 31, 3, 6, 2, 6, 2, 6, 2, 3, 3, 2, 1, 1, 1, 2, 1, 1, 4, 2, 10, 3, 2, 2, 12, 1, 26, 1, 19, 1, 2, 1, 15, 2, 14, 34, 123, 5, 3, 4, 45, 3, 9, 53, 4, 17, 1, 5, 12, 52, 45, 1, 130, 29, 3, 49, 47, 31, 1, 4, 12, 17, 1, 8, 1, 53, 30, 1, 1, 36, 4, 8, 1, 5, 42, 40, 40, 78, 2, 10, 854, 6, 2, 1, 1, 44, 1, 2, 3, 1, 2, 23, 1, 1, 8, 160, 22, 6, 3, 1, 26, 5, 1, 64, 56, 6, 2, 64, 1, 3, 1, 2, 5, 4, 4, 1, 3, 1, 27, 4, 3, 4, 1, 8, 8, 9, 7, 29, 2, 1, 128, 54, 3, 7, 22, 2, 8, 19, 5, 8, 128, 73, 535, 31, 385, 1, 1, 1, 53, 15, 7, 4, 20, 10, 16, 2, 1, 45, 3, 4, 2, 2, 2, 1, 4, 14, 25, 7, 10, 6, 3, 36, 5, 1, 8, 1, 10, 4, 60, 2, 1, 48, 3, 9, 2, 4, 4, 7, 10, 1190, 43, 1, 1, 1, 2, 6, 1, 1, 8, 10, 2358, 879, 145, 99, 13, 4, 2956, 1071, 13265, 569, 1223, 69, 11, 1, 46, 16, 4, 13, 16480, 2, 8190, 246, 10, 39, 2, 60, 2, 3, 3, 6, 8, 8, 2, 7, 30, 4, 48, 34, 66, 3, 1, 186, 87, 9, 18, 142, 26, 26, 26, 7, 1, 18, 26, 26, 1, 1, 2, 2, 1, 2, 2, 2, 4, 1, 8, 4, 1, 1, 1, 7, 1, 11, 26, 26, 2, 1, 4, 2, 8, 1, 7, 1, 26, 2, 1, 4, 1, 5, 1, 1, 3, 7, 1, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 28, 2, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 1, 1, 2, 50, 5632, 4, 1, 27, 1, 2, 1, 1, 2, 1, 1, 10, 1, 4, 1, 1, 1, 1, 6, 1, 4, 1, 1, 1, 1, 1, 1, 3, 1, 2, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 2, 4, 1, 7, 1, 4, 1, 4, 1, 1, 1, 10, 1, 17, 5, 3, 1, 5, 1, 17, 52, 2, 270, 44, 4, 100, 12, 15, 2, 14, 2, 15, 1, 15, 32, 11, 5, 31, 1, 60, 4, 43, 75, 29, 13, 43, 5, 9, 7, 2, 174, 33, 15, 6, 1, 70, 3, 20, 12, 37, 1, 5, 21, 17, 15, 63, 1, 1, 1, 182, 1, 4, 3, 62, 2, 4, 12, 24, 147, 70, 4, 11, 48, 70, 58, 116, 2188, 42711, 41, 4149, 11, 222, 16354, 542, 722403, 1, 30, 96, 128, 240, 65040, 65534, 2, 65534]));
    $thiz.jl_Character$__f_charTypeIndices = $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas);
    $thiz.jl_Character$__f_bitmap$0 = (((2 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_charTypeIndices
}
function $p_jl_Character$__charTypeIndices__AI($thiz) {
  return (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypeIndices)
}
function $p_jl_Character$__charTypes$lzycompute__AI($thiz) {
  if (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_charTypes = new $ac_I(new Int32Array([1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 1, 2, 5, 1, 3, 2, 1, 3, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 4, 27, 4, 27, 4, 27, 4, 27, 4, 27, 6, 1, 2, 1, 2, 4, 27, 1, 2, 0, 4, 2, 24, 0, 27, 1, 24, 1, 0, 1, 0, 1, 2, 1, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 25, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 6, 7, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 4, 24, 0, 2, 0, 24, 20, 0, 26, 0, 6, 20, 6, 24, 6, 24, 6, 24, 6, 0, 5, 0, 5, 24, 0, 16, 0, 25, 24, 26, 24, 28, 6, 24, 0, 24, 5, 4, 5, 6, 9, 24, 5, 6, 5, 24, 5, 6, 16, 28, 6, 4, 6, 28, 6, 5, 9, 5, 28, 5, 24, 0, 16, 5, 6, 5, 6, 0, 5, 6, 5, 0, 9, 5, 6, 4, 28, 24, 4, 0, 5, 6, 4, 6, 4, 6, 4, 6, 0, 24, 0, 5, 6, 0, 24, 0, 5, 0, 5, 0, 6, 0, 6, 8, 5, 6, 8, 6, 5, 8, 6, 8, 6, 8, 5, 6, 5, 6, 24, 9, 24, 4, 5, 0, 5, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 0, 5, 6, 0, 9, 5, 26, 11, 28, 26, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 9, 6, 5, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 6, 8, 0, 8, 6, 0, 5, 0, 5, 6, 0, 9, 24, 26, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 6, 0, 8, 0, 8, 6, 0, 6, 8, 0, 5, 0, 5, 6, 0, 9, 28, 5, 11, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 8, 6, 8, 0, 8, 0, 8, 6, 0, 5, 0, 8, 0, 9, 11, 28, 26, 28, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 8, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 6, 0, 9, 0, 11, 28, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 6, 8, 0, 8, 6, 0, 8, 0, 5, 0, 5, 6, 0, 9, 0, 5, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 6, 0, 9, 11, 0, 28, 5, 0, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 8, 0, 8, 24, 0, 5, 6, 5, 6, 0, 26, 5, 4, 6, 24, 9, 24, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 5, 6, 0, 6, 5, 0, 5, 0, 4, 0, 6, 0, 9, 0, 5, 0, 5, 28, 24, 28, 24, 28, 6, 28, 9, 11, 28, 6, 28, 6, 28, 6, 21, 22, 21, 22, 8, 5, 0, 5, 0, 6, 8, 6, 24, 6, 5, 6, 0, 6, 0, 28, 6, 28, 0, 28, 24, 28, 24, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 9, 24, 5, 8, 6, 5, 6, 5, 8, 5, 8, 5, 6, 5, 6, 8, 6, 8, 6, 5, 8, 9, 8, 6, 28, 1, 0, 1, 0, 1, 0, 5, 24, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 11, 0, 5, 28, 0, 5, 0, 20, 5, 24, 5, 12, 5, 21, 22, 0, 5, 24, 10, 0, 5, 0, 5, 6, 0, 5, 6, 24, 0, 5, 6, 0, 5, 0, 5, 0, 6, 0, 5, 6, 8, 6, 8, 6, 8, 6, 24, 4, 24, 26, 5, 6, 0, 9, 0, 11, 0, 24, 20, 24, 6, 12, 0, 9, 0, 5, 4, 5, 0, 5, 6, 5, 0, 5, 0, 5, 0, 6, 8, 6, 8, 0, 8, 6, 8, 6, 0, 28, 0, 24, 9, 5, 0, 5, 0, 5, 0, 8, 5, 8, 0, 9, 11, 0, 28, 5, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 6, 8, 6, 8, 6, 8, 6, 0, 6, 9, 0, 9, 0, 24, 4, 24, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 6, 8, 5, 0, 9, 24, 28, 6, 28, 0, 6, 8, 5, 8, 6, 8, 6, 8, 6, 8, 5, 9, 5, 6, 8, 6, 8, 6, 8, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 24, 9, 0, 5, 9, 5, 4, 24, 0, 24, 0, 6, 24, 6, 8, 6, 5, 6, 5, 8, 6, 5, 0, 2, 4, 2, 4, 2, 4, 6, 0, 6, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 2, 1, 2, 1, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 0, 2, 3, 2, 3, 2, 3, 2, 0, 2, 1, 3, 27, 2, 27, 2, 0, 2, 1, 3, 27, 2, 0, 2, 1, 0, 27, 2, 1, 27, 0, 2, 0, 2, 1, 3, 27, 0, 12, 16, 20, 24, 29, 30, 21, 29, 30, 21, 29, 24, 13, 14, 16, 12, 24, 29, 30, 24, 23, 24, 25, 21, 22, 24, 25, 24, 23, 24, 12, 16, 0, 16, 11, 4, 0, 11, 25, 21, 22, 4, 11, 25, 21, 22, 0, 4, 0, 26, 0, 6, 7, 6, 7, 6, 0, 28, 1, 28, 1, 28, 2, 1, 2, 1, 2, 28, 1, 28, 25, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 2, 1, 2, 5, 2, 28, 2, 1, 25, 1, 2, 28, 25, 28, 2, 28, 11, 10, 1, 2, 10, 11, 0, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 28, 25, 28, 25, 28, 25, 28, 0, 28, 0, 28, 0, 11, 28, 11, 28, 25, 28, 25, 28, 25, 28, 25, 28, 0, 28, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 11, 28, 25, 21, 22, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 28, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 21, 22, 21, 22, 25, 21, 22, 25, 28, 25, 28, 25, 0, 28, 0, 1, 0, 2, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 1, 2, 1, 2, 6, 1, 2, 0, 24, 11, 24, 2, 0, 2, 0, 2, 0, 5, 0, 4, 24, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 29, 30, 29, 30, 24, 29, 30, 24, 29, 30, 24, 20, 24, 20, 24, 29, 30, 24, 29, 30, 21, 22, 21, 22, 21, 22, 21, 22, 24, 4, 24, 20, 0, 28, 0, 28, 0, 28, 0, 28, 0, 12, 24, 28, 4, 5, 10, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 28, 21, 22, 21, 22, 21, 22, 21, 22, 20, 21, 22, 28, 10, 6, 8, 20, 4, 28, 10, 4, 5, 24, 28, 0, 5, 0, 6, 27, 4, 5, 20, 5, 24, 4, 5, 0, 5, 0, 5, 0, 28, 11, 28, 5, 0, 28, 0, 5, 28, 0, 11, 28, 11, 28, 11, 28, 11, 28, 11, 28, 5, 0, 28, 5, 0, 5, 4, 5, 0, 28, 0, 5, 4, 24, 5, 4, 24, 5, 9, 5, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 6, 7, 24, 6, 24, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 6, 5, 10, 6, 24, 0, 27, 4, 27, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 27, 1, 2, 1, 2, 0, 1, 2, 1, 2, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 0, 4, 2, 5, 6, 5, 6, 5, 6, 5, 8, 6, 8, 28, 0, 11, 28, 26, 28, 0, 5, 24, 0, 8, 5, 8, 6, 0, 24, 9, 0, 6, 5, 24, 5, 0, 9, 5, 6, 24, 5, 6, 8, 0, 24, 5, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 24, 0, 4, 9, 0, 24, 0, 5, 6, 8, 6, 8, 6, 0, 5, 6, 5, 6, 8, 0, 9, 0, 24, 5, 4, 5, 28, 5, 8, 0, 5, 6, 5, 6, 5, 6, 5, 6, 5, 6, 5, 0, 5, 4, 24, 5, 8, 6, 8, 24, 5, 4, 8, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 8, 6, 8, 6, 8, 24, 8, 6, 0, 9, 0, 5, 0, 5, 0, 5, 0, 19, 18, 5, 0, 5, 0, 2, 0, 2, 0, 5, 6, 5, 25, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 27, 0, 5, 21, 22, 0, 5, 0, 5, 0, 5, 26, 28, 0, 6, 24, 21, 22, 24, 0, 6, 0, 24, 20, 23, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 24, 21, 22, 24, 23, 24, 0, 24, 20, 21, 22, 21, 22, 21, 22, 24, 25, 20, 25, 0, 24, 26, 24, 0, 5, 0, 5, 0, 16, 0, 24, 26, 24, 21, 22, 24, 25, 24, 20, 24, 9, 24, 25, 24, 1, 21, 24, 22, 27, 23, 27, 2, 21, 25, 22, 25, 21, 22, 24, 21, 22, 24, 5, 4, 5, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 26, 25, 27, 28, 26, 0, 28, 25, 28, 0, 16, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 0, 11, 0, 28, 10, 11, 28, 11, 0, 28, 0, 28, 6, 0, 5, 0, 5, 0, 5, 0, 11, 0, 5, 10, 5, 10, 0, 5, 0, 24, 5, 0, 5, 24, 10, 0, 1, 2, 5, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 11, 0, 5, 11, 0, 24, 5, 0, 24, 0, 5, 0, 5, 0, 5, 6, 0, 6, 0, 6, 5, 0, 5, 0, 5, 0, 6, 0, 6, 11, 0, 24, 0, 5, 11, 24, 0, 5, 0, 24, 5, 0, 11, 5, 0, 11, 0, 5, 0, 11, 0, 8, 6, 8, 5, 6, 24, 0, 11, 9, 0, 6, 8, 5, 8, 6, 8, 6, 24, 16, 24, 0, 5, 0, 9, 0, 6, 5, 6, 8, 6, 0, 9, 24, 0, 6, 8, 5, 8, 6, 8, 5, 24, 0, 9, 0, 5, 6, 8, 6, 8, 6, 8, 6, 0, 9, 0, 5, 0, 10, 0, 24, 0, 5, 0, 5, 0, 5, 0, 5, 8, 0, 6, 4, 0, 5, 0, 28, 0, 28, 0, 28, 8, 6, 28, 8, 16, 6, 28, 6, 28, 6, 28, 0, 28, 6, 28, 0, 28, 0, 11, 0, 1, 2, 1, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 0, 2, 0, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 2, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 25, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 11, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 16, 0, 16, 0, 6, 0, 18, 0, 18, 0]));
    $thiz.jl_Character$__f_bitmap$0 = (((4 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_charTypes
}
function $p_jl_Character$__charTypes__AI($thiz) {
  return (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypes$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypes)
}
function $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas) {
  var acc = deltas.get(0);
  var i = 1;
  var len = deltas.u.length;
  while ((i !== len)) {
    acc = ((acc + deltas.get(i)) | 0);
    deltas.set(i, acc);
    i = ((1 + i) | 0)
  };
  return deltas
}
function $p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, startOfRangesArray, value, hasEmptyRanges) {
  var i = $m_ju_Arrays$().binarySearch__AI__I__I(startOfRangesArray, value);
  if ((i >= 0)) {
    if (hasEmptyRanges) {
      var j = ((1 + i) | 0);
      while (((j < startOfRangesArray.u.length) && (startOfRangesArray.get(j) === value))) {
        j = ((1 + j) | 0)
      };
      return j
    } else {
      return ((1 + i) | 0)
    }
  } else {
    return (((-1) - i) | 0)
  }
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) {
  if (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I(new Int32Array([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43600, 44016, 65296, 66720, 69734, 69872, 69942, 70096, 71360, 120782, 120792, 120802, 120812, 120822]));
    $thiz.jl_Character$__f_bitmap$0 = (((32 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints
}
function $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI($thiz) {
  return (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) : $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints)
}
function $p_jl_Character$__isSeparator$1__I__Z($thiz, tpe) {
  return (((tpe === 12) || (tpe === 13)) || (tpe === 14))
}
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_isMirroredIndices = null;
  this.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0
}
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
  /*<skip>*/
}
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if (((codePoint >= 0) && (codePoint < 65536))) {
    return $as_T(String.fromCharCode(codePoint))
  } else if (((codePoint >= 0) && (codePoint <= 1114111))) {
    return $as_T(String.fromCharCode((65535 & (55296 | (((-64) + (codePoint >> 10)) | 0))), (65535 & (56320 | (1023 & codePoint)))))
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_jl_Character$.prototype.getType__I__I = (function(codePoint) {
  return ((codePoint < 0) ? 0 : ((codePoint < 256) ? this.java$lang$Character$$charTypesFirst256__AI().get(codePoint) : $p_jl_Character$__getTypeGE256__I__I(this, codePoint)))
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((codePoint >= 48) && (codePoint <= 57)) ? (((-48) + codePoint) | 0) : (((codePoint >= 65) && (codePoint <= 90)) ? (((-55) + codePoint) | 0) : (((codePoint >= 97) && (codePoint <= 122)) ? (((-87) + codePoint) | 0) : (-1))))
  } else if (((codePoint >= 65313) && (codePoint <= 65338))) {
    var value = (((-65303) + codePoint) | 0)
  } else if (((codePoint >= 65345) && (codePoint <= 65370))) {
    var value = (((-65335) + codePoint) | 0)
  } else {
    var a = $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this);
    var p = $m_ju_Arrays$().binarySearch__AI__I__I(a, codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1)
    } else {
      var v = ((codePoint - $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this).get(zeroCodePointIndex)) | 0);
      var value = ((v > 9) ? (-1) : v)
    }
  };
  return ((value < radix) ? value : (-1))
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  if ((ch < 256)) {
    return (ch === 48)
  } else {
    var a = $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this);
    var key = ch;
    return ($m_ju_Arrays$().binarySearch__AI__I__I(a, key) >= 0)
  }
});
$c_jl_Character$.prototype.isWhitespace__I__Z = (function(codePoint) {
  return ((codePoint < 256) ? (((((((codePoint === 9) || (codePoint === 10)) || (codePoint === 11)) || (codePoint === 12)) || (codePoint === 13)) || ((codePoint >= 28) && (codePoint <= 31))) || ((codePoint !== 160) && $p_jl_Character$__isSeparator$1__I__Z(this, this.java$lang$Character$$charTypesFirst256__AI().get(codePoint)))) : (((codePoint !== 8199) && (codePoint !== 8239)) && $p_jl_Character$__isSeparator$1__I__Z(this, $p_jl_Character$__getTypeGE256__I__I(this, codePoint))))
});
$c_jl_Character$.prototype.isDigit__I__Z = (function(cp) {
  if ((cp < 256)) {
    return ((cp >= 48) && (cp <= 57))
  } else {
    var tpe = $p_jl_Character$__getTypeGE256__I__I(this, cp);
    return (tpe === 9)
  }
});
$c_jl_Character$.prototype.isLetter__I__Z = (function(cp) {
  var tpe = this.getType__I__I(cp);
  return (((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5))
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch))
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break
    }
    default: {
      if (((codePoint >= 8064) && (codePoint <= 8111))) {
        return (8 | codePoint)
      } else {
        var this$1 = this.toString__I__T(codePoint);
        var upperChars = $as_T(this$1.toUpperCase());
        var x1$2 = $uI(upperChars.length);
        switch (x1$2) {
          case 1: {
            return (65535 & $uI(upperChars.charCodeAt(0)));
            break
          }
          case 2: {
            var high = (65535 & $uI(upperChars.charCodeAt(0)));
            var low = (65535 & $uI(upperChars.charCodeAt(1)));
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break
          }
          default: {
            return codePoint
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__C__C = (function(ch) {
  return (65535 & this.toLowerCase__I__I(ch))
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105
  } else {
    var this$1 = this.toString__I__T(codePoint);
    var lowerChars = $as_T(this$1.toLowerCase());
    var x1$2 = $uI(lowerChars.length);
    switch (x1$2) {
      case 1: {
        return (65535 & $uI(lowerChars.charCodeAt(0)));
        break
      }
      case 2: {
        var high = (65535 & $uI(lowerChars.charCodeAt(0)));
        var low = (65535 & $uI(lowerChars.charCodeAt(1)));
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break
      }
      default: {
        return codePoint
      }
    }
  }
});
$c_jl_Character$.prototype.java$lang$Character$$charTypesFirst256__AI = (function() {
  return (((((1 & this.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI(this) : this.jl_Character$__f_java$lang$Character$$charTypesFirst256)
});
var $d_jl_Character$ = new $TypeData().initClass({
  jl_Character$: 0
}, false, "java.lang.Character$", {
  jl_Character$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Character$.prototype.$classData = $d_jl_Character$;
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$()
  };
  return $n_jl_Character$
}
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrPat
}
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat)
}
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24)
  };
  return $thiz.jl_Double$__f_doubleStrHexPat
}
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat)
}
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var signStr = $as_T(groups[1]);
  var integralPartStr = $as_T(groups[2]);
  var fractionalPartStr = $as_T(groups[3]);
  var binaryExpStr = $as_T(groups[4]);
  if (((integralPartStr === "") && (fractionalPartStr === ""))) {
    $p_jl_Double$__fail$1__T__E($thiz, s)
  };
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 15);
  return ((signStr === "-") ? (-absResult) : absResult)
}
function $p_jl_Double$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0
}
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
  /*<skip>*/
}
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  return ((groups !== null) ? $uD(parseFloat(groups[1])) : $p_jl_Double$__parseDoubleSlowPath__T__D(this, s))
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var correction1 = ((-($uI(fractionalPartStr.length) << 2)) | 0);
  var i = 0;
  while (true) {
    if ((i !== $uI(mantissaStr0.length))) {
      var index = i;
      var $$x1 = ((65535 & $uI(mantissaStr0.charCodeAt(index))) === 48)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      i = ((1 + i) | 0)
    } else {
      break
    }
  };
  var beginIndex = i;
  var mantissaStr = $as_T(mantissaStr0.substring(beginIndex));
  if ((mantissaStr === "")) {
    return 0.0
  };
  var mantissaStrLen = $uI(mantissaStr.length);
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var index$1 = j;
      if (((65535 & $uI(mantissaStr.charCodeAt(index$1))) !== 48)) {
        hasNonZeroChar = true
      };
      j = ((1 + j) | 0)
    };
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var truncatedMantissaStr = ($as_T(mantissaStr.substring(0, maxPrecisionChars)) + compressedTail)
  } else {
    var truncatedMantissaStr = mantissaStr
  };
  var correction2 = (needsCorrection2 ? ((($uI(mantissaStr.length) - ((1 + maxPrecisionChars) | 0)) | 0) << 2) : 0);
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = $uD(parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = $uD(parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  var binExpAndCorrection = ((binaryExp + fullCorrection) | 0);
  var binExpAndCorrection_div_3 = ((binExpAndCorrection / 3) | 0);
  var b = binExpAndCorrection_div_3;
  var correctingPow = $uD(Math.pow(2.0, b));
  var b$1 = ((binExpAndCorrection - (binExpAndCorrection_div_3 << 1)) | 0);
  var correctingPow3 = $uD(Math.pow(2.0, b$1));
  return (((mantissa * correctingPow) * correctingPow) * correctingPow3)
});
$c_jl_Double$.prototype.compare__D__D__I = (function(a, b) {
  if ((a !== a)) {
    return ((b !== b) ? 0 : 1)
  } else if ((b !== b)) {
    return (-1)
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1))
    } else {
      return 0
    }
  } else {
    return ((a < b) ? (-1) : 1)
  }
});
var $d_jl_Double$ = new $TypeData().initClass({
  jl_Double$: 0
}, false, "java.lang.Double$", {
  jl_Double$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Double$.prototype.$classData = $d_jl_Double$;
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$()
  };
  return $n_jl_Double$
}
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true
  };
  return $thiz.jl_Float$__f_parseFloatRegExp
}
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp)
}
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = $uD(parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z)
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = ((zDouble + zUp) / 2.0);
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z)
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = ((zDouble + zDown) / 2.0);
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z)
  }
}
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), (("" + integralPartStr) + fractionalPartStr));
  var this$1 = $m_jl_Integer$();
  var e = ((this$1.parseInt__T__I__I(exponentStr, 10) - $uI(fractionalPartStr.length)) | 0);
  var t = $m_jl_FloatingPointBits$().doubleToLongBits__D__J(mid);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw new $c_jl_AssertionError(("parseFloatCorrection was given a subnormal mid: " + mid))
  };
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$3));
  var k = (((-1075) + lo$1) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var y = m.shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = x.compareTo__Ljava_math_BigInteger__I(y)
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = v.shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = x$1.compareTo__Ljava_math_BigInteger__I(m)
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = v$1.shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1)
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$4));
    var cmp = x$2.compareTo__Ljava_math_BigInteger__I(y$2)
  };
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $m_jl_FloatingPointBits$().floatToIntBits__F__I(zDown)) === 0) ? zDown : zUp)))
}
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return Math.fround(doubleValue)
}
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false
}
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
  /*<skip>*/
}
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
  };
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN)
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var fullNumberStr = $as_T(x$3);
        var x$4 = groups[5];
        var integralPartStr = $as_T(((x$4 !== (void 0)) ? x$4 : ""));
        var x$5 = groups[6];
        var $$x1 = $as_T(((x$5 !== (void 0)) ? x$5 : ""));
        var x$6 = groups[7];
        var fractionalPartStr = (("" + $$x1) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = $as_T(((x$7 !== (void 0)) ? x$7 : "0"));
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr)
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = $as_T(((x$8 !== (void 0)) ? x$8 : ""));
        var x$9 = groups[11];
        var $$x2 = $as_T(((x$9 !== (void 0)) ? x$9 : ""));
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + $$x2) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var binaryExpStr = $as_T(x$11);
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, binaryExpStr)
      }
    }
  };
  var x$12 = groups[1];
  var signStr = $as_T(x$12);
  return ((signStr === "-") ? Math.fround((-absResult)) : absResult)
});
var $d_jl_Float$ = new $TypeData().initClass({
  jl_Float$: 0
}, false, "java.lang.Float$", {
  jl_Float$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Float$.prototype.$classData = $d_jl_Float$;
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$()
  };
  return $n_jl_Float$
}
function $p_jl_Integer$__fail$1__T__E($thiz, s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""))
}
/** @constructor */
function $c_jl_Integer$() {
  /*<skip>*/
}
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
  /*<skip>*/
}
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseInt__T__I__I = (function(s, radix) {
  var len = ((s === null) ? 0 : $uI(s.length));
  if ((((len === 0) || (radix < 2)) || (radix > 36))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var firstChar = (65535 & $uI(s.charCodeAt(0)));
  var negative = (firstChar === 45);
  var maxAbsValue = (negative ? 2.147483648E9 : 2.147483647E9);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  if ((i >= $uI(s.length))) {
    $p_jl_Integer$__fail$1__T__E(this, s)
  };
  var result = 0.0;
  while ((i !== len)) {
    var $$x1 = $m_jl_Character$();
    var index = i;
    var digit = $$x1.digitWithValidRadix__I__I__I((65535 & $uI(s.charCodeAt(index))), radix);
    result = ((result * radix) + digit);
    if (((digit === (-1)) || (result > maxAbsValue))) {
      $p_jl_Integer$__fail$1__T__E(this, s)
    };
    i = ((1 + i) | 0)
  };
  if (negative) {
    var n = (-result);
    return $uI((n | 0))
  } else {
    var n$1 = result;
    return $uI((n$1 | 0))
  }
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24)
});
var $d_jl_Integer$ = new $TypeData().initClass({
  jl_Integer$: 0
}, false, "java.lang.Integer$", {
  jl_Integer$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Integer$.prototype.$classData = $d_jl_Integer$;
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$()
  };
  return $n_jl_Integer$
}
function $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var radix = 0;
    while ((radix < 2)) {
      r.push(null);
      radix = ((1 + radix) | 0)
    };
    while ((radix <= 36)) {
      var barrier = $intDiv(2147483647, radix);
      var radixPowLength = radix;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, radix);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0")
      };
      var value = radixPowLength;
      var hi = (value >> 31);
      var this$2 = $m_RTLong$();
      var lo = this$2.divideUnsignedImpl__I__I__I__I__I((-1), (-1), value, hi);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, new $c_RTLong(value, hi), paddingZeros, new $c_RTLong(lo, hi$1)));
      radix = ((1 + radix) | 0)
    };
    $thiz.jl_Long$__f_StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true
  };
  return $thiz.jl_Long$__f_StringRadixInfos
}
function $p_jl_Long$__StringRadixInfos__O($thiz) {
  return ((!$thiz.jl_Long$__f_bitmap$0) ? $p_jl_Long$__StringRadixInfos$lzycompute__O($thiz) : $thiz.jl_Long$__f_StringRadixInfos)
}
function $p_jl_Long$__parseLongError__T__E($thiz, s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""))
}
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $$x1 = $m_jl_Character$();
    var index = i;
    var digit = $$x1.digitWithValidRadix__I__I__I((65535 & $uI(s$1.charCodeAt(index))), radix$1);
    if ((digit === (-1))) {
      $p_jl_Long$__parseLongError__T__E($thiz, s$1)
    };
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0)
  };
  return result
}
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false
}
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
  /*<skip>*/
}
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.parseLong__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  };
  var start = 0;
  var neg = false;
  var x1 = (65535 & $uI(s.charCodeAt(0)));
  switch (x1) {
    case 43: {
      start = 1;
      break
    }
    case 45: {
      start = 1;
      neg = true;
      break
    }
  };
  var t = this.parseUnsignedLongInternal__T__I__I__J(s, radix, start);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (neg) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    if (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo$1, hi$1)
  } else {
    if ((hi < 0)) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    return new $c_RTLong(lo, hi)
  }
});
$c_jl_Long$.prototype.parseUnsignedLongInternal__T__I__I__J = (function(s, radix, start) {
  var length = $uI(s.length);
  if ((((start >= length) || (radix < 2)) || (radix > 36))) {
    $p_jl_Long$__parseLongError__T__E(this, s)
  } else {
    var radixInfo = $as_jl_Long$StringRadixInfo($p_jl_Long$__StringRadixInfos__O(this)[radix]);
    var chunkLen = radixInfo.jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $$x2 = $m_jl_Character$();
        var index = firstChunkStart;
        var $$x1 = $$x2.isZeroDigit__C__Z((65535 & $uI(s.charCodeAt(index))))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        firstChunkStart = ((1 + firstChunkStart) | 0)
      } else {
        break
      }
    };
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $p_jl_Long$__parseLongError__T__E(this, s)
    };
    var firstChunkLength = ((1 + $intMod((((-1) + ((length - firstChunkStart) | 0)) | 0), chunkLen)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return new $c_RTLong(x, 0)
    } else {
      var t = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((Math.imul(x, hi$1) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$1 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$2 = ((lo$1 + x$1) | 0);
      var hi$4 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo$1)) ? ((1 + hi$2) | 0) : hi$2);
      if ((secondChunkEnd === length)) {
        return new $c_RTLong(lo$2, hi$4)
      } else {
        var t$1 = radixInfo.jl_Long$StringRadixInfo__f_overflowBarrier;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$5 = t$1.RTLong__f_hi;
        var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$4 === hi$5) ? (((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$3)) : (hi$4 > hi$5))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        var a0$1 = (65535 & lo$2);
        var a1$1 = ((lo$2 >>> 16) | 0);
        var b0$1 = (65535 & lo);
        var b1$1 = ((lo >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$7 = ((((((((Math.imul(lo$2, hi$1) + Math.imul(hi$4, lo)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$5 = ((lo$4 + x$2) | 0);
        var hi$8 = ((((-2147483648) ^ lo$5) < ((-2147483648) ^ lo$4)) ? ((1 + hi$7) | 0) : hi$7);
        var hi$9 = ((-2147483648) ^ hi$8);
        if (((hi$9 === (-2147483648)) && (((-2147483648) ^ lo$5) < ((-2147483648) ^ x$2)))) {
          $p_jl_Long$__parseLongError__T__E(this, s)
        };
        return new $c_RTLong(lo$5, hi$8)
      }
    }
  }
});
var $d_jl_Long$ = new $TypeData().initClass({
  jl_Long$: 0
}, false, "java.lang.Long$", {
  jl_Long$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Long$.prototype.$classData = $d_jl_Long$;
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$()
  };
  return $n_jl_Long$
}
/** @constructor */
function $c_jl_Number() {
  /*<skip>*/
}
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
  /*<skip>*/
}
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $c_RTLong))
}
function $as_jl_Number(obj) {
  return (($is_jl_Number(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Number"))
}
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)))
}
function $asArrayOf_jl_Number(obj, depth) {
  return (($isArrayOf_jl_Number(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Number;", depth))
}
/** @constructor */
function $c_jl_StackTraceElement(declaringClass, methodName, fileName, lineNumber) {
  this.jl_StackTraceElement__f_declaringClass = null;
  this.jl_StackTraceElement__f_methodName = null;
  this.jl_StackTraceElement__f_fileName = null;
  this.jl_StackTraceElement__f_lineNumber = 0;
  this.jl_StackTraceElement__f_columnNumber = 0;
  this.jl_StackTraceElement__f_declaringClass = declaringClass;
  this.jl_StackTraceElement__f_methodName = methodName;
  this.jl_StackTraceElement__f_fileName = fileName;
  this.jl_StackTraceElement__f_lineNumber = lineNumber;
  this.jl_StackTraceElement__f_columnNumber = (-1)
}
$c_jl_StackTraceElement.prototype = new $h_O();
$c_jl_StackTraceElement.prototype.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
  /*<skip>*/
}
$h_jl_StackTraceElement.prototype = $c_jl_StackTraceElement.prototype;
$c_jl_StackTraceElement.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_jl_StackTraceElement)) {
    var x2 = $as_jl_StackTraceElement(that);
    return ((((this.jl_StackTraceElement__f_fileName === x2.jl_StackTraceElement__f_fileName) && (this.jl_StackTraceElement__f_lineNumber === x2.jl_StackTraceElement__f_lineNumber)) && (this.jl_StackTraceElement__f_declaringClass === x2.jl_StackTraceElement__f_declaringClass)) && (this.jl_StackTraceElement__f_methodName === x2.jl_StackTraceElement__f_methodName))
  } else {
    return false
  }
});
$c_jl_StackTraceElement.prototype.toString__T = (function() {
  var result = "";
  if ((this.jl_StackTraceElement__f_declaringClass !== "<jscode>")) {
    result = ((("" + result) + this.jl_StackTraceElement__f_declaringClass) + ".")
  };
  result = (("" + result) + this.jl_StackTraceElement__f_methodName);
  if ((this.jl_StackTraceElement__f_fileName === null)) {
    result = (result + "(Unknown Source)")
  } else {
    result = ((result + "(") + this.jl_StackTraceElement__f_fileName);
    if ((this.jl_StackTraceElement__f_lineNumber >= 0)) {
      result = ((result + ":") + this.jl_StackTraceElement__f_lineNumber);
      if ((this.jl_StackTraceElement__f_columnNumber >= 0)) {
        result = ((result + ":") + this.jl_StackTraceElement__f_columnNumber)
      }
    };
    result = (result + ")")
  };
  return result
});
$c_jl_StackTraceElement.prototype.hashCode__I = (function() {
  return ($f_T__hashCode__I(this.jl_StackTraceElement__f_declaringClass) ^ $f_T__hashCode__I(this.jl_StackTraceElement__f_methodName))
});
function $as_jl_StackTraceElement(obj) {
  return (((obj instanceof $c_jl_StackTraceElement) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.StackTraceElement"))
}
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StackTraceElement)))
}
function $asArrayOf_jl_StackTraceElement(obj, depth) {
  return (($isArrayOf_jl_StackTraceElement(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.StackTraceElement;", depth))
}
var $d_jl_StackTraceElement = new $TypeData().initClass({
  jl_StackTraceElement: 0
}, false, "java.lang.StackTraceElement", {
  jl_StackTraceElement: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StackTraceElement.prototype.$classData = $d_jl_StackTraceElement;
/** @constructor */
function $c_jl_String$() {
  this.jl_String$__f_CASE_INSENSITIVE_ORDER = null;
  this.jl_String$__f_bitmap$0 = false
}
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
  /*<skip>*/
}
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var end = ((offset + count) | 0);
  if ((((offset < 0) || (end < offset)) || (end > value.u.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException())
  };
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $$x1 = result;
    var this$1 = value.get(i);
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$1)));
    i = ((1 + i) | 0)
  };
  return result
});
var $d_jl_String$ = new $TypeData().initClass({
  jl_String$: 0
}, false, "java.lang.String$", {
  jl_String$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_String$.prototype.$classData = $d_jl_String$;
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$()
  };
  return $n_jl_String$
}
/** @constructor */
function $c_jl_Thread(dummy) {
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_name = null;
  this.jl_Thread__f_java$lang$Thread$$interruptedState = false;
  this.jl_Thread__f_name = "main"
}
$c_jl_Thread.prototype = new $h_O();
$c_jl_Thread.prototype.constructor = $c_jl_Thread;
/** @constructor */
function $h_jl_Thread() {
  /*<skip>*/
}
$h_jl_Thread.prototype = $c_jl_Thread.prototype;
$c_jl_Thread.prototype.run__V = (function() {
  /*<skip>*/
});
var $d_jl_Thread = new $TypeData().initClass({
  jl_Thread: 0
}, false, "java.lang.Thread", {
  jl_Thread: 1,
  O: 1,
  jl_Runnable: 1
});
$c_jl_Thread.prototype.$classData = $d_jl_Thread;
function $p_jl_Throwable__printStackTraceImpl__O__V($thiz, sprintln) {
  $thiz.getStackTrace__Ajl_StackTraceElement();
  sprintln($thiz.toString__T());
  if (($thiz.jl_Throwable__f_stackTrace.u.length !== 0)) {
    var i = 0;
    while ((i < $thiz.jl_Throwable__f_stackTrace.u.length)) {
      sprintln(("  at " + $thiz.jl_Throwable__f_stackTrace.get(i)));
      i = ((1 + i) | 0)
    }
  } else {
    sprintln("  <no stack trace available>")
  };
  var wCause = $thiz;
  while (true) {
    var $$x3 = wCause;
    var this$1 = wCause;
    if (($$x3 !== this$1.jl_Throwable__f_e)) {
      var this$2 = wCause;
      var $$x2 = (this$2.jl_Throwable__f_e !== null)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var parentTrace = wCause.getStackTrace__Ajl_StackTraceElement();
      var this$3 = wCause;
      wCause = this$3.jl_Throwable__f_e;
      var thisTrace = wCause.getStackTrace__Ajl_StackTraceElement();
      var thisLength = thisTrace.u.length;
      var parentLength = parentTrace.u.length;
      sprintln(("Caused by: " + wCause.toString__T()));
      if ((thisLength !== 0)) {
        var sameFrameCount = 0;
        while (true) {
          if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
            var x = thisTrace.get((((-1) + ((thisLength - sameFrameCount) | 0)) | 0));
            var x$2 = parentTrace.get((((-1) + ((parentLength - sameFrameCount) | 0)) | 0));
            var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            sameFrameCount = ((1 + sameFrameCount) | 0)
          } else {
            break
          }
        };
        if ((sameFrameCount > 0)) {
          sameFrameCount = (((-1) + sameFrameCount) | 0)
        };
        var lengthToPrint = ((thisLength - sameFrameCount) | 0);
        var i$2 = 0;
        while ((i$2 < lengthToPrint)) {
          sprintln(("  at " + thisTrace.get(i$2)));
          i$2 = ((1 + i$2) | 0)
        };
        if ((sameFrameCount > 0)) {
          sprintln((("  ... " + sameFrameCount) + " more"))
        }
      } else {
        sprintln("  <no stack trace available>")
      }
    } else {
      break
    }
  }
}
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_enableSuppression = enableSuppression;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable()
  };
  return $thiz
}
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.jl_Throwable__f_s = null;
    this.jl_Throwable__f_e = null;
    this.jl_Throwable__f_enableSuppression = false;
    this.jl_Throwable__f_writableStackTrace = false;
    this.jl_Throwable__f_stackTraceStateInternal = null;
    this.jl_Throwable__f_stackTrace = null;
    this.jl_Throwable__f_suppressed = null
  };
  getMessage__T() {
    return this.jl_Throwable__f_s
  };
  fillInStackTrace__jl_Throwable() {
    var identifyingString = Object.prototype.toString.call(this);
    if ((identifyingString === "[object Error]")) {
      this.jl_Throwable__f_stackTraceStateInternal = this
    } else if ((Error.captureStackTrace === (void 0))) {
      var e = new Error();
      this.jl_Throwable__f_stackTraceStateInternal = e
    } else {
      Error.captureStackTrace(this);
      this.jl_Throwable__f_stackTraceStateInternal = this
    };
    return this
  };
  getStackTrace__Ajl_StackTraceElement() {
    if ((this.jl_Throwable__f_stackTrace === null)) {
      if (this.jl_Throwable__f_writableStackTrace) {
        var this$1 = $m_jl_StackTrace$();
        this.jl_Throwable__f_stackTrace = $p_jl_StackTrace$__extract__O__Ajl_StackTraceElement(this$1, this.jl_Throwable__f_stackTraceStateInternal)
      } else {
        this.jl_Throwable__f_stackTrace = new ($d_jl_StackTraceElement.getArrayOf().constr)(0)
      }
    };
    return this.jl_Throwable__f_stackTrace
  };
  setStackTrace__Ajl_StackTraceElement__V(stackTrace) {
    if (this.jl_Throwable__f_writableStackTrace) {
      var i = 0;
      while ((i < stackTrace.u.length)) {
        if ((stackTrace.get(i) === null)) {
          throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
        };
        i = ((1 + i) | 0)
      };
      this.jl_Throwable__f_stackTrace = stackTrace.clone__O()
    }
  };
  printStackTrace__Ljava_io_PrintStream__V(s) {
    $p_jl_Throwable__printStackTraceImpl__O__V(this, ((s$1) => ((arg1$2) => {
      var arg1 = $as_T(arg1$2);
      s$1.println__T__V(arg1)
    }))(s))
  };
  toString__T() {
    var className = $objectClassName(this);
    var message = this.getMessage__T();
    return ((message === null) ? className : ((className + ": ") + message))
  };
  $js$exported$meth$toString__O() {
    return this.toString__T()
  };
  $js$exported$prop$name__O() {
    return $objectClassName(this)
  };
  $js$exported$prop$message__O() {
    var m = this.getMessage__T();
    return ((m === null) ? "" : m)
  };
  hashCode__I() {
    return $c_O.prototype.hashCode__I.call(this)
  };
  equals__O__Z(that) {
    return $c_O.prototype.equals__O__Z.call(this, that)
  };
  get "message"() {
    return this.$js$exported$prop$message__O()
  };
  get "name"() {
    return this.$js$exported$prop$name__O()
  };
  "toString"() {
    return this.$js$exported$meth$toString__O()
  };
}
function $as_jl_Throwable(obj) {
  return (((obj instanceof $c_jl_Throwable) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Throwable"))
}
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)))
}
function $asArrayOf_jl_Throwable(obj, depth) {
  return (($isArrayOf_jl_Throwable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Throwable;", depth))
}
var $d_jl_Throwable = new $TypeData().initClass({
  jl_Throwable: 0
}, false, "java.lang.Throwable", {
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Throwable.prototype.$classData = $d_jl_Throwable;
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $thiz.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.get(diffScale$1)
}
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return ((augend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0)
}
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = thisValue$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0)
}
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_ZERO = null;
  this.Ljava_math_BigDecimal$__f_ONE = null;
  this.Ljava_math_BigDecimal$__f_TEN = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.Ljava_math_BigDecimal$__f_ZERO = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  this.Ljava_math_BigDecimal$__f_ONE = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  this.Ljava_math_BigDecimal$__f_TEN = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var n = this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.u.length;
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((n <= 0)) {
    var $$x1 = new $ac_I(0)
  } else {
    var array = new $ac_I(n);
    var i = 0;
    while ((i < n)) {
      var $$x2 = i;
      var arg1 = i;
      array.set($$x2, $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.get(arg1)));
      i = ((1 + i) | 0)
    };
    var $$x1 = array
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePowsBitLength = $$x1;
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var n$1 = this.Ljava_math_BigDecimal$__f_LongTenPows.u.length;
  $m_s_reflect_ManifestFactory$IntManifest$();
  if ((n$1 <= 0)) {
    var $$x3 = new $ac_I(0)
  } else {
    var array$1 = new $ac_I(n$1);
    var i$1 = 0;
    while ((i$1 < n$1)) {
      var $$x4 = i$1;
      var arg1$1 = i$1;
      array$1.set($$x4, $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(arg1$1)));
      i$1 = ((1 + i$1) | 0)
    };
    var $$x3 = array$1
  };
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = $$x3;
  var array$2 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var $$x5 = i$2;
    var arg1$2 = i$2;
    array$2.set($$x5, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), arg1$2, 0));
    i$2 = ((1 + i$2) | 0)
  };
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = array$2;
  var array$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var $$x6 = i$3;
    var arg1$3 = i$3;
    array$3.set($$x6, $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, arg1$3));
    i$3 = ((1 + i$3) | 0)
  };
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = array$3;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
}
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal) : (((((unscaledVal.RTLong__f_lo === 0) && (unscaledVal.RTLong__f_hi === 0)) && (scale >= 0)) && (scale < this.Ljava_math_BigDecimal$__f_ZeroScaledBy.u.length)) ? this.Ljava_math_BigDecimal$__f_ZeroScaledBy.get(scale) : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, scale)))
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal) {
  var ahi = unscaledVal.RTLong__f_hi;
  if ((ahi >= 0)) {
    var ahi$1 = unscaledVal.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ unscaledVal.RTLong__f_lo) < (-2147483637)) : (ahi$1 < 0))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return this.Ljava_math_BigDecimal$__f_BigIntScaledByZero.get(unscaledVal.RTLong__f_lo)
  } else {
    return $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, 0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal = (function(thisValue, augend, diffScale) {
  if (((diffScale < this.Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var this$1 = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = this.Ljava_math_BigDecimal$__f_LongTenPows.get(diffScale);
    var alo = this$1.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(this$1.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var this$2 = thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo$1 = this$2.RTLong__f_lo;
    var ahi = this$2.RTLong__f_hi;
    var lo$1 = ((alo$1 + lo) | 0);
    var hi$1 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ alo$1)) ? ((1 + ((ahi + hi) | 0)) | 0) : ((ahi + hi) | 0));
    return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  } else {
    var $$x2 = $m_Ljava_math_Multiplication$();
    var $$x1 = augend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var hi$2 = (diffScale >> 31);
    var bi = $$x2.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($$x1, new $c_RTLong(diffScale, hi$2));
    var this$5 = thisValue.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$5, bi), thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1, value2) {
  var ahi = value1.RTLong__f_hi;
  var bhi = value2.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ value1.RTLong__f_lo) > ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi > bhi))) {
    return 1
  } else {
    var ahi$1 = value1.RTLong__f_hi;
    var bhi$1 = value2.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ value1.RTLong__f_lo) < ((-2147483648) ^ value2.RTLong__f_lo)) : (ahi$1 < bhi$1))) {
      return (-1)
    } else {
      return 0
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  $m_s_reflect_ManifestFactory$LongManifest$();
  if ((len > 0)) {
    var array = new $ac_J(len);
    var acc = new $c_RTLong(1, 0);
    var i = 1;
    array.set(0, $uJ(acc));
    while ((i < len)) {
      var arg1 = acc;
      var t = $uJ(arg1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var hi$1 = (pow >> 31);
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & pow);
      var b1 = ((pow >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(lo, hi$1) + Math.imul(hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      acc = new $c_RTLong(lo$1, hi$2);
      array.set(i, $uJ(acc));
      i = ((1 + i) | 0)
    };
    return array
  } else {
    return new $ac_J(0)
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var absFraction = ((fraction < 0) ? ((-fraction) | 0) : fraction);
  var sigFraction = ((fraction === 0) ? 0 : ((fraction < 0) ? (-1) : 1));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === roundingMode)) {
    return sigFraction
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === roundingMode)) {
      return 0
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === roundingMode)) {
        return ((sigFraction > 0) ? sigFraction : 0)
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === roundingMode)) {
          return ((sigFraction < 0) ? sigFraction : 0)
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === roundingMode)) {
            return ((absFraction >= 5) ? sigFraction : 0)
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === roundingMode)) {
              return ((absFraction > 5) ? sigFraction : 0)
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === roundingMode)) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0)
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === roundingMode)) {
                  if ((fraction === 0)) {
                    return 0
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary")
                  }
                } else {
                  throw new $c_s_MatchError(roundingMode)
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue) {
  var ahi = longValue.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ longValue.RTLong__f_lo) < 0) : (ahi < (-1)))) {
    var $$x1 = true
  } else {
    var ahi$1 = longValue.RTLong__f_hi;
    var $$x1 = ((ahi$1 === 0) ? (((-2147483648) ^ longValue.RTLong__f_lo) > (-1)) : (ahi$1 > 0))
  };
  if ($$x1) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + longValue))
  };
  return longValue.RTLong__f_lo
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale) {
  var value = longScale.RTLong__f_lo;
  var hi = (value >> 31);
  if (((longScale.RTLong__f_lo === value) && (longScale.RTLong__f_hi === hi))) {
    return this.valueOf__J__I__Ljava_math_BigDecimal($L0, longScale.RTLong__f_lo)
  } else {
    var ahi = longScale.RTLong__f_hi;
    if ((ahi >= 0)) {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647)
    } else {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648))
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue) {
  var ahi = sValue.RTLong__f_hi;
  if ((ahi < 0)) {
    var lo = (~sValue.RTLong__f_lo);
    var hi = (~sValue.RTLong__f_hi);
    var x__lo = lo;
    var x__hi = hi;
    var t = new $c_RTLong(x__lo, x__hi)
  } else {
    var t = sValue
  };
  var lo$1 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0)
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - Math.clz32(smallValue)) | 0)
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass({
  Ljava_math_BigDecimal$: 0
}, false, "java.math.BigDecimal$", {
  Ljava_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigDecimal$.prototype.$classData = $d_Ljava_math_BigDecimal$;
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$()
  };
  return $n_Ljava_math_BigDecimal$
}
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var array = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var $$x2 = i;
    var arg1 = i;
    var $$x1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & arg1) === 0) ? (1 << arg1) : 0);
    var hi = (((32 & arg1) === 0) ? 0 : (1 << arg1));
    array.set($$x2, $$x1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi)));
    i = ((1 + i) | 0)
  };
  this.Ljava_math_BigInteger$__f_TWO_POWS = array
}
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal) {
  var ahi = lVal.RTLong__f_hi;
  if ((ahi < 0)) {
    if ((!((lVal.RTLong__f_lo === (-1)) && (lVal.RTLong__f_hi === (-1))))) {
      var lo = lVal.RTLong__f_lo;
      var hi = lVal.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), new $c_RTLong(lo$1, hi$1))
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE
    }
  } else {
    var ahi$1 = lVal.RTLong__f_hi;
    if (((ahi$1 === 0) ? (((-2147483648) ^ lVal.RTLong__f_lo) <= (-2147483638)) : (ahi$1 < 0))) {
      return this.Ljava_math_BigInteger$__f_SMALL_VALUES.get(lVal.RTLong__f_lo)
    } else {
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal)
    }
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < this.Ljava_math_BigInteger$__f_TWO_POWS.u.length)) {
    return this.Ljava_math_BigInteger$__f_TWO_POWS.get(exp)
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.set(intCount, (1 << bitN));
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits)
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass({
  Ljava_math_BigInteger$: 0
}, false, "java.math.BigInteger$", {
  Ljava_math_BigInteger$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_BigInteger$.prototype.$classData = $d_Ljava_math_BigInteger$;
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$()
  };
  return $n_Ljava_math_BigInteger$
}
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  this.Ljava_math_RoundingMode$__f__values = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
  this.Ljava_math_RoundingMode$__f__values = new ($d_Ljava_math_RoundingMode.getArrayOf().constr)([this.Ljava_math_RoundingMode$__f_UP, this.Ljava_math_RoundingMode$__f_DOWN, this.Ljava_math_RoundingMode$__f_CEILING, this.Ljava_math_RoundingMode$__f_FLOOR, this.Ljava_math_RoundingMode$__f_HALF_UP, this.Ljava_math_RoundingMode$__f_HALF_DOWN, this.Ljava_math_RoundingMode$__f_HALF_EVEN, this.Ljava_math_RoundingMode$__f_UNNECESSARY])
}
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass({
  Ljava_math_RoundingMode$: 0
}, false, "java.math.RoundingMode$", {
  Ljava_math_RoundingMode$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode$.prototype.$classData = $d_Ljava_math_RoundingMode$;
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$()
  };
  return $n_Ljava_math_RoundingMode$
}
/** @constructor */
function $c_ju_AbstractMap() {
  /*<skip>*/
}
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
  /*<skip>*/
}
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_Map(o)) {
    var x2 = $as_ju_Map(o);
    if ((this.size__I() === x2.size__I())) {
      var _\uff3fself = this.entrySet__ju_Set();
      var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
      _return: {
        while (_\uff3fself$1.hasNext__Z()) {
          var arg1 = _\uff3fself$1.next__O();
          var item = $as_ju_Map$Entry(arg1);
          var a = x2.get__O__O(item.ju_HashMap$Node__f_key);
          var b = item.ju_HashMap$Node__f_value;
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z(a, b)))) {
            var $$x1 = true;
            break _return
          }
        };
        var $$x1 = false
      };
      return (!$$x1)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = this.entrySet__ju_Set();
  var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself$1.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself$1.next__O();
    var prev = $uI(arg1);
    var item = $as_ju_Map$Entry(arg2);
    result = ((item.hashCode__I() + prev) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = this.entrySet__ju_Set().iterator__ju_Iterator();
  while (iter.hasNext__Z()) {
    var entry = $as_ju_Map$Entry(iter.next__O());
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (((("" + result) + entry.ju_HashMap$Node__f_key) + "=") + entry.ju_HashMap$Node__f_value)
  };
  return (result + "}")
});
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)))
}
function $as_ju_Collection(obj) {
  return (($is_ju_Collection(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.Collection"))
}
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)))
}
function $asArrayOf_ju_Collection(obj, depth) {
  return (($isArrayOf_ju_Collection(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.Collection;", depth))
}
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.ju_HashMap$AbstractHashMapIterator__f_$outer = outer
  };
  $thiz.ju_HashMap$AbstractHashMapIterator__f_len = outer.ju_HashMap__f_java$util$HashMap$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null
}
$c_ju_HashMap$AbstractHashMapIterator.prototype = new $h_O();
$c_ju_HashMap$AbstractHashMapIterator.prototype.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
  /*<skip>*/
}
$h_ju_HashMap$AbstractHashMapIterator.prototype = $c_ju_HashMap$AbstractHashMapIterator.prototype;
$c_ju_HashMap$AbstractHashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.ju_HashMap$AbstractHashMapIterator__f_nextNode !== null)) {
    return true
  } else {
    while ((this.ju_HashMap$AbstractHashMapIterator__f_nextIdx < this.ju_HashMap$AbstractHashMapIterator__f_len)) {
      var node = this.ju_HashMap$AbstractHashMapIterator__f_$outer.ju_HashMap__f_java$util$HashMap$$table.get(this.ju_HashMap$AbstractHashMapIterator__f_nextIdx);
      this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = ((1 + this.ju_HashMap$AbstractHashMapIterator__f_nextIdx) | 0);
      if ((node !== null)) {
        this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node;
        return true
      }
    };
    return false
  }
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  };
  var node = this.ju_HashMap$AbstractHashMapIterator__f_nextNode;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = node;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node.ju_HashMap$Node__f_next;
  return node
});
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null
}
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
  /*<skip>*/
}
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var x2 = $as_ju_Map$Entry(that);
    var a = this.ju_HashMap$Node__f_key;
    var b = x2.ju_HashMap$Node__f_key;
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var b$1 = x2.ju_HashMap$Node__f_value;
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I(o)))
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value)
});
function $as_ju_HashMap$Node(obj) {
  return (((obj instanceof $c_ju_HashMap$Node) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.HashMap$Node"))
}
function $isArrayOf_ju_HashMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap$Node)))
}
function $asArrayOf_ju_HashMap$Node(obj, depth) {
  return (($isArrayOf_ju_HashMap$Node(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.HashMap$Node;", depth))
}
var $d_ju_HashMap$Node = new $TypeData().initClass({
  ju_HashMap$Node: 0
}, false, "java.util.HashMap$Node", {
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_HashMap$Node.prototype.$classData = $d_ju_HashMap$Node;
function $p_ju_Random__loop$1__I__I($thiz, n$1) {
  while (true) {
    var bits = $thiz.next__I__I(31);
    var value = $intMod(bits, n$1);
    if ((((((bits - value) | 0) + (((-1) + n$1) | 0)) | 0) < 0)) {
      /*<skip>*/
    } else {
      return value
    }
  }
}
function $ct_ju_Random__J__($thiz, seed_in) {
  $thiz.ju_Random__f_haveNextNextGaussian = false;
  $thiz.setSeed__J__V(seed_in);
  return $thiz
}
function $ct_ju_Random__($thiz) {
  $ct_ju_Random__J__($thiz, $m_ju_Random$().java$util$Random$$randomSeed__J());
  return $thiz
}
/** @constructor */
function $c_ju_Random() {
  this.ju_Random__f_seedHi = 0;
  this.ju_Random__f_seedLo = 0;
  this.ju_Random__f_nextNextGaussian = 0.0;
  this.ju_Random__f_haveNextNextGaussian = false
}
$c_ju_Random.prototype = new $h_O();
$c_ju_Random.prototype.constructor = $c_ju_Random;
/** @constructor */
function $h_ju_Random() {
  /*<skip>*/
}
$h_ju_Random.prototype = $c_ju_Random.prototype;
$c_ju_Random.prototype.setSeed__J__V = (function(seed_in) {
  var lo = ((-554899859) ^ seed_in.RTLong__f_lo);
  var hi = (5 ^ seed_in.RTLong__f_hi);
  var hi$1 = (65535 & hi);
  var lo$1 = (((lo >>> 24) | 0) | (hi$1 << 8));
  this.ju_Random__f_seedHi = lo$1;
  this.ju_Random__f_seedLo = (16777215 & lo);
  this.ju_Random__f_haveNextNextGaussian = false
});
$c_ju_Random.prototype.next__I__I = (function(bits) {
  var oldSeedHi = this.ju_Random__f_seedHi;
  var oldSeedLo = this.ju_Random__f_seedLo;
  var loProd = ((1.5525485E7 * oldSeedLo) + 11.0);
  var hiProd = ((1502.0 * oldSeedLo) + (1.5525485E7 * oldSeedHi));
  var x = (loProd / 1.6777216E7);
  var newSeedHi = (16777215 & (($uI((x | 0)) + (16777215 & $uI((hiProd | 0)))) | 0));
  var newSeedLo = (16777215 & $uI((loProd | 0)));
  this.ju_Random__f_seedHi = newSeedHi;
  this.ju_Random__f_seedLo = newSeedLo;
  var result32 = ((newSeedHi << 8) | (newSeedLo >> 16));
  return ((result32 >>> ((32 - bits) | 0)) | 0)
});
$c_ju_Random.prototype.nextInt__I__I = (function(n) {
  if ((n <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "n must be positive")
  } else {
    return (((n & ((-n) | 0)) === n) ? (this.next__I__I(31) >> Math.clz32(n)) : $p_ju_Random__loop$1__I__I(this, n))
  }
});
var $d_ju_Random = new $TypeData().initClass({
  ju_Random: 0
}, false, "java.util.Random", {
  ju_Random: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Random.prototype.$classData = $d_ju_Random;
function $p_ju_Random$__randomInt__I($thiz) {
  var a = (4.294967296E9 * $uD(Math.random()));
  return $doubleToInt(($uD(Math.floor(a)) - 2.147483648E9))
}
/** @constructor */
function $c_ju_Random$() {
  /*<skip>*/
}
$c_ju_Random$.prototype = new $h_O();
$c_ju_Random$.prototype.constructor = $c_ju_Random$;
/** @constructor */
function $h_ju_Random$() {
  /*<skip>*/
}
$h_ju_Random$.prototype = $c_ju_Random$.prototype;
$c_ju_Random$.prototype.java$util$Random$$randomSeed__J = (function() {
  var value = $p_ju_Random$__randomInt__I(this);
  var value$1 = $p_ju_Random$__randomInt__I(this);
  return new $c_RTLong(value$1, value)
});
var $d_ju_Random$ = new $TypeData().initClass({
  ju_Random$: 0
}, false, "java.util.Random$", {
  ju_Random$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Random$.prototype.$classData = $d_ju_Random$;
var $n_ju_Random$;
function $m_ju_Random$() {
  if ((!$n_ju_Random$)) {
    $n_ju_Random$ = new $c_ju_Random$()
  };
  return $n_ju_Random$
}
function $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = outer
  };
  var this$1 = outer.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList();
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = this$1.listIterator__I__ju_ListIterator(0);
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.hasNext__Z = (function() {
  return this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter.hasNext__Z()
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.next__O = (function() {
  var node = $as_ju_HashMap$Node(this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter.next__O());
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = node;
  return this.extract__ju_HashMap$Node__O(node)
});
/** @constructor */
function $c_ju_concurrent_ThreadLocalRandom$() {
  this.ju_concurrent_ThreadLocalRandom$__f__current = null;
  $n_ju_concurrent_ThreadLocalRandom$ = this;
  this.ju_concurrent_ThreadLocalRandom$__f__current = new $c_ju_concurrent_ThreadLocalRandom()
}
$c_ju_concurrent_ThreadLocalRandom$.prototype = new $h_O();
$c_ju_concurrent_ThreadLocalRandom$.prototype.constructor = $c_ju_concurrent_ThreadLocalRandom$;
/** @constructor */
function $h_ju_concurrent_ThreadLocalRandom$() {
  /*<skip>*/
}
$h_ju_concurrent_ThreadLocalRandom$.prototype = $c_ju_concurrent_ThreadLocalRandom$.prototype;
var $d_ju_concurrent_ThreadLocalRandom$ = new $TypeData().initClass({
  ju_concurrent_ThreadLocalRandom$: 0
}, false, "java.util.concurrent.ThreadLocalRandom$", {
  ju_concurrent_ThreadLocalRandom$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ThreadLocalRandom$.prototype.$classData = $d_ju_concurrent_ThreadLocalRandom$;
var $n_ju_concurrent_ThreadLocalRandom$;
function $m_ju_concurrent_ThreadLocalRandom$() {
  if ((!$n_ju_concurrent_ThreadLocalRandom$)) {
    $n_ju_concurrent_ThreadLocalRandom$ = new $c_ju_concurrent_ThreadLocalRandom$()
  };
  return $n_ju_concurrent_ThreadLocalRandom$
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  this.ju_concurrent_TimeUnit$__f__values = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7();
  this.ju_concurrent_TimeUnit$__f__values = new ($d_ju_concurrent_TimeUnit.getArrayOf().constr)([this.ju_concurrent_TimeUnit$__f_NANOSECONDS, this.ju_concurrent_TimeUnit$__f_MICROSECONDS, this.ju_concurrent_TimeUnit$__f_MILLISECONDS, this.ju_concurrent_TimeUnit$__f_SECONDS, this.ju_concurrent_TimeUnit$__f_MINUTES, this.ju_concurrent_TimeUnit$__f_HOURS, this.ju_concurrent_TimeUnit$__f_DAYS])
}
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a, b, max) {
  var ahi = a.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ max.RTLong__f_lo)) : (ahi > bhi))) {
    return new $c_RTLong((-1), 2147483647)
  } else {
    var lo = max.RTLong__f_lo;
    var hi = max.RTLong__f_hi;
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$1 < hi$1))) {
      return new $c_RTLong(1, (-2147483648))
    } else {
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return new $c_RTLong(lo$2, hi$2)
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass({
  ju_concurrent_TimeUnit$: 0
}, false, "java.util.concurrent.TimeUnit$", {
  ju_concurrent_TimeUnit$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$.prototype.$classData = $d_ju_concurrent_TimeUnit$;
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$()
  };
  return $n_ju_concurrent_TimeUnit$
}
function $ct_ju_concurrent_atomic_AtomicBoolean__Z__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = value;
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicBoolean() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false
}
$c_ju_concurrent_atomic_AtomicBoolean.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicBoolean.prototype.constructor = $c_ju_concurrent_atomic_AtomicBoolean;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicBoolean() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicBoolean.prototype = $c_ju_concurrent_atomic_AtomicBoolean.prototype;
$c_ju_concurrent_atomic_AtomicBoolean.prototype.getAndSet__Z__Z = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = newValue;
  return old
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  return ("" + this$1)
});
function $as_ju_concurrent_atomic_AtomicBoolean(obj) {
  return (((obj instanceof $c_ju_concurrent_atomic_AtomicBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.atomic.AtomicBoolean"))
}
function $isArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_atomic_AtomicBoolean)))
}
function $asArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) {
  return (($isArrayOf_ju_concurrent_atomic_AtomicBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.atomic.AtomicBoolean;", depth))
}
var $d_ju_concurrent_atomic_AtomicBoolean = new $TypeData().initClass({
  ju_concurrent_atomic_AtomicBoolean: 0
}, false, "java.util.concurrent.atomic.AtomicBoolean", {
  ju_concurrent_atomic_AtomicBoolean: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.$classData = $d_ju_concurrent_atomic_AtomicBoolean;
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if (Object.is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true
  } else {
    return false
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.getAndSet__O__O = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicReference__f_value;
  this.ju_concurrent_atomic_AtomicReference__f_value = newValue;
  return old
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj)
});
function $as_ju_concurrent_atomic_AtomicReference(obj) {
  return (((obj instanceof $c_ju_concurrent_atomic_AtomicReference) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.atomic.AtomicReference"))
}
function $isArrayOf_ju_concurrent_atomic_AtomicReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_atomic_AtomicReference)))
}
function $asArrayOf_ju_concurrent_atomic_AtomicReference(obj, depth) {
  return (($isArrayOf_ju_concurrent_atomic_AtomicReference(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.atomic.AtomicReference;", depth))
}
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().initClass({
  ju_concurrent_atomic_AtomicReference: 0
}, false, "java.util.concurrent.atomic.AtomicReference", {
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_atomic_AtomicReference.prototype.$classData = $d_ju_concurrent_atomic_AtomicReference;
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.ju_regex_Matcher__f_position = 0;
  $thiz.ju_regex_Matcher__f_lastMatch = null;
  $thiz.ju_regex_Matcher__f_appendPos = 0;
  return $thiz
}
function $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available")
  };
  return $thiz.ju_regex_Matcher__f_lastMatch
}
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_regionEnd0 = 0;
  this.ju_regex_Matcher__f_inputstr = null;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  this.ju_regex_Matcher__f_appendPos = 0;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_regionEnd0 = $uI(input0.length);
  this.ju_regex_Matcher__f_inputstr = input0;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  this.ju_regex_Matcher__f_appendPos = 0
}
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
  /*<skip>*/
}
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  var this$1 = this.ju_regex_Matcher__f_pattern0;
  var input = this.ju_regex_Matcher__f_inputstr;
  var start = this.ju_regex_Matcher__f_position;
  var mtch = this$1.java$util$regex$Pattern$$execFindInternal__T__I__sjs_js_RegExp$ExecResult(input, start);
  var end = $uI(this$1.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind.lastIndex);
  if ((mtch !== null)) {
    var $$x1 = ((end === $uI(mtch.index)) ? ((1 + end) | 0) : end)
  } else {
    var this$2 = this.ju_regex_Matcher__f_inputstr;
    var $$x1 = ((1 + $uI(this$2.length)) | 0)
  };
  this.ju_regex_Matcher__f_position = $$x1;
  this.ju_regex_Matcher__f_lastMatch = mtch;
  this.ju_regex_Matcher__f_lastMatchIsForMatches = false;
  return (mtch !== null)
});
$c_ju_regex_Matcher.prototype.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher = (function(sb, replacement) {
  var this$1 = this.ju_regex_Matcher__f_inputstr;
  var beginIndex = this.ju_regex_Matcher__f_appendPos;
  var endIndex = this.start__I();
  sb.append__T__jl_StringBuffer($as_T(this$1.substring(beginIndex, endIndex)));
  var len = $uI(replacement.length);
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x1 = (65535 & $uI(replacement.charCodeAt(index)));
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (true) {
          if ((i < len)) {
            var index$1 = i;
            var c = (65535 & $uI(replacement.charCodeAt(index$1)));
            var $$x1 = ((c >= 48) && (c <= 57))
          } else {
            var $$x1 = false
          };
          if ($$x1) {
            i = ((1 + i) | 0)
          } else {
            break
          }
        };
        var endIndex$1 = i;
        var s = $as_T(replacement.substring(j, endIndex$1));
        var this$2 = $m_jl_Integer$();
        var group = this$2.parseInt__T__I__I(s, 10);
        var replaced = this.group__I__T(group);
        if ((replaced !== null)) {
          sb.append__T__jl_StringBuffer(replaced)
        };
        break
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var index$2 = i;
          sb.append__C__jl_StringBuffer((65535 & $uI(replacement.charCodeAt(index$2))))
        };
        i = ((1 + i) | 0);
        break
      }
      default: {
        sb.append__C__jl_StringBuffer(x1);
        i = ((1 + i) | 0)
      }
    }
  };
  this.ju_regex_Matcher__f_appendPos = this.end__I();
  return this
});
$c_ju_regex_Matcher.prototype.appendTail__jl_StringBuffer__jl_StringBuffer = (function(sb) {
  var this$1 = this.ju_regex_Matcher__f_inputstr;
  var beginIndex = this.ju_regex_Matcher__f_appendPos;
  sb.append__T__jl_StringBuffer($as_T(this$1.substring(beginIndex)));
  var this$3 = this.ju_regex_Matcher__f_inputstr;
  this.ju_regex_Matcher__f_appendPos = $uI(this$3.length);
  return sb
});
$c_ju_regex_Matcher.prototype.replaceAll__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  var sb = $ct_jl_StringBuffer__(new $c_jl_StringBuffer());
  while (this.find__Z()) {
    this.appendReplacement__jl_StringBuffer__T__ju_regex_Matcher(sb, replacement)
  };
  this.appendTail__jl_StringBuffer__jl_StringBuffer(sb);
  return sb.toString__T()
});
$c_ju_regex_Matcher.prototype.reset__ju_regex_Matcher = (function() {
  this.ju_regex_Matcher__f_regionStart0 = 0;
  var this$1 = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  this.ju_regex_Matcher__f_regionEnd0 = $uI(this$1.length);
  this.ju_regex_Matcher__f_inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this)
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return (($uI($p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this).index) + this.ju_regex_Matcher__f_regionStart0) | 0)
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $$x1 = this.start__I();
  var this$1 = this.group__T();
  return (($$x1 + $uI(this$1.length)) | 0)
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var value = $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this)[0];
  if ((value === (void 0))) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get")
  };
  return $as_T(value)
});
$c_ju_regex_Matcher.prototype.group__I__T = (function(group) {
  var value = $p_ju_regex_Matcher__ensureLastMatch__sjs_js_RegExp$ExecResult(this)[this.ju_regex_Matcher__f_pattern0.numberedGroup__I__I(group)];
  $m_s_$less$colon$less$();
  return $as_T(((value === (void 0)) ? null : value))
});
var $d_ju_regex_Matcher = new $TypeData().initClass({
  ju_regex_Matcher: 0
}, false, "java.util.regex.Matcher", {
  ju_regex_Matcher: 1,
  O: 1,
  ju_regex_MatchResult: 1
});
$c_ju_regex_Matcher.prototype.$classData = $d_ju_regex_Matcher;
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.ju_regex_Pattern__f_indicesBuilder = null;
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f__flags = 0;
  this.ju_regex_Pattern__f_jsPattern = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = false;
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupNumberMap = null;
  this.ju_regex_Pattern__f_namedGroups = null;
  this.ju_regex_Pattern__f_enabledNativeIndices = false;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = null;
  this.ju_regex_Pattern__f_jsRegExpForMatches = null;
  this.ju_regex_Pattern__f_bitmap$0 = false;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f__flags = _flags;
  this.ju_regex_Pattern__f_jsPattern = jsPattern;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = jsFlags;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = sticky;
  this.ju_regex_Pattern__f_groupCount = groupCount;
  this.ju_regex_Pattern__f_groupNumberMap = groupNumberMap;
  this.ju_regex_Pattern__f_namedGroups = namedGroups;
  this.ju_regex_Pattern__f_enabledNativeIndices = false;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(jsPattern, (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")));
  this.ju_regex_Pattern__f_jsRegExpForMatches = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags)
}
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
  /*<skip>*/
}
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$execFindInternal__T__I__sjs_js_RegExp$ExecResult = (function(input, start) {
  var regexp = this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind;
  regexp.lastIndex = start;
  return regexp.exec(input)
});
$c_ju_regex_Pattern.prototype.numberedGroup__I__I = (function(group) {
  if (((group < 0) || (group > this.ju_regex_Pattern__f_groupCount))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + group))
  };
  return $uI(this.ju_regex_Pattern__f_groupNumberMap[group])
});
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$split__T__I__AT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""])
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var matcher = new $c_ju_regex_Matcher(this, inputStr);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var prevEnd = 0;
    var size$1 = 0;
    while (((size$1 < (((-1) + lim) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        var elem = $as_T(inputStr.substring(beginIndex, endIndex));
        var unboxedElem = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem);
        size$1 = ((1 + size$1) | 0)
      };
      prevEnd = matcher.end__I()
    };
    var beginIndex$1 = prevEnd;
    var elem$1 = $as_T(inputStr.substring(beginIndex$1));
    var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
    jsElems.push(unboxedElem$1);
    var result = new ($d_T.getArrayOf().constr)(jsElems);
    if ((limit !== 0)) {
      return result
    } else {
      var actualLength = result.u.length;
      while (((actualLength !== 0) && (result.get((((-1) + actualLength) | 0)) === ""))) {
        actualLength = (((-1) + actualLength) | 0)
      };
      if ((actualLength === result.u.length)) {
        return result
      } else {
        var actualResult = new ($d_T.getArrayOf().constr)(actualLength);
        var length = actualLength;
        result.copyTo(0, actualResult, 0, length);
        return actualResult
      }
    }
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass({
  ju_regex_Pattern: 0
}, false, "java.util.regex.Pattern", {
  ju_regex_Pattern: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_Pattern.prototype.$classData = $d_ju_regex_Pattern;
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1()
}
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
  /*<skip>*/
}
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass({
  s_$less$colon$less$: 0
}, false, "scala.$less$colon$less$", {
  s_$less$colon$less$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$.prototype.$classData = $d_s_$less$colon$less$;
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$()
  };
  return $n_s_$less$colon$less$
}
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0)
  }
}
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.getArrayOf().constr)(len);
  $m_ju_Arrays$().fill__AO__O__V(result, (void 0));
  return result
}
/** @constructor */
function $c_s_Array$() {
  /*<skip>*/
}
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
  /*<skip>*/
}
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__O = (function(it, evidence$3) {
  var n = it.knownSize__I();
  if ((n > (-1))) {
    var elements = evidence$3.newArray__I__O(n);
    var iterator = it.iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(elements, i, iterator.next__O());
      i = ((1 + i) | 0)
    };
    return elements
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$3.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var iterator$2 = it.iterator__sc_Iterator();
    while (iterator$2.hasNext__Z()) {
      var elem = iterator$2.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
      jsElems.push(unboxedElem)
    };
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems)
  }
});
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var srcClass = $objectGetClass(src);
  if ((srcClass.isArray__Z() && $objectGetClass(dest).isAssignableFrom__jl_Class__Z(srcClass))) {
    src.copyTo(srcPos, dest, destPos, length)
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length)
  }
});
$c_s_Array$.prototype.copyOf__O__I__O = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength)
  } else if ((original instanceof $ac_O)) {
    var x3 = $asArrayOf_O(original, 1);
    return $m_ju_Arrays$().copyOf__AO__I__AO(x3, newLength)
  } else if ((original instanceof $ac_I)) {
    var x4 = $asArrayOf_I(original, 1);
    return $m_ju_Arrays$().copyOf__AI__I__AI(x4, newLength)
  } else if ((original instanceof $ac_D)) {
    var x5 = $asArrayOf_D(original, 1);
    return $m_ju_Arrays$().copyOf__AD__I__AD(x5, newLength)
  } else if ((original instanceof $ac_J)) {
    var x6 = $asArrayOf_J(original, 1);
    return $m_ju_Arrays$().copyOf__AJ__I__AJ(x6, newLength)
  } else if ((original instanceof $ac_F)) {
    var x7 = $asArrayOf_F(original, 1);
    return $m_ju_Arrays$().copyOf__AF__I__AF(x7, newLength)
  } else if ((original instanceof $ac_C)) {
    var x8 = $asArrayOf_C(original, 1);
    return $m_ju_Arrays$().copyOf__AC__I__AC(x8, newLength)
  } else if ((original instanceof $ac_B)) {
    var x9 = $asArrayOf_B(original, 1);
    return $m_ju_Arrays$().copyOf__AB__I__AB(x9, newLength)
  } else if ((original instanceof $ac_S)) {
    var x10 = $asArrayOf_S(original, 1);
    return $m_ju_Arrays$().copyOf__AS__I__AS(x10, newLength)
  } else if ((original instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(original, 1);
    return $m_ju_Arrays$().copyOf__AZ__I__AZ(x11, newLength)
  } else {
    throw new $c_s_MatchError(original)
  }
});
$c_s_Array$.prototype.copyAs__O__I__s_reflect_ClassTag__O = (function(original, newLength, ct) {
  var runtimeClass = ct.runtimeClass__jl_Class();
  if (((runtimeClass !== null) && (runtimeClass === $d_V.getClassOf()))) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength)
  } else if (runtimeClass.isAssignableFrom__jl_Class__Z($objectGetClass(original).getComponentType__jl_Class())) {
    if (runtimeClass.isPrimitive__Z()) {
      return this.copyOf__O__I__O(original, newLength)
    } else {
      var this$1 = $m_jl_reflect_Array$().newInstance__jl_Class__I__O(runtimeClass, 0);
      var destArrayClass = $objectGetClass(this$1);
      var original$1 = $asArrayOf_O(original, 1);
      return $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, destArrayClass)
    }
  } else {
    var dest = ct.newArray__I__O(newLength);
    $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_sr_ScalaRunTime$().array_length__O__I(original));
    return dest
  }
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true
  };
  if ((xs.u.length !== ys.u.length)) {
    return false
  };
  var len = xs.u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(xs.get(i), ys.get(i)))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
var $d_s_Array$ = new $TypeData().initClass({
  s_Array$: 0
}, false, "scala.Array$", {
  s_Array$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Array$.prototype.$classData = $d_s_Array$;
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$()
  };
  return $n_s_Array$
}
/** @constructor */
function $c_s_LowPriorityImplicits() {
  /*<skip>*/
}
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
  /*<skip>*/
}
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null
  } else if ((xs.u.length === 0)) {
    var this$3 = $m_scm_ArraySeq$();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    return this$3.scm_ArraySeq$__f_EmptyArraySeq
  } else {
    return new $c_scm_ArraySeq$ofRef(xs)
  }
});
/** @constructor */
function $c_s_Option$() {
  /*<skip>*/
}
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
  /*<skip>*/
}
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x))
});
var $d_s_Option$ = new $TypeData().initClass({
  s_Option$: 0
}, false, "scala.Option$", {
  s_Option$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_Option$.prototype.$classData = $d_s_Option$;
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$()
  };
  return $n_s_Option$
}
function $f_s_PartialFunction__andThen__F1__s_PartialFunction($thiz, k) {
  if ($is_s_PartialFunction(k)) {
    var x2 = $as_s_PartialFunction(k);
    return new $c_s_PartialFunction$Combined($thiz, x2)
  } else {
    return new $c_s_PartialFunction$AndThen($thiz, k)
  }
}
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : default$1.apply__O__O(x))
}
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)))
}
function $as_s_PartialFunction(obj) {
  return (($is_s_PartialFunction(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.PartialFunction"))
}
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)))
}
function $asArrayOf_s_PartialFunction(obj, depth) {
  return (($isArrayOf_s_PartialFunction(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.PartialFunction;", depth))
}
function $as_s_Symbol(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Symbol"))
}
function $isArrayOf_s_Symbol(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Symbol)))
}
function $asArrayOf_s_Symbol(obj, depth) {
  return (($isArrayOf_s_Symbol(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Symbol;", depth))
}
/** @constructor */
function $c_T2$() {
  /*<skip>*/
}
$c_T2$.prototype = new $h_O();
$c_T2$.prototype.constructor = $c_T2$;
/** @constructor */
function $h_T2$() {
  /*<skip>*/
}
$h_T2$.prototype = $c_T2$.prototype;
$c_T2$.prototype.toString__T = (function() {
  return "Tuple2"
});
var $d_T2$ = new $TypeData().initClass({
  T2$: 0
}, false, "scala.Tuple2$", {
  T2$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_T2$.prototype.$classData = $d_T2$;
var $n_T2$;
function $m_T2$() {
  if ((!$n_T2$)) {
    $n_T2$ = new $c_T2$()
  };
  return $n_T2$
}
/** @constructor */
function $c_sci_$colon$colon$() {
  /*<skip>*/
}
$c_sci_$colon$colon$.prototype = new $h_O();
$c_sci_$colon$colon$.prototype.constructor = $c_sci_$colon$colon$;
/** @constructor */
function $h_sci_$colon$colon$() {
  /*<skip>*/
}
$h_sci_$colon$colon$.prototype = $c_sci_$colon$colon$.prototype;
$c_sci_$colon$colon$.prototype.toString__T = (function() {
  return "::"
});
var $d_sci_$colon$colon$ = new $TypeData().initClass({
  sci_$colon$colon$: 0
}, false, "scala.collection.immutable.$colon$colon$", {
  sci_$colon$colon$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_$colon$colon$.prototype.$classData = $d_sci_$colon$colon$;
var $n_sci_$colon$colon$;
function $m_sci_$colon$colon$() {
  if ((!$n_sci_$colon$colon$)) {
    $n_sci_$colon$colon$ = new $c_sci_$colon$colon$()
  };
  return $n_sci_$colon$colon$
}
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_MapNode__O__O__I__I__I__V(outer.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashMapBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashMapBuilder$$anon$1", {
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  O: 1
});
$c_sci_HashMapBuilder$$anon$1.prototype.$classData = $d_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_SetNode__O__I__I__I__V(outer.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, $as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0)
  }
}
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
  /*<skip>*/
}
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass({
  sci_HashSetBuilder$$anon$1: 0
}, false, "scala.collection.immutable.HashSetBuilder$$anon$1", {
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  O: 1
});
$c_sci_HashSetBuilder$$anon$1.prototype.$classData = $d_sci_HashSetBuilder$$anon$1;
function $is_sci_LazyList$State(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_LazyList$State)))
}
function $as_sci_LazyList$State(obj) {
  return (($is_sci_LazyList$State(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList$State"))
}
function $isArrayOf_sci_LazyList$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList$State)))
}
function $asArrayOf_sci_LazyList$State(obj, depth) {
  return (($isArrayOf_sci_LazyList$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList$State;", depth))
}
/** @constructor */
function $c_sci_List$$anon$1() {
  /*<skip>*/
}
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
  /*<skip>*/
}
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this
});
var $d_sci_List$$anon$1 = new $TypeData().initClass({
  sci_List$$anon$1: 0
}, false, "scala.collection.immutable.List$$anon$1", {
  sci_List$$anon$1: 1,
  O: 1,
  F1: 1
});
$c_sci_List$$anon$1.prototype.$classData = $d_sci_List$$anon$1;
/** @constructor */
function $c_sci_LongMapUtils$() {
  /*<skip>*/
}
$c_sci_LongMapUtils$.prototype = new $h_O();
$c_sci_LongMapUtils$.prototype.constructor = $c_sci_LongMapUtils$;
/** @constructor */
function $h_sci_LongMapUtils$() {
  /*<skip>*/
}
$h_sci_LongMapUtils$.prototype = $c_sci_LongMapUtils$.prototype;
$c_sci_LongMapUtils$.prototype.branchMask__J__J__J = (function(i, j) {
  var lo = (i.RTLong__f_lo ^ j.RTLong__f_lo);
  var hi = (i.RTLong__f_hi ^ j.RTLong__f_hi);
  var lo$1 = ((hi !== 0) ? 0 : (((-2147483648) >> Math.clz32(lo)) & lo));
  var hi$1 = (((-2147483648) >> Math.clz32(hi)) & hi);
  return new $c_RTLong(lo$1, hi$1)
});
$c_sci_LongMapUtils$.prototype.join__J__sci_LongMap__J__sci_LongMap__sci_LongMap = (function(p1, t1, p2, t2) {
  var t = this.branchMask__J__J__J(p1, p2);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $f_scg_BitOperations$Long__mask__J__J__J(this, p1, new $c_RTLong(lo, hi));
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return ($f_scg_BitOperations$Long__zero__J__J__Z(this, p1, new $c_RTLong(lo, hi)) ? new $c_sci_LongMap$Bin(new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo, hi), t1, t2) : new $c_sci_LongMap$Bin(new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo, hi), t2, t1))
});
$c_sci_LongMapUtils$.prototype.bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap = (function(prefix, mask, left, right) {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(right)) {
    return left
  } else {
    var x$3 = $m_sci_LongMap$Nil$();
    if (x$3.equals__O__Z(left)) {
      return right
    } else {
      return new $c_sci_LongMap$Bin(prefix, mask, left, right)
    }
  }
});
var $d_sci_LongMapUtils$ = new $TypeData().initClass({
  sci_LongMapUtils$: 0
}, false, "scala.collection.immutable.LongMapUtils$", {
  sci_LongMapUtils$: 1,
  O: 1,
  scg_BitOperations$Long: 1
});
$c_sci_LongMapUtils$.prototype.$classData = $d_sci_LongMapUtils$;
var $n_sci_LongMapUtils$;
function $m_sci_LongMapUtils$() {
  if ((!$n_sci_LongMapUtils$)) {
    $n_sci_LongMapUtils$ = new $c_sci_LongMapUtils$()
  };
  return $n_sci_LongMapUtils$
}
/** @constructor */
function $c_sci_MapNode() {
  /*<skip>*/
}
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
  /*<skip>*/
}
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $as_sci_MapNode(obj) {
  return (((obj instanceof $c_sci_MapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapNode"))
}
function $isArrayOf_sci_MapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapNode)))
}
function $asArrayOf_sci_MapNode(obj, depth) {
  return (($isArrayOf_sci_MapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapNode;", depth))
}
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step)
}
/** @constructor */
function $c_sci_Range$() {
  /*<skip>*/
}
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
  /*<skip>*/
}
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
$c_sci_Range$.prototype.scala$collection$immutable$Range$$fail__I__I__I__Z__E = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."))
});
var $d_sci_Range$ = new $TypeData().initClass({
  sci_Range$: 0
}, false, "scala.collection.immutable.Range$", {
  sci_Range$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Range$.prototype.$classData = $d_sci_Range$;
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$()
  };
  return $n_sci_Range$
}
/** @constructor */
function $c_sci_RedBlackTree$SetHelper() {
  this.sci_RedBlackTree$Helper__f_ordering = null
}
$c_sci_RedBlackTree$SetHelper.prototype = new $h_sci_RedBlackTree$Helper();
$c_sci_RedBlackTree$SetHelper.prototype.constructor = $c_sci_RedBlackTree$SetHelper;
/** @constructor */
function $h_sci_RedBlackTree$SetHelper() {
  /*<skip>*/
}
$h_sci_RedBlackTree$SetHelper.prototype = $c_sci_RedBlackTree$SetHelper.prototype;
$c_sci_RedBlackTree$SetHelper.prototype.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree = (function(tree, k) {
  if ((tree === null)) {
    $m_sci_RedBlackTree$();
    return new $c_sci_RedBlackTree$Tree(k, (void 0), null, null, 0)
  } else if (Object.is(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
    return tree
  } else {
    var cmp = this.sci_RedBlackTree$Helper__f_ordering.compare__O__O__I(k, tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key);
    return ((cmp < 0) ? this.mutableBalanceLeft__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left, k)) : ((cmp > 0) ? this.mutableBalanceRight__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree, this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right, k)) : tree))
  }
});
/** @constructor */
function $c_sci_SetNode() {
  /*<skip>*/
}
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
  /*<skip>*/
}
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $as_sci_SetNode(obj) {
  return (((obj instanceof $c_sci_SetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetNode"))
}
function $isArrayOf_sci_SetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetNode)))
}
function $asArrayOf_sci_SetNode(obj, depth) {
  return (($isArrayOf_sci_SetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetNode;", depth))
}
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, xs) {
  if ((xs === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(xs))
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      $thiz.addOne__O__scm_Growable(it.next__O())
    }
  };
  return $thiz
}
function $is_scm_Growable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Growable)))
}
function $as_scm_Growable(obj) {
  return (($is_scm_Growable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Growable"))
}
function $isArrayOf_scm_Growable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Growable)))
}
function $asArrayOf_scm_Growable(obj, depth) {
  return (($isArrayOf_scm_Growable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Growable;", depth))
}
/** @constructor */
function $c_scm_StringBuilder$() {
  /*<skip>*/
}
$c_scm_StringBuilder$.prototype = new $h_O();
$c_scm_StringBuilder$.prototype.constructor = $c_scm_StringBuilder$;
/** @constructor */
function $h_scm_StringBuilder$() {
  /*<skip>*/
}
$h_scm_StringBuilder$.prototype = $c_scm_StringBuilder$.prototype;
var $d_scm_StringBuilder$ = new $TypeData().initClass({
  scm_StringBuilder$: 0
}, false, "scala.collection.mutable.StringBuilder$", {
  scm_StringBuilder$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder$.prototype.$classData = $d_scm_StringBuilder$;
var $n_scm_StringBuilder$;
function $m_scm_StringBuilder$() {
  if ((!$n_scm_StringBuilder$)) {
    $n_scm_StringBuilder$ = new $c_scm_StringBuilder$()
  };
  return $n_scm_StringBuilder$
}
function $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V($thiz, runnable) {
  if ((runnable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "runnable is null")
  };
  var tl = $thiz.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal;
  var b = tl.get__O();
  if ((b instanceof $c_s_concurrent_BatchingExecutor$SyncBatch)) {
    $as_s_concurrent_BatchingExecutor$SyncBatch(b).push__jl_Runnable__V(runnable)
  } else {
    if ((b !== null)) {
      var this$2 = $as_jl_Integer(b);
      var i = $uI(this$2)
    } else {
      var i = 0
    };
    if ((i < 16)) {
      var i$1 = ((1 + i) | 0);
      tl.set__O__V(i$1);
      try {
        runnable.run__V()
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if (false) {
          var x2 = $as_jl_InterruptedException(e$2);
          $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(x2)
        } else if ((e$2 !== null)) {
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2)
          } else {
            throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
          }
        } else {
          throw e
        }
      } finally {
        tl.set__O__V(b)
      }
    } else {
      var batch = new $c_s_concurrent_BatchingExecutor$SyncBatch($thiz, runnable);
      tl.set__O__V(batch);
      batch.run__V();
      tl.set__O__V(b)
    }
  }
}
/** @constructor */
function $c_s_concurrent_BlockContext$DefaultBlockContext$() {
  /*<skip>*/
}
$c_s_concurrent_BlockContext$DefaultBlockContext$.prototype = new $h_O();
$c_s_concurrent_BlockContext$DefaultBlockContext$.prototype.constructor = $c_s_concurrent_BlockContext$DefaultBlockContext$;
/** @constructor */
function $h_s_concurrent_BlockContext$DefaultBlockContext$() {
  /*<skip>*/
}
$h_s_concurrent_BlockContext$DefaultBlockContext$.prototype = $c_s_concurrent_BlockContext$DefaultBlockContext$.prototype;
var $d_s_concurrent_BlockContext$DefaultBlockContext$ = new $TypeData().initClass({
  s_concurrent_BlockContext$DefaultBlockContext$: 0
}, false, "scala.concurrent.BlockContext$DefaultBlockContext$", {
  s_concurrent_BlockContext$DefaultBlockContext$: 1,
  O: 1,
  s_concurrent_BlockContext: 1
});
$c_s_concurrent_BlockContext$DefaultBlockContext$.prototype.$classData = $d_s_concurrent_BlockContext$DefaultBlockContext$;
var $n_s_concurrent_BlockContext$DefaultBlockContext$;
function $m_s_concurrent_BlockContext$DefaultBlockContext$() {
  if ((!$n_s_concurrent_BlockContext$DefaultBlockContext$)) {
    $n_s_concurrent_BlockContext$DefaultBlockContext$ = new $c_s_concurrent_BlockContext$DefaultBlockContext$()
  };
  return $n_s_concurrent_BlockContext$DefaultBlockContext$
}
function $is_s_concurrent_Future(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_concurrent_Future)))
}
function $as_s_concurrent_Future(obj) {
  return (($is_s_concurrent_Future(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.Future"))
}
function $isArrayOf_s_concurrent_Future(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_Future)))
}
function $asArrayOf_s_concurrent_Future(obj, depth) {
  return (($isArrayOf_s_concurrent_Future(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.Future;", depth))
}
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $$x1 = $m_s_Predef$();
  var this$1 = $f_T__trim__T(s);
  var this$2 = $$x1.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0));
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2)
}
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1)
  };
  var x2 = $as_sci_$colon$colon(x1);
  var hd = $as_T(x2.sci_$colon$colon__f_head);
  var rest = x2.sci_$colon$colon__f_next;
  var rest$1 = rest;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var arg1 = rest$1.head__O();
    var s = $as_T(arg1);
    $m_s_package$();
    var array = [s, (s + "s")];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest$1 = $as_sci_List(rest$1.tail__O())
  };
  var this$5 = ((h === null) ? $m_sci_Nil$() : h);
  return new $c_sci_$colon$colon(hd, this$5)
}
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_timeUnit = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  $m_s_package$();
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var $$x6 = new $c_T2(self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var $$x5 = new $c_T2(self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var $$x4 = new $c_T2(self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var $$x3 = new $c_T2(self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var $$x2 = new $c_T2(self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var $$x1 = new $c_T2(self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var array = [$$x6, $$x5, $$x4, $$x3, $$x2, $$x1, new $c_T2(self$6, "ns nano nanosecond")];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  $m_s_$less$colon$less$();
  var this$21 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20);
  var this$23 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sjsr_AnonFunction1(((s$2) => {
    var s = $as_T(s$2);
    return $as_T($p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s).last__O())
  }));
  var this$25 = new $c_sc_MapView$MapValues(this$23, f);
  $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$25);
  var this$26 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  var rest = this$26;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = rest.head__O();
    var x0$1 = $as_T2(arg1);
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1)
    };
    var unit = $as_ju_concurrent_TimeUnit(x0$1._1__O());
    var names = $as_T(x0$1._2__O());
    var this$30 = $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names);
    var f$1 = ((unit$1) => ((x$5$2) => {
      var x$5 = $as_T(x$5$2);
      return new $c_T2(x$5, unit$1)
    }))(unit);
    if ((this$30 === $m_sci_Nil$())) {
      var $$x7 = $m_sci_Nil$()
    } else {
      var arg1$1 = this$30.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = $as_sci_List(this$30.tail__O());
      while ((rest$1 !== $m_sci_Nil$())) {
        var arg1$2 = rest$1.head__O();
        var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = $as_sci_List(rest$1.tail__O())
      };
      var $$x7 = h$1
    };
    var it = $$x7.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1
      } else {
        t.sci_$colon$colon__f_next = nx$1
      };
      t = nx$1
    };
    rest = $as_sci_List(rest.tail__O())
  };
  var this$32 = ((h === null) ? $m_sci_Nil$() : h);
  $m_s_$less$colon$less$();
  this.s_concurrent_duration_Duration$__f_timeUnit = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$32);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration($L0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3()
}
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
$c_s_concurrent_duration_Duration$.prototype.apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration = (function(length, unit) {
  var this$1 = unit.toNanos__J__J(new $c_RTLong(1, 0));
  return this.fromNanos__D__s_concurrent_duration_Duration(($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$1.RTLong__f_lo, this$1.RTLong__f_hi) * length))
});
$c_s_concurrent_duration_Duration$.prototype.apply__T__s_concurrent_duration_Duration = (function(s) {
  var len = $uI(s.length);
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x = (65535 & $uI(s.charCodeAt(index)));
    var this$6 = $m_jl_Character$();
    if ((!this$6.isWhitespace__I__Z(x))) {
      var str = $as_T(String.fromCharCode(x));
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
    };
    i = ((1 + i) | 0)
  };
  var s1 = ((len === sb.length__I()) ? s : sb.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  switch (s1) {
    case "Inf":
    case "PlusInf":
    case "+Inf":
    case "Duration.Inf": {
      return this.s_concurrent_duration_Duration$__f_Inf;
      break
    }
    case "MinusInf":
    case "-Inf":
    case "Duration.MinusInf": {
      return this.s_concurrent_duration_Duration$__f_MinusInf;
      break
    }
    case "Duration.Undefined": {
      return this.s_concurrent_duration_Duration$__f_Undefined;
      break
    }
    default: {
      var $$x1 = $m_sc_StringOps$();
      var x$1 = $m_sc_StringOps$().reverse$extension__T__T(s1);
      _return: {
        var len$1 = $uI(x$1.length);
        var i$1 = 0;
        while ((i$1 < len$1)) {
          var index$1 = i$1;
          var arg1 = (65535 & $uI(x$1.charCodeAt(index$1)));
          var this$14 = $m_jl_Character$();
          if ((!this$14.isLetter__I__Z(arg1))) {
            var x1 = i$1;
            break _return
          };
          i$1 = ((1 + i$1) | 0)
        };
        var x1 = (-1)
      };
      var x$2 = ((x1 === (-1)) ? x$1 : $as_T(x$1.substring(0, x1)));
      var unitName = $$x1.reverse$extension__T__T(x$2);
      var x1$2 = this.s_concurrent_duration_Duration$__f_timeUnit.get__O__s_Option(unitName);
      if ((x1$2 instanceof $c_s_Some)) {
        var x2 = $as_s_Some(x1$2);
        var unit = $as_ju_concurrent_TimeUnit(x2.s_Some__f_value);
        var valueStr = $m_sc_StringOps$().dropRight$extension__T__I__T(s1, $uI(unitName.length));
        var this$17 = $m_sc_StringParsers$().parseLong__T__s_Option(valueStr);
        if (this$17.isEmpty__Z()) {
          var this$19 = $m_s_None$()
        } else {
          var arg1$1 = this$17.get__O();
          var t = $uJ(arg1$1);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var this$19 = new $c_s_Some(new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), unit))
        };
        return $as_s_concurrent_duration_Duration((this$19.isEmpty__Z() ? $m_s_concurrent_duration_Duration$().apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration($m_jl_Double$().parseDouble__T__D(valueStr), unit) : this$19.get__O()))
      } else {
        throw new $c_jl_NumberFormatException(("format error " + s))
      }
    }
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__D__s_concurrent_duration_Duration = (function(nanos) {
  if (((nanos === Infinity) || (nanos === (-Infinity)))) {
    return ((nanos > 0.0) ? this.s_concurrent_duration_Duration$__f_Inf : this.s_concurrent_duration_Duration$__f_MinusInf)
  } else if ((nanos !== nanos)) {
    return this.s_concurrent_duration_Duration$__f_Undefined
  } else if (((nanos > 9.223372036854776E18) || (nanos < (-9.223372036854776E18)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("trying to construct too large duration with " + nanos) + "ns"))
  } else {
    var this$8 = $m_RTLong$();
    var value = $uD(Math.round(nanos));
    var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return this.fromNanos__J__s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi))
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__J__s_concurrent_duration_FiniteDuration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    $m_s_concurrent_duration_Duration$();
    var this$2 = $m_RTLong$();
    var lo$1 = this$2.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
    var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
    return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit)
  } else {
    var this$4 = $m_RTLong$();
    var lo$2 = this$4.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
    var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$2 === 0) && (hi$2 === 0))) {
      $m_s_concurrent_duration_Duration$();
      var this$5 = $m_RTLong$();
      var lo$3 = this$5.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
      var hi$3 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
      return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1)
    } else {
      var this$7 = $m_RTLong$();
      var lo$4 = this$7.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
      var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      if (((lo$4 === 0) && (hi$4 === 0))) {
        $m_s_concurrent_duration_Duration$();
        var this$8 = $m_RTLong$();
        var lo$5 = this$8.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
        var hi$5 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
        return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$5, hi$5), unit$2)
      } else {
        var this$10 = $m_RTLong$();
        var lo$6 = this$10.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
        var hi$6 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        if (((lo$6 === 0) && (hi$6 === 0))) {
          $m_s_concurrent_duration_Duration$();
          var this$11 = $m_RTLong$();
          var lo$7 = this$11.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
          var hi$7 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
          return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$7, hi$7), unit$3)
        } else {
          var this$13 = $m_RTLong$();
          var lo$8 = this$13.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
          var hi$8 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          if (((lo$8 === 0) && (hi$8 === 0))) {
            $m_s_concurrent_duration_Duration$();
            var this$14 = $m_RTLong$();
            var lo$9 = this$14.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
            var hi$9 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
            return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$9, hi$9), unit$4)
          } else {
            var this$16 = $m_RTLong$();
            var lo$10 = this$16.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
            var hi$10 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            if (((lo$10 === 0) && (hi$10 === 0))) {
              $m_s_concurrent_duration_Duration$();
              var this$17 = $m_RTLong$();
              var lo$11 = this$17.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
              var hi$11 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$11, hi$11), unit$5)
            } else {
              $m_s_concurrent_duration_Duration$();
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(nanos, unit$6)
            }
          }
        }
      }
    }
  }
});
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass({
  s_concurrent_duration_Duration$: 0
}, false, "scala.concurrent.duration.Duration$", {
  s_concurrent_duration_Duration$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_duration_Duration$.prototype.$classData = $d_s_concurrent_duration_Duration$;
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$()
  };
  return $n_s_concurrent_duration_Duration$
}
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n
}
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1)
});
function $as_s_concurrent_duration_package$DurationInt(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationInt"))
}
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)))
}
function $asArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationInt;", depth))
}
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass({
  s_concurrent_duration_package$DurationInt: 0
}, false, "scala.concurrent.duration.package$DurationInt", {
  s_concurrent_duration_package$DurationInt: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationInt.prototype.$classData = $d_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong(n) {
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = $L0;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = n
}
$c_s_concurrent_duration_package$DurationLong.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong.prototype.constructor = $c_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong() {
  /*<skip>*/
}
$h_s_concurrent_duration_package$DurationLong.prototype = $c_s_concurrent_duration_package$DurationLong.prototype;
$c_s_concurrent_duration_package$DurationLong.prototype.hashCode__I = (function() {
  var t = this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_s_concurrent_duration_package$DurationLong.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationLong$().equals$extension__J__O__Z(this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n, x$1)
});
function $as_s_concurrent_duration_package$DurationLong(obj) {
  return (((obj instanceof $c_s_concurrent_duration_package$DurationLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.package$DurationLong"))
}
function $isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationLong)))
}
function $asArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.package$DurationLong;", depth))
}
var $d_s_concurrent_duration_package$DurationLong = new $TypeData().initClass({
  s_concurrent_duration_package$DurationLong: 0
}, false, "scala.concurrent.duration.package$DurationLong", {
  s_concurrent_duration_package$DurationLong: 1,
  O: 1,
  s_concurrent_duration_DurationConversions: 1
});
$c_s_concurrent_duration_package$DurationLong.prototype.$classData = $d_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $c_s_concurrent_impl_Promise$ManyCallbacks(first, rest) {
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = null;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_first = first;
  this.s_concurrent_impl_Promise$ManyCallbacks__f_rest = rest
}
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype = new $h_O();
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.constructor = $c_s_concurrent_impl_Promise$ManyCallbacks;
/** @constructor */
function $h_s_concurrent_impl_Promise$ManyCallbacks() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$ManyCallbacks.prototype = $c_s_concurrent_impl_Promise$ManyCallbacks.prototype;
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.toString__T = (function() {
  return "ManyCallbacks"
});
function $as_s_concurrent_impl_Promise$ManyCallbacks(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$ManyCallbacks) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$ManyCallbacks"))
}
function $isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$ManyCallbacks)))
}
function $asArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$ManyCallbacks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$ManyCallbacks;", depth))
}
var $d_s_concurrent_impl_Promise$ManyCallbacks = new $TypeData().initClass({
  s_concurrent_impl_Promise$ManyCallbacks: 0
}, false, "scala.concurrent.impl.Promise$ManyCallbacks", {
  s_concurrent_impl_Promise$ManyCallbacks: 1,
  O: 1,
  s_concurrent_impl_Promise$Callbacks: 1
});
$c_s_concurrent_impl_Promise$ManyCallbacks.prototype.$classData = $d_s_concurrent_impl_Promise$ManyCallbacks;
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true
  };
  return $thiz.s_math_BigDecimal$__f_cache
}
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache)
}
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128
}
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
  /*<skip>*/
}
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc)
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : mc.equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).get(offset);
    if ((n === null)) {
      var hi = (i >> 31);
      n = new $c_s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(i, hi)), mc);
      $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).set(offset, n)
    };
    return n
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(new $c_RTLong(i, hi$1), mc)
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l, mc), mc)
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass({
  s_math_BigDecimal$: 0
}, false, "scala.math.BigDecimal$", {
  s_math_BigDecimal$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigDecimal$.prototype.$classData = $d_s_math_BigDecimal$;
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$()
  };
  return $n_s_math_BigDecimal$
}
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.s_math_BigInt$__f_minCached) | 0);
  var n = $thiz.s_math_BigInt$__f_cache.get(offset);
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, new $c_RTLong(i, hi));
    $thiz.s_math_BigInt$__f_cache.set(offset, n)
  };
  return n
}
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = null;
  this.s_math_BigInt$__f_longMinValue = null;
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_longMinValue = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger, new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1), (-1)))
}
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
  /*<skip>*/
}
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i)
  } else {
    var hi = (i >> 31);
    return this.apply__J__s_math_BigInt(new $c_RTLong(i, hi))
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ l.RTLong__f_lo)) : (hi < bhi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $$x1 = ((ahi === hi$1) ? (((-2147483648) ^ l.RTLong__f_lo) <= ((-2147483648) ^ value$1)) : (ahi < hi$1))
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l.RTLong__f_lo)
  } else {
    return (((l.RTLong__f_lo === 0) && (l.RTLong__f_hi === (-2147483648))) ? this.s_math_BigInt$__f_longMinValue : $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, l))
  }
});
$c_s_math_BigInt$.prototype.apply__Ljava_math_BigInteger__s_math_BigInt = (function(x) {
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(x) <= 63)) {
    var t = x.longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var value = this.s_math_BigInt$__f_minCached;
    var hi$1 = (value >> 31);
    if (((hi$1 === hi) ? (((-2147483648) ^ value) <= ((-2147483648) ^ lo)) : (hi$1 < hi))) {
      var value$1 = this.s_math_BigInt$__f_maxCached;
      var hi$2 = (value$1 >> 31);
      var $$x1 = ((hi === hi$2) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$1)) : (hi < hi$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, lo)
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(lo, hi))
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(0, (-2147483648)))
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass({
  s_math_BigInt$: 0
}, false, "scala.math.BigInt$", {
  s_math_BigInt$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_BigInt$.prototype.$classData = $d_s_math_BigInt$;
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$()
  };
  return $n_s_math_BigInt$
}
function $is_s_math_Equiv(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Equiv)))
}
function $as_s_math_Equiv(obj) {
  return (($is_s_math_Equiv(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Equiv"))
}
function $isArrayOf_s_math_Equiv(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Equiv)))
}
function $asArrayOf_s_math_Equiv(obj, depth) {
  return (($isArrayOf_s_math_Equiv(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Equiv;", depth))
}
/** @constructor */
function $c_s_math_Fractional$() {
  /*<skip>*/
}
$c_s_math_Fractional$.prototype = new $h_O();
$c_s_math_Fractional$.prototype.constructor = $c_s_math_Fractional$;
/** @constructor */
function $h_s_math_Fractional$() {
  /*<skip>*/
}
$h_s_math_Fractional$.prototype = $c_s_math_Fractional$.prototype;
var $d_s_math_Fractional$ = new $TypeData().initClass({
  s_math_Fractional$: 0
}, false, "scala.math.Fractional$", {
  s_math_Fractional$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Fractional$.prototype.$classData = $d_s_math_Fractional$;
var $n_s_math_Fractional$;
function $m_s_math_Fractional$() {
  if ((!$n_s_math_Fractional$)) {
    $n_s_math_Fractional$ = new $c_s_math_Fractional$()
  };
  return $n_s_math_Fractional$
}
/** @constructor */
function $c_s_math_Integral$() {
  /*<skip>*/
}
$c_s_math_Integral$.prototype = new $h_O();
$c_s_math_Integral$.prototype.constructor = $c_s_math_Integral$;
/** @constructor */
function $h_s_math_Integral$() {
  /*<skip>*/
}
$h_s_math_Integral$.prototype = $c_s_math_Integral$.prototype;
var $d_s_math_Integral$ = new $TypeData().initClass({
  s_math_Integral$: 0
}, false, "scala.math.Integral$", {
  s_math_Integral$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Integral$.prototype.$classData = $d_s_math_Integral$;
var $n_s_math_Integral$;
function $m_s_math_Integral$() {
  if ((!$n_s_math_Integral$)) {
    $n_s_math_Integral$ = new $c_s_math_Integral$()
  };
  return $n_s_math_Integral$
}
/** @constructor */
function $c_s_math_Numeric$() {
  /*<skip>*/
}
$c_s_math_Numeric$.prototype = new $h_O();
$c_s_math_Numeric$.prototype.constructor = $c_s_math_Numeric$;
/** @constructor */
function $h_s_math_Numeric$() {
  /*<skip>*/
}
$h_s_math_Numeric$.prototype = $c_s_math_Numeric$.prototype;
var $d_s_math_Numeric$ = new $TypeData().initClass({
  s_math_Numeric$: 0
}, false, "scala.math.Numeric$", {
  s_math_Numeric$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Numeric$.prototype.$classData = $d_s_math_Numeric$;
var $n_s_math_Numeric$;
function $m_s_math_Numeric$() {
  if ((!$n_s_math_Numeric$)) {
    $n_s_math_Numeric$ = new $c_s_math_Numeric$()
  };
  return $n_s_math_Numeric$
}
function $f_s_math_Ordered__$less$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) <= 0)
}
/** @constructor */
function $c_s_package$$anon$1() {
  /*<skip>*/
}
$c_s_package$$anon$1.prototype = new $h_O();
$c_s_package$$anon$1.prototype.constructor = $c_s_package$$anon$1;
/** @constructor */
function $h_s_package$$anon$1() {
  /*<skip>*/
}
$h_s_package$$anon$1.prototype = $c_s_package$$anon$1.prototype;
$c_s_package$$anon$1.prototype.toString__T = (function() {
  return "object AnyRef"
});
var $d_s_package$$anon$1 = new $TypeData().initClass({
  s_package$$anon$1: 0
}, false, "scala.package$$anon$1", {
  s_package$$anon$1: 1,
  O: 1,
  s_Specializable: 1
});
$c_s_package$$anon$1.prototype.$classData = $d_s_package$$anon$1;
/** @constructor */
function $c_s_reflect_ClassTag$() {
  /*<skip>*/
}
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))))
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass({
  s_reflect_ClassTag$: 0
}, false, "scala.reflect.ClassTag$", {
  s_reflect_ClassTag$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_ClassTag$.prototype.$classData = $d_s_reflect_ClassTag$;
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$()
  };
  return $n_s_reflect_ClassTag$
}
/** @constructor */
function $c_s_reflect_Manifest$() {
  /*<skip>*/
}
$c_s_reflect_Manifest$.prototype = new $h_O();
$c_s_reflect_Manifest$.prototype.constructor = $c_s_reflect_Manifest$;
/** @constructor */
function $h_s_reflect_Manifest$() {
  /*<skip>*/
}
$h_s_reflect_Manifest$.prototype = $c_s_reflect_Manifest$.prototype;
var $d_s_reflect_Manifest$ = new $TypeData().initClass({
  s_reflect_Manifest$: 0
}, false, "scala.reflect.Manifest$", {
  s_reflect_Manifest$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_Manifest$.prototype.$classData = $d_s_reflect_Manifest$;
var $n_s_reflect_Manifest$;
function $m_s_reflect_Manifest$() {
  if ((!$n_s_reflect_Manifest$)) {
    $n_s_reflect_Manifest$ = new $c_s_reflect_Manifest$()
  };
  return $n_s_reflect_Manifest$
}
/** @constructor */
function $c_sr_AbstractFunction0() {
  /*<skip>*/
}
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
  /*<skip>*/
}
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>"
});
/** @constructor */
function $c_sr_AbstractFunction1() {
  /*<skip>*/
}
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
  /*<skip>*/
}
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>"
});
/** @constructor */
function $c_sr_AbstractFunction2() {
  /*<skip>*/
}
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
  /*<skip>*/
}
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>"
});
/** @constructor */
function $c_sr_AbstractFunction3() {
  /*<skip>*/
}
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
  /*<skip>*/
}
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>"
});
/** @constructor */
function $c_sr_AbstractFunction4() {
  /*<skip>*/
}
$c_sr_AbstractFunction4.prototype = new $h_O();
$c_sr_AbstractFunction4.prototype.constructor = $c_sr_AbstractFunction4;
/** @constructor */
function $h_sr_AbstractFunction4() {
  /*<skip>*/
}
$h_sr_AbstractFunction4.prototype = $c_sr_AbstractFunction4.prototype;
$c_sr_AbstractFunction4.prototype.toString__T = (function() {
  return "<function4>"
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.sr_BooleanRef__f_elem = false;
  this.sr_BooleanRef__f_elem = elem
}
$c_sr_BooleanRef.prototype = new $h_O();
$c_sr_BooleanRef.prototype.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
  /*<skip>*/
}
$h_sr_BooleanRef.prototype = $c_sr_BooleanRef.prototype;
$c_sr_BooleanRef.prototype.toString__T = (function() {
  var b = this.sr_BooleanRef__f_elem;
  return ("" + b)
});
var $d_sr_BooleanRef = new $TypeData().initClass({
  sr_BooleanRef: 0
}, false, "scala.runtime.BooleanRef", {
  sr_BooleanRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_BooleanRef.prototype.$classData = $d_sr_BooleanRef;
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem
}
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
  /*<skip>*/
}
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i)
});
var $d_sr_IntRef = new $TypeData().initClass({
  sr_IntRef: 0
}, false, "scala.runtime.IntRef", {
  sr_IntRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_IntRef.prototype.$classData = $d_sr_IntRef;
/** @constructor */
function $c_sr_LazyRef() {
  this.sr_LazyRef__f__initialized = false;
  this.sr_LazyRef__f__value = null
}
$c_sr_LazyRef.prototype = new $h_O();
$c_sr_LazyRef.prototype.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
  /*<skip>*/
}
$h_sr_LazyRef.prototype = $c_sr_LazyRef.prototype;
$c_sr_LazyRef.prototype.initialize__O__O = (function(value) {
  this.sr_LazyRef__f__value = value;
  this.sr_LazyRef__f__initialized = true;
  return value
});
$c_sr_LazyRef.prototype.toString__T = (function() {
  return ("LazyRef " + (this.sr_LazyRef__f__initialized ? ("of: " + this.sr_LazyRef__f__value) : "thunk"))
});
var $d_sr_LazyRef = new $TypeData().initClass({
  sr_LazyRef: 0
}, false, "scala.runtime.LazyRef", {
  sr_LazyRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_LazyRef.prototype.$classData = $d_sr_LazyRef;
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem
}
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
  /*<skip>*/
}
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj)
});
var $d_sr_ObjectRef = new $TypeData().initClass({
  sr_ObjectRef: 0
}, false, "scala.runtime.ObjectRef", {
  sr_ObjectRef: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_sr_ObjectRef.prototype.$classData = $d_sr_ObjectRef;
/** @constructor */
function $c_s_util_Either$() {
  /*<skip>*/
}
$c_s_util_Either$.prototype = new $h_O();
$c_s_util_Either$.prototype.constructor = $c_s_util_Either$;
/** @constructor */
function $h_s_util_Either$() {
  /*<skip>*/
}
$h_s_util_Either$.prototype = $c_s_util_Either$.prototype;
var $d_s_util_Either$ = new $TypeData().initClass({
  s_util_Either$: 0
}, false, "scala.util.Either$", {
  s_util_Either$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Either$.prototype.$classData = $d_s_util_Either$;
var $n_s_util_Either$;
function $m_s_util_Either$() {
  if ((!$n_s_util_Either$)) {
    $n_s_util_Either$ = new $c_s_util_Either$()
  };
  return $n_s_util_Either$
}
/** @constructor */
function $c_s_util_Left$() {
  /*<skip>*/
}
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
  /*<skip>*/
}
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left"
});
var $d_s_util_Left$ = new $TypeData().initClass({
  s_util_Left$: 0
}, false, "scala.util.Left$", {
  s_util_Left$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left$.prototype.$classData = $d_s_util_Left$;
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$()
  };
  return $n_s_util_Left$
}
function $ct_s_util_Random__ju_Random__($thiz, self) {
  $thiz.s_util_Random__f_self = self;
  return $thiz
}
/** @constructor */
function $c_s_util_Random() {
  this.s_util_Random__f_self = null
}
$c_s_util_Random.prototype = new $h_O();
$c_s_util_Random.prototype.constructor = $c_s_util_Random;
/** @constructor */
function $h_s_util_Random() {
  /*<skip>*/
}
$h_s_util_Random.prototype = $c_s_util_Random.prototype;
/** @constructor */
function $c_s_util_Right$() {
  /*<skip>*/
}
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
  /*<skip>*/
}
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right"
});
var $d_s_util_Right$ = new $TypeData().initClass({
  s_util_Right$: 0
}, false, "scala.util.Right$", {
  s_util_Right$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right$.prototype.$classData = $d_s_util_Right$;
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$()
  };
  return $n_s_util_Right$
}
/** @constructor */
function $c_s_util_control_NoStackTrace$() {
  this.s_util_control_NoStackTrace$__f__noSuppression = false;
  this.s_util_control_NoStackTrace$__f__noSuppression = false
}
$c_s_util_control_NoStackTrace$.prototype = new $h_O();
$c_s_util_control_NoStackTrace$.prototype.constructor = $c_s_util_control_NoStackTrace$;
/** @constructor */
function $h_s_util_control_NoStackTrace$() {
  /*<skip>*/
}
$h_s_util_control_NoStackTrace$.prototype = $c_s_util_control_NoStackTrace$.prototype;
var $d_s_util_control_NoStackTrace$ = new $TypeData().initClass({
  s_util_control_NoStackTrace$: 0
}, false, "scala.util.control.NoStackTrace$", {
  s_util_control_NoStackTrace$: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_control_NoStackTrace$.prototype.$classData = $d_s_util_control_NoStackTrace$;
var $n_s_util_control_NoStackTrace$;
function $m_s_util_control_NoStackTrace$() {
  if ((!$n_s_util_control_NoStackTrace$)) {
    $n_s_util_control_NoStackTrace$ = new $c_s_util_control_NoStackTrace$()
  };
  return $n_s_util_control_NoStackTrace$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_s_package$().s_package$__f_Nil, this.s_util_hashing_MurmurHash3$__f_mapSeed)
}
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714))
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  if ($is_sc_IndexedSeq(xs)) {
    var x2 = $as_sc_IndexedSeq(xs);
    return this.indexedSeqHash__sc_IndexedSeq__I__I(x2, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else if ((xs instanceof $c_sci_List)) {
    var x3 = $as_sci_List(xs);
    return this.listHash__sci_List__I__I(x3, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  } else {
    return this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed)
  }
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if (xs.isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    xs.foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n)
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$: 0
}, false, "scala.util.hashing.MurmurHash3$", {
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1,
  O: 1
});
$c_s_util_hashing_MurmurHash3$.prototype.$classData = $d_s_util_hashing_MurmurHash3$;
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$()
  };
  return $n_s_util_hashing_MurmurHash3$
}
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1
}
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
  /*<skip>*/
}
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>"
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = Math.imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0)
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2)
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass({
  s_util_hashing_MurmurHash3$accum$1: 0
}, false, "scala.util.hashing.MurmurHash3$accum$1", {
  s_util_hashing_MurmurHash3$accum$1: 1,
  O: 1,
  F2: 1
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.$classData = $d_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $c_Lsnabbdom_DomApi$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_DomApi$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_DomApi$$anon$1.prototype.constructor = $c_Lsnabbdom_DomApi$$anon$1;
/** @constructor */
function $h_Lsnabbdom_DomApi$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_DomApi$$anon$1.prototype = $c_Lsnabbdom_DomApi$$anon$1.prototype;
$c_Lsnabbdom_DomApi$$anon$1.prototype.createElement__T__Lorg_scalajs_dom_HTMLElement = (function(tagName) {
  return document.createElement(tagName)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createElementNS__T__T__Lorg_scalajs_dom_Element = (function(namespaceURI, qualifiedName) {
  return document.createElementNS(namespaceURI, qualifiedName)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createDocumentFragment__Lorg_scalajs_dom_DocumentFragment = (function() {
  return document.createDocumentFragment()
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createTextNode__T__Lorg_scalajs_dom_Text = (function(text) {
  return document.createTextNode(text)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.createComment__T__Lorg_scalajs_dom_Comment = (function(text) {
  return document.createComment(text)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__s_Option__V = (function(parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, (referenceNode.isEmpty__Z() ? null : referenceNode.get__O()))
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V = (function(node, child) {
  node.removeChild(child)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__V = (function(node, child) {
  node.appendChild(child)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.parentNode__Lorg_scalajs_dom_Node__s_Option = (function(node) {
  return $m_s_Option$().apply__O__s_Option(node.parentNode)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.nextSibling__Lorg_scalajs_dom_Node__s_Option = (function(node) {
  return $m_s_Option$().apply__O__s_Option(node.nextSibling)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.tagName__Lorg_scalajs_dom_Element__T = (function(elm) {
  return $as_T(elm.tagName)
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.setTextContent__Lorg_scalajs_dom_Node__s_Option__V = (function(node, text) {
  node.textContent = $as_T((text.isEmpty__Z() ? null : text.get__O()))
});
var $d_Lsnabbdom_DomApi$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_DomApi$$anon$1: 0
}, false, "snabbdom.DomApi$$anon$1", {
  Lsnabbdom_DomApi$$anon$1: 1,
  O: 1,
  Lsnabbdom_DomApi: 1
});
$c_Lsnabbdom_DomApi$$anon$1.prototype.$classData = $d_Lsnabbdom_DomApi$$anon$1;
/** @constructor */
function $c_Lsnabbdom_init$$anon$1(api$24, cbs$19) {
  this.Lsnabbdom_init$$anon$1__f_api$23 = null;
  this.Lsnabbdom_init$$anon$1__f_cbs$18 = null;
  this.Lsnabbdom_init$$anon$1__f_api$23 = api$24;
  this.Lsnabbdom_init$$anon$1__f_cbs$18 = cbs$19
}
$c_Lsnabbdom_init$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_init$$anon$1.prototype.constructor = $c_Lsnabbdom_init$$anon$1;
/** @constructor */
function $h_Lsnabbdom_init$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_init$$anon$1.prototype = $c_Lsnabbdom_init$$anon$1.prototype;
$c_Lsnabbdom_init$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(oldVnode, vnode) {
  return $m_Lsnabbdom_init$().snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode(this.Lsnabbdom_init$$anon$1__f_api$23, this.Lsnabbdom_init$$anon$1__f_cbs$18, oldVnode, vnode)
});
$c_Lsnabbdom_init$$anon$1.prototype.apply__Lorg_scalajs_dom_Element__Lsnabbdom_VNode__Lsnabbdom_VNode = (function(elm, vnode) {
  return $m_Lsnabbdom_init$().snabbdom$init$$$_$patch$1__Lsnabbdom_DomApi__Lsnabbdom_ModuleHooks__Lsnabbdom_VNode__Lsnabbdom_VNode__Lsnabbdom_VNode(this.Lsnabbdom_init$$anon$1__f_api$23, this.Lsnabbdom_init$$anon$1__f_cbs$18, $m_Lsnabbdom_init$().snabbdom$init$$$_$emptyNodeAt$1__Lsnabbdom_DomApi__Lorg_scalajs_dom_Element__Lsnabbdom_VNode(this.Lsnabbdom_init$$anon$1__f_api$23, elm), vnode)
});
var $d_Lsnabbdom_init$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_init$$anon$1: 0
}, false, "snabbdom.init$$anon$1", {
  Lsnabbdom_init$$anon$1: 1,
  O: 1,
  Lsnabbdom_Patch: 1
});
$c_Lsnabbdom_init$$anon$1.prototype.$classData = $d_Lsnabbdom_init$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Attributes$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Attributes$$anon$1.prototype = $c_Lsnabbdom_modules_Attributes$$anon$1.prototype;
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Attributes$().snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode)
});
var $d_Lsnabbdom_modules_Attributes$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_modules_Attributes$$anon$1: 0
}, false, "snabbdom.modules.Attributes$$anon$1", {
  Lsnabbdom_modules_Attributes$$anon$1: 1,
  O: 1,
  Lsnabbdom_CreateHook: 1
});
$c_Lsnabbdom_modules_Attributes$$anon$1.prototype.$classData = $d_Lsnabbdom_modules_Attributes$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_Attributes$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Attributes$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Attributes$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Attributes$$anon$2.prototype = $c_Lsnabbdom_modules_Attributes$$anon$2.prototype;
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Attributes$().snabbdom$modules$Attributes$$$updateAttrs__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode)
});
var $d_Lsnabbdom_modules_Attributes$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_modules_Attributes$$anon$2: 0
}, false, "snabbdom.modules.Attributes$$anon$2", {
  Lsnabbdom_modules_Attributes$$anon$2: 1,
  O: 1,
  Lsnabbdom_UpdateHook: 1
});
$c_Lsnabbdom_modules_Attributes$$anon$2.prototype.$classData = $d_Lsnabbdom_modules_Attributes$$anon$2;
/** @constructor */
function $c_Lsnabbdom_modules_Classes$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Classes$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Classes$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Classes$$anon$1.prototype = $c_Lsnabbdom_modules_Classes$$anon$1.prototype;
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Classes$().snabbdom$modules$Classes$$$updateClasses__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode)
});
var $d_Lsnabbdom_modules_Classes$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_modules_Classes$$anon$1: 0
}, false, "snabbdom.modules.Classes$$anon$1", {
  Lsnabbdom_modules_Classes$$anon$1: 1,
  O: 1,
  Lsnabbdom_CreateHook: 1
});
$c_Lsnabbdom_modules_Classes$$anon$1.prototype.$classData = $d_Lsnabbdom_modules_Classes$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_Classes$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Classes$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Classes$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Classes$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Classes$$anon$2.prototype = $c_Lsnabbdom_modules_Classes$$anon$2.prototype;
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Classes$().snabbdom$modules$Classes$$$updateClasses__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode)
});
var $d_Lsnabbdom_modules_Classes$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_modules_Classes$$anon$2: 0
}, false, "snabbdom.modules.Classes$$anon$2", {
  Lsnabbdom_modules_Classes$$anon$2: 1,
  O: 1,
  Lsnabbdom_UpdateHook: 1
});
$c_Lsnabbdom_modules_Classes$$anon$2.prototype.$classData = $d_Lsnabbdom_modules_Classes$$anon$2;
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Dataset$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Dataset$$anon$1.prototype = $c_Lsnabbdom_modules_Dataset$$anon$1.prototype;
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Dataset$().snabbdom$modules$Dataset$$$updateDataset__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode)
});
var $d_Lsnabbdom_modules_Dataset$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_modules_Dataset$$anon$1: 0
}, false, "snabbdom.modules.Dataset$$anon$1", {
  Lsnabbdom_modules_Dataset$$anon$1: 1,
  O: 1,
  Lsnabbdom_CreateHook: 1
});
$c_Lsnabbdom_modules_Dataset$$anon$1.prototype.$classData = $d_Lsnabbdom_modules_Dataset$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_Dataset$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Dataset$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Dataset$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Dataset$$anon$2.prototype = $c_Lsnabbdom_modules_Dataset$$anon$2.prototype;
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Dataset$().snabbdom$modules$Dataset$$$updateDataset__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode)
});
var $d_Lsnabbdom_modules_Dataset$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_modules_Dataset$$anon$2: 0
}, false, "snabbdom.modules.Dataset$$anon$2", {
  Lsnabbdom_modules_Dataset$$anon$2: 1,
  O: 1,
  Lsnabbdom_UpdateHook: 1
});
$c_Lsnabbdom_modules_Dataset$$anon$2.prototype.$classData = $d_Lsnabbdom_modules_Dataset$$anon$2;
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_EventListeners$$anon$1.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$1.prototype;
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(emptyVNode, new $c_s_Some(vNode))
});
var $d_Lsnabbdom_modules_EventListeners$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_modules_EventListeners$$anon$1: 0
}, false, "snabbdom.modules.EventListeners$$anon$1", {
  Lsnabbdom_modules_EventListeners$$anon$1: 1,
  O: 1,
  Lsnabbdom_CreateHook: 1
});
$c_Lsnabbdom_modules_EventListeners$$anon$1.prototype.$classData = $d_Lsnabbdom_modules_EventListeners$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_EventListeners$$anon$2.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$2.prototype;
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_EventListeners$().snabbdom$modules$EventListeners$$$updateEventListeners__Lsnabbdom_VNode__s_Option__V(oldVNode, new $c_s_Some(vNode))
});
var $d_Lsnabbdom_modules_EventListeners$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_modules_EventListeners$$anon$2: 0
}, false, "snabbdom.modules.EventListeners$$anon$2", {
  Lsnabbdom_modules_EventListeners$$anon$2: 1,
  O: 1,
  Lsnabbdom_UpdateHook: 1
});
$c_Lsnabbdom_modules_EventListeners$$anon$2.prototype.$classData = $d_Lsnabbdom_modules_EventListeners$$anon$2;
/** @constructor */
function $c_Lsnabbdom_modules_EventListeners$$anon$3() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype = new $h_O();
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype.constructor = $c_Lsnabbdom_modules_EventListeners$$anon$3;
/** @constructor */
function $h_Lsnabbdom_modules_EventListeners$$anon$3() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_EventListeners$$anon$3.prototype = $c_Lsnabbdom_modules_EventListeners$$anon$3.prototype;
var $d_Lsnabbdom_modules_EventListeners$$anon$3 = new $TypeData().initClass({
  Lsnabbdom_modules_EventListeners$$anon$3: 0
}, false, "snabbdom.modules.EventListeners$$anon$3", {
  Lsnabbdom_modules_EventListeners$$anon$3: 1,
  O: 1,
  Lsnabbdom_DestroyHook: 1
});
$c_Lsnabbdom_modules_EventListeners$$anon$3.prototype.$classData = $d_Lsnabbdom_modules_EventListeners$$anon$3;
/** @constructor */
function $c_Lsnabbdom_modules_Props$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Props$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Props$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Props$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Props$$anon$1.prototype = $c_Lsnabbdom_modules_Props$$anon$1.prototype;
$c_Lsnabbdom_modules_Props$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Props$().snabbdom$modules$Props$$$updateProps__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode)
});
var $d_Lsnabbdom_modules_Props$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_modules_Props$$anon$1: 0
}, false, "snabbdom.modules.Props$$anon$1", {
  Lsnabbdom_modules_Props$$anon$1: 1,
  O: 1,
  Lsnabbdom_CreateHook: 1
});
$c_Lsnabbdom_modules_Props$$anon$1.prototype.$classData = $d_Lsnabbdom_modules_Props$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_Props$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Props$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Props$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Props$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Props$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Props$$anon$2.prototype = $c_Lsnabbdom_modules_Props$$anon$2.prototype;
$c_Lsnabbdom_modules_Props$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Props$().snabbdom$modules$Props$$$updateProps__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode)
});
var $d_Lsnabbdom_modules_Props$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_modules_Props$$anon$2: 0
}, false, "snabbdom.modules.Props$$anon$2", {
  Lsnabbdom_modules_Props$$anon$2: 1,
  O: 1,
  Lsnabbdom_UpdateHook: 1
});
$c_Lsnabbdom_modules_Props$$anon$2.prototype.$classData = $d_Lsnabbdom_modules_Props$$anon$2;
/** @constructor */
function $c_Lsnabbdom_modules_Styles$$anon$1() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Styles$$anon$1.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.constructor = $c_Lsnabbdom_modules_Styles$$anon$1;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$$anon$1() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Styles$$anon$1.prototype = $c_Lsnabbdom_modules_Styles$$anon$1.prototype;
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(emptyVNode, vNode) {
  $m_Lsnabbdom_modules_Styles$().snabbdom$modules$Styles$$$updateStyle__Lsnabbdom_VNode__Lsnabbdom_VNode__V(emptyVNode, vNode)
});
var $d_Lsnabbdom_modules_Styles$$anon$1 = new $TypeData().initClass({
  Lsnabbdom_modules_Styles$$anon$1: 0
}, false, "snabbdom.modules.Styles$$anon$1", {
  Lsnabbdom_modules_Styles$$anon$1: 1,
  O: 1,
  Lsnabbdom_CreateHook: 1
});
$c_Lsnabbdom_modules_Styles$$anon$1.prototype.$classData = $d_Lsnabbdom_modules_Styles$$anon$1;
/** @constructor */
function $c_Lsnabbdom_modules_Styles$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_modules_Styles$$anon$2.prototype = new $h_O();
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.constructor = $c_Lsnabbdom_modules_Styles$$anon$2;
/** @constructor */
function $h_Lsnabbdom_modules_Styles$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_modules_Styles$$anon$2.prototype = $c_Lsnabbdom_modules_Styles$$anon$2.prototype;
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.apply__Lsnabbdom_VNode__Lsnabbdom_VNode__O = (function(oldVNode, vNode) {
  $m_Lsnabbdom_modules_Styles$().snabbdom$modules$Styles$$$updateStyle__Lsnabbdom_VNode__Lsnabbdom_VNode__V(oldVNode, vNode)
});
var $d_Lsnabbdom_modules_Styles$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_modules_Styles$$anon$2: 0
}, false, "snabbdom.modules.Styles$$anon$2", {
  Lsnabbdom_modules_Styles$$anon$2: 1,
  O: 1,
  Lsnabbdom_UpdateHook: 1
});
$c_Lsnabbdom_modules_Styles$$anon$2.prototype.$classData = $d_Lsnabbdom_modules_Styles$$anon$2;
function $is_Ltyrian_Html(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ltyrian_Html)))
}
function $as_Ltyrian_Html(obj) {
  return (($is_Ltyrian_Html(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Html"))
}
function $isArrayOf_Ltyrian_Html(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Html)))
}
function $asArrayOf_Ltyrian_Html(obj, depth) {
  return (($isArrayOf_Ltyrian_Html(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Html;", depth))
}
function $f_Ltyrian_TyrianApp__$init$__V($thiz) {
  $thiz.Lnet_andimiller_ProbabilisticPlayground$__f_run = new $c_sjsr_AnonFunction1(((_$1) => {
    var _$1$1 = $as_Lcats_effect_kernel_Resource(_$1);
    $as_Lcats_effect_IO(_$1$1.map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = $as_Ltyrian_runtime_TyrianRuntime(_$2);
      _$2$1.start__V()
    }))).useForever__Lcats_effect_kernel_GenSpawn__O($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO)).unsafeRunAndForget__Lcats_effect_unsafe_IORuntime__V($m_Lcats_effect_unsafe_implicits$().Lcats_effect_unsafe_implicits$__f_global)
  }))
}
function $ct_Lcats_Eval$Defer__F0__($thiz, thunk) {
  $thiz.Lcats_Eval$Defer__f_thunk = thunk;
  return $thiz
}
/** @constructor */
function $c_Lcats_Eval$Defer() {
  this.Lcats_Eval$Defer__f_thunk = null
}
$c_Lcats_Eval$Defer.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Defer.prototype.constructor = $c_Lcats_Eval$Defer;
/** @constructor */
function $h_Lcats_Eval$Defer() {
  /*<skip>*/
}
$h_Lcats_Eval$Defer.prototype = $c_Lcats_Eval$Defer.prototype;
$c_Lcats_Eval$Defer.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Eval$Memoize(this)
});
$c_Lcats_Eval$Defer.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this)
});
function $as_Lcats_Eval$Defer(obj) {
  return (((obj instanceof $c_Lcats_Eval$Defer) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Defer"))
}
function $isArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Defer)))
}
function $asArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Defer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Defer;", depth))
}
/** @constructor */
function $c_Lcats_Eval$FlatMap() {
  /*<skip>*/
}
$c_Lcats_Eval$FlatMap.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$FlatMap.prototype.constructor = $c_Lcats_Eval$FlatMap;
/** @constructor */
function $h_Lcats_Eval$FlatMap() {
  /*<skip>*/
}
$h_Lcats_Eval$FlatMap.prototype = $c_Lcats_Eval$FlatMap.prototype;
$c_Lcats_Eval$FlatMap.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Eval$Memoize(this)
});
$c_Lcats_Eval$FlatMap.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this)
});
function $as_Lcats_Eval$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_Eval$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$FlatMap"))
}
function $isArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$FlatMap)))
}
function $asArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_Eval$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$FlatMap;", depth))
}
/** @constructor */
function $c_Lcats_Eval$Leaf() {
  /*<skip>*/
}
$c_Lcats_Eval$Leaf.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Leaf.prototype.constructor = $c_Lcats_Eval$Leaf;
/** @constructor */
function $h_Lcats_Eval$Leaf() {
  /*<skip>*/
}
$h_Lcats_Eval$Leaf.prototype = $c_Lcats_Eval$Leaf.prototype;
function $as_Lcats_Eval$Leaf(obj) {
  return (((obj instanceof $c_Lcats_Eval$Leaf) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Leaf"))
}
function $isArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Leaf)))
}
function $asArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Leaf(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Leaf;", depth))
}
function $ct_Lcats_EvalInstances__($thiz) {
  $thiz.Lcats_EvalInstances__f_catsBimonadForEval = new $c_Lcats_EvalInstances$$anon$1();
  $thiz.Lcats_EvalInstances__f_catsDeferForEval = new $c_Lcats_EvalInstances$$anon$2();
  $thiz.Lcats_EvalInstances__f_catsReducibleForEval = new $c_Lcats_EvalInstances$$anon$3();
  $thiz.Lcats_EvalInstances__f_catsRepresentableForEval = new $c_Lcats_EvalInstances$$anon$4($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_EvalInstances() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_EvalInstances__f_catsDeferForEval = null;
  this.Lcats_EvalInstances__f_catsReducibleForEval = null;
  this.Lcats_EvalInstances__f_catsRepresentableForEval = null
}
$c_Lcats_EvalInstances.prototype = new $h_Lcats_EvalInstances0();
$c_Lcats_EvalInstances.prototype.constructor = $c_Lcats_EvalInstances;
/** @constructor */
function $h_Lcats_EvalInstances() {
  /*<skip>*/
}
$h_Lcats_EvalInstances.prototype = $c_Lcats_EvalInstances.prototype;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$2.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$2.prototype.constructor = $c_Lcats_EvalInstances$$anon$2;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$2.prototype = $c_Lcats_EvalInstances$$anon$2.prototype;
var $d_Lcats_EvalInstances$$anon$2 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$2: 0
}, false, "cats.EvalInstances$$anon$2", {
  Lcats_EvalInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
});
$c_Lcats_EvalInstances$$anon$2.prototype.$classData = $d_Lcats_EvalInstances$$anon$2;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$4(outer) {
  this.Lcats_EvalInstances$$anon$4__f_F = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var instance = outer.Lcats_EvalInstances__f_catsBimonadForEval;
  this.Lcats_EvalInstances$$anon$4__f_F = instance
}
$c_Lcats_EvalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$4.prototype.constructor = $c_Lcats_EvalInstances$$anon$4;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$4.prototype = $c_Lcats_EvalInstances$$anon$4.prototype;
var $d_Lcats_EvalInstances$$anon$4 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$4: 0
}, false, "cats.EvalInstances$$anon$4", {
  Lcats_EvalInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
});
$c_Lcats_EvalInstances$$anon$4.prototype.$classData = $d_Lcats_EvalInstances$$anon$4;
/** @constructor */
function $c_Lcats_FlatMap$$anon$2(target$2, tc$2) {
  this.Lcats_FlatMap$$anon$2__f_self = null;
  this.Lcats_FlatMap$$anon$2__f_typeClassInstance = null;
  this.Lcats_FlatMap$$anon$2__f_self = target$2;
  this.Lcats_FlatMap$$anon$2__f_typeClassInstance = tc$2
}
$c_Lcats_FlatMap$$anon$2.prototype = new $h_O();
$c_Lcats_FlatMap$$anon$2.prototype.constructor = $c_Lcats_FlatMap$$anon$2;
/** @constructor */
function $h_Lcats_FlatMap$$anon$2() {
  /*<skip>*/
}
$h_Lcats_FlatMap$$anon$2.prototype = $c_Lcats_FlatMap$$anon$2.prototype;
var $d_Lcats_FlatMap$$anon$2 = new $TypeData().initClass({
  Lcats_FlatMap$$anon$2: 0
}, false, "cats.FlatMap$$anon$2", {
  Lcats_FlatMap$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FlatMap$Ops: 1
});
$c_Lcats_FlatMap$$anon$2.prototype.$classData = $d_Lcats_FlatMap$$anon$2;
/** @constructor */
function $c_Lcats_Foldable$$anon$2() {
  /*<skip>*/
}
$c_Lcats_Foldable$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_Foldable$$anon$2.prototype.constructor = $c_Lcats_Foldable$$anon$2;
/** @constructor */
function $h_Lcats_Foldable$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Foldable$$anon$2.prototype = $c_Lcats_Foldable$$anon$2.prototype;
$c_Lcats_Foldable$$anon$2.prototype.apply__O__O = (function(a) {
  return this
});
var $d_Lcats_Foldable$$anon$2 = new $TypeData().initClass({
  Lcats_Foldable$$anon$2: 0
}, false, "cats.Foldable$$anon$2", {
  Lcats_Foldable$$anon$2: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_Lcats_Foldable$$anon$2.prototype.$classData = $d_Lcats_Foldable$$anon$2;
/** @constructor */
function $c_Lcats_Foldable$$anon$6(target$2, tc$2) {
  this.Lcats_Foldable$$anon$6__f_self = null;
  this.Lcats_Foldable$$anon$6__f_typeClassInstance = null;
  this.Lcats_Foldable$$anon$6__f_self = target$2;
  this.Lcats_Foldable$$anon$6__f_typeClassInstance = tc$2
}
$c_Lcats_Foldable$$anon$6.prototype = new $h_O();
$c_Lcats_Foldable$$anon$6.prototype.constructor = $c_Lcats_Foldable$$anon$6;
/** @constructor */
function $h_Lcats_Foldable$$anon$6() {
  /*<skip>*/
}
$h_Lcats_Foldable$$anon$6.prototype = $c_Lcats_Foldable$$anon$6.prototype;
var $d_Lcats_Foldable$$anon$6 = new $TypeData().initClass({
  Lcats_Foldable$$anon$6: 0
}, false, "cats.Foldable$$anon$6", {
  Lcats_Foldable$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable$Ops: 1
});
$c_Lcats_Foldable$$anon$6.prototype.$classData = $d_Lcats_Foldable$$anon$6;
function $f_Lcats_Functor__as__O__O__O($thiz, fa, b) {
  return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((b$2) => ((_$3) => b$2))(b)))
}
/** @constructor */
function $c_Lcats_Functor$$anon$4(target$2, tc$2) {
  this.Lcats_Functor$$anon$4__f_self = null;
  this.Lcats_Functor$$anon$4__f_typeClassInstance = null;
  this.Lcats_Functor$$anon$4__f_self = target$2;
  this.Lcats_Functor$$anon$4__f_typeClassInstance = tc$2
}
$c_Lcats_Functor$$anon$4.prototype = new $h_O();
$c_Lcats_Functor$$anon$4.prototype.constructor = $c_Lcats_Functor$$anon$4;
/** @constructor */
function $h_Lcats_Functor$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Functor$$anon$4.prototype = $c_Lcats_Functor$$anon$4.prototype;
var $d_Lcats_Functor$$anon$4 = new $TypeData().initClass({
  Lcats_Functor$$anon$4: 0
}, false, "cats.Functor$$anon$4", {
  Lcats_Functor$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Functor$Ops: 1
});
$c_Lcats_Functor$$anon$4.prototype.$classData = $d_Lcats_Functor$$anon$4;
/** @constructor */
function $c_Lcats_Invariant$$anon$10() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$10.prototype = new $h_O();
$c_Lcats_Invariant$$anon$10.prototype.constructor = $c_Lcats_Invariant$$anon$10;
/** @constructor */
function $h_Lcats_Invariant$$anon$10() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$10.prototype = $c_Lcats_Invariant$$anon$10.prototype;
var $d_Lcats_Invariant$$anon$10 = new $TypeData().initClass({
  Lcats_Invariant$$anon$10: 0
}, false, "cats.Invariant$$anon$10", {
  Lcats_Invariant$$anon$10: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$10.prototype.$classData = $d_Lcats_Invariant$$anon$10;
/** @constructor */
function $c_Lcats_Invariant$$anon$4() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$4.prototype = new $h_O();
$c_Lcats_Invariant$$anon$4.prototype.constructor = $c_Lcats_Invariant$$anon$4;
/** @constructor */
function $h_Lcats_Invariant$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$4.prototype = $c_Lcats_Invariant$$anon$4.prototype;
var $d_Lcats_Invariant$$anon$4 = new $TypeData().initClass({
  Lcats_Invariant$$anon$4: 0
}, false, "cats.Invariant$$anon$4", {
  Lcats_Invariant$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$4.prototype.$classData = $d_Lcats_Invariant$$anon$4;
/** @constructor */
function $c_Lcats_Invariant$$anon$5() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$5.prototype = new $h_O();
$c_Lcats_Invariant$$anon$5.prototype.constructor = $c_Lcats_Invariant$$anon$5;
/** @constructor */
function $h_Lcats_Invariant$$anon$5() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$5.prototype = $c_Lcats_Invariant$$anon$5.prototype;
var $d_Lcats_Invariant$$anon$5 = new $TypeData().initClass({
  Lcats_Invariant$$anon$5: 0
}, false, "cats.Invariant$$anon$5", {
  Lcats_Invariant$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$5.prototype.$classData = $d_Lcats_Invariant$$anon$5;
/** @constructor */
function $c_Lcats_Invariant$$anon$6() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$6.prototype = new $h_O();
$c_Lcats_Invariant$$anon$6.prototype.constructor = $c_Lcats_Invariant$$anon$6;
/** @constructor */
function $h_Lcats_Invariant$$anon$6() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$6.prototype = $c_Lcats_Invariant$$anon$6.prototype;
var $d_Lcats_Invariant$$anon$6 = new $TypeData().initClass({
  Lcats_Invariant$$anon$6: 0
}, false, "cats.Invariant$$anon$6", {
  Lcats_Invariant$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$6.prototype.$classData = $d_Lcats_Invariant$$anon$6;
/** @constructor */
function $c_Lcats_Invariant$$anon$7() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$7.prototype = new $h_O();
$c_Lcats_Invariant$$anon$7.prototype.constructor = $c_Lcats_Invariant$$anon$7;
/** @constructor */
function $h_Lcats_Invariant$$anon$7() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$7.prototype = $c_Lcats_Invariant$$anon$7.prototype;
var $d_Lcats_Invariant$$anon$7 = new $TypeData().initClass({
  Lcats_Invariant$$anon$7: 0
}, false, "cats.Invariant$$anon$7", {
  Lcats_Invariant$$anon$7: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$7.prototype.$classData = $d_Lcats_Invariant$$anon$7;
/** @constructor */
function $c_Lcats_Invariant$$anon$8() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$8.prototype = new $h_O();
$c_Lcats_Invariant$$anon$8.prototype.constructor = $c_Lcats_Invariant$$anon$8;
/** @constructor */
function $h_Lcats_Invariant$$anon$8() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$8.prototype = $c_Lcats_Invariant$$anon$8.prototype;
var $d_Lcats_Invariant$$anon$8 = new $TypeData().initClass({
  Lcats_Invariant$$anon$8: 0
}, false, "cats.Invariant$$anon$8", {
  Lcats_Invariant$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$8.prototype.$classData = $d_Lcats_Invariant$$anon$8;
/** @constructor */
function $c_Lcats_Invariant$$anon$9() {
  /*<skip>*/
}
$c_Lcats_Invariant$$anon$9.prototype = new $h_O();
$c_Lcats_Invariant$$anon$9.prototype.constructor = $c_Lcats_Invariant$$anon$9;
/** @constructor */
function $h_Lcats_Invariant$$anon$9() {
  /*<skip>*/
}
$h_Lcats_Invariant$$anon$9.prototype = $c_Lcats_Invariant$$anon$9.prototype;
var $d_Lcats_Invariant$$anon$9 = new $TypeData().initClass({
  Lcats_Invariant$$anon$9: 0
}, false, "cats.Invariant$$anon$9", {
  Lcats_Invariant$$anon$9: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_Invariant$$anon$9.prototype.$classData = $d_Lcats_Invariant$$anon$9;
/** @constructor */
function $c_Lcats_Parallel$() {
  /*<skip>*/
}
$c_Lcats_Parallel$.prototype = new $h_Lcats_ParallelArityFunctions2();
$c_Lcats_Parallel$.prototype.constructor = $c_Lcats_Parallel$;
/** @constructor */
function $h_Lcats_Parallel$() {
  /*<skip>*/
}
$h_Lcats_Parallel$.prototype = $c_Lcats_Parallel$.prototype;
$c_Lcats_Parallel$.prototype.parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O = (function(ta, f, evidence$9, evidence$10, P) {
  return P.sequential__Lcats_arrow_FunctionK().apply__O__O(evidence$9.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O(ta, new $c_sjsr_AnonFunction1(((f$2, P$2) => ((a) => P$2.parallel__Lcats_arrow_FunctionK().apply__O__O(f$2.apply__O__O(a))))(f, P)), evidence$10))
});
$c_Lcats_Parallel$.prototype.parUnorderedSequence__O__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O = (function(ta, evidence$11, evidence$12, P) {
  return this.parUnorderedTraverse__O__F1__Lcats_UnorderedTraverse__Lcats_CommutativeApplicative__Lcats_Parallel__O(ta, new $c_sjsr_AnonFunction1(((x) => x)), evidence$11, evidence$12, P)
});
var $d_Lcats_Parallel$ = new $TypeData().initClass({
  Lcats_Parallel$: 0
}, false, "cats.Parallel$", {
  Lcats_Parallel$: 1,
  Lcats_ParallelArityFunctions2: 1,
  O: 1,
  Lcats_ParallelArityFunctions: 1
});
$c_Lcats_Parallel$.prototype.$classData = $d_Lcats_Parallel$;
var $n_Lcats_Parallel$;
function $m_Lcats_Parallel$() {
  if ((!$n_Lcats_Parallel$)) {
    $n_Lcats_Parallel$ = new $c_Lcats_Parallel$()
  };
  return $n_Lcats_Parallel$
}
/** @constructor */
function $c_Lcats_Semigroupal$() {
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrder = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrder = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrdering = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrdering = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEq = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEquiv = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForMonoid = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForSemigroup = null;
  this.Lcats_Semigroupal$__f_catsSemigroupalForCommutativeSemigroup = null;
  $n_Lcats_Semigroupal$ = this;
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrder = $m_Lcats_instances_package$order$().Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrder = $m_Lcats_instances_package$partialOrder$().Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder;
  this.Lcats_Semigroupal$__f_catsSemigroupalForOrdering = $m_Lcats_instances_package$ordering$().Lcats_instances_package$ordering$__f_catsContravariantMonoidalForOrdering;
  this.Lcats_Semigroupal$__f_catsSemigroupalForPartialOrdering = $m_Lcats_instances_package$partialOrdering$().Lcats_instances_package$partialOrdering$__f_catsContravariantMonoidalForPartialOrdering;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEq = $m_Lcats_instances_package$eq$().Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq;
  this.Lcats_Semigroupal$__f_catsSemigroupalForEquiv = $m_Lcats_instances_package$equiv$().Lcats_instances_package$equiv$__f_catsContravariantMonoidalForEquiv;
  this.Lcats_Semigroupal$__f_catsSemigroupalForMonoid = ($m_Lcats_instances_package$invariant$(), new $c_Lcats_instances_InvariantMonoidalInstances$$anon$3());
  this.Lcats_Semigroupal$__f_catsSemigroupalForSemigroup = $m_Lcats_instances_package$invariant$().Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup;
  this.Lcats_Semigroupal$__f_catsSemigroupalForCommutativeSemigroup = $m_Lcats_instances_package$invariant$().Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup
}
$c_Lcats_Semigroupal$.prototype = new $h_O();
$c_Lcats_Semigroupal$.prototype.constructor = $c_Lcats_Semigroupal$;
/** @constructor */
function $h_Lcats_Semigroupal$() {
  /*<skip>*/
}
$h_Lcats_Semigroupal$.prototype = $c_Lcats_Semigroupal$.prototype;
var $d_Lcats_Semigroupal$ = new $TypeData().initClass({
  Lcats_Semigroupal$: 0
}, false, "cats.Semigroupal$", {
  Lcats_Semigroupal$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificSemigroupalInstances: 1,
  Lcats_SemigroupalArityFunctions: 1
});
$c_Lcats_Semigroupal$.prototype.$classData = $d_Lcats_Semigroupal$;
var $n_Lcats_Semigroupal$;
function $m_Lcats_Semigroupal$() {
  if ((!$n_Lcats_Semigroupal$)) {
    $n_Lcats_Semigroupal$ = new $c_Lcats_Semigroupal$()
  };
  return $n_Lcats_Semigroupal$
}
/** @constructor */
function $c_Lcats_Traverse$$anon$3(target$2, tc$2) {
  this.Lcats_Traverse$$anon$3__f_self = null;
  this.Lcats_Traverse$$anon$3__f_typeClassInstance = null;
  this.Lcats_Traverse$$anon$3__f_self = target$2;
  this.Lcats_Traverse$$anon$3__f_typeClassInstance = tc$2
}
$c_Lcats_Traverse$$anon$3.prototype = new $h_O();
$c_Lcats_Traverse$$anon$3.prototype.constructor = $c_Lcats_Traverse$$anon$3;
/** @constructor */
function $h_Lcats_Traverse$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Traverse$$anon$3.prototype = $c_Lcats_Traverse$$anon$3.prototype;
var $d_Lcats_Traverse$$anon$3 = new $TypeData().initClass({
  Lcats_Traverse$$anon$3: 0
}, false, "cats.Traverse$$anon$3", {
  Lcats_Traverse$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Traverse$Ops: 1
});
$c_Lcats_Traverse$$anon$3.prototype.$classData = $d_Lcats_Traverse$$anon$3;
/** @constructor */
function $c_Lcats_UnorderedFoldable$() {
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$orEvalMonoid = null;
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$andEvalMonoid = null;
  $n_Lcats_UnorderedFoldable$ = this;
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$orEvalMonoid = new $c_Lcats_UnorderedFoldable$$anon$1();
  this.Lcats_UnorderedFoldable$__f_cats$UnorderedFoldable$$$andEvalMonoid = new $c_Lcats_UnorderedFoldable$$anon$2()
}
$c_Lcats_UnorderedFoldable$.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$.prototype.constructor = $c_Lcats_UnorderedFoldable$;
/** @constructor */
function $h_Lcats_UnorderedFoldable$() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$.prototype = $c_Lcats_UnorderedFoldable$.prototype;
var $d_Lcats_UnorderedFoldable$ = new $TypeData().initClass({
  Lcats_UnorderedFoldable$: 0
}, false, "cats.UnorderedFoldable$", {
  Lcats_UnorderedFoldable$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificTraverseInstances: 1,
  Lcats_instances_NTupleUnorderedFoldableInstances: 1
});
$c_Lcats_UnorderedFoldable$.prototype.$classData = $d_Lcats_UnorderedFoldable$;
var $n_Lcats_UnorderedFoldable$;
function $m_Lcats_UnorderedFoldable$() {
  if ((!$n_Lcats_UnorderedFoldable$)) {
    $n_Lcats_UnorderedFoldable$ = new $c_Lcats_UnorderedFoldable$()
  };
  return $n_Lcats_UnorderedFoldable$
}
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$1(f$2, outer) {
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = null;
  this.Lcats_arrow_FunctionK$$anon$1__f_f$1 = f$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_arrow_FunctionK$$anon$1__f_$outer = outer
}
$c_Lcats_arrow_FunctionK$$anon$1.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$1.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$1;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$1() {
  /*<skip>*/
}
$h_Lcats_arrow_FunctionK$$anon$1.prototype = $c_Lcats_arrow_FunctionK$$anon$1.prototype;
$c_Lcats_arrow_FunctionK$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.Lcats_arrow_FunctionK$$anon$1__f_$outer.apply__O__O(this.Lcats_arrow_FunctionK$$anon$1__f_f$1.apply__O__O(fa))
});
var $d_Lcats_arrow_FunctionK$$anon$1 = new $TypeData().initClass({
  Lcats_arrow_FunctionK$$anon$1: 0
}, false, "cats.arrow.FunctionK$$anon$1", {
  Lcats_arrow_FunctionK$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_arrow_FunctionK$$anon$1.prototype.$classData = $d_Lcats_arrow_FunctionK$$anon$1;
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$4() {
  /*<skip>*/
}
$c_Lcats_arrow_FunctionK$$anon$4.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$4.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$4() {
  /*<skip>*/
}
$h_Lcats_arrow_FunctionK$$anon$4.prototype = $c_Lcats_arrow_FunctionK$$anon$4.prototype;
$c_Lcats_arrow_FunctionK$$anon$4.prototype.apply__O__O = (function(fa) {
  return fa
});
var $d_Lcats_arrow_FunctionK$$anon$4 = new $TypeData().initClass({
  Lcats_arrow_FunctionK$$anon$4: 0
}, false, "cats.arrow.FunctionK$$anon$4", {
  Lcats_arrow_FunctionK$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_arrow_FunctionK$$anon$4.prototype.$classData = $d_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $c_Lcats_data_Chain$$anon$2() {
  /*<skip>*/
}
$c_Lcats_data_Chain$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_data_Chain$$anon$2.prototype.constructor = $c_Lcats_data_Chain$$anon$2;
/** @constructor */
function $h_Lcats_data_Chain$$anon$2() {
  /*<skip>*/
}
$h_Lcats_data_Chain$$anon$2.prototype = $c_Lcats_data_Chain$$anon$2.prototype;
$c_Lcats_data_Chain$$anon$2.prototype.apply__O__O = (function(a) {
  return this
});
var $d_Lcats_data_Chain$$anon$2 = new $TypeData().initClass({
  Lcats_data_Chain$$anon$2: 0
}, false, "cats.data.Chain$$anon$2", {
  Lcats_data_Chain$$anon$2: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_Lcats_data_Chain$$anon$2.prototype.$classData = $d_Lcats_data_Chain$$anon$2;
/** @constructor */
function $c_Lcats_data_ChainInstances1() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances1.prototype = new $h_Lcats_data_ChainInstances2();
$c_Lcats_data_ChainInstances1.prototype.constructor = $c_Lcats_data_ChainInstances1;
/** @constructor */
function $h_Lcats_data_ChainInstances1() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances1.prototype = $c_Lcats_data_ChainInstances1.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances7() {
  /*<skip>*/
}
$c_Lcats_data_KleisliInstances7.prototype = new $h_Lcats_data_KleisliInstances8();
$c_Lcats_data_KleisliInstances7.prototype.constructor = $c_Lcats_data_KleisliInstances7;
/** @constructor */
function $h_Lcats_data_KleisliInstances7() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances7.prototype = $c_Lcats_data_KleisliInstances7.prototype;
function $ct_Lcats_data_NonEmptyListInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = new $c_Lcats_data_NonEmptyListInstances$$anon$1();
  return $thiz
}
function $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$1$$_$go$1__F1__scm_ListBuffer__Lcats_data_NonEmptyList__V(f$9, buf$3, v) {
  var v$tailLocal1 = v;
  while (true) {
    matchResult18: {
      var x60 = $as_s_util_Either(v$tailLocal1.Lcats_data_NonEmptyList__f_head);
      if ((x60 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x60).s_util_Right__f_value;
        buf$3.addOne__O__scm_ListBuffer(b);
        matchResult17: {
          var x57 = $m_Lcats_data_NonEmptyList$().fromList__sci_List__s_Option(v$tailLocal1.Lcats_data_NonEmptyList__f_tail);
          if ((x57 instanceof $c_s_Some)) {
            var t = $as_Lcats_data_NonEmptyList($as_s_Some(x57).s_Some__f_value);
            v$tailLocal1 = t;
            continue
          };
          var x = $m_s_None$();
          if ((x === x57)) {
            break matchResult17
          };
          throw new $c_s_MatchError(x57)
        };
        break matchResult18
      };
      if ((x60 instanceof $c_s_util_Left)) {
        var a = $as_s_util_Left(x60).s_util_Left__f_value;
        var this$1 = $as_Lcats_data_NonEmptyList(f$9.apply__O__O(a));
        var l = v$tailLocal1.Lcats_data_NonEmptyList__f_tail;
        v$tailLocal1 = this$1.concat__sci_List__Lcats_data_NonEmptyList(l);
        continue
      };
      throw new $c_s_MatchError(x60)
    };
    return (void 0)
  }
}
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = null
}
$c_Lcats_data_NonEmptyListInstances.prototype = new $h_Lcats_data_NonEmptyListInstances0();
$c_Lcats_data_NonEmptyListInstances.prototype.constructor = $c_Lcats_data_NonEmptyListInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances.prototype = $c_Lcats_data_NonEmptyListInstances.prototype;
function $p_Lcats_effect_CallbackStack__loop$1__Lcats_effect_CallbackStack__Lcats_effect_CallbackStack($thiz, attempt$1) {
  while (true) {
    var cur = $as_Lcats_effect_CallbackStack($thiz.ju_concurrent_atomic_AtomicReference__f_value);
    attempt$1.ju_concurrent_atomic_AtomicReference__f_value = cur;
    if ((!$thiz.compareAndSet__O__O__Z(cur, attempt$1))) {
      /*<skip>*/
    } else {
      return attempt$1
    }
  }
}
/** @constructor */
function $c_Lcats_effect_CallbackStack(callback) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.Lcats_effect_CallbackStack__f_callback = null;
  this.Lcats_effect_CallbackStack__f_callback = callback;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, null)
}
$c_Lcats_effect_CallbackStack.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_Lcats_effect_CallbackStack.prototype.constructor = $c_Lcats_effect_CallbackStack;
/** @constructor */
function $h_Lcats_effect_CallbackStack() {
  /*<skip>*/
}
$h_Lcats_effect_CallbackStack.prototype = $c_Lcats_effect_CallbackStack.prototype;
$c_Lcats_effect_CallbackStack.prototype.push__F1__Lcats_effect_CallbackStack = (function(next) {
  var attempt = new $c_Lcats_effect_CallbackStack(next);
  return $p_Lcats_effect_CallbackStack__loop$1__Lcats_effect_CallbackStack__Lcats_effect_CallbackStack(this, attempt)
});
$c_Lcats_effect_CallbackStack.prototype.apply__Lcats_effect_kernel_Outcome__Z__Z = (function(oc, invoked) {
  var this$ = this;
  var invoked$tailLocal1 = invoked;
  while (true) {
    var cb = this$.Lcats_effect_CallbackStack__f_callback;
    var invoked2 = ((cb !== null) ? (cb.apply__O__O(oc), true) : invoked$tailLocal1);
    var next = $as_Lcats_effect_CallbackStack(this$.ju_concurrent_atomic_AtomicReference__f_value);
    if ((next !== null)) {
      this$ = next;
      invoked$tailLocal1 = invoked2
    } else {
      return invoked2
    }
  }
});
$c_Lcats_effect_CallbackStack.prototype.clearCurrent__V = (function() {
  this.Lcats_effect_CallbackStack__f_callback = null
});
function $as_Lcats_effect_CallbackStack(obj) {
  return (((obj instanceof $c_Lcats_effect_CallbackStack) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.CallbackStack"))
}
function $isArrayOf_Lcats_effect_CallbackStack(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_CallbackStack)))
}
function $asArrayOf_Lcats_effect_CallbackStack(obj, depth) {
  return (($isArrayOf_Lcats_effect_CallbackStack(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.CallbackStack;", depth))
}
var $d_Lcats_effect_CallbackStack = new $TypeData().initClass({
  Lcats_effect_CallbackStack: 0
}, false, "cats.effect.CallbackStack", {
  Lcats_effect_CallbackStack: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_CallbackStack.prototype.$classData = $d_Lcats_effect_CallbackStack;
/** @constructor */
function $c_Lcats_effect_IO$$anon$1() {
  /*<skip>*/
}
$c_Lcats_effect_IO$$anon$1.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$1.prototype.constructor = $c_Lcats_effect_IO$$anon$1;
/** @constructor */
function $h_Lcats_effect_IO$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_IO$$anon$1.prototype = $c_Lcats_effect_IO$$anon$1.prototype;
var $d_Lcats_effect_IO$$anon$1 = new $TypeData().initClass({
  Lcats_effect_IO$$anon$1: 0
}, false, "cats.effect.IO$$anon$1", {
  Lcats_effect_IO$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align: 1
});
$c_Lcats_effect_IO$$anon$1.prototype.$classData = $d_Lcats_effect_IO$$anon$1;
/** @constructor */
function $c_Lcats_effect_IO$IOSemigroupK() {
  /*<skip>*/
}
$c_Lcats_effect_IO$IOSemigroupK.prototype = new $h_O();
$c_Lcats_effect_IO$IOSemigroupK.prototype.constructor = $c_Lcats_effect_IO$IOSemigroupK;
/** @constructor */
function $h_Lcats_effect_IO$IOSemigroupK() {
  /*<skip>*/
}
$h_Lcats_effect_IO$IOSemigroupK.prototype = $c_Lcats_effect_IO$IOSemigroupK.prototype;
var $d_Lcats_effect_IO$IOSemigroupK = new $TypeData().initClass({
  Lcats_effect_IO$IOSemigroupK: 0
}, false, "cats.effect.IO$IOSemigroupK", {
  Lcats_effect_IO$IOSemigroupK: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1
});
$c_Lcats_effect_IO$IOSemigroupK.prototype.$classData = $d_Lcats_effect_IO$IOSemigroupK;
/** @constructor */
function $c_Lcats_effect_IOFiberPlatform() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false
}
$c_Lcats_effect_IOFiberPlatform.prototype = new $h_ju_concurrent_atomic_AtomicBoolean();
$c_Lcats_effect_IOFiberPlatform.prototype.constructor = $c_Lcats_effect_IOFiberPlatform;
/** @constructor */
function $h_Lcats_effect_IOFiberPlatform() {
  /*<skip>*/
}
$h_Lcats_effect_IOFiberPlatform.prototype = $c_Lcats_effect_IOFiberPlatform.prototype;
/** @constructor */
function $c_Lcats_effect_SyncIO$$anon$1() {
  /*<skip>*/
}
$c_Lcats_effect_SyncIO$$anon$1.prototype = new $h_O();
$c_Lcats_effect_SyncIO$$anon$1.prototype.constructor = $c_Lcats_effect_SyncIO$$anon$1;
/** @constructor */
function $h_Lcats_effect_SyncIO$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$$anon$1.prototype = $c_Lcats_effect_SyncIO$$anon$1.prototype;
var $d_Lcats_effect_SyncIO$$anon$1 = new $TypeData().initClass({
  Lcats_effect_SyncIO$$anon$1: 0
}, false, "cats.effect.SyncIO$$anon$1", {
  Lcats_effect_SyncIO$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align: 1
});
$c_Lcats_effect_SyncIO$$anon$1.prototype.$classData = $d_Lcats_effect_SyncIO$$anon$1;
/** @constructor */
function $c_Lcats_effect_kernel_Deferred() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Deferred.prototype = new $h_O();
$c_Lcats_effect_kernel_Deferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred.prototype = $c_Lcats_effect_kernel_Deferred.prototype;
function $as_Lcats_effect_kernel_Deferred(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Deferred) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Deferred"))
}
function $isArrayOf_Lcats_effect_kernel_Deferred(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Deferred)))
}
function $asArrayOf_Lcats_effect_kernel_Deferred(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Deferred(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Deferred;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$State$() {
  this.Lcats_effect_kernel_Deferred$State$__f_initialId = $L0;
  this.Lcats_effect_kernel_Deferred$State$__f_dummyId = $L0;
  this.Lcats_effect_kernel_Deferred$State$__f_initialId = new $c_RTLong(1, 0);
  this.Lcats_effect_kernel_Deferred$State$__f_dummyId = $L0
}
$c_Lcats_effect_kernel_Deferred$State$.prototype = new $h_O();
$c_Lcats_effect_kernel_Deferred$State$.prototype.constructor = $c_Lcats_effect_kernel_Deferred$State$;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$State$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$State$.prototype = $c_Lcats_effect_kernel_Deferred$State$.prototype;
var $d_Lcats_effect_kernel_Deferred$State$ = new $TypeData().initClass({
  Lcats_effect_kernel_Deferred$State$: 0
}, false, "cats.effect.kernel.Deferred$State$", {
  Lcats_effect_kernel_Deferred$State$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_effect_kernel_Deferred$State$.prototype.$classData = $d_Lcats_effect_kernel_Deferred$State$;
var $n_Lcats_effect_kernel_Deferred$State$;
function $m_Lcats_effect_kernel_Deferred$State$() {
  if ((!$n_Lcats_effect_kernel_Deferred$State$)) {
    $n_Lcats_effect_kernel_Deferred$State$ = new $c_Lcats_effect_kernel_Deferred$State$()
  };
  return $n_Lcats_effect_kernel_Deferred$State$
}
function $is_Lcats_effect_kernel_Poll(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Poll)))
}
function $as_Lcats_effect_kernel_Poll(obj) {
  return (($is_Lcats_effect_kernel_Poll(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Poll"))
}
function $isArrayOf_Lcats_effect_kernel_Poll(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Poll)))
}
function $asArrayOf_Lcats_effect_kernel_Poll(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Poll(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Poll;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_Ref() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Ref.prototype = new $h_O();
$c_Lcats_effect_kernel_Ref.prototype.constructor = $c_Lcats_effect_kernel_Ref;
/** @constructor */
function $h_Lcats_effect_kernel_Ref() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Ref.prototype = $c_Lcats_effect_kernel_Ref.prototype;
$c_Lcats_effect_kernel_Ref.prototype.updateAndGet__F1__O = (function(f) {
  return this.modify__F1__O(new $c_sjsr_AnonFunction1(((f$2) => ((a) => {
    var newA = f$2.apply__O__O(a);
    return new $c_T2(newA, newA)
  }))(f)))
});
function $as_Lcats_effect_kernel_Ref(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Ref) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Ref"))
}
function $isArrayOf_Lcats_effect_kernel_Ref(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Ref)))
}
function $asArrayOf_Lcats_effect_kernel_Ref(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Ref(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Ref;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$5() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$$anon$5.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$5;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$5() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$$anon$5.prototype = $c_Lcats_effect_kernel_Resource$$anon$5.prototype;
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.apply__O__O = (function(fa) {
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
var $d_Lcats_effect_kernel_Resource$$anon$5 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$$anon$5: 0
}, false, "cats.effect.kernel.Resource$$anon$5", {
  Lcats_effect_kernel_Resource$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_effect_kernel_Resource$$anon$5.prototype.$classData = $d_Lcats_effect_kernel_Resource$$anon$5;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$7$$anon$1(G$9, nt$6, outer) {
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_G$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_nt$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_G$1 = G$9;
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_nt$1 = nt$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$7$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$7$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype = $c_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype;
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype.apply__Lcats_effect_kernel_Resource__Lcats_data_Kleisli = (function(rfa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, rfa$2) => ((r) => {
    var r$1 = $as_Lcats_effect_kernel_Ref(r);
    var target = this$1.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_nt$1.apply__O__O(rfa$2.allocatedCase__Lcats_effect_kernel_MonadCancel__O(this$1.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_$outer.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1));
    var tc = this$1.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_G$1;
    var this$11 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f$3 = new $c_sjsr_AnonFunction1(((this$3, r$2) => ((x$1) => {
      var x$1$1 = $as_T2(x$1);
      if ((x$1$1 !== null)) {
        var a = x$1$1._1__O();
        var fin = $as_F1(x$1$1._2__O());
        var x$2 = this$3.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_$outer;
        var target$1 = r$2.update__F1__O(new $c_sjsr_AnonFunction1(((x, fin$2) => ((f) => {
          var f$1 = $as_F1(f);
          return new $c_sjsr_AnonFunction1(((this$4, fin$5$2, f$2) => ((ec) => {
            var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
            var wrapped = f$2.apply__O__O(ec$1);
            var this$6 = this$4.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1;
            var fa = this$6.pure__O__O((void 0));
            var fb = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((fin$4$2, ec$2) => (() => fin$4$2.apply__O__O(ec$2)))(fin$5$2, ec$1)), this$4.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1);
            var F = this$4.Lcats_effect_kernel_Resource$$anon$7__f_cats$effect$kernel$Resource$$anon$7$$F$1;
            return F.forceR__O__O__O(wrapped, fb)
          }))(x, fin$2, f$1))
        }))(x$2, fin)));
        var tc$1 = this$3.Lcats_effect_kernel_Resource$$anon$7$$anon$1__f_G$1;
        var this$10 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
        return this$10.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$10.Lcats_Functor$$anon$4__f_self, a)
      };
      throw new $c_s_MatchError(x$1$1)
    }))(this$1, r$1));
    return this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f$3)
  }))(this, rfa));
  return new $c_Lcats_data_Kleisli(run)
});
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_kernel_Resource__Lcats_data_Kleisli($as_Lcats_effect_kernel_Resource(fa))
});
var $d_Lcats_effect_kernel_Resource$$anon$7$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$$anon$7$$anon$1: 0
}, false, "cats.effect.kernel.Resource$$anon$7$$anon$1", {
  Lcats_effect_kernel_Resource$$anon$7$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_effect_kernel_Resource$$anon$7$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_Resource$$anon$7$$anon$1;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$ExitCase$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.fromOutcome__Lcats_effect_kernel_Outcome__Lcats_effect_kernel_Resource$ExitCase = (function(outcome) {
  if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$1 = $as_Lcats_effect_kernel_Outcome$Succeeded(outcome);
    return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$()
  };
  if ((outcome instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome$Errored(outcome);
    var x186 = $as_jl_Throwable(x$1$1.Lcats_effect_kernel_Outcome$Errored__f_e);
    return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x186)
  };
  if (((outcome instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(outcome), true))) {
    return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$()
  };
  throw new $c_s_MatchError(outcome)
});
var $d_Lcats_effect_kernel_Resource$ExitCase$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$ExitCase$: 0
}, false, "cats.effect.kernel.Resource$ExitCase$", {
  Lcats_effect_kernel_Resource$ExitCase$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_effect_kernel_Resource$ExitCase$.prototype.$classData = $d_Lcats_effect_kernel_Resource$ExitCase$;
var $n_Lcats_effect_kernel_Resource$ExitCase$;
function $m_Lcats_effect_kernel_Resource$ExitCase$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$ = new $c_Lcats_effect_kernel_Resource$ExitCase$()
  };
  return $n_Lcats_effect_kernel_Resource$ExitCase$
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$2$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$2$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$Frame$2$__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$Frame$2$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$2$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$2$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$2$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Frame$2$.prototype = $c_Lcats_effect_kernel_Resource$Frame$2$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$2$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$1__Lcats_effect_kernel_Resource$Frame$1 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$1(this.Lcats_effect_kernel_Resource$Frame$2$__f_$outer, head, tail)
});
$c_Lcats_effect_kernel_Resource$Frame$2$.prototype.toString__T = (function() {
  return "Frame"
});
function $as_Lcats_effect_kernel_Resource$Frame$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$2$"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$2$)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$2$;", depth))
}
var $d_Lcats_effect_kernel_Resource$Frame$2$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Frame$2$: 0
}, false, "cats.effect.kernel.Resource$Frame$2$", {
  Lcats_effect_kernel_Resource$Frame$2$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_kernel_Resource$Frame$2$.prototype.$classData = $d_Lcats_effect_kernel_Resource$Frame$2$;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$4$(outer) {
  this.Lcats_effect_kernel_Resource$Frame$4$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$Frame$4$__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$Frame$4$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$4$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$4$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$4$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Frame$4$.prototype = $c_Lcats_effect_kernel_Resource$Frame$4$.prototype;
$c_Lcats_effect_kernel_Resource$Frame$4$.prototype.apply__F1__Lcats_effect_kernel_Resource$Stack$2__Lcats_effect_kernel_Resource$Frame$3 = (function(head, tail) {
  return new $c_Lcats_effect_kernel_Resource$Frame$3(this.Lcats_effect_kernel_Resource$Frame$4$__f_$outer, head, tail)
});
$c_Lcats_effect_kernel_Resource$Frame$4$.prototype.toString__T = (function() {
  return "Frame"
});
function $as_Lcats_effect_kernel_Resource$Frame$4$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$4$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$4$"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$4$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$4$)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$4$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$4$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$4$;", depth))
}
var $d_Lcats_effect_kernel_Resource$Frame$4$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Frame$4$: 0
}, false, "cats.effect.kernel.Resource$Frame$4$", {
  Lcats_effect_kernel_Resource$Frame$4$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_kernel_Resource$Frame$4$.prototype.$classData = $d_Lcats_effect_kernel_Resource$Frame$4$;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$State$1$(F$74, outer) {
  this.Lcats_effect_kernel_Resource$State$1$__f_F$1 = null;
  this.Lcats_effect_kernel_Resource$State$1$__f_$outer = null;
  this.Lcats_effect_kernel_Resource$State$1$__f_F$1 = F$74;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$State$1$__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$State$1$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$State$1$.prototype.constructor = $c_Lcats_effect_kernel_Resource$State$1$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$State$1$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$State$1$.prototype = $c_Lcats_effect_kernel_Resource$State$1$.prototype;
$c_Lcats_effect_kernel_Resource$State$1$.prototype.apply__O__Z__Z__Lcats_effect_kernel_Resource$State$2 = (function(fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  return new $c_Lcats_effect_kernel_Resource$State$2(this.Lcats_effect_kernel_Resource$State$1$__f_$outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete)
});
$c_Lcats_effect_kernel_Resource$State$1$.prototype.toString__T = (function() {
  return "State"
});
$c_Lcats_effect_kernel_Resource$State$1$.prototype.$lessinit$greater$default$1__O = (function() {
  var this$1 = this.Lcats_effect_kernel_Resource$State$1$__f_F$1;
  return this$1.pure__O__O((void 0))
});
function $as_Lcats_effect_kernel_Resource$State$1$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$State$1$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$State$1$"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$State$1$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$State$1$)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$State$1$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$State$1$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$State$1$;", depth))
}
var $d_Lcats_effect_kernel_Resource$State$1$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$State$1$: 0
}, false, "cats.effect.kernel.Resource$State$1$", {
  Lcats_effect_kernel_Resource$State$1$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_kernel_Resource$State$1$.prototype.$classData = $d_Lcats_effect_kernel_Resource$State$1$;
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.apply__O__O = (function(fa) {
  $m_Lcats_effect_kernel_package$();
  $m_Lcats_effect_kernel_Par$();
  return fa
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4 = new $TypeData().initClass({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4: 0
}, false, "cats.effect.kernel.instances.GenSpawnInstances$$anon$4", {
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4.prototype.$classData = $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4;
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5.prototype.apply__O__O = (function(ma) {
  $m_Lcats_effect_kernel_package$();
  $m_Lcats_effect_kernel_Par$();
  return ma
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5 = new $TypeData().initClass({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5: 0
}, false, "cats.effect.kernel.instances.GenSpawnInstances$$anon$5", {
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5.prototype.$classData = $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5;
function $p_Lcats_effect_std_Dispatcher$$anon$2__loop$1__ju_concurrent_atomic_AtomicReference__F0__V($thiz, cancelState$2, cancelToken$1) {
  while (true) {
    var state = $as_Lcats_effect_std_Dispatcher$CancelState$1(cancelState$2.ju_concurrent_atomic_AtomicReference__f_value);
    var x = $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CancelInit$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelInit$1$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CancelInit$lzy1$1);
    if ((x === state)) {
      if ((!cancelState$2.compareAndSet__O__O__Z(state, ($m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CancelToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelToken$2$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CancelToken$lzy1$1), new $c_Lcats_effect_std_Dispatcher$CancelToken$1(cancelToken$1))))) {
        continue
      }
    } else if ((state instanceof $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1)) {
      $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CanceledNoToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CanceledNoToken$2$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CanceledNoToken$lzy1$1);
      var x$1 = $as_Lcats_effect_std_Dispatcher$CanceledNoToken$1(state);
      var x31 = x$1.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise;
      if ((!cancelState$2.compareAndSet__O__O__Z(state, ($m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CancelToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelToken$2$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CancelToken$lzy1$1), new $c_Lcats_effect_std_Dispatcher$CancelToken$1(cancelToken$1))))) {
        continue
      } else {
        $as_s_concurrent_Future(cancelToken$1.apply__O()).onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sjsr_AnonFunction1(((promise$2) => ((x$1$1) => {
          var x$1$2 = $as_s_util_Try(x$1$1);
          if ((x$1$2 instanceof $c_s_util_Success)) {
            return $f_s_concurrent_Promise__success__O__s_concurrent_Promise(promise$2, (void 0))
          };
          if ((x$1$2 instanceof $c_s_util_Failure)) {
            var ex = $as_s_util_Failure(x$1$2).s_util_Failure__f_exception;
            return $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(promise$2, ex)
          };
          throw new $c_s_MatchError(x$1$2)
        }))(x31)), $thiz.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1)
      }
    };
    return (void 0)
  }
}
function $p_Lcats_effect_std_Dispatcher$$anon$2__registerCancel$1__ju_concurrent_atomic_AtomicReference__O__V($thiz, cancelState$1, token) {
  var cancelToken = new $c_sjsr_AnonFunction0(((this$1, token$2) => (() => $f_Lcats_effect_std_Dispatcher__unsafeToFuture__O__s_concurrent_Future(this$1, token$2)))($thiz, token));
  $p_Lcats_effect_std_Dispatcher$$anon$2__loop$1__ju_concurrent_atomic_AtomicReference__F0__V($thiz, cancelState$1, cancelToken)
}
function $p_Lcats_effect_std_Dispatcher$$anon$2__loop$2__ju_concurrent_atomic_AtomicReference__s_concurrent_Future($thiz, cancelState$4) {
  while (true) {
    var state = $as_Lcats_effect_std_Dispatcher$CancelState$1(cancelState$4.ju_concurrent_atomic_AtomicReference__f_value);
    var x = $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CancelInit$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelInit$1$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CancelInit$lzy1$1);
    if ((x === state)) {
      var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
      if ((!cancelState$4.compareAndSet__O__O__Z(state, ($m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CanceledNoToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CanceledNoToken$2$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CanceledNoToken$lzy1$1), new $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1(promise))))) {
        continue
      } else {
        return promise
      }
    };
    if ((state instanceof $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1)) {
      $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CanceledNoToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CanceledNoToken$2$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CanceledNoToken$lzy1$1);
      var x$1 = $as_Lcats_effect_std_Dispatcher$CanceledNoToken$1(state);
      var x38 = x$1.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise;
      return x38
    };
    if ((state instanceof $c_Lcats_effect_std_Dispatcher$CancelToken$1)) {
      $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CancelToken$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelToken$2$($thiz.Lcats_effect_std_Dispatcher$$anon$2__f_CancelToken$lzy1$1);
      var x$1$1 = $as_Lcats_effect_std_Dispatcher$CancelToken$1(state);
      var x35 = x$1$1.Lcats_effect_std_Dispatcher$CancelToken$1__f_cancelToken;
      return $as_s_concurrent_Future(x35.apply__O())
    };
    throw new $c_s_MatchError(state)
  }
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$$anon$2(F$17, latches$8, states$7, ec$4, alive$3, Registration$lzy1$16, CancelInit$lzy1$10, CanceledNoToken$lzy1$10, CancelToken$lzy1$10) {
  this.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_latches$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_states$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_alive$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_Registration$lzy1$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_CancelInit$lzy1$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_CanceledNoToken$lzy1$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_CancelToken$lzy1$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1 = F$17;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_latches$1 = latches$8;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_states$1 = states$7;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_ec$1 = ec$4;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_alive$1 = alive$3;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_Registration$lzy1$1 = Registration$lzy1$16;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_CancelInit$lzy1$1 = CancelInit$lzy1$10;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_CanceledNoToken$lzy1$1 = CanceledNoToken$lzy1$10;
  this.Lcats_effect_std_Dispatcher$$anon$2__f_CancelToken$lzy1$1 = CancelToken$lzy1$10
}
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.constructor = $c_Lcats_effect_std_Dispatcher$$anon$2;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$$anon$2.prototype = $c_Lcats_effect_std_Dispatcher$$anon$2.prototype;
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.unsafeToFutureCancelable__O__T2 = (function(fe) {
  var promise = $ct_s_concurrent_impl_Promise$DefaultPromise__(new $c_s_concurrent_impl_Promise$DefaultPromise());
  var tc = this.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1;
  var this$4 = new $c_Lcats_FlatMap$$anon$2(fe, tc);
  var f = new $c_sjsr_AnonFunction1(((this$3, promise$2) => ((e) => this$3.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1.delay__F0__O(new $c_sjsr_AnonFunction0(((promise$1$2, e$2) => (() => $f_s_concurrent_Promise__success__O__s_concurrent_Promise(promise$1$2, e$2)))(promise$2, e)))))(this, promise));
  var fa = this$4.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$$anon$2__f_self, f);
  var pf = new $c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1(promise, this);
  var F$1 = this.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1;
  var target = $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(F$1, fa, pf);
  var tc$1 = this.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1;
  var this$8 = new $c_Lcats_Functor$$anon$4(target, tc$1);
  var action = this$8.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$8.Lcats_Functor$$anon$4__f_self);
  var cancelState = $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$CancelInit$1__sr_LazyRef__Lcats_effect_std_Dispatcher$CancelInit$1$(this.Lcats_effect_std_Dispatcher$$anon$2__f_CancelInit$lzy1$1));
  if (this.Lcats_effect_std_Dispatcher$$anon$2__f_alive$1.ju_concurrent_atomic_AtomicBoolean__f_value) {
    var this$9 = $m_ju_concurrent_ThreadLocalRandom$();
    var rand = this$9.ju_concurrent_ThreadLocalRandom$__f__current;
    var dispatcher = rand.nextInt__I__I($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus);
    var inner = rand.nextInt__I__I($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Cpus);
    var state = this.Lcats_effect_std_Dispatcher$$anon$2__f_states$1.get(dispatcher).get(inner);
    $m_Lcats_effect_std_Dispatcher$().cats$effect$std$Dispatcher$$$_$Registration$1__sr_LazyRef__Lcats_effect_std_Dispatcher$Registration$2$(this.Lcats_effect_std_Dispatcher$$anon$2__f_Registration$lzy1$1);
    var prepareCancel = new $c_sjsr_AnonFunction1(((this$2$1, cancelState$2) => ((token) => {
      $p_Lcats_effect_std_Dispatcher$$anon$2__registerCancel$1__ju_concurrent_atomic_AtomicReference__O__V(this$2$1, cancelState$2, token)
    }))(this, cancelState));
    var reg = new $c_Lcats_effect_std_Dispatcher$Registration$1(action, prepareCancel);
    $s_Lcats_effect_std_Dispatcher$__cats$effect$std$Dispatcher$$anon$2$$_$enqueue$1__ju_concurrent_atomic_AtomicReference__Lcats_effect_std_Dispatcher$Registration$1__V(state, reg);
    var lt = this.Lcats_effect_std_Dispatcher$$anon$2__f_latches$1.get(dispatcher);
    if ((lt.ju_concurrent_atomic_AtomicReference__f_value !== $m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Open)) {
      var f$1 = $as_F0(lt.getAndSet__O__O($m_Lcats_effect_std_Dispatcher$().Lcats_effect_std_Dispatcher$__f_cats$effect$std$Dispatcher$$$Open));
      f$1.apply__O()
    };
    var cancel = new $c_sjsr_AnonFunction0(((this$3$1, cancelState$3, reg$2) => (() => {
      reg$2.ju_concurrent_atomic_AtomicBoolean__f_value = false;
      return $p_Lcats_effect_std_Dispatcher$$anon$2__loop$2__ju_concurrent_atomic_AtomicReference__s_concurrent_Future(this$3$1, cancelState$3)
    }))(this, cancelState, reg));
    if (this.Lcats_effect_std_Dispatcher$$anon$2__f_alive$1.ju_concurrent_atomic_AtomicBoolean__f_value) {
      return new $c_T2(promise, cancel)
    } else {
      cancel.apply__O();
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "dispatcher already shutdown")
    }
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "dispatcher already shutdown")
  }
});
var $d_Lcats_effect_std_Dispatcher$$anon$2 = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$$anon$2: 0
}, false, "cats.effect.std.Dispatcher$$anon$2", {
  Lcats_effect_std_Dispatcher$$anon$2: 1,
  O: 1,
  Lcats_effect_std_DispatcherPlatform: 1,
  Lcats_effect_std_Dispatcher: 1
});
$c_Lcats_effect_std_Dispatcher$$anon$2.prototype.$classData = $d_Lcats_effect_std_Dispatcher$$anon$2;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$CancelToken$2$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Dispatcher$CancelToken$2$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$CancelToken$2$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$CancelToken$2$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$CancelToken$2$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$CancelToken$2$.prototype = $c_Lcats_effect_std_Dispatcher$CancelToken$2$.prototype;
$c_Lcats_effect_std_Dispatcher$CancelToken$2$.prototype.toString__T = (function() {
  return "CancelToken"
});
function $as_Lcats_effect_std_Dispatcher$CancelToken$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$CancelToken$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$CancelToken$2$"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$CancelToken$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$CancelToken$2$)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$CancelToken$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$CancelToken$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$CancelToken$2$;", depth))
}
var $d_Lcats_effect_std_Dispatcher$CancelToken$2$ = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$CancelToken$2$: 0
}, false, "cats.effect.std.Dispatcher$CancelToken$2$", {
  Lcats_effect_std_Dispatcher$CancelToken$2$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_std_Dispatcher$CancelToken$2$.prototype.$classData = $d_Lcats_effect_std_Dispatcher$CancelToken$2$;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$CanceledNoToken$2$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$CanceledNoToken$2$.prototype = $c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$.prototype;
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$.prototype.toString__T = (function() {
  return "CanceledNoToken"
});
function $as_Lcats_effect_std_Dispatcher$CanceledNoToken$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$CanceledNoToken$2$"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$CanceledNoToken$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$CanceledNoToken$2$)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$CanceledNoToken$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$CanceledNoToken$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$CanceledNoToken$2$;", depth))
}
var $d_Lcats_effect_std_Dispatcher$CanceledNoToken$2$ = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$CanceledNoToken$2$: 0
}, false, "cats.effect.std.Dispatcher$CanceledNoToken$2$", {
  Lcats_effect_std_Dispatcher$CanceledNoToken$2$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$2$.prototype.$classData = $d_Lcats_effect_std_Dispatcher$CanceledNoToken$2$;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$2$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Dispatcher$Registration$2$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$Registration$2$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$2$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$2$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$Registration$2$.prototype = $c_Lcats_effect_std_Dispatcher$Registration$2$.prototype;
$c_Lcats_effect_std_Dispatcher$Registration$2$.prototype.toString__T = (function() {
  return "Registration"
});
function $as_Lcats_effect_std_Dispatcher$Registration$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$2$"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$2$)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$2$;", depth))
}
var $d_Lcats_effect_std_Dispatcher$Registration$2$ = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$Registration$2$: 0
}, false, "cats.effect.std.Dispatcher$Registration$2$", {
  Lcats_effect_std_Dispatcher$Registration$2$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_std_Dispatcher$Registration$2$.prototype.$classData = $d_Lcats_effect_std_Dispatcher$Registration$2$;
/** @constructor */
function $c_Lcats_effect_std_Queue() {
  /*<skip>*/
}
$c_Lcats_effect_std_Queue.prototype = new $h_O();
$c_Lcats_effect_std_Queue.prototype.constructor = $c_Lcats_effect_std_Queue;
/** @constructor */
function $h_Lcats_effect_std_Queue() {
  /*<skip>*/
}
$h_Lcats_effect_std_Queue.prototype = $c_Lcats_effect_std_Queue.prototype;
function $as_Lcats_effect_std_Queue(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Queue"))
}
function $isArrayOf_Lcats_effect_std_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Queue)))
}
function $asArrayOf_Lcats_effect_std_Queue(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Queue;", depth))
}
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Request$(outer) {
  this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer = outer
}
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Request$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Request$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl$Request$.prototype = $c_Lcats_effect_std_Semaphore$impl$Request$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request = (function(n, gate) {
  return new $c_Lcats_effect_std_Semaphore$impl$Request(this.Lcats_effect_std_Semaphore$impl$Request$__f_$outer, n, gate)
});
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.toString__T = (function() {
  return "Request"
});
var $d_Lcats_effect_std_Semaphore$impl$Request$ = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl$Request$: 0
}, false, "cats.effect.std.Semaphore$impl$Request$", {
  Lcats_effect_std_Semaphore$impl$Request$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_std_Semaphore$impl$Request$.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl$Request$;
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$State$(outer) {
  this.Lcats_effect_std_Semaphore$impl$State$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_std_Semaphore$impl$State$__f_$outer = outer
}
$c_Lcats_effect_std_Semaphore$impl$State$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$State$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$State$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl$State$.prototype = $c_Lcats_effect_std_Semaphore$impl$State$.prototype;
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.apply__J__sci_Queue__Lcats_effect_std_Semaphore$impl$State = (function(permits, waiting) {
  return new $c_Lcats_effect_std_Semaphore$impl$State(this.Lcats_effect_std_Semaphore$impl$State$__f_$outer, permits, waiting)
});
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.toString__T = (function() {
  return "State"
});
var $d_Lcats_effect_std_Semaphore$impl$State$ = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl$State$: 0
}, false, "cats.effect.std.Semaphore$impl$State$", {
  Lcats_effect_std_Semaphore$impl$State$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_std_Semaphore$impl$State$.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl$State$;
/** @constructor */
function $c_Lcats_effect_unsafe_ES2021FiberMonitor(compute) {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null;
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_compute = null;
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag = null;
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_compute = compute;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this);
  this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag = new $c_Lcats_effect_unsafe_WeakBag()
}
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_ES2021FiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_ES2021FiberMonitor() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_ES2021FiberMonitor.prototype = $c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype;
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return this.Lcats_effect_unsafe_ES2021FiberMonitor__f_bag.insert__O__Lcats_effect_unsafe_WeakBag$Handle(fiber)
});
var $d_Lcats_effect_unsafe_ES2021FiberMonitor = new $TypeData().initClass({
  Lcats_effect_unsafe_ES2021FiberMonitor: 0
}, false, "cats.effect.unsafe.ES2021FiberMonitor", {
  Lcats_effect_unsafe_ES2021FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1,
  O: 1
});
$c_Lcats_effect_unsafe_ES2021FiberMonitor.prototype.$classData = $d_Lcats_effect_unsafe_ES2021FiberMonitor;
/** @constructor */
function $c_Lcats_effect_unsafe_NoOpFiberMonitor() {
  this.Lcats_effect_unsafe_FiberMonitorShared__f_newline = null;
  this.Lcats_effect_unsafe_FiberMonitorShared__f_doubleNewline = null;
  $ct_Lcats_effect_unsafe_FiberMonitorShared__(this)
}
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = new $h_Lcats_effect_unsafe_FiberMonitor();
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.constructor = $c_Lcats_effect_unsafe_NoOpFiberMonitor;
/** @constructor */
function $h_Lcats_effect_unsafe_NoOpFiberMonitor() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_NoOpFiberMonitor.prototype = $c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype;
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle = (function(fiber) {
  return new $c_Lcats_effect_unsafe_NoOpFiberMonitor$$anon$1(this)
});
var $d_Lcats_effect_unsafe_NoOpFiberMonitor = new $TypeData().initClass({
  Lcats_effect_unsafe_NoOpFiberMonitor: 0
}, false, "cats.effect.unsafe.NoOpFiberMonitor", {
  Lcats_effect_unsafe_NoOpFiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitor: 1,
  Lcats_effect_unsafe_FiberMonitorShared: 1,
  O: 1
});
$c_Lcats_effect_unsafe_NoOpFiberMonitor.prototype.$classData = $d_Lcats_effect_unsafe_NoOpFiberMonitor;
/** @constructor */
function $c_Lcats_evidence_As$() {
  this.Lcats_evidence_AsInstances__f_liskov = null;
  this.Lcats_evidence_As$__f_reflAny = null;
  $ct_Lcats_evidence_AsInstances__(this);
  $n_Lcats_evidence_As$ = this;
  this.Lcats_evidence_As$__f_reflAny = new $c_Lcats_evidence_As$$anon$1()
}
$c_Lcats_evidence_As$.prototype = new $h_Lcats_evidence_AsInstances();
$c_Lcats_evidence_As$.prototype.constructor = $c_Lcats_evidence_As$;
/** @constructor */
function $h_Lcats_evidence_As$() {
  /*<skip>*/
}
$h_Lcats_evidence_As$.prototype = $c_Lcats_evidence_As$.prototype;
$c_Lcats_evidence_As$.prototype.witness__Lcats_evidence_As__F1 = (function(lt) {
  var fa = new $c_sjsr_AnonFunction1(((x) => x));
  return fa
});
var $d_Lcats_evidence_As$ = new $TypeData().initClass({
  Lcats_evidence_As$: 0
}, false, "cats.evidence.As$", {
  Lcats_evidence_As$: 1,
  Lcats_evidence_AsInstances: 1,
  O: 1,
  Lcats_evidence_AsSupport: 1
});
$c_Lcats_evidence_As$.prototype.$classData = $d_Lcats_evidence_As$;
var $n_Lcats_evidence_As$;
function $m_Lcats_evidence_As$() {
  if ((!$n_Lcats_evidence_As$)) {
    $n_Lcats_evidence_As$ = new $c_Lcats_evidence_As$()
  };
  return $n_Lcats_evidence_As$
}
/** @constructor */
function $c_Lcats_evidence_As$$anon$1() {
  /*<skip>*/
}
$c_Lcats_evidence_As$$anon$1.prototype = new $h_Lcats_evidence_As();
$c_Lcats_evidence_As$$anon$1.prototype.constructor = $c_Lcats_evidence_As$$anon$1;
/** @constructor */
function $h_Lcats_evidence_As$$anon$1() {
  /*<skip>*/
}
$h_Lcats_evidence_As$$anon$1.prototype = $c_Lcats_evidence_As$$anon$1.prototype;
var $d_Lcats_evidence_As$$anon$1 = new $TypeData().initClass({
  Lcats_evidence_As$$anon$1: 0
}, false, "cats.evidence.As$$anon$1", {
  Lcats_evidence_As$$anon$1: 1,
  Lcats_evidence_As: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_evidence_As$$anon$1.prototype.$classData = $d_Lcats_evidence_As$$anon$1;
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$4(fa$4, fb$2) {
  this.Lcats_instances_EquivInstances$$anon$4__f_fa$1 = null;
  this.Lcats_instances_EquivInstances$$anon$4__f_fb$1 = null;
  this.Lcats_instances_EquivInstances$$anon$4__f_fa$1 = fa$4;
  this.Lcats_instances_EquivInstances$$anon$4__f_fb$1 = fb$2
}
$c_Lcats_instances_EquivInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$4.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$4.prototype = $c_Lcats_instances_EquivInstances$$anon$4.prototype;
var $d_Lcats_instances_EquivInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$4: 0
}, false, "cats.instances.EquivInstances$$anon$4", {
  Lcats_instances_EquivInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1
});
$c_Lcats_instances_EquivInstances$$anon$4.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1__f_Deferred$lzy1 = null;
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1__f_Deferred$lzy1 = new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(this)
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.FunctionInstancesBinCompat0$$anon$1", {
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Defer: 1
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$(outer) {
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$__f_$outer = outer
}
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = new $h_O();
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.constructor = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$() {
  /*<skip>*/
}
$h_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype = $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype;
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.toString__T = (function() {
  return "Deferred"
});
var $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$ = new $TypeData().initClass({
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 0
}, false, "cats.instances.FunctionInstancesBinCompat0$$anon$1$Deferred$", {
  Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$.prototype.$classData = $d_Lcats_instances_FunctionInstancesBinCompat0$$anon$1$Deferred$;
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantInstances$$anon$1.prototype = $c_Lcats_instances_InvariantInstances$$anon$1.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantInstances$$anon$1: 0
}, false, "cats.instances.InvariantInstances$$anon$1", {
  Lcats_instances_InvariantInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantInstances$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantInstances$$anon$2.prototype = $c_Lcats_instances_InvariantInstances$$anon$2.prototype;
var $d_Lcats_instances_InvariantInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_InvariantInstances$$anon$2: 0
}, false, "cats.instances.InvariantInstances$$anon$2", {
  Lcats_instances_InvariantInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantInstances$$anon$2.prototype.$classData = $d_Lcats_instances_InvariantInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_InvariantInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.InvariantInstancesBinCompat0$$anon$1", {
  Lcats_instances_InvariantInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
});
$c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$4(fa$13, fb$5) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fa$1 = fa$13;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$4__f_fb$1 = fb$5
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype;
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$4", {
  Lcats_instances_InvariantMonoidalInstances$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$4.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_MapInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_MapInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_MapInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_MapInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_MapInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.MapInstancesBinCompat0$$anon$1", {
  Lcats_instances_MapInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1
});
$c_Lcats_instances_MapInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_MapInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype;
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.product__sci_SortedSet__sci_SortedSet__sci_SortedSet = (function(fa, fb) {
  var orderingA = fa.ordering__s_math_Ordering();
  var orderingB = fb.ordering__s_math_Ordering();
  return $as_sci_SortedSet(fa.flatMap__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((fb$2, orderingA$2, orderingB$2) => ((a) => $as_sci_SortedSet(fb$2.map__F1__s_math_Ordering__sc_SortedSet(new $c_sjsr_AnonFunction1(((a$2) => ((b) => new $c_T2(a$2, b)))(a)), new $c_s_math_Ordering$Tuple2Ordering(orderingA$2, orderingB$2)))))(fb, orderingA, orderingB)), new $c_s_math_Ordering$Tuple2Ordering(orderingA, orderingB)))
});
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__sci_SortedSet__sci_SortedSet__sci_SortedSet($as_sci_SortedSet(fa), $as_sci_SortedSet(fb))
});
var $d_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SortedSetInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.SortedSetInstancesBinCompat0$$anon$1", {
  Lcats_instances_SortedSetInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1
});
$c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1;
function $is_Lcats_kernel_CommutativeSemigroup(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_CommutativeSemigroup)))
}
function $as_Lcats_kernel_CommutativeSemigroup(obj) {
  return (($is_Lcats_kernel_CommutativeSemigroup(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.CommutativeSemigroup"))
}
function $isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_CommutativeSemigroup)))
}
function $asArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) {
  return (($isArrayOf_Lcats_kernel_CommutativeSemigroup(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.CommutativeSemigroup;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Comparison$() {
  this.Lcats_kernel_Comparison$__f_SomeGt = null;
  this.Lcats_kernel_Comparison$__f_SomeEq = null;
  this.Lcats_kernel_Comparison$__f_SomeLt = null;
  this.Lcats_kernel_Comparison$__f_catsKernelEqForComparison = null;
  $n_Lcats_kernel_Comparison$ = this;
  var value = $m_Lcats_kernel_Comparison$GreaterThan$();
  this.Lcats_kernel_Comparison$__f_SomeGt = new $c_s_Some(value);
  var value$1 = $m_Lcats_kernel_Comparison$EqualTo$();
  this.Lcats_kernel_Comparison$__f_SomeEq = new $c_s_Some(value$1);
  var value$2 = $m_Lcats_kernel_Comparison$LessThan$();
  this.Lcats_kernel_Comparison$__f_SomeLt = new $c_s_Some(value$2);
  this.Lcats_kernel_Comparison$__f_catsKernelEqForComparison = new $c_Lcats_kernel_Comparison$$anon$1()
}
$c_Lcats_kernel_Comparison$.prototype = new $h_O();
$c_Lcats_kernel_Comparison$.prototype.constructor = $c_Lcats_kernel_Comparison$;
/** @constructor */
function $h_Lcats_kernel_Comparison$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$.prototype = $c_Lcats_kernel_Comparison$.prototype;
var $d_Lcats_kernel_Comparison$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$: 0
}, false, "cats.kernel.Comparison$", {
  Lcats_kernel_Comparison$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_kernel_Comparison$.prototype.$classData = $d_Lcats_kernel_Comparison$;
var $n_Lcats_kernel_Comparison$;
function $m_Lcats_kernel_Comparison$() {
  if ((!$n_Lcats_kernel_Comparison$)) {
    $n_Lcats_kernel_Comparison$ = new $c_Lcats_kernel_Comparison$()
  };
  return $n_Lcats_kernel_Comparison$
}
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$4(f$4) {
  this.Lcats_kernel_Eq$$anon$4__f_f$1 = null;
  this.Lcats_kernel_Eq$$anon$4__f_f$1 = f$4
}
$c_Lcats_kernel_Eq$$anon$4.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$4.prototype.constructor = $c_Lcats_kernel_Eq$$anon$4;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$4() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$4.prototype = $c_Lcats_kernel_Eq$$anon$4.prototype;
$c_Lcats_kernel_Eq$$anon$4.prototype.eqv__O__O__Z = (function(x, y) {
  return $uZ(this.Lcats_kernel_Eq$$anon$4__f_f$1.apply__O__O__O(x, y))
});
var $d_Lcats_kernel_Eq$$anon$4 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$4: 0
}, false, "cats.kernel.Eq$$anon$4", {
  Lcats_kernel_Eq$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
});
$c_Lcats_kernel_Eq$$anon$4.prototype.$classData = $d_Lcats_kernel_Eq$$anon$4;
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$5() {
  /*<skip>*/
}
$c_Lcats_kernel_Eq$$anon$5.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$5.prototype.constructor = $c_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$5() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$$anon$5.prototype = $c_Lcats_kernel_Eq$$anon$5.prototype;
$c_Lcats_kernel_Eq$$anon$5.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
});
var $d_Lcats_kernel_Eq$$anon$5 = new $TypeData().initClass({
  Lcats_kernel_Eq$$anon$5: 0
}, false, "cats.kernel.Eq$$anon$5", {
  Lcats_kernel_Eq$$anon$5: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
});
$c_Lcats_kernel_Eq$$anon$5.prototype.$classData = $d_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $c_Lcats_kernel_GroupFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_GroupFunctions.prototype = new $h_Lcats_kernel_MonoidFunctions();
$c_Lcats_kernel_GroupFunctions.prototype.constructor = $c_Lcats_kernel_GroupFunctions;
/** @constructor */
function $h_Lcats_kernel_GroupFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_GroupFunctions.prototype = $c_Lcats_kernel_GroupFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_Hash$() {
  /*<skip>*/
}
$c_Lcats_kernel_Hash$.prototype = new $h_Lcats_kernel_HashFunctions();
$c_Lcats_kernel_Hash$.prototype.constructor = $c_Lcats_kernel_Hash$;
/** @constructor */
function $h_Lcats_kernel_Hash$() {
  /*<skip>*/
}
$h_Lcats_kernel_Hash$.prototype = $c_Lcats_kernel_Hash$.prototype;
var $d_Lcats_kernel_Hash$ = new $TypeData().initClass({
  Lcats_kernel_Hash$: 0
}, false, "cats.kernel.Hash$", {
  Lcats_kernel_Hash$: 1,
  Lcats_kernel_HashFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1
});
$c_Lcats_kernel_Hash$.prototype.$classData = $d_Lcats_kernel_Hash$;
var $n_Lcats_kernel_Hash$;
function $m_Lcats_kernel_Hash$() {
  if ((!$n_Lcats_kernel_Hash$)) {
    $n_Lcats_kernel_Hash$ = new $c_Lcats_kernel_Hash$()
  };
  return $n_Lcats_kernel_Hash$
}
function $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O($thiz, as) {
  var this$1 = as.iterator__sc_Iterator();
  var z = $thiz.empty__O();
  var result = z;
  while (this$1.hasNext__Z()) {
    var arg1 = result;
    var arg2 = this$1.next__O();
    result = $thiz.combine__O__O__O(arg1, arg2)
  };
  return result
}
function $is_Lcats_kernel_Monoid(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Monoid)))
}
function $as_Lcats_kernel_Monoid(obj) {
  return (($is_Lcats_kernel_Monoid(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Monoid"))
}
function $isArrayOf_Lcats_kernel_Monoid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Monoid)))
}
function $asArrayOf_Lcats_kernel_Monoid(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Monoid(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Monoid;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Monoid$() {
  /*<skip>*/
}
$c_Lcats_kernel_Monoid$.prototype = new $h_Lcats_kernel_MonoidFunctions();
$c_Lcats_kernel_Monoid$.prototype.constructor = $c_Lcats_kernel_Monoid$;
/** @constructor */
function $h_Lcats_kernel_Monoid$() {
  /*<skip>*/
}
$h_Lcats_kernel_Monoid$.prototype = $c_Lcats_kernel_Monoid$.prototype;
var $d_Lcats_kernel_Monoid$ = new $TypeData().initClass({
  Lcats_kernel_Monoid$: 0
}, false, "cats.kernel.Monoid$", {
  Lcats_kernel_Monoid$: 1,
  Lcats_kernel_MonoidFunctions: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1
});
$c_Lcats_kernel_Monoid$.prototype.$classData = $d_Lcats_kernel_Monoid$;
var $n_Lcats_kernel_Monoid$;
function $m_Lcats_kernel_Monoid$() {
  if ((!$n_Lcats_kernel_Monoid$)) {
    $n_Lcats_kernel_Monoid$ = new $c_Lcats_kernel_Monoid$()
  };
  return $n_Lcats_kernel_Monoid$
}
/** @constructor */
function $c_Lcats_kernel_OrderFunctions() {
  /*<skip>*/
}
$c_Lcats_kernel_OrderFunctions.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_OrderFunctions.prototype.constructor = $c_Lcats_kernel_OrderFunctions;
/** @constructor */
function $h_Lcats_kernel_OrderFunctions() {
  /*<skip>*/
}
$h_Lcats_kernel_OrderFunctions.prototype = $c_Lcats_kernel_OrderFunctions.prototype;
function $f_Lcats_kernel_PartialOrder__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.partialCompare__O__O__D(x, y) === 0.0)
}
function $is_Lcats_kernel_PartialOrder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_PartialOrder)))
}
function $as_Lcats_kernel_PartialOrder(obj) {
  return (($is_Lcats_kernel_PartialOrder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.PartialOrder"))
}
function $isArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_PartialOrder)))
}
function $asArrayOf_Lcats_kernel_PartialOrder(obj, depth) {
  return (($isArrayOf_Lcats_kernel_PartialOrder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.PartialOrder;", depth))
}
/** @constructor */
function $c_Lcats_package$$anon$2() {
  this.Lcats_package$$anon$2__f_F = null;
  $m_Lcats_Invariant$();
  var instance = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  this.Lcats_package$$anon$2__f_F = instance
}
$c_Lcats_package$$anon$2.prototype = new $h_O();
$c_Lcats_package$$anon$2.prototype.constructor = $c_Lcats_package$$anon$2;
/** @constructor */
function $h_Lcats_package$$anon$2() {
  /*<skip>*/
}
$h_Lcats_package$$anon$2.prototype = $c_Lcats_package$$anon$2.prototype;
var $d_Lcats_package$$anon$2 = new $TypeData().initClass({
  Lcats_package$$anon$2: 0
}, false, "cats.package$$anon$2", {
  Lcats_package$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
});
$c_Lcats_package$$anon$2.prototype.$classData = $d_Lcats_package$$anon$2;
/** @constructor */
function $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F$1) {
  this.Lcats_syntax_ApplySyntax$$anon$1__f_self = null;
  this.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance = null;
  this.Lcats_syntax_ApplySyntax$$anon$1__f_self = fa$1;
  this.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance = F$1
}
$c_Lcats_syntax_ApplySyntax$$anon$1.prototype = new $h_O();
$c_Lcats_syntax_ApplySyntax$$anon$1.prototype.constructor = $c_Lcats_syntax_ApplySyntax$$anon$1;
/** @constructor */
function $h_Lcats_syntax_ApplySyntax$$anon$1() {
  /*<skip>*/
}
$h_Lcats_syntax_ApplySyntax$$anon$1.prototype = $c_Lcats_syntax_ApplySyntax$$anon$1.prototype;
var $d_Lcats_syntax_ApplySyntax$$anon$1 = new $TypeData().initClass({
  Lcats_syntax_ApplySyntax$$anon$1: 0
}, false, "cats.syntax.ApplySyntax$$anon$1", {
  Lcats_syntax_ApplySyntax$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Apply$Ops: 1
});
$c_Lcats_syntax_ApplySyntax$$anon$1.prototype.$classData = $d_Lcats_syntax_ApplySyntax$$anon$1;
function $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList($thiz, throwable) {
  if ((throwable instanceof $c_Lfs2_CompositeFailure)) {
    var cf = $as_Lfs2_CompositeFailure(throwable);
    var this$1 = cf.Lfs2_CompositeFailure__f_tail;
    var a = cf.Lfs2_CompositeFailure__f_head;
    return this$1.prepend__O__Lcats_data_NonEmptyList(a)
  } else {
    $m_Lcats_data_NonEmptyList$();
    $m_Lcats_data_NonEmptyList$();
    var tail = $m_s_package$().s_package$__f_Nil;
    return new $c_Lcats_data_NonEmptyList(throwable, tail)
  }
}
/** @constructor */
function $c_Lfs2_CompositeFailure$() {
  /*<skip>*/
}
$c_Lfs2_CompositeFailure$.prototype = new $h_O();
$c_Lfs2_CompositeFailure$.prototype.constructor = $c_Lfs2_CompositeFailure$;
/** @constructor */
function $h_Lfs2_CompositeFailure$() {
  /*<skip>*/
}
$h_Lfs2_CompositeFailure$.prototype = $c_Lfs2_CompositeFailure$.prototype;
$c_Lfs2_CompositeFailure$.prototype.toString__T = (function() {
  return "CompositeFailure"
});
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure = (function(first, second, rest) {
  return this.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure(first, ($m_Lcats_data_NonEmptyList$(), new $c_Lcats_data_NonEmptyList(second, rest)))
});
$c_Lfs2_CompositeFailure$.prototype.apply__jl_Throwable__Lcats_data_NonEmptyList__Lfs2_CompositeFailure = (function(first, rest) {
  if ((first instanceof $c_Lfs2_CompositeFailure)) {
    var cf = $as_Lfs2_CompositeFailure(first);
    var f = ((this$1) => ((throwable) => {
      var throwable$1 = $as_jl_Throwable(throwable);
      return $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this$1, throwable$1)
    }))(this);
    var arg1 = rest.Lcats_data_NonEmptyList__f_head;
    var this$6 = $as_Lcats_data_NonEmptyList(f(arg1));
    var this$2 = rest.Lcats_data_NonEmptyList__f_tail;
    var rest$1 = this$2;
    var h = null;
    var t = null;
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$1 = rest$1.head__O();
      var this$3 = $as_Lcats_data_NonEmptyList(f(arg1$1));
      var this$4 = this$3.Lcats_data_NonEmptyList__f_tail;
      var elem = this$3.Lcats_data_NonEmptyList__f_head;
      var this$5 = new $c_sci_$colon$colon(elem, this$4);
      var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$5);
      while (it.hasNext__Z()) {
        var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx
        } else {
          t.sci_$colon$colon__f_next = nx
        };
        t = nx
      };
      rest$1 = $as_sci_List(rest$1.tail__O())
    };
    var l = ((h === null) ? $m_sci_Nil$() : h);
    var this$7 = this$6.concat__sci_List__Lcats_data_NonEmptyList(l);
    var other = cf.Lfs2_CompositeFailure__f_tail;
    var tail = other.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(this$7);
    return new $c_Lfs2_CompositeFailure(cf.Lfs2_CompositeFailure__f_head, tail)
  } else {
    var f$1 = ((this$2$1) => ((throwable$2) => {
      var throwable$3 = $as_jl_Throwable(throwable$2);
      return $p_Lfs2_CompositeFailure$__flattenExceptions$1__jl_Throwable__Lcats_data_NonEmptyList(this$2$1, throwable$3)
    }))(this);
    var arg1$2 = rest.Lcats_data_NonEmptyList__f_head;
    var this$12 = $as_Lcats_data_NonEmptyList(f$1(arg1$2));
    var this$8 = rest.Lcats_data_NonEmptyList__f_tail;
    var rest$2 = this$8;
    var h$1 = null;
    var t$1 = null;
    while ((rest$2 !== $m_sci_Nil$())) {
      var arg1$3 = rest$2.head__O();
      var this$9 = $as_Lcats_data_NonEmptyList(f$1(arg1$3));
      var this$10 = this$9.Lcats_data_NonEmptyList__f_tail;
      var elem$1 = this$9.Lcats_data_NonEmptyList__f_head;
      var this$11 = new $c_sci_$colon$colon(elem$1, this$10);
      var it$1 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$11);
      while (it$1.hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon(it$1.next__O(), $m_sci_Nil$());
        if ((t$1 === null)) {
          h$1 = nx$1
        } else {
          t$1.sci_$colon$colon__f_next = nx$1
        };
        t$1 = nx$1
      };
      rest$2 = $as_sci_List(rest$2.tail__O())
    };
    var l$1 = ((h$1 === null) ? $m_sci_Nil$() : h$1);
    return new $c_Lfs2_CompositeFailure(first, this$12.concat__sci_List__Lcats_data_NonEmptyList(l$1))
  }
});
$c_Lfs2_CompositeFailure$.prototype.fromList__sci_List__s_Option = (function(errors) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (errors === null) : x.equals__O__Z(errors))) {
    return $m_s_None$()
  };
  if ((errors instanceof $c_sci_$colon$colon)) {
    var x26 = $as_sci_$colon$colon(errors);
    var x27 = $as_jl_Throwable(x26.sci_$colon$colon__f_head);
    var x28 = x26.sci_$colon$colon__f_next;
    var x$3 = $m_s_package$().s_package$__f_Nil;
    if (((x$3 === null) ? (x28 === null) : x$3.equals__O__Z(x28))) {
      return new $c_s_Some(x27)
    };
    if ((x28 instanceof $c_sci_$colon$colon)) {
      var x23 = $as_sci_$colon$colon(x28);
      var x25 = x23.sci_$colon$colon__f_next;
      var second = $as_jl_Throwable(x23.sci_$colon$colon__f_head);
      var value = this.apply__jl_Throwable__jl_Throwable__sci_List__Lfs2_CompositeFailure(x27, second, x25);
      return new $c_s_Some(value)
    }
  };
  throw new $c_s_MatchError(errors)
});
var $d_Lfs2_CompositeFailure$ = new $TypeData().initClass({
  Lfs2_CompositeFailure$: 0
}, false, "fs2.CompositeFailure$", {
  Lfs2_CompositeFailure$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lfs2_CompositeFailure$.prototype.$classData = $d_Lfs2_CompositeFailure$;
var $n_Lfs2_CompositeFailure$;
function $m_Lfs2_CompositeFailure$() {
  if ((!$n_Lfs2_CompositeFailure$)) {
    $n_Lfs2_CompositeFailure$ = new $c_Lfs2_CompositeFailure$()
  };
  return $n_Lfs2_CompositeFailure$
}
/** @constructor */
function $c_Lfs2_Pull$$anon$10(evidence$3$2) {
  this.Lfs2_Pull$$anon$10__f_evidence$3$1 = null;
  this.Lfs2_Pull$$anon$10__f_evidence$3$1 = evidence$3$2
}
$c_Lfs2_Pull$$anon$10.prototype = new $h_O();
$c_Lfs2_Pull$$anon$10.prototype.constructor = $c_Lfs2_Pull$$anon$10;
/** @constructor */
function $h_Lfs2_Pull$$anon$10() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$10.prototype = $c_Lfs2_Pull$$anon$10.prototype;
$c_Lfs2_Pull$$anon$10.prototype.apply__O__O = (function(a) {
  var F = this.Lfs2_Pull$$anon$10__f_evidence$3$1;
  return F.pure__O__O(a)
});
var $d_Lfs2_Pull$$anon$10 = new $TypeData().initClass({
  Lfs2_Pull$$anon$10: 0
}, false, "fs2.Pull$$anon$10", {
  Lfs2_Pull$$anon$10: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
});
$c_Lfs2_Pull$$anon$10.prototype.$classData = $d_Lfs2_Pull$$anon$10;
/** @constructor */
function $c_Lfs2_Pull$Action() {
  /*<skip>*/
}
$c_Lfs2_Pull$Action.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Action.prototype.constructor = $c_Lfs2_Pull$Action;
/** @constructor */
function $h_Lfs2_Pull$Action() {
  /*<skip>*/
}
$h_Lfs2_Pull$Action.prototype = $c_Lfs2_Pull$Action.prototype;
function $as_Lfs2_Pull$Action(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Action) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Action"))
}
function $isArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Action)))
}
function $asArrayOf_Lfs2_Pull$Action(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Action(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Action;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$IdContP$() {
  /*<skip>*/
}
$c_Lfs2_Pull$IdContP$.prototype = new $h_O();
$c_Lfs2_Pull$IdContP$.prototype.constructor = $c_Lfs2_Pull$IdContP$;
/** @constructor */
function $h_Lfs2_Pull$IdContP$() {
  /*<skip>*/
}
$h_Lfs2_Pull$IdContP$.prototype = $c_Lfs2_Pull$IdContP$.prototype;
$c_Lfs2_Pull$IdContP$.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lfs2_Pull$IdContP$.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lfs2_Pull$IdContP$.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return r
});
$c_Lfs2_Pull$IdContP$.prototype.apply__O__O = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return r
});
var $d_Lfs2_Pull$IdContP$ = new $TypeData().initClass({
  Lfs2_Pull$IdContP$: 0
}, false, "fs2.Pull$IdContP$", {
  Lfs2_Pull$IdContP$: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$IdContP$.prototype.$classData = $d_Lfs2_Pull$IdContP$;
var $n_Lfs2_Pull$IdContP$;
function $m_Lfs2_Pull$IdContP$() {
  if ((!$n_Lfs2_Pull$IdContP$)) {
    $n_Lfs2_Pull$IdContP$ = new $c_Lfs2_Pull$IdContP$()
  };
  return $n_Lfs2_Pull$IdContP$
}
/** @constructor */
function $c_Lfs2_Pull$StepLegRunR$1(extendLastTopLevelScope$39, F$53, contP$42, scope$38, extendedTopLevelScope$36, TheBuildR$lzy1$42, translation$tailLocal1$39, runner$tailLocal1$36, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_F$18 = null;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = false;
  this.Lfs2_Pull$StepLegRunR$1__f_F$20 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = null;
  this.Lfs2_Pull$StepLegRunR$1__f_view = null;
  this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10 = extendLastTopLevelScope$39;
  this.Lfs2_Pull$StepLegRunR$1__f_F$20 = F$53;
  this.Lfs2_Pull$StepLegRunR$1__f_contP$12 = contP$42;
  this.Lfs2_Pull$StepLegRunR$1__f_scope$11 = scope$38;
  this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9 = extendedTopLevelScope$36;
  this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12 = TheBuildR$lzy1$42;
  this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9 = translation$tailLocal1$39;
  this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9 = runner$tailLocal1$36;
  this.Lfs2_Pull$StepLegRunR$1__f_view = view;
  $ct_Lfs2_Pull$StepRunR$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__F1__(this, extendLastTopLevelScope$39, F$53, contP$42, scope$38, extendedTopLevelScope$36, TheBuildR$lzy1$42, translation$tailLocal1$39, runner$tailLocal1$36, view)
}
$c_Lfs2_Pull$StepLegRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$StepLegRunR$1.prototype.constructor = $c_Lfs2_Pull$StepLegRunR$1;
/** @constructor */
function $h_Lfs2_Pull$StepLegRunR$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$StepLegRunR$1.prototype = $c_Lfs2_Pull$StepLegRunR$1.prototype;
$c_Lfs2_Pull$StepLegRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this.Lfs2_Pull$StepLegRunR$1__f_F$20, this.Lfs2_Pull$StepLegRunR$1__f_contP$12, this.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, this.Lfs2_Pull$StepLegRunR$1__f_scope$11, this.Lfs2_Pull$StepLegRunR$1__f_view, new $c_sjsr_AnonFunction0(((this$1, head$2, outScope$2, tail$2) => (() => {
    var value = new $c_Lfs2_Stream$StepLeg(head$2, outScope$2.Lfs2_internal_Scope__f_id, tail$2);
    var r = new $c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this$1.Lfs2_Pull$StepLegRunR$1__f_extendLastTopLevelScope$10, this$1.Lfs2_Pull$StepLegRunR$1__f_F$20, this$1.Lfs2_Pull$StepLegRunR$1__f_contP$12, this$1.Lfs2_Pull$StepLegRunR$1__f_TheBuildR$lzy1$12, this$1.Lfs2_Pull$StepLegRunR$1__f_scope$11, this$1.Lfs2_Pull$StepLegRunR$1__f_extendedTopLevelScope$9, this$1.Lfs2_Pull$StepLegRunR$1__f_translation$tailLocal1$9, this$1.Lfs2_Pull$StepLegRunR$1__f_runner$tailLocal1$9, $as_Lfs2_Pull(this$1.Lfs2_Pull$StepLegRunR$1__f_view.apply__O__O(result)))
  }))(this, head, outScope, tail)))
});
var $d_Lfs2_Pull$StepLegRunR$1 = new $TypeData().initClass({
  Lfs2_Pull$StepLegRunR$1: 0
}, false, "fs2.Pull$StepLegRunR$1", {
  Lfs2_Pull$StepLegRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$StepLegRunR$1.prototype.$classData = $d_Lfs2_Pull$StepLegRunR$1;
/** @constructor */
function $c_Lfs2_Pull$Terminal() {
  /*<skip>*/
}
$c_Lfs2_Pull$Terminal.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Terminal.prototype.constructor = $c_Lfs2_Pull$Terminal;
/** @constructor */
function $h_Lfs2_Pull$Terminal() {
  /*<skip>*/
}
$h_Lfs2_Pull$Terminal.prototype = $c_Lfs2_Pull$Terminal.prototype;
function $as_Lfs2_Pull$Terminal(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Terminal) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Terminal"))
}
function $isArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Terminal)))
}
function $asArrayOf_Lfs2_Pull$Terminal(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Terminal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Terminal;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$UnconsRunR$1(extendLastTopLevelScope$38, F$52, contP$41, scope$37, extendedTopLevelScope$35, TheBuildR$lzy1$41, translation$tailLocal1$38, runner$tailLocal1$35, view) {
  this.Lfs2_Pull$StepRunR$1__f_extendLastTopLevelScope$8 = false;
  this.Lfs2_Pull$StepRunR$1__f_F$18 = null;
  this.Lfs2_Pull$StepRunR$1__f_contP$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_scope$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_extendedTopLevelScope$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_TheBuildR$lzy1$10 = null;
  this.Lfs2_Pull$StepRunR$1__f_translation$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_runner$tailLocal1$7 = null;
  this.Lfs2_Pull$StepRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = false;
  this.Lfs2_Pull$UnconsRunR$1__f_F$19 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = null;
  this.Lfs2_Pull$UnconsRunR$1__f_view = null;
  this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9 = extendLastTopLevelScope$38;
  this.Lfs2_Pull$UnconsRunR$1__f_F$19 = F$52;
  this.Lfs2_Pull$UnconsRunR$1__f_contP$11 = contP$41;
  this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8 = extendedTopLevelScope$35;
  this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11 = TheBuildR$lzy1$41;
  this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8 = translation$tailLocal1$38;
  this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8 = runner$tailLocal1$35;
  this.Lfs2_Pull$UnconsRunR$1__f_view = view;
  $ct_Lfs2_Pull$StepRunR$1__Z__Lcats_MonadError__sr_ObjectRef__Lfs2_internal_Scope__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__F1__(this, extendLastTopLevelScope$38, F$52, contP$41, scope$37, extendedTopLevelScope$35, TheBuildR$lzy1$41, translation$tailLocal1$38, runner$tailLocal1$35, view)
}
$c_Lfs2_Pull$UnconsRunR$1.prototype = new $h_Lfs2_Pull$StepRunR$1();
$c_Lfs2_Pull$UnconsRunR$1.prototype.constructor = $c_Lfs2_Pull$UnconsRunR$1;
/** @constructor */
function $h_Lfs2_Pull$UnconsRunR$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$UnconsRunR$1.prototype = $c_Lfs2_Pull$UnconsRunR$1.prototype;
$c_Lfs2_Pull$UnconsRunR$1.prototype.out__Lfs2_Chunk__Lfs2_internal_Scope__Lfs2_Pull__O = (function(head, outScope, tail) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$interruptGuard$1__Z__Lcats_MonadError__sr_ObjectRef__s_Option__sr_LazyRef__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_internal_Scope__F1__F0__O(this.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this.Lfs2_Pull$UnconsRunR$1__f_F$19, this.Lfs2_Pull$UnconsRunR$1__f_contP$11, this.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, this.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, outScope, this.Lfs2_Pull$UnconsRunR$1__f_view, new $c_sjsr_AnonFunction0(((this$1, head$2, outScope$2, tail$2) => (() => {
    var value = new $c_T2(head$2, tail$2);
    var r = new $c_s_Some(value);
    var result = new $c_Lfs2_Pull$Succeeded(r);
    return $m_Lfs2_Pull$().fs2$Pull$$$_$go$1__Z__Lcats_MonadError__sr_ObjectRef__sr_LazyRef__Lfs2_internal_Scope__s_Option__Lcats_arrow_FunctionK__Lfs2_Pull$Run$1__Lfs2_Pull__O(this$1.Lfs2_Pull$UnconsRunR$1__f_extendLastTopLevelScope$9, this$1.Lfs2_Pull$UnconsRunR$1__f_F$19, this$1.Lfs2_Pull$UnconsRunR$1__f_contP$11, this$1.Lfs2_Pull$UnconsRunR$1__f_TheBuildR$lzy1$11, outScope$2, this$1.Lfs2_Pull$UnconsRunR$1__f_extendedTopLevelScope$8, this$1.Lfs2_Pull$UnconsRunR$1__f_translation$tailLocal1$8, this$1.Lfs2_Pull$UnconsRunR$1__f_runner$tailLocal1$8, $as_Lfs2_Pull(this$1.Lfs2_Pull$UnconsRunR$1__f_view.apply__O__O(result)))
  }))(this, head, outScope, tail)))
});
var $d_Lfs2_Pull$UnconsRunR$1 = new $TypeData().initClass({
  Lfs2_Pull$UnconsRunR$1: 0
}, false, "fs2.Pull$UnconsRunR$1", {
  Lfs2_Pull$UnconsRunR$1: 1,
  Lfs2_Pull$StepRunR$1: 1,
  O: 1,
  Lfs2_Pull$Run$1: 1
});
$c_Lfs2_Pull$UnconsRunR$1.prototype.$classData = $d_Lfs2_Pull$UnconsRunR$1;
/** @constructor */
function $c_Lfs2_concurrent_Channel$State$3$() {
  /*<skip>*/
}
$c_Lfs2_concurrent_Channel$State$3$.prototype = new $h_O();
$c_Lfs2_concurrent_Channel$State$3$.prototype.constructor = $c_Lfs2_concurrent_Channel$State$3$;
/** @constructor */
function $h_Lfs2_concurrent_Channel$State$3$() {
  /*<skip>*/
}
$h_Lfs2_concurrent_Channel$State$3$.prototype = $c_Lfs2_concurrent_Channel$State$3$.prototype;
$c_Lfs2_concurrent_Channel$State$3$.prototype.toString__T = (function() {
  return "State"
});
function $as_Lfs2_concurrent_Channel$State$3$(obj) {
  return (((obj instanceof $c_Lfs2_concurrent_Channel$State$3$) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.concurrent.Channel$State$3$"))
}
function $isArrayOf_Lfs2_concurrent_Channel$State$3$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_concurrent_Channel$State$3$)))
}
function $asArrayOf_Lfs2_concurrent_Channel$State$3$(obj, depth) {
  return (($isArrayOf_Lfs2_concurrent_Channel$State$3$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.concurrent.Channel$State$3$;", depth))
}
var $d_Lfs2_concurrent_Channel$State$3$ = new $TypeData().initClass({
  Lfs2_concurrent_Channel$State$3$: 0
}, false, "fs2.concurrent.Channel$State$3$", {
  Lfs2_concurrent_Channel$State$3$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lfs2_concurrent_Channel$State$3$.prototype.$classData = $d_Lfs2_concurrent_Channel$State$3$;
/** @constructor */
function $c_Lfs2_internal_Scope$State$() {
  this.Lfs2_internal_Scope$State$__f_initial_ = null;
  this.Lfs2_internal_Scope$State$__f_closed_ = null;
  $n_Lfs2_internal_Scope$State$ = this;
  var this$1 = $m_Lcats_data_Chain$();
  var resources = this$1.Lcats_data_Chain$__f_nil;
  var this$2 = $m_Lcats_data_Chain$();
  var children = this$2.Lcats_data_Chain$__f_nil;
  this.Lfs2_internal_Scope$State$__f_initial_ = new $c_Lfs2_internal_Scope$State$Open(resources, children);
  this.Lfs2_internal_Scope$State$__f_closed_ = new $c_Lfs2_internal_Scope$State$Closed()
}
$c_Lfs2_internal_Scope$State$.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$.prototype.constructor = $c_Lfs2_internal_Scope$State$;
/** @constructor */
function $h_Lfs2_internal_Scope$State$() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope$State$.prototype = $c_Lfs2_internal_Scope$State$.prototype;
var $d_Lfs2_internal_Scope$State$ = new $TypeData().initClass({
  Lfs2_internal_Scope$State$: 0
}, false, "fs2.internal.Scope$State$", {
  Lfs2_internal_Scope$State$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lfs2_internal_Scope$State$.prototype.$classData = $d_Lfs2_internal_Scope$State$;
var $n_Lfs2_internal_Scope$State$;
function $m_Lfs2_internal_Scope$State$() {
  if ((!$n_Lfs2_internal_Scope$State$)) {
    $n_Lfs2_internal_Scope$State$ = new $c_Lfs2_internal_Scope$State$()
  };
  return $n_Lfs2_internal_Scope$State$
}
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz
}
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
  /*<skip>*/
}
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this)
});
$c_jl_Enum.prototype.compareTo__jl_Enum__I = (function(o) {
  var x = this.jl_Enum__f__ordinal;
  var y = o.jl_Enum__f__ordinal;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1))
});
$c_jl_Enum.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__jl_Enum__I($as_jl_Enum(o))
});
function $as_jl_Enum(obj) {
  return (((obj instanceof $c_jl_Enum) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Enum"))
}
function $isArrayOf_jl_Enum(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Enum)))
}
function $asArrayOf_jl_Enum(obj, depth) {
  return (($isArrayOf_jl_Enum(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Enum;", depth))
}
class $c_jl_Error extends $c_jl_Throwable {
}
function $as_jl_Error(obj) {
  return (((obj instanceof $c_jl_Error) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Error"))
}
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Error)))
}
function $asArrayOf_jl_Error(obj, depth) {
  return (($isArrayOf_jl_Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Error;", depth))
}
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_Exception extends $c_jl_Throwable {
}
var $d_jl_Exception = new $TypeData().initClass({
  jl_Exception: 0
}, false, "java.lang.Exception", {
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_Exception.prototype.$classData = $d_jl_Exception;
function $ct_Ljava_nio_ByteBuffer__I__AB__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_ByteBuffer__f__array = _array;
  $thiz.Ljava_nio_ByteBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  $thiz.Ljava_nio_ByteBuffer__f__isBigEndian = true;
  return $thiz
}
/** @constructor */
function $c_Ljava_nio_ByteBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = false
}
$c_Ljava_nio_ByteBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_ByteBuffer.prototype.constructor = $c_Ljava_nio_ByteBuffer;
/** @constructor */
function $h_Ljava_nio_ByteBuffer() {
  /*<skip>*/
}
$h_Ljava_nio_ByteBuffer.prototype = $c_Ljava_nio_ByteBuffer.prototype;
$c_Ljava_nio_ByteBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-547316498);
  var i = start;
  while ((i !== end)) {
    var $$x2 = $m_s_util_hashing_MurmurHash3$();
    var $$x1 = h;
    var index = i;
    var x = this.Ljava_nio_ByteBuffer__f__array.get(((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0));
    h = $$x2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0)
  };
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0))
});
$c_Ljava_nio_ByteBuffer.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Ljava_nio_ByteBuffer)) {
    var x2 = $as_Ljava_nio_ByteBuffer(that);
    return (this.compareTo__Ljava_nio_ByteBuffer__I(x2) === 0)
  } else {
    return false
  }
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__Ljava_nio_ByteBuffer__I = (function(that) {
  if ((this === that)) {
    return 0
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var thatStart = that.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thatRemaining = ((that.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var arg1 = this.Ljava_nio_ByteBuffer__f__array.get(((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0));
      var index$1 = ((thatStart + i) | 0);
      var arg2 = that.Ljava_nio_ByteBuffer__f__array.get(((that.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0));
      var cmp = ((arg1 - arg2) | 0);
      if ((cmp !== 0)) {
        return cmp
      };
      i = ((1 + i) | 0)
    };
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1))
  }
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__O__I = (function(x$1) {
  return this.compareTo__Ljava_nio_ByteBuffer__I($as_Ljava_nio_ByteBuffer(x$1))
});
function $as_Ljava_nio_ByteBuffer(obj) {
  return (((obj instanceof $c_Ljava_nio_ByteBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "java.nio.ByteBuffer"))
}
function $isArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_ByteBuffer)))
}
function $asArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (($isArrayOf_Ljava_nio_ByteBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.nio.ByteBuffer;", depth))
}
/** @constructor */
function $c_ju_AbstractCollection() {
  /*<skip>*/
}
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
  /*<skip>*/
}
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.iterator__ju_Iterator();
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = _\uff3fself.next__O();
    if (((o === null) ? (arg1 === null) : $dp_equals__O__Z(o, arg1))) {
      return true
    }
  };
  return false
});
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  _return: {
    while (_\uff3fself.hasNext__Z()) {
      var arg1 = _\uff3fself.next__O();
      if ((!this.contains__O__Z(arg1))) {
        var $$x1 = true;
        break _return
      }
    };
    var $$x1 = false
  };
  return (!$$x1)
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while (_\uff3fself.hasNext__Z()) {
    if (first) {
      first = false
    } else {
      result = (result + ", ")
    };
    result = (("" + result) + _\uff3fself.next__O())
  };
  return (result + "]")
});
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer)
}
$c_ju_HashMap$NodeIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$NodeIterator.prototype.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_HashMap$NodeIterator.prototype = $c_ju_HashMap$NodeIterator.prototype;
var $d_ju_HashMap$NodeIterator = new $TypeData().initClass({
  ju_HashMap$NodeIterator: 0
}, false, "java.util.HashMap$NodeIterator", {
  ju_HashMap$NodeIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_HashMap$NodeIterator.prototype.$classData = $d_ju_HashMap$NodeIterator;
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_List)))
}
function $as_ju_List(obj) {
  return (($is_ju_List(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.List"))
}
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_List)))
}
function $asArrayOf_ju_List(obj, depth) {
  return (($isArrayOf_ju_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.List;", depth))
}
/** @constructor */
function $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next)
}
$c_ju_NullRejectingHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_NullRejectingHashMap$Node.prototype.constructor = $c_ju_NullRejectingHashMap$Node;
/** @constructor */
function $h_ju_NullRejectingHashMap$Node() {
  /*<skip>*/
}
$h_ju_NullRejectingHashMap$Node.prototype = $c_ju_NullRejectingHashMap$Node.prototype;
var $d_ju_NullRejectingHashMap$Node = new $TypeData().initClass({
  ju_NullRejectingHashMap$Node: 0
}, false, "java.util.NullRejectingHashMap$Node", {
  ju_NullRejectingHashMap$Node: 1,
  ju_HashMap$Node: 1,
  O: 1,
  ju_Map$Entry: 1
});
$c_ju_NullRejectingHashMap$Node.prototype.$classData = $d_ju_NullRejectingHashMap$Node;
function $as_ju_UUID(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.UUID"))
}
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_UUID)))
}
function $asArrayOf_ju_UUID(obj, depth) {
  return (($isArrayOf_ju_UUID(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.UUID;", depth))
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer)
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 0
}, false, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$NodeIterator", {
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer)
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node.ju_HashMap$Node__f_value
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator: 0
}, false, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$ValueIterator", {
  ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  O: 1,
  ju_Iterator: 1
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator;
/** @constructor */
function $c_ju_concurrent_ThreadLocalRandom() {
  this.ju_Random__f_seedHi = 0;
  this.ju_Random__f_seedLo = 0;
  this.ju_Random__f_nextNextGaussian = 0.0;
  this.ju_Random__f_haveNextNextGaussian = false;
  this.ju_concurrent_ThreadLocalRandom__f_initialized = false;
  $ct_ju_Random__J__(this, $m_ju_Random$().java$util$Random$$randomSeed__J());
  this.ju_concurrent_ThreadLocalRandom__f_initialized = true
}
$c_ju_concurrent_ThreadLocalRandom.prototype = new $h_ju_Random();
$c_ju_concurrent_ThreadLocalRandom.prototype.constructor = $c_ju_concurrent_ThreadLocalRandom;
/** @constructor */
function $h_ju_concurrent_ThreadLocalRandom() {
  /*<skip>*/
}
$h_ju_concurrent_ThreadLocalRandom.prototype = $c_ju_concurrent_ThreadLocalRandom.prototype;
$c_ju_concurrent_ThreadLocalRandom.prototype.setSeed__J__V = (function(seed) {
  if (this.ju_concurrent_ThreadLocalRandom__f_initialized) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  $c_ju_Random.prototype.setSeed__J__V.call(this, seed)
});
var $d_ju_concurrent_ThreadLocalRandom = new $TypeData().initClass({
  ju_concurrent_ThreadLocalRandom: 0
}, false, "java.util.concurrent.ThreadLocalRandom", {
  ju_concurrent_ThreadLocalRandom: 1,
  ju_Random: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ThreadLocalRandom.prototype.$classData = $d_ju_concurrent_ThreadLocalRandom;
function $ct_ju_concurrent_atomic_AtomicInteger__I__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = value;
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_atomic_AtomicInteger() {
  this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = 0
}
$c_ju_concurrent_atomic_AtomicInteger.prototype = new $h_jl_Number();
$c_ju_concurrent_atomic_AtomicInteger.prototype.constructor = $c_ju_concurrent_atomic_AtomicInteger;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicInteger() {
  /*<skip>*/
}
$h_ju_concurrent_atomic_AtomicInteger.prototype = $c_ju_concurrent_atomic_AtomicInteger.prototype;
$c_ju_concurrent_atomic_AtomicInteger.prototype.compareAndSet__I__I__Z = (function(expect, update) {
  if ((expect === this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value)) {
    this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = update;
    return true
  } else {
    return false
  }
});
$c_ju_concurrent_atomic_AtomicInteger.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value;
  return ("" + this$1)
});
function $s_Lnet_andimiller_Msg$__AddOneHundred__Lnet_andimiller_Msg() {
  $m_Lnet_andimiller_Msg$();
  return $t_Lnet_andimiller_Msg$__AddOneHundred
}
function $s_Lnet_andimiller_Msg$__Clear__Lnet_andimiller_Msg() {
  $m_Lnet_andimiller_Msg$();
  return $t_Lnet_andimiller_Msg$__Clear
}
function $s_Lnet_andimiller_Msg$__EnterInput__Lnet_andimiller_Msg() {
  $m_Lnet_andimiller_Msg$();
  return $t_Lnet_andimiller_Msg$__EnterInput
}
function $s_Lnet_andimiller_Msg$__NoOp__Lnet_andimiller_Msg() {
  $m_Lnet_andimiller_Msg$();
  return $t_Lnet_andimiller_Msg$__NoOp
}
/** @constructor */
function $c_Lnet_andimiller_Msg$() {
  $n_Lnet_andimiller_Msg$ = this;
  $t_Lnet_andimiller_Msg$__AddOneHundred = new $c_Lnet_andimiller_Msg$$anon$1(2, "AddOneHundred");
  $t_Lnet_andimiller_Msg$__Clear = new $c_Lnet_andimiller_Msg$$anon$1(3, "Clear");
  $t_Lnet_andimiller_Msg$__EnterInput = new $c_Lnet_andimiller_Msg$$anon$1(4, "EnterInput");
  $t_Lnet_andimiller_Msg$__NoOp = new $c_Lnet_andimiller_Msg$$anon$1(5, "NoOp")
}
$c_Lnet_andimiller_Msg$.prototype = new $h_O();
$c_Lnet_andimiller_Msg$.prototype.constructor = $c_Lnet_andimiller_Msg$;
/** @constructor */
function $h_Lnet_andimiller_Msg$() {
  /*<skip>*/
}
$h_Lnet_andimiller_Msg$.prototype = $c_Lnet_andimiller_Msg$.prototype;
var $d_Lnet_andimiller_Msg$ = new $TypeData().initClass({
  Lnet_andimiller_Msg$: 0
}, false, "net.andimiller.Msg$", {
  Lnet_andimiller_Msg$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lnet_andimiller_Msg$.prototype.$classData = $d_Lnet_andimiller_Msg$;
var $n_Lnet_andimiller_Msg$;
function $m_Lnet_andimiller_Msg$() {
  if ((!$n_Lnet_andimiller_Msg$)) {
    $n_Lnet_andimiller_Msg$ = new $c_Lnet_andimiller_Msg$()
  };
  return $n_Lnet_andimiller_Msg$
}
function $p_Lnet_andimiller_ProbabilisticPlayground$__hashToTheta__J__D($thiz, hash) {
  return ((($m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(hash.RTLong__f_lo, hash.RTLong__f_hi) / 9.223372036854776E18) / 2.0) + 0.5)
}
/** @constructor */
function $c_Lnet_andimiller_ProbabilisticPlayground$() {
  this.Lnet_andimiller_ProbabilisticPlayground$__f_tyrian$TyrianAppF$$evidence$1 = null;
  this.Lnet_andimiller_ProbabilisticPlayground$__f_run = null;
  $n_Lnet_andimiller_ProbabilisticPlayground$ = this;
  this.Lnet_andimiller_ProbabilisticPlayground$__f_tyrian$TyrianAppF$$evidence$1 = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO;
  $f_Ltyrian_TyrianApp__$init$__V(this)
}
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype = new $h_O();
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.constructor = $c_Lnet_andimiller_ProbabilisticPlayground$;
/** @constructor */
function $h_Lnet_andimiller_ProbabilisticPlayground$() {
  /*<skip>*/
}
$h_Lnet_andimiller_ProbabilisticPlayground$.prototype = $c_Lnet_andimiller_ProbabilisticPlayground$.prototype;
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.$js$exported$meth$launch__T__O = (function(containerId) {
  $f_Ltyrian_TyrianAppF__launch__T__V(this, containerId)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.$js$exported$meth$launch__T__sjs_js_Dictionary__O = (function(containerId, flags) {
  $f_Ltyrian_TyrianAppF__launch__T__sjs_js_Dictionary__V(this, containerId, flags)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.init__sci_Map__T2 = (function(flags) {
  $m_s_package$();
  var rows = $m_sci_Nil$();
  var _1 = new $c_Lnet_andimiller_Model("", 10, rows);
  var _2 = $m_Ltyrian_Cmd$None$();
  return new $c_T2(_1, _2)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.hash__T__J = (function(s) {
  var $$x2 = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(8);
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var $$x1 = $$x2.putInt__I__Ljava_nio_ByteBuffer(this$1.stringHash__T__I__I(s, (-137723950)));
  var this$3 = $m_s_util_hashing_MurmurHash3$();
  var x = $m_sc_StringOps$().reverse$extension__T__T(s);
  return $$x1.putInt__I__Ljava_nio_ByteBuffer(this$3.stringHash__T__I__I(x, (-137723950))).getLong__I__J(0)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.enterInput__Lnet_andimiller_Model__Lnet_andimiller_Model = (function(model) {
  var t = this.hash__T__J(model.Lnet_andimiller_Model__f_input);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = model.Lnet_andimiller_Model__f_rows;
  var f = ((_$1) => {
    var _$1$1 = $as_Lnet_andimiller_Row(_$1);
    return _$1$1.Lnet_andimiller_Row__f_hash
  });
  if ((this$2 === $m_sci_Nil$())) {
    var $$x1 = $m_sci_Nil$()
  } else {
    var arg1 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t$1 = h;
    var rest = $as_sci_List(this$2.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var $$x1 = h
  };
  if ($$x1.contains__O__Z(new $c_RTLong(lo, hi))) {
    var rows = model.Lnet_andimiller_Model__f_rows
  } else {
    var input = model.Lnet_andimiller_Model__f_input;
    var t$2 = this.hash__T__J(model.Lnet_andimiller_Model__f_input);
    var lo$1 = t$2.RTLong__f_lo;
    var hi$1 = t$2.RTLong__f_hi;
    var theta = $p_Lnet_andimiller_ProbabilisticPlayground$__hashToTheta__J__D(this, this.hash__T__J(model.Lnet_andimiller_Model__f_input));
    var elem$1 = new $c_Lnet_andimiller_Row(input, new $c_RTLong(lo$1, hi$1), theta, true);
    var this$4 = model.Lnet_andimiller_Model__f_rows;
    var rows = new $c_sci_$colon$colon(elem$1, this$4)
  };
  var f$1 = new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Lnet_andimiller_Row(_$2);
    return _$2$1.Lnet_andimiller_Row__f_theta
  }));
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var this$5 = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(rows, f$1, ord)).take__I__sci_List(model.Lnet_andimiller_Model__f_topK);
  var keepMe = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$5);
  var f$2 = ((keepMe$2) => ((row) => {
    var row$1 = $as_Lnet_andimiller_Row(row);
    var keep$1 = keepMe$2.contains__O__Z(row$1);
    var input$1 = row$1.Lnet_andimiller_Row__f_input;
    var t$3 = row$1.Lnet_andimiller_Row__f_hash;
    var lo$2 = t$3.RTLong__f_lo;
    var hi$2 = t$3.RTLong__f_hi;
    var theta$1 = row$1.Lnet_andimiller_Row__f_theta;
    return new $c_Lnet_andimiller_Row(input$1, new $c_RTLong(lo$2, hi$2), theta$1, keep$1)
  }))(keepMe);
  if ((rows === $m_sci_Nil$())) {
    var rows2 = $m_sci_Nil$()
  } else {
    var arg1$2 = rows.head__O();
    var h$1 = new $c_sci_$colon$colon(f$2(arg1$2), $m_sci_Nil$());
    var t$4 = h$1;
    var rest$1 = $as_sci_List(rows.tail__O());
    while ((rest$1 !== $m_sci_Nil$())) {
      var arg1$3 = rest$1.head__O();
      var nx$1 = new $c_sci_$colon$colon(f$2(arg1$3), $m_sci_Nil$());
      t$4.sci_$colon$colon__f_next = nx$1;
      t$4 = nx$1;
      rest$1 = $as_sci_List(rest$1.tail__O())
    };
    var rows2 = h$1
  };
  var topK = model.Lnet_andimiller_Model__f_topK;
  return new $c_Lnet_andimiller_Model("", topK, rows2)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.recalculate__Lnet_andimiller_Model__Lnet_andimiller_Model = (function(model) {
  var this$2 = model.Lnet_andimiller_Model__f_rows;
  var f = new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Lnet_andimiller_Row(_$3);
    return _$3$1.Lnet_andimiller_Row__f_theta
  }));
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var this$3 = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$2, f, ord)).take__I__sci_List(model.Lnet_andimiller_Model__f_topK);
  var keepMe = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$3);
  var this$4 = model.Lnet_andimiller_Model__f_rows;
  var f$1 = ((keepMe$2) => ((row) => {
    var row$1 = $as_Lnet_andimiller_Row(row);
    var keep$2 = keepMe$2.contains__O__Z(row$1);
    var input$2 = row$1.Lnet_andimiller_Row__f_input;
    var t = row$1.Lnet_andimiller_Row__f_hash;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var theta$2 = row$1.Lnet_andimiller_Row__f_theta;
    return new $c_Lnet_andimiller_Row(input$2, new $c_RTLong(lo, hi), theta$2, keep$2)
  }))(keepMe);
  if ((this$4 === $m_sci_Nil$())) {
    var rows2 = $m_sci_Nil$()
  } else {
    var arg1 = this$4.head__O();
    var h = new $c_sci_$colon$colon(f$1(arg1), $m_sci_Nil$());
    var t$1 = h;
    var rest = $as_sci_List(this$4.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var rows2 = h
  };
  var input = model.Lnet_andimiller_Model__f_input;
  var topK = model.Lnet_andimiller_Model__f_topK;
  return new $c_Lnet_andimiller_Model(input, topK, rows2)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.update__Lnet_andimiller_Model__F1 = (function(model) {
  return new $c_sjsr_AnonFunction1(((this$1, model$2) => ((x$1) => {
    var x$1$1 = $as_Lnet_andimiller_Msg(x$1);
    if ((x$1$1 instanceof $c_Lnet_andimiller_Msg$NewInput)) {
      var x$1$2 = $as_Lnet_andimiller_Msg$NewInput(x$1$1);
      var x7 = x$1$2.Lnet_andimiller_Msg$NewInput__f_s;
      var topK = model$2.Lnet_andimiller_Model__f_topK;
      var rows = model$2.Lnet_andimiller_Model__f_rows;
      var _1 = new $c_Lnet_andimiller_Model(x7, topK, rows);
      var _2 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1, _2)
    };
    var x = $s_Lnet_andimiller_Msg$__Clear__Lnet_andimiller_Msg();
    if (((x === null) ? (x$1$1 === null) : x.equals__O__Z(x$1$1))) {
      return this$1.init__sci_Map__T2($m_sci_Map$EmptyMap$())
    };
    var x$3 = $s_Lnet_andimiller_Msg$__AddOneHundred__Lnet_andimiller_Msg();
    if (((x$3 === null) ? (x$1$1 === null) : x$3.equals__O__Z(x$1$1))) {
      var $$x4 = $m_Ltyrian_Cmd$();
      $m_sci_List$();
      var this$9 = $m_sci_Nil$();
      var this$18;
      var iter = new $c_sci_RangeIterator(1, 1, 100, false);
      if (iter.sci_RangeIterator__f__hasNext) {
        var result = new $c_sci_$colon$colon(iter.next__I(), this$9);
        var curr = result;
        while (iter.sci_RangeIterator__f__hasNext) {
          var temp = new $c_sci_$colon$colon(iter.next__I(), this$9);
          curr.sci_$colon$colon__f_next = temp;
          curr = temp
        };
        var this$18 = result
      } else {
        var this$18 = this$9
      };
      var f = ((i) => {
        var i$1 = $uI(i);
        var $$x2 = $m_sr_ScalaRunTime$();
        var s = ("" + i$1);
        var msg = new $c_Lnet_andimiller_Msg$NewInput(s);
        var $$x1 = new $c_Ltyrian_Cmd$Emit(msg);
        var msg$1 = $s_Lnet_andimiller_Msg$__EnterInput__Lnet_andimiller_Msg();
        var cmds = $$x2.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Cmd.getArrayOf().constr)([$$x1, new $c_Ltyrian_Cmd$Emit(msg$1)]));
        $m_sci_List$();
        var cmds$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(cmds);
        return new $c_Ltyrian_Cmd$Batch(cmds$1)
      });
      if ((this$18 === $m_sci_Nil$())) {
        var $$x3 = $m_sci_Nil$()
      } else {
        var arg1 = this$18.head__O();
        var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
        var t = h;
        var rest = $as_sci_List(this$18.tail__O());
        while ((rest !== $m_sci_Nil$())) {
          var arg1$1 = rest.head__O();
          var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = $as_sci_List(rest.tail__O())
        };
        var $$x3 = h
      };
      var _2$1 = $$x4.combineAll__sci_List__Ltyrian_Cmd($$x3);
      return new $c_T2(model$2, _2$1)
    };
    if ((x$1$1 instanceof $c_Lnet_andimiller_Msg$NewK)) {
      var x$1$3 = $as_Lnet_andimiller_Msg$NewK(x$1$1);
      var x4 = x$1$3.Lnet_andimiller_Msg$NewK__f_s;
      var this$23 = $m_sc_StringParsers$().parseInt__T__s_Option(x4);
      if (this$23.isEmpty__Z()) {
        var this$24 = $m_s_None$()
      } else {
        var arg1$2 = this$23.get__O();
        var i$2 = $uI(arg1$2);
        var input = model$2.Lnet_andimiller_Model__f_input;
        var rows$1 = model$2.Lnet_andimiller_Model__f_rows;
        var this$24 = new $c_s_Some(new $c_Lnet_andimiller_Model(input, i$2, rows$1))
      };
      var _1$1 = this$1.recalculate__Lnet_andimiller_Model__Lnet_andimiller_Model($as_Lnet_andimiller_Model((this$24.isEmpty__Z() ? model$2 : this$24.get__O())));
      var _2$2 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(_1$1, _2$2)
    };
    var x$5 = $s_Lnet_andimiller_Msg$__EnterInput__Lnet_andimiller_Msg();
    if (((x$5 === null) ? (x$1$1 === null) : x$5.equals__O__Z(x$1$1))) {
      var _1$2 = this$1.enterInput__Lnet_andimiller_Model__Lnet_andimiller_Model(model$2);
      var _2$3 = $m_Ltyrian_Cmd$SideEffect$().apply__F0__Lcats_effect_kernel_Sync__Ltyrian_Cmd$SideEffect(new $c_sjsr_AnonFunction0((() => {
        document.getElementById("input-box").value = ""
      })), $m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO);
      return new $c_T2(_1$2, _2$3)
    };
    var x$7 = $s_Lnet_andimiller_Msg$__NoOp__Lnet_andimiller_Msg();
    if (((x$7 === null) ? (x$1$1 === null) : x$7.equals__O__Z(x$1$1))) {
      var _2$4 = $m_Ltyrian_Cmd$None$();
      return new $c_T2(model$2, _2$4)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, model))
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.view__Lnet_andimiller_Model__Ltyrian_Html = (function(model) {
  $m_Ltyrian_Html$();
  var attributes$36 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([]));
  var $$x56 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$34 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("container")]));
  var $$x55 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("row")]));
  var $$x53 = $m_sr_ScalaRunTime$();
  var this$1 = $m_Ltyrian_Html$();
  var $$x52 = $f_Ltyrian_HtmlTags__h3$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$1, "Theta Sketch TopK");
  var this$2 = $m_Ltyrian_Html$();
  var $$x51 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$2, "Theta Sketches are a type of probabilistic data structure which store a list of hashes for items it's seen, and uses those to estimate how many unique items have been seen.");
  var this$3 = $m_Ltyrian_Html$();
  var $$x50 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$3, "This interactive demo allows you to input strings and see how they'd be entered into a Top K Theta Sketch.");
  var this$4 = $m_Ltyrian_Html$();
  var $$x49 = $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$4, "Configuration");
  var this$5 = $m_Ltyrian_Html$();
  var $$x48 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$5, "The one configuration parameter is K, this is how many hashes we should keep track of, I have set the default to 10");
  var this$6 = $m_Ltyrian_Html$();
  var $$x47 = $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$6, "Internal Data");
  var this$7 = $m_Ltyrian_Html$();
  var $$x46 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$7, "For each item you can see the following:");
  $m_Ltyrian_Html$();
  var attributes$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("collection")]));
  var $$x44 = $m_sr_ScalaRunTime$();
  var this$8 = $m_Ltyrian_Html$();
  var attributes = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("collection-item")]));
  var $$x43 = $f_Ltyrian_HtmlTags__li$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$8, attributes, "Input shows the raw string input");
  var this$9 = $m_Ltyrian_Html$();
  var attributes$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("collection-item")]));
  var $$x42 = $f_Ltyrian_HtmlTags__li$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$9, attributes$1, "Hash shows the input hashed into a 64-bit integer using murmur3");
  var this$10 = $m_Ltyrian_Html$();
  var attributes$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("collection-item")]));
  var $$x41 = $f_Ltyrian_HtmlTags__li$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$10, attributes$2, "Theta shows this hash moved into the range of 0.0 to 1.0, which is how this algorithm operates");
  var this$11 = $m_Ltyrian_Html$();
  var attributes$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("collection-item")]));
  var children = $$x44.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x43, $$x42, $$x41, $f_Ltyrian_HtmlTags__li$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$11, attributes$3, "Included shows whether this item would be kept by a real sketch with the current configuration")]));
  $m_sci_List$();
  var attributes$5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$4);
  $m_sci_List$();
  var children$1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children);
  var $$x45 = new $c_Ltyrian_Tag("ul", attributes$5, children$1);
  var this$16 = $m_Ltyrian_Html$();
  var $$x40 = $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$16, "Formula");
  var this$17 = $m_Ltyrian_Html$();
  var $$x39 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$17, "The formula to calculate the estimate is:");
  var this$18 = $m_Ltyrian_Html$();
  var $$x38 = $f_Ltyrian_HtmlTags__blockquote$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$18, "(K - 1) / topTheta");
  var this$19 = $m_Ltyrian_Html$();
  var children$2 = $$x53.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x52, $$x51, $$x50, $$x49, $$x48, $$x47, $$x46, $$x45, $$x40, $$x39, $$x38, $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$19, "Where K is the K from the configuration, and topTheta is the highest value of theta we've stored")]));
  $m_sci_List$();
  var attributes$7 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$6);
  $m_sci_List$();
  var children$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$2);
  var $$x54 = new $c_Ltyrian_Tag("div", attributes$7, children$3);
  $m_Ltyrian_Html$();
  var attributes$32 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("row")]));
  var $$x37 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var attributes$19 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("inputs"), $m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("col s3")]));
  var $$x35 = $m_sr_ScalaRunTime$();
  var this$24 = $m_Ltyrian_Html$();
  var $$x34 = $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$24, "Inputs");
  var this$26 = $m_Ltyrian_Html$();
  var $$x32 = $m_sr_ScalaRunTime$();
  var $$x31 = $m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("waves-effect waves-light btn");
  var this$25 = $m_Ltyrian_Html$();
  var msg = $s_Lnet_andimiller_Msg$__AddOneHundred__Lnet_andimiller_Msg();
  var attributes$8 = $$x32.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$$x31, $f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Attr(this$25, msg)]));
  var $$x33 = $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$26, attributes$8, "Add 100 items");
  var this$28 = $m_Ltyrian_Html$();
  var $$x29 = $m_sr_ScalaRunTime$();
  var $$x28 = $m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("waves-effect waves-light btn");
  var this$27 = $m_Ltyrian_Html$();
  var msg$1 = $s_Lnet_andimiller_Msg$__Clear__Lnet_andimiller_Msg();
  var attributes$9 = $$x29.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$$x28, $f_Ltyrian_HtmlAttributes__onClick__O__Ltyrian_Attr(this$27, msg$1)]));
  var $$x30 = $f_Ltyrian_HtmlTags__button$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$28, attributes$9, "Clear");
  $m_Ltyrian_Html$();
  var $$x26 = $m_sr_ScalaRunTime$();
  var $$x25 = $m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("input-box");
  var $$x24 = $m_Ltyrian_Html$().Ltyrian_Html$__f_placeholder$minusString.$colon$eq__T__Ltyrian_Attribute("New string to add");
  var $$x23 = $m_Ltyrian_Html$().onInput__F1__Ltyrian_Attr(new $c_sjsr_AnonFunction1(((s) => {
    var s$1 = $as_T(s);
    return new $c_Lnet_andimiller_Msg$NewInput(s$1)
  })));
  $m_Ltyrian_Html$();
  var msg$2 = new $c_sjsr_AnonFunction1(((e) => (($uI(e.keyCode) === 13) ? $s_Lnet_andimiller_Msg$__EnterInput__Lnet_andimiller_Msg() : $s_Lnet_andimiller_Msg$__NoOp__Lnet_andimiller_Msg())));
  var attributes$10 = $$x26.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$$x25, $$x24, $$x23, new $c_Ltyrian_Event("keydown", msg$2)]));
  $m_sci_List$();
  var attributes$11 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$10);
  var children$4 = $m_s_package$().s_package$__f_Nil;
  var $$x27 = new $c_Ltyrian_Tag("input", attributes$11, children$4);
  $m_Ltyrian_Html$();
  var attributes$17 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("input-field")]));
  var $$x22 = $m_sr_ScalaRunTime$();
  var this$38 = $m_Ltyrian_Html$();
  var attributes$12 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([($m_Ltyrian_Html$(), $m_Ltyrian_Attribute$(), new $c_Ltyrian_Attribute("for", "k"))]));
  var $$x21 = $f_Ltyrian_HtmlTags__label$minusrepeated$minuslist$minusplaintext__sci_Seq__T__Ltyrian_Html(this$38, attributes$12, "K value (how many items to keep)");
  $m_Ltyrian_Html$();
  var attributes$13 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([]));
  $m_sci_List$();
  var attributes$14 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$13);
  var children$5 = $m_s_package$().s_package$__f_Nil;
  var $$x20 = new $c_Ltyrian_Tag("br", attributes$14, children$5);
  $m_Ltyrian_Html$();
  var attributes$15 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("k"), $m_Ltyrian_Html$().Ltyrian_Html$__f_placeholder$minusString.$colon$eq__T__Ltyrian_Attribute("10"), $m_Ltyrian_Html$().onInput__F1__Ltyrian_Attr(new $c_sjsr_AnonFunction1(((s$2) => {
    var s$3 = $as_T(s$2);
    return new $c_Lnet_andimiller_Msg$NewK(s$3)
  })))]));
  $m_sci_List$();
  var attributes$16 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$15);
  var children$6 = $m_s_package$().s_package$__f_Nil;
  var children$7 = $$x22.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x21, $$x20, new $c_Ltyrian_Tag("input", attributes$16, children$6)]));
  $m_sci_List$();
  var attributes$18 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$17);
  $m_sci_List$();
  var children$8 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$7);
  var children$9 = $$x35.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x34, $$x33, $$x30, $$x27, new $c_Ltyrian_Tag("div", attributes$18, children$8)]));
  $m_sci_List$();
  var attributes$20 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$19);
  $m_sci_List$();
  var children$10 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$9);
  var $$x36 = new $c_Ltyrian_Tag("div", attributes$20, children$10);
  $m_Ltyrian_Html$();
  var attributes$28 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("data"), $m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("col s6")]));
  var $$x18 = $m_sr_ScalaRunTime$();
  var this$54 = $m_Ltyrian_Html$();
  var $$x17 = $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$54, "Data");
  $m_Ltyrian_Html$();
  var attributes$26 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([]));
  var $$x16 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var $$x14 = $m_sr_ScalaRunTime$();
  $m_Ltyrian_Html$();
  var $$x13 = $m_sr_ScalaRunTime$();
  var this$55 = $m_Ltyrian_Html$();
  var $$x12 = $f_Ltyrian_HtmlTags__th$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$55, "Input");
  var this$56 = $m_Ltyrian_Html$();
  var $$x11 = $f_Ltyrian_HtmlTags__th$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$56, "Hash");
  var this$57 = $m_Ltyrian_Html$();
  var $$x10 = $f_Ltyrian_HtmlTags__th$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$57, "Theta");
  var this$58 = $m_Ltyrian_Html$();
  var children$11 = $$x13.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x12, $$x11, $$x10, $f_Ltyrian_HtmlTags__th$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$58, "Included")]));
  var attributes$21 = $m_s_package$().s_package$__f_Nil;
  $m_sci_List$();
  var children$12 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$11);
  var children$13 = $$x14.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Tag("tr", attributes$21, children$12)]));
  var attributes$22 = $m_s_package$().s_package$__f_Nil;
  $m_sci_List$();
  var children$14 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$13);
  var $$x15 = new $c_Ltyrian_Tag("thead", attributes$22, children$14);
  $m_Ltyrian_Html$();
  var this$65 = model.Lnet_andimiller_Model__f_rows;
  var f = new $c_sjsr_AnonFunction1(((_$4) => {
    var _$4$1 = $as_Lnet_andimiller_Row(_$4);
    return _$4$1.Lnet_andimiller_Row__f_theta
  }));
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  var this$79 = $as_sci_List($f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$65, f, ord));
  var f$1 = ((row) => {
    var row$1 = $as_Lnet_andimiller_Row(row);
    var bgStyle = (row$1.Lnet_andimiller_Row__f_keep ? "background-color: lightgray" : "");
    $m_Ltyrian_Html$();
    var attributes$23 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_style$minusString.$colon$eq__T__Ltyrian_Attribute(bgStyle)]));
    var $$x9 = $m_sr_ScalaRunTime$();
    var this$66 = $m_Ltyrian_Html$();
    var plainText = row$1.Lnet_andimiller_Row__f_input;
    var $$x8 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$66, plainText);
    var this$68 = $m_Ltyrian_Html$();
    var this$67 = row$1.Lnet_andimiller_Row__f_hash;
    var plainText$1 = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$67.RTLong__f_lo, this$67.RTLong__f_hi);
    var $$x7 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$68, plainText$1);
    var this$71 = $m_Ltyrian_Html$();
    var this$69 = row$1.Lnet_andimiller_Row__f_theta;
    var plainText$2 = ("" + this$69);
    var $$x6 = $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$71, plainText$2);
    var this$74 = $m_Ltyrian_Html$();
    var this$72 = row$1.Lnet_andimiller_Row__f_keep;
    var plainText$3 = ("" + this$72);
    var children$15 = $$x9.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x8, $$x7, $$x6, $f_Ltyrian_HtmlTags__td$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$74, plainText$3)]));
    $m_sci_List$();
    var attributes$24 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$23);
    $m_sci_List$();
    var children$16 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$15);
    return new $c_Ltyrian_Tag("tr", attributes$24, children$16)
  });
  if ((this$79 === $m_sci_Nil$())) {
    var children$17 = $m_sci_Nil$()
  } else {
    var arg1 = this$79.head__O();
    var h = new $c_sci_$colon$colon(f$1(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$79.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var children$17 = h
  };
  var attributes$25 = $m_s_package$().s_package$__f_Nil;
  var children$18 = $$x16.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x15, new $c_Ltyrian_Tag("tbody", attributes$25, children$17)]));
  $m_sci_List$();
  var attributes$27 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$26);
  $m_sci_List$();
  var children$19 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$18);
  var children$20 = $$x18.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x17, new $c_Ltyrian_Tag("table", attributes$27, children$19)]));
  $m_sci_List$();
  var attributes$29 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$28);
  $m_sci_List$();
  var children$21 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$20);
  var $$x19 = new $c_Ltyrian_Tag("div", attributes$29, children$21);
  $m_Ltyrian_Html$();
  var attributes$30 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Attr.getArrayOf().constr)([$m_Ltyrian_Html$().Ltyrian_Html$__f_id$minusString.$colon$eq__T__Ltyrian_Attribute("output"), $m_Ltyrian_Html$().Ltyrian_Html$__f_cls$minusString.$colon$eq__T__Ltyrian_Attribute("col s3")]));
  var $$x5 = $m_sr_ScalaRunTime$();
  var this$90 = $m_Ltyrian_Html$();
  var $$x4 = $f_Ltyrian_HtmlTags__h5$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$90, "Outputs");
  var this$92 = $m_Ltyrian_Html$();
  var $$x2 = model.Lnet_andimiller_Model__f_topK;
  var this$91 = model.topTheta__s_Option();
  var plainText$4 = ((("Estimate Formula: " + $$x2) + " - 1 / ") + (this$91.isEmpty__Z() ? 0.0 : this$91.get__O()));
  var $$x3 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$92, plainText$4);
  var this$93 = $m_Ltyrian_Html$();
  var plainText$5 = ("Estimated unique items: " + model.estimate__D());
  var $$x1 = $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$93, plainText$5);
  var this$94 = $m_Ltyrian_Html$();
  var plainText$6 = ("Actual unique items: " + model.uniques__J());
  var children$22 = $$x5.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x4, $$x3, $$x1, $f_Ltyrian_HtmlTags__p$minusno_attrs$minuslist$minusplaintext__T__Ltyrian_Html(this$94, plainText$6)]));
  $m_sci_List$();
  var attributes$31 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$30);
  $m_sci_List$();
  var children$23 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$22);
  var children$24 = $$x37.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x36, $$x19, new $c_Ltyrian_Tag("div", attributes$31, children$23)]));
  $m_sci_List$();
  var attributes$33 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$32);
  $m_sci_List$();
  var children$25 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$24);
  var children$26 = $$x55.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([$$x54, new $c_Ltyrian_Tag("div", attributes$33, children$25)]));
  $m_sci_List$();
  var attributes$35 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$34);
  $m_sci_List$();
  var children$27 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$26);
  var children$28 = $$x56.wrapRefArray__AO__sci_ArraySeq(new ($d_Ltyrian_Elem.getArrayOf().constr)([new $c_Ltyrian_Tag("div", attributes$35, children$27)]));
  $m_sci_List$();
  var attributes$37 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(attributes$36);
  $m_sci_List$();
  var children$29 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(children$28);
  return new $c_Ltyrian_Tag("div", attributes$37, children$29)
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.launch = (function(arg, ...rest) {
  switch ($uI(rest.length)) {
    case 0: {
      var prep0 = $as_T(arg);
      return this.$js$exported$meth$launch__T__O(prep0);
      break
    }
    case 1: {
      var prep0$2 = $as_T(arg);
      var prep1 = rest[0];
      return this.$js$exported$meth$launch__T__sjs_js_Dictionary__O(prep0$2, prep1);
      break
    }
    default: {
      throw new TypeError("No matching overload")
    }
  }
});
var $d_Lnet_andimiller_ProbabilisticPlayground$ = new $TypeData().initClass({
  Lnet_andimiller_ProbabilisticPlayground$: 0
}, false, "net.andimiller.ProbabilisticPlayground$", {
  Lnet_andimiller_ProbabilisticPlayground$: 1,
  O: 1,
  Ltyrian_TyrianAppF: 1,
  Ltyrian_TyrianApp: 1
});
$c_Lnet_andimiller_ProbabilisticPlayground$.prototype.$classData = $d_Lnet_andimiller_ProbabilisticPlayground$;
var $n_Lnet_andimiller_ProbabilisticPlayground$;
function $m_Lnet_andimiller_ProbabilisticPlayground$() {
  if ((!$n_Lnet_andimiller_ProbabilisticPlayground$)) {
    $n_Lnet_andimiller_ProbabilisticPlayground$ = new $c_Lnet_andimiller_ProbabilisticPlayground$()
  };
  return $n_Lnet_andimiller_ProbabilisticPlayground$
}
/** @constructor */
function $c_s_$less$colon$less() {
  /*<skip>*/
}
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
  /*<skip>*/
}
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  this.s_Predef$__f_$minus$greater = null;
  this.s_Predef$__f_Manifest = null;
  this.s_Predef$__f_NoManifest = null;
  $n_s_Predef$ = this;
  $m_s_package$();
  $m_sci_List$();
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$();
  this.s_Predef$__f_$minus$greater = $m_T2$();
  this.s_Predef$__f_Manifest = $m_s_reflect_Manifest$();
  this.s_Predef$__f_NoManifest = $m_s_reflect_NoManifest$()
}
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
  /*<skip>*/
}
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.assert__Z__V = (function(assertion) {
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed")
  }
});
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed")
  }
});
$c_s_Predef$.prototype.$qmark$qmark$qmark__E = (function() {
  throw new $c_s_NotImplementedError()
});
var $d_s_Predef$ = new $TypeData().initClass({
  s_Predef$: 0
}, false, "scala.Predef$", {
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1,
  O: 1
});
$c_s_Predef$.prototype.$classData = $d_s_Predef$;
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$()
  };
  return $n_s_Predef$
}
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break
    }
    case 1: {
      return $thiz._2__O();
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
    }
  }
}
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break
    }
    case 1: {
      return $thiz.T3__f__2;
      break
    }
    case 2: {
      return $thiz.T3__f__3;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"))
    }
  }
}
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T4__f__1;
      break
    }
    case 1: {
      return $thiz.T4__f__2;
      break
    }
    case 2: {
      return $thiz.T4__f__3;
      break
    }
    case 3: {
      return $thiz.T4__f__4;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"))
    }
  }
}
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null
}
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  return this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate.empty__O__O($m_s_reflect_ManifestFactory$AnyManifest$())
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate.from__sc_IterableOnce__O__O(it, $m_s_reflect_ManifestFactory$AnyManifest$())
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  var evidence$12 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12)
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$3 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  var evidence$7 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$3.from__sc_IterableOnce__O__O(elems, evidence$7)
});
function $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__($thiz, delegate) {
  $thiz.sc_EvidenceIterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_EvidenceIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null
}
$c_sc_EvidenceIterableFactory$Delegate.prototype = new $h_O();
$c_sc_EvidenceIterableFactory$Delegate.prototype.constructor = $c_sc_EvidenceIterableFactory$Delegate;
/** @constructor */
function $h_sc_EvidenceIterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_EvidenceIterableFactory$Delegate.prototype = $c_sc_EvidenceIterableFactory$Delegate.prototype;
$c_sc_EvidenceIterableFactory$Delegate.prototype.newBuilder__O__scm_Builder = (function(evidence$21) {
  return this.sc_EvidenceIterableFactory$Delegate__f_delegate.newBuilder__O__scm_Builder(evidence$21)
});
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null
}
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.empty__O()
});
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it)
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
/** @constructor */
function $c_sc_IterableFactory$ToFactory(factory) {
  this.sc_IterableFactory$ToFactory__f_factory = null;
  this.sc_IterableFactory$ToFactory__f_factory = factory
}
$c_sc_IterableFactory$ToFactory.prototype = new $h_O();
$c_sc_IterableFactory$ToFactory.prototype.constructor = $c_sc_IterableFactory$ToFactory;
/** @constructor */
function $h_sc_IterableFactory$ToFactory() {
  /*<skip>*/
}
$h_sc_IterableFactory$ToFactory.prototype = $c_sc_IterableFactory$ToFactory.prototype;
$c_sc_IterableFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$ToFactory__f_factory.from__sc_IterableOnce__O(it)
});
var $d_sc_IterableFactory$ToFactory = new $TypeData().initClass({
  sc_IterableFactory$ToFactory: 0
}, false, "scala.collection.IterableFactory$ToFactory", {
  sc_IterableFactory$ToFactory: 1,
  O: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IterableFactory$ToFactory.prototype.$classData = $d_sc_IterableFactory$ToFactory;
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  var lst = it.next__O();
  while (it.hasNext__Z()) {
    lst = it.next__O()
  };
  return lst
}
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1))
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        if ((i === otherSize)) {
          return 1
        };
        it.next__O();
        i = ((1 + i) | 0)
      };
      return ((i - otherSize) | 0)
    }
  }
}
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, false))
}
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n))
}
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException())
  };
  return $thiz.drop__I__O(1)
}
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $$x2 = $thiz.iterableFactory__sc_IterableFactory();
  if ($is_sc_Iterable(suffix)) {
    var x2 = $as_sc_Iterable(suffix);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var this$2 = $thiz.iterator__sc_Iterator();
    var xs = new $c_sjsr_AnonFunction0(((suffix$1) => (() => suffix$1.iterator__sc_Iterator()))(suffix));
    var $$x1 = this$2.concat__F0__sc_Iterator(xs)
  };
  return $$x2.from__sc_IterableOnce__O($$x1)
}
function $is_sc_IterableOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IterableOps)))
}
function $as_sc_IterableOps(obj) {
  return (($is_sc_IterableOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IterableOps"))
}
function $isArrayOf_sc_IterableOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IterableOps)))
}
function $asArrayOf_sc_IterableOps(obj, depth) {
  return (($isArrayOf_sc_IterableOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IterableOps;", depth))
}
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.drop__I__sc_Iterator(from);
  while (dropped.hasNext__Z()) {
    if ($uZ(p.apply__O__O(dropped.next__O()))) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
}
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs)
}
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_Iterator$SliceIterator($thiz, lo, rest))
}
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = that.iterator__sc_Iterator();
  while (($thiz.hasNext__Z() && those.hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), those.next__O()))) {
      return false
    }
  };
  return ($thiz.hasNext__Z() === those.hasNext__Z())
}
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)))
}
function $as_sc_Iterator(obj) {
  return (($is_sc_Iterator(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator"))
}
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)))
}
function $asArrayOf_sc_Iterator(obj, depth) {
  return (($isArrayOf_sc_Iterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator;", depth))
}
var $d_sc_Iterator = new $TypeData().initClass({
  sc_Iterator: 0
}, true, "scala.collection.Iterator", {
  sc_Iterator: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19()
}
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
  /*<skip>*/
}
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21()
});
$c_sc_Iterator$.prototype.empty__O = (function() {
  return this.sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return source.iterator__sc_Iterator()
});
var $d_sc_Iterator$ = new $TypeData().initClass({
  sc_Iterator$: 0
}, false, "scala.collection.Iterator$", {
  sc_Iterator$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterator$.prototype.$classData = $d_sc_Iterator$;
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$()
  };
  return $n_sc_Iterator$
}
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null
}
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
  /*<skip>*/
}
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.sc_MapFactory$Delegate__f_delegate.apply__sci_Seq__O(elems)
});
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_MapFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it)
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.empty__O()
});
/** @constructor */
function $c_sc_View$() {
  /*<skip>*/
}
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
  /*<skip>*/
}
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    var x2 = $as_sc_View(it);
    return x2
  } else if ($is_sc_Iterable(it)) {
    var x3 = $as_sc_Iterable(it);
    var it$1 = new $c_sjsr_AnonFunction0(((x3$1) => (() => x3$1.iterator__sc_Iterator()))(x3));
    return new $c_sc_View$$anon$1(it$1)
  } else {
    var this$3 = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it);
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$3)
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((it$2) => {
    var it = $as_sc_IterableOnce(it$2);
    return $m_sc_View$().from__sc_IterableOnce__sc_View(it)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sc_View$.prototype.empty__O = (function() {
  return $m_sc_View$Empty$()
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source)
});
var $d_sc_View$ = new $TypeData().initClass({
  sc_View$: 0
}, false, "scala.collection.View$", {
  sc_View$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$.prototype.$classData = $d_sc_View$;
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$()
  };
  return $n_sc_View$
}
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.get((index << 1))
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.get(((1 + (index << 1)) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return new $c_T2(this.sci_BitmapIndexedMapNode__f_content.get((index << 1)), this.sci_BitmapIndexedMapNode__f_content.get(((1 + (index << 1)) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_originalHashes.get(index)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return $as_sci_MapNode(this.sci_BitmapIndexedMapNode__f_content.get((((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index)
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0))
  } else {
    return $m_s_None$()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : f.apply__O())
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f)
  } else {
    return f.apply__O()
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedMapNode__f_originalHashes.get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)))
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)))
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value))
      } else {
        return this
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2))
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(1), this.getValue__I__O(1)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedMapNode__f_originalHashes.get(1)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(0), this.getValue__I__O(0)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedMapNode__f_originalHashes.get(0)])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0))))
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash)
      }
    } else {
      return this
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = subNodeNew.size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === subNode.size__I()) ? $as_sci_BitmapIndexedMapNode(subNodeNew) : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this))
  } else {
    return this
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [new $c_T2(key0, value0), new $c_T2(key1, value1)];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash))
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.set(((1 + idx) | 0), newValue);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  src.copyTo(idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-2) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((-2) + ((src.u.length - idx) | 0)) | 0);
  src.copyTo(srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.copyTo(srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.copyTo(srcPos, dst, idxOld, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = node.getKey__I__O(0);
  var value = node.getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxNew);
  dst.set(idxNew, key);
  dst.set(((1 + idxNew) | 0), value);
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  src.copyTo(idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  src.copyTo(srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachEntry__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    f.apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0)
  };
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === x2.sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === x2.sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === x2.sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = x2.sci_BitmapIndexedMapNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = x2.sci_BitmapIndexedMapNode__f_content;
        var length = this.sci_BitmapIndexedMapNode__f_content.u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.get(i), a2.get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = this.sci_BitmapIndexedMapNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $as_sci_MapNode(contentClone.get(i$1)).copy__sci_MapNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedMapNode__f_originalHashes;
  return new $c_sci_BitmapIndexedMapNode($$x2, $$x1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedMapNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
    return this
  } else if ((this.sci_BitmapIndexedMapNode__f_size === 1)) {
    if (($uZ(pred.apply__O__O(this.getPayload__I__T2(0))) !== flipped)) {
      return this
    } else {
      var this$1 = $m_sci_MapNode$();
      return this$1.sci_MapNode$__f_EmptyMapNode
    }
  } else if ((this.sci_BitmapIndexedMapNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedMapNode__f_dataMap;
    var minimumIndex = ((i === 0) ? 32 : ((31 - Math.clz32((i & ((-i) | 0)))) | 0));
    var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
    var maximumIndex = ((32 - Math.clz32(i$1)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$2 = minimumIndex;
    while ((i$2 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$2);
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__T2(dataIndex);
        var passed = ($uZ(pred.apply__O__O(payload)) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0)
        };
        dataIndex = ((1 + dataIndex) | 0)
      };
      i$2 = ((1 + i$2) | 0)
    };
    if ((newDataMap === 0)) {
      var this$3 = $m_sci_MapNode$();
      return this$3.sci_MapNode$__f_EmptyMapNode
    } else if ((newDataMap === this.sci_BitmapIndexedMapNode__f_dataMap)) {
      return this
    } else {
      var i$3 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$3);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$4 = newDataMap;
      var newMaximumIndex = ((32 - Math.clz32(i$4)) | 0);
      var i$5 = newDataMap;
      var j = ((i$5 === 0) ? 32 : ((31 - Math.clz32((i$5 & ((-i$5) | 0)))) | 0));
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, bitpos$2);
          newContent.set((newDataIndex << 1), this.sci_BitmapIndexedMapNode__f_content.get((oldIndex << 1)));
          newContent.set(((1 + (newDataIndex << 1)) | 0), this.sci_BitmapIndexedMapNode__f_content.get(((1 + (oldIndex << 1)) | 0)));
          newOriginalHashCodes.set(newDataIndex, this.sci_BitmapIndexedMapNode__f_originalHashes.get(oldIndex));
          newDataIndex = ((1 + newDataIndex) | 0)
        };
        j = ((1 + j) | 0)
      };
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode)
    }
  } else {
    var allMap = (this.sci_BitmapIndexedMapNode__f_dataMap | this.sci_BitmapIndexedMapNode__f_nodeMap);
    var minimumIndex$2 = ((allMap === 0) ? 32 : ((31 - Math.clz32((allMap & ((-allMap) | 0)))) | 0));
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__T2(dataIndex$2);
        var passed$2 = ($uZ(pred.apply__O__O(payload$2)) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0)
        };
        dataIndex$2 = ((1 + dataIndex$2) | 0)
      } else if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_MapNode(nodeIndex);
        var newSubNode = oldSubNode.filterImpl__F1__Z__sci_MapNode(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.cachedJavaKeySetHashCode__I()) | 0);
        if ((newSubNode.size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3)
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = new $c_scm_Queue(16)
            };
            var this$7 = newNodes;
            this$7.addOne__O__scm_ArrayDeque(newSubNode)
          }
        } else if ((newSubNode.size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $m_sci_Nil$();
            var this$9 = new $c_scm_Queue(16);
            nodesToMigrateToData = $as_scm_Queue(this$9.addAll__sc_IterableOnce__scm_ArrayDeque(elems))
          };
          var this$10 = nodesToMigrateToData;
          this$10.addOne__O__scm_ArrayDeque(newSubNode)
        };
        nodeIndex = ((1 + nodeIndex) | 0)
      };
      i$2$1 = ((1 + i$2$1) | 0)
    };
    if ((newSize$2 === 0)) {
      var this$11 = $m_sci_MapNode$();
      return this$11.sci_MapNode$__f_EmptyMapNode
    } else if ((newSize$2 === this.sci_BitmapIndexedMapNode__f_size)) {
      return this
    } else {
      var i$6 = newDataMap$2;
      var newDataSize = $m_jl_Integer$().bitCount__I__I(i$6);
      var i$7 = newNodeMap;
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(i$7)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().bitposFrom__I__I(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          newContent$2.set((newDataIndex$2 << 1), this.getKey__I__O(oldDataIndex));
          newContent$2.set(((1 + (newDataIndex$2 << 1)) | 0), this.getValue__I__O(oldDataIndex));
          newOriginalHashes.set(newDataIndex$2, this.getHash__I__I(oldDataIndex));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0)
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          newContent$2.set((((-1) + ((newContentSize - newNodeIndex) | 0)) | 0), this.getNode__I__sci_MapNode(oldNodeIndex));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var this$12 = nodesToMigrateToData;
          var node = $as_sci_MapNode(this$12.removeHead__Z__O(false));
          newContent$2.set((newDataIndex$2 << 1), node.getKey__I__O(0));
          newContent$2.set(((1 + (newDataIndex$2 << 1)) | 0), node.getValue__I__O(0));
          newOriginalHashes.set(newDataIndex$2, node.getHash__I__I(0));
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          var $$x1 = newNodeIndex;
          var this$13 = newNodes;
          newContent$2.set((((-1) + ((newContentSize - $$x1) | 0)) | 0), this$13.removeHead__Z__O(false));
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0)
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0)
        };
        i$3$1 = ((1 + i$3$1) | 0)
      };
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2)
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped)
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode()
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift)
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue)
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_BitmapIndexedMapNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedMapNode"))
}
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)))
}
function $asArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedMapNode;", depth))
}
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass({
  sci_BitmapIndexedMapNode: 0
}, false, "scala.collection.immutable.BitmapIndexedMapNode", {
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedMapNode.prototype.$classData = $d_sci_BitmapIndexedMapNode;
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode
}
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
  /*<skip>*/
}
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_content.get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_originalHashes.get(index)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return $as_sci_SetNode(this.sci_BitmapIndexedSetNode__f_content.get((((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - index) | 0)))
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedSetNode__f_originalHashes.get(index) === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)))
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_SetNode(index$2).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0))
  };
  return false
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if (Object.is(element0, element)) {
      return this
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2)
    }
  };
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash)
});
$c_sci_BitmapIndexedSetNode.prototype.updateWithShallowMutations__O__I__I__I__I__I = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    var element0UnimprovedHash = this.getHash__I__I(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
      return shallowlyMutableNodeMap
    } else {
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos)
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeSize = subNode.size__I();
    var subNodeCachedJavaKeySetHashCode = subNode.cachedJavaKeySetHashCode__I();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        var x2 = $as_sci_BitmapIndexedSetNode(subNode);
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          x2.updateWithShallowMutations__O__I__I__I__I__I(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = x2;
          break matchEnd4
        }
      };
      var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos)
      };
      var subNodeNew$3 = subNodeNew$2
    };
    this.sci_BitmapIndexedSetNode__f_content.set((((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0), subNodeNew$3);
    this.sci_BitmapIndexedSetNode__f_size = ((((this.sci_BitmapIndexedSetNode__f_size - subNodeSize) | 0) + subNodeNew$3.size__I()) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - subNodeCachedJavaKeySetHashCode) | 0) + subNodeNew$3.cachedJavaKeySetHashCode__I()) | 0);
    return returnNodeMap
  } else {
    var dataIx = this.dataIndex__I__I(bitpos);
    var src = this.sci_BitmapIndexedSetNode__f_content;
    var dst = new $ac_O(((1 + src.u.length) | 0));
    src.copyTo(0, dst, 0, dataIx);
    dst.set(dataIx, element);
    var destPos = ((1 + dataIx) | 0);
    var length = ((src.u.length - dataIx) | 0);
    src.copyTo(dataIx, dst, destPos, length);
    var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
    this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedSetNode__f_content = dst;
    this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
    this.sci_BitmapIndexedSetNode__f_size = ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0);
    return shallowlyMutableNodeMap
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $$x1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        if ((index === 0)) {
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(1)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.get(1)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.get(1)))
        } else {
          return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(0)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.get(0)])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.get(0)))
        }
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash)
      }
    } else {
      return this
    }
  };
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this
    };
    var subNodeNewSize = subNodeNew.size__I();
    if ((subNodeNewSize === 1)) {
      if ((this.sci_BitmapIndexedSetNode__f_size === subNode.size__I())) {
        return $as_sci_BitmapIndexedSetNode(subNodeNew)
      } else {
        return this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)
      }
    } else if ((subNodeNewSize > 1)) {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew)
    }
  };
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems))
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode))
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I())
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i)
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.set(idx, newNode);
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  src.copyTo(dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((-1) + ((src.u.length - dataIx) | 0)) | 0);
  src.copyTo(srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  src.copyTo(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  src.copyTo(srcPos, dst, dataIx, length);
  dst.set(idxNew, node);
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-1) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  src.copyTo(srcPos, dest, dataIx, length);
  this.sci_BitmapIndexedSetNode__f_content.set(idxNew, node);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  src.copyTo(0, dst, 0, dataIxNew);
  dst.set(dataIxNew, node.getPayload__I__O(0));
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  src.copyTo(dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  src.copyTo(srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0))
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    f.apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    this.getNode__I__sci_SetNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === x2.sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === x2.sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === x2.sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = x2.sci_BitmapIndexedSetNode__f_originalHashes;
        var $$x1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b)
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = x2.sci_BitmapIndexedSetNode__f_content;
        var length = this.sci_BitmapIndexedSetNode__f_content.u.length;
        if ((a1 === a2)) {
          return true
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.get(i), a2.get(i));
            i = ((1 + i) | 0)
          };
          return isEqual
        }
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = this.sci_BitmapIndexedSetNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    contentClone.set(i$1, $as_sci_SetNode(contentClone.get(i$1)).copy__sci_SetNode());
    i$1 = ((1 + i$1) | 0)
  };
  var $$x2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $$x1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedSetNode__f_originalHashes;
  return new $c_sci_BitmapIndexedSetNode($$x2, $$x1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode)
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(that);
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return x2
    } else if (((x2.sci_BitmapIndexedSetNode__f_size === 0) || (x2 === this))) {
      return this
    } else if ((x2.sci_BitmapIndexedSetNode__f_size === 1)) {
      var originalHash = x2.getHash__I__I(0);
      return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(x2.getPayload__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift)
    };
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedSetNode__f_dataMap | x2.sci_BitmapIndexedSetNode__f_dataMap) | this.sci_BitmapIndexedSetNode__f_nodeMap) | x2.sci_BitmapIndexedSetNode__f_nodeMap);
    var minimumBitPos = $m_sci_Node$().bitposFrom__I__I(((allMap === 0) ? 32 : ((31 - Math.clz32((allMap & ((-allMap) | 0)))) | 0)));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          if (((this.getHash__I__I(leftIdx) === x2.getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getPayload__I__O(leftIdx), x2.getPayload__I__O(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos)
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(this.getHash__I__I(leftIdx)), shift)))
          };
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos)
        } else {
          leftDataOnly = (leftDataOnly | bitpos)
        };
        leftIdx = ((1 + leftIdx) | 0)
      } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        if (((bitpos & x2.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0)
        } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos)
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos)
        }
      } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0)
      } else if (((bitpos & x2.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos)
      };
      if ((bitpos === maximumBitPos)) {
        finished = true
      } else {
        bitpos = (bitpos << 1)
      }
    };
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this
    };
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.getNode__I__sci_SetNode(leftNodeIdx);
        var newNode = leftNode.concat__sci_SetNode__I__sci_SetNode(x2.getNode__I__sci_SetNode(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = x2.getNode__I__sci_SetNode(rightNodeIdx);
        var leftPayload = this.getPayload__I__O(leftDataIdx);
        var leftOriginalHash = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash);
        var newNode$2 = n.updated__O__I__I__I__sci_SetNode(leftPayload, leftOriginalHash, leftImproved, nextShift);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$2);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + newNode$2.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$2.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = x2.getHash__I__I(rightDataIdx);
        var leftNode$2 = this.getNode__I__sci_SetNode(leftNodeIdx);
        var updated = leftNode$2.updated__O__I__I__I__sci_SetNode(x2.getPayload__I__O(rightDataIdx), x2.getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true
        };
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), updated);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + updated.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = this.sci_BitmapIndexedSetNode__f_originalHashes.get(leftDataIdx);
        newContent.set(compressedDataIdx, this.getPayload__I__O(leftDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$2);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0)
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = x2.sci_BitmapIndexedSetNode__f_originalHashes.get(rightDataIdx);
        newContent.set(compressedDataIdx, x2.getPayload__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$3);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0)
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.getNode__I__sci_SetNode(leftNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$4);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = x2.getNode__I__sci_SetNode(rightNodeIdx);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$5);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = x2.getHash__I__I(rightDataIdx);
        var newNode$6 = x2.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(this.getPayload__I__O(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().improve__I__I(leftOriginalHash$2), x2.getPayload__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.set((((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0), newNode$6);
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.cachedJavaKeySetHashCode__I()) | 0)
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = x2.sci_BitmapIndexedSetNode__f_originalHashes.get(rightDataIdx);
        newContent.set(compressedDataIdx, x2.getPayload__I__O(rightDataIdx));
        newOriginalHashes.set(compressedDataIdx, originalHash$4);
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0)
      };
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true
      } else {
        bitpos$2 = (bitpos$2 << 1)
      }
    };
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this)
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode")
  }
});
$c_sci_BitmapIndexedSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getPayload__I__O(i$1), this.getHash__I__I(i$1));
    i$1 = ((1 + i$1) | 0)
  };
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_SetNode(j).foreachWithHash__F2__V(f);
    j = ((1 + j) | 0)
  }
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode()
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift)
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_BitmapIndexedSetNode(obj) {
  return (((obj instanceof $c_sci_BitmapIndexedSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitmapIndexedSetNode"))
}
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)))
}
function $asArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (($isArrayOf_sci_BitmapIndexedSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitmapIndexedSetNode;", depth))
}
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass({
  sci_BitmapIndexedSetNode: 0
}, false, "scala.collection.immutable.BitmapIndexedSetNode", {
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_BitmapIndexedSetNode.prototype.$classData = $d_sci_BitmapIndexedSetNode;
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionMapNode__f_content.length__I() >= 2))
}
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
  /*<skip>*/
}
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  var i = 0;
  while (iter.hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z($as_T2(iter.next__O())._1__O(), key)) {
      return i
    };
    i = ((1 + i) | 0)
  };
  return (-1)
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I()
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = this.get__O__I__I__I__s_Option(key, originalHash, hash, shift);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  } else {
    return this$1.get__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some($as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O()) : $m_s_None$())
  } else {
    return $m_s_None$()
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? f.apply__O() : $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(x1))._2__O())
  } else {
    return f.apply__O()
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0))
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? (Object.is($as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index, new $c_T2(key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector(new $c_T2(key, value))))
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = this.sci_HashCollisionMapNode__f_content;
    var pred = new $c_sjsr_AnonFunction1(((key$1) => ((keyValuePair$2) => {
      var keyValuePair = $as_T2(keyValuePair$2);
      return $m_sr_BoxesRunTime$().equals__O__O__Z(keyValuePair._1__O(), key$1)
    }))(key));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    if ((x1 === 1)) {
      var x1$2 = $as_T2(updatedContent.apply__I__O(0));
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2)
      };
      var k = x1$2._1__O();
      var v = x1$2._2__O();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash)
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent)
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I()
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._1__O()
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O()
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $as_T2(this.sci_HashCollisionMapNode__f_content.apply__I__O(index))
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(f)
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(new $c_sjsr_AnonFunction1(((f$1) => ((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = x0$1._1__O();
      var v = x0$1._2__O();
      return f$1.apply__O__O__O(k, v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }))(f)))
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = $as_T2(iter.next__O());
    f.apply__O__O__O__O(next._1__O(), next._2__O(), this.sci_HashCollisionMapNode__f_originalHash)
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    var x2 = $as_sci_HashCollisionMapNode(that);
    if ((this === x2)) {
      return true
    } else if (((this.sci_HashCollisionMapNode__f_hash === x2.sci_HashCollisionMapNode__f_hash) && (this.sci_HashCollisionMapNode__f_content.length__I() === x2.sci_HashCollisionMapNode__f_content.length__I()))) {
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var x1$2 = $as_T2(iter.next__O());
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2)
        };
        var key = x1$2._1__O();
        var value = x1$2._2__O();
        var index = x2.indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, $as_T2(x2.sci_HashCollisionMapNode__f_content.apply__I__O(index))._2__O())))) {
          return false
        }
      };
      return true
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, flipped) {
  var newContent = this.sci_HashCollisionMapNode__f_content.filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = newContent.length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_MapNode$();
    return this$1.sci_MapNode$__f_EmptyMapNode
  } else if ((newContentLength === 1)) {
    var x1 = $as_T2(newContent.head__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var k = x1._1__O();
    var v = x1._2__O();
    return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionMapNode__f_hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([this.sci_HashCollisionMapNode__f_originalHash])), 1, this.sci_HashCollisionMapNode__f_hash)
  } else {
    return ((newContentLength === this.sci_HashCollisionMapNode__f_content.length__I()) ? this : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent))
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul(this.sci_HashCollisionMapNode__f_content.length__I(), this.sci_HashCollisionMapNode__f_hash)
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content)
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index)
});
function $as_sci_HashCollisionMapNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionMapNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionMapNode"))
}
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)))
}
function $asArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionMapNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionMapNode;", depth))
}
var $d_sci_HashCollisionMapNode = new $TypeData().initClass({
  sci_HashCollisionMapNode: 0
}, false, "scala.collection.immutable.HashCollisionMapNode", {
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionMapNode.prototype.$classData = $d_sci_HashCollisionMapNode;
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionSetNode__f_content.length__I() >= 2))
}
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
  /*<skip>*/
}
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = this.sci_HashCollisionSetNode__f_content;
    return $f_sc_SeqOps__contains__O__Z(this$1, element)
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, this.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)))
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this
  } else {
    var this$2 = this.sci_HashCollisionSetNode__f_content;
    var pred = new $c_sjsr_AnonFunction1(((element$1) => ((element0$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2, element$1)))(element));
    var updatedContent = this$2.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    return ((x1 === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([updatedContent.apply__I__O(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent))
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.")
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I()
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_HashCollisionSetNode__f_content.apply__I__O(index)
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I()
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    f.apply__O__O(iter.next__O())
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul(this.sci_HashCollisionSetNode__f_content.length__I(), this.sci_HashCollisionSetNode__f_hash)
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((this === x2)) {
      return true
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === x2.sci_HashCollisionSetNode__f_hash)) {
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        var $$x2 = this$1.length__I();
        var this$2 = x2.sci_HashCollisionSetNode__f_content;
        var $$x1 = ($$x2 === this$2.length__I())
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var this$3 = this.sci_HashCollisionSetNode__f_content;
        var eta$0$1 = x2.sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && it.hasNext__Z())) {
          var arg1 = it.next__O();
          res = $f_sc_SeqOps__contains__O__Z(eta$0$1, arg1)
        };
        return res
      } else {
        return false
      }
    }
  } else {
    return false
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.")
});
$c_sci_HashCollisionSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    var x2 = $as_sci_HashCollisionSetNode(that);
    if ((x2 === this)) {
      return this
    } else {
      var newContent = null;
      var iter = x2.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var nextPayload = iter.next__O();
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        if ((!$f_sc_SeqOps__contains__O__Z(this$1, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.addAll__sc_IterableOnce__sci_VectorBuilder(this.sci_HashCollisionSetNode__f_content)
          };
          newContent.addOne__O__sci_VectorBuilder(nextPayload)
        }
      };
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent.result__sci_Vector()))
    }
  } else if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode")
  } else {
    throw new $c_s_MatchError(that)
  }
});
$c_sci_HashCollisionSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = iter.next__O();
    f.apply__O__O__O(next, this.sci_HashCollisionSetNode__f_originalHash)
  }
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content)
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index)
});
function $as_sci_HashCollisionSetNode(obj) {
  return (((obj instanceof $c_sci_HashCollisionSetNode) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashCollisionSetNode"))
}
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)))
}
function $asArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (($isArrayOf_sci_HashCollisionSetNode(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashCollisionSetNode;", depth))
}
var $d_sci_HashCollisionSetNode = new $TypeData().initClass({
  sci_HashCollisionSetNode: 0
}, false, "scala.collection.immutable.HashCollisionSetNode", {
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1,
  O: 1
});
$c_sci_HashCollisionSetNode.prototype.$classData = $d_sci_HashCollisionSetNode;
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode)
}
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
  /*<skip>*/
}
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashMap(elems)
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(source);
    return x2
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source);
    return this$2.result__sci_HashMap()
  }
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it)
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap
});
var $d_sci_HashMap$ = new $TypeData().initClass({
  sci_HashMap$: 0
}, false, "scala.collection.immutable.HashMap$", {
  sci_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap$.prototype.$classData = $d_sci_HashMap$;
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$()
  };
  return $n_sci_HashMap$
}
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode)
}
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
  /*<skip>*/
}
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(source);
    return x2
  } else if ((source.knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source);
    return this$2.result__sci_HashSet()
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder()
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source)
});
$c_sci_HashSet$.prototype.empty__O = (function() {
  return this.sci_HashSet$__f_EmptySet
});
var $d_sci_HashSet$ = new $TypeData().initClass({
  sci_HashSet$: 0
}, false, "scala.collection.immutable.HashSet$", {
  sci_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet$.prototype.$classData = $d_sci_HashSet$;
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$()
  };
  return $n_sci_HashSet$
}
/** @constructor */
function $c_sci_LazyList$State$Cons(head, tail) {
  this.sci_LazyList$State$Cons__f_head = null;
  this.sci_LazyList$State$Cons__f_tail = null;
  this.sci_LazyList$State$Cons__f_head = head;
  this.sci_LazyList$State$Cons__f_tail = tail
}
$c_sci_LazyList$State$Cons.prototype = new $h_O();
$c_sci_LazyList$State$Cons.prototype.constructor = $c_sci_LazyList$State$Cons;
/** @constructor */
function $h_sci_LazyList$State$Cons() {
  /*<skip>*/
}
$h_sci_LazyList$State$Cons.prototype = $c_sci_LazyList$State$Cons.prototype;
$c_sci_LazyList$State$Cons.prototype.head__O = (function() {
  return this.sci_LazyList$State$Cons__f_head
});
$c_sci_LazyList$State$Cons.prototype.tail__sci_LazyList = (function() {
  return this.sci_LazyList$State$Cons__f_tail
});
var $d_sci_LazyList$State$Cons = new $TypeData().initClass({
  sci_LazyList$State$Cons: 0
}, false, "scala.collection.immutable.LazyList$State$Cons", {
  sci_LazyList$State$Cons: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Cons.prototype.$classData = $d_sci_LazyList$State$Cons;
/** @constructor */
function $c_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$c_sci_LazyList$State$Empty$.prototype = new $h_O();
$c_sci_LazyList$State$Empty$.prototype.constructor = $c_sci_LazyList$State$Empty$;
/** @constructor */
function $h_sci_LazyList$State$Empty$() {
  /*<skip>*/
}
$h_sci_LazyList$State$Empty$.prototype = $c_sci_LazyList$State$Empty$.prototype;
$c_sci_LazyList$State$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.tail__sci_LazyList = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list")
});
$c_sci_LazyList$State$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_LazyList$State$Empty$ = new $TypeData().initClass({
  sci_LazyList$State$Empty$: 0
}, false, "scala.collection.immutable.LazyList$State$Empty$", {
  sci_LazyList$State$Empty$: 1,
  O: 1,
  sci_LazyList$State: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$State$Empty$.prototype.$classData = $d_sci_LazyList$State$Empty$;
var $n_sci_LazyList$State$Empty$;
function $m_sci_LazyList$State$Empty$() {
  if ((!$n_sci_LazyList$State$Empty$)) {
    $n_sci_LazyList$State$Empty$ = new $c_sci_LazyList$State$Empty$()
  };
  return $n_sci_LazyList$State$Empty$
}
/** @constructor */
function $c_sci_Map$() {
  /*<skip>*/
}
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
  /*<skip>*/
}
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Map(elems)
});
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    if (x2.isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$()
    }
  };
  if ($is_sci_Map(it)) {
    var x3 = $as_sci_Map(it);
    return x3
  };
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it);
  return this$2.result__sci_Map()
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it)
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$()
});
var $d_sci_Map$ = new $TypeData().initClass({
  sci_Map$: 0
}, false, "scala.collection.immutable.Map$", {
  sci_Map$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$.prototype.$classData = $d_sci_Map$;
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$()
  };
  return $n_sci_Map$
}
/** @constructor */
function $c_sci_Set$() {
  /*<skip>*/
}
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
  /*<skip>*/
}
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if ($is_sci_SortedSet(it)) {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$2.result__sci_Set()
  } else if ((it.knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$()
  } else if ($is_sci_Set(it)) {
    var x3 = $as_sci_Set(it);
    return x3
  } else {
    var this$3 = new $c_sci_SetBuilderImpl();
    var this$4 = this$3.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$4.result__sci_Set()
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl()
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source)
});
$c_sci_Set$.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$()
});
var $d_sci_Set$ = new $TypeData().initClass({
  sci_Set$: 0
}, false, "scala.collection.immutable.Set$", {
  sci_Set$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$.prototype.$classData = $d_sci_Set$;
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$()
  };
  return $n_sci_Set$
}
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var s = coll.knownSize__I();
  if ((s !== (-1))) {
    $thiz.sizeHint__I__V(((s + delta) | 0))
  }
}
function $is_scm_Builder(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Builder)))
}
function $as_scm_Builder(obj) {
  return (($is_scm_Builder(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Builder"))
}
function $isArrayOf_scm_Builder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Builder)))
}
function $asArrayOf_scm_Builder(obj, depth) {
  return (($isArrayOf_scm_Builder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Builder;", depth))
}
/** @constructor */
function $c_scm_HashMap$() {
  /*<skip>*/
}
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
  /*<skip>*/
}
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashMap(elems)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it)
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap())
});
var $d_scm_HashMap$ = new $TypeData().initClass({
  scm_HashMap$: 0
}, false, "scala.collection.mutable.HashMap$", {
  scm_HashMap$: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap$.prototype.$classData = $d_scm_HashMap$;
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$()
  };
  return $n_scm_HashMap$
}
/** @constructor */
function $c_scm_HashSet$() {
  /*<skip>*/
}
$c_scm_HashSet$.prototype = new $h_O();
$c_scm_HashSet$.prototype.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
  /*<skip>*/
}
$h_scm_HashSet$.prototype = $c_scm_HashSet$.prototype;
$c_scm_HashSet$.prototype.from__sc_IterableOnce__scm_HashSet = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  var this$1 = $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), cap, 0.75);
  return this$1.addAll__sc_IterableOnce__scm_HashSet(it)
});
$c_scm_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75)
});
$c_scm_HashSet$.prototype.empty__O = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet())
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_HashSet(source)
});
var $d_scm_HashSet$ = new $TypeData().initClass({
  scm_HashSet$: 0
}, false, "scala.collection.mutable.HashSet$", {
  scm_HashSet$: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashSet$.prototype.$classData = $d_scm_HashSet$;
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$()
  };
  return $n_scm_HashSet$
}
/** @constructor */
function $c_s_concurrent_BatchingExecutor$SyncBatch(outer, runnable) {
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_first = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_other = null;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_size = 0;
  this.s_concurrent_BatchingExecutor$AbstractBatch__f_$outer = null;
  $ct_s_concurrent_BatchingExecutor$AbstractBatch__s_concurrent_BatchingExecutor__jl_Runnable__Ajl_Runnable__I__(this, outer, runnable, $m_s_concurrent_BatchingExecutorStatics$().s_concurrent_BatchingExecutorStatics$__f_emptyBatchArray, 1)
}
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype = new $h_s_concurrent_BatchingExecutor$AbstractBatch();
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.constructor = $c_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $h_s_concurrent_BatchingExecutor$SyncBatch() {
  /*<skip>*/
}
$h_s_concurrent_BatchingExecutor$SyncBatch.prototype = $c_s_concurrent_BatchingExecutor$SyncBatch.prototype;
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.run__V = (function() {
  while (true) {
    try {
      this.runN__I__V(1024)
    } catch (e) {
      var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
      if (false) {
        var x2 = $as_jl_InterruptedException(e$2);
        $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(x2)
      } else if ((e$2 !== null)) {
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(e$2)
        } else {
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
        }
      } else {
        throw e
      }
    };
    if ((this.s_concurrent_BatchingExecutor$AbstractBatch__f_size > 0)) {
      continue
    };
    return (void 0)
  }
});
function $as_s_concurrent_BatchingExecutor$SyncBatch(obj) {
  return (((obj instanceof $c_s_concurrent_BatchingExecutor$SyncBatch) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.BatchingExecutor$SyncBatch"))
}
function $isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_BatchingExecutor$SyncBatch)))
}
function $asArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) {
  return (($isArrayOf_s_concurrent_BatchingExecutor$SyncBatch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.BatchingExecutor$SyncBatch;", depth))
}
var $d_s_concurrent_BatchingExecutor$SyncBatch = new $TypeData().initClass({
  s_concurrent_BatchingExecutor$SyncBatch: 0
}, false, "scala.concurrent.BatchingExecutor$SyncBatch", {
  s_concurrent_BatchingExecutor$SyncBatch: 1,
  s_concurrent_BatchingExecutor$AbstractBatch: 1,
  O: 1,
  jl_Runnable: 1
});
$c_s_concurrent_BatchingExecutor$SyncBatch.prototype.$classData = $d_s_concurrent_BatchingExecutor$SyncBatch;
/** @constructor */
function $c_s_concurrent_impl_Promise$Link(to) {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  $ct_ju_concurrent_atomic_AtomicReference__O__(this, to)
}
$c_s_concurrent_impl_Promise$Link.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$Link.prototype.constructor = $c_s_concurrent_impl_Promise$Link;
/** @constructor */
function $h_s_concurrent_impl_Promise$Link() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$Link.prototype = $c_s_concurrent_impl_Promise$Link.prototype;
$c_s_concurrent_impl_Promise$Link.prototype.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise = (function(owner) {
  var c = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value);
  var current = c;
  var target = c;
  while (true) {
    var value = target.ju_concurrent_atomic_AtomicReference__f_value;
    if ($is_s_concurrent_impl_Promise$Callbacks(value)) {
      if (this.compareAndSet__O__O__Z(current, target)) {
        return target
      } else {
        current = $as_s_concurrent_impl_Promise$DefaultPromise(this.ju_concurrent_atomic_AtomicReference__f_value)
      }
    } else if ((value instanceof $c_s_concurrent_impl_Promise$Link)) {
      target = $as_s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_impl_Promise$Link(value).ju_concurrent_atomic_AtomicReference__f_value)
    } else {
      owner.unlink__s_util_Try__V($as_s_util_Try(value));
      return owner
    }
  }
});
function $as_s_concurrent_impl_Promise$Link(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Link) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Link"))
}
function $isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Link)))
}
function $asArrayOf_s_concurrent_impl_Promise$Link(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Link(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Link;", depth))
}
var $d_s_concurrent_impl_Promise$Link = new $TypeData().initClass({
  s_concurrent_impl_Promise$Link: 0
}, false, "scala.concurrent.impl.Promise$Link", {
  s_concurrent_impl_Promise$Link: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_concurrent_impl_Promise$Link.prototype.$classData = $d_s_concurrent_impl_Promise$Link;
/** @constructor */
function $c_s_math_Equiv$() {
  /*<skip>*/
}
$c_s_math_Equiv$.prototype = new $h_O();
$c_s_math_Equiv$.prototype.constructor = $c_s_math_Equiv$;
/** @constructor */
function $h_s_math_Equiv$() {
  /*<skip>*/
}
$h_s_math_Equiv$.prototype = $c_s_math_Equiv$.prototype;
var $d_s_math_Equiv$ = new $TypeData().initClass({
  s_math_Equiv$: 0
}, false, "scala.math.Equiv$", {
  s_math_Equiv$: 1,
  O: 1,
  s_math_LowPriorityEquiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Equiv$.prototype.$classData = $d_s_math_Equiv$;
var $n_s_math_Equiv$;
function $m_s_math_Equiv$() {
  if ((!$n_s_math_Equiv$)) {
    $n_s_math_Equiv$ = new $c_s_math_Equiv$()
  };
  return $n_s_math_Equiv$
}
/** @constructor */
function $c_s_math_Ordering$() {
  /*<skip>*/
}
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
  /*<skip>*/
}
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass({
  s_math_Ordering$: 0
}, false, "scala.math.Ordering$", {
  s_math_Ordering$: 1,
  O: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$.prototype.$classData = $d_s_math_Ordering$;
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$()
  };
  return $n_s_math_Ordering$
}
function $is_s_math_PartialOrdering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_PartialOrdering)))
}
function $as_s_math_PartialOrdering(obj) {
  return (($is_s_math_PartialOrdering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.PartialOrdering"))
}
function $isArrayOf_s_math_PartialOrdering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_PartialOrdering)))
}
function $asArrayOf_s_math_PartialOrdering(obj, depth) {
  return (($isArrayOf_s_math_PartialOrdering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.PartialOrdering;", depth))
}
/** @constructor */
function $c_s_math_ScalaNumber() {
  /*<skip>*/
}
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
  /*<skip>*/
}
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $as_s_math_ScalaNumber(obj) {
  return (((obj instanceof $c_s_math_ScalaNumber) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.ScalaNumber"))
}
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)))
}
function $asArrayOf_s_math_ScalaNumber(obj, depth) {
  return (($isArrayOf_s_math_ScalaNumber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.ScalaNumber;", depth))
}
/** @constructor */
function $c_s_reflect_NoManifest$() {
  /*<skip>*/
}
$c_s_reflect_NoManifest$.prototype = new $h_O();
$c_s_reflect_NoManifest$.prototype.constructor = $c_s_reflect_NoManifest$;
/** @constructor */
function $h_s_reflect_NoManifest$() {
  /*<skip>*/
}
$h_s_reflect_NoManifest$.prototype = $c_s_reflect_NoManifest$.prototype;
$c_s_reflect_NoManifest$.prototype.toString__T = (function() {
  return "<?>"
});
var $d_s_reflect_NoManifest$ = new $TypeData().initClass({
  s_reflect_NoManifest$: 0
}, false, "scala.reflect.NoManifest$", {
  s_reflect_NoManifest$: 1,
  O: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1
});
$c_s_reflect_NoManifest$.prototype.$classData = $d_s_reflect_NoManifest$;
var $n_s_reflect_NoManifest$;
function $m_s_reflect_NoManifest$() {
  if ((!$n_s_reflect_NoManifest$)) {
    $n_s_reflect_NoManifest$ = new $c_s_reflect_NoManifest$()
  };
  return $n_s_reflect_NoManifest$
}
/** @constructor */
function $c_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
  /*<skip>*/
}
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_sr_Nothing$ = new $TypeData().initClass({
  sr_Nothing$: 0
}, false, "scala.runtime.Nothing$", {
  sr_Nothing$: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
/** @constructor */
function $c_sjs_js_Any$() {
  /*<skip>*/
}
$c_sjs_js_Any$.prototype = new $h_O();
$c_sjs_js_Any$.prototype.constructor = $c_sjs_js_Any$;
/** @constructor */
function $h_sjs_js_Any$() {
  /*<skip>*/
}
$h_sjs_js_Any$.prototype = $c_sjs_js_Any$.prototype;
$c_sjs_js_Any$.prototype.fromFunction0__F0__sjs_js_Function0 = (function(f) {
  return ((f$1) => (() => f$1.apply__O()))(f)
});
$c_sjs_js_Any$.prototype.fromFunction1__F1__sjs_js_Function1 = (function(f) {
  return ((f$2) => ((arg1$2) => f$2.apply__O__O(arg1$2)))(f)
});
var $d_sjs_js_Any$ = new $TypeData().initClass({
  sjs_js_Any$: 0
}, false, "scala.scalajs.js.Any$", {
  sjs_js_Any$: 1,
  O: 1,
  sjs_js_LowPrioAnyImplicits: 1,
  sjs_js_LowestPrioAnyImplicits: 1
});
$c_sjs_js_Any$.prototype.$classData = $d_sjs_js_Any$;
var $n_sjs_js_Any$;
function $m_sjs_js_Any$() {
  if ((!$n_sjs_js_Any$)) {
    $n_sjs_js_Any$ = new $c_sjs_js_Any$()
  };
  return $n_sjs_js_Any$
}
/** @constructor */
function $c_sjsr_AnonFunction0(f) {
  this.sjsr_AnonFunction0__f_f = null;
  this.sjsr_AnonFunction0__f_f = f
}
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
  /*<skip>*/
}
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
$c_sjsr_AnonFunction0.prototype.apply__O = (function() {
  return (0, this.sjsr_AnonFunction0__f_f)()
});
var $d_sjsr_AnonFunction0 = new $TypeData().initClass({
  sjsr_AnonFunction0: 0
}, false, "scala.scalajs.runtime.AnonFunction0", {
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  O: 1,
  F0: 1
});
$c_sjsr_AnonFunction0.prototype.$classData = $d_sjsr_AnonFunction0;
/** @constructor */
function $c_sjsr_AnonFunction1(f) {
  this.sjsr_AnonFunction1__f_f = null;
  this.sjsr_AnonFunction1__f_f = f
}
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
  /*<skip>*/
}
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
$c_sjsr_AnonFunction1.prototype.apply__O__O = (function(arg1) {
  return (0, this.sjsr_AnonFunction1__f_f)(arg1)
});
var $d_sjsr_AnonFunction1 = new $TypeData().initClass({
  sjsr_AnonFunction1: 0
}, false, "scala.scalajs.runtime.AnonFunction1", {
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  O: 1,
  F1: 1
});
$c_sjsr_AnonFunction1.prototype.$classData = $d_sjsr_AnonFunction1;
/** @constructor */
function $c_sjsr_AnonFunction2(f) {
  this.sjsr_AnonFunction2__f_f = null;
  this.sjsr_AnonFunction2__f_f = f
}
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
  /*<skip>*/
}
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
$c_sjsr_AnonFunction2.prototype.apply__O__O__O = (function(arg1, arg2) {
  return (0, this.sjsr_AnonFunction2__f_f)(arg1, arg2)
});
var $d_sjsr_AnonFunction2 = new $TypeData().initClass({
  sjsr_AnonFunction2: 0
}, false, "scala.scalajs.runtime.AnonFunction2", {
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  O: 1,
  F2: 1
});
$c_sjsr_AnonFunction2.prototype.$classData = $d_sjsr_AnonFunction2;
/** @constructor */
function $c_sjsr_AnonFunction3(f) {
  this.sjsr_AnonFunction3__f_f = null;
  this.sjsr_AnonFunction3__f_f = f
}
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
  /*<skip>*/
}
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
$c_sjsr_AnonFunction3.prototype.apply__O__O__O__O = (function(arg1, arg2, arg3) {
  return (0, this.sjsr_AnonFunction3__f_f)(arg1, arg2, arg3)
});
var $d_sjsr_AnonFunction3 = new $TypeData().initClass({
  sjsr_AnonFunction3: 0
}, false, "scala.scalajs.runtime.AnonFunction3", {
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  O: 1,
  F3: 1
});
$c_sjsr_AnonFunction3.prototype.$classData = $d_sjsr_AnonFunction3;
/** @constructor */
function $c_sjsr_AnonFunction4(f) {
  this.sjsr_AnonFunction4__f_f = null;
  this.sjsr_AnonFunction4__f_f = f
}
$c_sjsr_AnonFunction4.prototype = new $h_sr_AbstractFunction4();
$c_sjsr_AnonFunction4.prototype.constructor = $c_sjsr_AnonFunction4;
/** @constructor */
function $h_sjsr_AnonFunction4() {
  /*<skip>*/
}
$h_sjsr_AnonFunction4.prototype = $c_sjsr_AnonFunction4.prototype;
$c_sjsr_AnonFunction4.prototype.apply__O__O__O__O__O = (function(arg1, arg2, arg3, arg4) {
  return (0, this.sjsr_AnonFunction4__f_f)(arg1, arg2, arg3, arg4)
});
var $d_sjsr_AnonFunction4 = new $TypeData().initClass({
  sjsr_AnonFunction4: 0
}, false, "scala.scalajs.runtime.AnonFunction4", {
  sjsr_AnonFunction4: 1,
  sr_AbstractFunction4: 1,
  O: 1,
  F4: 1
});
$c_sjsr_AnonFunction4.prototype.$classData = $d_sjsr_AnonFunction4;
/** @constructor */
function $c_s_util_Random$() {
  this.s_util_Random__f_self = null;
  $ct_s_util_Random__ju_Random__(this, $ct_ju_Random__(new $c_ju_Random()))
}
$c_s_util_Random$.prototype = new $h_s_util_Random();
$c_s_util_Random$.prototype.constructor = $c_s_util_Random$;
/** @constructor */
function $h_s_util_Random$() {
  /*<skip>*/
}
$h_s_util_Random$.prototype = $c_s_util_Random$.prototype;
var $d_s_util_Random$ = new $TypeData().initClass({
  s_util_Random$: 0
}, false, "scala.util.Random$", {
  s_util_Random$: 1,
  s_util_Random: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Random$.prototype.$classData = $d_s_util_Random$;
var $n_s_util_Random$;
function $m_s_util_Random$() {
  if ((!$n_s_util_Random$)) {
    $n_s_util_Random$ = new $c_s_util_Random$()
  };
  return $n_s_util_Random$
}
function $as_s_util_control_ControlThrowable(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.control.ControlThrowable"))
}
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)))
}
function $asArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (($isArrayOf_s_util_control_ControlThrowable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.control.ControlThrowable;", depth))
}
/** @constructor */
function $c_Lsnabbdom_VNodeData$() {
  this.Lsnabbdom_VNodeData$__f_empty = null;
  $n_Lsnabbdom_VNodeData$ = this;
  $m_Lsnabbdom_VNodeData$();
  $m_Lsnabbdom_VNodeData$();
  var props = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var attrs = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var classes = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var style = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var dataset = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var on = $m_sci_Map$EmptyMap$();
  $m_Lsnabbdom_VNodeData$();
  var hook = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var key = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var ns = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var fn = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var args = $m_s_None$();
  $m_Lsnabbdom_VNodeData$();
  var is = $m_s_None$();
  this.Lsnabbdom_VNodeData$__f_empty = new $c_Lsnabbdom_VNodeData(props, attrs, classes, style, dataset, on, hook, key, ns, fn, args, is)
}
$c_Lsnabbdom_VNodeData$.prototype = new $h_O();
$c_Lsnabbdom_VNodeData$.prototype.constructor = $c_Lsnabbdom_VNodeData$;
/** @constructor */
function $h_Lsnabbdom_VNodeData$() {
  /*<skip>*/
}
$h_Lsnabbdom_VNodeData$.prototype = $c_Lsnabbdom_VNodeData$.prototype;
$c_Lsnabbdom_VNodeData$.prototype.toString__T = (function() {
  return "VNodeData"
});
var $d_Lsnabbdom_VNodeData$ = new $TypeData().initClass({
  Lsnabbdom_VNodeData$: 0
}, false, "snabbdom.VNodeData$", {
  Lsnabbdom_VNodeData$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lsnabbdom_VNodeData$.prototype.$classData = $d_Lsnabbdom_VNodeData$;
var $n_Lsnabbdom_VNodeData$;
function $m_Lsnabbdom_VNodeData$() {
  if ((!$n_Lsnabbdom_VNodeData$)) {
    $n_Lsnabbdom_VNodeData$ = new $c_Lsnabbdom_VNodeData$()
  };
  return $n_Lsnabbdom_VNodeData$
}
/** @constructor */
function $c_Ltyrian_Attribute$() {
  this.Ltyrian_Attribute$__f_empty = null;
  $n_Ltyrian_Attribute$ = this;
  this.Ltyrian_Attribute$__f_empty = ($m_Ltyrian_Attribute$(), new $c_Ltyrian_Attribute("", ""))
}
$c_Ltyrian_Attribute$.prototype = new $h_O();
$c_Ltyrian_Attribute$.prototype.constructor = $c_Ltyrian_Attribute$;
/** @constructor */
function $h_Ltyrian_Attribute$() {
  /*<skip>*/
}
$h_Ltyrian_Attribute$.prototype = $c_Ltyrian_Attribute$.prototype;
$c_Ltyrian_Attribute$.prototype.toString__T = (function() {
  return "Attribute"
});
var $d_Ltyrian_Attribute$ = new $TypeData().initClass({
  Ltyrian_Attribute$: 0
}, false, "tyrian.Attribute$", {
  Ltyrian_Attribute$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_Attribute$.prototype.$classData = $d_Ltyrian_Attribute$;
var $n_Ltyrian_Attribute$;
function $m_Ltyrian_Attribute$() {
  if ((!$n_Ltyrian_Attribute$)) {
    $n_Ltyrian_Attribute$ = new $c_Ltyrian_Attribute$()
  };
  return $n_Ltyrian_Attribute$
}
/** @constructor */
function $c_Ltyrian_Cmd$() {
  this.Ltyrian_Cmd$__f_given_CanEqual_Cmd_Cmd$lzy1 = null;
  this.Ltyrian_Cmd$__f_given_CanEqual_Cmd_Cmdbitmap$1 = false
}
$c_Ltyrian_Cmd$.prototype = new $h_O();
$c_Ltyrian_Cmd$.prototype.constructor = $c_Ltyrian_Cmd$;
/** @constructor */
function $h_Ltyrian_Cmd$() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$.prototype = $c_Ltyrian_Cmd$.prototype;
$c_Ltyrian_Cmd$.prototype.merge__Ltyrian_Cmd__Ltyrian_Cmd__Ltyrian_Cmd = (function(a, b) {
  var x = $m_Ltyrian_Cmd$None$();
  if ((x === a)) {
    var x$3 = $m_Ltyrian_Cmd$None$();
    if ((x$3 === b)) {
      return $m_Ltyrian_Cmd$None$()
    };
    return b
  };
  var x$5 = $m_Ltyrian_Cmd$None$();
  if ((x$5 === b)) {
    return a
  };
  return new $c_Ltyrian_Cmd$Combine(a, b)
});
$c_Ltyrian_Cmd$.prototype.combineAll__sci_List__Ltyrian_Cmd = (function(list) {
  var ev = new $c_Ltyrian_Cmd$$anon$1();
  return $as_Ltyrian_Cmd($f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(ev, list))
});
var $d_Ltyrian_Cmd$ = new $TypeData().initClass({
  Ltyrian_Cmd$: 0
}, false, "tyrian.Cmd$", {
  Ltyrian_Cmd$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_Cmd$.prototype.$classData = $d_Ltyrian_Cmd$;
var $n_Ltyrian_Cmd$;
function $m_Ltyrian_Cmd$() {
  if ((!$n_Ltyrian_Cmd$)) {
    $n_Ltyrian_Cmd$ = new $c_Ltyrian_Cmd$()
  };
  return $n_Ltyrian_Cmd$
}
/** @constructor */
function $c_Ltyrian_Cmd$SideEffect$() {
  /*<skip>*/
}
$c_Ltyrian_Cmd$SideEffect$.prototype = new $h_O();
$c_Ltyrian_Cmd$SideEffect$.prototype.constructor = $c_Ltyrian_Cmd$SideEffect$;
/** @constructor */
function $h_Ltyrian_Cmd$SideEffect$() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$SideEffect$.prototype = $c_Ltyrian_Cmd$SideEffect$.prototype;
$c_Ltyrian_Cmd$SideEffect$.prototype.toString__T = (function() {
  return "SideEffect"
});
$c_Ltyrian_Cmd$SideEffect$.prototype.apply__F0__Lcats_effect_kernel_Sync__Ltyrian_Cmd$SideEffect = (function(thunk, evidence$2) {
  var task = evidence$2.delay__F0__O(thunk);
  return new $c_Ltyrian_Cmd$SideEffect(task)
});
var $d_Ltyrian_Cmd$SideEffect$ = new $TypeData().initClass({
  Ltyrian_Cmd$SideEffect$: 0
}, false, "tyrian.Cmd$SideEffect$", {
  Ltyrian_Cmd$SideEffect$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_Cmd$SideEffect$.prototype.$classData = $d_Ltyrian_Cmd$SideEffect$;
var $n_Ltyrian_Cmd$SideEffect$;
function $m_Ltyrian_Cmd$SideEffect$() {
  if ((!$n_Ltyrian_Cmd$SideEffect$)) {
    $n_Ltyrian_Cmd$SideEffect$ = new $c_Ltyrian_Cmd$SideEffect$()
  };
  return $n_Ltyrian_Cmd$SideEffect$
}
/** @constructor */
function $c_Ltyrian_Property$() {
  this.Ltyrian_Property$__f_empty = null;
  $n_Ltyrian_Property$ = this;
  this.Ltyrian_Property$__f_empty = ($m_Ltyrian_Property$(), new $c_Ltyrian_Property("", ""))
}
$c_Ltyrian_Property$.prototype = new $h_O();
$c_Ltyrian_Property$.prototype.constructor = $c_Ltyrian_Property$;
/** @constructor */
function $h_Ltyrian_Property$() {
  /*<skip>*/
}
$h_Ltyrian_Property$.prototype = $c_Ltyrian_Property$.prototype;
$c_Ltyrian_Property$.prototype.toString__T = (function() {
  return "Property"
});
var $d_Ltyrian_Property$ = new $TypeData().initClass({
  Ltyrian_Property$: 0
}, false, "tyrian.Property$", {
  Ltyrian_Property$: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Ltyrian_Property$.prototype.$classData = $d_Ltyrian_Property$;
var $n_Ltyrian_Property$;
function $m_Ltyrian_Property$() {
  if ((!$n_Ltyrian_Property$)) {
    $n_Ltyrian_Property$ = new $c_Ltyrian_Property$()
  };
  return $n_Ltyrian_Property$
}
/** @constructor */
function $c_Lcats_Always(f) {
  this.Lcats_Always__f_f = null;
  this.Lcats_Always__f_f = f
}
$c_Lcats_Always.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Always.prototype.constructor = $c_Lcats_Always;
/** @constructor */
function $h_Lcats_Always() {
  /*<skip>*/
}
$h_Lcats_Always.prototype = $c_Lcats_Always.prototype;
$c_Lcats_Always.prototype.value__O = (function() {
  return this.Lcats_Always__f_f.apply__O()
});
$c_Lcats_Always.prototype.memoize__Lcats_Eval = (function() {
  return new $c_Lcats_Later(this.Lcats_Always__f_f)
});
var $d_Lcats_Always = new $TypeData().initClass({
  Lcats_Always: 0
}, false, "cats.Always", {
  Lcats_Always: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Always.prototype.$classData = $d_Lcats_Always;
function $p_Lcats_Eval$__addToMemo$2__Lcats_Eval$Memoize__F1($thiz, m) {
  return new $c_sjsr_AnonFunction1(((m$2) => ((a) => {
    m$2.Lcats_Eval$Memoize__f_result = new $c_s_Some(a);
    return new $c_Lcats_Now(a)
  }))(m))
}
function $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O($thiz, curr, fs) {
  var fs$tailLocal1 = fs;
  var curr$tailLocal1 = curr;
  while (true) {
    var x52 = curr$tailLocal1;
    if ((x52 instanceof $c_Lcats_Eval$FlatMap)) {
      var c = $as_Lcats_Eval$FlatMap(x52);
      var x26 = $as_Lcats_Eval(c.start__F0().apply__O());
      if ((x26 instanceof $c_Lcats_Eval$FlatMap)) {
        var cc = $as_Lcats_Eval$FlatMap(x26);
        var first = c.run__F1();
        var rest = fs$tailLocal1;
        var nextFs = new $c_Lcats_Eval$Many(first, rest);
        var curr$tailLocal1$tmp1 = $as_Lcats_Eval(cc.start__F0().apply__O());
        var first$1 = cc.run__F1();
        var fs$tailLocal1$tmp1 = new $c_Lcats_Eval$Many(first$1, nextFs);
        curr$tailLocal1 = curr$tailLocal1$tmp1;
        fs$tailLocal1 = fs$tailLocal1$tmp1;
        continue
      };
      if ((x26 instanceof $c_Lcats_Eval$Defer)) {
        var call = $as_Lcats_Eval$Defer(x26);
        var curr$tailLocal1$tmp2 = $as_Lcats_Eval(call.Lcats_Eval$Defer__f_thunk.apply__O());
        var first$2 = c.run__F1();
        var rest$1 = fs$tailLocal1;
        var fs$tailLocal1$tmp2 = new $c_Lcats_Eval$Many(first$2, rest$1);
        curr$tailLocal1 = curr$tailLocal1$tmp2;
        fs$tailLocal1 = fs$tailLocal1$tmp2;
        continue
      };
      if ((x26 instanceof $c_Lcats_Eval$Memoize)) {
        var x28 = $as_Lcats_Eval$Memoize(x26);
        var x30 = x28.Lcats_Eval$Memoize__f_eval;
        var x23 = x28.Lcats_Eval$Memoize__f_result;
        if ((x23 instanceof $c_s_Some)) {
          var a = $as_s_Some(x23).s_Some__f_value;
          curr$tailLocal1 = $as_Lcats_Eval(c.run__F1().apply__O__O(a));
          continue
        };
        var x = $m_s_None$();
        if ((x === x23)) {
          var first$3 = c.run__F1();
          var rest$2 = fs$tailLocal1;
          var nextFs$2 = new $c_Lcats_Eval$Many(first$3, rest$2);
          var first$4 = $p_Lcats_Eval$__addToMemo$2__Lcats_Eval$Memoize__F1($thiz, x28);
          var fs$tailLocal1$tmp3 = new $c_Lcats_Eval$Many(first$4, nextFs$2);
          curr$tailLocal1 = x30;
          fs$tailLocal1 = fs$tailLocal1$tmp3;
          continue
        };
        throw new $c_s_MatchError(x23)
      };
      if ((x26 instanceof $c_Lcats_Eval$Leaf)) {
        var xx = $as_Lcats_Eval$Leaf(x26);
        curr$tailLocal1 = $as_Lcats_Eval(c.run__F1().apply__O__O(xx.value__O()));
        continue
      };
      throw new $c_s_MatchError(x26)
    };
    if ((x52 instanceof $c_Lcats_Eval$Defer)) {
      var call$2 = $as_Lcats_Eval$Defer(x52);
      curr$tailLocal1 = $as_Lcats_Eval(call$2.Lcats_Eval$Defer__f_thunk.apply__O());
      continue
    };
    if ((x52 instanceof $c_Lcats_Eval$Memoize)) {
      var m = $as_Lcats_Eval$Memoize(x52);
      var x41 = m.Lcats_Eval$Memoize__f_result;
      if ((x41 instanceof $c_s_Some)) {
        var a$2 = $as_s_Some(x41).s_Some__f_value;
        var x33 = fs$tailLocal1;
        if ((x33 instanceof $c_Lcats_Eval$Many)) {
          var x$1 = $as_Lcats_Eval$Many(x33);
          var x39 = x$1.Lcats_Eval$Many__f_first;
          var x40 = x$1.Lcats_Eval$Many__f_rest;
          var curr$tailLocal1$tmp4 = $as_Lcats_Eval(x39.apply__O__O(a$2));
          curr$tailLocal1 = curr$tailLocal1$tmp4;
          fs$tailLocal1 = x40;
          continue
        };
        if ((x33 instanceof $c_Lcats_Eval$Ident)) {
          var x$1$1 = $as_Lcats_Eval$Ident(x33);
          return a$2
        };
        throw new $c_s_MatchError(x33)
      };
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        var curr$tailLocal1$tmp5 = m.Lcats_Eval$Memoize__f_eval;
        var first$5 = $p_Lcats_Eval$__addToMemo$2__Lcats_Eval$Memoize__F1($thiz, m);
        var rest$3 = fs$tailLocal1;
        var fs$tailLocal1$tmp5 = new $c_Lcats_Eval$Many(first$5, rest$3);
        curr$tailLocal1 = curr$tailLocal1$tmp5;
        fs$tailLocal1 = fs$tailLocal1$tmp5;
        continue
      };
      throw new $c_s_MatchError(x41)
    };
    if ((x52 instanceof $c_Lcats_Eval$Leaf)) {
      var x$5 = $as_Lcats_Eval$Leaf(x52);
      var a1 = x$5.value__O();
      var x44 = fs$tailLocal1;
      if ((x44 instanceof $c_Lcats_Eval$Many)) {
        var x$1$2 = $as_Lcats_Eval$Many(x44);
        var x50 = x$1$2.Lcats_Eval$Many__f_first;
        var x51 = x$1$2.Lcats_Eval$Many__f_rest;
        var curr$tailLocal1$tmp6 = $as_Lcats_Eval(x50.apply__O__O(a1));
        curr$tailLocal1 = curr$tailLocal1$tmp6;
        fs$tailLocal1 = x51;
        continue
      };
      if ((x44 instanceof $c_Lcats_Eval$Ident)) {
        var x$1$3 = $as_Lcats_Eval$Ident(x44);
        return a1
      };
      throw new $c_s_MatchError(x44)
    };
    throw new $c_s_MatchError(x52)
  }
}
/** @constructor */
function $c_Lcats_Eval$() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_EvalInstances__f_catsDeferForEval = null;
  this.Lcats_EvalInstances__f_catsReducibleForEval = null;
  this.Lcats_EvalInstances__f_catsRepresentableForEval = null;
  this.Lcats_Eval$__f_Unit = null;
  this.Lcats_Eval$__f_True = null;
  this.Lcats_Eval$__f_False = null;
  this.Lcats_Eval$__f_Zero = null;
  this.Lcats_Eval$__f_One = null;
  $ct_Lcats_EvalInstances__(this);
  $n_Lcats_Eval$ = this;
  this.Lcats_Eval$__f_Unit = new $c_Lcats_Now((void 0));
  this.Lcats_Eval$__f_True = new $c_Lcats_Now(true);
  this.Lcats_Eval$__f_False = new $c_Lcats_Now(false);
  this.Lcats_Eval$__f_Zero = new $c_Lcats_Now(0);
  this.Lcats_Eval$__f_One = new $c_Lcats_Now(1)
}
$c_Lcats_Eval$.prototype = new $h_Lcats_EvalInstances();
$c_Lcats_Eval$.prototype.constructor = $c_Lcats_Eval$;
/** @constructor */
function $h_Lcats_Eval$() {
  /*<skip>*/
}
$h_Lcats_Eval$.prototype = $c_Lcats_Eval$.prototype;
$c_Lcats_Eval$.prototype.later__F0__Lcats_Eval = (function(a) {
  return new $c_Lcats_Later(new $c_sjsr_AnonFunction0(((a$2) => (() => a$2.apply__O()))(a)))
});
$c_Lcats_Eval$.prototype.always__F0__Lcats_Eval = (function(a) {
  return new $c_Lcats_Always(new $c_sjsr_AnonFunction0(((a$2) => (() => a$2.apply__O()))(a)))
});
$c_Lcats_Eval$.prototype.cats$Eval$$$evaluate__Lcats_Eval__O = (function(e) {
  var this$1 = $m_s_$less$colon$less$();
  var e$1 = this$1.s_$less$colon$less$__f_singleton;
  return $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O(this, e, new $c_Lcats_Eval$Ident(e$1))
});
$c_Lcats_Eval$.prototype.cats$Eval$$$_$$anon$superArg$1$1__F0__F0 = (function(a$5) {
  return new $c_sjsr_AnonFunction0(((a$5$2) => (() => $as_Lcats_Eval(a$5$2.apply__O())))(a$5))
});
var $d_Lcats_Eval$ = new $TypeData().initClass({
  Lcats_Eval$: 0
}, false, "cats.Eval$", {
  Lcats_Eval$: 1,
  Lcats_EvalInstances: 1,
  Lcats_EvalInstances0: 1,
  Lcats_EvalInstances1: 1,
  O: 1
});
$c_Lcats_Eval$.prototype.$classData = $d_Lcats_Eval$;
var $n_Lcats_Eval$;
function $m_Lcats_Eval$() {
  if ((!$n_Lcats_Eval$)) {
    $n_Lcats_Eval$ = new $c_Lcats_Eval$()
  };
  return $n_Lcats_Eval$
}
/** @constructor */
function $c_Lcats_Eval$$anon$1(f$2$2, c$1) {
  this.Lcats_Eval$$anon$1__f_start = null;
  this.Lcats_Eval$$anon$1__f_run = null;
  this.Lcats_Eval$$anon$1__f_start = c$1.start__F0();
  this.Lcats_Eval$$anon$1__f_run = new $c_sjsr_AnonFunction1(((this$1, f$2, c$1$2) => ((s) => new $c_Lcats_Eval$$anon$4(f$2, c$1$2, s, this$1)))(this, f$2$2, c$1))
}
$c_Lcats_Eval$$anon$1.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1.prototype.constructor = $c_Lcats_Eval$$anon$1;
/** @constructor */
function $h_Lcats_Eval$$anon$1() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$1.prototype = $c_Lcats_Eval$$anon$1.prototype;
$c_Lcats_Eval$$anon$1.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1__f_start
});
$c_Lcats_Eval$$anon$1.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1__f_run
});
var $d_Lcats_Eval$$anon$1 = new $TypeData().initClass({
  Lcats_Eval$$anon$1: 0
}, false, "cats.Eval$$anon$1", {
  Lcats_Eval$$anon$1: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$1.prototype.$classData = $d_Lcats_Eval$$anon$1;
/** @constructor */
function $c_Lcats_Eval$$anon$2(f$5, c$5) {
  this.Lcats_Eval$$anon$2__f_start = null;
  this.Lcats_Eval$$anon$2__f_run = null;
  this.Lcats_Eval$$anon$2__f_start = c$5.Lcats_Eval$Defer__f_thunk;
  this.Lcats_Eval$$anon$2__f_run = f$5
}
$c_Lcats_Eval$$anon$2.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$2.prototype.constructor = $c_Lcats_Eval$$anon$2;
/** @constructor */
function $h_Lcats_Eval$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$2.prototype = $c_Lcats_Eval$$anon$2.prototype;
$c_Lcats_Eval$$anon$2.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$2__f_start
});
$c_Lcats_Eval$$anon$2.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$2__f_run
});
var $d_Lcats_Eval$$anon$2 = new $TypeData().initClass({
  Lcats_Eval$$anon$2: 0
}, false, "cats.Eval$$anon$2", {
  Lcats_Eval$$anon$2: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$2.prototype.$classData = $d_Lcats_Eval$$anon$2;
/** @constructor */
function $c_Lcats_Eval$$anon$3(f$6, outer) {
  this.Lcats_Eval$$anon$3__f_start = null;
  this.Lcats_Eval$$anon$3__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_Eval$$anon$3__f_start = new $c_sjsr_AnonFunction0(((\u03b4outer) => (() => \u03b4outer))(outer));
  this.Lcats_Eval$$anon$3__f_run = f$6
}
$c_Lcats_Eval$$anon$3.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$3.prototype.constructor = $c_Lcats_Eval$$anon$3;
/** @constructor */
function $h_Lcats_Eval$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$3.prototype = $c_Lcats_Eval$$anon$3.prototype;
$c_Lcats_Eval$$anon$3.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$3__f_start
});
$c_Lcats_Eval$$anon$3.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$3__f_run
});
var $d_Lcats_Eval$$anon$3 = new $TypeData().initClass({
  Lcats_Eval$$anon$3: 0
}, false, "cats.Eval$$anon$3", {
  Lcats_Eval$$anon$3: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$3.prototype.$classData = $d_Lcats_Eval$$anon$3;
/** @constructor */
function $c_Lcats_Eval$$anon$4(f$4, c$3$2, s$1$2, outer) {
  this.Lcats_Eval$$anon$4__f_start = null;
  this.Lcats_Eval$$anon$4__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_Eval$$anon$4__f_start = new $c_sjsr_AnonFunction0(((c$3, s$1) => (() => $as_Lcats_Eval(c$3.run__F1().apply__O__O(s$1))))(c$3$2, s$1$2));
  this.Lcats_Eval$$anon$4__f_run = f$4
}
$c_Lcats_Eval$$anon$4.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$4.prototype.constructor = $c_Lcats_Eval$$anon$4;
/** @constructor */
function $h_Lcats_Eval$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$4.prototype = $c_Lcats_Eval$$anon$4.prototype;
$c_Lcats_Eval$$anon$4.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$4__f_start
});
$c_Lcats_Eval$$anon$4.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$4__f_run
});
var $d_Lcats_Eval$$anon$4 = new $TypeData().initClass({
  Lcats_Eval$$anon$4: 0
}, false, "cats.Eval$$anon$4", {
  Lcats_Eval$$anon$4: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$4.prototype.$classData = $d_Lcats_Eval$$anon$4;
/** @constructor */
function $c_Lcats_Eval$$anon$5(a$7) {
  this.Lcats_Eval$Defer__f_thunk = null;
  $ct_Lcats_Eval$Defer__F0__(this, $m_Lcats_Eval$().cats$Eval$$$_$$anon$superArg$1$1__F0__F0(a$7))
}
$c_Lcats_Eval$$anon$5.prototype = new $h_Lcats_Eval$Defer();
$c_Lcats_Eval$$anon$5.prototype.constructor = $c_Lcats_Eval$$anon$5;
/** @constructor */
function $h_Lcats_Eval$$anon$5() {
  /*<skip>*/
}
$h_Lcats_Eval$$anon$5.prototype = $c_Lcats_Eval$$anon$5.prototype;
var $d_Lcats_Eval$$anon$5 = new $TypeData().initClass({
  Lcats_Eval$$anon$5: 0
}, false, "cats.Eval$$anon$5", {
  Lcats_Eval$$anon$5: 1,
  Lcats_Eval$Defer: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$$anon$5.prototype.$classData = $d_Lcats_Eval$$anon$5;
function $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O($thiz, fa, f, B) {
  return $thiz.foldLeft__O__O__F2__O(fa, B.empty__O(), new $c_sjsr_AnonFunction2(((f$2, B$2) => ((b, a) => B$2.combine__O__O__O(b, f$2.apply__O__O(a))))(f, B)))
}
function $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O($thiz, fa, f, G) {
  return $thiz.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((G$2) => (() => G$2.pure__O__O((void 0))))(G))), new $c_sjsr_AnonFunction2(((f$2, G$3) => ((a, acc) => {
    var acc$1 = $as_Lcats_Eval(acc);
    return G$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$2.apply__O__O(a), acc$1, new $c_sjsr_AnonFunction2(((_$17, _$18) => {
      $as_jl_Void(_$18)
    })))
  }))(f, G))).value__O()
}
/** @constructor */
function $c_Lcats_Later(f) {
  this.Lcats_Later__f_thunk = null;
  this.Lcats_Later__f_value$lzy1 = null;
  this.Lcats_Later__f_valuebitmap$1 = false;
  this.Lcats_Later__f_thunk = f
}
$c_Lcats_Later.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Later.prototype.constructor = $c_Lcats_Later;
/** @constructor */
function $h_Lcats_Later() {
  /*<skip>*/
}
$h_Lcats_Later.prototype = $c_Lcats_Later.prototype;
$c_Lcats_Later.prototype.value__O = (function() {
  if ((!this.Lcats_Later__f_valuebitmap$1)) {
    var result = this.Lcats_Later__f_thunk.apply__O();
    this.Lcats_Later__f_thunk = null;
    this.Lcats_Later__f_value$lzy1 = result;
    this.Lcats_Later__f_valuebitmap$1 = true
  };
  return this.Lcats_Later__f_value$lzy1
});
$c_Lcats_Later.prototype.memoize__Lcats_Eval = (function() {
  return this
});
var $d_Lcats_Later = new $TypeData().initClass({
  Lcats_Later: 0
}, false, "cats.Later", {
  Lcats_Later: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Later.prototype.$classData = $d_Lcats_Later;
/** @constructor */
function $c_Lcats_Parallel$$anon$2(evidence$31$1) {
  this.Lcats_Parallel$$anon$2__f_monad = null;
  this.Lcats_Parallel$$anon$2__f_applicative = null;
  this.Lcats_Parallel$$anon$2__f_sequential = null;
  this.Lcats_Parallel$$anon$2__f_parallel = null;
  this.Lcats_Parallel$$anon$2__f_monad = evidence$31$1;
  this.Lcats_Parallel$$anon$2__f_applicative = evidence$31$1;
  this.Lcats_Parallel$$anon$2__f_sequential = new $c_Lcats_arrow_FunctionK$$anon$4();
  this.Lcats_Parallel$$anon$2__f_parallel = new $c_Lcats_arrow_FunctionK$$anon$4()
}
$c_Lcats_Parallel$$anon$2.prototype = new $h_O();
$c_Lcats_Parallel$$anon$2.prototype.constructor = $c_Lcats_Parallel$$anon$2;
/** @constructor */
function $h_Lcats_Parallel$$anon$2() {
  /*<skip>*/
}
$h_Lcats_Parallel$$anon$2.prototype = $c_Lcats_Parallel$$anon$2.prototype;
$c_Lcats_Parallel$$anon$2.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_sequential
});
$c_Lcats_Parallel$$anon$2.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_parallel
});
var $d_Lcats_Parallel$$anon$2 = new $TypeData().initClass({
  Lcats_Parallel$$anon$2: 0
}, false, "cats.Parallel$$anon$2", {
  Lcats_Parallel$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
});
$c_Lcats_Parallel$$anon$2.prototype.$classData = $d_Lcats_Parallel$$anon$2;
/** @constructor */
function $c_Lcats_Show$$anon$1() {
  /*<skip>*/
}
$c_Lcats_Show$$anon$1.prototype = new $h_O();
$c_Lcats_Show$$anon$1.prototype.constructor = $c_Lcats_Show$$anon$1;
/** @constructor */
function $h_Lcats_Show$$anon$1() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$1.prototype = $c_Lcats_Show$$anon$1.prototype;
var $d_Lcats_Show$$anon$1 = new $TypeData().initClass({
  Lcats_Show$$anon$1: 0
}, false, "cats.Show$$anon$1", {
  Lcats_Show$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1
});
$c_Lcats_Show$$anon$1.prototype.$classData = $d_Lcats_Show$$anon$1;
/** @constructor */
function $c_Lcats_Show$$anon$3(f$2) {
  this.Lcats_Show$$anon$3__f_f$1 = null;
  this.Lcats_Show$$anon$3__f_f$1 = f$2
}
$c_Lcats_Show$$anon$3.prototype = new $h_O();
$c_Lcats_Show$$anon$3.prototype.constructor = $c_Lcats_Show$$anon$3;
/** @constructor */
function $h_Lcats_Show$$anon$3() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$3.prototype = $c_Lcats_Show$$anon$3.prototype;
$c_Lcats_Show$$anon$3.prototype.show__O__T = (function(a) {
  return $as_T(this.Lcats_Show$$anon$3__f_f$1.apply__O__O(a))
});
var $d_Lcats_Show$$anon$3 = new $TypeData().initClass({
  Lcats_Show$$anon$3: 0
}, false, "cats.Show$$anon$3", {
  Lcats_Show$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
});
$c_Lcats_Show$$anon$3.prototype.$classData = $d_Lcats_Show$$anon$3;
/** @constructor */
function $c_Lcats_Show$$anon$4() {
  /*<skip>*/
}
$c_Lcats_Show$$anon$4.prototype = new $h_O();
$c_Lcats_Show$$anon$4.prototype.constructor = $c_Lcats_Show$$anon$4;
/** @constructor */
function $h_Lcats_Show$$anon$4() {
  /*<skip>*/
}
$h_Lcats_Show$$anon$4.prototype = $c_Lcats_Show$$anon$4.prototype;
$c_Lcats_Show$$anon$4.prototype.show__O__T = (function(a) {
  return $dp_toString__T(a)
});
var $d_Lcats_Show$$anon$4 = new $TypeData().initClass({
  Lcats_Show$$anon$4: 0
}, false, "cats.Show$$anon$4", {
  Lcats_Show$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
});
$c_Lcats_Show$$anon$4.prototype.$classData = $d_Lcats_Show$$anon$4;
function $p_Lcats_data_Chain$ChainIterator__go$1__O($thiz) {
  while (true) {
    if ((($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.hasNext__Z())) {
      return $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.next__O()
    } else {
      $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
      var x147 = $thiz.Lcats_data_Chain$ChainIterator__f_c;
      if ((x147 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x$1 = $as_Lcats_data_Chain$Singleton(x147);
        var x157 = x$1.Lcats_data_Chain$Singleton__f_a;
        if ($thiz.Lcats_data_Chain$ChainIterator__f_rights.isEmpty__Z()) {
          var $$x1 = null
        } else {
          var head = $as_Lcats_data_Chain$NonEmpty($thiz.Lcats_data_Chain$ChainIterator__f_rights.head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($thiz.Lcats_data_Chain$ChainIterator__f_rights.tail__O());
          var $$x1 = head
        };
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $$x1;
        return x157
      };
      if ((x147 instanceof $c_Lcats_data_Chain$Append)) {
        var x$1$1 = $as_Lcats_data_Chain$Append(x147);
        var x153 = x$1$1.Lcats_data_Chain$Append__f_leftNE;
        var x154 = x$1$1.Lcats_data_Chain$Append__f_rightNE;
        $thiz.Lcats_data_Chain$ChainIterator__f_c = x153;
        var this$3 = $thiz.Lcats_data_Chain$ChainIterator__f_rights;
        $thiz.Lcats_data_Chain$ChainIterator__f_rights = new $c_sci_$colon$colon(x154, this$3);
        continue
      };
      if ((x147 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x$1$2 = $as_Lcats_data_Chain$Wrap(x147);
        var x150 = x$1$2.Lcats_data_Chain$Wrap__f_seq;
        if ($thiz.Lcats_data_Chain$ChainIterator__f_rights.isEmpty__Z()) {
          var $$x2 = null
        } else {
          var head$2 = $as_Lcats_data_Chain$NonEmpty($thiz.Lcats_data_Chain$ChainIterator__f_rights.head__O());
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $as_sci_List($thiz.Lcats_data_Chain$ChainIterator__f_rights.tail__O());
          var $$x2 = head$2
        };
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $$x2;
        $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = x150.iterator__sc_Iterator();
        return $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.next__O()
      };
      if ((x147 === null)) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next called on empty iterator")
      };
      throw new $c_s_MatchError(x147)
    }
  }
}
/** @constructor */
function $c_Lcats_data_Chain$ChainIterator(self) {
  this.Lcats_data_Chain$ChainIterator__f_c = null;
  this.Lcats_data_Chain$ChainIterator__f_rights = null;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
  this.Lcats_data_Chain$ChainIterator__f_c = self;
  this.Lcats_data_Chain$ChainIterator__f_rights = $m_s_package$().s_package$__f_Nil;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null
}
$c_Lcats_data_Chain$ChainIterator.prototype = new $h_O();
$c_Lcats_data_Chain$ChainIterator.prototype.constructor = $c_Lcats_data_Chain$ChainIterator;
/** @constructor */
function $h_Lcats_data_Chain$ChainIterator() {
  /*<skip>*/
}
$h_Lcats_data_Chain$ChainIterator.prototype = $c_Lcats_data_Chain$ChainIterator.prototype;
$c_Lcats_data_Chain$ChainIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lcats_data_Chain$ChainIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lcats_data_Chain$ChainIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lcats_data_Chain$ChainIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_Lcats_data_Chain$ChainIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lcats_data_Chain$ChainIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lcats_data_Chain$ChainIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lcats_data_Chain$ChainIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lcats_data_Chain$ChainIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lcats_data_Chain$ChainIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lcats_data_Chain$ChainIterator.prototype.hasNext__Z = (function() {
  return ((this.Lcats_data_Chain$ChainIterator__f_c !== null) || ((this.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && this.Lcats_data_Chain$ChainIterator__f_currentIterator.hasNext__Z()))
});
$c_Lcats_data_Chain$ChainIterator.prototype.next__O = (function() {
  return $p_Lcats_data_Chain$ChainIterator__go$1__O(this)
});
var $d_Lcats_data_Chain$ChainIterator = new $TypeData().initClass({
  Lcats_data_Chain$ChainIterator: 0
}, false, "cats.data.Chain$ChainIterator", {
  Lcats_data_Chain$ChainIterator: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lcats_data_Chain$ChainIterator.prototype.$classData = $d_Lcats_data_Chain$ChainIterator;
function $ct_Lcats_data_ChainInstances__($thiz) {
  $thiz.Lcats_data_ChainInstances__f_catsDataInstancesForChain = new $c_Lcats_data_ChainInstances$$anon$1();
  $thiz.Lcats_data_ChainInstances__f_catsDataTraverseFilterForChain = new $c_Lcats_data_ChainInstances$$anon$2();
  return $thiz
}
function $ps_Lcats_data_ChainInstances__loop$2__Lcats_Eval__F2__Lcats_data_Chain__Lcats_Eval(lb$1, f$18, as) {
  var x171 = as.uncons__s_Option();
  if ((x171 instanceof $c_s_Some)) {
    var x173 = $as_T2($as_s_Some(x171).s_Some__f_value);
    if ((x173 !== null)) {
      var h = x173._1__O();
      var t = $as_Lcats_data_Chain(x173._2__O());
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0(((lb$1$2, f$18$2, t$2) => (() => $ps_Lcats_data_ChainInstances__loop$2__Lcats_Eval__F2__Lcats_data_Chain__Lcats_Eval(lb$1$2, f$18$2, t$2)))(lb$1, f$18, t));
      return $as_Lcats_Eval(f$18.apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a)))
    }
  };
  var x = $m_s_None$();
  if ((x === x171)) {
    return lb$1
  };
  throw new $c_s_MatchError(x171)
}
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$1$$_$go$2__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f$22, rest, acc) {
  var acc$tailLocal2 = acc;
  var rest$tailLocal1 = rest;
  while (true) {
    var x191 = rest$tailLocal1;
    if ((x191 instanceof $c_sci_$colon$colon)) {
      var x192 = $as_sci_$colon$colon(x191);
      var x194 = x192.sci_$colon$colon__f_next;
      var hd = $as_Lcats_data_Chain(x192.sci_$colon$colon__f_head);
      var x186 = hd.uncons__s_Option();
      if ((x186 instanceof $c_s_Some)) {
        var x188 = $as_T2($as_s_Some(x186).s_Some__f_value);
        if ((x188 !== null)) {
          var hdh = $as_s_util_Either(x188._1__O());
          var hdt = $as_Lcats_data_Chain(x188._2__O());
          if ((hdh instanceof $c_s_util_Right)) {
            var b = $as_s_util_Right(hdh).s_util_Right__f_value;
            var rest$tailLocal1$tmp1 = new $c_sci_$colon$colon(hdt, x194);
            var this$1 = acc$tailLocal2;
            var acc$tailLocal2$tmp1 = this$1.append__O__Lcats_data_Chain(b);
            rest$tailLocal1 = rest$tailLocal1$tmp1;
            acc$tailLocal2 = acc$tailLocal2$tmp1;
            continue
          };
          if ((hdh instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(hdh).s_util_Left__f_value;
            var elem$3 = $as_Lcats_data_Chain(f$22.apply__O__O(a));
            var this$2 = new $c_sci_$colon$colon(hdt, x194);
            rest$tailLocal1 = new $c_sci_$colon$colon(elem$3, this$2);
            continue
          };
          throw new $c_s_MatchError(hdh)
        }
      };
      var x = $m_s_None$();
      if ((x === x186)) {
        rest$tailLocal1 = x194;
        continue
      };
      throw new $c_s_MatchError(x186)
    };
    return acc$tailLocal2
  }
}
/** @constructor */
function $c_Lcats_data_ChainInstances() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_ChainInstances__f_catsDataTraverseFilterForChain = null
}
$c_Lcats_data_ChainInstances.prototype = new $h_Lcats_data_ChainInstances1();
$c_Lcats_data_ChainInstances.prototype.constructor = $c_Lcats_data_ChainInstances;
/** @constructor */
function $h_Lcats_data_ChainInstances() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances.prototype = $c_Lcats_data_ChainInstances.prototype;
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances$$anon$2.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$2.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$2;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances$$anon$2.prototype = $c_Lcats_data_ChainInstances$$anon$2.prototype;
var $d_Lcats_data_ChainInstances$$anon$2 = new $TypeData().initClass({
  Lcats_data_ChainInstances$$anon$2: 0
}, false, "cats.data.ChainInstances$$anon$2", {
  Lcats_data_ChainInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_data_ChainInstances$$anon$2.prototype.$classData = $d_Lcats_data_ChainInstances$$anon$2;
/** @constructor */
function $c_Lcats_data_Kleisli(run) {
  this.Lcats_data_Kleisli__f_run = null;
  this.Lcats_data_Kleisli__f_run = run
}
$c_Lcats_data_Kleisli.prototype = new $h_O();
$c_Lcats_data_Kleisli.prototype.constructor = $c_Lcats_data_Kleisli;
/** @constructor */
function $h_Lcats_data_Kleisli() {
  /*<skip>*/
}
$h_Lcats_data_Kleisli.prototype = $c_Lcats_data_Kleisli.prototype;
$c_Lcats_data_Kleisli.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Kleisli.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_Kleisli.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_Kleisli)) {
    var x$0$2 = $as_Lcats_data_Kleisli(x$0);
    var x = this.Lcats_data_Kleisli__f_run;
    var x$2 = x$0$2.Lcats_data_Kleisli__f_run;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_data_Kleisli.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_data_Kleisli.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Kleisli.prototype.productPrefix__T = (function() {
  return "Kleisli"
});
$c_Lcats_data_Kleisli.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Kleisli__f_run
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_data_Kleisli.prototype.ap__Lcats_data_Kleisli__Lcats_Apply__Lcats_evidence_As__Lcats_data_Kleisli = (function(f, F, ev) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, f$2, F$2, ev$2) => ((a) => {
    var fb = F$2.map__O__F1__O(this$1.Lcats_data_Kleisli__f_run.apply__O__O(a), new $c_sjsr_AnonFunction1(((ev$2$2) => ((a$2) => $as_F1($m_Lcats_evidence_As$().witness__Lcats_evidence_As__F1(ev$2$2).apply__O__O(a$2))))(ev$2)));
    var fc = f$2.Lcats_data_Kleisli__f_run.apply__O__O(a);
    return F$2.ap__O__O__O(fb, fc)
  }))(this, f, F, ev));
  return new $c_Lcats_data_Kleisli(run)
});
$c_Lcats_data_Kleisli.prototype.map__F1__Lcats_Functor__Lcats_data_Kleisli = (function(f, F) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, f$2, F$2) => ((a) => F$2.map__O__F1__O(this$1.Lcats_data_Kleisli__f_run.apply__O__O(a), f$2)))(this, f, F));
  return new $c_Lcats_data_Kleisli(run)
});
$c_Lcats_data_Kleisli.prototype.flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli = (function(f, F) {
  return $m_Lcats_data_Kleisli$().shift__F1__Lcats_FlatMap__Lcats_data_Kleisli(new $c_sjsr_AnonFunction1(((this$1, f$2, F$2) => ((a) => F$2.flatMap__O__F1__O(this$1.Lcats_data_Kleisli__f_run.apply__O__O(a), new $c_sjsr_AnonFunction1(((f$7$2, a$2) => ((b) => $as_Lcats_data_Kleisli(f$7$2.apply__O__O(b)).Lcats_data_Kleisli__f_run.apply__O__O(a$2)))(f$2, a)))))(this, f, F)), F)
});
function $as_Lcats_data_Kleisli(obj) {
  return (((obj instanceof $c_Lcats_data_Kleisli) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Kleisli"))
}
function $isArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Kleisli)))
}
function $asArrayOf_Lcats_data_Kleisli(obj, depth) {
  return (($isArrayOf_Lcats_data_Kleisli(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Kleisli;", depth))
}
var $d_Lcats_data_Kleisli = new $TypeData().initClass({
  Lcats_data_Kleisli: 0
}, false, "cats.data.Kleisli", {
  Lcats_data_Kleisli: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Kleisli.prototype.$classData = $d_Lcats_data_Kleisli;
function $f_Lcats_data_KleisliFunctor__void__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, fa$2) => ((a) => this$1.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1.void__O__O(fa$2.Lcats_data_Kleisli__f_run.apply__O__O(a))))($thiz, fa));
  return new $c_Lcats_data_Kleisli(run)
}
/** @constructor */
function $c_Lcats_data_KleisliInstances6() {
  /*<skip>*/
}
$c_Lcats_data_KleisliInstances6.prototype = new $h_Lcats_data_KleisliInstances7();
$c_Lcats_data_KleisliInstances6.prototype.constructor = $c_Lcats_data_KleisliInstances6;
/** @constructor */
function $h_Lcats_data_KleisliInstances6() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances6.prototype = $c_Lcats_data_KleisliInstances6.prototype;
/** @constructor */
function $c_Lcats_effect_ContState(wasFinalizing) {
  this.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = 0;
  this.Lcats_effect_ContState__f_wasFinalizing = false;
  this.Lcats_effect_ContState__f_result = null;
  this.Lcats_effect_ContState__f_handle = null;
  this.Lcats_effect_ContState__f_wasFinalizing = wasFinalizing;
  $ct_ju_concurrent_atomic_AtomicInteger__I__(this, 0)
}
$c_Lcats_effect_ContState.prototype = new $h_ju_concurrent_atomic_AtomicInteger();
$c_Lcats_effect_ContState.prototype.constructor = $c_Lcats_effect_ContState;
/** @constructor */
function $h_Lcats_effect_ContState() {
  /*<skip>*/
}
$h_Lcats_effect_ContState.prototype = $c_Lcats_effect_ContState.prototype;
var $d_Lcats_effect_ContState = new $TypeData().initClass({
  Lcats_effect_ContState: 0
}, false, "cats.effect.ContState", {
  Lcats_effect_ContState: 1,
  ju_concurrent_atomic_AtomicInteger: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_ContState.prototype.$classData = $d_Lcats_effect_ContState;
/** @constructor */
function $c_Lcats_effect_IOFiber$$anon$1(id$2, outer) {
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = 0;
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = null;
  this.Lcats_effect_IOFiber$$anon$1__f_id$1 = id$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_IOFiber$$anon$1__f_$outer = outer
}
$c_Lcats_effect_IOFiber$$anon$1.prototype = new $h_O();
$c_Lcats_effect_IOFiber$$anon$1.prototype.constructor = $c_Lcats_effect_IOFiber$$anon$1;
/** @constructor */
function $h_Lcats_effect_IOFiber$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_IOFiber$$anon$1.prototype = $c_Lcats_effect_IOFiber$$anon$1.prototype;
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__Lcats_effect_IO__Lcats_effect_IO = (function(ioa) {
  var id = this.Lcats_effect_IOFiber$$anon$1__f_id$1;
  var self = this.Lcats_effect_IOFiber$$anon$1__f_$outer;
  return new $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self)
});
$c_Lcats_effect_IOFiber$$anon$1.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_IO__Lcats_effect_IO($as_Lcats_effect_IO(fa))
});
var $d_Lcats_effect_IOFiber$$anon$1 = new $TypeData().initClass({
  Lcats_effect_IOFiber$$anon$1: 0
}, false, "cats.effect.IOFiber$$anon$1", {
  Lcats_effect_IOFiber$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
});
$c_Lcats_effect_IOFiber$$anon$1.prototype.$classData = $d_Lcats_effect_IOFiber$$anon$1;
function $p_Lcats_effect_kernel_Deferred$AsyncDeferred__loop$1__F1__J($thiz, awakeReader$1) {
  while (true) {
    var x12 = $as_Lcats_effect_kernel_Deferred$State($thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.ju_concurrent_atomic_AtomicReference__f_value);
    if ((x12 instanceof $c_Lcats_effect_kernel_Deferred$State$Set)) {
      var x$1 = $as_Lcats_effect_kernel_Deferred$State$Set(x12);
      var x19 = x$1.Lcats_effect_kernel_Deferred$State$Set__f_a;
      awakeReader$1.apply__O__O(x19);
      return $m_Lcats_effect_kernel_Deferred$State$().Lcats_effect_kernel_Deferred$State$__f_dummyId
    };
    if ((x12 instanceof $c_Lcats_effect_kernel_Deferred$State$Unset)) {
      var x13 = $as_Lcats_effect_kernel_Deferred$State$Unset(x12);
      var x15 = x13.Lcats_effect_kernel_Deferred$State$Unset__f_readers;
      var t = x13.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var readers = x15.updated__J__O__sci_LongMap($uJ(new $c_RTLong(lo, hi)), awakeReader$1);
      var lo$1 = ((1 + lo) | 0);
      var hi$1 = ((lo$1 === 0) ? ((1 + hi) | 0) : hi);
      var updated = new $c_Lcats_effect_kernel_Deferred$State$Unset(readers, new $c_RTLong(lo$1, hi$1));
      if ((!$thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.compareAndSet__O__O__Z(x13, updated))) {
        continue
      } else {
        return new $c_RTLong(lo, hi)
      }
    };
    throw new $c_s_MatchError(x12)
  }
}
function $p_Lcats_effect_kernel_Deferred$AsyncDeferred__loop$2__J__V($thiz, id$1) {
  while (true) {
    matchResult9: {
      var x20 = $as_Lcats_effect_kernel_Deferred$State($thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.ju_concurrent_atomic_AtomicReference__f_value);
      if ((x20 instanceof $c_Lcats_effect_kernel_Deferred$State$Set)) {
        var x$1 = $as_Lcats_effect_kernel_Deferred$State$Set(x20);
        break matchResult9
      };
      if ((x20 instanceof $c_Lcats_effect_kernel_Deferred$State$Unset)) {
        var x21 = $as_Lcats_effect_kernel_Deferred$State$Unset(x20);
        var x23 = x21.Lcats_effect_kernel_Deferred$State$Unset__f_readers;
        var t = x21.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
        var readers = x23.removed__J__sci_LongMap(id$1);
        var t$1 = x21.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var updated = new $c_Lcats_effect_kernel_Deferred$State$Unset(readers, new $c_RTLong(lo$1, hi$1));
        if ((!$thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.compareAndSet__O__O__Z(x21, updated))) {
          continue
        };
        break matchResult9
      };
      throw new $c_s_MatchError(x20)
    };
    return (void 0)
  }
}
function $p_Lcats_effect_kernel_Deferred$AsyncDeferred__notifyReaders$2__O__sci_LongMap__O($thiz, a$2, readers) {
  var cursor = readers.valuesIterator__sc_Iterator();
  var this$1 = $thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F;
  var acc = this$1.pure__O__O((void 0));
  while (cursor.hasNext__Z()) {
    var next = $as_F1(cursor.next__O());
    var task = $thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((a$2$2, next$2) => (() => {
      next$2.apply__O__O(a$2$2)
    }))(a$2, next)));
    var fa = acc;
    acc = $m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((task$2) => (() => task$2))(task)), $thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F)
  };
  return acc
}
function $p_Lcats_effect_kernel_Deferred$AsyncDeferred__loop$3__O__O($thiz, a$3) {
  while (true) {
    var x44 = $as_Lcats_effect_kernel_Deferred$State($thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.ju_concurrent_atomic_AtomicReference__f_value);
    if ((x44 instanceof $c_Lcats_effect_kernel_Deferred$State$Set)) {
      var x$1 = $as_Lcats_effect_kernel_Deferred$State$Set(x44);
      return $thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F.pure__O__O(false)
    };
    if ((x44 instanceof $c_Lcats_effect_kernel_Deferred$State$Unset)) {
      var x45 = $as_Lcats_effect_kernel_Deferred$State$Unset(x44);
      var x47 = x45.Lcats_effect_kernel_Deferred$State$Unset__f_readers;
      var t = x45.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
      var updated = new $c_Lcats_effect_kernel_Deferred$State$Set(a$3);
      if ((!$thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.compareAndSet__O__O__Z(x45, updated))) {
        continue
      } else {
        if (x47.isEmpty__Z()) {
          var this$4 = $thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F;
          var notify = this$4.pure__O__O((void 0))
        } else {
          var notify = $p_Lcats_effect_kernel_Deferred$AsyncDeferred__notifyReaders$2__O__sci_LongMap__O($thiz, a$3, x47)
        };
        var tc = $thiz.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F;
        var this$6 = new $c_Lcats_Functor$$anon$4(notify, tc);
        return this$6.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$6.Lcats_Functor$$anon$4__f_self, true)
      }
    };
    throw new $c_s_MatchError(x44)
  }
}
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$AsyncDeferred(F) {
  this.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F = null;
  this.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref = null;
  this.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F = F;
  var readers = $m_sci_LongMap$Nil$();
  var t = $m_Lcats_effect_kernel_Deferred$State$().Lcats_effect_kernel_Deferred$State$__f_initialId;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  this.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref = $ct_ju_concurrent_atomic_AtomicReference__O__(new $c_ju_concurrent_atomic_AtomicReference(), new $c_Lcats_effect_kernel_Deferred$State$Unset(readers, new $c_RTLong(lo, hi)))
}
$c_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred$AsyncDeferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$AsyncDeferred() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype = $c_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype;
$c_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype.get__O = (function() {
  var this$13 = this.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F;
  var thunk = new $c_sjsr_AnonFunction0(((this$1) => (() => {
    var x28 = $as_Lcats_effect_kernel_Deferred$State(this$1.Lcats_effect_kernel_Deferred$AsyncDeferred__f_ref.ju_concurrent_atomic_AtomicReference__f_value);
    if ((x28 instanceof $c_Lcats_effect_kernel_Deferred$State$Set)) {
      var x$1 = $as_Lcats_effect_kernel_Deferred$State$Set(x28);
      var x35 = x$1.Lcats_effect_kernel_Deferred$State$Set__f_a;
      return this$1.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F.pure__O__O(x35)
    };
    if ((x28 instanceof $c_Lcats_effect_kernel_Deferred$State$Unset)) {
      var x$1$1 = $as_Lcats_effect_kernel_Deferred$State$Unset(x28);
      var t = x$1$1.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
      return this$1.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F.async__F1__O(new $c_sjsr_AnonFunction1(((this$4) => ((cb) => {
        var cb$1 = $as_F1(cb);
        var resume = new $c_sjsr_AnonFunction1(((cb$2) => ((a) => {
          cb$2.apply__O__O(($m_s_package$(), new $c_s_util_Right(a)))
        }))(cb$1));
        var target = this$4.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$2$1, resume$2) => (() => $p_Lcats_effect_kernel_Deferred$AsyncDeferred__loop$1__F1__J(this$2$1, resume$2)))(this$4, resume)));
        var tc = this$4.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F;
        var this$12 = new $c_Lcats_Functor$$anon$4(target, tc);
        var f = new $c_sjsr_AnonFunction1(((this$3$1) => ((id) => {
          var t$1 = $uJ(id);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          var a$1 = this$3$1.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$8, id$2) => (() => {
            $p_Lcats_effect_kernel_Deferred$AsyncDeferred__loop$2__J__V(this$8, id$2)
          }))(this$3$1, new $c_RTLong(lo$1, hi$1))));
          return new $c_s_Some(a$1)
        }))(this$4));
        return this$12.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$12.Lcats_Functor$$anon$4__f_self, f)
      }))(this$1)))
    };
    throw new $c_s_MatchError(x28)
  }))(this));
  return $f_Lcats_effect_kernel_Sync__defer__F0__O(this$13, thunk)
});
$c_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype.complete__O__O = (function(a) {
  var this$2 = this.Lcats_effect_kernel_Deferred$AsyncDeferred__f_F;
  var thunk = new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => $p_Lcats_effect_kernel_Deferred$AsyncDeferred__loop$3__O__O(this$1, a$2)))(this, a));
  return $f_Lcats_effect_kernel_Sync__defer__F0__O(this$2, thunk)
});
var $d_Lcats_effect_kernel_Deferred$AsyncDeferred = new $TypeData().initClass({
  Lcats_effect_kernel_Deferred$AsyncDeferred: 0
}, false, "cats.effect.kernel.Deferred$AsyncDeferred", {
  Lcats_effect_kernel_Deferred$AsyncDeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  O: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
});
$c_Lcats_effect_kernel_Deferred$AsyncDeferred.prototype.$classData = $d_Lcats_effect_kernel_Deferred$AsyncDeferred;
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$TransformedDeferred(underlying, trans) {
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying = null;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans = null;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying = underlying;
  this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans = trans
}
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype = new $h_Lcats_effect_kernel_Deferred();
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.constructor = $c_Lcats_effect_kernel_Deferred$TransformedDeferred;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$TransformedDeferred() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype = $c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype;
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.get__O = (function() {
  return this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans.apply__O__O(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying.get__O())
});
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.complete__O__O = (function(a) {
  return this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_trans.apply__O__O(this.Lcats_effect_kernel_Deferred$TransformedDeferred__f_underlying.complete__O__O(a))
});
var $d_Lcats_effect_kernel_Deferred$TransformedDeferred = new $TypeData().initClass({
  Lcats_effect_kernel_Deferred$TransformedDeferred: 0
}, false, "cats.effect.kernel.Deferred$TransformedDeferred", {
  Lcats_effect_kernel_Deferred$TransformedDeferred: 1,
  Lcats_effect_kernel_Deferred: 1,
  O: 1,
  Lcats_effect_kernel_DeferredSource: 1,
  Lcats_effect_kernel_DeferredSink: 1
});
$c_Lcats_effect_kernel_Deferred$TransformedDeferred.prototype.$classData = $d_Lcats_effect_kernel_Deferred$TransformedDeferred;
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$13(nat$9) {
  this.Lcats_effect_kernel_MonadCancel$$anon$13__f_nat$1 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$13__f_nat$1 = nat$9
}
$c_Lcats_effect_kernel_MonadCancel$$anon$13.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$$anon$13.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$13;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$13() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_MonadCancel$$anon$13.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$13.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$13.prototype.apply__Lcats_data_Kleisli__Lcats_data_Kleisli = (function(stfa) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, stfa$2) => ((r) => this$1.Lcats_effect_kernel_MonadCancel$$anon$13__f_nat$1.apply__O__O(stfa$2.Lcats_data_Kleisli__f_run.apply__O__O(r))))(this, stfa));
  return new $c_Lcats_data_Kleisli(run)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$13.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_data_Kleisli__Lcats_data_Kleisli($as_Lcats_data_Kleisli(fa))
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$13 = new $TypeData().initClass({
  Lcats_effect_kernel_MonadCancel$$anon$13: 0
}, false, "cats.effect.kernel.MonadCancel$$anon$13", {
  Lcats_effect_kernel_MonadCancel$$anon$13: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
});
$c_Lcats_effect_kernel_MonadCancel$$anon$13.prototype.$classData = $d_Lcats_effect_kernel_MonadCancel$$anon$13;
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$9() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_MonadCancel$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$9() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_MonadCancel$$anon$9.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$9.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$9.prototype.apply__O__O = (function(fa) {
  return fa
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$9 = new $TypeData().initClass({
  Lcats_effect_kernel_MonadCancel$$anon$9: 0
}, false, "cats.effect.kernel.MonadCancel$$anon$9", {
  Lcats_effect_kernel_MonadCancel$$anon$9: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
});
$c_Lcats_effect_kernel_MonadCancel$$anon$9.prototype.$classData = $d_Lcats_effect_kernel_MonadCancel$$anon$9;
function $is_Lcats_effect_kernel_Outcome(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Outcome)))
}
function $as_Lcats_effect_kernel_Outcome(obj) {
  return (($is_Lcats_effect_kernel_Outcome(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome"))
}
function $isArrayOf_Lcats_effect_kernel_Outcome(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome)))
}
function $asArrayOf_Lcats_effect_kernel_Outcome(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Outcome$.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$.prototype.constructor = $c_Lcats_effect_kernel_Outcome$;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Outcome$.prototype = $c_Lcats_effect_kernel_Outcome$.prototype;
var $d_Lcats_effect_kernel_Outcome$ = new $TypeData().initClass({
  Lcats_effect_kernel_Outcome$: 0
}, false, "cats.effect.kernel.Outcome$", {
  Lcats_effect_kernel_Outcome$: 1,
  O: 1,
  Lcats_effect_kernel_LowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_effect_kernel_Outcome$.prototype.$classData = $d_Lcats_effect_kernel_Outcome$;
var $n_Lcats_effect_kernel_Outcome$;
function $m_Lcats_effect_kernel_Outcome$() {
  if ((!$n_Lcats_effect_kernel_Outcome$)) {
    $n_Lcats_effect_kernel_Outcome$ = new $c_Lcats_effect_kernel_Outcome$()
  };
  return $n_Lcats_effect_kernel_Outcome$
}
function $p_Lcats_effect_kernel_Ref$SyncRef__spin$2__F1__V($thiz, f$6) {
  while (true) {
    var a = $thiz.Lcats_effect_kernel_Ref$SyncRef__f_ar.ju_concurrent_atomic_AtomicReference__f_value;
    var u = f$6.apply__O__O(a);
    if ((!$thiz.Lcats_effect_kernel_Ref$SyncRef__f_ar.compareAndSet__O__O__Z(a, u))) {
      continue
    };
    return (void 0)
  }
}
function $p_Lcats_effect_kernel_Ref$SyncRef__spin$3__F1__O($thiz, f$7) {
  while (true) {
    var a = $thiz.Lcats_effect_kernel_Ref$SyncRef__f_ar.ju_concurrent_atomic_AtomicReference__f_value;
    var u = f$7.apply__O__O(a);
    if ((!$thiz.Lcats_effect_kernel_Ref$SyncRef__f_ar.compareAndSet__O__O__Z(a, u))) {
      /*<skip>*/
    } else {
      return u
    }
  }
}
function $p_Lcats_effect_kernel_Ref$SyncRef__spin$4__F1__O($thiz, f$8) {
  while (true) {
    var c = $thiz.Lcats_effect_kernel_Ref$SyncRef__f_ar.ju_concurrent_atomic_AtomicReference__f_value;
    matchResult3: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x6 = $as_T2(f$8.apply__O__O(c));
      if ((x6 !== null)) {
        var u = x6._1__O();
        var b = x6._2__O();
        var \u03b42$___1 = u;
        var \u03b42$___2 = b;
        break matchResult3
      };
      throw new $c_s_MatchError(x6)
    };
    var u$2 = \u03b42$___1;
    var b$2 = \u03b42$___2;
    if ((!$thiz.Lcats_effect_kernel_Ref$SyncRef__f_ar.compareAndSet__O__O__Z(c, u$2))) {
      /*<skip>*/
    } else {
      return b$2
    }
  }
}
/** @constructor */
function $c_Lcats_effect_kernel_Ref$SyncRef(ar, F) {
  this.Lcats_effect_kernel_Ref$SyncRef__f_ar = null;
  this.Lcats_effect_kernel_Ref$SyncRef__f_F = null;
  this.Lcats_effect_kernel_Ref$SyncRef__f_ar = ar;
  this.Lcats_effect_kernel_Ref$SyncRef__f_F = F
}
$c_Lcats_effect_kernel_Ref$SyncRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.constructor = $c_Lcats_effect_kernel_Ref$SyncRef;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$SyncRef() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Ref$SyncRef.prototype = $c_Lcats_effect_kernel_Ref$SyncRef.prototype;
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.get__O = (function() {
  return this.Lcats_effect_kernel_Ref$SyncRef__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.Lcats_effect_kernel_Ref$SyncRef__f_ar.ju_concurrent_atomic_AtomicReference__f_value))(this)))
});
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.set__O__O = (function(a) {
  return this.Lcats_effect_kernel_Ref$SyncRef__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => {
    this$1.Lcats_effect_kernel_Ref$SyncRef__f_ar.ju_concurrent_atomic_AtomicReference__f_value = a$2
  }))(this, a)))
});
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.update__F1__O = (function(f) {
  return this.Lcats_effect_kernel_Ref$SyncRef__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, f$2) => (() => {
    $p_Lcats_effect_kernel_Ref$SyncRef__spin$2__F1__V(this$1, f$2)
  }))(this, f)))
});
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.updateAndGet__F1__O = (function(f) {
  return this.Lcats_effect_kernel_Ref$SyncRef__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, f$2) => (() => $p_Lcats_effect_kernel_Ref$SyncRef__spin$3__F1__O(this$1, f$2)))(this, f)))
});
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.modify__F1__O = (function(f) {
  return this.Lcats_effect_kernel_Ref$SyncRef__f_F.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, f$2) => (() => $p_Lcats_effect_kernel_Ref$SyncRef__spin$4__F1__O(this$1, f$2)))(this, f)))
});
var $d_Lcats_effect_kernel_Ref$SyncRef = new $TypeData().initClass({
  Lcats_effect_kernel_Ref$SyncRef: 0
}, false, "cats.effect.kernel.Ref$SyncRef", {
  Lcats_effect_kernel_Ref$SyncRef: 1,
  Lcats_effect_kernel_Ref: 1,
  O: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
});
$c_Lcats_effect_kernel_Ref$SyncRef.prototype.$classData = $d_Lcats_effect_kernel_Ref$SyncRef;
/** @constructor */
function $c_Lcats_effect_kernel_Ref$TransformedRef(underlying, trans, F) {
  this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying = null;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_trans = null;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_F = null;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying = underlying;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_trans = trans;
  this.Lcats_effect_kernel_Ref$TransformedRef__f_F = F
}
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype = new $h_Lcats_effect_kernel_Ref();
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.constructor = $c_Lcats_effect_kernel_Ref$TransformedRef;
/** @constructor */
function $h_Lcats_effect_kernel_Ref$TransformedRef() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Ref$TransformedRef.prototype = $c_Lcats_effect_kernel_Ref$TransformedRef.prototype;
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.get__O = (function() {
  return this.Lcats_effect_kernel_Ref$TransformedRef__f_trans.apply__O__O(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying.get__O())
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.set__O__O = (function(a) {
  return this.Lcats_effect_kernel_Ref$TransformedRef__f_trans.apply__O__O(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying.set__O__O(a))
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.update__F1__O = (function(f) {
  return this.Lcats_effect_kernel_Ref$TransformedRef__f_trans.apply__O__O(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying.update__F1__O(f))
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.modify__F1__O = (function(f) {
  return this.Lcats_effect_kernel_Ref$TransformedRef__f_trans.apply__O__O(this.Lcats_effect_kernel_Ref$TransformedRef__f_underlying.modify__F1__O(f))
});
var $d_Lcats_effect_kernel_Ref$TransformedRef = new $TypeData().initClass({
  Lcats_effect_kernel_Ref$TransformedRef: 0
}, false, "cats.effect.kernel.Ref$TransformedRef", {
  Lcats_effect_kernel_Ref$TransformedRef: 1,
  Lcats_effect_kernel_Ref: 1,
  O: 1,
  Lcats_effect_kernel_RefSource: 1,
  Lcats_effect_kernel_RefSink: 1
});
$c_Lcats_effect_kernel_Ref$TransformedRef.prototype.$classData = $d_Lcats_effect_kernel_Ref$TransformedRef;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$6(F$76, poll$3) {
  this.Lcats_effect_kernel_Resource$$anon$6__f_F$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$6__f_poll$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$6__f_F$1 = F$76;
  this.Lcats_effect_kernel_Resource$$anon$6__f_poll$1 = poll$3
}
$c_Lcats_effect_kernel_Resource$$anon$6.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$6;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$6() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$$anon$6.prototype = $c_Lcats_effect_kernel_Resource$$anon$6.prototype;
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.apply__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource = (function(rfb) {
  var resource = new $c_sjsr_AnonFunction1(((this$1, rfb$2) => ((innerPoll) => {
    var innerPoll$1 = $as_Lcats_effect_kernel_Poll(innerPoll);
    return innerPoll$1.apply__O__O(this$1.Lcats_effect_kernel_Resource$$anon$6__f_poll$1.apply__O__O(rfb$2.allocatedCase__Lcats_effect_kernel_MonadCancel__O(this$1.Lcats_effect_kernel_Resource$$anon$6__f_F$1)))
  }))(this, rfb));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
});
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.apply__O__O = (function(fa) {
  return this.apply__Lcats_effect_kernel_Resource__Lcats_effect_kernel_Resource($as_Lcats_effect_kernel_Resource(fa))
});
var $d_Lcats_effect_kernel_Resource$$anon$6 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$$anon$6: 0
}, false, "cats.effect.kernel.Resource$$anon$6", {
  Lcats_effect_kernel_Resource$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
});
$c_Lcats_effect_kernel_Resource$$anon$6.prototype.$classData = $d_Lcats_effect_kernel_Resource$$anon$6;
function $is_Lcats_effect_kernel_Resource$ExitCase(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Resource$ExitCase)))
}
function $as_Lcats_effect_kernel_Resource$ExitCase(obj) {
  return (($is_Lcats_effect_kernel_Resource$ExitCase(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$ExitCase"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$ExitCase(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$ExitCase;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$State$2(outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  this.Lcats_effect_kernel_Resource$State$2__f_fin = null;
  this.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete = false;
  this.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete = false;
  this.Lcats_effect_kernel_Resource$State$2__f_$outer = null;
  this.Lcats_effect_kernel_Resource$State$2__f_fin = fin;
  this.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete = finalizeOnComplete;
  this.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete = confirmedFinalizeOnComplete;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$State$2__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$State$2.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$State$2.prototype.constructor = $c_Lcats_effect_kernel_Resource$State$2;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$State$2() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$State$2.prototype = $c_Lcats_effect_kernel_Resource$State$2.prototype;
$c_Lcats_effect_kernel_Resource$State$2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_kernel_Resource$State$2__f_fin;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$State$2)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$State$2(x$0);
    if (((this.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete === x$0$2.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete) && (this.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete === x$0$2.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete))) {
      var x = this.Lcats_effect_kernel_Resource$State$2__f_fin;
      var y = x$0$2.Lcats_effect_kernel_Resource$State$2__f_fin;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.productArity__I = (function() {
  return 3
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_kernel_Resource$State$2__f_fin;
      break
    }
    case 1: {
      return this.Lcats_effect_kernel_Resource$State$2__f_finalizeOnComplete;
      break
    }
    case 2: {
      return this.Lcats_effect_kernel_Resource$State$2__f_confirmedFinalizeOnComplete;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.copy__O__Z__Z__Lcats_effect_kernel_Resource$State$2 = (function(fin, finalizeOnComplete, confirmedFinalizeOnComplete) {
  return new $c_Lcats_effect_kernel_Resource$State$2(this.Lcats_effect_kernel_Resource$State$2__f_$outer, fin, finalizeOnComplete, confirmedFinalizeOnComplete)
});
function $as_Lcats_effect_kernel_Resource$State$2(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$State$2) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$State$2"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$State$2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$State$2)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$State$2(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$State$2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$State$2;", depth))
}
var $d_Lcats_effect_kernel_Resource$State$2 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$State$2: 0
}, false, "cats.effect.kernel.Resource$State$2", {
  Lcats_effect_kernel_Resource$State$2: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$State$2.prototype.$classData = $d_Lcats_effect_kernel_Resource$State$2;
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M$2, outer) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_M$1 = M$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1__f_$outer = outer
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$4()
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$5()
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1: 0
}, false, "cats.effect.kernel.instances.GenSpawnInstances$$anon$1", {
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1;
function $ct_Lcats_effect_std_Queue$AbstractQueue__I__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__($thiz, capacity, state, F) {
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_capacity = capacity;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_state = state;
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_F = F;
  var target = F.deferred__O();
  var this$32 = new $c_Lcats_FlatMap$$anon$2(target, F);
  var f = new $c_sjsr_AnonFunction1(((state$2, F$2) => ((taker) => {
    var taker$1 = $as_Lcats_effect_kernel_Deferred(taker);
    return F$2.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((state$1$2, F$4$2, taker$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var ffa = state$1$2.modify__F1__O(new $c_sjsr_AnonFunction1(((state$2$2, F$5$2, taker$1$2, poll$2) => ((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Queue$State(x$1);
        if ((x$1$1 !== null)) {
          var x62 = x$1$1.Lcats_effect_std_Queue$State__f_queue;
          var x63 = x$1$1.Lcats_effect_std_Queue$State__f_size;
          var x64 = x$1$1.Lcats_effect_std_Queue$State__f_takers;
          var x65 = x$1$1.Lcats_effect_std_Queue$State__f_offerers;
          if (((!x62.isEmpty__Z()) && x65.isEmpty__Z())) {
            matchResult5: {
              var \u03b43$___1;
              var \u03b43$___2;
              var x29 = x62.dequeue__T2();
              if ((x29 !== null)) {
                var a = x29._1__O();
                var rest = $as_sci_Queue(x29._2__O());
                var \u03b43$___1 = a;
                var \u03b43$___2 = rest;
                break matchResult5
              };
              throw new $c_s_MatchError(x29)
            };
            var a$2 = \u03b43$___1;
            var rest$2 = $as_sci_Queue(\u03b43$___2);
            var size = (((-1) + x63) | 0);
            var self = new $c_Lcats_effect_std_Queue$State(rest$2, size, x64, x65);
            var y = F$5$2.pure__O__O(a$2);
            return new $c_T2(self, y)
          };
          if ((!x62.isEmpty__Z())) {
            matchResult6: {
              var \u03b44$___1;
              var \u03b44$___2;
              var x32 = x62.dequeue__T2();
              if ((x32 !== null)) {
                var a$3 = x32._1__O();
                var rest$3 = $as_sci_Queue(x32._2__O());
                var \u03b44$___1 = a$3;
                var \u03b44$___2 = rest$3;
                break matchResult6
              };
              throw new $c_s_MatchError(x32)
            };
            var a$4 = \u03b44$___1;
            var rest$4 = $as_sci_Queue(\u03b44$___2);
            matchResult7: {
              var \u03b45$___1;
              var \u03b45$___2;
              var \u03b45$___3;
              var x35 = x65.dequeue__T2();
              if ((x35 !== null)) {
                var x36 = $as_T2(x35._1__O());
                if ((x36 !== null)) {
                  var move = x36._1__O();
                  var release = $as_Lcats_effect_kernel_Deferred(x36._2__O());
                  var tail = $as_sci_Queue(x35._2__O());
                  var \u03b45$___1 = move;
                  var \u03b45$___2 = release;
                  var \u03b45$___3 = tail;
                  break matchResult7
                }
              };
              throw new $c_s_MatchError(x35)
            };
            var move$2 = \u03b45$___1;
            var release$2 = $as_Lcats_effect_kernel_Deferred(\u03b45$___2);
            var tail$2 = $as_sci_Queue(\u03b45$___3);
            var queue = rest$4.enqueue__O__sci_Queue(move$2);
            var self$1 = new $c_Lcats_effect_std_Queue$State(queue, x63, x64, tail$2);
            var target$1 = release$2.complete__O__O((void 0));
            var this$15 = new $c_Lcats_Functor$$anon$4(target$1, F$5$2);
            var y$1 = this$15.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$15.Lcats_Functor$$anon$4__f_self, a$4);
            return new $c_T2(self$1, y$1)
          };
          if ((!x65.isEmpty__Z())) {
            matchResult8: {
              var \u03b46$___1;
              var \u03b46$___2;
              var \u03b46$___3;
              var x40 = x65.dequeue__T2();
              if ((x40 !== null)) {
                var x41 = $as_T2(x40._1__O());
                if ((x41 !== null)) {
                  var a$5 = x41._1__O();
                  var release$3 = $as_Lcats_effect_kernel_Deferred(x41._2__O());
                  var rest$5 = $as_sci_Queue(x40._2__O());
                  var \u03b46$___1 = a$5;
                  var \u03b46$___2 = release$3;
                  var \u03b46$___3 = rest$5;
                  break matchResult8
                }
              };
              throw new $c_s_MatchError(x40)
            };
            var a$6 = \u03b46$___1;
            var release$4 = $as_Lcats_effect_kernel_Deferred(\u03b46$___2);
            var rest$6 = $as_sci_Queue(\u03b46$___3);
            var self$2 = new $c_Lcats_effect_std_Queue$State(x62, x63, x64, rest$6);
            var target$2 = release$4.complete__O__O((void 0));
            var this$21 = new $c_Lcats_Functor$$anon$4(target$2, F$5$2);
            var y$2 = this$21.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$21.Lcats_Functor$$anon$4__f_self, a$6);
            return new $c_T2(self$2, y$2)
          };
          var cleanup = state$2$2.update__F1__O(new $c_sjsr_AnonFunction1(((taker$2$2) => ((s) => {
            var s$1 = $as_Lcats_effect_std_Queue$State(s);
            var this$24 = s$1.Lcats_effect_std_Queue$State__f_takers;
            var b = $m_sci_Queue$().newBuilder__scm_Builder();
            var it = this$24.iterator__sc_Iterator();
            while (it.hasNext__Z()) {
              var elem = it.next__O();
              var _$12 = $as_Lcats_effect_kernel_Deferred(elem);
              if (((_$12 !== taker$2$2) !== false)) {
                b.addOne__O__scm_Growable(elem)
              }
            };
            var takers$1 = $as_sci_Queue(b.result__O());
            var queue$1 = s$1.Lcats_effect_std_Queue$State__f_queue;
            var size$1 = s$1.Lcats_effect_std_Queue$State__f_size;
            var offerers$1 = s$1.Lcats_effect_std_Queue$State__f_offerers;
            return new $c_Lcats_effect_std_Queue$State(queue$1, size$1, takers$1, offerers$1)
          }))(taker$1$2)));
          var takers = x64.enqueue__O__sci_Queue(taker$1$2);
          var self$3 = new $c_Lcats_effect_std_Queue$State(x62, x63, takers, x65);
          var wrapped = poll$2.apply__O__O(taker$1$2.get__O());
          var y$3 = F$5$2.onCancel__O__O__O(wrapped, cleanup);
          return new $c_T2(self$3, y$3)
        };
        throw new $c_s_MatchError(x$1$1)
      }))(state$1$2, F$4$2, taker$2, poll$1)));
      return $f_Lcats_FlatMap__flatten__O__O(F$4$2, ffa)
    }))(state$2, F$2, taker$1)))
  }))(state, F));
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_take = this$32.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$32.Lcats_FlatMap$$anon$2__f_self, f);
  var ffa$1 = state.modify__F1__O(new $c_sjsr_AnonFunction1(((F$3) => ((x$1$2) => {
    var x$1$3 = $as_Lcats_effect_std_Queue$State(x$1$2);
    if ((x$1$3 !== null)) {
      var x94 = x$1$3.Lcats_effect_std_Queue$State__f_queue;
      var x95 = x$1$3.Lcats_effect_std_Queue$State__f_size;
      var x96 = x$1$3.Lcats_effect_std_Queue$State__f_takers;
      var x97 = x$1$3.Lcats_effect_std_Queue$State__f_offerers;
      if (((!x94.isEmpty__Z()) && x97.isEmpty__Z())) {
        matchResult10: {
          var \u03b47$___1;
          var \u03b47$___2;
          var x66 = x94.dequeue__T2();
          if ((x66 !== null)) {
            var a$1 = x66._1__O();
            var rest$1 = $as_sci_Queue(x66._2__O());
            var \u03b47$___1 = a$1;
            var \u03b47$___2 = rest$1;
            break matchResult10
          };
          throw new $c_s_MatchError(x66)
        };
        var a$2$1 = \u03b47$___1;
        var rest$2$1 = $as_sci_Queue(\u03b47$___2);
        var size$2 = (((-1) + x95) | 0);
        var self$4 = new $c_Lcats_effect_std_Queue$State(rest$2$1, size$2, x96, x97);
        var y$4 = F$3.pure__O__O(new $c_s_Some(a$2$1));
        return new $c_T2(self$4, y$4)
      };
      if ((!x94.isEmpty__Z())) {
        matchResult11: {
          var \u03b48$___1;
          var \u03b48$___2;
          var x69 = x94.dequeue__T2();
          if ((x69 !== null)) {
            var a$3$1 = x69._1__O();
            var rest$3$1 = $as_sci_Queue(x69._2__O());
            var \u03b48$___1 = a$3$1;
            var \u03b48$___2 = rest$3$1;
            break matchResult11
          };
          throw new $c_s_MatchError(x69)
        };
        var a$4$1 = \u03b48$___1;
        var rest$4$1 = $as_sci_Queue(\u03b48$___2);
        matchResult12: {
          var \u03b49$___1;
          var \u03b49$___2;
          var \u03b49$___3;
          var x72 = x97.dequeue__T2();
          if ((x72 !== null)) {
            var x73 = $as_T2(x72._1__O());
            if ((x73 !== null)) {
              var move$1 = x73._1__O();
              var release$1 = $as_Lcats_effect_kernel_Deferred(x73._2__O());
              var tail$1 = $as_sci_Queue(x72._2__O());
              var \u03b49$___1 = move$1;
              var \u03b49$___2 = release$1;
              var \u03b49$___3 = tail$1;
              break matchResult12
            }
          };
          throw new $c_s_MatchError(x72)
        };
        var move$2$1 = \u03b49$___1;
        var release$2$1 = $as_Lcats_effect_kernel_Deferred(\u03b49$___2);
        var tail$2$1 = $as_sci_Queue(\u03b49$___3);
        var queue$2 = rest$4$1.enqueue__O__sci_Queue(move$2$1);
        var self$5 = new $c_Lcats_effect_std_Queue$State(queue$2, x95, x96, tail$2$1);
        var target$3 = release$2$1.complete__O__O((void 0));
        var this$49 = new $c_Lcats_Functor$$anon$4(target$3, F$3);
        var b$1 = new $c_s_Some(a$4$1);
        var y$5 = this$49.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$49.Lcats_Functor$$anon$4__f_self, b$1);
        return new $c_T2(self$5, y$5)
      };
      if ((!x97.isEmpty__Z())) {
        matchResult13: {
          var \u03b410$___1;
          var \u03b410$___2;
          var \u03b410$___3;
          var x77 = x97.dequeue__T2();
          if ((x77 !== null)) {
            var x78 = $as_T2(x77._1__O());
            if ((x78 !== null)) {
              var a$5$1 = x78._1__O();
              var release$3$1 = $as_Lcats_effect_kernel_Deferred(x78._2__O());
              var rest$5$1 = $as_sci_Queue(x77._2__O());
              var \u03b410$___1 = a$5$1;
              var \u03b410$___2 = release$3$1;
              var \u03b410$___3 = rest$5$1;
              break matchResult13
            }
          };
          throw new $c_s_MatchError(x77)
        };
        var a$6$1 = \u03b410$___1;
        var release$4$1 = $as_Lcats_effect_kernel_Deferred(\u03b410$___2);
        var rest$6$1 = $as_sci_Queue(\u03b410$___3);
        var self$6 = new $c_Lcats_effect_std_Queue$State(x94, x95, x96, rest$6$1);
        var target$4 = release$4$1.complete__O__O((void 0));
        var this$58 = new $c_Lcats_Functor$$anon$4(target$4, F$3);
        var b$2 = new $c_s_Some(a$6$1);
        var y$6 = this$58.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$58.Lcats_Functor$$anon$4__f_self, b$2);
        return new $c_T2(self$6, y$6)
      }
    };
    var y$7 = F$3.pure__O__O($m_s_None$());
    return new $c_T2(x$1$3, y$7)
  }))(F)));
  var wrapped$1 = $f_Lcats_FlatMap__flatten__O__O(F, ffa$1);
  $thiz.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped$1, F);
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_std_Queue$AbstractQueue() {
  this.Lcats_effect_std_Queue$AbstractQueue__f_capacity = 0;
  this.Lcats_effect_std_Queue$AbstractQueue__f_state = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_F = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_take = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = null
}
$c_Lcats_effect_std_Queue$AbstractQueue.prototype = new $h_Lcats_effect_std_Queue();
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.constructor = $c_Lcats_effect_std_Queue$AbstractQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$AbstractQueue() {
  /*<skip>*/
}
$h_Lcats_effect_std_Queue$AbstractQueue.prototype = $c_Lcats_effect_std_Queue$AbstractQueue.prototype;
$c_Lcats_effect_std_Queue$AbstractQueue.prototype.offer__O__O = (function(a) {
  var target = this.Lcats_effect_std_Queue$AbstractQueue__f_F.deferred__O();
  var tc = this.Lcats_effect_std_Queue$AbstractQueue__f_F;
  var this$18 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2, a$2) => ((offerer) => {
    var offerer$1 = $as_Lcats_effect_kernel_Deferred(offerer);
    return this$2.Lcats_effect_std_Queue$AbstractQueue__f_F.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$3, a$1$2, offerer$2) => ((poll) => {
      var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
      var ffa = this$3.Lcats_effect_std_Queue$AbstractQueue__f_state.modify__F1__O(new $c_sjsr_AnonFunction1(((this$4, a$2$2, offerer$1$2, poll$2) => ((x$1) => {
        var x$1$1 = $as_Lcats_effect_std_Queue$State(x$1);
        if ((x$1$1 !== null)) {
          var x11 = x$1$1.Lcats_effect_std_Queue$State__f_queue;
          var x12 = x$1$1.Lcats_effect_std_Queue$State__f_size;
          var x13 = x$1$1.Lcats_effect_std_Queue$State__f_takers;
          var x14 = x$1$1.Lcats_effect_std_Queue$State__f_offerers;
          if ((!x13.isEmpty__Z())) {
            matchResult1: {
              var \u03b41$___1;
              var \u03b41$___2;
              var x1 = x13.dequeue__T2();
              if ((x1 !== null)) {
                var taker = $as_Lcats_effect_kernel_Deferred(x1._1__O());
                var rest = $as_sci_Queue(x1._2__O());
                var \u03b41$___1 = taker;
                var \u03b41$___2 = rest;
                break matchResult1
              };
              throw new $c_s_MatchError(x1)
            };
            var taker$2 = $as_Lcats_effect_kernel_Deferred(\u03b41$___1);
            var rest$2 = $as_sci_Queue(\u03b41$___2);
            var self = new $c_Lcats_effect_std_Queue$State(x11, x12, rest$2, x14);
            var target$1 = taker$2.complete__O__O(a$2$2);
            var tc$1 = this$4.Lcats_effect_std_Queue$AbstractQueue__f_F;
            var this$10 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
            var y = this$10.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$10.Lcats_Functor$$anon$4__f_self);
            return new $c_T2(self, y)
          };
          if ((x12 < this$4.Lcats_effect_std_Queue$AbstractQueue__f_capacity)) {
            var queue = x11.enqueue__O__sci_Queue(a$2$2);
            var size = ((1 + x12) | 0);
            var self$1 = new $c_Lcats_effect_std_Queue$State(queue, size, x13, x14);
            var this$14 = this$4.Lcats_effect_std_Queue$AbstractQueue__f_F;
            var y$1 = this$14.pure__O__O((void 0));
            return new $c_T2(self$1, y$1)
          }
        };
        return this$4.onOfferNoCapacity__Lcats_effect_std_Queue$State__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__T2(x$1$1, a$2$2, offerer$1$2, poll$2)
      }))(this$3, a$1$2, offerer$2, poll$1)));
      var F = this$3.Lcats_effect_std_Queue$AbstractQueue__f_F;
      return $f_Lcats_FlatMap__flatten__O__O(F, ffa)
    }))(this$2, a$2, offerer$1)))
  }))(this, a));
  return this$18.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$18.Lcats_FlatMap$$anon$2__f_self, f)
});
/** @constructor */
function $c_Lcats_effect_std_Queue$State(queue, size, takers, offerers) {
  this.Lcats_effect_std_Queue$State__f_queue = null;
  this.Lcats_effect_std_Queue$State__f_size = 0;
  this.Lcats_effect_std_Queue$State__f_takers = null;
  this.Lcats_effect_std_Queue$State__f_offerers = null;
  this.Lcats_effect_std_Queue$State__f_queue = queue;
  this.Lcats_effect_std_Queue$State__f_size = size;
  this.Lcats_effect_std_Queue$State__f_takers = takers;
  this.Lcats_effect_std_Queue$State__f_offerers = offerers
}
$c_Lcats_effect_std_Queue$State.prototype = new $h_O();
$c_Lcats_effect_std_Queue$State.prototype.constructor = $c_Lcats_effect_std_Queue$State;
/** @constructor */
function $h_Lcats_effect_std_Queue$State() {
  /*<skip>*/
}
$h_Lcats_effect_std_Queue$State.prototype = $c_Lcats_effect_std_Queue$State.prototype;
$c_Lcats_effect_std_Queue$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Queue$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_std_Queue$State__f_queue;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_std_Queue$State__f_size;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_std_Queue$State__f_takers;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lcats_effect_std_Queue$State__f_offerers;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lcats_effect_std_Queue$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_std_Queue$State)) {
    var x$0$2 = $as_Lcats_effect_std_Queue$State(x$0);
    if ((this.Lcats_effect_std_Queue$State__f_size === x$0$2.Lcats_effect_std_Queue$State__f_size)) {
      var x = this.Lcats_effect_std_Queue$State__f_queue;
      var x$2 = x$0$2.Lcats_effect_std_Queue$State__f_queue;
      var $$x2 = ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Lcats_effect_std_Queue$State__f_takers;
      var x$4 = x$0$2.Lcats_effect_std_Queue$State__f_takers;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : $f_sc_Seq__equals__O__Z(x$3, x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcats_effect_std_Queue$State__f_offerers;
      var x$6 = x$0$2.Lcats_effect_std_Queue$State__f_offerers;
      return ((x$5 === null) ? (x$6 === null) : $f_sc_Seq__equals__O__Z(x$5, x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_std_Queue$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_std_Queue$State.prototype.productArity__I = (function() {
  return 4
});
$c_Lcats_effect_std_Queue$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lcats_effect_std_Queue$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_std_Queue$State__f_queue;
      break
    }
    case 1: {
      return this.Lcats_effect_std_Queue$State__f_size;
      break
    }
    case 2: {
      return this.Lcats_effect_std_Queue$State__f_takers;
      break
    }
    case 3: {
      return this.Lcats_effect_std_Queue$State__f_offerers;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lcats_effect_std_Queue$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Queue$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Queue$State"))
}
function $isArrayOf_Lcats_effect_std_Queue$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Queue$State)))
}
function $asArrayOf_Lcats_effect_std_Queue$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Queue$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Queue$State;", depth))
}
var $d_Lcats_effect_std_Queue$State = new $TypeData().initClass({
  Lcats_effect_std_Queue$State: 0
}, false, "cats.effect.std.Queue$State", {
  Lcats_effect_std_Queue$State: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_std_Queue$State.prototype.$classData = $d_Lcats_effect_std_Queue$State;
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Request(outer, n, gate) {
  this.Lcats_effect_std_Semaphore$impl$Request__f_n = $L0;
  this.Lcats_effect_std_Semaphore$impl$Request__f_gate = null;
  this.Lcats_effect_std_Semaphore$impl$Request__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$Request__f_n = n;
  this.Lcats_effect_std_Semaphore$impl$Request__f_gate = gate;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_std_Semaphore$impl$Request__f_$outer = outer
}
$c_Lcats_effect_std_Semaphore$impl$Request.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Request;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Request() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl$Request.prototype = $c_Lcats_effect_std_Semaphore$impl$Request.prototype;
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Request");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lcats_effect_std_Semaphore$impl$Request__f_n;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if (((x$0 instanceof $c_Lcats_effect_std_Semaphore$impl$Request) && ($as_Lcats_effect_std_Semaphore$impl$Request(x$0).Lcats_effect_std_Semaphore$impl$Request__f_$outer === this.Lcats_effect_std_Semaphore$impl$Request__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Semaphore$impl$Request(x$0);
    var this$1 = this.Lcats_effect_std_Semaphore$impl$Request__f_n;
    var b = x$0$2.Lcats_effect_std_Semaphore$impl$Request__f_n;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lcats_effect_std_Semaphore$impl$Request__f_gate;
      var x$2 = x$0$2.Lcats_effect_std_Semaphore$impl$Request__f_gate;
      return (x === x$2)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productPrefix__T = (function() {
  return "Request"
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Semaphore$impl$Request__f_n
  };
  if ((n === 1)) {
    return this.Lcats_effect_std_Semaphore$impl$Request__f_gate
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.sameAs__Lcats_effect_std_Semaphore$impl$Request__Z = (function(r) {
  return (r.Lcats_effect_std_Semaphore$impl$Request__f_gate === this.Lcats_effect_std_Semaphore$impl$Request__f_gate)
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.of__J__Lcats_effect_std_Semaphore$impl$Request = (function(newN) {
  return this.Lcats_effect_std_Semaphore$impl$Request__f_$outer.Lcats_effect_std_Semaphore$impl__f_Request$lzy1.apply__J__Lcats_effect_kernel_Deferred__Lcats_effect_std_Semaphore$impl$Request(newN, this.Lcats_effect_std_Semaphore$impl$Request__f_gate)
});
function $as_Lcats_effect_std_Semaphore$impl$Request(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Semaphore$impl$Request) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore$impl$Request"))
}
function $isArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$Request)))
}
function $asArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore$impl$Request(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore$impl$Request;", depth))
}
var $d_Lcats_effect_std_Semaphore$impl$Request = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl$Request: 0
}, false, "cats.effect.std.Semaphore$impl$Request", {
  Lcats_effect_std_Semaphore$impl$Request: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_std_Semaphore$impl$Request.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl$Request;
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$State(outer, permits, waiting) {
  this.Lcats_effect_std_Semaphore$impl$State__f_permits = $L0;
  this.Lcats_effect_std_Semaphore$impl$State__f_waiting = null;
  this.Lcats_effect_std_Semaphore$impl$State__f_$outer = null;
  this.Lcats_effect_std_Semaphore$impl$State__f_permits = permits;
  this.Lcats_effect_std_Semaphore$impl$State__f_waiting = waiting;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_std_Semaphore$impl$State__f_$outer = outer
}
$c_Lcats_effect_std_Semaphore$impl$State.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$State.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$State;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$State() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl$State.prototype = $c_Lcats_effect_std_Semaphore$impl$State.prototype;
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lcats_effect_std_Semaphore$impl$State__f_permits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if (((x$0 instanceof $c_Lcats_effect_std_Semaphore$impl$State) && ($as_Lcats_effect_std_Semaphore$impl$State(x$0).Lcats_effect_std_Semaphore$impl$State__f_$outer === this.Lcats_effect_std_Semaphore$impl$State__f_$outer))) {
    var x$0$2 = $as_Lcats_effect_std_Semaphore$impl$State(x$0);
    var this$1 = this.Lcats_effect_std_Semaphore$impl$State__f_permits;
    var b = x$0$2.Lcats_effect_std_Semaphore$impl$State__f_permits;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      var x$2 = x$0$2.Lcats_effect_std_Semaphore$impl$State__f_waiting;
      return ((x === null) ? (x$2 === null) : $f_sc_Seq__equals__O__Z(x, x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Semaphore$impl$State__f_permits
  };
  if ((n === 1)) {
    return this.Lcats_effect_std_Semaphore$impl$State__f_waiting
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_std_Semaphore$impl$State(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Semaphore$impl$State) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Semaphore$impl$State"))
}
function $isArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Semaphore$impl$State)))
}
function $asArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Semaphore$impl$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Semaphore$impl$State;", depth))
}
var $d_Lcats_effect_std_Semaphore$impl$State = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl$State: 0
}, false, "cats.effect.std.Semaphore$impl$State", {
  Lcats_effect_std_Semaphore$impl$State: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_std_Semaphore$impl$State.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl$State;
class $c_Lcats_effect_tracing_TracingEvent$StackTrace extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
function $as_Lcats_effect_tracing_TracingEvent$StackTrace(obj) {
  return (((obj instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.tracing.TracingEvent$StackTrace"))
}
function $isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_tracing_TracingEvent$StackTrace)))
}
function $asArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) {
  return (($isArrayOf_Lcats_effect_tracing_TracingEvent$StackTrace(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.tracing.TracingEvent$StackTrace;", depth))
}
var $d_Lcats_effect_tracing_TracingEvent$StackTrace = new $TypeData().initClass({
  Lcats_effect_tracing_TracingEvent$StackTrace: 0
}, false, "cats.effect.tracing.TracingEvent$StackTrace", {
  Lcats_effect_tracing_TracingEvent$StackTrace: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_tracing_TracingEvent: 1
});
$c_Lcats_effect_tracing_TracingEvent$StackTrace.prototype.$classData = $d_Lcats_effect_tracing_TracingEvent$StackTrace;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout) {
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = false;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = null;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = 0;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold = cancelationCheckThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold = autoYieldThreshold;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions = enhancedExceptions;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize = traceBufferSize;
  this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout = shutdownHookTimeout;
  var a = traceBufferSize;
  var a$1 = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
  var this$4 = $m_RTLong$();
  var value = $uD(Math.round(a$1));
  var lo = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferLogSize = lo
}
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype = new $h_O();
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_IORuntimeConfig.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("IORuntimeConfig");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_unsafe_IORuntimeConfig)) {
    var x$0$2 = $as_Lcats_effect_unsafe_IORuntimeConfig(x$0);
    if (((((this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold === x$0$2.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold === x$0$2.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions === x$0$2.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions)) && (this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize === x$0$2.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize))) {
      var x = this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      var x$2 = x$0$2.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productArity__I = (function() {
  return 5
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productPrefix__T = (function() {
  return "IORuntimeConfig"
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_cancelationCheckThreshold;
      break
    }
    case 1: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_autoYieldThreshold;
      break
    }
    case 2: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_enhancedExceptions;
      break
    }
    case 3: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_traceBufferSize;
      break
    }
    case 4: {
      return this.Lcats_effect_unsafe_IORuntimeConfig__f_shutdownHookTimeout;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lcats_effect_unsafe_IORuntimeConfig(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntimeConfig) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntimeConfig"))
}
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig)))
}
function $asArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntimeConfig(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntimeConfig;", depth))
}
var $d_Lcats_effect_unsafe_IORuntimeConfig = new $TypeData().initClass({
  Lcats_effect_unsafe_IORuntimeConfig: 0
}, false, "cats.effect.unsafe.IORuntimeConfig", {
  Lcats_effect_unsafe_IORuntimeConfig: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_unsafe_IORuntimeConfig.prototype.$classData = $d_Lcats_effect_unsafe_IORuntimeConfig;
/** @constructor */
function $c_Lcats_effect_unsafe_IORuntimeConfig$() {
  this.Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__f_Default = null;
  $ct_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform__(this)
}
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype = new $h_Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform();
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.constructor = $c_Lcats_effect_unsafe_IORuntimeConfig$;
/** @constructor */
function $h_Lcats_effect_unsafe_IORuntimeConfig$() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_IORuntimeConfig$.prototype = $c_Lcats_effect_unsafe_IORuntimeConfig$.prototype;
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.toString__T = (function() {
  return "IORuntimeConfig"
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.apply__I__I__Z__I__s_concurrent_duration_Duration__Lcats_effect_unsafe_IORuntimeConfig = (function(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, traceBufferSize, shutdownHookTimeout) {
  if (($intMod(autoYieldThreshold, cancelationCheckThreshold) === 0)) {
    var a = traceBufferSize;
    var a$1 = ($uD(Math.log(a)) / $uD(Math.log(2.0)));
    var this$4 = $m_RTLong$();
    var value = $uD(Math.round(a$1));
    var lo = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    return new $c_Lcats_effect_unsafe_IORuntimeConfig(cancelationCheckThreshold, autoYieldThreshold, enhancedExceptions, (1 << lo), shutdownHookTimeout)
  } else {
    throw new $c_jl_AssertionError(((("Auto yield threshold " + autoYieldThreshold) + " must be a multiple of cancelation check threshold ") + cancelationCheckThreshold))
  }
});
function $as_Lcats_effect_unsafe_IORuntimeConfig$(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_IORuntimeConfig$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.IORuntimeConfig$"))
}
function $isArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_IORuntimeConfig$)))
}
function $asArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_IORuntimeConfig$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.IORuntimeConfig$;", depth))
}
var $d_Lcats_effect_unsafe_IORuntimeConfig$ = new $TypeData().initClass({
  Lcats_effect_unsafe_IORuntimeConfig$: 0
}, false, "cats.effect.unsafe.IORuntimeConfig$", {
  Lcats_effect_unsafe_IORuntimeConfig$: 1,
  Lcats_effect_unsafe_IORuntimeConfigCompanionPlatform: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_effect_unsafe_IORuntimeConfig$.prototype.$classData = $d_Lcats_effect_unsafe_IORuntimeConfig$;
var $n_Lcats_effect_unsafe_IORuntimeConfig$;
function $m_Lcats_effect_unsafe_IORuntimeConfig$() {
  if ((!$n_Lcats_effect_unsafe_IORuntimeConfig$)) {
    $n_Lcats_effect_unsafe_IORuntimeConfig$ = new $c_Lcats_effect_unsafe_IORuntimeConfig$()
  };
  return $n_Lcats_effect_unsafe_IORuntimeConfig$
}
/** @constructor */
function $c_Lcats_effect_unsafe_WeakBag$Entry(a, index, rq) {
  this.Lcats_effect_unsafe_ref_Reference__f_queue = null;
  this.Lcats_effect_unsafe_ref_Reference__f_weakRef = null;
  this.Lcats_effect_unsafe_ref_Reference__f_enqueued = false;
  this.Lcats_effect_unsafe_WeakBag$Entry__f_index = 0;
  this.Lcats_effect_unsafe_WeakBag$Entry__f_index = index;
  $ct_Lcats_effect_unsafe_ref_Reference__O__Lcats_effect_unsafe_ref_ReferenceQueue__(this, a, rq)
}
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype = new $h_Lcats_effect_unsafe_ref_WeakReference();
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.constructor = $c_Lcats_effect_unsafe_WeakBag$Entry;
/** @constructor */
function $h_Lcats_effect_unsafe_WeakBag$Entry() {
  /*<skip>*/
}
$h_Lcats_effect_unsafe_WeakBag$Entry.prototype = $c_Lcats_effect_unsafe_WeakBag$Entry.prototype;
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.deregister__V = (function() {
  this.enqueue__Z()
});
function $as_Lcats_effect_unsafe_WeakBag$Entry(obj) {
  return (((obj instanceof $c_Lcats_effect_unsafe_WeakBag$Entry) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.unsafe.WeakBag$Entry"))
}
function $isArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_unsafe_WeakBag$Entry)))
}
function $asArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) {
  return (($isArrayOf_Lcats_effect_unsafe_WeakBag$Entry(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.unsafe.WeakBag$Entry;", depth))
}
var $d_Lcats_effect_unsafe_WeakBag$Entry = new $TypeData().initClass({
  Lcats_effect_unsafe_WeakBag$Entry: 0
}, false, "cats.effect.unsafe.WeakBag$Entry", {
  Lcats_effect_unsafe_WeakBag$Entry: 1,
  Lcats_effect_unsafe_ref_WeakReference: 1,
  Lcats_effect_unsafe_ref_Reference: 1,
  O: 1,
  Lcats_effect_unsafe_WeakBag$Handle: 1
});
$c_Lcats_effect_unsafe_WeakBag$Entry.prototype.$classData = $d_Lcats_effect_unsafe_WeakBag$Entry;
/** @constructor */
function $c_Lcats_evidence_AsInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_evidence_AsInstances$$anon$1.prototype = new $h_O();
$c_Lcats_evidence_AsInstances$$anon$1.prototype.constructor = $c_Lcats_evidence_AsInstances$$anon$1;
/** @constructor */
function $h_Lcats_evidence_AsInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_evidence_AsInstances$$anon$1.prototype = $c_Lcats_evidence_AsInstances$$anon$1.prototype;
var $d_Lcats_evidence_AsInstances$$anon$1 = new $TypeData().initClass({
  Lcats_evidence_AsInstances$$anon$1: 0
}, false, "cats.evidence.AsInstances$$anon$1", {
  Lcats_evidence_AsInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1
});
$c_Lcats_evidence_AsInstances$$anon$1.prototype.$classData = $d_Lcats_evidence_AsInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$2(outer) {
  this.Lcats_instances_Function1Instances$$anon$2__f_category = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  var instance = outer.Lcats_implicits$__f_catsStdInstancesForFunction1;
  this.Lcats_instances_Function1Instances$$anon$2__f_category = instance
}
$c_Lcats_instances_Function1Instances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$2.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$2;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_Function1Instances$$anon$2.prototype = $c_Lcats_instances_Function1Instances$$anon$2.prototype;
var $d_Lcats_instances_Function1Instances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_Function1Instances$$anon$2: 0
}, false, "cats.instances.Function1Instances$$anon$2", {
  Lcats_instances_Function1Instances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
});
$c_Lcats_instances_Function1Instances$$anon$2.prototype.$classData = $d_Lcats_instances_Function1Instances$$anon$2;
/** @constructor */
function $c_Lcats_instances_HashInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_HashInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_HashInstances$$anon$1.prototype.constructor = $c_Lcats_instances_HashInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_HashInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_HashInstances$$anon$1.prototype = $c_Lcats_instances_HashInstances$$anon$1.prototype;
var $d_Lcats_instances_HashInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_HashInstances$$anon$1: 0
}, false, "cats.instances.HashInstances$$anon$1", {
  Lcats_instances_HashInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Contravariant: 1
});
$c_Lcats_instances_HashInstances$$anon$1.prototype.$classData = $d_Lcats_instances_HashInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(fa$15, fb$6) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fa$1 = fa$15;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$6__f_fb$1 = fb$6
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$6() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype;
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$6 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$6", {
  Lcats_instances_InvariantMonoidalInstances$$anon$6: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_CommutativeSemigroup: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$6.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$6;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$8(fa$5, fb$3) {
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fa$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fb$1 = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_empty = null;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fa$1 = fa$5;
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fb$1 = fb$3;
  var self = fa$5.empty__O();
  var y = fb$3.empty__O();
  this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_empty = new $c_T2(self, y)
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$8;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$8() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.combine__T2__T2__T2 = (function(x, y) {
  var self = this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fa$1.combine__O__O__O(x._1__O(), y._1__O());
  var y$1 = this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_fb$1.combine__O__O__O(x._2__O(), y._2__O());
  return new $c_T2(self, y$1)
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.empty__O = (function() {
  return this.Lcats_instances_InvariantMonoidalInstances$$anon$8__f_empty
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T2__T2__T2($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$8 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$8: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$8", {
  Lcats_instances_InvariantMonoidalInstances$$anon$8: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$8.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$8;
function $f_Lcats_instances_LazyListInstances__$init$__V($thiz) {
  $thiz.Lcats_implicits$__f_catsStdInstancesForLazyList = new $c_Lcats_instances_LazyListInstances$$anon$1();
  $thiz.Lcats_implicits$__f_catsStdTraverseFilterForLazyList = new $c_Lcats_instances_LazyListInstances$$anon$2($thiz)
}
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$2(outer) {
  this.Lcats_instances_LazyListInstances$$anon$2__f_traverse = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_instances_LazyListInstances$$anon$2__f_traverse = $as_Lcats_Traverse(outer.Lcats_implicits$__f_catsStdInstancesForLazyList)
}
$c_Lcats_instances_LazyListInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$2.prototype = $c_Lcats_instances_LazyListInstances$$anon$2.prototype;
var $d_Lcats_instances_LazyListInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$2: 0
}, false, "cats.instances.LazyListInstances$$anon$2", {
  Lcats_instances_LazyListInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_LazyListInstances$$anon$2.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$2;
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__V(f$4, buf$1, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    matchResult2: {
      var x6 = lists$tailLocal1;
      if ((x6 instanceof $c_sci_$colon$colon)) {
        var x10 = $as_sci_$colon$colon(x6);
        var x11 = $as_sci_List(x10.sci_$colon$colon__f_head);
        var x12 = x10.sci_$colon$colon__f_next;
        if ((x11 instanceof $c_sci_$colon$colon)) {
          var x13 = $as_sci_$colon$colon(x11);
          var x15 = x13.sci_$colon$colon__f_next;
          var ab = $as_s_util_Either(x13.sci_$colon$colon__f_head);
          if ((ab instanceof $c_s_util_Right)) {
            var b = $as_s_util_Right(ab).s_util_Right__f_value;
            buf$1.addOne__O__scm_Growable(b);
            lists$tailLocal1 = new $c_sci_$colon$colon(x15, x12);
            continue
          };
          if ((ab instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(ab).s_util_Left__f_value;
            var elem$1 = $as_sci_List(f$4.apply__O__O(a));
            var this$1 = new $c_sci_$colon$colon(x15, x12);
            lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$1);
            continue
          };
          throw new $c_s_MatchError(ab);
          break matchResult2
        };
        var x = $m_s_package$().s_package$__f_Nil;
        if (((x === null) ? (x11 === null) : x.equals__O__Z(x11))) {
          lists$tailLocal1 = x12;
          continue
        }
      };
      var x$3 = $m_s_package$().s_package$__f_Nil;
      if (((x$3 === null) ? (x6 === null) : x$3.equals__O__Z(x6))) {
        break matchResult2
      };
      throw new $c_s_MatchError(x6)
    };
    return (void 0)
  }
}
function $ps_Lcats_instances_ListInstances__loop$3__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, as) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (as === null) : x.equals__O__Z(as))) {
    return lb$1
  };
  if ((as instanceof $c_sci_$colon$colon)) {
    var x21 = $as_sci_$colon$colon(as);
    var x23 = x21.sci_$colon$colon__f_next;
    var h = x21.sci_$colon$colon__f_head;
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((lb$1$2, f$6$2, t$2) => (() => $ps_Lcats_instances_ListInstances__loop$3__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1$2, f$6$2, t$2)))(lb$1, f$6, x23));
    return $as_Lcats_Eval(f$6.apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a)))
  };
  throw new $c_s_MatchError(as)
}
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$4__F1__Lcats_Applicative__I__sci_List__Lcats_Eval(f$12, G$4, size, fa) {
  if ((size > 1)) {
    var leftSize = ((size / 2) | 0);
    var rightSize = ((size - leftSize) | 0);
    matchResult6: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x28 = fa.splitAt__I__T2(leftSize);
      if ((x28 !== null)) {
        var leftL = $as_sci_List(x28._1__O());
        var rightL = $as_sci_List(x28._2__O());
        var \u03b41$___1 = leftL;
        var \u03b41$___2 = rightL;
        break matchResult6
      };
      throw new $c_s_MatchError(x28)
    };
    var leftL$2 = $as_sci_List(\u03b41$___1);
    var rightL$2 = $as_sci_List(\u03b41$___2);
    return $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$4__F1__Lcats_Applicative__I__sci_List__Lcats_Eval(f$12, G$4, leftSize, leftL$2).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$12$2, G$4$2, rightSize$2, rightL$3) => ((left) => {
      var right = $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$4__F1__Lcats_Applicative__I__sci_List__Lcats_Eval(f$12$2, G$4$2, rightSize$2, rightL$3);
      return G$4$2.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2(((_$5, _$6) => {
        $as_jl_Void(_$5);
        $as_jl_Void(_$6)
      })))
    }))(f$12, G$4, rightSize, rightL$2)))
  } else {
    var a = fa.head__O();
    return $m_Lcats_Eval$().always__F0__Lcats_Eval(new $c_sjsr_AnonFunction0(((f$12$3, G$4$3, a$2) => (() => {
      var gb = f$12$3.apply__O__O(a$2);
      return G$4$3.void__O__O(gb)
    }))(f$12, G$4, a)))
  }
}
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List(fa, acc) {
  var acc$tailLocal1 = acc;
  var fa$tailLocal2 = fa;
  while (true) {
    if (fa$tailLocal2.isEmpty__Z()) {
      return acc$tailLocal1
    } else {
      var fa$tailLocal2$tmp1 = $as_sci_List(fa$tailLocal2.tail__O());
      var this$1 = acc$tailLocal1;
      var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon((void 0), this$1);
      fa$tailLocal2 = fa$tailLocal2$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1
    }
  }
}
/** @constructor */
function $c_Lcats_instances_ListInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_ListInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_ListInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList)
}
$c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_ListInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_ListInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.ListInstancesBinCompat0$$anon$1", {
  Lcats_instances_ListInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_ListInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_ListInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_OptionInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_OptionInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$option$().Lcats_instances_package$option$__f_catsStdInstancesForOption)
}
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_OptionInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OptionInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.OptionInstancesBinCompat0$$anon$1", {
  Lcats_instances_OptionInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_OptionInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_OptionInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$2, fb$2) {
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$1 = fa$2;
  this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$1 = fb$2
}
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderInstances$$anon$2.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$2.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_PartialOrder__eqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__T2__T2__D = (function(x, y) {
  var z = this.Lcats_instances_PartialOrderInstances$$anon$2__f_fa$1.partialCompare__O__O__D(x._1__O(), y._1__O());
  return ((z === 0.0) ? this.Lcats_instances_PartialOrderInstances$$anon$2__f_fb$1.partialCompare__O__O__D(x._2__O(), y._2__O()) : z)
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__T2__T2__D($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_PartialOrderInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_PartialOrderInstances$$anon$2: 0
}, false, "cats.instances.PartialOrderInstances$$anon$2", {
  Lcats_instances_PartialOrderInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1
});
$c_Lcats_instances_PartialOrderInstances$$anon$2.prototype.$classData = $d_Lcats_instances_PartialOrderInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$4, fb$2) {
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fa$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fb$1 = null;
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fa$1 = fa$4;
  this.Lcats_instances_PartialOrderingInstances$$anon$3__f_fb$1 = fb$2
}
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$3.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype;
var $d_Lcats_instances_PartialOrderingInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$3: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$3", {
  Lcats_instances_PartialOrderingInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$3.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$3;
function $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__sci_Queue(f$4, bldr$1, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    var x9 = lists$tailLocal1;
    if ((x9 instanceof $c_sci_$colon$colon)) {
      var x10 = $as_sci_$colon$colon(x9);
      var x12 = x10.sci_$colon$colon__f_next;
      var q = $as_sci_Queue(x10.sci_$colon$colon__f_head);
      if (q.isEmpty__Z()) {
        lists$tailLocal1 = x12;
        continue
      } else {
        matchResult1: {
          var \u03b41$___1;
          var \u03b41$___2;
          var x1 = q.dequeue__T2();
          if ((x1 !== null)) {
            var e = $as_s_util_Either(x1._1__O());
            var es = $as_sci_Queue(x1._2__O());
            var \u03b41$___1 = e;
            var \u03b41$___2 = es;
            break matchResult1
          };
          throw new $c_s_MatchError(x1)
        };
        var e$2 = $as_s_util_Either(\u03b41$___1);
        var es$2 = $as_sci_Queue(\u03b41$___2);
        if ((e$2 instanceof $c_s_util_Right)) {
          var b = $as_s_util_Right(e$2).s_util_Right__f_value;
          bldr$1.addOne__O__scm_Growable(b);
          lists$tailLocal1 = new $c_sci_$colon$colon(es$2, x12);
          continue
        };
        if ((e$2 instanceof $c_s_util_Left)) {
          var a = $as_s_util_Left(e$2).s_util_Left__f_value;
          var elem$1 = $as_sci_Queue(f$4.apply__O__O(a));
          var this$2 = new $c_sci_$colon$colon(es$2, x12);
          lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$2);
          continue
        };
        throw new $c_s_MatchError(e$2)
      }
    };
    var x = $m_s_package$().s_package$__f_Nil;
    if (((x === null) ? (x9 === null) : x.equals__O__Z(x9))) {
      return $as_sci_Queue(bldr$1.result__O())
    };
    throw new $c_s_MatchError(x9)
  }
}
function $ps_Lcats_instances_QueueInstances__loop$3__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1, f$6, as) {
  if (as.isEmpty__Z()) {
    return lb$1
  } else {
    matchResult5: {
      var \u03b42$___1;
      var \u03b42$___2;
      var x16 = as.dequeue__T2();
      if ((x16 !== null)) {
        var h = x16._1__O();
        var t = $as_sci_Queue(x16._2__O());
        var \u03b42$___1 = h;
        var \u03b42$___2 = t;
        break matchResult5
      };
      throw new $c_s_MatchError(x16)
    };
    var h$2 = \u03b42$___1;
    var t$2 = $as_sci_Queue(\u03b42$___2);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((lb$1$2, f$6$2, t$3) => (() => $ps_Lcats_instances_QueueInstances__loop$3__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$1$2, f$6$2, t$3)))(lb$1, f$6, t$2));
    return $as_Lcats_Eval(f$6.apply__O__O__O(h$2, new $c_Lcats_Eval$$anon$5(a)))
  }
}
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$4(a$2, fn$1) {
  this.Lcats_instances_StreamInstances$$anon$4__f_fn$1 = null;
  this.Lcats_instances_StreamInstances$$anon$4__f_stack = null;
  this.Lcats_instances_StreamInstances$$anon$4__f_state = null;
  this.Lcats_instances_StreamInstances$$anon$4__f_fn$1 = fn$1;
  this.Lcats_instances_StreamInstances$$anon$4__f_stack = $as_sci_Stream(fn$1.apply__O__O(a$2));
  this.Lcats_instances_StreamInstances$$anon$4__f_state = ($m_s_package$(), new $c_s_util_Left((void 0)))
}
$c_Lcats_instances_StreamInstances$$anon$4.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$4.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstances$$anon$4.prototype = $c_Lcats_instances_StreamInstances$$anon$4.prototype;
$c_Lcats_instances_StreamInstances$$anon$4.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.advance__V = (function() {
  var this$ = this;
  while (true) {
    matchResult1: {
      var x1 = this$.Lcats_instances_StreamInstances$$anon$4__f_stack;
      if ((x1 !== null)) {
        var x8 = $m_s_package$$hash$colon$colon$().unapply__sci_Stream__s_Option(x1);
        if ((!x8.isEmpty__Z())) {
          var x9 = $as_T2(x8.get__O());
          var x10 = $as_s_util_Either(x9._1__O());
          var x11 = $as_sci_Stream(x9._2__O());
          if ((x10 instanceof $c_s_util_Right)) {
            var b = $as_s_util_Right(x10).s_util_Right__f_value;
            this$.Lcats_instances_StreamInstances$$anon$4__f_stack = x11;
            var $$x1 = this$;
            $m_s_package$();
            var value = new $c_s_Some(b);
            $$x1.Lcats_instances_StreamInstances$$anon$4__f_state = new $c_s_util_Right(value);
            break matchResult1
          };
          if ((x10 instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(x10).s_util_Left__f_value;
            var $$x2 = this$;
            var prefix$1 = $as_sci_Stream(this.Lcats_instances_StreamInstances$$anon$4__f_fn$1.apply__O__O(a));
            var l = new $c_sjsr_AnonFunction0(((tail$3) => (() => tail$3))(x11));
            $$x2.Lcats_instances_StreamInstances$$anon$4__f_stack = prefix$1.lazyAppendedAll__F0__sci_Stream(l);
            this$ = this$;
            continue
          }
        }
      };
      var $$x3 = this$;
      $m_s_package$();
      var value$1 = $m_s_None$();
      $$x3.Lcats_instances_StreamInstances$$anon$4__f_state = new $c_s_util_Right(value$1)
    };
    return (void 0)
  }
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.hasNext__Z = (function() {
  var this$ = this;
  while (true) {
    var x14 = this$.Lcats_instances_StreamInstances$$anon$4__f_state;
    if ((x14 instanceof $c_s_util_Left)) {
      var x$2 = $as_s_util_Left(x14).s_util_Left__f_value;
      var $$x1 = (x$2 === (void 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this$.advance__V();
      this$ = this$;
      continue
    };
    if ((x14 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($as_s_util_Right(x14).s_util_Right__f_value);
      return (!o.isEmpty__Z())
    };
    throw new $c_s_MatchError(x14)
  }
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.next__O = (function() {
  var this$ = this;
  while (true) {
    var x19 = this$.Lcats_instances_StreamInstances$$anon$4__f_state;
    if ((x19 instanceof $c_s_util_Left)) {
      var x$2 = $as_s_util_Left(x19).s_util_Left__f_value;
      var $$x1 = (x$2 === (void 0))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      this$.advance__V();
      this$ = this$;
      continue
    };
    if ((x19 instanceof $c_s_util_Right)) {
      var o = $as_s_Option($as_s_util_Right(x19).s_util_Right__f_value);
      var b = o.get__O();
      this$.advance__V();
      return b
    };
    throw new $c_s_MatchError(x19)
  }
});
var $d_Lcats_instances_StreamInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_StreamInstances$$anon$4: 0
}, false, "cats.instances.StreamInstances$$anon$4", {
  Lcats_instances_StreamInstances$$anon$4: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lcats_instances_StreamInstances$$anon$4.prototype.$classData = $d_Lcats_instances_StreamInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_StreamInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_StreamInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$stream$().Lcats_instances_package$stream$__f_catsStdInstancesForStream)
}
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_StreamInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_StreamInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.StreamInstancesBinCompat0$$anon$1", {
  Lcats_instances_StreamInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_StreamInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_StreamInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype;
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.map__T2__F1__T2 = (function(fa, f) {
  var _1 = f.apply__O__O(fa._1__O());
  var _2 = f.apply__O__O(fa._2__O());
  return new $c_T2(_1, _2)
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__T2__F1__T2($as_T2(fa), f)
});
var $d_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Tuple2InstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.Tuple2InstancesBinCompat0$$anon$1", {
  Lcats_instances_Tuple2InstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1
});
$c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1;
function $ps_Lcats_instances_VectorInstances__loop$3__sci_Vector__Lcats_Eval__F2__I__Lcats_Eval(fa$2, lb$1, f$5, i) {
  if ((i < fa$2.length__I())) {
    var $$x1 = fa$2.apply__I__O(i);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((fa$2$2, lb$1$2, f$5$2, i$2) => (() => $ps_Lcats_instances_VectorInstances__loop$3__sci_Vector__Lcats_Eval__F2__I__Lcats_Eval(fa$2$2, lb$1$2, f$5$2, ((1 + i$2) | 0))))(fa$2, lb$1, f$5, i));
    return $as_Lcats_Eval(f$5.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
  } else {
    return lb$1
  }
}
function $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$4__sci_Vector__F1__Lcats_Applicative__I__I__Lcats_Eval(fa$7, f$10, G$4, size, idx) {
  if ((size > 1)) {
    var leftSize = ((size / 2) | 0);
    var rightSize = ((size - leftSize) | 0);
    return $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$4__sci_Vector__F1__Lcats_Applicative__I__I__Lcats_Eval(fa$7, f$10, G$4, leftSize, idx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fa$7$2, f$10$2, G$4$2, idx$2, leftSize$2, rightSize$2) => ((left) => {
      var right = $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$4__sci_Vector__F1__Lcats_Applicative__I__I__Lcats_Eval(fa$7$2, f$10$2, G$4$2, rightSize$2, ((idx$2 + leftSize$2) | 0));
      return G$4$2.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2(((_$5, _$6) => {
        $as_jl_Void(_$5);
        $as_jl_Void(_$6)
      })))
    }))(fa$7, f$10, G$4, idx, leftSize, rightSize)))
  } else {
    var a = fa$7.apply__I__O(idx);
    return $m_Lcats_Eval$().always__F0__Lcats_Eval(new $c_sjsr_AnonFunction0(((f$10$3, G$4$3, a$2) => (() => {
      var gb = f$10$3.apply__O__O(a$2);
      return G$4$3.void__O__O(gb)
    }))(f$10, G$4, a)))
  }
}
/** @constructor */
function $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1() {
  this.Lcats_instances_VectorInstancesBinCompat0$$anon$1__f_traverse = null;
  this.Lcats_instances_VectorInstancesBinCompat0$$anon$1__f_traverse = $as_Lcats_Traverse($m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector)
}
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstancesBinCompat0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype;
var $d_Lcats_instances_VectorInstancesBinCompat0$$anon$1 = new $TypeData().initClass({
  Lcats_instances_VectorInstancesBinCompat0$$anon$1: 0
}, false, "cats.instances.VectorInstancesBinCompat0$$anon$1", {
  Lcats_instances_VectorInstancesBinCompat0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$1.prototype.$classData = $d_Lcats_instances_VectorInstancesBinCompat0$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$eq$() {
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = null;
  $n_Lcats_instances_package$eq$ = this;
  this.Lcats_instances_package$eq$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1()
}
$c_Lcats_instances_package$eq$.prototype = new $h_O();
$c_Lcats_instances_package$eq$.prototype.constructor = $c_Lcats_instances_package$eq$;
/** @constructor */
function $h_Lcats_instances_package$eq$() {
  /*<skip>*/
}
$h_Lcats_instances_package$eq$.prototype = $c_Lcats_instances_package$eq$.prototype;
var $d_Lcats_instances_package$eq$ = new $TypeData().initClass({
  Lcats_instances_package$eq$: 0
}, false, "cats.instances.package$eq$", {
  Lcats_instances_package$eq$: 1,
  O: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1
});
$c_Lcats_instances_package$eq$.prototype.$classData = $d_Lcats_instances_package$eq$;
var $n_Lcats_instances_package$eq$;
function $m_Lcats_instances_package$eq$() {
  if ((!$n_Lcats_instances_package$eq$)) {
    $n_Lcats_instances_package$eq$ = new $c_Lcats_instances_package$eq$()
  };
  return $n_Lcats_instances_package$eq$
}
/** @constructor */
function $c_Lcats_instances_package$invariant$() {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantForNumeric = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantForIntegral = null;
  this.Lcats_instances_package$invariant$__f_catsInvariantForFractional = null;
  $n_Lcats_instances_package$invariant$ = this;
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_InvariantInstances__$init$__V(this);
  this.Lcats_instances_package$invariant$__f_catsInvariantForFractional = new $c_Lcats_instances_InvariantInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$invariant$.prototype = new $h_O();
$c_Lcats_instances_package$invariant$.prototype.constructor = $c_Lcats_instances_package$invariant$;
/** @constructor */
function $h_Lcats_instances_package$invariant$() {
  /*<skip>*/
}
$h_Lcats_instances_package$invariant$.prototype = $c_Lcats_instances_package$invariant$.prototype;
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalSemigroup = x$0
});
$c_Lcats_instances_package$invariant$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_instances_package$invariant$__f_catsInvariantMonoidalCommutativeSemigroup = x$0
});
var $d_Lcats_instances_package$invariant$ = new $TypeData().initClass({
  Lcats_instances_package$invariant$: 0
}, false, "cats.instances.package$invariant$", {
  Lcats_instances_package$invariant$: 1,
  O: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_instances_InvariantInstances: 1,
  Lcats_instances_InvariantInstancesBinCompat0: 1
});
$c_Lcats_instances_package$invariant$.prototype.$classData = $d_Lcats_instances_package$invariant$;
var $n_Lcats_instances_package$invariant$;
function $m_Lcats_instances_package$invariant$() {
  if ((!$n_Lcats_instances_package$invariant$)) {
    $n_Lcats_instances_package$invariant$ = new $c_Lcats_instances_package$invariant$()
  };
  return $n_Lcats_instances_package$invariant$
}
/** @constructor */
function $c_Lcats_instances_package$order$() {
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = null;
  $n_Lcats_instances_package$order$ = this;
  this.Lcats_instances_package$order$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1()
}
$c_Lcats_instances_package$order$.prototype = new $h_O();
$c_Lcats_instances_package$order$.prototype.constructor = $c_Lcats_instances_package$order$;
/** @constructor */
function $h_Lcats_instances_package$order$() {
  /*<skip>*/
}
$h_Lcats_instances_package$order$.prototype = $c_Lcats_instances_package$order$.prototype;
var $d_Lcats_instances_package$order$ = new $TypeData().initClass({
  Lcats_instances_package$order$: 0
}, false, "cats.instances.package$order$", {
  Lcats_instances_package$order$: 1,
  O: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1
});
$c_Lcats_instances_package$order$.prototype.$classData = $d_Lcats_instances_package$order$;
var $n_Lcats_instances_package$order$;
function $m_Lcats_instances_package$order$() {
  if ((!$n_Lcats_instances_package$order$)) {
    $n_Lcats_instances_package$order$ = new $c_Lcats_instances_package$order$()
  };
  return $n_Lcats_instances_package$order$
}
/** @constructor */
function $c_Lcats_instances_package$partialOrder$() {
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = null;
  $n_Lcats_instances_package$partialOrder$ = this;
  this.Lcats_instances_package$partialOrder$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1()
}
$c_Lcats_instances_package$partialOrder$.prototype = new $h_O();
$c_Lcats_instances_package$partialOrder$.prototype.constructor = $c_Lcats_instances_package$partialOrder$;
/** @constructor */
function $h_Lcats_instances_package$partialOrder$() {
  /*<skip>*/
}
$h_Lcats_instances_package$partialOrder$.prototype = $c_Lcats_instances_package$partialOrder$.prototype;
var $d_Lcats_instances_package$partialOrder$ = new $TypeData().initClass({
  Lcats_instances_package$partialOrder$: 0
}, false, "cats.instances.package$partialOrder$", {
  Lcats_instances_package$partialOrder$: 1,
  O: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1
});
$c_Lcats_instances_package$partialOrder$.prototype.$classData = $d_Lcats_instances_package$partialOrder$;
var $n_Lcats_instances_package$partialOrder$;
function $m_Lcats_instances_package$partialOrder$() {
  if ((!$n_Lcats_instances_package$partialOrder$)) {
    $n_Lcats_instances_package$partialOrder$ = new $c_Lcats_instances_package$partialOrder$()
  };
  return $n_Lcats_instances_package$partialOrder$
}
function $ct_Lcats_kernel_Comparison__I__D__($thiz, toInt, toDouble) {
  $thiz.Lcats_kernel_Comparison__f_toInt = toInt;
  $thiz.Lcats_kernel_Comparison__f_toDouble = toDouble;
  return $thiz
}
/** @constructor */
function $c_Lcats_kernel_Comparison() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0
}
$c_Lcats_kernel_Comparison.prototype = new $h_O();
$c_Lcats_kernel_Comparison.prototype.constructor = $c_Lcats_kernel_Comparison;
/** @constructor */
function $h_Lcats_kernel_Comparison() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison.prototype = $c_Lcats_kernel_Comparison.prototype;
$c_Lcats_kernel_Comparison.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lcats_kernel_Comparison(obj) {
  return (((obj instanceof $c_Lcats_kernel_Comparison) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Comparison"))
}
function $isArrayOf_Lcats_kernel_Comparison(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Comparison)))
}
function $asArrayOf_Lcats_kernel_Comparison(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Comparison(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Comparison;", depth))
}
/** @constructor */
function $c_Lcats_kernel_Group$() {
  /*<skip>*/
}
$c_Lcats_kernel_Group$.prototype = new $h_Lcats_kernel_GroupFunctions();
$c_Lcats_kernel_Group$.prototype.constructor = $c_Lcats_kernel_Group$;
/** @constructor */
function $h_Lcats_kernel_Group$() {
  /*<skip>*/
}
$h_Lcats_kernel_Group$.prototype = $c_Lcats_kernel_Group$.prototype;
var $d_Lcats_kernel_Group$ = new $TypeData().initClass({
  Lcats_kernel_Group$: 0
}, false, "cats.kernel.Group$", {
  Lcats_kernel_Group$: 1,
  Lcats_kernel_GroupFunctions: 1,
  Lcats_kernel_MonoidFunctions: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1
});
$c_Lcats_kernel_Group$.prototype.$classData = $d_Lcats_kernel_Group$;
var $n_Lcats_kernel_Group$;
function $m_Lcats_kernel_Group$() {
  if ((!$n_Lcats_kernel_Group$)) {
    $n_Lcats_kernel_Group$ = new $c_Lcats_kernel_Group$()
  };
  return $n_Lcats_kernel_Group$
}
/** @constructor */
function $c_Lcats_kernel_Hash$$anon$3() {
  /*<skip>*/
}
$c_Lcats_kernel_Hash$$anon$3.prototype = new $h_O();
$c_Lcats_kernel_Hash$$anon$3.prototype.constructor = $c_Lcats_kernel_Hash$$anon$3;
/** @constructor */
function $h_Lcats_kernel_Hash$$anon$3() {
  /*<skip>*/
}
$h_Lcats_kernel_Hash$$anon$3.prototype = $c_Lcats_kernel_Hash$$anon$3.prototype;
$c_Lcats_kernel_Hash$$anon$3.prototype.hash__O__I = (function(x) {
  return $dp_hashCode__I(x)
});
$c_Lcats_kernel_Hash$$anon$3.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
});
var $d_Lcats_kernel_Hash$$anon$3 = new $TypeData().initClass({
  Lcats_kernel_Hash$$anon$3: 0
}, false, "cats.kernel.Hash$$anon$3", {
  Lcats_kernel_Hash$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_Hash$$anon$3.prototype.$classData = $d_Lcats_kernel_Hash$$anon$3;
function $f_Lcats_kernel_Order__partialCompare__O__O__D($thiz, x, y) {
  return $thiz.compare__O__O__I(x, y)
}
function $f_Lcats_kernel_Order__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0)
}
function $is_Lcats_kernel_Order(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_kernel_Order)))
}
function $as_Lcats_kernel_Order(obj) {
  return (($is_Lcats_kernel_Order(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.kernel.Order"))
}
function $isArrayOf_Lcats_kernel_Order(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_kernel_Order)))
}
function $asArrayOf_Lcats_kernel_Order(obj, depth) {
  return (($isArrayOf_Lcats_kernel_Order(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.kernel.Order;", depth))
}
/** @constructor */
function $c_Lcats_kernel_PartialOrder$() {
  /*<skip>*/
}
$c_Lcats_kernel_PartialOrder$.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_PartialOrder$.prototype.constructor = $c_Lcats_kernel_PartialOrder$;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$() {
  /*<skip>*/
}
$h_Lcats_kernel_PartialOrder$.prototype = $c_Lcats_kernel_PartialOrder$.prototype;
var $d_Lcats_kernel_PartialOrder$ = new $TypeData().initClass({
  Lcats_kernel_PartialOrder$: 0
}, false, "cats.kernel.PartialOrder$", {
  Lcats_kernel_PartialOrder$: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1
});
$c_Lcats_kernel_PartialOrder$.prototype.$classData = $d_Lcats_kernel_PartialOrder$;
var $n_Lcats_kernel_PartialOrder$;
function $m_Lcats_kernel_PartialOrder$() {
  if ((!$n_Lcats_kernel_PartialOrder$)) {
    $n_Lcats_kernel_PartialOrder$ = new $c_Lcats_kernel_PartialOrder$()
  };
  return $n_Lcats_kernel_PartialOrder$
}
/** @constructor */
function $c_Lcats_kernel_instances_StringMonoid() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_StringMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StringMonoid.prototype.constructor = $c_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StringMonoid() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StringMonoid.prototype = $c_Lcats_kernel_instances_StringMonoid.prototype;
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__T__T__T = (function(x, y) {
  return (("" + x) + y)
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__T = (function(xs) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var this$1 = xs.iterator__sc_Iterator();
  while (this$1.hasNext__Z()) {
    var arg1 = this$1.next__O();
    var s = $as_T(arg1);
    sb.append__T__scm_StringBuilder(s)
  };
  return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_Lcats_kernel_instances_StringMonoid.prototype.empty__O = (function() {
  return ""
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T__T__T($as_T(x), $as_T(y))
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__T(as)
});
var $d_Lcats_kernel_instances_StringMonoid = new $TypeData().initClass({
  Lcats_kernel_instances_StringMonoid: 0
}, false, "cats.kernel.instances.StringMonoid", {
  Lcats_kernel_instances_StringMonoid: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_instances_StringMonoid.prototype.$classData = $d_Lcats_kernel_instances_StringMonoid;
function $p_Lfs2_Chunk__loop$1__F1__Lcats_Applicative__I__I__I__Lcats_Eval($thiz, f$7, F$1, width$1, start, end) {
  if ((((end - start) | 0) <= width$1)) {
    var target = f$7.apply__O__O($thiz.apply__I__O((((-1) + end) | 0)));
    var this$3 = new $c_Lcats_Functor$$anon$4(target, F$1);
    var f = new $c_sjsr_AnonFunction1(((_$2) => {
      var this$2 = $m_s_package$().s_package$__f_Nil;
      return new $c_sci_$colon$colon(_$2, this$2)
    }));
    var flist = this$3.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$3.Lcats_Functor$$anon$4__f_self, f);
    var idx = (((-2) + end) | 0);
    while ((start <= idx)) {
      flist = F$1.map2__O__O__F2__O(f$7.apply__O__O($thiz.apply__I__O(idx)), flist, new $c_sjsr_AnonFunction2(((_$3, _$4) => {
        var _$4$1 = $as_sci_List(_$4);
        return new $c_sci_$colon$colon(_$3, _$4$1)
      })));
      idx = (((-1) + idx) | 0)
    };
    $m_Lcats_Eval$();
    var target$1 = flist;
    var this$5 = new $c_Lcats_Functor$$anon$4(target$1, F$1);
    var f$1 = new $c_sjsr_AnonFunction1(((_$5) => {
      var _$5$1 = $as_sci_List(_$5);
      return $m_Lcats_data_Chain$().fromSeq__sci_Seq__Lcats_data_Chain(_$5$1)
    }));
    var a = this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f$1);
    return new $c_Lcats_Now(a)
  } else {
    var step = $intDiv(((end - start) | 0), width$1);
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0(((this$8, f$7$2, F$1$2, width$1$2, start$2, step$2) => (() => $p_Lfs2_Chunk__loop$1__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this$8, f$7$2, F$1$2, width$1$2, start$2, ((start$2 + step$2) | 0))))($thiz, f$7, F$1, width$1, start, step));
    var fchain = new $c_Lcats_Eval$$anon$5(a$1);
    var start0 = ((start + step) | 0);
    var end0 = ((start0 + step) | 0);
    while ((start0 < end)) {
      var y = end0;
      var end1 = ((end < y) ? end : y);
      var start1 = start0;
      fchain = fchain.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2$1, f$7$3, F$1$3, width$1$3, end1$2, start1$2) => ((_$6) => {
        $m_Lcats_Eval$();
        var a$2 = new $c_sjsr_AnonFunction0(((this$12, f$9$2, F$3$2, width$3$2, end1$1$2, start1$1$2) => (() => $p_Lfs2_Chunk__loop$1__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this$12, f$9$2, F$3$2, width$3$2, start1$1$2, end1$1$2)))(this$2$1, f$7$3, F$1$3, width$1$3, end1$2, start1$2));
        return F$1$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(_$6, new $c_Lcats_Eval$$anon$5(a$2), new $c_sjsr_AnonFunction2(((_$7, _$8) => {
          var _$7$1 = $as_Lcats_data_Chain(_$7);
          var _$8$1 = $as_Lcats_data_Chain(_$8);
          return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(_$7$1, _$8$1)
        })))
      }))($thiz, f$7, F$1, width$1, end1, start1)));
      start0 = ((start0 + step) | 0);
      end0 = ((end0 + step) | 0)
    };
    return fchain
  }
}
/** @constructor */
function $c_Lfs2_Chunk() {
  /*<skip>*/
}
$c_Lfs2_Chunk.prototype = new $h_O();
$c_Lfs2_Chunk.prototype.constructor = $c_Lfs2_Chunk;
/** @constructor */
function $h_Lfs2_Chunk() {
  /*<skip>*/
}
$h_Lfs2_Chunk.prototype = $c_Lfs2_Chunk.prototype;
$c_Lfs2_Chunk.prototype.flatMap__F1__Lfs2_Chunk = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_Lfs2_Chunk$().Lfs2_Chunk$__f_empty_
  } else {
    var elem = $m_Lfs2_Chunk$Queue$().Lfs2_Chunk$Queue$__f_empty_;
    var acc = new $c_sr_ObjectRef(elem);
    this.foreach__F1__V(new $c_sjsr_AnonFunction1(((f$2, acc$2) => ((o) => {
      var ev$10 = $as_Lfs2_Chunk$Queue(acc$2.sr_ObjectRef__f_elem).$colon$plus__Lfs2_Chunk__Lfs2_Chunk$Queue($as_Lfs2_Chunk(f$2.apply__O__O(o)));
      acc$2.sr_ObjectRef__f_elem = ev$10
    }))(f, acc)));
    return $as_Lfs2_Chunk$Queue(acc.sr_ObjectRef__f_elem)
  }
});
$c_Lfs2_Chunk.prototype.foldLeft__O__F2__O = (function(init, f) {
  var res = new $c_sr_ObjectRef(init);
  this.foreach__F1__V(new $c_sjsr_AnonFunction1(((f$2, res$2) => ((o) => {
    var ev$11 = f$2.apply__O__O__O(res$2.sr_ObjectRef__f_elem, o);
    res$2.sr_ObjectRef__f_elem = ev$11
  }))(f, res)));
  return res.sr_ObjectRef__f_elem
});
$c_Lfs2_Chunk.prototype.foreach__F1__V = (function(f) {
  var i = 0;
  while ((i < this.size__I())) {
    f.apply__O__O(this.apply__I__O(i));
    i = ((1 + i) | 0)
  }
});
$c_Lfs2_Chunk.prototype.foreachWithIndex__F2__V = (function(f) {
  var i = 0;
  while ((i < this.size__I())) {
    f.apply__O__O__O(this.apply__I__O(i), i);
    i = ((1 + i) | 0)
  }
});
$c_Lfs2_Chunk.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0)
});
$c_Lfs2_Chunk.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lfs2_Chunk$$anon$1(this)
});
$c_Lfs2_Chunk.prototype.last__s_Option = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_None$()
  } else {
    var value = this.apply__I__O((((-1) + this.size__I()) | 0));
    return new $c_s_Some(value)
  }
});
$c_Lfs2_Chunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  var dimensions = new $ac_I(new Int32Array([this.size__I()]));
  var arr = $asArrayOf_O($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions), 1);
  this.foreachWithIndex__F2__V(new $c_sjsr_AnonFunction2(((f$2, arr$2) => ((v1, v2) => {
    var i = $uI(v2);
    arr$2.set(i, f$2.apply__O__O(v1))
  }))(f, arr)));
  var this$4 = $m_Lfs2_Chunk$();
  var evidence$2 = $m_s_reflect_ManifestFactory$AnyManifest$();
  var length = arr.u.length;
  if ((length === 0)) {
    return this$4.Lfs2_Chunk$__f_empty_
  } else if ((length === 1)) {
    var o = arr.get(0);
    return new $c_Lfs2_Chunk$Singleton(o)
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(arr, 0, length, evidence$2)
  }
});
$c_Lfs2_Chunk.prototype.toIndexedChunk__Lfs2_Chunk = (function() {
  if ((this instanceof $c_Lfs2_Chunk$Queue)) {
    $m_s_reflect_ManifestFactory$AnyManifest$();
    var b = new $c_scm_ArrayBuilder$generic($d_O.getClassOf());
    b.sizeHint__I__V(this.size__I());
    this.foreach__F1__V(new $c_sjsr_AnonFunction1(((b$2) => ((o) => {
      b$2.addOne__O__scm_ArrayBuilder$generic(o)
    }))(b)));
    var this$8 = $m_Lfs2_Chunk$();
    var values = b.result__O();
    var evidence$2 = $m_s_reflect_ManifestFactory$AnyManifest$();
    var length = $m_sr_ScalaRunTime$().array_length__O__I(values);
    if ((length === 0)) {
      return this$8.Lfs2_Chunk$__f_empty_
    } else if ((length === 1)) {
      var o$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(values, 0);
      return new $c_Lfs2_Chunk$Singleton(o$1)
    } else {
      return new $c_Lfs2_Chunk$ArraySlice(values, 0, length, evidence$2)
    }
  } else {
    return this
  }
});
$c_Lfs2_Chunk.prototype.traverse__F1__Lcats_Applicative__O = (function(f, F) {
  return (this.isEmpty__Z() ? F.pure__O__O($m_Lfs2_Chunk$().Lfs2_Chunk$__f_empty_) : F.map__O__F1__O($p_Lfs2_Chunk__loop$1__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this, f, F, 128, 0, this.size__I()).value__O(), new $c_sjsr_AnonFunction1(((c) => {
    var c$1 = $as_Lcats_data_Chain(c);
    return $m_Lfs2_Chunk$().chain__Lcats_data_Chain__Lfs2_Chunk(c$1)
  }))))
});
$c_Lfs2_Chunk.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var elem = this$1.stringHash__T__I__I("Chunk", (-137723950));
  var h = new $c_sr_IntRef(elem);
  this.foreach__F1__V(new $c_sjsr_AnonFunction1(((h$2) => ((o) => {
    var ev$16 = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h$2.sr_IntRef__f_elem, $m_sr_Statics$().anyHash__O__I(o));
    h$2.sr_IntRef__f_elem = ev$16
  }))(h)));
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h.sr_IntRef__f_elem, this.size__I())
});
$c_Lfs2_Chunk.prototype.equals__O__Z = (function(a) {
  if ((a instanceof $c_Lfs2_Chunk)) {
    var c = $as_Lfs2_Chunk(a);
    if ((this.size__I() === c.size__I())) {
      var this$1 = this.iterator__sc_Iterator();
      var that = c.iterator__sc_Iterator();
      return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Chunk.prototype.toString__T = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "Chunk(", ", ", ")")
});
function $as_Lfs2_Chunk(obj) {
  return (((obj instanceof $c_Lfs2_Chunk) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Chunk"))
}
function $isArrayOf_Lfs2_Chunk(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Chunk)))
}
function $asArrayOf_Lfs2_Chunk(obj, depth) {
  return (($isArrayOf_Lfs2_Chunk(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Chunk;", depth))
}
var $d_Lfs2_Chunk = new $TypeData().initClass({
  Lfs2_Chunk: 0
}, false, "fs2.Chunk", {
  Lfs2_Chunk: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
});
$c_Lfs2_Chunk.prototype.$classData = $d_Lfs2_Chunk;
function $s_Lfs2_Chunk$__fs2$Chunk$$anon$3$$_$go$1__Lfs2_Chunk__Lcats_Eval__F2__I__Lcats_Eval(fa$1, b$5, f$16, i) {
  if ((i < fa$1.size__I())) {
    var $$x1 = fa$1.apply__I__O(i);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0(((fa$1$2, b$5$2, f$16$2, i$2) => (() => $s_Lfs2_Chunk$__fs2$Chunk$$anon$3$$_$go$1__Lfs2_Chunk__Lcats_Eval__F2__I__Lcats_Eval(fa$1$2, b$5$2, f$16$2, ((1 + i$2) | 0))))(fa$1, b$5, f$16, i));
    return $as_Lcats_Eval(f$16.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
  } else {
    return b$5
  }
}
/** @constructor */
function $c_Lfs2_Chunk$() {
  this.Lfs2_Chunk$__f_IArraySlice$lzy1 = null;
  this.Lfs2_Chunk$__f_IArraySlicebitmap$1 = false;
  this.Lfs2_Chunk$__f_empty_ = null;
  this.Lfs2_Chunk$__f_instance = null;
  $n_Lfs2_Chunk$ = this;
  this.Lfs2_Chunk$__f_empty_ = new $c_Lfs2_Chunk$EmptyChunk();
  this.Lfs2_Chunk$__f_instance = new $c_Lfs2_Chunk$$anon$3()
}
$c_Lfs2_Chunk$.prototype = new $h_O();
$c_Lfs2_Chunk$.prototype.constructor = $c_Lfs2_Chunk$;
/** @constructor */
function $h_Lfs2_Chunk$() {
  /*<skip>*/
}
$h_Lfs2_Chunk$.prototype = $c_Lfs2_Chunk$.prototype;
$c_Lfs2_Chunk$.prototype.indexedSeq__sc_IndexedSeq__Lfs2_Chunk = (function(s) {
  if (s.isEmpty__Z()) {
    return this.Lfs2_Chunk$__f_empty_
  } else if ((s.length__I() === 1)) {
    var o = s.head__O();
    return new $c_Lfs2_Chunk$Singleton(o)
  } else {
    return new $c_Lfs2_Chunk$IndexedSeqChunk(s)
  }
});
$c_Lfs2_Chunk$.prototype.iterable__sc_Iterable__Lfs2_Chunk = (function(i) {
  var this$1 = $f_Lfs2_ChunkCompanionPlatform__platformIterable__sc_Iterable__s_Option(this, i);
  if (this$1.isEmpty__Z()) {
    if ((i instanceof $c_scm_ArraySeq)) {
      var a = $as_scm_ArraySeq(i);
      var $$x1 = this.arraySeq__scm_ArraySeq__Lfs2_Chunk(a)
    } else if ((i instanceof $c_sci_Vector)) {
      var v = $as_sci_Vector(i);
      var $$x1 = this.indexedSeq__sc_IndexedSeq__Lfs2_Chunk(v)
    } else if ((i instanceof $c_sci_List)) {
      var l = $as_sci_List(i);
      if (l.isEmpty__Z()) {
        var $$x1 = this.Lfs2_Chunk$__f_empty_
      } else if ($as_sci_List(l.tail__O()).isEmpty__Z()) {
        var o = l.head__O();
        var $$x1 = new $c_Lfs2_Chunk$Singleton(o)
      } else {
        $m_s_reflect_ManifestFactory$AnyManifest$();
        var capacity = 0;
        var size = 0;
        var jsElems = null;
        capacity = 0;
        size = 0;
        jsElems = [];
        var it = l.iterator__sc_Iterator();
        while (it.hasNext__Z()) {
          var elem = it.next__O();
          var unboxedElem = ((elem === null) ? null : elem);
          jsElems.push(unboxedElem)
        };
        var values = new $ac_O(jsElems);
        var evidence$2 = $m_s_reflect_ManifestFactory$AnyManifest$();
        var length = values.u.length;
        if ((length === 0)) {
          var $$x1 = this.Lfs2_Chunk$__f_empty_
        } else if ((length === 1)) {
          var o$1 = values.get(0);
          var $$x1 = new $c_Lfs2_Chunk$Singleton(o$1)
        } else {
          var $$x1 = new $c_Lfs2_Chunk$ArraySlice(values, 0, length, evidence$2)
        }
      }
    } else if ($is_sc_IndexedSeq(i)) {
      var ix = $as_sc_IndexedSeq(i);
      var $$x1 = this.indexedSeq__sc_IndexedSeq__Lfs2_Chunk(ix)
    } else {
      var $$x1 = (i.isEmpty__Z() ? this.Lfs2_Chunk$__f_empty_ : this.iterator__sc_Iterator__Lfs2_Chunk(i.iterator__sc_Iterator()))
    }
  } else {
    var $$x1 = this$1.get__O()
  };
  return $as_Lfs2_Chunk($$x1)
});
$c_Lfs2_Chunk$.prototype.iterator__sc_Iterator__Lfs2_Chunk = (function(itr) {
  if ((!itr.hasNext__Z())) {
    return this.Lfs2_Chunk$__f_empty_
  } else {
    var head = itr.next__O();
    if (itr.hasNext__Z()) {
      $m_s_reflect_ManifestFactory$AnyManifest$();
      var capacity = 0;
      var size = 0;
      var jsElems = null;
      capacity = 0;
      size = 0;
      jsElems = [];
      var unboxedElem = ((head === null) ? null : head);
      jsElems.push(unboxedElem);
      while (itr.hasNext__Z()) {
        var elem = itr.next__O();
        var unboxedElem$1 = ((elem === null) ? null : elem);
        jsElems.push(unboxedElem$1)
      };
      var values = new $ac_O(jsElems);
      var evidence$2 = $m_s_reflect_ManifestFactory$AnyManifest$();
      var length = values.u.length;
      if ((length === 0)) {
        return this.Lfs2_Chunk$__f_empty_
      } else if ((length === 1)) {
        var o = values.get(0);
        return new $c_Lfs2_Chunk$Singleton(o)
      } else {
        return new $c_Lfs2_Chunk$ArraySlice(values, 0, length, evidence$2)
      }
    } else {
      return new $c_Lfs2_Chunk$Singleton(head)
    }
  }
});
$c_Lfs2_Chunk$.prototype.arraySeq__scm_ArraySeq__Lfs2_Chunk = (function(arraySeq) {
  var arr = arraySeq.array__O();
  return this.array__O__s_reflect_ClassTag__Lfs2_Chunk(arr, $m_s_reflect_ClassTag$().apply__jl_Class__s_reflect_ClassTag($objectGetClass(arr).getComponentType__jl_Class()))
});
$c_Lfs2_Chunk$.prototype.chain__Lcats_data_Chain__Lfs2_Chunk = (function(c) {
  return (c.isEmpty__Z() ? this.Lfs2_Chunk$__f_empty_ : this.iterator__sc_Iterator__Lfs2_Chunk(c.iterator__sc_Iterator()))
});
$c_Lfs2_Chunk$.prototype.array__O__s_reflect_ClassTag__Lfs2_Chunk = (function(values, evidence$2) {
  return this.array__O__I__I__s_reflect_ClassTag__Lfs2_Chunk(values, 0, $m_sr_ScalaRunTime$().array_length__O__I(values), evidence$2)
});
$c_Lfs2_Chunk$.prototype.array__O__I__I__s_reflect_ClassTag__Lfs2_Chunk = (function(values, offset, length, evidence$3) {
  if ((length === 0)) {
    return this.Lfs2_Chunk$__f_empty_
  } else if ((length === 1)) {
    var o = $m_sr_ScalaRunTime$().array_apply__O__I__O(values, offset);
    return new $c_Lfs2_Chunk$Singleton(o)
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(values, offset, length, evidence$3)
  }
});
function $as_Lfs2_Chunk$(obj) {
  return (((obj instanceof $c_Lfs2_Chunk$) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Chunk$"))
}
function $isArrayOf_Lfs2_Chunk$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Chunk$)))
}
function $asArrayOf_Lfs2_Chunk$(obj, depth) {
  return (($isArrayOf_Lfs2_Chunk$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Chunk$;", depth))
}
var $d_Lfs2_Chunk$ = new $TypeData().initClass({
  Lfs2_Chunk$: 0
}, false, "fs2.Chunk$", {
  Lfs2_Chunk$: 1,
  O: 1,
  Lfs2_CollectorK: 1,
  Lfs2_ChunkCompanionPlatform: 1,
  Lfs2_ChunkCompanionRuntimePlatform: 1
});
$c_Lfs2_Chunk$.prototype.$classData = $d_Lfs2_Chunk$;
var $n_Lfs2_Chunk$;
function $m_Lfs2_Chunk$() {
  if ((!$n_Lfs2_Chunk$)) {
    $n_Lfs2_Chunk$ = new $c_Lfs2_Chunk$()
  };
  return $n_Lfs2_Chunk$
}
/** @constructor */
function $c_Lfs2_Chunk$$anon$1(outer) {
  this.Lfs2_Chunk$$anon$1__f_i = 0;
  this.Lfs2_Chunk$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lfs2_Chunk$$anon$1__f_$outer = outer;
  this.Lfs2_Chunk$$anon$1__f_i = 0
}
$c_Lfs2_Chunk$$anon$1.prototype = new $h_O();
$c_Lfs2_Chunk$$anon$1.prototype.constructor = $c_Lfs2_Chunk$$anon$1;
/** @constructor */
function $h_Lfs2_Chunk$$anon$1() {
  /*<skip>*/
}
$h_Lfs2_Chunk$$anon$1.prototype = $c_Lfs2_Chunk$$anon$1.prototype;
$c_Lfs2_Chunk$$anon$1.prototype.knownSize__I = (function() {
  return (-1)
});
$c_Lfs2_Chunk$$anon$1.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lfs2_Chunk$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lfs2_Chunk$$anon$1.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_Lfs2_Chunk$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lfs2_Chunk$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_Lfs2_Chunk$$anon$1.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_Lfs2_Chunk$$anon$1.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_Lfs2_Chunk$$anon$1.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_Lfs2_Chunk$$anon$1.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_Lfs2_Chunk$$anon$1.prototype.hasNext__Z = (function() {
  return (this.Lfs2_Chunk$$anon$1__f_i < this.Lfs2_Chunk$$anon$1__f_$outer.size__I())
});
$c_Lfs2_Chunk$$anon$1.prototype.next__O = (function() {
  var result = this.Lfs2_Chunk$$anon$1__f_$outer.apply__I__O(this.Lfs2_Chunk$$anon$1__f_i);
  this.Lfs2_Chunk$$anon$1__f_i = ((1 + this.Lfs2_Chunk$$anon$1__f_i) | 0);
  return result
});
var $d_Lfs2_Chunk$$anon$1 = new $TypeData().initClass({
  Lfs2_Chunk$$anon$1: 0
}, false, "fs2.Chunk$$anon$1", {
  Lfs2_Chunk$$anon$1: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
});
$c_Lfs2_Chunk$$anon$1.prototype.$classData = $d_Lfs2_Chunk$$anon$1;
/** @constructor */
function $c_Lfs2_Pull$AlgEffect() {
  /*<skip>*/
}
$c_Lfs2_Pull$AlgEffect.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$AlgEffect.prototype.constructor = $c_Lfs2_Pull$AlgEffect;
/** @constructor */
function $h_Lfs2_Pull$AlgEffect() {
  /*<skip>*/
}
$h_Lfs2_Pull$AlgEffect.prototype = $c_Lfs2_Pull$AlgEffect.prototype;
function $as_Lfs2_Pull$AlgEffect(obj) {
  return (((obj instanceof $c_Lfs2_Pull$AlgEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$AlgEffect"))
}
function $isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$AlgEffect)))
}
function $asArrayOf_Lfs2_Pull$AlgEffect(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$AlgEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$AlgEffect;", depth))
}
function $ct_Lfs2_Pull$Bind__Lfs2_Pull__($thiz, step) {
  $thiz.Lfs2_Pull$Bind__f_step = step;
  return $thiz
}
/** @constructor */
function $c_Lfs2_Pull$Bind() {
  this.Lfs2_Pull$Bind__f_step = null
}
$c_Lfs2_Pull$Bind.prototype = new $h_Lfs2_Pull();
$c_Lfs2_Pull$Bind.prototype.constructor = $c_Lfs2_Pull$Bind;
/** @constructor */
function $h_Lfs2_Pull$Bind() {
  /*<skip>*/
}
$h_Lfs2_Pull$Bind.prototype = $c_Lfs2_Pull$Bind.prototype;
$c_Lfs2_Pull$Bind.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_Lfs2_Pull$Bind.prototype.toString__T = (function() {
  return "<function1>"
});
$c_Lfs2_Pull$Bind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this
});
$c_Lfs2_Pull$Bind.prototype.apply__O__O = (function(v1) {
  var r = $as_Lfs2_Pull$Terminal(v1);
  return this.cont__Lfs2_Pull$Terminal__Lfs2_Pull(r)
});
function $as_Lfs2_Pull$Bind(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Bind) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Bind"))
}
function $isArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Bind)))
}
function $asArrayOf_Lfs2_Pull$Bind(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Bind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Bind;", depth))
}
/** @constructor */
function $c_Lfs2_concurrent_Channel$State$1(values, size, waiting, producers, closed) {
  this.Lfs2_concurrent_Channel$State$1__f_values = null;
  this.Lfs2_concurrent_Channel$State$1__f_size = 0;
  this.Lfs2_concurrent_Channel$State$1__f_waiting = null;
  this.Lfs2_concurrent_Channel$State$1__f_producers = null;
  this.Lfs2_concurrent_Channel$State$1__f_closed = false;
  this.Lfs2_concurrent_Channel$State$1__f_values = values;
  this.Lfs2_concurrent_Channel$State$1__f_size = size;
  this.Lfs2_concurrent_Channel$State$1__f_waiting = waiting;
  this.Lfs2_concurrent_Channel$State$1__f_producers = producers;
  this.Lfs2_concurrent_Channel$State$1__f_closed = closed
}
$c_Lfs2_concurrent_Channel$State$1.prototype = new $h_O();
$c_Lfs2_concurrent_Channel$State$1.prototype.constructor = $c_Lfs2_concurrent_Channel$State$1;
/** @constructor */
function $h_Lfs2_concurrent_Channel$State$1() {
  /*<skip>*/
}
$h_Lfs2_concurrent_Channel$State$1.prototype = $c_Lfs2_concurrent_Channel$State$1.prototype;
$c_Lfs2_concurrent_Channel$State$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_concurrent_Channel$State$1.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfs2_concurrent_Channel$State$1__f_values;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lfs2_concurrent_Channel$State$1__f_size;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lfs2_concurrent_Channel$State$1__f_waiting;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lfs2_concurrent_Channel$State$1__f_producers;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var data$5 = (this.Lfs2_concurrent_Channel$State$1__f_closed ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$6, 5)
});
$c_Lfs2_concurrent_Channel$State$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_concurrent_Channel$State$1)) {
    var x$0$2 = $as_Lfs2_concurrent_Channel$State$1(x$0);
    if (((this.Lfs2_concurrent_Channel$State$1__f_size === x$0$2.Lfs2_concurrent_Channel$State$1__f_size) && (this.Lfs2_concurrent_Channel$State$1__f_closed === x$0$2.Lfs2_concurrent_Channel$State$1__f_closed))) {
      var x = this.Lfs2_concurrent_Channel$State$1__f_values;
      var x$2 = x$0$2.Lfs2_concurrent_Channel$State$1__f_values;
      var $$x2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$3 = this.Lfs2_concurrent_Channel$State$1__f_waiting;
      var x$4 = x$0$2.Lfs2_concurrent_Channel$State$1__f_waiting;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lfs2_concurrent_Channel$State$1__f_producers;
      var x$6 = x$0$2.Lfs2_concurrent_Channel$State$1__f_producers;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_concurrent_Channel$State$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productArity__I = (function() {
  return 5
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lfs2_concurrent_Channel$State$1.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_concurrent_Channel$State$1__f_values;
      break
    }
    case 1: {
      return this.Lfs2_concurrent_Channel$State$1__f_size;
      break
    }
    case 2: {
      return this.Lfs2_concurrent_Channel$State$1__f_waiting;
      break
    }
    case 3: {
      return this.Lfs2_concurrent_Channel$State$1__f_producers;
      break
    }
    case 4: {
      return this.Lfs2_concurrent_Channel$State$1__f_closed;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lfs2_concurrent_Channel$State$1(obj) {
  return (((obj instanceof $c_Lfs2_concurrent_Channel$State$1) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.concurrent.Channel$State$1"))
}
function $isArrayOf_Lfs2_concurrent_Channel$State$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_concurrent_Channel$State$1)))
}
function $asArrayOf_Lfs2_concurrent_Channel$State$1(obj, depth) {
  return (($isArrayOf_Lfs2_concurrent_Channel$State$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.concurrent.Channel$State$1;", depth))
}
var $d_Lfs2_concurrent_Channel$State$1 = new $TypeData().initClass({
  Lfs2_concurrent_Channel$State$1: 0
}, false, "fs2.concurrent.Channel$State$1", {
  Lfs2_concurrent_Channel$State$1: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_concurrent_Channel$State$1.prototype.$classData = $d_Lfs2_concurrent_Channel$State$1;
function $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O($thiz, outcome) {
  var wrapped = $thiz.Lfs2_internal_InterruptContext__f_ref.update__F1__O(new $c_sjsr_AnonFunction1(((outcome$2) => ((_$2) => {
    var _$2$1 = $as_s_Option(_$2);
    return (_$2$1.isEmpty__Z() ? new $c_s_Some(outcome$2) : _$2$1)
  }))(outcome)));
  var target = $thiz.Lfs2_internal_InterruptContext__f_deferred.complete__O__O(outcome);
  var tc = $thiz.Lfs2_internal_InterruptContext__f_F;
  var this$4 = new $c_Lcats_Functor$$anon$4(target, tc);
  var fin = this$4.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$4.Lcats_Functor$$anon$4__f_self);
  var F = $thiz.Lfs2_internal_InterruptContext__f_F;
  return F.guarantee__O__O__O(wrapped, fin)
}
/** @constructor */
function $c_Lfs2_internal_InterruptContext(deferred, ref, interruptRoot, cancelParent, F) {
  this.Lfs2_internal_InterruptContext__f_deferred = null;
  this.Lfs2_internal_InterruptContext__f_ref = null;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = null;
  this.Lfs2_internal_InterruptContext__f_cancelParent = null;
  this.Lfs2_internal_InterruptContext__f_F = null;
  this.Lfs2_internal_InterruptContext__f_deferred = deferred;
  this.Lfs2_internal_InterruptContext__f_ref = ref;
  this.Lfs2_internal_InterruptContext__f_interruptRoot = interruptRoot;
  this.Lfs2_internal_InterruptContext__f_cancelParent = cancelParent;
  this.Lfs2_internal_InterruptContext__f_F = F
}
$c_Lfs2_internal_InterruptContext.prototype = new $h_O();
$c_Lfs2_internal_InterruptContext.prototype.constructor = $c_Lfs2_internal_InterruptContext;
/** @constructor */
function $h_Lfs2_internal_InterruptContext() {
  /*<skip>*/
}
$h_Lfs2_internal_InterruptContext.prototype = $c_Lfs2_internal_InterruptContext.prototype;
$c_Lfs2_internal_InterruptContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_internal_InterruptContext.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_internal_InterruptContext.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_internal_InterruptContext)) {
    var x$0$2 = $as_Lfs2_internal_InterruptContext(x$0);
    var x = this.Lfs2_internal_InterruptContext__f_deferred;
    var x$2 = x$0$2.Lfs2_internal_InterruptContext__f_deferred;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_internal_InterruptContext__f_ref;
      var x$4 = x$0$2.Lfs2_internal_InterruptContext__f_ref;
      var $$x2 = (x$3 === x$4)
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$5 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
      var x$6 = x$0$2.Lfs2_internal_InterruptContext__f_interruptRoot;
      var $$x1 = (x$5 === x$6)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$1 = this.Lfs2_internal_InterruptContext__f_cancelParent;
      var y = x$0$2.Lfs2_internal_InterruptContext__f_cancelParent;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_internal_InterruptContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_internal_InterruptContext.prototype.productArity__I = (function() {
  return 4
});
$c_Lfs2_internal_InterruptContext.prototype.productPrefix__T = (function() {
  return "InterruptContext"
});
$c_Lfs2_internal_InterruptContext.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_InterruptContext__f_deferred;
      break
    }
    case 1: {
      return this.Lfs2_internal_InterruptContext__f_ref;
      break
    }
    case 2: {
      return this.Lfs2_internal_InterruptContext__f_interruptRoot;
      break
    }
    case 3: {
      return this.Lfs2_internal_InterruptContext__f_cancelParent;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lfs2_internal_InterruptContext.prototype.completeWhen__O__O = (function(outcome) {
  var $$x1 = this.Lfs2_internal_InterruptContext__f_F;
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$3 = new $c_Lcats_FlatMap$$anon$2(outcome, tc);
  var f = new $c_sjsr_AnonFunction1(((this$2) => ((outcome$2) => {
    var outcome$1 = $as_Lcats_effect_kernel_Outcome(outcome$2);
    return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(this$2, outcome$1)
  }))(this));
  return $$x1.start__O__O(this$3.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$3.Lcats_FlatMap$$anon$2__f_self, f))
});
$c_Lfs2_internal_InterruptContext.prototype.childContext__Z__Lcats_effect_kernel_Unique$Token__O = (function(interruptible, newScopeId) {
  if (interruptible) {
    var this$1 = $m_Lcats_effect_kernel_implicits$();
    var wrapped = this.Lfs2_internal_InterruptContext__f_deferred.get__O();
    var F = this.Lfs2_internal_InterruptContext__f_F;
    var ev$2 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$1, wrapped, F);
    var F$1 = this.Lfs2_internal_InterruptContext__f_F;
    var target = F$1.start__O__O(ev$2);
    var tc = this.Lfs2_internal_InterruptContext__f_F;
    var this$21 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f$3 = new $c_sjsr_AnonFunction1(((this$4, newScopeId$2) => ((fiber) => {
      var fiber$1 = $as_Lcats_effect_kernel_Fiber(fiber);
      var target$1 = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(newScopeId$2, fiber$1.cancel__O(), this$4.Lfs2_internal_InterruptContext__f_F);
      var tc$1 = this$4.Lfs2_internal_InterruptContext__f_F;
      var this$20 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
      var f$2 = new $c_sjsr_AnonFunction1(((this$6, fiber$2) => ((context) => {
        var context$1 = $as_Lfs2_internal_InterruptContext(context);
        var this$16 = $m_Lcats_effect_kernel_implicits$();
        var target$2 = fiber$2.join__O();
        var tc$2 = this$6.Lfs2_internal_InterruptContext__f_F;
        var this$15 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$2);
        var f$1 = new $c_sjsr_AnonFunction1(((this$8, context$2) => ((x$1) => {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
            var x12 = x$1$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var tc$3 = this$8.Lfs2_internal_InterruptContext__f_F;
            var this$11 = new $c_Lcats_FlatMap$$anon$2(x12, tc$3);
            var f = new $c_sjsr_AnonFunction1(((context$1$2) => ((i) => {
              var i$1 = $as_Lcats_effect_kernel_Outcome(i);
              return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(context$1$2, i$1)
            }))(context$2));
            return this$11.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$11.Lcats_FlatMap$$anon$2__f_self, f)
          };
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
            var x9 = $as_jl_Throwable(x$1$3.Lcats_effect_kernel_Outcome$Errored__f_e);
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(context$2, new $c_Lcats_effect_kernel_Outcome$Errored(x9))
          };
          if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
            return $p_Lfs2_internal_InterruptContext__complete__Lcats_effect_kernel_Outcome__O(context$2, new $c_Lcats_effect_kernel_Outcome$Canceled())
          };
          throw new $c_s_MatchError(x$1$1)
        }))(this$6, context$1));
        var wrapped$1 = this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, f$1);
        var F$2 = this$6.Lfs2_internal_InterruptContext__f_F;
        var ev$3 = $f_Lcats_effect_kernel_syntax_GenSpawnSyntax__genSpawnOps__O__Lcats_effect_kernel_GenSpawn__O(this$16, wrapped$1, F$2);
        var F$3 = this$6.Lfs2_internal_InterruptContext__f_F;
        var target$3 = F$3.start__O__O(ev$3);
        var tc$4 = this$6.Lfs2_internal_InterruptContext__f_F;
        var this$19 = new $c_Lcats_Functor$$anon$4(target$3, tc$4);
        return this$19.Lcats_Functor$$anon$4__f_typeClassInstance.as__O__O__O(this$19.Lcats_Functor$$anon$4__f_self, context$1)
      }))(this$4, fiber$1));
      return this$20.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$$anon$2__f_self, f$2)
    }))(this, newScopeId));
    return this$21.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$21.Lcats_FlatMap$$anon$2__f_self, f$3)
  } else {
    var instance = this.Lfs2_internal_InterruptContext__f_F;
    var cancelParent$1 = instance.pure__O__O((void 0));
    var deferred$1 = this.Lfs2_internal_InterruptContext__f_deferred;
    var ref$1 = this.Lfs2_internal_InterruptContext__f_ref;
    var interruptRoot$1 = this.Lfs2_internal_InterruptContext__f_interruptRoot;
    var F$4 = this.Lfs2_internal_InterruptContext__f_F;
    var a = new $c_Lfs2_internal_InterruptContext(deferred$1, ref$1, interruptRoot$1, cancelParent$1, F$4);
    var F$5 = this.Lfs2_internal_InterruptContext__f_F;
    return F$5.pure__O__O(a)
  }
});
$c_Lfs2_internal_InterruptContext.prototype.eval__O__O = (function(fa) {
  var target = this.Lfs2_internal_InterruptContext__f_ref.get__O();
  var tc = this.Lfs2_internal_InterruptContext__f_F;
  var this$15 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$1 = new $c_sjsr_AnonFunction1(((this$2, fa$2) => ((x$1) => {
    var x$1$1 = $as_s_Option(x$1);
    if ((x$1$1 instanceof $c_s_Some)) {
      var outcome = $as_Lcats_effect_kernel_Outcome($as_s_Some(x$1$1).s_Some__f_value);
      return this$2.Lfs2_internal_InterruptContext__f_F.pure__O__O(($m_s_package$(), new $c_s_util_Left(outcome)))
    };
    var x = $m_s_None$();
    if ((x === x$1$1)) {
      var this$6 = this$2.Lfs2_internal_InterruptContext__f_F;
      var fa$1 = this$2.Lfs2_internal_InterruptContext__f_deferred.get__O();
      var F$1 = this$2.Lfs2_internal_InterruptContext__f_F;
      var fb = F$1.attempt__O__O(fa$2);
      var target$1 = $f_Lcats_effect_kernel_GenSpawn__race__O__O__O(this$6, fa$1, fb);
      var tc$1 = this$2.Lfs2_internal_InterruptContext__f_F;
      var this$14 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
      var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
        var x$1$3 = $as_s_util_Either(x$1$2);
        if ((x$1$3 instanceof $c_s_util_Right)) {
          var result = $as_s_util_Either($as_s_util_Right(x$1$3).s_util_Right__f_value);
          if ((result instanceof $c_s_util_Left)) {
            var a = $as_s_util_Left(result).s_util_Left__f_value;
            $m_s_package$();
            var _$3 = $as_jl_Throwable(a);
            var value = new $c_Lcats_effect_kernel_Outcome$Errored(_$3);
            return new $c_s_util_Left(value)
          };
          if ((result instanceof $c_s_util_Right)) {
            var r = $as_s_util_Right(result);
            $m_Lcats_syntax_EitherUtil$();
            return r
          };
          throw new $c_s_MatchError(result)
        };
        if ((x$1$3 instanceof $c_s_util_Left)) {
          var other = $as_Lcats_effect_kernel_Outcome($as_s_util_Left(x$1$3).s_util_Left__f_value);
          $m_s_package$();
          return new $c_s_util_Left(other)
        };
        throw new $c_s_MatchError(x$1$3)
      }));
      return this$14.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$14.Lcats_Functor$$anon$4__f_self, f)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, fa));
  return this$15.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$15.Lcats_FlatMap$$anon$2__f_self, f$1)
});
function $as_Lfs2_internal_InterruptContext(obj) {
  return (((obj instanceof $c_Lfs2_internal_InterruptContext) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.InterruptContext"))
}
function $isArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_InterruptContext)))
}
function $asArrayOf_Lfs2_internal_InterruptContext(obj, depth) {
  return (($isArrayOf_Lfs2_internal_InterruptContext(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.InterruptContext;", depth))
}
var $d_Lfs2_internal_InterruptContext = new $TypeData().initClass({
  Lfs2_internal_InterruptContext: 0
}, false, "fs2.internal.InterruptContext", {
  Lfs2_internal_InterruptContext: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_internal_InterruptContext.prototype.$classData = $d_Lfs2_internal_InterruptContext;
/** @constructor */
function $c_Lfs2_internal_ScopedResource$State(open, finalizer, leases) {
  this.Lfs2_internal_ScopedResource$State__f_open = false;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = null;
  this.Lfs2_internal_ScopedResource$State__f_leases = 0;
  this.Lfs2_internal_ScopedResource$State__f_open = open;
  this.Lfs2_internal_ScopedResource$State__f_finalizer = finalizer;
  this.Lfs2_internal_ScopedResource$State__f_leases = leases
}
$c_Lfs2_internal_ScopedResource$State.prototype = new $h_O();
$c_Lfs2_internal_ScopedResource$State.prototype.constructor = $c_Lfs2_internal_ScopedResource$State;
/** @constructor */
function $h_Lfs2_internal_ScopedResource$State() {
  /*<skip>*/
}
$h_Lfs2_internal_ScopedResource$State.prototype = $c_Lfs2_internal_ScopedResource$State.prototype;
$c_Lfs2_internal_ScopedResource$State.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_internal_ScopedResource$State.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("State");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lfs2_internal_ScopedResource$State__f_open ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = this.Lfs2_internal_ScopedResource$State__f_leases;
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lfs2_internal_ScopedResource$State.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_internal_ScopedResource$State)) {
    var x$0$2 = $as_Lfs2_internal_ScopedResource$State(x$0);
    if (((this.Lfs2_internal_ScopedResource$State__f_open === x$0$2.Lfs2_internal_ScopedResource$State__f_open) && (this.Lfs2_internal_ScopedResource$State__f_leases === x$0$2.Lfs2_internal_ScopedResource$State__f_leases))) {
      var x = this.Lfs2_internal_ScopedResource$State__f_finalizer;
      var x$2 = x$0$2.Lfs2_internal_ScopedResource$State__f_finalizer;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_internal_ScopedResource$State.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_internal_ScopedResource$State.prototype.productArity__I = (function() {
  return 3
});
$c_Lfs2_internal_ScopedResource$State.prototype.productPrefix__T = (function() {
  return "State"
});
$c_Lfs2_internal_ScopedResource$State.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_internal_ScopedResource$State__f_open;
      break
    }
    case 1: {
      return this.Lfs2_internal_ScopedResource$State__f_finalizer;
      break
    }
    case 2: {
      return this.Lfs2_internal_ScopedResource$State__f_leases;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lfs2_internal_ScopedResource$State(obj) {
  return (((obj instanceof $c_Lfs2_internal_ScopedResource$State) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.ScopedResource$State"))
}
function $isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_ScopedResource$State)))
}
function $asArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) {
  return (($isArrayOf_Lfs2_internal_ScopedResource$State(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.ScopedResource$State;", depth))
}
var $d_Lfs2_internal_ScopedResource$State = new $TypeData().initClass({
  Lfs2_internal_ScopedResource$State: 0
}, false, "fs2.internal.ScopedResource$State", {
  Lfs2_internal_ScopedResource$State: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_internal_ScopedResource$State.prototype.$classData = $d_Lfs2_internal_ScopedResource$State;
/** @constructor */
function $c_Ljava_io_OutputStream() {
  /*<skip>*/
}
$c_Ljava_io_OutputStream.prototype = new $h_O();
$c_Ljava_io_OutputStream.prototype.constructor = $c_Ljava_io_OutputStream;
/** @constructor */
function $h_Ljava_io_OutputStream() {
  /*<skip>*/
}
$h_Ljava_io_OutputStream.prototype = $c_Ljava_io_OutputStream.prototype;
class $c_jl_AssertionError extends $c_jl_Error {
  constructor(detailMessage) {
    super();
    var message = ("" + detailMessage);
    if ((detailMessage instanceof $c_jl_Throwable)) {
      var x2 = $as_jl_Throwable(detailMessage);
      var cause = x2
    } else {
      var cause = null
    };
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_jl_AssertionError = new $TypeData().initClass({
  jl_AssertionError: 0
}, false, "java.lang.AssertionError", {
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_AssertionError.prototype.$classData = $d_jl_AssertionError;
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($uZ($thiz) ? 1231 : 1237)
}
function $f_jl_Boolean__toString__T($thiz) {
  var b = $uZ($thiz);
  return ("" + b)
}
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  var that = $as_jl_Boolean(o);
  var x = $uZ($thiz);
  var y = $uZ(that);
  return ((x === y) ? 0 : (x ? 1 : (-1)))
}
function $as_jl_Boolean(obj) {
  return ((((typeof obj) === "boolean") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Boolean"))
}
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)))
}
function $asArrayOf_jl_Boolean(obj, depth) {
  return (($isArrayOf_jl_Boolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Boolean;", depth))
}
var $d_jl_Boolean = new $TypeData().initClass({
  jl_Boolean: 0
}, false, "java.lang.Boolean", {
  jl_Boolean: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "boolean")));
function $f_jl_Character__hashCode__I($thiz) {
  var value = $uC($thiz);
  return value
}
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var $$x1 = $uC($thiz);
    var this$1 = $as_jl_Character(that);
    return ($$x1 === $uC(this$1))
  } else {
    return false
  }
}
function $f_jl_Character__toString__T($thiz) {
  var c = $uC($thiz);
  return $as_T(String.fromCharCode(c))
}
function $f_jl_Character__compareTo__O__I($thiz, o) {
  var that = $as_jl_Character(o);
  var x = $uC($thiz);
  var y = $uC(that);
  return ((x - y) | 0)
}
function $as_jl_Character(obj) {
  return (((obj instanceof $Char) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Character"))
}
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)))
}
function $asArrayOf_jl_Character(obj, depth) {
  return (($isArrayOf_jl_Character(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Character;", depth))
}
var $d_jl_Character = new $TypeData().initClass({
  jl_Character: 0
}, false, "java.lang.Character", {
  jl_Character: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => (x instanceof $Char)));
function $as_jl_InterruptedException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.InterruptedException"))
}
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)))
}
function $asArrayOf_jl_InterruptedException(obj, depth) {
  return (($isArrayOf_jl_InterruptedException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.InterruptedException;", depth))
}
function $as_jl_LinkageError(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.LinkageError"))
}
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)))
}
function $asArrayOf_jl_LinkageError(obj, depth) {
  return (($isArrayOf_jl_LinkageError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.LinkageError;", depth))
}
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_RuntimeException extends $c_jl_Exception {
}
var $d_jl_RuntimeException = new $TypeData().initClass({
  jl_RuntimeException: 0
}, false, "java.lang.RuntimeException", {
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_RuntimeException.prototype.$classData = $d_jl_RuntimeException;
function $ct_jl_StringBuffer__jl_StringBuilder__($thiz, builder) {
  $thiz.jl_StringBuffer__f_builder = builder;
  return $thiz
}
function $ct_jl_StringBuffer__($thiz) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz
}
/** @constructor */
function $c_jl_StringBuffer() {
  this.jl_StringBuffer__f_builder = null
}
$c_jl_StringBuffer.prototype = new $h_O();
$c_jl_StringBuffer.prototype.constructor = $c_jl_StringBuffer;
/** @constructor */
function $h_jl_StringBuffer() {
  /*<skip>*/
}
$h_jl_StringBuffer.prototype = $c_jl_StringBuffer.prototype;
$c_jl_StringBuffer.prototype.append__T__jl_StringBuffer = (function(str) {
  var this$1 = this.jl_StringBuffer__f_builder;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_jl_StringBuffer.prototype.append__C__jl_StringBuffer = (function(c) {
  var this$1 = this.jl_StringBuffer__f_builder;
  var str = $as_T(String.fromCharCode(c));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_jl_StringBuffer.prototype.toString__T = (function() {
  return this.jl_StringBuffer__f_builder.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
var $d_jl_StringBuffer = new $TypeData().initClass({
  jl_StringBuffer: 0
}, false, "java.lang.StringBuffer", {
  jl_StringBuffer: 1,
  O: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringBuffer.prototype.$classData = $d_jl_StringBuffer;
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz
}
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  if ((str === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = str;
  return $thiz
}
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    throw new $c_jl_NegativeArraySizeException()
  };
  return $thiz
}
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null
}
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
  /*<skip>*/
}
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = str.u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this
});
$c_jl_StringBuilder.prototype.reverse__jl_StringBuilder = (function() {
  var original = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var result = "";
  var i = (((-1) + $uI(original.length)) | 0);
  while ((i > 0)) {
    var index = i;
    var c = (65535 & $uI(original.charCodeAt(index)));
    if (((64512 & c) === 56320)) {
      var index$1 = (((-1) + i) | 0);
      var c2 = (65535 & $uI(original.charCodeAt(index$1)));
      if (((64512 & c2) === 55296)) {
        result = ((("" + result) + $as_T(String.fromCharCode(c2))) + $as_T(String.fromCharCode(c)));
        i = (((-2) + i) | 0)
      } else {
        result = (("" + result) + $as_T(String.fromCharCode(c)));
        i = (((-1) + i) | 0)
      }
    } else {
      result = (("" + result) + $as_T(String.fromCharCode(c)));
      i = (((-1) + i) | 0)
    }
  };
  if ((i === 0)) {
    var $$x1 = result;
    var this$7 = (65535 & $uI(original.charCodeAt(0)));
    result = (("" + $$x1) + $as_T(String.fromCharCode(this$7)))
  };
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = result;
  return this
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return $uI(this$1.length)
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return (65535 & $uI(this$1.charCodeAt(index)))
});
var $d_jl_StringBuilder = new $TypeData().initClass({
  jl_StringBuilder: 0
}, false, "java.lang.StringBuilder", {
  jl_StringBuilder: 1,
  O: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringBuilder.prototype.$classData = $d_jl_StringBuilder;
function $as_jl_ThreadDeath(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ThreadDeath"))
}
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)))
}
function $asArrayOf_jl_ThreadDeath(obj, depth) {
  return (($isArrayOf_jl_ThreadDeath(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ThreadDeath;", depth))
}
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
function $as_jl_VirtualMachineError(obj) {
  return (((obj instanceof $c_jl_VirtualMachineError) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.VirtualMachineError"))
}
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)))
}
function $asArrayOf_jl_VirtualMachineError(obj, depth) {
  return (($isArrayOf_jl_VirtualMachineError(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.VirtualMachineError;", depth))
}
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === (-2147483648)))) {
    return 19
  } else {
    var $$x3 = $m_ju_Arrays$();
    var $$x2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var ahi = value.RTLong__f_hi;
    if ((ahi < 0)) {
      var lo = value.RTLong__f_lo;
      var hi = value.RTLong__f_hi;
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      var x__lo = lo$1;
      var x__hi = hi$1;
      var $$x1 = new $c_RTLong(x__lo, x__hi)
    } else {
      var $$x1 = value
    };
    var index = $$x3.binarySearch__AJ__J__I($$x2, $$x1);
    return ((index < 0) ? (((-1) - index) | 0) : ((1 + index) | 0))
  }
}
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = mc.Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision)
    } else {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(discardedPrecision, hi));
      var integerAndFraction = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
      var this$5 = integerAndFraction.get(1);
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = integerAndFraction.get(1).abs__Ljava_math_BigInteger();
        var compRem = absBi.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = (integerAndFraction.get(0).testBit__I__Z(0) ? 1 : 0);
        var this$6 = integerAndFraction.get(1);
        var frac = Math.imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, mc.Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $$x2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $$x2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(carry, hi$4));
          var this$8 = integerAndFraction.get(0);
          integerAndFraction.set(0, $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi))
        };
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), integerAndFraction.get(0));
        if ((tempBD.precision__I() > mcPrecision)) {
          integerAndFraction.set(0, integerAndFraction.get(0).divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN));
          var lo$1 = (((-1) + lo) | 0);
          var hi$5 = ((lo$1 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
          var newScale__lo = lo$1;
          var newScale__hi = hi$5
        } else {
          var newScale__lo = lo;
          var newScale__hi = hi$3
        }
      } else {
        var newScale__lo = lo;
        var newScale__hi = hi$3
      };
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(newScale__lo, newScale__hi));
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, integerAndFraction.get(0))
    }
  }
}
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var this$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    return (!((this$1.RTLong__f_lo === (-1)) && (this$1.RTLong__f_hi === (-1))))
  } else {
    return false
  }
}
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.get(discardedPrecision);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var hi$2 = (discardedPrecision >> 31);
  var lo$1 = ((value - discardedPrecision) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi$1 - hi$2) | 0)) | 0) : ((hi$1 - hi$2) | 0));
  var t$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
  var lo$2 = t$1.RTLong__f_lo;
  var hi$4 = t$1.RTLong__f_hi;
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$5 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$5 = $m_RTLong$();
  var lo$4 = this$5.remainderImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$6 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$4 === 0) && (hi$6 === 0)))) {
    var $$x1 = $m_Ljava_math_BigDecimal$();
    if ((hi$6 < 0)) {
      var lo$5 = ((-lo$4) | 0);
      var hi$7 = ((lo$4 !== 0) ? (~hi$6) : ((-hi$6) | 0));
      var this$9__lo = lo$5;
      var this$9__hi = hi$7
    } else {
      var this$9__lo = lo$4;
      var this$9__hi = hi$6
    };
    var lo$6 = this$9__lo;
    var lo$7 = (lo$6 << 1);
    var hi$8 = (((lo$6 >>> 31) | 0) | (this$9__hi << 1));
    var compRem = $$x1.java$math$BigDecimal$$longCompareTo__J__J__I(new $c_RTLong(lo$7, hi$8), new $c_RTLong(lo, hi));
    var frac = Math.imul(((hi$6 < 0) ? (-1) : (((hi$6 === 0) && (lo$4 === 0)) ? 0 : 1)), ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$3), frac, mc.Ljava_math_MathContext__f_roundingMode);
    var hi$9 = (value$1 >> 31);
    var lo$8 = ((lo$3 + value$1) | 0);
    var hi$10 = ((((-2147483648) ^ lo$8) < ((-2147483648) ^ lo$3)) ? ((1 + ((hi$5 + hi$9) | 0)) | 0) : ((hi$5 + hi$9) | 0));
    if ((hi$10 < 0)) {
      var lo$9 = ((-lo$8) | 0);
      var hi$11 = ((lo$8 !== 0) ? (~hi$10) : ((-hi$10) | 0));
      var this$16__lo = lo$9;
      var this$16__hi = hi$11
    } else {
      var this$16__lo = lo$8;
      var this$16__hi = hi$10
    };
    var a = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$16__lo, this$16__hi);
    if (($uD(Math.log10(a)) >= mc.Ljava_math_MathContext__f_precision)) {
      var lo$10 = (((-1) + lo$1) | 0);
      var hi$12 = ((lo$10 !== (-1)) ? hi$3 : (((-1) + hi$3) | 0));
      var this$19 = $m_RTLong$();
      var lo$11 = this$19.divideImpl__I__I__I__I__I(lo$8, hi$10, 10, 0);
      var hi$13 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var x1___1 = null;
      var x1___2 = null;
      var x1___1$mcJ$sp = new $c_RTLong(lo$10, hi$12);
      var x1___2$mcJ$sp = new $c_RTLong(lo$11, hi$13)
    } else {
      var x1___1 = null;
      var x1___2 = null;
      var x1___1$mcJ$sp = new $c_RTLong(lo$1, hi$3);
      var x1___2$mcJ$sp = new $c_RTLong(lo$8, hi$10)
    }
  } else {
    var x1___1 = null;
    var x1___2 = null;
    var x1___1$mcJ$sp = new $c_RTLong(lo$1, hi$3);
    var x1___2$mcJ$sp = new $c_RTLong(lo$3, hi$5)
  };
  var t$2 = x1___1$mcJ$sp;
  var lo$12 = t$2.RTLong__f_lo;
  var hi$14 = t$2.RTLong__f_hi;
  var t$3 = x1___2$mcJ$sp;
  var lo$13 = t$3.RTLong__f_lo;
  var hi$15 = t$3.RTLong__f_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$12, hi$14));
  $thiz.Ljava_math_BigDecimal__f__precision = mc.Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(lo$13, hi$15);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(new $c_RTLong(lo$13, hi$15));
  $thiz.Ljava_math_BigDecimal__f__intVal = null
}
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
  if (((hi$3 === 0) ? (((-2147483648) ^ lo$1) > (-2147483629)) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  };
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) < bitLengthOfType)) {
    return bigInteger.longValue__J()
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary")
  }
}
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (((-1) + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0))
}
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(unscaledVal);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = unscaledVal.longValue__J()
  }
}
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(smallValue, hi);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = (((-1) + ((offset + len) | 0)) | 0);
  if ((in$1 === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "in == null")
  };
  if (((((last >= in$1.u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + in$1.u.length))
  };
  var index = offset;
  if (((offset <= last) && (in$1.get(offset) === 43))) {
    index = ((1 + index) | 0);
    if ((index < last)) {
      $m_Ljava_math_BigDecimal$();
      var c = in$1.get(index);
      var array = [$bC(43), $bC(45)];
      var cs = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var $$x1 = $f_sc_SeqOps__contains__O__Z(cs, $bC(c))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()))
    }
  } else {
    var isMinus = ((index <= last) && (in$1.get(index) === 45));
    if ((((1 + index) | 0) < last)) {
      $m_Ljava_math_BigDecimal$();
      var c$1 = in$1.get(((1 + index) | 0));
      var array$1 = [$bC(43), $bC(45)];
      var cs$1 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$1);
      var nextIsSign = $f_sc_SeqOps__contains__O__Z(cs$1, $bC(c$1))
    } else {
      var nextIsSign = false
    };
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()))
    }
  };
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (true) {
    if ((index <= last)) {
      $m_Ljava_math_BigDecimal$();
      var c$2 = in$1.get(index);
      var array$2 = [$bC(46), $bC(101), $bC(69)];
      var cs$2 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$2);
      var $$x2 = (!$f_sc_SeqOps__contains__O__Z(cs$2, $bC(c$2)))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      if ((!wasNonZero)) {
        if ((in$1.get(index) === 48)) {
          counter = ((1 + counter) | 0)
        } else {
          wasNonZero = true
        }
      };
      index = ((1 + index) | 0)
    } else {
      break
    }
  };
  var count = ((index - begin) | 0);
  var this$13 = $m_jl_String$();
  var u = this$13.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && (in$1.get(index) === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (true) {
      if ((index <= last)) {
        $m_Ljava_math_BigDecimal$();
        var c$3 = in$1.get(index);
        var array$3 = [$bC(101), $bC(69)];
        var cs$3 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$3);
        var $$x3 = (!$f_sc_SeqOps__contains__O__Z(cs$3, $bC(c$3)))
      } else {
        var $$x3 = false
      };
      if ($$x3) {
        if ((!wasNonZero)) {
          if ((in$1.get(index) === 48)) {
            counter = ((1 + counter) | 0)
          } else {
            wasNonZero = true
          }
        };
        index = ((1 + index) | 0)
      } else {
        break
      }
    };
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$18 = $m_jl_String$();
    var _1 = (("" + u) + this$18.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b
  };
  var unscaled = $as_T(x1___1);
  var bufLength = $uI(x1___2);
  if ((index <= last)) {
    $m_Ljava_math_BigDecimal$();
    var c$4 = in$1.get(index);
    var array$4 = [$bC(101), $bC(69)];
    var cs$4 = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array$4);
    var $$x4 = $f_sc_SeqOps__contains__O__Z(cs$4, $bC(c$4))
  } else {
    var $$x4 = false
  };
  if ($$x4) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && (in$1.get(index) === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && (in$1.get(((1 + index) | 0)) !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$23 = $m_jl_String$();
    var scaleString = this$23.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$25 = $m_jl_Integer$();
    var value$1 = this$25.parseInt__T__I__I(scaleString, 10);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((!((lo === value$2) && (hi$2 === hi$3)))) {
      throw new $c_jl_NumberFormatException("Scale out of range")
    }
  };
  if ((bufLength < 19)) {
    var this$29 = $m_jl_Long$();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = this$29.parseLong__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled))
  };
  return $thiz
}
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, $uI(sVal.length));
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  if ((unscaledVal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "unscaledVal == null")
  };
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz
}
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0
}
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
  /*<skip>*/
}
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(augend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(augend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $$x1 = $m_Ljava_math_BigDecimal$();
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = this$2.RTLong__f_lo;
      var ahi = this$2.RTLong__f_hi;
      var bhi = b$1.RTLong__f_hi;
      var lo = ((alo + b$1.RTLong__f_lo) | 0);
      var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
      return $$x1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    } else {
      var this$4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var bi = augend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(augend, this, ((-diffScale) | 0)))
  }
});
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      return (-1)
    } else {
      var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = this$2.RTLong__f_hi;
      if (((ahi$1 === 0) ? (this$2.RTLong__f_lo !== 0) : (ahi$1 > 0))) {
        return 1
      } else {
        return 0
      }
    }
  } else {
    var this$3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return this$3.Ljava_math_BigInteger__f_sign
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $$x1 = 1
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $$x1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * (((-1) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0);
      var $$x3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $$x2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $$x3.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($$x2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(decimalDigits, hi)));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $$x1 = ((1 + decimalDigits) | 0)
      } else {
        var $$x1 = decimalDigits
      }
    };
    this.Ljava_math_BigDecimal__f__precision = $$x1
  };
  return this.Ljava_math_BigDecimal__f__precision
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    if (((this$4.RTLong__f_lo === 0) && (this$4.RTLong__f_hi === 0))) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2))
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return this
  } else {
    var lastPow = (((-1) + $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u.length) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale__lo = value;
    var scale__hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.testBit__I__Z(0))) {
        var qr = strippedBI.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.get(i));
        var this$2 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem;
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
          var this$4__lo = scale__lo;
          var this$4__hi = scale__hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var alo = this$4__lo;
          var ahi = this$4__hi;
          var lo = ((alo - value$1) | 0);
          var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ alo)) ? (((-1) + ((ahi - hi$1) | 0)) | 0) : ((ahi - hi$1) | 0));
          i = temp$i;
          strippedBI = temp$strippedBI;
          var $$x1__lo = lo;
          var $$x1__hi = hi$2;
          scale__lo = $$x1__lo;
          scale__hi = $$x1__hi;
          continue
        };
        if ((i !== 1)) {
          i = 1;
          continue
        };
        var _1 = strippedBI;
        var _2__lo = scale__lo;
        var _2__hi = scale__hi;
        var x1___1 = _1;
        var x1___2 = new $c_RTLong(_2__lo, _2__hi);
        break
      } else {
        var _1$1 = strippedBI;
        var _2$1__lo = scale__lo;
        var _2$1__hi = scale__hi;
        var x1___1 = _1$1;
        var x1___2 = new $c_RTLong(_2$1__lo, _2$1__hi);
        break
      }
    };
    var strippedBI$1 = $as_Ljava_math_BigInteger(x1___1);
    var t = $uJ(x1___2);
    var lo$1 = t.RTLong__f_lo;
    var hi$3 = t.RTLong__f_hi;
    var t$1 = $uJ(new $c_RTLong(lo$1, hi$3));
    var lo$2 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$2, hi$4)))
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = bi.signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && (bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = this$1.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? (((-2147483648) ^ this$1.RTLong__f_lo) < ((-2147483648) ^ b.RTLong__f_lo)) : (ahi < bhi))) {
        return (-1)
      } else {
        var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var ahi$1 = this$2.RTLong__f_hi;
        var bhi$1 = b$1.RTLong__f_hi;
        if (((ahi$1 === bhi$1) ? (((-2147483648) ^ this$2.RTLong__f_lo) > ((-2147483648) ^ b$1.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
          return 1
        } else {
          return 0
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((-2147483648) ^ lo) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((lo$1 === 0) ? ((1 + hi$2) | 0) : hi$2);
      if (((hi$3 === hi$4) ? (((-2147483648) ^ diffPrecision) > ((-2147483648) ^ lo$1)) : (hi$3 > hi$4))) {
        return thisSign
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = (((-1) + lo) | 0);
        var hi$6 = ((lo$2 !== (-1)) ? hi$2 : (((-1) + hi$2) | 0));
        if (((hi$5 === hi$6) ? (((-2147483648) ^ diffPrecision) < ((-2147483648) ^ lo$2)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0)
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = bi.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $$x1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((lo !== 0) ? (~hi$2) : ((-hi$2) | 0));
            var _1 = t.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$3, hi$7)));
            var x1___1 = _1;
            var x1___2 = v
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = v.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$2)));
            var x1___1 = t;
            var x1___2 = _2
          } else {
            var x1___1 = t;
            var x1___2 = v
          };
          var thisUnscaled = $as_Ljava_math_BigInteger(x1___1);
          var valUnscaled = $as_Ljava_math_BigInteger(x1___2);
          return thisUnscaled.compareTo__Ljava_math_BigInteger__I(valUnscaled)
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1)
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    var x2 = $as_Ljava_math_BigDecimal(x);
    if ((x2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var this$1 = x2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
      } else {
        var xn = this.Ljava_math_BigDecimal__f__intVal;
        var yn = x2.Ljava_math_BigDecimal__f__intVal;
        return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)
      }
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var this$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    this.Ljava_math_BigDecimal__f__hashCode = this$1.RTLong__f_lo;
    var $$x1 = this.Ljava_math_BigDecimal__f__hashCode;
    var this$2 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var hi = this$2.RTLong__f_hi;
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(33, $$x1) + hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__intVal.hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage
  } else {
    var this$1 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString
    } else {
      var this$2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2
      } else {
        var begin = 1
      };
      var end = $uI(intString.length);
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((-2147483648) ^ lo$1) < ((-2147483648) ^ lo)) ? ((1 + ((hi$1 + hi$2) | 0)) | 0) : ((hi$1 + hi$2) | 0));
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((-2147483648) ^ lo$2) > ((-2147483648) ^ lo$1)) ? (((-1) + ((hi$3 - hi$4) | 0)) | 0) : ((hi$3 - hi$4) | 0));
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? (((-2147483648) ^ lo$2) >= 2147483642) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = (($as_T(intString.substring(0, pos)) + ".") + $as_T(intString.substring(pos)))
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = (((-1) + begin) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = (($as_T(intString.substring(0, pos$1)) + "0.") + $as_T(intString.substring(pos$1)));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (((-1) - lo$2) | 0);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = $as_T(s2.substring(0, s2Len));
          var result = ((("" + $as_T(s.substring(0, pos$2))) + s2$1) + $as_T(s.substring(pos$2)))
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), (($as_T(intString.substring(0, begin)) + ".") + $as_T(intString.substring(begin)))) : intString);
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var result = (r2 + $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$5))
      };
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    var $$x4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $$x4.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($$x3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)))
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger()
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $$x2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((value !== 0) ? (~hi) : ((-hi) | 0));
    return $$x2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)))
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    var $$x4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $$x3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $$x4.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($$x3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
    var this$5 = integerAndFraction.get(1);
    if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary")
    };
    return integerAndFraction.get(0)
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? $L0 : this.toBigInteger__Ljava_math_BigInteger().longValue__J())
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : this.toBigInteger__Ljava_math_BigInteger().intValue__I())
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return this$1.RTLong__f_lo
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return ((this$1.RTLong__f_lo << 16) >> 16)
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var this$1 = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return ((this$1.RTLong__f_lo << 24) >> 24)
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var value$1 = (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale / 0.3010299956639812);
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$1 = ((value - lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  var floatResult0 = Math.fround(this.signum__I());
  var floatResult = ((((hi$2 === (-1)) ? (((-2147483648) ^ lo$1) < 2147483499) : (hi$2 < (-1))) || (floatResult0 === 0.0)) ? Math.fround((0.0 * floatResult0)) : (((hi$2 === 0) ? (((-2147483648) ^ lo$1) > (-2147483519)) : (hi$2 > 0)) ? Math.fround((Infinity * floatResult0)) : Math.fround(this.doubleValue__D())));
  return floatResult
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  var sign = this.signum__I();
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var hi = (value >> 31);
  var this$2 = $m_RTLong$();
  var value$1 = (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale / 0.3010299956639812);
  var lo = this$2.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$1 = ((value - lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$1) > ((-2147483648) ^ value)) ? (((-1) + ((hi - hi$1) | 0)) | 0) : ((hi - hi$1) | 0));
  if ((((hi$2 === (-1)) ? (((-2147483648) ^ lo$1) < 2147482574) : (hi$2 < (-1))) || (sign === 0))) {
    return (0.0 * sign)
  } else if (((hi$2 === 0) ? (((-2147483648) ^ lo$1) > (-2147482623)) : (hi$2 > 0))) {
    return (Infinity * sign)
  } else {
    var mantissa0 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().abs__Ljava_math_BigInteger();
    var exponent = 1076;
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
      var $$x1 = $m_Ljava_math_Multiplication$();
      var value$2 = ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
      var hi$3 = (value$2 >> 31);
      var mantissa = mantissa0.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($$x1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$2, hi$3)))
    } else {
      var $$x2 = $m_Ljava_math_Multiplication$();
      var value$3 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$4 = (value$3 >> 31);
      var powerOfTen = $$x2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$3, hi$4));
      var k = ((100 - lo$1) | 0);
      if ((k > 0)) {
        exponent = ((exponent - k) | 0);
        var m = mantissa0.shiftLeft__I__Ljava_math_BigInteger(k)
      } else {
        var m = mantissa0
      };
      var qr = m.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(powerOfTen);
      var compRem = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(powerOfTen);
      exponent = (((-2) + exponent) | 0);
      var this$7 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot.shiftLeft__I__Ljava_math_BigInteger(2);
      var $$x3 = $m_Ljava_math_BigInteger$();
      var value$4 = ((1 + ((Math.imul(compRem, ((3 + compRem) | 0)) / 2) | 0)) | 0);
      var hi$5 = (value$4 >> 31);
      var bi = $$x3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(value$4, hi$5));
      var mantissa = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi)
    };
    var lowestSetBit = mantissa.getLowestSetBit__I();
    var discardedSize = (((-54) + $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(mantissa)) | 0);
    var bits__lo = 0;
    var bits__hi = 0;
    var tempBits__lo = 0;
    var tempBits__hi = 0;
    if ((discardedSize > 0)) {
      var t = mantissa.shiftRight__I__Ljava_math_BigInteger(discardedSize).longValue__J();
      var lo$2 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      var $$x4__lo = lo$2;
      var $$x4__hi = hi$6;
      bits__lo = $$x4__lo;
      bits__hi = $$x4__hi;
      tempBits__lo = bits__lo;
      tempBits__hi = bits__hi;
      var b__lo = bits__lo;
      var b__hi = bits__hi;
      var lo$3 = (1 & b__lo);
      if (((lo$3 === 1) && (lowestSetBit < discardedSize))) {
        var $$x5 = true
      } else {
        var b$1__lo = bits__lo;
        var b$1__hi = bits__hi;
        var lo$4 = (3 & b$1__lo);
        var $$x5 = (lo$4 === 3)
      };
      if ($$x5) {
        var b$2__lo = bits__lo;
        var b$2__hi = bits__hi;
        var bhi = b$2__hi;
        var lo$5 = ((2 + b$2__lo) | 0);
        var hi$7 = ((((-2147483648) ^ lo$5) < (-2147483646)) ? ((1 + bhi) | 0) : bhi);
        var $$x6__lo = lo$5;
        var $$x6__hi = hi$7;
        bits__lo = $$x6__lo;
        bits__hi = $$x6__hi
      }
    } else {
      var this$9 = mantissa.longValue__J();
      var n = ((-discardedSize) | 0);
      var lo$6 = this$9.RTLong__f_lo;
      var lo$7 = (((32 & n) === 0) ? (lo$6 << n) : 0);
      var hi$8 = (((32 & n) === 0) ? (((((lo$6 >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (this$9.RTLong__f_hi << n)) : (lo$6 << n));
      var $$x7__lo = lo$7;
      var $$x7__hi = hi$8;
      bits__lo = $$x7__lo;
      bits__hi = $$x7__hi;
      tempBits__lo = bits__lo;
      tempBits__hi = bits__hi;
      var b$3__lo = bits__lo;
      var b$3__hi = bits__hi;
      var lo$8 = (3 & b$3__lo);
      if ((lo$8 === 3)) {
        var b$4__lo = bits__lo;
        var b$4__hi = bits__hi;
        var bhi$1 = b$4__hi;
        var lo$9 = ((2 + b$4__lo) | 0);
        var hi$9 = ((((-2147483648) ^ lo$9) < (-2147483646)) ? ((1 + bhi$1) | 0) : bhi$1);
        var $$x8__lo = lo$9;
        var $$x8__hi = hi$9;
        bits__lo = $$x8__lo;
        bits__hi = $$x8__hi
      }
    };
    var b$5__lo = bits__lo;
    var b$5__hi = bits__hi;
    var hi$10 = (4194304 & b$5__hi);
    if ((hi$10 === 0)) {
      var this$11__lo = bits__lo;
      var this$11__hi = bits__hi;
      var hi$11 = this$11__hi;
      var lo$10 = (((this$11__lo >>> 1) | 0) | (hi$11 << 31));
      var hi$12 = (hi$11 >> 1);
      var $$x9__lo = lo$10;
      var $$x9__hi = hi$12;
      bits__lo = $$x9__lo;
      bits__hi = $$x9__hi;
      exponent = ((exponent + discardedSize) | 0)
    } else {
      var this$12__lo = bits__lo;
      var this$12__hi = bits__hi;
      var hi$13 = this$12__hi;
      var lo$11 = (((this$12__lo >>> 2) | 0) | (hi$13 << 30));
      var hi$14 = (hi$13 >> 2);
      var $$x10__lo = lo$11;
      var $$x10__hi = hi$14;
      bits__lo = $$x10__lo;
      bits__hi = $$x10__hi;
      exponent = ((exponent + ((1 + discardedSize) | 0)) | 0)
    };
    if ((exponent > 2046)) {
      return (Infinity * sign)
    } else if ((exponent < (-53))) {
      return (0.0 * sign)
    } else {
      if ((exponent <= 0)) {
        var this$13__lo = tempBits__lo;
        var this$13__hi = tempBits__hi;
        var hi$15 = this$13__hi;
        var lo$12 = (((this$13__lo >>> 1) | 0) | (hi$15 << 31));
        var hi$16 = (hi$15 >> 1);
        var $$x11__lo = lo$12;
        var $$x11__hi = hi$16;
        bits__lo = $$x11__lo;
        bits__hi = $$x11__hi;
        var this$14__lo = bits__lo;
        var this$14__hi = bits__hi;
        var n$1 = ((63 + exponent) | 0);
        var lo$13 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
        var hi$17 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
        var lo$14 = (this$14__lo & lo$13);
        var hi$18 = (this$14__hi & hi$17);
        var $$x12__lo = lo$14;
        var $$x12__hi = hi$18;
        tempBits__lo = $$x12__lo;
        tempBits__hi = $$x12__hi;
        var this$15__lo = bits__lo;
        var this$15__hi = bits__hi;
        var n$2 = ((-exponent) | 0);
        var hi$19 = this$15__hi;
        var lo$15 = (((32 & n$2) === 0) ? (((this$15__lo >>> n$2) | 0) | ((hi$19 << 1) << ((31 - n$2) | 0))) : (hi$19 >> n$2));
        var hi$20 = (((32 & n$2) === 0) ? (hi$19 >> n$2) : (hi$19 >> 31));
        var $$x13__lo = lo$15;
        var $$x13__hi = hi$20;
        bits__lo = $$x13__lo;
        bits__hi = $$x13__hi;
        var b$6__lo = bits__lo;
        var b$6__hi = bits__hi;
        var lo$16 = (3 & b$6__lo);
        if ((lo$16 === 3)) {
          var $$x14 = true
        } else {
          var b$7__lo = bits__lo;
          var b$7__hi = bits__hi;
          var lo$17 = (1 & b$7__lo);
          if ((lo$17 === 1)) {
            var this$16__lo = tempBits__lo;
            var this$16__hi = tempBits__hi;
            var $$x15 = (!((this$16__lo === 0) && (this$16__hi === 0)))
          } else {
            var $$x15 = false
          };
          if ($$x15) {
            var $$x14 = (lowestSetBit < discardedSize)
          } else {
            var $$x14 = false
          }
        };
        if ($$x14) {
          var b$8__lo = bits__lo;
          var b$8__hi = bits__hi;
          var bhi$2 = b$8__hi;
          var lo$18 = ((1 + b$8__lo) | 0);
          var hi$21 = ((lo$18 === 0) ? ((1 + bhi$2) | 0) : bhi$2);
          var $$x16__lo = lo$18;
          var $$x16__hi = hi$21;
          bits__lo = $$x16__lo;
          bits__hi = $$x16__hi
        };
        exponent = 0;
        var this$18__lo = bits__lo;
        var this$18__hi = bits__hi;
        var hi$22 = this$18__hi;
        var lo$19 = (((this$18__lo >>> 1) | 0) | (hi$22 << 31));
        var hi$23 = (hi$22 >> 1);
        var $$x17__lo = lo$19;
        var $$x17__hi = hi$23;
        bits__lo = $$x17__lo;
        bits__hi = $$x17__hi
      };
      var hi$24 = (sign >> 31);
      var hi$25 = ((-2147483648) & hi$24);
      var value$5 = exponent;
      var hi$27 = (value$5 << 20);
      var hi$28 = (hi$25 | hi$27);
      var b$9__lo = bits__lo;
      var b$9__hi = bits__hi;
      var lo$20 = b$9__lo;
      var hi$29 = (1048575 & b$9__hi);
      var hi$30 = (hi$28 | hi$29);
      return $m_jl_FloatingPointBits$().longBitsToDouble__J__D(new $c_RTLong(lo$20, hi$30))
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue)
  };
  return this.Ljava_math_BigDecimal__f__intVal
});
$c_Ljava_math_BigDecimal.prototype.compareTo__O__I = (function(x$1) {
  return this.compareTo__Ljava_math_BigDecimal__I($as_Ljava_math_BigDecimal(x$1))
});
function $as_Ljava_math_BigDecimal(obj) {
  return (((obj instanceof $c_Ljava_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigDecimal"))
}
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)))
}
function $asArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (($isArrayOf_Ljava_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigDecimal;", depth))
}
var $d_Ljava_math_BigDecimal = new $TypeData().initClass({
  Ljava_math_BigDecimal: 0
}, false, "java.math.BigDecimal", {
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigDecimal.prototype.$classData = $d_Ljava_math_BigDecimal;
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  var stringLength0 = $uI(s.length);
  if (((65535 & $uI(s.charCodeAt(0))) === 45)) {
    var _3 = (((-1) + stringLength0) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3
  } else if (((65535 & $uI(s.charCodeAt(0))) === 43)) {
    var _3$1 = (((-1) + stringLength0) | 0);
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = _3$1
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0
  };
  var _sign = $uI(x1___1);
  var startChar = $uI(x1___2);
  var stringLength = $uI(x1___3);
  var i = startChar;
  while ((i < stringLength0)) {
    var arg1 = i;
    var c = (65535 & $uI(s.charCodeAt(arg1)));
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character")
    };
    i = ((1 + i) | 0)
  };
  var charsPerInt = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt.get(radix);
  var bigRadixDigitsLength = $intDiv(stringLength, charsPerInt);
  var topChars = $intMod(stringLength, charsPerInt);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0)
  };
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices.get((((-2) + radix) | 0));
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = $as_T(s.substring(beginIndex, endIndex));
    var bigRadixDigit = $m_jl_Integer$().parseInt__T__I__I(s$1, radix);
    var this$3 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$3, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.set(digitIndex, newDigit);
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0)
  };
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V()
}
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $m_Ljava_math_BigInteger$();
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if (((radix < 2) || (radix > 36))) {
    throw new $c_jl_NumberFormatException("Radix out of range")
  };
  if ((s === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger")
  };
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz
}
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([value]));
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([0]))
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = digits.u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V()
  };
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz
}
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  var hi = lVal.RTLong__f_hi;
  if ((hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo]))
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo, hi]))
  };
  return $thiz
}
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0
}
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
  /*<skip>*/
}
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this)
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > bi.Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < bi.Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > bi.Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < bi.Ljava_math_BigInteger__f_numberLength) ? ((-bi.Ljava_math_BigInteger__f_sign) | 0) : Math.imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, bi.Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))))
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if ((divisor.Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if (divisor.isOne__Z()) {
    return ((divisor.Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger())
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var value = this.Ljava_math_BigInteger__f_digits.get(0);
      var value$1 = divisor.Ljava_math_BigInteger__f_digits.get(0);
      var this$3 = $m_RTLong$();
      var lo = this$3.divideImpl__I__I__I__I__I(value, 0, value$1, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var bi__lo = lo;
      var bi__hi = hi$2;
      if ((thisSign !== divisorSign)) {
        var this$4__lo = bi__lo;
        var this$4__hi = bi__hi;
        var lo$1 = this$4__lo;
        var hi$3 = this$4__hi;
        var lo$2 = ((-lo$1) | 0);
        var hi$4 = ((lo$1 !== 0) ? (~hi$3) : ((-hi$3) | 0));
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$4;
        bi__lo = $$x1__lo;
        bi__hi = $$x1__hi
      };
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(bi__lo, bi__hi))
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, divisor.Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE)
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits.get(0))
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits, divisorLen)
        };
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor).toArray__ALjava_math_BigInteger()
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero")
  };
  var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = divisor.Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, divisorDigits.get(0), divisorSign)
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this)
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1)
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigInteger)) {
    var x2 = $as_Ljava_math_BigInteger(x);
    return (((this.Ljava_math_BigInteger__f_sign === x2.Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === x2.Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z(x2.Ljava_math_BigInteger__f_digits))
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1)
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = this.Ljava_math_BigInteger__f_digits.get(i);
    return (((i << 5) + ((i$1 === 0) ? 32 : ((31 - Math.clz32((i$1 & ((-i$1) | 0)))) | 0))) | 0)
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var arg1 = i;
      this.Ljava_math_BigInteger__f__hashCode = ((Math.imul(33, this.Ljava_math_BigInteger__f__hashCode) + this.Ljava_math_BigInteger__f_digits.get(arg1)) | 0);
      i = ((1 + i) | 0)
    };
    this.Ljava_math_BigInteger__f__hashCode = Math.imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return Math.imul(this.Ljava_math_BigInteger__f_sign, this.Ljava_math_BigInteger__f_digits.get(0))
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = this.Ljava_math_BigInteger__f_digits.get(1);
    var value$1 = this.Ljava_math_BigInteger__f_digits.get(0);
    var value$3__lo = value$1;
    var value$3__hi = value
  } else {
    var value$2 = this.Ljava_math_BigInteger__f_digits.get(0);
    var value$3__lo = value$2;
    var value$3__hi = 0
  };
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var blo = value$3__lo;
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3__hi) + Math.imul(hi$3, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi$4)
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if (((bi.Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi)
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits))
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent")
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0)
    };
    return $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(Math.imul(x, exp)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.shiftRight__I__Ljava_math_BigInteger(x).pow__I__Ljava_math_BigInteger(exp))
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp)
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))))
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.Ljava_math_BigInteger__f_digits.get(0)) !== 0)
  } else if ((n < 0)) {
    throw new $c_jl_ArithmeticException("Negative bit address")
  } else if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
    return (this.Ljava_math_BigInteger__f_sign < 0)
  } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
    var digit = this.Ljava_math_BigInteger__f_digits.get(intCount);
    if ((this.Ljava_math_BigInteger__f_sign < 0)) {
      digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit))
    };
    var i = (1 << (31 & n));
    return ((digit & i) !== 0)
  } else {
    return false
  }
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this)
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = (((-1) + this.Ljava_math_BigInteger__f_numberLength) | 0);
      if ((this.Ljava_math_BigInteger__f_digits.get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
        continue
      }
    };
    break
  };
  if ((this.Ljava_math_BigInteger__f_digits.get(this.Ljava_math_BigInteger__f_numberLength) === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0
  };
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0)
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if ((this.Ljava_math_BigInteger__f_digits.get(i) !== b.get(i))) {
      return false
    };
    i = ((1 + i) | 0)
  };
  return true
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $$x1 = (-1)
    } else {
      var i = 0;
      while ((this.Ljava_math_BigInteger__f_digits.get(i) === 0)) {
        i = ((1 + i) | 0)
      };
      var $$x1 = i
    };
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $$x1
  };
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && (this.Ljava_math_BigInteger__f_digits.get(0) === 1))
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this))
});
$c_Ljava_math_BigInteger.prototype.compareTo__O__I = (function(x$1) {
  return this.compareTo__Ljava_math_BigInteger__I($as_Ljava_math_BigInteger(x$1))
});
function $as_Ljava_math_BigInteger(obj) {
  return (((obj instanceof $c_Ljava_math_BigInteger) || (obj === null)) ? obj : $throwClassCastException(obj, "java.math.BigInteger"))
}
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)))
}
function $asArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (($isArrayOf_Ljava_math_BigInteger(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.math.BigInteger;", depth))
}
var $d_Ljava_math_BigInteger = new $TypeData().initClass({
  Ljava_math_BigInteger: 0
}, false, "java.math.BigInteger", {
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
});
$c_Ljava_math_BigInteger.prototype.$classData = $d_Ljava_math_BigInteger;
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal)
}
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
  /*<skip>*/
}
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass({
  Ljava_math_RoundingMode: 0
}, false, "java.math.RoundingMode", {
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_math_RoundingMode.prototype.$classData = $d_Ljava_math_RoundingMode;
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = _readOnly;
  $ct_Ljava_nio_ByteBuffer__I__AB__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit)
}
$c_Ljava_nio_HeapByteBuffer.prototype = new $h_Ljava_nio_ByteBuffer();
$c_Ljava_nio_HeapByteBuffer.prototype.constructor = $c_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer() {
  /*<skip>*/
}
$h_Ljava_nio_HeapByteBuffer.prototype = $c_Ljava_nio_HeapByteBuffer.prototype;
$c_Ljava_nio_HeapByteBuffer.prototype.putInt__I__Ljava_nio_ByteBuffer = (function(value) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException()
  };
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((4 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException()
  };
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var _1 = (((value >> 24) << 24) >> 24);
  var _2 = (((value >> 16) << 24) >> 24);
  var _3 = (((value >> 8) << 24) >> 24);
  var _4 = ((value << 24) >> 24);
  if (isBigEndian) {
    var bs___1 = _1;
    var bs___2 = _2;
    var bs___3 = _3;
    var bs___4 = _4
  } else {
    var bs___1 = _4;
    var bs___2 = _3;
    var bs___3 = _2;
    var bs___4 = _1
  };
  var idx = ((p + arrayOffset) | 0);
  array.set(idx, $uB(bs___1));
  array.set(((1 + idx) | 0), $uB(bs___2));
  array.set(((2 + idx) | 0), $uB(bs___3));
  array.set(((3 + idx) | 0), $uB(bs___4));
  return this
});
$c_Ljava_nio_HeapByteBuffer.prototype.getLong__I__J = (function(index) {
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  if (((index < 0) || (((8 + index) | 0) > this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  var idx = ((index + arrayOffset) | 0);
  var _1 = array.get(idx);
  var _2 = array.get(((1 + idx) | 0));
  var _3 = array.get(((2 + idx) | 0));
  var _4 = array.get(((3 + idx) | 0));
  var _5 = array.get(((4 + idx) | 0));
  var _6 = array.get(((5 + idx) | 0));
  var _7 = array.get(((6 + idx) | 0));
  var _8 = array.get(((7 + idx) | 0));
  if (isBigEndian) {
    var value = ((((_1 << 24) | ((255 & _2) << 16)) | ((255 & _3) << 8)) | (255 & _4));
    var value$1 = ((((_5 << 24) | ((255 & _6) << 16)) | ((255 & _7) << 8)) | (255 & _8));
    return new $c_RTLong(value$1, value)
  } else {
    var value$2 = ((((_8 << 24) | ((255 & _7) << 16)) | ((255 & _6) << 8)) | (255 & _5));
    var value$3 = ((((_4 << 24) | ((255 & _3) << 16)) | ((255 & _2) << 8)) | (255 & _1));
    return new $c_RTLong(value$3, value$2)
  }
});
var $d_Ljava_nio_HeapByteBuffer = new $TypeData().initClass({
  Ljava_nio_HeapByteBuffer: 0
}, false, "java.nio.HeapByteBuffer", {
  Ljava_nio_HeapByteBuffer: 1,
  Ljava_nio_ByteBuffer: 1,
  Ljava_nio_Buffer: 1,
  O: 1,
  jl_Comparable: 1
});
$c_Ljava_nio_HeapByteBuffer.prototype.$classData = $d_Ljava_nio_HeapByteBuffer;
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.ju_AbstractRandomAccessListIterator__f_i = i;
  $thiz.ju_AbstractRandomAccessListIterator__f_start = start;
  $thiz.ju_AbstractRandomAccessListIterator__f_end = end;
  $thiz.ju_AbstractRandomAccessListIterator__f_last = (-1);
  return $thiz
}
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_start = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0
}
$c_ju_AbstractRandomAccessListIterator.prototype = new $h_O();
$c_ju_AbstractRandomAccessListIterator.prototype.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
  /*<skip>*/
}
$h_ju_AbstractRandomAccessListIterator.prototype = $c_ju_AbstractRandomAccessListIterator.prototype;
$c_ju_AbstractRandomAccessListIterator.prototype.hasNext__Z = (function() {
  return (this.ju_AbstractRandomAccessListIterator__f_i < this.ju_AbstractRandomAccessListIterator__f_end)
});
$c_ju_AbstractRandomAccessListIterator.prototype.next__O = (function() {
  this.ju_AbstractRandomAccessListIterator__f_last = this.ju_AbstractRandomAccessListIterator__f_i;
  this.ju_AbstractRandomAccessListIterator__f_i = ((1 + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  return this.get__I__O(this.ju_AbstractRandomAccessListIterator__f_last)
});
/** @constructor */
function $c_ju_HashMap$Values(outer) {
  this.ju_HashMap$Values__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.ju_HashMap$Values__f_$outer = outer
  }
}
$c_ju_HashMap$Values.prototype = new $h_ju_AbstractCollection();
$c_ju_HashMap$Values.prototype.constructor = $c_ju_HashMap$Values;
/** @constructor */
function $h_ju_HashMap$Values() {
  /*<skip>*/
}
$h_ju_HashMap$Values.prototype = $c_ju_HashMap$Values.prototype;
$c_ju_HashMap$Values.prototype.iterator__ju_Iterator = (function() {
  var this$1 = this.ju_HashMap$Values__f_$outer;
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(this$1)
});
$c_ju_HashMap$Values.prototype.size__I = (function() {
  return this.ju_HashMap$Values__f_$outer.ju_HashMap__f_contentSize
});
$c_ju_HashMap$Values.prototype.contains__O__Z = (function(o) {
  return this.ju_HashMap$Values__f_$outer.containsValue__O__Z(o)
});
var $d_ju_HashMap$Values = new $TypeData().initClass({
  ju_HashMap$Values: 0
}, false, "java.util.HashMap$Values", {
  ju_HashMap$Values: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1
});
$c_ju_HashMap$Values.prototype.$classData = $d_ju_HashMap$Values;
class $c_ju_concurrent_ExecutionException extends $c_jl_Exception {
  constructor(message, cause) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_ju_concurrent_ExecutionException = new $TypeData().initClass({
  ju_concurrent_ExecutionException: 0
}, false, "java.util.concurrent.ExecutionException", {
  ju_concurrent_ExecutionException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ExecutionException.prototype.$classData = $d_ju_concurrent_ExecutionException;
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0
}
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
function $as_ju_concurrent_TimeUnit(obj) {
  return (((obj instanceof $c_ju_concurrent_TimeUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.TimeUnit"))
}
function $isArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_TimeUnit)))
}
function $asArrayOf_ju_concurrent_TimeUnit(obj, depth) {
  return (($isArrayOf_ju_concurrent_TimeUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.TimeUnit;", depth))
}
var $d_ju_concurrent_TimeUnit = new $TypeData().initClass({
  ju_concurrent_TimeUnit: 0
}, false, "java.util.concurrent.TimeUnit", {
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit.prototype.$classData = $d_ju_concurrent_TimeUnit;
/** @constructor */
function $c_Lnet_andimiller_Model(input, topK, rows) {
  this.Lnet_andimiller_Model__f_input = null;
  this.Lnet_andimiller_Model__f_topK = 0;
  this.Lnet_andimiller_Model__f_rows = null;
  this.Lnet_andimiller_Model__f_input = input;
  this.Lnet_andimiller_Model__f_topK = topK;
  this.Lnet_andimiller_Model__f_rows = rows
}
$c_Lnet_andimiller_Model.prototype = new $h_O();
$c_Lnet_andimiller_Model.prototype.constructor = $c_Lnet_andimiller_Model;
/** @constructor */
function $h_Lnet_andimiller_Model() {
  /*<skip>*/
}
$h_Lnet_andimiller_Model.prototype = $c_Lnet_andimiller_Model.prototype;
$c_Lnet_andimiller_Model.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_andimiller_Model.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Model");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lnet_andimiller_Model__f_input;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lnet_andimiller_Model__f_topK;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lnet_andimiller_Model__f_rows;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lnet_andimiller_Model.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_andimiller_Model)) {
    var x$0$2 = $as_Lnet_andimiller_Model(x$0);
    if (((this.Lnet_andimiller_Model__f_topK === x$0$2.Lnet_andimiller_Model__f_topK) && (this.Lnet_andimiller_Model__f_input === x$0$2.Lnet_andimiller_Model__f_input))) {
      var x = this.Lnet_andimiller_Model__f_rows;
      var x$2 = x$0$2.Lnet_andimiller_Model__f_rows;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_andimiller_Model.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_andimiller_Model.prototype.productArity__I = (function() {
  return 3
});
$c_Lnet_andimiller_Model.prototype.productPrefix__T = (function() {
  return "Model"
});
$c_Lnet_andimiller_Model.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_andimiller_Model__f_input;
      break
    }
    case 1: {
      return this.Lnet_andimiller_Model__f_topK;
      break
    }
    case 2: {
      return this.Lnet_andimiller_Model__f_rows;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lnet_andimiller_Model.prototype.topTheta__s_Option = (function() {
  var this$1 = this.Lnet_andimiller_Model__f_rows;
  var f = ((_$5) => {
    var _$5$1 = $as_Lnet_andimiller_Row(_$5);
    return _$5$1.Lnet_andimiller_Row__f_keep
  });
  var l = this$1;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break
      } else {
        var h = l.head__O();
        var t = $as_sci_List(l.tail__O());
        if (($uZ(f(h)) === false)) {
          l = t;
          continue
        };
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block
          } else {
            var x = remaining.head__O();
            if (($uZ(f(x)) !== false)) {
              remaining = $as_sci_List(remaining.tail__O());
              continue
            };
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = $as_sci_List(start.tail__O());
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = $as_sci_List(toProcess.tail__O())
            };
            var next = $as_sci_List(firstMiss.tail__O());
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (($uZ(f(head)) !== false)) {
                next = $as_sci_List(next.tail__O())
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = $as_sci_List(nextToCopy.tail__O())
                };
                nextToCopy = $as_sci_List(next.tail__O());
                next = $as_sci_List(next.tail__O())
              }
            };
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy
            };
            var result = newHead;
            break block
          }
        }
      }
    }
  };
  var f$1 = ((_$6) => {
    var _$6$1 = $as_Lnet_andimiller_Row(_$6);
    return _$6$1.Lnet_andimiller_Row__f_theta
  });
  if ((result === $m_sci_Nil$())) {
    var this$2 = $m_sci_Nil$()
  } else {
    var arg1 = result.head__O();
    var h$1 = new $c_sci_$colon$colon(f$1(arg1), $m_sci_Nil$());
    var t$1 = h$1;
    var rest = $as_sci_List(result.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var this$2 = h$1
  };
  var ord = $m_s_math_Ordering$DeprecatedDoubleOrdering$();
  return $f_sc_IterableOnceOps__maxOption__s_math_Ordering__s_Option(this$2, ord)
});
$c_Lnet_andimiller_Model.prototype.estimate__D = (function() {
  var $$x1 = this.Lnet_andimiller_Model__f_topK;
  var this$1 = this.topTheta__s_Option();
  return ((((-1) + $$x1) | 0) / $uD((this$1.isEmpty__Z() ? 0.0 : this$1.get__O())))
});
$c_Lnet_andimiller_Model.prototype.uniques__J = (function() {
  var this$1 = this.Lnet_andimiller_Model__f_rows;
  var f = ((_$7) => {
    var _$7$1 = $as_Lnet_andimiller_Row(_$7);
    return _$7$1.Lnet_andimiller_Row__f_input
  });
  if ((this$1 === $m_sci_Nil$())) {
    var this$2 = $m_sci_Nil$()
  } else {
    var arg1 = this$1.head__O();
    var h = new $c_sci_$colon$colon(f(arg1), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this$1.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var arg1$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(arg1$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    var this$2 = h
  };
  var this$3 = $as_sc_SeqOps($f_sc_SeqOps__distinct__O(this$2));
  var x = this$3.length__I();
  var hi = (x >> 31);
  return new $c_RTLong(x, hi)
});
function $as_Lnet_andimiller_Model(obj) {
  return (((obj instanceof $c_Lnet_andimiller_Model) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.Model"))
}
function $isArrayOf_Lnet_andimiller_Model(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_Model)))
}
function $asArrayOf_Lnet_andimiller_Model(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_Model(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.Model;", depth))
}
var $d_Lnet_andimiller_Model = new $TypeData().initClass({
  Lnet_andimiller_Model: 0
}, false, "net.andimiller.Model", {
  Lnet_andimiller_Model: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_andimiller_Model.prototype.$classData = $d_Lnet_andimiller_Model;
/** @constructor */
function $c_Lnet_andimiller_Row(input, hash, theta, keep) {
  this.Lnet_andimiller_Row__f_input = null;
  this.Lnet_andimiller_Row__f_hash = $L0;
  this.Lnet_andimiller_Row__f_theta = 0.0;
  this.Lnet_andimiller_Row__f_keep = false;
  this.Lnet_andimiller_Row__f_input = input;
  this.Lnet_andimiller_Row__f_hash = hash;
  this.Lnet_andimiller_Row__f_theta = theta;
  this.Lnet_andimiller_Row__f_keep = keep
}
$c_Lnet_andimiller_Row.prototype = new $h_O();
$c_Lnet_andimiller_Row.prototype.constructor = $c_Lnet_andimiller_Row;
/** @constructor */
function $h_Lnet_andimiller_Row() {
  /*<skip>*/
}
$h_Lnet_andimiller_Row.prototype = $c_Lnet_andimiller_Row.prototype;
$c_Lnet_andimiller_Row.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lnet_andimiller_Row.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Row");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lnet_andimiller_Row__f_input;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lnet_andimiller_Row__f_hash;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var dv = this.Lnet_andimiller_Row__f_theta;
  var data$3 = $m_sr_Statics$().doubleHash__D__I(dv);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var data$4 = (this.Lnet_andimiller_Row__f_keep ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4)
});
$c_Lnet_andimiller_Row.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_andimiller_Row)) {
    var x$0$2 = $as_Lnet_andimiller_Row(x$0);
    var this$1 = this.Lnet_andimiller_Row__f_hash;
    var b = x$0$2.Lnet_andimiller_Row__f_hash;
    if (((((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi)) && (this.Lnet_andimiller_Row__f_theta === x$0$2.Lnet_andimiller_Row__f_theta)) && (this.Lnet_andimiller_Row__f_keep === x$0$2.Lnet_andimiller_Row__f_keep))) {
      return (this.Lnet_andimiller_Row__f_input === x$0$2.Lnet_andimiller_Row__f_input)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lnet_andimiller_Row.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_andimiller_Row.prototype.productArity__I = (function() {
  return 4
});
$c_Lnet_andimiller_Row.prototype.productPrefix__T = (function() {
  return "Row"
});
$c_Lnet_andimiller_Row.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lnet_andimiller_Row__f_input;
      break
    }
    case 1: {
      return this.Lnet_andimiller_Row__f_hash;
      break
    }
    case 2: {
      return this.Lnet_andimiller_Row__f_theta;
      break
    }
    case 3: {
      return this.Lnet_andimiller_Row__f_keep;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lnet_andimiller_Row(obj) {
  return (((obj instanceof $c_Lnet_andimiller_Row) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.Row"))
}
function $isArrayOf_Lnet_andimiller_Row(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_Row)))
}
function $asArrayOf_Lnet_andimiller_Row(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_Row(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.Row;", depth))
}
var $d_Lnet_andimiller_Row = new $TypeData().initClass({
  Lnet_andimiller_Row: 0
}, false, "net.andimiller.Row", {
  Lnet_andimiller_Row: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lnet_andimiller_Row.prototype.$classData = $d_Lnet_andimiller_Row;
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__liftedTree1$3__sr_BooleanRef__sjs_js_Dynamic__Z($thiz, postMessageIsAsynchronous$1, oldOnMessage$1) {
  try {
    onmessage = $m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0(((postMessageIsAsynchronous$1$2) => (() => {
      postMessageIsAsynchronous$1$2.sr_BooleanRef__f_elem = false
    }))(postMessageIsAsynchronous$1)));
    postMessage("", "*");
    onmessage = oldOnMessage$1;
    return postMessageIsAsynchronous$1.sr_BooleanRef__f_elem
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x2.isEmpty__Z())) {
        $as_jl_Throwable(x2.get__O());
        return false
      }
    };
    throw e$2
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z($thiz) {
  if ((($as_T((typeof postMessage)) !== "undefined") && ($as_T((typeof importScripts)) === "undefined"))) {
    var postMessageIsAsynchronous = new $c_sr_BooleanRef(true);
    var oldOnMessage = onmessage;
    return $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__liftedTree1$3__sr_BooleanRef__sjs_js_Dynamic__Z($thiz, postMessageIsAsynchronous, oldOnMessage)
  } else {
    return false
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$2__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$1, currentlyRunningATask$1, handle) {
  if (currentlyRunningATask$1.sr_BooleanRef__f_elem) {
    setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(new $c_sjsr_AnonFunction0(((this$1, tasksByHandle$1$2, currentlyRunningATask$1$2, handle$2) => (() => {
      $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$2__scm_Map__sr_BooleanRef__I__V(this$1, tasksByHandle$1$2, currentlyRunningATask$1$2, handle$2)
    }))($thiz, tasksByHandle$1, currentlyRunningATask$1, handle))), 0)
  } else {
    matchResult2: {
      var x5 = tasksByHandle$1.get__O__s_Option(handle);
      if ((x5 instanceof $c_s_Some)) {
        var task = $as_F0($as_s_Some(x5).s_Some__f_value);
        currentlyRunningATask$1.sr_BooleanRef__f_elem = true;
        try {
          task.apply__O()
        } finally {
          tasksByHandle$1.subtractOne__O__scm_Shrinkable(handle);
          currentlyRunningATask$1.sr_BooleanRef__f_elem = false
        };
        break matchResult2
      };
      var x = $m_s_None$();
      if ((x === x5)) {
        break matchResult2
      };
      throw new $c_s_MatchError(x5)
    }
  }
}
function $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V($thiz, tasksByHandle$3, currentlyRunningATask$3, messagePrefix$1, event) {
  if ((($as_T((typeof event.data)) === "string") && ($uI(event.data.indexOf(messagePrefix$1)) === 0))) {
    var this$2 = $dp_toString__T(event.data);
    var beginIndex = $uI(messagePrefix$1.length);
    var x = $as_T(this$2.substring(beginIndex));
    var this$6 = $m_jl_Integer$();
    $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$2__scm_Map__sr_BooleanRef__I__V($thiz, tasksByHandle$3, currentlyRunningATask$3, this$6.parseInt__T__I__I(x, 10))
  }
}
/** @constructor */
function $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = null;
  $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = this;
  if (($as_T((typeof setImmediate)) === "undefined")) {
    var nextHandle = new $c_sr_IntRef(1);
    var tasksByHandle = $as_scm_Map($m_scm_Map$().apply__sci_Seq__O($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]))));
    var currentlyRunningATask = new $c_sr_BooleanRef(false);
    if ($p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__canUsePostMessage$1__Z(this)) {
      var this$3 = $m_s_util_Random$();
      var this$4 = this$3.s_util_Random__f_self;
      var messagePrefix = (("setImmediate$" + this$4.next__I__I(32)) + "$");
      if (($as_T((typeof addEventListener)) !== "undefined")) {
        addEventListener("message", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((this$6, tasksByHandle$2, currentlyRunningATask$2, messagePrefix$2) => ((event) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this$6, tasksByHandle$2, currentlyRunningATask$2, messagePrefix$2, event)
        }))(this, tasksByHandle, currentlyRunningATask, messagePrefix))), false)
      } else {
        attachEvent("onmessage", $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((this$2$1, tasksByHandle$3, currentlyRunningATask$3, messagePrefix$3) => ((event$2) => {
          $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__onGlobalMessage$1__scm_Map__sr_BooleanRef__T__sjs_js_Dynamic__V(this$2$1, tasksByHandle$3, currentlyRunningATask$3, messagePrefix$3, event$2)
        }))(this, tasksByHandle, currentlyRunningATask, messagePrefix))))
      };
      var $$x4 = new $c_sjsr_AnonFunction1(((nextHandle$2, tasksByHandle$4, messagePrefix$4) => ((k) => {
        var k$1 = $as_F0(k);
        var handle = nextHandle$2.sr_IntRef__f_elem;
        var ev$7 = ((1 + nextHandle$2.sr_IntRef__f_elem) | 0);
        nextHandle$2.sr_IntRef__f_elem = ev$7;
        var elem = new $c_T2(handle, k$1);
        tasksByHandle$4.addOne__O__scm_Growable(elem);
        var $$x5 = postMessage;
        var s = (("" + messagePrefix$4) + handle);
        $$x5(s, "*")
      }))(nextHandle, tasksByHandle, messagePrefix))
    } else if (($as_T((typeof MessageChannel)) !== "undefined")) {
      var channel = new MessageChannel();
      channel.port1.onmessage = $m_sjs_js_Any$().fromFunction1__F1__sjs_js_Function1(new $c_sjsr_AnonFunction1(((this$4$1, tasksByHandle$5, currentlyRunningATask$4) => ((event$3) => {
        $p_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__runIfPresent$2__scm_Map__sr_BooleanRef__I__V(this$4$1, tasksByHandle$5, currentlyRunningATask$4, $uI(event$3.data))
      }))(this, tasksByHandle, currentlyRunningATask)));
      var $$x4 = new $c_sjsr_AnonFunction1(((nextHandle$3, tasksByHandle$6, channel$2) => ((k$2) => {
        var k$3 = $as_F0(k$2);
        var handle$1 = nextHandle$3.sr_IntRef__f_elem;
        var ev$8 = ((1 + nextHandle$3.sr_IntRef__f_elem) | 0);
        nextHandle$3.sr_IntRef__f_elem = ev$8;
        var elem$1 = new $c_T2(handle$1, k$3);
        tasksByHandle$6.addOne__O__scm_Growable(elem$1);
        channel$2.port2.postMessage(handle$1)
      }))(nextHandle, tasksByHandle, channel))
    } else {
      if (($as_T((typeof navigator)) !== "undefined")) {
        var x = navigator.userAgent;
        if ((x !== (void 0))) {
          var _$1 = $as_T(x);
          var $$x6 = ($uI(_$1.indexOf("jsdom")) !== (-1))
        } else {
          var $$x6 = false
        }
      } else {
        var $$x6 = false
      };
      if ($$x6) {
        var setImmediate$1 = Node.constructor("return setImmediate")();
        var $$x4 = new $c_sjsr_AnonFunction1(((setImmediate$2) => ((k$3$1) => {
          var k$4 = $as_F0(k$3$1);
          setImmediate$2($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$4))
        }))(setImmediate$1))
      } else {
        var $$x4 = new $c_sjsr_AnonFunction1(((k$4$1) => {
          var k$5 = $as_F0(k$4$1);
          setTimeout($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$5), 0)
        }))
      }
    }
  } else {
    var $$x4 = new $c_sjsr_AnonFunction1(((k$5$1) => {
      var k$6 = $as_F0(k$5$1);
      setImmediate($m_sjs_js_Any$().fromFunction0__F0__sjs_js_Function0(k$6))
    }))
  };
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate = $$x4
}
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = new $h_O();
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.constructor = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
/** @constructor */
function $h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  /*<skip>*/
}
$h_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype = $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype;
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.execute__jl_Runnable__V = (function(runnable) {
  this.Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$__f_setImmediate.apply__O__O(new $c_sjsr_AnonFunction0(((runnable$2) => (() => {
    runnable$2.run__V()
  }))(runnable)))
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.reportFailure__jl_Throwable__V = (function(cause) {
  cause.printStackTrace__Ljava_io_PrintStream__V($m_jl_System$Streams$().jl_System$Streams$__f_err)
});
var $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $TypeData().initClass({
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 0
}, false, "org.scalajs.macrotaskexecutor.MacrotaskExecutor$", {
  Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$: 1,
  O: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_ExecutionContextExecutor: 1
});
$c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$.prototype.$classData = $d_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
var $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$;
function $m_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$() {
  if ((!$n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$)) {
    $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$ = new $c_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$()
  };
  return $n_Lorg_scalajs_macrotaskexecutor_MacrotaskExecutor$
}
/** @constructor */
function $c_s_$eq$colon$eq() {
  /*<skip>*/
}
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
  /*<skip>*/
}
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
class $c_s_NotImplementedError extends $c_jl_Error {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "an implementation is missing", null, true, true)
  };
}
var $d_s_NotImplementedError = new $TypeData().initClass({
  s_NotImplementedError: 0
}, false, "scala.NotImplementedError", {
  s_NotImplementedError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_NotImplementedError.prototype.$classData = $d_s_NotImplementedError;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sjsr_AnonFunction1(((x$2) => $m_s_None$()))
}
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
  /*<skip>*/
}
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x)
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return this
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1)
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass({
  s_PartialFunction$$anon$1: 0
}, false, "scala.PartialFunction$$anon$1", {
  s_PartialFunction$$anon$1: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$$anon$1.prototype.$classData = $d_s_PartialFunction$$anon$1;
/** @constructor */
function $c_s_PartialFunction$AndThen(pf, k) {
  this.s_PartialFunction$AndThen__f_pf = null;
  this.s_PartialFunction$AndThen__f_k = null;
  this.s_PartialFunction$AndThen__f_pf = pf;
  this.s_PartialFunction$AndThen__f_k = k
}
$c_s_PartialFunction$AndThen.prototype = new $h_O();
$c_s_PartialFunction$AndThen.prototype.constructor = $c_s_PartialFunction$AndThen;
/** @constructor */
function $h_s_PartialFunction$AndThen() {
  /*<skip>*/
}
$h_s_PartialFunction$AndThen.prototype = $c_s_PartialFunction$AndThen.prototype;
$c_s_PartialFunction$AndThen.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_s_PartialFunction$AndThen.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$AndThen.prototype.isDefinedAt__O__Z = (function(x) {
  return this.s_PartialFunction$AndThen__f_pf.isDefinedAt__O__Z(x)
});
$c_s_PartialFunction$AndThen.prototype.apply__O__O = (function(x) {
  return this.s_PartialFunction$AndThen__f_k.apply__O__O(this.s_PartialFunction$AndThen__f_pf.apply__O__O(x))
});
$c_s_PartialFunction$AndThen.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = this.s_PartialFunction$AndThen__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? this.s_PartialFunction$AndThen__f_k.apply__O__O(z) : default$1.apply__O__O(x))
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_s_PartialFunction$AndThen = new $TypeData().initClass({
  s_PartialFunction$AndThen: 0
}, false, "scala.PartialFunction$AndThen", {
  s_PartialFunction$AndThen: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$AndThen.prototype.$classData = $d_s_PartialFunction$AndThen;
/** @constructor */
function $c_s_PartialFunction$Combined(pf, k) {
  this.s_PartialFunction$Combined__f_pf = null;
  this.s_PartialFunction$Combined__f_k = null;
  this.s_PartialFunction$Combined__f_pf = pf;
  this.s_PartialFunction$Combined__f_k = k
}
$c_s_PartialFunction$Combined.prototype = new $h_O();
$c_s_PartialFunction$Combined.prototype.constructor = $c_s_PartialFunction$Combined;
/** @constructor */
function $h_s_PartialFunction$Combined() {
  /*<skip>*/
}
$h_s_PartialFunction$Combined.prototype = $c_s_PartialFunction$Combined.prototype;
$c_s_PartialFunction$Combined.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_s_PartialFunction$Combined.prototype.toString__T = (function() {
  return "<function1>"
});
$c_s_PartialFunction$Combined.prototype.isDefinedAt__O__Z = (function(x) {
  var b = this.s_PartialFunction$Combined__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(b)) && this.s_PartialFunction$Combined__f_k.isDefinedAt__O__Z(b))
});
$c_s_PartialFunction$Combined.prototype.apply__O__O = (function(x) {
  return this.s_PartialFunction$Combined__f_k.apply__O__O(this.s_PartialFunction$Combined__f_pf.apply__O__O(x))
});
$c_s_PartialFunction$Combined.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var pfv = this.s_PartialFunction$Combined__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(pfv)) ? this.s_PartialFunction$Combined__f_k.applyOrElse__O__F1__O(pfv, new $c_sjsr_AnonFunction1(((default$2, x$1) => ((x$1$2) => default$2.apply__O__O(x$1)))(default$1, x))) : default$1.apply__O__O(x))
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
var $d_s_PartialFunction$Combined = new $TypeData().initClass({
  s_PartialFunction$Combined: 0
}, false, "scala.PartialFunction$Combined", {
  s_PartialFunction$Combined: 1,
  O: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_PartialFunction$Combined.prototype.$classData = $d_s_PartialFunction$Combined;
/** @constructor */
function $c_sc_AbstractIterator() {
  /*<skip>*/
}
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
  /*<skip>*/
}
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sc_AbstractIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return this.sliceIterator__I__I__sc_Iterator(n, (-1))
});
$c_sc_AbstractIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until)
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sc_AbstractIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1)
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$())
}
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
  /*<skip>*/
}
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass({
  sc_Iterable$: 0
}, false, "scala.collection.Iterable$", {
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Iterable$.prototype.$classData = $d_sc_Iterable$;
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$()
  };
  return $n_sc_Iterable$
}
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sjsr_AnonFunction0((() => $m_sc_Map$().sc_Map$__f_DefaultSentinel))
}
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
  /*<skip>*/
}
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass({
  sc_Map$: 0
}, false, "scala.collection.Map$", {
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Map$.prototype.$classData = $d_sc_Map$;
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$()
  };
  return $n_sc_Map$
}
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz
}
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null
}
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.apply__sci_Seq__O(elems))
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.empty__O())
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return $as_sc_SeqOps(this.sc_SeqFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it))
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_SeqFactory$Delegate__f_delegate.newBuilder__scm_Builder()
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source)
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps()
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems)
});
function $f_sc_SeqOps__distinct__O($thiz) {
  return $thiz.distinctBy__F1__O(new $c_sjsr_AnonFunction1(((x$2) => x$2)))
}
function $f_sc_SeqOps__distinctBy__F1__O($thiz, f) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$DistinctBy($thiz, f))
}
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0))
}
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sjsr_AnonFunction1(((elem$1) => ((x$1$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(elem$1, x$1$2)))(elem)), from)
}
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sjsr_AnonFunction1(((elem$1) => ((x$3$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2, elem$1)))(elem)))
}
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.length__I();
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((len === 1)) {
    var elem = $thiz.head__O();
    b.addOne__O__scm_Growable(elem)
  } else if ((len > 1)) {
    b.sizeHint__I__V(len);
    var arr = new $ac_O(len);
    $thiz.copyToArray__O__I__I__I(arr, 0, 2147483647);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, ord);
    var i = 0;
    while ((i < len)) {
      var elem$1 = arr.get(i);
      b.addOne__O__scm_Growable(elem$1);
      i = ((1 + i) | 0)
    }
  };
  return b.result__O()
}
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  return $thiz.sorted__s_math_Ordering__O(new $c_s_math_Ordering$$anon$1(ord, f))
}
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0)
}
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = that.knownSize__I();
    var knownSizeDifference = ((thatKnownSize !== (-1)) && (thisKnownSize !== thatKnownSize))
  } else {
    var knownSizeDifference = false
  };
  if ((!knownSizeDifference)) {
    var this$1 = $thiz.iterator__sc_Iterator();
    return $f_sc_Iterator__sameElements__sc_IterableOnce__Z(this$1, that)
  } else {
    return false
  }
}
function $is_sc_SeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SeqOps)))
}
function $as_sc_SeqOps(obj) {
  return (($is_sc_SeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SeqOps"))
}
function $isArrayOf_sc_SeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SeqOps)))
}
function $asArrayOf_sc_SeqOps(obj, depth) {
  return (($isArrayOf_sc_SeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SeqOps;", depth))
}
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return b.result__O()
}
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var xs = $as_sc_IterableOnce(f.apply__O__O(it.next__O()));
    b.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return b.result__O()
}
/** @constructor */
function $c_sci_BitSet$() {
  this.sci_BitSet$__f_empty = null;
  $n_sci_BitSet$ = this;
  this.sci_BitSet$__f_empty = new $c_sci_BitSet$BitSet1($L0)
}
$c_sci_BitSet$.prototype = new $h_O();
$c_sci_BitSet$.prototype.constructor = $c_sci_BitSet$;
/** @constructor */
function $h_sci_BitSet$() {
  /*<skip>*/
}
$h_sci_BitSet$.prototype = $c_sci_BitSet$.prototype;
$c_sci_BitSet$.prototype.fromSpecific__sc_IterableOnce__sci_BitSet = (function(it) {
  if ((it instanceof $c_sci_BitSet)) {
    var x2 = $as_sci_BitSet(it);
    return x2
  } else {
    var this$1 = this.newBuilder__scm_Builder();
    return $as_sci_BitSet($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(it)).result__O())
  }
});
$c_sci_BitSet$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  var f = new $c_sjsr_AnonFunction1(((bs$2) => {
    var bs = $as_scm_BitSet(bs$2);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(bs.scm_BitSet__f_elems)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_BitSet$.prototype.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet = (function(a, b) {
  return (((b.RTLong__f_lo === 0) && (b.RTLong__f_hi === 0)) ? new $c_sci_BitSet$BitSet1(a) : new $c_sci_BitSet$BitSet2(a, b))
});
$c_sci_BitSet$.prototype.fromBitMaskNoCopy__AJ__sci_BitSet = (function(elems) {
  var len = elems.u.length;
  return ((len === 0) ? this.sci_BitSet$__f_empty : ((len === 1) ? new $c_sci_BitSet$BitSet1(elems.get(0)) : ((len === 2) ? this.scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(elems.get(0), elems.get(1)) : new $c_sci_BitSet$BitSetN(elems))))
});
var $d_sci_BitSet$ = new $TypeData().initClass({
  sci_BitSet$: 0
}, false, "scala.collection.immutable.BitSet$", {
  sci_BitSet$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$.prototype.$classData = $d_sci_BitSet$;
var $n_sci_BitSet$;
function $m_sci_BitSet$() {
  if ((!$n_sci_BitSet$)) {
    $n_sci_BitSet$ = new $c_sci_BitSet$()
  };
  return $n_sci_BitSet$
}
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$())
}
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
  /*<skip>*/
}
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  if ($is_sci_Iterable(it)) {
    var x2 = $as_sci_Iterable(it);
    return x2
  } else {
    return $as_sci_Iterable($c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it))
  }
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it)
});
var $d_sci_Iterable$ = new $TypeData().initClass({
  sci_Iterable$: 0
}, false, "scala.collection.immutable.Iterable$", {
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Iterable$.prototype.$classData = $d_sci_Iterable$;
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$()
  };
  return $n_sci_Iterable$
}
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f__empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  var state = new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$State$Empty$()));
  this.sci_LazyList$__f__empty = new $c_sci_LazyList(state).force__sci_LazyList();
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sjsr_AnonFunction1(((x$10$2) => $m_sr_Statics$PFMarker$()))
}
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
  /*<skip>*/
}
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sjsr_AnonFunction0(((restRef$1, f$1) => (() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var elem = $as_sci_LazyList(restRef$1.sr_ObjectRef__f_elem);
    var rest = new $c_sr_ObjectRef(elem);
    while (((!itHasNext) && (!$as_sci_LazyList(rest.sr_ObjectRef__f_elem).isEmpty__Z()))) {
      var this$5 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      it.sr_ObjectRef__f_elem = $as_sc_IterableOnce(f$1.apply__O__O(this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O())).iterator__sc_Iterator();
      itHasNext = $as_sc_Iterator(it.sr_ObjectRef__f_elem).hasNext__Z();
      if ((!itHasNext)) {
        var this$6 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
        rest.sr_ObjectRef__f_elem = this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        restRef$1.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem)
      }
    };
    if (itHasNext) {
      var head = $as_sc_Iterator(it.sr_ObjectRef__f_elem).next__O();
      var this$7 = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      rest.sr_ObjectRef__f_elem = this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      restRef$1.sr_ObjectRef__f_elem = $as_sci_LazyList(rest.sr_ObjectRef__f_elem);
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sjsr_AnonFunction0(((it$1, rest$1, f$3) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State($as_sc_Iterator(it$1.sr_ObjectRef__f_elem), new $c_sjsr_AnonFunction0(((rest$1$1, f$3$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList($as_sci_LazyList(rest$1$1.sr_ObjectRef__f_elem), f$3$1).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))(rest$1, f$3)))))(it, rest, f$1));
      var tl = new $c_sci_LazyList(state);
      return new $c_sci_LazyList$State$Cons(head, tl)
    } else {
      return $m_sci_LazyList$State$Empty$()
    }
  }))(restRef, f));
  return new $c_sci_LazyList(state$1)
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sjsr_AnonFunction0(((restRef$1, iRef$1) => (() => {
    var rest = $as_sci_LazyList(restRef$1.sr_ObjectRef__f_elem);
    var i = iRef$1.sr_IntRef__f_elem;
    while (((i > 0) && (!rest.isEmpty__Z()))) {
      var this$4 = rest;
      rest = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      restRef$1.sr_ObjectRef__f_elem = rest;
      i = (((-1) + i) | 0);
      iRef$1.sr_IntRef__f_elem = i
    };
    return rest.scala$collection$immutable$LazyList$$state__sci_LazyList$State()
  }))(restRef, iRef));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    var x2 = $as_sci_LazyList(coll);
    return x2
  } else if ((coll.knownSize__I() === 0)) {
    return this.sci_LazyList$__f__empty
  } else {
    var state = new $c_sjsr_AnonFunction0(((coll$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(coll$1.iterator__sc_Iterator())))(coll));
    return new $c_sci_LazyList(state)
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State = (function(it, suffix) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sjsr_AnonFunction0(((it$1, suffix$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(it$1, suffix$1)))(it, suffix));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $as_sci_LazyList$State(suffix.apply__O())
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State = (function(it) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sjsr_AnonFunction0(((it$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(it$1)))(it));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(hd, tl)
  } else {
    return $m_sci_LazyList$State$Empty$()
  }
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder()
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f__empty
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source)
});
var $d_sci_LazyList$ = new $TypeData().initClass({
  sci_LazyList$: 0
}, false, "scala.collection.immutable.LazyList$", {
  sci_LazyList$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList$.prototype.$classData = $d_sci_LazyList$;
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$()
  };
  return $n_sci_LazyList$
}
/** @constructor */
function $c_sci_Stream$() {
  /*<skip>*/
}
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
  /*<skip>*/
}
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems)
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  if ((coll instanceof $c_sci_Stream)) {
    var x2 = $as_sci_Stream(coll);
    return x2
  } else {
    return this.fromIterator__sc_Iterator__sci_Stream(coll.iterator__sc_Iterator())
  }
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return (it.hasNext__Z() ? new $c_sci_Stream$Cons(it.next__O(), new $c_sjsr_AnonFunction0(((it$1) => (() => $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it$1)))(it))) : $m_sci_Stream$Empty$())
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((array$2) => {
    var array = $as_scm_ArrayBuffer(array$2);
    return $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array)
  }));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$()
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source)
});
var $d_sci_Stream$ = new $TypeData().initClass({
  sci_Stream$: 0
}, false, "scala.collection.immutable.Stream$", {
  sci_Stream$: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$.prototype.$classData = $d_sci_Stream$;
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$()
  };
  return $n_sci_Stream$
}
/** @constructor */
function $c_sci_TreeSet$() {
  /*<skip>*/
}
$c_sci_TreeSet$.prototype = new $h_O();
$c_sci_TreeSet$.prototype.constructor = $c_sci_TreeSet$;
/** @constructor */
function $h_sci_TreeSet$() {
  /*<skip>*/
}
$h_sci_TreeSet$.prototype = $c_sci_TreeSet$.prototype;
$c_sci_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(it);
    var x$2 = x2.sci_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : ordering.equals__O__Z(x$2))) {
      return x2
    }
  };
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = x3.ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : ordering.equals__O__Z(x$4))) {
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(x3.iterator__sc_Iterator(), x3.size__I()), ordering)
    }
  };
  if (false) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $$x1 = true
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $$x1 = $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ordering)
    };
    if ($$x1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === (x4.sci_Range__f_step > 0))) {
        var it$2 = x4.iterator__sc_Iterator()
      } else {
        var this$2 = new $c_sc_IndexedSeqView$Id(x4);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$2)
      };
      var tree = $m_sci_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__sci_RedBlackTree$Tree(it$2, x4.length__I());
      return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), tree, ordering)
    }
  };
  var t = null;
  var i = it.iterator__sc_Iterator();
  while (i.hasNext__Z()) {
    t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, i.next__O(), null, false, ordering)
  };
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, ordering)
});
$c_sci_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_sci_TreeSet$TreeSetBuilder(ordering)
});
var $d_sci_TreeSet$ = new $TypeData().initClass({
  sci_TreeSet$: 0
}, false, "scala.collection.immutable.TreeSet$", {
  sci_TreeSet$: 1,
  O: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeSet$.prototype.$classData = $d_sci_TreeSet$;
var $n_sci_TreeSet$;
function $m_sci_TreeSet$() {
  if ((!$n_sci_TreeSet$)) {
    $n_sci_TreeSet$ = new $c_sci_TreeSet$()
  };
  return $n_sci_TreeSet$
}
/** @constructor */
function $c_sci_WrappedString$() {
  this.sci_WrappedString$__f_empty = null;
  $n_sci_WrappedString$ = this;
  this.sci_WrappedString$__f_empty = new $c_sci_WrappedString("")
}
$c_sci_WrappedString$.prototype = new $h_O();
$c_sci_WrappedString$.prototype.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
  /*<skip>*/
}
$h_sci_WrappedString$.prototype = $c_sci_WrappedString$.prototype;
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__sci_WrappedString = (function(it) {
  var b = this.newBuilder__scm_Builder();
  var s = it.knownSize__I();
  if ((s >= 0)) {
    b.sizeHint__I__V(s)
  };
  b.addAll__sc_IterableOnce__scm_Growable(it);
  return $as_sci_WrappedString(b.result__O())
});
$c_sci_WrappedString$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_T(x$2);
    return new $c_sci_WrappedString(x)
  }));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
var $d_sci_WrappedString$ = new $TypeData().initClass({
  sci_WrappedString$: 0
}, false, "scala.collection.immutable.WrappedString$", {
  sci_WrappedString$: 1,
  O: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString$.prototype.$classData = $d_sci_WrappedString$;
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$()
  };
  return $n_sci_WrappedString$
}
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_Builder$$anon$1__f_$outer = outer
  };
  this.scm_Builder$$anon$1__f_f$1 = f$1
}
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
  /*<skip>*/
}
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addOne__O__scm_Growable(x);
  return this
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  this.scm_Builder$$anon$1__f_$outer.sizeHint__I__V(size)
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return this.scm_Builder$$anon$1__f_f$1.apply__O__O(this.scm_Builder$$anon$1__f_$outer.result__O())
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(xs)
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem)
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass({
  scm_Builder$$anon$1: 0
}, false, "scala.collection.mutable.Builder$$anon$1", {
  scm_Builder$$anon$1: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_Builder$$anon$1.prototype.$classData = $d_scm_Builder$$anon$1;
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz
}
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null
}
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
  /*<skip>*/
}
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = this.scm_GrowableBuilder__f_elems;
  this$1.addOne__O__scm_Growable(elem);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  this.scm_GrowableBuilder__f_elems.addAll__sc_IterableOnce__scm_Growable(xs);
  return this
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(xs)
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem)
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems
});
var $d_scm_GrowableBuilder = new $TypeData().initClass({
  scm_GrowableBuilder: 0
}, false, "scala.collection.mutable.GrowableBuilder", {
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_GrowableBuilder.prototype.$classData = $d_scm_GrowableBuilder;
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
  /*<skip>*/
}
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass({
  scm_Iterable$: 0
}, false, "scala.collection.mutable.Iterable$", {
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Iterable$.prototype.$classData = $d_scm_Iterable$;
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$()
  };
  return $n_scm_Iterable$
}
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$())
}
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
  /*<skip>*/
}
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass({
  scm_Map$: 0
}, false, "scala.collection.mutable.Map$", {
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  O: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Map$.prototype.$classData = $d_scm_Map$;
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$()
  };
  return $n_scm_Map$
}
/** @constructor */
function $c_scm_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$())
}
$c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Set$.prototype.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
  /*<skip>*/
}
$h_scm_Set$.prototype = $c_scm_Set$.prototype;
var $d_scm_Set$ = new $TypeData().initClass({
  scm_Set$: 0
}, false, "scala.collection.mutable.Set$", {
  scm_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Set$.prototype.$classData = $d_scm_Set$;
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$()
  };
  return $n_scm_Set$
}
/** @constructor */
function $c_scm_TreeSet$() {
  /*<skip>*/
}
$c_scm_TreeSet$.prototype = new $h_O();
$c_scm_TreeSet$.prototype.constructor = $c_scm_TreeSet$;
/** @constructor */
function $h_scm_TreeSet$() {
  /*<skip>*/
}
$h_scm_TreeSet$.prototype = $c_scm_TreeSet$.prototype;
$c_scm_TreeSet$.prototype.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet = (function(it, ordering) {
  if ((it instanceof $c_scm_TreeSet)) {
    var x2 = $as_scm_TreeSet(it);
    var x$2 = x2.scm_TreeSet__f_ordering;
    if (((ordering === null) ? (x$2 === null) : ordering.equals__O__Z(x$2))) {
      return new $c_scm_TreeSet(x2.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree.treeCopy__scm_RedBlackTree$Tree(), ordering)
    }
  };
  if ($is_sc_SortedSet(it)) {
    var x3 = $as_sc_SortedSet(it);
    var x$4 = x3.ordering__s_math_Ordering();
    if (((ordering === null) ? (x$4 === null) : ordering.equals__O__Z(x$4))) {
      return new $c_scm_TreeSet($m_scm_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree(x3.iterator__sc_Iterator(), x3.size__I()), ordering)
    }
  };
  if (false) {
    var x4 = $as_sci_Range(it);
    if ((ordering === $m_s_math_Ordering$Int$())) {
      var $$x1 = true
    } else {
      var this$1 = $m_s_math_Ordering$Int$();
      var $$x1 = (ordering === this$1.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)
    };
    if ($$x1) {
      if (((ordering === $m_s_math_Ordering$Int$()) === (x4.sci_Range__f_step > 0))) {
        var it$2 = x4.iterator__sc_Iterator()
      } else {
        var this$2 = new $c_sc_IndexedSeqView$Id(x4);
        var it$2 = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$2)
      };
      return new $c_scm_TreeSet($m_scm_RedBlackTree$().fromOrderedKeys__sc_Iterator__I__scm_RedBlackTree$Tree(it$2, x4.length__I()), ordering)
    }
  };
  var t = new $c_scm_RedBlackTree$Tree(null, 0);
  var i = it.iterator__sc_Iterator();
  while (i.hasNext__Z()) {
    $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(t, i.next__O(), null, ordering)
  };
  return new $c_scm_TreeSet(t, ordering)
});
$c_scm_TreeSet$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  var ordering = $as_s_math_Ordering(evidence$12);
  return new $c_scm_TreeSet$$anon$1(ordering)
});
var $d_scm_TreeSet$ = new $TypeData().initClass({
  scm_TreeSet$: 0
}, false, "scala.collection.mutable.TreeSet$", {
  scm_TreeSet$: 1,
  O: 1,
  sc_SortedIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_TreeSet$.prototype.$classData = $d_scm_TreeSet$;
var $n_scm_TreeSet$;
function $m_scm_TreeSet$() {
  if ((!$n_scm_TreeSet$)) {
    $n_scm_TreeSet$ = new $c_scm_TreeSet$()
  };
  return $n_scm_TreeSet$
}
class $c_s_concurrent_Future$$anon$4 extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$4 = new $TypeData().initClass({
  s_concurrent_Future$$anon$4: 0
}, false, "scala.concurrent.Future$$anon$4", {
  s_concurrent_Future$$anon$4: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$4.prototype.$classData = $d_s_concurrent_Future$$anon$4;
/** @constructor */
function $c_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
$c_s_concurrent_duration_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
function $as_s_concurrent_duration_Duration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration"))
}
function $isArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration)))
}
function $asArrayOf_s_concurrent_duration_Duration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration;", depth))
}
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
}
function $as_sr_NonLocalReturnControl(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.NonLocalReturnControl"))
}
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)))
}
function $asArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (($isArrayOf_sr_NonLocalReturnControl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.NonLocalReturnControl;", depth))
}
/** @constructor */
function $c_sjs_js_WrappedDictionary$DictionaryIterator(dict) {
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = null;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict = dict;
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys = Object.keys(dict);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = 0
}
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype = new $h_O();
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.constructor = $c_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $h_sjs_js_WrappedDictionary$DictionaryIterator() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary$DictionaryIterator.prototype = $c_sjs_js_WrappedDictionary$DictionaryIterator.prototype;
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.hasNext__Z = (function() {
  return (this.sjs_js_WrappedDictionary$DictionaryIterator__f_index < $uI(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys.length))
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__T2 = (function() {
  var key = $as_T(this.sjs_js_WrappedDictionary$DictionaryIterator__f_keys[this.sjs_js_WrappedDictionary$DictionaryIterator__f_index]);
  this.sjs_js_WrappedDictionary$DictionaryIterator__f_index = ((1 + this.sjs_js_WrappedDictionary$DictionaryIterator__f_index) | 0);
  var dict = this.sjs_js_WrappedDictionary$DictionaryIterator__f_dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    var $$x1 = dict[key]
  } else {
    var $$x1;
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  };
  return new $c_T2(key, $$x1)
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sjs_js_WrappedDictionary$DictionaryIterator = new $TypeData().initClass({
  sjs_js_WrappedDictionary$DictionaryIterator: 0
}, false, "scala.scalajs.js.WrappedDictionary$DictionaryIterator", {
  sjs_js_WrappedDictionary$DictionaryIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sjs_js_WrappedDictionary$DictionaryIterator.prototype.$classData = $d_sjs_js_WrappedDictionary$DictionaryIterator;
/** @constructor */
function $c_s_util_Either() {
  /*<skip>*/
}
$c_s_util_Either.prototype = new $h_O();
$c_s_util_Either.prototype.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
  /*<skip>*/
}
$h_s_util_Either.prototype = $c_s_util_Either.prototype;
$c_s_util_Either.prototype.fold__F1__F1__O = (function(fa, fb) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return fb.apply__O__O(b)
  } else if ((this instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(this);
    var a = x3.s_util_Left__f_value;
    return fa.apply__O__O(a)
  } else {
    throw new $c_s_MatchError(this)
  }
});
$c_s_util_Either.prototype.swap__s_util_Either = (function() {
  if ((this instanceof $c_s_util_Left)) {
    var x2 = $as_s_util_Left(this);
    var a = x2.s_util_Left__f_value;
    return new $c_s_util_Right(a)
  } else if ((this instanceof $c_s_util_Right)) {
    var x3 = $as_s_util_Right(this);
    var b = x3.s_util_Right__f_value;
    return new $c_s_util_Left(b)
  } else {
    throw new $c_s_MatchError(this)
  }
});
$c_s_util_Either.prototype.flatMap__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return $as_s_util_Either(f.apply__O__O(b))
  } else {
    return this
  }
});
$c_s_util_Either.prototype.map__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return new $c_s_util_Right(f.apply__O__O(b))
  } else {
    return this
  }
});
$c_s_util_Either.prototype.toOption__s_Option = (function() {
  if ((this instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(this);
    var b = x2.s_util_Right__f_value;
    return new $c_s_Some(b)
  } else {
    return $m_s_None$()
  }
});
function $as_s_util_Either(obj) {
  return (((obj instanceof $c_s_util_Either) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Either"))
}
function $isArrayOf_s_util_Either(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either)))
}
function $asArrayOf_s_util_Either(obj, depth) {
  return (($isArrayOf_s_util_Either(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Either;", depth))
}
/** @constructor */
function $c_s_util_Try() {
  /*<skip>*/
}
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
  /*<skip>*/
}
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $as_s_util_Try(obj) {
  return (((obj instanceof $c_s_util_Try) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Try"))
}
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)))
}
function $asArrayOf_s_util_Try(obj, depth) {
  return (($isArrayOf_s_util_Try(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Try;", depth))
}
function $as_Lsnabbdom_Hooks(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Hooks"))
}
function $isArrayOf_Lsnabbdom_Hooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Hooks)))
}
function $asArrayOf_Lsnabbdom_Hooks(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Hooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Hooks;", depth))
}
/** @constructor */
function $c_Lsnabbdom_Module(pre, create, update, destroy, remove, post) {
  this.Lsnabbdom_Module__f_pre = null;
  this.Lsnabbdom_Module__f_create = null;
  this.Lsnabbdom_Module__f_update = null;
  this.Lsnabbdom_Module__f_destroy = null;
  this.Lsnabbdom_Module__f_remove = null;
  this.Lsnabbdom_Module__f_post = null;
  this.Lsnabbdom_Module__f_pre = pre;
  this.Lsnabbdom_Module__f_create = create;
  this.Lsnabbdom_Module__f_update = update;
  this.Lsnabbdom_Module__f_destroy = destroy;
  this.Lsnabbdom_Module__f_remove = remove;
  this.Lsnabbdom_Module__f_post = post
}
$c_Lsnabbdom_Module.prototype = new $h_O();
$c_Lsnabbdom_Module.prototype.constructor = $c_Lsnabbdom_Module;
/** @constructor */
function $h_Lsnabbdom_Module() {
  /*<skip>*/
}
$h_Lsnabbdom_Module.prototype = $c_Lsnabbdom_Module.prototype;
$c_Lsnabbdom_Module.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lsnabbdom_Module.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsnabbdom_Module.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lsnabbdom_Module)) {
    var x$0$2 = $as_Lsnabbdom_Module(x$0);
    var x = this.Lsnabbdom_Module__f_pre;
    var x$2 = x$0$2.Lsnabbdom_Module__f_pre;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_Module__f_create;
      var x$4 = x$0$2.Lsnabbdom_Module__f_create;
      var $$x4 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$5 = this.Lsnabbdom_Module__f_update;
      var x$6 = x$0$2.Lsnabbdom_Module__f_update;
      var $$x3 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$7 = this.Lsnabbdom_Module__f_destroy;
      var x$8 = x$0$2.Lsnabbdom_Module__f_destroy;
      var $$x2 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$9 = this.Lsnabbdom_Module__f_remove;
      var x$10 = x$0$2.Lsnabbdom_Module__f_remove;
      var $$x1 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lsnabbdom_Module__f_post;
      var x$12 = x$0$2.Lsnabbdom_Module__f_post;
      return ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lsnabbdom_Module.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsnabbdom_Module.prototype.productArity__I = (function() {
  return 6
});
$c_Lsnabbdom_Module.prototype.productPrefix__T = (function() {
  return "Module"
});
$c_Lsnabbdom_Module.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_Module__f_pre;
      break
    }
    case 1: {
      return this.Lsnabbdom_Module__f_create;
      break
    }
    case 2: {
      return this.Lsnabbdom_Module__f_update;
      break
    }
    case 3: {
      return this.Lsnabbdom_Module__f_destroy;
      break
    }
    case 4: {
      return this.Lsnabbdom_Module__f_remove;
      break
    }
    case 5: {
      return this.Lsnabbdom_Module__f_post;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lsnabbdom_Module(obj) {
  return (((obj instanceof $c_Lsnabbdom_Module) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.Module"))
}
function $isArrayOf_Lsnabbdom_Module(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_Module)))
}
function $asArrayOf_Lsnabbdom_Module(obj, depth) {
  return (($isArrayOf_Lsnabbdom_Module(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.Module;", depth))
}
var $d_Lsnabbdom_Module = new $TypeData().initClass({
  Lsnabbdom_Module: 0
}, false, "snabbdom.Module", {
  Lsnabbdom_Module: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lsnabbdom_Module.prototype.$classData = $d_Lsnabbdom_Module;
/** @constructor */
function $c_Lsnabbdom_ModuleHooks(create, update, remove, destroy, pre, post) {
  this.Lsnabbdom_ModuleHooks__f_create = null;
  this.Lsnabbdom_ModuleHooks__f_update = null;
  this.Lsnabbdom_ModuleHooks__f_remove = null;
  this.Lsnabbdom_ModuleHooks__f_destroy = null;
  this.Lsnabbdom_ModuleHooks__f_pre = null;
  this.Lsnabbdom_ModuleHooks__f_post = null;
  this.Lsnabbdom_ModuleHooks__f_create = create;
  this.Lsnabbdom_ModuleHooks__f_update = update;
  this.Lsnabbdom_ModuleHooks__f_remove = remove;
  this.Lsnabbdom_ModuleHooks__f_destroy = destroy;
  this.Lsnabbdom_ModuleHooks__f_pre = pre;
  this.Lsnabbdom_ModuleHooks__f_post = post
}
$c_Lsnabbdom_ModuleHooks.prototype = new $h_O();
$c_Lsnabbdom_ModuleHooks.prototype.constructor = $c_Lsnabbdom_ModuleHooks;
/** @constructor */
function $h_Lsnabbdom_ModuleHooks() {
  /*<skip>*/
}
$h_Lsnabbdom_ModuleHooks.prototype = $c_Lsnabbdom_ModuleHooks.prototype;
$c_Lsnabbdom_ModuleHooks.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lsnabbdom_ModuleHooks.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsnabbdom_ModuleHooks.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lsnabbdom_ModuleHooks)) {
    var x$0$2 = $as_Lsnabbdom_ModuleHooks(x$0);
    var x = this.Lsnabbdom_ModuleHooks__f_create;
    var x$2 = x$0$2.Lsnabbdom_ModuleHooks__f_create;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_ModuleHooks__f_update;
      var x$4 = x$0$2.Lsnabbdom_ModuleHooks__f_update;
      var $$x4 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$5 = this.Lsnabbdom_ModuleHooks__f_remove;
      var x$6 = x$0$2.Lsnabbdom_ModuleHooks__f_remove;
      var $$x3 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$7 = this.Lsnabbdom_ModuleHooks__f_destroy;
      var x$8 = x$0$2.Lsnabbdom_ModuleHooks__f_destroy;
      var $$x2 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$9 = this.Lsnabbdom_ModuleHooks__f_pre;
      var x$10 = x$0$2.Lsnabbdom_ModuleHooks__f_pre;
      var $$x1 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$11 = this.Lsnabbdom_ModuleHooks__f_post;
      var x$12 = x$0$2.Lsnabbdom_ModuleHooks__f_post;
      return ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lsnabbdom_ModuleHooks.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsnabbdom_ModuleHooks.prototype.productArity__I = (function() {
  return 6
});
$c_Lsnabbdom_ModuleHooks.prototype.productPrefix__T = (function() {
  return "ModuleHooks"
});
$c_Lsnabbdom_ModuleHooks.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_ModuleHooks__f_create;
      break
    }
    case 1: {
      return this.Lsnabbdom_ModuleHooks__f_update;
      break
    }
    case 2: {
      return this.Lsnabbdom_ModuleHooks__f_remove;
      break
    }
    case 3: {
      return this.Lsnabbdom_ModuleHooks__f_destroy;
      break
    }
    case 4: {
      return this.Lsnabbdom_ModuleHooks__f_pre;
      break
    }
    case 5: {
      return this.Lsnabbdom_ModuleHooks__f_post;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lsnabbdom_ModuleHooks(obj) {
  return (((obj instanceof $c_Lsnabbdom_ModuleHooks) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.ModuleHooks"))
}
function $isArrayOf_Lsnabbdom_ModuleHooks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_ModuleHooks)))
}
function $asArrayOf_Lsnabbdom_ModuleHooks(obj, depth) {
  return (($isArrayOf_Lsnabbdom_ModuleHooks(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.ModuleHooks;", depth))
}
var $d_Lsnabbdom_ModuleHooks = new $TypeData().initClass({
  Lsnabbdom_ModuleHooks: 0
}, false, "snabbdom.ModuleHooks", {
  Lsnabbdom_ModuleHooks: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lsnabbdom_ModuleHooks.prototype.$classData = $d_Lsnabbdom_ModuleHooks;
/** @constructor */
function $c_Lsnabbdom_VNodeData(props, attrs, classes, style, dataset, on, hook, key, ns, fn, args, is) {
  this.Lsnabbdom_VNodeData__f_props = null;
  this.Lsnabbdom_VNodeData__f_attrs = null;
  this.Lsnabbdom_VNodeData__f_classes = null;
  this.Lsnabbdom_VNodeData__f_style = null;
  this.Lsnabbdom_VNodeData__f_dataset = null;
  this.Lsnabbdom_VNodeData__f_on = null;
  this.Lsnabbdom_VNodeData__f_hook = null;
  this.Lsnabbdom_VNodeData__f_key = null;
  this.Lsnabbdom_VNodeData__f_ns = null;
  this.Lsnabbdom_VNodeData__f_fn = null;
  this.Lsnabbdom_VNodeData__f_args = null;
  this.Lsnabbdom_VNodeData__f_is = null;
  this.Lsnabbdom_VNodeData__f_props = props;
  this.Lsnabbdom_VNodeData__f_attrs = attrs;
  this.Lsnabbdom_VNodeData__f_classes = classes;
  this.Lsnabbdom_VNodeData__f_style = style;
  this.Lsnabbdom_VNodeData__f_dataset = dataset;
  this.Lsnabbdom_VNodeData__f_on = on;
  this.Lsnabbdom_VNodeData__f_hook = hook;
  this.Lsnabbdom_VNodeData__f_key = key;
  this.Lsnabbdom_VNodeData__f_ns = ns;
  this.Lsnabbdom_VNodeData__f_fn = fn;
  this.Lsnabbdom_VNodeData__f_args = args;
  this.Lsnabbdom_VNodeData__f_is = is
}
$c_Lsnabbdom_VNodeData.prototype = new $h_O();
$c_Lsnabbdom_VNodeData.prototype.constructor = $c_Lsnabbdom_VNodeData;
/** @constructor */
function $h_Lsnabbdom_VNodeData() {
  /*<skip>*/
}
$h_Lsnabbdom_VNodeData.prototype = $c_Lsnabbdom_VNodeData.prototype;
$c_Lsnabbdom_VNodeData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lsnabbdom_VNodeData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lsnabbdom_VNodeData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lsnabbdom_VNodeData)) {
    var x$0$2 = $as_Lsnabbdom_VNodeData(x$0);
    var x = this.Lsnabbdom_VNodeData__f_props;
    var x$2 = x$0$2.Lsnabbdom_VNodeData__f_props;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsnabbdom_VNodeData__f_attrs;
      var x$4 = x$0$2.Lsnabbdom_VNodeData__f_attrs;
      var $$x10 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x10 = false
    };
    if ($$x10) {
      var x$5 = this.Lsnabbdom_VNodeData__f_classes;
      var x$6 = x$0$2.Lsnabbdom_VNodeData__f_classes;
      var $$x9 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6))
    } else {
      var $$x9 = false
    };
    if ($$x9) {
      var x$7 = this.Lsnabbdom_VNodeData__f_style;
      var x$8 = x$0$2.Lsnabbdom_VNodeData__f_style;
      var $$x8 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8))
    } else {
      var $$x8 = false
    };
    if ($$x8) {
      var x$9 = this.Lsnabbdom_VNodeData__f_dataset;
      var x$10 = x$0$2.Lsnabbdom_VNodeData__f_dataset;
      var $$x7 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10))
    } else {
      var $$x7 = false
    };
    if ($$x7) {
      var x$11 = this.Lsnabbdom_VNodeData__f_on;
      var x$12 = x$0$2.Lsnabbdom_VNodeData__f_on;
      var $$x6 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12))
    } else {
      var $$x6 = false
    };
    if ($$x6) {
      var x$13 = this.Lsnabbdom_VNodeData__f_hook;
      var x$14 = x$0$2.Lsnabbdom_VNodeData__f_hook;
      var $$x5 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14))
    } else {
      var $$x5 = false
    };
    if ($$x5) {
      var x$15 = this.Lsnabbdom_VNodeData__f_key;
      var x$16 = x$0$2.Lsnabbdom_VNodeData__f_key;
      var $$x4 = ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16))
    } else {
      var $$x4 = false
    };
    if ($$x4) {
      var x$17 = this.Lsnabbdom_VNodeData__f_ns;
      var x$18 = x$0$2.Lsnabbdom_VNodeData__f_ns;
      var $$x3 = ((x$17 === null) ? (x$18 === null) : x$17.equals__O__Z(x$18))
    } else {
      var $$x3 = false
    };
    if ($$x3) {
      var x$19 = this.Lsnabbdom_VNodeData__f_fn;
      var x$20 = x$0$2.Lsnabbdom_VNodeData__f_fn;
      var $$x2 = ((x$19 === null) ? (x$20 === null) : x$19.equals__O__Z(x$20))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      var x$21 = this.Lsnabbdom_VNodeData__f_args;
      var x$22 = x$0$2.Lsnabbdom_VNodeData__f_args;
      var $$x1 = ((x$21 === null) ? (x$22 === null) : x$21.equals__O__Z(x$22))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$23 = this.Lsnabbdom_VNodeData__f_is;
      var x$24 = x$0$2.Lsnabbdom_VNodeData__f_is;
      return ((x$23 === null) ? (x$24 === null) : x$23.equals__O__Z(x$24))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lsnabbdom_VNodeData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lsnabbdom_VNodeData.prototype.productArity__I = (function() {
  return 12
});
$c_Lsnabbdom_VNodeData.prototype.productPrefix__T = (function() {
  return "VNodeData"
});
$c_Lsnabbdom_VNodeData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsnabbdom_VNodeData__f_props;
      break
    }
    case 1: {
      return this.Lsnabbdom_VNodeData__f_attrs;
      break
    }
    case 2: {
      return this.Lsnabbdom_VNodeData__f_classes;
      break
    }
    case 3: {
      return this.Lsnabbdom_VNodeData__f_style;
      break
    }
    case 4: {
      return this.Lsnabbdom_VNodeData__f_dataset;
      break
    }
    case 5: {
      return this.Lsnabbdom_VNodeData__f_on;
      break
    }
    case 6: {
      return this.Lsnabbdom_VNodeData__f_hook;
      break
    }
    case 7: {
      return this.Lsnabbdom_VNodeData__f_key;
      break
    }
    case 8: {
      return this.Lsnabbdom_VNodeData__f_ns;
      break
    }
    case 9: {
      return this.Lsnabbdom_VNodeData__f_fn;
      break
    }
    case 10: {
      return this.Lsnabbdom_VNodeData__f_args;
      break
    }
    case 11: {
      return this.Lsnabbdom_VNodeData__f_is;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lsnabbdom_VNodeData(obj) {
  return (((obj instanceof $c_Lsnabbdom_VNodeData) || (obj === null)) ? obj : $throwClassCastException(obj, "snabbdom.VNodeData"))
}
function $isArrayOf_Lsnabbdom_VNodeData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsnabbdom_VNodeData)))
}
function $asArrayOf_Lsnabbdom_VNodeData(obj, depth) {
  return (($isArrayOf_Lsnabbdom_VNodeData(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lsnabbdom.VNodeData;", depth))
}
var $d_Lsnabbdom_VNodeData = new $TypeData().initClass({
  Lsnabbdom_VNodeData: 0
}, false, "snabbdom.VNodeData", {
  Lsnabbdom_VNodeData: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lsnabbdom_VNodeData.prototype.$classData = $d_Lsnabbdom_VNodeData;
/** @constructor */
function $c_Ltyrian_Cmd$$anon$1() {
  /*<skip>*/
}
$c_Ltyrian_Cmd$$anon$1.prototype = new $h_O();
$c_Ltyrian_Cmd$$anon$1.prototype.constructor = $c_Ltyrian_Cmd$$anon$1;
/** @constructor */
function $h_Ltyrian_Cmd$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$$anon$1.prototype = $c_Ltyrian_Cmd$$anon$1.prototype;
$c_Ltyrian_Cmd$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Ltyrian_Cmd$$anon$1.prototype.empty__O = (function() {
  return $m_Ltyrian_Cmd$None$()
});
$c_Ltyrian_Cmd$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  var a = $as_Ltyrian_Cmd(x);
  var b = $as_Ltyrian_Cmd(y);
  return $m_Ltyrian_Cmd$().merge__Ltyrian_Cmd__Ltyrian_Cmd__Ltyrian_Cmd(a, b)
});
var $d_Ltyrian_Cmd$$anon$1 = new $TypeData().initClass({
  Ltyrian_Cmd$$anon$1: 0
}, false, "tyrian.Cmd$$anon$1", {
  Ltyrian_Cmd$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Ltyrian_Cmd$$anon$1.prototype.$classData = $d_Ltyrian_Cmd$$anon$1;
/** @constructor */
function $c_Ltyrian_runtime_SubHelper$CancelableSub(id, cancel, evidence$5) {
  this.Ltyrian_runtime_SubHelper$CancelableSub__f_id = null;
  this.Ltyrian_runtime_SubHelper$CancelableSub__f_cancel = null;
  this.Ltyrian_runtime_SubHelper$CancelableSub__f_id = id;
  this.Ltyrian_runtime_SubHelper$CancelableSub__f_cancel = cancel
}
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype = new $h_O();
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.constructor = $c_Ltyrian_runtime_SubHelper$CancelableSub;
/** @constructor */
function $h_Ltyrian_runtime_SubHelper$CancelableSub() {
  /*<skip>*/
}
$h_Ltyrian_runtime_SubHelper$CancelableSub.prototype = $c_Ltyrian_runtime_SubHelper$CancelableSub.prototype;
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_runtime_SubHelper$CancelableSub)) {
    var x$0$2 = $as_Ltyrian_runtime_SubHelper$CancelableSub(x$0);
    if ((this.Ltyrian_runtime_SubHelper$CancelableSub__f_id === x$0$2.Ltyrian_runtime_SubHelper$CancelableSub__f_id)) {
      var x = this.Ltyrian_runtime_SubHelper$CancelableSub__f_cancel;
      var y = x$0$2.Ltyrian_runtime_SubHelper$CancelableSub__f_cancel;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.productPrefix__T = (function() {
  return "CancelableSub"
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_runtime_SubHelper$CancelableSub__f_id
  };
  if ((n === 1)) {
    return this.Ltyrian_runtime_SubHelper$CancelableSub__f_cancel
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_runtime_SubHelper$CancelableSub(obj) {
  return (((obj instanceof $c_Ltyrian_runtime_SubHelper$CancelableSub) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.runtime.SubHelper$CancelableSub"))
}
function $isArrayOf_Ltyrian_runtime_SubHelper$CancelableSub(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_runtime_SubHelper$CancelableSub)))
}
function $asArrayOf_Ltyrian_runtime_SubHelper$CancelableSub(obj, depth) {
  return (($isArrayOf_Ltyrian_runtime_SubHelper$CancelableSub(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.runtime.SubHelper$CancelableSub;", depth))
}
var $d_Ltyrian_runtime_SubHelper$CancelableSub = new $TypeData().initClass({
  Ltyrian_runtime_SubHelper$CancelableSub: 0
}, false, "tyrian.runtime.SubHelper$CancelableSub", {
  Ltyrian_runtime_SubHelper$CancelableSub: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_SubHelper$CancelableSub.prototype.$classData = $d_Ltyrian_runtime_SubHelper$CancelableSub;
/** @constructor */
function $c_Lcats_Eval$Ident(ev) {
  this.Lcats_Eval$Ident__f_ev = null;
  this.Lcats_Eval$Ident__f_ev = ev
}
$c_Lcats_Eval$Ident.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Ident.prototype.constructor = $c_Lcats_Eval$Ident;
/** @constructor */
function $h_Lcats_Eval$Ident() {
  /*<skip>*/
}
$h_Lcats_Eval$Ident.prototype = $c_Lcats_Eval$Ident.prototype;
$c_Lcats_Eval$Ident.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Eval$Ident.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Eval$Ident.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Eval$Ident)) {
    var x$0$2 = $as_Lcats_Eval$Ident(x$0);
    var x = this.Lcats_Eval$Ident__f_ev;
    var x$2 = x$0$2.Lcats_Eval$Ident__f_ev;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lcats_Eval$Ident.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Eval$Ident.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Eval$Ident.prototype.productPrefix__T = (function() {
  return "Ident"
});
$c_Lcats_Eval$Ident.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Ident__f_ev
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_Eval$Ident(obj) {
  return (((obj instanceof $c_Lcats_Eval$Ident) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Ident"))
}
function $isArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Ident)))
}
function $asArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Ident(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Ident;", depth))
}
var $d_Lcats_Eval$Ident = new $TypeData().initClass({
  Lcats_Eval$Ident: 0
}, false, "cats.Eval$Ident", {
  Lcats_Eval$Ident: 1,
  Lcats_Eval$FnStack: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$Ident.prototype.$classData = $d_Lcats_Eval$Ident;
/** @constructor */
function $c_Lcats_Eval$Many(first, rest) {
  this.Lcats_Eval$Many__f_first = null;
  this.Lcats_Eval$Many__f_rest = null;
  this.Lcats_Eval$Many__f_first = first;
  this.Lcats_Eval$Many__f_rest = rest
}
$c_Lcats_Eval$Many.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Many.prototype.constructor = $c_Lcats_Eval$Many;
/** @constructor */
function $h_Lcats_Eval$Many() {
  /*<skip>*/
}
$h_Lcats_Eval$Many.prototype = $c_Lcats_Eval$Many.prototype;
$c_Lcats_Eval$Many.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Eval$Many.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Eval$Many.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Eval$Many)) {
    var x$0$2 = $as_Lcats_Eval$Many(x$0);
    var x = this.Lcats_Eval$Many__f_first;
    var x$2 = x$0$2.Lcats_Eval$Many__f_first;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_Eval$Many__f_rest;
      var x$4 = x$0$2.Lcats_Eval$Many__f_rest;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_Eval$Many.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Eval$Many.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_Eval$Many.prototype.productPrefix__T = (function() {
  return "Many"
});
$c_Lcats_Eval$Many.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Many__f_first
  };
  if ((n === 1)) {
    return this.Lcats_Eval$Many__f_rest
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_Eval$Many(obj) {
  return (((obj instanceof $c_Lcats_Eval$Many) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Many"))
}
function $isArrayOf_Lcats_Eval$Many(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Many)))
}
function $asArrayOf_Lcats_Eval$Many(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Many(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Many;", depth))
}
var $d_Lcats_Eval$Many = new $TypeData().initClass({
  Lcats_Eval$Many: 0
}, false, "cats.Eval$Many", {
  Lcats_Eval$Many: 1,
  Lcats_Eval$FnStack: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_Eval$Many.prototype.$classData = $d_Lcats_Eval$Many;
/** @constructor */
function $c_Lcats_Eval$Memoize(eval$1) {
  this.Lcats_Eval$Memoize__f_eval = null;
  this.Lcats_Eval$Memoize__f_result = null;
  this.Lcats_Eval$Memoize__f_eval = eval$1;
  this.Lcats_Eval$Memoize__f_result = $m_s_None$()
}
$c_Lcats_Eval$Memoize.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Memoize.prototype.constructor = $c_Lcats_Eval$Memoize;
/** @constructor */
function $h_Lcats_Eval$Memoize() {
  /*<skip>*/
}
$h_Lcats_Eval$Memoize.prototype = $c_Lcats_Eval$Memoize.prototype;
$c_Lcats_Eval$Memoize.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Eval$Memoize.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Eval$Memoize.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Eval$Memoize)) {
    var x$0$2 = $as_Lcats_Eval$Memoize(x$0);
    var x = this.Lcats_Eval$Memoize__f_eval;
    var x$2 = x$0$2.Lcats_Eval$Memoize__f_eval;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_Eval$Memoize.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Eval$Memoize.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Eval$Memoize.prototype.productPrefix__T = (function() {
  return "Memoize"
});
$c_Lcats_Eval$Memoize.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Memoize__f_eval
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_Eval$Memoize.prototype.memoize__Lcats_Eval = (function() {
  return this
});
$c_Lcats_Eval$Memoize.prototype.value__O = (function() {
  var x12 = this.Lcats_Eval$Memoize__f_result;
  if ((x12 instanceof $c_s_Some)) {
    var a = $as_s_Some(x12).s_Some__f_value;
    return a
  };
  var x = $m_s_None$();
  if ((x === x12)) {
    var a$2 = $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
    this.Lcats_Eval$Memoize__f_result = new $c_s_Some(a$2);
    return a$2
  };
  throw new $c_s_MatchError(x12)
});
function $as_Lcats_Eval$Memoize(obj) {
  return (((obj instanceof $c_Lcats_Eval$Memoize) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Eval$Memoize"))
}
function $isArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Memoize)))
}
function $asArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (($isArrayOf_Lcats_Eval$Memoize(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Eval$Memoize;", depth))
}
var $d_Lcats_Eval$Memoize = new $TypeData().initClass({
  Lcats_Eval$Memoize: 0
}, false, "cats.Eval$Memoize", {
  Lcats_Eval$Memoize: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lcats_Eval$Memoize.prototype.$classData = $d_Lcats_Eval$Memoize;
/** @constructor */
function $c_Lcats_Show$() {
  this.Lcats_Show$__f_catsContravariantForShow = null;
  $n_Lcats_Show$ = this;
  this.Lcats_Show$__f_catsContravariantForShow = new $c_Lcats_Show$$anon$1()
}
$c_Lcats_Show$.prototype = new $h_O();
$c_Lcats_Show$.prototype.constructor = $c_Lcats_Show$;
/** @constructor */
function $h_Lcats_Show$() {
  /*<skip>*/
}
$h_Lcats_Show$.prototype = $c_Lcats_Show$.prototype;
var $d_Lcats_Show$ = new $TypeData().initClass({
  Lcats_Show$: 0
}, false, "cats.Show$", {
  Lcats_Show$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificShowInstances: 1,
  Lcats_instances_NTupleShowInstances: 1,
  Lcats_ShowInstances0: 1,
  Lcats_ShowInstances: 1
});
$c_Lcats_Show$.prototype.$classData = $d_Lcats_Show$;
var $n_Lcats_Show$;
function $m_Lcats_Show$() {
  if ((!$n_Lcats_Show$)) {
    $n_Lcats_Show$ = new $c_Lcats_Show$()
  };
  return $n_Lcats_Show$
}
function $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval($thiz, as$1, f$10, G$1, width$1, start, end) {
  if ((((end - start) | 0) <= width$1)) {
    var flist = $m_Lcats_Eval$().later__F0__Lcats_Eval(new $c_sjsr_AnonFunction0(((as$1$2, f$10$2, G$1$2, end$2) => (() => G$1$2.map__O__F1__O(f$10$2.apply__O__O(as$1$2.apply__I__O((((-1) + end$2) | 0))), new $c_sjsr_AnonFunction1(((_$6) => {
      var this$3 = $m_s_package$().s_package$__f_Nil;
      return new $c_sci_$colon$colon(_$6, this$3)
    })))))(as$1, f$10, G$1, end)));
    var idx = (((-2) + end) | 0);
    while ((start <= idx)) {
      var a = as$1.apply__I__O(idx);
      var right = flist;
      $m_Lcats_Eval$();
      var a$1 = new $c_sjsr_AnonFunction0(((f$10$3, G$1$3, a$2, right$2) => (() => G$1$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$10$3.apply__O__O(a$2), right$2, new $c_sjsr_AnonFunction2(((_$7, _$8) => {
        var _$8$1 = $as_sci_List(_$8);
        return new $c_sci_$colon$colon(_$7, _$8$1)
      })))))(f$10, G$1, a, right));
      flist = new $c_Lcats_Eval$$anon$5(a$1);
      idx = (((-1) + idx) | 0)
    };
    return flist.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((G$1$4) => ((glist) => G$1$4.map__O__F1__O(glist, new $c_sjsr_AnonFunction1(((_$9) => {
      var _$9$1 = $as_sci_List(_$9);
      return $m_Lcats_data_Chain$().fromSeq__sci_Seq__Lcats_data_Chain(_$9$1)
    })))))(G$1)))
  } else {
    var step = $intDiv(((end - start) | 0), width$1);
    $m_Lcats_Eval$();
    var a$3 = new $c_sjsr_AnonFunction0(((this$4$1, as$1$3, f$10$4, G$1$5, width$1$2, start$2, step$2) => (() => $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this$4$1, as$1$3, f$10$4, G$1$5, width$1$2, start$2, ((start$2 + step$2) | 0))))($thiz, as$1, f$10, G$1, width$1, start, step));
    var fchain = new $c_Lcats_Eval$$anon$5(a$3);
    var start0 = ((start + step) | 0);
    var end0 = ((start0 + step) | 0);
    while ((start0 < end)) {
      var y = end0;
      var end1 = ((end < y) ? end : y);
      var right$3 = $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval($thiz, as$1, f$10, G$1, width$1, start0, end1);
      fchain = fchain.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((G$1$6, right$4) => ((_$10) => G$1$6.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(_$10, right$4, new $c_sjsr_AnonFunction2(((_$11, _$12) => {
        var _$11$1 = $as_Lcats_data_Chain(_$11);
        var _$12$1 = $as_Lcats_data_Chain(_$12);
        return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(_$11$1, _$12$1)
      })))))(G$1, right$3)));
      start0 = ((start0 + step) | 0);
      end0 = ((end0 + step) | 0)
    };
    return fchain
  }
}
/** @constructor */
function $c_Lcats_data_Chain$() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_ChainInstances__f_catsDataTraverseFilterForChain = null;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = null;
  this.Lcats_data_Chain$__f_nil = null;
  $ct_Lcats_data_ChainInstances__(this);
  $n_Lcats_data_Chain$ = this;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = new $c_Lcats_data_Chain$$anon$2();
  this.Lcats_data_Chain$__f_nil = $m_Lcats_data_Chain$Empty$()
}
$c_Lcats_data_Chain$.prototype = new $h_Lcats_data_ChainInstances();
$c_Lcats_data_Chain$.prototype.constructor = $c_Lcats_data_Chain$;
/** @constructor */
function $h_Lcats_data_Chain$() {
  /*<skip>*/
}
$h_Lcats_data_Chain$.prototype = $c_Lcats_data_Chain$.prototype;
$c_Lcats_data_Chain$.prototype.concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain = (function(c, c2) {
  if ((c instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var non = $as_Lcats_data_Chain$NonEmpty(c);
    if ((c2 instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var non2 = $as_Lcats_data_Chain$NonEmpty(c2);
      return new $c_Lcats_data_Chain$Append(non, non2)
    } else {
      return non
    }
  } else {
    return c2
  }
});
$c_Lcats_data_Chain$.prototype.fromSeq__sci_Seq__Lcats_data_Chain = (function(s) {
  if (s.isEmpty__Z()) {
    return this.Lcats_data_Chain$__f_nil
  } else if ((s.lengthCompare__I__I(1) === 0)) {
    var a = s.head__O();
    return new $c_Lcats_data_Chain$Singleton(a)
  } else {
    return new $c_Lcats_data_Chain$Wrap(s)
  }
});
$c_Lcats_data_Chain$.prototype.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O = (function(as, f, G) {
  return (as.isEmpty__Z() ? G.pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil) : $p_Lcats_data_Chain$__loop$1__sci_IndexedSeq__F1__Lcats_Applicative__I__I__I__Lcats_Eval(this, as, f, G, 128, 0, as.length__I()).value__O())
});
var $d_Lcats_data_Chain$ = new $TypeData().initClass({
  Lcats_data_Chain$: 0
}, false, "cats.data.Chain$", {
  Lcats_data_Chain$: 1,
  Lcats_data_ChainInstances: 1,
  Lcats_data_ChainInstances1: 1,
  Lcats_data_ChainInstances2: 1,
  Lcats_data_ChainInstances3: 1,
  O: 1
});
$c_Lcats_data_Chain$.prototype.$classData = $d_Lcats_data_Chain$;
var $n_Lcats_data_Chain$;
function $m_Lcats_data_Chain$() {
  if ((!$n_Lcats_data_Chain$)) {
    $n_Lcats_data_Chain$ = new $c_Lcats_data_Chain$()
  };
  return $n_Lcats_data_Chain$
}
/** @constructor */
function $c_Lcats_data_KleisliInstances5() {
  /*<skip>*/
}
$c_Lcats_data_KleisliInstances5.prototype = new $h_Lcats_data_KleisliInstances6();
$c_Lcats_data_KleisliInstances5.prototype.constructor = $c_Lcats_data_KleisliInstances5;
/** @constructor */
function $h_Lcats_data_KleisliInstances5() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances5.prototype = $c_Lcats_data_KleisliInstances5.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyList(head, tail) {
  this.Lcats_data_NonEmptyList__f_head = null;
  this.Lcats_data_NonEmptyList__f_tail = null;
  this.Lcats_data_NonEmptyList__f_head = head;
  this.Lcats_data_NonEmptyList__f_tail = tail
}
$c_Lcats_data_NonEmptyList.prototype = new $h_O();
$c_Lcats_data_NonEmptyList.prototype.constructor = $c_Lcats_data_NonEmptyList;
/** @constructor */
function $h_Lcats_data_NonEmptyList() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyList.prototype = $c_Lcats_data_NonEmptyList.prototype;
$c_Lcats_data_NonEmptyList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_NonEmptyList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_data_NonEmptyList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_data_NonEmptyList)) {
    var x$0$2 = $as_Lcats_data_NonEmptyList(x$0);
    var x = this.Lcats_data_NonEmptyList__f_head;
    var y = x$0$2.Lcats_data_NonEmptyList__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lcats_data_NonEmptyList__f_tail;
      var x$2 = x$0$2.Lcats_data_NonEmptyList__f_tail;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_data_NonEmptyList.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_NonEmptyList.prototype.productPrefix__T = (function() {
  return "NonEmptyList"
});
$c_Lcats_data_NonEmptyList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_NonEmptyList__f_head
  };
  if ((n === 1)) {
    return this.Lcats_data_NonEmptyList__f_tail
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_data_NonEmptyList.prototype.size__I = (function() {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  return ((1 + this$1.length__I()) | 0)
});
$c_Lcats_data_NonEmptyList.prototype.map__F1__Lcats_data_NonEmptyList = (function(f) {
  $m_Lcats_data_NonEmptyList$();
  var head = f.apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var tail = this.Lcats_data_NonEmptyList__f_tail.map__F1__sci_List(f);
  return new $c_Lcats_data_NonEmptyList(head, tail)
});
$c_Lcats_data_NonEmptyList.prototype.concat__sci_List__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var tail = other.$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail)
});
$c_Lcats_data_NonEmptyList.prototype.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var this$1 = other.Lcats_data_NonEmptyList__f_tail;
  var elem = other.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail)
});
$c_Lcats_data_NonEmptyList.prototype.flatMap__F1__Lcats_data_NonEmptyList = (function(f) {
  var this$5 = $as_Lcats_data_NonEmptyList(f.apply__O__O(this.Lcats_data_NonEmptyList__f_head));
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var arg1 = rest.head__O();
    var this$2 = $as_Lcats_data_NonEmptyList(f.apply__O__O(arg1));
    var this$3 = this$2.Lcats_data_NonEmptyList__f_tail;
    var elem = this$2.Lcats_data_NonEmptyList__f_head;
    var this$4 = new $c_sci_$colon$colon(elem, this$3);
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List(rest.tail__O())
  };
  var l = ((h === null) ? $m_sci_Nil$() : h);
  return this$5.concat__sci_List__Lcats_data_NonEmptyList(l)
});
$c_Lcats_data_NonEmptyList.prototype.prepend__O__Lcats_data_NonEmptyList = (function(a) {
  $m_Lcats_data_NonEmptyList$();
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1);
  return new $c_Lcats_data_NonEmptyList(a, tail)
});
$c_Lcats_data_NonEmptyList.prototype.foldLeft__O__F2__O = (function(b, f) {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var z = f.apply__O__O__O(b, this.Lcats_data_NonEmptyList__f_head);
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this$1, z, f)
});
$c_Lcats_data_NonEmptyList.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $m_Lcats_Foldable$();
  $m_Lcats_UnorderedFoldable$();
  var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
  var this$3 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return instance.foldRight__O__Lcats_Eval__F2__Lcats_Eval(new $c_sci_$colon$colon(elem, this$3), lb, f)
});
$c_Lcats_data_NonEmptyList.prototype.traverse__F1__Lcats_Applicative__O = (function(f, G) {
  return G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(this.Lcats_data_NonEmptyList__f_head), $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((this$1, f$2, G$2) => (() => {
    $m_Lcats_UnorderedFoldable$();
    var instance = $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList);
    return instance.traverse__O__F1__Lcats_Applicative__O(this$1.Lcats_data_NonEmptyList__f_tail, f$2, G$2)
  }))(this, f, G))), new $c_sjsr_AnonFunction2(((_$2, _$3) => {
    var _$3$1 = $as_sci_List(_$3);
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(_$2, _$3$1)
  }))).value__O()
});
$c_Lcats_data_NonEmptyList.prototype.toString__T = (function() {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return ("NonEmpty" + new $c_sci_$colon$colon(elem, this$1))
});
function $as_Lcats_data_NonEmptyList(obj) {
  return (((obj instanceof $c_Lcats_data_NonEmptyList) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.NonEmptyList"))
}
function $isArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyList)))
}
function $asArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (($isArrayOf_Lcats_data_NonEmptyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.NonEmptyList;", depth))
}
var $d_Lcats_data_NonEmptyList = new $TypeData().initClass({
  Lcats_data_NonEmptyList: 0
}, false, "cats.data.NonEmptyList", {
  Lcats_data_NonEmptyList: 1,
  O: 1,
  Lcats_data_NonEmptyCollection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_NonEmptyList.prototype.$classData = $d_Lcats_data_NonEmptyList;
/** @constructor */
function $c_Lcats_effect_IO$() {
  this.Lcats_effect_IO$__f__unit = null;
  this.Lcats_effect_IO$__f_semigroupKForIO = null;
  this.Lcats_effect_IO$__f__alignForIO = null;
  this.Lcats_effect_IO$__f__asyncForIO = null;
  this.Lcats_effect_IO$__f__parallelForIO = null;
  this.Lcats_effect_IO$__f_consoleForIO = null;
  this.Lcats_effect_IO$__f__never = null;
  $n_Lcats_effect_IO$ = this;
  this.Lcats_effect_IO$__f__unit = new $c_Lcats_effect_IO$Pure((void 0));
  this.Lcats_effect_IO$__f_semigroupKForIO = new $c_Lcats_effect_IO$IOSemigroupK();
  this.Lcats_effect_IO$__f__alignForIO = new $c_Lcats_effect_IO$$anon$1();
  this.Lcats_effect_IO$__f__asyncForIO = new $c_Lcats_effect_IO$$anon$2();
  var this$2 = $m_Lcats_effect_instances_package$spawn$();
  var M = this.Lcats_effect_IO$__f__asyncForIO;
  this.Lcats_effect_IO$__f__parallelForIO = new $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$1(M, this$2);
  var F = this.Lcats_effect_IO$__f__asyncForIO;
  this.Lcats_effect_IO$__f_consoleForIO = new $c_Lcats_effect_std_Console$SyncConsole(F);
  this.Lcats_effect_IO$__f__never = $as_Lcats_effect_IO(this.Lcats_effect_IO$__f__asyncForIO.never__O())
}
$c_Lcats_effect_IO$.prototype = new $h_Lcats_effect_IOCompanionPlatform();
$c_Lcats_effect_IO$.prototype.constructor = $c_Lcats_effect_IO$;
/** @constructor */
function $h_Lcats_effect_IO$() {
  /*<skip>*/
}
$h_Lcats_effect_IO$.prototype = $c_Lcats_effect_IO$.prototype;
$c_Lcats_effect_IO$.prototype.delay__F0__Lcats_effect_IO = (function(thunk) {
  var fn = $m_Lcats_effect_Thunk$().asFunction0__F0__F0(thunk);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F0__Lcats_effect_tracing_TracingEvent(fn);
  return new $c_Lcats_effect_IO$Delay(fn, event)
});
$c_Lcats_effect_IO$.prototype.defer__F0__Lcats_effect_IO = (function(thunk) {
  var this$2 = this.delay__F0__Lcats_effect_IO(thunk);
  var this$1 = $m_s_$less$colon$less$();
  var ev = this$1.s_$less$colon$less$__f_singleton;
  return this$2.flatMap__F1__Lcats_effect_IO(ev)
});
$c_Lcats_effect_IO$.prototype.async__F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$3(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event)
});
$c_Lcats_effect_IO$.prototype.async___F1__Lcats_effect_IO = (function(k) {
  var body = new $c_Lcats_effect_IO$$anon$4(k);
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(k);
  return new $c_Lcats_effect_IO$IOCont(body, event)
});
$c_Lcats_effect_IO$.prototype.cont__Lcats_effect_kernel_Cont__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__Lcats_effect_kernel_Cont__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$IOCont(body, event)
});
$c_Lcats_effect_IO$.prototype.uncancelable__F1__Lcats_effect_IO = (function(body) {
  var event = $m_Lcats_effect_tracing_Tracing$().calculateTracingEvent__F1__Lcats_effect_tracing_TracingEvent(body);
  return new $c_Lcats_effect_IO$Uncancelable(body, event)
});
$c_Lcats_effect_IO$.prototype.ref__O__Lcats_effect_IO = (function(a) {
  var this$2 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0(((this$1, a$2) => (() => $m_Lcats_effect_package$().Lcats_effect_package$__f_Ref.unsafe__O__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Ref(a$2, this$1.Lcats_effect_IO$__f__asyncForIO)))(this, a));
  return this$2.delay__F0__Lcats_effect_IO(thunk)
});
$c_Lcats_effect_IO$.prototype.deferred__Lcats_effect_IO = (function() {
  var this$3 = $m_Lcats_effect_IO$();
  var thunk = new $c_sjsr_AnonFunction0(((this$1) => (() => {
    $m_Lcats_effect_package$();
    var evidence$1 = this$1.Lcats_effect_IO$__f__asyncForIO;
    return new $c_Lcats_effect_kernel_Deferred$AsyncDeferred(evidence$1)
  }))(this));
  return this$3.delay__F0__Lcats_effect_IO(thunk)
});
$c_Lcats_effect_IO$.prototype.bracketFull__F1__F1__F2__Lcats_effect_IO = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((acquire$2, use$2, release$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return $as_Lcats_effect_IO(acquire$2.apply__O__O(poll$1)).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((use$1$2, release$2$2, poll$2) => ((a) => $m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0(((use$2$2, poll$4$2, a$2) => (() => $as_Lcats_effect_IO(poll$4$2.apply__O__O(use$2$2.apply__O__O(a$2)))))(use$1$2, poll$2, a))).guaranteeCase__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((release$3$2, a$3) => ((_$35) => {
      var _$35$1 = $as_Lcats_effect_kernel_Outcome(_$35);
      return $as_Lcats_effect_IO(release$3$2.apply__O__O__O(a$3, _$35$1))
    }))(release$2$2, a)))))(use$2, release$2, poll$1)))
  }))(acquire, use, release)))
});
function $as_Lcats_effect_IO$(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$"))
}
function $isArrayOf_Lcats_effect_IO$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$)))
}
function $asArrayOf_Lcats_effect_IO$(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$;", depth))
}
var $d_Lcats_effect_IO$ = new $TypeData().initClass({
  Lcats_effect_IO$: 0
}, false, "cats.effect.IO$", {
  Lcats_effect_IO$: 1,
  Lcats_effect_IOCompanionPlatform: 1,
  O: 1,
  Lcats_effect_IOLowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_effect_IO$.prototype.$classData = $d_Lcats_effect_IO$;
var $n_Lcats_effect_IO$;
function $m_Lcats_effect_IO$() {
  if ((!$n_Lcats_effect_IO$)) {
    $n_Lcats_effect_IO$ = new $c_Lcats_effect_IO$()
  };
  return $n_Lcats_effect_IO$
}
/** @constructor */
function $c_Lcats_effect_SyncIO$() {
  this.Lcats_effect_SyncIO$__f_Delay = null;
  this.Lcats_effect_SyncIO$__f_monotonic = null;
  this.Lcats_effect_SyncIO$__f_realTime = null;
  this.Lcats_effect_SyncIO$__f__unit = null;
  this.Lcats_effect_SyncIO$__f__alignForSyncIO = null;
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = null;
  $n_Lcats_effect_SyncIO$ = this;
  this.Lcats_effect_SyncIO$__f_Delay = ($m_Lcats_effect_package$(), $m_Lcats_effect_kernel_Sync$Type$Delay$());
  this.Lcats_effect_SyncIO$__f_monotonic = $m_Lcats_effect_SyncIO$Monotonic$();
  this.Lcats_effect_SyncIO$__f_realTime = $m_Lcats_effect_SyncIO$RealTime$();
  this.Lcats_effect_SyncIO$__f__unit = new $c_Lcats_effect_SyncIO$Pure((void 0));
  this.Lcats_effect_SyncIO$__f__alignForSyncIO = new $c_Lcats_effect_SyncIO$$anon$1();
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = new $c_Lcats_effect_SyncIO$$anon$2()
}
$c_Lcats_effect_SyncIO$.prototype = new $h_O();
$c_Lcats_effect_SyncIO$.prototype.constructor = $c_Lcats_effect_SyncIO$;
/** @constructor */
function $h_Lcats_effect_SyncIO$() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$.prototype = $c_Lcats_effect_SyncIO$.prototype;
var $d_Lcats_effect_SyncIO$ = new $TypeData().initClass({
  Lcats_effect_SyncIO$: 0
}, false, "cats.effect.SyncIO$", {
  Lcats_effect_SyncIO$: 1,
  O: 1,
  Lcats_effect_SyncIOCompanionPlatform: 1,
  Lcats_effect_SyncIOLowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_effect_SyncIO$.prototype.$classData = $d_Lcats_effect_SyncIO$;
var $n_Lcats_effect_SyncIO$;
function $m_Lcats_effect_SyncIO$() {
  if ((!$n_Lcats_effect_SyncIO$)) {
    $n_Lcats_effect_SyncIO$ = new $c_Lcats_effect_SyncIO$()
  };
  return $n_Lcats_effect_SyncIO$
}
/** @constructor */
function $c_Lcats_effect_SyncIO$Attempt(ioa) {
  this.Lcats_effect_SyncIO$Attempt__f_ioa = null;
  this.Lcats_effect_SyncIO$Attempt__f_ioa = ioa
}
$c_Lcats_effect_SyncIO$Attempt.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Attempt.prototype.constructor = $c_Lcats_effect_SyncIO$Attempt;
/** @constructor */
function $h_Lcats_effect_SyncIO$Attempt() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Attempt.prototype = $c_Lcats_effect_SyncIO$Attempt.prototype;
$c_Lcats_effect_SyncIO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Attempt)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Attempt(x$0);
    var x = this.Lcats_effect_SyncIO$Attempt__f_ioa;
    var x$2 = x$0$2.Lcats_effect_SyncIO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt"
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Attempt__f_ioa
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Attempt.prototype.tag__B = (function() {
  return 8
});
function $as_Lcats_effect_SyncIO$Attempt(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Attempt) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Attempt"))
}
function $isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Attempt)))
}
function $asArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Attempt;", depth))
}
var $d_Lcats_effect_SyncIO$Attempt = new $TypeData().initClass({
  Lcats_effect_SyncIO$Attempt: 0
}, false, "cats.effect.SyncIO$Attempt", {
  Lcats_effect_SyncIO$Attempt: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$Attempt.prototype.$classData = $d_Lcats_effect_SyncIO$Attempt;
/** @constructor */
function $c_Lcats_effect_SyncIO$Error(t) {
  this.Lcats_effect_SyncIO$Error__f_t = null;
  this.Lcats_effect_SyncIO$Error__f_t = t
}
$c_Lcats_effect_SyncIO$Error.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Error.prototype.constructor = $c_Lcats_effect_SyncIO$Error;
/** @constructor */
function $h_Lcats_effect_SyncIO$Error() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Error.prototype = $c_Lcats_effect_SyncIO$Error.prototype;
$c_Lcats_effect_SyncIO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Error)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Error(x$0);
    var x = this.Lcats_effect_SyncIO$Error__f_t;
    var x$2 = x$0$2.Lcats_effect_SyncIO$Error__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$Error.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_SyncIO$Error.prototype.productPrefix__T = (function() {
  return "Error"
});
$c_Lcats_effect_SyncIO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Error__f_t
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Error.prototype.tag__B = (function() {
  return 2
});
function $as_Lcats_effect_SyncIO$Error(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Error"))
}
function $isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Error)))
}
function $asArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Error;", depth))
}
var $d_Lcats_effect_SyncIO$Error = new $TypeData().initClass({
  Lcats_effect_SyncIO$Error: 0
}, false, "cats.effect.SyncIO$Error", {
  Lcats_effect_SyncIO$Error: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$Error.prototype.$classData = $d_Lcats_effect_SyncIO$Error;
/** @constructor */
function $c_Lcats_effect_SyncIO$Failure(t) {
  this.Lcats_effect_SyncIO$Failure__f_t = null;
  this.Lcats_effect_SyncIO$Failure__f_t = t
}
$c_Lcats_effect_SyncIO$Failure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Failure.prototype.constructor = $c_Lcats_effect_SyncIO$Failure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Failure() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Failure.prototype = $c_Lcats_effect_SyncIO$Failure.prototype;
$c_Lcats_effect_SyncIO$Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$Failure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Failure)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Failure(x$0);
    var x = this.Lcats_effect_SyncIO$Failure__f_t;
    var x$2 = x$0$2.Lcats_effect_SyncIO$Failure__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$Failure.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_SyncIO$Failure.prototype.productPrefix__T = (function() {
  return "Failure"
});
$c_Lcats_effect_SyncIO$Failure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Failure__f_t
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Failure.prototype.tag__B = (function() {
  return 7
});
function $as_Lcats_effect_SyncIO$Failure(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Failure"))
}
function $isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Failure)))
}
function $asArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Failure;", depth))
}
var $d_Lcats_effect_SyncIO$Failure = new $TypeData().initClass({
  Lcats_effect_SyncIO$Failure: 0
}, false, "cats.effect.SyncIO$Failure", {
  Lcats_effect_SyncIO$Failure: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$Failure.prototype.$classData = $d_Lcats_effect_SyncIO$Failure;
/** @constructor */
function $c_Lcats_effect_SyncIO$FlatMap(ioe, f) {
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = null;
  this.Lcats_effect_SyncIO$FlatMap__f_f = null;
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_SyncIO$FlatMap__f_f = f
}
$c_Lcats_effect_SyncIO$FlatMap.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$FlatMap.prototype.constructor = $c_Lcats_effect_SyncIO$FlatMap;
/** @constructor */
function $h_Lcats_effect_SyncIO$FlatMap() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$FlatMap.prototype = $c_Lcats_effect_SyncIO$FlatMap.prototype;
$c_Lcats_effect_SyncIO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$FlatMap)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$FlatMap(x$0);
    var x = this.Lcats_effect_SyncIO$FlatMap__f_ioe;
    var x$2 = x$0$2.Lcats_effect_SyncIO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$FlatMap__f_f;
      var x$4 = x$0$2.Lcats_effect_SyncIO$FlatMap__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap"
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_ioe
  };
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_f
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.tag__B = (function() {
  return 4
});
function $as_Lcats_effect_SyncIO$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$FlatMap"))
}
function $isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$FlatMap)))
}
function $asArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$FlatMap;", depth))
}
var $d_Lcats_effect_SyncIO$FlatMap = new $TypeData().initClass({
  Lcats_effect_SyncIO$FlatMap: 0
}, false, "cats.effect.SyncIO$FlatMap", {
  Lcats_effect_SyncIO$FlatMap: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.$classData = $d_Lcats_effect_SyncIO$FlatMap;
/** @constructor */
function $c_Lcats_effect_SyncIO$HandleErrorWith(ioa, f) {
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = f
}
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_SyncIO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_SyncIO$HandleErrorWith() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$HandleErrorWith.prototype = $c_Lcats_effect_SyncIO$HandleErrorWith.prototype;
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$HandleErrorWith)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$HandleErrorWith(x$0);
    var x = this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    var x$2 = x$0$2.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
      var x$4 = x$0$2.Lcats_effect_SyncIO$HandleErrorWith__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith"
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa
  };
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_f
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.tag__B = (function() {
  return 5
});
function $as_Lcats_effect_SyncIO$HandleErrorWith(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$HandleErrorWith) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$HandleErrorWith"))
}
function $isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$HandleErrorWith)))
}
function $asArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$HandleErrorWith;", depth))
}
var $d_Lcats_effect_SyncIO$HandleErrorWith = new $TypeData().initClass({
  Lcats_effect_SyncIO$HandleErrorWith: 0
}, false, "cats.effect.SyncIO$HandleErrorWith", {
  Lcats_effect_SyncIO$HandleErrorWith: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.$classData = $d_Lcats_effect_SyncIO$HandleErrorWith;
function $as_Lcats_effect_SyncIO$Map(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Map"))
}
function $isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Map)))
}
function $asArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Map;", depth))
}
/** @constructor */
function $c_Lcats_effect_SyncIO$Pure(value) {
  this.Lcats_effect_SyncIO$Pure__f_value = null;
  this.Lcats_effect_SyncIO$Pure__f_value = value
}
$c_Lcats_effect_SyncIO$Pure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Pure.prototype.constructor = $c_Lcats_effect_SyncIO$Pure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Pure() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Pure.prototype = $c_Lcats_effect_SyncIO$Pure.prototype;
$c_Lcats_effect_SyncIO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Pure)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Pure(x$0);
    var x = this.Lcats_effect_SyncIO$Pure__f_value;
    var y = x$0$2.Lcats_effect_SyncIO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$Pure.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_SyncIO$Pure.prototype.productPrefix__T = (function() {
  return "Pure"
});
$c_Lcats_effect_SyncIO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Pure__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Pure.prototype.tag__B = (function() {
  return 0
});
$c_Lcats_effect_SyncIO$Pure.prototype.toString__T = (function() {
  return (("SyncIO(" + this.Lcats_effect_SyncIO$Pure__f_value) + ")")
});
function $as_Lcats_effect_SyncIO$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Pure"))
}
function $isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Pure)))
}
function $asArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Pure;", depth))
}
var $d_Lcats_effect_SyncIO$Pure = new $TypeData().initClass({
  Lcats_effect_SyncIO$Pure: 0
}, false, "cats.effect.SyncIO$Pure", {
  Lcats_effect_SyncIO$Pure: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$Pure.prototype.$classData = $d_Lcats_effect_SyncIO$Pure;
/** @constructor */
function $c_Lcats_effect_SyncIO$Success(value) {
  this.Lcats_effect_SyncIO$Success__f_value = null;
  this.Lcats_effect_SyncIO$Success__f_value = value
}
$c_Lcats_effect_SyncIO$Success.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Success.prototype.constructor = $c_Lcats_effect_SyncIO$Success;
/** @constructor */
function $h_Lcats_effect_SyncIO$Success() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Success.prototype = $c_Lcats_effect_SyncIO$Success.prototype;
$c_Lcats_effect_SyncIO$Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$Success.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Success)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Success(x$0);
    var x = this.Lcats_effect_SyncIO$Success__f_value;
    var y = x$0$2.Lcats_effect_SyncIO$Success__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$Success.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_SyncIO$Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_Lcats_effect_SyncIO$Success.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Success__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Success.prototype.tag__B = (function() {
  return 6
});
function $as_Lcats_effect_SyncIO$Success(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Success) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Success"))
}
function $isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Success)))
}
function $asArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Success;", depth))
}
var $d_Lcats_effect_SyncIO$Success = new $TypeData().initClass({
  Lcats_effect_SyncIO$Success: 0
}, false, "cats.effect.SyncIO$Success", {
  Lcats_effect_SyncIO$Success: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$Success.prototype.$classData = $d_Lcats_effect_SyncIO$Success;
/** @constructor */
function $c_Lcats_effect_SyncIO$Suspend(hint, thunk) {
  this.Lcats_effect_SyncIO$Suspend__f_hint = null;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = null;
  this.Lcats_effect_SyncIO$Suspend__f_hint = hint;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = thunk
}
$c_Lcats_effect_SyncIO$Suspend.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Suspend.prototype.constructor = $c_Lcats_effect_SyncIO$Suspend;
/** @constructor */
function $h_Lcats_effect_SyncIO$Suspend() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Suspend.prototype = $c_Lcats_effect_SyncIO$Suspend.prototype;
$c_Lcats_effect_SyncIO$Suspend.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Suspend.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_SyncIO$Suspend.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Suspend)) {
    var x$0$2 = $as_Lcats_effect_SyncIO$Suspend(x$0);
    var x = this.Lcats_effect_SyncIO$Suspend__f_hint;
    var x$2 = x$0$2.Lcats_effect_SyncIO$Suspend__f_hint;
    if ((x === x$2)) {
      var x$3 = this.Lcats_effect_SyncIO$Suspend__f_thunk;
      var x$4 = x$0$2.Lcats_effect_SyncIO$Suspend__f_thunk;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productPrefix__T = (function() {
  return "Suspend"
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Suspend__f_hint
  };
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$Suspend__f_thunk
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Suspend.prototype.tag__B = (function() {
  return 1
});
function $as_Lcats_effect_SyncIO$Suspend(obj) {
  return (((obj instanceof $c_Lcats_effect_SyncIO$Suspend) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.SyncIO$Suspend"))
}
function $isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Suspend)))
}
function $asArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (($isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.SyncIO$Suspend;", depth))
}
var $d_Lcats_effect_SyncIO$Suspend = new $TypeData().initClass({
  Lcats_effect_SyncIO$Suspend: 0
}, false, "cats.effect.SyncIO$Suspend", {
  Lcats_effect_SyncIO$Suspend: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_SyncIO$Suspend.prototype.$classData = $d_Lcats_effect_SyncIO$Suspend;
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$State$Set(a) {
  this.Lcats_effect_kernel_Deferred$State$Set__f_a = null;
  this.Lcats_effect_kernel_Deferred$State$Set__f_a = a
}
$c_Lcats_effect_kernel_Deferred$State$Set.prototype = new $h_Lcats_effect_kernel_Deferred$State();
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.constructor = $c_Lcats_effect_kernel_Deferred$State$Set;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$State$Set() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$State$Set.prototype = $c_Lcats_effect_kernel_Deferred$State$Set.prototype;
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Deferred$State$Set)) {
    var x$0$2 = $as_Lcats_effect_kernel_Deferred$State$Set(x$0);
    var x = this.Lcats_effect_kernel_Deferred$State$Set__f_a;
    var y = x$0$2.Lcats_effect_kernel_Deferred$State$Set__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.productPrefix__T = (function() {
  return "Set"
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Deferred$State$Set__f_a
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Deferred$State$Set(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Deferred$State$Set) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Deferred$State$Set"))
}
function $isArrayOf_Lcats_effect_kernel_Deferred$State$Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Deferred$State$Set)))
}
function $asArrayOf_Lcats_effect_kernel_Deferred$State$Set(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Deferred$State$Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Deferred$State$Set;", depth))
}
var $d_Lcats_effect_kernel_Deferred$State$Set = new $TypeData().initClass({
  Lcats_effect_kernel_Deferred$State$Set: 0
}, false, "cats.effect.kernel.Deferred$State$Set", {
  Lcats_effect_kernel_Deferred$State$Set: 1,
  Lcats_effect_kernel_Deferred$State: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Deferred$State$Set.prototype.$classData = $d_Lcats_effect_kernel_Deferred$State$Set;
/** @constructor */
function $c_Lcats_effect_kernel_Deferred$State$Unset(readers, nextId) {
  this.Lcats_effect_kernel_Deferred$State$Unset__f_readers = null;
  this.Lcats_effect_kernel_Deferred$State$Unset__f_nextId = $L0;
  this.Lcats_effect_kernel_Deferred$State$Unset__f_readers = readers;
  this.Lcats_effect_kernel_Deferred$State$Unset__f_nextId = nextId
}
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype = new $h_Lcats_effect_kernel_Deferred$State();
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.constructor = $c_Lcats_effect_kernel_Deferred$State$Unset;
/** @constructor */
function $h_Lcats_effect_kernel_Deferred$State$Unset() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Deferred$State$Unset.prototype = $c_Lcats_effect_kernel_Deferred$State$Unset.prototype;
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Unset");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_kernel_Deferred$State$Unset__f_readers;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Deferred$State$Unset)) {
    var x$0$2 = $as_Lcats_effect_kernel_Deferred$State$Unset(x$0);
    var this$1 = this.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
    var b = x$0$2.Lcats_effect_kernel_Deferred$State$Unset__f_nextId;
    if (((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lcats_effect_kernel_Deferred$State$Unset__f_readers;
      var x$2 = x$0$2.Lcats_effect_kernel_Deferred$State$Unset__f_readers;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.productPrefix__T = (function() {
  return "Unset"
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Deferred$State$Unset__f_readers
  };
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Deferred$State$Unset__f_nextId
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Deferred$State$Unset(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Deferred$State$Unset) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Deferred$State$Unset"))
}
function $isArrayOf_Lcats_effect_kernel_Deferred$State$Unset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Deferred$State$Unset)))
}
function $asArrayOf_Lcats_effect_kernel_Deferred$State$Unset(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Deferred$State$Unset(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Deferred$State$Unset;", depth))
}
var $d_Lcats_effect_kernel_Deferred$State$Unset = new $TypeData().initClass({
  Lcats_effect_kernel_Deferred$State$Unset: 0
}, false, "cats.effect.kernel.Deferred$State$Unset", {
  Lcats_effect_kernel_Deferred$State$Unset: 1,
  Lcats_effect_kernel_Deferred$State: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Deferred$State$Unset.prototype.$classData = $d_Lcats_effect_kernel_Deferred$State$Unset;
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin$18, outer) {
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$1 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$1 = fin$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = outer
}
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return true
});
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer.handleError__O__F1__O(this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$1.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x)), new $c_sjsr_AnonFunction1(((_$3) => (void 0))))
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_MonadCancel$$anon$1: 0
}, false, "cats.effect.kernel.MonadCancel$$anon$1", {
  Lcats_effect_kernel_MonadCancel$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_MonadCancel$$anon$1;
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Canceled() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Outcome$Canceled.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Canceled;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Canceled() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Outcome$Canceled.prototype = $c_Lcats_effect_kernel_Outcome$Canceled.prototype;
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$0), true)))
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productPrefix__T = (function() {
  return "Canceled"
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Outcome$Canceled(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Canceled) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Canceled"))
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Canceled)))
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Canceled;", depth))
}
var $d_Lcats_effect_kernel_Outcome$Canceled = new $TypeData().initClass({
  Lcats_effect_kernel_Outcome$Canceled: 0
}, false, "cats.effect.kernel.Outcome$Canceled", {
  Lcats_effect_kernel_Outcome$Canceled: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.$classData = $d_Lcats_effect_kernel_Outcome$Canceled;
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Errored(e) {
  this.Lcats_effect_kernel_Outcome$Errored__f_e = null;
  this.Lcats_effect_kernel_Outcome$Errored__f_e = e
}
$c_Lcats_effect_kernel_Outcome$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Errored.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Errored() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Outcome$Errored.prototype = $c_Lcats_effect_kernel_Outcome$Errored.prototype;
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x$0$2 = $as_Lcats_effect_kernel_Outcome$Errored(x$0);
    var x = this.Lcats_effect_kernel_Outcome$Errored__f_e;
    var y = x$0$2.Lcats_effect_kernel_Outcome$Errored__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productPrefix__T = (function() {
  return "Errored"
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Errored__f_e
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Outcome$Errored(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Errored) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Errored"))
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Errored)))
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Errored;", depth))
}
var $d_Lcats_effect_kernel_Outcome$Errored = new $TypeData().initClass({
  Lcats_effect_kernel_Outcome$Errored: 0
}, false, "cats.effect.kernel.Outcome$Errored", {
  Lcats_effect_kernel_Outcome$Errored: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.$classData = $d_Lcats_effect_kernel_Outcome$Errored;
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Succeeded(fa) {
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = null;
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = fa
}
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Succeeded;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Succeeded() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Outcome$Succeeded.prototype = $c_Lcats_effect_kernel_Outcome$Succeeded.prototype;
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x$0$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$0);
    var x = this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    var y = x$0$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded"
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Succeeded__f_fa
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Outcome$Succeeded(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Outcome$Succeeded) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Outcome$Succeeded"))
}
function $isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Succeeded)))
}
function $asArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Outcome$Succeeded;", depth))
}
var $d_Lcats_effect_kernel_Outcome$Succeeded = new $TypeData().initClass({
  Lcats_effect_kernel_Outcome$Succeeded: 0
}, false, "cats.effect.kernel.Outcome$Succeeded", {
  Lcats_effect_kernel_Outcome$Succeeded: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.$classData = $d_Lcats_effect_kernel_Outcome$Succeeded;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$$anon$3(F$72, rel$4) {
  this.Lcats_effect_kernel_Resource$$anon$3__f_F$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$3__f_rel$1 = null;
  this.Lcats_effect_kernel_Resource$$anon$3__f_F$1 = F$72;
  this.Lcats_effect_kernel_Resource$$anon$3__f_rel$1 = rel$4
}
$c_Lcats_effect_kernel_Resource$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_Resource$$anon$3.prototype.constructor = $c_Lcats_effect_kernel_Resource$$anon$3;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$$anon$3() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$$anon$3.prototype = $c_Lcats_effect_kernel_Resource$$anon$3.prototype;
$c_Lcats_effect_kernel_Resource$$anon$3.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true
});
$c_Lcats_effect_kernel_Resource$$anon$3.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  var fa = this.Lcats_effect_kernel_Resource$$anon$3__f_rel$1.apply__O__O(new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(x));
  var f = new $c_sjsr_AnonFunction1(((_$18) => {
    $as_jl_Throwable(_$18)
  }));
  var F$1 = this.Lcats_effect_kernel_Resource$$anon$3__f_F$1;
  return F$1.handleError__O__F1__O(fa, f)
});
$c_Lcats_effect_kernel_Resource$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcats_effect_kernel_Resource$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcats_effect_kernel_Resource$$anon$3 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$$anon$3: 0
}, false, "cats.effect.kernel.Resource$$anon$3", {
  Lcats_effect_kernel_Resource$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$$anon$3.prototype.$classData = $d_Lcats_effect_kernel_Resource$$anon$3;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Allocate(resource) {
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = null;
  this.Lcats_effect_kernel_Resource$Allocate__f_resource = resource
}
$c_Lcats_effect_kernel_Resource$Allocate.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Allocate.prototype.constructor = $c_Lcats_effect_kernel_Resource$Allocate;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Allocate() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Allocate.prototype = $c_Lcats_effect_kernel_Resource$Allocate.prototype;
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Allocate)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Allocate(x$0);
    var x = this.Lcats_effect_kernel_Resource$Allocate__f_resource;
    var x$2 = x$0$2.Lcats_effect_kernel_Resource$Allocate__f_resource;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productPrefix__T = (function() {
  return "Allocate"
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Allocate__f_resource
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Allocate(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Allocate) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Allocate"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Allocate)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Allocate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Allocate;", depth))
}
var $d_Lcats_effect_kernel_Resource$Allocate = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Allocate: 0
}, false, "cats.effect.kernel.Resource$Allocate", {
  Lcats_effect_kernel_Resource$Allocate: 1,
  Lcats_effect_kernel_Resource: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$Allocate.prototype.$classData = $d_Lcats_effect_kernel_Resource$Allocate;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Bind(source, fs) {
  this.Lcats_effect_kernel_Resource$Bind__f_source = null;
  this.Lcats_effect_kernel_Resource$Bind__f_fs = null;
  this.Lcats_effect_kernel_Resource$Bind__f_source = source;
  this.Lcats_effect_kernel_Resource$Bind__f_fs = fs
}
$c_Lcats_effect_kernel_Resource$Bind.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Bind.prototype.constructor = $c_Lcats_effect_kernel_Resource$Bind;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Bind() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Bind.prototype = $c_Lcats_effect_kernel_Resource$Bind.prototype;
$c_Lcats_effect_kernel_Resource$Bind.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Bind)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Bind(x$0);
    var x = this.Lcats_effect_kernel_Resource$Bind__f_source;
    var x$2 = x$0$2.Lcats_effect_kernel_Resource$Bind__f_source;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Bind__f_fs;
      var x$4 = x$0$2.Lcats_effect_kernel_Resource$Bind__f_fs;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productPrefix__T = (function() {
  return "Bind"
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Bind__f_source
  };
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Bind__f_fs
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Bind(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Bind) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Bind"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Bind)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Bind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Bind;", depth))
}
var $d_Lcats_effect_kernel_Resource$Bind = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Bind: 0
}, false, "cats.effect.kernel.Resource$Bind", {
  Lcats_effect_kernel_Resource$Bind: 1,
  Lcats_effect_kernel_Resource: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$Bind.prototype.$classData = $d_Lcats_effect_kernel_Resource$Bind;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Eval(fa) {
  this.Lcats_effect_kernel_Resource$Eval__f_fa = null;
  this.Lcats_effect_kernel_Resource$Eval__f_fa = fa
}
$c_Lcats_effect_kernel_Resource$Eval.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Eval.prototype.constructor = $c_Lcats_effect_kernel_Resource$Eval;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Eval() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Eval.prototype = $c_Lcats_effect_kernel_Resource$Eval.prototype;
$c_Lcats_effect_kernel_Resource$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Eval)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Eval(x$0);
    var x = this.Lcats_effect_kernel_Resource$Eval__f_fa;
    var y = x$0$2.Lcats_effect_kernel_Resource$Eval__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productPrefix__T = (function() {
  return "Eval"
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Eval__f_fa
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Eval(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Eval"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Eval)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Eval;", depth))
}
var $d_Lcats_effect_kernel_Resource$Eval = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Eval: 0
}, false, "cats.effect.kernel.Resource$Eval", {
  Lcats_effect_kernel_Resource$Eval: 1,
  Lcats_effect_kernel_Resource: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$Eval.prototype.$classData = $d_Lcats_effect_kernel_Resource$Eval;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e) {
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = null;
  this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e = e
}
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Errored() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$ExitCase$Errored(x$0);
    var x = this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    var x$2 = x$0$2.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productPrefix__T = (function() {
  return "Errored"
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$ExitCase$Errored__f_e
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$ExitCase$Errored(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$ExitCase$Errored) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$ExitCase$Errored"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$ExitCase$Errored)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$ExitCase$Errored(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$ExitCase$Errored;", depth))
}
var $d_Lcats_effect_kernel_Resource$ExitCase$Errored = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$ExitCase$Errored: 0
}, false, "cats.effect.kernel.Resource$ExitCase$Errored", {
  Lcats_effect_kernel_Resource$ExitCase$Errored: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1
});
$c_Lcats_effect_kernel_Resource$ExitCase$Errored.prototype.$classData = $d_Lcats_effect_kernel_Resource$ExitCase$Errored;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$1(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_$outer = null;
  this.Lcats_effect_kernel_Resource$Frame$1__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$1__f_tail = tail;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$Frame$1__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$Frame$1.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$1;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Frame$1.prototype = $c_Lcats_effect_kernel_Resource$Frame$1.prototype;
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$1)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Frame$1(x$0);
    var x = this.Lcats_effect_kernel_Resource$Frame$1__f_head;
    var x$2 = x$0$2.Lcats_effect_kernel_Resource$Frame$1__f_head;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$1__f_tail;
      var x$4 = x$0$2.Lcats_effect_kernel_Resource$Frame$1__f_tail;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productPrefix__T = (function() {
  return "Frame"
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_head
  };
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$1__f_tail
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Frame$1(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$1"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$1)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$1;", depth))
}
var $d_Lcats_effect_kernel_Resource$Frame$1 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Frame$1: 0
}, false, "cats.effect.kernel.Resource$Frame$1", {
  Lcats_effect_kernel_Resource$Frame$1: 1,
  O: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$Frame$1.prototype.$classData = $d_Lcats_effect_kernel_Resource$Frame$1;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Frame$3(outer, head, tail) {
  this.Lcats_effect_kernel_Resource$Frame$3__f_head = null;
  this.Lcats_effect_kernel_Resource$Frame$3__f_tail = null;
  this.Lcats_effect_kernel_Resource$Frame$3__f_$outer = null;
  this.Lcats_effect_kernel_Resource$Frame$3__f_head = head;
  this.Lcats_effect_kernel_Resource$Frame$3__f_tail = tail;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_kernel_Resource$Frame$3__f_$outer = outer
}
$c_Lcats_effect_kernel_Resource$Frame$3.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.constructor = $c_Lcats_effect_kernel_Resource$Frame$3;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Frame$3() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Frame$3.prototype = $c_Lcats_effect_kernel_Resource$Frame$3.prototype;
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Frame$3)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Frame$3(x$0);
    var x = this.Lcats_effect_kernel_Resource$Frame$3__f_head;
    var x$2 = x$0$2.Lcats_effect_kernel_Resource$Frame$3__f_head;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_kernel_Resource$Frame$3__f_tail;
      var x$4 = x$0$2.Lcats_effect_kernel_Resource$Frame$3__f_tail;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.productPrefix__T = (function() {
  return "Frame"
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Frame$3__f_head
  };
  if ((n === 1)) {
    return this.Lcats_effect_kernel_Resource$Frame$3__f_tail
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Frame$3(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Frame$3) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Frame$3"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Frame$3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Frame$3)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Frame$3(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Frame$3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Frame$3;", depth))
}
var $d_Lcats_effect_kernel_Resource$Frame$3 = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Frame$3: 0
}, false, "cats.effect.kernel.Resource$Frame$3", {
  Lcats_effect_kernel_Resource$Frame$3: 1,
  O: 1,
  Lcats_effect_kernel_Resource$Stack$2: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$Frame$3.prototype.$classData = $d_Lcats_effect_kernel_Resource$Frame$3;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Pure(a) {
  this.Lcats_effect_kernel_Resource$Pure__f_a = null;
  this.Lcats_effect_kernel_Resource$Pure__f_a = a
}
$c_Lcats_effect_kernel_Resource$Pure.prototype = new $h_Lcats_effect_kernel_Resource();
$c_Lcats_effect_kernel_Resource$Pure.prototype.constructor = $c_Lcats_effect_kernel_Resource$Pure;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Pure() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Pure.prototype = $c_Lcats_effect_kernel_Resource$Pure.prototype;
$c_Lcats_effect_kernel_Resource$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Resource$Pure)) {
    var x$0$2 = $as_Lcats_effect_kernel_Resource$Pure(x$0);
    var x = this.Lcats_effect_kernel_Resource$Pure__f_a;
    var y = x$0$2.Lcats_effect_kernel_Resource$Pure__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productPrefix__T = (function() {
  return "Pure"
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Resource$Pure__f_a
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Pure"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Pure)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Pure;", depth))
}
var $d_Lcats_effect_kernel_Resource$Pure = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Pure: 0
}, false, "cats.effect.kernel.Resource$Pure", {
  Lcats_effect_kernel_Resource$Pure: 1,
  Lcats_effect_kernel_Resource: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_kernel_Resource$Pure.prototype.$classData = $d_Lcats_effect_kernel_Resource$Pure;
/** @constructor */
function $c_Lcats_effect_process$$anon$1() {
  /*<skip>*/
}
$c_Lcats_effect_process$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_process$$anon$1.prototype.constructor = $c_Lcats_effect_process$$anon$1;
/** @constructor */
function $h_Lcats_effect_process$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_process$$anon$1.prototype = $c_Lcats_effect_process$$anon$1.prototype;
$c_Lcats_effect_process$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  if (((typeof x) === "string")) {
    var v = $as_T(x);
    if ((v !== (void 0))) {
      return true
    }
  };
  return false
});
$c_Lcats_effect_process$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  if (((typeof x) === "string")) {
    var v = $as_T(x);
    if ((v !== (void 0))) {
      return v
    }
  };
  return default$1.apply__O__O(x)
});
var $d_Lcats_effect_process$$anon$1 = new $TypeData().initClass({
  Lcats_effect_process$$anon$1: 0
}, false, "cats.effect.process$$anon$1", {
  Lcats_effect_process$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_process$$anon$1.prototype.$classData = $d_Lcats_effect_process$$anon$1;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1(promise$5, outer) {
  this.Lcats_effect_std_Dispatcher$$anon$2$$anon$1__f_promise$1 = null;
  this.Lcats_effect_std_Dispatcher$$anon$2$$anon$1__f_$outer = null;
  this.Lcats_effect_std_Dispatcher$$anon$2$$anon$1__f_promise$1 = promise$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  this.Lcats_effect_std_Dispatcher$$anon$2$$anon$1__f_$outer = outer
}
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype.constructor = $c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$$anon$2$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype = $c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype;
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true
});
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  return this.Lcats_effect_std_Dispatcher$$anon$2$$anon$1__f_$outer.Lcats_effect_std_Dispatcher$$anon$2__f_cats$effect$std$Dispatcher$$anon$2$$F$1.delay__F0__O(new $c_sjsr_AnonFunction0(((this$1, t$2) => (() => {
    var this$2 = this$1.Lcats_effect_std_Dispatcher$$anon$2$$anon$1__f_promise$1;
    $f_s_concurrent_Promise__failure__jl_Throwable__s_concurrent_Promise(this$2, t$2)
  }))(this, x)))
});
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcats_effect_std_Dispatcher$$anon$2$$anon$1 = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$$anon$2$$anon$1: 0
}, false, "cats.effect.std.Dispatcher$$anon$2$$anon$1", {
  Lcats_effect_std_Dispatcher$$anon$2$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_std_Dispatcher$$anon$2$$anon$1.prototype.$classData = $d_Lcats_effect_std_Dispatcher$$anon$2$$anon$1;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$CancelToken$1(cancelToken) {
  this.Lcats_effect_std_Dispatcher$CancelToken$1__f_cancelToken = null;
  this.Lcats_effect_std_Dispatcher$CancelToken$1__f_cancelToken = cancelToken
}
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.constructor = $c_Lcats_effect_std_Dispatcher$CancelToken$1;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$CancelToken$1() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$CancelToken$1.prototype = $c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype;
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$CancelToken$1)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$CancelToken$1(x$0);
    var x = this.Lcats_effect_std_Dispatcher$CancelToken$1__f_cancelToken;
    var x$2 = x$0$2.Lcats_effect_std_Dispatcher$CancelToken$1__f_cancelToken;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.productPrefix__T = (function() {
  return "CancelToken"
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$CancelToken$1__f_cancelToken
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_std_Dispatcher$CancelToken$1(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$CancelToken$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$CancelToken$1"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$CancelToken$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$CancelToken$1)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$CancelToken$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$CancelToken$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$CancelToken$1;", depth))
}
var $d_Lcats_effect_std_Dispatcher$CancelToken$1 = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$CancelToken$1: 0
}, false, "cats.effect.std.Dispatcher$CancelToken$1", {
  Lcats_effect_std_Dispatcher$CancelToken$1: 1,
  O: 1,
  Lcats_effect_std_Dispatcher$CancelState$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_std_Dispatcher$CancelToken$1.prototype.$classData = $d_Lcats_effect_std_Dispatcher$CancelToken$1;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1(promise) {
  this.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise = null;
  this.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise = promise
}
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.constructor = $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$CanceledNoToken$1() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype = $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype;
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$CanceledNoToken$1(x$0);
    var x = this.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise;
    var x$2 = x$0$2.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.productPrefix__T = (function() {
  return "CanceledNoToken"
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$CanceledNoToken$1__f_promise
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_std_Dispatcher$CanceledNoToken$1(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$CanceledNoToken$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$CanceledNoToken$1"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$CanceledNoToken$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$CanceledNoToken$1)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$CanceledNoToken$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$CanceledNoToken$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$CanceledNoToken$1;", depth))
}
var $d_Lcats_effect_std_Dispatcher$CanceledNoToken$1 = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$CanceledNoToken$1: 0
}, false, "cats.effect.std.Dispatcher$CanceledNoToken$1", {
  Lcats_effect_std_Dispatcher$CanceledNoToken$1: 1,
  O: 1,
  Lcats_effect_std_Dispatcher$CancelState$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_std_Dispatcher$CanceledNoToken$1.prototype.$classData = $d_Lcats_effect_std_Dispatcher$CanceledNoToken$1;
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$Registration$1(action, prepareCancel) {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.Lcats_effect_std_Dispatcher$Registration$1__f_action = null;
  this.Lcats_effect_std_Dispatcher$Registration$1__f_prepareCancel = null;
  this.Lcats_effect_std_Dispatcher$Registration$1__f_action = action;
  this.Lcats_effect_std_Dispatcher$Registration$1__f_prepareCancel = prepareCancel;
  $ct_ju_concurrent_atomic_AtomicBoolean__Z__(this, true)
}
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype = new $h_ju_concurrent_atomic_AtomicBoolean();
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.constructor = $c_Lcats_effect_std_Dispatcher$Registration$1;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$Registration$1() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$Registration$1.prototype = $c_Lcats_effect_std_Dispatcher$Registration$1.prototype;
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_std_Dispatcher$Registration$1)) {
    var x$0$2 = $as_Lcats_effect_std_Dispatcher$Registration$1(x$0);
    var x = this.Lcats_effect_std_Dispatcher$Registration$1__f_action;
    var y = x$0$2.Lcats_effect_std_Dispatcher$Registration$1__f_action;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lcats_effect_std_Dispatcher$Registration$1__f_prepareCancel;
      var x$2 = x$0$2.Lcats_effect_std_Dispatcher$Registration$1__f_prepareCancel;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.productPrefix__T = (function() {
  return "Registration"
});
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_std_Dispatcher$Registration$1__f_action
  };
  if ((n === 1)) {
    return this.Lcats_effect_std_Dispatcher$Registration$1__f_prepareCancel
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_std_Dispatcher$Registration$1(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$Registration$1) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$Registration$1"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$Registration$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$Registration$1)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$Registration$1(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$Registration$1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$Registration$1;", depth))
}
var $d_Lcats_effect_std_Dispatcher$Registration$1 = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$Registration$1: 0
}, false, "cats.effect.std.Dispatcher$Registration$1", {
  Lcats_effect_std_Dispatcher$Registration$1: 1,
  ju_concurrent_atomic_AtomicBoolean: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lcats_effect_std_Dispatcher$Registration$1.prototype.$classData = $d_Lcats_effect_std_Dispatcher$Registration$1;
/** @constructor */
function $c_Lcats_effect_std_Queue$BoundedQueue(capacity, state, F) {
  this.Lcats_effect_std_Queue$AbstractQueue__f_capacity = 0;
  this.Lcats_effect_std_Queue$AbstractQueue__f_state = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_F = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_take = null;
  this.Lcats_effect_std_Queue$AbstractQueue__f_tryTake = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_state = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_F = null;
  this.Lcats_effect_std_Queue$BoundedQueue__f_state = state;
  this.Lcats_effect_std_Queue$BoundedQueue__f_F = F;
  $ct_Lcats_effect_std_Queue$AbstractQueue__I__Lcats_effect_kernel_Ref__Lcats_effect_kernel_GenConcurrent__(this, capacity, state, F)
}
$c_Lcats_effect_std_Queue$BoundedQueue.prototype = new $h_Lcats_effect_std_Queue$AbstractQueue();
$c_Lcats_effect_std_Queue$BoundedQueue.prototype.constructor = $c_Lcats_effect_std_Queue$BoundedQueue;
/** @constructor */
function $h_Lcats_effect_std_Queue$BoundedQueue() {
  /*<skip>*/
}
$h_Lcats_effect_std_Queue$BoundedQueue.prototype = $c_Lcats_effect_std_Queue$BoundedQueue.prototype;
$c_Lcats_effect_std_Queue$BoundedQueue.prototype.onOfferNoCapacity__Lcats_effect_std_Queue$State__O__Lcats_effect_kernel_Deferred__Lcats_effect_kernel_Poll__T2 = (function(s, a, offerer, poll) {
  matchResult15: {
    var \u03b411$___1;
    var \u03b411$___2;
    var \u03b411$___3;
    var \u03b411$___4;
    if ((s !== null)) {
      var x100 = s.Lcats_effect_std_Queue$State__f_queue;
      var x101 = s.Lcats_effect_std_Queue$State__f_size;
      var x102 = s.Lcats_effect_std_Queue$State__f_takers;
      var x103 = s.Lcats_effect_std_Queue$State__f_offerers;
      var \u03b411$___1 = x100;
      var \u03b411$___2 = x101;
      var \u03b411$___3 = x102;
      var \u03b411$___4 = x103;
      break matchResult15
    };
    throw new $c_s_MatchError(s)
  };
  var queue$2 = $as_sci_Queue(\u03b411$___1);
  var size$2 = $uI(\u03b411$___2);
  var takers$2 = $as_sci_Queue(\u03b411$___3);
  var offerers$2 = $as_sci_Queue(\u03b411$___4);
  var cleanup = this.Lcats_effect_std_Queue$BoundedQueue__f_state.update__F1__O(new $c_sjsr_AnonFunction1(((offerer$2) => ((s$2) => {
    var s$1 = $as_Lcats_effect_std_Queue$State(s$2);
    var this$4 = s$1.Lcats_effect_std_Queue$State__f_offerers;
    var b = $m_sci_Queue$().newBuilder__scm_Builder();
    var it = this$4.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var _$15 = $as_T2(elem);
      if (((_$15._2__O() !== offerer$2) !== false)) {
        b.addOne__O__scm_Growable(elem)
      }
    };
    var offerers$2$1 = $as_sci_Queue(b.result__O());
    var queue$2$1 = s$1.Lcats_effect_std_Queue$State__f_queue;
    var size$2$1 = s$1.Lcats_effect_std_Queue$State__f_size;
    var takers$2$1 = s$1.Lcats_effect_std_Queue$State__f_takers;
    return new $c_Lcats_effect_std_Queue$State(queue$2$1, size$2$1, takers$2$1, offerers$2$1)
  }))(offerer)));
  var offerers = offerers$2.enqueue__O__sci_Queue(new $c_T2(a, offerer));
  var self = new $c_Lcats_effect_std_Queue$State(queue$2, size$2, takers$2, offerers);
  var wrapped = poll.apply__O__O(offerer.get__O());
  var F = this.Lcats_effect_std_Queue$BoundedQueue__f_F;
  var y = F.onCancel__O__O__O(wrapped, cleanup);
  return new $c_T2(self, y)
});
var $d_Lcats_effect_std_Queue$BoundedQueue = new $TypeData().initClass({
  Lcats_effect_std_Queue$BoundedQueue: 0
}, false, "cats.effect.std.Queue$BoundedQueue", {
  Lcats_effect_std_Queue$BoundedQueue: 1,
  Lcats_effect_std_Queue$AbstractQueue: 1,
  Lcats_effect_std_Queue: 1,
  O: 1,
  Lcats_effect_std_QueueSource: 1,
  Lcats_effect_std_QueueSink: 1
});
$c_Lcats_effect_std_Queue$BoundedQueue.prototype.$classData = $d_Lcats_effect_std_Queue$BoundedQueue;
/** @constructor */
function $c_Lcats_effect_tracing_Tracing$$anon$1() {
  /*<skip>*/
}
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.constructor = $c_Lcats_effect_tracing_Tracing$$anon$1;
/** @constructor */
function $h_Lcats_effect_tracing_Tracing$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_tracing_Tracing$$anon$1.prototype = $c_Lcats_effect_tracing_Tracing$$anon$1.prototype;
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z = (function(x) {
  return ((x instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace) && ($as_Lcats_effect_tracing_TracingEvent$StackTrace(x), true))
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lcats_effect_tracing_TracingEvent$StackTrace)) {
    var ev = $as_Lcats_effect_tracing_TracingEvent$StackTrace(x);
    return $m_Lcats_effect_tracing_Tracing$().cats$effect$tracing$Tracing$$$getOpAndCallSite__Ajl_StackTraceElement__jl_StackTraceElement(ev.getStackTrace__Ajl_StackTraceElement())
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lcats_effect_tracing_TracingEvent__Z($as_Lcats_effect_tracing_TracingEvent(x))
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lcats_effect_tracing_TracingEvent__F1__O($as_Lcats_effect_tracing_TracingEvent(x), default$1)
});
var $d_Lcats_effect_tracing_Tracing$$anon$1 = new $TypeData().initClass({
  Lcats_effect_tracing_Tracing$$anon$1: 0
}, false, "cats.effect.tracing.Tracing$$anon$1", {
  Lcats_effect_tracing_Tracing$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_tracing_Tracing$$anon$1.prototype.$classData = $d_Lcats_effect_tracing_Tracing$$anon$1;
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$1.prototype = $c_Lcats_instances_EitherInstances$$anon$1.prototype;
var $d_Lcats_instances_EitherInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$1: 0
}, false, "cats.instances.EitherInstances$$anon$1", {
  Lcats_instances_EitherInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifoldable: 1,
  Lcats_Bifunctor: 1,
  Lcats_Bitraverse: 1
});
$c_Lcats_instances_EitherInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Monoid(fa);
  var fb$1 = $as_Lcats_kernel_Monoid(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$8(fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$3 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$3", {
  Lcats_instances_InvariantMonoidalInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$3.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$3;
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$5() {
  /*<skip>*/
}
$c_Lcats_instances_LazyListInstances$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$5;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$5() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$5.prototype = $c_Lcats_instances_LazyListInstances$$anon$5.prototype;
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return ((x instanceof $c_s_Some) && ($as_s_Some(x), true))
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var v = $as_s_Some(x).s_Some__f_value;
    return v
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x))
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1)
});
var $d_Lcats_instances_LazyListInstances$$anon$5 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$5: 0
}, false, "cats.instances.LazyListInstances$$anon$5", {
  Lcats_instances_LazyListInstances$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_LazyListInstances$$anon$5.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$5;
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$2(fa$2, fb$2) {
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderInstances$$anon$2__f_fa$1 = fa$2;
  this.Lcats_instances_OrderInstances$$anon$2__f_fb$1 = fb$2
}
$c_Lcats_instances_OrderInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_OrderInstances$$anon$2.prototype = $c_Lcats_instances_OrderInstances$$anon$2.prototype;
$c_Lcats_instances_OrderInstances$$anon$2.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = this.Lcats_instances_OrderInstances$$anon$2__f_fa$1.compare__O__O__I(x._1__O(), y._1__O());
  return ((z === 0) ? this.Lcats_instances_OrderInstances$$anon$2__f_fb$1.compare__O__O__I(x._2__O(), y._2__O()) : z)
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_OrderInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_OrderInstances$$anon$2: 0
}, false, "cats.instances.OrderInstances$$anon$2", {
  Lcats_instances_OrderInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
});
$c_Lcats_instances_OrderInstances$$anon$2.prototype.$classData = $d_Lcats_instances_OrderInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_TryCoflatMap() {
  /*<skip>*/
}
$c_Lcats_instances_TryCoflatMap.prototype = new $h_O();
$c_Lcats_instances_TryCoflatMap.prototype.constructor = $c_Lcats_instances_TryCoflatMap;
/** @constructor */
function $h_Lcats_instances_TryCoflatMap() {
  /*<skip>*/
}
$h_Lcats_instances_TryCoflatMap.prototype = $c_Lcats_instances_TryCoflatMap.prototype;
$c_Lcats_instances_TryCoflatMap.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
/** @constructor */
function $c_Lcats_instances_TryInstances$$anon$4(f$7) {
  this.Lcats_instances_TryInstances$$anon$4__f_f$1 = null;
  this.Lcats_instances_TryInstances$$anon$4__f_f$1 = f$7
}
$c_Lcats_instances_TryInstances$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_instances_TryInstances$$anon$4.prototype.constructor = $c_Lcats_instances_TryInstances$$anon$4;
/** @constructor */
function $h_Lcats_instances_TryInstances$$anon$4() {
  /*<skip>*/
}
$h_Lcats_instances_TryInstances$$anon$4.prototype = $c_Lcats_instances_TryInstances$$anon$4.prototype;
$c_Lcats_instances_TryInstances$$anon$4.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  return this.Lcats_instances_TryInstances$$anon$4__f_f$1.apply__O__O(x)
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z($as_jl_Throwable(x))
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O($as_jl_Throwable(x), default$1)
});
var $d_Lcats_instances_TryInstances$$anon$4 = new $TypeData().initClass({
  Lcats_instances_TryInstances$$anon$4: 0
}, false, "cats.instances.TryInstances$$anon$4", {
  Lcats_instances_TryInstances$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_instances_TryInstances$$anon$4.prototype.$classData = $d_Lcats_instances_TryInstances$$anon$4;
/** @constructor */
function $c_Lcats_instances_Tuple2Instances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Tuple2Instances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Tuple2Instances$$anon$1.prototype.constructor = $c_Lcats_instances_Tuple2Instances$$anon$1;
/** @constructor */
function $h_Lcats_instances_Tuple2Instances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Tuple2Instances$$anon$1.prototype = $c_Lcats_instances_Tuple2Instances$$anon$1.prototype;
var $d_Lcats_instances_Tuple2Instances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Tuple2Instances$$anon$1: 0
}, false, "cats.instances.Tuple2Instances$$anon$1", {
  Lcats_instances_Tuple2Instances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Bifoldable: 1,
  Lcats_Bifunctor: 1,
  Lcats_Bitraverse: 1
});
$c_Lcats_instances_Tuple2Instances$$anon$1.prototype.$classData = $d_Lcats_instances_Tuple2Instances$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$either$() {
  this.Lcats_instances_package$either$__f_catsStdBitraverseForEither = null;
  $n_Lcats_instances_package$either$ = this;
  this.Lcats_instances_package$either$__f_catsStdBitraverseForEither = new $c_Lcats_instances_EitherInstances$$anon$1()
}
$c_Lcats_instances_package$either$.prototype = new $h_O();
$c_Lcats_instances_package$either$.prototype.constructor = $c_Lcats_instances_package$either$;
/** @constructor */
function $h_Lcats_instances_package$either$() {
  /*<skip>*/
}
$h_Lcats_instances_package$either$.prototype = $c_Lcats_instances_package$either$.prototype;
var $d_Lcats_instances_package$either$ = new $TypeData().initClass({
  Lcats_instances_package$either$: 0
}, false, "cats.instances.package$either$", {
  Lcats_instances_package$either$: 1,
  O: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1
});
$c_Lcats_instances_package$either$.prototype.$classData = $d_Lcats_instances_package$either$;
var $n_Lcats_instances_package$either$;
function $m_Lcats_instances_package$either$() {
  if ((!$n_Lcats_instances_package$either$)) {
    $n_Lcats_instances_package$either$ = new $c_Lcats_instances_package$either$()
  };
  return $n_Lcats_instances_package$either$
}
/** @constructor */
function $c_Lcats_instances_package$queue$() {
  this.Lcats_instances_package$queue$__f_catsStdInstancesForQueue = null;
  $n_Lcats_instances_package$queue$ = this;
  this.Lcats_instances_package$queue$__f_catsStdInstancesForQueue = new $c_Lcats_instances_QueueInstances$$anon$1()
}
$c_Lcats_instances_package$queue$.prototype = new $h_O();
$c_Lcats_instances_package$queue$.prototype.constructor = $c_Lcats_instances_package$queue$;
/** @constructor */
function $h_Lcats_instances_package$queue$() {
  /*<skip>*/
}
$h_Lcats_instances_package$queue$.prototype = $c_Lcats_instances_package$queue$.prototype;
var $d_Lcats_instances_package$queue$ = new $TypeData().initClass({
  Lcats_instances_package$queue$: 0
}, false, "cats.instances.package$queue$", {
  Lcats_instances_package$queue$: 1,
  O: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1
});
$c_Lcats_instances_package$queue$.prototype.$classData = $d_Lcats_instances_package$queue$;
var $n_Lcats_instances_package$queue$;
function $m_Lcats_instances_package$queue$() {
  if ((!$n_Lcats_instances_package$queue$)) {
    $n_Lcats_instances_package$queue$ = new $c_Lcats_instances_package$queue$()
  };
  return $n_Lcats_instances_package$queue$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$$anon$1() {
  /*<skip>*/
}
$c_Lcats_kernel_Comparison$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Comparison$$anon$1.prototype.constructor = $c_Lcats_kernel_Comparison$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Comparison$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$$anon$1.prototype = $c_Lcats_kernel_Comparison$$anon$1.prototype;
$c_Lcats_kernel_Comparison$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.eqv__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.combine__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Lcats_kernel_Comparison = (function(x, y) {
  var x$2 = $m_Lcats_kernel_Comparison$EqualTo$();
  if ((x$2 === x)) {
    return y
  } else {
    return x
  }
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Z($as_Lcats_kernel_Comparison(x), $as_Lcats_kernel_Comparison(y))
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.empty__O = (function() {
  return $m_Lcats_kernel_Comparison$EqualTo$()
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_kernel_Comparison__Lcats_kernel_Comparison__Lcats_kernel_Comparison($as_Lcats_kernel_Comparison(x), $as_Lcats_kernel_Comparison(y))
});
var $d_Lcats_kernel_Comparison$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_Comparison$$anon$1: 0
}, false, "cats.kernel.Comparison$$anon$1", {
  Lcats_kernel_Comparison$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
});
$c_Lcats_kernel_Comparison$$anon$1.prototype.$classData = $d_Lcats_kernel_Comparison$$anon$1;
/** @constructor */
function $c_Lcats_kernel_Order$() {
  /*<skip>*/
}
$c_Lcats_kernel_Order$.prototype = new $h_Lcats_kernel_OrderFunctions();
$c_Lcats_kernel_Order$.prototype.constructor = $c_Lcats_kernel_Order$;
/** @constructor */
function $h_Lcats_kernel_Order$() {
  /*<skip>*/
}
$h_Lcats_kernel_Order$.prototype = $c_Lcats_kernel_Order$.prototype;
var $d_Lcats_kernel_Order$ = new $TypeData().initClass({
  Lcats_kernel_Order$: 0
}, false, "cats.kernel.Order$", {
  Lcats_kernel_Order$: 1,
  Lcats_kernel_OrderFunctions: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_OrderToOrderingConversion: 1
});
$c_Lcats_kernel_Order$.prototype.$classData = $d_Lcats_kernel_Order$;
var $n_Lcats_kernel_Order$;
function $m_Lcats_kernel_Order$() {
  if ((!$n_Lcats_kernel_Order$)) {
    $n_Lcats_kernel_Order$ = new $c_Lcats_kernel_Order$()
  };
  return $n_Lcats_kernel_Order$
}
/** @constructor */
function $c_Lcats_kernel_instances_BitSetPartialOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.constructor = $c_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetPartialOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BitSetPartialOrder.prototype = $c_Lcats_kernel_instances_BitSetPartialOrder.prototype;
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__sci_BitSet__sci_BitSet__D = (function(x, y) {
  return ((x === y) ? 0.0 : (($f_sc_BitSetOps__size__I(x) < $f_sc_BitSetOps__size__I(y)) ? ($f_sc_IterableOnceOps__forall__F1__Z(x, y) ? (-1.0) : (NaN)) : (($f_sc_BitSetOps__size__I(y) < $f_sc_BitSetOps__size__I(x)) ? ($f_sc_IterableOnceOps__forall__F1__Z(y, x) ? 1.0 : (NaN)) : (((x === null) ? (y === null) : $f_sc_SortedSet__equals__O__Z(x, y)) ? 0.0 : (NaN)))))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__sci_BitSet__sci_BitSet__Z = (function(x, y) {
  return ((x === null) ? (y === null) : $f_sc_SortedSet__equals__O__Z(x, y))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_sci_BitSet(x);
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(x$1, this$1.s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return this.partialCompare__sci_BitSet__sci_BitSet__D($as_sci_BitSet(x), $as_sci_BitSet(y))
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_BitSet__sci_BitSet__Z($as_sci_BitSet(x), $as_sci_BitSet(y))
});
var $d_Lcats_kernel_instances_BitSetPartialOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BitSetPartialOrder: 0
}, false, "cats.kernel.instances.BitSetPartialOrder", {
  Lcats_kernel_instances_BitSetPartialOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_BitSetPartialOrder.prototype.$classData = $d_Lcats_kernel_instances_BitSetPartialOrder;
/** @constructor */
function $c_Lfs2_Chunk$EmptyChunk() {
  /*<skip>*/
}
$c_Lfs2_Chunk$EmptyChunk.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$EmptyChunk.prototype.constructor = $c_Lfs2_Chunk$EmptyChunk;
/** @constructor */
function $h_Lfs2_Chunk$EmptyChunk() {
  /*<skip>*/
}
$h_Lfs2_Chunk$EmptyChunk.prototype = $c_Lfs2_Chunk$EmptyChunk.prototype;
$c_Lfs2_Chunk$EmptyChunk.prototype.size__I = (function() {
  return 0
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__E = (function(i) {
  $m_s_sys_package$().error__T__E((("Chunk.empty.apply(" + i) + ")"))
});
$c_Lfs2_Chunk$EmptyChunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  return this
});
$c_Lfs2_Chunk$EmptyChunk.prototype.toString__T = (function() {
  return "empty"
});
$c_Lfs2_Chunk$EmptyChunk.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i)
});
var $d_Lfs2_Chunk$EmptyChunk = new $TypeData().initClass({
  Lfs2_Chunk$EmptyChunk: 0
}, false, "fs2.Chunk$EmptyChunk", {
  Lfs2_Chunk$EmptyChunk: 1,
  Lfs2_Chunk: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
});
$c_Lfs2_Chunk$EmptyChunk.prototype.$classData = $d_Lfs2_Chunk$EmptyChunk;
/** @constructor */
function $c_Lfs2_Chunk$IndexedSeqChunk(s) {
  this.Lfs2_Chunk$IndexedSeqChunk__f_s = null;
  this.Lfs2_Chunk$IndexedSeqChunk__f_s = s
}
$c_Lfs2_Chunk$IndexedSeqChunk.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$IndexedSeqChunk.prototype.constructor = $c_Lfs2_Chunk$IndexedSeqChunk;
/** @constructor */
function $h_Lfs2_Chunk$IndexedSeqChunk() {
  /*<skip>*/
}
$h_Lfs2_Chunk$IndexedSeqChunk.prototype = $c_Lfs2_Chunk$IndexedSeqChunk.prototype;
$c_Lfs2_Chunk$IndexedSeqChunk.prototype.size__I = (function() {
  return this.Lfs2_Chunk$IndexedSeqChunk__f_s.length__I()
});
$c_Lfs2_Chunk$IndexedSeqChunk.prototype.apply__I__O = (function(i) {
  return this.Lfs2_Chunk$IndexedSeqChunk__f_s.apply__I__O(i)
});
$c_Lfs2_Chunk$IndexedSeqChunk.prototype.map__F1__Lfs2_Chunk = (function(f) {
  return $m_Lfs2_Chunk$().indexedSeq__sc_IndexedSeq__Lfs2_Chunk($as_sc_IndexedSeq(this.Lfs2_Chunk$IndexedSeqChunk__f_s.map__F1__O(f)))
});
var $d_Lfs2_Chunk$IndexedSeqChunk = new $TypeData().initClass({
  Lfs2_Chunk$IndexedSeqChunk: 0
}, false, "fs2.Chunk$IndexedSeqChunk", {
  Lfs2_Chunk$IndexedSeqChunk: 1,
  Lfs2_Chunk: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
});
$c_Lfs2_Chunk$IndexedSeqChunk.prototype.$classData = $d_Lfs2_Chunk$IndexedSeqChunk;
function $p_Lfs2_Chunk$Queue__accumulatedLengths__T2($thiz) {
  if ((!$thiz.Lfs2_Chunk$Queue__f_accumulatedLengthsbitmap$1)) {
    var this$1 = $thiz.Lfs2_Chunk$Queue__f_chunks;
    var dimensions = new $ac_I(new Int32Array([this$1.length__I()]));
    var lens = $asArrayOf_I($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_I.getClassOf(), dimensions), 1);
    var this$3 = $thiz.Lfs2_Chunk$Queue__f_chunks;
    var dimensions$1 = new $ac_I(new Int32Array([this$3.length__I()]));
    var arr = $asArrayOf_Lfs2_Chunk($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lfs2_Chunk.getClassOf(), dimensions$1), 1);
    var elem = 0;
    elem = 0;
    var elem$1 = 0;
    elem$1 = 0;
    var this$7 = $thiz.Lfs2_Chunk$Queue__f_chunks;
    var these = this$7;
    while ((!these.isEmpty__Z())) {
      var arg1 = these.head__O();
      var c = $as_Lfs2_Chunk(arg1);
      var ev$18 = ((elem + c.size__I()) | 0);
      elem = ev$18;
      lens.set(elem$1, elem);
      arr.set(elem$1, c);
      var ev$19 = ((1 + elem$1) | 0);
      elem$1 = ev$19;
      these = $as_sc_LinearSeq(these.tail__O())
    };
    $thiz.Lfs2_Chunk$Queue__f_accumulatedLengths$lzy1 = new $c_T2(lens, arr);
    $thiz.Lfs2_Chunk$Queue__f_accumulatedLengthsbitmap$1 = true
  };
  return $thiz.Lfs2_Chunk$Queue__f_accumulatedLengths$lzy1
}
/** @constructor */
function $c_Lfs2_Chunk$Queue(chunks, size) {
  this.Lfs2_Chunk$Queue__f_chunks = null;
  this.Lfs2_Chunk$Queue__f_size = 0;
  this.Lfs2_Chunk$Queue__f_accumulatedLengths$lzy1 = null;
  this.Lfs2_Chunk$Queue__f_accumulatedLengthsbitmap$1 = false;
  this.Lfs2_Chunk$Queue__f_chunks = chunks;
  this.Lfs2_Chunk$Queue__f_size = size
}
$c_Lfs2_Chunk$Queue.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$Queue.prototype.constructor = $c_Lfs2_Chunk$Queue;
/** @constructor */
function $h_Lfs2_Chunk$Queue() {
  /*<skip>*/
}
$h_Lfs2_Chunk$Queue.prototype = $c_Lfs2_Chunk$Queue.prototype;
$c_Lfs2_Chunk$Queue.prototype.size__I = (function() {
  return this.Lfs2_Chunk$Queue__f_size
});
$c_Lfs2_Chunk$Queue.prototype.foreach__F1__V = (function(f) {
  var this$1 = this.Lfs2_Chunk$Queue__f_chunks;
  var these = this$1;
  while ((!these.isEmpty__Z())) {
    var arg1 = these.head__O();
    var _$16 = $as_Lfs2_Chunk(arg1);
    _$16.foreach__F1__V(f);
    these = $as_sc_LinearSeq(these.tail__O())
  }
});
$c_Lfs2_Chunk$Queue.prototype.foreachWithIndex__F2__V = (function(f) {
  var i = new $c_sr_IntRef(0);
  var this$2 = this.Lfs2_Chunk$Queue__f_chunks;
  var these = this$2;
  while ((!these.isEmpty__Z())) {
    var arg1 = these.head__O();
    var c = $as_Lfs2_Chunk(arg1);
    c.foreach__F1__V(new $c_sjsr_AnonFunction1(((f$20$2, i$6$2) => ((o) => {
      f$20$2.apply__O__O__O(o, i$6$2.sr_IntRef__f_elem);
      var ev$20 = ((1 + i$6$2.sr_IntRef__f_elem) | 0);
      i$6$2.sr_IntRef__f_elem = ev$20
    }))(f, i)));
    these = $as_sc_LinearSeq(these.tail__O())
  }
});
$c_Lfs2_Chunk$Queue.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.Lfs2_Chunk$Queue__f_chunks.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((_$17) => {
    var _$17$1 = $as_Lfs2_Chunk(_$17);
    return _$17$1.iterator__sc_Iterator()
  }));
  return new $c_sc_Iterator$$anon$10(this$2, f)
});
$c_Lfs2_Chunk$Queue.prototype.$colon$plus__Lfs2_Chunk__Lfs2_Chunk$Queue = (function(c) {
  if (c.isEmpty__Z()) {
    return this
  } else {
    var this$1 = this.Lfs2_Chunk$Queue__f_chunks;
    return new $c_Lfs2_Chunk$Queue(this$1.enqueue__O__sci_Queue(c), ((this.Lfs2_Chunk$Queue__f_size + c.size__I()) | 0))
  }
});
$c_Lfs2_Chunk$Queue.prototype.apply__I__O = (function(i) {
  if (((i < 0) || (i >= this.Lfs2_Chunk$Queue__f_size))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  };
  if ((i === 0)) {
    return $as_Lfs2_Chunk(this.Lfs2_Chunk$Queue__f_chunks.head__O()).apply__I__O(0)
  } else if ((i === (((-1) + this.Lfs2_Chunk$Queue__f_size) | 0))) {
    return $as_Lfs2_Chunk(this.Lfs2_Chunk$Queue__f_chunks.last__O()).last__s_Option().get__O()
  } else {
    matchResult25: {
      var \u03b47$___1;
      var \u03b47$___2;
      var x51 = $p_Lfs2_Chunk$Queue__accumulatedLengths__T2(this);
      if ((x51 !== null)) {
        var lengths = $asArrayOf_I(x51._1__O(), 1);
        var chunks = $asArrayOf_Lfs2_Chunk(x51._2__O(), 1);
        var \u03b47$___1 = lengths;
        var \u03b47$___2 = chunks;
        break matchResult25
      };
      throw new $c_s_MatchError(x51)
    };
    var lengths$2 = $asArrayOf_I(\u03b47$___1, 1);
    var chunks$2 = $asArrayOf_Lfs2_Chunk(\u03b47$___2, 1);
    var j = $m_ju_Arrays$().binarySearch__AI__I__I(lengths$2, i);
    if ((j >= 0)) {
      return chunks$2.get(((1 + j) | 0)).apply__I__O(0)
    } else {
      var k = (((-1) - j) | 0);
      var accLenBefore = ((k === 0) ? 0 : lengths$2.get((((-1) + k) | 0)));
      return chunks$2.get(k).apply__I__O(((i - accLenBefore) | 0))
    }
  }
});
$c_Lfs2_Chunk$Queue.prototype.traverse__F1__Lcats_Applicative__O = (function(f, F) {
  return this.toIndexedChunk__Lfs2_Chunk().traverse__F1__Lcats_Applicative__O(f, F)
});
function $as_Lfs2_Chunk$Queue(obj) {
  return (((obj instanceof $c_Lfs2_Chunk$Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Chunk$Queue"))
}
function $isArrayOf_Lfs2_Chunk$Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Chunk$Queue)))
}
function $asArrayOf_Lfs2_Chunk$Queue(obj, depth) {
  return (($isArrayOf_Lfs2_Chunk$Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Chunk$Queue;", depth))
}
var $d_Lfs2_Chunk$Queue = new $TypeData().initClass({
  Lfs2_Chunk$Queue: 0
}, false, "fs2.Chunk$Queue", {
  Lfs2_Chunk$Queue: 1,
  Lfs2_Chunk: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
});
$c_Lfs2_Chunk$Queue.prototype.$classData = $d_Lfs2_Chunk$Queue;
/** @constructor */
function $c_Lfs2_Chunk$Singleton(value) {
  this.Lfs2_Chunk$Singleton__f_value = null;
  this.Lfs2_Chunk$Singleton__f_value = value
}
$c_Lfs2_Chunk$Singleton.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$Singleton.prototype.constructor = $c_Lfs2_Chunk$Singleton;
/** @constructor */
function $h_Lfs2_Chunk$Singleton() {
  /*<skip>*/
}
$h_Lfs2_Chunk$Singleton.prototype = $c_Lfs2_Chunk$Singleton.prototype;
$c_Lfs2_Chunk$Singleton.prototype.size__I = (function() {
  return 1
});
$c_Lfs2_Chunk$Singleton.prototype.apply__I__O = (function(i) {
  if ((i === 0)) {
    return this.Lfs2_Chunk$Singleton__f_value
  } else {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  }
});
$c_Lfs2_Chunk$Singleton.prototype.map__F1__Lfs2_Chunk = (function(f) {
  $m_Lfs2_Chunk$();
  var o = f.apply__O__O(this.Lfs2_Chunk$Singleton__f_value);
  return new $c_Lfs2_Chunk$Singleton(o)
});
var $d_Lfs2_Chunk$Singleton = new $TypeData().initClass({
  Lfs2_Chunk$Singleton: 0
}, false, "fs2.Chunk$Singleton", {
  Lfs2_Chunk$Singleton: 1,
  Lfs2_Chunk: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1
});
$c_Lfs2_Chunk$Singleton.prototype.$classData = $d_Lfs2_Chunk$Singleton;
/** @constructor */
function $c_Lfs2_Compiler$() {
  this.Lfs2_Compiler$__f_idInstance = null;
  this.Lfs2_Compiler$__f_fallibleInstance = null;
  this.Lfs2_Compiler$__f_pureInstance = null;
  $n_Lfs2_Compiler$ = this;
  this.Lfs2_Compiler$__f_idInstance = new $c_Lfs2_CompilerLowPriority0$$anon$3();
  this.Lfs2_Compiler$__f_fallibleInstance = new $c_Lfs2_CompilerLowPriority$$anon$4();
  this.Lfs2_Compiler$__f_pureInstance = new $c_Lfs2_Compiler$$anon$5()
}
$c_Lfs2_Compiler$.prototype = new $h_O();
$c_Lfs2_Compiler$.prototype.constructor = $c_Lfs2_Compiler$;
/** @constructor */
function $h_Lfs2_Compiler$() {
  /*<skip>*/
}
$h_Lfs2_Compiler$.prototype = $c_Lfs2_Compiler$.prototype;
var $d_Lfs2_Compiler$ = new $TypeData().initClass({
  Lfs2_Compiler$: 0
}, false, "fs2.Compiler$", {
  Lfs2_Compiler$: 1,
  O: 1,
  Lfs2_CompilerLowPriority2: 1,
  Lfs2_CompilerLowPriority1: 1,
  Lfs2_CompilerLowPriority0: 1,
  Lfs2_CompilerLowPriority: 1
});
$c_Lfs2_Compiler$.prototype.$classData = $d_Lfs2_Compiler$;
var $n_Lfs2_Compiler$;
function $m_Lfs2_Compiler$() {
  if ((!$n_Lfs2_Compiler$)) {
    $n_Lfs2_Compiler$ = new $c_Lfs2_Compiler$()
  };
  return $n_Lfs2_Compiler$
}
class $c_Lfs2_CompositeFailure extends $c_jl_Throwable {
  constructor(head, tail) {
    super();
    this.Lfs2_CompositeFailure__f_head = null;
    this.Lfs2_CompositeFailure__f_tail = null;
    this.Lfs2_CompositeFailure__f_head = head;
    this.Lfs2_CompositeFailure__f_tail = tail;
    var message = ((((("Multiple exceptions were thrown (" + ((1 + tail.size__I()) | 0)) + "), first ") + $objectClassName(head)) + ": ") + head.getMessage__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, head, true, true)
  };
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true
    } else if ((x$0 instanceof $c_Lfs2_CompositeFailure)) {
      var x$0$2 = $as_Lfs2_CompositeFailure(x$0);
      var x = this.Lfs2_CompositeFailure__f_head;
      var x$2 = x$0$2.Lfs2_CompositeFailure__f_head;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Lfs2_CompositeFailure__f_tail;
        var x$4 = x$0$2.Lfs2_CompositeFailure__f_tail;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
      } else {
        return false
      }
    } else {
      return false
    }
  };
  productArity__I() {
    return 2
  };
  productPrefix__T() {
    return "CompositeFailure"
  };
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lfs2_CompositeFailure__f_head
    };
    if ((n === 1)) {
      return this.Lfs2_CompositeFailure__f_tail
    };
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
}
function $as_Lfs2_CompositeFailure(obj) {
  return (((obj instanceof $c_Lfs2_CompositeFailure) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.CompositeFailure"))
}
function $isArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_CompositeFailure)))
}
function $asArrayOf_Lfs2_CompositeFailure(obj, depth) {
  return (($isArrayOf_Lfs2_CompositeFailure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.CompositeFailure;", depth))
}
var $d_Lfs2_CompositeFailure = new $TypeData().initClass({
  Lfs2_CompositeFailure: 0
}, false, "fs2.CompositeFailure", {
  Lfs2_CompositeFailure: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lfs2_CompositeFailure.prototype.$classData = $d_Lfs2_CompositeFailure;
/** @constructor */
function $c_Lfs2_Pull$$anon$1(f$14, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = null;
  this.Lfs2_Pull$$anon$1__f_f$1 = f$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer)
}
$c_Lfs2_Pull$$anon$1.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$1.prototype.constructor = $c_Lfs2_Pull$$anon$1;
/** @constructor */
function $h_Lfs2_Pull$$anon$1() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$1.prototype = $c_Lfs2_Pull$$anon$1.prototype;
$c_Lfs2_Pull$$anon$1.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(e) {
  if ((e instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$1 = $as_Lfs2_Pull$Succeeded(e);
    var x15 = x$1.Lfs2_Pull$Succeeded__f_r;
    try {
      return $as_Lfs2_Pull(this.Lfs2_Pull$$anon$1__f_f$1.apply__O__O(x15))
    } catch (e$2) {
      var e$3 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$2);
      if ((e$3 !== null)) {
        var x2 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
        if ((!x2.isEmpty__Z())) {
          var x3 = $as_jl_Throwable(x2.get__O());
          return new $c_Lfs2_Pull$Fail(x3)
        }
      };
      throw e$3
    }
  };
  if ((e instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$1$1 = $as_Lfs2_Pull$Interrupted(e);
    var res = $as_Lfs2_Pull$Interrupted(e);
    return res
  };
  if ((e instanceof $c_Lfs2_Pull$Fail)) {
    var x$1$2 = $as_Lfs2_Pull$Fail(e);
    var res$2 = $as_Lfs2_Pull$Fail(e);
    return res$2
  };
  throw new $c_s_MatchError(e)
});
var $d_Lfs2_Pull$$anon$1 = new $TypeData().initClass({
  Lfs2_Pull$$anon$1: 0
}, false, "fs2.Pull$$anon$1", {
  Lfs2_Pull$$anon$1: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$$anon$1.prototype.$classData = $d_Lfs2_Pull$$anon$1;
/** @constructor */
function $c_Lfs2_Pull$$anon$2(post$3, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = null;
  this.Lfs2_Pull$$anon$2__f_post$1 = post$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer)
}
$c_Lfs2_Pull$$anon$2.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$2.prototype.constructor = $c_Lfs2_Pull$$anon$2;
/** @constructor */
function $h_Lfs2_Pull$$anon$2() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$2.prototype = $c_Lfs2_Pull$$anon$2.prototype;
$c_Lfs2_Pull$$anon$2.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  if ((r instanceof $c_Lfs2_Pull$Succeeded)) {
    return $as_Lfs2_Pull(this.Lfs2_Pull$$anon$2__f_post$1.apply__O())
  };
  if ((r instanceof $c_Lfs2_Pull$Interrupted)) {
    var r$2 = $as_Lfs2_Pull$Interrupted(r);
    return r$2
  };
  if ((r instanceof $c_Lfs2_Pull$Fail)) {
    var r$3 = $as_Lfs2_Pull$Fail(r);
    return r$3
  };
  throw new $c_s_MatchError(r)
});
var $d_Lfs2_Pull$$anon$2 = new $TypeData().initClass({
  Lfs2_Pull$$anon$2: 0
}, false, "fs2.Pull$$anon$2", {
  Lfs2_Pull$$anon$2: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$$anon$2.prototype.$classData = $d_Lfs2_Pull$$anon$2;
/** @constructor */
function $c_Lfs2_Pull$$anon$3(handler$2, outer) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = null;
  this.Lfs2_Pull$$anon$3__f_handler$1 = handler$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, outer)
}
$c_Lfs2_Pull$$anon$3.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$3.prototype.constructor = $c_Lfs2_Pull$$anon$3;
/** @constructor */
function $h_Lfs2_Pull$$anon$3() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$3.prototype = $c_Lfs2_Pull$$anon$3.prototype;
$c_Lfs2_Pull$$anon$3.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(term) {
  if ((term instanceof $c_Lfs2_Pull$Fail)) {
    var x$1 = $as_Lfs2_Pull$Fail(term);
    var x27 = x$1.Lfs2_Pull$Fail__f_error;
    try {
      return $as_Lfs2_Pull(this.Lfs2_Pull$$anon$3__f_handler$1.apply__O__O(x27))
    } catch (e$2) {
      var e$3 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$2);
      if ((e$3 !== null)) {
        var x21 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$3);
        if ((!x21.isEmpty__Z())) {
          var x22 = $as_jl_Throwable(x21.get__O());
          return new $c_Lfs2_Pull$Fail(x22)
        }
      };
      throw e$3
    }
  } else {
    return term
  }
});
var $d_Lfs2_Pull$$anon$3 = new $TypeData().initClass({
  Lfs2_Pull$$anon$3: 0
}, false, "fs2.Pull$$anon$3", {
  Lfs2_Pull$$anon$3: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$$anon$3.prototype.$classData = $d_Lfs2_Pull$$anon$3;
/** @constructor */
function $c_Lfs2_Pull$$anon$7(fmoc$1, view$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = null;
  this.Lfs2_Pull$$anon$7__f_view$2 = view$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, fmoc$1)
}
$c_Lfs2_Pull$$anon$7.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$7.prototype.constructor = $c_Lfs2_Pull$$anon$7;
/** @constructor */
function $h_Lfs2_Pull$$anon$7() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$7.prototype = $c_Lfs2_Pull$$anon$7.prototype;
$c_Lfs2_Pull$$anon$7.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $as_Lfs2_Pull(this.Lfs2_Pull$$anon$7__f_view$2.apply__O__O(r))
});
var $d_Lfs2_Pull$$anon$7 = new $TypeData().initClass({
  Lfs2_Pull$$anon$7: 0
}, false, "fs2.Pull$$anon$7", {
  Lfs2_Pull$$anon$7: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$$anon$7.prototype.$classData = $d_Lfs2_Pull$$anon$7;
/** @constructor */
function $c_Lfs2_Pull$$anon$8(stream$3, childScope$1) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = null;
  this.Lfs2_Pull$$anon$8__f_childScope$2 = childScope$1;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, stream$3)
}
$c_Lfs2_Pull$$anon$8.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$8.prototype.constructor = $c_Lfs2_Pull$$anon$8;
/** @constructor */
function $h_Lfs2_Pull$$anon$8() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$8.prototype = $c_Lfs2_Pull$$anon$8.prototype;
$c_Lfs2_Pull$$anon$8.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  return $m_Lfs2_Pull$().fs2$Pull$$$_$endScope$1__Lcats_effect_kernel_Unique$Token__Lfs2_Pull$Terminal__Lfs2_Pull(this.Lfs2_Pull$$anon$8__f_childScope$2.Lfs2_internal_Scope__f_id, r)
});
var $d_Lfs2_Pull$$anon$8 = new $TypeData().initClass({
  Lfs2_Pull$$anon$8: 0
}, false, "fs2.Pull$$anon$8", {
  Lfs2_Pull$$anon$8: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$$anon$8.prototype.$classData = $d_Lfs2_Pull$$anon$8;
/** @constructor */
function $c_Lfs2_Pull$$anon$9(p$2, f$11) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = null;
  this.Lfs2_Pull$$anon$9__f_f$12 = f$11;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, p$2)
}
$c_Lfs2_Pull$$anon$9.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$$anon$9.prototype.constructor = $c_Lfs2_Pull$$anon$9;
/** @constructor */
function $h_Lfs2_Pull$$anon$9() {
  /*<skip>*/
}
$h_Lfs2_Pull$$anon$9.prototype = $c_Lfs2_Pull$$anon$9.prototype;
$c_Lfs2_Pull$$anon$9.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(r) {
  try {
    return $as_Lfs2_Pull(this.Lfs2_Pull$$anon$9__f_f$12.apply__O__O(r))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x327 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x327.isEmpty__Z())) {
        var x328 = $as_jl_Throwable(x327.get__O());
        return new $c_Lfs2_Pull$Fail(x328)
      }
    };
    throw e$2
  }
});
var $d_Lfs2_Pull$$anon$9 = new $TypeData().initClass({
  Lfs2_Pull$$anon$9: 0
}, false, "fs2.Pull$$anon$9", {
  Lfs2_Pull$$anon$9: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$$anon$9.prototype.$classData = $d_Lfs2_Pull$$anon$9;
/** @constructor */
function $c_Lfs2_Pull$BindBind(step, bb, del) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$BindBind__f_bb = null;
  this.Lfs2_Pull$BindBind__f_del = null;
  this.Lfs2_Pull$BindBind__f_bb = bb;
  this.Lfs2_Pull$BindBind__f_del = del;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step)
}
$c_Lfs2_Pull$BindBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$BindBind.prototype.constructor = $c_Lfs2_Pull$BindBind;
/** @constructor */
function $h_Lfs2_Pull$BindBind() {
  /*<skip>*/
}
$h_Lfs2_Pull$BindBind.prototype = $c_Lfs2_Pull$BindBind.prototype;
$c_Lfs2_Pull$BindBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(tx) {
  try {
    return $m_Lfs2_Pull$().fs2$Pull$$$bindBindAux__Lfs2_Pull__Lfs2_Pull$Bind__Lfs2_Pull(this.Lfs2_Pull$BindBind__f_bb.cont__Lfs2_Pull$Terminal__Lfs2_Pull(tx), this.Lfs2_Pull$BindBind__f_del)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x86 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x86.isEmpty__Z())) {
        var x87 = $as_jl_Throwable(x86.get__O());
        return new $c_Lfs2_Pull$Fail(x87)
      }
    };
    throw e$2
  }
});
function $as_Lfs2_Pull$BindBind(obj) {
  return (((obj instanceof $c_Lfs2_Pull$BindBind) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$BindBind"))
}
function $isArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$BindBind)))
}
function $asArrayOf_Lfs2_Pull$BindBind(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$BindBind(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$BindBind;", depth))
}
var $d_Lfs2_Pull$BindBind = new $TypeData().initClass({
  Lfs2_Pull$BindBind: 0
}, false, "fs2.Pull$BindBind", {
  Lfs2_Pull$BindBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$BindBind.prototype.$classData = $d_Lfs2_Pull$BindBind;
/** @constructor */
function $c_Lfs2_Pull$CloseScope() {
  /*<skip>*/
}
$c_Lfs2_Pull$CloseScope.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$CloseScope.prototype.constructor = $c_Lfs2_Pull$CloseScope;
/** @constructor */
function $h_Lfs2_Pull$CloseScope() {
  /*<skip>*/
}
$h_Lfs2_Pull$CloseScope.prototype = $c_Lfs2_Pull$CloseScope.prototype;
function $as_Lfs2_Pull$CloseScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$CloseScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$CloseScope"))
}
function $isArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CloseScope)))
}
function $asArrayOf_Lfs2_Pull$CloseScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$CloseScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$CloseScope;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$DelegateBind(step, delegate) {
  this.Lfs2_Pull$Bind__f_step = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = null;
  this.Lfs2_Pull$DelegateBind__f_delegate = delegate;
  $ct_Lfs2_Pull$Bind__Lfs2_Pull__(this, step)
}
$c_Lfs2_Pull$DelegateBind.prototype = new $h_Lfs2_Pull$Bind();
$c_Lfs2_Pull$DelegateBind.prototype.constructor = $c_Lfs2_Pull$DelegateBind;
/** @constructor */
function $h_Lfs2_Pull$DelegateBind() {
  /*<skip>*/
}
$h_Lfs2_Pull$DelegateBind.prototype = $c_Lfs2_Pull$DelegateBind.prototype;
$c_Lfs2_Pull$DelegateBind.prototype.delegate__Lfs2_Pull$Bind = (function() {
  return this.Lfs2_Pull$DelegateBind__f_delegate
});
$c_Lfs2_Pull$DelegateBind.prototype.cont__Lfs2_Pull$Terminal__Lfs2_Pull = (function(yr) {
  return this.Lfs2_Pull$DelegateBind__f_delegate.cont__Lfs2_Pull$Terminal__Lfs2_Pull(yr)
});
var $d_Lfs2_Pull$DelegateBind = new $TypeData().initClass({
  Lfs2_Pull$DelegateBind: 0
}, false, "fs2.Pull$DelegateBind", {
  Lfs2_Pull$DelegateBind: 1,
  Lfs2_Pull$Bind: 1,
  Lfs2_Pull: 1,
  O: 1,
  F1: 1,
  Lfs2_Pull$ContP: 1
});
$c_Lfs2_Pull$DelegateBind.prototype.$classData = $d_Lfs2_Pull$DelegateBind;
/** @constructor */
function $c_Lfs2_internal_Scope$$anon$1() {
  /*<skip>*/
}
$c_Lfs2_internal_Scope$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lfs2_internal_Scope$$anon$1.prototype.constructor = $c_Lfs2_internal_Scope$$anon$1;
/** @constructor */
function $h_Lfs2_internal_Scope$$anon$1() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope$$anon$1.prototype = $c_Lfs2_internal_Scope$$anon$1.prototype;
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return ((x instanceof $c_s_util_Left) && ($as_jl_Throwable($as_s_util_Left(x).s_util_Left__f_value), true))
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Left)) {
    var err = $as_jl_Throwable($as_s_util_Left(x).s_util_Left__f_value);
    return err
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Lfs2_internal_Scope$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z($as_s_util_Either(x))
});
$c_Lfs2_internal_Scope$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O($as_s_util_Either(x), default$1)
});
var $d_Lfs2_internal_Scope$$anon$1 = new $TypeData().initClass({
  Lfs2_internal_Scope$$anon$1: 0
}, false, "fs2.internal.Scope$$anon$1", {
  Lfs2_internal_Scope$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_internal_Scope$$anon$1.prototype.$classData = $d_Lfs2_internal_Scope$$anon$1;
/** @constructor */
function $c_Lfs2_internal_Scope$State$Closed() {
  /*<skip>*/
}
$c_Lfs2_internal_Scope$State$Closed.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$Closed.prototype.constructor = $c_Lfs2_internal_Scope$State$Closed;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Closed() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope$State$Closed.prototype = $c_Lfs2_internal_Scope$State$Closed.prototype;
$c_Lfs2_internal_Scope$State$Closed.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_internal_Scope$State$Closed.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_internal_Scope$State$Closed.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lfs2_internal_Scope$State$Closed) && ($as_Lfs2_internal_Scope$State$Closed(x$0), true)))
});
$c_Lfs2_internal_Scope$State$Closed.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productArity__I = (function() {
  return 0
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productPrefix__T = (function() {
  return "Closed"
});
$c_Lfs2_internal_Scope$State$Closed.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_internal_Scope$State$Closed(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope$State$Closed) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State$Closed"))
}
function $isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Closed)))
}
function $asArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State$Closed(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State$Closed;", depth))
}
var $d_Lfs2_internal_Scope$State$Closed = new $TypeData().initClass({
  Lfs2_internal_Scope$State$Closed: 0
}, false, "fs2.internal.Scope$State$Closed", {
  Lfs2_internal_Scope$State$Closed: 1,
  O: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_internal_Scope$State$Closed.prototype.$classData = $d_Lfs2_internal_Scope$State$Closed;
/** @constructor */
function $c_Lfs2_internal_Scope$State$Open(resources, children) {
  this.Lfs2_internal_Scope$State$Open__f_resources = null;
  this.Lfs2_internal_Scope$State$Open__f_children = null;
  this.Lfs2_internal_Scope$State$Open__f_resources = resources;
  this.Lfs2_internal_Scope$State$Open__f_children = children
}
$c_Lfs2_internal_Scope$State$Open.prototype = new $h_O();
$c_Lfs2_internal_Scope$State$Open.prototype.constructor = $c_Lfs2_internal_Scope$State$Open;
/** @constructor */
function $h_Lfs2_internal_Scope$State$Open() {
  /*<skip>*/
}
$h_Lfs2_internal_Scope$State$Open.prototype = $c_Lfs2_internal_Scope$State$Open.prototype;
$c_Lfs2_internal_Scope$State$Open.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_internal_Scope$State$Open.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_internal_Scope$State$Open.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_internal_Scope$State$Open)) {
    var x$0$2 = $as_Lfs2_internal_Scope$State$Open(x$0);
    var x = this.Lfs2_internal_Scope$State$Open__f_resources;
    var x$2 = x$0$2.Lfs2_internal_Scope$State$Open__f_resources;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_internal_Scope$State$Open__f_children;
      var x$4 = x$0$2.Lfs2_internal_Scope$State$Open__f_children;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_internal_Scope$State$Open.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_internal_Scope$State$Open.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_internal_Scope$State$Open.prototype.productPrefix__T = (function() {
  return "Open"
});
$c_Lfs2_internal_Scope$State$Open.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_internal_Scope$State$Open__f_resources
  };
  if ((n === 1)) {
    return this.Lfs2_internal_Scope$State$Open__f_children
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lfs2_internal_Scope$State$Open.prototype.unregisterChild__Lcats_effect_kernel_Unique$Token__Lfs2_internal_Scope$State = (function(id) {
  var this$1 = this.Lfs2_internal_Scope$State$Open__f_children;
  var acc = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var x116;
  var acc$tailLocal1 = acc;
  var rem$tailLocal2 = this$1;
  while (true) {
    var x59 = rem$tailLocal2.uncons__s_Option();
    if ((x59 instanceof $c_s_Some)) {
      var x61 = $as_T2($as_s_Some(x59).s_Some__f_value);
      if ((x61 !== null)) {
        var a = x61._1__O();
        var tail = $as_Lcats_data_Chain(x61._2__O());
        var _$23 = $as_Lfs2_internal_Scope(a);
        var x = _$23.Lfs2_internal_Scope__f_id;
        if ((!(x === id))) {
          var this$2 = acc$tailLocal1;
          var acc$tailLocal1$tmp1 = this$2.append__O__Lcats_data_Chain(a);
          rem$tailLocal2 = tail;
          acc$tailLocal1 = acc$tailLocal1$tmp1;
          continue
        };
        var this$3 = acc$tailLocal1;
        var _2 = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$3, tail);
        var value = new $c_T2(a, _2);
        var x116 = new $c_s_Some(value);
        break
      }
    };
    var x$1 = $m_s_None$();
    if ((x$1 === x59)) {
      var x116 = $m_s_None$();
      break
    };
    throw new $c_s_MatchError(x59)
  };
  if ((x116 instanceof $c_s_Some)) {
    var x118 = $as_T2($as_s_Some(x116).s_Some__f_value);
    if ((x118 !== null)) {
      var newChildren = $as_Lcats_data_Chain(x118._2__O());
      var resources = this.Lfs2_internal_Scope$State$Open__f_resources;
      return new $c_Lfs2_internal_Scope$State$Open(resources, newChildren)
    }
  };
  var x$2 = $m_s_None$();
  if ((x$2 === x116)) {
    return this
  };
  throw new $c_s_MatchError(x116)
});
function $as_Lfs2_internal_Scope$State$Open(obj) {
  return (((obj instanceof $c_Lfs2_internal_Scope$State$Open) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.internal.Scope$State$Open"))
}
function $isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_internal_Scope$State$Open)))
}
function $asArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) {
  return (($isArrayOf_Lfs2_internal_Scope$State$Open(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.internal.Scope$State$Open;", depth))
}
var $d_Lfs2_internal_Scope$State$Open = new $TypeData().initClass({
  Lfs2_internal_Scope$State$Open: 0
}, false, "fs2.internal.Scope$State$Open", {
  Lfs2_internal_Scope$State$Open: 1,
  O: 1,
  Lfs2_internal_Scope$State: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_internal_Scope$State$Open.prototype.$classData = $d_Lfs2_internal_Scope$State$Open;
function $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, out) {
  $thiz.Ljava_io_FilterOutputStream__f_out = out;
  return $thiz
}
/** @constructor */
function $c_Ljava_io_FilterOutputStream() {
  this.Ljava_io_FilterOutputStream__f_out = null
}
$c_Ljava_io_FilterOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_Ljava_io_FilterOutputStream.prototype.constructor = $c_Ljava_io_FilterOutputStream;
/** @constructor */
function $h_Ljava_io_FilterOutputStream() {
  /*<skip>*/
}
$h_Ljava_io_FilterOutputStream.prototype = $c_Ljava_io_FilterOutputStream.prototype;
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_ArithmeticException(obj) {
  return (((obj instanceof $c_jl_ArithmeticException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArithmeticException"))
}
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)))
}
function $asArrayOf_jl_ArithmeticException(obj, depth) {
  return (($isArrayOf_jl_ArithmeticException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArithmeticException;", depth))
}
var $d_jl_ArithmeticException = new $TypeData().initClass({
  jl_ArithmeticException: 0
}, false, "java.lang.ArithmeticException", {
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArithmeticException.prototype.$classData = $d_jl_ArithmeticException;
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Byte__hashCode__I($thiz) {
  return $uB($thiz)
}
function $f_jl_Byte__toString__T($thiz) {
  var b = $uB($thiz);
  return ("" + b)
}
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  var that = $as_jl_Byte(o);
  var x = $uB($thiz);
  var y = $uB(that);
  return ((x - y) | 0)
}
function $as_jl_Byte(obj) {
  return (($isByte(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Byte"))
}
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)))
}
function $asArrayOf_jl_Byte(obj, depth) {
  return (($isArrayOf_jl_Byte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Byte;", depth))
}
var $d_jl_Byte = new $TypeData().initClass({
  jl_Byte: 0
}, false, "java.lang.Byte", {
  jl_Byte: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => $isByte(x)));
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_ClassCastException(obj) {
  return (((obj instanceof $c_jl_ClassCastException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ClassCastException"))
}
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ClassCastException)))
}
function $asArrayOf_jl_ClassCastException(obj, depth) {
  return (($isArrayOf_jl_ClassCastException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ClassCastException;", depth))
}
var $d_jl_ClassCastException = new $TypeData().initClass({
  jl_ClassCastException: 0
}, false, "java.lang.ClassCastException", {
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ClassCastException.prototype.$classData = $d_jl_ClassCastException;
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalArgumentException = new $TypeData().initClass({
  jl_IllegalArgumentException: 0
}, false, "java.lang.IllegalArgumentException", {
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalArgumentException.prototype.$classData = $d_jl_IllegalArgumentException;
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
var $d_jl_IllegalStateException = new $TypeData().initClass({
  jl_IllegalStateException: 0
}, false, "java.lang.IllegalStateException", {
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IllegalStateException.prototype.$classData = $d_jl_IllegalStateException;
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass({
  jl_IndexOutOfBoundsException: 0
}, false, "java.lang.IndexOutOfBoundsException", {
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_IndexOutOfBoundsException.prototype.$classData = $d_jl_IndexOutOfBoundsException;
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $h_Ljava_io_OutputStream();
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", {
  jl_JSConsoleBasedPrintStream$DummyOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
});
$c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream$DummyOutputStream;
class $c_jl_NegativeArraySizeException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_jl_NegativeArraySizeException = new $TypeData().initClass({
  jl_NegativeArraySizeException: 0
}, false, "java.lang.NegativeArraySizeException", {
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NegativeArraySizeException.prototype.$classData = $d_jl_NegativeArraySizeException;
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
var $d_jl_NullPointerException = new $TypeData().initClass({
  jl_NullPointerException: 0
}, false, "java.lang.NullPointerException", {
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NullPointerException.prototype.$classData = $d_jl_NullPointerException;
function $as_jl_SecurityException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.SecurityException"))
}
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)))
}
function $asArrayOf_jl_SecurityException(obj, depth) {
  return (($isArrayOf_jl_SecurityException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.SecurityException;", depth))
}
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Short__hashCode__I($thiz) {
  return $uS($thiz)
}
function $f_jl_Short__toString__T($thiz) {
  var s = $uS($thiz);
  return ("" + s)
}
function $f_jl_Short__compareTo__O__I($thiz, o) {
  var that = $as_jl_Short(o);
  var x = $uS($thiz);
  var y = $uS(that);
  return ((x - y) | 0)
}
function $as_jl_Short(obj) {
  return (($isShort(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Short"))
}
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)))
}
function $asArrayOf_jl_Short(obj, depth) {
  return (($isArrayOf_jl_Short(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Short;", depth))
}
var $d_jl_Short = new $TypeData().initClass({
  jl_Short: 0
}, false, "java.lang.Short", {
  jl_Short: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}, (void 0), (void 0), ((x) => $isShort(x)));
class $c_jl_StackOverflowError extends $c_jl_VirtualMachineError {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_jl_StackOverflowError = new $TypeData().initClass({
  jl_StackOverflowError: 0
}, false, "java.lang.StackOverflowError", {
  jl_StackOverflowError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StackOverflowError.prototype.$classData = $d_jl_StackOverflowError;
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
var $d_jl_UnsupportedOperationException = new $TypeData().initClass({
  jl_UnsupportedOperationException: 0
}, false, "java.lang.UnsupportedOperationException", {
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_UnsupportedOperationException.prototype.$classData = $d_jl_UnsupportedOperationException;
class $c_Ljava_nio_BufferOverflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_Ljava_nio_BufferOverflowException = new $TypeData().initClass({
  Ljava_nio_BufferOverflowException: 0
}, false, "java.nio.BufferOverflowException", {
  Ljava_nio_BufferOverflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_BufferOverflowException.prototype.$classData = $d_Ljava_nio_BufferOverflowException;
/** @constructor */
function $c_ju_AbstractList() {
  /*<skip>*/
}
$c_ju_AbstractList.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractList.prototype.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
  /*<skip>*/
}
$h_ju_AbstractList.prototype = $c_ju_AbstractList.prototype;
$c_ju_AbstractList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0)
});
$c_ju_AbstractList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_RandomAccessListIterator(this, index, 0, this.size__I())
});
$c_ju_AbstractList.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true
  } else if ($is_ju_List(o)) {
    var x2 = $as_ju_List(o);
    var oIter = x2.listIterator__I__ju_ListIterator(0);
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while (_\uff3fself.hasNext__Z()) {
        var arg1 = _\uff3fself.next__O();
        if (oIter.hasNext__Z()) {
          var b = oIter.next__O();
          var $$x2 = ((arg1 === null) ? (b === null) : $dp_equals__O__Z(arg1, b))
        } else {
          var $$x2 = false
        };
        if ((!$$x2)) {
          var $$x1 = true;
          break _return
        }
      };
      var $$x1 = false
    };
    if ((!$$x1)) {
      return (!oIter.hasNext__Z())
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_ju_AbstractList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uI(arg1);
    result = ((Math.imul(31, prev) + ((arg2 === null) ? 0 : $dp_hashCode__I(arg2))) | 0)
  };
  return $uI(result)
});
$c_ju_AbstractList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
$c_ju_AbstractList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index))
  }
});
/** @constructor */
function $c_ju_AbstractSet() {
  /*<skip>*/
}
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
  /*<skip>*/
}
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  if ((that === this)) {
    return true
  } else if ($is_ju_Collection(that)) {
    var x2 = $as_ju_Collection(that);
    return ((x2.size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(x2))
  } else {
    return false
  }
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = result;
    var arg2 = _\uff3fself.next__O();
    var prev = $uI(arg1);
    result = (($dp_hashCode__I(arg2) + prev) | 0)
  };
  return $uI(result)
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
var $d_ju_ConcurrentModificationException = new $TypeData().initClass({
  ju_ConcurrentModificationException: 0
}, false, "java.util.ConcurrentModificationException", {
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ConcurrentModificationException.prototype.$classData = $d_ju_ConcurrentModificationException;
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
  return ((node === null) ? defaultValue : node.ju_HashMap$Node__f_value)
}
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = oldTable.u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.get(i);
    while ((node !== null)) {
      if (((node.ju_HashMap$Node__f_hash & oldlen) === 0)) {
        node.ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          newTable.set(i, node)
        } else {
          lastLow.ju_HashMap$Node__f_next = node
        };
        lastLow = node
      } else {
        node.ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          newTable.set(((oldlen + i) | 0), node)
        } else {
          lastHigh.ju_HashMap$Node__f_next = node
        };
        lastHigh = node
      };
      node = node.ju_HashMap$Node__f_next
    };
    if ((lastLow !== null)) {
      lastLow.ju_HashMap$Node__f_next = null
    };
    if ((lastHigh !== null)) {
      lastHigh.ju_HashMap$Node__f_next = null
    };
    i = ((1 + i) | 0)
  }
}
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0")
  };
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0")
  };
  var a = (((-1) + initialCapacity) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz
}
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0
}
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
  /*<skip>*/
}
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.size__I = (function() {
  return this.ju_HashMap__f_contentSize
});
$c_ju_HashMap.prototype.remove__O__O = (function(key) {
  var node = this.java$util$HashMap$$remove0__O__ju_HashMap$Node(key);
  return ((node === null) ? null : node.ju_HashMap$Node__f_value)
});
$c_ju_HashMap.prototype.containsValue__O__Z = (function(value) {
  var _\uff3fself = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$ValueIterator(this);
  while (_\uff3fself.hasNext__Z()) {
    var arg1 = _\uff3fself.next__O();
    if (((value === null) ? (arg1 === null) : $dp_equals__O__Z(value, arg1))) {
      return true
    }
  };
  return false
});
$c_ju_HashMap.prototype.entrySet__ju_Set = (function() {
  return new $c_ju_HashMap$EntrySet(this)
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = this.ju_HashMap__f_java$util$HashMap$$table.get(idx);
  while (true) {
    if ((node === null)) {
      return null
    } else {
      if ((hash === node.ju_HashMap$Node__f_hash)) {
        var b = node.ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        return node
      } else if ((hash < node.ju_HashMap$Node__f_hash)) {
        return null
      } else {
        node = node.ju_HashMap$Node__f_next
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this)
  };
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var x1 = this.ju_HashMap__f_java$util$HashMap$$table.get(idx);
  if ((x1 === null)) {
    var newNode = new $c_ju_NullRejectingHashMap$Node(key, hash, value, null, null);
    this.ju_HashMap__f_java$util$HashMap$$table.set(idx, newNode)
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.ju_HashMap$Node__f_hash <= hash))) {
      if ((n.ju_HashMap$Node__f_hash === hash)) {
        var b = n.ju_HashMap$Node__f_key;
        var $$x1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b))
      } else {
        var $$x1 = false
      };
      if ($$x1) {
        var old = n.ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          n.ju_HashMap$Node__f_value = value
        };
        return old
      };
      prev = n;
      n = n.ju_HashMap$Node__f_next
    };
    var previous = prev;
    var next = n;
    var newNode$2 = new $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next);
    if ((prev === null)) {
      this.ju_HashMap__f_java$util$HashMap$$table.set(idx, newNode$2)
    } else {
      prev.ju_HashMap$Node__f_next = newNode$2
    };
    if ((n !== null)) {
      n.ju_HashMap$Node__f_previous = newNode$2
    }
  };
  this.ju_HashMap__f_contentSize = newContentSize;
  return null
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__O__ju_HashMap$Node = (function(key) {
  if ((key === null)) {
    var hash = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  if ((node !== null)) {
    this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx)
  };
  return node
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__ju_HashMap$Node__I__V = (function(node, idx) {
  var previous = node.ju_HashMap$Node__f_previous;
  var next = node.ju_HashMap$Node__f_next;
  if ((previous === null)) {
    this.ju_HashMap__f_java$util$HashMap$$table.set(idx, next)
  } else {
    previous.ju_HashMap$Node__f_next = next
  };
  if ((next !== null)) {
    next.ju_HashMap$Node__f_previous = previous
  };
  this.ju_HashMap__f_contentSize = (((-1) + this.ju_HashMap__f_contentSize) | 0)
});
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
var $d_ju_NoSuchElementException = new $TypeData().initClass({
  ju_NoSuchElementException: 0
}, false, "java.util.NoSuchElementException", {
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_NoSuchElementException.prototype.$classData = $d_ju_NoSuchElementException;
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_start = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_RandomAccessListIterator__f_list = null;
  this.ju_RandomAccessListIterator__f_list = list;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end)
}
$c_ju_RandomAccessListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_RandomAccessListIterator.prototype.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
  /*<skip>*/
}
$h_ju_RandomAccessListIterator.prototype = $c_ju_RandomAccessListIterator.prototype;
$c_ju_RandomAccessListIterator.prototype.get__I__O = (function(index) {
  return this.ju_RandomAccessListIterator__f_list.get__I__O(index)
});
var $d_ju_RandomAccessListIterator = new $TypeData().initClass({
  ju_RandomAccessListIterator: 0
}, false, "java.util.RandomAccessListIterator", {
  ju_RandomAccessListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  O: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
});
$c_ju_RandomAccessListIterator.prototype.$classData = $d_ju_RandomAccessListIterator;
function $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_concurrent_ConcurrentHashMap__f_inner = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor);
  return $thiz
}
function $ct_ju_concurrent_ConcurrentHashMap__($thiz) {
  $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap() {
  this.ju_concurrent_ConcurrentHashMap__f_inner = null
}
$c_ju_concurrent_ConcurrentHashMap.prototype = new $h_ju_AbstractMap();
$c_ju_concurrent_ConcurrentHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap.prototype.size__I = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.ju_HashMap__f_contentSize
});
$c_ju_concurrent_ConcurrentHashMap.prototype.get__O__O = (function(key) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.get__O__O(key)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.put__O__O__O = (function(key, value) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.put__O__O__O(key, value)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.remove__O__O = (function(key) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.remove__O__O(key)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.values__ju_Collection = (function() {
  var this$1 = this.ju_concurrent_ConcurrentHashMap__f_inner;
  return new $c_ju_HashMap$Values(this$1)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.entrySet__ju_Set = (function() {
  var this$1 = this.ju_concurrent_ConcurrentHashMap__f_inner;
  return new $c_ju_HashMap$EntrySet(this$1)
});
$c_ju_concurrent_ConcurrentHashMap.prototype.hashCode__I = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.hashCode__I()
});
$c_ju_concurrent_ConcurrentHashMap.prototype.toString__T = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.toString__T()
});
$c_ju_concurrent_ConcurrentHashMap.prototype.equals__O__Z = (function(o) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.equals__O__Z(o)
});
var $d_ju_concurrent_ConcurrentHashMap = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap: 0
}, false, "java.util.concurrent.ConcurrentHashMap", {
  ju_concurrent_ConcurrentHashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  ju_concurrent_ConcurrentMap: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_ConcurrentHashMap.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap;
function $as_ju_concurrent_RejectedExecutionException(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "java.util.concurrent.RejectedExecutionException"))
}
function $isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_concurrent_RejectedExecutionException)))
}
function $asArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) {
  return (($isArrayOf_ju_concurrent_RejectedExecutionException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.util.concurrent.RejectedExecutionException;", depth))
}
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0)
}
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toNanos__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-129542144), 13);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 817405952, 838);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$1: 0
}, false, "java.util.concurrent.TimeUnit$$anon$1", {
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1)
}
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMicros__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-694967296), 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 500654080, 20);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$2: 0
}, false, "java.util.concurrent.TimeUnit$$anon$2", {
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2)
}
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMillis__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$3: 0
}, false, "java.util.concurrent.TimeUnit$$anon$3", {
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3)
}
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toSeconds__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000000, 0), new $c_RTLong(633437444, 2))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483))
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$4: 0
}, false, "java.util.concurrent.TimeUnit$$anon$4", {
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4)
}
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMinutes__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-129542144), 13), new $c_RTLong(153722867, 0))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000000, 0), new $c_RTLong((-895955376), 35))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000, 0), new $c_RTLong(1692789776, 35791))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1440, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$5: 0
}, false, "java.util.concurrent.TimeUnit$$anon$5", {
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5)
}
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toHours__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(817405952, 838), new $c_RTLong(2562047, 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-694967296), 0), new $c_RTLong((-1732919508), 0))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600000, 0), new $c_RTLong((-2047687697), 596))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600, 0), new $c_RTLong(1011703407, 596523))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394))
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a) {
  return a
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 24, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi)
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$6: 0
}, false, "java.util.concurrent.TimeUnit$$anon$6", {
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6)
}
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
  /*<skip>*/
}
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toDays__J__J(a)
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-1857093632), 20116), new $c_RTLong(106751, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(500654080, 20), new $c_RTLong(106751991, 0))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400000, 0), new $c_RTLong((-622191233), 24))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400, 0), new $c_RTLong(579025220, 24855))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1440, 0), new $c_RTLong(381774870, 1491308))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(24, 0), new $c_RTLong(1431655765, 89478485))
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a) {
  return a
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass({
  ju_concurrent_TimeUnit$$anon$7: 0
}, false, "java.util.concurrent.TimeUnit$$anon$7", {
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  O: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.$classData = $d_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $c_Lnet_andimiller_Msg() {
  /*<skip>*/
}
$c_Lnet_andimiller_Msg.prototype = new $h_O();
$c_Lnet_andimiller_Msg.prototype.constructor = $c_Lnet_andimiller_Msg;
/** @constructor */
function $h_Lnet_andimiller_Msg() {
  /*<skip>*/
}
$h_Lnet_andimiller_Msg.prototype = $c_Lnet_andimiller_Msg.prototype;
$c_Lnet_andimiller_Msg.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
function $as_Lnet_andimiller_Msg(obj) {
  return (((obj instanceof $c_Lnet_andimiller_Msg) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.Msg"))
}
function $isArrayOf_Lnet_andimiller_Msg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_Msg)))
}
function $asArrayOf_Lnet_andimiller_Msg(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_Msg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.Msg;", depth))
}
class $c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError extends $c_jl_VirtualMachineError {
  constructor(cause) {
    super();
    var message = ((cause === null) ? null : cause.toString__T());
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, cause, true, true)
  };
}
var $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError = new $TypeData().initClass({
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 0
}, false, "org.scalajs.linker.runtime.UndefinedBehaviorError", {
  Lorg_scalajs_linker_runtime_UndefinedBehaviorError: 1,
  jl_VirtualMachineError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Lorg_scalajs_linker_runtime_UndefinedBehaviorError.prototype.$classData = $d_Lorg_scalajs_linker_runtime_UndefinedBehaviorError;
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
  /*<skip>*/
}
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x
});
$c_s_$less$colon$less$$anon$1.prototype.andThen__F1__F1 = (function(r) {
  return r
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint"
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass({
  s_$less$colon$less$$anon$1: 0
}, false, "scala.$less$colon$less$$anon$1", {
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  O: 1,
  F1: 1,
  Ljava_io_Serializable: 1
});
$c_s_$less$colon$less$$anon$1.prototype.$classData = $d_s_$less$colon$less$$anon$1;
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    $thiz.s_MatchError__f_objString = (($thiz.s_MatchError__f_obj === null) ? "null" : $p_s_MatchError__liftedTree1$1__T($thiz));
    $thiz.s_MatchError__f_bitmap$0 = true
  };
  return $thiz.s_MatchError__f_objString
}
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString)
}
function $p_s_MatchError__ofClass$1__T($thiz) {
  var this$1 = $thiz.s_MatchError__f_obj;
  return ("of class " + $objectClassName(this$1))
}
function $p_s_MatchError__liftedTree1$1__T($thiz) {
  try {
    return ((($dp_toString__T($thiz.s_MatchError__f_obj) + " (") + $p_s_MatchError__ofClass$1__T($thiz)) + ")")
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      return ("an instance " + $p_s_MatchError__ofClass$1__T($thiz))
    } else {
      throw e
    }
  }
}
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.s_MatchError__f_objString = null;
    this.s_MatchError__f_obj = null;
    this.s_MatchError__f_bitmap$0 = false;
    this.s_MatchError__f_obj = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return $p_s_MatchError__objString__T(this)
  };
}
var $d_s_MatchError = new $TypeData().initClass({
  s_MatchError: 0
}, false, "scala.MatchError", {
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_s_MatchError.prototype.$classData = $d_s_MatchError;
/** @constructor */
function $c_s_Option() {
  /*<skip>*/
}
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
  /*<skip>*/
}
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$())
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1)
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    $m_sc_Iterator$();
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a)
  }
});
$c_s_Option.prototype.toList__sci_List = (function() {
  if (this.isEmpty__Z()) {
    $m_s_package$();
    var elems = $m_sci_Nil$();
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
  } else {
    return new $c_sci_$colon$colon(this.get__O(), $m_s_package$().s_package$__f_Nil)
  }
});
function $as_s_Option(obj) {
  return (((obj instanceof $c_s_Option) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Option"))
}
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)))
}
function $asArrayOf_s_Option(obj, depth) {
  return (($isArrayOf_s_Option(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Option;", depth))
}
var $d_s_Option = new $TypeData().initClass({
  s_Option: 0
}, false, "scala.Option", {
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_Option.prototype.$classData = $d_s_Option;
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = 0;
  this.s_Product$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.s_Product$$anon$1__f_$outer = outer
  };
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = outer.productArity__I()
}
$c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_s_Product$$anon$1.prototype.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
  /*<skip>*/
}
$h_s_Product$$anon$1.prototype = $c_s_Product$$anon$1.prototype;
$c_s_Product$$anon$1.prototype.hasNext__Z = (function() {
  return (this.s_Product$$anon$1__f_c < this.s_Product$$anon$1__f_cmax)
});
$c_s_Product$$anon$1.prototype.next__O = (function() {
  var result = this.s_Product$$anon$1__f_$outer.productElement__I__O(this.s_Product$$anon$1__f_c);
  this.s_Product$$anon$1__f_c = ((1 + this.s_Product$$anon$1__f_c) | 0);
  return result
});
var $d_s_Product$$anon$1 = new $TypeData().initClass({
  s_Product$$anon$1: 0
}, false, "scala.Product$$anon$1", {
  s_Product$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_s_Product$$anon$1.prototype.$classData = $d_s_Product$$anon$1;
/** @constructor */
function $c_T2(_1, _2) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2__f__1 = _1;
  this.T2__f__2 = _2
}
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
  /*<skip>*/
}
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n)
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")")
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2"
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T2.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T2)) {
    var Tuple2$1 = $as_T2(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), Tuple2$1._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), Tuple2$1._2__O()))
  } else {
    return false
  }
});
$c_T2.prototype._1$mcJ$sp__J = (function() {
  return $uJ(this._1__O())
});
function $as_T2(obj) {
  return (((obj instanceof $c_T2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple2"))
}
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)))
}
function $asArrayOf_T2(obj, depth) {
  return (($isArrayOf_T2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple2;", depth))
}
var $d_T2 = new $TypeData().initClass({
  T2: 0
}, false, "scala.Tuple2", {
  T2: 1,
  O: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T2.prototype.$classData = $d_T2;
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3
}
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
  /*<skip>*/
}
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n)
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")")
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3"
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T3.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T3)) {
    var Tuple3$1 = $as_T3(x$1);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, Tuple3$1.T3__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, Tuple3$1.T3__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, Tuple3$1.T3__f__3)))
  } else {
    return false
  }
});
function $as_T3(obj) {
  return (((obj instanceof $c_T3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple3"))
}
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)))
}
function $asArrayOf_T3(obj, depth) {
  return (($isArrayOf_T3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple3;", depth))
}
var $d_T3 = new $TypeData().initClass({
  T3: 0
}, false, "scala.Tuple3", {
  T3: 1,
  O: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T3.prototype.$classData = $d_T3;
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.T4__f__1 = null;
  this.T4__f__2 = null;
  this.T4__f__3 = null;
  this.T4__f__4 = null;
  this.T4__f__1 = _1;
  this.T4__f__2 = _2;
  this.T4__f__3 = _3;
  this.T4__f__4 = _4
}
$c_T4.prototype = new $h_O();
$c_T4.prototype.constructor = $c_T4;
/** @constructor */
function $h_T4() {
  /*<skip>*/
}
$h_T4.prototype = $c_T4.prototype;
$c_T4.prototype.productArity__I = (function() {
  return 4
});
$c_T4.prototype.productElement__I__O = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n)
});
$c_T4.prototype.toString__T = (function() {
  return (((((((("(" + this.T4__f__1) + ",") + this.T4__f__2) + ",") + this.T4__f__3) + ",") + this.T4__f__4) + ")")
});
$c_T4.prototype.productPrefix__T = (function() {
  return "Tuple4"
});
$c_T4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_T4.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_T4.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_T4)) {
    var Tuple4$1 = $as_T4(x$1);
    return (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__1, Tuple4$1.T4__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__2, Tuple4$1.T4__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__3, Tuple4$1.T4__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__4, Tuple4$1.T4__f__4)))
  } else {
    return false
  }
});
function $as_T4(obj) {
  return (((obj instanceof $c_T4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Tuple4"))
}
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T4)))
}
function $asArrayOf_T4(obj, depth) {
  return (($isArrayOf_T4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Tuple4;", depth))
}
var $d_T4 = new $TypeData().initClass({
  T4: 0
}, false, "scala.Tuple4", {
  T4: 1,
  O: 1,
  s_Product4: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_T4.prototype.$classData = $d_T4;
/** @constructor */
function $c_sc_BitSetOps$$anon$1(outer, start$1) {
  this.sc_BitSetOps$$anon$1__f_currentPos = 0;
  this.sc_BitSetOps$$anon$1__f_currentWord = $L0;
  this.sc_BitSetOps$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_BitSetOps$$anon$1__f_$outer = outer
  };
  this.sc_BitSetOps$$anon$1__f_currentPos = ((start$1 > 0) ? (start$1 >> 6) : 0);
  if ((start$1 > 0)) {
    var this$1 = outer.word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos);
    var n = (63 & start$1);
    var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
    var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    var $$x1 = new $c_RTLong(lo$1, hi$1)
  } else {
    var $$x1 = outer.word__I__J(0)
  };
  this.sc_BitSetOps$$anon$1__f_currentWord = $$x1
}
$c_sc_BitSetOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_BitSetOps$$anon$1.prototype.constructor = $c_sc_BitSetOps$$anon$1;
/** @constructor */
function $h_sc_BitSetOps$$anon$1() {
  /*<skip>*/
}
$h_sc_BitSetOps$$anon$1.prototype = $c_sc_BitSetOps$$anon$1.prototype;
$c_sc_BitSetOps$$anon$1.prototype.hasNext__Z = (function() {
  while (true) {
    var this$1 = this.sc_BitSetOps$$anon$1__f_currentWord;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      if ((((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0) >= this.sc_BitSetOps$$anon$1__f_$outer.nwords__I())) {
        return false
      };
      this.sc_BitSetOps$$anon$1__f_currentPos = ((1 + this.sc_BitSetOps$$anon$1__f_currentPos) | 0);
      this.sc_BitSetOps$$anon$1__f_currentWord = this.sc_BitSetOps$$anon$1__f_$outer.word__I__J(this.sc_BitSetOps$$anon$1__f_currentPos)
    } else {
      break
    }
  };
  return true
});
$c_sc_BitSetOps$$anon$1.prototype.next__I = (function() {
  if (this.hasNext__Z()) {
    var t = this.sc_BitSetOps$$anon$1__f_currentWord;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var bitPos = ((lo !== 0) ? ((lo === 0) ? 32 : ((31 - Math.clz32((lo & ((-lo) | 0)))) | 0)) : ((32 + ((hi === 0) ? 32 : ((31 - Math.clz32((hi & ((-hi) | 0)))) | 0))) | 0));
    var this$5 = this.sc_BitSetOps$$anon$1__f_currentWord;
    var b = this.sc_BitSetOps$$anon$1__f_currentWord;
    var bhi = b.RTLong__f_hi;
    var lo$1 = (((-1) + b.RTLong__f_lo) | 0);
    var hi$1 = ((lo$1 !== (-1)) ? bhi : (((-1) + bhi) | 0));
    var lo$2 = (this$5.RTLong__f_lo & lo$1);
    var hi$2 = (this$5.RTLong__f_hi & hi$1);
    this.sc_BitSetOps$$anon$1__f_currentWord = new $c_RTLong(lo$2, hi$2);
    return (((this.sc_BitSetOps$$anon$1__f_currentPos << 6) + bitPos) | 0)
  } else {
    return $uI($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
  }
});
$c_sc_BitSetOps$$anon$1.prototype.next__O = (function() {
  return this.next__I()
});
var $d_sc_BitSetOps$$anon$1 = new $TypeData().initClass({
  sc_BitSetOps$$anon$1: 0
}, false, "scala.collection.BitSetOps$$anon$1", {
  sc_BitSetOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_BitSetOps$$anon$1.prototype.$classData = $d_sc_BitSetOps$$anon$1;
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate)
}
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
  /*<skip>*/
}
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass({
  sc_ClassTagSeqFactory$AnySeqDelegate: 0
}, false, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", {
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  O: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
});
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.$classData = $d_sc_ClassTagSeqFactory$AnySeqDelegate;
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n))
}
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Map($thiz, f))
}
function $f_sc_Iterable__toString__T($thiz) {
  var start = ($thiz.className__T() + "(");
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, ", ", ")")
}
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)))
}
function $as_sc_Iterable(obj) {
  return (($is_sc_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterable"))
}
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)))
}
function $asArrayOf_sc_Iterable(obj, depth) {
  return (($isArrayOf_sc_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterable;", depth))
}
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = null;
  $thiz.sc_Iterator$$anon$10__f_cur = $as_sc_IterableOnce($thiz.sc_Iterator$$anon$10__f_f$3.apply__O__O($thiz.sc_Iterator$$anon$10__f_$outer.next__O())).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1)
}
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$10__f_$outer = outer
  };
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1)
}
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!this.sc_Iterator$$anon$10__f_cur.hasNext__Z())) {
      if ((!this.sc_Iterator$$anon$10__f_$outer.hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false
      };
      $p_sc_Iterator$$anon$10__nextCur__V(this)
    };
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1)
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1)
  };
  return this.sc_Iterator$$anon$10__f_cur.next__O()
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass({
  sc_Iterator$$anon$10: 0
}, false, "scala.collection.Iterator$$anon$10", {
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$10.prototype.$classData = $d_sc_Iterator$$anon$10;
/** @constructor */
function $c_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_Iterator$$anon$19.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return this
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E()
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass({
  sc_Iterator$$anon$19: 0
}, false, "scala.collection.Iterator$$anon$19", {
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$19.prototype.$classData = $d_sc_Iterator$$anon$19;
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false
}
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed)
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1
  }
});
$c_sc_Iterator$$anon$20.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return (((this.sc_Iterator$$anon$20__f_consumed || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : this)
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass({
  sc_Iterator$$anon$20: 0
}, false, "scala.collection.Iterator$$anon$20", {
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$20.prototype.$classData = $d_sc_Iterator$$anon$20;
/** @constructor */
function $c_sc_Iterator$$anon$6(outer, p$1, isFlipped$1) {
  this.sc_Iterator$$anon$6__f_hd = null;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
  this.sc_Iterator$$anon$6__f_$outer = null;
  this.sc_Iterator$$anon$6__f_p$1 = null;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = false;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$6__f_$outer = outer
  };
  this.sc_Iterator$$anon$6__f_p$1 = p$1;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = isFlipped$1;
  this.sc_Iterator$$anon$6__f_hdDefined = false
}
$c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$6.prototype.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$6.prototype = $c_sc_Iterator$$anon$6.prototype;
$c_sc_Iterator$$anon$6.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$6__f_hdDefined) {
    return true
  } else {
    if ((!this.sc_Iterator$$anon$6__f_$outer.hasNext__Z())) {
      return false
    };
    this.sc_Iterator$$anon$6__f_hd = this.sc_Iterator$$anon$6__f_$outer.next__O();
    while (($uZ(this.sc_Iterator$$anon$6__f_p$1.apply__O__O(this.sc_Iterator$$anon$6__f_hd)) === this.sc_Iterator$$anon$6__f_isFlipped$1)) {
      if ((!this.sc_Iterator$$anon$6__f_$outer.hasNext__Z())) {
        return false
      };
      this.sc_Iterator$$anon$6__f_hd = this.sc_Iterator$$anon$6__f_$outer.next__O()
    };
    this.sc_Iterator$$anon$6__f_hdDefined = true;
    return true
  }
});
$c_sc_Iterator$$anon$6.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$6__f_hdDefined = false;
    return this.sc_Iterator$$anon$6__f_hd
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().initClass({
  sc_Iterator$$anon$6: 0
}, false, "scala.collection.Iterator$$anon$6", {
  sc_Iterator$$anon$6: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$6.prototype.$classData = $d_sc_Iterator$$anon$6;
/** @constructor */
function $c_sc_Iterator$$anon$8(outer, f$1) {
  this.sc_Iterator$$anon$8__f_traversedValues = null;
  this.sc_Iterator$$anon$8__f_nextElementDefined = false;
  this.sc_Iterator$$anon$8__f_nextElement = null;
  this.sc_Iterator$$anon$8__f_$outer = null;
  this.sc_Iterator$$anon$8__f_f$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$8__f_$outer = outer
  };
  this.sc_Iterator$$anon$8__f_f$1 = f$1;
  this.sc_Iterator$$anon$8__f_traversedValues = $ct_scm_HashSet__(new $c_scm_HashSet());
  this.sc_Iterator$$anon$8__f_nextElementDefined = false
}
$c_sc_Iterator$$anon$8.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$8.prototype.constructor = $c_sc_Iterator$$anon$8;
/** @constructor */
function $h_sc_Iterator$$anon$8() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$8.prototype = $c_sc_Iterator$$anon$8.prototype;
$c_sc_Iterator$$anon$8.prototype.hasNext__Z = (function() {
  while (true) {
    if (this.sc_Iterator$$anon$8__f_nextElementDefined) {
      return true
    } else if (this.sc_Iterator$$anon$8__f_$outer.hasNext__Z()) {
      var a = this.sc_Iterator$$anon$8__f_$outer.next__O();
      if (this.sc_Iterator$$anon$8__f_traversedValues.add__O__Z(this.sc_Iterator$$anon$8__f_f$1.apply__O__O(a))) {
        this.sc_Iterator$$anon$8__f_nextElement = a;
        this.sc_Iterator$$anon$8__f_nextElementDefined = true;
        return true
      }
    } else {
      return false
    }
  }
});
$c_sc_Iterator$$anon$8.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$8__f_nextElementDefined = false;
    return this.sc_Iterator$$anon$8__f_nextElement
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_Iterator$$anon$8 = new $TypeData().initClass({
  sc_Iterator$$anon$8: 0
}, false, "scala.collection.Iterator$$anon$8", {
  sc_Iterator$$anon$8: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$8.prototype.$classData = $d_sc_Iterator$$anon$8;
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$9__f_$outer = outer
  };
  this.sc_Iterator$$anon$9__f_f$2 = f$2
}
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.knownSize__I()
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.hasNext__Z()
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return this.sc_Iterator$$anon$9__f_f$2.apply__O__O(this.sc_Iterator$$anon$9__f_$outer.next__O())
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass({
  sc_Iterator$$anon$9: 0
}, false, "scala.collection.Iterator$$anon$9", {
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$$anon$9.prototype.$classData = $d_sc_Iterator$$anon$9;
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
    var c = $as_sc_Iterator$ConcatIterator($thiz.sc_Iterator$ConcatIterator__f_current);
    $thiz.sc_Iterator$ConcatIterator__f_current = c.sc_Iterator$ConcatIterator__f_current;
    $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = c.sc_Iterator$ConcatIterator__f_currentHasNextChecked;
    if ((c.sc_Iterator$ConcatIterator__f_tail !== null)) {
      if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = c.sc_Iterator$ConcatIterator__f_last
      };
      c.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
      $thiz.sc_Iterator$ConcatIterator__f_tail = c.sc_Iterator$ConcatIterator__f_tail
    }
  }
}
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $thiz.sc_Iterator$ConcatIterator__f_tail.headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $thiz.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail
      };
      $thiz.sc_Iterator$ConcatIterator__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail.sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true
      } else if ((($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $thiz.sc_Iterator$ConcatIterator__f_current.hasNext__Z())) {
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true
      }
    }
  }
}
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false
}
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
  /*<skip>*/
}
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if (this.sc_Iterator$ConcatIterator__f_current.hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this)
    }
  } else {
    return false
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return this.sc_Iterator$ConcatIterator__f_current.next__O()
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  } else {
    this.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c
  };
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  };
  return this
});
function $as_sc_Iterator$ConcatIterator(obj) {
  return (((obj instanceof $c_sc_Iterator$ConcatIterator) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Iterator$ConcatIterator"))
}
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)))
}
function $asArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (($isArrayOf_sc_Iterator$ConcatIterator(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Iterator$ConcatIterator;", depth))
}
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass({
  sc_Iterator$ConcatIterator: 0
}, false, "scala.collection.Iterator$ConcatIterator", {
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$ConcatIterator.prototype.$classData = $d_sc_Iterator$ConcatIterator;
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.sc_Iterator$SliceIterator__f_dropping > 0)) {
    if ($thiz.sc_Iterator$SliceIterator__f_underlying.hasNext__Z()) {
      $thiz.sc_Iterator$SliceIterator__f_underlying.next__O();
      $thiz.sc_Iterator$SliceIterator__f_dropping = (((-1) + $thiz.sc_Iterator$SliceIterator__f_dropping) | 0)
    } else {
      $thiz.sc_Iterator$SliceIterator__f_dropping = 0
    }
  }
}
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    return (-1)
  } else {
    var that = (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - lo$1) | 0);
    return ((that < 0) ? 0 : that)
  }
}
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.sc_Iterator$SliceIterator__f_underlying = null;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
  this.sc_Iterator$SliceIterator__f_dropping = 0;
  this.sc_Iterator$SliceIterator__f_underlying = underlying;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = limit;
  this.sc_Iterator$SliceIterator__f_dropping = start
}
$c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$SliceIterator.prototype.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
  /*<skip>*/
}
$h_sc_Iterator$SliceIterator.prototype = $c_sc_Iterator$SliceIterator.prototype;
$c_sc_Iterator$SliceIterator.prototype.knownSize__I = (function() {
  var size = this.sc_Iterator$SliceIterator__f_underlying.knownSize__I();
  if ((size < 0)) {
    return (-1)
  } else {
    var that = ((size - this.sc_Iterator$SliceIterator__f_dropping) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
      return dropSize
    } else {
      var x = this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining;
      return ((x < dropSize) ? x : dropSize)
    }
  }
});
$c_sc_Iterator$SliceIterator.prototype.hasNext__Z = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining !== 0) && this.sc_Iterator$SliceIterator__f_underlying.hasNext__Z())
});
$c_sc_Iterator$SliceIterator.prototype.next__O = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining > 0)) {
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = (((-1) + this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining) | 0);
    return this.sc_Iterator$SliceIterator__f_underlying.next__O()
  } else {
    return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0) ? this.sc_Iterator$SliceIterator__f_underlying.next__O() : $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
  }
});
$c_sc_Iterator$SliceIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo)
  } else if ((until <= lo)) {
    var rest = 0
  } else if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    var rest = ((until - lo) | 0)
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that)
  };
  if ((rest === 0)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    this.sc_Iterator$SliceIterator__f_dropping = ((this.sc_Iterator$SliceIterator__f_dropping + lo) | 0);
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = rest;
    return this
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().initClass({
  sc_Iterator$SliceIterator: 0
}, false, "scala.collection.Iterator$SliceIterator", {
  sc_Iterator$SliceIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$SliceIterator.prototype.$classData = $d_sc_Iterator$SliceIterator;
/** @constructor */
function $c_sc_Iterator$UnfoldIterator(init, f) {
  this.sc_Iterator$UnfoldIterator__f_f = null;
  this.sc_Iterator$UnfoldIterator__f_state = null;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null;
  this.sc_Iterator$UnfoldIterator__f_f = f;
  this.sc_Iterator$UnfoldIterator__f_state = init;
  this.sc_Iterator$UnfoldIterator__f_nextResult = null
}
$c_sc_Iterator$UnfoldIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$UnfoldIterator.prototype.constructor = $c_sc_Iterator$UnfoldIterator;
/** @constructor */
function $h_sc_Iterator$UnfoldIterator() {
  /*<skip>*/
}
$h_sc_Iterator$UnfoldIterator.prototype = $c_sc_Iterator$UnfoldIterator.prototype;
$c_sc_Iterator$UnfoldIterator.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$UnfoldIterator__f_nextResult === null)) {
    var res = $as_s_Option(this.sc_Iterator$UnfoldIterator__f_f.apply__O__O(this.sc_Iterator$UnfoldIterator__f_state));
    if ((res === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "null during unfold")
    };
    this.sc_Iterator$UnfoldIterator__f_nextResult = res;
    this.sc_Iterator$UnfoldIterator__f_state = null
  };
  var this$1 = this.sc_Iterator$UnfoldIterator__f_nextResult;
  return (!this$1.isEmpty__Z())
});
$c_sc_Iterator$UnfoldIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var x1 = $as_T2(this.sc_Iterator$UnfoldIterator__f_nextResult.get__O());
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1)
    };
    var value = x1._1__O();
    var newState = x1._2__O();
    this.sc_Iterator$UnfoldIterator__f_state = newState;
    this.sc_Iterator$UnfoldIterator__f_nextResult = null;
    return value
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_Iterator$UnfoldIterator = new $TypeData().initClass({
  sc_Iterator$UnfoldIterator: 0
}, false, "scala.collection.Iterator$UnfoldIterator", {
  sc_Iterator$UnfoldIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_Iterator$UnfoldIterator.prototype.$classData = $d_sc_Iterator$UnfoldIterator;
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0(((initialHead) => (() => initialHead))(coll)))
}
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
  /*<skip>*/
}
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
  return (!this$1.isEmpty__Z())
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var cur = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
    var result = cur.head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sjsr_AnonFunction0(((cur$1) => (() => $as_sc_LinearSeq(cur$1.tail__O())))(cur)));
    return result
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass({
  sc_LinearSeqIterator: 0
}, false, "scala.collection.LinearSeqIterator", {
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_LinearSeqIterator.prototype.$classData = $d_sc_LinearSeqIterator;
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz))
}
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $as_sc_LinearSeq($thiz);
  var len = 0;
  while (true) {
    var this$1 = these;
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = $as_sc_LinearSeq(these.tail__O())
    } else {
      break
    }
  };
  return len
}
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $as_sc_LinearSeq($thiz), len))
}
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0))
}
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  var skipped = $as_sc_LinearSeq($thiz.drop__I__O(n));
  if (skipped.isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  return skipped.head__O()
}
function $f_sc_LinearSeqOps__foreach__F1__V($thiz, f) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = $as_sc_LinearSeq(these.tail__O())
  }
}
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    if ($uZ(p.apply__O__O(these.head__O()))) {
      return true
    };
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return false
}
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $as_sc_LinearSeq($thiz);
  while ((!these.isEmpty__Z())) {
    acc = op.apply__O__O__O(acc, these.head__O());
    these = $as_sc_LinearSeq(these.tail__O())
  };
  return acc
}
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  if ($is_sc_LinearSeq(that)) {
    var x2 = $as_sc_LinearSeq(that);
    return $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $as_sc_LinearSeq($thiz), x2)
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that)
  }
}
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $as_sc_LinearSeq($thiz.drop__I__O(from));
  while (true) {
    var this$3 = these;
    if ((!this$3.isEmpty__Z())) {
      if ($uZ(p.apply__O__O(these.head__O()))) {
        return i
      };
      i = ((1 + i) | 0);
      these = $as_sc_LinearSeq(these.tail__O())
    } else {
      break
    }
  };
  return (-1)
}
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1)
    } else if (xs.isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sc_LinearSeq(xs.tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var this$1 = a;
      if ((!this$1.isEmpty__Z())) {
        var this$2 = b;
        var $$x1 = (!this$2.isEmpty__Z())
      } else {
        var $$x1 = false
      };
      if (($$x1 && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = $as_sc_LinearSeq(a.tail__O());
        var temp$b = $as_sc_LinearSeq(b.tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (a.isEmpty__Z() && b.isEmpty__Z())
      }
    }
  }
}
function $is_sc_LinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeqOps)))
}
function $as_sc_LinearSeqOps(obj) {
  return (($is_sc_LinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeqOps"))
}
function $isArrayOf_sc_LinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeqOps)))
}
function $asArrayOf_sc_LinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_LinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeqOps;", depth))
}
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.sc_MapOps$$anon$3__f_iter = null;
  this.sc_MapOps$$anon$3__f_iter = outer.iterator__sc_Iterator()
}
$c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$3.prototype.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
  /*<skip>*/
}
$h_sc_MapOps$$anon$3.prototype = $c_sc_MapOps$$anon$3.prototype;
$c_sc_MapOps$$anon$3.prototype.hasNext__Z = (function() {
  return this.sc_MapOps$$anon$3__f_iter.hasNext__Z()
});
$c_sc_MapOps$$anon$3.prototype.next__O = (function() {
  return $as_T2(this.sc_MapOps$$anon$3__f_iter.next__O())._2__O()
});
var $d_sc_MapOps$$anon$3 = new $TypeData().initClass({
  sc_MapOps$$anon$3: 0
}, false, "scala.collection.MapOps$$anon$3", {
  sc_MapOps$$anon$3: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_MapOps$$anon$3.prototype.$classData = $d_sc_MapOps$$anon$3;
/** @constructor */
function $c_sc_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Seq$())
}
$c_sc_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sc_Seq$.prototype.constructor = $c_sc_Seq$;
/** @constructor */
function $h_sc_Seq$() {
  /*<skip>*/
}
$h_sc_Seq$.prototype = $c_sc_Seq$.prototype;
var $d_sc_Seq$ = new $TypeData().initClass({
  sc_Seq$: 0
}, false, "scala.collection.Seq$", {
  sc_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sc_Seq$.prototype.$classData = $d_sc_Seq$;
var $n_sc_Seq$;
function $m_sc_Seq$() {
  if ((!$n_sc_Seq$)) {
    $n_sc_Seq$ = new $c_sc_Seq$()
  };
  return $n_sc_Seq$
}
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ($is_sc_Iterable(that)) {
    var x2 = $as_sc_Iterable(that);
    var $$x1 = new $c_sc_View$Concat($thiz, x2)
  } else {
    var $$x1 = $thiz.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0(((that$1) => (() => that$1.iterator__sc_Iterator()))(that)))
  };
  return $as_sc_SetOps($thiz.fromSpecific__sc_IterableOnce__O($$x1))
}
function $is_sc_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SetOps)))
}
function $as_sc_SetOps(obj) {
  return (($is_sc_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SetOps"))
}
function $isArrayOf_sc_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SetOps)))
}
function $asArrayOf_sc_SetOps(obj, depth) {
  return (($isArrayOf_sc_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SetOps;", depth))
}
/** @constructor */
function $c_sc_SortedIterableFactory$Delegate() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null
}
$c_sc_SortedIterableFactory$Delegate.prototype = new $h_sc_EvidenceIterableFactory$Delegate();
$c_sc_SortedIterableFactory$Delegate.prototype.constructor = $c_sc_SortedIterableFactory$Delegate;
/** @constructor */
function $h_sc_SortedIterableFactory$Delegate() {
  /*<skip>*/
}
$h_sc_SortedIterableFactory$Delegate.prototype = $c_sc_SortedIterableFactory$Delegate.prototype;
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer
}
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.isEmpty__Z())
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = $as_sc_StrictOptimizedLinearSeqOps(this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.tail__O());
  return r
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 0
}, false, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", {
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.$classData = $d_sc_StrictOptimizedLinearSeqOps$$anon$1;
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  while (true) {
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$ = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var c = (65535 & $uI(this$.charCodeAt(i)));
      var $$x1 = (!((c === 13) || (c === 10)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0)
    } else {
      break
    }
  };
  var end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var this$$2 = $thiz.sc_StringOps$$anon$1__f_$this$2;
    var i$1 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    var c$1 = (65535 & $uI(this$$2.charCodeAt(i$1)));
    $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$$3 = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i$2 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var c$2 = (65535 & $uI(this$$3.charCodeAt(i$2)));
      var $$x2 = ((c$1 === 13) && (c$2 === 10))
    } else {
      var $$x2 = false
    };
    if ($$x2) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0)
    };
    if ((!$thiz.sc_StringOps$$anon$1__f_stripped$1)) {
      end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index
    }
  };
  var this$6 = $thiz.sc_StringOps$$anon$1__f_$this$2;
  var endIndex = end;
  return $as_T(this$6.substring(start, endIndex))
}
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = 0;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
  this.sc_StringOps$$anon$1__f_$this$2 = null;
  this.sc_StringOps$$anon$1__f_stripped$1 = false;
  this.sc_StringOps$$anon$1__f_$this$2 = \u03b4this$2;
  this.sc_StringOps$$anon$1__f_stripped$1 = stripped$1;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = $uI(\u03b4this$2.length);
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0
}
$c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StringOps$$anon$1.prototype.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
  /*<skip>*/
}
$h_sc_StringOps$$anon$1.prototype = $c_sc_StringOps$$anon$1.prototype;
$c_sc_StringOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)
});
$c_sc_StringOps$$anon$1.prototype.next__T = (function() {
  return ((this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index >= this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len) ? $as_T($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()) : $p_sc_StringOps$$anon$1__advance__T(this))
});
$c_sc_StringOps$$anon$1.prototype.next__O = (function() {
  return this.next__T()
});
var $d_sc_StringOps$$anon$1 = new $TypeData().initClass({
  sc_StringOps$$anon$1: 0
}, false, "scala.collection.StringOps$$anon$1", {
  sc_StringOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sc_StringOps$$anon$1.prototype.$classData = $d_sc_StringOps$$anon$1;
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null)
}
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result
}
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = bm.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  dst.set(idx, key);
  dst.set(((1 + idx) | 0), value);
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  src.copyTo(idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedMapNode__f_dataMap = (bm.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedMapNode__f_content = dst;
  bm.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedMapNode__f_size = ((1 + bm.sci_BitmapIndexedMapNode__f_size) | 0);
  bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashMapBuilder__f_aliased = null
}
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.copy__sci_BitmapIndexedMapNode()
}
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
  /*<skip>*/
}
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var x2 = $as_sci_BitmapIndexedMapNode(mapNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((x2.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = x2.getKey__I__O(index);
      var key0UnimprovedHash = x2.getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        x2.sci_BitmapIndexedMapNode__f_content.set(((1 + (index << 1)) | 0), value)
      } else {
        var value0 = x2.getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = x2.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        x2.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew)
      }
    } else if (((x2.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = x2.getNode__I__sci_MapNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHash = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      x2.sci_BitmapIndexedMapNode__f_size = ((x2.sci_BitmapIndexedMapNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((x2.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0)
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, x2, bitpos, key, originalHash, keyHash, value)
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var x3 = $as_sci_HashCollisionMapNode(mapNode);
    var index$3 = x3.indexOf__O__I(key);
    if ((index$3 < 0)) {
      x3.sci_HashCollisionMapNode__f_content = x3.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector(new $c_T2(key, value))
    } else {
      x3.sci_HashCollisionMapNode__f_content = x3.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index$3, new $c_T2(key, value))
    }
  } else {
    throw new $c_s_MatchError(mapNode)
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if ((this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = elem._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem._1__O(), elem._2__O(), h, im, 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    new $c_sci_HashMapBuilder$$anon$1(this, x2)
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = x3.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, hash, 0)
    }
  } else if ($is_sci_Map(xs)) {
    var x4 = $as_sci_Map(xs);
    x4.foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((this$1) => ((key$2, value$2) => this$1.addOne__O__O__sci_HashMapBuilder(key$2, value$2)))(this)))
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder($as_T2(it.next__O()))
    }
  };
  return this
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(xs)
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder($as_T2(elem))
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap()
});
var $d_sci_HashMapBuilder = new $TypeData().initClass({
  sci_HashMapBuilder: 0
}, false, "scala.collection.immutable.HashMapBuilder", {
  sci_HashMapBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashMapBuilder.prototype.$classData = $d_sci_HashMapBuilder;
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null)
}
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException())
  };
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.set(ix, elem);
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result
}
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var src = bm.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  dst.set(dataIx, key);
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  src.copyTo(dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedSetNode__f_dataMap = (bm.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedSetNode__f_content = dst;
  bm.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedSetNode__f_size = ((1 + bm.sci_BitmapIndexedSetNode__f_size) | 0);
  bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0)
}
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  bm.sci_BitmapIndexedSetNode__f_content.set(dataIx, elem)
}
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz)
  };
  $thiz.sci_HashSetBuilder__f_aliased = null
}
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.copy__sci_BitmapIndexedSetNode()
}
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0)
}
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
  /*<skip>*/
}
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var x2 = $as_sci_BitmapIndexedSetNode(setNode);
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((x2.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = x2.getPayload__I__O(index);
      var element0UnimprovedHash = x2.getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, x2, bitpos, element0)
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = x2.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        x2.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew)
      }
    } else if (((x2.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(x2.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = x2.getNode__I__sci_SetNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHashCode = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      x2.sci_BitmapIndexedSetNode__f_size = ((x2.sci_BitmapIndexedSetNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((x2.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0)
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, x2, bitpos, element, originalHash, elementHash)
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var x3 = $as_sci_HashCollisionSetNode(setNode);
    var this$1 = x3.sci_HashCollisionSetNode__f_content;
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      x3.sci_HashCollisionSetNode__f_content = x3.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)
    } else {
      x3.sci_HashCollisionSetNode__f_content = x3.sci_HashCollisionSetNode__f_content.updated__I__O__sci_Vector(index$3, element)
    }
  } else {
    throw new $c_s_MatchError(setNode)
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if ((this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    new $c_sci_HashSetBuilder$$anon$1(this, x2)
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder(it.next__O())
    }
  };
  return this
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(xs)
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem)
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet()
});
var $d_sci_HashSetBuilder = new $TypeData().initClass({
  sci_HashSetBuilder: 0
}, false, "scala.collection.immutable.HashSetBuilder", {
  sci_HashSetBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_HashSetBuilder.prototype.$classData = $d_sci_HashSetBuilder;
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$())
}
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
  /*<skip>*/
}
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  if ($is_sci_IndexedSeq(it)) {
    var x2 = $as_sci_IndexedSeq(it);
    return x2
  } else {
    return $as_sci_IndexedSeq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source)
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it)
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass({
  sci_IndexedSeq$: 0
}, false, "scala.collection.immutable.IndexedSeq$", {
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_IndexedSeq$.prototype.$classData = $d_sci_IndexedSeq$;
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$()
  };
  return $n_sci_IndexedSeq$
}
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V()
}
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
  /*<skip>*/
}
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0(((deferred$1) => (() => deferred$1.eval__sci_LazyList$State()))(deferred));
  this.sci_LazyList$LazyBuilder__f_list = new $c_sci_LazyList(state);
  this.sci_LazyList$LazyBuilder__f_next = deferred
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0((() => $m_sci_LazyList$State$Empty$())));
  return this.sci_LazyList$LazyBuilder__f_list
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0(((elem$1, deferred$1) => (() => {
    $m_sci_LazyList$();
    $m_sci_LazyList$();
    var state = new $c_sjsr_AnonFunction0(((deferred$2) => (() => deferred$2.eval__sci_LazyList$State()))(deferred$1));
    var tl = new $c_sci_LazyList(state);
    return new $c_sci_LazyList$State$Cons(elem$1, tl)
  }))(elem, deferred)));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if ((xs.knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sjsr_AnonFunction0(((xs$1, deferred$1) => (() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIteratorConcatSuffix__sc_Iterator__F0__sci_LazyList$State(xs$1.iterator__sc_Iterator(), new $c_sjsr_AnonFunction0(((deferred$3) => (() => deferred$3.eval__sci_LazyList$State()))(deferred$1)))))(xs, deferred)));
    this.sci_LazyList$LazyBuilder__f_next = deferred
  };
  return this
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(xs)
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem)
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList()
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass({
  sci_LazyList$LazyBuilder: 0
}, false, "scala.collection.immutable.LazyList$LazyBuilder", {
  sci_LazyList$LazyBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_LazyList$LazyBuilder.prototype.$classData = $d_sci_LazyList$LazyBuilder;
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList
}
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
  /*<skip>*/
}
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  return (!this.sci_LazyList$LazyIterator__f_lazyList.isEmpty__Z())
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  if (this.sci_LazyList$LazyIterator__f_lazyList.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var this$1 = this.sci_LazyList$LazyIterator__f_lazyList;
    var res = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    var this$2 = this.sci_LazyList$LazyIterator__f_lazyList;
    this.sci_LazyList$LazyIterator__f_lazyList = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    return res
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass({
  sci_LazyList$LazyIterator: 0
}, false, "scala.collection.immutable.LazyList$LazyIterator", {
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_LazyList$LazyIterator.prototype.$classData = $d_sci_LazyList$LazyIterator;
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = new $c_T2($m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1()
}
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
  /*<skip>*/
}
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer()
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$()
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source)
});
var $d_sci_List$ = new $TypeData().initClass({
  sci_List$: 0
}, false, "scala.collection.immutable.List$", {
  sci_List$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_List$.prototype.$classData = $d_sci_List$;
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$()
  };
  return $n_sci_List$
}
function $ct_sci_LongMapIterator__sci_LongMap__($thiz, it) {
  $thiz.sci_LongMapIterator__f_index = 0;
  $thiz.sci_LongMapIterator__f_buffer = new $ac_O(65);
  $thiz.push__sci_LongMap__V(it);
  return $thiz
}
/** @constructor */
function $c_sci_LongMapIterator() {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null
}
$c_sci_LongMapIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LongMapIterator.prototype.constructor = $c_sci_LongMapIterator;
/** @constructor */
function $h_sci_LongMapIterator() {
  /*<skip>*/
}
$h_sci_LongMapIterator.prototype = $c_sci_LongMapIterator.prototype;
$c_sci_LongMapIterator.prototype.pop__sci_LongMap = (function() {
  this.sci_LongMapIterator__f_index = (((-1) + this.sci_LongMapIterator__f_index) | 0);
  return $as_sci_LongMap(this.sci_LongMapIterator__f_buffer.get(this.sci_LongMapIterator__f_index))
});
$c_sci_LongMapIterator.prototype.push__sci_LongMap__V = (function(x) {
  this.sci_LongMapIterator__f_buffer.set(this.sci_LongMapIterator__f_index, x);
  this.sci_LongMapIterator__f_index = ((1 + this.sci_LongMapIterator__f_index) | 0)
});
$c_sci_LongMapIterator.prototype.hasNext__Z = (function() {
  return (this.sci_LongMapIterator__f_index !== 0)
});
$c_sci_LongMapIterator.prototype.next__O = (function() {
  while (true) {
    var rc16 = false;
    var x2 = null;
    var x1 = this.pop__sci_LongMap();
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      rc16 = true;
      x2 = $as_sci_LongMap$Bin(x1);
      var t = x2.sci_LongMap$Bin__f_left;
      var right = x2.sci_LongMap$Bin__f_right;
      if ((t instanceof $c_sci_LongMap$Tip)) {
        var x5 = $as_sci_LongMap$Tip(t);
        this.push__sci_LongMap__V(right);
        return this.valueOf__sci_LongMap$Tip__O(x5)
      }
    };
    if (rc16) {
      var left = x2.sci_LongMap$Bin__f_left;
      var right$2 = x2.sci_LongMap$Bin__f_right;
      this.push__sci_LongMap__V(right$2);
      this.push__sci_LongMap__V(left);
      continue
    };
    if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var x11 = $as_sci_LongMap$Tip(x1);
      return this.valueOf__sci_LongMap$Tip__O(x11)
    };
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(x1)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Empty maps not allowed as subtrees")
    };
    throw new $c_s_MatchError(x1)
  }
});
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null
}
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2)
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null
}
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3)
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
      break
    }
    case 2: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer
  };
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz
}
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null
}
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
  /*<skip>*/
}
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4)
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
      break
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
      break
    }
    case 2: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
      break
    }
    case 3: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
      break
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    }
  };
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false
}
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
  /*<skip>*/
}
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? this.sci_MapBuilderImpl__f_hashMapBuilder.result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value)
  } else if ((this.sci_MapBuilderImpl__f_elems.size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map(this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value))
  } else if (this.sci_MapBuilderImpl__f_elems.contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = $as_sci_Map(this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value))
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder()
    };
    $as_sci_Map$Map4(this.sci_MapBuilderImpl__f_elems).buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value)
  };
  return this
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? (this.sci_MapBuilderImpl__f_hashMapBuilder.addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $as_sci_MapBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(xs)
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  var elem$1 = $as_T2(elem);
  return this.addOne__O__O__sci_MapBuilderImpl(elem$1._1__O(), elem$1._2__O())
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map()
});
function $as_sci_MapBuilderImpl(obj) {
  return (((obj instanceof $c_sci_MapBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.MapBuilderImpl"))
}
function $isArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapBuilderImpl)))
}
function $asArrayOf_sci_MapBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_MapBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.MapBuilderImpl;", depth))
}
var $d_sci_MapBuilderImpl = new $TypeData().initClass({
  sci_MapBuilderImpl: 0
}, false, "scala.collection.immutable.MapBuilderImpl", {
  sci_MapBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_MapBuilderImpl.prototype.$classData = $d_sci_MapBuilderImpl;
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0
}
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyValueTupleHashIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_MapKeyValueTupleHashIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyValueTupleHashIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $$x2 = $m_s_util_hashing_MurmurHash3$();
  var $$x1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $$x2.tuple2Hash__I__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x), (-889275714))
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.sci_MapKeyValueTupleHashIterator__f_hash = this.sci_ChampBaseReverseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = $as_sci_MapNode(this.sci_ChampBaseReverseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return this
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator()
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleHashIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleHashIterator", {
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleHashIterator.prototype.$classData = $d_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
  /*<skip>*/
}
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapKeyValueTupleIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapKeyValueTupleIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapKeyValueTupleIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_MapKeyValueTupleIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapKeyValueTupleIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sci_MapKeyValueTupleIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapKeyValueTupleIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sci_MapKeyValueTupleIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapKeyValueTupleIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var payload = $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2()
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass({
  sci_MapKeyValueTupleIterator: 0
}, false, "scala.collection.immutable.MapKeyValueTupleIterator", {
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapKeyValueTupleIterator.prototype.$classData = $d_sci_MapKeyValueTupleIterator;
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapValueIterator.prototype.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
  /*<skip>*/
}
$h_sci_MapValueIterator.prototype = $c_sci_MapValueIterator.prototype;
$c_sci_MapValueIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_MapValueIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_MapValueIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_MapValueIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_MapValueIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_MapValueIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sci_MapValueIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_MapValueIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sci_MapValueIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_MapValueIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_MapValueIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var value = $as_sci_MapNode(this.sci_ChampBaseIterator__f_currentValueNode).getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return value
});
var $d_sci_MapValueIterator = new $TypeData().initClass({
  sci_MapValueIterator: 0
}, false, "scala.collection.immutable.MapValueIterator", {
  sci_MapValueIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_MapValueIterator.prototype.$classData = $d_sci_MapValueIterator;
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  };
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while ((slice.u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx)
  };
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = ((count / 2) | 0);
  var a = ((idx - c) | 0);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = $asArrayOf_O(slice, 2);
      break
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = $asArrayOf_O(slice, 3);
      break
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = $asArrayOf_O(slice, 4);
      break
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = $asArrayOf_O(slice, 5);
      break
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = $asArrayOf_O(slice, 6);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + Math.imul(slice.u.length, (1 << Math.imul(5, (((-1) + $thiz.sci_NewVectorIterator__f_sliceDim) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((-1) + (1 << Math.imul(5, $thiz.sci_NewVectorIterator__f_sliceDim))) | 0)
  }
}
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz)
  };
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io
  };
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $thiz.sci_NewVectorIterator__f_a1.u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0
}
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get(0);
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get(0);
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get(0);
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get(0)
  }
}
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.get(((io >>> 25) | 0));
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.get((31 & ((io >>> 20) | 0)));
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.get((31 & ((io >>> 15) | 0)));
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.get((31 & ((io >>> 10) | 0)));
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.get((31 & ((io >>> 5) | 0)))
  }
}
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = v.sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len
}
$c_sci_NewVectorIterator.prototype = new $h_O();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
  /*<skip>*/
}
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_NewVectorIterator.prototype.isEmpty__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_NewVectorIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_NewVectorIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sci_NewVectorIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sci_NewVectorIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0)
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this)
  };
  var r = this.sci_NewVectorIterator__f_a1.get(this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this)
      };
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io
      };
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1
      }
    }
  };
  return this
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((xsLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var total = ((x$1 > 0) ? x$1 : 0);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this)
    };
    var a = ((total - copied) | 0);
    var b = ((this.sci_NewVectorIterator__f_a1.u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      src.copyTo(srcPos, xs, destPos, count)
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count)
    };
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0)
  };
  return total
});
var $d_sci_NewVectorIterator = new $TypeData().initClass({
  sci_NewVectorIterator: 0
}, false, "scala.collection.immutable.NewVectorIterator", {
  sci_NewVectorIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
});
$c_sci_NewVectorIterator.prototype.$classData = $d_sci_NewVectorIterator;
/** @constructor */
function $c_sci_Queue$() {
  /*<skip>*/
}
$c_sci_Queue$.prototype = new $h_O();
$c_sci_Queue$.prototype.constructor = $c_sci_Queue$;
/** @constructor */
function $h_sci_Queue$() {
  /*<skip>*/
}
$h_sci_Queue$.prototype = $c_sci_Queue$.prototype;
$c_sci_Queue$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = new $c_scm_ListBuffer();
  var f = new $c_sjsr_AnonFunction1(((x$2) => {
    var x = $as_sci_List(x$2);
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), x)
  }));
  return new $c_scm_Builder$$anon$1(this$2, f)
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__sci_Queue = (function(source) {
  if ((source instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(source);
    return x2
  } else {
    $m_sci_List$();
    var list = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
    return (list.isEmpty__Z() ? $m_sci_Queue$EmptyQueue$() : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), list))
  }
});
$c_sci_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), elems.toList__sci_List())
});
$c_sci_Queue$.prototype.empty__O = (function() {
  return $m_sci_Queue$EmptyQueue$()
});
$c_sci_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Queue(source)
});
var $d_sci_Queue$ = new $TypeData().initClass({
  sci_Queue$: 0
}, false, "scala.collection.immutable.Queue$", {
  sci_Queue$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue$.prototype.$classData = $d_sci_Queue$;
var $n_sci_Queue$;
function $m_sci_Queue$() {
  if ((!$n_sci_Queue$)) {
    $n_sci_Queue$ = new $c_sci_Queue$()
  };
  return $n_sci_Queue$
}
function $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, key) {
  return (($thiz.sci_RedBlackTree$TreeIterator__f_root === null) ? null : $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, $thiz.sci_RedBlackTree$TreeIterator__f_root, key))
}
function $p_sci_RedBlackTree$TreeIterator__find$1__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree($thiz, tree, key$1) {
  while (true) {
    if ((tree === null)) {
      if (($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null
      } else {
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      }
    } else {
      var $$x1 = $thiz.sci_RedBlackTree$TreeIterator__f_ordering;
      var this$1 = tree;
      if ($$x1.lteq__O__O__Z(key$1, this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        var tree$1 = tree;
        $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts.set($thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        tree = tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      } else {
        var tree$2 = tree;
        tree = tree$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right
      }
    }
  }
}
function $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__($thiz, root, start, ordering) {
  $thiz.sci_RedBlackTree$TreeIterator__f_root = root;
  $thiz.sci_RedBlackTree$TreeIterator__f_ordering = ordering;
  if ((root === null)) {
    var $$x1 = null
  } else {
    var i = ((1 + (2147483647 & root.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_count)) | 0);
    var maximumHeight = (((-2) + (((32 - Math.clz32(i)) | 0) << 1)) | 0);
    var $$x1 = new ($d_sci_RedBlackTree$Tree.getArrayOf().constr)(maximumHeight)
  };
  $thiz.sci_RedBlackTree$TreeIterator__f_stackOfNexts = $$x1;
  $thiz.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  $thiz.sci_RedBlackTree$TreeIterator__f_lookahead = ((!start.isEmpty__Z()) ? $p_sci_RedBlackTree$TreeIterator__startFrom__O__sci_RedBlackTree$Tree($thiz, start.get__O()) : $thiz.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(root));
  return $thiz
}
/** @constructor */
function $c_sci_RedBlackTree$TreeIterator() {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null
}
$c_sci_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RedBlackTree$TreeIterator.prototype.constructor = $c_sci_RedBlackTree$TreeIterator;
/** @constructor */
function $h_sci_RedBlackTree$TreeIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$TreeIterator.prototype = $c_sci_RedBlackTree$TreeIterator.prototype;
$c_sci_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)
});
$c_sci_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
  if ((tree !== null)) {
    this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
    return this.nextResult__sci_RedBlackTree$Tree__O(tree)
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sci_RedBlackTree$TreeIterator.prototype.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree = (function(tree) {
  while (true) {
    if ((tree === null)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        return null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        return this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      }
    } else {
      var this$1 = tree;
      if ((this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left === null)) {
        return tree
      } else {
        var tree$1 = tree;
        this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.set(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index, tree$1);
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = ((1 + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        tree = tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_left
      }
    }
  }
});
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$())
}
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
  /*<skip>*/
}
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  if ($is_sci_Seq(it)) {
    var x2 = $as_sci_Seq(it);
    return x2
  } else {
    return $as_sci_Seq($c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it))
  }
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source)
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it)
});
var $d_sci_Seq$ = new $TypeData().initClass({
  sci_Seq$: 0
}, false, "scala.collection.immutable.Seq$", {
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Seq$.prototype.$classData = $d_sci_Seq$;
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$()
  };
  return $n_sci_Seq$
}
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false
}
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
  /*<skip>*/
}
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? this.sci_SetBuilderImpl__f_hashSetBuilder.result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem)
  } else if ((this.sci_SetBuilderImpl__f_elems.size__I() < 4)) {
    var this$1 = this.sci_SetBuilderImpl__f_elems;
    this.sci_SetBuilderImpl__f_elems = $as_sci_Set(this$1.incl__O__sci_SetOps(elem))
  } else if ((!this.sci_SetBuilderImpl__f_elems.contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder()
    };
    $as_sci_Set$Set4(this.sci_SetBuilderImpl__f_elems).buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem)
  };
  return this
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? (this.sci_SetBuilderImpl__f_hashSetBuilder.addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $as_sci_SetBuilderImpl($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)))
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(xs)
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem)
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set()
});
function $as_sci_SetBuilderImpl(obj) {
  return (((obj instanceof $c_sci_SetBuilderImpl) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetBuilderImpl"))
}
function $isArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetBuilderImpl)))
}
function $asArrayOf_sci_SetBuilderImpl(obj, depth) {
  return (($isArrayOf_sci_SetBuilderImpl(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetBuilderImpl;", depth))
}
var $d_sci_SetBuilderImpl = new $TypeData().initClass({
  sci_SetBuilderImpl: 0
}, false, "scala.collection.immutable.SetBuilderImpl", {
  sci_SetBuilderImpl: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_SetBuilderImpl.prototype.$classData = $d_sci_SetBuilderImpl;
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0
}
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
  /*<skip>*/
}
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_SetHashIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_SetHashIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_SetHashIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_SetHashIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_SetHashIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sci_SetHashIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_SetHashIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sci_SetHashIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_SetHashIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  this.sci_SetHashIterator__f_hash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this
});
var $d_sci_SetHashIterator = new $TypeData().initClass({
  sci_SetHashIterator: 0
}, false, "scala.collection.immutable.SetHashIterator", {
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetHashIterator.prototype.$classData = $d_sci_SetHashIterator;
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode)
}
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
  /*<skip>*/
}
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.iterator__sc_Iterator = (function() {
  return this
});
$c_sci_SetIterator.prototype.isEmpty__Z = (function() {
  return (!this.hasNext__Z())
});
$c_sci_SetIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs)
});
$c_sci_SetIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1))
});
$c_sci_SetIterator.prototype.toString__T = (function() {
  return "<iterator>"
});
$c_sci_SetIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sci_SetIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sci_SetIterator.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sci_SetIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sci_SetIterator.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException())
  };
  var payload = $as_sci_SetNode(this.sci_ChampBaseIterator__f_currentValueNode).getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload
});
var $d_sci_SetIterator = new $TypeData().initClass({
  sci_SetIterator: 0
}, false, "scala.collection.immutable.SetIterator", {
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_SetIterator.prototype.$classData = $d_sci_SetIterator;
function $p_sci_Vector$__liftedTree1$1__I($thiz) {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$4 = $m_jl_Integer$();
    return this$4.parseInt__T__I__I(x, 10)
  } catch (e) {
    if (false) {
      return 250
    } else {
      throw e
    }
  }
}
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $p_sci_Vector$__liftedTree1$1__I(this);
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0)
}
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
  /*<skip>*/
}
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems)
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(it);
    return x2
  } else {
    var knownSize = it.knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$()
    } else if (((knownSize > 0) && (knownSize <= 32))) {
      matchEnd5: {
        var a1$3;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x2$2 = $as_sci_ArraySeq$ofRef(it);
          var x = x2$2.elemTag__s_reflect_ClassTag().runtimeClass__jl_Class();
          if (((x !== null) && (x === $d_O.getClassOf()))) {
            var a1$3 = x2$2.sci_ArraySeq$ofRef__f_unsafeArray;
            break matchEnd5
          }
        };
        if ($is_sci_Iterable(it)) {
          var x3 = $as_sci_Iterable(it);
          var a1 = new $ac_O(knownSize);
          x3.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5
        };
        var a1$2 = new $ac_O(knownSize);
        var this$1 = it.iterator__sc_Iterator();
        this$1.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2
      };
      return new $c_sci_Vector1(a1$3)
    } else {
      var this$2 = new $c_sci_VectorBuilder();
      var this$3 = this$2.addAll__sc_IterableOnce__sci_VectorBuilder(it);
      return this$3.result__sci_Vector()
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder()
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source)
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$()
});
var $d_sci_Vector$ = new $TypeData().initClass({
  sci_Vector$: 0
}, false, "scala.collection.immutable.Vector$", {
  sci_Vector$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector$.prototype.$classData = $d_sci_Vector$;
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$()
  };
  return $n_sci_Vector$
}
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = data.u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz)
    };
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    data.copyTo(0, dest, destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      data.copyTo(copy1, dest$1, 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0)
    }
  }
}
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = xs.vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = xs.vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = ((sliceCount / 2) | 0);
    var a = ((idx - c) | 0);
    var x1 = ((((1 + c) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice)
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V((((-2) + x1) | 0), slice, new $c_sjsr_AnonFunction1(((this$3) => ((data$2) => {
        var data = $asArrayOf_O(data$2, 1);
        $p_sci_VectorBuilder__addArr1__AO__V(this$3, data)
      }))($thiz)))
    };
    sliceIdx = ((1 + sliceIdx) | 0)
  };
  return $thiz
}
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor)
}
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a2.set(0, $thiz.sci_VectorBuilder__f_a1);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1)
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a3.set(0, $thiz.sci_VectorBuilder__f_a2);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2)
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a4.set(0, $thiz.sci_VectorBuilder__f_a3);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3)
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a5.set(0, $thiz.sci_VectorBuilder__f_a4);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $thiz.sci_VectorBuilder__f_a5.set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4)
  } else if ((xor < 1073741824)) {
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $thiz.sci_VectorBuilder__f_a6.set(0, $thiz.sci_VectorBuilder__f_a5);
      $thiz.sci_VectorBuilder__f_depth = ((1 + $thiz.sci_VectorBuilder__f_depth) | 0)
    };
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.set((31 & ((idx >>> 5) | 0)), $thiz.sci_VectorBuilder__f_a1);
    $thiz.sci_VectorBuilder__f_a3.set((31 & ((idx >>> 10) | 0)), $thiz.sci_VectorBuilder__f_a2);
    $thiz.sci_VectorBuilder__f_a4.set((31 & ((idx >>> 15) | 0)), $thiz.sci_VectorBuilder__f_a3);
    $thiz.sci_VectorBuilder__f_a5.set((31 & ((idx >>> 20) | 0)), $thiz.sci_VectorBuilder__f_a4);
    $thiz.sci_VectorBuilder__f_a6.set((31 & ((idx >>> 25) | 0)), $thiz.sci_VectorBuilder__f_a5)
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth))
  }
}
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_offset = 0;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_offset = 0;
  this.sci_VectorBuilder__f_depth = 1
}
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
  /*<skip>*/
}
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = prefix1.u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = ((prefix1.u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = v.vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break
    }
    case 1: {
      var v1 = $as_sci_Vector1(v);
      this.sci_VectorBuilder__f_depth = 1;
      var i = v1.sci_Vector__f_prefix1.u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = v1.sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = ((a.u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break
    }
    case 3: {
      var v2 = $as_sci_Vector2(v);
      var d2 = v2.sci_Vector2__f_data2;
      var a$1 = v2.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$1.u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_offset = ((32 - v2.sci_Vector2__f_len1) | 0);
      var i$1 = ((v2.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a2.set(0, v2.sci_Vector__f_prefix1);
      var dest = this.sci_VectorBuilder__f_a2;
      var length = d2.u.length;
      d2.copyTo(0, dest, 1, length);
      this.sci_VectorBuilder__f_a2.set(((1 + d2.u.length) | 0), this.sci_VectorBuilder__f_a1);
      break
    }
    case 5: {
      var v3 = $as_sci_Vector3(v);
      var d3 = v3.sci_Vector3__f_data3;
      var s2 = v3.sci_Vector3__f_suffix2;
      var a$2 = v3.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$2.u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_offset = ((1024 - v3.sci_Vector3__f_len12) | 0);
      var i$2 = ((v3.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a3.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v3.sci_Vector__f_prefix1, v3.sci_Vector3__f_prefix2), 2));
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = d3.u.length;
      d3.copyTo(0, dest$1, 1, length$1);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2, 32), 2);
      this.sci_VectorBuilder__f_a3.set(((1 + d3.u.length) | 0), this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 7: {
      var v4 = $as_sci_Vector4(v);
      var d4 = v4.sci_Vector4__f_data4;
      var s3 = v4.sci_Vector4__f_suffix3;
      var s2$2 = v4.sci_Vector4__f_suffix2;
      var a$3 = v4.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$3.u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_offset = ((32768 - v4.sci_Vector4__f_len123) | 0);
      var i$3 = ((v4.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a4.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v4.sci_Vector__f_prefix1, v4.sci_Vector4__f_prefix2), v4.sci_Vector4__f_prefix3), 3));
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = d4.u.length;
      d4.copyTo(0, dest$2, 1, length$2);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32), 2);
      this.sci_VectorBuilder__f_a4.set(((1 + d4.u.length) | 0), this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$2.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 9: {
      var v5 = $as_sci_Vector5(v);
      var d5 = v5.sci_Vector5__f_data5;
      var s4 = v5.sci_Vector5__f_suffix4;
      var s3$2 = v5.sci_Vector5__f_suffix3;
      var s2$3 = v5.sci_Vector5__f_suffix2;
      var a$4 = v5.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$4.u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_offset = ((1048576 - v5.sci_Vector5__f_len1234) | 0);
      var i$4 = ((v5.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a5.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v5.sci_Vector__f_prefix1, v5.sci_Vector5__f_prefix2), v5.sci_Vector5__f_prefix3), v5.sci_Vector5__f_prefix4), 4));
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = d5.u.length;
      d5.copyTo(0, dest$3, 1, length$3);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32), 2);
      this.sci_VectorBuilder__f_a5.set(((1 + d5.u.length) | 0), this.sci_VectorBuilder__f_a4);
      this.sci_VectorBuilder__f_a4.set(s4.u.length, this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3$2.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$3.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    case 11: {
      var v6 = $as_sci_Vector6(v);
      var d6 = v6.sci_Vector6__f_data6;
      var s5 = v6.sci_Vector6__f_suffix5;
      var s4$2 = v6.sci_Vector6__f_suffix4;
      var s3$3 = v6.sci_Vector6__f_suffix3;
      var s2$4 = v6.sci_Vector6__f_suffix2;
      var a$5 = v6.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$5.u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_offset = ((33554432 - v6.sci_Vector6__f_len12345) | 0);
      var i$5 = ((v6.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a6.set(0, $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v6.sci_Vector__f_prefix1, v6.sci_Vector6__f_prefix2), v6.sci_Vector6__f_prefix3), v6.sci_Vector6__f_prefix4), v6.sci_Vector6__f_prefix5), 5));
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = d6.u.length;
      d6.copyTo(0, dest$4, 1, length$4);
      this.sci_VectorBuilder__f_a5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s5, 32), 5);
      this.sci_VectorBuilder__f_a4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32), 4);
      this.sci_VectorBuilder__f_a3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32), 3);
      this.sci_VectorBuilder__f_a2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32), 2);
      this.sci_VectorBuilder__f_a6.set(((1 + d6.u.length) | 0), this.sci_VectorBuilder__f_a5);
      this.sci_VectorBuilder__f_a5.set(s5.u.length, this.sci_VectorBuilder__f_a4);
      this.sci_VectorBuilder__f_a4.set(s4$2.u.length, this.sci_VectorBuilder__f_a3);
      this.sci_VectorBuilder__f_a3.set(s3$3.u.length, this.sci_VectorBuilder__f_a2);
      this.sci_VectorBuilder__f_a2.set(s2$4.u.length, this.sci_VectorBuilder__f_a1);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  };
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0)
  };
  return this
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this)
  };
  this.sci_VectorBuilder__f_a1.set(this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1, elem);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  if ((xs instanceof $c_sci_Vector)) {
    var x2 = $as_sci_Vector(xs);
    return (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) ? this.initFrom__sci_Vector__sci_VectorBuilder(x2) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, x2))
  } else {
    return $as_sci_VectorBuilder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$()
  } else if ((len <= 32)) {
    if ((realLen === 32)) {
      return new $c_sci_Vector1(this.sci_VectorBuilder__f_a1)
    } else {
      var original = this.sci_VectorBuilder__f_a1;
      return new $c_sci_Vector1($m_ju_Arrays$().copyOf__AO__I__AO(original, realLen))
    }
  } else if ((len <= 1024)) {
    var i1 = (31 & (((-1) + len) | 0));
    var i2 = (((((-1) + len) | 0) >>> 5) | 0);
    var original$1 = this.sci_VectorBuilder__f_a2;
    var data = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i2), 2);
    var prefix1 = this.sci_VectorBuilder__f_a2.get(0);
    var a = this.sci_VectorBuilder__f_a2.get(i2);
    var len$1 = ((1 + i1) | 0);
    var suffix1 = ((a.u.length === len$1) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_offset) | 0), data, suffix1, realLen)
  } else if ((len <= 32768)) {
    var i1$2 = (31 & (((-1) + len) | 0));
    var i2$2 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3 = (((((-1) + len) | 0) >>> 10) | 0);
    var original$2 = this.sci_VectorBuilder__f_a3;
    var data$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, 1, i3), 3);
    var a$1 = this.sci_VectorBuilder__f_a3.get(0);
    var to = a$1.u.length;
    var prefix2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 1, to), 2);
    var prefix1$2 = this.sci_VectorBuilder__f_a3.get(0).get(0);
    var original$3 = this.sci_VectorBuilder__f_a3.get(i3);
    var suffix2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$3, i2$2), 2);
    var a$2 = this.sci_VectorBuilder__f_a3.get(i3).get(i2$2);
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = ((a$2.u.length === len$2) ? a$2 : $m_ju_Arrays$().copyOf__AO__I__AO(a$2, len$2));
    var len1 = prefix1$2.u.length;
    var len12 = ((len1 + (prefix2.u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen)
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & (((-1) + len) | 0));
    var i2$3 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$2 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4 = (((((-1) + len) | 0) >>> 15) | 0);
    var original$4 = this.sci_VectorBuilder__f_a4;
    var data$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, 1, i4), 4);
    var a$3 = this.sci_VectorBuilder__f_a4.get(0);
    var to$1 = a$3.u.length;
    var prefix3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 1, to$1), 3);
    var a$4 = this.sci_VectorBuilder__f_a4.get(0).get(0);
    var to$2 = a$4.u.length;
    var prefix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$2), 2);
    var prefix1$3 = this.sci_VectorBuilder__f_a4.get(0).get(0).get(0);
    var original$5 = this.sci_VectorBuilder__f_a4.get(i4);
    var suffix3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$5, i3$2), 3);
    var original$6 = this.sci_VectorBuilder__f_a4.get(i4).get(i3$2);
    var suffix2$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$6, i2$3), 2);
    var a$5 = this.sci_VectorBuilder__f_a4.get(i4).get(i3$2).get(i2$3);
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = ((a$5.u.length === len$3) ? a$5 : $m_ju_Arrays$().copyOf__AO__I__AO(a$5, len$3));
    var len1$2 = prefix1$3.u.length;
    var len12$2 = ((len1$2 + (prefix2$2.u.length << 5)) | 0);
    var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen)
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & (((-1) + len) | 0));
    var i2$4 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$3 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$2 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5 = (((((-1) + len) | 0) >>> 20) | 0);
    var original$7 = this.sci_VectorBuilder__f_a5;
    var data$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$7, 1, i5), 5);
    var a$6 = this.sci_VectorBuilder__f_a5.get(0);
    var to$3 = a$6.u.length;
    var prefix4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$6, 1, to$3), 4);
    var a$7 = this.sci_VectorBuilder__f_a5.get(0).get(0);
    var to$4 = a$7.u.length;
    var prefix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$4), 3);
    var a$8 = this.sci_VectorBuilder__f_a5.get(0).get(0).get(0);
    var to$5 = a$8.u.length;
    var prefix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$5), 2);
    var prefix1$4 = this.sci_VectorBuilder__f_a5.get(0).get(0).get(0).get(0);
    var original$8 = this.sci_VectorBuilder__f_a5.get(i5);
    var suffix4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$8, i4$2), 4);
    var original$9 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2);
    var suffix3$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$9, i3$3), 3);
    var original$10 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2).get(i3$3);
    var suffix2$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$10, i2$4), 2);
    var a$9 = this.sci_VectorBuilder__f_a5.get(i5).get(i4$2).get(i3$3).get(i2$4);
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = ((a$9.u.length === len$4) ? a$9 : $m_ju_Arrays$().copyOf__AO__I__AO(a$9, len$4));
    var len1$3 = prefix1$4.u.length;
    var len12$3 = ((len1$3 + (prefix2$3.u.length << 5)) | 0);
    var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
    var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen)
  } else {
    var i1$5 = (31 & (((-1) + len) | 0));
    var i2$5 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$4 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$3 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5$2 = (31 & (((((-1) + len) | 0) >>> 20) | 0));
    var i6 = (((((-1) + len) | 0) >>> 25) | 0);
    var original$11 = this.sci_VectorBuilder__f_a6;
    var data$5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$11, 1, i6), 6);
    var a$10 = this.sci_VectorBuilder__f_a6.get(0);
    var to$6 = a$10.u.length;
    var prefix5 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$10, 1, to$6), 5);
    var a$11 = this.sci_VectorBuilder__f_a6.get(0).get(0);
    var to$7 = a$11.u.length;
    var prefix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$7), 4);
    var a$12 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0);
    var to$8 = a$12.u.length;
    var prefix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$8), 3);
    var a$13 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0).get(0);
    var to$9 = a$13.u.length;
    var prefix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$9), 2);
    var prefix1$5 = this.sci_VectorBuilder__f_a6.get(0).get(0).get(0).get(0).get(0);
    var original$12 = this.sci_VectorBuilder__f_a6.get(i6);
    var suffix5 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$12, i5$2), 5);
    var original$13 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2);
    var suffix4$2 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$13, i4$3), 4);
    var original$14 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3);
    var suffix3$3 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$14, i3$4), 3);
    var original$15 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3).get(i3$4);
    var suffix2$4 = $asArrayOf_O($m_ju_Arrays$().copyOf__AO__I__AO(original$15, i2$5), 2);
    var a$14 = this.sci_VectorBuilder__f_a6.get(i6).get(i5$2).get(i4$3).get(i3$4).get(i2$5);
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = ((a$14.u.length === len$5) ? a$14 : $m_ju_Arrays$().copyOf__AO__I__AO(a$14, len$5));
    var len1$4 = prefix1$5.u.length;
    var len12$4 = ((len1$4 + (prefix2$4.u.length << 5)) | 0);
    var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
    var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen)
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")")
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector()
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem)
});
function $as_sci_VectorBuilder(obj) {
  return (((obj instanceof $c_sci_VectorBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.VectorBuilder"))
}
function $isArrayOf_sci_VectorBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorBuilder)))
}
function $asArrayOf_sci_VectorBuilder(obj, depth) {
  return (($isArrayOf_sci_VectorBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.VectorBuilder;", depth))
}
var $d_sci_VectorBuilder = new $TypeData().initClass({
  sci_VectorBuilder: 0
}, false, "scala.collection.immutable.VectorBuilder", {
  sci_VectorBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_VectorBuilder.prototype.$classData = $d_sci_VectorBuilder;
function $p_scm_ArrayBuffer$__resizeEnsuring$1__I__I__I__I($thiz, length, end, n) {
  var hi = (length >> 31);
  var newSize__lo = length;
  var newSize__hi = hi;
  var this$2__lo = newSize__lo;
  var this$2__hi = newSize__hi;
  var lo = this$2__lo;
  var lo$1 = (lo << 1);
  var hi$1 = (((lo >>> 31) | 0) | (this$2__hi << 1));
  var t = (((hi$1 === 0) ? (((-2147483648) ^ lo$1) > (-2147483632)) : (hi$1 > 0)) ? new $c_RTLong(lo$1, hi$1) : new $c_RTLong(16, 0));
  var lo$2 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var $$x1__lo = lo$2;
  var $$x1__hi = hi$2;
  newSize__lo = $$x1__lo;
  newSize__hi = $$x1__hi;
  while (true) {
    var this$6__lo = newSize__lo;
    var this$6__hi = newSize__hi;
    var hi$3 = (n >> 31);
    var ahi = this$6__hi;
    if (((ahi === hi$3) ? (((-2147483648) ^ this$6__lo) < ((-2147483648) ^ n)) : (ahi < hi$3))) {
      var this$7__lo = newSize__lo;
      var this$7__hi = newSize__hi;
      var lo$3 = this$7__lo;
      var lo$4 = (lo$3 << 1);
      var hi$4 = (((lo$3 >>> 31) | 0) | (this$7__hi << 1));
      var $$x2__lo = lo$4;
      var $$x2__hi = hi$4;
      newSize__lo = $$x2__lo;
      newSize__hi = $$x2__hi
    } else {
      break
    }
  };
  var this$8__lo = newSize__lo;
  var this$8__hi = newSize__hi;
  var ahi$1 = this$8__hi;
  if (((ahi$1 === 0) ? (((-2147483648) ^ this$8__lo) <= (-1)) : (ahi$1 < 0))) {
    var this$9__lo = newSize__lo;
    var this$9__hi = newSize__hi;
    return this$9__lo
  } else if ((end === 2147483647)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_Exception__T__(new $c_jl_Exception(), "Collections can not have more than 2147483647 elements"))
  } else {
    return 2147483647
  }
}
/** @constructor */
function $c_scm_ArrayBuffer$() {
  /*<skip>*/
}
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems)
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = coll.knownSize__I();
  if ((k >= 0)) {
    var array = new $ac_O(((k > 16) ? k : 16));
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      x2.copyToArray__O__I__I__I(array, 0, 2147483647)
    } else {
      coll.iterator__sc_Iterator().copyToArray__O__I__I__I(array, 0, 2147483647)
    };
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k)
  } else {
    var this$6 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$6.addAll__sc_IterableOnce__scm_ArrayBuffer(coll)
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1()
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO = (function(array, end, n) {
  if ((n <= array.u.length)) {
    return array
  } else {
    var a = new $ac_O($p_scm_ArrayBuffer$__resizeEnsuring$1__I__I__I__I(this, array.u.length, end, n));
    $m_s_Array$().copy__O__I__O__I__I__V(array, 0, a, 0, end);
    return a
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source)
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass({
  scm_ArrayBuffer$: 0
}, false, "scala.collection.mutable.ArrayBuffer$", {
  scm_ArrayBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer$.prototype.$classData = $d_scm_ArrayBuffer$;
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$()
  };
  return $n_scm_ArrayBuffer$
}
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer()))
}
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
  /*<skip>*/
}
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  $as_scm_ArrayBuffer(this.scm_GrowableBuilder__f_elems).ensureSize__I__V(size)
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass({
  scm_ArrayBuffer$$anon$1: 0
}, false, "scala.collection.mutable.ArrayBuffer$$anon$1", {
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_ArrayBuffer$$anon$1.prototype.$classData = $d_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $c_scm_ArrayDeque$() {
  /*<skip>*/
}
$c_scm_ArrayDeque$.prototype = new $h_O();
$c_scm_ArrayDeque$.prototype.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
  /*<skip>*/
}
$h_scm_ArrayDeque$.prototype = $c_scm_ArrayDeque$.prototype;
$c_scm_ArrayDeque$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(elems)
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__scm_ArrayDeque = (function(coll) {
  var s = coll.knownSize__I();
  if ((s >= 0)) {
    var array = this.alloc__I__AO(s);
    if ($is_sc_Iterable(coll)) {
      var x2 = $as_sc_Iterable(coll);
      x2.copyToArray__O__I__I__I(array, 0, 2147483647)
    } else {
      coll.iterator__sc_Iterator().copyToArray__O__I__I__I(array, 0, 2147483647)
    };
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s)
  } else {
    var this$2 = $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
    return this$2.addAll__sc_IterableOnce__scm_ArrayDeque(coll)
  }
});
$c_scm_ArrayDeque$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayDeque$$anon$1()
});
$c_scm_ArrayDeque$.prototype.alloc__I__AO = (function(len) {
  var requirement = (len >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required")
  };
  var size = ((((-2147483648) >>> Math.clz32(len)) | 0) << 1);
  var requirement$1 = (size >= 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len))
  };
  return new $ac_O(((size > 16) ? size : 16))
});
$c_scm_ArrayDeque$.prototype.empty__O = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16)
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(source)
});
var $d_scm_ArrayDeque$ = new $TypeData().initClass({
  scm_ArrayDeque$: 0
}, false, "scala.collection.mutable.ArrayDeque$", {
  scm_ArrayDeque$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayDeque$.prototype.$classData = $d_scm_ArrayDeque$;
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$()
  };
  return $n_scm_ArrayDeque$
}
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16))
}
$c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayDeque$$anon$1.prototype.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
  /*<skip>*/
}
$h_scm_ArrayDeque$$anon$1.prototype = $c_scm_ArrayDeque$$anon$1.prototype;
$c_scm_ArrayDeque$$anon$1.prototype.sizeHint__I__V = (function(size) {
  var this$1 = $as_scm_ArrayDeque(this.scm_GrowableBuilder__f_elems);
  var idx = this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((size > (((this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this$1.scm_ArrayDeque__f_array.u.length) | 0))) && (size >= this$1.scm_ArrayDeque__f_array.u.length))) {
    this$1.scala$collection$mutable$ArrayDeque$$resize__I__V(size)
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().initClass({
  scm_ArrayDeque$$anon$1: 0
}, false, "scala.collection.mutable.ArrayDeque$$anon$1", {
  scm_ArrayDeque$$anon$1: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_ArrayDeque$$anon$1.prototype.$classData = $d_scm_ArrayDeque$$anon$1;
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$())
}
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
  /*<skip>*/
}
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass({
  scm_Buffer$: 0
}, false, "scala.collection.mutable.Buffer$", {
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Buffer$.prototype.$classData = $d_scm_Buffer$;
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$()
  };
  return $n_scm_Buffer$
}
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.scm_HashMap$HashMapIterator__f_$outer = outer
  };
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null
}
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
  /*<skip>*/
}
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = this.scm_HashMap$HashMapIterator__f_$outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(this.scm_HashMap$HashMapIterator__f_i);
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = this.scm_HashMap$HashMapIterator__f_node.scm_HashMap$Node__f__next;
    return r
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1))
}
$c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashSet$$anon$4.prototype.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$4.prototype = $c_scm_HashSet$$anon$4.prototype;
$c_scm_HashSet$$anon$4.prototype.sizeHint__I__V = (function(size) {
  $as_scm_HashSet(this.scm_GrowableBuilder__f_elems).sizeHint__I__V(size)
});
var $d_scm_HashSet$$anon$4 = new $TypeData().initClass({
  scm_HashSet$$anon$4: 0
}, false, "scala.collection.mutable.HashSet$$anon$4", {
  scm_HashSet$$anon$4: 1,
  scm_GrowableBuilder: 1,
  O: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_HashSet$$anon$4.prototype.$classData = $d_scm_HashSet$$anon$4;
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    $thiz.scm_HashSet$HashSetIterator__f_$outer = outer
  };
  $thiz.scm_HashSet$HashSetIterator__f_i = 0;
  $thiz.scm_HashSet$HashSetIterator__f_node = null;
  $thiz.scm_HashSet$HashSetIterator__f_len = outer.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  return $thiz
}
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null
}
$c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashSet$HashSetIterator.prototype.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
  /*<skip>*/
}
$h_scm_HashSet$HashSetIterator.prototype = $c_scm_HashSet$HashSetIterator.prototype;
$c_scm_HashSet$HashSetIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashSet$HashSetIterator__f_node !== null)) {
    return true
  } else {
    while ((this.scm_HashSet$HashSetIterator__f_i < this.scm_HashSet$HashSetIterator__f_len)) {
      var n = this.scm_HashSet$HashSetIterator__f_$outer.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(this.scm_HashSet$HashSetIterator__f_i);
      this.scm_HashSet$HashSetIterator__f_i = ((1 + this.scm_HashSet$HashSetIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashSet$HashSetIterator__f_node = n;
        return true
      }
    };
    return false
  }
});
$c_scm_HashSet$HashSetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  } else {
    var r = this.extract__scm_HashSet$Node__O(this.scm_HashSet$HashSetIterator__f_node);
    this.scm_HashSet$HashSetIterator__f_node = this.scm_HashSet$HashSetIterator__f_node.scm_HashSet$Node__f__next;
    return r
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_empty = empty;
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz
}
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null
}
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
  /*<skip>*/
}
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$())
}
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
  /*<skip>*/
}
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass({
  scm_IndexedSeq$: 0
}, false, "scala.collection.mutable.IndexedSeq$", {
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  O: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_IndexedSeq$.prototype.$classData = $d_scm_IndexedSeq$;
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$()
  };
  return $n_scm_IndexedSeq$
}
/** @constructor */
function $c_scm_ListBuffer$() {
  /*<skip>*/
}
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
  /*<skip>*/
}
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems)
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer())
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer()
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(source)
});
var $d_scm_ListBuffer$ = new $TypeData().initClass({
  scm_ListBuffer$: 0
}, false, "scala.collection.mutable.ListBuffer$", {
  scm_ListBuffer$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer$.prototype.$classData = $d_scm_ListBuffer$;
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$()
  };
  return $n_scm_ListBuffer$
}
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
  /*<skip>*/
}
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_MutationTracker$CheckedIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return this.scm_MutationTracker$CheckedIterator__f_underlying.hasNext__Z()
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return this.scm_MutationTracker$CheckedIterator__f_underlying.next__O()
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass({
  scm_MutationTracker$CheckedIterator: 0
}, false, "scala.collection.mutable.MutationTracker$CheckedIterator", {
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_MutationTracker$CheckedIterator.prototype.$classData = $d_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $c_scm_Queue$() {
  /*<skip>*/
}
$c_scm_Queue$.prototype = new $h_O();
$c_scm_Queue$.prototype.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
  /*<skip>*/
}
$h_scm_Queue$.prototype = $c_scm_Queue$.prototype;
$c_scm_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = new $c_scm_Queue(16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(elems))
});
$c_scm_Queue$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_Queue(16))
});
$c_scm_Queue$.prototype.empty__O = (function() {
  return new $c_scm_Queue(16)
});
$c_scm_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  var this$1 = new $c_scm_Queue(16);
  return $as_scm_Queue(this$1.addAll__sc_IterableOnce__scm_ArrayDeque(source))
});
var $d_scm_Queue$ = new $TypeData().initClass({
  scm_Queue$: 0
}, false, "scala.collection.mutable.Queue$", {
  scm_Queue$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Queue$.prototype.$classData = $d_scm_Queue$;
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$()
  };
  return $n_scm_Queue$
}
function $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz) {
  var this$1 = $thiz.scm_RedBlackTree$TreeIterator__f_end;
  if ((((!this$1.isEmpty__Z()) && ($thiz.scm_RedBlackTree$TreeIterator__f_nextNode !== null)) && ($thiz.scm_RedBlackTree$TreeIterator__f_ord.compare__O__O__I($thiz.scm_RedBlackTree$TreeIterator__f_nextNode.scm_RedBlackTree$Node__f_key, $thiz.scm_RedBlackTree$TreeIterator__f_end.get__O()) >= 0))) {
    $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = null
  }
}
function $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__($thiz, tree, start, end, ord) {
  $thiz.scm_RedBlackTree$TreeIterator__f_end = end;
  $thiz.scm_RedBlackTree$TreeIterator__f_ord = ord;
  var x = $m_s_None$();
  if ((x === start)) {
    var $$x1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNode__scm_RedBlackTree$Node__scm_RedBlackTree$Node(tree.scm_RedBlackTree$Tree__f_root)
  } else if ((start instanceof $c_s_Some)) {
    var x3 = $as_s_Some(start);
    var from = x3.s_Some__f_value;
    var $$x1 = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$minNodeAfter__scm_RedBlackTree$Node__O__s_math_Ordering__scm_RedBlackTree$Node(tree.scm_RedBlackTree$Tree__f_root, from, ord)
  } else {
    var $$x1;
    throw new $c_s_MatchError(start)
  };
  $thiz.scm_RedBlackTree$TreeIterator__f_nextNode = $$x1;
  $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V($thiz);
  return $thiz
}
/** @constructor */
function $c_scm_RedBlackTree$TreeIterator() {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null
}
$c_scm_RedBlackTree$TreeIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_RedBlackTree$TreeIterator.prototype.constructor = $c_scm_RedBlackTree$TreeIterator;
/** @constructor */
function $h_scm_RedBlackTree$TreeIterator() {
  /*<skip>*/
}
$h_scm_RedBlackTree$TreeIterator.prototype = $c_scm_RedBlackTree$TreeIterator.prototype;
$c_scm_RedBlackTree$TreeIterator.prototype.hasNext__Z = (function() {
  return (this.scm_RedBlackTree$TreeIterator__f_nextNode !== null)
});
$c_scm_RedBlackTree$TreeIterator.prototype.next__O = (function() {
  var x1 = this.scm_RedBlackTree$TreeIterator__f_nextNode;
  if ((x1 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator")
  } else {
    this.scm_RedBlackTree$TreeIterator__f_nextNode = $m_scm_RedBlackTree$().scala$collection$mutable$RedBlackTree$$successor__scm_RedBlackTree$Node__scm_RedBlackTree$Node(x1);
    $p_scm_RedBlackTree$TreeIterator__setNullIfAfterEnd__V(this);
    return x1.scm_RedBlackTree$Node__f_key
  }
});
/** @constructor */
function $c_scm_TreeSet$$anon$1(ordering$1) {
  this.scm_TreeSet$$anon$1__f_tree = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = null;
  this.scm_TreeSet$$anon$1__f_ordering$1 = ordering$1;
  this.scm_TreeSet$$anon$1__f_tree = new $c_scm_RedBlackTree$Tree(null, 0)
}
$c_scm_TreeSet$$anon$1.prototype = new $h_O();
$c_scm_TreeSet$$anon$1.prototype.constructor = $c_scm_TreeSet$$anon$1;
/** @constructor */
function $h_scm_TreeSet$$anon$1() {
  /*<skip>*/
}
$h_scm_TreeSet$$anon$1.prototype = $c_scm_TreeSet$$anon$1.prototype;
$c_scm_TreeSet$$anon$1.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_TreeSet$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_TreeSet$$anon$1 = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet$$anon$1__f_tree, elem, null, this.scm_TreeSet$$anon$1__f_ordering$1);
  return this
});
$c_scm_TreeSet$$anon$1.prototype.result__scm_TreeSet = (function() {
  return new $c_scm_TreeSet(this.scm_TreeSet$$anon$1__f_tree, this.scm_TreeSet$$anon$1__f_ordering$1)
});
$c_scm_TreeSet$$anon$1.prototype.result__O = (function() {
  return this.result__scm_TreeSet()
});
$c_scm_TreeSet$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet$$anon$1(elem)
});
var $d_scm_TreeSet$$anon$1 = new $TypeData().initClass({
  scm_TreeSet$$anon$1: 0
}, false, "scala.collection.mutable.TreeSet$$anon$1", {
  scm_TreeSet$$anon$1: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_scm_TreeSet$$anon$1.prototype.$classData = $d_scm_TreeSet$$anon$1;
/** @constructor */
function $c_s_concurrent_ExecutionContext$parasitic$() {
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = null;
  $n_s_concurrent_ExecutionContext$parasitic$ = this;
  this.s_concurrent_ExecutionContext$parasitic$__f_scala$concurrent$BatchingExecutor$$_tasksLocal = new $c_jl_ThreadLocal()
}
$c_s_concurrent_ExecutionContext$parasitic$.prototype = new $h_O();
$c_s_concurrent_ExecutionContext$parasitic$.prototype.constructor = $c_s_concurrent_ExecutionContext$parasitic$;
/** @constructor */
function $h_s_concurrent_ExecutionContext$parasitic$() {
  /*<skip>*/
}
$h_s_concurrent_ExecutionContext$parasitic$.prototype = $c_s_concurrent_ExecutionContext$parasitic$.prototype;
$c_s_concurrent_ExecutionContext$parasitic$.prototype.execute__jl_Runnable__V = (function(runnable) {
  $f_s_concurrent_BatchingExecutor__submitSyncBatched__jl_Runnable__V(this, runnable)
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.reportFailure__jl_Throwable__V = (function(t) {
  $m_s_concurrent_ExecutionContext$().s_concurrent_ExecutionContext$__f_defaultReporter.apply__O__O(t)
});
var $d_s_concurrent_ExecutionContext$parasitic$ = new $TypeData().initClass({
  s_concurrent_ExecutionContext$parasitic$: 0
}, false, "scala.concurrent.ExecutionContext$parasitic$", {
  s_concurrent_ExecutionContext$parasitic$: 1,
  O: 1,
  s_concurrent_ExecutionContextExecutor: 1,
  s_concurrent_ExecutionContext: 1,
  ju_concurrent_Executor: 1,
  s_concurrent_BatchingExecutor: 1
});
$c_s_concurrent_ExecutionContext$parasitic$.prototype.$classData = $d_s_concurrent_ExecutionContext$parasitic$;
var $n_s_concurrent_ExecutionContext$parasitic$;
function $m_s_concurrent_ExecutionContext$parasitic$() {
  if ((!$n_s_concurrent_ExecutionContext$parasitic$)) {
    $n_s_concurrent_ExecutionContext$parasitic$ = new $c_s_concurrent_ExecutionContext$parasitic$()
  };
  return $n_s_concurrent_ExecutionContext$parasitic$
}
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
$c_s_concurrent_duration_Duration$Infinite.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined
  };
  if ((other instanceof $c_s_concurrent_duration_Duration$Infinite)) {
    var x2 = $as_s_concurrent_duration_Duration$Infinite(other);
    if ((x2 !== this)) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined
    }
  };
  return this
});
function $as_s_concurrent_duration_Duration$Infinite(obj) {
  return (((obj instanceof $c_s_concurrent_duration_Duration$Infinite) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.Duration$Infinite"))
}
function $isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration$Infinite)))
}
function $asArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.Duration$Infinite;", depth))
}
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max) {
  var lo = max.RTLong__f_lo;
  var hi = max.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  var b = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  var bhi = b.RTLong__f_hi;
  if (((hi$1 === bhi) ? (((-2147483648) ^ lo$1) <= ((-2147483648) ^ b.RTLong__f_lo)) : (hi$1 < bhi))) {
    var this$3 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
    var ahi = this$3.RTLong__f_hi;
    var bhi$1 = max.RTLong__f_hi;
    return ((ahi === bhi$1) ? (((-2147483648) ^ this$3.RTLong__f_lo) <= ((-2147483648) ^ max.RTLong__f_lo)) : (ahi < bhi$1))
  } else {
    return false
  }
}
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $$x1 = $as_T($m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName.apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit));
  var this$1 = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  return ($$x1 + (((this$1.RTLong__f_lo === 1) && (this$1.RTLong__f_hi === 0)) ? "" : "s"))
}
function $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var bhi = b.RTLong__f_hi;
    var lo = (((-1) - b.RTLong__f_lo) | 0);
    var hi = ((2147483647 - bhi) | 0);
    var ahi$1 = a.RTLong__f_hi;
    var $$x2 = ((ahi$1 === hi) ? (((-2147483648) ^ a.RTLong__f_lo) > ((-2147483648) ^ lo)) : (ahi$1 > hi))
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = true
  } else {
    var ahi$2 = b.RTLong__f_hi;
    if ((ahi$2 < 0)) {
      var bhi$1 = b.RTLong__f_hi;
      var lo$1 = ((-b.RTLong__f_lo) | 0);
      var hi$1 = ((lo$1 !== 0) ? ((2147483647 - bhi$1) | 0) : (((-2147483648) - bhi$1) | 0));
      var ahi$3 = a.RTLong__f_hi;
      var $$x1 = ((ahi$3 === hi$1) ? (((-2147483648) ^ a.RTLong__f_lo) < ((-2147483648) ^ lo$1)) : (ahi$3 < hi$1))
    } else {
      var $$x1 = false
    }
  };
  if ($$x1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "integer overflow")
  };
  var alo = a.RTLong__f_lo;
  var ahi$4 = a.RTLong__f_hi;
  var bhi$2 = b.RTLong__f_hi;
  var lo$2 = ((alo + b.RTLong__f_lo) | 0);
  var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ alo)) ? ((1 + ((ahi$4 + bhi$2) | 0)) | 0) : ((ahi$4 + bhi$2) | 0));
  return new $c_RTLong(lo$2, hi$2)
}
function $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration($thiz, otherLength, otherUnit) {
  var this$1 = otherUnit.convert__J__ju_concurrent_TimeUnit__J(new $c_RTLong(1, 0), $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
    var commonUnit = $thiz.s_concurrent_duration_FiniteDuration__f_unit
  } else {
    var commonUnit = otherUnit
  };
  var t = $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, commonUnit.convert__J__ju_concurrent_TimeUnit__J($thiz.s_concurrent_duration_FiniteDuration__f_length, $thiz.s_concurrent_duration_FiniteDuration__f_unit), commonUnit.convert__J__ju_concurrent_TimeUnit__J(otherLength, otherUnit));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), commonUnit)
}
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length = $L0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length = length;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === unit)) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1), 2147483647))
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === unit)) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1511828489), 2147483))
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === unit)) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2077252342, 2147))
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === unit)) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(633437444, 2))
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === unit)) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(153722867, 0))
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === unit)) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2562047, 0))
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === unit)) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(106751, 0))
              } else {
                var t = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS.convert__J__ju_concurrent_TimeUnit__J(length, unit);
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var requirement = (((hi === (-1)) ? (((-2147483648) ^ lo) >= 2147376897) : (hi > (-1))) && ((hi === 0) ? (((-2147483648) ^ lo) <= (-2147376897)) : (hi < 0)))
              }
            }
          }
        }
      }
    }
  };
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)")
  }
}
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
  /*<skip>*/
}
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return ((this.s_concurrent_duration_FiniteDuration__f_length + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this))
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var t = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$2 = new $c_sr_RichLong(new $c_RTLong(lo, hi));
    var t$1 = x2.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x2.s_concurrent_duration_FiniteDuration__f_length);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$3 = this$2.sr_RichLong__f_self;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    var t$4 = $uJ(new $c_RTLong(lo$3, hi$3));
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var t$5 = $uJ(new $c_RTLong(lo$1, hi$1));
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$4, hi$4, lo$5, hi$5)
  } else {
    return ((-other.compare__s_concurrent_duration_Duration__I(this)) | 0)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, x2.s_concurrent_duration_FiniteDuration__f_length, x2.s_concurrent_duration_FiniteDuration__f_unit)
  } else {
    return other
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  var this$1 = other.s_concurrent_duration_FiniteDuration__f_length;
  var lo = this$1.RTLong__f_lo;
  var hi = this$1.RTLong__f_hi;
  var lo$1 = ((-lo) | 0);
  var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, new $c_RTLong(lo$1, hi$1), other.s_concurrent_duration_FiniteDuration__f_unit)
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var x2 = $as_s_concurrent_duration_FiniteDuration(other);
    var this$1 = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var b = x2.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x2.s_concurrent_duration_FiniteDuration__f_length);
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return (this === other)
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var this$1 = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
function $as_s_concurrent_duration_FiniteDuration(obj) {
  return (((obj instanceof $c_s_concurrent_duration_FiniteDuration) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.duration.FiniteDuration"))
}
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)))
}
function $asArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (($isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.duration.FiniteDuration;", depth))
}
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass({
  s_concurrent_duration_FiniteDuration: 0
}, false, "scala.concurrent.duration.FiniteDuration", {
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_FiniteDuration.prototype.$classData = $d_s_concurrent_duration_FiniteDuration;
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) <= 0)
}
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) >= 0)
}
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0)
}
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.gteq__O__O__Z(x, y) ? x : y)
}
function $f_s_math_Ordering__min__O__O__O($thiz, x, y) {
  return ($thiz.lteq__O__O__Z(x, y) ? x : y)
}
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x2 = $as_s_math_Ordering$Reverse(other);
    var x = x2.s_math_Ordering$Reverse__f_outer;
    return ((x !== null) && x.equals__O__Z($thiz))
  } else {
    return false
  }
}
function $is_s_math_Ordering(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Ordering)))
}
function $as_s_math_Ordering(obj) {
  return (($is_s_math_Ordering(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering"))
}
function $isArrayOf_s_math_Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering)))
}
function $asArrayOf_s_math_Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering;", depth))
}
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = $as_s_reflect_ClassTag(x).runtimeClass__jl_Class();
    return (x$2 === x$3)
  } else {
    return false
  }
}
function $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz) {
  return (clazz.isArray__Z() ? (("Array[" + $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T($thiz, clazz.getComponentType__jl_Class())) + "]") : clazz.getName__T())
}
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)))
}
function $as_s_reflect_ClassTag(obj) {
  return (($is_s_reflect_ClassTag(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.reflect.ClassTag"))
}
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)))
}
function $asArrayOf_s_reflect_ClassTag(obj, depth) {
  return (($isArrayOf_s_reflect_ClassTag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.reflect.ClassTag;", depth))
}
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = x$2.productArity__I()
}
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
  /*<skip>*/
}
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax)
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = this.sr_ScalaRunTime$$anon$1__f_x$2.productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass({
  sr_ScalaRunTime$$anon$1: 0
}, false, "scala.runtime.ScalaRunTime$$anon$1", {
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sr_ScalaRunTime$$anon$1.prototype.$classData = $d_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $c_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems)
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $as_sjs_js_WrappedArray($as_scm_Builder($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source)).result__O())
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source)
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray())
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass({
  sjs_js_WrappedArray$: 0
}, false, "scala.scalajs.js.WrappedArray$", {
  sjs_js_WrappedArray$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray$.prototype.$classData = $d_sjs_js_WrappedArray$;
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$()
  };
  return $n_sjs_js_WrappedArray$
}
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = this.newBuilder__scm_Builder();
  return $as_sjsr_WrappedVarArgs($as_scm_Builder(this$1.addAll__sc_IterableOnce__scm_Growable(source)).result__O())
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$4 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
    var x$1 = $as_sjs_js_WrappedArray(x$1$2);
    return $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), x$1.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array)
  }));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source)
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs())
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass({
  sjsr_WrappedVarArgs$: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs$", {
  sjsr_WrappedVarArgs$: 1,
  O: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs$.prototype.$classData = $d_sjsr_WrappedVarArgs$;
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$()
  };
  return $n_sjsr_WrappedVarArgs$
}
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception
}
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
  /*<skip>*/
}
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.isSuccess__Z = (function() {
  return false
});
$c_s_util_Failure.prototype.get__O = (function() {
  throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(this.s_util_Failure__f_exception)
});
$c_s_util_Failure.prototype.orElse__F0__s_util_Try = (function(default$1) {
  try {
    return $as_s_util_Try(default$1.apply__O())
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Failure.prototype.flatMap__F1__s_util_Try = (function(f) {
  return this
});
$c_s_util_Failure.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_s_util_Failure.prototype.map__F1__s_util_Try = (function(f) {
  return this
});
$c_s_util_Failure.prototype.collect__s_PartialFunction__s_util_Try = (function(pf) {
  return this
});
$c_s_util_Failure.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sjsr_AnonFunction1(((marker$1) => ((x$2) => {
      $as_jl_Throwable(x$2);
      return marker$1
    }))(marker)));
    return ((marker !== v) ? new $c_s_util_Success(v) : this)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Failure.prototype.recoverWith__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sjsr_AnonFunction1(((marker$1) => ((x$2) => {
      $as_jl_Throwable(x$2);
      return marker$1
    }))(marker)));
    return ((marker !== v) ? $as_s_util_Try(v) : this)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$()
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure"
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var Failure$1 = $as_s_util_Failure(x$1);
    var x = this.s_util_Failure__f_exception;
    var x$2 = Failure$1.s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
function $as_s_util_Failure(obj) {
  return (((obj instanceof $c_s_util_Failure) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Failure"))
}
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)))
}
function $asArrayOf_s_util_Failure(obj, depth) {
  return (($isArrayOf_s_util_Failure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Failure;", depth))
}
var $d_s_util_Failure = new $TypeData().initClass({
  s_util_Failure: 0
}, false, "scala.util.Failure", {
  s_util_Failure: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Failure.prototype.$classData = $d_s_util_Failure;
/** @constructor */
function $c_s_util_Left(value) {
  this.s_util_Left__f_value = null;
  this.s_util_Left__f_value = value
}
$c_s_util_Left.prototype = new $h_s_util_Either();
$c_s_util_Left.prototype.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
  /*<skip>*/
}
$h_s_util_Left.prototype = $c_s_util_Left.prototype;
$c_s_util_Left.prototype.isRight__Z = (function() {
  return false
});
$c_s_util_Left.prototype.productPrefix__T = (function() {
  return "Left"
});
$c_s_util_Left.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Left.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Left__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Left.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Left.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Left.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Left.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Left)) {
    var Left$1 = $as_s_util_Left(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Left__f_value, Left$1.s_util_Left__f_value)
  } else {
    return false
  }
});
function $as_s_util_Left(obj) {
  return (((obj instanceof $c_s_util_Left) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Left"))
}
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Left)))
}
function $asArrayOf_s_util_Left(obj, depth) {
  return (($isArrayOf_s_util_Left(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Left;", depth))
}
var $d_s_util_Left = new $TypeData().initClass({
  s_util_Left: 0
}, false, "scala.util.Left", {
  s_util_Left: 1,
  s_util_Either: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Left.prototype.$classData = $d_s_util_Left;
/** @constructor */
function $c_s_util_Right(value) {
  this.s_util_Right__f_value = null;
  this.s_util_Right__f_value = value
}
$c_s_util_Right.prototype = new $h_s_util_Either();
$c_s_util_Right.prototype.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
  /*<skip>*/
}
$h_s_util_Right.prototype = $c_s_util_Right.prototype;
$c_s_util_Right.prototype.isRight__Z = (function() {
  return true
});
$c_s_util_Right.prototype.productPrefix__T = (function() {
  return "Right"
});
$c_s_util_Right.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Right.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Right__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Right.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Right.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Right.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Right.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Right)) {
    var Right$1 = $as_s_util_Right(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Right__f_value, Right$1.s_util_Right__f_value)
  } else {
    return false
  }
});
function $as_s_util_Right(obj) {
  return (((obj instanceof $c_s_util_Right) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Right"))
}
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Right)))
}
function $asArrayOf_s_util_Right(obj, depth) {
  return (($isArrayOf_s_util_Right(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Right;", depth))
}
var $d_s_util_Right = new $TypeData().initClass({
  s_util_Right: 0
}, false, "scala.util.Right", {
  s_util_Right: 1,
  s_util_Either: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Right.prototype.$classData = $d_s_util_Right;
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value
}
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
  /*<skip>*/
}
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.isSuccess__Z = (function() {
  return true
});
$c_s_util_Success.prototype.get__O = (function() {
  return this.s_util_Success__f_value
});
$c_s_util_Success.prototype.orElse__F0__s_util_Try = (function(default$1) {
  return this
});
$c_s_util_Success.prototype.flatMap__F1__s_util_Try = (function(f) {
  try {
    return $as_s_util_Try(f.apply__O__O(this.s_util_Success__f_value))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Success.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.map__F1__s_util_Try = (function(f) {
  try {
    return new $c_s_util_Success(f.apply__O__O(this.s_util_Success__f_value))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Success.prototype.collect__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.applyOrElse__O__F1__O(this.s_util_Success__f_value, new $c_sjsr_AnonFunction1(((marker$1) => ((x$2) => marker$1))(marker)));
    return ((marker !== v) ? new $c_s_util_Success(v) : new $c_s_util_Failure($ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("Predicate does not hold for " + this.s_util_Success__f_value))))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      if ((e$2 !== null)) {
        var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!o11.isEmpty__Z())) {
          var e$3 = $as_jl_Throwable(o11.get__O());
          return new $c_s_util_Failure(e$3)
        }
      };
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
    } else {
      throw e
    }
  }
});
$c_s_util_Success.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  return this
});
$c_s_util_Success.prototype.recoverWith__s_PartialFunction__s_util_Try = (function(pf) {
  return this
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value)
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success"
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_util_Success)) {
    var Success$1 = $as_s_util_Success(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, Success$1.s_util_Success__f_value)
  } else {
    return false
  }
});
function $as_s_util_Success(obj) {
  return (((obj instanceof $c_s_util_Success) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.util.Success"))
}
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)))
}
function $asArrayOf_s_util_Success(obj, depth) {
  return (($isArrayOf_s_util_Success(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.util.Success;", depth))
}
var $d_s_util_Success = new $TypeData().initClass({
  s_util_Success: 0
}, false, "scala.util.Success", {
  s_util_Success: 1,
  s_util_Try: 1,
  O: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_util_Success.prototype.$classData = $d_s_util_Success;
/** @constructor */
function $c_Lsnabbdom_init$$anon$2() {
  /*<skip>*/
}
$c_Lsnabbdom_init$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsnabbdom_init$$anon$2.prototype.constructor = $c_Lsnabbdom_init$$anon$2;
/** @constructor */
function $h_Lsnabbdom_init$$anon$2() {
  /*<skip>*/
}
$h_Lsnabbdom_init$$anon$2.prototype = $c_Lsnabbdom_init$$anon$2.prototype;
$c_Lsnabbdom_init$$anon$2.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return ((x instanceof $c_s_Some) && ($as_T2($as_s_Some(x).s_Some__f_value), true))
});
$c_Lsnabbdom_init$$anon$2.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var a = $as_T2($as_s_Some(x).s_Some__f_value);
    return a
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Lsnabbdom_init$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z($as_s_Option(x))
});
$c_Lsnabbdom_init$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O($as_s_Option(x), default$1)
});
var $d_Lsnabbdom_init$$anon$2 = new $TypeData().initClass({
  Lsnabbdom_init$$anon$2: 0
}, false, "snabbdom.init$$anon$2", {
  Lsnabbdom_init$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Lsnabbdom_init$$anon$2.prototype.$classData = $d_Lsnabbdom_init$$anon$2;
/** @constructor */
function $c_Ltyrian_Attribute(name, value) {
  this.Ltyrian_Attribute__f_name = null;
  this.Ltyrian_Attribute__f_value = null;
  this.Ltyrian_Attribute__f_name = name;
  this.Ltyrian_Attribute__f_value = value
}
$c_Ltyrian_Attribute.prototype = new $h_O();
$c_Ltyrian_Attribute.prototype.constructor = $c_Ltyrian_Attribute;
/** @constructor */
function $h_Ltyrian_Attribute() {
  /*<skip>*/
}
$h_Ltyrian_Attribute.prototype = $c_Ltyrian_Attribute.prototype;
$c_Ltyrian_Attribute.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Attribute.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Attribute.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Attribute)) {
    var x$0$2 = $as_Ltyrian_Attribute(x$0);
    return ((this.Ltyrian_Attribute__f_name === x$0$2.Ltyrian_Attribute__f_name) && (this.Ltyrian_Attribute__f_value === x$0$2.Ltyrian_Attribute__f_value))
  } else {
    return false
  }
});
$c_Ltyrian_Attribute.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Attribute.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Attribute.prototype.productPrefix__T = (function() {
  return "Attribute"
});
$c_Ltyrian_Attribute.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Attribute__f_name
  };
  if ((n === 1)) {
    return this.Ltyrian_Attribute__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Attribute(obj) {
  return (((obj instanceof $c_Ltyrian_Attribute) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Attribute"))
}
function $isArrayOf_Ltyrian_Attribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Attribute)))
}
function $asArrayOf_Ltyrian_Attribute(obj, depth) {
  return (($isArrayOf_Ltyrian_Attribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Attribute;", depth))
}
var $d_Ltyrian_Attribute = new $TypeData().initClass({
  Ltyrian_Attribute: 0
}, false, "tyrian.Attribute", {
  Ltyrian_Attribute: 1,
  O: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Attribute.prototype.$classData = $d_Ltyrian_Attribute;
/** @constructor */
function $c_Ltyrian_Cmd$Batch(cmds) {
  this.Ltyrian_Cmd$Batch__f_cmds = null;
  this.Ltyrian_Cmd$Batch__f_cmds = cmds
}
$c_Ltyrian_Cmd$Batch.prototype = new $h_O();
$c_Ltyrian_Cmd$Batch.prototype.constructor = $c_Ltyrian_Cmd$Batch;
/** @constructor */
function $h_Ltyrian_Cmd$Batch() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Batch.prototype = $c_Ltyrian_Cmd$Batch.prototype;
$c_Ltyrian_Cmd$Batch.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Batch.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Batch.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Batch)) {
    var x$0$2 = $as_Ltyrian_Cmd$Batch(x$0);
    var x = this.Ltyrian_Cmd$Batch__f_cmds;
    var x$2 = x$0$2.Ltyrian_Cmd$Batch__f_cmds;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Batch.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Batch.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$Batch.prototype.productPrefix__T = (function() {
  return "Batch"
});
$c_Ltyrian_Cmd$Batch.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Batch__f_cmds
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Batch(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Batch) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Batch"))
}
function $isArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Batch)))
}
function $asArrayOf_Ltyrian_Cmd$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Batch;", depth))
}
var $d_Ltyrian_Cmd$Batch = new $TypeData().initClass({
  Ltyrian_Cmd$Batch: 0
}, false, "tyrian.Cmd$Batch", {
  Ltyrian_Cmd$Batch: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Batch.prototype.$classData = $d_Ltyrian_Cmd$Batch;
/** @constructor */
function $c_Ltyrian_Cmd$Combine(cmd1, cmd2) {
  this.Ltyrian_Cmd$Combine__f_cmd1 = null;
  this.Ltyrian_Cmd$Combine__f_cmd2 = null;
  this.Ltyrian_Cmd$Combine__f_cmd1 = cmd1;
  this.Ltyrian_Cmd$Combine__f_cmd2 = cmd2
}
$c_Ltyrian_Cmd$Combine.prototype = new $h_O();
$c_Ltyrian_Cmd$Combine.prototype.constructor = $c_Ltyrian_Cmd$Combine;
/** @constructor */
function $h_Ltyrian_Cmd$Combine() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Combine.prototype = $c_Ltyrian_Cmd$Combine.prototype;
$c_Ltyrian_Cmd$Combine.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Combine.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Combine.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Combine)) {
    var x$0$2 = $as_Ltyrian_Cmd$Combine(x$0);
    var x = this.Ltyrian_Cmd$Combine__f_cmd1;
    var x$2 = x$0$2.Ltyrian_Cmd$Combine__f_cmd1;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Ltyrian_Cmd$Combine__f_cmd2;
      var x$4 = x$0$2.Ltyrian_Cmd$Combine__f_cmd2;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Combine.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Combine.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Cmd$Combine.prototype.productPrefix__T = (function() {
  return "Combine"
});
$c_Ltyrian_Cmd$Combine.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Combine__f_cmd1
  };
  if ((n === 1)) {
    return this.Ltyrian_Cmd$Combine__f_cmd2
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Combine(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Combine) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Combine"))
}
function $isArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Combine)))
}
function $asArrayOf_Ltyrian_Cmd$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Combine;", depth))
}
var $d_Ltyrian_Cmd$Combine = new $TypeData().initClass({
  Ltyrian_Cmd$Combine: 0
}, false, "tyrian.Cmd$Combine", {
  Ltyrian_Cmd$Combine: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Combine.prototype.$classData = $d_Ltyrian_Cmd$Combine;
/** @constructor */
function $c_Ltyrian_Cmd$Emit(msg) {
  this.Ltyrian_Cmd$Emit__f_msg = null;
  this.Ltyrian_Cmd$Emit__f_msg = msg
}
$c_Ltyrian_Cmd$Emit.prototype = new $h_O();
$c_Ltyrian_Cmd$Emit.prototype.constructor = $c_Ltyrian_Cmd$Emit;
/** @constructor */
function $h_Ltyrian_Cmd$Emit() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$Emit.prototype = $c_Ltyrian_Cmd$Emit.prototype;
$c_Ltyrian_Cmd$Emit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$Emit.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$Emit.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$Emit)) {
    var x$0$2 = $as_Ltyrian_Cmd$Emit(x$0);
    var x = this.Ltyrian_Cmd$Emit__f_msg;
    var y = x$0$2.Ltyrian_Cmd$Emit__f_msg;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$Emit.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$Emit.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$Emit.prototype.productPrefix__T = (function() {
  return "Emit"
});
$c_Ltyrian_Cmd$Emit.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$Emit__f_msg
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$Emit(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$Emit) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Emit"))
}
function $isArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Emit)))
}
function $asArrayOf_Ltyrian_Cmd$Emit(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Emit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Emit;", depth))
}
var $d_Ltyrian_Cmd$Emit = new $TypeData().initClass({
  Ltyrian_Cmd$Emit: 0
}, false, "tyrian.Cmd$Emit", {
  Ltyrian_Cmd$Emit: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$Emit.prototype.$classData = $d_Ltyrian_Cmd$Emit;
function $as_Ltyrian_Cmd$Run(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$Run"))
}
function $isArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$Run)))
}
function $asArrayOf_Ltyrian_Cmd$Run(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$Run(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$Run;", depth))
}
/** @constructor */
function $c_Ltyrian_Cmd$SideEffect(task) {
  this.Ltyrian_Cmd$SideEffect__f_task = null;
  this.Ltyrian_Cmd$SideEffect__f_task = task
}
$c_Ltyrian_Cmd$SideEffect.prototype = new $h_O();
$c_Ltyrian_Cmd$SideEffect.prototype.constructor = $c_Ltyrian_Cmd$SideEffect;
/** @constructor */
function $h_Ltyrian_Cmd$SideEffect() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$SideEffect.prototype = $c_Ltyrian_Cmd$SideEffect.prototype;
$c_Ltyrian_Cmd$SideEffect.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$SideEffect.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Cmd$SideEffect.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Cmd$SideEffect)) {
    var x$0$2 = $as_Ltyrian_Cmd$SideEffect(x$0);
    var x = this.Ltyrian_Cmd$SideEffect__f_task;
    var y = x$0$2.Ltyrian_Cmd$SideEffect__f_task;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Ltyrian_Cmd$SideEffect.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Cmd$SideEffect.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Cmd$SideEffect.prototype.productPrefix__T = (function() {
  return "SideEffect"
});
$c_Ltyrian_Cmd$SideEffect.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Cmd$SideEffect__f_task
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Cmd$SideEffect(obj) {
  return (((obj instanceof $c_Ltyrian_Cmd$SideEffect) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Cmd$SideEffect"))
}
function $isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Cmd$SideEffect)))
}
function $asArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) {
  return (($isArrayOf_Ltyrian_Cmd$SideEffect(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Cmd$SideEffect;", depth))
}
var $d_Ltyrian_Cmd$SideEffect = new $TypeData().initClass({
  Ltyrian_Cmd$SideEffect: 0
}, false, "tyrian.Cmd$SideEffect", {
  Ltyrian_Cmd$SideEffect: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Cmd$SideEffect.prototype.$classData = $d_Ltyrian_Cmd$SideEffect;
/** @constructor */
function $c_Ltyrian_Event(name, msg) {
  this.Ltyrian_Event__f_name = null;
  this.Ltyrian_Event__f_msg = null;
  this.Ltyrian_Event__f_name = name;
  this.Ltyrian_Event__f_msg = msg
}
$c_Ltyrian_Event.prototype = new $h_O();
$c_Ltyrian_Event.prototype.constructor = $c_Ltyrian_Event;
/** @constructor */
function $h_Ltyrian_Event() {
  /*<skip>*/
}
$h_Ltyrian_Event.prototype = $c_Ltyrian_Event.prototype;
$c_Ltyrian_Event.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Event.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Event.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Event)) {
    var x$0$2 = $as_Ltyrian_Event(x$0);
    if ((this.Ltyrian_Event__f_name === x$0$2.Ltyrian_Event__f_name)) {
      var x = this.Ltyrian_Event__f_msg;
      var x$2 = x$0$2.Ltyrian_Event__f_msg;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Event.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Event.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Event.prototype.productPrefix__T = (function() {
  return "Event"
});
$c_Ltyrian_Event.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Event__f_name
  };
  if ((n === 1)) {
    return this.Ltyrian_Event__f_msg
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Event(obj) {
  return (((obj instanceof $c_Ltyrian_Event) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Event"))
}
function $isArrayOf_Ltyrian_Event(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Event)))
}
function $asArrayOf_Ltyrian_Event(obj, depth) {
  return (($isArrayOf_Ltyrian_Event(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Event;", depth))
}
var $d_Ltyrian_Event = new $TypeData().initClass({
  Ltyrian_Event: 0
}, false, "tyrian.Event", {
  Ltyrian_Event: 1,
  O: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Event.prototype.$classData = $d_Ltyrian_Event;
/** @constructor */
function $c_Ltyrian_Html$() {
  this.Ltyrian_Html$__f_accept$minusString = null;
  this.Ltyrian_Html$__f_accessKey$minusString = null;
  this.Ltyrian_Html$__f_action$minusString = null;
  this.Ltyrian_Html$__f_alt$minusString = null;
  this.Ltyrian_Html$__f_autoComplete$minusString = null;
  this.Ltyrian_Html$__f_charset$minusString = null;
  this.Ltyrian_Html$__f_cite$minusString = null;
  this.Ltyrian_Html$__f_$u0060class$u0060$minusString = null;
  this.Ltyrian_Html$__f_cls$minusString = null;
  this.Ltyrian_Html$__f_className$minusString = null;
  this.Ltyrian_Html$__f_classname$minusString = null;
  this.Ltyrian_Html$__f__class$minusString = null;
  this.Ltyrian_Html$__f_cols$minusString = null;
  this.Ltyrian_Html$__f_cols$minusInt = null;
  this.Ltyrian_Html$__f_colSpan$minusString = null;
  this.Ltyrian_Html$__f_colSpan$minusInt = null;
  this.Ltyrian_Html$__f_colspan$minusString = null;
  this.Ltyrian_Html$__f_colspan$minusInt = null;
  this.Ltyrian_Html$__f_content$minusString = null;
  this.Ltyrian_Html$__f_contentEditable$minusString = null;
  this.Ltyrian_Html$__f_contentEditable$minusBoolean = null;
  this.Ltyrian_Html$__f_contenteditable$minusString = null;
  this.Ltyrian_Html$__f_contenteditable$minusBoolean = null;
  this.Ltyrian_Html$__f_coords$minusString = null;
  this.Ltyrian_Html$__f_data$minusString = null;
  this.Ltyrian_Html$__f_dateTime$minusString = null;
  this.Ltyrian_Html$__f_datetime$minusString = null;
  this.Ltyrian_Html$__f_dir$minusString = null;
  this.Ltyrian_Html$__f_dirname$minusString = null;
  this.Ltyrian_Html$__f_draggable$minusString = null;
  this.Ltyrian_Html$__f_draggable$minusBoolean = null;
  this.Ltyrian_Html$__f_encType$minusString = null;
  this.Ltyrian_Html$__f_enctype$minusString = null;
  this.Ltyrian_Html$__f__for$minusString = null;
  this.Ltyrian_Html$__f_forId$minusString = null;
  this.Ltyrian_Html$__f_htmlFor$minusString = null;
  this.Ltyrian_Html$__f_form$minusString = null;
  this.Ltyrian_Html$__f_formAction$minusString = null;
  this.Ltyrian_Html$__f_formaction$minusString = null;
  this.Ltyrian_Html$__f_headers$minusString = null;
  this.Ltyrian_Html$__f_height$minusString = null;
  this.Ltyrian_Html$__f_height$minusInt = null;
  this.Ltyrian_Html$__f_high$minusString = null;
  this.Ltyrian_Html$__f_high$minusDouble = null;
  this.Ltyrian_Html$__f_href$minusString = null;
  this.Ltyrian_Html$__f_hrefLang$minusString = null;
  this.Ltyrian_Html$__f_hreflang$minusString = null;
  this.Ltyrian_Html$__f_http$minusString = null;
  this.Ltyrian_Html$__f_id$minusString = null;
  this.Ltyrian_Html$__f_kind$minusString = null;
  this.Ltyrian_Html$__f_label$minusString = null;
  this.Ltyrian_Html$__f_lang$minusString = null;
  this.Ltyrian_Html$__f_list$minusString = null;
  this.Ltyrian_Html$__f_low$minusString = null;
  this.Ltyrian_Html$__f_low$minusDouble = null;
  this.Ltyrian_Html$__f_max$minusString = null;
  this.Ltyrian_Html$__f_max$minusInt = null;
  this.Ltyrian_Html$__f_maxLength$minusString = null;
  this.Ltyrian_Html$__f_maxLength$minusInt = null;
  this.Ltyrian_Html$__f_maxlength$minusString = null;
  this.Ltyrian_Html$__f_maxlength$minusInt = null;
  this.Ltyrian_Html$__f_media$minusString = null;
  this.Ltyrian_Html$__f_method$minusString = null;
  this.Ltyrian_Html$__f_min$minusString = null;
  this.Ltyrian_Html$__f_min$minusInt = null;
  this.Ltyrian_Html$__f_multiple$minusString = null;
  this.Ltyrian_Html$__f_muted$minusString = null;
  this.Ltyrian_Html$__f_name$minusString = null;
  this.Ltyrian_Html$__f_optimum$minusString = null;
  this.Ltyrian_Html$__f_optimum$minusDouble = null;
  this.Ltyrian_Html$__f_pattern$minusString = null;
  this.Ltyrian_Html$__f_placeholder$minusString = null;
  this.Ltyrian_Html$__f_poster$minusString = null;
  this.Ltyrian_Html$__f_preload$minusString = null;
  this.Ltyrian_Html$__f_rel$minusString = null;
  this.Ltyrian_Html$__f_rows$minusString = null;
  this.Ltyrian_Html$__f_rows$minusInt = null;
  this.Ltyrian_Html$__f_rowSpan$minusString = null;
  this.Ltyrian_Html$__f_rowSpan$minusInt = null;
  this.Ltyrian_Html$__f_rowspan$minusString = null;
  this.Ltyrian_Html$__f_rowspan$minusInt = null;
  this.Ltyrian_Html$__f_scope$minusString = null;
  this.Ltyrian_Html$__f_shape$minusString = null;
  this.Ltyrian_Html$__f_size$minusString = null;
  this.Ltyrian_Html$__f_size$minusInt = null;
  this.Ltyrian_Html$__f_sizes$minusString = null;
  this.Ltyrian_Html$__f_span$minusString = null;
  this.Ltyrian_Html$__f_span$minusInt = null;
  this.Ltyrian_Html$__f_spellCheck$minusString = null;
  this.Ltyrian_Html$__f_spellCheck$minusBoolean = null;
  this.Ltyrian_Html$__f_spellcheck$minusString = null;
  this.Ltyrian_Html$__f_spellcheck$minusBoolean = null;
  this.Ltyrian_Html$__f_src$minusString = null;
  this.Ltyrian_Html$__f_srcDoc$minusString = null;
  this.Ltyrian_Html$__f_srcdoc$minusString = null;
  this.Ltyrian_Html$__f_srcLang$minusString = null;
  this.Ltyrian_Html$__f_srclang$minusString = null;
  this.Ltyrian_Html$__f_srcSet$minusString = null;
  this.Ltyrian_Html$__f_srcset$minusString = null;
  this.Ltyrian_Html$__f_start$minusString = null;
  this.Ltyrian_Html$__f_start$minusInt = null;
  this.Ltyrian_Html$__f_step$minusString = null;
  this.Ltyrian_Html$__f_step$minusInt = null;
  this.Ltyrian_Html$__f_style$minusString = null;
  this.Ltyrian_Html$__f_tabIndex$minusString = null;
  this.Ltyrian_Html$__f_tabIndex$minusInt = null;
  this.Ltyrian_Html$__f_tabindex$minusString = null;
  this.Ltyrian_Html$__f_tabindex$minusInt = null;
  this.Ltyrian_Html$__f_target$minusString = null;
  this.Ltyrian_Html$__f_title$minusString = null;
  this.Ltyrian_Html$__f_translate$minusString = null;
  this.Ltyrian_Html$__f_$u0060type$u0060$minusString = null;
  this.Ltyrian_Html$__f__type$minusString = null;
  this.Ltyrian_Html$__f_typ$minusString = null;
  this.Ltyrian_Html$__f_tpe$minusString = null;
  this.Ltyrian_Html$__f_useMap$minusString = null;
  this.Ltyrian_Html$__f_usemap$minusString = null;
  this.Ltyrian_Html$__f_width$minusString = null;
  this.Ltyrian_Html$__f_width$minusInt = null;
  this.Ltyrian_Html$__f_wrap$minusString = null;
  this.Ltyrian_Html$__f_value$minusString = null;
  this.Ltyrian_Html$__f_value$minusDouble = null;
  this.Ltyrian_Html$__f_value$minusBoolean = null;
  $n_Ltyrian_Html$ = this;
  $f_Ltyrian_HtmlAttributes__$init$__V(this)
}
$c_Ltyrian_Html$.prototype = new $h_O();
$c_Ltyrian_Html$.prototype.constructor = $c_Ltyrian_Html$;
/** @constructor */
function $h_Ltyrian_Html$() {
  /*<skip>*/
}
$h_Ltyrian_Html$.prototype = $c_Ltyrian_Html$.prototype;
$c_Ltyrian_Html$.prototype.onInput__F1__Ltyrian_Attr = (function(msg) {
  var msg$1 = new $c_sjsr_AnonFunction1(((msg$2) => ((e) => msg$2.apply__O__O($as_T(e.target.value))))(msg));
  return new $c_Ltyrian_Event("input", msg$1)
});
var $d_Ltyrian_Html$ = new $TypeData().initClass({
  Ltyrian_Html$: 0
}, false, "tyrian.Html$", {
  Ltyrian_Html$: 1,
  O: 1,
  Ltyrian_HtmlTags: 1,
  Ltyrian_HtmlAttributes: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Ltyrian_Html$.prototype.$classData = $d_Ltyrian_Html$;
var $n_Ltyrian_Html$;
function $m_Ltyrian_Html$() {
  if ((!$n_Ltyrian_Html$)) {
    $n_Ltyrian_Html$ = new $c_Ltyrian_Html$()
  };
  return $n_Ltyrian_Html$
}
function $as_Ltyrian_NamedAttribute(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.NamedAttribute"))
}
function $isArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_NamedAttribute)))
}
function $asArrayOf_Ltyrian_NamedAttribute(obj, depth) {
  return (($isArrayOf_Ltyrian_NamedAttribute(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.NamedAttribute;", depth))
}
/** @constructor */
function $c_Ltyrian_Property(name, value) {
  this.Ltyrian_Property__f_name = null;
  this.Ltyrian_Property__f_value = null;
  this.Ltyrian_Property__f_name = name;
  this.Ltyrian_Property__f_value = value
}
$c_Ltyrian_Property.prototype = new $h_O();
$c_Ltyrian_Property.prototype.constructor = $c_Ltyrian_Property;
/** @constructor */
function $h_Ltyrian_Property() {
  /*<skip>*/
}
$h_Ltyrian_Property.prototype = $c_Ltyrian_Property.prototype;
$c_Ltyrian_Property.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Property.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Property.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Property)) {
    var x$0$2 = $as_Ltyrian_Property(x$0);
    return ((this.Ltyrian_Property__f_name === x$0$2.Ltyrian_Property__f_name) && (this.Ltyrian_Property__f_value === x$0$2.Ltyrian_Property__f_value))
  } else {
    return false
  }
});
$c_Ltyrian_Property.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Property.prototype.productArity__I = (function() {
  return 2
});
$c_Ltyrian_Property.prototype.productPrefix__T = (function() {
  return "Property"
});
$c_Ltyrian_Property.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Property__f_name
  };
  if ((n === 1)) {
    return this.Ltyrian_Property__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Property(obj) {
  return (((obj instanceof $c_Ltyrian_Property) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Property"))
}
function $isArrayOf_Ltyrian_Property(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Property)))
}
function $asArrayOf_Ltyrian_Property(obj, depth) {
  return (($isArrayOf_Ltyrian_Property(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Property;", depth))
}
var $d_Ltyrian_Property = new $TypeData().initClass({
  Ltyrian_Property: 0
}, false, "tyrian.Property", {
  Ltyrian_Property: 1,
  O: 1,
  Ltyrian_Attr: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Property.prototype.$classData = $d_Ltyrian_Property;
function $as_Ltyrian_Sub$Batch(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Batch"))
}
function $isArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Batch)))
}
function $asArrayOf_Ltyrian_Sub$Batch(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Batch(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Batch;", depth))
}
function $as_Ltyrian_Sub$Combine(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Combine"))
}
function $isArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Combine)))
}
function $asArrayOf_Ltyrian_Sub$Combine(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Combine(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Combine;", depth))
}
function $as_Ltyrian_Sub$Observe(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Sub$Observe"))
}
function $isArrayOf_Ltyrian_Sub$Observe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Sub$Observe)))
}
function $asArrayOf_Ltyrian_Sub$Observe(obj, depth) {
  return (($isArrayOf_Ltyrian_Sub$Observe(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Sub$Observe;", depth))
}
/** @constructor */
function $c_Ltyrian_Text(value) {
  this.Ltyrian_Text__f_value = null;
  this.Ltyrian_Text__f_value = value
}
$c_Ltyrian_Text.prototype = new $h_O();
$c_Ltyrian_Text.prototype.constructor = $c_Ltyrian_Text;
/** @constructor */
function $h_Ltyrian_Text() {
  /*<skip>*/
}
$h_Ltyrian_Text.prototype = $c_Ltyrian_Text.prototype;
$c_Ltyrian_Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Text.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Text)) {
    var x$0$2 = $as_Ltyrian_Text(x$0);
    return (this.Ltyrian_Text__f_value === x$0$2.Ltyrian_Text__f_value)
  } else {
    return false
  }
});
$c_Ltyrian_Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Text.prototype.productArity__I = (function() {
  return 1
});
$c_Ltyrian_Text.prototype.productPrefix__T = (function() {
  return "Text"
});
$c_Ltyrian_Text.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ltyrian_Text__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Ltyrian_Text(obj) {
  return (((obj instanceof $c_Ltyrian_Text) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Text"))
}
function $isArrayOf_Ltyrian_Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Text)))
}
function $asArrayOf_Ltyrian_Text(obj, depth) {
  return (($isArrayOf_Ltyrian_Text(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Text;", depth))
}
var $d_Ltyrian_Text = new $TypeData().initClass({
  Ltyrian_Text: 0
}, false, "tyrian.Text", {
  Ltyrian_Text: 1,
  O: 1,
  Ltyrian_Elem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Text.prototype.$classData = $d_Ltyrian_Text;
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$1() {
  /*<skip>*/
}
$c_Ltyrian_runtime_Rendering$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$1;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$1() {
  /*<skip>*/
}
$h_Ltyrian_runtime_Rendering$$anon$1.prototype = $c_Ltyrian_runtime_Rendering$$anon$1.prototype;
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    return true
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    x$1$1._1__T();
    return true
  } else {
    return false
  }
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Attribute)) {
    $m_Ltyrian_Attribute$();
    var x$1 = $as_Ltyrian_Attribute(x);
    var x15 = x$1.Ltyrian_Attribute__f_name;
    var x16 = x$1.Ltyrian_Attribute__f_value;
    return new $c_T2(x15, x16)
  } else if (false) {
    var x$1$1 = $as_Ltyrian_NamedAttribute(x);
    var x12 = x$1$1._1__T();
    return new $c_T2(x12, "")
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x))
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1)
});
var $d_Ltyrian_runtime_Rendering$$anon$1 = new $TypeData().initClass({
  Ltyrian_runtime_Rendering$$anon$1: 0
}, false, "tyrian.runtime.Rendering$$anon$1", {
  Ltyrian_runtime_Rendering$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_Rendering$$anon$1.prototype.$classData = $d_Ltyrian_runtime_Rendering$$anon$1;
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$2() {
  /*<skip>*/
}
$c_Ltyrian_runtime_Rendering$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$2;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$2() {
  /*<skip>*/
}
$h_Ltyrian_runtime_Rendering$$anon$2.prototype = $c_Ltyrian_runtime_Rendering$$anon$2.prototype;
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Property)) {
    $m_Ltyrian_Property$();
    var x$1 = $as_Ltyrian_Property(x);
    return true
  } else {
    return false
  }
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Property)) {
    $m_Ltyrian_Property$();
    var x$1 = $as_Ltyrian_Property(x);
    var x25 = x$1.Ltyrian_Property__f_name;
    var x26 = x$1.Ltyrian_Property__f_value;
    return new $c_T2(x25, x26)
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x))
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1)
});
var $d_Ltyrian_runtime_Rendering$$anon$2 = new $TypeData().initClass({
  Ltyrian_runtime_Rendering$$anon$2: 0
}, false, "tyrian.runtime.Rendering$$anon$2", {
  Ltyrian_runtime_Rendering$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_Rendering$$anon$2.prototype.$classData = $d_Ltyrian_runtime_Rendering$$anon$2;
/** @constructor */
function $c_Ltyrian_runtime_Rendering$$anon$3(onMsg$3) {
  this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1 = null;
  this.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1 = onMsg$3
}
$c_Ltyrian_runtime_Rendering$$anon$3.prototype = new $h_sr_AbstractPartialFunction();
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.constructor = $c_Ltyrian_runtime_Rendering$$anon$3;
/** @constructor */
function $h_Ltyrian_runtime_Rendering$$anon$3() {
  /*<skip>*/
}
$h_Ltyrian_runtime_Rendering$$anon$3.prototype = $c_Ltyrian_runtime_Rendering$$anon$3.prototype;
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.isDefinedAt__Ltyrian_Attr__Z = (function(x) {
  if ((x instanceof $c_Ltyrian_Event)) {
    var x$1 = $as_Ltyrian_Event(x);
    return true
  } else {
    return false
  }
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.applyOrElse__Ltyrian_Attr__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Ltyrian_Event)) {
    var x$1 = $as_Ltyrian_Event(x);
    var x35 = x$1.Ltyrian_Event__f_name;
    var x36 = x$1.Ltyrian_Event__f_msg;
    var _2 = $m_Lsnabbdom_EventHandler$().apply__sci_Seq__Lsnabbdom_EventHandler($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([new $c_sjsr_AnonFunction1(((this$2, msg$2) => ((e) => {
      this$2.Ltyrian_runtime_Rendering$$anon$3__f_onMsg$1.apply__O__O(msg$2.apply__O__O(e))
    }))(this, x36))])));
    return new $c_T2(x35, _2)
  } else {
    return default$1.apply__O__O(x)
  }
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Ltyrian_Attr__Z($as_Ltyrian_Attr(x))
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Ltyrian_Attr__F1__O($as_Ltyrian_Attr(x), default$1)
});
var $d_Ltyrian_runtime_Rendering$$anon$3 = new $TypeData().initClass({
  Ltyrian_runtime_Rendering$$anon$3: 0
}, false, "tyrian.runtime.Rendering$$anon$3", {
  Ltyrian_runtime_Rendering$$anon$3: 1,
  sr_AbstractPartialFunction: 1,
  O: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_runtime_Rendering$$anon$3.prototype.$classData = $d_Ltyrian_runtime_Rendering$$anon$3;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$3() {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$3.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$3.prototype.constructor = $c_Lcats_EvalInstances$$anon$3;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$3() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$3.prototype = $c_Lcats_EvalInstances$$anon$3.prototype;
$c_Lcats_EvalInstances$$anon$3.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O(this, fa, f, B)
});
$c_Lcats_EvalInstances$$anon$3.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_EvalInstances$$anon$3.prototype.foldRight__Lcats_Eval__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return fa.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((lb$2, f$2) => ((_$1) => $as_Lcats_Eval(f$2.apply__O__O__O(_$1, lb$2))))(lb, f)))
});
$c_Lcats_EvalInstances$$anon$3.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return f.apply__O__O__O(b, fa$1.value__O())
});
$c_Lcats_EvalInstances$$anon$3.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_Eval__Lcats_Eval__F2__Lcats_Eval($as_Lcats_Eval(fa), lb, f)
});
var $d_Lcats_EvalInstances$$anon$3 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$3: 0
}, false, "cats.EvalInstances$$anon$3", {
  Lcats_EvalInstances$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1
});
$c_Lcats_EvalInstances$$anon$3.prototype.$classData = $d_Lcats_EvalInstances$$anon$3;
function $ct_Lcats_NonEmptyReducible__Lcats_Foldable__($thiz, G) {
  $thiz.Lcats_NonEmptyReducible__f_G = G;
  return $thiz
}
/** @constructor */
function $c_Lcats_NonEmptyReducible() {
  this.Lcats_NonEmptyReducible__f_G = null
}
$c_Lcats_NonEmptyReducible.prototype = new $h_O();
$c_Lcats_NonEmptyReducible.prototype.constructor = $c_Lcats_NonEmptyReducible;
/** @constructor */
function $h_Lcats_NonEmptyReducible() {
  /*<skip>*/
}
$h_Lcats_NonEmptyReducible.prototype = $c_Lcats_NonEmptyReducible.prototype;
$c_Lcats_NonEmptyReducible.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
/** @constructor */
function $c_Lcats_Now(value) {
  this.Lcats_Now__f_value = null;
  this.Lcats_Now__f_value = value
}
$c_Lcats_Now.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Now.prototype.constructor = $c_Lcats_Now;
/** @constructor */
function $h_Lcats_Now() {
  /*<skip>*/
}
$h_Lcats_Now.prototype = $c_Lcats_Now.prototype;
$c_Lcats_Now.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_Now.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_Now.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_Now)) {
    var x$0$2 = $as_Lcats_Now(x$0);
    var x = this.Lcats_Now__f_value;
    var y = x$0$2.Lcats_Now__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_Now.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lcats_Now.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_Now.prototype.productPrefix__T = (function() {
  return "Now"
});
$c_Lcats_Now.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Now__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_Now.prototype.value__O = (function() {
  return this.Lcats_Now__f_value
});
$c_Lcats_Now.prototype.memoize__Lcats_Eval = (function() {
  return this
});
function $as_Lcats_Now(obj) {
  return (((obj instanceof $c_Lcats_Now) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Now"))
}
function $isArrayOf_Lcats_Now(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Now)))
}
function $asArrayOf_Lcats_Now(obj, depth) {
  return (($isArrayOf_Lcats_Now(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Now;", depth))
}
var $d_Lcats_Now = new $TypeData().initClass({
  Lcats_Now: 0
}, false, "cats.Now", {
  Lcats_Now: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lcats_Now.prototype.$classData = $d_Lcats_Now;
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$1() {
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_False
}
$c_Lcats_UnorderedFoldable$$anon$1.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$1.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$1() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$$anon$1.prototype = $c_Lcats_UnorderedFoldable$$anon$1.prototype;
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return lx.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((ly$2) => ((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_True
    };
    if ((x$1$1 === false)) {
      return ly$2
    };
    throw new $c_s_MatchError(x$1$1)
  }))(ly)))
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$1__f_empty
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y))
});
var $d_Lcats_UnorderedFoldable$$anon$1 = new $TypeData().initClass({
  Lcats_UnorderedFoldable$$anon$1: 0
}, false, "cats.UnorderedFoldable$$anon$1", {
  Lcats_UnorderedFoldable$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.$classData = $d_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$2() {
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_True
}
$c_Lcats_UnorderedFoldable$$anon$2.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$2.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$2() {
  /*<skip>*/
}
$h_Lcats_UnorderedFoldable$$anon$2.prototype = $c_Lcats_UnorderedFoldable$$anon$2.prototype;
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return lx.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((ly$2) => ((x$1) => {
    var x$1$1 = $uZ(x$1);
    if ((x$1$1 === true)) {
      return ly$2
    };
    if ((x$1$1 === false)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_False
    };
    throw new $c_s_MatchError(x$1$1)
  }))(ly)))
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$2__f_empty
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval($as_Lcats_Eval(x), $as_Lcats_Eval(y))
});
var $d_Lcats_UnorderedFoldable$$anon$2 = new $TypeData().initClass({
  Lcats_UnorderedFoldable$$anon$2: 0
}, false, "cats.UnorderedFoldable$$anon$2", {
  Lcats_UnorderedFoldable$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.$classData = $d_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $c_Lcats_data_Chain$Append(leftNE, rightNE) {
  this.Lcats_data_Chain$Append__f_leftNE = null;
  this.Lcats_data_Chain$Append__f_rightNE = null;
  this.Lcats_data_Chain$Append__f_leftNE = leftNE;
  this.Lcats_data_Chain$Append__f_rightNE = rightNE
}
$c_Lcats_data_Chain$Append.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Append.prototype.constructor = $c_Lcats_data_Chain$Append;
/** @constructor */
function $h_Lcats_data_Chain$Append() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Append.prototype = $c_Lcats_data_Chain$Append.prototype;
$c_Lcats_data_Chain$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Append.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_data_Chain$Append.prototype.productPrefix__T = (function() {
  return "Append"
});
$c_Lcats_data_Chain$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Append__f_leftNE
  };
  if ((n === 1)) {
    return this.Lcats_data_Chain$Append__f_rightNE
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Chain$Append(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Append) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Append"))
}
function $isArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Append)))
}
function $asArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Append(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Append;", depth))
}
var $d_Lcats_data_Chain$Append = new $TypeData().initClass({
  Lcats_data_Chain$Append: 0
}, false, "cats.data.Chain$Append", {
  Lcats_data_Chain$Append: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Chain$Append.prototype.$classData = $d_Lcats_data_Chain$Append;
/** @constructor */
function $c_Lcats_data_Chain$Singleton(a) {
  this.Lcats_data_Chain$Singleton__f_a = null;
  this.Lcats_data_Chain$Singleton__f_a = a
}
$c_Lcats_data_Chain$Singleton.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Singleton.prototype.constructor = $c_Lcats_data_Chain$Singleton;
/** @constructor */
function $h_Lcats_data_Chain$Singleton() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Singleton.prototype = $c_Lcats_data_Chain$Singleton.prototype;
$c_Lcats_data_Chain$Singleton.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Singleton.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Chain$Singleton.prototype.productPrefix__T = (function() {
  return "Singleton"
});
$c_Lcats_data_Chain$Singleton.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Singleton__f_a
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Chain$Singleton(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Singleton) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Singleton"))
}
function $isArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Singleton)))
}
function $asArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Singleton(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Singleton;", depth))
}
var $d_Lcats_data_Chain$Singleton = new $TypeData().initClass({
  Lcats_data_Chain$Singleton: 0
}, false, "cats.data.Chain$Singleton", {
  Lcats_data_Chain$Singleton: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Chain$Singleton.prototype.$classData = $d_Lcats_data_Chain$Singleton;
/** @constructor */
function $c_Lcats_data_Chain$Wrap(seq) {
  this.Lcats_data_Chain$Wrap__f_seq = null;
  this.Lcats_data_Chain$Wrap__f_seq = seq
}
$c_Lcats_data_Chain$Wrap.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Wrap.prototype.constructor = $c_Lcats_data_Chain$Wrap;
/** @constructor */
function $h_Lcats_data_Chain$Wrap() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Wrap.prototype = $c_Lcats_data_Chain$Wrap.prototype;
$c_Lcats_data_Chain$Wrap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Wrap.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_data_Chain$Wrap.prototype.productPrefix__T = (function() {
  return "Wrap"
});
$c_Lcats_data_Chain$Wrap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Wrap__f_seq
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_data_Chain$Wrap(obj) {
  return (((obj instanceof $c_Lcats_data_Chain$Wrap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.data.Chain$Wrap"))
}
function $isArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Wrap)))
}
function $asArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (($isArrayOf_Lcats_data_Chain$Wrap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.data.Chain$Wrap;", depth))
}
var $d_Lcats_data_Chain$Wrap = new $TypeData().initClass({
  Lcats_data_Chain$Wrap: 0
}, false, "cats.data.Chain$Wrap", {
  Lcats_data_Chain$Wrap: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_data_Chain$Wrap.prototype.$classData = $d_Lcats_data_Chain$Wrap;
/** @constructor */
function $c_Lcats_data_KleisliInstances4() {
  /*<skip>*/
}
$c_Lcats_data_KleisliInstances4.prototype = new $h_Lcats_data_KleisliInstances5();
$c_Lcats_data_KleisliInstances4.prototype.constructor = $c_Lcats_data_KleisliInstances4;
/** @constructor */
function $h_Lcats_data_KleisliInstances4() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances4.prototype = $c_Lcats_data_KleisliInstances4.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyList$() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyList = null;
  $ct_Lcats_data_NonEmptyListInstances__(this)
}
$c_Lcats_data_NonEmptyList$.prototype = new $h_Lcats_data_NonEmptyListInstances();
$c_Lcats_data_NonEmptyList$.prototype.constructor = $c_Lcats_data_NonEmptyList$;
/** @constructor */
function $h_Lcats_data_NonEmptyList$() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyList$.prototype = $c_Lcats_data_NonEmptyList$.prototype;
$c_Lcats_data_NonEmptyList$.prototype.toString__T = (function() {
  return "NonEmptyList"
});
$c_Lcats_data_NonEmptyList$.prototype.fromList__sci_List__s_Option = (function(l) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (l === null) : x.equals__O__Z(l))) {
    return $m_s_None$()
  };
  if ((l instanceof $c_sci_$colon$colon)) {
    var x41 = $as_sci_$colon$colon(l);
    var x43 = x41.sci_$colon$colon__f_next;
    var h = x41.sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    var value = new $c_Lcats_data_NonEmptyList(h, x43);
    return new $c_s_Some(value)
  };
  throw new $c_s_MatchError(l)
});
$c_Lcats_data_NonEmptyList$.prototype.fromListUnsafe__sci_List__Lcats_data_NonEmptyList = (function(l) {
  var x = $m_s_package$().s_package$__f_Nil;
  if (((x === null) ? (l === null) : x.equals__O__Z(l))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptyList from empty list")
  };
  if ((l instanceof $c_sci_$colon$colon)) {
    var x45 = $as_sci_$colon$colon(l);
    var x47 = x45.sci_$colon$colon__f_next;
    var h = x45.sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(h, x47)
  };
  throw new $c_s_MatchError(l)
});
var $d_Lcats_data_NonEmptyList$ = new $TypeData().initClass({
  Lcats_data_NonEmptyList$: 0
}, false, "cats.data.NonEmptyList$", {
  Lcats_data_NonEmptyList$: 1,
  Lcats_data_NonEmptyListInstances: 1,
  Lcats_data_NonEmptyListInstances0: 1,
  Lcats_data_NonEmptyListInstances1: 1,
  O: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_data_NonEmptyList$.prototype.$classData = $d_Lcats_data_NonEmptyList$;
var $n_Lcats_data_NonEmptyList$;
function $m_Lcats_data_NonEmptyList$() {
  if ((!$n_Lcats_data_NonEmptyList$)) {
    $n_Lcats_data_NonEmptyList$ = new $c_Lcats_data_NonEmptyList$()
  };
  return $n_Lcats_data_NonEmptyList$
}
/** @constructor */
function $c_Lcats_effect_IO$Attempt(ioa) {
  this.Lcats_effect_IO$Attempt__f_ioa = null;
  this.Lcats_effect_IO$Attempt__f_ioa = ioa
}
$c_Lcats_effect_IO$Attempt.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Attempt.prototype.constructor = $c_Lcats_effect_IO$Attempt;
/** @constructor */
function $h_Lcats_effect_IO$Attempt() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Attempt.prototype = $c_Lcats_effect_IO$Attempt.prototype;
$c_Lcats_effect_IO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Attempt)) {
    var x$0$2 = $as_Lcats_effect_IO$Attempt(x$0);
    var x = this.Lcats_effect_IO$Attempt__f_ioa;
    var x$2 = x$0$2.Lcats_effect_IO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Attempt.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_IO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt"
});
$c_Lcats_effect_IO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Attempt__f_ioa
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Attempt.prototype.tag__B = (function() {
  return 8
});
function $as_Lcats_effect_IO$Attempt(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Attempt) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Attempt"))
}
function $isArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Attempt)))
}
function $asArrayOf_Lcats_effect_IO$Attempt(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Attempt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Attempt;", depth))
}
var $d_Lcats_effect_IO$Attempt = new $TypeData().initClass({
  Lcats_effect_IO$Attempt: 0
}, false, "cats.effect.IO$Attempt", {
  Lcats_effect_IO$Attempt: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Attempt.prototype.$classData = $d_Lcats_effect_IO$Attempt;
function $as_Lcats_effect_IO$Blocking(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Blocking"))
}
function $isArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Blocking)))
}
function $asArrayOf_Lcats_effect_IO$Blocking(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Blocking(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Blocking;", depth))
}
/** @constructor */
function $c_Lcats_effect_IO$Delay(thunk, event) {
  this.Lcats_effect_IO$Delay__f_thunk = null;
  this.Lcats_effect_IO$Delay__f_event = null;
  this.Lcats_effect_IO$Delay__f_thunk = thunk;
  this.Lcats_effect_IO$Delay__f_event = event
}
$c_Lcats_effect_IO$Delay.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Delay.prototype.constructor = $c_Lcats_effect_IO$Delay;
/** @constructor */
function $h_Lcats_effect_IO$Delay() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Delay.prototype = $c_Lcats_effect_IO$Delay.prototype;
$c_Lcats_effect_IO$Delay.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Delay.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Delay.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Delay)) {
    var x$0$2 = $as_Lcats_effect_IO$Delay(x$0);
    var x = this.Lcats_effect_IO$Delay__f_thunk;
    var x$2 = x$0$2.Lcats_effect_IO$Delay__f_thunk;
    if ((x === x$2)) {
      var x$3 = this.Lcats_effect_IO$Delay__f_event;
      var x$4 = x$0$2.Lcats_effect_IO$Delay__f_event;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Delay.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_IO$Delay.prototype.productPrefix__T = (function() {
  return "Delay"
});
$c_Lcats_effect_IO$Delay.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Delay__f_thunk
  };
  if ((n === 1)) {
    return this.Lcats_effect_IO$Delay__f_event
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Delay.prototype.tag__B = (function() {
  return 2
});
function $as_Lcats_effect_IO$Delay(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Delay) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Delay"))
}
function $isArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Delay)))
}
function $asArrayOf_Lcats_effect_IO$Delay(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Delay(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Delay;", depth))
}
var $d_Lcats_effect_IO$Delay = new $TypeData().initClass({
  Lcats_effect_IO$Delay: 0
}, false, "cats.effect.IO$Delay", {
  Lcats_effect_IO$Delay: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Delay.prototype.$classData = $d_Lcats_effect_IO$Delay;
/** @constructor */
function $c_Lcats_effect_IO$Error(t) {
  this.Lcats_effect_IO$Error__f_t = null;
  this.Lcats_effect_IO$Error__f_t = t
}
$c_Lcats_effect_IO$Error.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Error.prototype.constructor = $c_Lcats_effect_IO$Error;
/** @constructor */
function $h_Lcats_effect_IO$Error() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Error.prototype = $c_Lcats_effect_IO$Error.prototype;
$c_Lcats_effect_IO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Error)) {
    var x$0$2 = $as_Lcats_effect_IO$Error(x$0);
    var x = this.Lcats_effect_IO$Error__f_t;
    var x$2 = x$0$2.Lcats_effect_IO$Error__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Error.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_IO$Error.prototype.productPrefix__T = (function() {
  return "Error"
});
$c_Lcats_effect_IO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Error__f_t
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Error.prototype.tag__B = (function() {
  return 1
});
function $as_Lcats_effect_IO$Error(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Error) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Error"))
}
function $isArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Error)))
}
function $asArrayOf_Lcats_effect_IO$Error(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Error(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Error;", depth))
}
var $d_Lcats_effect_IO$Error = new $TypeData().initClass({
  Lcats_effect_IO$Error: 0
}, false, "cats.effect.IO$Error", {
  Lcats_effect_IO$Error: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Error.prototype.$classData = $d_Lcats_effect_IO$Error;
/** @constructor */
function $c_Lcats_effect_IO$EvalOn(ioa, ec) {
  this.Lcats_effect_IO$EvalOn__f_ioa = null;
  this.Lcats_effect_IO$EvalOn__f_ec = null;
  this.Lcats_effect_IO$EvalOn__f_ioa = ioa;
  this.Lcats_effect_IO$EvalOn__f_ec = ec
}
$c_Lcats_effect_IO$EvalOn.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EvalOn.prototype.constructor = $c_Lcats_effect_IO$EvalOn;
/** @constructor */
function $h_Lcats_effect_IO$EvalOn() {
  /*<skip>*/
}
$h_Lcats_effect_IO$EvalOn.prototype = $c_Lcats_effect_IO$EvalOn.prototype;
$c_Lcats_effect_IO$EvalOn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$EvalOn.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$EvalOn.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$EvalOn)) {
    var x$0$2 = $as_Lcats_effect_IO$EvalOn(x$0);
    var x = this.Lcats_effect_IO$EvalOn__f_ioa;
    var x$2 = x$0$2.Lcats_effect_IO$EvalOn__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$EvalOn__f_ec;
      var x$4 = x$0$2.Lcats_effect_IO$EvalOn__f_ec;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$EvalOn.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_IO$EvalOn.prototype.productPrefix__T = (function() {
  return "EvalOn"
});
$c_Lcats_effect_IO$EvalOn.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$EvalOn__f_ioa
  };
  if ((n === 1)) {
    return this.Lcats_effect_IO$EvalOn__f_ec
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$EvalOn.prototype.tag__B = (function() {
  return 20
});
function $as_Lcats_effect_IO$EvalOn(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$EvalOn) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$EvalOn"))
}
function $isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$EvalOn)))
}
function $asArrayOf_Lcats_effect_IO$EvalOn(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$EvalOn(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$EvalOn;", depth))
}
var $d_Lcats_effect_IO$EvalOn = new $TypeData().initClass({
  Lcats_effect_IO$EvalOn: 0
}, false, "cats.effect.IO$EvalOn", {
  Lcats_effect_IO$EvalOn: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$EvalOn.prototype.$classData = $d_Lcats_effect_IO$EvalOn;
/** @constructor */
function $c_Lcats_effect_IO$FlatMap(ioe, f, event) {
  this.Lcats_effect_IO$FlatMap__f_ioe = null;
  this.Lcats_effect_IO$FlatMap__f_f = null;
  this.Lcats_effect_IO$FlatMap__f_event = null;
  this.Lcats_effect_IO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_IO$FlatMap__f_f = f;
  this.Lcats_effect_IO$FlatMap__f_event = event
}
$c_Lcats_effect_IO$FlatMap.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$FlatMap.prototype.constructor = $c_Lcats_effect_IO$FlatMap;
/** @constructor */
function $h_Lcats_effect_IO$FlatMap() {
  /*<skip>*/
}
$h_Lcats_effect_IO$FlatMap.prototype = $c_Lcats_effect_IO$FlatMap.prototype;
$c_Lcats_effect_IO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$FlatMap)) {
    var x$0$2 = $as_Lcats_effect_IO$FlatMap(x$0);
    var x = this.Lcats_effect_IO$FlatMap__f_ioe;
    var x$2 = x$0$2.Lcats_effect_IO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$FlatMap__f_f;
      var x$4 = x$0$2.Lcats_effect_IO$FlatMap__f_f;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcats_effect_IO$FlatMap__f_event;
      var x$6 = x$0$2.Lcats_effect_IO$FlatMap__f_event;
      return (x$5 === x$6)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.productArity__I = (function() {
  return 3
});
$c_Lcats_effect_IO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap"
});
$c_Lcats_effect_IO$FlatMap.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$FlatMap__f_ioe;
      break
    }
    case 1: {
      return this.Lcats_effect_IO$FlatMap__f_f;
      break
    }
    case 2: {
      return this.Lcats_effect_IO$FlatMap__f_event;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lcats_effect_IO$FlatMap.prototype.tag__B = (function() {
  return 7
});
function $as_Lcats_effect_IO$FlatMap(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$FlatMap) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$FlatMap"))
}
function $isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$FlatMap)))
}
function $asArrayOf_Lcats_effect_IO$FlatMap(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$FlatMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$FlatMap;", depth))
}
var $d_Lcats_effect_IO$FlatMap = new $TypeData().initClass({
  Lcats_effect_IO$FlatMap: 0
}, false, "cats.effect.IO$FlatMap", {
  Lcats_effect_IO$FlatMap: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$FlatMap.prototype.$classData = $d_Lcats_effect_IO$FlatMap;
/** @constructor */
function $c_Lcats_effect_IO$HandleErrorWith(ioa, f, event) {
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_IO$HandleErrorWith__f_f = null;
  this.Lcats_effect_IO$HandleErrorWith__f_event = null;
  this.Lcats_effect_IO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_IO$HandleErrorWith__f_f = f;
  this.Lcats_effect_IO$HandleErrorWith__f_event = event
}
$c_Lcats_effect_IO$HandleErrorWith.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_IO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_IO$HandleErrorWith() {
  /*<skip>*/
}
$h_Lcats_effect_IO$HandleErrorWith.prototype = $c_Lcats_effect_IO$HandleErrorWith.prototype;
$c_Lcats_effect_IO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$HandleErrorWith)) {
    var x$0$2 = $as_Lcats_effect_IO$HandleErrorWith(x$0);
    var x = this.Lcats_effect_IO$HandleErrorWith__f_ioa;
    var x$2 = x$0$2.Lcats_effect_IO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$HandleErrorWith__f_f;
      var x$4 = x$0$2.Lcats_effect_IO$HandleErrorWith__f_f;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcats_effect_IO$HandleErrorWith__f_event;
      var x$6 = x$0$2.Lcats_effect_IO$HandleErrorWith__f_event;
      return (x$5 === x$6)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productArity__I = (function() {
  return 3
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith"
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$HandleErrorWith__f_ioa;
      break
    }
    case 1: {
      return this.Lcats_effect_IO$HandleErrorWith__f_f;
      break
    }
    case 2: {
      return this.Lcats_effect_IO$HandleErrorWith__f_event;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.tag__B = (function() {
  return 9
});
function $as_Lcats_effect_IO$HandleErrorWith(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$HandleErrorWith) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$HandleErrorWith"))
}
function $isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$HandleErrorWith)))
}
function $asArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$HandleErrorWith(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$HandleErrorWith;", depth))
}
var $d_Lcats_effect_IO$HandleErrorWith = new $TypeData().initClass({
  Lcats_effect_IO$HandleErrorWith: 0
}, false, "cats.effect.IO$HandleErrorWith", {
  Lcats_effect_IO$HandleErrorWith: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$HandleErrorWith.prototype.$classData = $d_Lcats_effect_IO$HandleErrorWith;
/** @constructor */
function $c_Lcats_effect_IO$IOCont(body, event) {
  this.Lcats_effect_IO$IOCont__f_body = null;
  this.Lcats_effect_IO$IOCont__f_event = null;
  this.Lcats_effect_IO$IOCont__f_body = body;
  this.Lcats_effect_IO$IOCont__f_event = event
}
$c_Lcats_effect_IO$IOCont.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont.prototype.constructor = $c_Lcats_effect_IO$IOCont;
/** @constructor */
function $h_Lcats_effect_IO$IOCont() {
  /*<skip>*/
}
$h_Lcats_effect_IO$IOCont.prototype = $c_Lcats_effect_IO$IOCont.prototype;
$c_Lcats_effect_IO$IOCont.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$IOCont.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$IOCont.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont)) {
    var x$0$2 = $as_Lcats_effect_IO$IOCont(x$0);
    var x = this.Lcats_effect_IO$IOCont__f_body;
    var x$2 = x$0$2.Lcats_effect_IO$IOCont__f_body;
    if ((x === x$2)) {
      var x$3 = this.Lcats_effect_IO$IOCont__f_event;
      var x$4 = x$0$2.Lcats_effect_IO$IOCont__f_event;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$IOCont.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_IO$IOCont.prototype.productPrefix__T = (function() {
  return "IOCont"
});
$c_Lcats_effect_IO$IOCont.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont__f_body
  };
  if ((n === 1)) {
    return this.Lcats_effect_IO$IOCont__f_event
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$IOCont.prototype.tag__B = (function() {
  return 14
});
function $as_Lcats_effect_IO$IOCont(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$IOCont) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$IOCont"))
}
function $isArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont)))
}
function $asArrayOf_Lcats_effect_IO$IOCont(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$IOCont(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$IOCont;", depth))
}
var $d_Lcats_effect_IO$IOCont = new $TypeData().initClass({
  Lcats_effect_IO$IOCont: 0
}, false, "cats.effect.IO$IOCont", {
  Lcats_effect_IO$IOCont: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$IOCont.prototype.$classData = $d_Lcats_effect_IO$IOCont;
/** @constructor */
function $c_Lcats_effect_IO$IOCont$Get(state) {
  this.Lcats_effect_IO$IOCont$Get__f_state = null;
  this.Lcats_effect_IO$IOCont$Get__f_state = state
}
$c_Lcats_effect_IO$IOCont$Get.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$IOCont$Get.prototype.constructor = $c_Lcats_effect_IO$IOCont$Get;
/** @constructor */
function $h_Lcats_effect_IO$IOCont$Get() {
  /*<skip>*/
}
$h_Lcats_effect_IO$IOCont$Get.prototype = $c_Lcats_effect_IO$IOCont$Get.prototype;
$c_Lcats_effect_IO$IOCont$Get.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$IOCont$Get.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$IOCont$Get.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$IOCont$Get)) {
    var x$0$2 = $as_Lcats_effect_IO$IOCont$Get(x$0);
    var x = this.Lcats_effect_IO$IOCont$Get__f_state;
    var x$2 = x$0$2.Lcats_effect_IO$IOCont$Get__f_state;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productPrefix__T = (function() {
  return "Get"
});
$c_Lcats_effect_IO$IOCont$Get.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$IOCont$Get__f_state
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$IOCont$Get.prototype.tag__B = (function() {
  return 15
});
function $as_Lcats_effect_IO$IOCont$Get(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$IOCont$Get) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$IOCont$Get"))
}
function $isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$IOCont$Get)))
}
function $asArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$IOCont$Get(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$IOCont$Get;", depth))
}
var $d_Lcats_effect_IO$IOCont$Get = new $TypeData().initClass({
  Lcats_effect_IO$IOCont$Get: 0
}, false, "cats.effect.IO$IOCont$Get", {
  Lcats_effect_IO$IOCont$Get: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$IOCont$Get.prototype.$classData = $d_Lcats_effect_IO$IOCont$Get;
function $as_Lcats_effect_IO$Local(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Local"))
}
function $isArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Local)))
}
function $asArrayOf_Lcats_effect_IO$Local(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Local(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Local;", depth))
}
/** @constructor */
function $c_Lcats_effect_IO$Map(ioe, f, event) {
  this.Lcats_effect_IO$Map__f_ioe = null;
  this.Lcats_effect_IO$Map__f_f = null;
  this.Lcats_effect_IO$Map__f_event = null;
  this.Lcats_effect_IO$Map__f_ioe = ioe;
  this.Lcats_effect_IO$Map__f_f = f;
  this.Lcats_effect_IO$Map__f_event = event
}
$c_Lcats_effect_IO$Map.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Map.prototype.constructor = $c_Lcats_effect_IO$Map;
/** @constructor */
function $h_Lcats_effect_IO$Map() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Map.prototype = $c_Lcats_effect_IO$Map.prototype;
$c_Lcats_effect_IO$Map.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Map.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Map.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Map)) {
    var x$0$2 = $as_Lcats_effect_IO$Map(x$0);
    var x = this.Lcats_effect_IO$Map__f_ioe;
    var x$2 = x$0$2.Lcats_effect_IO$Map__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Map__f_f;
      var x$4 = x$0$2.Lcats_effect_IO$Map__f_f;
      var $$x1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$5 = this.Lcats_effect_IO$Map__f_event;
      var x$6 = x$0$2.Lcats_effect_IO$Map__f_event;
      return (x$5 === x$6)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Map.prototype.productArity__I = (function() {
  return 3
});
$c_Lcats_effect_IO$Map.prototype.productPrefix__T = (function() {
  return "Map"
});
$c_Lcats_effect_IO$Map.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Map__f_ioe;
      break
    }
    case 1: {
      return this.Lcats_effect_IO$Map__f_f;
      break
    }
    case 2: {
      return this.Lcats_effect_IO$Map__f_event;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lcats_effect_IO$Map.prototype.tag__B = (function() {
  return 6
});
function $as_Lcats_effect_IO$Map(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Map) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Map"))
}
function $isArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Map)))
}
function $asArrayOf_Lcats_effect_IO$Map(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Map;", depth))
}
var $d_Lcats_effect_IO$Map = new $TypeData().initClass({
  Lcats_effect_IO$Map: 0
}, false, "cats.effect.IO$Map", {
  Lcats_effect_IO$Map: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Map.prototype.$classData = $d_Lcats_effect_IO$Map;
/** @constructor */
function $c_Lcats_effect_IO$OnCancel(ioa, fin) {
  this.Lcats_effect_IO$OnCancel__f_ioa = null;
  this.Lcats_effect_IO$OnCancel__f_fin = null;
  this.Lcats_effect_IO$OnCancel__f_ioa = ioa;
  this.Lcats_effect_IO$OnCancel__f_fin = fin
}
$c_Lcats_effect_IO$OnCancel.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$OnCancel.prototype.constructor = $c_Lcats_effect_IO$OnCancel;
/** @constructor */
function $h_Lcats_effect_IO$OnCancel() {
  /*<skip>*/
}
$h_Lcats_effect_IO$OnCancel.prototype = $c_Lcats_effect_IO$OnCancel.prototype;
$c_Lcats_effect_IO$OnCancel.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$OnCancel.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$OnCancel.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$OnCancel)) {
    var x$0$2 = $as_Lcats_effect_IO$OnCancel(x$0);
    var x = this.Lcats_effect_IO$OnCancel__f_ioa;
    var x$2 = x$0$2.Lcats_effect_IO$OnCancel__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$OnCancel__f_fin;
      var x$4 = x$0$2.Lcats_effect_IO$OnCancel__f_fin;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$OnCancel.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_IO$OnCancel.prototype.productPrefix__T = (function() {
  return "OnCancel"
});
$c_Lcats_effect_IO$OnCancel.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$OnCancel__f_ioa
  };
  if ((n === 1)) {
    return this.Lcats_effect_IO$OnCancel__f_fin
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$OnCancel.prototype.tag__B = (function() {
  return 11
});
function $as_Lcats_effect_IO$OnCancel(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$OnCancel) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$OnCancel"))
}
function $isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$OnCancel)))
}
function $asArrayOf_Lcats_effect_IO$OnCancel(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$OnCancel(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$OnCancel;", depth))
}
var $d_Lcats_effect_IO$OnCancel = new $TypeData().initClass({
  Lcats_effect_IO$OnCancel: 0
}, false, "cats.effect.IO$OnCancel", {
  Lcats_effect_IO$OnCancel: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$OnCancel.prototype.$classData = $d_Lcats_effect_IO$OnCancel;
/** @constructor */
function $c_Lcats_effect_IO$Pure(value) {
  this.Lcats_effect_IO$Pure__f_value = null;
  this.Lcats_effect_IO$Pure__f_value = value
}
$c_Lcats_effect_IO$Pure.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Pure.prototype.constructor = $c_Lcats_effect_IO$Pure;
/** @constructor */
function $h_Lcats_effect_IO$Pure() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Pure.prototype = $c_Lcats_effect_IO$Pure.prototype;
$c_Lcats_effect_IO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Pure)) {
    var x$0$2 = $as_Lcats_effect_IO$Pure(x$0);
    var x = this.Lcats_effect_IO$Pure__f_value;
    var y = x$0$2.Lcats_effect_IO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Pure.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_IO$Pure.prototype.productPrefix__T = (function() {
  return "Pure"
});
$c_Lcats_effect_IO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Pure__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Pure.prototype.tag__B = (function() {
  return 0
});
$c_Lcats_effect_IO$Pure.prototype.toString__T = (function() {
  return (("IO(" + this.Lcats_effect_IO$Pure__f_value) + ")")
});
function $as_Lcats_effect_IO$Pure(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Pure) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Pure"))
}
function $isArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Pure)))
}
function $asArrayOf_Lcats_effect_IO$Pure(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Pure(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Pure;", depth))
}
var $d_Lcats_effect_IO$Pure = new $TypeData().initClass({
  Lcats_effect_IO$Pure: 0
}, false, "cats.effect.IO$Pure", {
  Lcats_effect_IO$Pure: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Pure.prototype.$classData = $d_Lcats_effect_IO$Pure;
function $as_Lcats_effect_IO$RacePair(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$RacePair"))
}
function $isArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$RacePair)))
}
function $asArrayOf_Lcats_effect_IO$RacePair(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$RacePair(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$RacePair;", depth))
}
function $as_Lcats_effect_IO$Sleep(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Sleep"))
}
function $isArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Sleep)))
}
function $asArrayOf_Lcats_effect_IO$Sleep(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Sleep(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Sleep;", depth))
}
/** @constructor */
function $c_Lcats_effect_IO$Start(ioa) {
  this.Lcats_effect_IO$Start__f_ioa = null;
  this.Lcats_effect_IO$Start__f_ioa = ioa
}
$c_Lcats_effect_IO$Start.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Start.prototype.constructor = $c_Lcats_effect_IO$Start;
/** @constructor */
function $h_Lcats_effect_IO$Start() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Start.prototype = $c_Lcats_effect_IO$Start.prototype;
$c_Lcats_effect_IO$Start.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Start.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Start.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Start)) {
    var x$0$2 = $as_Lcats_effect_IO$Start(x$0);
    var x = this.Lcats_effect_IO$Start__f_ioa;
    var x$2 = x$0$2.Lcats_effect_IO$Start__f_ioa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Start.prototype.productArity__I = (function() {
  return 1
});
$c_Lcats_effect_IO$Start.prototype.productPrefix__T = (function() {
  return "Start"
});
$c_Lcats_effect_IO$Start.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Start__f_ioa
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Start.prototype.tag__B = (function() {
  return 17
});
function $as_Lcats_effect_IO$Start(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Start) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Start"))
}
function $isArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Start)))
}
function $asArrayOf_Lcats_effect_IO$Start(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Start(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Start;", depth))
}
var $d_Lcats_effect_IO$Start = new $TypeData().initClass({
  Lcats_effect_IO$Start: 0
}, false, "cats.effect.IO$Start", {
  Lcats_effect_IO$Start: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Start.prototype.$classData = $d_Lcats_effect_IO$Start;
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable(body, event) {
  this.Lcats_effect_IO$Uncancelable__f_body = null;
  this.Lcats_effect_IO$Uncancelable__f_event = null;
  this.Lcats_effect_IO$Uncancelable__f_body = body;
  this.Lcats_effect_IO$Uncancelable__f_event = event
}
$c_Lcats_effect_IO$Uncancelable.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable.prototype.constructor = $c_Lcats_effect_IO$Uncancelable;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Uncancelable.prototype = $c_Lcats_effect_IO$Uncancelable.prototype;
$c_Lcats_effect_IO$Uncancelable.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Uncancelable.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lcats_effect_IO$Uncancelable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable)) {
    var x$0$2 = $as_Lcats_effect_IO$Uncancelable(x$0);
    var x = this.Lcats_effect_IO$Uncancelable__f_body;
    var x$2 = x$0$2.Lcats_effect_IO$Uncancelable__f_body;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_IO$Uncancelable__f_event;
      var x$4 = x$0$2.Lcats_effect_IO$Uncancelable__f_event;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Uncancelable.prototype.productArity__I = (function() {
  return 2
});
$c_Lcats_effect_IO$Uncancelable.prototype.productPrefix__T = (function() {
  return "Uncancelable"
});
$c_Lcats_effect_IO$Uncancelable.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_IO$Uncancelable__f_body
  };
  if ((n === 1)) {
    return this.Lcats_effect_IO$Uncancelable__f_event
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Uncancelable.prototype.tag__B = (function() {
  return 12
});
function $as_Lcats_effect_IO$Uncancelable(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Uncancelable) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Uncancelable"))
}
function $isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable)))
}
function $asArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Uncancelable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Uncancelable;", depth))
}
var $d_Lcats_effect_IO$Uncancelable = new $TypeData().initClass({
  Lcats_effect_IO$Uncancelable: 0
}, false, "cats.effect.IO$Uncancelable", {
  Lcats_effect_IO$Uncancelable: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Uncancelable.prototype.$classData = $d_Lcats_effect_IO$Uncancelable;
/** @constructor */
function $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(ioa, id, self) {
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = 0;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = null;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa = ioa;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id = id;
  this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self = self
}
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.constructor = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop;
/** @constructor */
function $h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype = $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype;
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("UnmaskRunLoop");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop)) {
    var x$0$2 = $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(x$0);
    if ((this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id === x$0$2.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id)) {
      var x = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var x$2 = x$0$2.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      var x$4 = x$0$2.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productArity__I = (function() {
  return 3
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productPrefix__T = (function() {
  return "UnmaskRunLoop"
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
      break
    }
    case 1: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id;
      break
    }
    case 2: {
      return this.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.tag__B = (function() {
  return 13
});
function $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj) {
  return (((obj instanceof $c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IO$Uncancelable$UnmaskRunLoop"))
}
function $isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IO$Uncancelable$UnmaskRunLoop)))
}
function $asArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) {
  return (($isArrayOf_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IO$Uncancelable$UnmaskRunLoop;", depth))
}
var $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop = new $TypeData().initClass({
  Lcats_effect_IO$Uncancelable$UnmaskRunLoop: 0
}, false, "cats.effect.IO$Uncancelable$UnmaskRunLoop", {
  Lcats_effect_IO$Uncancelable$UnmaskRunLoop: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lcats_effect_IO$Uncancelable$UnmaskRunLoop.prototype.$classData = $d_Lcats_effect_IO$Uncancelable$UnmaskRunLoop;
function $ct_Lcats_effect_IOFiber__sci_Map__Lcats_effect_ArrayStack__s_concurrent_ExecutionContext__Lcats_effect_ArrayStack__Lcats_effect_CallbackStack__B__O__Lcats_effect_tracing_RingBuffer__Lcats_effect_unsafe_IORuntime__($thiz, localState, objectState, currentCtx, finalizers, callbacks, resumeTag, resumeIO, tracingEvents, runtime) {
  $thiz.Lcats_effect_IOFiber__f_localState = localState;
  $thiz.Lcats_effect_IOFiber__f_objectState = objectState;
  $thiz.Lcats_effect_IOFiber__f_currentCtx = currentCtx;
  $thiz.Lcats_effect_IOFiber__f_finalizers = finalizers;
  $thiz.Lcats_effect_IOFiber__f_callbacks = callbacks;
  $thiz.Lcats_effect_IOFiber__f_resumeTag = resumeTag;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = resumeIO;
  $thiz.Lcats_effect_IOFiber__f_tracingEvents = tracingEvents;
  $thiz.Lcats_effect_IOFiber__f_runtime = runtime;
  $ct_ju_concurrent_atomic_AtomicBoolean__Z__($thiz, false);
  $thiz.Lcats_effect_IOFiber__f_canceled = false;
  $thiz.Lcats_effect_IOFiber__f_masks = 0;
  $thiz.Lcats_effect_IOFiber__f_finalizing = false;
  $thiz.Lcats_effect_IOFiber__f_RightUnit = $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_RightUnit;
  $thiz.Lcats_effect_IOFiber__f_IOEndFiber = $m_Lcats_effect_IO$EndFiber$();
  $thiz.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((this$1, objectState$2) => ((_$3) => {
    $as_Lcats_effect_kernel_Poll(_$3);
    return $m_Lcats_effect_IO$().defer__F0__Lcats_effect_IO(new $c_sjsr_AnonFunction0(((this$2, objectState$1$2) => (() => {
      this$2.Lcats_effect_IOFiber__f_canceled = true;
      if (this$2.getAndSet__Z__Z(false)) {
        if ($p_Lcats_effect_IOFiber__isUnmasked__Z(this$2)) {
          return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((this$3, objectState$2$2) => ((fin) => {
            var fin$1 = $as_F1(fin);
            var ec = this$3.Lcats_effect_IOFiber__f_currentCtx;
            this$3.Lcats_effect_IOFiber__f_resumeTag = 4;
            objectState$2$2.push__O__V(fin$1);
            $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this$3, ec, this$3)
          }))(this$2, objectState$1$2)))
        } else {
          this$2.ju_concurrent_atomic_AtomicBoolean__f_value = true;
          return this$2.join__Lcats_effect_IO().void__Lcats_effect_IO()
        }
      } else {
        return this$2.join__Lcats_effect_IO().void__Lcats_effect_IO()
      }
    }))(this$1, objectState$2)))
  }))($thiz, objectState)));
  $thiz.Lcats_effect_IOFiber__f__join = $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((this$2$1) => ((cb) => {
    var cb$1 = $as_F1(cb);
    var this$8 = $m_Lcats_effect_IO$();
    var thunk$1 = new $c_sjsr_AnonFunction0(((this$4, cb$2) => (() => {
      var handle = $p_Lcats_effect_IOFiber__registerListener__F1__Lcats_effect_CallbackStack(this$4, new $c_sjsr_AnonFunction1(((cb$1$2) => ((oc) => {
        var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
        cb$1$2.apply__O__O(($m_s_package$(), new $c_s_util_Right(oc$1)))
      }))(cb$2)));
      if ((handle === null)) {
        return $m_s_None$()
      } else {
        var this$6 = $m_Lcats_effect_IO$();
        var thunk = new $c_sjsr_AnonFunction0(((handle$2) => (() => {
          handle$2.clearCurrent__V()
        }))(handle));
        var value = this$6.delay__F0__Lcats_effect_IO(thunk);
        return new $c_s_Some(value)
      }
    }))(this$2$1, cb$1));
    return this$8.delay__F0__Lcats_effect_IO(thunk$1)
  }))($thiz)));
  return $thiz
}
function $ct_Lcats_effect_IOFiber__sci_Map__F1__Lcats_effect_IO__s_concurrent_ExecutionContext__Lcats_effect_unsafe_IORuntime__($thiz, localState, cb, startIO, startEC, runtime) {
  var $$x4 = $ct_Lcats_effect_ArrayStack__(new $c_Lcats_effect_ArrayStack());
  var $$x3 = $ct_Lcats_effect_ArrayStack__(new $c_Lcats_effect_ArrayStack());
  var $$x2 = new $c_Lcats_effect_CallbackStack(cb);
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var logSize = runtime.Lcats_effect_unsafe_IORuntime__f_traceBufferLogSize;
    var $$x1 = new $c_Lcats_effect_tracing_RingBuffer(logSize)
  } else {
    var $$x1 = null
  };
  $ct_Lcats_effect_IOFiber__sci_Map__Lcats_effect_ArrayStack__s_concurrent_ExecutionContext__Lcats_effect_ArrayStack__Lcats_effect_CallbackStack__B__O__Lcats_effect_tracing_RingBuffer__Lcats_effect_unsafe_IORuntime__($thiz, localState, $$x4, startEC, $$x3, $$x2, 0, startIO, $$x1, runtime);
  return $thiz
}
function $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, _cur0, cancelationIterations, autoCedeIterations) {
  var this$ = $thiz;
  var autoCedeIterations$tailLocal1 = autoCedeIterations;
  var cancelationIterations$tailLocal1 = cancelationIterations;
  var _cur0$tailLocal1 = _cur0;
  while (true) {
    if ((_cur0$tailLocal1 === this$.Lcats_effect_IOFiber__f_IOEndFiber)) {
      return (void 0)
    };
    var nextCancelation = (((-1) + cancelationIterations$tailLocal1) | 0);
    var nextAutoCede = autoCedeIterations$tailLocal1;
    if ((nextCancelation <= 0)) {
      nextCancelation = this$.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold;
      nextAutoCede = ((nextAutoCede - nextCancelation) | 0);
      if ((nextAutoCede <= 0)) {
        this$.Lcats_effect_IOFiber__f_resumeTag = 7;
        this$.Lcats_effect_IOFiber__f_resumeIO = _cur0$tailLocal1;
        var ec = this$.Lcats_effect_IOFiber__f_currentCtx;
        $p_Lcats_effect_IOFiber__rescheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this$, ec, this$);
        return (void 0)
      }
    };
    if ($p_Lcats_effect_IOFiber__shouldFinalize__Z(this$)) {
      var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO(this$, null);
      var \u03b4this$tmp1 = this$;
      var cancelationIterations$tailLocal1$tmp1 = nextCancelation;
      var autoCedeIterations$tailLocal1$tmp1 = nextAutoCede;
      this$ = \u03b4this$tmp1;
      _cur0$tailLocal1 = fin;
      cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp1;
      autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp1;
      continue
    } else {
      if ((_cur0$tailLocal1 === null)) {
        var t = $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
        var cur0 = new $c_Lcats_effect_IO$Error(t)
      } else {
        var cur0 = _cur0$tailLocal1
      };
      var x55 = cur0.tag__B();
      switch (x55) {
        case 0: {
          var cur = $as_Lcats_effect_IO$Pure(cur0);
          var \u03b4this$tmp2 = this$;
          var _cur0$tailLocal1$tmp2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, cur.Lcats_effect_IO$Pure__f_value, 0);
          var cancelationIterations$tailLocal1$tmp2 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp2 = nextAutoCede;
          this$ = \u03b4this$tmp2;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp2;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp2;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp2;
          continue;
          break
        }
        case 1: {
          var cur$2 = $as_Lcats_effect_IO$Error(cur0);
          var \u03b4this$tmp3 = this$;
          var _cur0$tailLocal1$tmp3 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, cur$2.Lcats_effect_IO$Error__f_t, 0);
          var cancelationIterations$tailLocal1$tmp3 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp3 = nextAutoCede;
          this$ = \u03b4this$tmp3;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp3;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp3;
          continue;
          break
        }
        case 2: {
          var cur$3 = $as_Lcats_effect_IO$Delay(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$3.Lcats_effect_IO$Delay__f_event)
          };
          var error = null;
          try {
            var r = cur$3.Lcats_effect_IO$Delay__f_thunk.apply__O()
          } catch (e) {
            var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
            matchResult2: {
              var r;
              if ((e$2 !== null)) {
                var x4 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
                if ((!x4.isEmpty__Z())) {
                  var x5 = $as_jl_Throwable(x4.get__O());
                  error = x5;
                  var r = (void 0);
                  break matchResult2
                }
              };
              if ((e$2 !== null)) {
                var r = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$2);
                break matchResult2
              };
              throw e$2
            }
          };
          var next = ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, r, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, error, 0));
          var \u03b4this$tmp4 = this$;
          var cancelationIterations$tailLocal1$tmp4 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp4 = nextAutoCede;
          this$ = \u03b4this$tmp4;
          _cur0$tailLocal1 = next;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp4;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp4;
          continue;
          break
        }
        case 3: {
          var \u03b4this$tmp5 = this$;
          var $$x1 = this$;
          var this$5 = $m_RTLong$();
          var value = $uD(new Date().getTime());
          var lo = this$5.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
          var hi = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$7 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
          var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
          var t$1 = this$7.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp5 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($$x1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit), 0);
          var cancelationIterations$tailLocal1$tmp5 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp5 = nextAutoCede;
          this$ = \u03b4this$tmp5;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp5;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp5;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp5;
          continue;
          break
        }
        case 4: {
          var \u03b4this$tmp6 = this$;
          var $$x2 = this$;
          var this$12 = $m_RTLong$();
          var value$1 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
          var lo$2 = this$12.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
          var hi$2 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$14 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$2, hi$2));
          var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
          var t$2 = this$14.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
          var lo$3 = t$2.RTLong__f_lo;
          var hi$3 = t$2.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var _cur0$tailLocal1$tmp6 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($$x2, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1), 0);
          var cancelationIterations$tailLocal1$tmp6 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp6 = nextAutoCede;
          this$ = \u03b4this$tmp6;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp6;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp6;
          continue;
          break
        }
        case 5: {
          var \u03b4this$tmp7 = this$;
          var _cur0$tailLocal1$tmp7 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, this$.Lcats_effect_IOFiber__f_currentCtx, 0);
          var cancelationIterations$tailLocal1$tmp7 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp7 = nextAutoCede;
          this$ = \u03b4this$tmp7;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp7;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp7;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp7;
          continue;
          break
        }
        case 6: {
          var cur$4 = $as_Lcats_effect_IO$Map(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$4.Lcats_effect_IO$Map__f_event)
          };
          var ioe = cur$4.Lcats_effect_IO$Map__f_ioe;
          var f = cur$4.Lcats_effect_IO$Map__f_f;
          var x17 = ioe.tag__B();
          switch (x17) {
            case 0: {
              var pure = $as_Lcats_effect_IO$Pure(ioe);
              var \u03b4this$tmp8 = this$;
              var _cur0$tailLocal1$tmp8 = $ps_Lcats_effect_IOFiber__next$1__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f, this$, pure.Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp8 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp8 = nextAutoCede;
              this$ = \u03b4this$tmp8;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp8;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp8;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp8;
              continue;
              break
            }
            case 1: {
              var error$2 = $as_Lcats_effect_IO$Error(ioe);
              var \u03b4this$tmp9 = this$;
              var _cur0$tailLocal1$tmp9 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, error$2.Lcats_effect_IO$Error__f_t, 0);
              var cancelationIterations$tailLocal1$tmp9 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp9 = nextAutoCede;
              this$ = \u03b4this$tmp9;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp9;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp9;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp9;
              continue;
              break
            }
            case 2: {
              var delay = $as_Lcats_effect_IO$Delay(ioe);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, delay.Lcats_effect_IO$Delay__f_event)
              };
              var error$3 = null;
              try {
                var result = f.apply__O__O(delay.Lcats_effect_IO$Delay__f_thunk.apply__O())
              } catch (e$3) {
                var e$4 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$3);
                matchResult4: {
                  var result;
                  if ((e$4 !== null)) {
                    var x14 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$4);
                    if ((!x14.isEmpty__Z())) {
                      var x15 = $as_jl_Throwable(x14.get__O());
                      error$3 = x15;
                      var result = (void 0);
                      break matchResult4
                    }
                  };
                  if ((e$4 !== null)) {
                    var result = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$4);
                    break matchResult4
                  };
                  throw e$4
                }
              };
              var nextIO = ((error$3 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, error$3, 0));
              var \u03b4this$tmp10 = this$;
              var cancelationIterations$tailLocal1$tmp10 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp10 = nextAutoCede;
              this$ = \u03b4this$tmp10;
              _cur0$tailLocal1 = nextIO;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp10;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp10;
              continue;
              break
            }
            case 3: {
              var this$19 = $m_RTLong$();
              var value$2 = $uD(new Date().getTime());
              var lo$4 = this$19.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$2);
              var hi$4 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$21 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$4, hi$4));
              var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
              var t$3 = this$21.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$5 = t$3.RTLong__f_lo;
              var hi$5 = t$3.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var realTime = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$5, hi$5), unit$2);
              var \u03b4this$tmp11 = this$;
              var _cur0$tailLocal1$tmp11 = $ps_Lcats_effect_IOFiber__next$1__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f, this$, realTime);
              var cancelationIterations$tailLocal1$tmp11 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp11 = nextAutoCede;
              this$ = \u03b4this$tmp11;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp11;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp11;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp11;
              continue;
              break
            }
            case 4: {
              var this$26 = $m_RTLong$();
              var value$3 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
              var lo$6 = this$26.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$3);
              var hi$6 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$28 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$6, hi$6));
              var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$4 = this$28.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$7 = t$4.RTLong__f_lo;
              var hi$7 = t$4.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$7, hi$7), unit$3);
              var \u03b4this$tmp12 = this$;
              var _cur0$tailLocal1$tmp12 = $ps_Lcats_effect_IOFiber__next$1__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f, this$, monotonic);
              var cancelationIterations$tailLocal1$tmp12 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp12 = nextAutoCede;
              this$ = \u03b4this$tmp12;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp12;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp12;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp12;
              continue;
              break
            }
            case 5: {
              var ec$2 = this$.Lcats_effect_IOFiber__f_currentCtx;
              var \u03b4this$tmp13 = this$;
              var _cur0$tailLocal1$tmp13 = $ps_Lcats_effect_IOFiber__next$1__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f, this$, ec$2);
              var cancelationIterations$tailLocal1$tmp13 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp13 = nextAutoCede;
              this$ = \u03b4this$tmp13;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp13;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp13;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp13;
              continue;
              break
            }
            default: {
              this$.Lcats_effect_IOFiber__f_objectState.push__O__V(f);
              this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 0);
              var \u03b4this$tmp14 = this$;
              var cancelationIterations$tailLocal1$tmp14 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp14 = nextAutoCede;
              this$ = \u03b4this$tmp14;
              _cur0$tailLocal1 = ioe;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp14;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp14;
              continue
            }
          };
          break
        }
        case 7: {
          var cur$5 = $as_Lcats_effect_IO$FlatMap(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$5.Lcats_effect_IO$FlatMap__f_event)
          };
          var ioe$2 = cur$5.Lcats_effect_IO$FlatMap__f_ioe;
          var f$2 = cur$5.Lcats_effect_IO$FlatMap__f_f;
          var x28 = ioe$2.tag__B();
          switch (x28) {
            case 0: {
              var pure$2 = $as_Lcats_effect_IO$Pure(ioe$2);
              var \u03b4this$tmp15 = this$;
              var _cur0$tailLocal1$tmp15 = $ps_Lcats_effect_IOFiber__next$2__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f$2, this$, pure$2.Lcats_effect_IO$Pure__f_value);
              var cancelationIterations$tailLocal1$tmp15 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp15 = nextAutoCede;
              this$ = \u03b4this$tmp15;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp15;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp15;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp15;
              continue;
              break
            }
            case 1: {
              var error$4 = $as_Lcats_effect_IO$Error(ioe$2);
              var \u03b4this$tmp16 = this$;
              var _cur0$tailLocal1$tmp16 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, error$4.Lcats_effect_IO$Error__f_t, 0);
              var cancelationIterations$tailLocal1$tmp16 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp16 = nextAutoCede;
              this$ = \u03b4this$tmp16;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp16;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp16;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp16;
              continue;
              break
            }
            case 2: {
              var delay$2 = $as_Lcats_effect_IO$Delay(ioe$2);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, delay$2.Lcats_effect_IO$Delay__f_event)
              };
              try {
                var result$2 = $as_Lcats_effect_IO(f$2.apply__O__O(delay$2.Lcats_effect_IO$Delay__f_thunk.apply__O()))
              } catch (e$5) {
                var e$6 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$5);
                matchResult7: {
                  var result$2;
                  if ((e$6 !== null)) {
                    var x25 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$6);
                    if ((!x25.isEmpty__Z())) {
                      var x26 = $as_jl_Throwable(x25.get__O());
                      var result$2 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, x26, 0);
                      break matchResult7
                    }
                  };
                  if ((e$6 !== null)) {
                    var result$2 = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$6);
                    break matchResult7
                  };
                  throw e$6
                }
              };
              var \u03b4this$tmp17 = this$;
              var cancelationIterations$tailLocal1$tmp17 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp17 = nextAutoCede;
              this$ = \u03b4this$tmp17;
              _cur0$tailLocal1 = result$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp17;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp17;
              continue;
              break
            }
            case 3: {
              var this$33 = $m_RTLong$();
              var value$4 = $uD(new Date().getTime());
              var lo$8 = this$33.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$4);
              var hi$8 = this$33.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$35 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$8, hi$8));
              var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
              var t$5 = this$35.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$9 = t$5.RTLong__f_lo;
              var hi$9 = t$5.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var realTime$2 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$9, hi$9), unit$4);
              var \u03b4this$tmp18 = this$;
              var _cur0$tailLocal1$tmp18 = $ps_Lcats_effect_IOFiber__next$2__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f$2, this$, realTime$2);
              var cancelationIterations$tailLocal1$tmp18 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp18 = nextAutoCede;
              this$ = \u03b4this$tmp18;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp18;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp18;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp18;
              continue;
              break
            }
            case 4: {
              var this$40 = $m_RTLong$();
              var value$5 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
              var lo$10 = this$40.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$5);
              var hi$10 = this$40.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$42 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$10, hi$10));
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$6 = this$42.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$11 = t$6.RTLong__f_lo;
              var hi$11 = t$6.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic$2 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$11, hi$11), unit$5);
              var \u03b4this$tmp19 = this$;
              var _cur0$tailLocal1$tmp19 = $ps_Lcats_effect_IOFiber__next$2__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f$2, this$, monotonic$2);
              var cancelationIterations$tailLocal1$tmp19 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp19 = nextAutoCede;
              this$ = \u03b4this$tmp19;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp19;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp19;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp19;
              continue;
              break
            }
            case 5: {
              var ec$3 = this$.Lcats_effect_IOFiber__f_currentCtx;
              var \u03b4this$tmp20 = this$;
              var _cur0$tailLocal1$tmp20 = $ps_Lcats_effect_IOFiber__next$2__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f$2, this$, ec$3);
              var cancelationIterations$tailLocal1$tmp20 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp20 = nextAutoCede;
              this$ = \u03b4this$tmp20;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp20;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp20;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp20;
              continue;
              break
            }
            default: {
              this$.Lcats_effect_IOFiber__f_objectState.push__O__V(f$2);
              this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 1);
              var \u03b4this$tmp21 = this$;
              var cancelationIterations$tailLocal1$tmp21 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp21 = nextAutoCede;
              this$ = \u03b4this$tmp21;
              _cur0$tailLocal1 = ioe$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp21;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp21;
              continue
            }
          };
          break
        }
        case 8: {
          var cur$6 = $as_Lcats_effect_IO$Attempt(cur0);
          var ioa = cur$6.Lcats_effect_IO$Attempt__f_ioa;
          var x34 = ioa.tag__B();
          switch (x34) {
            case 0: {
              var pure$3 = $as_Lcats_effect_IO$Pure(ioa);
              var \u03b4this$tmp22 = this$;
              var $$x3 = this$;
              $m_s_package$();
              var value$6 = pure$3.Lcats_effect_IO$Pure__f_value;
              var _cur0$tailLocal1$tmp22 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($$x3, new $c_s_util_Right(value$6), 0);
              var cancelationIterations$tailLocal1$tmp22 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp22 = nextAutoCede;
              this$ = \u03b4this$tmp22;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp22;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp22;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp22;
              continue;
              break
            }
            case 1: {
              var error$5 = $as_Lcats_effect_IO$Error(ioa);
              var t$7 = error$5.Lcats_effect_IO$Error__f_t;
              $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V(this$.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, t$7, this$.Lcats_effect_IOFiber__f_tracingEvents);
              var \u03b4this$tmp23 = this$;
              var _cur0$tailLocal1$tmp23 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, ($m_s_package$(), new $c_s_util_Left(t$7)), 0);
              var cancelationIterations$tailLocal1$tmp23 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp23 = nextAutoCede;
              this$ = \u03b4this$tmp23;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp23;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp23;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp23;
              continue;
              break
            }
            case 2: {
              var delay$3 = $as_Lcats_effect_IO$Delay(ioa);
              if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
                $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, delay$3.Lcats_effect_IO$Delay__f_event)
              };
              var error$6 = null;
              try {
                var result$3 = delay$3.Lcats_effect_IO$Delay__f_thunk.apply__O()
              } catch (e$7) {
                var e$8 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$7);
                matchResult9: {
                  var result$3;
                  if ((e$8 !== null)) {
                    var x31 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$8);
                    if ((!x31.isEmpty__Z())) {
                      var x32 = $as_jl_Throwable(x31.get__O());
                      $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V(this$.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, x32, this$.Lcats_effect_IOFiber__f_tracingEvents);
                      error$6 = x32;
                      var result$3 = (void 0);
                      break matchResult9
                    }
                  };
                  if ((e$8 !== null)) {
                    var result$3 = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$8);
                    break matchResult9
                  };
                  throw e$8
                }
              };
              if ((error$6 === null)) {
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, ($m_s_package$(), new $c_s_util_Right(result$3)), 0)
              } else {
                var $$x4 = this$;
                $m_s_package$();
                var value$7 = error$6;
                var next$2 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($$x4, new $c_s_util_Left(value$7), 0)
              };
              var \u03b4this$tmp24 = this$;
              var cancelationIterations$tailLocal1$tmp24 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp24 = nextAutoCede;
              this$ = \u03b4this$tmp24;
              _cur0$tailLocal1 = next$2;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp24;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp24;
              continue;
              break
            }
            case 3: {
              var this$51 = $m_RTLong$();
              var value$8 = $uD(new Date().getTime());
              var lo$12 = this$51.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$8);
              var hi$12 = this$51.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$53 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$12, hi$12));
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
              var t$8 = this$53.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$13 = t$8.RTLong__f_lo;
              var hi$13 = t$8.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var realTime$3 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$13, hi$13), unit$6);
              var \u03b4this$tmp25 = this$;
              var _cur0$tailLocal1$tmp25 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, ($m_s_package$(), new $c_s_util_Right(realTime$3)), 0);
              var cancelationIterations$tailLocal1$tmp25 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp25 = nextAutoCede;
              this$ = \u03b4this$tmp25;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp25;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp25;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp25;
              continue;
              break
            }
            case 4: {
              var this$59 = $m_RTLong$();
              var value$9 = (1000000.0 * $uD((0, $m_jl_System$NanoTime$().jl_System$NanoTime$__f_getHighPrecisionTime)()));
              var lo$14 = this$59.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$9);
              var hi$14 = this$59.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var this$61 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$14, hi$14));
              var unit$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              var t$9 = this$61.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
              var lo$15 = t$9.RTLong__f_lo;
              var hi$15 = t$9.RTLong__f_hi;
              $m_s_concurrent_duration_Duration$();
              var monotonic$3 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$15, hi$15), unit$7);
              var \u03b4this$tmp26 = this$;
              var _cur0$tailLocal1$tmp26 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, ($m_s_package$(), new $c_s_util_Right(monotonic$3)), 0);
              var cancelationIterations$tailLocal1$tmp26 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp26 = nextAutoCede;
              this$ = \u03b4this$tmp26;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp26;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp26;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp26;
              continue;
              break
            }
            case 5: {
              var ec$4 = this$.Lcats_effect_IOFiber__f_currentCtx;
              var \u03b4this$tmp27 = this$;
              var _cur0$tailLocal1$tmp27 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, ($m_s_package$(), new $c_s_util_Right(ec$4)), 0);
              var cancelationIterations$tailLocal1$tmp27 = (((-1) + nextCancelation) | 0);
              var autoCedeIterations$tailLocal1$tmp27 = nextAutoCede;
              this$ = \u03b4this$tmp27;
              _cur0$tailLocal1 = _cur0$tailLocal1$tmp27;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp27;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp27;
              continue;
              break
            }
            default: {
              this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 9);
              var \u03b4this$tmp28 = this$;
              var cancelationIterations$tailLocal1$tmp28 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp28 = nextAutoCede;
              this$ = \u03b4this$tmp28;
              _cur0$tailLocal1 = ioa;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp28;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp28;
              continue
            }
          };
          break
        }
        case 9: {
          var cur$7 = $as_Lcats_effect_IO$HandleErrorWith(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$7.Lcats_effect_IO$HandleErrorWith__f_event)
          };
          this$.Lcats_effect_IOFiber__f_objectState.push__O__V(cur$7.Lcats_effect_IO$HandleErrorWith__f_f);
          this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 5);
          var \u03b4this$tmp29 = this$;
          var _cur0$tailLocal1$tmp29 = cur$7.Lcats_effect_IO$HandleErrorWith__f_ioa;
          var cancelationIterations$tailLocal1$tmp29 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp29 = nextAutoCede;
          this$ = \u03b4this$tmp29;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp29;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp29;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp29;
          continue;
          break
        }
        case 10: {
          this$.Lcats_effect_IOFiber__f_canceled = true;
          if ($p_Lcats_effect_IOFiber__isUnmasked__Z(this$)) {
            var fin$2 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO(this$, null);
            var \u03b4this$tmp30 = this$;
            var cancelationIterations$tailLocal1$tmp30 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp30 = nextAutoCede;
            this$ = \u03b4this$tmp30;
            _cur0$tailLocal1 = fin$2;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp30;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp30;
            continue
          } else {
            var \u03b4this$tmp31 = this$;
            var _cur0$tailLocal1$tmp31 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, (void 0), 0);
            var cancelationIterations$tailLocal1$tmp31 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp31 = nextAutoCede;
            this$ = \u03b4this$tmp31;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp31;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp31;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp31;
            continue
          };
          break
        }
        case 11: {
          var cur$8 = $as_Lcats_effect_IO$OnCancel(cur0);
          var $$x5 = this$.Lcats_effect_IOFiber__f_finalizers;
          var ioa$1 = cur$8.Lcats_effect_IO$OnCancel__f_fin;
          var ec$1 = this$.Lcats_effect_IOFiber__f_currentCtx;
          $$x5.push__O__V(new $c_Lcats_effect_IO$EvalOn(ioa$1, ec$1));
          this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 6);
          var \u03b4this$tmp32 = this$;
          var _cur0$tailLocal1$tmp32 = cur$8.Lcats_effect_IO$OnCancel__f_ioa;
          var cancelationIterations$tailLocal1$tmp32 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp32 = nextAutoCede;
          this$ = \u03b4this$tmp32;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp32;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp32;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp32;
          continue;
          break
        }
        case 12: {
          var cur$9 = $as_Lcats_effect_IO$Uncancelable(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$9.Lcats_effect_IO$Uncancelable__f_event)
          };
          this$.Lcats_effect_IOFiber__f_masks = ((1 + this$.Lcats_effect_IOFiber__f_masks) | 0);
          var id = this$.Lcats_effect_IOFiber__f_masks;
          var poll = new $c_Lcats_effect_IOFiber$$anon$1(id, this$);
          this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 7);
          var \u03b4this$tmp33 = this$;
          var _cur0$tailLocal1$tmp33 = $as_Lcats_effect_IO(cur$9.Lcats_effect_IO$Uncancelable__f_body.apply__O__O(poll));
          var cancelationIterations$tailLocal1$tmp33 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp33 = nextAutoCede;
          this$ = \u03b4this$tmp33;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp33;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp33;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp33;
          continue;
          break
        }
        case 13: {
          var cur$10 = $as_Lcats_effect_IO$Uncancelable$UnmaskRunLoop(cur0);
          var self = this$;
          if (((this$.Lcats_effect_IOFiber__f_masks === cur$10.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_id) && (self === cur$10.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_self))) {
            this$.Lcats_effect_IOFiber__f_masks = (((-1) + this$.Lcats_effect_IOFiber__f_masks) | 0);
            this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 8)
          };
          var \u03b4this$tmp34 = this$;
          var _cur0$tailLocal1$tmp34 = cur$10.Lcats_effect_IO$Uncancelable$UnmaskRunLoop__f_ioa;
          var cancelationIterations$tailLocal1$tmp34 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp34 = nextAutoCede;
          this$ = \u03b4this$tmp34;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp34;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp34;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp34;
          continue;
          break
        }
        case 14: {
          var cur$11 = $as_Lcats_effect_IO$IOCont(cur0);
          var body = cur$11.Lcats_effect_IO$IOCont__f_body;
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$11.Lcats_effect_IO$IOCont__f_event)
          };
          var state = new $c_Lcats_effect_ContState(this$.Lcats_effect_IOFiber__f_finalizing);
          var \u03b4this$1 = this$;
          var cb = new $c_sjsr_AnonFunction1(((state$2, \u03b4this) => ((e$9) => {
            var e$1 = $as_s_util_Either(e$9);
            $ps_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__Lcats_effect_IOFiber__V(state$2, e$1, \u03b4this)
          }))(state, \u03b4this$1));
          var get = new $c_Lcats_effect_IO$IOCont$Get(state);
          var next$3 = $as_Lcats_effect_IO(body.apply__Lcats_effect_kernel_MonadCancel__F3($m_Lcats_effect_IO$().Lcats_effect_IO$__f__asyncForIO).apply__O__O__O__O(cb, get, new $c_Lcats_arrow_FunctionK$$anon$4()));
          var \u03b4this$tmp35 = this$;
          var cancelationIterations$tailLocal1$tmp35 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp35 = nextAutoCede;
          this$ = \u03b4this$tmp35;
          _cur0$tailLocal1 = next$3;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp35;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp35;
          continue;
          break
        }
        case 15: {
          var cur$12 = $as_Lcats_effect_IO$IOCont$Get(cur0);
          var state$3 = cur$12.Lcats_effect_IO$IOCont$Get__f_state;
          var this$69 = $m_Lcats_effect_IO$();
          var thunk = new $c_sjsr_AnonFunction0(((state$4) => (() => {
            state$4.compareAndSet__I__I__Z(1, 0)
          }))(state$3));
          var fin$3 = this$69.delay__F0__Lcats_effect_IO(thunk);
          this$.Lcats_effect_IOFiber__f_finalizers.push__O__V(fin$3);
          this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 6);
          if (state$3.compareAndSet__I__I__Z(0, 1)) {
            state$3.Lcats_effect_ContState__f_wasFinalizing = this$.Lcats_effect_IOFiber__f_finalizing;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              state$3.Lcats_effect_ContState__f_handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle(this$)
            };
            this$.getAndSet__Z__Z(true);
            if ($p_Lcats_effect_IOFiber__shouldFinalize__Z(this$)) {
              var this$70 = this$;
              if (this$70.getAndSet__Z__Z(false)) {
                if ($p_Lcats_effect_IOFiber__shouldFinalize__Z(this$)) {
                  var fin$4 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO(this$, null);
                  var \u03b4this$tmp36 = this$;
                  var cancelationIterations$tailLocal1$tmp36 = nextCancelation;
                  var autoCedeIterations$tailLocal1$tmp36 = nextAutoCede;
                  this$ = \u03b4this$tmp36;
                  _cur0$tailLocal1 = fin$4;
                  cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp36;
                  autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp36;
                  continue
                } else {
                  var this$71 = this$;
                  this$71.ju_concurrent_atomic_AtomicBoolean__f_value = true
                }
              }
            }
          } else {
            while ((state$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value !== 3)) {
              /*<skip>*/
            };
            var result$4 = state$3.Lcats_effect_ContState__f_result;
            if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z(this$))) {
              matchResult12: {
                var next$4;
                if ((result$4 instanceof $c_s_util_Left)) {
                  var t$10 = $as_jl_Throwable($as_s_util_Left(result$4).s_util_Left__f_value);
                  var next$4 = $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, t$10, 0);
                  break matchResult12
                };
                if ((result$4 instanceof $c_s_util_Right)) {
                  var a = $as_s_util_Right(result$4).s_util_Right__f_value;
                  var next$4 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, a, 0);
                  break matchResult12
                };
                throw new $c_s_MatchError(result$4)
              };
              var \u03b4this$tmp37 = this$;
              var cancelationIterations$tailLocal1$tmp37 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp37 = nextAutoCede;
              this$ = \u03b4this$tmp37;
              _cur0$tailLocal1 = next$4;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp37;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp37;
              continue
            } else if ((this$.Lcats_effect_IOFiber__f_outcome === null)) {
              var fin$5 = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO(this$, null);
              var \u03b4this$tmp38 = this$;
              var cancelationIterations$tailLocal1$tmp38 = nextCancelation;
              var autoCedeIterations$tailLocal1$tmp38 = nextAutoCede;
              this$ = \u03b4this$tmp38;
              _cur0$tailLocal1 = fin$5;
              cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp38;
              autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp38;
              continue
            }
          };
          break
        }
        case 16: {
          this$.Lcats_effect_IOFiber__f_resumeTag = 6;
          $p_Lcats_effect_IOFiber__rescheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this$, this$.Lcats_effect_IOFiber__f_currentCtx, this$);
          break
        }
        case 17: {
          var cur$13 = $as_Lcats_effect_IO$Start(cur0);
          var ec$5 = this$.Lcats_effect_IOFiber__f_currentCtx;
          var fiber = $ct_Lcats_effect_IOFiber__sci_Map__F1__Lcats_effect_IO__s_concurrent_ExecutionContext__Lcats_effect_unsafe_IORuntime__(new $c_Lcats_effect_IOFiber(), this$.Lcats_effect_IOFiber__f_localState, null, cur$13.Lcats_effect_IO$Start__f_ioa, ec$5, this$.Lcats_effect_IOFiber__f_runtime);
          $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this$, ec$5, fiber);
          var \u03b4this$tmp39 = this$;
          var _cur0$tailLocal1$tmp39 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, fiber, 0);
          var cancelationIterations$tailLocal1$tmp39 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp39 = nextAutoCede;
          this$ = \u03b4this$tmp39;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp39;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp39;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp39;
          continue;
          break
        }
        case 18: {
          var cur$14 = $as_Lcats_effect_IO$RacePair(cur0);
          var $$x6 = $m_Lcats_effect_IO$();
          var \u03b4this$2$1 = this$;
          var next$5 = $$x6.async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cur$15, \u03b4this$2) => ((cb$2) => {
            var cb$1 = $as_F1(cb$2);
            var this$83 = $m_Lcats_effect_IO$();
            var thunk$1 = new $c_sjsr_AnonFunction0(((cur$1$2, cb$2$1, \u03b4this$6$2) => (() => {
              var ec$6 = \u03b4this$6$2.Lcats_effect_IOFiber__f_currentCtx;
              var rt = \u03b4this$6$2.Lcats_effect_IOFiber__f_runtime;
              var fiberA = $ct_Lcats_effect_IOFiber__sci_Map__F1__Lcats_effect_IO__s_concurrent_ExecutionContext__Lcats_effect_unsafe_IORuntime__(new $c_Lcats_effect_IOFiber(), \u03b4this$6$2.Lcats_effect_IOFiber__f_localState, null, cur$1$2.ioa__Lcats_effect_IO(), ec$6, rt);
              var fiberB = $ct_Lcats_effect_IOFiber__sci_Map__F1__Lcats_effect_IO__s_concurrent_ExecutionContext__Lcats_effect_unsafe_IORuntime__(new $c_Lcats_effect_IOFiber(), \u03b4this$6$2.Lcats_effect_IOFiber__f_localState, null, cur$1$2.iob__Lcats_effect_IO(), ec$6, rt);
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberA, new $c_sjsr_AnonFunction1(((cb$3$2, fiberB$2) => ((oc) => {
                var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
                $m_s_package$();
                $m_s_package$();
                var value$10 = new $c_T2(oc$1, fiberB$2);
                var value$11 = new $c_s_util_Left(value$10);
                cb$3$2.apply__O__O(new $c_s_util_Right(value$11))
              }))(cb$2$1, fiberB)));
              $p_Lcats_effect_IOFiber__setCallback__F1__V(fiberB, new $c_sjsr_AnonFunction1(((cb$3$3, fiberA$2) => ((oc$2) => {
                var oc$3 = $as_Lcats_effect_kernel_Outcome(oc$2);
                $m_s_package$();
                $m_s_package$();
                var value$12 = new $c_T2(fiberA$2, oc$3);
                var value$13 = new $c_s_util_Right(value$12);
                cb$3$3.apply__O__O(new $c_s_util_Right(value$13))
              }))(cb$2$1, fiberA)));
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(\u03b4this$6$2, ec$6, fiberA);
              $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(\u03b4this$6$2, ec$6, fiberB);
              var this$78 = fiberA.cancel__Lcats_effect_IO();
              var cancel = new $c_Lcats_effect_IO$Start(this$78).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((fiberB$3) => ((cancelA) => {
                var cancelA$1 = $as_Lcats_effect_kernel_Fiber(cancelA);
                var this$80 = fiberB$3.cancel__Lcats_effect_IO();
                return new $c_Lcats_effect_IO$Start(this$80).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cancelA$2) => ((cancelB) => {
                  var cancelB$1 = $as_Lcats_effect_kernel_Fiber(cancelB);
                  return $as_Lcats_effect_IO(cancelA$2.join__O()).flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cancelB$2) => ((x$1) => {
                    $as_Lcats_effect_kernel_Outcome(x$1);
                    return $as_Lcats_effect_IO(cancelB$2.join__O()).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((x$1$2) => {
                      $as_Lcats_effect_kernel_Outcome(x$1$2)
                    })))
                  }))(cancelB$1)))
                }))(cancelA$1)))
              }))(fiberB)));
              return new $c_s_Some(cancel)
            }))(cur$15, cb$1, \u03b4this$2));
            return this$83.delay__F0__Lcats_effect_IO(thunk$1)
          }))(cur$14, \u03b4this$2$1)));
          var \u03b4this$tmp40 = this$;
          var cancelationIterations$tailLocal1$tmp40 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp40 = nextAutoCede;
          this$ = \u03b4this$tmp40;
          _cur0$tailLocal1 = next$5;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp40;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp40;
          continue;
          break
        }
        case 19: {
          var cur$16 = $as_Lcats_effect_IO$Sleep(cur0);
          var $$x7 = $m_Lcats_effect_IO$();
          var \u03b4this$3$1 = this$;
          var next$6 = $$x7.async__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((cur$17, \u03b4this$3) => ((cb$3) => {
            var cb$4 = $as_F1(cb$3);
            var this$86 = $m_Lcats_effect_IO$();
            var thunk$3 = new $c_sjsr_AnonFunction0(((cur$3$2, cb$2$2, \u03b4this$8$2) => (() => {
              var cancel$1 = \u03b4this$8$2.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_scheduler.sleep__s_concurrent_duration_FiniteDuration__jl_Runnable__jl_Runnable(cur$3$2.delay__s_concurrent_duration_FiniteDuration(), new $c_Lcats_effect_IOFiber$$anon$2(cb$2$2, \u03b4this$8$2, \u03b4this$8$2));
              var this$84 = $m_Lcats_effect_IO$();
              var thunk$2 = new $c_sjsr_AnonFunction0(((cancel$2) => (() => {
                cancel$2.run__V()
              }))(cancel$1));
              var value$14 = this$84.delay__F0__Lcats_effect_IO(thunk$2);
              return new $c_s_Some(value$14)
            }))(cur$17, cb$4, \u03b4this$3));
            return this$86.delay__F0__Lcats_effect_IO(thunk$3)
          }))(cur$16, \u03b4this$3$1)));
          var \u03b4this$tmp41 = this$;
          var cancelationIterations$tailLocal1$tmp41 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp41 = nextAutoCede;
          this$ = \u03b4this$tmp41;
          _cur0$tailLocal1 = next$6;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp41;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp41;
          continue;
          break
        }
        case 20: {
          var cur$18 = $as_Lcats_effect_IO$EvalOn(cur0);
          if ((cur$18.Lcats_effect_IO$EvalOn__f_ec === this$.Lcats_effect_IOFiber__f_currentCtx)) {
            var \u03b4this$tmp42 = this$;
            var _cur0$tailLocal1$tmp42 = cur$18.Lcats_effect_IO$EvalOn__f_ioa;
            var cancelationIterations$tailLocal1$tmp42 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp42 = nextAutoCede;
            this$ = \u03b4this$tmp42;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp42;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp42;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp42;
            continue
          } else {
            var ec$6$1 = cur$18.Lcats_effect_IO$EvalOn__f_ec;
            this$.Lcats_effect_IOFiber__f_objectState.push__O__V(this$.Lcats_effect_IOFiber__f_currentCtx);
            this$.Lcats_effect_IOFiber__f_currentCtx = ec$6$1;
            this$.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI(this$.Lcats_effect_IOFiber__f_conts, 4);
            this$.Lcats_effect_IOFiber__f_resumeTag = 7;
            this$.Lcats_effect_IOFiber__f_resumeIO = cur$18.Lcats_effect_IO$EvalOn__f_ioa;
            if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
              var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle(this$);
              this$.Lcats_effect_IOFiber__f_objectState.push__O__V(handle)
            };
            $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(this$, ec$6$1, this$)
          };
          break
        }
        case 21: {
          var cur$19 = $as_Lcats_effect_IO$Blocking(cur0);
          if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
            $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V(this$, cur$19.event__Lcats_effect_tracing_TracingEvent())
          };
          if ((cur$19.hint__Lcats_effect_kernel_Sync$Type() === $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_TypeBlocking)) {
            var ec$7 = this$.Lcats_effect_IOFiber__f_currentCtx;
            if (false) {
              var wstp = $as_Lcats_effect_unsafe_WorkStealingThreadPool(ec$7);
              if (wstp.canExecuteBlockingCode__Z()) {
                var error$7 = null;
                try {
                  var body$1 = cur$19.thunk__F0();
                  $m_s_concurrent_BlockContext$().current__s_concurrent_BlockContext();
                  var r$2 = body$1.apply__O()
                } catch (e$10) {
                  var e$11 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$10);
                  matchResult15: {
                    var r$2;
                    if ((e$11 !== null)) {
                      var x49 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$11);
                      if ((!x49.isEmpty__Z())) {
                        var x50 = $as_jl_Throwable(x49.get__O());
                        error$7 = x50;
                        var r$2 = (void 0);
                        break matchResult15
                      }
                    };
                    if ((e$11 !== null)) {
                      var r$2 = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$11);
                      break matchResult15
                    };
                    throw e$11
                  }
                };
                var next$7 = ((error$7 === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, r$2, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, error$7, 0));
                var \u03b4this$tmp43 = this$;
                var cancelationIterations$tailLocal1$tmp43 = nextCancelation;
                var autoCedeIterations$tailLocal1$tmp43 = nextAutoCede;
                this$ = \u03b4this$tmp43;
                _cur0$tailLocal1 = next$7;
                cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp43;
                autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp43;
                continue
              } else {
                $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V(this$, cur$19)
              }
            } else {
              $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V(this$, cur$19)
            }
          } else {
            var \u03b4this$tmp44 = this$;
            var this$90 = $m_Lcats_effect_IO$();
            var thunk$4 = cur$19.thunk__F0();
            var _cur0$tailLocal1$tmp44 = this$90.delay__F0__Lcats_effect_IO(thunk$4);
            var cancelationIterations$tailLocal1$tmp44 = nextCancelation;
            var autoCedeIterations$tailLocal1$tmp44 = nextAutoCede;
            this$ = \u03b4this$tmp44;
            _cur0$tailLocal1 = _cur0$tailLocal1$tmp44;
            cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp44;
            autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp44;
            continue
          };
          break
        }
        case 22: {
          var cur$20 = $as_Lcats_effect_IO$Local(cur0);
          matchResult16: {
            var \u03b41$___1;
            var \u03b41$___2;
            var x52 = $as_T2(cur$20.f__F1().apply__O__O(this$.Lcats_effect_IOFiber__f_localState));
            if ((x52 !== null)) {
              var nextLocalState = $as_sci_Map(x52._1__O());
              var value$15 = x52._2__O();
              var \u03b41$___1 = nextLocalState;
              var \u03b41$___2 = value$15;
              break matchResult16
            };
            throw new $c_s_MatchError(x52)
          };
          var nextLocalState$2 = $as_sci_Map(\u03b41$___1);
          var value$2$1 = \u03b41$___2;
          this$.Lcats_effect_IOFiber__f_localState = nextLocalState$2;
          var \u03b4this$tmp45 = this$;
          var _cur0$tailLocal1$tmp45 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, value$2$1, 0);
          var cancelationIterations$tailLocal1$tmp45 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp45 = nextAutoCede;
          this$ = \u03b4this$tmp45;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp45;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp45;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp45;
          continue;
          break
        }
        case 23: {
          var \u03b4this$tmp46 = this$;
          var _cur0$tailLocal1$tmp46 = $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(this$, $m_Lcats_effect_Trace$().apply__Lcats_effect_tracing_RingBuffer__Lcats_effect_Trace(this$.Lcats_effect_IOFiber__f_tracingEvents), 0);
          var cancelationIterations$tailLocal1$tmp46 = nextCancelation;
          var autoCedeIterations$tailLocal1$tmp46 = nextAutoCede;
          this$ = \u03b4this$tmp46;
          _cur0$tailLocal1 = _cur0$tailLocal1$tmp46;
          cancelationIterations$tailLocal1 = cancelationIterations$tailLocal1$tmp46;
          autoCedeIterations$tailLocal1 = autoCedeIterations$tailLocal1$tmp46;
          continue;
          break
        }
        default: {
          throw new $c_s_MatchError(x55)
        }
      }
    };
    return (void 0)
  }
}
function $p_Lcats_effect_IOFiber__blockingFallback__Lcats_effect_IO$Blocking__V($thiz, cur) {
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 5;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = cur;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    var handle = $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz);
    $thiz.Lcats_effect_IOFiber__f_objectState.push__O__V(handle)
  };
  var ec = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_blocking;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz)
}
function $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, oc) {
  $thiz.Lcats_effect_IOFiber__f__join = ($m_Lcats_effect_IO$(), new $c_Lcats_effect_IO$Pure(oc));
  $thiz.Lcats_effect_IOFiber__f__cancel = $m_Lcats_effect_IO$().Lcats_effect_IO$__f__unit;
  $thiz.Lcats_effect_IOFiber__f_outcome = oc;
  try {
    if ((!$thiz.Lcats_effect_IOFiber__f_callbacks.apply__Lcats_effect_kernel_Outcome__Z__Z(oc, false))) {
      if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
        $m_Lcats_effect_package$();
        var x$1 = $as_Lcats_effect_kernel_Outcome$Errored(oc);
        var x59 = $as_jl_Throwable(x$1.Lcats_effect_kernel_Outcome$Errored__f_e);
        $thiz.Lcats_effect_IOFiber__f_currentCtx.reportFailure__jl_Throwable__V(x59)
      }
    }
  } finally {
    var this$4 = $thiz.Lcats_effect_IOFiber__f_callbacks;
    this$4.ju_concurrent_atomic_AtomicReference__f_value = null
  };
  $thiz.Lcats_effect_IOFiber__f_masks = 0;
  $thiz.Lcats_effect_IOFiber__f_resumeTag = 9;
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  $thiz.Lcats_effect_IOFiber__f_conts = null;
  $thiz.Lcats_effect_IOFiber__f_objectState.invalidate__V();
  $thiz.Lcats_effect_IOFiber__f_finalizers.invalidate__V();
  $thiz.Lcats_effect_IOFiber__f_currentCtx = null;
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $thiz.Lcats_effect_IOFiber__f_tracingEvents.invalidate__V()
  }
}
function $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb) {
  if ((!$thiz.Lcats_effect_IOFiber__f_finalizers.isEmpty__Z())) {
    if ((!$thiz.Lcats_effect_IOFiber__f_finalizing)) {
      $thiz.Lcats_effect_IOFiber__f_finalizing = true;
      $thiz.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().create__I__AI(8);
      $thiz.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI($thiz.Lcats_effect_IOFiber__f_conts, 2);
      $thiz.Lcats_effect_IOFiber__f_objectState.init__I__V(16);
      $thiz.Lcats_effect_IOFiber__f_objectState.push__O__V(cb);
      $thiz.Lcats_effect_IOFiber__f_masks = ((1 + $thiz.Lcats_effect_IOFiber__f_masks) | 0)
    };
    return $as_Lcats_effect_IO($thiz.Lcats_effect_IOFiber__f_finalizers.pop__O())
  } else {
    if ((cb !== null)) {
      cb.apply__O__O($thiz.Lcats_effect_IOFiber__f_RightUnit)
    };
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $thiz.Lcats_effect_IOFiber__f_IOEndFiber
  }
}
function $p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_canceled && $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz))
}
function $p_Lcats_effect_IOFiber__isUnmasked__Z($thiz) {
  return ($thiz.Lcats_effect_IOFiber__f_masks === 0)
}
function $p_Lcats_effect_IOFiber__monitor__Lcats_effect_unsafe_WeakBag$Handle($thiz) {
  return $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_fiberMonitor.monitorSuspended__Lcats_effect_IOFiber__Lcats_effect_unsafe_WeakBag$Handle($thiz)
}
function $p_Lcats_effect_IOFiber__setCallback__F1__V($thiz, cb) {
  $thiz.Lcats_effect_IOFiber__f_callbacks.Lcats_effect_CallbackStack__f_callback = cb
}
function $p_Lcats_effect_IOFiber__registerListener__F1__Lcats_effect_CallbackStack($thiz, listener) {
  if (($thiz.Lcats_effect_IOFiber__f_outcome === null)) {
    var back = $thiz.Lcats_effect_IOFiber__f_callbacks.push__F1__Lcats_effect_CallbackStack(listener);
    return (($thiz.Lcats_effect_IOFiber__f_outcome !== null) ? (back.clearCurrent__V(), listener.apply__O__O($thiz.Lcats_effect_IOFiber__f_outcome), null) : back)
  } else {
    listener.apply__O__O($thiz.Lcats_effect_IOFiber__f_outcome);
    return null
  }
}
function $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, result, depth) {
  var this$ = $thiz;
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var x70 = $m_Lcats_effect_ByteStack$().pop__AI__B(this$.Lcats_effect_IOFiber__f_conts);
    switch (x70) {
      case 0: {
        var f = $as_F1(this$.Lcats_effect_IOFiber__f_objectState.pop__O());
        var error = null;
        try {
          var transformed = f.apply__O__O(result$tailLocal1)
        } catch (e) {
          var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
          matchResult19: {
            var transformed;
            if ((e$2 !== null)) {
              var x62 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
              if ((!x62.isEmpty__Z())) {
                var x63 = $as_jl_Throwable(x62.get__O());
                error = x63;
                var transformed = (void 0);
                break matchResult19
              }
            };
            if ((e$2 !== null)) {
              var transformed = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$2);
              break matchResult19
            };
            throw e$2
          }
        };
        if ((depth$tailLocal1 > 512)) {
          if ((error === null)) {
            var $$x1 = new $c_Lcats_effect_IO$Pure(transformed)
          } else {
            var t = error;
            var $$x1 = new $c_Lcats_effect_IO$Error(t)
          };
          return $as_Lcats_effect_IO($$x1)
        } else if ((error === null)) {
          var \u03b4this$tmp47 = this$;
          var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
          this$ = \u03b4this$tmp47;
          result$tailLocal1 = transformed;
          depth$tailLocal1 = depth$tailLocal1$tmp1
        } else {
          return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, error, ((1 + depth$tailLocal1) | 0))
        };
        break
      }
      case 1: {
        var f$2 = $as_F1(this$.Lcats_effect_IOFiber__f_objectState.pop__O());
        try {
          return $as_Lcats_effect_IO(f$2.apply__O__O(result$tailLocal1))
        } catch (e$3) {
          var e$4 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$3);
          if ((e$4 !== null)) {
            var x67 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$4);
            if ((!x67.isEmpty__Z())) {
              var x68 = $as_jl_Throwable(x67.get__O());
              return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(this$, x68, ((1 + depth$tailLocal1) | 0))
            }
          };
          if ((e$4 !== null)) {
            return $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$4)
          };
          throw e$4
        };
        break
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO(this$);
        break
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO(this$, result$tailLocal1);
        break
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO(this$, result$tailLocal1);
        break
      }
      case 5: {
        this$.Lcats_effect_IOFiber__f_objectState.pop__O();
        this$ = this$;
        break
      }
      case 6: {
        this$.Lcats_effect_IOFiber__f_finalizers.pop__O();
        var \u03b4this$tmp48 = this$;
        var depth$tailLocal1$tmp2 = ((1 + depth$tailLocal1) | 0);
        this$ = \u03b4this$tmp48;
        depth$tailLocal1 = depth$tailLocal1$tmp2;
        break
      }
      case 7: {
        this$.Lcats_effect_IOFiber__f_masks = (((-1) + this$.Lcats_effect_IOFiber__f_masks) | 0);
        var \u03b4this$tmp49 = this$;
        var depth$tailLocal1$tmp3 = ((1 + depth$tailLocal1) | 0);
        this$ = \u03b4this$tmp49;
        depth$tailLocal1 = depth$tailLocal1$tmp3;
        break
      }
      case 8: {
        this$.Lcats_effect_IOFiber__f_masks = ((1 + this$.Lcats_effect_IOFiber__f_masks) | 0);
        var \u03b4this$tmp50 = this$;
        var depth$tailLocal1$tmp4 = ((1 + depth$tailLocal1) | 0);
        this$ = \u03b4this$tmp50;
        depth$tailLocal1 = depth$tailLocal1$tmp4;
        break
      }
      case 9: {
        var \u03b4this$tmp51 = this$;
        $m_s_package$();
        var value = result$tailLocal1;
        var result$tailLocal1$tmp2 = new $c_s_util_Right(value);
        this$ = \u03b4this$tmp51;
        result$tailLocal1 = result$tailLocal1$tmp2;
        break
      }
      default: {
        throw new $c_s_MatchError(x70)
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, error, depth) {
  var this$ = $thiz;
  var depth$tailLocal2 = depth;
  var error$tailLocal1 = error;
  while (true) {
    $m_Lcats_effect_tracing_Tracing$().augmentThrowable__Z__jl_Throwable__Lcats_effect_tracing_RingBuffer__V(this$.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_enhancedExceptions, error$tailLocal1, this$.Lcats_effect_IOFiber__f_tracingEvents);
    var x76 = $m_Lcats_effect_ByteStack$().pop__AI__B(this$.Lcats_effect_IOFiber__f_conts);
    switch (x76) {
      case 0:
      case 1: {
        this$.Lcats_effect_IOFiber__f_objectState.pop__O();
        this$ = this$;
        break
      }
      case 2: {
        return $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO(this$, error$tailLocal1);
        break
      }
      case 3: {
        return $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO(this$, error$tailLocal1);
        break
      }
      case 4: {
        return $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO(this$, error$tailLocal1);
        break
      }
      case 5: {
        var f = $as_F1(this$.Lcats_effect_IOFiber__f_objectState.pop__O());
        try {
          return $as_Lcats_effect_IO(f.apply__O__O(error$tailLocal1))
        } catch (e) {
          var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
          if ((e$2 !== null)) {
            var x73 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
            if ((!x73.isEmpty__Z())) {
              var x74 = $as_jl_Throwable(x73.get__O());
              var \u03b4this$tmp52 = this$;
              var depth$tailLocal2$tmp1 = ((1 + depth$tailLocal2) | 0);
              this$ = \u03b4this$tmp52;
              error$tailLocal1 = x74;
              depth$tailLocal2 = depth$tailLocal2$tmp1;
              break
            }
          };
          if ((e$2 !== null)) {
            return $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(this$, e$2)
          };
          throw e$2
        };
        break
      }
      case 6: {
        this$.Lcats_effect_IOFiber__f_finalizers.pop__O();
        var \u03b4this$tmp53 = this$;
        var depth$tailLocal2$tmp2 = ((1 + depth$tailLocal2) | 0);
        this$ = \u03b4this$tmp53;
        depth$tailLocal2 = depth$tailLocal2$tmp2;
        break
      }
      case 7: {
        this$.Lcats_effect_IOFiber__f_masks = (((-1) + this$.Lcats_effect_IOFiber__f_masks) | 0);
        var \u03b4this$tmp54 = this$;
        var depth$tailLocal2$tmp3 = ((1 + depth$tailLocal2) | 0);
        this$ = \u03b4this$tmp54;
        depth$tailLocal2 = depth$tailLocal2$tmp3;
        break
      }
      case 8: {
        this$.Lcats_effect_IOFiber__f_masks = ((1 + this$.Lcats_effect_IOFiber__f_masks) | 0);
        var \u03b4this$tmp55 = this$;
        var depth$tailLocal2$tmp4 = ((1 + depth$tailLocal2) | 0);
        this$ = \u03b4this$tmp55;
        depth$tailLocal2 = depth$tailLocal2$tmp4;
        break
      }
      case 9: {
        var $$x1 = this$;
        $m_s_package$();
        var value = error$tailLocal1;
        return $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($$x1, new $c_s_util_Left(value), depth$tailLocal2);
        break
      }
      default: {
        throw new $c_s_MatchError(x76)
      }
    }
  }
}
function $p_Lcats_effect_IOFiber__rescheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  if (false) {
    var wstp = $as_Lcats_effect_unsafe_WorkStealingThreadPool(ec);
    wstp.rescheduleFiber__Lcats_effect_IOFiber__V(fiber)
  } else {
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber)
  }
}
function $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  if (false) {
    var wstp = $as_Lcats_effect_unsafe_WorkStealingThreadPool(ec);
    wstp.scheduleFiber__Lcats_effect_IOFiber__V(fiber)
  } else {
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber)
  }
}
function $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, fiber) {
  try {
    ec.execute__jl_Runnable__V(fiber)
  } catch (e) {
    if ((!false)) {
      throw e
    }
  }
}
function $p_Lcats_effect_IOFiber__execR__V($thiz) {
  if ($thiz.Lcats_effect_IOFiber__f_canceled) {
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled)
  } else {
    $thiz.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().create__I__AI(16);
    $thiz.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI($thiz.Lcats_effect_IOFiber__f_conts, 3);
    $thiz.Lcats_effect_IOFiber__f_objectState.init__I__V(16);
    $thiz.Lcats_effect_IOFiber__f_finalizers.init__I__V(16);
    var io = $as_Lcats_effect_IO($thiz.Lcats_effect_IOFiber__f_resumeIO);
    $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
    $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
  }
}
function $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V($thiz) {
  var a = $thiz.Lcats_effect_IOFiber__f_objectState.pop__O();
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, a, 0), $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
}
function $p_Lcats_effect_IOFiber__asyncContinueFailedR__V($thiz) {
  var t = $as_jl_Throwable($thiz.Lcats_effect_IOFiber__f_objectState.pop__O());
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO($thiz, t, 0), $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
}
function $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V($thiz) {
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
}
function $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V($thiz) {
  var cb = $as_F1($thiz.Lcats_effect_IOFiber__f_objectState.pop__O());
  var fin = $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, cb);
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, fin, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
}
function $p_Lcats_effect_IOFiber__blockingR__V($thiz) {
  var error = null;
  var cur = $as_Lcats_effect_IO$Blocking($thiz.Lcats_effect_IOFiber__f_resumeIO);
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  try {
    var r = cur.thunk__F0().apply__O()
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    matchResult24: {
      var r;
      if ((e$2 !== null)) {
        var x79 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x79.isEmpty__Z())) {
          var x80 = $as_jl_Throwable(x79.get__O());
          error = x80;
          var r = (void 0);
          break matchResult24
        }
      };
      if ((e$2 !== null)) {
        var r = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N($thiz, e$2);
        break matchResult24
      };
      throw e$2
    }
  };
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $as_Lcats_effect_unsafe_WeakBag$Handle($thiz.Lcats_effect_IOFiber__f_objectState.pop__O()).deregister__V()
  };
  if ((error === null)) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    $thiz.Lcats_effect_IOFiber__f_objectState.push__O__V(r)
  } else {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    $thiz.Lcats_effect_IOFiber__f_objectState.push__O__V(error)
  };
  var ec = $thiz.Lcats_effect_IOFiber__f_currentCtx;
  $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz)
}
function $p_Lcats_effect_IOFiber__cedeR__V($thiz) {
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO($thiz, (void 0), 0), $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
}
function $p_Lcats_effect_IOFiber__autoCedeR__V($thiz) {
  var io = $as_Lcats_effect_IO($thiz.Lcats_effect_IOFiber__f_resumeIO);
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  $p_Lcats_effect_IOFiber__runLoop__Lcats_effect_IO__I__I__V($thiz, io, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_cancelationCheckThreshold, $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_autoYieldThreshold)
}
function $p_Lcats_effect_IOFiber__executeRunnableR__V($thiz) {
  var runnable = $as_jl_Runnable($thiz.Lcats_effect_IOFiber__f_resumeIO);
  $thiz.Lcats_effect_IOFiber__f_resumeIO = null;
  try {
    runnable.run__V()
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    matchResult25: {
      if ((e$2 !== null)) {
        var x84 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x84.isEmpty__Z())) {
          var x85 = $as_jl_Throwable(x84.get__O());
          $thiz.Lcats_effect_IOFiber__f_currentCtx.reportFailure__jl_Throwable__V(x85);
          break matchResult25
        }
      };
      if ((e$2 !== null)) {
        $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N($thiz, e$2);
        break matchResult25
      };
      throw e$2
    }
  } finally {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 9;
    $thiz.Lcats_effect_IOFiber__f_currentCtx = null
  }
}
function $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz) {
  if ((!$thiz.Lcats_effect_IOFiber__f_finalizers.isEmpty__Z())) {
    $thiz.Lcats_effect_IOFiber__f_conts = $m_Lcats_effect_ByteStack$().push__AI__B__AI($thiz.Lcats_effect_IOFiber__f_conts, 2);
    return $as_Lcats_effect_IO($thiz.Lcats_effect_IOFiber__f_finalizers.pop__O())
  } else {
    var cb = $thiz.Lcats_effect_IOFiber__f_objectState.pop__O();
    if ((cb !== null)) {
      $as_F1(cb).apply__O__O($thiz.Lcats_effect_IOFiber__f_RightUnit)
    };
    $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, $m_Lcats_effect_IOFiber$().Lcats_effect_IOFiber$__f_OutcomeCanceled);
    return $thiz.Lcats_effect_IOFiber__f_IOEndFiber
  }
}
function $p_Lcats_effect_IOFiber__cancelationLoopFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $thiz.Lcats_effect_IOFiber__f_currentCtx.reportFailure__jl_Throwable__V(t);
  return $p_Lcats_effect_IOFiber__cancelationLoopSuccessK__Lcats_effect_IO($thiz)
}
function $p_Lcats_effect_IOFiber__runTerminusSuccessK__O__Lcats_effect_IO($thiz, result) {
  $m_Lcats_effect_package$();
  $m_Lcats_effect_IO$();
  var fa = new $c_Lcats_effect_IO$Pure(result);
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, new $c_Lcats_effect_kernel_Outcome$Succeeded(fa));
  return $thiz.Lcats_effect_IOFiber__f_IOEndFiber
}
function $p_Lcats_effect_IOFiber__runTerminusFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  $p_Lcats_effect_IOFiber__done__Lcats_effect_kernel_Outcome__V($thiz, ($m_Lcats_effect_package$(), new $c_Lcats_effect_kernel_Outcome$Errored(t)));
  return $thiz.Lcats_effect_IOFiber__f_IOEndFiber
}
function $p_Lcats_effect_IOFiber__evalOnSuccessK__O__Lcats_effect_IO($thiz, result) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $as_Lcats_effect_unsafe_WeakBag$Handle($thiz.Lcats_effect_IOFiber__f_objectState.pop__O()).deregister__V()
  };
  var ec = $as_s_concurrent_ExecutionContext($thiz.Lcats_effect_IOFiber__f_objectState.pop__O());
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 1;
    $thiz.Lcats_effect_IOFiber__f_objectState.push__O__V(result);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $thiz.Lcats_effect_IOFiber__f_IOEndFiber
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null)
  }
}
function $p_Lcats_effect_IOFiber__evalOnFailureK__jl_Throwable__Lcats_effect_IO($thiz, t) {
  if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
    $thiz.Lcats_effect_IOFiber__f_objectState.pop__O()
  };
  var ec = $as_s_concurrent_ExecutionContext($thiz.Lcats_effect_IOFiber__f_objectState.pop__O());
  $thiz.Lcats_effect_IOFiber__f_currentCtx = ec;
  if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z($thiz))) {
    $thiz.Lcats_effect_IOFiber__f_resumeTag = 2;
    $thiz.Lcats_effect_IOFiber__f_objectState.push__O__V(t);
    $p_Lcats_effect_IOFiber__scheduleOnForeignEC__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V($thiz, ec, $thiz);
    return $thiz.Lcats_effect_IOFiber__f_IOEndFiber
  } else {
    return $p_Lcats_effect_IOFiber__prepareFiberForCancelation__F1__Lcats_effect_IO($thiz, null)
  }
}
function $p_Lcats_effect_IOFiber__pushTracingEvent__Lcats_effect_tracing_TracingEvent__V($thiz, te) {
  if ((te !== null)) {
    $thiz.Lcats_effect_IOFiber__f_tracingEvents.push__Lcats_effect_tracing_TracingEvent__V(te)
  }
}
function $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N($thiz, t) {
  $m_jl_Thread$().interrupted__Z();
  $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_shutdown.apply__O();
  var interrupted = $m_jl_Thread$().interrupted__Z();
  var idx = 0;
  var tables = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.Lcats_effect_unsafe_StripedHashtable__f_tables;
  var numTables = $thiz.Lcats_effect_IOFiber__f_runtime.Lcats_effect_unsafe_IORuntime__f_fiberErrorCbs.numTables__I();
  while ((idx < numTables)) {
    var table = tables.get(idx);
    if ((table === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
    };
    var hashtable = table.Lcats_effect_unsafe_ThreadSafeHashtable__f_hashtable;
    var len = hashtable.u.length;
    var i = 0;
    while ((i < len)) {
      var cb = hashtable.get(i);
      if ((cb !== null)) {
        cb.apply__O__O(t)
      };
      i = ((1 + i) | 0)
    };
    idx = ((1 + idx) | 0)
  };
  if (interrupted) {
    var this$1 = $m_jl_Thread$().jl_Thread$__f_SingleThread;
    this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true
  };
  throw t
}
function $ps_Lcats_effect_IOFiber__next$1__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f$1, \u03b4this$1, v) {
  var error = null;
  try {
    var result = f$1.apply__O__O(v)
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    matchResult3: {
      var result;
      if ((e$2 !== null)) {
        var x9 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
        if ((!x9.isEmpty__Z())) {
          var x10 = $as_jl_Throwable(x9.get__O());
          error = x10;
          var result = (void 0);
          break matchResult3
        }
      };
      if ((e$2 !== null)) {
        var result = $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(\u03b4this$1, e$2);
        break matchResult3
      };
      throw e$2
    }
  };
  return ((error === null) ? $p_Lcats_effect_IOFiber__succeeded__O__I__Lcats_effect_IO(\u03b4this$1, result, 0) : $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(\u03b4this$1, error, 0))
}
function $ps_Lcats_effect_IOFiber__next$2__F1__Lcats_effect_IOFiber__O__Lcats_effect_IO(f$2, \u03b4this$2, v) {
  try {
    return $as_Lcats_effect_IO(f$2.apply__O__O(v))
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      var x20 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
      if ((!x20.isEmpty__Z())) {
        var x21 = $as_jl_Throwable(x20.get__O());
        return $p_Lcats_effect_IOFiber__failed__jl_Throwable__I__Lcats_effect_IO(\u03b4this$2, x21, 0)
      }
    };
    if ((e$2 !== null)) {
      return $p_Lcats_effect_IOFiber__onFatalFailure__jl_Throwable__N(\u03b4this$2, e$2)
    };
    throw e$2
  }
}
function $ps_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__Lcats_effect_IOFiber__V(state$2, e$1, \u03b4this$4) {
  while (true) {
    if (\u03b4this$4.getAndSet__Z__Z(false)) {
      if ((\u03b4this$4.Lcats_effect_IOFiber__f_finalizing === state$2.Lcats_effect_ContState__f_wasFinalizing)) {
        if ($m_Lcats_effect_tracing_TracingConstants$().Lcats_effect_tracing_TracingConstants$__f_isStackTracing) {
          state$2.Lcats_effect_ContState__f_handle.deregister__V()
        };
        var ec = \u03b4this$4.Lcats_effect_IOFiber__f_currentCtx;
        if ((!$p_Lcats_effect_IOFiber__shouldFinalize__Z(\u03b4this$4))) {
          matchResult11: {
            if ((e$1 instanceof $c_s_util_Left)) {
              var t = $as_jl_Throwable($as_s_util_Left(e$1).s_util_Left__f_value);
              \u03b4this$4.Lcats_effect_IOFiber__f_resumeTag = 2;
              \u03b4this$4.Lcats_effect_IOFiber__f_objectState.push__O__V(t);
              break matchResult11
            };
            if ((e$1 instanceof $c_s_util_Right)) {
              var a = $as_s_util_Right(e$1).s_util_Right__f_value;
              \u03b4this$4.Lcats_effect_IOFiber__f_resumeTag = 1;
              \u03b4this$4.Lcats_effect_IOFiber__f_objectState.push__O__V(a);
              break matchResult11
            };
            throw new $c_s_MatchError(e$1)
          }
        } else {
          \u03b4this$4.Lcats_effect_IOFiber__f_resumeTag = 3
        };
        $p_Lcats_effect_IOFiber__scheduleFiber__s_concurrent_ExecutionContext__Lcats_effect_IOFiber__V(\u03b4this$4, ec, \u03b4this$4)
      } else {
        \u03b4this$4.ju_concurrent_atomic_AtomicBoolean__f_value = true
      }
    } else if ((((\u03b4this$4.Lcats_effect_IOFiber__f_finalizing === state$2.Lcats_effect_ContState__f_wasFinalizing) && (!$p_Lcats_effect_IOFiber__shouldFinalize__Z(\u03b4this$4))) && (\u03b4this$4.Lcats_effect_IOFiber__f_outcome === null))) {
      continue
    };
    return (void 0)
  }
}
function $ps_Lcats_effect_IOFiber__stateLoop$1__Lcats_effect_ContState__s_util_Either__Lcats_effect_IOFiber__V(state$3, e$2, \u03b4this$5) {
  while (true) {
    var tag = state$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value;
    if ((tag <= 1)) {
      if ((!state$3.compareAndSet__I__I__Z(tag, 2))) {
        continue
      } else {
        state$3.Lcats_effect_ContState__f_result = e$2;
        state$3.ju_concurrent_atomic_AtomicInteger__f_java$util$concurrent$atomic$AtomicInteger$$value = 3;
        if ((tag === 1)) {
          $ps_Lcats_effect_IOFiber__loop$1__Lcats_effect_ContState__s_util_Either__Lcats_effect_IOFiber__V(state$3, e$2, \u03b4this$5)
        }
      }
    };
    return (void 0)
  }
}
/** @constructor */
function $c_Lcats_effect_IOFiber() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
  this.Lcats_effect_IOFiber__f_localState = null;
  this.Lcats_effect_IOFiber__f_objectState = null;
  this.Lcats_effect_IOFiber__f_currentCtx = null;
  this.Lcats_effect_IOFiber__f_finalizers = null;
  this.Lcats_effect_IOFiber__f_callbacks = null;
  this.Lcats_effect_IOFiber__f_resumeTag = 0;
  this.Lcats_effect_IOFiber__f_resumeIO = null;
  this.Lcats_effect_IOFiber__f_tracingEvents = null;
  this.Lcats_effect_IOFiber__f_runtime = null;
  this.Lcats_effect_IOFiber__f_conts = null;
  this.Lcats_effect_IOFiber__f_canceled = false;
  this.Lcats_effect_IOFiber__f_masks = 0;
  this.Lcats_effect_IOFiber__f_finalizing = false;
  this.Lcats_effect_IOFiber__f_outcome = null;
  this.Lcats_effect_IOFiber__f_RightUnit = null;
  this.Lcats_effect_IOFiber__f_IOEndFiber = null;
  this.Lcats_effect_IOFiber__f__cancel = null;
  this.Lcats_effect_IOFiber__f__join = null
}
$c_Lcats_effect_IOFiber.prototype = new $h_Lcats_effect_IOFiberPlatform();
$c_Lcats_effect_IOFiber.prototype.constructor = $c_Lcats_effect_IOFiber;
/** @constructor */
function $h_Lcats_effect_IOFiber() {
  /*<skip>*/
}
$h_Lcats_effect_IOFiber.prototype = $c_Lcats_effect_IOFiber.prototype;
$c_Lcats_effect_IOFiber.prototype.run__V = (function() {
  var x1 = this.Lcats_effect_IOFiber__f_resumeTag;
  switch (x1) {
    case 0: {
      $p_Lcats_effect_IOFiber__execR__V(this);
      return (void 0);
      break
    }
    case 1: {
      $p_Lcats_effect_IOFiber__asyncContinueSuccessfulR__V(this);
      return (void 0);
      break
    }
    case 2: {
      $p_Lcats_effect_IOFiber__asyncContinueFailedR__V(this);
      return (void 0);
      break
    }
    case 3: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledR__V(this);
      return (void 0);
      break
    }
    case 4: {
      $p_Lcats_effect_IOFiber__asyncContinueCanceledWithFinalizerR__V(this);
      return (void 0);
      break
    }
    case 5: {
      $p_Lcats_effect_IOFiber__blockingR__V(this);
      return (void 0);
      break
    }
    case 6: {
      $p_Lcats_effect_IOFiber__cedeR__V(this);
      return (void 0);
      break
    }
    case 7: {
      $p_Lcats_effect_IOFiber__autoCedeR__V(this);
      return (void 0);
      break
    }
    case 8: {
      $p_Lcats_effect_IOFiber__executeRunnableR__V(this);
      return (void 0);
      break
    }
    case 9: {
      return (void 0);
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_Lcats_effect_IOFiber.prototype.cancel__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__cancel
});
$c_Lcats_effect_IOFiber.prototype.join__Lcats_effect_IO = (function() {
  return this.Lcats_effect_IOFiber__f__join
});
$c_Lcats_effect_IOFiber.prototype.toString__T = (function() {
  var state = (this.ju_concurrent_atomic_AtomicBoolean__f_value ? "SUSPENDED" : "RUNNING");
  var tracingEvents = this.Lcats_effect_IOFiber__f_tracingEvents;
  var this$1 = $m_Lcats_effect_tracing_Tracing$().getFrames__Lcats_effect_tracing_RingBuffer__sci_List(tracingEvents).headOption__s_Option();
  if (this$1.isEmpty__Z()) {
    var this$2 = $m_s_None$()
  } else {
    var arg1 = this$1.get__O();
    var frame = $as_jl_StackTraceElement(arg1);
    var this$2 = new $c_s_Some((": " + frame))
  };
  var opAndCallSite = $as_T((this$2.isEmpty__Z() ? "" : this$2.get__O()));
  var x = $systemIdentityHashCode(this);
  return (((("cats.effect.IOFiber@" + $as_T($uD((x >>> 0)).toString(16))) + " ") + state) + opAndCallSite)
});
$c_Lcats_effect_IOFiber.prototype.cancel__O = (function() {
  return this.cancel__Lcats_effect_IO()
});
$c_Lcats_effect_IOFiber.prototype.join__O = (function() {
  return this.join__Lcats_effect_IO()
});
function $as_Lcats_effect_IOFiber(obj) {
  return (((obj instanceof $c_Lcats_effect_IOFiber) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.IOFiber"))
}
function $isArrayOf_Lcats_effect_IOFiber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_IOFiber)))
}
function $asArrayOf_Lcats_effect_IOFiber(obj, depth) {
  return (($isArrayOf_Lcats_effect_IOFiber(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.IOFiber;", depth))
}
var $d_Lcats_effect_IOFiber = new $TypeData().initClass({
  Lcats_effect_IOFiber: 0
}, false, "cats.effect.IOFiber", {
  Lcats_effect_IOFiber: 1,
  Lcats_effect_IOFiberPlatform: 1,
  ju_concurrent_atomic_AtomicBoolean: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Fiber: 1,
  jl_Runnable: 1
});
$c_Lcats_effect_IOFiber.prototype.$classData = $d_Lcats_effect_IOFiber;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Semigroup(fa);
  var fb$1 = $as_Lcats_kernel_Semigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$4(fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$1", {
  Lcats_instances_InvariantMonoidalInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$1.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.constructor = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_InvariantMonoidalInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype = $c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype;
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_CommutativeSemigroup(fa);
  var fb$1 = $as_Lcats_kernel_CommutativeSemigroup(fb);
  return new $c_Lcats_instances_InvariantMonoidalInstances$$anon$6(fa$1, fb$1)
});
var $d_Lcats_instances_InvariantMonoidalInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 0
}, false, "cats.instances.InvariantMonoidalInstances$$anon$2", {
  Lcats_instances_InvariantMonoidalInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1
});
$c_Lcats_instances_InvariantMonoidalInstances$$anon$2.prototype.$classData = $d_Lcats_instances_InvariantMonoidalInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$2(fa$2, fb$2) {
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = null;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1 = fa$2;
  this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1 = fb$2
}
$c_Lcats_instances_OrderingInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_OrderingInstances$$anon$2.prototype = $c_Lcats_instances_OrderingInstances$$anon$2.prototype;
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__T2__T2__I = (function(x, y) {
  var z = this.Lcats_instances_OrderingInstances$$anon$2__f_fa$1.compare__O__O__I(x._1__O(), y._1__O());
  return ((z === 0) ? this.Lcats_instances_OrderingInstances$$anon$2__f_fb$1.compare__O__O__I(x._2__O(), y._2__O()) : z)
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
var $d_Lcats_instances_OrderingInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_OrderingInstances$$anon$2: 0
}, false, "cats.instances.OrderingInstances$$anon$2", {
  Lcats_instances_OrderingInstances$$anon$2: 1,
  O: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
});
$c_Lcats_instances_OrderingInstances$$anon$2.prototype.$classData = $d_Lcats_instances_OrderingInstances$$anon$2;
/** @constructor */
function $c_Lcats_instances_SetInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_SetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SetInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SetInstances$$anon$1.prototype = $c_Lcats_instances_SetInstances$$anon$1.prototype;
$c_Lcats_instances_SetInstances$$anon$1.prototype.unorderedTraverse__sci_Set__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$2) {
  var z = evidence$2.pure__O__O($m_sci_Set$EmptySet$());
  var result = z;
  var it = sa.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var arg1 = result;
    var arg2 = it.next__O();
    result = evidence$2.map2__O__O__F2__O(arg1, f.apply__O__O(arg2), new $c_sjsr_AnonFunction2(((_$2, _$3) => {
      var _$2$1 = $as_sci_Set(_$2);
      return $as_sci_Set(_$2$1.incl__O__sci_SetOps(_$3))
    })))
  };
  return result
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$1) {
  return this.unorderedTraverse__sci_Set__F1__Lcats_CommutativeApplicative__O($as_sci_Set(sa), f, evidence$1)
});
var $d_Lcats_instances_SetInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SetInstances$$anon$1: 0
}, false, "cats.instances.SetInstances$$anon$1", {
  Lcats_instances_SetInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_SemigroupK: 1,
  Lcats_MonoidK: 1
});
$c_Lcats_instances_SetInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SetInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_SortedSetInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SortedSetInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SortedSetInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_SortedSetInstances$$anon$1.prototype = $c_Lcats_instances_SortedSetInstances$$anon$1.prototype;
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldMap__sci_SortedSet__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f))
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_SortedSet(fa);
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(fa$1, b, f)
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_sci_SortedSet(fa);
  return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa$1, lb, f)
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_SortedSet__F1__Lcats_kernel_Monoid__O($as_sci_SortedSet(fa), f, B)
});
var $d_Lcats_instances_SortedSetInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_SortedSetInstances$$anon$1: 0
}, false, "cats.instances.SortedSetInstances$$anon$1", {
  Lcats_instances_SortedSetInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_SemigroupK: 1
});
$c_Lcats_instances_SortedSetInstances$$anon$1.prototype.$classData = $d_Lcats_instances_SortedSetInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_package$list$() {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = null;
  this.Lcats_instances_package$list$__f_catsStdTraverseFilterForList = null;
  $n_Lcats_instances_package$list$ = this;
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  this.Lcats_instances_package$list$__f_catsStdTraverseFilterForList = new $c_Lcats_instances_ListInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$list$.prototype = new $h_O();
$c_Lcats_instances_package$list$.prototype.constructor = $c_Lcats_instances_package$list$;
/** @constructor */
function $h_Lcats_instances_package$list$() {
  /*<skip>*/
}
$h_Lcats_instances_package$list$.prototype = $c_Lcats_instances_package$list$.prototype;
var $d_Lcats_instances_package$list$ = new $TypeData().initClass({
  Lcats_instances_package$list$: 0
}, false, "cats.instances.package$list$", {
  Lcats_instances_package$list$: 1,
  O: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_instances_ListInstancesBinCompat0: 1
});
$c_Lcats_instances_package$list$.prototype.$classData = $d_Lcats_instances_package$list$;
var $n_Lcats_instances_package$list$;
function $m_Lcats_instances_package$list$() {
  if ((!$n_Lcats_instances_package$list$)) {
    $n_Lcats_instances_package$list$ = new $c_Lcats_instances_package$list$()
  };
  return $n_Lcats_instances_package$list$
}
/** @constructor */
function $c_Lcats_instances_package$stream$() {
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = null;
  this.Lcats_instances_package$stream$__f_catsStdTraverseFilterForStream = null;
  $n_Lcats_instances_package$stream$ = this;
  this.Lcats_instances_package$stream$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  this.Lcats_instances_package$stream$__f_catsStdTraverseFilterForStream = new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$stream$.prototype = new $h_O();
$c_Lcats_instances_package$stream$.prototype.constructor = $c_Lcats_instances_package$stream$;
/** @constructor */
function $h_Lcats_instances_package$stream$() {
  /*<skip>*/
}
$h_Lcats_instances_package$stream$.prototype = $c_Lcats_instances_package$stream$.prototype;
var $d_Lcats_instances_package$stream$ = new $TypeData().initClass({
  Lcats_instances_package$stream$: 0
}, false, "cats.instances.package$stream$", {
  Lcats_instances_package$stream$: 1,
  O: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1
});
$c_Lcats_instances_package$stream$.prototype.$classData = $d_Lcats_instances_package$stream$;
var $n_Lcats_instances_package$stream$;
function $m_Lcats_instances_package$stream$() {
  if ((!$n_Lcats_instances_package$stream$)) {
    $n_Lcats_instances_package$stream$ = new $c_Lcats_instances_package$stream$()
  };
  return $n_Lcats_instances_package$stream$
}
/** @constructor */
function $c_Lcats_instances_package$vector$() {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = null;
  this.Lcats_instances_package$vector$__f_catsStdTraverseFilterForVector = null;
  $n_Lcats_instances_package$vector$ = this;
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  this.Lcats_instances_package$vector$__f_catsStdTraverseFilterForVector = new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$vector$.prototype = new $h_O();
$c_Lcats_instances_package$vector$.prototype.constructor = $c_Lcats_instances_package$vector$;
/** @constructor */
function $h_Lcats_instances_package$vector$() {
  /*<skip>*/
}
$h_Lcats_instances_package$vector$.prototype = $c_Lcats_instances_package$vector$.prototype;
var $d_Lcats_instances_package$vector$ = new $TypeData().initClass({
  Lcats_instances_package$vector$: 0
}, false, "cats.instances.package$vector$", {
  Lcats_instances_package$vector$: 1,
  O: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1
});
$c_Lcats_instances_package$vector$.prototype.$classData = $d_Lcats_instances_package$vector$;
var $n_Lcats_instances_package$vector$;
function $m_Lcats_instances_package$vector$() {
  if ((!$n_Lcats_instances_package$vector$)) {
    $n_Lcats_instances_package$vector$ = new $c_Lcats_instances_package$vector$()
  };
  return $n_Lcats_instances_package$vector$
}
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BigDecimalOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigDecimalOrder.prototype = $c_Lcats_kernel_instances_BigDecimalOrder.prototype;
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigDecimal(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return x$1.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(y$1.s_math_BigDecimal__f_bigDecimal)
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigDecimal(x);
  var y$1 = $as_s_math_BigDecimal(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1)
});
var $d_Lcats_kernel_instances_BigDecimalOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BigDecimalOrder: 0
}, false, "cats.kernel.instances.BigDecimalOrder", {
  Lcats_kernel_instances_BigDecimalOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_BigDecimalOrder.prototype.$classData = $d_Lcats_kernel_instances_BigDecimalOrder;
/** @constructor */
function $c_Lcats_kernel_instances_DoubleOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DoubleOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleOrder.prototype.constructor = $c_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DoubleOrder.prototype = $c_Lcats_kernel_instances_DoubleOrder.prototype;
$c_Lcats_kernel_instances_DoubleOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__D__D__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uD(x);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(x$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__D__D__Z($uD(x), $uD(y))
});
var $d_Lcats_kernel_instances_DoubleOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DoubleOrder: 0
}, false, "cats.kernel.instances.DoubleOrder", {
  Lcats_kernel_instances_DoubleOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_DoubleOrder.prototype.$classData = $d_Lcats_kernel_instances_DoubleOrder;
/** @constructor */
function $c_Lcats_kernel_instances_FloatOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FloatOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatOrder.prototype.constructor = $c_Lcats_kernel_instances_FloatOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FloatOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FloatOrder.prototype = $c_Lcats_kernel_instances_FloatOrder.prototype;
$c_Lcats_kernel_instances_FloatOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__F__F__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uF(x);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(x$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uF(x);
  var y$1 = $uF(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
$c_Lcats_kernel_instances_FloatOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__F__F__Z($uF(x), $uF(y))
});
var $d_Lcats_kernel_instances_FloatOrder = new $TypeData().initClass({
  Lcats_kernel_instances_FloatOrder: 0
}, false, "cats.kernel.instances.FloatOrder", {
  Lcats_kernel_instances_FloatOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1
});
$c_Lcats_kernel_instances_FloatOrder.prototype.$classData = $d_Lcats_kernel_instances_FloatOrder;
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
function $as_jl_ArrayIndexOutOfBoundsException(obj) {
  return (((obj instanceof $c_jl_ArrayIndexOutOfBoundsException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.ArrayIndexOutOfBoundsException"))
}
function $isArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArrayIndexOutOfBoundsException)))
}
function $asArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) {
  return (($isArrayOf_jl_ArrayIndexOutOfBoundsException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.ArrayIndexOutOfBoundsException;", depth))
}
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass({
  jl_ArrayIndexOutOfBoundsException: 0
}, false, "java.lang.ArrayIndexOutOfBoundsException", {
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_ArrayIndexOutOfBoundsException.prototype.$classData = $d_jl_ArrayIndexOutOfBoundsException;
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Double__hashCode__I($thiz) {
  var value = $uD($thiz);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(value)
}
function $f_jl_Double__toString__T($thiz) {
  var d = $uD($thiz);
  return ("" + d)
}
function $f_jl_Double__compareTo__O__I($thiz, o) {
  var that = $as_jl_Double(o);
  return $m_jl_Double$().compare__D__D__I($uD($thiz), $uD(that))
}
function $as_jl_Double(obj) {
  return ((((typeof obj) === "number") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Double"))
}
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)))
}
function $asArrayOf_jl_Double(obj, depth) {
  return (($isArrayOf_jl_Double(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Double;", depth))
}
var $d_jl_Double = new $TypeData().initClass({
  jl_Double: 0
}, false, "java.lang.Double", {
  jl_Double: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "number")));
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Float__hashCode__I($thiz) {
  var value = $uF($thiz);
  return $m_jl_FloatingPointBits$().numberHashCode__D__I(value)
}
function $f_jl_Float__toString__T($thiz) {
  var f = $uF($thiz);
  return ("" + f)
}
function $f_jl_Float__compareTo__O__I($thiz, o) {
  var that = $as_jl_Float(o);
  var a = $uF($thiz);
  var b = $uF(that);
  return $m_jl_Double$().compare__D__D__I(a, b)
}
function $as_jl_Float(obj) {
  return (($isFloat(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Float"))
}
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)))
}
function $asArrayOf_jl_Float(obj, depth) {
  return (($isArrayOf_jl_Float(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Float;", depth))
}
var $d_jl_Float = new $TypeData().initClass({
  jl_Float: 0
}, false, "java.lang.Float", {
  jl_Float: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => $isFloat(x)));
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that)
}
function $f_jl_Integer__hashCode__I($thiz) {
  return $uI($thiz)
}
function $f_jl_Integer__toString__T($thiz) {
  var i = $uI($thiz);
  return ("" + i)
}
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  var that = $as_jl_Integer(o);
  var x = $uI($thiz);
  var y = $uI(that);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1))
}
function $as_jl_Integer(obj) {
  return (($isInt(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Integer"))
}
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)))
}
function $asArrayOf_jl_Integer(obj, depth) {
  return (($isArrayOf_jl_Integer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Integer;", depth))
}
var $d_jl_Integer = new $TypeData().initClass({
  jl_Integer: 0
}, false, "java.lang.Integer", {
  jl_Integer: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => $isInt(x)));
function $f_jl_Long__equals__O__Z($thiz, that) {
  if ((that instanceof $c_RTLong)) {
    var x2 = $as_jl_Long(that);
    var this$1 = $uJ($thiz);
    var b = $uJ(x2);
    return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
  } else {
    return false
  }
}
function $f_jl_Long__hashCode__I($thiz) {
  var t = $uJ($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
}
function $f_jl_Long__toString__T($thiz) {
  var this$1 = $uJ($thiz);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
}
function $f_jl_Long__compareTo__O__I($thiz, o) {
  var that = $as_jl_Long(o);
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I($thiz.RTLong__f_lo, $thiz.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi)
}
function $as_jl_Long(obj) {
  return (((obj instanceof $c_RTLong) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.Long"))
}
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)))
}
function $asArrayOf_jl_Long(obj, depth) {
  return (($isArrayOf_jl_Long(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.Long;", depth))
}
var $d_jl_Long = new $TypeData().initClass({
  jl_Long: 0
}, false, "java.lang.Long", {
  jl_Long: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => (x instanceof $c_RTLong)));
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
}
function $as_jl_NumberFormatException(obj) {
  return (((obj instanceof $c_jl_NumberFormatException) || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.NumberFormatException"))
}
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)))
}
function $asArrayOf_jl_NumberFormatException(obj, depth) {
  return (($isArrayOf_jl_NumberFormatException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.NumberFormatException;", depth))
}
var $d_jl_NumberFormatException = new $TypeData().initClass({
  jl_NumberFormatException: 0
}, false, "java.lang.NumberFormatException", {
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_NumberFormatException.prototype.$classData = $d_jl_NumberFormatException;
function $f_T__codePointAt__I__I($thiz, index) {
  return $uI($thiz.codePointAt(index))
}
function $f_T__hashCode__I($thiz) {
  var res = 0;
  var mul = 1;
  var i = (((-1) + $uI($thiz.length)) | 0);
  while ((i >= 0)) {
    var $$x1 = res;
    var index = i;
    res = (($$x1 + Math.imul((65535 & $uI($thiz.charCodeAt(index))), mul)) | 0);
    mul = Math.imul(31, mul);
    i = (((-1) + i) | 0)
  };
  return res
}
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that)
}
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $uI($thiz.length);
  var strLength = $uI(anotherString.length);
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var $$x1 = $uI($thiz.charCodeAt(index));
    var index$1 = i;
    var cmp = (((65535 & $$x1) - (65535 & $uI(anotherString.charCodeAt(index$1)))) | 0);
    if ((cmp !== 0)) {
      return cmp
    };
    i = ((1 + i) | 0)
  };
  return ((thisLength - strLength) | 0)
}
function $f_T__endsWith__T__Z($thiz, suffix) {
  return ($as_T($thiz.substring((($uI($thiz.length) - $uI(suffix.length)) | 0))) === suffix)
}
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  if (((((srcEnd > $uI($thiz.length)) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    throw $ct_jl_StringIndexOutOfBoundsException__T__(new $c_jl_StringIndexOutOfBoundsException(), "Index out of Bound")
  };
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $$x1 = i;
    var index = i;
    dst.set((($$x1 + offset) | 0), (65535 & $uI($thiz.charCodeAt(index))));
    i = ((1 + i) | 0)
  }
}
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return $uI($thiz.indexOf(str))
}
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  var this$2 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceAll__T__T(replacement)
}
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$2 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return this$2.java$util$regex$Pattern$$split__T__I__AT($thiz, limit)
}
function $f_T__toCharArray__AC($thiz) {
  var len = $uI($thiz.length);
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $$x1 = i;
    var index = i;
    result.set($$x1, (65535 & $uI($thiz.charCodeAt(index))));
    i = ((1 + i) | 0)
  };
  return result
}
function $f_T__trim__T($thiz) {
  var len = $uI($thiz.length);
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $$x1 = ((65535 & $uI($thiz.charCodeAt(index))) <= 32)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      start = ((1 + start) | 0)
    } else {
      break
    }
  };
  if ((start === len)) {
    return ""
  } else {
    var end = len;
    while (true) {
      var index$1 = (((-1) + end) | 0);
      if (((65535 & $uI($thiz.charCodeAt(index$1))) <= 32)) {
        end = (((-1) + end) | 0)
      } else {
        break
      }
    };
    if (((start === 0) && (end === len))) {
      return $thiz
    } else {
      var beginIndex = start;
      var endIndex = end;
      return $as_T($thiz.substring(beginIndex, endIndex))
    }
  }
}
function $f_T__toString__T($thiz) {
  return $thiz
}
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, $as_T(o))
}
function $as_T(obj) {
  return ((((typeof obj) === "string") || (obj === null)) ? obj : $throwClassCastException(obj, "java.lang.String"))
}
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)))
}
function $asArrayOf_T(obj, depth) {
  return (($isArrayOf_T(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ljava.lang.String;", depth))
}
var $d_T = new $TypeData().initClass({
  T: 0
}, false, "java.lang.String", {
  T: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}, (void 0), (void 0), ((x) => ((typeof x) === "string")));
function $ct_jl_StringIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz
}
function $ct_jl_StringIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz
}
class $c_jl_StringIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass({
  jl_StringIndexOutOfBoundsException: 0
}, false, "java.lang.StringIndexOutOfBoundsException", {
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_jl_StringIndexOutOfBoundsException.prototype.$classData = $d_jl_StringIndexOutOfBoundsException;
class $c_Ljava_nio_ReadOnlyBufferException extends $c_jl_UnsupportedOperationException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
}
var $d_Ljava_nio_ReadOnlyBufferException = new $TypeData().initClass({
  Ljava_nio_ReadOnlyBufferException: 0
}, false, "java.nio.ReadOnlyBufferException", {
  Ljava_nio_ReadOnlyBufferException: 1,
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_Ljava_nio_ReadOnlyBufferException.prototype.$classData = $d_Ljava_nio_ReadOnlyBufferException;
/** @constructor */
function $c_ju_Arrays$$anon$1() {
  /*<skip>*/
}
$c_ju_Arrays$$anon$1.prototype = new $h_O();
$c_ju_Arrays$$anon$1.prototype.constructor = $c_ju_Arrays$$anon$1;
/** @constructor */
function $h_ju_Arrays$$anon$1() {
  /*<skip>*/
}
$h_ju_Arrays$$anon$1.prototype = $c_ju_Arrays$$anon$1.prototype;
$c_ju_Arrays$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_ju_Arrays$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_ju_Arrays$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return $dp_compareTo__O__I($as_jl_Comparable(x), y)
});
var $d_ju_Arrays$$anon$1 = new $TypeData().initClass({
  ju_Arrays$$anon$1: 0
}, false, "java.util.Arrays$$anon$1", {
  ju_Arrays$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Arrays$$anon$1.prototype.$classData = $d_ju_Arrays$$anon$1;
/** @constructor */
function $c_ju_Arrays$$anon$3(cmp$1) {
  this.ju_Arrays$$anon$3__f_cmp$1 = null;
  this.ju_Arrays$$anon$3__f_cmp$1 = cmp$1
}
$c_ju_Arrays$$anon$3.prototype = new $h_O();
$c_ju_Arrays$$anon$3.prototype.constructor = $c_ju_Arrays$$anon$3;
/** @constructor */
function $h_ju_Arrays$$anon$3() {
  /*<skip>*/
}
$h_ju_Arrays$$anon$3.prototype = $c_ju_Arrays$$anon$3.prototype;
$c_ju_Arrays$$anon$3.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_ju_Arrays$$anon$3.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_ju_Arrays$$anon$3.prototype.compare__O__O__I = (function(x, y) {
  return this.ju_Arrays$$anon$3__f_cmp$1.compare__O__O__I(x, y)
});
var $d_ju_Arrays$$anon$3 = new $TypeData().initClass({
  ju_Arrays$$anon$3: 0
}, false, "java.util.Arrays$$anon$3", {
  ju_Arrays$$anon$3: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_ju_Arrays$$anon$3.prototype.$classData = $d_ju_Arrays$$anon$3;
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.ju_HashMap$EntrySet__f_$outer = outer
  }
}
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
  /*<skip>*/
}
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = this.ju_HashMap$EntrySet__f_$outer;
  return this$1.nodeIterator__ju_Iterator()
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return this.ju_HashMap$EntrySet__f_$outer.ju_HashMap__f_contentSize
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var x2 = $as_ju_Map$Entry(o);
    var this$1 = this.ju_HashMap$EntrySet__f_$outer;
    var key = x2.ju_HashMap$Node__f_key;
    if ((key === null)) {
      var hash = 0
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0))
    };
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this$1.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
    if ((node !== null)) {
      var a = node.ju_HashMap$Node__f_value;
      var b = x2.ju_HashMap$Node__f_value;
      return ((a === null) ? (b === null) : $dp_equals__O__Z(a, b))
    } else {
      return false
    }
  } else {
    return false
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass({
  ju_HashMap$EntrySet: 0
}, false, "java.util.HashMap$EntrySet", {
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
});
$c_ju_HashMap$EntrySet.prototype.$classData = $d_ju_HashMap$EntrySet;
/** @constructor */
function $c_ju_NullRejectingHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0
}
$c_ju_NullRejectingHashMap.prototype = new $h_ju_HashMap();
$c_ju_NullRejectingHashMap.prototype.constructor = $c_ju_NullRejectingHashMap;
/** @constructor */
function $h_ju_NullRejectingHashMap() {
  /*<skip>*/
}
$h_ju_NullRejectingHashMap.prototype = $c_ju_NullRejectingHashMap.prototype;
$c_ju_NullRejectingHashMap.prototype.get__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null)
});
$c_ju_NullRejectingHashMap.prototype.put__O__O__O = (function(key, value) {
  if (((key === null) || (value === null))) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  if ((key === null)) {
    var $$x1 = 0
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $$x1 = (originalHash ^ ((originalHash >>> 16) | 0))
  };
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $$x1, false)
});
$c_ju_NullRejectingHashMap.prototype.remove__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $c_ju_HashMap.prototype.remove__O__O.call(this, key)
});
$c_ju_NullRejectingHashMap.prototype.containsValue__O__Z = (function(value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException())
  };
  return $c_ju_HashMap.prototype.containsValue__O__Z.call(this, value)
});
class $c_ju_concurrent_CancellationException extends $c_jl_IllegalStateException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true)
  };
}
var $d_ju_concurrent_CancellationException = new $TypeData().initClass({
  ju_concurrent_CancellationException: 0
}, false, "java.util.concurrent.CancellationException", {
  ju_concurrent_CancellationException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_concurrent_CancellationException.prototype.$classData = $d_ju_concurrent_CancellationException;
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.ju_regex_PatternSyntaxException__f_desc = null;
    this.ju_regex_PatternSyntaxException__f_regex = null;
    this.ju_regex_PatternSyntaxException__f_index = 0;
    this.ju_regex_PatternSyntaxException__f_desc = desc;
    this.ju_regex_PatternSyntaxException__f_regex = regex;
    this.ju_regex_PatternSyntaxException__f_index = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    var idx = this.ju_regex_PatternSyntaxException__f_index;
    var re = this.ju_regex_PatternSyntaxException__f_regex;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.ju_regex_PatternSyntaxException__f_desc + indexHint) + "\n") + re);
    return ((((idx >= 0) && (re !== null)) && (idx < $uI(re.length))) ? (((base + "\n") + $as_T(" ".repeat(idx))) + "^") : base)
  };
}
var $d_ju_regex_PatternSyntaxException = new $TypeData().initClass({
  ju_regex_PatternSyntaxException: 0
}, false, "java.util.regex.PatternSyntaxException", {
  ju_regex_PatternSyntaxException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1
});
$c_ju_regex_PatternSyntaxException.prototype.$classData = $d_ju_regex_PatternSyntaxException;
/** @constructor */
function $c_Lnet_andimiller_Msg$NewInput(s) {
  this.Lnet_andimiller_Msg$NewInput__f_s = null;
  this.Lnet_andimiller_Msg$NewInput__f_s = s
}
$c_Lnet_andimiller_Msg$NewInput.prototype = new $h_Lnet_andimiller_Msg();
$c_Lnet_andimiller_Msg$NewInput.prototype.constructor = $c_Lnet_andimiller_Msg$NewInput;
/** @constructor */
function $h_Lnet_andimiller_Msg$NewInput() {
  /*<skip>*/
}
$h_Lnet_andimiller_Msg$NewInput.prototype = $c_Lnet_andimiller_Msg$NewInput.prototype;
$c_Lnet_andimiller_Msg$NewInput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_andimiller_Msg$NewInput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_andimiller_Msg$NewInput)) {
    var x$0$2 = $as_Lnet_andimiller_Msg$NewInput(x$0);
    return (this.Lnet_andimiller_Msg$NewInput__f_s === x$0$2.Lnet_andimiller_Msg$NewInput__f_s)
  } else {
    return false
  }
});
$c_Lnet_andimiller_Msg$NewInput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_andimiller_Msg$NewInput.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_andimiller_Msg$NewInput.prototype.productPrefix__T = (function() {
  return "NewInput"
});
$c_Lnet_andimiller_Msg$NewInput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_Msg$NewInput__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lnet_andimiller_Msg$NewInput(obj) {
  return (((obj instanceof $c_Lnet_andimiller_Msg$NewInput) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.Msg$NewInput"))
}
function $isArrayOf_Lnet_andimiller_Msg$NewInput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_Msg$NewInput)))
}
function $asArrayOf_Lnet_andimiller_Msg$NewInput(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_Msg$NewInput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.Msg$NewInput;", depth))
}
var $d_Lnet_andimiller_Msg$NewInput = new $TypeData().initClass({
  Lnet_andimiller_Msg$NewInput: 0
}, false, "net.andimiller.Msg$NewInput", {
  Lnet_andimiller_Msg$NewInput: 1,
  Lnet_andimiller_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_andimiller_Msg$NewInput.prototype.$classData = $d_Lnet_andimiller_Msg$NewInput;
/** @constructor */
function $c_Lnet_andimiller_Msg$NewK(s) {
  this.Lnet_andimiller_Msg$NewK__f_s = null;
  this.Lnet_andimiller_Msg$NewK__f_s = s
}
$c_Lnet_andimiller_Msg$NewK.prototype = new $h_Lnet_andimiller_Msg();
$c_Lnet_andimiller_Msg$NewK.prototype.constructor = $c_Lnet_andimiller_Msg$NewK;
/** @constructor */
function $h_Lnet_andimiller_Msg$NewK() {
  /*<skip>*/
}
$h_Lnet_andimiller_Msg$NewK.prototype = $c_Lnet_andimiller_Msg$NewK.prototype;
$c_Lnet_andimiller_Msg$NewK.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lnet_andimiller_Msg$NewK.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lnet_andimiller_Msg$NewK)) {
    var x$0$2 = $as_Lnet_andimiller_Msg$NewK(x$0);
    return (this.Lnet_andimiller_Msg$NewK__f_s === x$0$2.Lnet_andimiller_Msg$NewK__f_s)
  } else {
    return false
  }
});
$c_Lnet_andimiller_Msg$NewK.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lnet_andimiller_Msg$NewK.prototype.productArity__I = (function() {
  return 1
});
$c_Lnet_andimiller_Msg$NewK.prototype.productPrefix__T = (function() {
  return "NewK"
});
$c_Lnet_andimiller_Msg$NewK.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lnet_andimiller_Msg$NewK__f_s
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lnet_andimiller_Msg$NewK(obj) {
  return (((obj instanceof $c_Lnet_andimiller_Msg$NewK) || (obj === null)) ? obj : $throwClassCastException(obj, "net.andimiller.Msg$NewK"))
}
function $isArrayOf_Lnet_andimiller_Msg$NewK(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lnet_andimiller_Msg$NewK)))
}
function $asArrayOf_Lnet_andimiller_Msg$NewK(obj, depth) {
  return (($isArrayOf_Lnet_andimiller_Msg$NewK(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lnet.andimiller.Msg$NewK;", depth))
}
var $d_Lnet_andimiller_Msg$NewK = new $TypeData().initClass({
  Lnet_andimiller_Msg$NewK: 0
}, false, "net.andimiller.Msg$NewK", {
  Lnet_andimiller_Msg$NewK: 1,
  Lnet_andimiller_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
});
$c_Lnet_andimiller_Msg$NewK.prototype.$classData = $d_Lnet_andimiller_Msg$NewK;
/** @constructor */
function $c_s_None$() {
  /*<skip>*/
}
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
  /*<skip>*/
}
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get")
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_s_None$.prototype.toString__T = (function() {
  return "None"
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E()
});
var $d_s_None$ = new $TypeData().initClass({
  s_None$: 0
}, false, "scala.None$", {
  s_None$: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_None$.prototype.$classData = $d_s_None$;
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$()
  };
  return $n_s_None$
}
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value
}
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
  /*<skip>*/
}
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some"
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_s_Some.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_s_Some)) {
    var Some$1 = $as_s_Some(x$1);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, Some$1.s_Some__f_value)
  } else {
    return false
  }
});
function $as_s_Some(obj) {
  return (((obj instanceof $c_s_Some) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.Some"))
}
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)))
}
function $asArrayOf_s_Some(obj, depth) {
  return (($isArrayOf_s_Some(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.Some;", depth))
}
var $d_s_Some = new $TypeData().initClass({
  s_Some: 0
}, false, "scala.Some", {
  s_Some: 1,
  s_Option: 1,
  O: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
});
$c_s_Some.prototype.$classData = $d_s_Some;
/** @constructor */
function $c_sc_AbstractIterable() {
  /*<skip>*/
}
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
  /*<skip>*/
}
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$()
});
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T()
});
$c_sc_AbstractIterable.prototype.stringPrefix__T = (function() {
  return "Iterable"
});
$c_sc_AbstractIterable.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps(this.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder()
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_AbstractIterable.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this)
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize)
});
$c_sc_AbstractIterable.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred)
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n)
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sc_AbstractIterable.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sc_AbstractIterable.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this)
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this)
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_AbstractIterable.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_AbstractIterable.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sc_AbstractIterable.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_sc_AbstractIterable.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this)
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1)
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_sr_ScalaRunTime$().array_length__O__I($thiz.sc_ArrayOps$ArrayIterator__f_xs);
  return $thiz
}
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0
}
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len)
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  try {
    var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    if ((newPos < 0)) {
      var $$x1 = this.sc_ArrayOps$ArrayIterator__f_len
    } else {
      var a = this.sc_ArrayOps$ArrayIterator__f_len;
      var $$x1 = ((a < newPos) ? a : newPos)
    };
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = $$x1
  };
  return this
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator: 0
}, false, "scala.collection.ArrayOps$ArrayIterator", {
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator.prototype.$classData = $d_sc_ArrayOps$ArrayIterator;
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) ? $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder : value))
}
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = self.length__I();
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0
}
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b)
  };
  return this
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + formatFrom) | 0);
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", {
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewIterator;
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = self.length__I();
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0
}
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder <= from)) {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = until
      }
    } else {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - from) | 0);
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        if ((until <= from)) {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0
        } else {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((until - from) | 0)
        }
      } else {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - from) | 0)
      }
    }
  };
  return this
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().initClass({
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 0
}, false, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", {
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.$classData = $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty)
}
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$3 = $as_sc_Iterator(this.scm_ImmutableBuilder__f_elems);
  var xs = new $c_sjsr_AnonFunction0(((elem$1) => (() => {
    $m_sc_Iterator$();
    return new $c_sc_Iterator$$anon$20(elem$1)
  }))(elem));
  this.scm_ImmutableBuilder__f_elems = this$3.concat__F0__sc_Iterator(xs);
  return this
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem)
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass({
  sc_Iterator$$anon$21: 0
}, false, "scala.collection.Iterator$$anon$21", {
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sc_Iterator$$anon$21.prototype.$classData = $d_sc_Iterator$$anon$21;
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.sc_Iterator$$anon$7__f_hd = null;
  this.sc_Iterator$$anon$7__f_status = 0;
  this.sc_Iterator$$anon$7__f_$outer = null;
  this.sc_Iterator$$anon$7__f_pf$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_Iterator$$anon$7__f_$outer = outer
  };
  this.sc_Iterator$$anon$7__f_pf$1 = pf$1;
  this.sc_Iterator$$anon$7__f_status = 0
}
$c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$7.prototype.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
  /*<skip>*/
}
$h_sc_Iterator$$anon$7.prototype = $c_sc_Iterator$$anon$7.prototype;
$c_sc_Iterator$$anon$7.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sc_Iterator$$anon$7.prototype.toString__T = (function() {
  return "<function1>"
});
$c_sc_Iterator$$anon$7.prototype.apply__O__O = (function(value) {
  return $m_sr_Statics$PFMarker$()
});
$c_sc_Iterator$$anon$7.prototype.hasNext__Z = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.sc_Iterator$$anon$7__f_status === 0)) {
    if (this.sc_Iterator$$anon$7__f_$outer.hasNext__Z()) {
      var x = this.sc_Iterator$$anon$7__f_$outer.next__O();
      var v = this.sc_Iterator$$anon$7__f_pf$1.applyOrElse__O__F1__O(x, this);
      if ((marker !== v)) {
        this.sc_Iterator$$anon$7__f_hd = v;
        this.sc_Iterator$$anon$7__f_status = 1
      }
    } else {
      this.sc_Iterator$$anon$7__f_status = (-1)
    }
  };
  return (this.sc_Iterator$$anon$7__f_status === 1)
});
$c_sc_Iterator$$anon$7.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$7__f_status = 0;
    return this.sc_Iterator$$anon$7__f_hd
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().initClass({
  sc_Iterator$$anon$7: 0
}, false, "scala.collection.Iterator$$anon$7", {
  sc_Iterator$$anon$7: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  F1: 1
});
$c_sc_Iterator$$anon$7.prototype.$classData = $d_sc_Iterator$$anon$7;
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var x2 = $as_s_Some(x1);
    var v = x2.s_Some__f_value;
    return v
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return default$1.apply__O()
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
}
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $thiz.default__O__O(key)
  } else if ((x1 instanceof $c_s_Some)) {
    var x3 = $as_s_Some(x1);
    var value = x3.s_Some__f_value;
    return value
  } else {
    throw new $c_s_MatchError(x1)
  }
}
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sjsr_AnonFunction0(((default$2, x$1) => (() => default$2.apply__O__O(x$1)))(default$1, x)))
}
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var next = $as_T2(it.next__O());
    f.apply__O__O__O(next._1__O(), next._2__O())
  }
}
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
}
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $thiz.get__O__s_Option(key);
  return (!this$1.isEmpty__Z())
}
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$2 = $thiz.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((x0$1$2) => {
    var x0$1 = $as_T2(x0$1$2);
    if ((x0$1 !== null)) {
      var k = x0$1._1__O();
      var v = x0$1._2__O();
      return ((k + " -> ") + v)
    } else {
      throw new $c_s_MatchError(x0$1)
    }
  }));
  var this$3 = new $c_sc_Iterator$$anon$9(this$2, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$3, sb, start, sep, end)
}
function $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  var builder = $thiz.newSpecificBuilder__scm_Builder();
  var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var next = it.next__O();
    if (seen.add__O__Z(f.apply__O__O(next))) {
      builder.addOne__O__scm_Growable(next)
    }
  };
  return builder.result__O()
}
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  if (($thiz.knownSize__I() >= 0)) {
    b.sizeHint__I__V(((1 + $thiz.length__I()) | 0))
  };
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addOne__O__scm_Growable(elem);
  return b.result__O()
}
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return b.result__O()
}
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.sci_ArraySeq$__f_bitmap$0)) {
    $thiz.sci_ArraySeq$__f_emptyImpl = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.sci_ArraySeq$__f_bitmap$0 = true
  };
  return $thiz.sci_ArraySeq$__f_emptyImpl
}
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.sci_ArraySeq$__f_bitmap$0) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.sci_ArraySeq$__f_emptyImpl)
}
/** @constructor */
function $c_sci_ArraySeq$() {
  this.sci_ArraySeq$__f_emptyImpl = null;
  this.sci_ArraySeq$__f_untagged = null;
  this.sci_ArraySeq$__f_bitmap$0 = false;
  $n_sci_ArraySeq$ = this;
  this.sci_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this)
}
$c_sci_ArraySeq$.prototype = new $h_O();
$c_sci_ArraySeq$.prototype.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
  /*<skip>*/
}
$h_sci_ArraySeq$.prototype = $c_sci_ArraySeq$.prototype;
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq = (function(it, tag) {
  if ((it instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(it);
    return x2
  } else {
    return this.unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, tag))
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$2) {
  var this$3 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sjsr_AnonFunction1(((evidence$2$1) => ((b$2) => {
    var b = $as_scm_ArrayBuffer(b$2);
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(b, evidence$2$1))
  }))(evidence$2));
  return new $c_scm_Builder$$anon$1(this$3, f)
});
$c_sci_ArraySeq$.prototype.unsafeWrapArray__O__sci_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_sci_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_sci_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_sci_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_sci_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_sci_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_sci_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_sci_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_sci_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_sci_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_sci_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12))
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5))
});
$c_sci_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this)
});
var $d_sci_ArraySeq$ = new $TypeData().initClass({
  sci_ArraySeq$: 0
}, false, "scala.collection.immutable.ArraySeq$", {
  sci_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$.prototype.$classData = $d_sci_ArraySeq$;
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$()
  };
  return $n_sci_ArraySeq$
}
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)))
}
function $as_sci_Iterable(obj) {
  return (($is_sci_Iterable(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Iterable"))
}
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)))
}
function $asArrayOf_sci_Iterable(obj, depth) {
  return (($isArrayOf_sci_Iterable(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Iterable;", depth))
}
/** @constructor */
function $c_sci_LongMap$$anon$2(outer) {
  this.scm_ImmutableBuilder__f_empty = null;
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sci_LongMap$Nil$())
}
$c_sci_LongMap$$anon$2.prototype = new $h_scm_ImmutableBuilder();
$c_sci_LongMap$$anon$2.prototype.constructor = $c_sci_LongMap$$anon$2;
/** @constructor */
function $h_sci_LongMap$$anon$2() {
  /*<skip>*/
}
$h_sci_LongMap$$anon$2.prototype = $c_sci_LongMap$$anon$2.prototype;
$c_sci_LongMap$$anon$2.prototype.addOne__T2__sci_LongMap$$anon$2 = (function(elem) {
  var this$1 = $as_sci_LongMap(this.scm_ImmutableBuilder__f_elems);
  this.scm_ImmutableBuilder__f_elems = this$1.updated__J__O__sci_LongMap(elem._1$mcJ$sp__J(), elem._2__O());
  return this
});
$c_sci_LongMap$$anon$2.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_LongMap$$anon$2($as_T2(elem))
});
var $d_sci_LongMap$$anon$2 = new $TypeData().initClass({
  sci_LongMap$$anon$2: 0
}, false, "scala.collection.immutable.LongMap$$anon$2", {
  sci_LongMap$$anon$2: 1,
  scm_ImmutableBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_LongMap$$anon$2.prototype.$classData = $d_sci_LongMap$$anon$2;
/** @constructor */
function $c_sci_LongMapEntryIterator(it) {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null;
  $ct_sci_LongMapIterator__sci_LongMap__(this, it)
}
$c_sci_LongMapEntryIterator.prototype = new $h_sci_LongMapIterator();
$c_sci_LongMapEntryIterator.prototype.constructor = $c_sci_LongMapEntryIterator;
/** @constructor */
function $h_sci_LongMapEntryIterator() {
  /*<skip>*/
}
$h_sci_LongMapEntryIterator.prototype = $c_sci_LongMapEntryIterator.prototype;
$c_sci_LongMapEntryIterator.prototype.valueOf__sci_LongMap$Tip__O = (function(tip) {
  return new $c_T2(tip.sci_LongMap$Tip__f_key, tip.sci_LongMap$Tip__f_value)
});
var $d_sci_LongMapEntryIterator = new $TypeData().initClass({
  sci_LongMapEntryIterator: 0
}, false, "scala.collection.immutable.LongMapEntryIterator", {
  sci_LongMapEntryIterator: 1,
  sci_LongMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_LongMapEntryIterator.prototype.$classData = $d_sci_LongMapEntryIterator;
/** @constructor */
function $c_sci_LongMapValueIterator(it) {
  this.sci_LongMapIterator__f_index = 0;
  this.sci_LongMapIterator__f_buffer = null;
  $ct_sci_LongMapIterator__sci_LongMap__(this, it)
}
$c_sci_LongMapValueIterator.prototype = new $h_sci_LongMapIterator();
$c_sci_LongMapValueIterator.prototype.constructor = $c_sci_LongMapValueIterator;
/** @constructor */
function $h_sci_LongMapValueIterator() {
  /*<skip>*/
}
$h_sci_LongMapValueIterator.prototype = $c_sci_LongMapValueIterator.prototype;
$c_sci_LongMapValueIterator.prototype.valueOf__sci_LongMap$Tip__O = (function(tip) {
  return tip.sci_LongMap$Tip__f_value
});
var $d_sci_LongMapValueIterator = new $TypeData().initClass({
  sci_LongMapValueIterator: 0
}, false, "scala.collection.immutable.LongMapValueIterator", {
  sci_LongMapValueIterator: 1,
  sci_LongMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_LongMapValueIterator.prototype.$classData = $d_sci_LongMapValueIterator;
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
$c_sci_Map$Map2$$anon$1.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v)
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass({
  sci_Map$Map2$$anon$1: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$1", {
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$1.prototype.$classData = $d_sci_Map$Map2$$anon$1;
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer)
}
$c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$3.prototype.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
  /*<skip>*/
}
$h_sci_Map$Map2$$anon$3.prototype = $c_sci_Map$Map2$$anon$3.prototype;
$c_sci_Map$Map2$$anon$3.prototype.nextResult__O__O__O = (function(k, v) {
  return v
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().initClass({
  sci_Map$Map2$$anon$3: 0
}, false, "scala.collection.immutable.Map$Map2$$anon$3", {
  sci_Map$Map2$$anon$3: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map2$$anon$3.prototype.$classData = $d_sci_Map$Map2$$anon$3;
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
$c_sci_Map$Map3$$anon$4.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v)
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass({
  sci_Map$Map3$$anon$4: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$4", {
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$4.prototype.$classData = $d_sci_Map$Map3$$anon$4;
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer)
}
$c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$6.prototype.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
  /*<skip>*/
}
$h_sci_Map$Map3$$anon$6.prototype = $c_sci_Map$Map3$$anon$6.prototype;
$c_sci_Map$Map3$$anon$6.prototype.nextResult__O__O__O = (function(k, v) {
  return v
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().initClass({
  sci_Map$Map3$$anon$6: 0
}, false, "scala.collection.immutable.Map$Map3$$anon$6", {
  sci_Map$Map3$$anon$6: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map3$$anon$6.prototype.$classData = $d_sci_Map$Map3$$anon$6;
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
$c_sci_Map$Map4$$anon$7.prototype.nextResult__O__O__O = (function(k, v) {
  return new $c_T2(k, v)
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass({
  sci_Map$Map4$$anon$7: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$7", {
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$7.prototype.$classData = $d_sci_Map$Map4$$anon$7;
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer)
}
$c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$9.prototype.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
  /*<skip>*/
}
$h_sci_Map$Map4$$anon$9.prototype = $c_sci_Map$Map4$$anon$9.prototype;
$c_sci_Map$Map4$$anon$9.prototype.nextResult__O__O__O = (function(k, v) {
  return v
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().initClass({
  sci_Map$Map4$$anon$9: 0
}, false, "scala.collection.immutable.Map$Map4$$anon$9", {
  sci_Map$Map4$$anon$9: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_Map$Map4$$anon$9.prototype.$classData = $d_sci_Map$Map4$$anon$9;
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.sci_RangeIterator__f_step = 0;
  this.sci_RangeIterator__f_lastElement = 0;
  this.sci_RangeIterator__f__hasNext = false;
  this.sci_RangeIterator__f__next = 0;
  this.sci_RangeIterator__f_step = step;
  this.sci_RangeIterator__f_lastElement = lastElement;
  this.sci_RangeIterator__f__hasNext = (!initiallyEmpty);
  this.sci_RangeIterator__f__next = start
}
$c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RangeIterator.prototype.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
  /*<skip>*/
}
$h_sci_RangeIterator.prototype = $c_sci_RangeIterator.prototype;
$c_sci_RangeIterator.prototype.knownSize__I = (function() {
  return (this.sci_RangeIterator__f__hasNext ? ((1 + $intDiv(((this.sci_RangeIterator__f_lastElement - this.sci_RangeIterator__f__next) | 0), this.sci_RangeIterator__f_step)) | 0) : 0)
});
$c_sci_RangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_RangeIterator__f__hasNext
});
$c_sci_RangeIterator.prototype.next__I = (function() {
  if ((!this.sci_RangeIterator__f__hasNext)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  };
  var value = this.sci_RangeIterator__f__next;
  this.sci_RangeIterator__f__hasNext = (value !== this.sci_RangeIterator__f_lastElement);
  this.sci_RangeIterator__f__next = ((value + this.sci_RangeIterator__f_step) | 0);
  return value
});
$c_sci_RangeIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var value = this.sci_RangeIterator__f__next;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.sci_RangeIterator__f_step, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo) < ((-2147483648) ^ value)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    if ((this.sci_RangeIterator__f_step > 0)) {
      var value$2 = this.sci_RangeIterator__f_lastElement;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? (((-2147483648) ^ value$2) < ((-2147483648) ^ lo)) : (hi$3 < hi$2))) {
        var this$6__lo = value$2;
        var this$6__hi = hi$3
      } else {
        var this$6__lo = lo;
        var this$6__hi = hi$2
      };
      this.sci_RangeIterator__f__next = this$6__lo;
      var value$3 = this.sci_RangeIterator__f_lastElement;
      var hi$4 = (value$3 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$4) ? (((-2147483648) ^ lo) <= ((-2147483648) ^ value$3)) : (hi$2 < hi$4))
    } else if ((this.sci_RangeIterator__f_step < 0)) {
      var value$4 = this.sci_RangeIterator__f_lastElement;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? (((-2147483648) ^ value$4) > ((-2147483648) ^ lo)) : (hi$5 > hi$2))) {
        var this$10__lo = value$4;
        var this$10__hi = hi$5
      } else {
        var this$10__lo = lo;
        var this$10__hi = hi$2
      };
      this.sci_RangeIterator__f__next = this$10__lo;
      var value$5 = this.sci_RangeIterator__f_lastElement;
      var hi$6 = (value$5 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$6) ? (((-2147483648) ^ lo) >= ((-2147483648) ^ value$5)) : (hi$2 > hi$6))
    }
  };
  return this
});
$c_sci_RangeIterator.prototype.next__O = (function() {
  return this.next__I()
});
var $d_sci_RangeIterator = new $TypeData().initClass({
  sci_RangeIterator: 0
}, false, "scala.collection.immutable.RangeIterator", {
  sci_RangeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_RangeIterator.prototype.$classData = $d_sci_RangeIterator;
/** @constructor */
function $c_sci_RedBlackTree$EqualsIterator(tree, evidence$19) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, $m_s_None$(), evidence$19)
}
$c_sci_RedBlackTree$EqualsIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$EqualsIterator.prototype.constructor = $c_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $h_sci_RedBlackTree$EqualsIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$EqualsIterator.prototype = $c_sci_RedBlackTree$EqualsIterator.prototype;
$c_sci_RedBlackTree$EqualsIterator.prototype.sameKeys__sci_RedBlackTree$EqualsIterator__Z = (function(that) {
  var equal = true;
  while (((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead !== null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead !== null))) {
    if ((this.sci_RedBlackTree$TreeIterator__f_lookahead === that.sci_RedBlackTree$TreeIterator__f_lookahead)) {
      if ((this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x1 = null
      } else {
        this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x1 = this.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get(this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      this.sci_RedBlackTree$TreeIterator__f_lookahead = $$x1;
      if ((that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index === 0)) {
        var $$x2 = null
      } else {
        that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = (((-1) + that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index) | 0);
        var $$x2 = that.sci_RedBlackTree$TreeIterator__f_stackOfNexts.get(that.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index)
      };
      that.sci_RedBlackTree$TreeIterator__f_lookahead = $$x2
    } else {
      var this$1 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      var $$x3 = this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
      var this$2 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      if (Object.is($$x3, this$2.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)) {
        equal = true
      } else {
        var $$x5 = this.sci_RedBlackTree$TreeIterator__f_ordering;
        var this$3 = this.sci_RedBlackTree$TreeIterator__f_lookahead;
        var $$x4 = this$3.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key;
        var this$4 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
        equal = $$x5.equiv__O__O__Z($$x4, this$4.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key)
      };
      var tree = this.sci_RedBlackTree$TreeIterator__f_lookahead;
      this.sci_RedBlackTree$TreeIterator__f_lookahead = this.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right);
      var tree$1 = that.sci_RedBlackTree$TreeIterator__f_lookahead;
      that.sci_RedBlackTree$TreeIterator__f_lookahead = that.findLeftMostOrPopOnEmpty__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(tree$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_right)
    }
  };
  return ((equal && (this.sci_RedBlackTree$TreeIterator__f_lookahead === null)) && (that.sci_RedBlackTree$TreeIterator__f_lookahead === null))
});
$c_sci_RedBlackTree$EqualsIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  $m_s_Predef$().$qmark$qmark$qmark__E()
});
var $d_sci_RedBlackTree$EqualsIterator = new $TypeData().initClass({
  sci_RedBlackTree$EqualsIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$EqualsIterator", {
  sci_RedBlackTree$EqualsIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$EqualsIterator.prototype.$classData = $d_sci_RedBlackTree$EqualsIterator;
/** @constructor */
function $c_sci_RedBlackTree$KeysIterator(tree, focus, evidence$21) {
  this.sci_RedBlackTree$TreeIterator__f_root = null;
  this.sci_RedBlackTree$TreeIterator__f_ordering = null;
  this.sci_RedBlackTree$TreeIterator__f_stackOfNexts = null;
  this.sci_RedBlackTree$TreeIterator__f_scala$collection$immutable$RedBlackTree$TreeIterator$$index = 0;
  this.sci_RedBlackTree$TreeIterator__f_lookahead = null;
  $ct_sci_RedBlackTree$TreeIterator__sci_RedBlackTree$Tree__s_Option__s_math_Ordering__(this, tree, focus, evidence$21)
}
$c_sci_RedBlackTree$KeysIterator.prototype = new $h_sci_RedBlackTree$TreeIterator();
$c_sci_RedBlackTree$KeysIterator.prototype.constructor = $c_sci_RedBlackTree$KeysIterator;
/** @constructor */
function $h_sci_RedBlackTree$KeysIterator() {
  /*<skip>*/
}
$h_sci_RedBlackTree$KeysIterator.prototype = $c_sci_RedBlackTree$KeysIterator.prototype;
$c_sci_RedBlackTree$KeysIterator.prototype.nextResult__sci_RedBlackTree$Tree__O = (function(tree) {
  return tree.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
var $d_sci_RedBlackTree$KeysIterator = new $TypeData().initClass({
  sci_RedBlackTree$KeysIterator: 0
}, false, "scala.collection.immutable.RedBlackTree$KeysIterator", {
  sci_RedBlackTree$KeysIterator: 1,
  sci_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_sci_RedBlackTree$KeysIterator.prototype.$classData = $d_sci_RedBlackTree$KeysIterator;
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz
}
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0
}
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
  /*<skip>*/
}
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0)
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = (((-1) + this.sci_Set$SetNIterator__f_remainder) | 0);
    return r
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b)
  };
  return this
});
function $is_sci_SetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SetOps)))
}
function $as_sci_SetOps(obj) {
  return (($is_sci_SetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SetOps"))
}
function $isArrayOf_sci_SetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SetOps)))
}
function $asArrayOf_sci_SetOps(obj, depth) {
  return (($isArrayOf_sci_SetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SetOps;", depth))
}
/** @constructor */
function $c_sci_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_sci_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate)
}
$c_sci_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_sci_SortedSet$.prototype.constructor = $c_sci_SortedSet$;
/** @constructor */
function $h_sci_SortedSet$() {
  /*<skip>*/
}
$h_sci_SortedSet$.prototype = $c_sci_SortedSet$.prototype;
var $d_sci_SortedSet$ = new $TypeData().initClass({
  sci_SortedSet$: 0
}, false, "scala.collection.immutable.SortedSet$", {
  sci_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  O: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
});
$c_sci_SortedSet$.prototype.$classData = $d_sci_SortedSet$;
var $n_sci_SortedSet$;
function $m_sci_SortedSet$() {
  if ((!$n_sci_SortedSet$)) {
    $n_sci_SortedSet$ = new $c_sci_SortedSet$()
  };
  return $n_sci_SortedSet$
}
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  $thiz.scm_ArrayBuilder__f_size = 0;
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0
}
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
  /*<skip>*/
}
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0))
}
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
  /*<skip>*/
}
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq = (function(it, evidence$2) {
  return this.make__O__scm_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, evidence$2))
});
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$4 = new $c_scm_ArrayBuilder$generic(evidence$3.runtimeClass__jl_Class());
  var f = new $c_sjsr_AnonFunction1(((x$2) => $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2)));
  return new $c_scm_Builder$$anon$1(this$4, f)
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null
  } else if ((x instanceof $ac_O)) {
    var x3 = $asArrayOf_O(x, 1);
    return new $c_scm_ArraySeq$ofRef(x3)
  } else if ((x instanceof $ac_I)) {
    var x4 = $asArrayOf_I(x, 1);
    return new $c_scm_ArraySeq$ofInt(x4)
  } else if ((x instanceof $ac_D)) {
    var x5 = $asArrayOf_D(x, 1);
    return new $c_scm_ArraySeq$ofDouble(x5)
  } else if ((x instanceof $ac_J)) {
    var x6 = $asArrayOf_J(x, 1);
    return new $c_scm_ArraySeq$ofLong(x6)
  } else if ((x instanceof $ac_F)) {
    var x7 = $asArrayOf_F(x, 1);
    return new $c_scm_ArraySeq$ofFloat(x7)
  } else if ((x instanceof $ac_C)) {
    var x8 = $asArrayOf_C(x, 1);
    return new $c_scm_ArraySeq$ofChar(x8)
  } else if ((x instanceof $ac_B)) {
    var x9 = $asArrayOf_B(x, 1);
    return new $c_scm_ArraySeq$ofByte(x9)
  } else if ((x instanceof $ac_S)) {
    var x10 = $asArrayOf_S(x, 1);
    return new $c_scm_ArraySeq$ofShort(x10)
  } else if ((x instanceof $ac_Z)) {
    var x11 = $asArrayOf_Z(x, 1);
    return new $c_scm_ArraySeq$ofBoolean(x11)
  } else if ($isArrayOf_jl_Void(x, 1)) {
    var x12 = $asArrayOf_jl_Void(x, 1);
    return new $c_scm_ArraySeq$ofUnit(x12)
  } else {
    throw new $c_s_MatchError(x)
  }
});
$c_scm_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder($as_s_reflect_ClassTag(evidence$12))
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(it, $as_s_reflect_ClassTag(evidence$5))
});
$c_scm_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  $as_s_reflect_ClassTag(evidence$6);
  return this.scm_ArraySeq$__f_EmptyArraySeq
});
var $d_scm_ArraySeq$ = new $TypeData().initClass({
  scm_ArraySeq$: 0
}, false, "scala.collection.mutable.ArraySeq$", {
  scm_ArraySeq$: 1,
  O: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$.prototype.$classData = $d_scm_ArraySeq$;
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$()
  };
  return $n_scm_ArraySeq$
}
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return new $c_T2(nd.scm_HashMap$Node__f__key, nd.scm_HashMap$Node__f__value)
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass({
  scm_HashMap$$anon$1: 0
}, false, "scala.collection.mutable.HashMap$$anon$1", {
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$1.prototype.$classData = $d_scm_HashMap$$anon$1;
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$3.prototype.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$3.prototype = $c_scm_HashMap$$anon$3.prototype;
$c_scm_HashMap$$anon$3.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd.scm_HashMap$Node__f__value
});
var $d_scm_HashMap$$anon$3 = new $TypeData().initClass({
  scm_HashMap$$anon$3: 0
}, false, "scala.collection.mutable.HashMap$$anon$3", {
  scm_HashMap$$anon$3: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$3.prototype.$classData = $d_scm_HashMap$$anon$3;
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer)
}
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass({
  scm_HashMap$$anon$4: 0
}, false, "scala.collection.mutable.HashMap$$anon$4", {
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$4.prototype.$classData = $d_scm_HashMap$$anon$4;
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_HashMap$$anon$5__f_$outer = outer
  };
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0
}
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
  /*<skip>*/
}
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $$x1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.scm_HashMap$Node__f__hash;
  var x = nd.scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $$x1.tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass({
  scm_HashMap$$anon$5: 0
}, false, "scala.collection.mutable.HashMap$$anon$5", {
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashMap$$anon$5.prototype.$classData = $d_scm_HashMap$$anon$5;
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer)
}
$c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$1.prototype.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$1.prototype = $c_scm_HashSet$$anon$1.prototype;
$c_scm_HashSet$$anon$1.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd.scm_HashSet$Node__f__key
});
var $d_scm_HashSet$$anon$1 = new $TypeData().initClass({
  scm_HashSet$$anon$1: 0
}, false, "scala.collection.mutable.HashSet$$anon$1", {
  scm_HashSet$$anon$1: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$1.prototype.$classData = $d_scm_HashSet$$anon$1;
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer)
}
$c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$2.prototype.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$2.prototype = $c_scm_HashSet$$anon$2.prototype;
$c_scm_HashSet$$anon$2.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd
});
var $d_scm_HashSet$$anon$2 = new $TypeData().initClass({
  scm_HashSet$$anon$2: 0
}, false, "scala.collection.mutable.HashSet$$anon$2", {
  scm_HashSet$$anon$2: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$2.prototype.$classData = $d_scm_HashSet$$anon$2;
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  this.scm_HashSet$$anon$3__f_hash = 0;
  this.scm_HashSet$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.scm_HashSet$$anon$3__f_$outer = outer
  };
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.scm_HashSet$$anon$3__f_hash = 0
}
$c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$3.prototype.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
  /*<skip>*/
}
$h_scm_HashSet$$anon$3.prototype = $c_scm_HashSet$$anon$3.prototype;
$c_scm_HashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_HashSet$$anon$3__f_hash
});
$c_scm_HashSet$$anon$3.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  var this$1 = this.scm_HashSet$$anon$3__f_$outer;
  var improvedHash = nd.scm_HashSet$Node__f__hash;
  this.scm_HashSet$$anon$3__f_hash = this$1.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
  return this
});
var $d_scm_HashSet$$anon$3 = new $TypeData().initClass({
  scm_HashSet$$anon$3: 0
}, false, "scala.collection.mutable.HashSet$$anon$3", {
  scm_HashSet$$anon$3: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_HashSet$$anon$3.prototype.$classData = $d_scm_HashSet$$anon$3;
/** @constructor */
function $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$7) {
  this.scm_RedBlackTree$TreeIterator__f_end = null;
  this.scm_RedBlackTree$TreeIterator__f_ord = null;
  this.scm_RedBlackTree$TreeIterator__f_nextNode = null;
  $ct_scm_RedBlackTree$TreeIterator__scm_RedBlackTree$Tree__s_Option__s_Option__s_math_Ordering__(this, tree, start, end, evidence$7)
}
$c_scm_RedBlackTree$KeysIterator.prototype = new $h_scm_RedBlackTree$TreeIterator();
$c_scm_RedBlackTree$KeysIterator.prototype.constructor = $c_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $h_scm_RedBlackTree$KeysIterator() {
  /*<skip>*/
}
$h_scm_RedBlackTree$KeysIterator.prototype = $c_scm_RedBlackTree$KeysIterator.prototype;
var $d_scm_RedBlackTree$KeysIterator = new $TypeData().initClass({
  scm_RedBlackTree$KeysIterator: 0
}, false, "scala.collection.mutable.RedBlackTree$KeysIterator", {
  scm_RedBlackTree$KeysIterator: 1,
  scm_RedBlackTree$TreeIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
});
$c_scm_RedBlackTree$KeysIterator.prototype.$classData = $d_scm_RedBlackTree$KeysIterator;
/** @constructor */
function $c_scm_SortedSet$() {
  this.sc_EvidenceIterableFactory$Delegate__f_delegate = null;
  var delegate = $m_scm_TreeSet$();
  $ct_sc_EvidenceIterableFactory$Delegate__sc_EvidenceIterableFactory__(this, delegate)
}
$c_scm_SortedSet$.prototype = new $h_sc_SortedIterableFactory$Delegate();
$c_scm_SortedSet$.prototype.constructor = $c_scm_SortedSet$;
/** @constructor */
function $h_scm_SortedSet$() {
  /*<skip>*/
}
$h_scm_SortedSet$.prototype = $c_scm_SortedSet$.prototype;
var $d_scm_SortedSet$ = new $TypeData().initClass({
  scm_SortedSet$: 0
}, false, "scala.collection.mutable.SortedSet$", {
  scm_SortedSet$: 1,
  sc_SortedIterableFactory$Delegate: 1,
  sc_EvidenceIterableFactory$Delegate: 1,
  O: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SortedIterableFactory: 1
});
$c_scm_SortedSet$.prototype.$classData = $d_scm_SortedSet$;
var $n_scm_SortedSet$;
function $m_scm_SortedSet$() {
  if ((!$n_scm_SortedSet$)) {
    $n_scm_SortedSet$ = new $c_scm_SortedSet$()
  };
  return $n_scm_SortedSet$
}
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined"
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return this
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1)
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$1: 0
}, false, "scala.concurrent.duration.Duration$$anon$1", {
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf"
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1))
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$2: 0
}, false, "scala.concurrent.duration.Duration$$anon$2", {
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
  /*<skip>*/
}
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf"
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1))
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I($as_s_concurrent_duration_Duration(that))
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass({
  s_concurrent_duration_Duration$$anon$3: 0
}, false, "scala.concurrent.duration.Duration$$anon$3", {
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.$classData = $d_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.s_math_Ordering$$anon$1__f_$outer = null;
  this.s_math_Ordering$$anon$1__f_f$1 = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.s_math_Ordering$$anon$1__f_$outer = outer
  };
  this.s_math_Ordering$$anon$1__f_f$1 = f$1
}
$c_s_math_Ordering$$anon$1.prototype = new $h_O();
$c_s_math_Ordering$$anon$1.prototype.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
  /*<skip>*/
}
$h_s_math_Ordering$$anon$1.prototype = $c_s_math_Ordering$$anon$1.prototype;
$c_s_math_Ordering$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$$anon$1__f_$outer.compare__O__O__I(this.s_math_Ordering$$anon$1__f_f$1.apply__O__O(x), this.s_math_Ordering$$anon$1__f_f$1.apply__O__O(y))
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().initClass({
  s_math_Ordering$$anon$1: 0
}, false, "scala.math.Ordering$$anon$1", {
  s_math_Ordering$$anon$1: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$$anon$1.prototype.$classData = $d_s_math_Ordering$$anon$1;
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)
}
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.s_math_Ordering$Reverse__f_outer = null;
  this.s_math_Ordering$Reverse__f_outer = outer
}
$c_s_math_Ordering$Reverse.prototype = new $h_O();
$c_s_math_Ordering$Reverse.prototype.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
  /*<skip>*/
}
$h_s_math_Ordering$Reverse.prototype = $c_s_math_Ordering$Reverse.prototype;
$c_s_math_Ordering$Reverse.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  var x$2 = this.s_math_Ordering$Reverse__f_outer;
  return ((other === null) ? (x$2 === null) : other.equals__O__Z(x$2))
});
$c_s_math_Ordering$Reverse.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.compare__O__O__I(y, x)
});
$c_s_math_Ordering$Reverse.prototype.lteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.lteq__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.gteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.gteq__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.equiv__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.equiv__O__O__Z(y, x)
});
$c_s_math_Ordering$Reverse.prototype.max__O__O__O = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.min__O__O__O(x, y)
});
$c_s_math_Ordering$Reverse.prototype.min__O__O__O = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.max__O__O__O(x, y)
});
$c_s_math_Ordering$Reverse.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x3 = $as_s_math_Ordering$Reverse(obj);
    var x = this.s_math_Ordering$Reverse__f_outer;
    var x$2 = x3.s_math_Ordering$Reverse__f_outer;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  };
  return false
});
$c_s_math_Ordering$Reverse.prototype.hashCode__I = (function() {
  return Math.imul(41, this.s_math_Ordering$Reverse__f_outer.hashCode__I())
});
function $as_s_math_Ordering$Reverse(obj) {
  return (((obj instanceof $c_s_math_Ordering$Reverse) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Reverse"))
}
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Reverse)))
}
function $asArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Reverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Reverse;", depth))
}
var $d_s_math_Ordering$Reverse = new $TypeData().initClass({
  s_math_Ordering$Reverse: 0
}, false, "scala.math.Ordering$Reverse", {
  s_math_Ordering$Reverse: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Reverse.prototype.$classData = $d_s_math_Ordering$Reverse;
/** @constructor */
function $c_s_math_Ordering$Tuple2Ordering(ord1, ord2) {
  this.s_math_Ordering$Tuple2Ordering__f_ord1 = null;
  this.s_math_Ordering$Tuple2Ordering__f_ord2 = null;
  this.s_math_Ordering$Tuple2Ordering__f_ord1 = ord1;
  this.s_math_Ordering$Tuple2Ordering__f_ord2 = ord2
}
$c_s_math_Ordering$Tuple2Ordering.prototype = new $h_O();
$c_s_math_Ordering$Tuple2Ordering.prototype.constructor = $c_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $h_s_math_Ordering$Tuple2Ordering() {
  /*<skip>*/
}
$h_s_math_Ordering$Tuple2Ordering.prototype = $c_s_math_Ordering$Tuple2Ordering.prototype;
$c_s_math_Ordering$Tuple2Ordering.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.compare__T2__T2__I = (function(x, y) {
  var compare1 = this.s_math_Ordering$Tuple2Ordering__f_ord1.compare__O__O__I(x._1__O(), y._1__O());
  if ((compare1 !== 0)) {
    return compare1
  };
  return this.s_math_Ordering$Tuple2Ordering__f_ord2.compare__O__O__I(x._2__O(), y._2__O())
});
$c_s_math_Ordering$Tuple2Ordering.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true
    }
  };
  if ((obj instanceof $c_s_math_Ordering$Tuple2Ordering)) {
    var x3 = $as_s_math_Ordering$Tuple2Ordering(obj);
    var x = this.s_math_Ordering$Tuple2Ordering__f_ord1;
    var x$2 = x3.s_math_Ordering$Tuple2Ordering__f_ord1;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.s_math_Ordering$Tuple2Ordering__f_ord2;
      var x$4 = x3.s_math_Ordering$Tuple2Ordering__f_ord2;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  };
  return false
});
$c_s_math_Ordering$Tuple2Ordering.prototype.hashCode__I = (function() {
  var _1 = this.s_math_Ordering$Tuple2Ordering__f_ord1;
  var _2 = this.s_math_Ordering$Tuple2Ordering__f_ord2;
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  var h = (-889275714);
  h = this$2.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  var i = 0;
  while ((i < 2)) {
    var $$x1 = h;
    var n = i;
    switch (n) {
      case 0: {
        var x = _1;
        break
      }
      case 1: {
        var x = _2;
        break
      }
      default: {
        var x;
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"))
      }
    };
    h = this$2.mix__I__I__I($$x1, $m_sr_Statics$().anyHash__O__I(x));
    i = ((1 + i) | 0)
  };
  return this$2.finalizeHash__I__I__I(h, 2)
});
$c_s_math_Ordering$Tuple2Ordering.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T2__T2__I($as_T2(x), $as_T2(y))
});
function $as_s_math_Ordering$Tuple2Ordering(obj) {
  return (((obj instanceof $c_s_math_Ordering$Tuple2Ordering) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.Ordering$Tuple2Ordering"))
}
function $isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Tuple2Ordering)))
}
function $asArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) {
  return (($isArrayOf_s_math_Ordering$Tuple2Ordering(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.Ordering$Tuple2Ordering;", depth))
}
var $d_s_math_Ordering$Tuple2Ordering = new $TypeData().initClass({
  s_math_Ordering$Tuple2Ordering: 0
}, false, "scala.math.Ordering$Tuple2Ordering", {
  s_math_Ordering$Tuple2Ordering: 1,
  O: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Tuple2Ordering.prototype.$classData = $d_s_math_Ordering$Tuple2Ordering;
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass
}
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
  /*<skip>*/
}
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $p_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this, this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass)
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_jl_reflect_Array$().newInstance__jl_Class__I__O(componentType, len)
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass({
  s_reflect_ClassTag$GenericClassTag: 0
}, false, "scala.reflect.ClassTag$GenericClassTag", {
  s_reflect_ClassTag$GenericClassTag: 1,
  O: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.$classData = $d_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $c_Ltyrian_Tag(name, attributes, children) {
  this.Ltyrian_Tag__f_name = null;
  this.Ltyrian_Tag__f_attributes = null;
  this.Ltyrian_Tag__f_children = null;
  this.Ltyrian_Tag__f_name = name;
  this.Ltyrian_Tag__f_attributes = attributes;
  this.Ltyrian_Tag__f_children = children
}
$c_Ltyrian_Tag.prototype = new $h_O();
$c_Ltyrian_Tag.prototype.constructor = $c_Ltyrian_Tag;
/** @constructor */
function $h_Ltyrian_Tag() {
  /*<skip>*/
}
$h_Ltyrian_Tag.prototype = $c_Ltyrian_Tag.prototype;
$c_Ltyrian_Tag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Tag.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Ltyrian_Tag.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Ltyrian_Tag)) {
    var x$0$2 = $as_Ltyrian_Tag(x$0);
    if ((this.Ltyrian_Tag__f_name === x$0$2.Ltyrian_Tag__f_name)) {
      var x = this.Ltyrian_Tag__f_attributes;
      var x$2 = x$0$2.Ltyrian_Tag__f_attributes;
      var $$x1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$3 = this.Ltyrian_Tag__f_children;
      var x$4 = x$0$2.Ltyrian_Tag__f_children;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Ltyrian_Tag.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Ltyrian_Tag.prototype.productArity__I = (function() {
  return 3
});
$c_Ltyrian_Tag.prototype.productPrefix__T = (function() {
  return "Tag"
});
$c_Ltyrian_Tag.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Ltyrian_Tag__f_name;
      break
    }
    case 1: {
      return this.Ltyrian_Tag__f_attributes;
      break
    }
    case 2: {
      return this.Ltyrian_Tag__f_children;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Ltyrian_Tag(obj) {
  return (((obj instanceof $c_Ltyrian_Tag) || (obj === null)) ? obj : $throwClassCastException(obj, "tyrian.Tag"))
}
function $isArrayOf_Ltyrian_Tag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ltyrian_Tag)))
}
function $asArrayOf_Ltyrian_Tag(obj, depth) {
  return (($isArrayOf_Ltyrian_Tag(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Ltyrian.Tag;", depth))
}
var $d_Ltyrian_Tag = new $TypeData().initClass({
  Ltyrian_Tag: 0
}, false, "tyrian.Tag", {
  Ltyrian_Tag: 1,
  O: 1,
  Ltyrian_Elem: 1,
  Ltyrian_Html: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Ltyrian_Tag.prototype.$classData = $d_Ltyrian_Tag;
function $f_Lcats_Apply__productR__O__O__O($thiz, fa, fb) {
  return $thiz.ap__O__O__O($thiz.as__O__O__O(fa, new $c_sjsr_AnonFunction1(((b) => b))), fb)
}
function $f_Lcats_Apply__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2(((a, _$2) => a)))
}
function $ct_Lcats_data_KleisliInstances3__($thiz) {
  $m_Lcats_Invariant$();
  var M = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  $thiz.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = new $c_Lcats_data_KleisliInstances3$$anon$3(M);
  return $thiz
}
/** @constructor */
function $c_Lcats_data_KleisliInstances3() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null
}
$c_Lcats_data_KleisliInstances3.prototype = new $h_Lcats_data_KleisliInstances4();
$c_Lcats_data_KleisliInstances3.prototype.constructor = $c_Lcats_data_KleisliInstances3;
/** @constructor */
function $h_Lcats_data_KleisliInstances3() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances3.prototype = $c_Lcats_data_KleisliInstances3.prototype;
/** @constructor */
function $c_Lcats_instances_package$option$() {
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = null;
  this.Lcats_instances_package$option$__f_catsStdTraverseFilterForOption = null;
  $n_Lcats_instances_package$option$ = this;
  this.Lcats_instances_package$option$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  this.Lcats_instances_package$option$__f_catsStdTraverseFilterForOption = new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1()
}
$c_Lcats_instances_package$option$.prototype = new $h_O();
$c_Lcats_instances_package$option$.prototype.constructor = $c_Lcats_instances_package$option$;
/** @constructor */
function $h_Lcats_instances_package$option$() {
  /*<skip>*/
}
$h_Lcats_instances_package$option$.prototype = $c_Lcats_instances_package$option$.prototype;
var $d_Lcats_instances_package$option$ = new $TypeData().initClass({
  Lcats_instances_package$option$: 0
}, false, "cats.instances.package$option$", {
  Lcats_instances_package$option$: 1,
  O: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1
});
$c_Lcats_instances_package$option$.prototype.$classData = $d_Lcats_instances_package$option$;
var $n_Lcats_instances_package$option$;
function $m_Lcats_instances_package$option$() {
  if ((!$n_Lcats_instances_package$option$)) {
    $n_Lcats_instances_package$option$ = new $c_Lcats_instances_package$option$()
  };
  return $n_Lcats_instances_package$option$
}
/** @constructor */
function $c_Lfs2_Chunk$ArraySlice(values, offset, length, ct) {
  this.Lfs2_Chunk$ArraySlice__f_values = null;
  this.Lfs2_Chunk$ArraySlice__f_offset = 0;
  this.Lfs2_Chunk$ArraySlice__f_length = 0;
  this.Lfs2_Chunk$ArraySlice__f_ct = null;
  this.Lfs2_Chunk$ArraySlice__f_values = values;
  this.Lfs2_Chunk$ArraySlice__f_offset = offset;
  this.Lfs2_Chunk$ArraySlice__f_length = length;
  this.Lfs2_Chunk$ArraySlice__f_ct = ct;
  $m_s_Predef$().require__Z__V((((((offset >= 0) && (offset <= $m_sr_ScalaRunTime$().array_length__O__I(values))) && (length >= 0)) && (length <= $m_sr_ScalaRunTime$().array_length__O__I(values))) && (((offset + length) | 0) <= $m_sr_ScalaRunTime$().array_length__O__I(values))))
}
$c_Lfs2_Chunk$ArraySlice.prototype = new $h_Lfs2_Chunk();
$c_Lfs2_Chunk$ArraySlice.prototype.constructor = $c_Lfs2_Chunk$ArraySlice;
/** @constructor */
function $h_Lfs2_Chunk$ArraySlice() {
  /*<skip>*/
}
$h_Lfs2_Chunk$ArraySlice.prototype = $c_Lfs2_Chunk$ArraySlice.prototype;
$c_Lfs2_Chunk$ArraySlice.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Chunk$ArraySlice.prototype.productArity__I = (function() {
  return 3
});
$c_Lfs2_Chunk$ArraySlice.prototype.productPrefix__T = (function() {
  return "ArraySlice"
});
$c_Lfs2_Chunk$ArraySlice.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_Chunk$ArraySlice__f_values;
      break
    }
    case 1: {
      return this.Lfs2_Chunk$ArraySlice__f_offset;
      break
    }
    case 2: {
      return this.Lfs2_Chunk$ArraySlice__f_length;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
$c_Lfs2_Chunk$ArraySlice.prototype.size__I = (function() {
  return this.Lfs2_Chunk$ArraySlice__f_length
});
$c_Lfs2_Chunk$ArraySlice.prototype.apply__I__O = (function(i) {
  if (((i < 0) || (i >= this.Lfs2_Chunk$ArraySlice__f_length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException())
  } else {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lfs2_Chunk$ArraySlice__f_values, ((this.Lfs2_Chunk$ArraySlice__f_offset + i) | 0))
  }
});
var $d_Lfs2_Chunk$ArraySlice = new $TypeData().initClass({
  Lfs2_Chunk$ArraySlice: 0
}, false, "fs2.Chunk$ArraySlice", {
  Lfs2_Chunk$ArraySlice: 1,
  Lfs2_Chunk: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lfs2_ChunkPlatform: 1,
  Lfs2_ChunkRuntimePlatform: 1,
  s_Equals: 1,
  s_Product: 1
});
$c_Lfs2_Chunk$ArraySlice.prototype.$classData = $d_Lfs2_Chunk$ArraySlice;
/** @constructor */
function $c_Lfs2_Pull$Fail(error) {
  this.Lfs2_Pull$Fail__f_error = null;
  this.Lfs2_Pull$Fail__f_error = error
}
$c_Lfs2_Pull$Fail.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Fail.prototype.constructor = $c_Lfs2_Pull$Fail;
/** @constructor */
function $h_Lfs2_Pull$Fail() {
  /*<skip>*/
}
$h_Lfs2_Pull$Fail.prototype = $c_Lfs2_Pull$Fail.prototype;
$c_Lfs2_Pull$Fail.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Fail.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$Fail.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Fail)) {
    var x$0$2 = $as_Lfs2_Pull$Fail(x$0);
    var x = this.Lfs2_Pull$Fail__f_error;
    var x$2 = x$0$2.Lfs2_Pull$Fail__f_error;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lfs2_Pull$Fail.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Fail.prototype.productArity__I = (function() {
  return 1
});
$c_Lfs2_Pull$Fail.prototype.productPrefix__T = (function() {
  return "Fail"
});
$c_Lfs2_Pull$Fail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Fail__f_error
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$Fail(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Fail) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Fail"))
}
function $isArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Fail)))
}
function $asArrayOf_Lfs2_Pull$Fail(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Fail(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Fail;", depth))
}
var $d_Lfs2_Pull$Fail = new $TypeData().initClass({
  Lfs2_Pull$Fail: 0
}, false, "fs2.Pull$Fail", {
  Lfs2_Pull$Fail: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Fail.prototype.$classData = $d_Lfs2_Pull$Fail;
/** @constructor */
function $c_Lfs2_Pull$FlatMapOutput(stream, fun) {
  this.Lfs2_Pull$FlatMapOutput__f_stream = null;
  this.Lfs2_Pull$FlatMapOutput__f_fun = null;
  this.Lfs2_Pull$FlatMapOutput__f_stream = stream;
  this.Lfs2_Pull$FlatMapOutput__f_fun = fun
}
$c_Lfs2_Pull$FlatMapOutput.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$FlatMapOutput.prototype.constructor = $c_Lfs2_Pull$FlatMapOutput;
/** @constructor */
function $h_Lfs2_Pull$FlatMapOutput() {
  /*<skip>*/
}
$h_Lfs2_Pull$FlatMapOutput.prototype = $c_Lfs2_Pull$FlatMapOutput.prototype;
$c_Lfs2_Pull$FlatMapOutput.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$FlatMapOutput.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$FlatMapOutput.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$FlatMapOutput)) {
    var x$0$2 = $as_Lfs2_Pull$FlatMapOutput(x$0);
    var x = this.Lfs2_Pull$FlatMapOutput__f_stream;
    var x$2 = x$0$2.Lfs2_Pull$FlatMapOutput__f_stream;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$FlatMapOutput__f_fun;
      var x$4 = x$0$2.Lfs2_Pull$FlatMapOutput__f_fun;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$FlatMapOutput.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productPrefix__T = (function() {
  return "FlatMapOutput"
});
$c_Lfs2_Pull$FlatMapOutput.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FlatMapOutput__f_stream
  };
  if ((n === 1)) {
    return this.Lfs2_Pull$FlatMapOutput__f_fun
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$FlatMapOutput(obj) {
  return (((obj instanceof $c_Lfs2_Pull$FlatMapOutput) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$FlatMapOutput"))
}
function $isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FlatMapOutput)))
}
function $asArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$FlatMapOutput(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$FlatMapOutput;", depth))
}
var $d_Lfs2_Pull$FlatMapOutput = new $TypeData().initClass({
  Lfs2_Pull$FlatMapOutput: 0
}, false, "fs2.Pull$FlatMapOutput", {
  Lfs2_Pull$FlatMapOutput: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$FlatMapOutput.prototype.$classData = $d_Lfs2_Pull$FlatMapOutput;
/** @constructor */
function $c_Lfs2_Pull$InScope(stream, useInterruption) {
  this.Lfs2_Pull$InScope__f_stream = null;
  this.Lfs2_Pull$InScope__f_useInterruption = false;
  this.Lfs2_Pull$InScope__f_stream = stream;
  this.Lfs2_Pull$InScope__f_useInterruption = useInterruption
}
$c_Lfs2_Pull$InScope.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$InScope.prototype.constructor = $c_Lfs2_Pull$InScope;
/** @constructor */
function $h_Lfs2_Pull$InScope() {
  /*<skip>*/
}
$h_Lfs2_Pull$InScope.prototype = $c_Lfs2_Pull$InScope.prototype;
$c_Lfs2_Pull$InScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$InScope.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("InScope");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfs2_Pull$InScope__f_stream;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lfs2_Pull$InScope__f_useInterruption ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2)
});
$c_Lfs2_Pull$InScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$InScope)) {
    var x$0$2 = $as_Lfs2_Pull$InScope(x$0);
    if ((this.Lfs2_Pull$InScope__f_useInterruption === x$0$2.Lfs2_Pull$InScope__f_useInterruption)) {
      var x = this.Lfs2_Pull$InScope__f_stream;
      var x$2 = x$0$2.Lfs2_Pull$InScope__f_stream;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$InScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$InScope.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_Pull$InScope.prototype.productPrefix__T = (function() {
  return "InScope"
});
$c_Lfs2_Pull$InScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$InScope__f_stream
  };
  if ((n === 1)) {
    return this.Lfs2_Pull$InScope__f_useInterruption
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$InScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$InScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$InScope"))
}
function $isArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InScope)))
}
function $asArrayOf_Lfs2_Pull$InScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$InScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$InScope;", depth))
}
var $d_Lfs2_Pull$InScope = new $TypeData().initClass({
  Lfs2_Pull$InScope: 0
}, false, "fs2.Pull$InScope", {
  Lfs2_Pull$InScope: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$InScope.prototype.$classData = $d_Lfs2_Pull$InScope;
/** @constructor */
function $c_Lfs2_Pull$Interrupted(context, deferredError) {
  this.Lfs2_Pull$Interrupted__f_context = null;
  this.Lfs2_Pull$Interrupted__f_deferredError = null;
  this.Lfs2_Pull$Interrupted__f_context = context;
  this.Lfs2_Pull$Interrupted__f_deferredError = deferredError
}
$c_Lfs2_Pull$Interrupted.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Interrupted.prototype.constructor = $c_Lfs2_Pull$Interrupted;
/** @constructor */
function $h_Lfs2_Pull$Interrupted() {
  /*<skip>*/
}
$h_Lfs2_Pull$Interrupted.prototype = $c_Lfs2_Pull$Interrupted.prototype;
$c_Lfs2_Pull$Interrupted.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Interrupted.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$Interrupted.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Interrupted)) {
    var x$0$2 = $as_Lfs2_Pull$Interrupted(x$0);
    var x = this.Lfs2_Pull$Interrupted__f_context;
    var x$2 = x$0$2.Lfs2_Pull$Interrupted__f_context;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_Pull$Interrupted__f_deferredError;
      var x$4 = x$0$2.Lfs2_Pull$Interrupted__f_deferredError;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$Interrupted.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Interrupted.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_Pull$Interrupted.prototype.productPrefix__T = (function() {
  return "Interrupted"
});
$c_Lfs2_Pull$Interrupted.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Interrupted__f_context
  };
  if ((n === 1)) {
    return this.Lfs2_Pull$Interrupted__f_deferredError
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$Interrupted(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Interrupted) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Interrupted"))
}
function $isArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Interrupted)))
}
function $asArrayOf_Lfs2_Pull$Interrupted(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Interrupted(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Interrupted;", depth))
}
var $d_Lfs2_Pull$Interrupted = new $TypeData().initClass({
  Lfs2_Pull$Interrupted: 0
}, false, "fs2.Pull$Interrupted", {
  Lfs2_Pull$Interrupted: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Interrupted.prototype.$classData = $d_Lfs2_Pull$Interrupted;
/** @constructor */
function $c_Lfs2_Pull$Output(values) {
  this.Lfs2_Pull$Output__f_values = null;
  this.Lfs2_Pull$Output__f_values = values
}
$c_Lfs2_Pull$Output.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Output.prototype.constructor = $c_Lfs2_Pull$Output;
/** @constructor */
function $h_Lfs2_Pull$Output() {
  /*<skip>*/
}
$h_Lfs2_Pull$Output.prototype = $c_Lfs2_Pull$Output.prototype;
$c_Lfs2_Pull$Output.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Output.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$Output.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Output)) {
    var x$0$2 = $as_Lfs2_Pull$Output(x$0);
    var x = this.Lfs2_Pull$Output__f_values;
    var x$2 = x$0$2.Lfs2_Pull$Output__f_values;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
  } else {
    return false
  }
});
$c_Lfs2_Pull$Output.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Output.prototype.productArity__I = (function() {
  return 1
});
$c_Lfs2_Pull$Output.prototype.productPrefix__T = (function() {
  return "Output"
});
$c_Lfs2_Pull$Output.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Output__f_values
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$Output(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Output) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Output"))
}
function $isArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Output)))
}
function $asArrayOf_Lfs2_Pull$Output(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Output(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Output;", depth))
}
var $d_Lfs2_Pull$Output = new $TypeData().initClass({
  Lfs2_Pull$Output: 0
}, false, "fs2.Pull$Output", {
  Lfs2_Pull$Output: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Output.prototype.$classData = $d_Lfs2_Pull$Output;
function $as_Lfs2_Pull$StepLeg(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$StepLeg"))
}
function $isArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$StepLeg)))
}
function $asArrayOf_Lfs2_Pull$StepLeg(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$StepLeg(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$StepLeg;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$Succeeded(r) {
  this.Lfs2_Pull$Succeeded__f_r = null;
  this.Lfs2_Pull$Succeeded__f_r = r
}
$c_Lfs2_Pull$Succeeded.prototype = new $h_Lfs2_Pull$Terminal();
$c_Lfs2_Pull$Succeeded.prototype.constructor = $c_Lfs2_Pull$Succeeded;
/** @constructor */
function $h_Lfs2_Pull$Succeeded() {
  /*<skip>*/
}
$h_Lfs2_Pull$Succeeded.prototype = $c_Lfs2_Pull$Succeeded.prototype;
$c_Lfs2_Pull$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Succeeded)) {
    var x$0$2 = $as_Lfs2_Pull$Succeeded(x$0);
    var x = this.Lfs2_Pull$Succeeded__f_r;
    var y = x$0$2.Lfs2_Pull$Succeeded__f_r;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lfs2_Pull$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Succeeded.prototype.productArity__I = (function() {
  return 1
});
$c_Lfs2_Pull$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded"
});
$c_Lfs2_Pull$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Succeeded__f_r
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$Succeeded(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Succeeded) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Succeeded"))
}
function $isArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Succeeded)))
}
function $asArrayOf_Lfs2_Pull$Succeeded(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Succeeded(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Succeeded;", depth))
}
var $d_Lfs2_Pull$Succeeded = new $TypeData().initClass({
  Lfs2_Pull$Succeeded: 0
}, false, "fs2.Pull$Succeeded", {
  Lfs2_Pull$Succeeded: 1,
  Lfs2_Pull$Terminal: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Succeeded.prototype.$classData = $d_Lfs2_Pull$Succeeded;
/** @constructor */
function $c_Lfs2_Pull$Translate(stream, fk) {
  this.Lfs2_Pull$Translate__f_stream = null;
  this.Lfs2_Pull$Translate__f_fk = null;
  this.Lfs2_Pull$Translate__f_stream = stream;
  this.Lfs2_Pull$Translate__f_fk = fk
}
$c_Lfs2_Pull$Translate.prototype = new $h_Lfs2_Pull$Action();
$c_Lfs2_Pull$Translate.prototype.constructor = $c_Lfs2_Pull$Translate;
/** @constructor */
function $h_Lfs2_Pull$Translate() {
  /*<skip>*/
}
$h_Lfs2_Pull$Translate.prototype = $c_Lfs2_Pull$Translate.prototype;
$c_Lfs2_Pull$Translate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Translate.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$Translate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Translate)) {
    var x$0$2 = $as_Lfs2_Pull$Translate(x$0);
    var x = this.Lfs2_Pull$Translate__f_stream;
    var x$2 = x$0$2.Lfs2_Pull$Translate__f_stream;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lfs2_Pull$Translate__f_fk;
      var x$4 = x$0$2.Lfs2_Pull$Translate__f_fk;
      return (x$3 === x$4)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$Translate.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Translate.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_Pull$Translate.prototype.productPrefix__T = (function() {
  return "Translate"
});
$c_Lfs2_Pull$Translate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Translate__f_stream
  };
  if ((n === 1)) {
    return this.Lfs2_Pull$Translate__f_fk
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$Translate(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Translate) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Translate"))
}
function $isArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Translate)))
}
function $asArrayOf_Lfs2_Pull$Translate(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Translate(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Translate;", depth))
}
var $d_Lfs2_Pull$Translate = new $TypeData().initClass({
  Lfs2_Pull$Translate: 0
}, false, "fs2.Pull$Translate", {
  Lfs2_Pull$Translate: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Translate.prototype.$classData = $d_Lfs2_Pull$Translate;
function $as_Lfs2_Pull$Uncons(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Uncons"))
}
function $isArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Uncons)))
}
function $asArrayOf_Lfs2_Pull$Uncons(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Uncons(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Uncons;", depth))
}
function $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__($thiz, _out, autoFlush, charset) {
  $thiz.Ljava_io_PrintStream__f_autoFlush = autoFlush;
  $thiz.Ljava_io_PrintStream__f_charset = charset;
  $ct_Ljava_io_FilterOutputStream__Ljava_io_OutputStream__($thiz, _out);
  $thiz.Ljava_io_PrintStream__f_closing = false;
  $thiz.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  $thiz.Ljava_io_PrintStream__f_errorFlag = false;
  return $thiz
}
/** @constructor */
function $c_Ljava_io_PrintStream() {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_closing = false;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_errorFlag = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false
}
$c_Ljava_io_PrintStream.prototype = new $h_Ljava_io_FilterOutputStream();
$c_Ljava_io_PrintStream.prototype.constructor = $c_Ljava_io_PrintStream;
/** @constructor */
function $h_Ljava_io_PrintStream() {
  /*<skip>*/
}
$h_Ljava_io_PrintStream.prototype = $c_Ljava_io_PrintStream.prototype;
$c_Ljava_io_PrintStream.prototype.println__T__V = (function(s) {
  this.print__T__V(s);
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V("\n")
});
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor) {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  $ct_ju_HashMap__I__F__(this, initialCapacity, loadFactor)
}
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = new $h_ju_NullRejectingHashMap();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap() {
  /*<skip>*/
}
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(this)
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList = (function() {
  var snapshot = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), this.ju_HashMap__f_contentSize);
  var iter = new $c_ju_HashMap$NodeIterator(this);
  while (iter.hasNext__Z()) {
    snapshot.add__O__Z(iter.next__O())
  };
  return snapshot
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap = new $TypeData().initClass({
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 0
}, false, "java.util.concurrent.ConcurrentHashMap$InnerHashMap", {
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 1,
  ju_NullRejectingHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  O: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.$classData = $d_ju_concurrent_ConcurrentHashMap$InnerHashMap;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uB($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B()
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcB$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", {
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uC($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C())
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcC$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", {
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uD($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D()
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcD$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", {
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uF($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F()
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcF$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", {
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uI($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I()
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcI$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", {
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  try {
    var t = this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return new $c_RTLong(lo, hi)
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uJ($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J()
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", {
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uS($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S()
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcS$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", {
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  try {
    this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0)
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O()
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V()
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcV$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", {
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp)
}
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
  /*<skip>*/
}
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  try {
    var r = this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp.get(this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
    return r
  } catch (e) {
    if ((e instanceof $c_jl_ArrayIndexOutOfBoundsException)) {
      return $uZ($m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O())
    } else {
      throw e
    }
  }
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z()
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 0
}, false, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", {
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.$classData = $d_sc_ArrayOps$ArrayIterator$mcZ$sp;
function $f_sc_SortedSetOps__max__s_math_Ordering__O($thiz, ord) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max")
  } else {
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((ord === null) ? (x$2 === null) : ord.equals__O__Z(x$2))) {
      return $thiz.last__O()
    } else {
      return (ord.isReverseOf__s_math_Ordering__Z($thiz.ordering__s_math_Ordering()) ? $thiz.head__O() : $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord))
    }
  }
}
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)")
}
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)))
}
function $as_sc_View(obj) {
  return (($is_sc_View(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.View"))
}
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)))
}
function $asArrayOf_sc_View(obj, depth) {
  return (($isArrayOf_sc_View(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.View;", depth))
}
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set2$$anon$1__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 2)
}
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
  /*<skip>*/
}
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set2$$anon$1__f_$outer.scala$collection$immutable$Set$Set2$$getElem__I__O(i)
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass({
  sci_Set$Set2$$anon$1: 0
}, false, "scala.collection.immutable.Set$Set2$$anon$1", {
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2$$anon$1.prototype.$classData = $d_sci_Set$Set2$$anon$1;
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set3$$anon$2__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 3)
}
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
  /*<skip>*/
}
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set3$$anon$2__f_$outer.scala$collection$immutable$Set$Set3$$getElem__I__O(i)
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass({
  sci_Set$Set3$$anon$2: 0
}, false, "scala.collection.immutable.Set$Set3$$anon$2", {
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3$$anon$2.prototype.$classData = $d_sci_Set$Set3$$anon$2;
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sci_Set$Set4$$anon$3__f_$outer = outer
  };
  $ct_sci_Set$SetNIterator__I__(this, 4)
}
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
  /*<skip>*/
}
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set4$$anon$3__f_$outer.scala$collection$immutable$Set$Set4$$getElem__I__O(i)
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass({
  sci_Set$Set4$$anon$3: 0
}, false, "scala.collection.immutable.Set$Set4$$anon$3", {
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4$$anon$3.prototype.$classData = $d_sci_Set$Set4$$anon$3;
/** @constructor */
function $c_sci_TreeSet$TreeSetBuilder(ordering) {
  this.sci_RedBlackTree$Helper__f_ordering = null;
  this.sci_TreeSet$TreeSetBuilder__f_tree = null;
  $ct_sci_RedBlackTree$Helper__s_math_Ordering__(this, ordering);
  this.sci_TreeSet$TreeSetBuilder__f_tree = null
}
$c_sci_TreeSet$TreeSetBuilder.prototype = new $h_sci_RedBlackTree$SetHelper();
$c_sci_TreeSet$TreeSetBuilder.prototype.constructor = $c_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $h_sci_TreeSet$TreeSetBuilder() {
  /*<skip>*/
}
$h_sci_TreeSet$TreeSetBuilder.prototype = $c_sci_TreeSet$TreeSetBuilder.prototype;
$c_sci_TreeSet$TreeSetBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__sci_TreeSet$TreeSetBuilder = (function(elem) {
  this.sci_TreeSet$TreeSetBuilder__f_tree = this.mutableUpd__sci_RedBlackTree$Tree__O__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree, elem);
  return this
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder = (function(xs) {
  matchEnd5: {
    if ((xs instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(xs);
      var x = x2.sci_TreeSet__f_ordering;
      var x$2 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = x2.sci_TreeSet__f_tree;
          break matchEnd5
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), x2.sci_TreeSet__f_tree, this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    if (false) {
      var x3 = $as_sci_TreeMap(xs);
      var x$3 = x3.ordering__s_math_Ordering();
      var x$4 = this.sci_RedBlackTree$Helper__f_ordering;
      if (((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))) {
        if ((this.sci_TreeSet$TreeSetBuilder__f_tree === null)) {
          this.sci_TreeSet$TreeSetBuilder__f_tree = x3.tree0__sci_RedBlackTree$Tree();
          break matchEnd5
        } else {
          this.sci_TreeSet$TreeSetBuilder__f_tree = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), x3.tree0__sci_RedBlackTree$Tree(), this.sci_RedBlackTree$Helper__f_ordering);
          break matchEnd5
        }
      }
    };
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
  };
  return this
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__sci_TreeSet = (function() {
  return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), this.beforePublish__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet$TreeSetBuilder__f_tree), this.sci_RedBlackTree$Helper__f_ordering)
});
$c_sci_TreeSet$TreeSetBuilder.prototype.result__O = (function() {
  return this.result__sci_TreeSet()
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__sci_TreeSet$TreeSetBuilder(xs)
});
$c_sci_TreeSet$TreeSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_TreeSet$TreeSetBuilder(elem)
});
var $d_sci_TreeSet$TreeSetBuilder = new $TypeData().initClass({
  sci_TreeSet$TreeSetBuilder: 0
}, false, "scala.collection.immutable.TreeSet$TreeSetBuilder", {
  sci_TreeSet$TreeSetBuilder: 1,
  sci_RedBlackTree$SetHelper: 1,
  sci_RedBlackTree$Helper: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
});
$c_sci_TreeSet$TreeSetBuilder.prototype.$classData = $d_sci_TreeSet$TreeSetBuilder;
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = []
}
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
  /*<skip>*/
}
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? this.scm_ArrayBuilder$generic__f_elementClass.jl_Class__f_data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem)
  };
  return this
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf()
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $$x1 = true
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $$x1 = (x$6 === $d_sr_Nothing$.getClassOf())
    };
    if ($$x1) {
      var elemRuntimeClass = $d_O.getClassOf()
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass
    }
  };
  return elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems)
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic"
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(xs)
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem)
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass({
  scm_ArrayBuilder$generic: 0
}, false, "scala.collection.mutable.ArrayBuilder$generic", {
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  O: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuilder$generic.prototype.$classData = $d_scm_ArrayBuilder$generic;
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_sr_ScalaRunTime$().array_length__O__I(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((destStart + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
  };
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var a = ((((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0)) - srcStart) | 0);
  var b = (($m_sr_ScalaRunTime$().array_length__O__I(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until$1 = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((srcStart + " is out of bounds (min 0, max ") + (((-1) + until$1) | 0)) + ")"))
    };
    var startIdx = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + srcStart) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0));
    var b$2 = (($thiz.scm_ArrayDeque__f_array.u.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, 0, dest, ((destStart + block1) | 0), block2)
    }
  };
  return dest
}
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$CheckedIterator: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", {
  scm_CheckedIndexedSeqView$CheckedIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.$classData = $d_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = $uI(mutationCount.apply__O())
}
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount;
  var this$1 = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount;
  var actualCount = $uI(this$1.apply__O());
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", {
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  O: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.$classData = $d_scm_CheckedIndexedSeqView$CheckedReverseIterator;
class $c_s_concurrent_Future$$anon$1 extends $c_ju_NoSuchElementException {
  constructor(t$2) {
    super();
    var s = ("Future.collect partial function is not defined at: " + t$2);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$1 = new $TypeData().initClass({
  s_concurrent_Future$$anon$1: 0
}, false, "scala.concurrent.Future$$anon$1", {
  s_concurrent_Future$$anon$1: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$1.prototype.$classData = $d_s_concurrent_Future$$anon$1;
class $c_s_concurrent_Future$$anon$2 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.filter predicate is not satisfied", null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$2 = new $TypeData().initClass({
  s_concurrent_Future$$anon$2: 0
}, false, "scala.concurrent.Future$$anon$2", {
  s_concurrent_Future$$anon$2: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$2.prototype.$classData = $d_s_concurrent_Future$$anon$2;
class $c_s_concurrent_Future$$anon$3 extends $c_ju_NoSuchElementException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, "Future.failed not completed with a throwable.", null, true, true)
  };
  fillInStackTrace__jl_Throwable() {
    return $f_s_util_control_NoStackTrace__fillInStackTrace__jl_Throwable(this)
  };
}
var $d_s_concurrent_Future$$anon$3 = new $TypeData().initClass({
  s_concurrent_Future$$anon$3: 0
}, false, "scala.concurrent.Future$$anon$3", {
  s_concurrent_Future$$anon$3: 1,
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_util_control_NoStackTrace: 1
});
$c_s_concurrent_Future$$anon$3.prototype.$classData = $d_s_concurrent_Future$$anon$3;
function $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($thiz) {
  var _$this = $thiz;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return $as_s_util_Try(state)
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this)
    } else {
      return null
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, state, callbacks) {
  var _$this = $thiz;
  while (true) {
    if ((state instanceof $c_s_util_Try)) {
      $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, callbacks, $as_s_util_Try(state));
      return callbacks
    } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.compareAndSet__O__O__Z(state, ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop) ? $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(_$this, callbacks, $as_s_concurrent_impl_Promise$Callbacks(state)) : callbacks))) {
        return callbacks
      } else {
        state = _$this.ju_concurrent_atomic_AtomicReference__f_value
      }
    } else {
      var p = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      var temp$state$2 = p.ju_concurrent_atomic_AtomicReference__f_value;
      _$this = p;
      state = temp$state$2
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__concatCallbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks($thiz, left, right) {
  while (true) {
    if ((left instanceof $c_s_concurrent_impl_Promise$Transformation)) {
      return new $c_s_concurrent_impl_Promise$ManyCallbacks($as_s_concurrent_impl_Promise$Transformation(left), right)
    } else {
      var m = $as_s_concurrent_impl_Promise$ManyCallbacks(left);
      var temp$left = m.s_concurrent_impl_Promise$ManyCallbacks__f_rest;
      var temp$right = new $c_s_concurrent_impl_Promise$ManyCallbacks(m.s_concurrent_impl_Promise$ManyCallbacks__f_first, right);
      left = temp$left;
      right = temp$right
    }
  }
}
function $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V($thiz, callbacks, resolved) {
  while ((callbacks instanceof $c_s_concurrent_impl_Promise$ManyCallbacks)) {
    var m = $as_s_concurrent_impl_Promise$ManyCallbacks(callbacks);
    m.s_concurrent_impl_Promise$ManyCallbacks__f_first.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved);
    callbacks = m.s_concurrent_impl_Promise$ManyCallbacks__f_rest
  };
  $as_s_concurrent_impl_Promise$Transformation(callbacks).submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation(resolved)
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, initial) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, initial);
  return $thiz
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__s_util_Try__($thiz, result) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(result));
  return $thiz
}
function $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz) {
  $ct_s_concurrent_impl_Promise$DefaultPromise__O__($thiz, $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop);
  return $thiz
}
/** @constructor */
function $c_s_concurrent_impl_Promise$DefaultPromise() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null
}
$c_s_concurrent_impl_Promise$DefaultPromise.prototype = new $h_ju_concurrent_atomic_AtomicReference();
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.constructor = $c_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $h_s_concurrent_impl_Promise$DefaultPromise() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$DefaultPromise.prototype = $c_s_concurrent_impl_Promise$DefaultPromise.prototype;
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.onComplete__F1__s_concurrent_ExecutionContext__V = (function(func, executor) {
  $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(this, this.ju_concurrent_atomic_AtomicReference__f_value, $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__(new $c_s_concurrent_impl_Promise$Transformation(), 6, func, executor))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.toString__T = (function() {
  var _$this = this;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_util_Try)) {
      return (("Future(" + state) + ")")
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      _$this = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this)
    } else {
      return "Future(<not completed>)"
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete__s_util_Try__Z = (function(value) {
  var state = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ((!(state instanceof $c_s_util_Try)) && this.tryComplete0__O__s_util_Try__Z(state, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(value)))
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.tryComplete0__O__s_util_Try__Z = (function(state, resolved) {
  var _$this = this;
  while (true) {
    if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
      if (_$this.compareAndSet__O__O__Z(state, resolved)) {
        if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
          $p_s_concurrent_impl_Promise$DefaultPromise__submitWithValue__s_concurrent_impl_Promise$Callbacks__s_util_Try__V(_$this, $as_s_concurrent_impl_Promise$Callbacks(state), resolved)
        };
        return true
      } else {
        state = _$this.ju_concurrent_atomic_AtomicReference__f_value
      }
    } else if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var p = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
      if ((p !== _$this)) {
        var temp$state$2 = p.ju_concurrent_atomic_AtomicReference__f_value;
        _$this = p;
        state = temp$state$2
      } else {
        return false
      }
    } else {
      return false
    }
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise = (function(other) {
  if ((other !== this)) {
    var state = this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((!(state instanceof $c_s_util_Try))) {
      if ((other instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
        var resolved = $p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try($as_s_concurrent_impl_Promise$DefaultPromise(other))
      } else {
        var this$2 = $m_s_Option$().apply__O__s_Option($p_s_concurrent_impl_Promise$DefaultPromise__value0__s_util_Try(other));
        $m_s_$less$colon$less$();
        var resolved = $as_s_util_Try((this$2.isEmpty__Z() ? null : this$2.get__O()))
      };
      if ((resolved !== null)) {
        this.tryComplete0__O__s_util_Try__Z(state, resolved)
      } else {
        other.onComplete__F1__s_concurrent_ExecutionContext__V(this, $m_s_concurrent_ExecutionContext$parasitic$())
      }
    }
  };
  return this
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V = (function(target, link) {
  var _$this = this;
  while (true) {
    if ((_$this !== target)) {
      var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
      if ((state instanceof $c_s_util_Try)) {
        if ((!target.tryComplete0__O__s_util_Try__Z(target.ju_concurrent_atomic_AtomicReference__f_value, $as_s_util_Try(state)))) {
          throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot link completed promises together")
        }
      } else if ($is_s_concurrent_impl_Promise$Callbacks(state)) {
        var l = ((link !== null) ? link : new $c_s_concurrent_impl_Promise$Link(target));
        var p = l.promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        if (((_$this !== p) && _$this.compareAndSet__O__O__Z(state, l))) {
          if ((state !== $m_s_concurrent_impl_Promise$().s_concurrent_impl_Promise$__f_scala$concurrent$impl$Promise$$Noop)) {
            $p_s_concurrent_impl_Promise$DefaultPromise__dispatchOrAddCallbacks__O__s_concurrent_impl_Promise$Callbacks__s_concurrent_impl_Promise$Callbacks(p, p.ju_concurrent_atomic_AtomicReference__f_value, $as_s_concurrent_impl_Promise$Callbacks(state))
          }
        } else {
          target = p;
          link = l;
          continue
        }
      } else {
        _$this = $as_s_concurrent_impl_Promise$Link(state).promise__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$DefaultPromise(_$this);
        continue
      }
    };
    break
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.unlink__s_util_Try__V = (function(resolved) {
  var _$this = this;
  while (true) {
    var state = _$this.ju_concurrent_atomic_AtomicReference__f_value;
    if ((state instanceof $c_s_concurrent_impl_Promise$Link)) {
      var next = (_$this.compareAndSet__O__O__Z(state, resolved) ? $as_s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_impl_Promise$Link(state).ju_concurrent_atomic_AtomicReference__f_value) : _$this);
      _$this = next;
      continue
    } else {
      _$this.tryComplete0__O__s_util_Try__Z(state, resolved)
    };
    break
  }
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.apply__O__O = (function(v1) {
  var resolved = $as_s_util_Try(v1);
  this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolved)
});
function $as_s_concurrent_impl_Promise$DefaultPromise(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$DefaultPromise) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$DefaultPromise"))
}
function $isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$DefaultPromise)))
}
function $asArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$DefaultPromise(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$DefaultPromise;", depth))
}
var $d_s_concurrent_impl_Promise$DefaultPromise = new $TypeData().initClass({
  s_concurrent_impl_Promise$DefaultPromise: 0
}, false, "scala.concurrent.impl.Promise$DefaultPromise", {
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1
});
$c_s_concurrent_impl_Promise$DefaultPromise.prototype.$classData = $d_s_concurrent_impl_Promise$DefaultPromise;
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
  /*<skip>*/
}
$c_s_math_Ordering$Boolean$.prototype = new $h_O();
$c_s_math_Ordering$Boolean$.prototype.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
  /*<skip>*/
}
$h_s_math_Ordering$Boolean$.prototype = $c_s_math_Ordering$Boolean$.prototype;
$c_s_math_Ordering$Boolean$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Boolean$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Boolean$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uZ(x);
  var y$1 = $uZ(y);
  return ((x$1 === y$1) ? 0 : (x$1 ? 1 : (-1)))
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().initClass({
  s_math_Ordering$Boolean$: 0
}, false, "scala.math.Ordering$Boolean$", {
  s_math_Ordering$Boolean$: 1,
  O: 1,
  s_math_Ordering$BooleanOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Boolean$.prototype.$classData = $d_s_math_Ordering$Boolean$;
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$()
  };
  return $n_s_math_Ordering$Boolean$
}
/** @constructor */
function $c_s_math_Ordering$Byte$() {
  /*<skip>*/
}
$c_s_math_Ordering$Byte$.prototype = new $h_O();
$c_s_math_Ordering$Byte$.prototype.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
  /*<skip>*/
}
$h_s_math_Ordering$Byte$.prototype = $c_s_math_Ordering$Byte$.prototype;
$c_s_math_Ordering$Byte$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Byte$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Byte$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uB(x);
  var y$1 = $uB(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Byte$ = new $TypeData().initClass({
  s_math_Ordering$Byte$: 0
}, false, "scala.math.Ordering$Byte$", {
  s_math_Ordering$Byte$: 1,
  O: 1,
  s_math_Ordering$ByteOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Byte$.prototype.$classData = $d_s_math_Ordering$Byte$;
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$()
  };
  return $n_s_math_Ordering$Byte$
}
/** @constructor */
function $c_s_math_Ordering$Char$() {
  /*<skip>*/
}
$c_s_math_Ordering$Char$.prototype = new $h_O();
$c_s_math_Ordering$Char$.prototype.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
  /*<skip>*/
}
$h_s_math_Ordering$Char$.prototype = $c_s_math_Ordering$Char$.prototype;
$c_s_math_Ordering$Char$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Char$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Char$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Char$ = new $TypeData().initClass({
  s_math_Ordering$Char$: 0
}, false, "scala.math.Ordering$Char$", {
  s_math_Ordering$Char$: 1,
  O: 1,
  s_math_Ordering$CharOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Char$.prototype.$classData = $d_s_math_Ordering$Char$;
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$()
  };
  return $n_s_math_Ordering$Char$
}
/** @constructor */
function $c_s_math_Ordering$DeprecatedDoubleOrdering$() {
  /*<skip>*/
}
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = new $h_O();
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.constructor = $c_s_math_Ordering$DeprecatedDoubleOrdering$;
/** @constructor */
function $h_s_math_Ordering$DeprecatedDoubleOrdering$() {
  /*<skip>*/
}
$h_s_math_Ordering$DeprecatedDoubleOrdering$.prototype = $c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype;
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uD(x);
  var y$1 = $uD(y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1)
});
var $d_s_math_Ordering$DeprecatedDoubleOrdering$ = new $TypeData().initClass({
  s_math_Ordering$DeprecatedDoubleOrdering$: 0
}, false, "scala.math.Ordering$DeprecatedDoubleOrdering$", {
  s_math_Ordering$DeprecatedDoubleOrdering$: 1,
  O: 1,
  s_math_Ordering$Double$TotalOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$DeprecatedDoubleOrdering$.prototype.$classData = $d_s_math_Ordering$DeprecatedDoubleOrdering$;
var $n_s_math_Ordering$DeprecatedDoubleOrdering$;
function $m_s_math_Ordering$DeprecatedDoubleOrdering$() {
  if ((!$n_s_math_Ordering$DeprecatedDoubleOrdering$)) {
    $n_s_math_Ordering$DeprecatedDoubleOrdering$ = new $c_s_math_Ordering$DeprecatedDoubleOrdering$()
  };
  return $n_s_math_Ordering$DeprecatedDoubleOrdering$
}
/** @constructor */
function $c_s_math_Ordering$Long$() {
  /*<skip>*/
}
$c_s_math_Ordering$Long$.prototype = new $h_O();
$c_s_math_Ordering$Long$.prototype.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
  /*<skip>*/
}
$h_s_math_Ordering$Long$.prototype = $c_s_math_Ordering$Long$.prototype;
$c_s_math_Ordering$Long$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Long$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Long$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
});
var $d_s_math_Ordering$Long$ = new $TypeData().initClass({
  s_math_Ordering$Long$: 0
}, false, "scala.math.Ordering$Long$", {
  s_math_Ordering$Long$: 1,
  O: 1,
  s_math_Ordering$LongOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Long$.prototype.$classData = $d_s_math_Ordering$Long$;
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$()
  };
  return $n_s_math_Ordering$Long$
}
/** @constructor */
function $c_s_math_Ordering$Short$() {
  /*<skip>*/
}
$c_s_math_Ordering$Short$.prototype = new $h_O();
$c_s_math_Ordering$Short$.prototype.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
  /*<skip>*/
}
$h_s_math_Ordering$Short$.prototype = $c_s_math_Ordering$Short$.prototype;
$c_s_math_Ordering$Short$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Short$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Short$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uS(x);
  var y$1 = $uS(y);
  return ((x$1 - y$1) | 0)
});
var $d_s_math_Ordering$Short$ = new $TypeData().initClass({
  s_math_Ordering$Short$: 0
}, false, "scala.math.Ordering$Short$", {
  s_math_Ordering$Short$: 1,
  O: 1,
  s_math_Ordering$ShortOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
});
$c_s_math_Ordering$Short$.prototype.$classData = $d_s_math_Ordering$Short$;
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$()
  };
  return $n_s_math_Ordering$Short$
}
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
  /*<skip>*/
}
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_AnyValManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null
}
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.sjs_js_JavaScriptException__f_exception = null;
    this.sjs_js_JavaScriptException__f_exception = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  getMessage__T() {
    return $dp_toString__T(this.sjs_js_JavaScriptException__f_exception)
  };
  fillInStackTrace__jl_Throwable() {
    this.setStackTraceStateInternal__O__(this.sjs_js_JavaScriptException__f_exception);
    return this
  };
  productPrefix__T() {
    return "JavaScriptException"
  };
  productArity__I() {
    return 1
  };
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1))
  };
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this)
  };
  hashCode__I() {
    var this$2 = $m_s_util_hashing_MurmurHash3$();
    return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
  };
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true
    } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
      var JavaScriptException$1 = $as_sjs_js_JavaScriptException(x$1);
      var x = this.sjs_js_JavaScriptException__f_exception;
      var y = JavaScriptException$1.sjs_js_JavaScriptException__f_exception;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      return false
    }
  };
  setStackTraceStateInternal__O__(e) {
    this.jl_Throwable__f_stackTraceStateInternal = e
  };
}
function $as_sjs_js_JavaScriptException(obj) {
  return (((obj instanceof $c_sjs_js_JavaScriptException) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.JavaScriptException"))
}
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)))
}
function $asArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (($isArrayOf_sjs_js_JavaScriptException(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.JavaScriptException;", depth))
}
var $d_sjs_js_JavaScriptException = new $TypeData().initClass({
  sjs_js_JavaScriptException: 0
}, false, "scala.scalajs.js.JavaScriptException", {
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sjs_js_JavaScriptException.prototype.$classData = $d_sjs_js_JavaScriptException;
function $f_Lcats_FlatMap__flatten__O__O($thiz, ffa) {
  return $thiz.flatMap__O__F1__O(ffa, new $c_sjsr_AnonFunction1(((fa) => fa)))
}
function $f_Lcats_FlatMap__ap__O__O__O($thiz, ff, fa) {
  return $thiz.flatMap__O__F1__O(ff, new $c_sjsr_AnonFunction1(((this$1, fa$2) => ((f) => {
    var f$1 = $as_F1(f);
    return this$1.map__O__F1__O(fa$2, f$1)
  }))($thiz, fa)))
}
function $f_Lcats_FlatMap__product__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, fb$2) => ((a) => this$1.map__O__F1__O(fb$2, new $c_sjsr_AnonFunction1(((a$2) => ((b) => new $c_T2(a$2, b)))(a)))))($thiz, fb)))
}
function $f_Lcats_FlatMap__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, fb$2, f$2) => ((a) => this$1.map__O__F1__O(fb$2, new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a)))))($thiz, fb, f)))
}
function $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  $m_Lcats_Eval$();
  var a$1 = $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, fb$2, f$2) => ((a) => this$1.map__O__F1__O(fb$2.value__O(), new $c_sjsr_AnonFunction1(((f$3$2, a$2) => ((b) => f$3$2.apply__O__O__O(a$2, b)))(f$2, a)))))($thiz, fb, f)));
  return new $c_Lcats_Now(a$1)
}
function $f_Lcats_FlatMap__productR__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((fb$2) => ((_$4) => fb$2))(fb)))
}
function $f_Lcats_FlatMap__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2(((a, _$5) => a)))
}
function $f_Lcats_FlatMap__ifM__O__F0__F0__O($thiz, fa, ifTrue, ifFalse) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((ifTrue$2, ifFalse$2) => ((_$7) => {
    var _$7$1 = $uZ(_$7);
    return (_$7$1 ? ifTrue$2.apply__O() : ifFalse$2.apply__O())
  }))(ifTrue, ifFalse)))
}
function $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, f$2) => ((a) => this$1.as__O__O__O(f$2.apply__O__O(a), a)))($thiz, f)))
}
function $f_Lcats_FlatMap__foreverM__O__O($thiz, fa) {
  $m_s_package$();
  var leftUnit = new $c_s_util_Left((void 0));
  var stepResult = $thiz.as__O__O__O(fa, leftUnit);
  return $thiz.tailRecM__O__F1__O((void 0), new $c_sjsr_AnonFunction1(((stepResult$2) => ((_$8) => {
    $as_jl_Void(_$8);
    return stepResult$2
  }))(stepResult)))
}
function $f_Lcats_Traverse__sequence__O__Lcats_Applicative__O($thiz, fga, evidence$3) {
  return $thiz.traverse__O__F1__Lcats_Applicative__O(fga, new $c_sjsr_AnonFunction1(((ga) => ga)), evidence$3)
}
function $is_Lcats_Traverse(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Traverse)))
}
function $as_Lcats_Traverse(obj) {
  return (($is_Lcats_Traverse(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Traverse"))
}
function $isArrayOf_Lcats_Traverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Traverse)))
}
function $asArrayOf_Lcats_Traverse(obj, depth) {
  return (($isArrayOf_Lcats_Traverse(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Traverse;", depth))
}
/** @constructor */
function $c_Lcats_data_Chain$Empty$() {
  /*<skip>*/
}
$c_Lcats_data_Chain$Empty$.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$Empty$.prototype.constructor = $c_Lcats_data_Chain$Empty$;
/** @constructor */
function $h_Lcats_data_Chain$Empty$() {
  /*<skip>*/
}
$h_Lcats_data_Chain$Empty$.prototype = $c_Lcats_data_Chain$Empty$.prototype;
$c_Lcats_data_Chain$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_data_Chain$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_data_Chain$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_Lcats_data_Chain$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_data_Chain$Empty$ = new $TypeData().initClass({
  Lcats_data_Chain$Empty$: 0
}, false, "cats.data.Chain$Empty$", {
  Lcats_data_Chain$Empty$: 1,
  Lcats_data_Chain: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_data_Chain$Empty$.prototype.$classData = $d_Lcats_data_Chain$Empty$;
var $n_Lcats_data_Chain$Empty$;
function $m_Lcats_data_Chain$Empty$() {
  if ((!$n_Lcats_data_Chain$Empty$)) {
    $n_Lcats_data_Chain$Empty$ = new $c_Lcats_data_Chain$Empty$()
  };
  return $n_Lcats_data_Chain$Empty$
}
/** @constructor */
function $c_Lcats_data_KleisliInstances2() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null
}
$c_Lcats_data_KleisliInstances2.prototype = new $h_Lcats_data_KleisliInstances3();
$c_Lcats_data_KleisliInstances2.prototype.constructor = $c_Lcats_data_KleisliInstances2;
/** @constructor */
function $h_Lcats_data_KleisliInstances2() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances2.prototype = $c_Lcats_data_KleisliInstances2.prototype;
/** @constructor */
function $c_Lcats_data_KleisliInstances3$$anon$3(M$9) {
  this.Lcats_data_KleisliInstances3$$anon$3__f_M$1 = null;
  this.Lcats_data_KleisliInstances3$$anon$3__f_M$1 = M$9
}
$c_Lcats_data_KleisliInstances3$$anon$3.prototype = new $h_O();
$c_Lcats_data_KleisliInstances3$$anon$3.prototype.constructor = $c_Lcats_data_KleisliInstances3$$anon$3;
/** @constructor */
function $h_Lcats_data_KleisliInstances3$$anon$3() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances3$$anon$3.prototype = $c_Lcats_data_KleisliInstances3$$anon$3.prototype;
var $d_Lcats_data_KleisliInstances3$$anon$3 = new $TypeData().initClass({
  Lcats_data_KleisliInstances3$$anon$3: 0
}, false, "cats.data.KleisliInstances3$$anon$3", {
  Lcats_data_KleisliInstances3$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Choice: 1,
  Lcats_data_KleisliCompose: 1,
  Lcats_data_KleisliCategory: 1,
  Lcats_data_KleisliChoice: 1
});
$c_Lcats_data_KleisliInstances3$$anon$3.prototype.$classData = $d_Lcats_data_KleisliInstances3$$anon$3;
/** @constructor */
function $c_Lcats_effect_SyncIO$Monotonic$() {
  /*<skip>*/
}
$c_Lcats_effect_SyncIO$Monotonic$.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Monotonic$.prototype.constructor = $c_Lcats_effect_SyncIO$Monotonic$;
/** @constructor */
function $h_Lcats_effect_SyncIO$Monotonic$() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$Monotonic$.prototype = $c_Lcats_effect_SyncIO$Monotonic$.prototype;
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.hashCode__I = (function() {
  return 572915850
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productPrefix__T = (function() {
  return "Monotonic"
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.tag__B = (function() {
  return 10
});
var $d_Lcats_effect_SyncIO$Monotonic$ = new $TypeData().initClass({
  Lcats_effect_SyncIO$Monotonic$: 0
}, false, "cats.effect.SyncIO$Monotonic$", {
  Lcats_effect_SyncIO$Monotonic$: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.$classData = $d_Lcats_effect_SyncIO$Monotonic$;
var $n_Lcats_effect_SyncIO$Monotonic$;
function $m_Lcats_effect_SyncIO$Monotonic$() {
  if ((!$n_Lcats_effect_SyncIO$Monotonic$)) {
    $n_Lcats_effect_SyncIO$Monotonic$ = new $c_Lcats_effect_SyncIO$Monotonic$()
  };
  return $n_Lcats_effect_SyncIO$Monotonic$
}
/** @constructor */
function $c_Lcats_effect_SyncIO$RealTime$() {
  /*<skip>*/
}
$c_Lcats_effect_SyncIO$RealTime$.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$RealTime$.prototype.constructor = $c_Lcats_effect_SyncIO$RealTime$;
/** @constructor */
function $h_Lcats_effect_SyncIO$RealTime$() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$RealTime$.prototype = $c_Lcats_effect_SyncIO$RealTime$.prototype;
$c_Lcats_effect_SyncIO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285)
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime"
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.tag__B = (function() {
  return 9
});
var $d_Lcats_effect_SyncIO$RealTime$ = new $TypeData().initClass({
  Lcats_effect_SyncIO$RealTime$: 0
}, false, "cats.effect.SyncIO$RealTime$", {
  Lcats_effect_SyncIO$RealTime$: 1,
  Lcats_effect_SyncIO: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.$classData = $d_Lcats_effect_SyncIO$RealTime$;
var $n_Lcats_effect_SyncIO$RealTime$;
function $m_Lcats_effect_SyncIO$RealTime$() {
  if ((!$n_Lcats_effect_SyncIO$RealTime$)) {
    $n_Lcats_effect_SyncIO$RealTime$ = new $c_Lcats_effect_SyncIO$RealTime$()
  };
  return $n_Lcats_effect_SyncIO$RealTime$
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.toString__T = (function() {
  return "Canceled"
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled"
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$ExitCase$Canceled$: 0
}, false, "cats.effect.kernel.Resource$ExitCase$Canceled$", {
  Lcats_effect_kernel_Resource$ExitCase$Canceled$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Resource$ExitCase$Canceled$.prototype.$classData = $d_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
var $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Canceled$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Canceled$()
  };
  return $n_Lcats_effect_kernel_Resource$ExitCase$Canceled$
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.constructor = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype = $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype;
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.hashCode__I = (function() {
  return (-1345265087)
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.toString__T = (function() {
  return "Succeeded"
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productPrefix__T = (function() {
  return "Succeeded"
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$ExitCase$Succeeded$: 0
}, false, "cats.effect.kernel.Resource$ExitCase$Succeeded$", {
  Lcats_effect_kernel_Resource$ExitCase$Succeeded$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Resource$ExitCase: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$.prototype.$classData = $d_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
var $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$;
function $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$() {
  if ((!$n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$)) {
    $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$ = new $c_Lcats_effect_kernel_Resource$ExitCase$Succeeded$()
  };
  return $n_Lcats_effect_kernel_Resource$ExitCase$Succeeded$
}
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$1$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$1$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$1$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Nil$1$.prototype = $c_Lcats_effect_kernel_Resource$Nil$1$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.hashCode__I = (function() {
  return 78321
});
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.toString__T = (function() {
  return "Nil"
});
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Nil$1$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Nil$1$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Nil$1$"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Nil$1$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Nil$1$)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Nil$1$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Nil$1$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Nil$1$;", depth))
}
var $d_Lcats_effect_kernel_Resource$Nil$1$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Nil$1$: 0
}, false, "cats.effect.kernel.Resource$Nil$1$", {
  Lcats_effect_kernel_Resource$Nil$1$: 1,
  O: 1,
  Lcats_effect_kernel_Resource$Stack$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Resource$Nil$1$.prototype.$classData = $d_Lcats_effect_kernel_Resource$Nil$1$;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$Nil$2$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype = new $h_O();
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.constructor = $c_Lcats_effect_kernel_Resource$Nil$2$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$Nil$2$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$Nil$2$.prototype = $c_Lcats_effect_kernel_Resource$Nil$2$.prototype;
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.hashCode__I = (function() {
  return 78321
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.toString__T = (function() {
  return "Nil"
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_kernel_Resource$Nil$2$(obj) {
  return (((obj instanceof $c_Lcats_effect_kernel_Resource$Nil$2$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Resource$Nil$2$"))
}
function $isArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Resource$Nil$2$)))
}
function $asArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Resource$Nil$2$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Resource$Nil$2$;", depth))
}
var $d_Lcats_effect_kernel_Resource$Nil$2$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$Nil$2$: 0
}, false, "cats.effect.kernel.Resource$Nil$2$", {
  Lcats_effect_kernel_Resource$Nil$2$: 1,
  O: 1,
  Lcats_effect_kernel_Resource$Stack$2: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Resource$Nil$2$.prototype.$classData = $d_Lcats_effect_kernel_Resource$Nil$2$;
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Blocking$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Blocking$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Blocking$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = $c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.hashCode__I = (function() {
  return (-599928747)
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.toString__T = (function() {
  return "Blocking"
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productPrefix__T = (function() {
  return "Blocking"
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_kernel_Sync$Type$Blocking$ = new $TypeData().initClass({
  Lcats_effect_kernel_Sync$Type$Blocking$: 0
}, false, "cats.effect.kernel.Sync$Type$Blocking$", {
  Lcats_effect_kernel_Sync$Type$Blocking$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.$classData = $d_Lcats_effect_kernel_Sync$Type$Blocking$;
var $n_Lcats_effect_kernel_Sync$Type$Blocking$;
function $m_Lcats_effect_kernel_Sync$Type$Blocking$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Blocking$)) {
    $n_Lcats_effect_kernel_Sync$Type$Blocking$ = new $c_Lcats_effect_kernel_Sync$Type$Blocking$()
  };
  return $n_Lcats_effect_kernel_Sync$Type$Blocking$
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Delay$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Delay$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Delay$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Sync$Type$Delay$.prototype = $c_Lcats_effect_kernel_Sync$Type$Delay$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.hashCode__I = (function() {
  return 65915235
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.toString__T = (function() {
  return "Delay"
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productPrefix__T = (function() {
  return "Delay"
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_kernel_Sync$Type$Delay$ = new $TypeData().initClass({
  Lcats_effect_kernel_Sync$Type$Delay$: 0
}, false, "cats.effect.kernel.Sync$Type$Delay$", {
  Lcats_effect_kernel_Sync$Type$Delay$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.$classData = $d_Lcats_effect_kernel_Sync$Type$Delay$;
var $n_Lcats_effect_kernel_Sync$Type$Delay$;
function $m_Lcats_effect_kernel_Sync$Type$Delay$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Delay$)) {
    $n_Lcats_effect_kernel_Sync$Type$Delay$ = new $c_Lcats_effect_kernel_Sync$Type$Delay$()
  };
  return $n_Lcats_effect_kernel_Sync$Type$Delay$
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.hashCode__I = (function() {
  return 430282004
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.toString__T = (function() {
  return "InterruptibleMany"
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productPrefix__T = (function() {
  return "InterruptibleMany"
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $TypeData().initClass({
  Lcats_effect_kernel_Sync$Type$InterruptibleMany$: 0
}, false, "cats.effect.kernel.Sync$Type$InterruptibleMany$", {
  Lcats_effect_kernel_Sync$Type$InterruptibleMany$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.$classData = $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$()
  };
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$
}
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.hashCode__I = (function() {
  return 430353718
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.toString__T = (function() {
  return "InterruptibleOnce"
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productPrefix__T = (function() {
  return "InterruptibleOnce"
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $TypeData().initClass({
  Lcats_effect_kernel_Sync$Type$InterruptibleOnce$: 0
}, false, "cats.effect.kernel.Sync$Type$InterruptibleOnce$", {
  Lcats_effect_kernel_Sync$Type$InterruptibleOnce$: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.$classData = $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$()
  };
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$
}
/** @constructor */
function $c_Lcats_effect_std_Dispatcher$CancelInit$1$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype = new $h_O();
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.constructor = $c_Lcats_effect_std_Dispatcher$CancelInit$1$;
/** @constructor */
function $h_Lcats_effect_std_Dispatcher$CancelInit$1$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype = $c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype;
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.hashCode__I = (function() {
  return (-413198646)
});
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.toString__T = (function() {
  return "CancelInit"
});
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.productPrefix__T = (function() {
  return "CancelInit"
});
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lcats_effect_std_Dispatcher$CancelInit$1$(obj) {
  return (((obj instanceof $c_Lcats_effect_std_Dispatcher$CancelInit$1$) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.std.Dispatcher$CancelInit$1$"))
}
function $isArrayOf_Lcats_effect_std_Dispatcher$CancelInit$1$(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_std_Dispatcher$CancelInit$1$)))
}
function $asArrayOf_Lcats_effect_std_Dispatcher$CancelInit$1$(obj, depth) {
  return (($isArrayOf_Lcats_effect_std_Dispatcher$CancelInit$1$(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.std.Dispatcher$CancelInit$1$;", depth))
}
var $d_Lcats_effect_std_Dispatcher$CancelInit$1$ = new $TypeData().initClass({
  Lcats_effect_std_Dispatcher$CancelInit$1$: 0
}, false, "cats.effect.std.Dispatcher$CancelInit$1$", {
  Lcats_effect_std_Dispatcher$CancelInit$1$: 1,
  O: 1,
  Lcats_effect_std_Dispatcher$CancelState$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_std_Dispatcher$CancelInit$1$.prototype.$classData = $d_Lcats_effect_std_Dispatcher$CancelInit$1$;
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Done$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Done$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Done$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl$Done$.prototype = $c_Lcats_effect_std_Semaphore$impl$Done$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.hashCode__I = (function() {
  return 2135970
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.toString__T = (function() {
  return "Done"
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productPrefix__T = (function() {
  return "Done"
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_std_Semaphore$impl$Done$ = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl$Done$: 0
}, false, "cats.effect.std.Semaphore$impl$Done$", {
  Lcats_effect_std_Semaphore$impl$Done$: 1,
  O: 1,
  Lcats_effect_std_Semaphore$impl$Action: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_std_Semaphore$impl$Done$.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl$Done$;
/** @constructor */
function $c_Lcats_effect_std_Semaphore$impl$Wait$() {
  /*<skip>*/
}
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype = new $h_O();
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.constructor = $c_Lcats_effect_std_Semaphore$impl$Wait$;
/** @constructor */
function $h_Lcats_effect_std_Semaphore$impl$Wait$() {
  /*<skip>*/
}
$h_Lcats_effect_std_Semaphore$impl$Wait$.prototype = $c_Lcats_effect_std_Semaphore$impl$Wait$.prototype;
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.hashCode__I = (function() {
  return 2688405
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.toString__T = (function() {
  return "Wait"
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productPrefix__T = (function() {
  return "Wait"
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_effect_std_Semaphore$impl$Wait$ = new $TypeData().initClass({
  Lcats_effect_std_Semaphore$impl$Wait$: 0
}, false, "cats.effect.std.Semaphore$impl$Wait$", {
  Lcats_effect_std_Semaphore$impl$Wait$: 1,
  O: 1,
  Lcats_effect_std_Semaphore$impl$Action: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_std_Semaphore$impl$Wait$.prototype.$classData = $d_Lcats_effect_std_Semaphore$impl$Wait$;
/** @constructor */
function $c_Lcats_kernel_Comparison$EqualTo$() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0;
  $ct_Lcats_kernel_Comparison__I__D__(this, 0, 0.0)
}
$c_Lcats_kernel_Comparison$EqualTo$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$EqualTo$.prototype.constructor = $c_Lcats_kernel_Comparison$EqualTo$;
/** @constructor */
function $h_Lcats_kernel_Comparison$EqualTo$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$EqualTo$.prototype = $c_Lcats_kernel_Comparison$EqualTo$.prototype;
$c_Lcats_kernel_Comparison$EqualTo$.prototype.hashCode__I = (function() {
  return 159386799
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.toString__T = (function() {
  return "EqualTo"
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productPrefix__T = (function() {
  return "EqualTo"
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_kernel_Comparison$EqualTo$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$EqualTo$: 0
}, false, "cats.kernel.Comparison$EqualTo$", {
  Lcats_kernel_Comparison$EqualTo$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.$classData = $d_Lcats_kernel_Comparison$EqualTo$;
var $n_Lcats_kernel_Comparison$EqualTo$;
function $m_Lcats_kernel_Comparison$EqualTo$() {
  if ((!$n_Lcats_kernel_Comparison$EqualTo$)) {
    $n_Lcats_kernel_Comparison$EqualTo$ = new $c_Lcats_kernel_Comparison$EqualTo$()
  };
  return $n_Lcats_kernel_Comparison$EqualTo$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$GreaterThan$() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0;
  $ct_Lcats_kernel_Comparison__I__D__(this, 1, 1.0)
}
$c_Lcats_kernel_Comparison$GreaterThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.constructor = $c_Lcats_kernel_Comparison$GreaterThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$GreaterThan$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$GreaterThan$.prototype = $c_Lcats_kernel_Comparison$GreaterThan$.prototype;
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.hashCode__I = (function() {
  return (-1701951333)
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.toString__T = (function() {
  return "GreaterThan"
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productPrefix__T = (function() {
  return "GreaterThan"
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_kernel_Comparison$GreaterThan$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$GreaterThan$: 0
}, false, "cats.kernel.Comparison$GreaterThan$", {
  Lcats_kernel_Comparison$GreaterThan$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.$classData = $d_Lcats_kernel_Comparison$GreaterThan$;
var $n_Lcats_kernel_Comparison$GreaterThan$;
function $m_Lcats_kernel_Comparison$GreaterThan$() {
  if ((!$n_Lcats_kernel_Comparison$GreaterThan$)) {
    $n_Lcats_kernel_Comparison$GreaterThan$ = new $c_Lcats_kernel_Comparison$GreaterThan$()
  };
  return $n_Lcats_kernel_Comparison$GreaterThan$
}
/** @constructor */
function $c_Lcats_kernel_Comparison$LessThan$() {
  this.Lcats_kernel_Comparison__f_toInt = 0;
  this.Lcats_kernel_Comparison__f_toDouble = 0.0;
  $ct_Lcats_kernel_Comparison__I__D__(this, (-1), (-1.0))
}
$c_Lcats_kernel_Comparison$LessThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$LessThan$.prototype.constructor = $c_Lcats_kernel_Comparison$LessThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$LessThan$() {
  /*<skip>*/
}
$h_Lcats_kernel_Comparison$LessThan$.prototype = $c_Lcats_kernel_Comparison$LessThan$.prototype;
$c_Lcats_kernel_Comparison$LessThan$.prototype.hashCode__I = (function() {
  return (-2140646662)
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.toString__T = (function() {
  return "LessThan"
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productPrefix__T = (function() {
  return "LessThan"
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Lcats_kernel_Comparison$LessThan$ = new $TypeData().initClass({
  Lcats_kernel_Comparison$LessThan$: 0
}, false, "cats.kernel.Comparison$LessThan$", {
  Lcats_kernel_Comparison$LessThan$: 1,
  Lcats_kernel_Comparison: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.$classData = $d_Lcats_kernel_Comparison$LessThan$;
var $n_Lcats_kernel_Comparison$LessThan$;
function $m_Lcats_kernel_Comparison$LessThan$() {
  if ((!$n_Lcats_kernel_Comparison$LessThan$)) {
    $n_Lcats_kernel_Comparison$LessThan$ = new $c_Lcats_kernel_Comparison$LessThan$()
  };
  return $n_Lcats_kernel_Comparison$LessThan$
}
/** @constructor */
function $c_Lcats_kernel_instances_BigDecimalGroup() {
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = null;
  var this$1 = $m_s_package$().BigDecimal__s_math_BigDecimal$();
  this.Lcats_kernel_instances_BigDecimalGroup__f_empty = this$1.apply__I__Ljava_math_MathContext__s_math_BigDecimal(0, this$1.s_math_BigDecimal$__f_defaultMathContext)
}
$c_Lcats_kernel_instances_BigDecimalGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.constructor = $c_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigDecimalGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigDecimalGroup.prototype = $c_Lcats_kernel_instances_BigDecimalGroup.prototype;
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal = (function(x, y) {
  return new $c_s_math_BigDecimal(x.s_math_BigDecimal__f_bigDecimal.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal(y.s_math_BigDecimal__f_bigDecimal), x.s_math_BigDecimal__f_mc)
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigDecimalGroup__f_empty
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__s_math_BigDecimal__s_math_BigDecimal__s_math_BigDecimal($as_s_math_BigDecimal(x), $as_s_math_BigDecimal(y))
});
var $d_Lcats_kernel_instances_BigDecimalGroup = new $TypeData().initClass({
  Lcats_kernel_instances_BigDecimalGroup: 0
}, false, "cats.kernel.instances.BigDecimalGroup", {
  Lcats_kernel_instances_BigDecimalGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_BigDecimalGroup.prototype.$classData = $d_Lcats_kernel_instances_BigDecimalGroup;
/** @constructor */
function $c_Lcats_kernel_instances_BigIntGroup() {
  this.Lcats_kernel_instances_BigIntGroup__f_empty = null;
  this.Lcats_kernel_instances_BigIntGroup__f_empty = $m_s_package$().BigInt__s_math_BigInt$().apply__I__s_math_BigInt(0)
}
$c_Lcats_kernel_instances_BigIntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntGroup.prototype.constructor = $c_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigIntGroup.prototype = $c_Lcats_kernel_instances_BigIntGroup.prototype;
$c_Lcats_kernel_instances_BigIntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.empty__O = (function() {
  return this.Lcats_kernel_instances_BigIntGroup__f_empty
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return x$1.$plus__s_math_BigInt__s_math_BigInt(y$1)
});
var $d_Lcats_kernel_instances_BigIntGroup = new $TypeData().initClass({
  Lcats_kernel_instances_BigIntGroup: 0
}, false, "cats.kernel.instances.BigIntGroup", {
  Lcats_kernel_instances_BigIntGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_BigIntGroup.prototype.$classData = $d_Lcats_kernel_instances_BigIntGroup;
/** @constructor */
function $c_Lcats_kernel_instances_ByteGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ByteGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteGroup.prototype.constructor = $c_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ByteGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ByteGroup.prototype = $c_Lcats_kernel_instances_ByteGroup.prototype;
$c_Lcats_kernel_instances_ByteGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__B__B__B = (function(x, y) {
  return ((((x + y) | 0) << 24) >> 24)
});
$c_Lcats_kernel_instances_ByteGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__B__B__B($uB(x), $uB(y))
});
$c_Lcats_kernel_instances_ByteGroup.prototype.empty__O = (function() {
  return 0
});
var $d_Lcats_kernel_instances_ByteGroup = new $TypeData().initClass({
  Lcats_kernel_instances_ByteGroup: 0
}, false, "cats.kernel.instances.ByteGroup", {
  Lcats_kernel_instances_ByteGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_ByteGroup.prototype.$classData = $d_Lcats_kernel_instances_ByteGroup;
/** @constructor */
function $c_Lcats_kernel_instances_DoubleGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DoubleGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DoubleGroup.prototype.constructor = $c_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DoubleGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DoubleGroup.prototype = $c_Lcats_kernel_instances_DoubleGroup.prototype;
$c_Lcats_kernel_instances_DoubleGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__D__D__D = (function(x, y) {
  return (x + y)
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__D__D__D($uD(x), $uD(y))
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.empty__O = (function() {
  return 0.0
});
var $d_Lcats_kernel_instances_DoubleGroup = new $TypeData().initClass({
  Lcats_kernel_instances_DoubleGroup: 0
}, false, "cats.kernel.instances.DoubleGroup", {
  Lcats_kernel_instances_DoubleGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_DoubleGroup.prototype.$classData = $d_Lcats_kernel_instances_DoubleGroup;
/** @constructor */
function $c_Lcats_kernel_instances_DurationGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_DurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationGroup.prototype.constructor = $c_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_DurationGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DurationGroup.prototype = $c_Lcats_kernel_instances_DurationGroup.prototype;
$c_Lcats_kernel_instances_DurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_DurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero
});
$c_Lcats_kernel_instances_DurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return x$1.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration(y$1)
});
var $d_Lcats_kernel_instances_DurationGroup = new $TypeData().initClass({
  Lcats_kernel_instances_DurationGroup: 0
}, false, "cats.kernel.instances.DurationGroup", {
  Lcats_kernel_instances_DurationGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_DurationGroup.prototype.$classData = $d_Lcats_kernel_instances_DurationGroup;
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FiniteDurationGroup.prototype = $c_Lcats_kernel_instances_FiniteDurationGroup.prototype;
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.empty__O = (function() {
  return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Zero
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(x$1, y$1.s_concurrent_duration_FiniteDuration__f_length, y$1.s_concurrent_duration_FiniteDuration__f_unit)
});
var $d_Lcats_kernel_instances_FiniteDurationGroup = new $TypeData().initClass({
  Lcats_kernel_instances_FiniteDurationGroup: 0
}, false, "cats.kernel.instances.FiniteDurationGroup", {
  Lcats_kernel_instances_FiniteDurationGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_FiniteDurationGroup.prototype.$classData = $d_Lcats_kernel_instances_FiniteDurationGroup;
/** @constructor */
function $c_Lcats_kernel_instances_FloatGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_FloatGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_FloatGroup.prototype.constructor = $c_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $h_Lcats_kernel_instances_FloatGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FloatGroup.prototype = $c_Lcats_kernel_instances_FloatGroup.prototype;
$c_Lcats_kernel_instances_FloatGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__F__F__F = (function(x, y) {
  return Math.fround((x + y))
});
$c_Lcats_kernel_instances_FloatGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__F__F__F($uF(x), $uF(y))
});
$c_Lcats_kernel_instances_FloatGroup.prototype.empty__O = (function() {
  return 0.0
});
var $d_Lcats_kernel_instances_FloatGroup = new $TypeData().initClass({
  Lcats_kernel_instances_FloatGroup: 0
}, false, "cats.kernel.instances.FloatGroup", {
  Lcats_kernel_instances_FloatGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_FloatGroup.prototype.$classData = $d_Lcats_kernel_instances_FloatGroup;
/** @constructor */
function $c_Lcats_kernel_instances_IntGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_IntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_IntGroup.prototype.constructor = $c_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_IntGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_IntGroup.prototype = $c_Lcats_kernel_instances_IntGroup.prototype;
$c_Lcats_kernel_instances_IntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__I__I__I = (function(x, y) {
  return ((x + y) | 0)
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__I__I__I($uI(x), $uI(y))
});
$c_Lcats_kernel_instances_IntGroup.prototype.empty__O = (function() {
  return 0
});
var $d_Lcats_kernel_instances_IntGroup = new $TypeData().initClass({
  Lcats_kernel_instances_IntGroup: 0
}, false, "cats.kernel.instances.IntGroup", {
  Lcats_kernel_instances_IntGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_IntGroup.prototype.$classData = $d_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $c_Lcats_kernel_instances_LongGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_LongGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_LongGroup.prototype.constructor = $c_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $h_Lcats_kernel_instances_LongGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LongGroup.prototype = $c_Lcats_kernel_instances_LongGroup.prototype;
$c_Lcats_kernel_instances_LongGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__J__J__J = (function(x, y) {
  var alo = x.RTLong__f_lo;
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  var lo = ((alo + y.RTLong__f_lo) | 0);
  var hi = ((((-2147483648) ^ lo) < ((-2147483648) ^ alo)) ? ((1 + ((ahi + bhi) | 0)) | 0) : ((ahi + bhi) | 0));
  return new $c_RTLong(lo, hi)
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__J__J__J($uJ(x), $uJ(y))
});
$c_Lcats_kernel_instances_LongGroup.prototype.empty__O = (function() {
  return $L0
});
var $d_Lcats_kernel_instances_LongGroup = new $TypeData().initClass({
  Lcats_kernel_instances_LongGroup: 0
}, false, "cats.kernel.instances.LongGroup", {
  Lcats_kernel_instances_LongGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_LongGroup.prototype.$classData = $d_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $c_Lcats_kernel_instances_ShortGroup() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_ShortGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortGroup.prototype.constructor = $c_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $h_Lcats_kernel_instances_ShortGroup() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ShortGroup.prototype = $c_Lcats_kernel_instances_ShortGroup.prototype;
$c_Lcats_kernel_instances_ShortGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__S__S__S = (function(x, y) {
  return ((((x + y) | 0) << 16) >> 16)
});
$c_Lcats_kernel_instances_ShortGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__S__S__S($uS(x), $uS(y))
});
$c_Lcats_kernel_instances_ShortGroup.prototype.empty__O = (function() {
  return 0
});
var $d_Lcats_kernel_instances_ShortGroup = new $TypeData().initClass({
  Lcats_kernel_instances_ShortGroup: 0
}, false, "cats.kernel.instances.ShortGroup", {
  Lcats_kernel_instances_ShortGroup: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_ShortGroup.prototype.$classData = $d_Lcats_kernel_instances_ShortGroup;
/** @constructor */
function $c_Lcats_kernel_instances_StringOrder() {
  this.Lcats_kernel_instances_StringOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_StringOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_StringOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_StringOrder.prototype.constructor = $c_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $h_Lcats_kernel_instances_StringOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StringOrder.prototype = $c_Lcats_kernel_instances_StringOrder.prototype;
$c_Lcats_kernel_instances_StringOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__T__T__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__T__T__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I(x, y))
});
$c_Lcats_kernel_instances_StringOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_T(x);
  return $f_T__hashCode__I(x$1)
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T__T__Z($as_T(x), $as_T(y))
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I($as_T(x), $as_T(y))
});
var $d_Lcats_kernel_instances_StringOrder = new $TypeData().initClass({
  Lcats_kernel_instances_StringOrder: 0
}, false, "cats.kernel.instances.StringOrder", {
  Lcats_kernel_instances_StringOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_StringLowerBounded: 1
});
$c_Lcats_kernel_instances_StringOrder.prototype.$classData = $d_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $c_Lcats_kernel_instances_SymbolOrder() {
  this.Lcats_kernel_instances_SymbolOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_SymbolOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_SymbolOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_SymbolOrder.prototype.constructor = $c_Lcats_kernel_instances_SymbolOrder;
/** @constructor */
function $h_Lcats_kernel_instances_SymbolOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_SymbolOrder.prototype = $c_Lcats_kernel_instances_SymbolOrder.prototype;
$c_Lcats_kernel_instances_SymbolOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.eqv__s_Symbol__s_Symbol__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.compare__s_Symbol__s_Symbol__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I(x.name__T(), y.name__T()))
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_Symbol(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_Symbol__s_Symbol__Z($as_s_Symbol(x), $as_s_Symbol(y))
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__s_Symbol__s_Symbol__I($as_s_Symbol(x), $as_s_Symbol(y))
});
var $d_Lcats_kernel_instances_SymbolOrder = new $TypeData().initClass({
  Lcats_kernel_instances_SymbolOrder: 0
}, false, "cats.kernel.instances.SymbolOrder", {
  Lcats_kernel_instances_SymbolOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_SymbolLowerBounded: 1
});
$c_Lcats_kernel_instances_SymbolOrder.prototype.$classData = $d_Lcats_kernel_instances_SymbolOrder;
/** @constructor */
function $c_Lfs2_Pull$Acquire(resource, release, cancelable) {
  this.Lfs2_Pull$Acquire__f_resource = null;
  this.Lfs2_Pull$Acquire__f_release = null;
  this.Lfs2_Pull$Acquire__f_cancelable = false;
  this.Lfs2_Pull$Acquire__f_resource = resource;
  this.Lfs2_Pull$Acquire__f_release = release;
  this.Lfs2_Pull$Acquire__f_cancelable = cancelable
}
$c_Lfs2_Pull$Acquire.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$Acquire.prototype.constructor = $c_Lfs2_Pull$Acquire;
/** @constructor */
function $h_Lfs2_Pull$Acquire() {
  /*<skip>*/
}
$h_Lfs2_Pull$Acquire.prototype = $c_Lfs2_Pull$Acquire.prototype;
$c_Lfs2_Pull$Acquire.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Acquire.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Acquire");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lfs2_Pull$Acquire__f_resource;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x$1 = this.Lfs2_Pull$Acquire__f_release;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var data$3 = (this.Lfs2_Pull$Acquire__f_cancelable ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3)
});
$c_Lfs2_Pull$Acquire.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Acquire)) {
    var x$0$2 = $as_Lfs2_Pull$Acquire(x$0);
    if ((this.Lfs2_Pull$Acquire__f_cancelable === x$0$2.Lfs2_Pull$Acquire__f_cancelable)) {
      var x = this.Lfs2_Pull$Acquire__f_resource;
      var y = x$0$2.Lfs2_Pull$Acquire__f_resource;
      var $$x1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      var x$1 = this.Lfs2_Pull$Acquire__f_release;
      var x$2 = x$0$2.Lfs2_Pull$Acquire__f_release;
      return (x$1 === x$2)
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$Acquire.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Acquire.prototype.productArity__I = (function() {
  return 3
});
$c_Lfs2_Pull$Acquire.prototype.productPrefix__T = (function() {
  return "Acquire"
});
$c_Lfs2_Pull$Acquire.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lfs2_Pull$Acquire__f_resource;
      break
    }
    case 1: {
      return this.Lfs2_Pull$Acquire__f_release;
      break
    }
    case 2: {
      return this.Lfs2_Pull$Acquire__f_cancelable;
      break
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
    }
  }
});
function $as_Lfs2_Pull$Acquire(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Acquire) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Acquire"))
}
function $isArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Acquire)))
}
function $asArrayOf_Lfs2_Pull$Acquire(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Acquire(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Acquire;", depth))
}
var $d_Lfs2_Pull$Acquire = new $TypeData().initClass({
  Lfs2_Pull$Acquire: 0
}, false, "fs2.Pull$Acquire", {
  Lfs2_Pull$Acquire: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Acquire.prototype.$classData = $d_Lfs2_Pull$Acquire;
/** @constructor */
function $c_Lfs2_Pull$Eval(value) {
  this.Lfs2_Pull$Eval__f_value = null;
  this.Lfs2_Pull$Eval__f_value = value
}
$c_Lfs2_Pull$Eval.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$Eval.prototype.constructor = $c_Lfs2_Pull$Eval;
/** @constructor */
function $h_Lfs2_Pull$Eval() {
  /*<skip>*/
}
$h_Lfs2_Pull$Eval.prototype = $c_Lfs2_Pull$Eval.prototype;
$c_Lfs2_Pull$Eval.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$Eval.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$Eval.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$Eval)) {
    var x$0$2 = $as_Lfs2_Pull$Eval(x$0);
    var x = this.Lfs2_Pull$Eval__f_value;
    var y = x$0$2.Lfs2_Pull$Eval__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lfs2_Pull$Eval.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$Eval.prototype.productArity__I = (function() {
  return 1
});
$c_Lfs2_Pull$Eval.prototype.productPrefix__T = (function() {
  return "Eval"
});
$c_Lfs2_Pull$Eval.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$Eval__f_value
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$Eval(obj) {
  return (((obj instanceof $c_Lfs2_Pull$Eval) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$Eval"))
}
function $isArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$Eval)))
}
function $asArrayOf_Lfs2_Pull$Eval(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$Eval(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$Eval;", depth))
}
var $d_Lfs2_Pull$Eval = new $TypeData().initClass({
  Lfs2_Pull$Eval: 0
}, false, "fs2.Pull$Eval", {
  Lfs2_Pull$Eval: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$Eval.prototype.$classData = $d_Lfs2_Pull$Eval;
function $as_Lfs2_Pull$GetScope(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$GetScope"))
}
function $isArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$GetScope)))
}
function $asArrayOf_Lfs2_Pull$GetScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$GetScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$GetScope;", depth))
}
/** @constructor */
function $c_Lfs2_Pull$InterruptWhen(haltOnSignal) {
  this.Lfs2_Pull$InterruptWhen__f_haltOnSignal = null;
  this.Lfs2_Pull$InterruptWhen__f_haltOnSignal = haltOnSignal
}
$c_Lfs2_Pull$InterruptWhen.prototype = new $h_Lfs2_Pull$AlgEffect();
$c_Lfs2_Pull$InterruptWhen.prototype.constructor = $c_Lfs2_Pull$InterruptWhen;
/** @constructor */
function $h_Lfs2_Pull$InterruptWhen() {
  /*<skip>*/
}
$h_Lfs2_Pull$InterruptWhen.prototype = $c_Lfs2_Pull$InterruptWhen.prototype;
$c_Lfs2_Pull$InterruptWhen.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$InterruptWhen.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$InterruptWhen.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$InterruptWhen)) {
    var x$0$2 = $as_Lfs2_Pull$InterruptWhen(x$0);
    var x = this.Lfs2_Pull$InterruptWhen__f_haltOnSignal;
    var y = x$0$2.Lfs2_Pull$InterruptWhen__f_haltOnSignal;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y)
  } else {
    return false
  }
});
$c_Lfs2_Pull$InterruptWhen.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$InterruptWhen.prototype.productArity__I = (function() {
  return 1
});
$c_Lfs2_Pull$InterruptWhen.prototype.productPrefix__T = (function() {
  return "InterruptWhen"
});
$c_Lfs2_Pull$InterruptWhen.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$InterruptWhen__f_haltOnSignal
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
function $as_Lfs2_Pull$InterruptWhen(obj) {
  return (((obj instanceof $c_Lfs2_Pull$InterruptWhen) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$InterruptWhen"))
}
function $isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$InterruptWhen)))
}
function $asArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$InterruptWhen(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$InterruptWhen;", depth))
}
var $d_Lfs2_Pull$InterruptWhen = new $TypeData().initClass({
  Lfs2_Pull$InterruptWhen: 0
}, false, "fs2.Pull$InterruptWhen", {
  Lfs2_Pull$InterruptWhen: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$InterruptWhen.prototype.$classData = $d_Lfs2_Pull$InterruptWhen;
class $c_Lfs2_internal_AcquireAfterScopeClosed$ extends $c_jl_Throwable {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true)
  };
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this)
  };
  hashCode__I() {
    return (-998855110)
  };
  productArity__I() {
    return 0
  };
  productPrefix__T() {
    return "AcquireAfterScopeClosed"
  };
  productElement__I__O(n) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
  };
  fillInStackTrace__jl_Throwable() {
    return this
  };
}
var $d_Lfs2_internal_AcquireAfterScopeClosed$ = new $TypeData().initClass({
  Lfs2_internal_AcquireAfterScopeClosed$: 0
}, false, "fs2.internal.AcquireAfterScopeClosed$", {
  Lfs2_internal_AcquireAfterScopeClosed$: 1,
  jl_Throwable: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lfs2_internal_AcquireAfterScopeClosed$.prototype.$classData = $d_Lfs2_internal_AcquireAfterScopeClosed$;
var $n_Lfs2_internal_AcquireAfterScopeClosed$;
function $m_Lfs2_internal_AcquireAfterScopeClosed$() {
  if ((!$n_Lfs2_internal_AcquireAfterScopeClosed$)) {
    $n_Lfs2_internal_AcquireAfterScopeClosed$ = new $c_Lfs2_internal_AcquireAfterScopeClosed$()
  };
  return $n_Lfs2_internal_AcquireAfterScopeClosed$
}
function $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V($thiz, line) {
  if (($as_T((typeof console)) !== "undefined")) {
    if ($thiz.jl_JSConsoleBasedPrintStream__f_isErr) {
      var x = console.error;
      var $$x1 = $uZ((!(!x)))
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      console.error(line)
    } else {
      console.log(line)
    }
  }
}
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream(isErr) {
  this.Ljava_io_FilterOutputStream__f_out = null;
  this.Ljava_io_PrintStream__f_encoder = null;
  this.Ljava_io_PrintStream__f_autoFlush = false;
  this.Ljava_io_PrintStream__f_charset = null;
  this.Ljava_io_PrintStream__f_closing = false;
  this.Ljava_io_PrintStream__f_java$io$PrintStream$$closed = false;
  this.Ljava_io_PrintStream__f_errorFlag = false;
  this.Ljava_io_PrintStream__f_bitmap$0 = false;
  this.jl_JSConsoleBasedPrintStream__f_isErr = false;
  this.jl_JSConsoleBasedPrintStream__f_flushed = false;
  this.jl_JSConsoleBasedPrintStream__f_buffer = null;
  this.jl_JSConsoleBasedPrintStream__f_isErr = isErr;
  var out = new $c_jl_JSConsoleBasedPrintStream$DummyOutputStream();
  $ct_Ljava_io_PrintStream__Ljava_io_OutputStream__Z__Ljava_nio_charset_Charset__(this, out, false, null);
  this.jl_JSConsoleBasedPrintStream__f_flushed = true;
  this.jl_JSConsoleBasedPrintStream__f_buffer = ""
}
$c_jl_JSConsoleBasedPrintStream.prototype = new $h_Ljava_io_PrintStream();
$c_jl_JSConsoleBasedPrintStream.prototype.constructor = $c_jl_JSConsoleBasedPrintStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream() {
  /*<skip>*/
}
$h_jl_JSConsoleBasedPrintStream.prototype = $c_jl_JSConsoleBasedPrintStream.prototype;
$c_jl_JSConsoleBasedPrintStream.prototype.print__T__V = (function(s) {
  this.java$lang$JSConsoleBasedPrintStream$$printString__T__V(((s === null) ? "null" : s))
});
$c_jl_JSConsoleBasedPrintStream.prototype.java$lang$JSConsoleBasedPrintStream$$printString__T__V = (function(s) {
  var rest = s;
  while ((rest !== "")) {
    var this$1 = rest;
    var nlPos = $uI(this$1.indexOf("\n"));
    if ((nlPos < 0)) {
      this.jl_JSConsoleBasedPrintStream__f_buffer = (("" + this.jl_JSConsoleBasedPrintStream__f_buffer) + rest);
      this.jl_JSConsoleBasedPrintStream__f_flushed = false;
      rest = ""
    } else {
      var $$x1 = this.jl_JSConsoleBasedPrintStream__f_buffer;
      var this$3 = rest;
      $p_jl_JSConsoleBasedPrintStream__doWriteLine__T__V(this, (("" + $$x1) + $as_T(this$3.substring(0, nlPos))));
      this.jl_JSConsoleBasedPrintStream__f_buffer = "";
      this.jl_JSConsoleBasedPrintStream__f_flushed = true;
      var this$4 = rest;
      var beginIndex = ((1 + nlPos) | 0);
      rest = $as_T(this$4.substring(beginIndex))
    }
  }
});
var $d_jl_JSConsoleBasedPrintStream = new $TypeData().initClass({
  jl_JSConsoleBasedPrintStream: 0
}, false, "java.lang.JSConsoleBasedPrintStream", {
  jl_JSConsoleBasedPrintStream: 1,
  Ljava_io_PrintStream: 1,
  Ljava_io_FilterOutputStream: 1,
  Ljava_io_OutputStream: 1,
  O: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1,
  jl_Appendable: 1
});
$c_jl_JSConsoleBasedPrintStream.prototype.$classData = $d_jl_JSConsoleBasedPrintStream;
function $f_sc_BitSetOps__contains__I__Z($thiz, elem) {
  if ((elem >= 0)) {
    var this$1 = $thiz.word__I__J((elem >> 6));
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo & lo);
    var hi$1 = (this$1.RTLong__f_hi & hi);
    return (!((lo$1 === 0) && (hi$1 === 0)))
  } else {
    return false
  }
}
function $f_sc_BitSetOps__size__I($thiz) {
  var s = 0;
  var i = $thiz.nwords__I();
  while ((i > 0)) {
    i = (((-1) + i) | 0);
    var $$x1 = s;
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    s = (($$x1 + (($m_jl_Integer$().bitCount__I__I(lo) + $m_jl_Integer$().bitCount__I__I(hi)) | 0)) | 0)
  };
  return s
}
function $f_sc_BitSetOps__isEmpty__Z($thiz) {
  var end = $thiz.nwords__I();
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  var res = true;
  var it = new $c_sci_RangeIterator(0, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
  while ((res && it.sci_RangeIterator__f__hasNext)) {
    var arg1 = it.next__I();
    var this$6 = $thiz.word__I__J(arg1);
    res = ((this$6.RTLong__f_lo === 0) && (this$6.RTLong__f_hi === 0))
  };
  return res
}
function $f_sc_BitSetOps__max__s_math_Ordering__I($thiz, ord) {
  if (($m_s_math_Ordering$Int$() === ord)) {
    var i = (((-1) + $thiz.nwords__I()) | 0);
    while ((i >= 0)) {
      var t = $thiz.word__I__J(i);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((!((lo === 0) && (hi === 0)))) {
        return (((-1) + (((((1 + i) | 0) << 6) - ((hi !== 0) ? Math.clz32(hi) : ((32 + Math.clz32(lo)) | 0))) | 0)) | 0)
      };
      i = (((-1) + i) | 0)
    };
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.largestInt")
  } else {
    var this$2 = $m_s_math_Ordering$Int$();
    if ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$2, ord)) {
      var thisnwords = $thiz.nwords__I();
      var i$1 = 0;
      while ((i$1 < thisnwords)) {
        var t$1 = $thiz.word__I__J(i$1);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        if ((!((lo$1 === 0) && (hi$1 === 0)))) {
          return ((((lo$1 !== 0) ? ((lo$1 === 0) ? 32 : ((31 - Math.clz32((lo$1 & ((-lo$1) | 0)))) | 0)) : ((32 + ((hi$1 === 0) ? 32 : ((31 - Math.clz32((hi$1 & ((-hi$1) | 0)))) | 0))) | 0)) + (i$1 << 6)) | 0)
        };
        i$1 = ((1 + i$1) | 0)
      };
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.smallestInt")
    } else {
      return $thiz.scala$collection$BitSetOps$$super$max__s_math_Ordering__I(ord)
    }
  }
}
function $f_sc_BitSetOps__foreach__F1__V($thiz, f) {
  var i = 0;
  while ((i < $thiz.nwords__I())) {
    var t = $thiz.word__I__J(i);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var w__lo = lo;
    var w__hi = hi;
    var j = (i << 6);
    while (true) {
      var this$1__lo = w__lo;
      var this$1__hi = w__hi;
      if ((!((this$1__lo === 0) && (this$1__hi === 0)))) {
        var b__lo = w__lo;
        var b__hi = w__hi;
        var lo$1 = (1 & b__lo);
        if ((lo$1 === 1)) {
          f.apply__O__O(j)
        };
        var this$2__lo = w__lo;
        var this$2__hi = w__hi;
        var hi$1 = this$2__hi;
        var lo$2 = (((this$2__lo >>> 1) | 0) | (hi$1 << 31));
        var hi$2 = ((hi$1 >>> 1) | 0);
        var $$x1__lo = lo$2;
        var $$x1__hi = hi$2;
        w__lo = $$x1__lo;
        w__hi = $$x1__hi;
        j = ((1 + j) | 0)
      } else {
        break
      }
    };
    i = ((1 + i) | 0)
  }
}
function $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet($thiz, other) {
  if ($is_sc_BitSet(other)) {
    var x2 = $as_sc_BitSet(other);
    var x = $as_sc_BitSetOps($thiz).nwords__I();
    var that = x2.nwords__I();
    var len = ((x > that) ? x : that);
    var words = new $ac_J(len);
    var isEmpty = (len <= 0);
    var scala$collection$immutable$Range$$lastElement = (((-1) + len) | 0);
    if ((!isEmpty)) {
      var i = 0;
      while (true) {
        var v1 = i;
        var this$10 = $thiz.word__I__J(v1);
        var b = x2.word__I__J(v1);
        var lo = (this$10.RTLong__f_lo | b.RTLong__f_lo);
        var hi$2 = (this$10.RTLong__f_hi | b.RTLong__f_hi);
        words.set(v1, new $c_RTLong(lo, hi$2));
        if ((i === scala$collection$immutable$Range$$lastElement)) {
          break
        };
        i = ((1 + i) | 0)
      }
    };
    return $thiz.fromBitMaskNoCopy__AJ__sc_BitSet(words)
  } else {
    return $thiz.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet(other)
  }
}
function $is_sc_BitSetOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSetOps)))
}
function $as_sc_BitSetOps(obj) {
  return (($is_sc_BitSetOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSetOps"))
}
function $isArrayOf_sc_BitSetOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSetOps)))
}
function $asArrayOf_sc_BitSetOps(obj, depth) {
  return (($isArrayOf_sc_BitSetOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSetOps;", depth))
}
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || s.isEmpty__Z())) {
      return s
    } else {
      var temp$n = (((-1) + n) | 0);
      var temp$s = $as_sc_LinearSeq(s.tail__O());
      n = temp$n;
      s = temp$s
    }
  }
}
function $is_sc_StrictOptimizedLinearSeqOps(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_StrictOptimizedLinearSeqOps)))
}
function $as_sc_StrictOptimizedLinearSeqOps(obj) {
  return (($is_sc_StrictOptimizedLinearSeqOps(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StrictOptimizedLinearSeqOps"))
}
function $isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StrictOptimizedLinearSeqOps)))
}
function $asArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) {
  return (($isArrayOf_sc_StrictOptimizedLinearSeqOps(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StrictOptimizedLinearSeqOps;", depth))
}
function $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  if (($thiz.lengthCompare__I__I(1) <= 0)) {
    return $thiz
  } else {
    var builder = $thiz.newSpecificBuilder__scm_Builder();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = $thiz.iterator__sc_Iterator();
    var different = false;
    while (it.hasNext__Z()) {
      var next = it.next__O();
      if (seen.add__O__Z(f.apply__O__O(next))) {
        builder.addOne__O__scm_Growable(next)
      } else {
        different = true
      }
    };
    return (different ? builder.result__O() : $thiz)
  }
}
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $$x3 = $thiz.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = $thiz.s_math_BigDecimal__f_bigDecimal;
    var $$x2 = ((($$x3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934)
  } else {
    var $$x2 = false
  };
  if ($$x2) {
    var $$x1 = $thiz.toBigInt__s_math_BigInt().hashCode__I()
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $thiz.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
    var $$x1 = $m_sr_Statics$().doubleHash__D__I(dv)
  } else {
    var temp = $thiz.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    var $$x1 = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(temp.scaleByPowerOfTen__I__Ljava_math_BigDecimal(temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale).toBigInteger__Ljava_math_BigInteger().hashCode__I(), temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)
  };
  $thiz.s_math_BigDecimal__f_computedHashCode = $$x1
}
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0;
  this.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  this.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal")
  };
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal")
  };
  this.s_math_BigDecimal__f_computedHashCode = 1565550863
}
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
  /*<skip>*/
}
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.compareTo__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that$1.s_math_BigDecimal__f_bigDecimal)
});
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this)
  };
  return this.s_math_BigDecimal__f_computedHashCode
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    var x2 = $as_s_math_BigDecimal(that);
    return this.equals__s_math_BigDecimal__Z(x2)
  } else if ((that instanceof $c_s_math_BigInt)) {
    var x3 = $as_s_math_BigInt(that);
    var $$x2 = x3.bitLength__I();
    var $$x1 = this.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    if (($$x2 > (3.3219280948873626 * (((-2) + (($$x1 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)) | 0)))) {
      var this$2 = this.toBigIntExact__s_Option();
      if ((!this$2.isEmpty__Z())) {
        var arg1 = this$2.get__O();
        var x$1 = $as_s_math_BigInt(arg1);
        return x3.equals__s_math_BigInt__Z(x$1)
      } else {
        return false
      }
    } else {
      return false
    }
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$9.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$9.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = this.s_math_BigDecimal__f_bigDecimal.floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$16.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$16.s_math_BigDecimal$__f_defaultMathContext))
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.byteValueExact__B();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.shortValueExact__S();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() >= 0)) && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() <= 65535))
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.intValueExact__I();
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false
    } else {
      throw e
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext))
  } else {
    return false
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = this.s_math_BigDecimal__f_bigDecimal;
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true
  } else {
    var this$2 = this.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return (this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that.s_math_BigDecimal__f_bigDecimal) === 0)
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 24) >> 24)
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 16) >> 16)
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.intValue__I()
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.longValue__J()
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.floatValue__F()
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.doubleValue__D()
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.s_math_BigDecimal__f_bigDecimal.toBigInteger__Ljava_math_BigInteger())
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.s_math_BigDecimal__f_bigDecimal.toBigIntegerExact__Ljava_math_BigInteger()))
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$()
      } else {
        throw e
      }
    }
  } else {
    return $m_s_None$()
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.toString__T()
});
$c_s_math_BigDecimal.prototype.compare__O__I = (function(that) {
  var that$1 = $as_s_math_BigDecimal(that);
  return this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that$1.s_math_BigDecimal__f_bigDecimal)
});
function $as_s_math_BigDecimal(obj) {
  return (((obj instanceof $c_s_math_BigDecimal) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigDecimal"))
}
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)))
}
function $asArrayOf_s_math_BigDecimal(obj, depth) {
  return (($isArrayOf_s_math_BigDecimal(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigDecimal;", depth))
}
var $d_s_math_BigDecimal = new $TypeData().initClass({
  s_math_BigDecimal: 0
}, false, "scala.math.BigDecimal", {
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigDecimal.prototype.$classData = $d_s_math_BigDecimal;
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var this$1 = $thiz.s_math_BigInt__f__long;
  return (!((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === (-2147483648))))
}
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.bigInteger__Ljava_math_BigInteger().shiftRight__I__Ljava_math_BigInteger(2147483647);
  return ((shifted.Ljava_math_BigInteger__f_sign !== 0) && (!shifted.equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne)))
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long) {
  $thiz.s_math_BigInt__f__bigInteger = _bigInteger;
  $thiz.s_math_BigInt__f__long = _long;
  return $thiz
}
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) <= 63) ? bigInteger.longValue__J() : new $c_RTLong(0, (-2147483648))));
  return $thiz
}
/** @constructor */
function $c_s_math_BigInt() {
  this.s_math_BigInt__f__bigInteger = null;
  this.s_math_BigInt__f__long = $L0
}
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
  /*<skip>*/
}
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that))
});
$c_s_math_BigInt.prototype.bigInteger__Ljava_math_BigInteger = (function() {
  var read = this.s_math_BigInt__f__bigInteger;
  if ((read !== null)) {
    return read
  } else {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var write = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
    this.s_math_BigInt__f__bigInteger = write;
    return write
  }
});
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this)
  } else {
    var x = this.bigInteger__Ljava_math_BigInteger();
    return $m_sr_Statics$().anyHash__O__I(x)
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    var x2 = $as_s_math_BigInt(that);
    return this.equals__s_math_BigInt__Z(x2)
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    var x3 = $as_s_math_BigDecimal(that);
    return x3.equals__O__Z(this)
  } else if (((typeof that) === "number")) {
    var x4 = $uD(that);
    return (this.isValidDouble__Z() && (this.doubleValue__D() === x4))
  } else if ($isFloat(that)) {
    var x5 = $uF(that);
    if (this.isValidFloat__Z()) {
      var this$1 = this.bigInteger__Ljava_math_BigInteger();
      var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
      return ($m_jl_Float$().parseFloat__T__F(s) === x5)
    } else {
      return false
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that))
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147483520) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147483521)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 2147450880) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147450881)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if ((ahi >= 0)) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-2147418113)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var this$1 = this.s_math_BigInt__f__long;
  var ahi = this$1.RTLong__f_hi;
  if (((ahi === (-1)) ? (((-2147483648) ^ this$1.RTLong__f_lo) >= 0) : (ahi > (-1)))) {
    var this$2 = this.s_math_BigInt__f__long;
    var ahi$1 = this$2.RTLong__f_hi;
    return ((ahi$1 === 0) ? (((-2147483648) ^ this$2.RTLong__f_lo) <= (-1)) : (ahi$1 < 0))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger))
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 24)) {
    var $$x1 = true
  } else {
    var lowest = this.lowestSetBit__I();
    var $$x1 = (((bitLen <= 128) && (lowest >= (((-24) + bitLen) | 0))) && (lowest < 128))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 53)) {
    var $$x1 = true
  } else {
    var lowest = this.lowestSetBit__I();
    var $$x1 = (((bitLen <= 1024) && (lowest >= (((-53) + bitLen) | 0))) && (lowest < 1024))
  };
  if ($$x1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this))
  } else {
    return false
  }
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var this$1 = this.s_math_BigInt__f__long;
      var b = that.s_math_BigInt__f__long;
      return ((this$1.RTLong__f_lo === b.RTLong__f_lo) && (this$1.RTLong__f_hi === b.RTLong__f_hi))
    } else {
      return false
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z(that)) && $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, that.s_math_BigInt__f__bigInteger))
  }
});
$c_s_math_BigInt.prototype.compare__s_math_BigInt__I = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = that.s_math_BigInt__f__long;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1)
    } else {
      var this$1 = that.s_math_BigInt__f__bigInteger;
      return ((-this$1.Ljava_math_BigInteger__f_sign) | 0)
    }
  } else if ($p_s_math_BigInt__longEncoding__Z(that)) {
    var this$2 = this.s_math_BigInt__f__bigInteger;
    return this$2.Ljava_math_BigInteger__f_sign
  } else {
    return this.s_math_BigInt__f__bigInteger.compareTo__Ljava_math_BigInteger__I(that.s_math_BigInt__f__bigInteger)
  }
});
$c_s_math_BigInt.prototype.$plus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z(that))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var lo$2 = ((lo + lo$1) | 0);
    var hi$2 = ((((-2147483648) ^ lo$2) < ((-2147483648) ^ lo)) ? ((1 + ((hi + hi$1) | 0)) | 0) : ((hi + hi$1) | 0));
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (~hi$3);
    var hi$5 = (hi ^ hi$2);
    var hi$6 = (hi$4 & hi$5);
    if ((hi$6 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2))
    }
  };
  var $$x1 = $m_s_math_BigInt$();
  var this$2 = this.bigInteger__Ljava_math_BigInteger();
  var bi = that.bigInteger__Ljava_math_BigInteger();
  return $$x1.apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, bi))
});
$c_s_math_BigInt.prototype.lowestSetBit__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    if (((this$1.RTLong__f_lo === 0) && (this$1.RTLong__f_hi === 0))) {
      return (-1)
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return ((lo !== 0) ? ((lo === 0) ? 32 : ((31 - Math.clz32((lo & ((-lo) | 0)))) | 0)) : ((32 + ((hi === 0) ? 32 : ((31 - Math.clz32((hi & ((-hi) | 0)))) | 0))) | 0))
    }
  } else {
    return this.bigInteger__Ljava_math_BigInteger().getLowestSetBit__I()
  }
});
$c_s_math_BigInt.prototype.bitLength__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi < 0)) {
      var b = this.s_math_BigInt__f__long;
      var bhi = b.RTLong__f_hi;
      var lo = ((1 + b.RTLong__f_lo) | 0);
      var hi = ((lo === 0) ? ((1 + bhi) | 0) : bhi);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((lo !== 0) ? (~hi) : ((-hi) | 0));
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0)
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo$2 = t.RTLong__f_lo;
      var hi$2 = t.RTLong__f_hi;
      return ((64 - ((hi$2 !== 0) ? Math.clz32(hi$2) : ((32 + Math.clz32(lo$2)) | 0))) | 0)
    }
  } else {
    var this$7 = this.s_math_BigInt__f__bigInteger;
    return $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$7)
  }
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.intValue__I() << 24) >> 24)
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.intValue__I() << 16) >> 16)
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return this$1.RTLong__f_lo
  } else {
    return this.bigInteger__Ljava_math_BigInteger().intValue__I()
  }
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? this.s_math_BigInt__f__long : this.s_math_BigInt__f__bigInteger.longValue__J())
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = this.bigInteger__Ljava_math_BigInteger();
  var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  return $m_jl_Float$().parseFloat__T__F(s)
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  if (this.isValidLong__Z()) {
    var this$1 = this.s_math_BigInt__f__long;
    var ahi = this$1.RTLong__f_hi;
    if ((ahi >= (-2097152))) {
      var this$2 = this.s_math_BigInt__f__long;
      var ahi$1 = this$2.RTLong__f_hi;
      var $$x1 = ((ahi$1 === 2097152) ? (this$2.RTLong__f_lo === 0) : (ahi$1 < 2097152))
    } else {
      var $$x1 = false
    }
  } else {
    var $$x1 = false
  };
  if ($$x1) {
    var this$3 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(this$3.RTLong__f_lo, this$3.RTLong__f_hi)
  } else {
    var this$4 = this.bigInteger__Ljava_math_BigInteger();
    var s = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$4);
    return $m_jl_Double$().parseDouble__T__D(s)
  }
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi)
  } else {
    var this$2 = this.s_math_BigInt__f__bigInteger;
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$2)
  }
});
$c_s_math_BigInt.prototype.compare__O__I = (function(that) {
  return this.compare__s_math_BigInt__I($as_s_math_BigInt(that))
});
function $as_s_math_BigInt(obj) {
  return (((obj instanceof $c_s_math_BigInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.math.BigInt"))
}
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)))
}
function $asArrayOf_s_math_BigInt(obj, depth) {
  return (($isArrayOf_s_math_BigInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.math.BigInt;", depth))
}
var $d_s_math_BigInt = new $TypeData().initClass({
  s_math_BigInt: 0
}, false, "scala.math.BigInt", {
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
});
$c_s_math_BigInt.prototype.$classData = $d_s_math_BigInt;
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = null;
  $n_s_math_Ordering$Int$ = this;
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = new $c_s_math_Ordering$Reverse(this)
}
$c_s_math_Ordering$Int$.prototype = new $h_O();
$c_s_math_Ordering$Int$.prototype.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
  /*<skip>*/
}
$h_s_math_Ordering$Int$.prototype = $c_s_math_Ordering$Int$.prototype;
$c_s_math_Ordering$Int$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other)
});
$c_s_math_Ordering$Int$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y)
});
$c_s_math_Ordering$Int$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uI(x);
  var y$1 = $uI(y);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1))
});
var $d_s_math_Ordering$Int$ = new $TypeData().initClass({
  s_math_Ordering$Int$: 0
}, false, "scala.math.Ordering$Int$", {
  s_math_Ordering$Int$: 1,
  O: 1,
  s_math_Ordering$IntOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CachedReverse: 1
});
$c_s_math_Ordering$Int$.prototype.$classData = $d_s_math_Ordering$Int$;
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$()
  };
  return $n_s_math_Ordering$Int$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf()
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf()
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf()
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf()
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf()
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf()
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf()
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that)
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf()
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len)
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0
}
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf()
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len)
});
/** @constructor */
function $c_Ltyrian_Cmd$None$() {
  /*<skip>*/
}
$c_Ltyrian_Cmd$None$.prototype = new $h_O();
$c_Ltyrian_Cmd$None$.prototype.constructor = $c_Ltyrian_Cmd$None$;
/** @constructor */
function $h_Ltyrian_Cmd$None$() {
  /*<skip>*/
}
$h_Ltyrian_Cmd$None$.prototype = $c_Ltyrian_Cmd$None$.prototype;
$c_Ltyrian_Cmd$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Cmd$None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_Ltyrian_Cmd$None$.prototype.toString__T = (function() {
  return "None"
});
$c_Ltyrian_Cmd$None$.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_Cmd$None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_Ltyrian_Cmd$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Ltyrian_Cmd$None$ = new $TypeData().initClass({
  Ltyrian_Cmd$None$: 0
}, false, "tyrian.Cmd$None$", {
  Ltyrian_Cmd$None$: 1,
  O: 1,
  Ltyrian_Cmd: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_Cmd$None$.prototype.$classData = $d_Ltyrian_Cmd$None$;
var $n_Ltyrian_Cmd$None$;
function $m_Ltyrian_Cmd$None$() {
  if ((!$n_Ltyrian_Cmd$None$)) {
    $n_Ltyrian_Cmd$None$ = new $c_Ltyrian_Cmd$None$()
  };
  return $n_Ltyrian_Cmd$None$
}
/** @constructor */
function $c_Ltyrian_Sub$None$() {
  /*<skip>*/
}
$c_Ltyrian_Sub$None$.prototype = new $h_O();
$c_Ltyrian_Sub$None$.prototype.constructor = $c_Ltyrian_Sub$None$;
/** @constructor */
function $h_Ltyrian_Sub$None$() {
  /*<skip>*/
}
$h_Ltyrian_Sub$None$.prototype = $c_Ltyrian_Sub$None$.prototype;
$c_Ltyrian_Sub$None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Ltyrian_Sub$None$.prototype.hashCode__I = (function() {
  return 2433880
});
$c_Ltyrian_Sub$None$.prototype.toString__T = (function() {
  return "None"
});
$c_Ltyrian_Sub$None$.prototype.productArity__I = (function() {
  return 0
});
$c_Ltyrian_Sub$None$.prototype.productPrefix__T = (function() {
  return "None"
});
$c_Ltyrian_Sub$None$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
var $d_Ltyrian_Sub$None$ = new $TypeData().initClass({
  Ltyrian_Sub$None$: 0
}, false, "tyrian.Sub$None$", {
  Ltyrian_Sub$None$: 1,
  O: 1,
  Ltyrian_Sub: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Ltyrian_Sub$None$.prototype.$classData = $d_Ltyrian_Sub$None$;
var $n_Ltyrian_Sub$None$;
function $m_Ltyrian_Sub$None$() {
  if ((!$n_Ltyrian_Sub$None$)) {
    $n_Ltyrian_Sub$None$ = new $c_Ltyrian_Sub$None$()
  };
  return $n_Ltyrian_Sub$None$
}
function $is_Lcats_Applicative(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_Applicative)))
}
function $as_Lcats_Applicative(obj) {
  return (($is_Lcats_Applicative(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.Applicative"))
}
function $isArrayOf_Lcats_Applicative(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Applicative)))
}
function $asArrayOf_Lcats_Applicative(obj, depth) {
  return (($isArrayOf_Lcats_Applicative(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.Applicative;", depth))
}
function $f_Lcats_data_KleisliApply__map2Eval__Lcats_data_Kleisli__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  var memoFb = fb.memoize__Lcats_Eval();
  $m_Lcats_Eval$();
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2, memoFb$2) => ((a) => {
    var fb$1 = fa$2.Lcats_data_Kleisli__f_run.apply__O__O(a);
    var efc = memoFb$2.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((a$2) => ((_$164) => {
      var _$164$1 = $as_Lcats_data_Kleisli(_$164);
      return _$164$1.Lcats_data_Kleisli__f_run.apply__O__O(a$2)
    }))(a)));
    var efz = this$1.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(fb$1, efc, f$2);
    return efz.value__O()
  }))($thiz, fa, f, memoFb));
  var a$1 = new $c_Lcats_data_Kleisli(run);
  return new $c_Lcats_Now(a$1)
}
function $f_Lcats_data_KleisliApply__product__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fb, fc) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, fb$2, fc$2) => ((a) => this$1.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1.product__O__O__O(fb$2.Lcats_data_Kleisli__f_run.apply__O__O(a), fc$2.Lcats_data_Kleisli__f_run.apply__O__O(a))))($thiz, fb, fc));
  return new $c_Lcats_data_Kleisli(run)
}
/** @constructor */
function $c_Lcats_data_KleisliInstances1() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null
}
$c_Lcats_data_KleisliInstances1.prototype = new $h_Lcats_data_KleisliInstances2();
$c_Lcats_data_KleisliInstances1.prototype.constructor = $c_Lcats_data_KleisliInstances1;
/** @constructor */
function $h_Lcats_data_KleisliInstances1() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances1.prototype = $c_Lcats_data_KleisliInstances1.prototype;
/** @constructor */
function $c_Lcats_effect_IO$Canceled$() {
  /*<skip>*/
}
$c_Lcats_effect_IO$Canceled$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Canceled$.prototype.constructor = $c_Lcats_effect_IO$Canceled$;
/** @constructor */
function $h_Lcats_effect_IO$Canceled$() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Canceled$.prototype = $c_Lcats_effect_IO$Canceled$.prototype;
$c_Lcats_effect_IO$Canceled$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Canceled$.prototype.hashCode__I = (function() {
  return (-58529607)
});
$c_Lcats_effect_IO$Canceled$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_IO$Canceled$.prototype.productPrefix__T = (function() {
  return "Canceled"
});
$c_Lcats_effect_IO$Canceled$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Canceled$.prototype.tag__B = (function() {
  return 10
});
var $d_Lcats_effect_IO$Canceled$ = new $TypeData().initClass({
  Lcats_effect_IO$Canceled$: 0
}, false, "cats.effect.IO$Canceled$", {
  Lcats_effect_IO$Canceled$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_IO$Canceled$.prototype.$classData = $d_Lcats_effect_IO$Canceled$;
var $n_Lcats_effect_IO$Canceled$;
function $m_Lcats_effect_IO$Canceled$() {
  if ((!$n_Lcats_effect_IO$Canceled$)) {
    $n_Lcats_effect_IO$Canceled$ = new $c_Lcats_effect_IO$Canceled$()
  };
  return $n_Lcats_effect_IO$Canceled$
}
/** @constructor */
function $c_Lcats_effect_IO$EndFiber$() {
  /*<skip>*/
}
$c_Lcats_effect_IO$EndFiber$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$EndFiber$.prototype.constructor = $c_Lcats_effect_IO$EndFiber$;
/** @constructor */
function $h_Lcats_effect_IO$EndFiber$() {
  /*<skip>*/
}
$h_Lcats_effect_IO$EndFiber$.prototype = $c_Lcats_effect_IO$EndFiber$.prototype;
$c_Lcats_effect_IO$EndFiber$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$EndFiber$.prototype.hashCode__I = (function() {
  return 1766772977
});
$c_Lcats_effect_IO$EndFiber$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_IO$EndFiber$.prototype.productPrefix__T = (function() {
  return "EndFiber"
});
$c_Lcats_effect_IO$EndFiber$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$EndFiber$.prototype.tag__B = (function() {
  return (-1)
});
var $d_Lcats_effect_IO$EndFiber$ = new $TypeData().initClass({
  Lcats_effect_IO$EndFiber$: 0
}, false, "cats.effect.IO$EndFiber$", {
  Lcats_effect_IO$EndFiber$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_IO$EndFiber$.prototype.$classData = $d_Lcats_effect_IO$EndFiber$;
var $n_Lcats_effect_IO$EndFiber$;
function $m_Lcats_effect_IO$EndFiber$() {
  if ((!$n_Lcats_effect_IO$EndFiber$)) {
    $n_Lcats_effect_IO$EndFiber$ = new $c_Lcats_effect_IO$EndFiber$()
  };
  return $n_Lcats_effect_IO$EndFiber$
}
/** @constructor */
function $c_Lcats_effect_IO$Monotonic$() {
  /*<skip>*/
}
$c_Lcats_effect_IO$Monotonic$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$Monotonic$.prototype.constructor = $c_Lcats_effect_IO$Monotonic$;
/** @constructor */
function $h_Lcats_effect_IO$Monotonic$() {
  /*<skip>*/
}
$h_Lcats_effect_IO$Monotonic$.prototype = $c_Lcats_effect_IO$Monotonic$.prototype;
$c_Lcats_effect_IO$Monotonic$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$Monotonic$.prototype.hashCode__I = (function() {
  return 572915850
});
$c_Lcats_effect_IO$Monotonic$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_IO$Monotonic$.prototype.productPrefix__T = (function() {
  return "Monotonic"
});
$c_Lcats_effect_IO$Monotonic$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$Monotonic$.prototype.tag__B = (function() {
  return 4
});
var $d_Lcats_effect_IO$Monotonic$ = new $TypeData().initClass({
  Lcats_effect_IO$Monotonic$: 0
}, false, "cats.effect.IO$Monotonic$", {
  Lcats_effect_IO$Monotonic$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_IO$Monotonic$.prototype.$classData = $d_Lcats_effect_IO$Monotonic$;
var $n_Lcats_effect_IO$Monotonic$;
function $m_Lcats_effect_IO$Monotonic$() {
  if ((!$n_Lcats_effect_IO$Monotonic$)) {
    $n_Lcats_effect_IO$Monotonic$ = new $c_Lcats_effect_IO$Monotonic$()
  };
  return $n_Lcats_effect_IO$Monotonic$
}
/** @constructor */
function $c_Lcats_effect_IO$ReadEC$() {
  /*<skip>*/
}
$c_Lcats_effect_IO$ReadEC$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$ReadEC$.prototype.constructor = $c_Lcats_effect_IO$ReadEC$;
/** @constructor */
function $h_Lcats_effect_IO$ReadEC$() {
  /*<skip>*/
}
$h_Lcats_effect_IO$ReadEC$.prototype = $c_Lcats_effect_IO$ReadEC$.prototype;
$c_Lcats_effect_IO$ReadEC$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$ReadEC$.prototype.hashCode__I = (function() {
  return (-1851113260)
});
$c_Lcats_effect_IO$ReadEC$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_IO$ReadEC$.prototype.productPrefix__T = (function() {
  return "ReadEC"
});
$c_Lcats_effect_IO$ReadEC$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$ReadEC$.prototype.tag__B = (function() {
  return 5
});
var $d_Lcats_effect_IO$ReadEC$ = new $TypeData().initClass({
  Lcats_effect_IO$ReadEC$: 0
}, false, "cats.effect.IO$ReadEC$", {
  Lcats_effect_IO$ReadEC$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_IO$ReadEC$.prototype.$classData = $d_Lcats_effect_IO$ReadEC$;
var $n_Lcats_effect_IO$ReadEC$;
function $m_Lcats_effect_IO$ReadEC$() {
  if ((!$n_Lcats_effect_IO$ReadEC$)) {
    $n_Lcats_effect_IO$ReadEC$ = new $c_Lcats_effect_IO$ReadEC$()
  };
  return $n_Lcats_effect_IO$ReadEC$
}
/** @constructor */
function $c_Lcats_effect_IO$RealTime$() {
  /*<skip>*/
}
$c_Lcats_effect_IO$RealTime$.prototype = new $h_Lcats_effect_IO();
$c_Lcats_effect_IO$RealTime$.prototype.constructor = $c_Lcats_effect_IO$RealTime$;
/** @constructor */
function $h_Lcats_effect_IO$RealTime$() {
  /*<skip>*/
}
$h_Lcats_effect_IO$RealTime$.prototype = $c_Lcats_effect_IO$RealTime$.prototype;
$c_Lcats_effect_IO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lcats_effect_IO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285)
});
$c_Lcats_effect_IO$RealTime$.prototype.productArity__I = (function() {
  return 0
});
$c_Lcats_effect_IO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime"
});
$c_Lcats_effect_IO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lcats_effect_IO$RealTime$.prototype.tag__B = (function() {
  return 3
});
var $d_Lcats_effect_IO$RealTime$ = new $TypeData().initClass({
  Lcats_effect_IO$RealTime$: 0
}, false, "cats.effect.IO$RealTime$", {
  Lcats_effect_IO$RealTime$: 1,
  Lcats_effect_IO: 1,
  Lcats_effect_IOPlatform: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lcats_effect_IO$RealTime$.prototype.$classData = $d_Lcats_effect_IO$RealTime$;
var $n_Lcats_effect_IO$RealTime$;
function $m_Lcats_effect_IO$RealTime$() {
  if ((!$n_Lcats_effect_IO$RealTime$)) {
    $n_Lcats_effect_IO$RealTime$ = new $c_Lcats_effect_IO$RealTime$()
  };
  return $n_Lcats_effect_IO$RealTime$
}
/** @constructor */
function $c_Lcats_instances_EqInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_EqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EqInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EqInstances$$anon$1.prototype = $c_Lcats_instances_EqInstances$$anon$1.prototype;
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__Lcats_kernel_Eq__Lcats_kernel_Eq__Lcats_kernel_Eq = (function(fa, fb) {
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2(((fa$2, fb$2) => ((left, right) => {
    var left$1 = $as_T2(left);
    var right$1 = $as_T2(right);
    return (fa$2.eqv__O__O__Z(left$1._1__O(), right$1._1__O()) && fb$2.eqv__O__O__Z(left$1._2__O(), right$1._2__O()))
  }))(fa, fb));
  return new $c_Lcats_kernel_Eq$$anon$4(f)
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_kernel_Eq__Lcats_kernel_Eq__Lcats_kernel_Eq($as_Lcats_kernel_Eq(fa), $as_Lcats_kernel_Eq(fb))
});
var $d_Lcats_instances_EqInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EqInstances$$anon$1: 0
}, false, "cats.instances.EqInstances$$anon$1", {
  Lcats_instances_EqInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_EqInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EqInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_EquivInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_EquivInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_EquivInstances$$anon$1.prototype.constructor = $c_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_EquivInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_EquivInstances$$anon$1.prototype = $c_Lcats_instances_EquivInstances$$anon$1.prototype;
$c_Lcats_instances_EquivInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Equiv(fa);
  var fb$1 = $as_s_math_Equiv(fb);
  return new $c_Lcats_instances_EquivInstances$$anon$4(fa$1, fb$1)
});
var $d_Lcats_instances_EquivInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_EquivInstances$$anon$1: 0
}, false, "cats.instances.EquivInstances$$anon$1", {
  Lcats_instances_EquivInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_EquivInstances$$anon$1.prototype.$classData = $d_Lcats_instances_EquivInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_OrderInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_OrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OrderInstances$$anon$1.prototype = $c_Lcats_instances_OrderInstances$$anon$1.prototype;
$c_Lcats_instances_OrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_Order(fa);
  var fb$1 = $as_Lcats_kernel_Order(fb);
  return new $c_Lcats_instances_OrderInstances$$anon$2(fa$1, fb$1)
});
var $d_Lcats_instances_OrderInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OrderInstances$$anon$1: 0
}, false, "cats.instances.OrderInstances$$anon$1", {
  Lcats_instances_OrderInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_OrderInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OrderInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_OrderingInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_OrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OrderingInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OrderingInstances$$anon$1.prototype = $c_Lcats_instances_OrderingInstances$$anon$1.prototype;
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_Ordering(fa);
  var fb$1 = $as_s_math_Ordering(fb);
  return new $c_Lcats_instances_OrderingInstances$$anon$2(fa$1, fb$1)
});
var $d_Lcats_instances_OrderingInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OrderingInstances$$anon$1: 0
}, false, "cats.instances.OrderingInstances$$anon$1", {
  Lcats_instances_OrderingInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_OrderingInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OrderingInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_kernel_PartialOrder(fa);
  var fb$1 = $as_Lcats_kernel_PartialOrder(fb);
  return new $c_Lcats_instances_PartialOrderInstances$$anon$2(fa$1, fb$1)
});
var $d_Lcats_instances_PartialOrderInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_PartialOrderInstances$$anon$1: 0
}, false, "cats.instances.PartialOrderInstances$$anon$1", {
  Lcats_instances_PartialOrderInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_PartialOrderInstances$$anon$1.prototype.$classData = $d_Lcats_instances_PartialOrderInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_PartialOrderingInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.constructor = $c_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_PartialOrderingInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_PartialOrderingInstances$$anon$1.prototype = $c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype;
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  var fa$1 = $as_s_math_PartialOrdering(fa);
  var fb$1 = $as_s_math_PartialOrdering(fb);
  return new $c_Lcats_instances_PartialOrderingInstances$$anon$3(fa$1, fb$1)
});
var $d_Lcats_instances_PartialOrderingInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_PartialOrderingInstances$$anon$1: 0
}, false, "cats.instances.PartialOrderingInstances$$anon$1", {
  Lcats_instances_PartialOrderingInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Semigroupal: 1,
  Lcats_Invariant: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_Contravariant: 1,
  Lcats_ContravariantSemigroupal: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_ContravariantMonoidal: 1
});
$c_Lcats_instances_PartialOrderingInstances$$anon$1.prototype.$classData = $d_Lcats_instances_PartialOrderingInstances$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BitSetSemilattice() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BitSetSemilattice.prototype = new $h_O();
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.constructor = $c_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $h_Lcats_kernel_instances_BitSetSemilattice() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BitSetSemilattice.prototype = $c_Lcats_kernel_instances_BitSetSemilattice.prototype;
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.empty__O = (function() {
  return $m_sci_BitSet$().sci_BitSet$__f_empty
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.combine__O__O__O = (function(x, y) {
  var x$1 = $as_sci_BitSet(x);
  var y$1 = $as_sci_BitSet(y);
  return $as_sci_BitSet($f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(x$1, y$1))
});
var $d_Lcats_kernel_instances_BitSetSemilattice = new $TypeData().initClass({
  Lcats_kernel_instances_BitSetSemilattice: 0
}, false, "cats.kernel.instances.BitSetSemilattice", {
  Lcats_kernel_instances_BitSetSemilattice: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1
});
$c_Lcats_kernel_instances_BitSetSemilattice.prototype.$classData = $d_Lcats_kernel_instances_BitSetSemilattice;
/** @constructor */
function $c_Lcats_kernel_instances_DurationOrder() {
  this.Lcats_kernel_instances_DurationOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_DurationOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_DurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_DurationOrder.prototype.constructor = $c_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_DurationOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_DurationOrder.prototype = $c_Lcats_kernel_instances_DurationOrder.prototype;
$c_Lcats_kernel_instances_DurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y))
});
$c_Lcats_kernel_instances_DurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_DurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_Duration(x);
  var y$1 = $as_s_concurrent_duration_Duration(y);
  return x$1.compare__s_concurrent_duration_Duration__I(y$1)
});
$c_Lcats_kernel_instances_DurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_Duration__s_concurrent_duration_Duration__Z($as_s_concurrent_duration_Duration(x), $as_s_concurrent_duration_Duration(y))
});
var $d_Lcats_kernel_instances_DurationOrder = new $TypeData().initClass({
  Lcats_kernel_instances_DurationOrder: 0
}, false, "cats.kernel.instances.DurationOrder", {
  Lcats_kernel_instances_DurationOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_DurationBounded: 1
});
$c_Lcats_kernel_instances_DurationOrder.prototype.$classData = $d_Lcats_kernel_instances_DurationOrder;
/** @constructor */
function $c_Lcats_kernel_instances_FiniteDurationOrder() {
  this.Lcats_kernel_instances_FiniteDurationOrder__f_partialOrder = null;
  this.Lcats_kernel_instances_FiniteDurationOrder__f_partialOrder = this
}
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.constructor = $c_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $h_Lcats_kernel_instances_FiniteDurationOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_FiniteDurationOrder.prototype = $c_Lcats_kernel_instances_FiniteDurationOrder.prototype;
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z = (function(x, y) {
  return ((x === null) ? (y === null) : x.equals__O__Z(y))
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var this$1 = x$1.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(x$1.s_concurrent_duration_FiniteDuration__f_length);
  return this$1.RTLong__f_lo
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_concurrent_duration_FiniteDuration(x);
  var y$1 = $as_s_concurrent_duration_FiniteDuration(y);
  return x$1.compare__s_concurrent_duration_Duration__I(y$1)
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration__Z($as_s_concurrent_duration_FiniteDuration(x), $as_s_concurrent_duration_FiniteDuration(y))
});
var $d_Lcats_kernel_instances_FiniteDurationOrder = new $TypeData().initClass({
  Lcats_kernel_instances_FiniteDurationOrder: 0
}, false, "cats.kernel.instances.FiniteDurationOrder", {
  Lcats_kernel_instances_FiniteDurationOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_FiniteDurationBounded: 1
});
$c_Lcats_kernel_instances_FiniteDurationOrder.prototype.$classData = $d_Lcats_kernel_instances_FiniteDurationOrder;
/** @constructor */
function $c_Lcats_kernel_instances_UUIDInstances$$anon$1() {
  this.Lcats_kernel_instances_UUIDInstances$$anon$1__f_partialOrder = null;
  this.Lcats_kernel_instances_UUIDInstances$$anon$1__f_partialOrder = this
}
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.constructor = $c_Lcats_kernel_instances_UUIDInstances$$anon$1;
/** @constructor */
function $h_Lcats_kernel_instances_UUIDInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype = $c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype;
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_ju_UUID(x);
  var y$1 = $as_ju_UUID(y);
  return x$1.compareTo__ju_UUID__I(y$1)
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.hash__O__I = (function(x) {
  var x$1 = $as_ju_UUID(x);
  return x$1.hashCode__I()
});
var $d_Lcats_kernel_instances_UUIDInstances$$anon$1 = new $TypeData().initClass({
  Lcats_kernel_instances_UUIDInstances$$anon$1: 0
}, false, "cats.kernel.instances.UUIDInstances$$anon$1", {
  Lcats_kernel_instances_UUIDInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UUIDBounded: 1
});
$c_Lcats_kernel_instances_UUIDInstances$$anon$1.prototype.$classData = $d_Lcats_kernel_instances_UUIDInstances$$anon$1;
/** @constructor */
function $c_Lfs2_Pull$CanceledScope(scopeId, inter) {
  this.Lfs2_Pull$CanceledScope__f_scopeId = null;
  this.Lfs2_Pull$CanceledScope__f_inter = null;
  this.Lfs2_Pull$CanceledScope__f_scopeId = scopeId;
  this.Lfs2_Pull$CanceledScope__f_inter = inter
}
$c_Lfs2_Pull$CanceledScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$CanceledScope.prototype.constructor = $c_Lfs2_Pull$CanceledScope;
/** @constructor */
function $h_Lfs2_Pull$CanceledScope() {
  /*<skip>*/
}
$h_Lfs2_Pull$CanceledScope.prototype = $c_Lfs2_Pull$CanceledScope.prototype;
$c_Lfs2_Pull$CanceledScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$CanceledScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$CanceledScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$CanceledScope)) {
    var x$0$2 = $as_Lfs2_Pull$CanceledScope(x$0);
    var x = this.Lfs2_Pull$CanceledScope__f_scopeId;
    var x$2 = x$0$2.Lfs2_Pull$CanceledScope__f_scopeId;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_Pull$CanceledScope__f_inter;
      var x$4 = x$0$2.Lfs2_Pull$CanceledScope__f_inter;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$CanceledScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$CanceledScope.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_Pull$CanceledScope.prototype.productPrefix__T = (function() {
  return "CanceledScope"
});
$c_Lfs2_Pull$CanceledScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$CanceledScope__f_scopeId
  };
  if ((n === 1)) {
    return this.Lfs2_Pull$CanceledScope__f_inter
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lfs2_Pull$CanceledScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$CanceledScope__f_scopeId
});
$c_Lfs2_Pull$CanceledScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Canceled$()
});
$c_Lfs2_Pull$CanceledScope.prototype.interruption__s_Option = (function() {
  var value = this.Lfs2_Pull$CanceledScope__f_inter;
  return new $c_s_Some(value)
});
function $as_Lfs2_Pull$CanceledScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$CanceledScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$CanceledScope"))
}
function $isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$CanceledScope)))
}
function $asArrayOf_Lfs2_Pull$CanceledScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$CanceledScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$CanceledScope;", depth))
}
var $d_Lfs2_Pull$CanceledScope = new $TypeData().initClass({
  Lfs2_Pull$CanceledScope: 0
}, false, "fs2.Pull$CanceledScope", {
  Lfs2_Pull$CanceledScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$CanceledScope.prototype.$classData = $d_Lfs2_Pull$CanceledScope;
/** @constructor */
function $c_Lfs2_Pull$FailedScope(scopeId, err) {
  this.Lfs2_Pull$FailedScope__f_scopeId = null;
  this.Lfs2_Pull$FailedScope__f_err = null;
  this.Lfs2_Pull$FailedScope__f_scopeId = scopeId;
  this.Lfs2_Pull$FailedScope__f_err = err
}
$c_Lfs2_Pull$FailedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$FailedScope.prototype.constructor = $c_Lfs2_Pull$FailedScope;
/** @constructor */
function $h_Lfs2_Pull$FailedScope() {
  /*<skip>*/
}
$h_Lfs2_Pull$FailedScope.prototype = $c_Lfs2_Pull$FailedScope.prototype;
$c_Lfs2_Pull$FailedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$FailedScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$FailedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$FailedScope)) {
    var x$0$2 = $as_Lfs2_Pull$FailedScope(x$0);
    var x = this.Lfs2_Pull$FailedScope__f_scopeId;
    var x$2 = x$0$2.Lfs2_Pull$FailedScope__f_scopeId;
    if ((x === x$2)) {
      var x$3 = this.Lfs2_Pull$FailedScope__f_err;
      var x$4 = x$0$2.Lfs2_Pull$FailedScope__f_err;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4))
    } else {
      return false
    }
  } else {
    return false
  }
});
$c_Lfs2_Pull$FailedScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$FailedScope.prototype.productArity__I = (function() {
  return 2
});
$c_Lfs2_Pull$FailedScope.prototype.productPrefix__T = (function() {
  return "FailedScope"
});
$c_Lfs2_Pull$FailedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$FailedScope__f_scopeId
  };
  if ((n === 1)) {
    return this.Lfs2_Pull$FailedScope__f_err
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lfs2_Pull$FailedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$FailedScope__f_scopeId
});
$c_Lfs2_Pull$FailedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  var e = this.Lfs2_Pull$FailedScope__f_err;
  return new $c_Lcats_effect_kernel_Resource$ExitCase$Errored(e)
});
$c_Lfs2_Pull$FailedScope.prototype.interruption__s_Option = (function() {
  return $m_s_None$()
});
function $as_Lfs2_Pull$FailedScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$FailedScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$FailedScope"))
}
function $isArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$FailedScope)))
}
function $asArrayOf_Lfs2_Pull$FailedScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$FailedScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$FailedScope;", depth))
}
var $d_Lfs2_Pull$FailedScope = new $TypeData().initClass({
  Lfs2_Pull$FailedScope: 0
}, false, "fs2.Pull$FailedScope", {
  Lfs2_Pull$FailedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$FailedScope.prototype.$classData = $d_Lfs2_Pull$FailedScope;
/** @constructor */
function $c_Lfs2_Pull$SucceedScope(scopeId) {
  this.Lfs2_Pull$SucceedScope__f_scopeId = null;
  this.Lfs2_Pull$SucceedScope__f_scopeId = scopeId
}
$c_Lfs2_Pull$SucceedScope.prototype = new $h_Lfs2_Pull$CloseScope();
$c_Lfs2_Pull$SucceedScope.prototype.constructor = $c_Lfs2_Pull$SucceedScope;
/** @constructor */
function $h_Lfs2_Pull$SucceedScope() {
  /*<skip>*/
}
$h_Lfs2_Pull$SucceedScope.prototype = $c_Lfs2_Pull$SucceedScope.prototype;
$c_Lfs2_Pull$SucceedScope.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this)
});
$c_Lfs2_Pull$SucceedScope.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_Lfs2_Pull$SucceedScope.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true
  } else if ((x$0 instanceof $c_Lfs2_Pull$SucceedScope)) {
    var x$0$2 = $as_Lfs2_Pull$SucceedScope(x$0);
    var x = this.Lfs2_Pull$SucceedScope__f_scopeId;
    var x$2 = x$0$2.Lfs2_Pull$SucceedScope__f_scopeId;
    return (x === x$2)
  } else {
    return false
  }
});
$c_Lfs2_Pull$SucceedScope.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this)
});
$c_Lfs2_Pull$SucceedScope.prototype.productArity__I = (function() {
  return 1
});
$c_Lfs2_Pull$SucceedScope.prototype.productPrefix__T = (function() {
  return "SucceedScope"
});
$c_Lfs2_Pull$SucceedScope.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lfs2_Pull$SucceedScope__f_scopeId
  };
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n))
});
$c_Lfs2_Pull$SucceedScope.prototype.scopeId__Lcats_effect_kernel_Unique$Token = (function() {
  return this.Lfs2_Pull$SucceedScope__f_scopeId
});
$c_Lfs2_Pull$SucceedScope.prototype.exitCase__Lcats_effect_kernel_Resource$ExitCase = (function() {
  return $m_Lcats_effect_kernel_Resource$ExitCase$Succeeded$()
});
$c_Lfs2_Pull$SucceedScope.prototype.interruption__s_Option = (function() {
  return $m_s_None$()
});
function $as_Lfs2_Pull$SucceedScope(obj) {
  return (((obj instanceof $c_Lfs2_Pull$SucceedScope) || (obj === null)) ? obj : $throwClassCastException(obj, "fs2.Pull$SucceedScope"))
}
function $isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lfs2_Pull$SucceedScope)))
}
function $asArrayOf_Lfs2_Pull$SucceedScope(obj, depth) {
  return (($isArrayOf_Lfs2_Pull$SucceedScope(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lfs2.Pull$SucceedScope;", depth))
}
var $d_Lfs2_Pull$SucceedScope = new $TypeData().initClass({
  Lfs2_Pull$SucceedScope: 0
}, false, "fs2.Pull$SucceedScope", {
  Lfs2_Pull$SucceedScope: 1,
  Lfs2_Pull$CloseScope: 1,
  Lfs2_Pull$AlgEffect: 1,
  Lfs2_Pull$Action: 1,
  Lfs2_Pull: 1,
  O: 1,
  Lfs2_Pull$ViewL: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
});
$c_Lfs2_Pull$SucceedScope.prototype.$classData = $d_Lfs2_Pull$SucceedScope;
function $ct_ju_ArrayList__sjs_js_Array__($thiz, inner) {
  $thiz.ju_ArrayList__f_java$util$ArrayList$$inner = inner;
  return $thiz
}
function $ct_ju_ArrayList__I__($thiz, initialCapacity) {
  $ct_ju_ArrayList__sjs_js_Array__($thiz, []);
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  };
  return $thiz
}
/** @constructor */
function $c_ju_ArrayList() {
  this.ju_ArrayList__f_java$util$ArrayList$$inner = null
}
$c_ju_ArrayList.prototype = new $h_ju_AbstractList();
$c_ju_ArrayList.prototype.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
  /*<skip>*/
}
$h_ju_ArrayList.prototype = $c_ju_ArrayList.prototype;
$c_ju_ArrayList.prototype.size__I = (function() {
  return $uI(this.ju_ArrayList__f_java$util$ArrayList$$inner.length)
});
$c_ju_ArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.ju_ArrayList__f_java$util$ArrayList$$inner[index]
});
$c_ju_ArrayList.prototype.add__O__Z = (function(e) {
  var array = this.ju_ArrayList__f_java$util$ArrayList$$inner;
  array.push(e);
  return true
});
var $d_ju_ArrayList = new $TypeData().initClass({
  ju_ArrayList: 0
}, false, "java.util.ArrayList", {
  ju_ArrayList: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  O: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
});
$c_ju_ArrayList.prototype.$classData = $d_ju_ArrayList;
/** @constructor */
function $c_sc_AbstractView() {
  /*<skip>*/
}
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
  /*<skip>*/
}
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View"
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.sc_MapOps$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_MapOps$$anon$1__f_$outer = outer
  }
}
$c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_MapOps$$anon$1.prototype.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
  /*<skip>*/
}
$h_sc_MapOps$$anon$1.prototype = $c_sc_MapOps$$anon$1.prototype;
$c_sc_MapOps$$anon$1.prototype.knownSize__I = (function() {
  return this.sc_MapOps$$anon$1__f_$outer.knownSize__I()
});
$c_sc_MapOps$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapOps$$anon$1__f_$outer.valuesIterator__sc_Iterator()
});
var $d_sc_MapOps$$anon$1 = new $TypeData().initClass({
  sc_MapOps$$anon$1: 0
}, false, "scala.collection.MapOps$$anon$1", {
  sc_MapOps$$anon$1: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sc_MapOps$$anon$1.prototype.$classData = $d_sc_MapOps$$anon$1;
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  } else if ($is_sc_Set(that)) {
    var x2 = $as_sc_Set(that);
    if (($thiz.size__I() === x2.size__I())) {
      try {
        return $thiz.subsetOf__sc_Set__Z(x2)
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false
        } else {
          throw e
        }
      }
    } else {
      return false
    }
  } else {
    return false
  }
}
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)))
}
function $as_sc_Set(obj) {
  return (($is_sc_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Set"))
}
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)))
}
function $asArrayOf_sc_Set(obj, depth) {
  return (($isArrayOf_sc_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Set;", depth))
}
function $f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps($thiz, that) {
  var result = $as_sci_SetOps($thiz);
  var it = that.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var this$1 = result;
    var elem = it.next__O();
    result = this$1.incl__O__sci_SetOps(elem)
  };
  return result
}
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$AnyManifest$: 0
}, false, "scala.reflect.ManifestFactory$AnyManifest$", {
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$AnyManifest$;
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$()
  };
  return $n_s_reflect_ManifestFactory$AnyManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$BooleanManifest$: 0
}, false, "scala.reflect.ManifestFactory$BooleanManifest$", {
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$BooleanManifest$;
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$()
  };
  return $n_s_reflect_ManifestFactory$BooleanManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ByteManifest$: 0
}, false, "scala.reflect.ManifestFactory$ByteManifest$", {
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ByteManifest$;
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$()
  };
  return $n_s_reflect_ManifestFactory$ByteManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Char";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$CharManifest$: 0
}, false, "scala.reflect.ManifestFactory$CharManifest$", {
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$CharManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$CharManifest$;
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$()
  };
  return $n_s_reflect_ManifestFactory$CharManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Double";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$DoubleManifest$: 0
}, false, "scala.reflect.ManifestFactory$DoubleManifest$", {
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$DoubleManifest$;
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$()
  };
  return $n_s_reflect_ManifestFactory$DoubleManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Float";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$FloatManifest$: 0
}, false, "scala.reflect.ManifestFactory$FloatManifest$", {
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$FloatManifest$;
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$()
  };
  return $n_s_reflect_ManifestFactory$FloatManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Int";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$IntManifest$: 0
}, false, "scala.reflect.ManifestFactory$IntManifest$", {
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$IntManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$IntManifest$;
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$()
  };
  return $n_s_reflect_ManifestFactory$IntManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Long";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$LongManifest$: 0
}, false, "scala.reflect.ManifestFactory$LongManifest$", {
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$LongManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$LongManifest$;
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$()
  };
  return $n_s_reflect_ManifestFactory$LongManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_sr_Nothing$.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf()
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NothingManifest$: 0
}, false, "scala.reflect.ManifestFactory$NothingManifest$", {
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NothingManifest$;
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$()
  };
  return $n_s_reflect_ManifestFactory$NothingManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_sr_Null$.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf()
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$NullManifest$: 0
}, false, "scala.reflect.ManifestFactory$NullManifest$", {
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$NullManifest$;
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$()
  };
  return $n_s_reflect_ManifestFactory$NullManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = null;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = 0;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
  var prefix = $m_s_None$();
  var typeArguments = $m_s_package$().s_package$__f_Nil;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_prefix = prefix;
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_runtimeClass1 = $d_O.getClassOf();
  this.s_reflect_ManifestFactory$ClassTypeManifest__f_typeArguments = typeArguments;
  this.s_reflect_ManifestFactory$PhantomManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf()
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len)
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ObjectManifest$: 0
}, false, "scala.reflect.ManifestFactory$ObjectManifest$", {
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ObjectManifest$;
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$()
  };
  return $n_s_reflect_ManifestFactory$ObjectManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Short";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$ShortManifest$: 0
}, false, "scala.reflect.ManifestFactory$ShortManifest$", {
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$ShortManifest$;
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$()
  };
  return $n_s_reflect_ManifestFactory$ShortManifest$
}
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_hashCode = 0;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
  this.s_reflect_AnyValManifest__f_hashCode = $systemIdentityHashCode(this)
}
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
  /*<skip>*/
}
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass({
  s_reflect_ManifestFactory$UnitManifest$: 0
}, false, "scala.reflect.ManifestFactory$UnitManifest$", {
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  O: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
});
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.$classData = $d_s_reflect_ManifestFactory$UnitManifest$;
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$()
  };
  return $n_s_reflect_ManifestFactory$UnitManifest$
}
function $f_Lcats_ApplicativeError__handleError__O__F1__O($thiz, fa, f) {
  return $thiz.handleErrorWith__O__F1__O(fa, f.andThen__F1__F1(new $c_sjsr_AnonFunction1(((this$1) => ((x) => this$1.pure__O__O(x)))($thiz))))
}
function $f_Lcats_ApplicativeError__attempt__O__O($thiz, fa) {
  return $thiz.handleErrorWith__O__F1__O($thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1(((_$2) => {
    $m_s_package$();
    return new $c_s_util_Right(_$2)
  }))), new $c_sjsr_AnonFunction1(((this$2) => ((e) => this$2.pure__O__O(($m_s_package$(), new $c_s_util_Left(e)))))($thiz)))
}
function $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O($thiz, fa, pf) {
  return $thiz.handleErrorWith__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, pf$2) => ((e) => pf$2.andThen__F1__s_PartialFunction(new $c_sjsr_AnonFunction1(((this$2, e$2) => ((_$6) => this$2.map2__O__O__F2__O(_$6, this$2.raiseError__O__O(e$2), new $c_sjsr_AnonFunction2(((_$7, b) => {
    $as_jl_Void(_$7);
    return b
  })))))(this$1, e))).applyOrElse__O__F1__O(e, new $c_sjsr_AnonFunction1(((this$2$1) => ((e$3) => this$2$1.raiseError__O__O(e$3)))(this$1)))))($thiz, pf)))
}
function $f_Lcats_ApplicativeError__fromEither__s_util_Either__O($thiz, x) {
  if ((x instanceof $c_s_util_Right)) {
    var a = $as_s_util_Right(x).s_util_Right__f_value;
    return $thiz.pure__O__O(a)
  };
  if ((x instanceof $c_s_util_Left)) {
    var e = $as_s_util_Left(x).s_util_Left__f_value;
    return $thiz.raiseError__O__O(e)
  };
  throw new $c_s_MatchError(x)
}
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null
}
$c_Lcats_data_KleisliInstances0\uff3f5.prototype = new $h_Lcats_data_KleisliInstances1();
$c_Lcats_data_KleisliInstances0\uff3f5.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances0\uff3f5.prototype = $c_Lcats_data_KleisliInstances0\uff3f5.prototype;
/** @constructor */
function $c_Lcats_instances_Function1Instances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Function1Instances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Function1Instances$$anon$1.prototype.constructor = $c_Lcats_instances_Function1Instances$$anon$1;
/** @constructor */
function $h_Lcats_instances_Function1Instances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Function1Instances$$anon$1.prototype = $c_Lcats_instances_Function1Instances$$anon$1.prototype;
var $d_Lcats_instances_Function1Instances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Function1Instances$$anon$1: 0
}, false, "cats.instances.Function1Instances$$anon$1", {
  Lcats_instances_Function1Instances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_arrow_CommutativeArrow: 1
});
$c_Lcats_instances_Function1Instances$$anon$1.prototype.$classData = $d_Lcats_instances_Function1Instances$$anon$1;
/** @constructor */
function $c_Lnet_andimiller_Msg$$anon$1(_$ordinal$2, \u03b4name$2) {
  this.Lnet_andimiller_Msg$$anon$1__f__$ordinal$1 = 0;
  this.Lnet_andimiller_Msg$$anon$1__f_$name$1 = null;
  this.Lnet_andimiller_Msg$$anon$1__f__$ordinal$1 = _$ordinal$2;
  this.Lnet_andimiller_Msg$$anon$1__f_$name$1 = \u03b4name$2
}
$c_Lnet_andimiller_Msg$$anon$1.prototype = new $h_Lnet_andimiller_Msg();
$c_Lnet_andimiller_Msg$$anon$1.prototype.constructor = $c_Lnet_andimiller_Msg$$anon$1;
/** @constructor */
function $h_Lnet_andimiller_Msg$$anon$1() {
  /*<skip>*/
}
$h_Lnet_andimiller_Msg$$anon$1.prototype = $c_Lnet_andimiller_Msg$$anon$1.prototype;
$c_Lnet_andimiller_Msg$$anon$1.prototype.productArity__I = (function() {
  return 0
});
$c_Lnet_andimiller_Msg$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n)
});
$c_Lnet_andimiller_Msg$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lnet_andimiller_Msg$$anon$1__f_$name$1
});
$c_Lnet_andimiller_Msg$$anon$1.prototype.toString__T = (function() {
  return this.Lnet_andimiller_Msg$$anon$1__f_$name$1
});
var $d_Lnet_andimiller_Msg$$anon$1 = new $TypeData().initClass({
  Lnet_andimiller_Msg$$anon$1: 0
}, false, "net.andimiller.Msg$$anon$1", {
  Lnet_andimiller_Msg$$anon$1: 1,
  Lnet_andimiller_Msg: 1,
  O: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
});
$c_Lnet_andimiller_Msg$$anon$1.prototype.$classData = $d_Lnet_andimiller_Msg$$anon$1;
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else {
    if ($is_sc_Seq(o)) {
      var x2 = $as_sc_Seq(o);
      if (x2.canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(x2)
      }
    };
    return false
  }
}
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)))
}
function $as_sc_Seq(obj) {
  return (($is_sc_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Seq"))
}
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)))
}
function $asArrayOf_sc_Seq(obj, depth) {
  return (($isArrayOf_sc_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Seq;", depth))
}
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.sc_SeqView$Sorted__f_bitmap$0)) {
    var len = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
    if ((len === 0)) {
      var res = $m_s_package$().s_package$__f_Nil
    } else if ((len === 1)) {
      $m_s_package$();
      var array = [$thiz.sc_SeqView$Sorted__f_underlying.head__O()];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var res = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems)
    } else {
      var arr = new $ac_O(len);
      var this$5 = $thiz.sc_SeqView$Sorted__f_underlying;
      this$5.copyToArray__O__I__I__I(arr, 0, 2147483647);
      var comparator = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
      $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, comparator);
      var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr)
    };
    $thiz.sc_SeqView$Sorted__f_evaluated = true;
    $thiz.sc_SeqView$Sorted__f_underlying = null;
    $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = res;
    $thiz.sc_SeqView$Sorted__f_bitmap$0 = true
  };
  return $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.sc_SeqView$Sorted__f_underlying = underlying;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = len;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = ord;
  $thiz.sc_SeqView$Sorted__f_evaluated = false;
  return $thiz
}
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, underlying.length__I(), ord);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = null;
  this.sc_SeqView$Sorted__f_underlying = null;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = 0;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = null;
  this.sc_SeqView$Sorted__f_evaluated = false;
  this.sc_SeqView$Sorted__f_bitmap$0 = false
}
$c_sc_SeqView$Sorted.prototype = new $h_O();
$c_sc_SeqView$Sorted.prototype.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
  /*<skip>*/
}
$h_sc_SeqView$Sorted.prototype = $c_sc_SeqView$Sorted.prototype;
$c_sc_SeqView$Sorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_SeqView$Sorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_SeqView$Sorted.prototype.className__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Sorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder()
});
$c_sc_SeqView$Sorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Sorted.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).iterator__sc_Iterator()
});
$c_sc_SeqView$Sorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Sorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Sorted.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_SeqView$Sorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_SeqView$Sorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_SeqView$Sorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_SeqView$Sorted.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sc_SeqView$Sorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$_sorted__sc_Seq = (function() {
  return ((!this.sc_SeqView$Sorted__f_bitmap$0) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted)
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$elems__sc_SeqOps = (function() {
  var orig = this.sc_SeqView$Sorted__f_underlying;
  return (this.sc_SeqView$Sorted__f_evaluated ? this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq() : orig)
});
$c_sc_SeqView$Sorted.prototype.apply__I__O = (function(i) {
  return this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq().apply__I__O(i)
});
$c_sc_SeqView$Sorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var xs = new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.scala$collection$SeqView$Sorted$$_sorted__sc_Seq().iterator__sc_Iterator()))(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_SeqView$Sorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0)
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : ord1.equals__O__Z(x$2))) {
    return this
  } else {
    return (ord1.isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1))
  }
});
$c_sc_SeqView$Sorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll)
});
$c_sc_SeqView$Sorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord)
});
var $d_sc_SeqView$Sorted = new $TypeData().initClass({
  sc_SeqView$Sorted: 0
}, false, "scala.collection.SeqView$Sorted", {
  sc_SeqView$Sorted: 1,
  O: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SeqView$Sorted.prototype.$classData = $d_sc_SeqView$Sorted;
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0)) {
    $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $thiz.sc_SeqView$Sorted$ReverseSorted__f_$outer.scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
    $thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = true
  };
  return $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed
}
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed)
}
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.sc_SeqView$Sorted$ReverseSorted__f__reversed = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = false;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = null;
  if ((outer === null)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(null)
  } else {
    this.sc_SeqView$Sorted$ReverseSorted__f_$outer = outer
  }
}
$c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$c_sc_SeqView$Sorted$ReverseSorted.prototype.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
  /*<skip>*/
}
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $c_sc_SeqView$Sorted$ReverseSorted.prototype;
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.className__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverseIterator__sc_Iterator = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.iterator__sc_Iterator()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.apply__I__O = (function(i) {
  return $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).apply__I__O(i)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var xs = new $c_sjsr_AnonFunction0(((this$1) => (() => $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this$1).iterator__sc_Iterator()))(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : ord1.equals__O__Z(x$2))) {
    return this.sc_SeqView$Sorted$ReverseSorted__f_$outer
  } else {
    return (ord1.isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.sc_SeqView$Sorted$ReverseSorted__f_$outer.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1))
  }
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord)
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().initClass({
  sc_SeqView$Sorted$ReverseSorted: 0
}, false, "scala.collection.SeqView$Sorted$ReverseSorted", {
  sc_SeqView$Sorted$ReverseSorted: 1,
  O: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.$classData = $d_sc_SeqView$Sorted$ReverseSorted;
function $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $thiz.sortedIterableFactory__sc_SortedIterableFactory().newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem)
  };
  return $as_sc_SortedSet(b.result__O())
}
function $f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet($thiz, f, ev) {
  var b = $thiz.sortedIterableFactory__sc_SortedIterableFactory().newBuilder__O__scm_Builder(ev);
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var xs = $as_sc_IterableOnce(f.apply__O__O(it.next__O()));
    b.addAll__sc_IterableOnce__scm_Growable(xs)
  };
  return $as_sc_SortedSet(b.result__O())
}
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1
}
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
  /*<skip>*/
}
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $as_sc_Iterator(this.sc_View$$anon$1__f_it$1.apply__O())
});
var $d_sc_View$$anon$1 = new $TypeData().initClass({
  sc_View$$anon$1: 0
}, false, "scala.collection.View$$anon$1", {
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$$anon$1.prototype.$classData = $d_sc_View$$anon$1;
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix
}
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
  /*<skip>*/
}
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_View$Concat__f_prefix.iterator__sc_Iterator();
  var xs = new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.sc_View$Concat__f_suffix.iterator__sc_Iterator()))(this));
  return this$2.concat__F0__sc_Iterator(xs)
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = this.sc_View$Concat__f_prefix.knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = this.sc_View$Concat__f_suffix.knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1))
  } else {
    return (-1)
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return (this.sc_View$Concat__f_prefix.isEmpty__Z() && this.sc_View$Concat__f_suffix.isEmpty__Z())
});
var $d_sc_View$Concat = new $TypeData().initClass({
  sc_View$Concat: 0
}, false, "scala.collection.View$Concat", {
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Concat.prototype.$classData = $d_sc_View$Concat;
/** @constructor */
function $c_sc_View$DistinctBy(underlying, f) {
  this.sc_View$DistinctBy__f_underlying = null;
  this.sc_View$DistinctBy__f_f = null;
  this.sc_View$DistinctBy__f_underlying = underlying;
  this.sc_View$DistinctBy__f_f = f
}
$c_sc_View$DistinctBy.prototype = new $h_sc_AbstractView();
$c_sc_View$DistinctBy.prototype.constructor = $c_sc_View$DistinctBy;
/** @constructor */
function $h_sc_View$DistinctBy() {
  /*<skip>*/
}
$h_sc_View$DistinctBy.prototype = $c_sc_View$DistinctBy.prototype;
$c_sc_View$DistinctBy.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$DistinctBy__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$DistinctBy__f_f;
  return new $c_sc_Iterator$$anon$8(this$1, f)
});
$c_sc_View$DistinctBy.prototype.knownSize__I = (function() {
  return ((this.sc_View$DistinctBy__f_underlying.knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$DistinctBy.prototype.isEmpty__Z = (function() {
  return this.sc_View$DistinctBy__f_underlying.isEmpty__Z()
});
var $d_sc_View$DistinctBy = new $TypeData().initClass({
  sc_View$DistinctBy: 0
}, false, "scala.collection.View$DistinctBy", {
  sc_View$DistinctBy: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$DistinctBy.prototype.$classData = $d_sc_View$DistinctBy;
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz
}
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0
}
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
  /*<skip>*/
}
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Drop__f_underlying.iterator__sc_Iterator().drop__I__sc_Iterator(this.sc_View$Drop__f_n)
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = this.sc_View$Drop__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0)
  } else {
    return (-1)
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Drop = new $TypeData().initClass({
  sc_View$Drop: 0
}, false, "scala.collection.View$Drop", {
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Drop.prototype.$classData = $d_sc_View$Drop;
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.sc_View$Filter__f_underlying = null;
  this.sc_View$Filter__f_p = null;
  this.sc_View$Filter__f_isFlipped = false;
  this.sc_View$Filter__f_underlying = underlying;
  this.sc_View$Filter__f_p = p;
  this.sc_View$Filter__f_isFlipped = isFlipped
}
$c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$c_sc_View$Filter.prototype.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
  /*<skip>*/
}
$h_sc_View$Filter.prototype = $c_sc_View$Filter.prototype;
$c_sc_View$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Filter__f_underlying.iterator__sc_Iterator();
  var p = this.sc_View$Filter__f_p;
  var isFlipped = this.sc_View$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped)
});
$c_sc_View$Filter.prototype.knownSize__I = (function() {
  return ((this.sc_View$Filter__f_underlying.knownSize__I() === 0) ? 0 : (-1))
});
$c_sc_View$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z())
});
var $d_sc_View$Filter = new $TypeData().initClass({
  sc_View$Filter: 0
}, false, "scala.collection.View$Filter", {
  sc_View$Filter: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
});
$c_sc_View$Filter.prototype.$classData = $d_sc_View$Filter;
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz
}
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null
}
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
  /*<skip>*/
}
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
function $f_Lcats_Monad__map__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1(((this$1, f$2) => ((a) => this$1.pure__O__O(f$2.apply__O__O(a))))($thiz, f)))
}
function $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli($thiz, b, f) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, b$2, f$2) => ((a) => this$1.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1.tailRecM__O__F1__O(b$2, new $c_sjsr_AnonFunction1(((f$30$2, a$2) => ((_$159) => $as_Lcats_data_Kleisli(f$30$2.apply__O__O(_$159)).Lcats_data_Kleisli__f_run.apply__O__O(a$2)))(f$2, a)))))($thiz, b, f));
  return new $c_Lcats_data_Kleisli(run)
}
/** @constructor */
function $c_Lcats_data_KleisliInstances0() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null
}
$c_Lcats_data_KleisliInstances0.prototype = new $h_Lcats_data_KleisliInstances0\uff3f5();
$c_Lcats_data_KleisliInstances0.prototype.constructor = $c_Lcats_data_KleisliInstances0;
/** @constructor */
function $h_Lcats_data_KleisliInstances0() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances0.prototype = $c_Lcats_data_KleisliInstances0.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_implicits$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_implicits$.prototype = new $h_O();
$c_Lcats_effect_kernel_implicits$.prototype.constructor = $c_Lcats_effect_kernel_implicits$;
/** @constructor */
function $h_Lcats_effect_kernel_implicits$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_implicits$.prototype = $c_Lcats_effect_kernel_implicits$.prototype;
var $d_Lcats_effect_kernel_implicits$ = new $TypeData().initClass({
  Lcats_effect_kernel_implicits$: 0
}, false, "cats.effect.kernel.implicits$", {
  Lcats_effect_kernel_implicits$: 1,
  O: 1,
  Lcats_effect_kernel_syntax_MonadCancelSyntax: 1,
  Lcats_effect_kernel_syntax_GenSpawnSyntax: 1,
  Lcats_effect_kernel_syntax_GenTemporalSyntax: 1,
  Lcats_effect_kernel_syntax_GenConcurrentSyntax: 1,
  Lcats_effect_kernel_syntax_AsyncSyntax: 1,
  Lcats_effect_kernel_syntax_ResourceSyntax: 1,
  Lcats_effect_kernel_syntax_ClockSyntax: 1,
  Lcats_effect_kernel_syntax_AllSyntax: 1,
  Lcats_effect_kernel_instances_GenSpawnInstances: 1,
  Lcats_effect_kernel_instances_AllInstances: 1
});
$c_Lcats_effect_kernel_implicits$.prototype.$classData = $d_Lcats_effect_kernel_implicits$;
var $n_Lcats_effect_kernel_implicits$;
function $m_Lcats_effect_kernel_implicits$() {
  if ((!$n_Lcats_effect_kernel_implicits$)) {
    $n_Lcats_effect_kernel_implicits$ = new $c_Lcats_effect_kernel_implicits$()
  };
  return $n_Lcats_effect_kernel_implicits$
}
/** @constructor */
function $c_Lcats_kernel_instances_UnitAlgebra() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_UnitAlgebra.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitAlgebra.prototype.constructor = $c_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $h_Lcats_kernel_instances_UnitAlgebra() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UnitAlgebra.prototype = $c_Lcats_kernel_instances_UnitAlgebra.prototype;
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as)
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.empty__O = (function() {
  return (void 0)
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.combine__O__O__O = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y)
});
var $d_Lcats_kernel_instances_UnitAlgebra = new $TypeData().initClass({
  Lcats_kernel_instances_UnitAlgebra: 0
}, false, "cats.kernel.instances.UnitAlgebra", {
  Lcats_kernel_instances_UnitAlgebra: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Band: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_Semilattice: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_BoundedSemilattice: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeGroup: 1
});
$c_Lcats_kernel_instances_UnitAlgebra.prototype.$classData = $d_Lcats_kernel_instances_UnitAlgebra;
/** @constructor */
function $c_sc_AbstractSet() {
  /*<skip>*/
}
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
  /*<skip>*/
}
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that)
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set"
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that)
});
$c_sc_AbstractSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that)
});
$c_sc_AbstractSet.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g)
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1)
});
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true
  } else if ($is_sc_Map(o)) {
    var x2 = $as_sc_Map(o);
    if (($thiz.size__I() === x2.size__I())) {
      try {
        return $thiz.forall__F1__Z(new $c_sjsr_AnonFunction1(((x2$1) => ((kv$2) => {
          var kv = $as_T2(kv$2);
          return $m_sr_BoxesRunTime$().equals__O__O__Z(x2$1.getOrElse__O__F0__O(kv._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), kv._2__O())
        }))(x2)))
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false
        } else {
          throw e
        }
      }
    } else {
      return false
    }
  } else {
    return false
  }
}
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)))
}
function $as_sc_Map(obj) {
  return (($is_sc_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.Map"))
}
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)))
}
function $asArrayOf_sc_Map(obj, depth) {
  return (($isArrayOf_sc_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.Map;", depth))
}
function $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V($thiz, t, e) {
  var wasInterrupted = false;
  if ((wasInterrupted || $m_s_util_control_NonFatal$().apply__jl_Throwable__Z(t))) {
    var completed = $thiz.tryComplete0__O__s_util_Try__Z($thiz.ju_concurrent_atomic_AtomicReference__f_value, $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(new $c_s_util_Failure(t)));
    if ((completed && wasInterrupted)) {
      var this$1 = $m_jl_Thread$().jl_Thread$__f_SingleThread;
      this$1.jl_Thread__f_java$lang$Thread$$interruptedState = true
    };
    if (((($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 5) || ($thiz.s_concurrent_impl_Promise$Transformation__f__xform === 6)) || (!completed))) {
      e.reportFailure__jl_Throwable__V(t)
    }
  } else {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(t)
  }
}
function $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, _fun, _ec, _arg, _xform) {
  $thiz.s_concurrent_impl_Promise$Transformation__f__fun = _fun;
  $thiz.s_concurrent_impl_Promise$Transformation__f__ec = _ec;
  $thiz.s_concurrent_impl_Promise$Transformation__f__arg = _arg;
  $thiz.s_concurrent_impl_Promise$Transformation__f__xform = _xform;
  $ct_s_concurrent_impl_Promise$DefaultPromise__($thiz);
  return $thiz
}
function $ct_s_concurrent_impl_Promise$Transformation__I__F1__s_concurrent_ExecutionContext__($thiz, xform, f, ec) {
  $ct_s_concurrent_impl_Promise$Transformation__F1__s_concurrent_ExecutionContext__s_util_Try__I__($thiz, f, ec, null, xform);
  return $thiz
}
/** @constructor */
function $c_s_concurrent_impl_Promise$Transformation() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__xform = 0
}
$c_s_concurrent_impl_Promise$Transformation.prototype = new $h_s_concurrent_impl_Promise$DefaultPromise();
$c_s_concurrent_impl_Promise$Transformation.prototype.constructor = $c_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $h_s_concurrent_impl_Promise$Transformation() {
  /*<skip>*/
}
$h_s_concurrent_impl_Promise$Transformation.prototype = $c_s_concurrent_impl_Promise$Transformation.prototype;
$c_s_concurrent_impl_Promise$Transformation.prototype.submitWithValue__s_util_Try__s_concurrent_impl_Promise$Transformation = (function(resolved) {
  this.s_concurrent_impl_Promise$Transformation__f__arg = resolved;
  var e = this.s_concurrent_impl_Promise$Transformation__f__ec;
  try {
    e.execute__jl_Runnable__V(this)
  } catch (e$2) {
    var e$3 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e$2);
    if ((e$3 !== null)) {
      this.s_concurrent_impl_Promise$Transformation__f__fun = null;
      this.s_concurrent_impl_Promise$Transformation__f__arg = null;
      this.s_concurrent_impl_Promise$Transformation__f__ec = null;
      $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$3, e)
    } else {
      throw e$2
    }
  };
  return this
});
$c_s_concurrent_impl_Promise$Transformation.prototype.run__V = (function() {
  var v = this.s_concurrent_impl_Promise$Transformation__f__arg;
  var fun = this.s_concurrent_impl_Promise$Transformation__f__fun;
  var ec = this.s_concurrent_impl_Promise$Transformation__f__ec;
  this.s_concurrent_impl_Promise$Transformation__f__fun = null;
  this.s_concurrent_impl_Promise$Transformation__f__arg = null;
  this.s_concurrent_impl_Promise$Transformation__f__ec = null;
  try {
    var x1 = this.s_concurrent_impl_Promise$Transformation__f__xform;
    switch (x1) {
      case 0: {
        var resolvedResult = null;
        break
      }
      case 1: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success(fun.apply__O__O(v.get__O())) : v);
        break
      }
      case 2: {
        if ((v instanceof $c_s_util_Success)) {
          var f = fun.apply__O__O(v.get__O());
          if ((f instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
            $as_s_concurrent_impl_Promise$DefaultPromise(f).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null)
          } else {
            this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f))
          };
          var resolvedResult = null
        } else {
          var resolvedResult = v
        };
        break
      }
      case 3: {
        var resolvedResult = $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try($as_s_util_Try(fun.apply__O__O(v)));
        break
      }
      case 4: {
        var f$2 = fun.apply__O__O(v);
        if ((f$2 instanceof $c_s_concurrent_impl_Promise$DefaultPromise)) {
          $as_s_concurrent_impl_Promise$DefaultPromise(f$2).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null)
        } else {
          this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise($as_s_concurrent_Future(f$2))
        };
        var resolvedResult = null;
        break
      }
      case 5: {
        v.foreach__F1__V(fun);
        var resolvedResult = null;
        break
      }
      case 6: {
        fun.apply__O__O(v);
        var resolvedResult = null;
        break
      }
      case 7: {
        var resolvedResult = ((v instanceof $c_s_util_Failure) ? $m_s_concurrent_impl_Promise$().scala$concurrent$impl$Promise$$resolve__s_util_Try__s_util_Try(v.recover__s_PartialFunction__s_util_Try($as_s_PartialFunction(fun))) : v);
        break
      }
      case 8: {
        if ((v instanceof $c_s_util_Failure)) {
          var f$3 = $as_s_concurrent_Future($as_s_PartialFunction(fun).applyOrElse__O__F1__O($as_s_util_Failure(v).s_util_Failure__f_exception, $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailed));
          var resolvedResult = ((f$3 !== $m_s_concurrent_Future$().s_concurrent_Future$__f_recoverWithFailedMarker) ? (((f$3 instanceof $c_s_concurrent_impl_Promise$DefaultPromise) ? $as_s_concurrent_impl_Promise$DefaultPromise(f$3).linkRootOf__s_concurrent_impl_Promise$DefaultPromise__s_concurrent_impl_Promise$Link__V(this, null) : this.completeWith__s_concurrent_Future__s_concurrent_impl_Promise$DefaultPromise(f$3)), null) : v)
        } else {
          var resolvedResult = v
        };
        break
      }
      case 9: {
        var resolvedResult = (((v instanceof $c_s_util_Failure) || $uZ(fun.apply__O__O(v.get__O()))) ? v : $m_s_concurrent_Future$().s_concurrent_Future$__f_filterFailure);
        break
      }
      case 10: {
        var resolvedResult = ((v instanceof $c_s_util_Success) ? new $c_s_util_Success($as_s_PartialFunction(fun).applyOrElse__O__F1__O(v.get__O(), $m_s_concurrent_Future$().s_concurrent_Future$__f_collectFailed)) : v);
        break
      }
      default: {
        var resolvedResult = new $c_s_util_Failure($ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ("BUG: encountered transformation promise with illegal type: " + this.s_concurrent_impl_Promise$Transformation__f__xform)))
      }
    };
    if ((resolvedResult !== null)) {
      this.tryComplete0__O__s_util_Try__Z(this.ju_concurrent_atomic_AtomicReference__f_value, resolvedResult)
    }
  } catch (e) {
    var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
    if ((e$2 !== null)) {
      $p_s_concurrent_impl_Promise$Transformation__handleFailure__jl_Throwable__s_concurrent_ExecutionContext__V(this, e$2, ec)
    } else {
      throw e
    }
  }
});
function $as_s_concurrent_impl_Promise$Transformation(obj) {
  return (((obj instanceof $c_s_concurrent_impl_Promise$Transformation) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.concurrent.impl.Promise$Transformation"))
}
function $isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_impl_Promise$Transformation)))
}
function $asArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) {
  return (($isArrayOf_s_concurrent_impl_Promise$Transformation(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.concurrent.impl.Promise$Transformation;", depth))
}
var $d_s_concurrent_impl_Promise$Transformation = new $TypeData().initClass({
  s_concurrent_impl_Promise$Transformation: 0
}, false, "scala.concurrent.impl.Promise$Transformation", {
  s_concurrent_impl_Promise$Transformation: 1,
  s_concurrent_impl_Promise$DefaultPromise: 1,
  ju_concurrent_atomic_AtomicReference: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  s_concurrent_Promise: 1,
  s_concurrent_Future: 1,
  s_concurrent_Awaitable: 1,
  F1: 1,
  s_concurrent_impl_Promise$Callbacks: 1,
  jl_Runnable: 1,
  s_concurrent_Batchable: 1
});
$c_s_concurrent_impl_Promise$Transformation.prototype.$classData = $d_s_concurrent_impl_Promise$Transformation;
/** @constructor */
function $c_sr_RichLong(self) {
  this.sr_RichLong__f_self = $L0;
  this.sr_RichLong__f_self = self
}
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
  /*<skip>*/
}
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.compare__O__I = (function(y) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(y);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3)
});
$c_sr_RichLong.prototype.compareTo__O__I = (function(that) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(new $c_RTLong(lo$1, hi$1));
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var t$3 = $uJ(that);
  var lo$3 = t$3.RTLong__f_lo;
  var hi$3 = t$3.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$2, hi$2, lo$3, hi$3)
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this)
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toDouble__I__I__D(lo, hi)
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$toFloat__I__I__F(lo, hi)
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_RTLong(lo, hi)
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return lo
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 24) >> 24)
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 16) >> 16)
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self)
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self, x$1)
});
function $as_sr_RichLong(obj) {
  return (((obj instanceof $c_sr_RichLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.runtime.RichLong"))
}
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)))
}
function $asArrayOf_sr_RichLong(obj, depth) {
  return (($isArrayOf_sr_RichLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.runtime.RichLong;", depth))
}
var $d_sr_RichLong = new $TypeData().initClass({
  sr_RichLong: 0
}, false, "scala.runtime.RichLong", {
  sr_RichLong: 1,
  O: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
});
$c_sr_RichLong.prototype.$classData = $d_sr_RichLong;
function $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a, f) {
  return $thiz.flatMap__O__F1__O(f.apply__O__O(a), new $c_sjsr_AnonFunction1(((this$1, f$2) => ((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var a$1 = $as_s_util_Left(x$1$1).s_util_Left__f_value;
      return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this$1, a$1, f$2)
    };
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x$1$1).s_util_Right__f_value;
      return this$1.pure__O__O(b)
    };
    throw new $c_s_MatchError(x$1$1)
  }))($thiz, f)))
}
function $ct_Lcats_data_KleisliInstances__($thiz) {
  $ct_Lcats_data_KleisliInstances3__($thiz);
  var M = $as_Lcats_CommutativeMonad(($m_Lcats_Invariant$(), $m_Lcats_package$().Lcats_package$__f_catsInstancesForId));
  $thiz.Lcats_data_KleisliInstances__f_catsDataCommutativeArrowForKleisliId = new $c_Lcats_data_KleisliInstances0$$anon$1(M);
  return $thiz
}
/** @constructor */
function $c_Lcats_data_KleisliInstances() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null;
  this.Lcats_data_KleisliInstances__f_catsDataCommutativeArrowForKleisliId = null
}
$c_Lcats_data_KleisliInstances.prototype = new $h_Lcats_data_KleisliInstances0();
$c_Lcats_data_KleisliInstances.prototype.constructor = $c_Lcats_data_KleisliInstances;
/** @constructor */
function $h_Lcats_data_KleisliInstances() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances.prototype = $c_Lcats_data_KleisliInstances.prototype;
/** @constructor */
function $c_Lcats_effect_kernel_Resource$() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_Resource$.prototype = new $h_Lcats_effect_kernel_ResourceFOInstances0();
$c_Lcats_effect_kernel_Resource$.prototype.constructor = $c_Lcats_effect_kernel_Resource$;
/** @constructor */
function $h_Lcats_effect_kernel_Resource$() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_Resource$.prototype = $c_Lcats_effect_kernel_Resource$.prototype;
$c_Lcats_effect_kernel_Resource$.prototype.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource = (function(resource, F) {
  var this$5 = new $c_Lcats_Functor$$anon$4(resource, F);
  var f = new $c_sjsr_AnonFunction1(((x$1) => {
    var x$1$1 = $as_T2(x$1);
    if ((x$1$1 !== null)) {
      var a = x$1$1._1__O();
      var release = x$1$1._2__O();
      var _2 = new $c_sjsr_AnonFunction1(((release$2) => ((_$41) => {
        $as_Lcats_effect_kernel_Resource$ExitCase(_$41);
        return release$2
      }))(release));
      return new $c_T2(a, _2)
    };
    throw new $c_s_MatchError(x$1$1)
  }));
  return this.applyCase__O__Lcats_effect_kernel_Resource(this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f))
});
$c_Lcats_effect_kernel_Resource$.prototype.applyCase__O__Lcats_effect_kernel_Resource = (function(resource) {
  var resource$1 = new $c_sjsr_AnonFunction1(((resource$2) => ((_$43) => {
    $as_Lcats_effect_kernel_Poll(_$43);
    return resource$2
  }))(resource));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource$1)
});
$c_Lcats_effect_kernel_Resource$.prototype.make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$5 = new $c_Lcats_Functor$$anon$4(acquire, F);
  var f = new $c_sjsr_AnonFunction1(((release$2) => ((a) => {
    var y = release$2.apply__O__O(a);
    return new $c_T2(a, y)
  }))(release));
  return this.apply__O__Lcats_Functor__Lcats_effect_kernel_Resource(this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f), F)
});
$c_Lcats_effect_kernel_Resource$.prototype.makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource = (function(acquire, release, F) {
  var this$5 = new $c_Lcats_Functor$$anon$4(acquire, F);
  var f = new $c_sjsr_AnonFunction1(((release$2) => ((a) => {
    var _2 = new $c_sjsr_AnonFunction1(((release$11$2, a$2) => ((e) => {
      var e$1 = $as_Lcats_effect_kernel_Resource$ExitCase(e);
      return release$11$2.apply__O__O__O(a$2, e$1)
    }))(release$2, a));
    return new $c_T2(a, _2)
  }))(release));
  return this.applyCase__O__Lcats_effect_kernel_Resource(this$5.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$5.Lcats_Functor$$anon$4__f_self, f))
});
$c_Lcats_effect_kernel_Resource$.prototype.uncancelable__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource = (function(body, F) {
  var resource = new $c_sjsr_AnonFunction1(((body$2, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var inner = new $c_Lcats_effect_kernel_Resource$$anon$6(F$2, poll$1);
    return $as_Lcats_effect_kernel_Resource(body$2.apply__O__O(inner)).allocatedCase__Lcats_effect_kernel_MonadCancel__O(F$2)
  }))(body, F));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
});
$c_Lcats_effect_kernel_Resource$.prototype.deferred__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(F) {
  var fa = F.deferred__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$71) => {
    var _$71$1 = $as_Lcats_effect_kernel_Deferred(_$71);
    var f = new $c_Lcats_effect_kernel_Resource$$anon$5();
    return new $c_Lcats_effect_kernel_Deferred$TransformedDeferred(_$71$1, f)
  })))
});
$c_Lcats_effect_kernel_Resource$.prototype.ref__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource = (function(a, F) {
  var fa = F.ref__O__O(a);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((F$2) => ((_$74) => {
    var _$74$1 = $as_Lcats_effect_kernel_Ref(_$74);
    var f = new $c_Lcats_effect_kernel_Resource$$anon$5();
    return new $c_Lcats_effect_kernel_Ref$TransformedRef(_$74$1, f, F$2)
  }))(F)))
});
$c_Lcats_effect_kernel_Resource$.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource = (function(hint, thunk, F) {
  var fa = F.suspend__Lcats_effect_kernel_Sync$Type__F0__O(hint, thunk);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
$c_Lcats_effect_kernel_Resource$.prototype.cont__Lcats_effect_kernel_Cont__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource = (function(body, F) {
  var resource = new $c_sjsr_AnonFunction1(((body$2, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    return poll$1.apply__O__O(F$2.cont__Lcats_effect_kernel_Cont__O(new $c_Lcats_effect_kernel_Resource$$anon$7(body$2, F$2)))
  }))(body, F));
  return new $c_Lcats_effect_kernel_Resource$Allocate(resource)
});
$c_Lcats_effect_kernel_Resource$.prototype.raiseError__O__Lcats_ApplicativeError__Lcats_effect_kernel_Resource = (function(e, F) {
  var fa = F.raiseError__O__O(e);
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
var $d_Lcats_effect_kernel_Resource$ = new $TypeData().initClass({
  Lcats_effect_kernel_Resource$: 0
}, false, "cats.effect.kernel.Resource$", {
  Lcats_effect_kernel_Resource$: 1,
  Lcats_effect_kernel_ResourceFOInstances0: 1,
  Lcats_effect_kernel_ResourceFOInstances1: 1,
  O: 1,
  Lcats_effect_kernel_ResourceHOInstances5: 1,
  Lcats_effect_kernel_ResourceHOInstances4: 1,
  Lcats_effect_kernel_ResourceHOInstances3: 1,
  Lcats_effect_kernel_ResourceHOInstances2: 1,
  Lcats_effect_kernel_ResourceHOInstances1: 1,
  Lcats_effect_kernel_ResourceHOInstances0: 1,
  Lcats_effect_kernel_ResourcePlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
});
$c_Lcats_effect_kernel_Resource$.prototype.$classData = $d_Lcats_effect_kernel_Resource$;
var $n_Lcats_effect_kernel_Resource$;
function $m_Lcats_effect_kernel_Resource$() {
  if ((!$n_Lcats_effect_kernel_Resource$)) {
    $n_Lcats_effect_kernel_Resource$ = new $c_Lcats_effect_kernel_Resource$()
  };
  return $n_Lcats_effect_kernel_Resource$
}
function $p_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__bothUnit__O__O__O($thiz, a, b) {
  $m_Lcats_implicits$();
  var target = $thiz.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.start__O__O(a);
  var tc = $thiz.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
  var this$8 = new $c_Lcats_FlatMap$$anon$2(target, tc);
  var f$2 = new $c_sjsr_AnonFunction1(((this$2, b$2) => ((f) => {
    var f$1 = $as_Lcats_effect_kernel_Fiber(f);
    $m_Lcats_implicits$();
    var F = this$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
    var this$6 = new $c_Lcats_syntax_ApplySyntax$$anon$1(b$2, F);
    $m_Lcats_implicits$();
    var target$1 = f$1.join__O();
    var tc$1 = this$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
    var this$5 = new $c_Lcats_Functor$$anon$4(target$1, tc$1);
    var fb = this$5.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$5.Lcats_Functor$$anon$4__f_self);
    var this$7 = this$6.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
    var fa = this$6.Lcats_syntax_ApplySyntax$$anon$1__f_self;
    return this$7.productR__O__O__O(fa, fb)
  }))($thiz, b));
  return this$8.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$8.Lcats_FlatMap$$anon$2__f_self, f$2)
}
/** @constructor */
function $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2(F$3) {
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1 = null;
  this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1 = F$3
}
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = new $h_O();
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.constructor = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2;
/** @constructor */
function $h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype = $c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype;
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productR__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.pure__O__O = (function(a) {
  $m_Lcats_effect_kernel_package$();
  var fa = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.pure__O__O(a);
  $m_Lcats_effect_kernel_Par$();
  return fa
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  $m_Lcats_effect_kernel_package$();
  var fa$10 = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, fa$2, fb$2, f$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    $m_Lcats_implicits$();
    var target = this$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.start__O__O(($m_Lcats_effect_kernel_package$(), $m_Lcats_effect_kernel_Par$(), fa$2));
    var tc = this$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
    var this$63 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f$14 = new $c_sjsr_AnonFunction1(((this$5, fb$1$2, f$1$2, poll$2) => ((fiberA) => {
      var fiberA$1 = $as_Lcats_effect_kernel_Fiber(fiberA);
      $m_Lcats_implicits$();
      var target$1 = this$5.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.start__O__O(($m_Lcats_effect_kernel_package$(), $m_Lcats_effect_kernel_Par$(), fb$1$2));
      var tc$1 = this$5.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
      var this$62 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
      var f$13 = new $c_sjsr_AnonFunction1(((this$9, f$2$2, poll$1$2, fiberA$2) => ((fiberB) => {
        var fiberB$1 = $as_Lcats_effect_kernel_Fiber(fiberB);
        $m_Lcats_implicits$();
        var $$x1 = this$9.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
        $m_Lcats_implicits$();
        var target$2 = fiberB$1.join__O();
        var tc$2 = this$9.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
        var this$14 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$2);
        var f$1 = new $c_sjsr_AnonFunction1(((this$11, fiberA$1$2) => ((x$1) => {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
            var this$13 = this$11.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
            return this$13.pure__O__O((void 0))
          } else {
            return fiberA$1$2.cancel__O()
          }
        }))(this$9, fiberA$2));
        var target$3 = $$x1.start__O__O(this$14.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$$anon$2__f_self, f$1));
        var tc$3 = this$9.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
        var this$61 = new $c_Lcats_FlatMap$$anon$2(target$3, tc$3);
        var f$12 = new $c_sjsr_AnonFunction1(((this$2$1, f$3$2, poll$2$2, fiberA$1$3, fiberB$2) => ((x$1$2$1) => {
          $as_Lcats_effect_kernel_Fiber(x$1$2$1);
          $m_Lcats_implicits$();
          var $$x2 = this$2$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
          $m_Lcats_implicits$();
          var target$4 = fiberA$1$3.join__O();
          var tc$4 = this$2$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
          var this$20 = new $c_Lcats_FlatMap$$anon$2(target$4, tc$4);
          var f$3 = new $c_sjsr_AnonFunction1(((this$17, fiberB$1$2) => ((x$1$2$2) => {
            var x$1$4 = $as_Lcats_effect_kernel_Outcome(x$1$2$2);
            if ((x$1$4 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
              var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$4);
              var this$19 = this$17.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
              return this$19.pure__O__O((void 0))
            } else {
              return fiberB$1$2.cancel__O()
            }
          }))(this$2$1, fiberB$2));
          var target$5 = $$x2.start__O__O(this$20.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$$anon$2__f_self, f$3));
          var tc$5 = this$2$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
          var this$60 = new $c_Lcats_FlatMap$$anon$2(target$5, tc$5);
          var f$11 = new $c_sjsr_AnonFunction1(((this$2$2, f$4$2, poll$3$2, fiberA$3$2, fiberB$1$3) => ((x$1$3$1) => {
            $as_Lcats_effect_kernel_Fiber(x$1$3$1);
            $m_Lcats_implicits$();
            $m_Lcats_implicits$();
            var target$6 = this$2$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.onCancel__O__O__O(poll$3$2.apply__O__O(fiberA$3$2.join__O()), $p_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__bothUnit__O__O__O(this$2$2, fiberA$3$2.cancel__O(), fiberB$1$3.cancel__O()));
            var tc$6 = this$2$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
            var this$40 = new $c_Lcats_FlatMap$$anon$2(target$6, tc$6);
            var f$5 = new $c_sjsr_AnonFunction1(((this$23, poll$4$2, fiberB$3$2) => ((x$1$2$3) => {
              var x$1$7 = $as_Lcats_effect_kernel_Outcome(x$1$2$3);
              if ((x$1$7 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$8 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$7);
                var x24 = x$1$8.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                return x24
              };
              if ((x$1$7 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$9 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$7);
                var x21 = x$1$9.Lcats_effect_kernel_Outcome$Errored__f_e;
                $m_Lcats_implicits$();
                var fa$1 = fiberB$3$2.cancel__O();
                var F = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                var this$27 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F);
                var fb$1 = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x21);
                var this$28 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$3 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$28.productR__O__O__O(fa$3, fb$1)
              };
              if (((x$1$7 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$7), true))) {
                $m_Lcats_implicits$();
                var fa$4 = fiberB$3$2.cancel__O();
                var F$1 = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                var this$38 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$4, F$1);
                $m_Lcats_implicits$();
                var target$7 = fiberB$3$2.join__O();
                var tc$7 = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                var this$37 = new $c_Lcats_FlatMap$$anon$2(target$7, tc$7);
                var f$4 = new $c_sjsr_AnonFunction1(((this$31) => ((x$1$2$4) => {
                  var x$1$10 = $as_Lcats_effect_kernel_Outcome(x$1$2$4);
                  matchAlts1: {
                    matchAlts2: {
                      if ((x$1$10 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                        var x$1$11 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$10);
                        break matchAlts2
                      };
                      if (((x$1$10 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$10), true))) {
                        break matchAlts2
                      };
                      break matchAlts1
                    };
                    $m_Lcats_implicits$();
                    var fa$5 = this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.canceled__O();
                    var F$2 = this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                    var this$34 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$5, F$2);
                    var fb$3 = this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.never__O();
                    var this$35 = this$34.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                    var fa$6 = this$34.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                    return this$35.productR__O__O__O(fa$6, fb$3)
                  };
                  if ((x$1$10 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                    var x$1$12 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$10);
                    var x12 = x$1$12.Lcats_effect_kernel_Outcome$Errored__f_e;
                    return this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x12)
                  };
                  throw new $c_s_MatchError(x$1$10)
                }))(this$23));
                var fb$4 = poll$4$2.apply__O__O(this$37.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$37.Lcats_FlatMap$$anon$2__f_self, f$4));
                var this$39 = this$38.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$7 = this$38.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$39.productR__O__O__O(fa$7, fb$4)
              };
              throw new $c_s_MatchError(x$1$7)
            }))(this$2$2, poll$3$2, fiberB$1$3));
            var target$8 = this$40.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$40.Lcats_FlatMap$$anon$2__f_self, f$5);
            var tc$8 = this$2$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
            var this$59 = new $c_Lcats_FlatMap$$anon$2(target$8, tc$8);
            var f$10 = new $c_sjsr_AnonFunction1(((this$2$3, f$5$2, poll$4$3, fiberA$4$2, fiberB$3$3) => ((a) => {
              $m_Lcats_implicits$();
              $m_Lcats_implicits$();
              var target$9 = this$2$3.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.onCancel__O__O__O(poll$4$3.apply__O__O(fiberB$3$3.join__O()), fiberB$3$3.cancel__O());
              var tc$9 = this$2$3.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
              var this$56 = new $c_Lcats_FlatMap$$anon$2(target$9, tc$9);
              var f$8 = new $c_sjsr_AnonFunction1(((this$43, f$6$2, poll$6$2, fiberA$5$2, a$2) => ((x$1$13) => {
                var x$1$14 = $as_Lcats_effect_kernel_Outcome(x$1$13);
                if ((x$1$14 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                  var x$1$15 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$14);
                  var x40 = x$1$15.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                  $m_Lcats_implicits$();
                  var tc$10 = this$43.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                  var this$46 = new $c_Lcats_Functor$$anon$4(x40, tc$10);
                  var f$6 = new $c_sjsr_AnonFunction1(((f$7$2, a$1$2) => ((b) => f$7$2.apply__O__O__O(a$1$2, b)))(f$6$2, a$2));
                  return this$46.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$46.Lcats_Functor$$anon$4__f_self, f$6)
                };
                if ((x$1$14 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                  var x$1$16 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$14);
                  var x37 = x$1$16.Lcats_effect_kernel_Outcome$Errored__f_e;
                  return this$43.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x37)
                };
                if (((x$1$14 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$14), true))) {
                  $m_Lcats_implicits$();
                  var target$10 = fiberA$5$2.join__O();
                  var tc$11 = this$43.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                  var this$55 = new $c_Lcats_FlatMap$$anon$2(target$10, tc$11);
                  var f$7 = new $c_sjsr_AnonFunction1(((this$49) => ((x$1$2$5) => {
                    var x$1$17 = $as_Lcats_effect_kernel_Outcome(x$1$2$5);
                    matchAlts3: {
                      matchAlts4: {
                        if ((x$1$17 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                          var x$1$18 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$17);
                          break matchAlts4
                        };
                        if (((x$1$17 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$17), true))) {
                          break matchAlts4
                        };
                        break matchAlts3
                      };
                      $m_Lcats_implicits$();
                      var fa$8 = this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.canceled__O();
                      var F$3 = this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                      var this$52 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$8, F$3);
                      var fb$5 = this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.never__O();
                      var this$53 = this$52.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                      var fa$9 = this$52.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                      return this$53.productR__O__O__O(fa$9, fb$5)
                    };
                    if ((x$1$17 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                      var x$1$19 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$17);
                      var x28 = x$1$19.Lcats_effect_kernel_Outcome$Errored__f_e;
                      return this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x28)
                    };
                    throw new $c_s_MatchError(x$1$17)
                  }))(this$43));
                  return poll$6$2.apply__O__O(this$55.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$55.Lcats_FlatMap$$anon$2__f_self, f$7))
                };
                throw new $c_s_MatchError(x$1$14)
              }))(this$2$3, f$5$2, poll$4$3, fiberA$4$2, a));
              var target$11 = this$56.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$56.Lcats_FlatMap$$anon$2__f_self, f$8);
              var tc$12 = this$2$3.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
              var this$58 = new $c_Lcats_Functor$$anon$4(target$11, tc$12);
              var f$9 = new $c_sjsr_AnonFunction1(((z) => z));
              return this$58.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$58.Lcats_Functor$$anon$4__f_self, f$9)
            }))(this$2$2, f$4$2, poll$3$2, fiberA$3$2, fiberB$1$3));
            return this$59.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$59.Lcats_FlatMap$$anon$2__f_self, f$10)
          }))(this$2$1, f$3$2, poll$2$2, fiberA$1$3, fiberB$2));
          return this$60.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$60.Lcats_FlatMap$$anon$2__f_self, f$11)
        }))(this$9, f$2$2, poll$1$2, fiberA$2, fiberB$1));
        return this$61.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$61.Lcats_FlatMap$$anon$2__f_self, f$12)
      }))(this$5, f$1$2, poll$2, fiberA$1));
      return this$62.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$62.Lcats_FlatMap$$anon$2__f_self, f$13)
    }))(this$1, fb$2, f$2, poll$1));
    return this$63.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$63.Lcats_FlatMap$$anon$2__f_self, f$14)
  }))(this, fa, fb, f)));
  $m_Lcats_effect_kernel_Par$();
  return fa$10
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  $m_Lcats_Eval$();
  $m_Lcats_effect_kernel_package$();
  var fa$10 = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, fa$2, fb$2, f$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    $m_Lcats_implicits$();
    var target = this$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.start__O__O(($m_Lcats_effect_kernel_package$(), $m_Lcats_effect_kernel_Par$(), fa$2));
    var tc = this$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
    var this$63 = new $c_Lcats_FlatMap$$anon$2(target, tc);
    var f$14 = new $c_sjsr_AnonFunction1(((this$5, fb$3$2, f$9$2, poll$2) => ((fiberA) => {
      var fiberA$1 = $as_Lcats_effect_kernel_Fiber(fiberA);
      $m_Lcats_implicits$();
      var $$x1 = this$5.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
      $m_Lcats_effect_kernel_package$();
      var t = fb$3$2.value__O();
      $m_Lcats_effect_kernel_Par$();
      var target$1 = $$x1.start__O__O(t);
      var tc$1 = this$5.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
      var this$62 = new $c_Lcats_FlatMap$$anon$2(target$1, tc$1);
      var f$13 = new $c_sjsr_AnonFunction1(((this$9, f$10$2, poll$8$2, fiberA$2) => ((fiberB) => {
        var fiberB$1 = $as_Lcats_effect_kernel_Fiber(fiberB);
        $m_Lcats_implicits$();
        var $$x2 = this$9.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
        $m_Lcats_implicits$();
        var target$2 = fiberB$1.join__O();
        var tc$2 = this$9.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
        var this$14 = new $c_Lcats_FlatMap$$anon$2(target$2, tc$2);
        var f$1 = new $c_sjsr_AnonFunction1(((this$11, fiberA$7$2) => ((x$1) => {
          var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
          if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
            var this$13 = this$11.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
            return this$13.pure__O__O((void 0))
          } else {
            return fiberA$7$2.cancel__O()
          }
        }))(this$9, fiberA$2));
        var target$3 = $$x2.start__O__O(this$14.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$14.Lcats_FlatMap$$anon$2__f_self, f$1));
        var tc$3 = this$9.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
        var this$61 = new $c_Lcats_FlatMap$$anon$2(target$3, tc$3);
        var f$12 = new $c_sjsr_AnonFunction1(((this$2$1, f$11$2, poll$9$2, fiberA$7$3, fiberB$2) => ((x$1$2$1) => {
          $as_Lcats_effect_kernel_Fiber(x$1$2$1);
          $m_Lcats_implicits$();
          var $$x3 = this$2$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
          $m_Lcats_implicits$();
          var target$4 = fiberA$7$3.join__O();
          var tc$4 = this$2$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
          var this$20 = new $c_Lcats_FlatMap$$anon$2(target$4, tc$4);
          var f$3 = new $c_sjsr_AnonFunction1(((this$17, fiberB$6$2) => ((x$1$2$2) => {
            var x$1$4 = $as_Lcats_effect_kernel_Outcome(x$1$2$2);
            if ((x$1$4 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
              var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$4);
              var this$19 = this$17.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
              return this$19.pure__O__O((void 0))
            } else {
              return fiberB$6$2.cancel__O()
            }
          }))(this$2$1, fiberB$2));
          var target$5 = $$x3.start__O__O(this$20.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$$anon$2__f_self, f$3));
          var tc$5 = this$2$1.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
          var this$60 = new $c_Lcats_FlatMap$$anon$2(target$5, tc$5);
          var f$11 = new $c_sjsr_AnonFunction1(((this$2$2, f$12$2, poll$10$2, fiberA$9$2, fiberB$6$3) => ((x$1$3$1) => {
            $as_Lcats_effect_kernel_Fiber(x$1$3$1);
            $m_Lcats_implicits$();
            $m_Lcats_implicits$();
            var target$6 = this$2$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.onCancel__O__O__O(poll$10$2.apply__O__O(fiberA$9$2.join__O()), $p_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__bothUnit__O__O__O(this$2$2, fiberA$9$2.cancel__O(), fiberB$6$3.cancel__O()));
            var tc$6 = this$2$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
            var this$40 = new $c_Lcats_FlatMap$$anon$2(target$6, tc$6);
            var f$5 = new $c_sjsr_AnonFunction1(((this$23, poll$11$2, fiberB$8$2) => ((x$1$2$3) => {
              var x$1$7 = $as_Lcats_effect_kernel_Outcome(x$1$2$3);
              if ((x$1$7 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$8 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$7);
                var x66 = x$1$8.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                return x66
              };
              if ((x$1$7 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$9 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$7);
                var x63 = x$1$9.Lcats_effect_kernel_Outcome$Errored__f_e;
                $m_Lcats_implicits$();
                var fa$1 = fiberB$8$2.cancel__O();
                var F = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                var this$27 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, F);
                var fb$1 = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x63);
                var this$28 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$3 = this$27.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$28.productR__O__O__O(fa$3, fb$1)
              };
              if (((x$1$7 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$7), true))) {
                $m_Lcats_implicits$();
                var fa$4 = fiberB$8$2.cancel__O();
                var F$1 = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                var this$38 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$4, F$1);
                $m_Lcats_implicits$();
                var target$7 = fiberB$8$2.join__O();
                var tc$7 = this$23.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                var this$37 = new $c_Lcats_FlatMap$$anon$2(target$7, tc$7);
                var f$4 = new $c_sjsr_AnonFunction1(((this$31) => ((x$1$2$4) => {
                  var x$1$10 = $as_Lcats_effect_kernel_Outcome(x$1$2$4);
                  matchAlts5: {
                    matchAlts6: {
                      if ((x$1$10 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                        var x$1$11 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$10);
                        break matchAlts6
                      };
                      if (((x$1$10 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$10), true))) {
                        break matchAlts6
                      };
                      break matchAlts5
                    };
                    $m_Lcats_implicits$();
                    var fa$5 = this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.canceled__O();
                    var F$2 = this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                    var this$34 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$5, F$2);
                    var fb$3 = this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.never__O();
                    var this$35 = this$34.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                    var fa$6 = this$34.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                    return this$35.productR__O__O__O(fa$6, fb$3)
                  };
                  if ((x$1$10 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                    var x$1$12 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$10);
                    var x54 = x$1$12.Lcats_effect_kernel_Outcome$Errored__f_e;
                    return this$31.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x54)
                  };
                  throw new $c_s_MatchError(x$1$10)
                }))(this$23));
                var fb$4 = poll$11$2.apply__O__O(this$37.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$37.Lcats_FlatMap$$anon$2__f_self, f$4));
                var this$39 = this$38.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$7 = this$38.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$39.productR__O__O__O(fa$7, fb$4)
              };
              throw new $c_s_MatchError(x$1$7)
            }))(this$2$2, poll$10$2, fiberB$6$3));
            var target$8 = this$40.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$40.Lcats_FlatMap$$anon$2__f_self, f$5);
            var tc$8 = this$2$2.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
            var this$59 = new $c_Lcats_FlatMap$$anon$2(target$8, tc$8);
            var f$10 = new $c_sjsr_AnonFunction1(((this$2$3, f$13$2, poll$11$3, fiberA$10$2, fiberB$8$3) => ((a) => {
              $m_Lcats_implicits$();
              $m_Lcats_implicits$();
              var target$9 = this$2$3.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.onCancel__O__O__O(poll$11$3.apply__O__O(fiberB$8$3.join__O()), fiberB$8$3.cancel__O());
              var tc$9 = this$2$3.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
              var this$56 = new $c_Lcats_FlatMap$$anon$2(target$9, tc$9);
              var f$8 = new $c_sjsr_AnonFunction1(((this$43, f$14$2, poll$13$2, fiberA$11$2, a$2) => ((x$1$13) => {
                var x$1$14 = $as_Lcats_effect_kernel_Outcome(x$1$13);
                if ((x$1$14 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                  var x$1$15 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$14);
                  var x82 = x$1$15.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                  $m_Lcats_implicits$();
                  var tc$10 = this$43.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                  var this$46 = new $c_Lcats_Functor$$anon$4(x82, tc$10);
                  var f$6 = new $c_sjsr_AnonFunction1(((f$15$2, a$3$2) => ((b) => f$15$2.apply__O__O__O(a$3$2, b)))(f$14$2, a$2));
                  return this$46.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$46.Lcats_Functor$$anon$4__f_self, f$6)
                };
                if ((x$1$14 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                  var x$1$16 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$14);
                  var x79 = x$1$16.Lcats_effect_kernel_Outcome$Errored__f_e;
                  return this$43.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x79)
                };
                if (((x$1$14 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$14), true))) {
                  $m_Lcats_implicits$();
                  var target$10 = fiberA$11$2.join__O();
                  var tc$11 = this$43.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                  var this$55 = new $c_Lcats_FlatMap$$anon$2(target$10, tc$11);
                  var f$7 = new $c_sjsr_AnonFunction1(((this$49) => ((x$1$2$5) => {
                    var x$1$17 = $as_Lcats_effect_kernel_Outcome(x$1$2$5);
                    matchAlts7: {
                      matchAlts8: {
                        if ((x$1$17 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                          var x$1$18 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$17);
                          break matchAlts8
                        };
                        if (((x$1$17 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$17), true))) {
                          break matchAlts8
                        };
                        break matchAlts7
                      };
                      $m_Lcats_implicits$();
                      var fa$8 = this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.canceled__O();
                      var F$3 = this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
                      var this$52 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$8, F$3);
                      var fb$5 = this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.never__O();
                      var this$53 = this$52.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                      var fa$9 = this$52.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                      return this$53.productR__O__O__O(fa$9, fb$5)
                    };
                    if ((x$1$17 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                      var x$1$19 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$17);
                      var x70 = x$1$19.Lcats_effect_kernel_Outcome$Errored__f_e;
                      return this$49.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1.raiseError__O__O(x70)
                    };
                    throw new $c_s_MatchError(x$1$17)
                  }))(this$43));
                  return poll$13$2.apply__O__O(this$55.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$55.Lcats_FlatMap$$anon$2__f_self, f$7))
                };
                throw new $c_s_MatchError(x$1$14)
              }))(this$2$3, f$13$2, poll$11$3, fiberA$10$2, a));
              var target$11 = this$56.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$56.Lcats_FlatMap$$anon$2__f_self, f$8);
              var tc$12 = this$2$3.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
              var this$58 = new $c_Lcats_Functor$$anon$4(target$11, tc$12);
              var f$9 = new $c_sjsr_AnonFunction1(((z) => z));
              return this$58.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$58.Lcats_Functor$$anon$4__f_self, f$9)
            }))(this$2$2, f$12$2, poll$10$2, fiberA$9$2, fiberB$6$3));
            return this$59.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$59.Lcats_FlatMap$$anon$2__f_self, f$10)
          }))(this$2$1, f$11$2, poll$9$2, fiberA$7$3, fiberB$2));
          return this$60.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$60.Lcats_FlatMap$$anon$2__f_self, f$11)
        }))(this$9, f$10$2, poll$8$2, fiberA$2, fiberB$1));
        return this$61.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$61.Lcats_FlatMap$$anon$2__f_self, f$12)
      }))(this$5, f$9$2, poll$2, fiberA$1));
      return this$62.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$62.Lcats_FlatMap$$anon$2__f_self, f$13)
    }))(this$1, fb$2, f$2, poll$1));
    return this$63.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$63.Lcats_FlatMap$$anon$2__f_self, f$14)
  }))(this, fa, fb, f)));
  $m_Lcats_effect_kernel_Par$();
  return new $c_Lcats_Now(fa$10)
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return this.map2__O__O__F2__O(ff, fa, new $c_sjsr_AnonFunction2(((_$6, _$7) => {
    var _$6$1 = $as_F1(_$6);
    return _$6$1.apply__O__O(_$7)
  })))
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return this.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2(((_$8, _$9) => new $c_T2(_$8, _$9))))
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  $m_Lcats_effect_kernel_package$();
  $m_Lcats_implicits$();
  $m_Lcats_effect_kernel_package$();
  $m_Lcats_effect_kernel_Par$();
  var tc = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
  var this$4 = new $c_Lcats_Functor$$anon$4(fa, tc);
  var fa$1 = this$4.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$4.Lcats_Functor$$anon$4__f_self, f);
  $m_Lcats_effect_kernel_Par$();
  return fa$1
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.unit__O = (function() {
  $m_Lcats_effect_kernel_package$();
  var this$1 = this.Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2__f_F$1;
  var fa = this$1.pure__O__O((void 0));
  $m_Lcats_effect_kernel_Par$();
  return fa
});
var $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2 = new $TypeData().initClass({
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2: 0
}, false, "cats.effect.kernel.instances.GenSpawnInstances$$anon$2", {
  Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1
});
$c_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2.prototype.$classData = $d_Lcats_effect_kernel_instances_GenSpawnInstances$$anon$2;
/** @constructor */
function $c_Lcats_kernel_instances_BigIntOrder() {
  /*<skip>*/
}
$c_Lcats_kernel_instances_BigIntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BigIntOrder.prototype.constructor = $c_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BigIntOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BigIntOrder.prototype = $c_Lcats_kernel_instances_BigIntOrder.prototype;
$c_Lcats_kernel_instances_BigIntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $as_s_math_BigInt(x);
  return x$1.hashCode__I()
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return x$1.compare__s_math_BigInt__I(y$1)
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  var x$1 = $as_s_math_BigInt(x);
  var y$1 = $as_s_math_BigInt(y);
  return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(x$1, y$1)
});
var $d_Lcats_kernel_instances_BigIntOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BigIntOrder: 0
}, false, "cats.kernel.instances.BigIntOrder", {
  Lcats_kernel_instances_BigIntOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_Next: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_Previous: 1,
  Lcats_kernel_UnboundedEnumerable: 1,
  Lcats_kernel_instances_BigIntUnboundedEnum: 1
});
$c_Lcats_kernel_instances_BigIntOrder.prototype.$classData = $d_Lcats_kernel_instances_BigIntOrder;
/** @constructor */
function $c_sc_AbstractSeq() {
  /*<skip>*/
}
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
  /*<skip>*/
}
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__O(suffix)
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_sc_AbstractSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_AbstractSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize)
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sc_AbstractSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z($uI(x))
});
/** @constructor */
function $c_sc_AbstractSeqView() {
  /*<skip>*/
}
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
  /*<skip>*/
}
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n)
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_AbstractSeqView.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_AbstractSeqView.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_AbstractSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_AbstractSeqView.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)))
}
function $as_sc_IndexedSeq(obj) {
  return (($is_sc_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.IndexedSeq"))
}
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)))
}
function $asArrayOf_sc_IndexedSeq(obj, depth) {
  return (($isArrayOf_sc_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.IndexedSeq;", depth))
}
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)))
}
function $as_sc_LinearSeq(obj) {
  return (($is_sc_LinearSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.LinearSeq"))
}
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)))
}
function $asArrayOf_sc_LinearSeq(obj, depth) {
  return (($isArrayOf_sc_LinearSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.LinearSeq;", depth))
}
/** @constructor */
function $c_sc_View$Empty$() {
  /*<skip>*/
}
$c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$c_sc_View$Empty$.prototype.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
  /*<skip>*/
}
$h_sc_View$Empty$.prototype = $c_sc_View$Empty$.prototype;
$c_sc_View$Empty$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sc_View$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sc_View$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sc_View$Empty$.prototype.productPrefix__T = (function() {
  return "Empty"
});
$c_sc_View$Empty$.prototype.productArity__I = (function() {
  return 0
});
$c_sc_View$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sc_View$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_View$Empty$.prototype.hashCode__I = (function() {
  return 67081517
});
var $d_sc_View$Empty$ = new $TypeData().initClass({
  sc_View$Empty$: 0
}, false, "scala.collection.View$Empty$", {
  sc_View$Empty$: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_View$Empty$.prototype.$classData = $d_sc_View$Empty$;
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$()
  };
  return $n_sc_View$Empty$
}
function $is_sci_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Set)))
}
function $as_sci_Set(obj) {
  return (($is_sci_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set"))
}
function $isArrayOf_sci_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set)))
}
function $asArrayOf_sci_Set(obj, depth) {
  return (($isArrayOf_sci_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set;", depth))
}
function $f_Lcats_MonadError__redeemWith__O__F1__F1__O($thiz, fa, recover, bind) {
  return $thiz.flatMap__O__F1__O($thiz.attempt__O__O(fa), new $c_sjsr_AnonFunction1(((recover$2, bind$2) => ((_$3) => {
    var _$3$1 = $as_s_util_Either(_$3);
    return _$3$1.fold__F1__F1__O(recover$2, bind$2)
  }))(recover, bind)))
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonad() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_ResourceMonad.prototype = new $h_O();
$c_Lcats_effect_kernel_ResourceMonad.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonad;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonad() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceMonad.prototype = $c_Lcats_effect_kernel_ResourceMonad.prototype;
$c_Lcats_effect_kernel_ResourceMonad.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.unit__O = (function() {
  return new $c_Lcats_effect_kernel_Resource$Pure((void 0))
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_effect_kernel_Resource$Pure(x)
});
$c_Lcats_effect_kernel_ResourceMonad.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return new $c_Lcats_effect_kernel_Resource$Bind(fa$1, f)
});
/** @constructor */
function $c_sc_AbstractMap() {
  /*<skip>*/
}
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
  /*<skip>*/
}
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o)
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this)
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map"
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $as_sc_IterableOps(this.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(coll))
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this)
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f)
});
$c_sc_AbstractMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key)
});
$c_sc_AbstractMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key)
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sc_AbstractMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll)
});
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
  /*<skip>*/
}
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView"
});
$c_sc_SeqView$Drop.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Drop.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator()
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len)
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Drop__f_underlying;
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0)
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Drop__f_underlying.apply__I__O(((i + this.sc_View$Drop__f_normN) | 0))
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0))
});
$c_sc_SeqView$Drop.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n)
});
var $d_sc_SeqView$Drop = new $TypeData().initClass({
  sc_SeqView$Drop: 0
}, false, "scala.collection.SeqView$Drop", {
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Drop.prototype.$classData = $d_sc_SeqView$Drop;
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null
}
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
  /*<skip>*/
}
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Id__f_underlying.apply__I__O(idx)
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return this.sc_SeqView$Id__f_underlying.length__I()
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Id__f_underlying.iterator__sc_Iterator()
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Id__f_underlying.knownSize__I()
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Id__f_underlying.isEmpty__Z()
});
var $d_sc_SeqView$Id = new $TypeData().initClass({
  sc_SeqView$Id: 0
}, false, "scala.collection.SeqView$Id", {
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Id.prototype.$classData = $d_sc_SeqView$Id;
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null
}
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
  /*<skip>*/
}
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix)
});
$c_sc_SeqView$Map.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Map__f_f.apply__O__O(this.sc_SeqView$Map__f_underlying.apply__I__O(idx))
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return this.sc_SeqView$Map__f_underlying.length__I()
});
$c_sc_SeqView$Map.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord)
});
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Reverse__f_underlying = underlying;
  return $thiz
}
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null
}
$c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Reverse.prototype.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
  /*<skip>*/
}
$h_sc_SeqView$Reverse.prototype = $c_sc_SeqView$Reverse.prototype;
$c_sc_SeqView$Reverse.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Reverse__f_underlying.apply__I__O((((((-1) + this.length__I()) | 0) - i) | 0))
});
$c_sc_SeqView$Reverse.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Reverse__f_underlying;
  return this$1.length__I()
});
$c_sc_SeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Reverse__f_underlying.reverseIterator__sc_Iterator()
});
$c_sc_SeqView$Reverse.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Reverse__f_underlying.knownSize__I()
});
$c_sc_SeqView$Reverse.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Reverse__f_underlying.isEmpty__Z()
});
var $d_sc_SeqView$Reverse = new $TypeData().initClass({
  sc_SeqView$Reverse: 0
}, false, "scala.collection.SeqView$Reverse", {
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
});
$c_sc_SeqView$Reverse.prototype.$classData = $d_sc_SeqView$Reverse;
function $f_sc_SortedSet__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true
  };
  if ($is_sc_SortedSet(that)) {
    var x2 = $as_sc_SortedSet(that);
    var x = x2.ordering__s_math_Ordering();
    var x$2 = $thiz.ordering__s_math_Ordering();
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      if (($thiz.size__I() === x2.size__I())) {
        var i1 = $thiz.iterator__sc_Iterator();
        var i2 = x2.iterator__sc_Iterator();
        var allEqual = true;
        while ((allEqual && i1.hasNext__Z())) {
          allEqual = $thiz.ordering__s_math_Ordering().equiv__O__O__Z(i1.next__O(), i2.next__O())
        };
        return allEqual
      } else {
        return false
      }
    }
  };
  return $f_sc_Set__equals__O__Z($thiz, that)
}
function $is_sc_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_SortedSet)))
}
function $as_sc_SortedSet(obj) {
  return (($is_sc_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.SortedSet"))
}
function $isArrayOf_sc_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_SortedSet)))
}
function $asArrayOf_sc_SortedSet(obj, depth) {
  return (($isArrayOf_sc_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.SortedSet;", depth))
}
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)))
}
function $as_sci_Seq(obj) {
  return (($is_sci_Seq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Seq"))
}
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)))
}
function $asArrayOf_sci_Seq(obj, depth) {
  return (($isArrayOf_sci_Seq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Seq;", depth))
}
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  var this$1 = $as_scm_Growable($thiz);
  var elem = new $c_T2(key, value);
  this$1.addOne__O__scm_Growable(elem)
}
/** @constructor */
function $c_Lcats_Invariant$() {
  this.Lcats_Invariant$__f_catsInvariantMonoid = null;
  this.Lcats_Invariant$__f_catsInvariantBand = null;
  this.Lcats_Invariant$__f_catsInvariantSemilattice = null;
  this.Lcats_Invariant$__f_catsInvariantCommutativeMonoid = null;
  this.Lcats_Invariant$__f_catsInvariantBoundedSemilattice = null;
  this.Lcats_Invariant$__f_catsInvariantGroup = null;
  this.Lcats_Invariant$__f_catsInvariantCommutativeGroup = null;
  $n_Lcats_Invariant$ = this;
  this.Lcats_Invariant$__f_catsInvariantMonoid = new $c_Lcats_Invariant$$anon$4();
  this.Lcats_Invariant$__f_catsInvariantBand = new $c_Lcats_Invariant$$anon$5();
  this.Lcats_Invariant$__f_catsInvariantSemilattice = new $c_Lcats_Invariant$$anon$6();
  this.Lcats_Invariant$__f_catsInvariantCommutativeMonoid = new $c_Lcats_Invariant$$anon$7();
  this.Lcats_Invariant$__f_catsInvariantBoundedSemilattice = new $c_Lcats_Invariant$$anon$8();
  this.Lcats_Invariant$__f_catsInvariantGroup = new $c_Lcats_Invariant$$anon$9();
  this.Lcats_Invariant$__f_catsInvariantCommutativeGroup = new $c_Lcats_Invariant$$anon$10()
}
$c_Lcats_Invariant$.prototype = new $h_O();
$c_Lcats_Invariant$.prototype.constructor = $c_Lcats_Invariant$;
/** @constructor */
function $h_Lcats_Invariant$() {
  /*<skip>*/
}
$h_Lcats_Invariant$.prototype = $c_Lcats_Invariant$.prototype;
var $d_Lcats_Invariant$ = new $TypeData().initClass({
  Lcats_Invariant$: 0
}, false, "cats.Invariant$", {
  Lcats_Invariant$: 1,
  O: 1,
  Lcats_ScalaVersionSpecificInvariantInstances: 1,
  Lcats_instances_NTupleMonadInstances5: 1,
  Lcats_instances_NTupleMonadInstances4: 1,
  Lcats_instances_NTupleMonadInstances3: 1,
  Lcats_instances_NTupleMonadInstances2: 1,
  Lcats_instances_NTupleMonadInstances1: 1,
  Lcats_instances_NTupleMonadInstances: 1,
  Lcats_TupleInstances2: 1,
  Lcats_TupleInstances1: 1,
  Lcats_TupleInstances0: 1,
  Lcats_InvariantInstances2: 1,
  Lcats_InvariantInstances1: 1,
  Lcats_InvariantInstances0: 1
});
$c_Lcats_Invariant$.prototype.$classData = $d_Lcats_Invariant$;
var $n_Lcats_Invariant$;
function $m_Lcats_Invariant$() {
  if ((!$n_Lcats_Invariant$)) {
    $n_Lcats_Invariant$ = new $c_Lcats_Invariant$()
  };
  return $n_Lcats_Invariant$
}
function $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli($thiz, e) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, e$2) => ((_$154) => this$1.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1.raiseError__O__O(e$2)))($thiz, e));
  return new $c_Lcats_data_Kleisli(run)
}
function $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli($thiz, kb, f) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, kb$2, f$2) => ((a) => this$1.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1.handleErrorWith__O__F1__O(kb$2.Lcats_data_Kleisli__f_run.apply__O__O(a), new $c_sjsr_AnonFunction1(((f$28$2, a$2) => ((e) => $as_Lcats_data_Kleisli(f$28$2.apply__O__O(e)).Lcats_data_Kleisli__f_run.apply__O__O(a$2)))(f$2, a)))))($thiz, kb, f));
  return new $c_Lcats_data_Kleisli(run)
}
function $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O($thiz, fa, fin) {
  return $thiz.guaranteeCase__O__F1__O(fa, new $c_sjsr_AnonFunction1(((fin$2) => ((_$2) => {
    $as_Lcats_effect_kernel_Outcome(_$2);
    return fin$2
  }))(fin)))
}
function $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O($thiz, fa, fin) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, fa$2, fin$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var finalized = this$1.onCancel__O__O__O(poll$1.apply__O__O(fa$2), fin$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()));
    var pf = new $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin$2, this$1);
    var handled = $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this$1, finalized, pf);
    var f = new $c_sjsr_AnonFunction1(((this$4, fin$2$2) => ((a) => {
      var fa$1 = this$4.pure__O__O(a);
      return fin$2$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1))
    }))(this$1, fin$2));
    return $f_Lcats_FlatMap__flatTap__O__F1__O(this$1, handled, f)
  }))($thiz, fa, fin)))
}
function $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O($thiz, acquire, use, release) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, acquire$2, use$2, release$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = acquire$2.apply__O__O(poll$1);
    var this$5 = new $c_Lcats_FlatMap$$anon$2(target, this$1);
    var f = new $c_sjsr_AnonFunction1(((this$3, use$1$2, release$2$2, poll$2) => ((a) => {
      var fa = this$3.unit__O();
      return this$3.guaranteeCase__O__F1__O(poll$2.apply__O__O($m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0(((use$2$2, a$2) => (() => use$2$2.apply__O__O(a$2)))(use$1$2, a)), this$3)), new $c_sjsr_AnonFunction1(((release$3$2, a$3) => ((_$6) => {
        var _$6$1 = $as_Lcats_effect_kernel_Outcome(_$6);
        return release$3$2.apply__O__O__O(a$3, _$6$1)
      }))(release$2$2, a)))
    }))(this$1, use$2, release$2, poll$1));
    return this$5.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$5.Lcats_FlatMap$$anon$2__f_self, f)
  }))($thiz, acquire, use, release)))
}
/** @constructor */
function $c_Lfs2_PullMonadErrorInstance() {
  /*<skip>*/
}
$c_Lfs2_PullMonadErrorInstance.prototype = new $h_O();
$c_Lfs2_PullMonadErrorInstance.prototype.constructor = $c_Lfs2_PullMonadErrorInstance;
/** @constructor */
function $h_Lfs2_PullMonadErrorInstance() {
  /*<skip>*/
}
$h_Lfs2_PullMonadErrorInstance.prototype = $c_Lfs2_PullMonadErrorInstance.prototype;
$c_Lfs2_PullMonadErrorInstance.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lfs2_PullMonadErrorInstance.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lfs2_PullMonadErrorInstance.prototype.unit__O = (function() {
  $m_Lfs2_Pull$();
  return new $c_Lfs2_Pull$Succeeded((void 0))
});
$c_Lfs2_PullMonadErrorInstance.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa)
});
$c_Lfs2_PullMonadErrorInstance.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lfs2_PullMonadErrorInstance.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lfs2_PullMonadErrorInstance.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lfs2_PullMonadErrorInstance.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lfs2_PullMonadErrorInstance.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lfs2_PullMonadErrorInstance.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lfs2_PullMonadErrorInstance.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lfs2_PullMonadErrorInstance.prototype.tailRecM__O__F1__Lfs2_Pull = (function(a, f) {
  var this$4 = $as_Lfs2_Pull(f.apply__O__O(a));
  var f$1 = new $c_sjsr_AnonFunction1(((this$1, f$2) => ((x$1) => {
    var x$1$1 = $as_s_util_Either(x$1);
    if ((x$1$1 instanceof $c_s_util_Left)) {
      var a$1 = $as_s_util_Left(x$1$1).s_util_Left__f_value;
      return this$1.tailRecM__O__F1__Lfs2_Pull(a$1, f$2)
    };
    if ((x$1$1 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x$1$1).s_util_Right__f_value;
      $m_Lfs2_Pull$();
      return new $c_Lfs2_Pull$Succeeded(b)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this, f));
  return new $c_Lfs2_Pull$$anon$1(f$1, this$4)
});
$c_Lfs2_PullMonadErrorInstance.prototype.pure__O__O = (function(x) {
  $m_Lfs2_Pull$();
  return new $c_Lfs2_Pull$Succeeded(x)
});
$c_Lfs2_PullMonadErrorInstance.prototype.flatMap__O__F1__O = (function(fa, f) {
  var p = $as_Lfs2_Pull(fa);
  return new $c_Lfs2_Pull$$anon$1(f, p)
});
$c_Lfs2_PullMonadErrorInstance.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lfs2_Pull(a, f)
});
$c_Lfs2_PullMonadErrorInstance.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lfs2_Pull$();
  return new $c_Lfs2_Pull$Fail(e$1)
});
$c_Lfs2_PullMonadErrorInstance.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lfs2_Pull(fa);
  return new $c_Lfs2_Pull$$anon$3(f, fa$1)
});
var $d_Lfs2_PullMonadErrorInstance = new $TypeData().initClass({
  Lfs2_PullMonadErrorInstance: 0
}, false, "fs2.PullMonadErrorInstance", {
  Lfs2_PullMonadErrorInstance: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1
});
$c_Lfs2_PullMonadErrorInstance.prototype.$classData = $d_Lfs2_PullMonadErrorInstance;
/** @constructor */
function $c_sc_AbstractMapView() {
  /*<skip>*/
}
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
  /*<skip>*/
}
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this)
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView"
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key)
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sc_AbstractMapView.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this)
});
$c_sc_AbstractMapView.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key)
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key)
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end)
});
$c_sc_AbstractMapView.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sc_AbstractMapView.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)))
}
function $as_sci_Map(obj) {
  return (($is_sci_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map"))
}
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)))
}
function $asArrayOf_sci_Map(obj, depth) {
  return (($isArrayOf_sci_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map;", depth))
}
function $is_Lcats_CommutativeMonad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_CommutativeMonad)))
}
function $as_Lcats_CommutativeMonad(obj) {
  return (($is_Lcats_CommutativeMonad(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.CommutativeMonad"))
}
function $isArrayOf_Lcats_CommutativeMonad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_CommutativeMonad)))
}
function $asArrayOf_Lcats_CommutativeMonad(obj, depth) {
  return (($isArrayOf_Lcats_CommutativeMonad(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.CommutativeMonad;", depth))
}
/** @constructor */
function $c_Lcats_data_KleisliInstances0$$anon$1(M$6) {
  this.Lcats_data_KleisliInstances0$$anon$1__f_M$1 = null;
  this.Lcats_data_KleisliInstances0$$anon$1__f_M$1 = M$6
}
$c_Lcats_data_KleisliInstances0$$anon$1.prototype = new $h_O();
$c_Lcats_data_KleisliInstances0$$anon$1.prototype.constructor = $c_Lcats_data_KleisliInstances0$$anon$1;
/** @constructor */
function $h_Lcats_data_KleisliInstances0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances0$$anon$1.prototype = $c_Lcats_data_KleisliInstances0$$anon$1.prototype;
var $d_Lcats_data_KleisliInstances0$$anon$1 = new $TypeData().initClass({
  Lcats_data_KleisliInstances0$$anon$1: 0
}, false, "cats.data.KleisliInstances0$$anon$1", {
  Lcats_data_KleisliInstances0$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_Compose: 1,
  Lcats_arrow_Category: 1,
  Lcats_arrow_Profunctor: 1,
  Lcats_arrow_Strong: 1,
  Lcats_arrow_Arrow: 1,
  Lcats_arrow_CommutativeArrow: 1,
  Lcats_arrow_Choice: 1,
  Lcats_arrow_ArrowChoice: 1,
  Lcats_data_KleisliCompose: 1,
  Lcats_data_KleisliCategory: 1,
  Lcats_data_KleisliStrong: 1,
  Lcats_data_KleisliArrowChoice: 1,
  Lcats_data_KleisliCommutativeArrow: 1
});
$c_Lcats_data_KleisliInstances0$$anon$1.prototype.$classData = $d_Lcats_data_KleisliInstances0$$anon$1;
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli($thiz, body) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, body$2) => ((r) => this$1.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((body$4$2, r$2) => ((nat) => {
    var nat$1 = $as_Lcats_effect_kernel_Poll(nat);
    var natT = new $c_Lcats_effect_kernel_MonadCancel$$anon$13(nat$1);
    return $as_Lcats_data_Kleisli(body$4$2.apply__O__O(natT)).Lcats_data_Kleisli__f_run.apply__O__O(r$2)
  }))(body$2, r)))))($thiz, body));
  return new $c_Lcats_data_Kleisli(run)
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli($thiz) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var x = $thiz.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1.canceled__O();
  return $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$1, x)
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fin) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, fa$2, fin$2) => ((r) => this$1.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1.onCancel__O__O__O(fa$2.Lcats_data_Kleisli__f_run.apply__O__O(r), fin$2.Lcats_data_Kleisli__f_run.apply__O__O(r))))($thiz, fa, fin));
  return new $c_Lcats_data_Kleisli(run)
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli($thiz, fa, fb) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, fa$2, fb$2) => ((r) => this$1.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1.forceR__O__O__O(fa$2.Lcats_data_Kleisli__f_run.apply__O__O(r), fb$2.Lcats_data_Kleisli__f_run.apply__O__O(r))))($thiz, fa, fb));
  return new $c_Lcats_data_Kleisli(run)
}
function $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli($thiz, fa, fin) {
  $m_Lcats_data_Kleisli$();
  var run = new $c_sjsr_AnonFunction1(((this$1, fa$2, fin$2) => ((r) => this$1.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1.guaranteeCase__O__F1__O(fa$2.Lcats_data_Kleisli__f_run.apply__O__O(r), new $c_sjsr_AnonFunction1(((this$2, fin$9$2, r$2) => ((x$1) => {
    var x$1$1 = $as_Lcats_effect_kernel_Outcome(x$1);
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
      var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$1);
      var x35 = x$1$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
      var this$4 = $m_Lcats_data_Kleisli$();
      var fa$1 = $f_Lcats_data_KleisliFunctions__liftF__O__Lcats_data_Kleisli(this$4, x35);
      return $as_Lcats_data_Kleisli(fin$9$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1))).Lcats_data_Kleisli__f_run.apply__O__O(r$2)
    };
    if ((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
      var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$1);
      var x32 = x$1$3.Lcats_effect_kernel_Outcome$Errored__f_e;
      var fa$3 = $as_Lcats_data_Kleisli(fin$9$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x32))).Lcats_data_Kleisli__f_run.apply__O__O(r$2);
      var f = new $c_sjsr_AnonFunction1(((_$51) => (void 0)));
      var F$1 = this$2.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
      return F$1.handleError__O__F1__O(fa$3, f)
    };
    if (((x$1$1 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$1), true))) {
      return $as_Lcats_data_Kleisli(fin$9$2.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled())).Lcats_data_Kleisli__f_run.apply__O__O(r$2)
    };
    throw new $c_s_MatchError(x$1$1)
  }))(this$1, fin$2, r)))))($thiz, fa, fin));
  return new $c_Lcats_data_Kleisli(run)
}
/** @constructor */
function $c_Lcats_instances_Function0Instances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_Function0Instances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_Function0Instances$$anon$1.prototype.constructor = $c_Lcats_instances_Function0Instances$$anon$1;
/** @constructor */
function $h_Lcats_instances_Function0Instances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_Function0Instances$$anon$1.prototype = $c_Lcats_instances_Function0Instances$$anon$1.prototype;
$c_Lcats_instances_Function0Instances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__F0((void 0))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.pure__O__F0 = (function(x) {
  return new $c_sjsr_AnonFunction0(((x$2) => (() => x$2))(x))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map__F0__F1__F0 = (function(fa, fn) {
  return new $c_sjsr_AnonFunction0(((fa$2, fn$2) => (() => fn$2.apply__O__O(fa$2.apply__O())))(fa, fn))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map2__F0__F0__F2__F0 = (function(fa, fb, fn) {
  return new $c_sjsr_AnonFunction0(((fa$2, fb$2, fn$2) => (() => fn$2.apply__O__O__O(fa$2.apply__O(), fb$2.apply__O())))(fa, fb, fn))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.product__F0__F0__F0 = (function(fa, fb) {
  return new $c_sjsr_AnonFunction0(((fa$2, fb$2) => (() => {
    var _1 = fa$2.apply__O();
    var _2 = fb$2.apply__O();
    return new $c_T2(_1, _2)
  }))(fa, fb))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.ap__F0__F0__F0 = (function(f, fa) {
  return new $c_sjsr_AnonFunction0(((f$2, fa$2) => (() => $as_F1(f$2.apply__O()).apply__O__O(fa$2.apply__O())))(f, fa))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.flatMap__F0__F1__F0 = (function(fa, f) {
  return new $c_sjsr_AnonFunction0(((fa$2, f$2) => (() => $as_F0(f$2.apply__O__O(fa$2.apply__O())).apply__O()))(fa, f))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.tailRecM__O__F1__F0 = (function(a, fn) {
  return new $c_sjsr_AnonFunction0(((a$2, fn$2) => (() => $ps_Lcats_instances_Function0Instances__loop$1__F1__O__O(fn$2, a$2)))(a, fn))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__F0(x)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return this.map__F0__F1__F0($as_F0(fa), f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__F0__F0__F2__F0($as_F0(fa), $as_F0(fb), f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__F0__F0__F0($as_F0(fa), $as_F0(fb))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__F0__F0__F0($as_F0(ff), $as_F0(fa))
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.flatMap__F0__F1__F0($as_F0(fa), f)
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__F0(a, f)
});
var $d_Lcats_instances_Function0Instances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_Function0Instances$$anon$1: 0
}, false, "cats.instances.Function0Instances$$anon$1", {
  Lcats_instances_Function0Instances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1
});
$c_Lcats_instances_Function0Instances$$anon$1.prototype.$classData = $d_Lcats_instances_Function0Instances$$anon$1;
/** @constructor */
function $c_Lcats_kernel_instances_BooleanOrder() {
  this.Lcats_kernel_instances_BooleanOrder__f_order = null;
  this.Lcats_kernel_instances_BooleanOrder__f_order = this
}
$c_Lcats_kernel_instances_BooleanOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_BooleanOrder.prototype.constructor = $c_Lcats_kernel_instances_BooleanOrder;
/** @constructor */
function $h_Lcats_kernel_instances_BooleanOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_BooleanOrder.prototype = $c_Lcats_kernel_instances_BooleanOrder.prototype;
$c_Lcats_kernel_instances_BooleanOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.compare__Z__Z__I = (function(x, y) {
  return ((x === y) ? 0 : (x ? 1 : (-1)))
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.eqv__Z__Z__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uZ(x);
  return (x$1 ? 1231 : 1237)
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__Z__Z__I($uZ(x), $uZ(y))
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__Z__Z__Z($uZ(x), $uZ(y))
});
var $d_Lcats_kernel_instances_BooleanOrder = new $TypeData().initClass({
  Lcats_kernel_instances_BooleanOrder: 0
}, false, "cats.kernel.instances.BooleanOrder", {
  Lcats_kernel_instances_BooleanOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_BooleanBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_BooleanEnumerable: 1
});
$c_Lcats_kernel_instances_BooleanOrder.prototype.$classData = $d_Lcats_kernel_instances_BooleanOrder;
/** @constructor */
function $c_Lcats_kernel_instances_ByteOrder() {
  this.Lcats_kernel_instances_ByteOrder__f_order = null;
  this.Lcats_kernel_instances_ByteOrder__f_order = this
}
$c_Lcats_kernel_instances_ByteOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ByteOrder.prototype.constructor = $c_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ByteOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ByteOrder.prototype = $c_Lcats_kernel_instances_ByteOrder.prototype;
$c_Lcats_kernel_instances_ByteOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__B__B__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__B__B__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_ByteOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uB(x);
  return x$1
});
$c_Lcats_kernel_instances_ByteOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__B__B__I($uB(x), $uB(y))
});
$c_Lcats_kernel_instances_ByteOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__B__B__Z($uB(x), $uB(y))
});
var $d_Lcats_kernel_instances_ByteOrder = new $TypeData().initClass({
  Lcats_kernel_instances_ByteOrder: 0
}, false, "cats.kernel.instances.ByteOrder", {
  Lcats_kernel_instances_ByteOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ByteBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ByteEnumerable: 1
});
$c_Lcats_kernel_instances_ByteOrder.prototype.$classData = $d_Lcats_kernel_instances_ByteOrder;
/** @constructor */
function $c_Lcats_kernel_instances_CharOrder() {
  this.Lcats_kernel_instances_CharOrder__f_order = null;
  this.Lcats_kernel_instances_CharOrder__f_order = this
}
$c_Lcats_kernel_instances_CharOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_CharOrder.prototype.constructor = $c_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $h_Lcats_kernel_instances_CharOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_CharOrder.prototype = $c_Lcats_kernel_instances_CharOrder.prototype;
$c_Lcats_kernel_instances_CharOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__C__C__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__C__C__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_CharOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uC(x);
  return x$1
});
$c_Lcats_kernel_instances_CharOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__C__C__I($uC(x), $uC(y))
});
$c_Lcats_kernel_instances_CharOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__C__C__Z($uC(x), $uC(y))
});
var $d_Lcats_kernel_instances_CharOrder = new $TypeData().initClass({
  Lcats_kernel_instances_CharOrder: 0
}, false, "cats.kernel.instances.CharOrder", {
  Lcats_kernel_instances_CharOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_CharBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_CharEnumerable: 1
});
$c_Lcats_kernel_instances_CharOrder.prototype.$classData = $d_Lcats_kernel_instances_CharOrder;
/** @constructor */
function $c_Lcats_kernel_instances_IntOrder() {
  this.Lcats_kernel_instances_IntOrder__f_order = null;
  this.Lcats_kernel_instances_IntOrder__f_order = this
}
$c_Lcats_kernel_instances_IntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_IntOrder.prototype.constructor = $c_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_IntOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_IntOrder.prototype = $c_Lcats_kernel_instances_IntOrder.prototype;
$c_Lcats_kernel_instances_IntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__I__I__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__I__I__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_IntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uI(x);
  return x$1
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__I__I__I($uI(x), $uI(y))
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__I__I__Z($uI(x), $uI(y))
});
var $d_Lcats_kernel_instances_IntOrder = new $TypeData().initClass({
  Lcats_kernel_instances_IntOrder: 0
}, false, "cats.kernel.instances.IntOrder", {
  Lcats_kernel_instances_IntOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_IntBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_IntEnumerable: 1
});
$c_Lcats_kernel_instances_IntOrder.prototype.$classData = $d_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $c_Lcats_kernel_instances_LongOrder() {
  this.Lcats_kernel_instances_LongOrder__f_order = null;
  this.Lcats_kernel_instances_LongOrder__f_order = this
}
$c_Lcats_kernel_instances_LongOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_LongOrder.prototype.constructor = $c_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $h_Lcats_kernel_instances_LongOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_LongOrder.prototype = $c_Lcats_kernel_instances_LongOrder.prototype;
$c_Lcats_kernel_instances_LongOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__J__J__I = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  if (((ahi === bhi) ? (((-2147483648) ^ x.RTLong__f_lo) < ((-2147483648) ^ y.RTLong__f_lo)) : (ahi < bhi))) {
    return (-1)
  } else {
    var ahi$1 = x.RTLong__f_hi;
    var bhi$1 = y.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? (((-2147483648) ^ x.RTLong__f_lo) > ((-2147483648) ^ y.RTLong__f_lo)) : (ahi$1 > bhi$1))) {
      return 1
    } else {
      return 0
    }
  }
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__J__J__Z = (function(x, y) {
  return ((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi))
});
$c_Lcats_kernel_instances_LongOrder.prototype.hash__O__I = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi)
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__J__J__I($uJ(x), $uJ(y))
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__J__J__Z($uJ(x), $uJ(y))
});
var $d_Lcats_kernel_instances_LongOrder = new $TypeData().initClass({
  Lcats_kernel_instances_LongOrder: 0
}, false, "cats.kernel.instances.LongOrder", {
  Lcats_kernel_instances_LongOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_LongBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_LongEnumerable: 1
});
$c_Lcats_kernel_instances_LongOrder.prototype.$classData = $d_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $c_Lcats_kernel_instances_ShortOrder() {
  this.Lcats_kernel_instances_ShortOrder__f_order = null;
  this.Lcats_kernel_instances_ShortOrder__f_order = this
}
$c_Lcats_kernel_instances_ShortOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_ShortOrder.prototype.constructor = $c_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $h_Lcats_kernel_instances_ShortOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_ShortOrder.prototype = $c_Lcats_kernel_instances_ShortOrder.prototype;
$c_Lcats_kernel_instances_ShortOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__S__S__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0))
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__S__S__Z = (function(x, y) {
  return (x === y)
});
$c_Lcats_kernel_instances_ShortOrder.prototype.hash__O__I = (function(x) {
  var x$1 = $uS(x);
  return x$1
});
$c_Lcats_kernel_instances_ShortOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__S__S__I($uS(x), $uS(y))
});
$c_Lcats_kernel_instances_ShortOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__S__S__Z($uS(x), $uS(y))
});
var $d_Lcats_kernel_instances_ShortOrder = new $TypeData().initClass({
  Lcats_kernel_instances_ShortOrder: 0
}, false, "cats.kernel.instances.ShortOrder", {
  Lcats_kernel_instances_ShortOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_ShortBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_ShortEnumerable: 1
});
$c_Lcats_kernel_instances_ShortOrder.prototype.$classData = $d_Lcats_kernel_instances_ShortOrder;
/** @constructor */
function $c_Lcats_kernel_instances_UnitOrder() {
  this.Lcats_kernel_instances_UnitOrder__f_order = null;
  this.Lcats_kernel_instances_UnitOrder__f_order = this
}
$c_Lcats_kernel_instances_UnitOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_UnitOrder.prototype.constructor = $c_Lcats_kernel_instances_UnitOrder;
/** @constructor */
function $h_Lcats_kernel_instances_UnitOrder() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_UnitOrder.prototype = $c_Lcats_kernel_instances_UnitOrder.prototype;
$c_Lcats_kernel_instances_UnitOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y)
});
$c_Lcats_kernel_instances_UnitOrder.prototype.compare__O__O__I = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return 0
});
$c_Lcats_kernel_instances_UnitOrder.prototype.hash__O__I = (function(x) {
  $as_jl_Void(x);
  return 0
});
$c_Lcats_kernel_instances_UnitOrder.prototype.eqv__O__O__Z = (function(x, y) {
  $as_jl_Void(x);
  $as_jl_Void(y);
  return true
});
var $d_Lcats_kernel_instances_UnitOrder = new $TypeData().initClass({
  Lcats_kernel_instances_UnitOrder: 0
}, false, "cats.kernel.instances.UnitOrder", {
  Lcats_kernel_instances_UnitOrder: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_UnitBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_UnitEnumerable: 1
});
$c_Lcats_kernel_instances_UnitOrder.prototype.$classData = $d_Lcats_kernel_instances_UnitOrder;
function $f_Lfs2_Compiler$Target__compile__Lfs2_Pull__O__F2__O($thiz, p, init, foldChunk) {
  return $m_Lcats_effect_kernel_Resource$().makeCase__O__F2__Lcats_Functor__Lcats_effect_kernel_Resource($m_Lfs2_internal_Scope$().newRoot__Lfs2_Compiler$Target__O($thiz), new $c_sjsr_AnonFunction2(((this$1) => ((scope, ec) => {
    var scope$1 = $as_Lfs2_internal_Scope(scope);
    var ec$1 = $as_Lcats_effect_kernel_Resource$ExitCase(ec);
    var fea = scope$1.close__Lcats_effect_kernel_Resource$ExitCase__O(ec$1);
    this$1.F__Lcats_effect_kernel_MonadCancel();
    return $m_Lcats_syntax_MonadErrorRethrowOps$().rethrow$extension__O__Lcats_MonadError__O(fea, this$1.F__Lcats_effect_kernel_MonadCancel())
  }))($thiz)), $thiz.F__Lcats_effect_kernel_MonadCancel()).use__F1__Lcats_effect_kernel_MonadCancel__O(new $c_sjsr_AnonFunction1(((this$2$1, p$2, init$2, foldChunk$2) => ((scope$2) => {
    var scope$3 = $as_Lfs2_internal_Scope(scope$2);
    return $m_Lfs2_Pull$().compile__Lfs2_Pull__Lfs2_internal_Scope__Z__O__F2__Lcats_MonadError__O(p$2, scope$3, false, init$2, foldChunk$2, this$2$1.F__Lcats_effect_kernel_MonadCancel())
  }))($thiz, p, init, foldChunk)), $thiz.F__Lcats_effect_kernel_MonadCancel())
}
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
  /*<skip>*/
}
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_AbstractIndexedSeqView.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
function $is_sc_BitSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_BitSet)))
}
function $as_sc_BitSet(obj) {
  return (($is_sc_BitSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.BitSet"))
}
function $isArrayOf_sc_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_BitSet)))
}
function $asArrayOf_sc_BitSet(obj, depth) {
  return (($isArrayOf_sc_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.BitSet;", depth))
}
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying
}
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
  /*<skip>*/
}
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return this.sc_MapView$Id__f_underlying.get__O__s_Option(key)
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapView$Id__f_underlying.iterator__sc_Iterator()
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return this.sc_MapView$Id__f_underlying.knownSize__I()
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$Id__f_underlying.isEmpty__Z()
});
var $d_sc_MapView$Id = new $TypeData().initClass({
  sc_MapView$Id: 0
}, false, "scala.collection.MapView$Id", {
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$Id.prototype.$classData = $d_sc_MapView$Id;
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f
}
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
  /*<skip>*/
}
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_MapView$MapValues__f_underlying.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((this$1) => ((kv$2) => {
    var kv = $as_T2(kv$2);
    return new $c_T2(kv._1__O(), this$1.sc_MapView$MapValues__f_f.apply__O__O(kv._2__O()))
  }))(this));
  return new $c_sc_Iterator$$anon$9(this$2, f)
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = this.sc_MapView$MapValues__f_underlying.get__O__s_Option(key);
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$1.get__O())))
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return this.sc_MapView$MapValues__f_underlying.knownSize__I()
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$MapValues__f_underlying.isEmpty__Z()
});
var $d_sc_MapView$MapValues = new $TypeData().initClass({
  sc_MapView$MapValues: 0
}, false, "scala.collection.MapView$MapValues", {
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
});
$c_sc_MapView$MapValues.prototype.$classData = $d_sc_MapView$MapValues;
/** @constructor */
function $c_sci_AbstractSet() {
  /*<skip>*/
}
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
  /*<skip>*/
}
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$()
});
function $f_Lcats_effect_kernel_GenSpawn__background__O__Lcats_effect_kernel_Resource($thiz, fa) {
  return $m_Lcats_effect_kernel_Resource$().make__O__F1__Lcats_Functor__Lcats_effect_kernel_Resource($thiz.start__O__O(fa), new $c_sjsr_AnonFunction1(((_$2) => {
    var _$2$1 = $as_Lcats_effect_kernel_Fiber(_$2);
    return _$2$1.cancel__O()
  })), $thiz).map__F1__Lcats_effect_kernel_Resource(new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Lcats_effect_kernel_Fiber(_$3);
    return _$3$1.join__O()
  })))
}
function $f_Lcats_effect_kernel_GenSpawn__race__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, fa$2, fb$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = poll$1.apply__O__O($f_Lcats_effect_kernel_GenConcurrent__racePair__O__O__O(this$1, fa$2, fb$2));
    var this$51 = new $c_Lcats_FlatMap$$anon$2(target, this$1);
    var f$7 = new $c_sjsr_AnonFunction1(((this$3, poll$2) => ((x$1) => {
      var x$1$1 = $as_s_util_Either(x$1);
      if ((x$1$1 instanceof $c_s_util_Left)) {
        var x48 = $as_T2($as_s_util_Left(x$1$1).s_util_Left__f_value);
        if ((x48 !== null)) {
          var oc = $as_Lcats_effect_kernel_Outcome(x48._1__O());
          var f = $as_Lcats_effect_kernel_Fiber(x48._2__O());
          if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$2 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc);
            var x25 = x$1$2.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var fa$1 = f.cancel__O();
            var this$9 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$1, this$3);
            var this$8 = new $c_Lcats_Functor$$anon$4(x25, this$3);
            var f$1 = new $c_sjsr_AnonFunction1(((_$4) => {
              $m_s_package$();
              return new $c_s_util_Left(_$4)
            }));
            var fb$1 = this$8.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$8.Lcats_Functor$$anon$4__f_self, f$1);
            var this$10 = this$9.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
            var fa$3 = this$9.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$10.productR__O__O__O(fa$3, fb$1)
          };
          if ((oc instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$3 = $as_Lcats_effect_kernel_Outcome$Errored(oc);
            var x22 = x$1$3.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$4 = f.cancel__O();
            var this$13 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$4, this$3);
            var fb$3 = this$3.raiseError__O__O(x22);
            var this$14 = this$13.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
            var fa$5 = this$13.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$14.productR__O__O__O(fa$5, fb$3)
          };
          if (((oc instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc), true))) {
            var wrapped = poll$2.apply__O__O(f.join__O());
            var fin = f.cancel__O();
            var target$1 = this$3.onCancel__O__O__O(wrapped, fin);
            var this$27 = new $c_Lcats_FlatMap$$anon$2(target$1, this$3);
            var f$3 = new $c_sjsr_AnonFunction1(((this$18, poll$1$2) => ((x$1$2$1) => {
              var x$1$4 = $as_Lcats_effect_kernel_Outcome(x$1$2$1);
              if ((x$1$4 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$5 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$4);
                var x17 = x$1$5.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                var this$22 = new $c_Lcats_Functor$$anon$4(x17, this$18);
                var f$2 = new $c_sjsr_AnonFunction1(((_$5) => {
                  $m_s_package$();
                  return new $c_s_util_Right(_$5)
                }));
                return this$22.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$22.Lcats_Functor$$anon$4__f_self, f$2)
              };
              if ((x$1$4 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$6 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$4);
                var x14 = x$1$6.Lcats_effect_kernel_Outcome$Errored__f_e;
                return this$18.raiseError__O__O(x14)
              };
              if (((x$1$4 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$4), true))) {
                var fa$6 = poll$1$2.apply__O__O(this$18.canceled__O());
                var this$25 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$6, this$18);
                var fb$4 = this$18.never__O();
                var this$26 = this$25.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$7 = this$25.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$26.productR__O__O__O(fa$7, fb$4)
              };
              throw new $c_s_MatchError(x$1$4)
            }))(this$3, poll$2));
            return this$27.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$27.Lcats_FlatMap$$anon$2__f_self, f$3)
          };
          throw new $c_s_MatchError(oc)
        }
      };
      if ((x$1$1 instanceof $c_s_util_Right)) {
        var x44 = $as_T2($as_s_util_Right(x$1$1).s_util_Right__f_value);
        if ((x44 !== null)) {
          var f$2$1 = $as_Lcats_effect_kernel_Fiber(x44._1__O());
          var oc$2 = $as_Lcats_effect_kernel_Outcome(x44._2__O());
          if ((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
            var x$1$7 = $as_Lcats_effect_kernel_Outcome$Succeeded(oc$2);
            var x41 = x$1$7.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
            var fa$8 = f$2$1.cancel__O();
            var this$33 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$8, this$3);
            var this$32 = new $c_Lcats_Functor$$anon$4(x41, this$3);
            var f$4 = new $c_sjsr_AnonFunction1(((_$6) => {
              $m_s_package$();
              return new $c_s_util_Right(_$6)
            }));
            var fb$5 = this$32.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$32.Lcats_Functor$$anon$4__f_self, f$4);
            var this$34 = this$33.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
            var fa$9 = this$33.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$34.productR__O__O__O(fa$9, fb$5)
          };
          if ((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
            var x$1$8 = $as_Lcats_effect_kernel_Outcome$Errored(oc$2);
            var x38 = x$1$8.Lcats_effect_kernel_Outcome$Errored__f_e;
            var fa$10 = f$2$1.cancel__O();
            var this$37 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$10, this$3);
            var fb$6 = this$3.raiseError__O__O(x38);
            var this$38 = this$37.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
            var fa$11 = this$37.Lcats_syntax_ApplySyntax$$anon$1__f_self;
            return this$38.productR__O__O__O(fa$11, fb$6)
          };
          if (((oc$2 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(oc$2), true))) {
            var wrapped$1 = poll$2.apply__O__O(f$2$1.join__O());
            var fin$1 = f$2$1.cancel__O();
            var target$2 = this$3.onCancel__O__O__O(wrapped$1, fin$1);
            var this$50 = new $c_Lcats_FlatMap$$anon$2(target$2, this$3);
            var f$6 = new $c_sjsr_AnonFunction1(((this$2$1, poll$1$3) => ((x$1$3$1) => {
              var x$1$9 = $as_Lcats_effect_kernel_Outcome(x$1$3$1);
              if ((x$1$9 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
                var x$1$10 = $as_Lcats_effect_kernel_Outcome$Succeeded(x$1$9);
                var x33 = x$1$10.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
                var this$45 = new $c_Lcats_Functor$$anon$4(x33, this$2$1);
                var f$5 = new $c_sjsr_AnonFunction1(((_$7) => {
                  $m_s_package$();
                  return new $c_s_util_Left(_$7)
                }));
                return this$45.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$45.Lcats_Functor$$anon$4__f_self, f$5)
              };
              if ((x$1$9 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
                var x$1$11 = $as_Lcats_effect_kernel_Outcome$Errored(x$1$9);
                var x30 = x$1$11.Lcats_effect_kernel_Outcome$Errored__f_e;
                return this$2$1.raiseError__O__O(x30)
              };
              if (((x$1$9 instanceof $c_Lcats_effect_kernel_Outcome$Canceled) && ($as_Lcats_effect_kernel_Outcome$Canceled(x$1$9), true))) {
                var fa$12 = poll$1$3.apply__O__O(this$2$1.canceled__O());
                var this$48 = new $c_Lcats_syntax_ApplySyntax$$anon$1(fa$12, this$2$1);
                var fb$7 = this$2$1.never__O();
                var this$49 = this$48.Lcats_syntax_ApplySyntax$$anon$1__f_typeClassInstance;
                var fa$13 = this$48.Lcats_syntax_ApplySyntax$$anon$1__f_self;
                return this$49.productR__O__O__O(fa$13, fb$7)
              };
              throw new $c_s_MatchError(x$1$9)
            }))(this$3, poll$2));
            return this$50.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$50.Lcats_FlatMap$$anon$2__f_self, f$6)
          };
          throw new $c_s_MatchError(oc$2)
        }
      };
      throw new $c_s_MatchError(x$1$1)
    }))(this$1, poll$1));
    return this$51.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$51.Lcats_FlatMap$$anon$2__f_self, f$7)
  }))($thiz, fa, fb)))
}
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$4(F0$10) {
  this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1 = F0$10
}
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$4;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$4() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_MonadCancel$$anon$4.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.unit__O = (function() {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, (void 0), F)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.uncancelable__F1__O = (function(body) {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__uncancelable__F1__Lcats_data_Kleisli(this, body)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.canceled__O = (function() {
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__canceled__Lcats_data_Kleisli(this)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fin$1 = $as_Lcats_data_Kleisli(fin);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__onCancel__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fin$1)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  var fb$1 = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__forceR__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1, fb$1)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_effect_kernel_MonadCancel$KleisliMonadCancel__guaranteeCase__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, fa$1, fin)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME);
  var this$3 = $m_Lcats_data_Kleisli$();
  var F = this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$3, x, F)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME);
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this$2, e)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this$2, fa$1, f)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME);
  return fa$1.flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this$2.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1)
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.tailRecM__O__F1__O = (function(a, f) {
  $m_Lcats_data_Kleisli$();
  var ME = this.Lcats_effect_kernel_MonadCancel$$anon$4__f_F0$1;
  var this$2 = new $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME);
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this$2, a, f)
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$4 = new $TypeData().initClass({
  Lcats_effect_kernel_MonadCancel$$anon$4: 0
}, false, "cats.effect.kernel.MonadCancel$$anon$4", {
  Lcats_effect_kernel_MonadCancel$$anon$4: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_MonadCancel$KleisliMonadCancel: 1
});
$c_Lcats_effect_kernel_MonadCancel$$anon$4.prototype.$classData = $d_Lcats_effect_kernel_MonadCancel$$anon$4;
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonadError() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_ResourceMonadError.prototype = new $h_Lcats_effect_kernel_ResourceMonad();
$c_Lcats_effect_kernel_ResourceMonadError.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonadError;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonadError() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceMonadError.prototype = $c_Lcats_effect_kernel_ResourceMonadError.prototype;
$c_Lcats_effect_kernel_ResourceMonadError.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f)
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.attempt__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return fa$1.attempt__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(this.F__Lcats_MonadError())
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return fa$1.handleErrorWith__F1__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(f, this.F__Lcats_MonadError())
});
$c_Lcats_effect_kernel_ResourceMonadError.prototype.raiseError__O__O = (function(e) {
  return $m_Lcats_effect_kernel_Resource$().raiseError__O__Lcats_ApplicativeError__Lcats_effect_kernel_Resource(e, this.F__Lcats_MonadError())
});
/** @constructor */
function $c_Lfs2_Compiler$Target$ConcurrentTarget(F0) {
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = null;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0 = F0;
  this.Lfs2_Compiler$Target$ConcurrentTarget__f_F = F0
}
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype = new $h_O();
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.constructor = $c_Lfs2_Compiler$Target$ConcurrentTarget;
/** @constructor */
function $h_Lfs2_Compiler$Target$ConcurrentTarget() {
  /*<skip>*/
}
$h_Lfs2_Compiler$Target$ConcurrentTarget.prototype = $c_Lfs2_Compiler$Target$ConcurrentTarget.prototype;
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unit__O = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.pure__O__O((void 0))
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.pure__O__O = (function(a) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.pure__O__O(a)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.handleErrorWith__O__F1__O(fa, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.flatMap__O__F1__O(fa, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.tailRecM__O__F1__O(a, f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.uncancelable__F1__O = (function(f) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.uncancelable__F1__O(f)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.canceled__O = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.canceled__O()
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.forceR__O__O__O = (function(fa, fb) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.forceR__O__O__O(fa, fb)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.onCancel__O__O__O(fa, fin)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.unique__O = (function() {
  $m_Lcats_effect_kernel_package$();
  var F = this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0;
  $m_s_DummyImplicit$();
  return F.unique__O()
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.ref__O__O = (function(a) {
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0.ref__O__O(a)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  var value = $m_Lfs2_internal_InterruptContext$().apply__Lcats_effect_kernel_Unique$Token__O__Lcats_effect_kernel_GenConcurrent__O(root, this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.unit__O(), this.Lfs2_Compiler$Target$ConcurrentTarget__f_F0);
  return new $c_s_Some(value)
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return this.Lfs2_Compiler$Target$ConcurrentTarget__f_F.raiseError__O__O(e$1)
});
var $d_Lfs2_Compiler$Target$ConcurrentTarget = new $TypeData().initClass({
  Lfs2_Compiler$Target$ConcurrentTarget: 0
}, false, "fs2.Compiler$Target$ConcurrentTarget", {
  Lfs2_Compiler$Target$ConcurrentTarget: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
});
$c_Lfs2_Compiler$Target$ConcurrentTarget.prototype.$classData = $d_Lfs2_Compiler$Target$ConcurrentTarget;
/** @constructor */
function $c_Lfs2_Compiler$TargetLowPriority$SyncTarget(F0) {
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = null;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0 = F0;
  this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F = F0
}
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = new $h_O();
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.constructor = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget;
/** @constructor */
function $h_Lfs2_Compiler$TargetLowPriority$SyncTarget() {
  /*<skip>*/
}
$h_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype = $c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype;
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unit__O = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.pure__O__O((void 0))
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.pure__O__O = (function(a) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.pure__O__O(a)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.handleErrorWith__O__F1__O(fa, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.flatMap__O__F1__O = (function(fa, f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.flatMap__O__F1__O(fa, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.tailRecM__O__F1__O(a, f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.uncancelable__F1__O = (function(f) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.uncancelable__F1__O(f)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.canceled__O = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.canceled__O()
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.forceR__O__O__O = (function(fa, fb) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.forceR__O__O__O(fa, fb)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.onCancel__O__O__O = (function(fa, fin) {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.onCancel__O__O__O(fa, fin)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.unique__O = (function() {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  return F.unique__O()
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.ref__O__O = (function(a) {
  var F = this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F0;
  var mk = new $c_Lcats_effect_kernel_Ref$$anon$2(F);
  return mk.refOf__O__O(a)
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.interruptContext__Lcats_effect_kernel_Unique$Token__s_Option = (function(root) {
  return $m_s_None$()
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return this.Lfs2_Compiler$TargetLowPriority$SyncTarget__f_F.raiseError__O__O(e$1)
});
var $d_Lfs2_Compiler$TargetLowPriority$SyncTarget = new $TypeData().initClass({
  Lfs2_Compiler$TargetLowPriority$SyncTarget: 0
}, false, "fs2.Compiler$TargetLowPriority$SyncTarget", {
  Lfs2_Compiler$TargetLowPriority$SyncTarget: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lfs2_Compiler$Target: 1
});
$c_Lfs2_Compiler$TargetLowPriority$SyncTarget.prototype.$classData = $d_Lfs2_Compiler$TargetLowPriority$SyncTarget;
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz
}
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0
}
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Drop.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass({
  sc_IndexedSeqView$Drop: 0
}, false, "scala.collection.IndexedSeqView$Drop", {
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Drop.prototype.$classData = $d_sc_IndexedSeqView$Drop;
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying)
}
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Id.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Id.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass({
  sc_IndexedSeqView$Id: 0
}, false, "scala.collection.IndexedSeqView$Id", {
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Id.prototype.$classData = $d_sc_IndexedSeqView$Id;
/** @constructor */
function $c_sc_IndexedSeqView$Map(underlying, f) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  $ct_sc_SeqView$Map__sc_SeqOps__F1__(this, underlying, f)
}
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass({
  sc_IndexedSeqView$Map: 0
}, false, "scala.collection.IndexedSeqView$Map", {
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Map.prototype.$classData = $d_sc_IndexedSeqView$Map;
/** @constructor */
function $c_sc_IndexedSeqView$Reverse(underlying) {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = underlying;
  $ct_sc_SeqView$Reverse__sc_SeqOps__(this, underlying)
}
$c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$c_sc_IndexedSeqView$Reverse.prototype.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
  /*<skip>*/
}
$h_sc_IndexedSeqView$Reverse.prototype = $c_sc_IndexedSeqView$Reverse.prototype;
$c_sc_IndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this)
});
$c_sc_IndexedSeqView$Reverse.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView"
});
$c_sc_IndexedSeqView$Reverse.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sc_IndexedSeqView$Reverse.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sc_IndexedSeqView$Reverse.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sc_IndexedSeqView$Reverse.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n)
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().initClass({
  sc_IndexedSeqView$Reverse: 0
}, false, "scala.collection.IndexedSeqView$Reverse", {
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_sc_IndexedSeqView$Reverse.prototype.$classData = $d_sc_IndexedSeqView$Reverse;
/** @constructor */
function $c_sci_AbstractSeq() {
  /*<skip>*/
}
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
  /*<skip>*/
}
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.scm_ArrayBufferView__f_underlying = null;
  this.scm_ArrayBufferView__f_mutationCount = null;
  this.scm_ArrayBufferView__f_underlying = underlying;
  this.scm_ArrayBufferView__f_mutationCount = mutationCount
}
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
  /*<skip>*/
}
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  return this.scm_ArrayBufferView__f_underlying.apply__I__O(n)
});
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  var this$1 = this.scm_ArrayBufferView__f_underlying;
  return this$1.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView"
});
$c_scm_ArrayBufferView.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_ArrayBufferView__f_mutationCount)
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
$c_scm_ArrayBufferView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n)
});
var $d_scm_ArrayBufferView = new $TypeData().initClass({
  scm_ArrayBufferView: 0
}, false, "scala.collection.mutable.ArrayBufferView", {
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
});
$c_scm_ArrayBufferView.prototype.$classData = $d_scm_ArrayBufferView;
function $f_Lcats_effect_kernel_GenConcurrent__racePair__O__O__O($thiz, fa, fb) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1(((this$1, fa$2, fb$2, F$2) => ((poll) => {
    var poll$1 = $as_Lcats_effect_kernel_Poll(poll);
    var target = this$1.deferred__O();
    var this$31 = new $c_Lcats_FlatMap$$anon$2(target, F$2);
    var f$7 = new $c_sjsr_AnonFunction1(((this$3, fa$8$2, fb$1$2, F$13$2, poll$2) => ((result) => {
      var result$1 = $as_Lcats_effect_kernel_Deferred(result);
      var target$2 = this$3.start__O__O(this$3.guaranteeCase__O__F1__O(fa$8$2, new $c_sjsr_AnonFunction1(((F$14$2, result$2) => ((oc) => {
        var oc$1 = $as_Lcats_effect_kernel_Outcome(oc);
        var target$1 = result$2.complete__O__O(($m_s_package$(), new $c_s_util_Left(oc$1)));
        var this$6 = new $c_Lcats_Functor$$anon$4(target$1, F$14$2);
        return this$6.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$6.Lcats_Functor$$anon$4__f_self)
      }))(F$13$2, result$1))));
      var this$30 = new $c_Lcats_FlatMap$$anon$2(target$2, F$13$2);
      var f$6 = new $c_sjsr_AnonFunction1(((this$8, fb$2$2, F$14$3, poll$2$2, result$3) => ((fibA) => {
        var fibA$1 = $as_Lcats_effect_kernel_Fiber(fibA);
        var target$4 = this$8.start__O__O(this$8.guaranteeCase__O__F1__O(fb$2$2, new $c_sjsr_AnonFunction1(((F$16$2, result$2$2) => ((oc$2) => {
          var oc$3 = $as_Lcats_effect_kernel_Outcome(oc$2);
          var target$3 = result$2$2.complete__O__O(($m_s_package$(), new $c_s_util_Right(oc$3)));
          var this$11 = new $c_Lcats_Functor$$anon$4(target$3, F$16$2);
          return this$11.Lcats_Functor$$anon$4__f_typeClassInstance.void__O__O(this$11.Lcats_Functor$$anon$4__f_self)
        }))(F$14$3, result$3))));
        var this$29 = new $c_Lcats_FlatMap$$anon$2(target$4, F$14$3);
        var f$5 = new $c_sjsr_AnonFunction1(((this$13, F$16$3, poll$3$2, result$2$3, fibA$2) => ((fibB) => {
          var fibB$1 = $as_Lcats_effect_kernel_Fiber(fibB);
          var $$x1 = poll$3$2.apply__O__O(result$2$3.get__O());
          var target$5 = this$13.start__O__O(fibA$2.cancel__O());
          var this$22 = new $c_Lcats_FlatMap$$anon$2(target$5, F$16$3);
          var f$3 = new $c_sjsr_AnonFunction1(((this$15, F$18$2, fibB$2) => ((canA) => {
            var canA$1 = $as_Lcats_effect_kernel_Fiber(canA);
            var target$6 = this$15.start__O__O(fibB$2.cancel__O());
            var this$21 = new $c_Lcats_FlatMap$$anon$2(target$6, F$18$2);
            var f$2 = new $c_sjsr_AnonFunction1(((F$19$2, canA$2) => ((canB) => {
              var canB$1 = $as_Lcats_effect_kernel_Fiber(canB);
              var target$7 = canA$2.join__O();
              var this$20 = new $c_Lcats_FlatMap$$anon$2(target$7, F$19$2);
              var f$1 = new $c_sjsr_AnonFunction1(((F$20$2, canB$2) => ((x$1) => {
                $as_Lcats_effect_kernel_Outcome(x$1);
                var target$8 = canB$2.join__O();
                var this$19 = new $c_Lcats_Functor$$anon$4(target$8, F$20$2);
                var f = new $c_sjsr_AnonFunction1(((x$1$2) => {
                  $as_Lcats_effect_kernel_Outcome(x$1$2)
                }));
                return this$19.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$19.Lcats_Functor$$anon$4__f_self, f)
              }))(F$19$2, canB$1));
              return this$20.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$20.Lcats_FlatMap$$anon$2__f_self, f$1)
            }))(F$18$2, canA$1));
            return this$21.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$21.Lcats_FlatMap$$anon$2__f_self, f$2)
          }))(this$13, F$16$3, fibB$1));
          var target$9 = this$13.onCancel__O__O__O($$x1, this$22.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$22.Lcats_FlatMap$$anon$2__f_self, f$3));
          var this$28 = new $c_Lcats_Functor$$anon$4(target$9, F$16$3);
          var f$4 = new $c_sjsr_AnonFunction1(((fibA$1$2, fibB$3) => ((back) => {
            var back$1 = $as_s_util_Either(back);
            if ((back$1 instanceof $c_s_util_Left)) {
              var oc$4 = $as_Lcats_effect_kernel_Outcome($as_s_util_Left(back$1).s_util_Left__f_value);
              $m_s_package$();
              var value = new $c_T2(oc$4, fibB$3);
              return new $c_s_util_Left(value)
            };
            if ((back$1 instanceof $c_s_util_Right)) {
              var oc$2$1 = $as_Lcats_effect_kernel_Outcome($as_s_util_Right(back$1).s_util_Right__f_value);
              $m_s_package$();
              var value$1 = new $c_T2(fibA$1$2, oc$2$1);
              return new $c_s_util_Right(value$1)
            };
            throw new $c_s_MatchError(back$1)
          }))(fibA$2, fibB$1));
          return this$28.Lcats_Functor$$anon$4__f_typeClassInstance.map__O__F1__O(this$28.Lcats_Functor$$anon$4__f_self, f$4)
        }))(this$8, F$14$3, poll$2$2, result$3, fibA$1));
        return this$29.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$29.Lcats_FlatMap$$anon$2__f_self, f$5)
      }))(this$3, fb$1$2, F$13$2, poll$2, result$1));
      return this$30.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$30.Lcats_FlatMap$$anon$2__f_self, f$6)
    }))(this$1, fa$2, fb$2, F$2, poll$1));
    return this$31.Lcats_FlatMap$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$31.Lcats_FlatMap$$anon$2__f_self, f$7)
  }))($thiz, fa, fb, $thiz)))
}
/** @constructor */
function $c_sci_AbstractMap() {
  /*<skip>*/
}
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
  /*<skip>*/
}
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$()
});
$c_sci_AbstractMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  return this.updated__O__O__sci_MapOps(kv._1__O(), kv._2__O())
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$()
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  if ((!$is_sci_IndexedSeq(that))) {
    return true
  } else {
    var x2 = $as_sci_IndexedSeq(that);
    return ($thiz.length__I() === x2.length__I())
  }
}
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    var x2 = $as_sci_IndexedSeq(o);
    if (($thiz === x2)) {
      return true
    } else {
      var length = $thiz.length__I();
      var equal = (length === x2.length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = x2.applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? (((-2147483648) ^ length) > ((-2147483648) ^ lo)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength
        } else {
          var maxApplyCompare = length
        };
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), x2.apply__I__O(index));
          index = ((1 + index) | 0)
        };
        if (((index < length) && equal)) {
          var thisIt = $thiz.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          var thatIt = x2.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          while ((equal && thisIt.hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z(thisIt.next__O(), thatIt.next__O())
          }
        }
      };
      return equal
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o)
  }
}
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)))
}
function $as_sci_IndexedSeq(obj) {
  return (($is_sci_IndexedSeq(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.IndexedSeq"))
}
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)))
}
function $asArrayOf_sci_IndexedSeq(obj, depth) {
  return (($isArrayOf_sci_IndexedSeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.IndexedSeq;", depth))
}
/** @constructor */
function $c_sci_Set$EmptySet$() {
  /*<skip>*/
}
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
  /*<skip>*/
}
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
  /*<skip>*/
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem)
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass({
  sci_Set$EmptySet$: 0
}, false, "scala.collection.immutable.Set$EmptySet$", {
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$EmptySet$.prototype.$classData = $d_sci_Set$EmptySet$;
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$()
  };
  return $n_sci_Set$EmptySet$
}
/** @constructor */
function $c_Lcats_data_Kleisli$() {
  this.Lcats_data_KleisliInstances3__f_catsDataChoiceForKleisliId = null;
  this.Lcats_data_KleisliInstances__f_catsDataCommutativeArrowForKleisliId = null;
  $ct_Lcats_data_KleisliInstances__(this)
}
$c_Lcats_data_Kleisli$.prototype = new $h_Lcats_data_KleisliInstances();
$c_Lcats_data_Kleisli$.prototype.constructor = $c_Lcats_data_Kleisli$;
/** @constructor */
function $h_Lcats_data_Kleisli$() {
  /*<skip>*/
}
$h_Lcats_data_Kleisli$.prototype = $c_Lcats_data_Kleisli$.prototype;
$c_Lcats_data_Kleisli$.prototype.toString__T = (function() {
  return "Kleisli"
});
$c_Lcats_data_Kleisli$.prototype.shift__F1__Lcats_FlatMap__Lcats_data_Kleisli = (function(run, F) {
  if ($is_Lcats_Applicative(F)) {
    var ap = $as_Lcats_Applicative(F);
    $m_Lcats_data_Kleisli$();
    var run$1 = new $c_sjsr_AnonFunction1(((run$2, F$2, ap$2) => ((r) => F$2.flatMap__O__F1__O(ap$2.pure__O__O(r), run$2)))(run, F, ap));
    return new $c_Lcats_data_Kleisli(run$1)
  } else {
    $m_Lcats_data_Kleisli$();
    return new $c_Lcats_data_Kleisli(run)
  }
});
var $d_Lcats_data_Kleisli$ = new $TypeData().initClass({
  Lcats_data_Kleisli$: 0
}, false, "cats.data.Kleisli$", {
  Lcats_data_Kleisli$: 1,
  Lcats_data_KleisliInstances: 1,
  Lcats_data_KleisliInstances0: 1,
  Lcats_data_KleisliInstances0\uff3f5: 1,
  Lcats_data_KleisliInstances1: 1,
  Lcats_data_KleisliInstances2: 1,
  Lcats_data_KleisliInstances3: 1,
  Lcats_data_KleisliInstances4: 1,
  Lcats_data_KleisliInstances5: 1,
  Lcats_data_KleisliInstances6: 1,
  Lcats_data_KleisliInstances7: 1,
  Lcats_data_KleisliInstances8: 1,
  Lcats_data_KleisliInstances9: 1,
  O: 1,
  Lcats_data_KleisliFunctions: 1,
  Lcats_data_KleisliFunctionsBinCompat: 1,
  Lcats_data_KleisliExplicitInstances: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
});
$c_Lcats_data_Kleisli$.prototype.$classData = $d_Lcats_data_Kleisli$;
var $n_Lcats_data_Kleisli$;
function $m_Lcats_data_Kleisli$() {
  if ((!$n_Lcats_data_Kleisli$)) {
    $n_Lcats_data_Kleisli$ = new $c_Lcats_data_Kleisli$()
  };
  return $n_Lcats_data_Kleisli$
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceMonadCancel() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype = new $h_Lcats_effect_kernel_ResourceMonadError();
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.constructor = $c_Lcats_effect_kernel_ResourceMonadCancel;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceMonadCancel() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceMonadCancel.prototype = $c_Lcats_effect_kernel_ResourceMonadCancel.prototype;
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin)
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release)
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.canceled__O = (function() {
  var F = this.F__Lcats_effect_kernel_MonadCancel();
  var fa = F.canceled__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fb$1 = $as_Lcats_effect_kernel_Resource(fb);
  return fa$1.forceR__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fb$1, this.F__Lcats_effect_kernel_MonadCancel())
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.onCancel__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  var fin$1 = $as_Lcats_effect_kernel_Resource(fin);
  return fa$1.onCancel__Lcats_effect_kernel_Resource__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fin$1, this.F__Lcats_effect_kernel_MonadCancel())
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_kernel_Resource$().uncancelable__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(body, this.F__Lcats_effect_kernel_MonadCancel())
});
$c_Lcats_effect_kernel_ResourceMonadCancel.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var rfa = $as_Lcats_effect_kernel_Resource(fa);
  return rfa.guaranteeCase__F1__Lcats_effect_kernel_MonadCancel__Lcats_effect_kernel_Resource(fin, this.F__Lcats_effect_kernel_MonadCancel())
});
/** @constructor */
function $c_Lcats_kernel_Eq$() {
  /*<skip>*/
}
$c_Lcats_kernel_Eq$.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_Eq$.prototype.constructor = $c_Lcats_kernel_Eq$;
/** @constructor */
function $h_Lcats_kernel_Eq$() {
  /*<skip>*/
}
$h_Lcats_kernel_Eq$.prototype = $c_Lcats_kernel_Eq$.prototype;
var $d_Lcats_kernel_Eq$ = new $TypeData().initClass({
  Lcats_kernel_Eq$: 0
}, false, "cats.kernel.Eq$", {
  Lcats_kernel_Eq$: 1,
  Lcats_kernel_EqFunctions: 1,
  O: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_ScalaVersionSpecificEqInstances: 1,
  Lcats_kernel_ScalaVersionSpecificHashInstances: 1,
  Lcats_kernel_ScalaVersionSpecificPartialOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificOrderInstances: 1,
  Lcats_kernel_instances_TupleEqInstances: 1,
  Lcats_kernel_instances_TupleHashInstances: 1,
  Lcats_kernel_instances_TuplePartialOrderInstances: 1,
  Lcats_kernel_instances_TupleOrderInstances: 1,
  Lcats_kernel_EqInstances0: 1,
  Lcats_kernel_EqInstances: 1,
  Lcats_kernel_HashInstances0: 1,
  Lcats_kernel_HashInstances: 1,
  Lcats_kernel_PartialOrderInstances0: 1,
  Lcats_kernel_PartialOrderInstances: 1,
  Lcats_kernel_OrderInstances0: 1
});
$c_Lcats_kernel_Eq$.prototype.$classData = $d_Lcats_kernel_Eq$;
var $n_Lcats_kernel_Eq$;
function $m_Lcats_kernel_Eq$() {
  if ((!$n_Lcats_kernel_Eq$)) {
    $n_Lcats_kernel_Eq$ = new $c_Lcats_kernel_Eq$()
  };
  return $n_Lcats_kernel_Eq$
}
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(m) {
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = null;
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = m
}
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = new $h_O();
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq() {
  /*<skip>*/
}
$h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype;
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_IndexedSeq$().newBuilder__scm_Builder()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.className__T = (function() {
  return "IndexedSeq"
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.size__I = (function() {
  return this.length__I()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = this.iterator__sc_Iterator();
  return $f_sc_Iterator__indexWhere__F1__I__I(this$1, p, from)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.length__I = (function() {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.length__I()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__I__O = (function(i) {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.apply__I__O(i)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterator__sc_Iterator = (function() {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.iterator__sc_Iterator()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_IndexedSeq$();
  return this$1.from__sc_IterableOnce__sci_IndexedSeq(coll)
});
var $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq = new $TypeData().initClass({
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 0
}, false, "cats.kernel.instances.StaticMethods$WrappedIndexedSeq", {
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 1,
  O: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  sci_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1,
  sci_SeqOps: 1,
  sci_Seq: 1,
  sc_IndexedSeqOps: 1,
  sc_IndexedSeq: 1,
  sci_IndexedSeqOps: 1,
  sci_IndexedSeq: 1
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.$classData = $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $c_sc_StringView(s) {
  this.sc_StringView__f_s = null;
  this.sc_StringView__f_s = s
}
$c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_StringView.prototype.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
  /*<skip>*/
}
$h_sc_StringView.prototype = $c_sc_StringView.prototype;
$c_sc_StringView.prototype.length__I = (function() {
  var this$1 = this.sc_StringView__f_s;
  return $uI(this$1.length)
});
$c_sc_StringView.prototype.toString__T = (function() {
  return (("StringView(" + this.sc_StringView__f_s) + ")")
});
$c_sc_StringView.prototype.productPrefix__T = (function() {
  return "StringView"
});
$c_sc_StringView.prototype.productArity__I = (function() {
  return 1
});
$c_sc_StringView.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_StringView__f_s : $m_sr_Statics$().ioobe__I__O(x$1))
});
$c_sc_StringView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sc_StringView.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.productHash__s_Product__I__Z__I(this, (-889275714), false)
});
$c_sc_StringView.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true
  } else if ((x$1 instanceof $c_sc_StringView)) {
    var StringView$1 = $as_sc_StringView(x$1);
    return (this.sc_StringView__f_s === StringView$1.sc_StringView__f_s)
  } else {
    return false
  }
});
$c_sc_StringView.prototype.apply__I__O = (function(i) {
  var this$1 = this.sc_StringView__f_s;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
function $as_sc_StringView(obj) {
  return (((obj instanceof $c_sc_StringView) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.StringView"))
}
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StringView)))
}
function $asArrayOf_sc_StringView(obj, depth) {
  return (($isArrayOf_sc_StringView(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.StringView;", depth))
}
var $d_sc_StringView = new $TypeData().initClass({
  sc_StringView: 0
}, false, "scala.collection.StringView", {
  sc_StringView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  s_Product: 1,
  s_Equals: 1
});
$c_sc_StringView.prototype.$classData = $d_sc_StringView;
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1
}
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
  /*<skip>*/
}
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem))
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this)
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set1__f_elem1)
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return $uZ(p.apply__O__O(this.sci_Set$Set1__f_elem1))
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set1 = new $TypeData().initClass({
  sci_Set$Set1: 0
}, false, "scala.collection.immutable.Set$Set1", {
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set1.prototype.$classData = $d_sci_Set$Set1;
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2
}
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
  /*<skip>*/
}
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2))
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem))
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this))
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this)
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set2__f_elem1);
  f.apply__O__O(this.sci_Set$Set2__f_elem2)
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ($uZ(p.apply__O__O(this.sci_Set$Set2__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set2__f_elem2)))
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set2 = new $TypeData().initClass({
  sci_Set$Set2: 0
}, false, "scala.collection.immutable.Set$Set2", {
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set2.prototype.$classData = $d_sci_Set$Set2;
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3
}
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
  /*<skip>*/
}
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3))
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem))
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)))
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this)
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set3__f_elem1);
  f.apply__O__O(this.sci_Set$Set3__f_elem2);
  f.apply__O__O(this.sci_Set$Set3__f_elem3)
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (($uZ(p.apply__O__O(this.sci_Set$Set3__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set3__f_elem2))) && $uZ(p.apply__O__O(this.sci_Set$Set3__f_elem3)))
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
var $d_sci_Set$Set3 = new $TypeData().initClass({
  sci_Set$Set3: 0
}, false, "scala.collection.immutable.Set$Set3", {
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set3.prototype.$classData = $d_sci_Set$Set3;
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4
}
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
  /*<skip>*/
}
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = this$1.sci_HashSet$__f_EmptySet;
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = this$2.incl__O__sci_HashSet(elem$1);
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = this$3.incl__O__sci_HashSet(elem$2);
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = this$4.incl__O__sci_HashSet(elem$3);
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = this$5.incl__O__sci_HashSet(elem$4);
    return this$6.incl__O__sci_HashSet(elem)
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))))
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this)
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break
    }
    default: {
      throw new $c_s_MatchError(i)
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set4__f_elem1);
  f.apply__O__O(this.sci_Set$Set4__f_elem2);
  f.apply__O__O(this.sci_Set$Set4__f_elem3);
  f.apply__O__O(this.sci_Set$Set4__f_elem4)
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ(p.apply__O__O(this.sci_Set$Set4__f_elem1)) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem2))) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem3))) && $uZ(p.apply__O__O(this.sci_Set$Set4__f_elem4)))
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return $as_scm_Builder(builder.addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4))
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem)
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem)
});
function $as_sci_Set$Set4(obj) {
  return (((obj instanceof $c_sci_Set$Set4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Set$Set4"))
}
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)))
}
function $asArrayOf_sci_Set$Set4(obj, depth) {
  return (($isArrayOf_sci_Set$Set4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Set$Set4;", depth))
}
var $d_sci_Set$Set4 = new $TypeData().initClass({
  sci_Set$Set4: 0
}, false, "scala.collection.immutable.Set$Set4", {
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Set$Set4.prototype.$classData = $d_sci_Set$Set4;
function $is_sci_SortedSet(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_SortedSet)))
}
function $as_sci_SortedSet(obj) {
  return (($is_sci_SortedSet(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.SortedSet"))
}
function $isArrayOf_sci_SortedSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SortedSet)))
}
function $asArrayOf_sci_SortedSet(obj, depth) {
  return (($isArrayOf_sci_SortedSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.SortedSet;", depth))
}
/** @constructor */
function $c_scm_AbstractSeq() {
  /*<skip>*/
}
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
  /*<skip>*/
}
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n)
}
$c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$c_scm_CheckedIndexedSeqView$Drop.prototype.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
  /*<skip>*/
}
$h_scm_CheckedIndexedSeqView$Drop.prototype = $c_scm_CheckedIndexedSeqView$Drop.prototype;
$c_scm_CheckedIndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount)
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().initClass({
  scm_CheckedIndexedSeqView$Drop: 0
}, false, "scala.collection.mutable.CheckedIndexedSeqView$Drop", {
  scm_CheckedIndexedSeqView$Drop: 1,
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.$classData = $d_scm_CheckedIndexedSeqView$Drop;
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Set)))
}
function $as_scm_Set(obj) {
  return (($is_scm_Set(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Set"))
}
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Set)))
}
function $asArrayOf_scm_Set(obj, depth) {
  return (($isArrayOf_scm_Set(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Set;", depth))
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1(F0$18) {
  this.Lcats_effect_kernel_ResourceHOInstances3$$anon$1__f_F0$1 = null;
  this.Lcats_effect_kernel_ResourceHOInstances3$$anon$1__f_F0$1 = F0$18
}
$c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype = new $h_Lcats_effect_kernel_ResourceMonadCancel();
$c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceHOInstances3$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype = $c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype;
$c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances3$$anon$1__f_F0$1
});
$c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype.F__Lcats_MonadError = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances3$$anon$1__f_F0$1
});
var $d_Lcats_effect_kernel_ResourceHOInstances3$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_ResourceHOInstances3$$anon$1: 0
}, false, "cats.effect.kernel.ResourceHOInstances3$$anon$1", {
  Lcats_effect_kernel_ResourceHOInstances3$$anon$1: 1,
  Lcats_effect_kernel_ResourceMonadCancel: 1,
  Lcats_effect_kernel_ResourceMonadError: 1,
  Lcats_effect_kernel_ResourceMonad: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_ApplicativeError: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1
});
$c_Lcats_effect_kernel_ResourceHOInstances3$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_ResourceHOInstances3$$anon$1;
function $f_Lcats_effect_kernel_Sync__$init$__V($thiz) {
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V($m_Lcats_effect_kernel_Sync$Type$Delay$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V($m_Lcats_effect_kernel_Sync$Type$Blocking$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$())
}
function $f_Lcats_effect_kernel_Sync__unique__O($thiz) {
  return $thiz.delay__F0__O(new $c_sjsr_AnonFunction0((() => new $c_Lcats_effect_kernel_Unique$Token())))
}
function $f_Lcats_effect_kernel_Sync__defer__F0__O($thiz, thunk) {
  return $thiz.flatMap__O__F1__O($thiz.delay__F0__O(thunk), new $c_sjsr_AnonFunction1(((x) => x)))
}
/** @constructor */
function $c_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
  /*<skip>*/
}
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$()
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return default$1.apply__O()
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.valuesIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Map$EmptyMap$.prototype.removed__O__sci_MapOps = (function(key) {
  return this
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value)
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key)
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass({
  sci_Map$EmptyMap$: 0
}, false, "scala.collection.immutable.Map$EmptyMap$", {
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$EmptyMap$.prototype.$classData = $d_sci_Map$EmptyMap$;
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$()
  };
  return $n_sci_Map$EmptyMap$
}
/** @constructor */
function $c_Lcats_EvalInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_EvalInstances$$anon$1.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$1.prototype.constructor = $c_Lcats_EvalInstances$$anon$1;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_EvalInstances$$anon$1.prototype = $c_Lcats_EvalInstances$$anon$1.prototype;
$c_Lcats_EvalInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_EvalInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_EvalInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_EvalInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_EvalInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_EvalInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return fa$1.map__F1__Lcats_Eval(f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_Now(x)
});
$c_Lcats_EvalInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_Eval(fa);
  return fa$1.flatMap__F1__Lcats_Eval(f)
});
$c_Lcats_EvalInstances$$anon$1.prototype.unit__O = (function() {
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit
});
$c_Lcats_EvalInstances$$anon$1.prototype.void__O__O = (function(fa) {
  $as_Lcats_Eval(fa);
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit
});
var $d_Lcats_EvalInstances$$anon$1 = new $TypeData().initClass({
  Lcats_EvalInstances$$anon$1: 0
}, false, "cats.EvalInstances$$anon$1", {
  Lcats_EvalInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1
});
$c_Lcats_EvalInstances$$anon$1.prototype.$classData = $d_Lcats_EvalInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$2() {
  /*<skip>*/
}
$c_Lcats_instances_EitherInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$2() {
  /*<skip>*/
}
$h_Lcats_instances_EitherInstances$$anon$2.prototype = $c_Lcats_instances_EitherInstances$$anon$2.prototype;
$c_Lcats_instances_EitherInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(sa), f, evidence$5)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__s_util_Either = (function() {
  $m_s_package$();
  return $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__s_util_Either__F1__s_util_Either = (function(fea, f) {
  if ((fea instanceof $c_s_util_Left)) {
    var e = $as_s_util_Left(fea).s_util_Left__f_value;
    return $as_s_util_Either(f.apply__O__O(e))
  };
  if ((fea instanceof $c_s_util_Right)) {
    var r = $as_s_util_Right(fea);
    return r
  };
  throw new $c_s_MatchError(fea)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__s_util_Either = (function(b, f) {
  var this$ = this;
  var b$tailLocal1 = b;
  while (true) {
    var x26 = $as_s_util_Either(f.apply__O__O(b$tailLocal1));
    if ((x26 instanceof $c_s_util_Left)) {
      var left = $as_s_util_Left(x26);
      return left
    };
    if ((x26 instanceof $c_s_util_Right)) {
      var e = $as_s_util_Either($as_s_util_Right(x26).s_util_Right__f_value);
      if ((e instanceof $c_s_util_Left)) {
        var b1 = $as_s_util_Left(e).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        b$tailLocal1 = b1;
        continue
      };
      if ((e instanceof $c_s_util_Right)) {
        var right = $as_s_util_Right(e);
        return right
      };
      throw new $c_s_MatchError(e)
    };
    throw new $c_s_MatchError(x26)
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fb, fc, f) {
  if ((fb instanceof $c_s_util_Left)) {
    var l = $as_s_util_Left(fb);
    $m_Lcats_syntax_EitherUtil$();
    return new $c_Lcats_Now(l)
  };
  if ((fb instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fb).s_util_Right__f_value;
    return fc.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$2, b$2) => ((_$10) => {
      var _$10$1 = $as_s_util_Either(_$10);
      if ((_$10$1 instanceof $c_s_util_Right)) {
        var x2 = $as_s_util_Right(_$10$1);
        var b$1 = x2.s_util_Right__f_value;
        return new $c_s_util_Right(f$2.apply__O__O__O(b$2, b$1))
      } else {
        return _$10$1
      }
    }))(f, b)))
  };
  throw new $c_s_MatchError(fb)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__s_util_Either__F1__Lcats_Applicative__O = (function(fa, f, F) {
  if ((fa instanceof $c_s_util_Left)) {
    var left = $as_s_util_Left(fa);
    return F.pure__O__O(left)
  };
  if ((fa instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fa).s_util_Right__f_value;
    return F.map__O__F1__O(f.apply__O__O(b), new $c_sjsr_AnonFunction1(((_$13) => {
      $m_s_package$();
      return new $c_s_util_Right(_$13)
    })))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldLeft__s_util_Either__O__F2__O = (function(fa, c, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return c
  };
  if ((fa instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fa).s_util_Right__f_value;
    return f.apply__O__O__O(c, b)
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fa, lc, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return lc
  };
  if ((fa instanceof $c_s_util_Right)) {
    var b = $as_s_util_Right(fa).s_util_Right__f_value;
    return $as_Lcats_Eval(f.apply__O__O__O(b, lc))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O = (function(fab, f, C) {
  if ((fab instanceof $c_s_util_Right)) {
    var x2 = $as_s_util_Right(fab);
    var b = x2.s_util_Right__f_value;
    return f.apply__O__O(b)
  } else if ((fab instanceof $c_s_util_Left)) {
    var x3 = $as_s_util_Left(fab);
    return C.empty__O()
  } else {
    throw new $c_s_MatchError(fab)
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__s_util_Either__s_util_Either = (function(e) {
  return (e.isRight__Z() ? ($m_s_package$(), $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit) : e)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__O = (function() {
  return this.unit__s_util_Either()
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.pure__O__O = (function(x) {
  $m_s_package$();
  return new $c_s_util_Right(x)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return fa$1.flatMap__F1__s_util_Either(f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Either__F1__s_util_Either($as_s_util_Either(fa), f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.raiseError__O__O = (function(e) {
  $m_s_package$();
  return new $c_s_util_Left(e)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_util_Either(fa);
  return fa$1.map__F1__s_util_Either(f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Either(a, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), fb, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O($as_s_util_Either(fa), f, evidence$1)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_util_Either__O__F2__O($as_s_util_Either(fa), b, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval($as_s_util_Either(fa), lb, f)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.attempt__O__O = (function(fa) {
  var fab = $as_s_util_Either(fa);
  $m_s_package$();
  return new $c_s_util_Right(fab)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O($as_s_util_Either(fa), f, B)
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return this.void__s_util_Either__s_util_Either($as_s_util_Either(fa))
});
var $d_Lcats_instances_EitherInstances$$anon$2 = new $TypeData().initClass({
  Lcats_instances_EitherInstances$$anon$2: 0
}, false, "cats.instances.EitherInstances$$anon$2", {
  Lcats_instances_EitherInstances$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.$classData = $d_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $c_Lcats_kernel_Semigroup$() {
  /*<skip>*/
}
$c_Lcats_kernel_Semigroup$.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_Semigroup$.prototype.constructor = $c_Lcats_kernel_Semigroup$;
/** @constructor */
function $h_Lcats_kernel_Semigroup$() {
  /*<skip>*/
}
$h_Lcats_kernel_Semigroup$.prototype = $c_Lcats_kernel_Semigroup$.prototype;
var $d_Lcats_kernel_Semigroup$ = new $TypeData().initClass({
  Lcats_kernel_Semigroup$: 0
}, false, "cats.kernel.Semigroup$", {
  Lcats_kernel_Semigroup$: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  O: 1,
  Lcats_kernel_ScalaVersionSpecificMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemigroupInstances: 1,
  Lcats_kernel_instances_TupleBandInstances: 1,
  Lcats_kernel_instances_TupleCommutativeSemigroupInstances: 1,
  Lcats_kernel_instances_TupleMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeMonoidInstances: 1,
  Lcats_kernel_instances_TupleGroupInstances: 1,
  Lcats_kernel_instances_TupleBoundedSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeGroupInstances: 1,
  Lcats_kernel_SemigroupInstances: 1,
  Lcats_kernel_CommutativeSemigroupInstances: 1,
  Lcats_kernel_BandInstances: 1,
  Lcats_kernel_MonoidInstances: 1,
  Lcats_kernel_CommutativeMonoidInstances: 1,
  Lcats_kernel_SemilatticeInstances: 1,
  Lcats_kernel_BoundedSemilatticeInstances: 1,
  Lcats_kernel_GroupInstances: 1
});
$c_Lcats_kernel_Semigroup$.prototype.$classData = $d_Lcats_kernel_Semigroup$;
var $n_Lcats_kernel_Semigroup$;
function $m_Lcats_kernel_Semigroup$() {
  if ((!$n_Lcats_kernel_Semigroup$)) {
    $n_Lcats_kernel_Semigroup$ = new $c_Lcats_kernel_Semigroup$()
  };
  return $n_Lcats_kernel_Semigroup$
}
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1
}
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
  /*<skip>*/
}
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$())
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : default$1.apply__O())
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.valuesIterator__sc_Iterator = (function() {
  $m_sc_Iterator$();
  var a = this.sci_Map$Map1__f_value1;
  return new $c_sc_Iterator$$anon$20(a)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value))
});
$c_sci_Map$Map1.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? $m_sci_Map$EmptyMap$() : this)
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)))
});
$c_sci_Map$Map1.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  return (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$())
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1)
});
$c_sci_Map$Map1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map1 = new $TypeData().initClass({
  sci_Map$Map1: 0
}, false, "scala.collection.immutable.Map$Map1", {
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map1.prototype.$classData = $d_sci_Map$Map1;
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2
}
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
  /*<skip>*/
}
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2))
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()))
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : default$1.apply__O()))
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this)
});
$c_sci_Map$Map2.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$3(this)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)))
});
$c_sci_Map$Map2.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : this))
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  f.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ($uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))))
});
$c_sci_Map$Map2.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1;
    v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
    n = ((1 + n) | 0)
  };
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2;
      v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break
    }
    case 2: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2)
});
$c_sci_Map$Map2.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map2 = new $TypeData().initClass({
  sci_Map$Map2: 0
}, false, "scala.collection.immutable.Map$Map2", {
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map2.prototype.$classData = $d_sci_Map$Map2;
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3
}
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
  /*<skip>*/
}
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3))
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())))
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : default$1.apply__O())))
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this)
});
$c_sci_Map$Map3.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$6(this)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))))
});
$c_sci_Map$Map3.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : this)))
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  f.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  f.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (($uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))))
});
$c_sci_Map$Map3.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1;
    v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
    n = ((1 + n) | 0)
  };
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
    } else {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2
    };
    n = ((1 + n) | 0)
  };
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break
    }
    case 3: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3)
});
$c_sci_Map$Map3.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
var $d_sci_Map$Map3 = new $TypeData().initClass({
  sci_Map$Map3: 0
}, false, "scala.collection.immutable.Map$Map3", {
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map3.prototype.$classData = $d_sci_Map$Map3;
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4
}
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
  /*<skip>*/
}
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false)
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4))
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))))
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : default$1.apply__O()))))
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this)
});
$c_sci_Map$Map4.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$9(this)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value)
  } else {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap.updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4).updated__O__O__sci_HashMap(key, value)
  }
});
$c_sci_Map$Map4.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : this))))
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  f.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((($uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) && $uZ(p.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))))
});
$c_sci_Map$Map4.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1))) !== isFlipped)) {
    k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1;
    v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
    n = ((1 + n) | 0)
  };
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
    } else {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2
    };
    n = ((1 + n) | 0)
  };
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
    } else {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3
    };
    n = ((1 + n) | 0)
  };
  if (($uZ(pred.apply__O__O(new $c_T2(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
    } else if ((n === 2)) {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4
    };
    n = ((1 + n) | 0)
  };
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break
    }
    case 3: {
      return new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break
    }
    case 4: {
      return this;
      break
    }
    default: {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return builder.addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4)
});
$c_sci_Map$Map4.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key)
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value)
});
function $as_sci_Map$Map4(obj) {
  return (((obj instanceof $c_sci_Map$Map4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Map$Map4"))
}
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)))
}
function $asArrayOf_sci_Map$Map4(obj, depth) {
  return (($isArrayOf_sci_Map$Map4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Map$Map4;", depth))
}
var $d_sci_Map$Map4 = new $TypeData().initClass({
  sci_Map$Map4: 0
}, false, "scala.collection.immutable.Map$Map4", {
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Map$Map4.prototype.$classData = $d_sci_Map$Map4;
function $f_scm_Map__withDefaultValue__O__scm_Map($thiz, d) {
  return new $c_scm_Map$WithDefault($thiz, new $c_sjsr_AnonFunction1(((d$1) => ((x$2) => d$1))(d)))
}
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)))
}
function $as_scm_Map(obj) {
  return (($is_scm_Map(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Map"))
}
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)))
}
function $asArrayOf_scm_Map(obj, depth) {
  return (($isArrayOf_scm_Map(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Map;", depth))
}
/** @constructor */
function $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2(ME$2) {
  this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1 = null;
  this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1 = ME$2
}
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype = new $h_O();
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.constructor = $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2;
/** @constructor */
function $h_Lcats_data_KleisliInstances0\uff3f5$$anon$2() {
  /*<skip>*/
}
$h_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype = $c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype;
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.unit__O = (function() {
  var this$1 = $m_Lcats_data_Kleisli$();
  var F = this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$1, (void 0), F)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return fa$1.flatMap__F1__Lcats_FlatMap__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_data_KleisliFlatMap__tailRecM__O__F1__Lcats_data_Kleisli(this, a, f)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.raiseError__O__O = (function(e) {
  return $f_Lcats_data_KleisliApplicativeError__raiseError__O__Lcats_data_Kleisli(this, e)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var kb = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliApplicativeError__handleErrorWith__Lcats_data_Kleisli__F1__Lcats_data_Kleisli(this, kb, f)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.pure__O__O = (function(x) {
  var this$1 = $m_Lcats_data_Kleisli$();
  var F = this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1;
  return $f_Lcats_data_KleisliFunctions__pure__O__Lcats_Applicative__Lcats_data_Kleisli(this$1, x, F)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  var f = $as_Lcats_data_Kleisli(ff);
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return f.ap__Lcats_data_Kleisli__Lcats_Apply__Lcats_evidence_As__Lcats_data_Kleisli(fa$1, this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1, $m_Lcats_evidence_As$().Lcats_evidence_As$__f_reflAny)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliApply__map2Eval__Lcats_data_Kleisli__Lcats_Eval__F2__Lcats_Eval(this, fa$1, fb, f)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  var fb$1 = $as_Lcats_data_Kleisli(fa);
  var fc = $as_Lcats_data_Kleisli(fb);
  return $f_Lcats_data_KleisliApply__product__Lcats_data_Kleisli__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fb$1, fc)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return fa$1.map__F1__Lcats_Functor__Lcats_data_Kleisli(f, this.Lcats_data_KleisliInstances0\uff3f5$$anon$2__f_ME$1)
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.void__O__O = (function(fa) {
  var fa$1 = $as_Lcats_data_Kleisli(fa);
  return $f_Lcats_data_KleisliFunctor__void__Lcats_data_Kleisli__Lcats_data_Kleisli(this, fa$1)
});
var $d_Lcats_data_KleisliInstances0\uff3f5$$anon$2 = new $TypeData().initClass({
  Lcats_data_KleisliInstances0\uff3f5$$anon$2: 0
}, false, "cats.data.KleisliInstances0_5$$anon$2", {
  Lcats_data_KleisliInstances0\uff3f5$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_data_KleisliFunctor: 1,
  Lcats_data_KleisliApply: 1,
  Lcats_data_KleisliApplicative: 1,
  Lcats_data_KleisliApplicativeError: 1,
  Lcats_data_KleisliFlatMap: 1,
  Lcats_data_KleisliMonad: 1,
  Lcats_data_KleisliMonadError: 1
});
$c_Lcats_data_KleisliInstances0\uff3f5$$anon$2.prototype.$classData = $d_Lcats_data_KleisliInstances0\uff3f5$$anon$2;
/** @constructor */
function $c_Lcats_instances_TryInstances$$anon$1() {
  this.Lcats_instances_TryInstances$$anon$1__f_successUnit = null;
  this.Lcats_instances_TryInstances$$anon$1__f_successUnit = new $c_s_util_Success((void 0))
}
$c_Lcats_instances_TryInstances$$anon$1.prototype = new $h_Lcats_instances_TryCoflatMap();
$c_Lcats_instances_TryInstances$$anon$1.prototype.constructor = $c_Lcats_instances_TryInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_TryInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_TryInstances$$anon$1.prototype = $c_Lcats_instances_TryInstances$$anon$1.prototype;
$c_Lcats_instances_TryInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__s_util_Try__F1__Lcats_Applicative__O($as_s_util_Try(sa), f, evidence$5)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.product__s_util_Try__s_util_Try__s_util_Try = (function(ta, tb) {
  var x1 = new $c_T2(ta, tb);
  var x8 = $as_s_util_Try(x1.T2__f__1);
  var x9 = $as_s_util_Try(x1.T2__f__2);
  if ((x8 instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(x8).s_util_Success__f_value;
    if ((x9 instanceof $c_s_util_Success)) {
      var b = $as_s_util_Success(x9).s_util_Success__f_value;
      var value = new $c_T2(a, b);
      return new $c_s_util_Success(value)
    }
  };
  if ((x8 instanceof $c_s_util_Failure)) {
    var f = $as_s_util_Failure(x8);
    return f
  };
  if ((x9 instanceof $c_s_util_Failure)) {
    var f$2 = $as_s_util_Failure(x9);
    return f$2
  };
  throw new $c_s_MatchError(x1)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2__s_util_Try__s_util_Try__F2__s_util_Try = (function(ta, tb, f) {
  var x14 = new $c_T2(ta, tb);
  var x21 = $as_s_util_Try(x14.T2__f__1);
  var x22 = $as_s_util_Try(x14.T2__f__2);
  if ((x21 instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(x21).s_util_Success__f_value;
    if ((x22 instanceof $c_s_util_Success)) {
      var b = $as_s_util_Success(x22).s_util_Success__f_value;
      try {
        return new $c_s_util_Success(f.apply__O__O__O(a, b))
      } catch (e) {
        var e$2 = $m_sjsr_package$().wrapJavaScriptException__O__jl_Throwable(e);
        if ((e$2 !== null)) {
          if ((e$2 !== null)) {
            var o11 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
            if ((!o11.isEmpty__Z())) {
              var e$3 = $as_jl_Throwable(o11.get__O());
              return new $c_s_util_Failure(e$3)
            }
          };
          throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O(e$2)
        } else {
          throw e
        }
      }
    }
  };
  if ((x21 instanceof $c_s_util_Failure)) {
    var f$3 = $as_s_util_Failure(x21);
    return f$3
  };
  if ((x22 instanceof $c_s_util_Failure)) {
    var f$4 = $as_s_util_Failure(x22);
    return f$4
  };
  throw new $c_s_MatchError(x14)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2Eval__s_util_Try__Lcats_Eval__F2__Lcats_Eval = (function(ta, tb, f) {
  if ((ta instanceof $c_s_util_Failure)) {
    var f$2 = $as_s_util_Failure(ta);
    return new $c_Lcats_Now(f$2)
  };
  if ((ta instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(ta).s_util_Success__f_value;
    return tb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$3, a$2) => ((_$1) => {
      var _$1$1 = $as_s_util_Try(_$1);
      return _$1$1.map__F1__s_util_Try(new $c_sjsr_AnonFunction1(((f$2$2, a$2$2) => ((_$2) => f$2$2.apply__O__O__O(a$2$2, _$2)))(f$3, a$2)))
    }))(f, a)))
  };
  throw new $c_s_MatchError(ta)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldLeft__s_util_Try__O__F2__O = (function(fa, b, f) {
  if ((fa instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(fa).s_util_Success__f_value;
    return f.apply__O__O__O(b, a)
  };
  if ((fa instanceof $c_s_util_Failure)) {
    return b
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldRight__s_util_Try__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  if ((fa instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(fa).s_util_Success__f_value;
    return $as_Lcats_Eval(f.apply__O__O__O(a, lb))
  };
  if ((fa instanceof $c_s_util_Failure)) {
    return lb
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.traverse__s_util_Try__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ((fa instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(fa).s_util_Success__f_value;
    return G.map__O__F1__O(f.apply__O__O(a), new $c_sjsr_AnonFunction1(((_$4) => new $c_s_util_Success(_$4))))
  };
  if ((fa instanceof $c_s_util_Failure)) {
    var f$2 = $as_s_util_Failure(fa);
    return G.pure__O__O(f$2)
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.tailRecM__O__F1__s_util_Try = (function(b, f) {
  var this$ = this;
  var b$tailLocal1 = b;
  while (true) {
    var x45 = $as_s_util_Try(f.apply__O__O(b$tailLocal1));
    if ((x45 instanceof $c_s_util_Failure)) {
      var f$2 = $as_s_util_Failure(x45);
      return f$2
    };
    if ((x45 instanceof $c_s_util_Success)) {
      var x51 = $as_s_util_Either($as_s_util_Success(x45).s_util_Success__f_value);
      if ((x51 instanceof $c_s_util_Left)) {
        var b1 = $as_s_util_Left(x51).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        b$tailLocal1 = b1;
        continue
      };
      if ((x51 instanceof $c_s_util_Right)) {
        var c = $as_s_util_Right(x51).s_util_Right__f_value;
        return new $c_s_util_Success(c)
      }
    };
    throw new $c_s_MatchError(x45)
  }
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.handleErrorWith__s_util_Try__F1__s_util_Try = (function(ta, f) {
  return ta.recoverWith__s_PartialFunction__s_util_Try(new $c_Lcats_instances_TryInstances$$anon$4(f))
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.attempt__s_util_Try__s_util_Try = (function(ta) {
  if ((ta instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(ta).s_util_Success__f_value;
    $m_s_package$();
    var value = new $c_s_util_Right(a);
    return new $c_s_util_Success(value)
  };
  if ((ta instanceof $c_s_util_Failure)) {
    var e = $as_s_util_Failure(ta).s_util_Failure__f_exception;
    $m_s_package$();
    var value$1 = new $c_s_util_Left(e);
    return new $c_s_util_Success(value$1)
  };
  throw new $c_s_MatchError(ta)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldMap__s_util_Try__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  if ((fa instanceof $c_s_util_Failure)) {
    return B.empty__O()
  };
  if ((fa instanceof $c_s_util_Success)) {
    var a = $as_s_util_Success(fa).s_util_Success__f_value;
    return f.apply__O__O(a)
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.void__s_util_Try__s_util_Try = (function(t) {
  return (t.isSuccess__Z() ? this.Lcats_instances_TryInstances$$anon$1__f_successUnit : t)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_s_util_Success(x)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_util_Try__s_util_Try__s_util_Try($as_s_util_Try(fa), $as_s_util_Try(fb))
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_util_Try__s_util_Try__F2__s_util_Try($as_s_util_Try(fa), $as_s_util_Try(fb), f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Try__Lcats_Eval__F2__Lcats_Eval($as_s_util_Try(fa), fb, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var ta = $as_s_util_Try(fa);
  return ta.flatMap__F1__s_util_Try(f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_util_Try__O__F2__O($as_s_util_Try(fa), b, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Try__Lcats_Eval__F2__Lcats_Eval($as_s_util_Try(fa), lb, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Try__F1__Lcats_Applicative__O($as_s_util_Try(fa), f, evidence$1)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Try(a, f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Try__F1__s_util_Try($as_s_util_Try(fa), f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  return new $c_s_util_Failure(e$1)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.attempt__O__O = (function(fa) {
  return this.attempt__s_util_Try__s_util_Try($as_s_util_Try(fa))
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var ta = $as_s_util_Try(fa);
  return ta.map__F1__s_util_Try(f)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_util_Try__F1__Lcats_kernel_Monoid__O($as_s_util_Try(fa), f, B)
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__s_util_Try__s_util_Try($as_s_util_Try(fa))
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_TryInstances$$anon$1__f_successUnit
});
var $d_Lcats_instances_TryInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_TryInstances$$anon$1: 0
}, false, "cats.instances.TryInstances$$anon$1", {
  Lcats_instances_TryInstances$$anon$1: 1,
  Lcats_instances_TryCoflatMap: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_CoflatMap: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1
});
$c_Lcats_instances_TryInstances$$anon$1.prototype.$classData = $d_Lcats_instances_TryInstances$$anon$1;
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode))
}
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode
}
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
  /*<skip>*/
}
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$()
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.size__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return (this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size === 0)
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode))
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return this.sci_HashSet__f_rootNode.contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0)
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode)
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sci_HashSet = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if (this.isEmpty__Z()) {
      return x2
    } else {
      var newNode = this.sci_HashSet__f_rootNode.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(x2.sci_HashSet__f_rootNode, 0);
      return ((newNode === x2.sci_HashSet__f_rootNode) ? x2 : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode))
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(that);
    var iter = new $c_scm_HashSet$$anon$2(x3);
    var current = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      var improvedHash = next.scm_HashSet$Node__f__hash;
      var originalHash = x3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = current.updated__O__I__I__I__sci_BitmapIndexedSetNode(next.scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((current !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = $as_scm_HashSet$Node(iter.next__O());
          var improvedHash$1 = next$2.scm_HashSet$Node__f__hash;
          var originalHash$2 = x3.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          shallowlyMutableNodeMap = current.updateWithShallowMutations__O__I__I__I__I__I(next$2.scm_HashSet$Node__f__key, originalHash$2, improved$2, 0, shallowlyMutableNodeMap)
        };
        return new $c_sci_HashSet(current)
      }
    };
    return this
  } else {
    var iter$2 = that.iterator__sc_Iterator();
    var current$2 = this.sci_HashSet__f_rootNode;
    while (iter$2.hasNext__Z()) {
      var element = iter$2.next__O();
      var originalHash$3 = $m_sr_Statics$().anyHash__O__I(element);
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = current$2.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash$3, improved$3, 0);
      if ((current$2 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$3, 0));
        while (iter$2.hasNext__Z()) {
          var element$2 = iter$2.next__O();
          var originalHash$4 = $m_sr_Statics$().anyHash__O__I(element$2);
          var improved$4 = $m_sc_Hashing$().improve__I__I(originalHash$4);
          shallowlyMutableNodeMap$2 = current$2.updateWithShallowMutations__O__I__I__I__I__I(element$2, originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2)
        };
        return new $c_sci_HashSet(current$2)
      }
    };
    return this
  }
});
$c_sci_HashSet.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O()
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  this.sci_HashSet__f_rootNode.foreach__F1__V(f)
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = x2.sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that)
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $as_sci_HashSet($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_HashSet(that)
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem)
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem)
});
function $as_sci_HashSet(obj) {
  return (((obj instanceof $c_sci_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashSet"))
}
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)))
}
function $asArrayOf_sci_HashSet(obj, depth) {
  return (($isArrayOf_sci_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashSet;", depth))
}
var $d_sci_HashSet = new $TypeData().initClass({
  sci_HashSet: 0
}, false, "scala.collection.immutable.HashSet", {
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashSet.prototype.$classData = $d_sci_HashSet;
/** @constructor */
function $c_scm_AbstractSet() {
  /*<skip>*/
}
$c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_scm_AbstractSet.prototype.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
  /*<skip>*/
}
$h_scm_AbstractSet.prototype = $c_scm_AbstractSet.prototype;
$c_scm_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Set$()
});
$c_scm_AbstractSet.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractSet.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractSet.prototype.result__O = (function() {
  return this
});
/** @constructor */
function $c_Lcats_effect_SyncIO$$anon$2() {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleOnce = null;
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleMany = null;
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = new $c_Lcats_effect_kernel_MonadCancel$$anon$9()
}
$c_Lcats_effect_SyncIO$$anon$2.prototype = new $h_O();
$c_Lcats_effect_SyncIO$$anon$2.prototype.constructor = $c_Lcats_effect_SyncIO$$anon$2;
/** @constructor */
function $h_Lcats_effect_SyncIO$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_SyncIO$$anon$2.prototype = $c_Lcats_effect_SyncIO$$anon$2.prototype;
$c_Lcats_effect_SyncIO$$anon$2.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.guarantee__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guarantee__O__O__O(this, fa, fin)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Delay = x$0
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = x$0
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleOnce = x$0
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleMany = x$0
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$Sync$$Delay;
  return this.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_SyncIO(hint, thunk)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.canceled__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O(this, fa, fin)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.uncancelable__F1__O = (function(body) {
  return body.apply__O__O(this.Lcats_effect_SyncIO$$anon$2__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_SyncIO = (function(hint, thunk) {
  var thunk$1 = new $c_sjsr_AnonFunction0(((thunk$2) => (() => thunk$2.apply__O()))(thunk));
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk$1)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Pure(x)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Error(e$1)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  return new $c_Lcats_effect_SyncIO$HandleErrorWith(fa$1, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  return new $c_Lcats_effect_SyncIO$FlatMap(fa$1, f)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return this.suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_SyncIO(hint, thunk)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.attempt__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  return new $c_Lcats_effect_SyncIO$Attempt(fa$1)
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.unit__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.forceR__O__O__O = (function(fa, fb) {
  var fa$1 = $as_Lcats_effect_SyncIO(fa);
  var fb$1 = $as_Lcats_effect_SyncIO(fb);
  return new $c_Lcats_effect_SyncIO$Attempt(fa$1).productR__Lcats_effect_SyncIO__Lcats_effect_SyncIO(fb$1)
});
var $d_Lcats_effect_SyncIO$$anon$2 = new $TypeData().initClass({
  Lcats_effect_SyncIO$$anon$2: 0
}, false, "cats.effect.SyncIO$$anon$2", {
  Lcats_effect_SyncIO$$anon$2: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_effect_kernel_MonadCancel$Uncancelable: 1
});
$c_Lcats_effect_SyncIO$$anon$2.prototype.$classData = $d_Lcats_effect_SyncIO$$anon$2;
/** @constructor */
function $c_Lcats_effect_kernel_ResourceConcurrent() {
  /*<skip>*/
}
$c_Lcats_effect_kernel_ResourceConcurrent.prototype = new $h_Lcats_effect_kernel_ResourceMonadCancel();
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.constructor = $c_Lcats_effect_kernel_ResourceConcurrent;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceConcurrent() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceConcurrent.prototype = $c_Lcats_effect_kernel_ResourceConcurrent.prototype;
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_kernel_Resource(fa);
  return fa$1.start__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1)
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.deferred__O = (function() {
  return $m_Lcats_effect_kernel_Resource$().deferred__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1)
});
$c_Lcats_effect_kernel_ResourceConcurrent.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_kernel_Resource$().ref__O__Lcats_effect_kernel_GenConcurrent__Lcats_effect_kernel_Resource(a, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1)
});
/** @constructor */
function $c_Lcats_instances_QueueInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_QueueInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_QueueInstances$$anon$1.prototype.constructor = $c_Lcats_instances_QueueInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_QueueInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_QueueInstances$$anon$1.prototype = $c_Lcats_instances_QueueInstances$$anon$1.prototype;
$c_Lcats_instances_QueueInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__sci_Queue__F1__Lcats_Applicative__O($as_sci_Queue(sa), f, evidence$5)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Queue((void 0))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__sci_Queue = (function(x) {
  var xs = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), ($m_sci_List$(), $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(xs)))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__sci_Queue__sci_Queue__F2__sci_Queue = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_sci_Queue$EmptyQueue$()
  } else {
    var b = $m_sci_Queue$().newBuilder__scm_Builder();
    var it = fa.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var arg1 = it.next__O();
      var b$1 = $m_sci_Queue$().newBuilder__scm_Builder();
      var it$1 = fb.iterator__sc_Iterator();
      while (it$1.hasNext__Z()) {
        var arg1$1 = it$1.next__O();
        var elem = f.apply__O__O__O(arg1, arg1$1);
        b$1.addOne__O__scm_Growable(elem)
      };
      var xs = $as_sc_IterableOnce(b$1.result__O());
      b.addAll__sc_IterableOnce__scm_Growable(xs)
    };
    return $as_sci_Queue(b.result__O())
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_sci_Queue$EmptyQueue$();
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$4, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_sci_Queue(fb$2);
      return this$4.map2__sci_Queue__sci_Queue__F2__sci_Queue(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__sci_Queue = (function(a, f) {
  var bldr = $m_sci_Queue$().newBuilder__scm_Builder();
  var elem$2 = $as_sci_Queue(f.apply__O__O(a));
  var this$1 = $m_s_package$().s_package$__f_Nil;
  return $s_Lcats_instances_QueueInstances__cats$instances$QueueInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__sci_Queue(f, bldr, new $c_sci_$colon$colon(elem$2, this$1))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_QueueInstances__loop$3__Lcats_Eval__F2__sci_Queue__Lcats_Eval(lb$2, f$2, fa$2)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__sci_Queue__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_sci_Queue$EmptyQueue$())
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$2 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$2.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($$x1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1(((chain) => {
      var chain$1 = $as_Lcats_data_Chain(chain);
      var z = $m_sci_Queue$EmptyQueue$();
      var result = z;
      var iter = chain$1.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var arg1 = result;
        var arg2 = iter.next__O();
        var _$2 = $as_sci_Queue(arg1);
        result = _$2.enqueue__O__sci_Queue(arg2)
      };
      return $as_sci_Queue(result)
    })))
  }
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Queue(x)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__map__F1__O(fa$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Queue(fa);
  return $as_sci_Queue($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(fa$1, f))
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Queue__sci_Queue__F2__sci_Queue($as_sci_Queue(fa), $as_sci_Queue(fb), f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Queue__Lcats_Eval__F2__Lcats_Eval($as_sci_Queue(fa), fb, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Queue(a, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_Queue(fa);
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(fa$1, b, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Queue__Lcats_Eval__F2__Lcats_Eval($as_sci_Queue(fa), lb, f)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Queue__F1__Lcats_kernel_Monoid__O($as_sci_Queue(fa), f, B)
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Queue__F1__Lcats_Applicative__O($as_sci_Queue(fa), f, evidence$1)
});
var $d_Lcats_instances_QueueInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_QueueInstances$$anon$1: 0
}, false, "cats.instances.QueueInstances$$anon$1", {
  Lcats_instances_QueueInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1
});
$c_Lcats_instances_QueueInstances$$anon$1.prototype.$classData = $d_Lcats_instances_QueueInstances$$anon$1;
function $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State($thiz) {
  if ((!$thiz.sci_LazyList__f_bitmap$0)) {
    if ($thiz.sci_LazyList__f_midEvaluation) {
      throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "self-referential LazyList or a derivation thereof has no more elements"))
    };
    $thiz.sci_LazyList__f_midEvaluation = true;
    try {
      var res = $as_sci_LazyList$State($thiz.sci_LazyList__f_lazyState.apply__O())
    } finally {
      $thiz.sci_LazyList__f_midEvaluation = false
    };
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = true;
    $thiz.sci_LazyList__f_lazyState = null;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state = res;
    $thiz.sci_LazyList__f_bitmap$0 = true
  };
  return $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$state
}
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0(((this$1, f$1) => (() => {
    if (this$1.isEmpty__Z()) {
      return $m_sci_LazyList$State$Empty$()
    } else {
      $m_sci_LazyList$();
      var hd = f$1.apply__O__O(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
      var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), f$1);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }))($thiz, f));
  return new $c_sci_LazyList(state)
}
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
  } else if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    var elem$1 = $thiz.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    var elem$2 = null;
    elem$2 = elem$1;
    if ((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ((!$as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated) || ($as_sci_LazyList(elem).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $as_sci_LazyList(elem$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
      elem = $as_sci_LazyList(elem$2);
      if (($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) {
        var this$3 = $as_sci_LazyList(elem$2);
        elem$2 = this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
        while (((($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2)) && ($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) && ($as_sci_LazyList(elem).scala$collection$immutable$LazyList$$state__sci_LazyList$State() !== $as_sci_LazyList(elem$2).scala$collection$immutable$LazyList$$state__sci_LazyList$State()))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$4 = $as_sci_LazyList(elem);
          var obj$1 = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
          var this$5 = $as_sci_LazyList(elem);
          elem = this$5.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          var this$6 = $as_sci_LazyList(elem$2);
          elem$2 = this$6.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          if (($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z()))) {
            var this$7 = $as_sci_LazyList(elem$2);
            elem$2 = this$7.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
          }
        }
      }
    };
    if ((!($as_sci_LazyList(elem$2).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && (!$as_sci_LazyList(elem$2).isEmpty__Z())))) {
      while (($as_sci_LazyList(elem) !== $as_sci_LazyList(elem$2))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$8 = $as_sci_LazyList(elem);
        var obj$2 = this$8.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        var this$9 = $as_sci_LazyList(elem);
        elem = this$9.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
      };
      if ((!$as_sci_LazyList(elem).sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated)) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      }
    } else {
      var runner = $thiz;
      var k = 0;
      while (true) {
        var a = runner;
        var b$1 = $as_sci_LazyList(elem$2);
        if ((!((a === b$1) || (a.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          var this$10 = runner;
          runner = this$10.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          var this$11 = $as_sci_LazyList(elem$2);
          elem$2 = this$11.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
          k = ((1 + k) | 0)
        } else {
          break
        }
      };
      var a$1 = $as_sci_LazyList(elem);
      var b$2 = $as_sci_LazyList(elem$2);
      if ((((a$1 === b$2) || (a$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State())) && (k > 0))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var this$12 = $as_sci_LazyList(elem);
        var obj$3 = this$12.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        var this$13 = $as_sci_LazyList(elem);
        elem = this$13.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
      };
      while (true) {
        var a$2 = $as_sci_LazyList(elem);
        var b$3 = $as_sci_LazyList(elem$2);
        if ((!((a$2 === b$3) || (a$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === b$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State())))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var this$14 = $as_sci_LazyList(elem);
          var obj$4 = this$14.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          var this$15 = $as_sci_LazyList(elem);
          elem = this$15.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
        } else {
          break
        }
      };
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
    }
  };
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_LazyList(lazyState) {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$state = null;
  this.sci_LazyList__f_lazyState = null;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false;
  this.sci_LazyList__f_bitmap$0 = false;
  this.sci_LazyList__f_lazyState = lazyState;
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated = false;
  this.sci_LazyList__f_midEvaluation = false
}
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
  /*<skip>*/
}
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$state__sci_LazyList$State = (function() {
  return ((!this.sci_LazyList__f_bitmap$0) ? $p_sci_LazyList__scala$collection$immutable$LazyList$$state$lzycompute__sci_LazyList$State(this) : this.sci_LazyList__f_scala$collection$immutable$LazyList$$state)
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$state__sci_LazyList$State() === $m_sci_LazyList$State$Empty$())
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? 0 : (-1))
});
$c_sci_LazyList.prototype.head__O = (function() {
  return this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O()
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    var this$1 = these;
    these = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  };
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this
    };
    var this$2 = these;
    these = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    if (these.isEmpty__Z()) {
      return this
    };
    var this$3 = these;
    these = this$3.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    if ((these === those)) {
      return this
    };
    var this$4 = those;
    those = this$4.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  };
  return this
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this))
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!_$this.isEmpty__Z())) {
    var this$1 = _$this;
    f.apply__O__O(this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
    var this$2 = _$this;
    _$this = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z
    } else {
      var this$1 = _$this;
      var temp$_$this = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
      var $$x1 = z;
      var this$2 = _$this;
      var temp$z = op.apply__O__O__O($$x1, this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList"
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sjsr_AnonFunction0(((this$1, suffix$1) => (() => {
    if (this$1.isEmpty__Z()) {
      var x1 = $as_sc_IterableOnce(suffix$1.apply__O());
      if ((x1 instanceof $c_sci_LazyList)) {
        var x2 = $as_sci_LazyList(x1);
        return x2.scala$collection$immutable$LazyList$$state__sci_LazyList$State()
      } else {
        return ((x1.knownSize__I() === 0) ? $m_sci_LazyList$State$Empty$() : $m_sci_LazyList$().scala$collection$immutable$LazyList$$stateFromIterator__sc_Iterator__sci_LazyList$State(x1.iterator__sc_Iterator()))
      }
    } else {
      $m_sci_LazyList$();
      var hd = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
      var tl = this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList().lazyAppendedAll__F0__sci_LazyList(suffix$1);
      return new $c_sci_LazyList$State$Cons(hd, tl)
    }
  }))(this, suffix));
  return new $c_sci_LazyList(state)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sjsr_AnonFunction0(((suffix$1) => (() => suffix$1))(suffix))))
});
$c_sci_LazyList.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  } else {
    var reducedRes = this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
    var left = this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList();
    while ((!left.isEmpty__Z())) {
      var $$x1 = reducedRes;
      var this$1 = left;
      reducedRes = f.apply__O__O__O($$x1, this$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O());
      var this$2 = left;
      left = this$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
    };
    return reducedRes
  }
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f))
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$stateEvaluated && this.isEmpty__Z()) ? $m_sci_LazyList$().sci_LazyList$__f__empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)))
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n)
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f)
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix)
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return this.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList()
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$()
});
function $as_sci_LazyList(obj) {
  return (((obj instanceof $c_sci_LazyList) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LazyList"))
}
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)))
}
function $asArrayOf_sci_LazyList(obj, depth) {
  return (($isArrayOf_sci_LazyList(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LazyList;", depth))
}
var $d_sci_LazyList = new $TypeData().initClass({
  sci_LazyList: 0
}, false, "scala.collection.immutable.LazyList", {
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_LazyList.prototype.$classData = $d_sci_LazyList;
/** @constructor */
function $c_sci_LongMap() {
  /*<skip>*/
}
$c_sci_LongMap.prototype = new $h_sci_AbstractMap();
$c_sci_LongMap.prototype.constructor = $c_sci_LongMap;
/** @constructor */
function $h_sci_LongMap() {
  /*<skip>*/
}
$h_sci_LongMap.prototype = $c_sci_LongMap.prototype;
$c_sci_LongMap.prototype.fromSpecific__sc_IterableOnce__sci_LongMap = (function(coll) {
  var b = new $c_sci_LongMap$$anon$2(this);
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, coll, 0);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, coll);
  return $as_sci_LongMap(b.scm_ImmutableBuilder__f_elems)
});
$c_sci_LongMap.prototype.iterator__sc_Iterator = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    return new $c_sci_LongMapEntryIterator(this)
  }
});
$c_sci_LongMap.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var x2 = $as_sci_LongMap$Bin(x1);
      var left = x2.sci_LongMap$Bin__f_left;
      var right = x2.sci_LongMap$Bin__f_right;
      left.foreach__F1__V(f);
      _$this = right;
      continue
    };
    if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var x5 = $as_sci_LongMap$Tip(x1);
      var t = x5.sci_LongMap$Tip__f_key;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = x5.sci_LongMap$Tip__f_value;
      f.apply__O__O(new $c_T2(new $c_RTLong(lo, hi), value))
    } else {
      var x = $m_sci_LongMap$Nil$();
      if ((!x.equals__O__Z(x1))) {
        throw new $c_s_MatchError(x1)
      }
    };
    break
  }
});
$c_sci_LongMap.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var x2 = $as_sci_LongMap$Bin(x1);
      var left = x2.sci_LongMap$Bin__f_left;
      var right = x2.sci_LongMap$Bin__f_right;
      left.foreachEntry__F2__V(f);
      _$this = right;
      continue
    };
    if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var x5 = $as_sci_LongMap$Tip(x1);
      var t = x5.sci_LongMap$Tip__f_key;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = x5.sci_LongMap$Tip__f_value;
      f.apply__O__O__O(new $c_RTLong(lo, hi), value)
    } else {
      var x = $m_sci_LongMap$Nil$();
      if ((!x.equals__O__Z(x1))) {
        throw new $c_s_MatchError(x1)
      }
    };
    break
  }
});
$c_sci_LongMap.prototype.valuesIterator__sc_Iterator = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
  } else {
    return new $c_sci_LongMapValueIterator(this)
  }
});
$c_sci_LongMap.prototype.className__T = (function() {
  return "LongMap"
});
$c_sci_LongMap.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_LongMap$Nil$())
});
$c_sci_LongMap.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : (-1))
});
$c_sci_LongMap.prototype.filter__F1__sci_LongMap = (function(f) {
  if ((this instanceof $c_sci_LongMap$Bin)) {
    var x2 = $as_sci_LongMap$Bin(this);
    var t = x2.sci_LongMap$Bin__f_prefix;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = x2.sci_LongMap$Bin__f_mask;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var left = x2.sci_LongMap$Bin__f_left;
    var right = x2.sci_LongMap$Bin__f_right;
    var _1 = left.filter__F1__sci_LongMap(f);
    var _2 = right.filter__F1__sci_LongMap(f);
    return (((left === _1) && (right === _2)) ? this : $m_sci_LongMapUtils$().bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), _1, _2))
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    var x3 = $as_sci_LongMap$Tip(this);
    var t$2 = x3.sci_LongMap$Tip__f_key;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    var value = x3.sci_LongMap$Tip__f_value;
    return ($uZ(f.apply__O__O(new $c_T2(new $c_RTLong(lo$2, hi$2), value))) ? this : $m_sci_LongMap$Nil$())
  } else {
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(this)) {
      return $m_sci_LongMap$Nil$()
    } else {
      throw new $c_s_MatchError(this)
    }
  }
});
$c_sci_LongMap.prototype.size__I = (function() {
  var x = $m_sci_LongMap$Nil$();
  if (x.equals__O__Z(this)) {
    return 0
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    return 1
  } else if ((this instanceof $c_sci_LongMap$Bin)) {
    var x6 = $as_sci_LongMap$Bin(this);
    var left = x6.sci_LongMap$Bin__f_left;
    var right = x6.sci_LongMap$Bin__f_right;
    return ((left.size__I() + right.size__I()) | 0)
  } else {
    throw new $c_s_MatchError(this)
  }
});
$c_sci_LongMap.prototype.get__J__s_Option = (function(key) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var x2 = $as_sci_LongMap$Bin(x1);
      var t = x2.sci_LongMap$Bin__f_mask;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var left = x2.sci_LongMap$Bin__f_left;
      var right = x2.sci_LongMap$Bin__f_right;
      var this$1 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$1, key, new $c_RTLong(lo, hi))) {
        _$this = left
      } else {
        _$this = right
      }
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var x3 = $as_sci_LongMap$Tip(x1);
      var t$1 = x3.sci_LongMap$Tip__f_key;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var value = x3.sci_LongMap$Tip__f_value;
      return (((key.RTLong__f_lo === lo$1) && (key.RTLong__f_hi === hi$1)) ? new $c_s_Some(value) : $m_s_None$())
    } else {
      var x = $m_sci_LongMap$Nil$();
      if (x.equals__O__Z(x1)) {
        return $m_s_None$()
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }
});
$c_sci_LongMap.prototype.getOrElse__J__F0__O = (function(key, default$1) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(x1)) {
      return default$1.apply__O()
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var x3 = $as_sci_LongMap$Tip(x1);
      var t = x3.sci_LongMap$Tip__f_key;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var value = x3.sci_LongMap$Tip__f_value;
      return (((key.RTLong__f_lo === lo) && (key.RTLong__f_hi === hi)) ? value : default$1.apply__O())
    } else if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var x4 = $as_sci_LongMap$Bin(x1);
      var t$1 = x4.sci_LongMap$Bin__f_mask;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var left = x4.sci_LongMap$Bin__f_left;
      var right = x4.sci_LongMap$Bin__f_right;
      var this$1 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$1, key, new $c_RTLong(lo$1, hi$1))) {
        _$this = left
      } else {
        _$this = right
      }
    } else {
      throw new $c_s_MatchError(x1)
    }
  }
});
$c_sci_LongMap.prototype.apply__J__O = (function(key) {
  var _$this = this;
  while (true) {
    var x1 = _$this;
    if ((x1 instanceof $c_sci_LongMap$Bin)) {
      var x2 = $as_sci_LongMap$Bin(x1);
      var t = x2.sci_LongMap$Bin__f_mask;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var left = x2.sci_LongMap$Bin__f_left;
      var right = x2.sci_LongMap$Bin__f_right;
      var this$1 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$1, key, new $c_RTLong(lo, hi))) {
        _$this = left
      } else {
        _$this = right
      }
    } else if ((x1 instanceof $c_sci_LongMap$Tip)) {
      var x3 = $as_sci_LongMap$Tip(x1);
      var t$1 = x3.sci_LongMap$Tip__f_key;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var value = x3.sci_LongMap$Tip__f_value;
      if (((key.RTLong__f_lo === lo$1) && (key.RTLong__f_hi === hi$1))) {
        return value
      } else {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Key not found")
      }
    } else {
      var x = $m_sci_LongMap$Nil$();
      if (x.equals__O__Z(x1)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "key not found")
      } else {
        throw new $c_s_MatchError(x1)
      }
    }
  }
});
$c_sci_LongMap.prototype.updated__J__O__sci_LongMap = (function(key, value) {
  if ((this instanceof $c_sci_LongMap$Bin)) {
    var x2 = $as_sci_LongMap$Bin(this);
    var t = x2.sci_LongMap$Bin__f_prefix;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = x2.sci_LongMap$Bin__f_mask;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var left = x2.sci_LongMap$Bin__f_left;
    var right = x2.sci_LongMap$Bin__f_right;
    var this$1 = $m_sci_LongMapUtils$();
    if ((!$f_scg_BitOperations$Long__hasMatch__J__J__J__Z(this$1, key, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)))) {
      return $m_sci_LongMapUtils$().join__J__sci_LongMap__J__sci_LongMap__sci_LongMap(key, new $c_sci_LongMap$Tip(key, value), new $c_RTLong(lo, hi), this)
    } else {
      var this$2 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$2, key, new $c_RTLong(lo$1, hi$1))) {
        return new $c_sci_LongMap$Bin(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), left.updated__J__O__sci_LongMap(key, value), right)
      } else {
        return new $c_sci_LongMap$Bin(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), left, right.updated__J__O__sci_LongMap(key, value))
      }
    }
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    var x3 = $as_sci_LongMap$Tip(this);
    var t$2 = x3.sci_LongMap$Tip__f_key;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    return (((key.RTLong__f_lo === lo$2) && (key.RTLong__f_hi === hi$2)) ? new $c_sci_LongMap$Tip(key, value) : $m_sci_LongMapUtils$().join__J__sci_LongMap__J__sci_LongMap__sci_LongMap(key, new $c_sci_LongMap$Tip(key, value), new $c_RTLong(lo$2, hi$2), this))
  } else {
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(this)) {
      return new $c_sci_LongMap$Tip(key, value)
    } else {
      throw new $c_s_MatchError(this)
    }
  }
});
$c_sci_LongMap.prototype.removed__J__sci_LongMap = (function(key) {
  if ((this instanceof $c_sci_LongMap$Bin)) {
    var x2 = $as_sci_LongMap$Bin(this);
    var t = x2.sci_LongMap$Bin__f_prefix;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = x2.sci_LongMap$Bin__f_mask;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var left = x2.sci_LongMap$Bin__f_left;
    var right = x2.sci_LongMap$Bin__f_right;
    var this$1 = $m_sci_LongMapUtils$();
    if ((!$f_scg_BitOperations$Long__hasMatch__J__J__J__Z(this$1, key, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1)))) {
      return this
    } else {
      var this$2 = $m_sci_LongMapUtils$();
      if ($f_scg_BitOperations$Long__zero__J__J__Z(this$2, key, new $c_RTLong(lo$1, hi$1))) {
        return $m_sci_LongMapUtils$().bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), left.removed__J__sci_LongMap(key), right)
      } else {
        return $m_sci_LongMapUtils$().bin__J__J__sci_LongMap__sci_LongMap__sci_LongMap(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), left, right.removed__J__sci_LongMap(key))
      }
    }
  } else if ((this instanceof $c_sci_LongMap$Tip)) {
    var x3 = $as_sci_LongMap$Tip(this);
    var t$2 = x3.sci_LongMap$Tip__f_key;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    return (((key.RTLong__f_lo === lo$2) && (key.RTLong__f_hi === hi$2)) ? $m_sci_LongMap$Nil$() : this)
  } else {
    var x = $m_sci_LongMap$Nil$();
    if (x.equals__O__Z(this)) {
      return $m_sci_LongMap$Nil$()
    } else {
      throw new $c_s_MatchError(this)
    }
  }
});
$c_sci_LongMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__J__sci_LongMap($uJ(key))
});
$c_sci_LongMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__J__O__sci_LongMap($uJ(key), value)
});
$c_sci_LongMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  return this.updated__J__O__sci_LongMap(kv._1$mcJ$sp__J(), kv._2__O())
});
$c_sci_LongMap.prototype.apply__O__O = (function(key) {
  return this.apply__J__O($uJ(key))
});
$c_sci_LongMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return this.getOrElse__J__F0__O($uJ(key), default$1)
});
$c_sci_LongMap.prototype.get__O__s_Option = (function(key) {
  return this.get__J__s_Option($uJ(key))
});
$c_sci_LongMap.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_LongMap(pred)
});
$c_sci_LongMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_LongMap(coll)
});
$c_sci_LongMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sci_LongMap(coll)
});
function $as_sci_LongMap(obj) {
  return (((obj instanceof $c_sci_LongMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LongMap"))
}
function $isArrayOf_sci_LongMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LongMap)))
}
function $asArrayOf_sci_LongMap(obj, depth) {
  return (($isArrayOf_sci_LongMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LongMap;", depth))
}
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $as_sci_Stream($thiz.tail__O());
      if (($as_sci_Stream(elem) !== scout)) {
        elem = scout;
        if (scout.tailDefined__Z()) {
          scout = $as_sci_Stream(scout.tail__O());
          while ((($as_sci_Stream(elem) !== scout) && scout.tailDefined__Z())) {
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = $as_sci_Stream(elem).head__O();
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = $as_sci_Stream($as_sci_Stream(elem).tail__O());
            scout = $as_sci_Stream(scout.tail__O());
            if (scout.tailDefined__Z()) {
              scout = $as_sci_Stream(scout.tail__O())
            }
          }
        }
      };
      if ((!scout.tailDefined__Z())) {
        while (($as_sci_Stream(elem) !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        };
        var this$2 = $as_sci_Stream(elem);
        if ((!this$2.isEmpty__Z())) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3)
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = $as_sci_Stream(runner.tail__O());
          scout = $as_sci_Stream(scout.tail__O());
          k = ((1 + k) | 0)
        };
        if ((($as_sci_Stream(elem) === scout) && (k > 0))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        };
        while (($as_sci_Stream(elem) !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = $as_sci_Stream(elem).head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = $as_sci_Stream($as_sci_Stream(elem).tail__O())
        }
      }
    };
    var this$3 = $as_sci_Stream(elem);
    if ((!this$3.isEmpty__Z())) {
      if ((!$as_sci_Stream(elem).tailDefined__Z())) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>")
      } else {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>")
      }
    }
  };
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b
}
/** @constructor */
function $c_sci_Stream() {
  /*<skip>*/
}
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
  /*<skip>*/
}
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this)
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this)
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p)
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream"
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while ((!_$this.isEmpty__Z())) {
    f.apply__O__O(_$this.head__O());
    _$this = $as_sci_Stream(_$this.tail__O())
  }
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z
    } else {
      var temp$_$this = $as_sci_Stream(_$this.tail__O());
      var temp$z = op.apply__O__O__O(z, _$this.head__O());
      _$this = temp$_$this;
      z = temp$z
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce(suffix.apply__O());
    return this$1.from__sc_IterableOnce__sci_Stream(source)
  } else {
    var hd = this.head__O();
    var tl = new $c_sjsr_AnonFunction0(((this$2, suffix$1) => (() => $as_sci_Stream(this$2.tail__O()).lazyAppendedAll__F0__sci_Stream(suffix$1)))(this, suffix));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft")
  } else {
    var reducedRes = this.head__O();
    var left = $as_sci_Stream(this.tail__O());
    while ((!left.isEmpty__Z())) {
      reducedRes = f.apply__O__O__O(reducedRes, left.head__O());
      left = $as_sci_Stream(left.tail__O())
    };
    return reducedRes
  }
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var hd = f.apply__O__O(this.head__O());
    var tl = new $c_sjsr_AnonFunction0(((this$2, f$1) => (() => $as_sci_Stream(this$2.tail__O()).map__F1__sci_Stream(f$1)))(this, f));
    return new $c_sci_Stream$Cons(hd, tl)
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$()
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = $as_sc_IterableOnce(f.apply__O__O($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).head__O()));
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!$as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z()) && prefix.isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = $as_sci_Stream($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).tail__O());
      if ((!$as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = $as_sc_IterableOnce(f.apply__O__O($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).head__O()));
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1)
      }
    };
    return ($as_sci_Stream(nonEmptyPrefix.sr_ObjectRef__f_elem).isEmpty__Z() ? $m_sci_Stream$Empty$() : prefix.lazyAppendedAll__F0__sci_Stream(new $c_sjsr_AnonFunction0(((nonEmptyPrefix$1, f$1) => (() => $as_sci_Stream($as_sci_Stream(nonEmptyPrefix$1.sr_ObjectRef__f_elem).tail__O()).flatMap__F1__sci_Stream(f$1)))(nonEmptyPrefix, f))))
  }
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f)
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$()
});
function $as_sci_Stream(obj) {
  return (((obj instanceof $c_sci_Stream) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Stream"))
}
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)))
}
function $asArrayOf_sci_Stream(obj, depth) {
  return (($isArrayOf_sci_Stream(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Stream;", depth))
}
/** @constructor */
function $c_sci_WrappedString(self) {
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = null;
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = self
}
$c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$c_sci_WrappedString.prototype.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
  /*<skip>*/
}
$h_sci_WrappedString.prototype = $c_sci_WrappedString.prototype;
$c_sci_WrappedString.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_WrappedString.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_WrappedString.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sci_WrappedString.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_WrappedString.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sci_WrappedString.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sci_WrappedString.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sci_WrappedString.prototype.head__O = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(0))))
});
$c_sci_WrappedString.prototype.lengthCompare__I__I = (function(len) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  var x = $uI(this$1.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_WrappedString.prototype.knownSize__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $uI(this$1.length)
});
$c_sci_WrappedString.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_WrappedString$().newBuilder__scm_Builder()
});
$c_sci_WrappedString.prototype.length__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $uI(this$1.length)
});
$c_sci_WrappedString.prototype.toString__T = (function() {
  return this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self
});
$c_sci_WrappedString.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var x2 = $asArrayOf_C(xs, 1);
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var srcLen = $uI(this$1.length);
    var destLen = x2.u.length;
    var x = ((len < srcLen) ? len : srcLen);
    var y = ((destLen - start) | 0);
    var x$1 = ((x < y) ? x : y);
    var copied = ((x$1 > 0) ? x$1 : 0);
    $f_T__getChars__I__I__AC__I__V(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self, 0, copied, x2, start);
    return copied
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
  }
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__sci_IndexedSeq = (function(suffix) {
  if ((suffix instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(suffix);
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var s = x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    return new $c_sci_WrappedString((("" + this$1) + s))
  } else {
    return $as_sci_IndexedSeq($f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_WrappedString.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  if ((o instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(o);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
  }
});
$c_sci_WrappedString.prototype.className__T = (function() {
  return "WrappedString"
});
$c_sci_WrappedString.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_WrappedString.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(other);
    return (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self)
  } else {
    return $f_sc_Seq__equals__O__Z(this, other)
  }
});
$c_sci_WrappedString.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$()
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_IndexedSeq(suffix)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll)
});
$c_sci_WrappedString.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
$c_sci_WrappedString.prototype.apply__I__O = (function(i) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC((65535 & $uI(this$1.charCodeAt(i))))
});
function $as_sci_WrappedString(obj) {
  return (((obj instanceof $c_sci_WrappedString) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.WrappedString"))
}
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)))
}
function $asArrayOf_sci_WrappedString(obj, depth) {
  return (($isArrayOf_sci_WrappedString(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.WrappedString;", depth))
}
var $d_sci_WrappedString = new $TypeData().initClass({
  sci_WrappedString: 0
}, false, "scala.collection.immutable.WrappedString", {
  sci_WrappedString: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_WrappedString.prototype.$classData = $d_sci_WrappedString;
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz
}
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null
}
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
  /*<skip>*/
}
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sjsr_WrappedVarArgs.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o)
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this)
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this)
});
$c_sjsr_WrappedVarArgs.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I()
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from)
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1))
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this)
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k)
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1)
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder()
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this)
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f)
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p)
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op)
});
$c_sjsr_WrappedVarArgs.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op)
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len)
});
$c_sjsr_WrappedVarArgs.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord)
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end)
});
$c_sjsr_WrappedVarArgs.prototype.toList__sci_List = (function() {
  $m_sci_List$();
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this)
});
$c_sjsr_WrappedVarArgs.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this)
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return $uI(this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length)
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx]
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs"
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll)
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g)
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = $uI(x);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx)
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$()
});
function $as_sjsr_WrappedVarArgs(obj) {
  return (((obj instanceof $c_sjsr_WrappedVarArgs) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.runtime.WrappedVarArgs"))
}
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)))
}
function $asArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (($isArrayOf_sjsr_WrappedVarArgs(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.runtime.WrappedVarArgs;", depth))
}
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass({
  sjsr_WrappedVarArgs: 0
}, false, "scala.scalajs.runtime.WrappedVarArgs", {
  sjsr_WrappedVarArgs: 1,
  O: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_sjsr_WrappedVarArgs.prototype.$classData = $d_sjsr_WrappedVarArgs;
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_data_ChainInstances$$anon$1.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$1.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_ChainInstances$$anon$1.prototype = $c_Lcats_data_ChainInstances$$anon$1.prototype;
$c_Lcats_data_ChainInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O(this, fa, f, B)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(sa), f, evidence$5)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.unit__O = (function() {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton((void 0))
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_data_ChainInstances__loop$2__Lcats_Eval__F2__Lcats_data_Chain__Lcats_Eval(lb$2, f$2, fa$2)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil)
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var xs = fa.iterator__sc_Iterator();
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(xs);
    return $$x1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G)
  }
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.tailRecM__O__F1__Lcats_data_Chain = (function(a, f) {
  var elem$4 = $as_Lcats_data_Chain(f.apply__O__O(a));
  var this$1 = $m_s_package$().s_package$__f_Nil;
  return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$1$$_$go$2__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f, new $c_sci_$colon$colon(elem$4, this$1), $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil
  } else {
    var this$1 = $m_Lcats_data_Chain$();
    var result = this$1.Lcats_data_Chain$__f_nil;
    var iter = fa.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var this$2 = result;
      var arg1 = iter.next__O();
      var c = fb.map__F1__Lcats_data_Chain(new $c_sjsr_AnonFunction1(((f$23$2, a$2) => ((b) => f$23$2.apply__O__O__O(a$2, b)))(f, arg1)));
      result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c)
    };
    return result
  }
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$3, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_Lcats_data_Chain(fb$2);
      return this$3.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return fa$1.foldLeft__O__F2__O(b, f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), lb, f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return fa$1.map__F1__Lcats_data_Chain(f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O($as_Lcats_data_Chain(fa), f, evidence$1)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton(x)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_Chain(fa);
  return fa$1.flatMap__F1__Lcats_data_Chain(f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_Chain(a, f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain($as_Lcats_data_Chain(fa), $as_Lcats_data_Chain(fb), f)
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval($as_Lcats_data_Chain(fa), fb, f)
});
var $d_Lcats_data_ChainInstances$$anon$1 = new $TypeData().initClass({
  Lcats_data_ChainInstances$$anon$1: 0
}, false, "cats.data.ChainInstances$$anon$1", {
  Lcats_data_ChainInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_data_ChainInstances$$anon$1.prototype.$classData = $d_Lcats_data_ChainInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_LazyListInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_LazyListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_LazyListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_LazyListInstances$$anon$1.prototype = $c_Lcats_instances_LazyListInstances$$anon$1.prototype;
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(sa), f, evidence$5)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_LazyList((void 0))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__sci_LazyList = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_LazyList;
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_LazyList(elems)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? $m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty : fa.flatMap__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((fb$2, f$2) => ((a) => fb$2.map__F1__sci_LazyList(new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a)))))(fb, f))))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty;
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$3, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_sci_LazyList(fb$2);
      return this$3.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2, lb$2, f$2) => ((s) => {
    var s$1 = $as_sci_LazyList(s);
    if (s$1.isEmpty__Z()) {
      return lb$2
    } else {
      var $$x1 = s$1.scala$collection$immutable$LazyList$$state__sci_LazyList$State().head__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0(((this$3, lb$1$2, f$4$2, s$2) => (() => this$3.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(s$2.scala$collection$immutable$LazyList$$state__sci_LazyList$State().tail__sci_LazyList(), lb$1$2, f$4$2)))(this$2, lb$2, f$2, s$1));
      return $as_Lcats_Eval(f$2.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
    }
  }))(this, lb, f)))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__sci_LazyList__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval(fa, $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((G$2) => (() => G$2.pure__O__O($m_s_package$().s_package$__f_LazyList.sci_LazyList$__f__empty)))(G))), new $c_sjsr_AnonFunction2(((f$2, G$3) => ((a, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return G$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$2.apply__O__O(a), lgsb$1, new $c_sjsr_AnonFunction2(((_$2, _$3) => {
      var _$3$1 = $as_sci_LazyList(_$3);
      $m_sci_LazyList$();
      var l = new $c_sjsr_AnonFunction0(((_$3$2) => (() => _$3$2))(_$3$1));
      return $m_sci_LazyList$Deferrer$().$hash$colon$colon$extension__F0__F0__sci_LazyList(l, new $c_sjsr_AnonFunction0(((_$2$2) => (() => _$2$2))(_$2)))
    })))
  }))(f, G))).value__O()
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__sci_LazyList = (function(a, fn) {
  $m_s_package$();
  $m_s_package$();
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_util_Left.getArrayOf().constr)([($m_s_package$(), new $c_s_util_Left(a))]));
  var init = xs.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1(((fn$2) => ((it) => {
    var it$1 = $as_sc_Iterator(it);
    if ((!it$1.hasNext__Z())) {
      return $m_s_None$()
    } else {
      var x1 = $as_s_util_Either(it$1.next__O());
      if ((x1 instanceof $c_s_util_Left)) {
        var a$1 = $as_s_util_Left(x1).s_util_Left__f_value;
        var _1 = $m_s_None$();
        var this$3 = $as_sci_LazyList(fn$2.apply__O__O(a$1)).iterator__sc_Iterator();
        var xs$1 = new $c_sjsr_AnonFunction0(((it$2) => (() => it$2))(it$1));
        var _2 = this$3.concat__F0__sc_Iterator(xs$1);
        var value = new $c_T2(_1, _2);
        return new $c_s_Some(value)
      };
      if ((x1 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x1).s_util_Right__f_value;
        var _1$1 = new $c_s_Some(b);
        var value$1 = new $c_T2(_1$1, it$1);
        return new $c_s_Some(value$1)
      };
      throw new $c_s_MatchError(x1)
    }
  }))(fn));
  var kernel = new $c_sc_Iterator$UnfoldIterator(init, f);
  var $$x1 = $m_s_package$().s_package$__f_LazyList;
  var pf = new $c_Lcats_instances_LazyListInstances$$anon$5();
  return $$x1.from__sc_IterableOnce__sci_LazyList(new $c_sc_Iterator$$anon$7(kernel, pf))
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_LazyList(x)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return fa$1.map__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return fa$1.flatMap__F1__sci_LazyList(f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_LazyList__sci_LazyList__F2__sci_LazyList($as_sci_LazyList(fa), $as_sci_LazyList(fb), f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), fb, f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_LazyList(fa);
  return fa$1.foldLeft__O__F2__O(b, f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_LazyList__Lcats_Eval__F2__Lcats_Eval($as_sci_LazyList(fa), lb, f)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_LazyList__F1__Lcats_kernel_Monoid__O($as_sci_LazyList(fa), f, B)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_LazyList__F1__Lcats_Applicative__O($as_sci_LazyList(fa), f, evidence$1)
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_LazyList(a, f)
});
var $d_Lcats_instances_LazyListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_LazyListInstances$$anon$1: 0
}, false, "cats.instances.LazyListInstances$$anon$1", {
  Lcats_instances_LazyListInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_LazyListInstances$$anon$1.prototype.$classData = $d_Lcats_instances_LazyListInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_ListInstances$$anon$1() {
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = null;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = null;
  $m_Lcats_Eval$();
  var a = $m_s_package$().s_package$__f_Nil;
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = new $c_Lcats_Now(a);
  var this$3 = $m_s_package$().s_package$__f_Nil;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = new $c_sci_$colon$colon((void 0), this$3)
}
$c_Lcats_instances_ListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_ListInstances$$anon$1.prototype = $c_Lcats_instances_ListInstances$$anon$1.prototype;
$c_Lcats_instances_ListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(sa), f, evidence$5)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__sci_List__sci_List__F2__sci_List = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_s_package$().s_package$__f_Nil
  } else {
    var rest = fa;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var arg1 = rest.head__O();
      var f$1 = ((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f, arg1);
      if ((fb === $m_sci_Nil$())) {
        var $$x1 = $m_sci_Nil$()
      } else {
        var arg1$1 = fb.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(arg1$1), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = $as_sci_List(fb.tail__O());
        while ((rest$1 !== $m_sci_Nil$())) {
          var arg1$2 = rest$1.head__O();
          var nx = new $c_sci_$colon$colon(f$1(arg1$2), $m_sci_Nil$());
          t$1.sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest$1 = $as_sci_List(rest$1.tail__O())
        };
        var $$x1 = h$1
      };
      var it = $$x1.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1
        } else {
          t.sci_$colon$colon__f_next = nx$1
        };
        t = nx$1
      };
      rest = $as_sci_List(rest.tail__O())
    };
    return ((h === null) ? $m_sci_Nil$() : h)
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return (fa.isEmpty__Z() ? this.Lcats_instances_ListInstances$$anon$1__f_evalNil : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2) => ((fb$2) => {
    var fb$1 = $as_sci_List(fb$2);
    return this$1.map2__sci_List__sci_List__F2__sci_List(fa$2, fb$1, f$2)
  }))(this, fa, f))))
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__sci_List = (function(a, f) {
  $m_s_package$();
  var buf = new $c_scm_ListBuffer();
  var elem$2 = $as_sci_List(f.apply__O__O(a));
  var this$2 = $m_s_package$().s_package$__f_Nil;
  $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__F1__scm_Builder__sci_List__V(f, buf, new $c_sci_$colon$colon(elem$2, this$2));
  return buf.toList__sci_List()
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_ListInstances__loop$3__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$2, f$2, fa$2)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__sci_List__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f))
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_s_package$().s_package$__f_Nil)
  } else {
    var $$x1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($$x1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1(((_$3) => {
      var _$3$1 = $as_Lcats_data_Chain(_$3);
      return _$3$1.toList__sci_List()
    })))
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse___sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var len = fa.length__I();
  return ((len === 0) ? G.unit__O() : $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$4__F1__Lcats_Applicative__I__sci_List__Lcats_Eval(f, G, len, fa).value__O())
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__sci_List__sci_List = (function(fa) {
  return (fa.isEmpty__Z() ? $m_s_package$().s_package$__f_Nil : $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List($as_sci_List(fa.tail__O()), this.Lcats_instances_ListInstances$$anon$1__f__unit))
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_Nil;
  return new $c_sci_$colon$colon(x, this$1)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return fa$1.map__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_List(fa);
  return fa$1.flatMap__F1__sci_List(f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_List__sci_List__F2__sci_List($as_sci_List(fa), $as_sci_List(fb), f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), fb, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_List(a, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_List(fa);
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(fa$1, b, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval($as_sci_List(fa), lb, f)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_List__F1__Lcats_kernel_Monoid__O($as_sci_List(fa), f, B)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, evidence$1)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverse___sci_List__F1__Lcats_Applicative__O($as_sci_List(fa), f, G)
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_ListInstances$$anon$1__f__unit
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__sci_List__sci_List($as_sci_List(fa))
});
var $d_Lcats_instances_ListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_ListInstances$$anon$1: 0
}, false, "cats.instances.ListInstances$$anon$1", {
  Lcats_instances_ListInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.$classData = $d_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_StreamInstances$$anon$1() {
  /*<skip>*/
}
$c_Lcats_instances_StreamInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_StreamInstances$$anon$1.prototype.constructor = $c_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_StreamInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_StreamInstances$$anon$1.prototype = $c_Lcats_instances_StreamInstances$$anon$1.prototype;
$c_Lcats_instances_StreamInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(sa), f, evidence$5)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Stream((void 0))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__sci_Stream = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_Stream;
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Stream(elems)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__sci_Stream__sci_Stream__F2__sci_Stream = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? ($m_s_package$(), $m_sci_Stream$Empty$()) : fa.flatMap__F1__sci_Stream(new $c_sjsr_AnonFunction1(((fb$2, f$2) => ((a) => fb$2.map__F1__sci_Stream(new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b) => f$1$2.apply__O__O__O(a$2, b)))(f$2, a)))))(fb, f))))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    $m_s_package$();
    var a = $m_sci_Stream$Empty$();
    return new $c_Lcats_Now(a)
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$4, fa$2, f$2) => ((fb$2) => {
      var fb$1 = $as_sci_Stream(fb$2);
      return this$4.map2__sci_Stream__sci_Stream__F2__sci_Stream(fa$2, fb$1, f$2)
    }))(this, fa, f)))
  }
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return new $c_Lcats_Now(fa).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$2, lb$2, f$2) => ((s) => {
    var s$1 = $as_sci_Stream(s);
    if (s$1.isEmpty__Z()) {
      return lb$2
    } else {
      var $$x1 = s$1.head__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0(((this$3, lb$1$2, f$4$2, s$2) => (() => this$3.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(s$2.tail__sci_Stream(), lb$1$2, f$4$2)))(this$2, lb$2, f$2, s$1));
      return $as_Lcats_Eval(f$2.apply__O__O__O($$x1, new $c_Lcats_Eval$$anon$5(a)))
    }
  }))(this, lb, f)))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = $f_sc_LinearSeqOps__iterator__sc_Iterator(fa);
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__sci_Stream__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval(fa, $m_Lcats_Always$().apply__F0__Lcats_Always(new $c_sjsr_AnonFunction0(((G$2) => (() => G$2.pure__O__O(($m_s_package$(), $m_sci_Stream$Empty$()))))(G))), new $c_sjsr_AnonFunction2(((f$2, G$3) => ((a, lgsb) => {
    var lgsb$1 = $as_Lcats_Eval(lgsb);
    return G$3.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$2.apply__O__O(a), lgsb$1, new $c_sjsr_AnonFunction2(((_$2, _$3) => {
      var _$3$1 = $as_sci_Stream(_$3);
      var l = new $c_sjsr_AnonFunction0(((_$3$2) => (() => _$3$2))(_$3$1));
      return new $c_sci_Stream$Cons(_$2, l)
    })))
  }))(f, G))).value__O()
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__sci_Stream = (function(a, fn) {
  var it = new $c_Lcats_instances_StreamInstances$$anon$4(a, fn);
  var factory = $m_sci_Stream$();
  var factory$1 = new $c_sc_IterableFactory$ToFactory(factory);
  return $as_sci_Stream(factory$1.fromSpecific__sc_IterableOnce__O(it))
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Stream(x)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return fa$1.map__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Stream(fa);
  return fa$1.flatMap__F1__sci_Stream(f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Stream__sci_Stream__F2__sci_Stream($as_sci_Stream(fa), $as_sci_Stream(fb), f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), fb, f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_Stream(fa);
  return fa$1.foldLeft__O__F2__O(b, f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Stream__Lcats_Eval__F2__Lcats_Eval($as_sci_Stream(fa), lb, f)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Stream__F1__Lcats_kernel_Monoid__O($as_sci_Stream(fa), f, B)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Stream__F1__Lcats_Applicative__O($as_sci_Stream(fa), f, evidence$1)
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Stream(a, f)
});
var $d_Lcats_instances_StreamInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_StreamInstances$$anon$1: 0
}, false, "cats.instances.StreamInstances$$anon$1", {
  Lcats_instances_StreamInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_StreamInstances$$anon$1.prototype.$classData = $d_Lcats_instances_StreamInstances$$anon$1;
/** @constructor */
function $c_Lcats_instances_VectorInstances$$anon$1() {
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  $m_s_package$();
  var a = $m_sci_Vector0$();
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a)
}
$c_Lcats_instances_VectorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_VectorInstances$$anon$1.prototype = $c_Lcats_instances_VectorInstances$$anon$1.prototype;
$c_Lcats_instances_VectorInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(sa), f, evidence$5)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Vector((void 0))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__sci_Vector = (function(x) {
  var this$1 = $m_s_package$().s_package$__f_Vector;
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Vector(elems)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__sci_Vector__sci_Vector__F2__sci_Vector = (function(fa, fb, f) {
  if ($f_sc_SeqOps__isEmpty__Z(fb)) {
    $m_s_package$();
    return $m_sci_Vector0$()
  } else {
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = fa.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var arg1 = it.next__O();
      var f$1 = new $c_sjsr_AnonFunction1(((f$1$2, a$2) => ((b$1) => f$1$2.apply__O__O__O(a$2, b$1)))(f, arg1));
      var xs = fb.map__F1__sci_Vector(f$1);
      b.addAll__sc_IterableOnce__sci_VectorBuilder(xs)
    };
    return b.result__sci_Vector()
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($f_sc_SeqOps__isEmpty__Z(fa) ? this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((this$1, fa$2, f$2) => ((fb$2) => {
    var fb$1 = $as_sci_Vector(fb$2);
    return this$1.map2__sci_Vector__sci_Vector__F2__sci_Vector(fa$2, fb$1, f$2)
  }))(this, fa, f))))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0(((fa$2, lb$2, f$2) => (() => $ps_Lcats_instances_VectorInstances__loop$3__sci_Vector__Lcats_Eval__F2__I__Lcats_Eval(fa$2, lb$2, f$2, 0)))(fa, lb, f));
  return new $c_Lcats_Eval$$anon$5(a)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__sci_Vector = (function(a, fn) {
  $m_s_package$();
  var buf = new $c_sci_VectorBuilder();
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sc_Iterator.getArrayOf().constr)([$as_sci_Vector(fn.apply__O__O(a)).iterator__sc_Iterator()]));
  var elem = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    matchResult3: {
      var x11 = $as_sci_List(elem$1);
      var x = $m_s_package$().s_package$__f_Nil;
      if (((x === null) ? (x11 === null) : x.equals__O__Z(x11))) {
        break matchResult3
      };
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x15 = $as_sci_$colon$colon(x11);
        var x16 = $as_sc_Iterator(x15.sci_$colon$colon__f_head);
        var x17 = x15.sci_$colon$colon__f_next;
        if ((!x16.hasNext__Z())) {
          elem$1 = x17;
          continue
        };
        var x6 = $as_s_util_Either(x16.next__O());
        if ((x6 instanceof $c_s_util_Right)) {
          var b = $as_s_util_Right(x6).s_util_Right__f_value;
          buf.addOne__O__sci_VectorBuilder(b);
          continue
        };
        if ((x6 instanceof $c_s_util_Left)) {
          var a$1 = $as_s_util_Left(x6).s_util_Left__f_value;
          var elem$1$1 = $as_sci_Vector(fn.apply__O__O(a$1)).iterator__sc_Iterator();
          var this$4 = new $c_sci_$colon$colon(x16, x17);
          var ev$2 = new $c_sci_$colon$colon(elem$1$1, this$4);
          elem$1 = ev$2;
          continue
        };
        throw new $c_s_MatchError(x6);
        break matchResult3
      };
      throw new $c_s_MatchError(x11)
    };
    break
  };
  return buf.result__sci_Vector()
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return G.map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa, f, G), new $c_sjsr_AnonFunction1(((_$3) => {
    var _$3$1 = $as_Lcats_data_Chain(_$3);
    return _$3$1.toVector__sci_Vector()
  })))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse___sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var len = fa.length__I();
  return ((len === 0) ? G.unit__O() : $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$4__sci_Vector__F1__Lcats_Applicative__I__I__Lcats_Eval(fa, f, G, len, 0).value__O())
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Vector(x)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return fa$1.map__F1__sci_Vector(f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $as_sci_Vector($f_sc_StrictOptimizedIterableOps__flatMap__F1__O(fa$1, f))
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Vector__sci_Vector__F2__sci_Vector($as_sci_Vector(fa), $as_sci_Vector(fb), f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), fb, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_sci_Vector(fa);
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(fa$1, b, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval($as_sci_Vector(fa), lb, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O($as_sci_Vector(fa), f, B)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Vector(a, f)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, evidence$1)
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverse___sci_Vector__F1__Lcats_Applicative__O($as_sci_Vector(fa), f, G)
});
var $d_Lcats_instances_VectorInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_VectorInstances$$anon$1: 0
}, false, "cats.instances.VectorInstances$$anon$1", {
  Lcats_instances_VectorInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.$classData = $d_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $c_Lfs2_Chunk$$anon$3() {
  /*<skip>*/
}
$c_Lfs2_Chunk$$anon$3.prototype = new $h_O();
$c_Lfs2_Chunk$$anon$3.prototype.constructor = $c_Lfs2_Chunk$$anon$3;
/** @constructor */
function $h_Lfs2_Chunk$$anon$3() {
  /*<skip>*/
}
$h_Lfs2_Chunk$$anon$3.prototype = $c_Lfs2_Chunk$$anon$3.prototype;
$c_Lfs2_Chunk$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lfs2_Chunk$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lfs2_Chunk$$anon$3.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O(this, fa, f, B)
});
$c_Lfs2_Chunk$$anon$3.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lfs2_Chunk$$anon$3.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  var fa = $as_Lfs2_Chunk(sa);
  return fa.traverse__F1__Lcats_Applicative__O(f, evidence$5)
});
$c_Lfs2_Chunk$$anon$3.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lfs2_Chunk$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lfs2_Chunk$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lfs2_Chunk$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lfs2_Chunk$$anon$3.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lfs2_Chunk$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lfs2_Chunk$$anon$3.prototype.unit__O = (function() {
  $m_Lfs2_Chunk$();
  return new $c_Lfs2_Chunk$Singleton((void 0))
});
$c_Lfs2_Chunk$$anon$3.prototype.tailRecM__O__F1__Lfs2_Chunk = (function(a, f) {
  $m_s_reflect_ManifestFactory$AnyManifest$();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  $m_s_package$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sc_Iterator.getArrayOf().constr)([$as_Lfs2_Chunk(f.apply__O__O(a)).iterator__sc_Iterator()]));
  var elem = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    matchResult29: {
      var x65 = $as_sci_List(elem$1);
      var x = $m_s_package$().s_package$__f_Nil;
      if (((x === null) ? (x65 === null) : x.equals__O__Z(x65))) {
        break matchResult29
      };
      if ((x65 instanceof $c_sci_$colon$colon)) {
        var x69 = $as_sci_$colon$colon(x65);
        var x70 = $as_sc_Iterator(x69.sci_$colon$colon__f_head);
        var x71 = x69.sci_$colon$colon__f_next;
        if ((!x70.hasNext__Z())) {
          elem$1 = x71;
          continue
        };
        var x60 = $as_s_util_Either(x70.next__O());
        if ((x60 instanceof $c_s_util_Right)) {
          var b = $as_s_util_Right(x60).s_util_Right__f_value;
          var unboxedElem = ((b === null) ? null : b);
          jsElems.push(unboxedElem);
          continue
        };
        if ((x60 instanceof $c_s_util_Left)) {
          var a$1 = $as_s_util_Left(x60).s_util_Left__f_value;
          var elem$3 = $as_Lfs2_Chunk(f.apply__O__O(a$1)).iterator__sc_Iterator();
          var this$8 = new $c_sci_$colon$colon(x70, x71);
          var ev$22 = new $c_sci_$colon$colon(elem$3, this$8);
          elem$1 = ev$22;
          continue
        };
        throw new $c_s_MatchError(x60);
        break matchResult29
      };
      throw new $c_s_MatchError(x65)
    };
    break
  };
  var this$11 = $m_Lfs2_Chunk$();
  var values = new $ac_O(jsElems);
  var evidence$2 = $m_s_reflect_ManifestFactory$AnyManifest$();
  var length = values.u.length;
  if ((length === 0)) {
    return this$11.Lfs2_Chunk$__f_empty_
  } else if ((length === 1)) {
    var o = values.get(0);
    return new $c_Lfs2_Chunk$Singleton(o)
  } else {
    return new $c_Lfs2_Chunk$ArraySlice(values, 0, length, evidence$2)
  }
});
$c_Lfs2_Chunk$$anon$3.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_Lfs2_Chunk(fa);
  return fa$1.foldLeft__O__F2__O(b, f)
});
$c_Lfs2_Chunk$$anon$3.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_Lfs2_Chunk(fa);
  return $s_Lfs2_Chunk$__fs2$Chunk$$anon$3$$_$go$1__Lfs2_Chunk__Lcats_Eval__F2__I__Lcats_Eval(fa$1, lb, f, 0)
});
$c_Lfs2_Chunk$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lfs2_Chunk$();
  return new $c_Lfs2_Chunk$Singleton(x)
});
$c_Lfs2_Chunk$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lfs2_Chunk(fa);
  return fa$1.map__F1__Lfs2_Chunk(f)
});
$c_Lfs2_Chunk$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lfs2_Chunk(fa);
  return fa$1.flatMap__F1__Lfs2_Chunk(f)
});
$c_Lfs2_Chunk$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lfs2_Chunk(a, f)
});
$c_Lfs2_Chunk$$anon$3.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var fa$1 = $as_Lfs2_Chunk(fa);
  return fa$1.traverse__F1__Lcats_Applicative__O(f, evidence$1)
});
var $d_Lfs2_Chunk$$anon$3 = new $TypeData().initClass({
  Lfs2_Chunk$$anon$3: 0
}, false, "fs2.Chunk$$anon$3", {
  Lfs2_Chunk$$anon$3: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
});
$c_Lfs2_Chunk$$anon$3.prototype.$classData = $d_Lfs2_Chunk$$anon$3;
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode
}
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
  /*<skip>*/
}
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, false)
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$()
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.size__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return (this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size === 0)
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapValueIterator(this.sci_HashMap__f_rootNode))
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0)
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1)
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode))
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreach__F1__V(f)
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreachEntry__F2__V(f)
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(that);
    if ((this === x2)) {
      return true
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = x2.sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that)
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap"
});
$c_sci_HashMap.prototype.filterImpl__F1__Z__sci_HashMap = (function(pred, isFlipped) {
  var newRootNode = this.sci_HashMap__f_rootNode.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashMap__f_rootNode)) {
    return this
  } else if ((newRootNode.sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap
  } else {
    return new $c_sci_HashMap(newRootNode)
  }
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $as_sci_HashMap($f_sc_IterableOps__drop__I__O(this, n))
});
$c_sci_HashMap.prototype.head__O = (function() {
  return $as_T2(this.iterator__sc_Iterator().next__O())
});
$c_sci_HashMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_HashMap(key)
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value)
});
function $as_sci_HashMap(obj) {
  return (((obj instanceof $c_sci_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.HashMap"))
}
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)))
}
function $asArrayOf_sci_HashMap(obj, depth) {
  return (($isArrayOf_sci_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.HashMap;", depth))
}
var $d_sci_HashMap = new $TypeData().initClass({
  sci_HashMap: 0
}, false, "scala.collection.immutable.HashMap", {
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_HashMap.prototype.$classData = $d_sci_HashMap;
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl
}
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
  /*<skip>*/
}
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null)
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = $as_sci_Stream(this.sci_Stream$Cons__f_tlGen.apply__O());
      this.sci_Stream$Cons__f_tlGen = null
    }
  };
  return this.sci_Stream$Cons__f_tlVal
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    these = $as_sci_Stream(these.tail__O())
  };
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream(these.tail__O());
    if (these.isEmpty__Z()) {
      return this
    };
    these = $as_sci_Stream(these.tail__O());
    if ((these === those)) {
      return this
    };
    those = $as_sci_Stream(those.tail__O())
  };
  return this
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons()
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
var $d_sci_Stream$Cons = new $TypeData().initClass({
  sci_Stream$Cons: 0
}, false, "scala.collection.immutable.Stream$Cons", {
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Cons.prototype.$classData = $d_sci_Stream$Cons;
/** @constructor */
function $c_sci_Stream$Empty$() {
  /*<skip>*/
}
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
  /*<skip>*/
}
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream")
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream")
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream()
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass({
  sci_Stream$Empty$: 0
}, false, "scala.collection.immutable.Stream$Empty$", {
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Stream$Empty$.prototype.$classData = $d_sci_Stream$Empty$;
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$()
  };
  return $n_sci_Stream$Empty$
}
/** @constructor */
function $c_scm_AbstractBuffer() {
  /*<skip>*/
}
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
  /*<skip>*/
}
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
/** @constructor */
function $c_scm_AbstractMap() {
  /*<skip>*/
}
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
  /*<skip>*/
}
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$()
});
$c_scm_AbstractMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value)
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1)
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$()
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this
});
function $f_Lcats_effect_kernel_Async__async__F1__O($thiz, k) {
  var body = new $c_Lcats_effect_kernel_Async$$anon$1(k);
  return $thiz.cont__Lcats_effect_kernel_Cont__O(body)
}
function $f_Lcats_effect_kernel_Async__async___F1__O($thiz, k) {
  return $thiz.async__F1__O(new $c_sjsr_AnonFunction1(((this$1, k$2) => ((cb) => {
    var cb$1 = $as_F1(cb);
    return this$1.as__O__O__O(this$1.delay__F0__O(new $c_sjsr_AnonFunction0(((k$2$2, cb$2) => (() => {
      k$2$2.apply__O__O(cb$2)
    }))(k$2, cb$1))), $m_s_None$())
  }))($thiz, k)))
}
function $f_Lcats_effect_kernel_Async__never__O($thiz) {
  return $thiz.async__F1__O(new $c_sjsr_AnonFunction1(((this$1) => ((_$3) => {
    $as_F1(_$3);
    return this$1.pure__O__O(($m_Lcats_implicits$(), $m_s_None$()))
  }))($thiz)))
}
function $is_Lcats_effect_kernel_Async(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_effect_kernel_Async)))
}
function $as_Lcats_effect_kernel_Async(obj) {
  return (($is_Lcats_effect_kernel_Async(obj) || (obj === null)) ? obj : $throwClassCastException(obj, "cats.effect.kernel.Async"))
}
function $isArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Async)))
}
function $asArrayOf_Lcats_effect_kernel_Async(obj, depth) {
  return (($isArrayOf_Lcats_effect_kernel_Async(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lcats.effect.kernel.Async;", depth))
}
/** @constructor */
function $c_sci_LongMap$Bin(prefix, mask, left, right) {
  this.sci_LongMap$Bin__f_prefix = $L0;
  this.sci_LongMap$Bin__f_mask = $L0;
  this.sci_LongMap$Bin__f_left = null;
  this.sci_LongMap$Bin__f_right = null;
  this.sci_LongMap$Bin__f_prefix = prefix;
  this.sci_LongMap$Bin__f_mask = mask;
  this.sci_LongMap$Bin__f_left = left;
  this.sci_LongMap$Bin__f_right = right
}
$c_sci_LongMap$Bin.prototype = new $h_sci_LongMap();
$c_sci_LongMap$Bin.prototype.constructor = $c_sci_LongMap$Bin;
/** @constructor */
function $h_sci_LongMap$Bin() {
  /*<skip>*/
}
$h_sci_LongMap$Bin.prototype = $c_sci_LongMap$Bin.prototype;
$c_sci_LongMap$Bin.prototype.productPrefix__T = (function() {
  return "Bin"
});
$c_sci_LongMap$Bin.prototype.productArity__I = (function() {
  return 4
});
$c_sci_LongMap$Bin.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_LongMap$Bin__f_prefix;
      break
    }
    case 1: {
      return this.sci_LongMap$Bin__f_mask;
      break
    }
    case 2: {
      return this.sci_LongMap$Bin__f_left;
      break
    }
    case 3: {
      return this.sci_LongMap$Bin__f_right;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_sci_LongMap$Bin.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_sci_LongMap$Bin(obj) {
  return (((obj instanceof $c_sci_LongMap$Bin) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LongMap$Bin"))
}
function $isArrayOf_sci_LongMap$Bin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LongMap$Bin)))
}
function $asArrayOf_sci_LongMap$Bin(obj, depth) {
  return (($isArrayOf_sci_LongMap$Bin(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LongMap$Bin;", depth))
}
var $d_sci_LongMap$Bin = new $TypeData().initClass({
  sci_LongMap$Bin: 0
}, false, "scala.collection.immutable.LongMap$Bin", {
  sci_LongMap$Bin: 1,
  sci_LongMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_LongMap$Bin.prototype.$classData = $d_sci_LongMap$Bin;
/** @constructor */
function $c_sci_LongMap$Nil$() {
  /*<skip>*/
}
$c_sci_LongMap$Nil$.prototype = new $h_sci_LongMap();
$c_sci_LongMap$Nil$.prototype.constructor = $c_sci_LongMap$Nil$;
/** @constructor */
function $h_sci_LongMap$Nil$() {
  /*<skip>*/
}
$h_sci_LongMap$Nil$.prototype = $c_sci_LongMap$Nil$.prototype;
$c_sci_LongMap$Nil$.prototype.equals__O__Z = (function(that) {
  return ((that === this) || ((!(that instanceof $c_sci_LongMap)) && $f_sc_Map__equals__O__Z(this, that)))
});
$c_sci_LongMap$Nil$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_sci_LongMap$Nil$.prototype.productArity__I = (function() {
  return 0
});
$c_sci_LongMap$Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sci_LongMap$Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
var $d_sci_LongMap$Nil$ = new $TypeData().initClass({
  sci_LongMap$Nil$: 0
}, false, "scala.collection.immutable.LongMap$Nil$", {
  sci_LongMap$Nil$: 1,
  sci_LongMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_LongMap$Nil$.prototype.$classData = $d_sci_LongMap$Nil$;
var $n_sci_LongMap$Nil$;
function $m_sci_LongMap$Nil$() {
  if ((!$n_sci_LongMap$Nil$)) {
    $n_sci_LongMap$Nil$ = new $c_sci_LongMap$Nil$()
  };
  return $n_sci_LongMap$Nil$
}
/** @constructor */
function $c_sci_LongMap$Tip(key, value) {
  this.sci_LongMap$Tip__f_key = $L0;
  this.sci_LongMap$Tip__f_value = null;
  this.sci_LongMap$Tip__f_key = key;
  this.sci_LongMap$Tip__f_value = value
}
$c_sci_LongMap$Tip.prototype = new $h_sci_LongMap();
$c_sci_LongMap$Tip.prototype.constructor = $c_sci_LongMap$Tip;
/** @constructor */
function $h_sci_LongMap$Tip() {
  /*<skip>*/
}
$h_sci_LongMap$Tip.prototype = $c_sci_LongMap$Tip.prototype;
$c_sci_LongMap$Tip.prototype.productPrefix__T = (function() {
  return "Tip"
});
$c_sci_LongMap$Tip.prototype.productArity__I = (function() {
  return 2
});
$c_sci_LongMap$Tip.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_LongMap$Tip__f_key;
      break
    }
    case 1: {
      return this.sci_LongMap$Tip__f_value;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_sci_LongMap$Tip.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
function $as_sci_LongMap$Tip(obj) {
  return (((obj instanceof $c_sci_LongMap$Tip) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.LongMap$Tip"))
}
function $isArrayOf_sci_LongMap$Tip(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LongMap$Tip)))
}
function $asArrayOf_sci_LongMap$Tip(obj, depth) {
  return (($isArrayOf_sci_LongMap$Tip(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.LongMap$Tip;", depth))
}
var $d_sci_LongMap$Tip = new $TypeData().initClass({
  sci_LongMap$Tip: 0
}, false, "scala.collection.immutable.LongMap$Tip", {
  sci_LongMap$Tip: 1,
  sci_LongMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_LongMap$Tip.prototype.$classData = $d_sci_LongMap$Tip;
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(idx);
  if ((x1 === null)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(idx, new $c_scm_HashSet$Node(elem, hash, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashSet$Node__f__hash <= hash))) {
      if (((n.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, n.scm_HashSet$Node__f__key))) {
        return false
      };
      prev = n;
      n = n.scm_HashSet$Node__f__next
    };
    if ((prev === null)) {
      $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(idx, new $c_scm_HashSet$Node(elem, hash, x1))
    } else {
      prev.scm_HashSet$Node__f__next = new $c_scm_HashSet$Node(elem, hash, prev.scm_HashSet$Node__f__next)
    }
  };
  $thiz.scm_HashSet__f_contentSize = ((1 + $thiz.scm_HashSet__f_contentSize) | 0);
  return true
}
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(idx);
  if ((x1 !== null)) {
    if (((x1.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_HashSet$Node__f__key, elem))) {
      $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(idx, x1.scm_HashSet$Node__f__next);
      $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
      return true
    } else {
      var prev = x1;
      var next = x1.scm_HashSet$Node__f__next;
      while (((next !== null) && (next.scm_HashSet$Node__f__hash <= hash))) {
        if (((next.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_HashSet$Node__f__key, elem))) {
          prev.scm_HashSet$Node__f__next = next.scm_HashSet$Node__f__next;
          $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
          return true
        };
        prev = next;
        next = next.scm_HashSet$Node__f__next
      };
      return false
    }
  } else {
    return false
  }
}
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashSet__f_contentSize === 0)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table;
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = $asArrayOf_scm_HashSet$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get(i);
        if ((old !== null)) {
          preLow.scm_HashSet$Node__f__next = null;
          preHigh.scm_HashSet$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashSet$Node__f__next;
            if (((n.scm_HashSet$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashSet$Node__f__next = n;
              lastLow = n
            } else {
              lastHigh.scm_HashSet$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          lastLow.scm_HashSet$Node__f__next = null;
          if ((old !== preLow.scm_HashSet$Node__f__next)) {
            $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(i, preLow.scm_HashSet$Node__f__next)
          };
          if ((preHigh.scm_HashSet$Node__f__next !== null)) {
            $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.set(((i + oldlen) | 0), preHigh.scm_HashSet$Node__f__next);
            lastHigh.scm_HashSet$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashSet__f_loadFactor))
}
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashSet__f_loadFactor = loadFactor;
  $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length);
  $thiz.scm_HashSet__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashSet() {
  this.scm_HashSet__f_loadFactor = 0.0;
  this.scm_HashSet__f_scala$collection$mutable$HashSet$$table = null;
  this.scm_HashSet__f_threshold = 0;
  this.scm_HashSet__f_contentSize = 0
}
$c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$c_scm_HashSet.prototype.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
  /*<skip>*/
}
$h_scm_HashSet.prototype = $c_scm_HashSet.prototype;
$c_scm_HashSet.prototype.size__I = (function() {
  return this.scm_HashSet__f_contentSize
});
$c_scm_HashSet.prototype.scala$collection$mutable$HashSet$$improveHash__I__I = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0))
});
$c_scm_HashSet.prototype.contains__O__Z = (function(elem) {
  var hash = this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem));
  var x1 = this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.get((hash & (((-1) + this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0)));
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashSet$Node(elem, hash)) !== null)
});
$c_scm_HashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashSet__f_loadFactor)));
  if ((target > this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length)) {
    $p_scm_HashSet__growTable__I__V(this, target)
  }
});
$c_scm_HashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_HashSet__f_contentSize) | 0) >= this.scm_HashSet__f_threshold)) {
    $p_scm_HashSet__growTable__I__V(this, (this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length << 1))
  };
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)))
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_HashSet = (function(xs) {
  this.sizeHint__I__V(xs.knownSize__I());
  if ((xs instanceof $c_sci_HashSet)) {
    var x2 = $as_sci_HashSet(xs);
    var f = new $c_sjsr_AnonFunction2(((this$1) => ((k$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashSet__addElem__O__I__Z(this$1, k$2, this$1.scala$collection$mutable$HashSet$$improveHash__I__I(h))
    }))(this));
    x2.sci_HashSet__f_rootNode.foreachWithHash__F2__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashSet)) {
    var x3 = $as_scm_HashSet(xs);
    var iter = new $c_scm_HashSet$$anon$2(x3);
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashSet$Node(iter.next__O());
      $p_scm_HashSet__addElem__O__I__Z(this, next.scm_HashSet$Node__f__key, next.scm_HashSet$Node__f__hash)
    };
    return this
  } else {
    return $as_scm_HashSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashSet.prototype.remove__O__Z = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)))
});
$c_scm_HashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_HashSet$$anon$1(this)
});
$c_scm_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$()
});
$c_scm_HashSet.prototype.knownSize__I = (function() {
  return this.scm_HashSet__f_contentSize
});
$c_scm_HashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_HashSet__f_contentSize === 0)
});
$c_scm_HashSet.prototype.className__T = (function() {
  return "HashSet"
});
$c_scm_HashSet.prototype.hashCode__I = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.hasNext__Z()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed)
});
$c_scm_HashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  this.remove__O__Z(elem);
  return this
});
$c_scm_HashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  this.add__O__Z(elem);
  return this
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashSet(xs)
});
function $as_scm_HashSet(obj) {
  return (((obj instanceof $c_scm_HashSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashSet"))
}
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet)))
}
function $asArrayOf_scm_HashSet(obj, depth) {
  return (($isArrayOf_scm_HashSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashSet;", depth))
}
var $d_scm_HashSet = new $TypeData().initClass({
  scm_HashSet: 0
}, false, "scala.collection.mutable.HashSet", {
  scm_HashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashSet.prototype.$classData = $d_scm_HashSet;
/** @constructor */
function $c_sjs_js_WrappedDictionary(dict) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = null;
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict = dict
}
$c_sjs_js_WrappedDictionary.prototype = new $h_scm_AbstractMap();
$c_sjs_js_WrappedDictionary.prototype.constructor = $c_sjs_js_WrappedDictionary;
/** @constructor */
function $h_sjs_js_WrappedDictionary() {
  /*<skip>*/
}
$h_sjs_js_WrappedDictionary.prototype = $c_sjs_js_WrappedDictionary.prototype;
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary = (function(coll) {
  var d = new $c_sjs_js_WrappedDictionary({});
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(d, coll);
  return d
});
$c_sjs_js_WrappedDictionary.prototype.get__T__s_Option = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return new $c_s_Some(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key])
  } else {
    return $m_s_None$()
  }
});
$c_sjs_js_WrappedDictionary.prototype.apply__T__O = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    return this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key))
  }
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__T__sjs_js_WrappedDictionary = (function(key) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  if ($uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key))) {
    delete this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key]
  };
  return this
});
$c_sjs_js_WrappedDictionary.prototype.update__T__O__V = (function(key, value) {
  this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict[key] = value
});
$c_sjs_js_WrappedDictionary.prototype.addOne__T2__sjs_js_WrappedDictionary = (function(kv) {
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  var key = $as_T(kv._1__O());
  var value = kv._2__O();
  dict[key] = value;
  return this
});
$c_sjs_js_WrappedDictionary.prototype.iterator__sc_Iterator = (function() {
  return new $c_sjs_js_WrappedDictionary$DictionaryIterator(this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict)
});
$c_sjs_js_WrappedDictionary.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sjs_js_WrappedDictionary($as_T2(elem))
});
$c_sjs_js_WrappedDictionary.prototype.update__O__O__V = (function(key, value) {
  this.update__T__O__V($as_T(key), value)
});
$c_sjs_js_WrappedDictionary.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__T__sjs_js_WrappedDictionary($as_T(elem))
});
$c_sjs_js_WrappedDictionary.prototype.contains__O__Z = (function(key) {
  var key$1 = $as_T(key);
  var dict = this.sjs_js_WrappedDictionary__f_scala$scalajs$js$WrappedDictionary$$dict;
  return $uZ($m_sjs_js_WrappedDictionary$Cache$().sjs_js_WrappedDictionary$Cache$__f_safeHasOwnProperty.call(dict, key$1))
});
$c_sjs_js_WrappedDictionary.prototype.apply__O__O = (function(key) {
  return this.apply__T__O($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.get__O__s_Option = (function(key) {
  return this.get__T__s_Option($as_T(key))
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
$c_sjs_js_WrappedDictionary.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sjs_js_WrappedDictionary(coll)
});
var $d_sjs_js_WrappedDictionary = new $TypeData().initClass({
  sjs_js_WrappedDictionary: 0
}, false, "scala.scalajs.js.WrappedDictionary", {
  sjs_js_WrappedDictionary: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1
});
$c_sjs_js_WrappedDictionary.prototype.$classData = $d_sjs_js_WrappedDictionary;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances$$anon$1() {
  this.Lcats_NonEmptyReducible__f_G = null;
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $as_Lcats_Traverse($m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList)))
}
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_data_NonEmptyListInstances$$anon$1.prototype = $c_Lcats_data_NonEmptyListInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.unit__O = (function() {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_s_package$().s_package$__f_Nil;
  return new $c_Lcats_data_NonEmptyList((void 0), tail)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  var fa = $as_Lcats_data_NonEmptyList(sa);
  return fa.traverse__F1__Lcats_Applicative__O(f, evidence$5)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.Lcats_data_NonEmptyList__f_tail;
  var elem = fa.Lcats_data_NonEmptyList__f_head;
  var this$2 = new $c_sci_$colon$colon(elem, this$1);
  var this$3 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$3, f))
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.tailRecM__O__F1__Lcats_data_NonEmptyList = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$1$$_$go$1__F1__scm_ListBuffer__Lcats_data_NonEmptyList__V(f, buf, $as_Lcats_data_NonEmptyList(f.apply__O__O(a)));
  return $m_Lcats_data_NonEmptyList$().fromListUnsafe__sci_List__Lcats_data_NonEmptyList(buf.toList__sci_List())
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.map__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_s_package$().s_package$__f_Nil;
  return new $c_Lcats_data_NonEmptyList(x, tail)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.flatMap__F1__Lcats_data_NonEmptyList(f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$3) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.traverse__F1__Lcats_Applicative__O(f, evidence$3)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.foldLeft__O__F2__O(b, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = $as_Lcats_data_NonEmptyList(fa);
  return fa$1.foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O($as_Lcats_data_NonEmptyList(fa), f, B)
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_NonEmptyList(a, f)
});
var $d_Lcats_data_NonEmptyListInstances$$anon$1 = new $TypeData().initClass({
  Lcats_data_NonEmptyListInstances$$anon$1: 0
}, false, "cats.data.NonEmptyListInstances$$anon$1", {
  Lcats_data_NonEmptyListInstances$$anon$1: 1,
  Lcats_NonEmptyReducible: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1,
  Lcats_SemigroupK: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
});
$c_Lcats_data_NonEmptyListInstances$$anon$1.prototype.$classData = $d_Lcats_data_NonEmptyListInstances$$anon$1;
function $as_sci_Range(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Range"))
}
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Range)))
}
function $asArrayOf_sci_Range(obj, depth) {
  return (($isArrayOf_sci_Range(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Range;", depth))
}
/** @constructor */
function $c_scm_Map$WithDefault(underlying, defaultValue) {
  this.scm_Map$WithDefault__f_underlying = null;
  this.scm_Map$WithDefault__f_defaultValue = null;
  this.scm_Map$WithDefault__f_underlying = underlying;
  this.scm_Map$WithDefault__f_defaultValue = defaultValue
}
$c_scm_Map$WithDefault.prototype = new $h_scm_AbstractMap();
$c_scm_Map$WithDefault.prototype.constructor = $c_scm_Map$WithDefault;
/** @constructor */
function $h_scm_Map$WithDefault() {
  /*<skip>*/
}
$h_scm_Map$WithDefault.prototype = $c_scm_Map$WithDefault.prototype;
$c_scm_Map$WithDefault.prototype.default__O__O = (function(key) {
  return this.scm_Map$WithDefault__f_defaultValue.apply__O__O(key)
});
$c_scm_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return this.scm_Map$WithDefault__f_underlying.iterator__sc_Iterator()
});
$c_scm_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return this.scm_Map$WithDefault__f_underlying.isEmpty__Z()
});
$c_scm_Map$WithDefault.prototype.knownSize__I = (function() {
  return this.scm_Map$WithDefault__f_underlying.knownSize__I()
});
$c_scm_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return this.scm_Map$WithDefault__f_underlying.mapFactory__sc_MapFactory()
});
$c_scm_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return this.scm_Map$WithDefault__f_underlying.get__O__s_Option(key)
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Map$WithDefault = (function(elem) {
  this.scm_Map$WithDefault__f_underlying.subtractOne__O__scm_Shrinkable(elem);
  return this
});
$c_scm_Map$WithDefault.prototype.addOne__T2__scm_Map$WithDefault = (function(elem) {
  this.scm_Map$WithDefault__f_underlying.addOne__O__scm_Growable(elem);
  return this
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__scm_Map$WithDefault = (function(coll) {
  return new $c_scm_Map$WithDefault($as_scm_Map(this.scm_Map$WithDefault__f_underlying.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(coll)), this.scm_Map$WithDefault__f_defaultValue)
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll)
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll)
});
$c_scm_Map$WithDefault.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_Map$WithDefault($as_T2(elem))
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Map$WithDefault(elem)
});
var $d_scm_Map$WithDefault = new $TypeData().initClass({
  scm_Map$WithDefault: 0
}, false, "scala.collection.mutable.Map$WithDefault", {
  scm_Map$WithDefault: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Map$WithDefault.prototype.$classData = $d_scm_Map$WithDefault;
/** @constructor */
function $c_Lcats_effect_IO$$anon$2() {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleOnce = null;
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleMany = null;
  this.Lcats_effect_IO$$anon$2__f_executionContext = null;
  this.Lcats_effect_IO$$anon$2__f_monotonic = null;
  this.Lcats_effect_IO$$anon$2__f_realTime = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_IO$$anon$2__f_executionContext = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$ReadEC$());
  this.Lcats_effect_IO$$anon$2__f_monotonic = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$Monotonic$());
  this.Lcats_effect_IO$$anon$2__f_realTime = ($m_Lcats_effect_IO$(), $m_Lcats_effect_IO$RealTime$())
}
$c_Lcats_effect_IO$$anon$2.prototype = new $h_O();
$c_Lcats_effect_IO$$anon$2.prototype.constructor = $c_Lcats_effect_IO$$anon$2;
/** @constructor */
function $h_Lcats_effect_IO$$anon$2() {
  /*<skip>*/
}
$h_Lcats_effect_IO$$anon$2.prototype = $c_Lcats_effect_IO$$anon$2.prototype;
$c_Lcats_effect_IO$$anon$2.prototype.unit__O = (function() {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Pure((void 0))
});
$c_Lcats_effect_IO$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa)
});
$c_Lcats_effect_IO$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_effect_IO$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f)
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Delay = x$0
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$Blocking = x$0
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleOnce = x$0
});
$c_Lcats_effect_IO$$anon$2.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
  this.Lcats_effect_IO$$anon$2__f_cats$effect$kernel$Sync$$InterruptibleMany = x$0
});
$c_Lcats_effect_IO$$anon$2.prototype.unique__O = (function() {
  return $f_Lcats_effect_kernel_Sync__unique__O(this)
});
$c_Lcats_effect_IO$$anon$2.prototype.never__O = (function() {
  return $f_Lcats_effect_kernel_Async__never__O(this)
});
$c_Lcats_effect_IO$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f)
});
$c_Lcats_effect_IO$$anon$2.prototype.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, fn) {
  $m_Lcats_Eval$();
  var a$1 = fa.flatMap__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((fb$2, fn$2) => ((a) => $as_Lcats_effect_IO(fb$2.value__O()).map__F1__Lcats_effect_IO(new $c_sjsr_AnonFunction1(((fn$1$2, a$2) => ((b) => fn$1$2.apply__O__O__O(a$2, b)))(fn$2, a)))))(fb, fn)));
  return new $c_Lcats_Now(a$1)
});
$c_Lcats_effect_IO$$anon$2.prototype.async__F1__O = (function(k) {
  return $m_Lcats_effect_IO$().async__F1__Lcats_effect_IO(k)
});
$c_Lcats_effect_IO$$anon$2.prototype.async___F1__O = (function(k) {
  return $m_Lcats_effect_IO$().async___F1__Lcats_effect_IO(k)
});
$c_Lcats_effect_IO$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  var ioa = $as_Lcats_effect_IO(fa);
  return ioa.as__O__Lcats_effect_IO(b)
});
$c_Lcats_effect_IO$$anon$2.prototype.attempt__O__O = (function(fa) {
  var ioa = $as_Lcats_effect_IO(fa);
  return new $c_Lcats_effect_IO$Attempt(ioa)
});
$c_Lcats_effect_IO$$anon$2.prototype.forceR__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return left.forceR__Lcats_effect_IO__Lcats_effect_IO(right)
});
$c_Lcats_effect_IO$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Pure(x)
});
$c_Lcats_effect_IO$$anon$2.prototype.guarantee__O__O__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  var fin$1 = $as_Lcats_effect_IO(fin);
  return fa$1.guarantee__Lcats_effect_IO__Lcats_effect_IO(fin$1)
});
$c_Lcats_effect_IO$$anon$2.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return fa$1.guaranteeCase__F1__Lcats_effect_IO(fin)
});
$c_Lcats_effect_IO$$anon$2.prototype.handleError__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return fa$1.handleError__F1__Lcats_effect_IO(f)
});
$c_Lcats_effect_IO$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return fa$1.handleErrorWith__F1__Lcats_effect_IO(f)
});
$c_Lcats_effect_IO$$anon$2.prototype.raiseError__O__O = (function(e) {
  var e$1 = $as_jl_Throwable(e);
  $m_Lcats_effect_IO$();
  return new $c_Lcats_effect_IO$Error(e$1)
});
$c_Lcats_effect_IO$$anon$2.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $m_Lcats_effect_IO$().cont__Lcats_effect_kernel_Cont__Lcats_effect_IO(body)
});
$c_Lcats_effect_IO$$anon$2.prototype.executionContext__O = (function() {
  return this.Lcats_effect_IO$$anon$2__f_executionContext
});
$c_Lcats_effect_IO$$anon$2.prototype.onCancel__O__O__O = (function(fa, fin) {
  var ioa = $as_Lcats_effect_IO(fa);
  var fin$1 = $as_Lcats_effect_IO(fin);
  return new $c_Lcats_effect_IO$OnCancel(ioa, fin$1)
});
$c_Lcats_effect_IO$$anon$2.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $m_Lcats_effect_IO$().bracketFull__F1__F1__F2__Lcats_effect_IO(acquire, use, release)
});
$c_Lcats_effect_IO$$anon$2.prototype.canceled__O = (function() {
  $m_Lcats_effect_IO$();
  return $m_Lcats_effect_IO$Canceled$()
});
$c_Lcats_effect_IO$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return left.productL__Lcats_effect_IO__Lcats_effect_IO(right)
});
$c_Lcats_effect_IO$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  var left = $as_Lcats_effect_IO(fa);
  var right = $as_Lcats_effect_IO(fb);
  return left.productR__Lcats_effect_IO__Lcats_effect_IO(right)
});
$c_Lcats_effect_IO$$anon$2.prototype.start__O__O = (function(fa) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return new $c_Lcats_effect_IO$Start(fa$1)
});
$c_Lcats_effect_IO$$anon$2.prototype.uncancelable__F1__O = (function(body) {
  return $m_Lcats_effect_IO$().uncancelable__F1__Lcats_effect_IO(body)
});
$c_Lcats_effect_IO$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return fa$1.map__F1__Lcats_effect_IO(f)
});
$c_Lcats_effect_IO$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_Lcats_effect_IO(fa);
  return fa$1.flatMap__F1__Lcats_effect_IO(f)
});
$c_Lcats_effect_IO$$anon$2.prototype.delay__F0__O = (function(thunk) {
  var this$1 = $m_Lcats_effect_IO$();
  return this$1.delay__F0__Lcats_effect_IO(thunk)
});
$c_Lcats_effect_IO$$anon$2.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_IO$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_IO(hint, thunk)
});
$c_Lcats_effect_IO$$anon$2.prototype.void__O__O = (function(fa) {
  var ioa = $as_Lcats_effect_IO(fa);
  return ioa.void__Lcats_effect_IO()
});
$c_Lcats_effect_IO$$anon$2.prototype.ref__O__O = (function(a) {
  return $m_Lcats_effect_IO$().ref__O__Lcats_effect_IO(a)
});
$c_Lcats_effect_IO$$anon$2.prototype.deferred__O = (function() {
  return $m_Lcats_effect_IO$().deferred__Lcats_effect_IO()
});
$c_Lcats_effect_IO$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_effect_IO__Lcats_Eval__F2__Lcats_Eval($as_Lcats_effect_IO(fa), fb, f)
});
var $d_Lcats_effect_IO$$anon$2 = new $TypeData().initClass({
  Lcats_effect_IO$$anon$2: 0
}, false, "cats.effect.IO$$anon$2", {
  Lcats_effect_IO$$anon$2: 1,
  O: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_Async: 1,
  Lcats_StackSafeMonad: 1
});
$c_Lcats_effect_IO$$anon$2.prototype.$classData = $d_Lcats_effect_IO$$anon$2;
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that
  } else if ($f_sc_SeqOps__isEmpty__Z(that)) {
    return $thiz
  } else {
    var thisIsObj = ($thiz.unsafeArray__O() instanceof $ac_O);
    var thatIsObj = (that.unsafeArray__O() instanceof $ac_O);
    var mismatch = (thisIsObj !== thatIsObj);
    if (mismatch) {
      return null
    } else if (thisIsObj) {
      var ax = $thiz.unsafeArray__O();
      var ay = that.unsafeArray__O();
      var len = (($m_sr_ScalaRunTime$().array_length__O__I(ax) + $m_sr_ScalaRunTime$().array_length__O__I(ay)) | 0);
      var a = new $ac_O(len);
      var length = $m_sr_ScalaRunTime$().array_length__O__I(ax);
      ax.copyTo(0, a, 0, length);
      var destPos = $m_sr_ScalaRunTime$().array_length__O__I(ax);
      var length$1 = $m_sr_ScalaRunTime$().array_length__O__I(ay);
      ay.copyTo(0, a, destPos, length$1);
      return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a)
    } else {
      var ax$2 = $thiz.unsafeArray__O();
      var ay$2 = that.unsafeArray__O();
      var len$2 = (($m_sr_ScalaRunTime$().array_length__O__I(ax$2) + $m_sr_ScalaRunTime$().array_length__O__I(ay$2)) | 0);
      var a$2 = $thiz.elemTag__s_reflect_ClassTag().newArray__I__O(len$2);
      var length$2 = $m_sr_ScalaRunTime$().array_length__O__I(ax$2);
      ax$2.copyTo(0, a$2, 0, length$2);
      var destPos$1 = $m_sr_ScalaRunTime$().array_length__O__I(ax$2);
      var length$3 = $m_sr_ScalaRunTime$().array_length__O__I(ay$2);
      ay$2.copyTo(0, a$2, destPos$1, length$3);
      return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a$2)
    }
  }
}
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = suffix$1.knownSize__I();
  if ((k === 0)) {
    return $thiz
  } else {
    $m_s_reflect_ManifestFactory$AnyManifest$();
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      $m_sr_ScalaRunTime$().array_length__O__I($thiz.unsafeArray__O())
    };
    var xs = $thiz.unsafeArray__O();
    var length = $m_sr_ScalaRunTime$().array_length__O__I(xs);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0)
    };
    var it = suffix$1.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem$1 = it.next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1)
    };
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems))
  }
}
/** @constructor */
function $c_sci_ArraySeq() {
  /*<skip>*/
}
$c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$c_sci_ArraySeq.prototype.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
  /*<skip>*/
}
$h_sci_ArraySeq.prototype = $c_sci_ArraySeq.prototype;
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5)
});
$c_sci_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$12 = this.elemTag__s_reflect_ClassTag();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12)
});
$c_sci_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_ArraySeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_ArraySeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sci_ArraySeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_sci_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged
});
$c_sci_ArraySeq.prototype.map__F1__sci_ArraySeq = (function(f) {
  var a = new $ac_O(this.length__I());
  var i = 0;
  while ((i < a.u.length)) {
    a.set(i, f.apply__O__O(this.apply__I__O(i)));
    i = ((1 + i) | 0)
  };
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a)
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__sci_ArraySeq = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var x2 = $as_sci_ArraySeq(suffix);
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, x2);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result)
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix)
  }
});
$c_sci_ArraySeq.prototype.drop__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().drop$extension__O__I__O(this.unsafeArray__O(), n)))
});
$c_sci_ArraySeq.prototype.foldLeft__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = 0;
  while ((i < $m_sr_ScalaRunTime$().array_length__O__I(array))) {
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = f.apply__O__O__O(b, a);
    i = ((1 + i) | 0)
  };
  return b
});
$c_sci_ArraySeq.prototype.tail__sci_ArraySeq = (function() {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().tail$extension__O__O(this.unsafeArray__O()))
});
$c_sci_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_sci_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, xs, start, copied)
  };
  return copied
});
$c_sci_ArraySeq.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if (($m_sr_ScalaRunTime$().array_length__O__I(this.unsafeArray__O()) <= 1)) {
    return this
  } else {
    var this$3 = $m_s_Array$();
    var original = this.unsafeArray__O();
    var newLength = this.length__I();
    $m_s_reflect_ManifestFactory$ObjectManifest$();
    if ($d_O.getClassOf().isAssignableFrom__jl_Class__Z($objectGetClass(original).getComponentType__jl_Class())) {
      if ($d_O.getClassOf().isPrimitive__Z()) {
        var $$x1 = this$3.copyOf__O__I__O(original, newLength)
      } else {
        var original$1 = $asArrayOf_O(original, 1);
        var $$x1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original$1, newLength, $d_O.getArrayOf().getClassOf())
      }
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_sr_ScalaRunTime$().array_length__O__I(original));
      var $$x1 = dest
    };
    var a = $asArrayOf_O($$x1, 1);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a)
  }
});
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5)
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq.prototype.tail__O = (function() {
  return this.tail__sci_ArraySeq()
});
$c_sci_ArraySeq.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_ArraySeq(n)
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix)
});
$c_sci_ArraySeq.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_ArraySeq(f)
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged
});
function $as_sci_ArraySeq(obj) {
  return (((obj instanceof $c_sci_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq"))
}
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq)))
}
function $asArrayOf_sci_ArraySeq(obj, depth) {
  return (($isArrayOf_sci_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq;", depth))
}
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz
}
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
  /*<skip>*/
}
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_Vector.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that)
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o)
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sci_Vector.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sci_Vector.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$()
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? $as_sci_BigVector(this).sci_BigVector__f_length0 : this.sci_Vector__f_prefix1.u.length)
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()))
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = this.sci_Vector__f_prefix1.u.length;
  while ((i !== len)) {
    if (($uZ(pred.apply__O__O(this.sci_Vector__f_prefix1.get(i))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (($uZ(pred.apply__O__O(this.sci_Vector__f_prefix1.get(j))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j))
        };
        j = ((1 + j) | 0)
      };
      var $$x1 = i;
      var i$1 = bitmap;
      var newLen = (($$x1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.get(k));
          k = ((1 + k) | 0)
        };
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.get(k));
            i = ((1 + i) | 0)
          };
          k = ((1 + k) | 0)
        };
        $as_sci_BigVector(this).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((pred$1, isFlipped$1, b$1) => ((v$2) => (($uZ(pred$1.apply__O__O(v$2)) !== isFlipped$1) ? b$1.addOne__O__sci_VectorBuilder(v$2) : (void 0))))(pred, isFlipped, b)));
        return b.result__sci_Vector()
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$()
        };
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        src.copyTo(0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.set(i, this.sci_Vector__f_prefix1.get(k$2));
            i = ((1 + i) | 0)
          };
          k$2 = ((1 + k$2) | 0)
        };
        return new $c_sci_Vector1(newData)
      }
    };
    i = ((1 + i) | 0)
  };
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    $as_sci_BigVector(this).foreachRest__F1__V(new $c_sjsr_AnonFunction1(((pred$2, isFlipped$2, b$2$1) => ((v$3$2) => (($uZ(pred$2.apply__O__O(v$3$2)) !== isFlipped$2) ? b$2$1.addOne__O__sci_VectorBuilder(v$3$2) : (void 0))))(pred, isFlipped, b$2)));
    return b$2.result__sci_Vector()
  } else {
    return this
  }
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = suffix.knownSize__I();
  return ((k === 0) ? this : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k))
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if (((k > 0) && (k < tinyAppendLimit))) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      var x2 = $as_sci_Iterable(suffix);
      x2.foreach__F1__V(new $c_sjsr_AnonFunction1(((v$1) => ((x$2) => {
        v$1.sr_ObjectRef__f_elem = $as_sci_Vector(v$1.sr_ObjectRef__f_elem).appended__O__sci_Vector(x$2)
      }))(v)))
    } else {
      var this$3 = suffix.iterator__sc_Iterator();
      while (this$3.hasNext__Z()) {
        var arg1 = this$3.next__O();
        v.sr_ObjectRef__f_elem = $as_sci_Vector(v.sr_ObjectRef__f_elem).appended__O__sci_Vector(arg1)
      }
    };
    return $as_sci_Vector(v.sr_ObjectRef__f_elem)
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = $as_sci_Vector(suffix);
    var this$4 = new $c_sc_IndexedSeqView$Id(this);
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$4);
    while ((ri.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
      v$2 = v$2.prepended__O__sci_Vector(ri.next__O())
    };
    return v$2
  } else {
    return new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this).addAll__sc_IterableOnce__sci_VectorBuilder(suffix).result__sci_Vector()
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector"
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return this.iterator__sc_Iterator().copyToArray__O__I__I__I(xs, start, len)
});
$c_sci_Vector.prototype.toVector__sci_Vector = (function() {
  return this
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"))
});
$c_sci_Vector.prototype.head__O = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head")
  } else {
    return this.sci_Vector__f_prefix1.get(0)
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $$x1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  var until = this.length__I();
  return this.slice__I__I__sci_Vector(n, until)
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$()
});
function $as_sci_Vector(obj) {
  return (((obj instanceof $c_sci_Vector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector"))
}
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)))
}
function $asArrayOf_sci_Vector(obj, depth) {
  return (($isArrayOf_sci_Vector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector;", depth))
}
/** @constructor */
function $c_scm_ArraySeq() {
  /*<skip>*/
}
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
  /*<skip>*/
}
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I()
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  var s = coll.knownSize__I();
  var it = coll.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.jl_Class__f_data.zero : elem));
    jsElems.push(unboxedElem)
  };
  var $$x1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $$x1.make__O__scm_ArraySeq(elemRuntimeClass.jl_Class__f_data.getArrayOf().wrapArray(jsElems))
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag())
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq"
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var x2 = $as_scm_ArraySeq(other);
    if (($m_sr_ScalaRunTime$().array_length__O__I(this.array__O()) !== $m_sr_ScalaRunTime$().array_length__O__I(x2.array__O()))) {
      return false
    }
  };
  return $f_sc_Seq__equals__O__Z(this, other)
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__scm_ArraySeq = (function(ord) {
  var $$x2 = $m_scm_ArraySeq$();
  var $$x1 = $m_sc_ArrayOps$();
  var xs = this.array__O();
  return $$x2.make__O__scm_ArraySeq($$x1.sorted$extension__O__s_math_Ordering__O(xs, ord))
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__scm_ArraySeq(ord)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll)
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged
});
function $as_scm_ArraySeq(obj) {
  return (((obj instanceof $c_scm_ArraySeq) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq"))
}
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)))
}
function $asArrayOf_scm_ArraySeq(obj, depth) {
  return (($isArrayOf_scm_ArraySeq(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq;", depth))
}
/** @constructor */
function $c_Lcats_package$$anon$1() {
  /*<skip>*/
}
$c_Lcats_package$$anon$1.prototype = new $h_O();
$c_Lcats_package$$anon$1.prototype.constructor = $c_Lcats_package$$anon$1;
/** @constructor */
function $h_Lcats_package$$anon$1() {
  /*<skip>*/
}
$h_Lcats_package$$anon$1.prototype = $c_Lcats_package$$anon$1.prototype;
$c_Lcats_package$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0))
});
$c_Lcats_package$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_package$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb)
});
$c_Lcats_package$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb)
});
$c_Lcats_package$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb)
});
$c_Lcats_package$$anon$1.prototype.unit__O = (function() {
  return (void 0)
});
$c_Lcats_package$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_package$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return f.apply__O__O(sa)
});
$c_Lcats_package$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$3) {
  return f.apply__O__O(fa)
});
$c_Lcats_package$$anon$1.prototype.pure__O__O = (function(a) {
  return a
});
$c_Lcats_package$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return f.apply__O__O(a)
});
$c_Lcats_package$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  var this$ = this;
  var a$tailLocal1 = a;
  while (true) {
    var x1 = $as_s_util_Either(f.apply__O__O(a$tailLocal1));
    if ((x1 instanceof $c_s_util_Left)) {
      var a1 = $as_s_util_Left(x1).s_util_Left__f_value;
      var \u03b4this$tmp1 = this$;
      this$ = \u03b4this$tmp1;
      a$tailLocal1 = a1;
      continue
    };
    if ((x1 instanceof $c_s_util_Right)) {
      var b = $as_s_util_Right(x1).s_util_Right__f_value;
      return b
    };
    throw new $c_s_MatchError(x1)
  }
});
$c_Lcats_package$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return f.apply__O__O(fa)
});
$c_Lcats_package$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return f.apply__O__O__O(fa, fb)
});
$c_Lcats_package$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((fa$2, f$2) => ((_$8) => f$2.apply__O__O__O(fa$2, _$8)))(fa, f)))
});
$c_Lcats_package$$anon$1.prototype.foldLeft__O__O__F2__O = (function(a, b, f) {
  return f.apply__O__O__O(b, a)
});
$c_Lcats_package$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(a, lb, f) {
  return $as_Lcats_Eval(f.apply__O__O__O(a, lb))
});
$c_Lcats_package$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return f.apply__O__O(fa)
});
$c_Lcats_package$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  var ff$1 = $as_F1(ff);
  return ff$1.apply__O__O(fa)
});
var $d_Lcats_package$$anon$1 = new $TypeData().initClass({
  Lcats_package$$anon$1: 0
}, false, "cats.package$$anon$1", {
  Lcats_package$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Distributive: 1
});
$c_Lcats_package$$anon$1.prototype.$classData = $d_Lcats_package$$anon$1;
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = null;
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofBoolean.prototype.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofBoolean.prototype = $c_sci_ArraySeq$ofBoolean.prototype;
$c_sci_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofBoolean)) {
    var x2 = $as_sci_ArraySeq$ofBoolean(that);
    var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofBoolean__f_unsafeArray;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var a = this$1.clone__O();
    var this$2 = $m_s_util_Sorting$();
    var evidence$3 = $m_s_math_Ordering$Boolean$();
    this$2.stableSort__O__I__I__s_math_Ordering__V(a, 0, a.u.length, evidence$3);
    return new $c_sci_ArraySeq$ofBoolean(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.sci_ArraySeq$ofBoolean__f_unsafeArray)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(i) {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcZI$sp__I__Z(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_sci_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_sci_ArraySeq$ofBoolean.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray
});
function $as_sci_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofBoolean)))
}
function $asArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofBoolean;", depth))
}
var $d_sci_ArraySeq$ofBoolean = new $TypeData().initClass({
  sci_ArraySeq$ofBoolean: 0
}, false, "scala.collection.immutable.ArraySeq$ofBoolean", {
  sci_ArraySeq$ofBoolean: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofBoolean.prototype.$classData = $d_sci_ArraySeq$ofBoolean;
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.sci_ArraySeq$ofByte__f_unsafeArray = null;
  this.sci_ArraySeq$ofByte__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofByte.prototype.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofByte.prototype = $c_sci_ArraySeq$ofByte.prototype;
$c_sci_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__B = (function(i) {
  return this.sci_ArraySeq$ofByte__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofByte)) {
    var x2 = $as_sci_ArraySeq$ofByte(that);
    var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofByte__f_unsafeArray;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AB__V(a);
    return new $c_sci_ArraySeq$ofByte(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.sci_ArraySeq$ofByte__f_unsafeArray)
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_sci_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_sci_ArraySeq$ofByte.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray
});
function $as_sci_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofByte"))
}
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofByte)))
}
function $asArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofByte;", depth))
}
var $d_sci_ArraySeq$ofByte = new $TypeData().initClass({
  sci_ArraySeq$ofByte: 0
}, false, "scala.collection.immutable.ArraySeq$ofByte", {
  sci_ArraySeq$ofByte: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofByte.prototype.$classData = $d_sci_ArraySeq$ofByte;
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.sci_ArraySeq$ofChar__f_unsafeArray = null;
  this.sci_ArraySeq$ofChar__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofChar.prototype.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofChar.prototype = $c_sci_ArraySeq$ofChar.prototype;
$c_sci_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__C = (function(i) {
  return this.sci_ArraySeq$ofChar__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofChar)) {
    var x2 = $as_sci_ArraySeq$ofChar(that);
    var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofChar__f_unsafeArray;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AC__V(a);
    return new $c_sci_ArraySeq$ofChar(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.sci_ArraySeq$ofChar__f_unsafeArray)
});
$c_sci_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.sci_ArraySeq$ofChar__f_unsafeArray).addString__scm_StringBuilder__T__T__T__scm_StringBuilder(sb, start, sep, end)
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_sci_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_sci_ArraySeq$ofChar.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray
});
function $as_sci_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofChar"))
}
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofChar)))
}
function $asArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofChar;", depth))
}
var $d_sci_ArraySeq$ofChar = new $TypeData().initClass({
  sci_ArraySeq$ofChar: 0
}, false, "scala.collection.immutable.ArraySeq$ofChar", {
  sci_ArraySeq$ofChar: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofChar.prototype.$classData = $d_sci_ArraySeq$ofChar;
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.sci_ArraySeq$ofDouble__f_unsafeArray = null;
  this.sci_ArraySeq$ofDouble__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofDouble.prototype.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofDouble.prototype = $c_sci_ArraySeq$ofDouble.prototype;
$c_sci_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var x2 = $as_sci_ArraySeq$ofDouble(that);
    var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofDouble__f_unsafeArray;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.sci_ArraySeq$ofDouble__f_unsafeArray)
});
$c_sci_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(i) {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcDI$sp__I__D(i)
});
$c_sci_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_sci_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_sci_ArraySeq$ofDouble.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray
});
function $as_sci_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofDouble"))
}
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofDouble)))
}
function $asArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofDouble;", depth))
}
var $d_sci_ArraySeq$ofDouble = new $TypeData().initClass({
  sci_ArraySeq$ofDouble: 0
}, false, "scala.collection.immutable.ArraySeq$ofDouble", {
  sci_ArraySeq$ofDouble: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofDouble.prototype.$classData = $d_sci_ArraySeq$ofDouble;
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.sci_ArraySeq$ofFloat__f_unsafeArray = null;
  this.sci_ArraySeq$ofFloat__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofFloat.prototype.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofFloat.prototype = $c_sci_ArraySeq$ofFloat.prototype;
$c_sci_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var x2 = $as_sci_ArraySeq$ofFloat(that);
    var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofFloat__f_unsafeArray;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.sci_ArraySeq$ofFloat__f_unsafeArray)
});
$c_sci_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(i) {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcFI$sp__I__F(i)
});
$c_sci_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_sci_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_sci_ArraySeq$ofFloat.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray
});
function $as_sci_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofFloat"))
}
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofFloat)))
}
function $asArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofFloat;", depth))
}
var $d_sci_ArraySeq$ofFloat = new $TypeData().initClass({
  sci_ArraySeq$ofFloat: 0
}, false, "scala.collection.immutable.ArraySeq$ofFloat", {
  sci_ArraySeq$ofFloat: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofFloat.prototype.$classData = $d_sci_ArraySeq$ofFloat;
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.sci_ArraySeq$ofInt__f_unsafeArray = null;
  this.sci_ArraySeq$ofInt__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofInt.prototype.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofInt.prototype = $c_sci_ArraySeq$ofInt.prototype;
$c_sci_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofInt)) {
    var x2 = $as_sci_ArraySeq$ofInt(that);
    var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofInt__f_unsafeArray;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AI__V(a);
    return new $c_sci_ArraySeq$ofInt(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.sci_ArraySeq$ofInt__f_unsafeArray)
});
$c_sci_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(i) {
  return this.sci_ArraySeq$ofInt__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_sci_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_sci_ArraySeq$ofInt.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray
});
function $as_sci_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofInt"))
}
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofInt)))
}
function $asArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofInt;", depth))
}
var $d_sci_ArraySeq$ofInt = new $TypeData().initClass({
  sci_ArraySeq$ofInt: 0
}, false, "scala.collection.immutable.ArraySeq$ofInt", {
  sci_ArraySeq$ofInt: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofInt.prototype.$classData = $d_sci_ArraySeq$ofInt;
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.sci_ArraySeq$ofLong__f_unsafeArray = null;
  this.sci_ArraySeq$ofLong__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofLong.prototype.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofLong.prototype = $c_sci_ArraySeq$ofLong.prototype;
$c_sci_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofLong)) {
    var x2 = $as_sci_ArraySeq$ofLong(that);
    var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofLong__f_unsafeArray;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AJ__V(a);
    return new $c_sci_ArraySeq$ofLong(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.sci_ArraySeq$ofLong__f_unsafeArray)
});
$c_sci_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(i) {
  return this.sci_ArraySeq$ofLong__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return this.apply$mcJI$sp__I__J(i)
});
$c_sci_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_sci_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_sci_ArraySeq$ofLong.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray
});
function $as_sci_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofLong"))
}
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofLong)))
}
function $asArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofLong;", depth))
}
var $d_sci_ArraySeq$ofLong = new $TypeData().initClass({
  sci_ArraySeq$ofLong: 0
}, false, "scala.collection.immutable.ArraySeq$ofLong", {
  sci_ArraySeq$ofLong: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofLong.prototype.$classData = $d_sci_ArraySeq$ofLong;
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.sci_ArraySeq$ofRef__f_unsafeArray = null;
  this.sci_ArraySeq$ofRef__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofRef.prototype.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofRef.prototype = $c_sci_ArraySeq$ofRef.prototype;
$c_sci_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return $$x1.apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_sci_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofRef.prototype.apply__I__O = (function(i) {
  return this.sci_ArraySeq$ofRef__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofRef)) {
    var x2 = $as_sci_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.sci_ArraySeq$ofRef__f_unsafeArray, x2.sci_ArraySeq$ofRef__f_unsafeArray)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq$ofRef = (function(ord) {
  if ((this.sci_ArraySeq$ofRef__f_unsafeArray.u.length <= 1)) {
    return this
  } else {
    var this$1 = this.sci_ArraySeq$ofRef__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a)
  }
});
$c_sci_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.sci_ArraySeq$ofRef__f_unsafeArray)
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord)
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord)
});
$c_sci_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sci_ArraySeq$ofRef.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray
});
function $as_sci_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofRef"))
}
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)))
}
function $asArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofRef;", depth))
}
var $d_sci_ArraySeq$ofRef = new $TypeData().initClass({
  sci_ArraySeq$ofRef: 0
}, false, "scala.collection.immutable.ArraySeq$ofRef", {
  sci_ArraySeq$ofRef: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofRef.prototype.$classData = $d_sci_ArraySeq$ofRef;
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.sci_ArraySeq$ofShort__f_unsafeArray = null;
  this.sci_ArraySeq$ofShort__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofShort.prototype.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofShort.prototype = $c_sci_ArraySeq$ofShort.prototype;
$c_sci_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__S = (function(i) {
  return this.sci_ArraySeq$ofShort__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofShort)) {
    var x2 = $as_sci_ArraySeq$ofShort(that);
    var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var b = x2.sci_ArraySeq$ofShort__f_unsafeArray;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.length__I() <= 1)) {
    return this
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AS__V(a);
    return new $c_sci_ArraySeq$ofShort(a)
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord)
  }
});
$c_sci_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.sci_ArraySeq$ofShort__f_unsafeArray)
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord)
});
$c_sci_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_sci_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_sci_ArraySeq$ofShort.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray
});
function $as_sci_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofShort"))
}
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofShort)))
}
function $asArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofShort;", depth))
}
var $d_sci_ArraySeq$ofShort = new $TypeData().initClass({
  sci_ArraySeq$ofShort: 0
}, false, "scala.collection.immutable.ArraySeq$ofShort", {
  sci_ArraySeq$ofShort: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofShort.prototype.$classData = $d_sci_ArraySeq$ofShort;
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray = null;
  this.sci_ArraySeq$ofUnit__f_unsafeArray = unsafeArray
}
$c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofUnit.prototype.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_sci_ArraySeq$ofUnit.prototype = $c_sci_ArraySeq$ofUnit.prototype;
$c_sci_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray.u.length
});
$c_sci_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofUnit__f_unsafeArray;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_sci_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofUnit)) {
    var x2 = $as_sci_ArraySeq$ofUnit(that);
    return (this.sci_ArraySeq$ofUnit__f_unsafeArray.u.length === x2.sci_ArraySeq$ofUnit__f_unsafeArray.u.length)
  } else {
    return $f_sc_Seq__equals__O__Z(this, that)
  }
});
$c_sci_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.sci_ArraySeq$ofUnit__f_unsafeArray)
});
$c_sci_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(i) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray.get(i)
});
$c_sci_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  this.apply$mcVI$sp__I__V(i)
});
$c_sci_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_sci_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_sci_ArraySeq$ofUnit.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray
});
function $as_sci_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_sci_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.ArraySeq$ofUnit"))
}
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofUnit)))
}
function $asArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_sci_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.ArraySeq$ofUnit;", depth))
}
var $d_sci_ArraySeq$ofUnit = new $TypeData().initClass({
  sci_ArraySeq$ofUnit: 0
}, false, "scala.collection.immutable.ArraySeq$ofUnit", {
  sci_ArraySeq$ofUnit: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
});
$c_sci_ArraySeq$ofUnit.prototype.$classData = $d_sci_ArraySeq$ofUnit;
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1)
    } else if (xs.isEmpty__Z()) {
      return (-1)
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = $as_sci_List(xs.tail__O());
      i = temp$i;
      xs = temp$xs
    }
  }
}
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true
    } else {
      var aEmpty = a.isEmpty__Z();
      var bEmpty = b.isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = $as_sci_List(a.tail__O());
        var temp$b = $as_sci_List(b.tail__O());
        a = temp$a;
        b = temp$b
      } else {
        return (aEmpty && bEmpty)
      }
    }
  }
}
/** @constructor */
function $c_sci_List() {
  /*<skip>*/
}
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
  /*<skip>*/
}
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_List.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this)
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$()
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix
  } else if (prefix.isEmpty__Z()) {
    return this
  } else {
    var result = new $c_sci_$colon$colon(prefix.head__O(), this);
    var curr = result;
    var that = $as_sci_List(prefix.tail__O());
    while ((!that.isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon(that.head__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp;
      that = $as_sci_List(that.tail__O())
    };
    return result
  }
});
$c_sci_List.prototype.reverse_$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  var these = this;
  var pres = prefix;
  while ((!pres.isEmpty__Z())) {
    var rassoc$1 = pres.head__O();
    var this$1 = these;
    these = new $c_sci_$colon$colon(rassoc$1, this$1);
    pres = $as_sci_List(pres.tail__O())
  };
  return these
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$())
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(prefix);
    return this.$colon$colon$colon__sci_List__sci_List(x2)
  };
  if ((prefix.knownSize__I() === 0)) {
    return this
  };
  if ((prefix instanceof $c_scm_ListBuffer)) {
    var x3 = $as_scm_ListBuffer(prefix);
    if (this.isEmpty__Z()) {
      return x3.toList__sci_List()
    }
  };
  var iter = prefix.iterator__sc_Iterator();
  if (iter.hasNext__Z()) {
    var result = new $c_sci_$colon$colon(iter.next__O(), this);
    var curr = result;
    while (iter.hasNext__Z()) {
      var temp = new $c_sci_$colon$colon(iter.next__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp
    };
    return result
  } else {
    return this
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  if ((suffix instanceof $c_sci_List)) {
    var x2 = $as_sci_List(suffix);
    return x2.$colon$colon$colon__sci_List__sci_List(this)
  } else {
    return $as_sci_List($f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix))
  }
});
$c_sci_List.prototype.take__I__sci_List = (function(n) {
  if ((this.isEmpty__Z() || (n <= 0))) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon(this.head__O(), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    var i = 1;
    while (true) {
      if (rest.isEmpty__Z()) {
        return this
      };
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon(rest.head__O(), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = $as_sci_List(rest.tail__O())
      } else {
        break
      }
    };
    return h
  }
});
$c_sci_List.prototype.splitAt__I__T2 = (function(n) {
  var b = new $c_scm_ListBuffer();
  var i = 0;
  var these = this;
  while (((!these.isEmpty__Z()) && (i < n))) {
    i = ((1 + i) | 0);
    var elem = these.head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = $as_sci_List(these.tail__O())
  };
  return new $c_T2(b.toList__sci_List(), these)
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var h = new $c_sci_$colon$colon(f.apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = $as_sci_List(this.tail__O());
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon(f.apply__O__O(rest.head__O()), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = $as_sci_List(rest.tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.collect__s_PartialFunction__sci_List = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$()
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = pf.applyOrElse__O__F1__O(rest.head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$())
      };
      rest = $as_sci_List(rest.tail__O());
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h)
      }
    };
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = pf.applyOrElse__O__F1__O(rest.head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx
      };
      rest = $as_sci_List(rest.tail__O())
    };
    return h
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = $as_sc_IterableOnce(f.apply__O__O(rest.head__O())).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx
      } else {
        t.sci_$colon$colon__f_next = nx
      };
      t = nx
    };
    rest = $as_sci_List(rest.tail__O())
  };
  return ((h === null) ? $m_sci_Nil$() : h)
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = $as_sci_List(these.tail__O())
  }
});
$c_sci_List.prototype.reverse__sci_List = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!these.isEmpty__Z())) {
    var rassoc$6 = these.head__O();
    var this$1 = result;
    result = new $c_sci_$colon$colon(rassoc$6, this$1);
    these = $as_sci_List(these.tail__O())
  };
  return result
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!these.isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = $as_sci_List(these.tail__O())
  };
  return len
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len))
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ($uZ(p.apply__O__O(these.head__O()))) {
      return true
    };
    these = $as_sci_List(these.tail__O())
  };
  return false
});
$c_sci_List.prototype.contains__O__Z = (function(elem) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(these.head__O(), elem)) {
      return true
    };
    these = $as_sci_List(these.tail__O())
  };
  return false
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last")
  } else {
    var these = this;
    var scout = $as_sci_List(this.tail__O());
    while ((!scout.isEmpty__Z())) {
      these = scout;
      scout = $as_sci_List(scout.tail__O())
    };
    return these.head__O()
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List"
});
$c_sci_List.prototype.toList__sci_List = (function() {
  return this
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  if ((o instanceof $c_sci_List)) {
    var x2 = $as_sci_List(o);
    return $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, x2)
  } else {
    return $f_sc_Seq__equals__O__Z(this, o)
  }
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = $uI(v1);
  return $f_sc_LinearSeqOps__apply__I__O(this, n)
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f)
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix)
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$()
});
function $as_sci_List(obj) {
  return (((obj instanceof $c_sci_List) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.List"))
}
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)))
}
function $asArrayOf_sci_List(obj, depth) {
  return (($isArrayOf_sci_List(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.List;", depth))
}
function $p_sci_Queue__indexOutOfRange$1__I__E($thiz, n$1) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n$1))
}
function $ct_sci_Queue__sci_List__sci_List__($thiz, in$1, out) {
  $thiz.sci_Queue__f_in = in$1;
  $thiz.sci_Queue__f_out = out;
  return $thiz
}
/** @constructor */
function $c_sci_Queue() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null
}
$c_sci_Queue.prototype = new $h_sci_AbstractSeq();
$c_sci_Queue.prototype.constructor = $c_sci_Queue;
/** @constructor */
function $h_sci_Queue() {
  /*<skip>*/
}
$h_sci_Queue.prototype = $c_sci_Queue.prototype;
$c_sci_Queue.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sci_Queue.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord)
});
$c_sci_Queue.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_sci_Queue.prototype.stringPrefix__T = (function() {
  return "LinearSeq"
});
$c_sci_Queue.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len)
});
$c_sci_Queue.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x)
});
$c_sci_Queue.prototype.foreach__F1__V = (function(f) {
  $f_sc_LinearSeqOps__foreach__F1__V(this, f)
});
$c_sci_Queue.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op)
});
$c_sci_Queue.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that)
});
$c_sci_Queue.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from)
});
$c_sci_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Queue$()
});
$c_sci_Queue.prototype.apply__I__O = (function(n) {
  var index = 0;
  var curr = this.sci_Queue__f_out;
  while (true) {
    if ((index < n)) {
      var this$1 = curr;
      var $$x1 = (!this$1.isEmpty__Z())
    } else {
      var $$x1 = false
    };
    if ($$x1) {
      index = ((1 + index) | 0);
      curr = $as_sci_List(curr.tail__O())
    } else {
      break
    }
  };
  if ((index === n)) {
    var this$2 = curr;
    if ((!this$2.isEmpty__Z())) {
      return curr.head__O()
    } else {
      var this$3 = this.sci_Queue__f_in;
      if ((!this$3.isEmpty__Z())) {
        return this.sci_Queue__f_in.last__O()
      } else {
        $p_sci_Queue__indexOutOfRange$1__I__E(this, n)
      }
    }
  } else {
    var indexFromBack = ((n - index) | 0);
    var inLength = this.sci_Queue__f_in.length__I();
    if ((indexFromBack >= inLength)) {
      $p_sci_Queue__indexOutOfRange$1__I__E(this, n)
    } else {
      var this$4 = this.sci_Queue__f_in;
      var n$1 = (((-1) + ((inLength - indexFromBack) | 0)) | 0);
      return $f_sc_LinearSeqOps__apply__I__O(this$4, n$1)
    }
  }
});
$c_sci_Queue.prototype.iterator__sc_Iterator = (function() {
  return this.sci_Queue__f_out.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.sci_Queue__f_in.reverse__sci_List()))(this)))
});
$c_sci_Queue.prototype.isEmpty__Z = (function() {
  return (this.sci_Queue__f_in.isEmpty__Z() && this.sci_Queue__f_out.isEmpty__Z())
});
$c_sci_Queue.prototype.head__O = (function() {
  var this$1 = this.sci_Queue__f_out;
  if ((!this$1.isEmpty__Z())) {
    return this.sci_Queue__f_out.head__O()
  } else {
    var this$2 = this.sci_Queue__f_in;
    if ((!this$2.isEmpty__Z())) {
      return this.sci_Queue__f_in.last__O()
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head on empty queue")
    }
  }
});
$c_sci_Queue.prototype.tail__sci_Queue = (function() {
  var this$1 = this.sci_Queue__f_out;
  if ((!this$1.isEmpty__Z())) {
    return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, $as_sci_List(this.sci_Queue__f_out.tail__O()))
  } else {
    var this$2 = this.sci_Queue__f_in;
    if ((!this$2.isEmpty__Z())) {
      return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List(this.sci_Queue__f_in.reverse__sci_List().tail__O()))
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "tail on empty queue")
    }
  }
});
$c_sci_Queue.prototype.last__O = (function() {
  var this$1 = this.sci_Queue__f_in;
  if ((!this$1.isEmpty__Z())) {
    return this.sci_Queue__f_in.head__O()
  } else {
    var this$2 = this.sci_Queue__f_out;
    if ((!this$2.isEmpty__Z())) {
      return this.sci_Queue__f_out.last__O()
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last on empty queue")
    }
  }
});
$c_sci_Queue.prototype.exists__F1__Z = (function(p) {
  return (this.sci_Queue__f_in.exists__F1__Z(p) || this.sci_Queue__f_out.exists__F1__Z(p))
});
$c_sci_Queue.prototype.className__T = (function() {
  return "Queue"
});
$c_sci_Queue.prototype.length__I = (function() {
  return ((this.sci_Queue__f_in.length__I() + this.sci_Queue__f_out.length__I()) | 0)
});
$c_sci_Queue.prototype.prepended__O__sci_Queue = (function(elem) {
  var $$x1 = this.sci_Queue__f_in;
  var this$1 = this.sci_Queue__f_out;
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $$x1, new $c_sci_$colon$colon(elem, this$1))
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__sci_Queue = (function(that) {
  if ((that instanceof $c_sci_Queue)) {
    var x2 = $as_sci_Queue(that);
    var this$1 = x2.sci_Queue__f_in;
    var rassoc$2 = x2.sci_Queue__f_out;
    var suffix = this.sci_Queue__f_in.reverse_$colon$colon$colon__sci_List__sci_List(rassoc$2);
    var newIn = this$1.appendedAll__sc_IterableOnce__sci_List(suffix)
  } else if ((that instanceof $c_sci_List)) {
    var x3 = $as_sci_List(that);
    var newIn = this.sci_Queue__f_in.reverse_$colon$colon$colon__sci_List__sci_List(x3)
  } else {
    var result = this.sci_Queue__f_in;
    var iter = that.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var rassoc$4 = iter.next__O();
      var this$2 = result;
      result = new $c_sci_$colon$colon(rassoc$4, this$2)
    };
    var newIn = result
  };
  return ((newIn === this.sci_Queue__f_in) ? this : $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), newIn, this.sci_Queue__f_out))
});
$c_sci_Queue.prototype.enqueue__O__sci_Queue = (function(elem) {
  var this$1 = this.sci_Queue__f_in;
  return $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), new $c_sci_$colon$colon(elem, this$1), this.sci_Queue__f_out)
});
$c_sci_Queue.prototype.dequeue__T2 = (function() {
  var x1 = this.sci_Queue__f_out;
  var x = $m_sci_Nil$();
  if ((x.equals__O__Z(x1) && (!this.sci_Queue__f_in.isEmpty__Z()))) {
    var rev = this.sci_Queue__f_in.reverse__sci_List();
    return new $c_T2(rev.head__O(), $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), $m_sci_Nil$(), $as_sci_List(rev.tail__O())))
  } else if ((x1 instanceof $c_sci_$colon$colon)) {
    var x3 = $as_sci_$colon$colon(x1);
    var x$3 = x3.sci_$colon$colon__f_head;
    var xs = x3.sci_$colon$colon__f_next;
    return new $c_T2(x$3, $ct_sci_Queue__sci_List__sci_List__(new $c_sci_Queue(), this.sci_Queue__f_in, xs))
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "dequeue on empty queue")
  }
});
$c_sci_Queue.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this, "Queue(", ", ", ")")
});
$c_sci_Queue.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = $uI(x);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1)
});
$c_sci_Queue.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this)
});
$c_sci_Queue.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Queue(suffix)
});
$c_sci_Queue.prototype.tail__O = (function() {
  return this.tail__sci_Queue()
});
$c_sci_Queue.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_sci_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Queue$()
});
function $as_sci_Queue(obj) {
  return (((obj instanceof $c_sci_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Queue"))
}
function $isArrayOf_sci_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Queue)))
}
function $asArrayOf_sci_Queue(obj, depth) {
  return (($isArrayOf_sci_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Queue;", depth))
}
var $d_sci_Queue = new $TypeData().initClass({
  sci_Queue: 0
}, false, "scala.collection.immutable.Queue", {
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue.prototype.$classData = $d_sci_Queue;
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null
}
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
  /*<skip>*/
}
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  var newlen = ((hi - lo) | 0);
  return ((newlen === this.length__I()) ? this : ((hi <= lo) ? $m_sci_Vector0$() : this.slice0__I__I__sci_Vector(lo, hi)))
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array
}
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array.u.length
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var x2 = $as_scm_ArraySeq$ofBoolean(that);
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = x2.scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return this.scm_ArraySeq$ofBoolean__f_array.get(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcZI$sp__I__Z(index)
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i)
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$()
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array
});
function $as_scm_ArraySeq$ofBoolean(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofBoolean) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofBoolean"))
}
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)))
}
function $asArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofBoolean;", depth))
}
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass({
  scm_ArraySeq$ofBoolean: 0
}, false, "scala.collection.mutable.ArraySeq$ofBoolean", {
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofBoolean.prototype.$classData = $d_scm_ArraySeq$ofBoolean;
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array
}
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofByte__f_array.u.length
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return this.scm_ArraySeq$ofByte__f_array.get(index)
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var x2 = $as_scm_ArraySeq$ofByte(that);
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = x2.scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array)
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B($uI(v1))
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i)
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$()
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array
});
function $as_scm_ArraySeq$ofByte(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofByte) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofByte"))
}
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)))
}
function $asArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofByte(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofByte;", depth))
}
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass({
  scm_ArraySeq$ofByte: 0
}, false, "scala.collection.mutable.ArraySeq$ofByte", {
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofByte.prototype.$classData = $d_scm_ArraySeq$ofByte;
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array
}
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofChar__f_array.u.length
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return this.scm_ArraySeq$ofChar__f_array.get(index)
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var x2 = $as_scm_ArraySeq$ofChar(that);
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = x2.scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array)
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = sb.scm_StringBuilder__f_underlying;
  if (($uI(start.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start)
  };
  var len = this.scm_ArraySeq$ofChar__f_array.u.length;
  if ((len !== 0)) {
    if ((sep === "")) {
      jsb.append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array)
    } else {
      jsb.length__I();
      $uI(end.length);
      $uI(sep.length);
      var c = this.scm_ArraySeq$ofChar__f_array.get(0);
      var str = $as_T(String.fromCharCode(c));
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      var i = 1;
      while ((i < len)) {
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var c$1 = this.scm_ArraySeq$ofChar__f_array.get(i);
        var str$1 = $as_T(String.fromCharCode(c$1));
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
        i = ((1 + i) | 0)
      }
    }
  };
  if (($uI(end.length) !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end)
  };
  return sb
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C($uI(v1)))
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i))
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$()
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array
});
function $as_scm_ArraySeq$ofChar(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofChar) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofChar"))
}
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)))
}
function $asArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofChar(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofChar;", depth))
}
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass({
  scm_ArraySeq$ofChar: 0
}, false, "scala.collection.mutable.ArraySeq$ofChar", {
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofChar.prototype.$classData = $d_scm_ArraySeq$ofChar;
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array
}
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofDouble__f_array.u.length
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var x2 = $as_scm_ArraySeq$ofDouble(that);
    var a = this.scm_ArraySeq$ofDouble__f_array;
    var b = x2.scm_ArraySeq$ofDouble__f_array;
    return $m_ju_Arrays$().equals__AD__AD__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array)
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return this.scm_ArraySeq$ofDouble__f_array.get(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcDI$sp__I__D(index)
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i)
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$()
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array
});
function $as_scm_ArraySeq$ofDouble(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofDouble) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofDouble"))
}
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)))
}
function $asArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofDouble(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofDouble;", depth))
}
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass({
  scm_ArraySeq$ofDouble: 0
}, false, "scala.collection.mutable.ArraySeq$ofDouble", {
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofDouble.prototype.$classData = $d_scm_ArraySeq$ofDouble;
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array
}
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofFloat__f_array.u.length
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var x2 = $as_scm_ArraySeq$ofFloat(that);
    var a = this.scm_ArraySeq$ofFloat__f_array;
    var b = x2.scm_ArraySeq$ofFloat__f_array;
    return $m_ju_Arrays$().equals__AF__AF__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array)
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return this.scm_ArraySeq$ofFloat__f_array.get(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcFI$sp__I__F(index)
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i)
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$()
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array
});
function $as_scm_ArraySeq$ofFloat(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofFloat) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofFloat"))
}
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)))
}
function $asArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofFloat(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofFloat;", depth))
}
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass({
  scm_ArraySeq$ofFloat: 0
}, false, "scala.collection.mutable.ArraySeq$ofFloat", {
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofFloat.prototype.$classData = $d_scm_ArraySeq$ofFloat;
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array
}
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofInt__f_array.u.length
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var x2 = $as_scm_ArraySeq$ofInt(that);
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = x2.scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array)
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return this.scm_ArraySeq$ofInt__f_array.get(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcII$sp__I__I(index)
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i)
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$()
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array
});
function $as_scm_ArraySeq$ofInt(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofInt) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofInt"))
}
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)))
}
function $asArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofInt(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofInt;", depth))
}
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass({
  scm_ArraySeq$ofInt: 0
}, false, "scala.collection.mutable.ArraySeq$ofInt", {
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofInt.prototype.$classData = $d_scm_ArraySeq$ofInt;
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array
}
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofLong__f_array.u.length
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var x2 = $as_scm_ArraySeq$ofLong(that);
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = x2.scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array)
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  return this.scm_ArraySeq$ofLong__f_array.get(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.apply$mcJI$sp__I__J(index)
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i)
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$()
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array
});
function $as_scm_ArraySeq$ofLong(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofLong) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofLong"))
}
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)))
}
function $asArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofLong(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofLong;", depth))
}
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass({
  scm_ArraySeq$ofLong: 0
}, false, "scala.collection.mutable.ArraySeq$ofLong", {
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofLong.prototype.$classData = $d_scm_ArraySeq$ofLong;
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array
}
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $$x1 = $m_s_reflect_ClassTag$();
  var this$1 = this.scm_ArraySeq$ofRef__f_array;
  return $$x1.apply__jl_Class__s_reflect_ClassTag($objectGetClass(this$1).getComponentType__jl_Class())
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofRef__f_array.u.length
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return this.scm_ArraySeq$ofRef__f_array.get(index)
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofRef)) {
    var x2 = $as_scm_ArraySeq$ofRef(that);
    return $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, x2.scm_ArraySeq$ofRef__f_array)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array)
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array
});
function $as_scm_ArraySeq$ofRef(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofRef) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofRef"))
}
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)))
}
function $asArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofRef(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofRef;", depth))
}
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass({
  scm_ArraySeq$ofRef: 0
}, false, "scala.collection.mutable.ArraySeq$ofRef", {
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofRef.prototype.$classData = $d_scm_ArraySeq$ofRef;
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array
}
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofShort__f_array.u.length
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return this.scm_ArraySeq$ofShort__f_array.get(index)
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var x2 = $as_scm_ArraySeq$ofShort(that);
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = x2.scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array)
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S($uI(v1))
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i)
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$()
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array
});
function $as_scm_ArraySeq$ofShort(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofShort) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofShort"))
}
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)))
}
function $asArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofShort(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofShort;", depth))
}
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass({
  scm_ArraySeq$ofShort: 0
}, false, "scala.collection.mutable.ArraySeq$ofShort", {
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofShort.prototype.$classData = $d_scm_ArraySeq$ofShort;
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array
}
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
  /*<skip>*/
}
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofUnit__f_array.u.length
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed)
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofUnit)) {
    var x2 = $as_scm_ArraySeq$ofUnit(that);
    return (this.scm_ArraySeq$ofUnit__f_array.u.length === x2.scm_ArraySeq$ofUnit__f_array.u.length)
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that)
  }
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array)
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
  this.scm_ArraySeq$ofUnit__f_array.get(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  this.apply$mcVI$sp__I__V(index)
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i)
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$()
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array
});
function $as_scm_ArraySeq$ofUnit(obj) {
  return (((obj instanceof $c_scm_ArraySeq$ofUnit) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArraySeq$ofUnit"))
}
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)))
}
function $asArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (($isArrayOf_scm_ArraySeq$ofUnit(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArraySeq$ofUnit;", depth))
}
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass({
  scm_ArraySeq$ofUnit: 0
}, false, "scala.collection.mutable.ArraySeq$ofUnit", {
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArraySeq$ofUnit.prototype.$classData = $d_scm_ArraySeq$ofUnit;
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
  };
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1))
  };
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx)
}
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
  if ((x1 === null)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, new $c_scm_HashMap$Node(key, hash, value, null))
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashMap$Node__f__hash <= hash))) {
      if (((n.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, n.scm_HashMap$Node__f__key))) {
        var old = n.scm_HashMap$Node__f__value;
        n.scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null)
      };
      prev = n;
      n = n.scm_HashMap$Node__f__next
    };
    if ((prev === null)) {
      $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, new $c_scm_HashMap$Node(key, hash, value, x1))
    } else {
      prev.scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, prev.scm_HashMap$Node__f__next)
    }
  };
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null
}
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)))
}
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(idx);
  if ((x1 === null)) {
    return null
  } else if (((x1.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_HashMap$Node__f__key, elem))) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(idx, x1.scm_HashMap$Node__f__next);
    $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
    return x1
  } else {
    var prev = x1;
    var next = x1.scm_HashMap$Node__f__next;
    while (((next !== null) && (next.scm_HashMap$Node__f__hash <= hash))) {
      if (((next.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_HashMap$Node__f__key, elem))) {
        prev.scm_HashMap$Node__f__next = next.scm_HashMap$Node__f__next;
        $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
        return next
      };
      prev = next;
      next = next.scm_HashMap$Node__f__next
    };
    return null
  }
}
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $m_sjsr_package$().unwrapJavaScriptException__jl_Throwable__O($ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum")))
  };
  var oldlen = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen)
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $asArrayOf_scm_HashMap$Node($m_ju_Arrays$().copyOf__AO__I__AO(original, newlen), 1);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(i);
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashMap$Node__f__next;
            if (((n.scm_HashMap$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashMap$Node__f__next = n;
              lastLow = n
            } else {
              lastHigh.scm_HashMap$Node__f__next = n;
              lastHigh = n
            };
            n = next
          };
          lastLow.scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(i, preLow.scm_HashMap$Node__f__next)
          };
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.set(((i + oldlen) | 0), preHigh.scm_HashMap$Node__f__next);
            lastHigh.scm_HashMap$Node__f__next = null
          }
        };
        i = ((1 + i) | 0)
      };
      oldlen = (oldlen << 1)
    }
  }
}
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824)
}
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor))
}
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz
}
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz
}
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0
}
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
  /*<skip>*/
}
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash)) !== null)
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target)
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  this.sizeHint__I__V(xs.knownSize__I());
  if ((xs instanceof $c_sci_HashMap)) {
    var x2 = $as_sci_HashMap(xs);
    var f = new $c_sjsr_AnonFunction3(((this$1) => ((k$2, v$2, h$2) => {
      var h = $uI(h$2);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this$1, k$2, v$2, (h ^ ((h >>> 16) | 0)), false)
    }))(this));
    x2.sci_HashMap__f_rootNode.foreachWithHash__F3__V(f);
    return this
  } else if ((xs instanceof $c_scm_HashMap)) {
    var x3 = $as_scm_HashMap(xs);
    var iter = x3.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = $as_scm_HashMap$Node(iter.next__O());
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, next.scm_HashMap$Node__f__hash, false)
    };
    return this
  } else if ($is_scm_Map(xs)) {
    var x4 = $as_scm_Map(xs);
    x4.foreachEntry__F2__V(new $c_sjsr_AnonFunction2(((this$2) => ((key$2, value$2) => {
      var originalHash = $m_sr_Statics$().anyHash__O__I(key$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this$2, key$2, value$2, (originalHash ^ ((originalHash >>> 16) | 0)), false)
    }))(this)));
    return this
  } else {
    return $as_scm_HashMap($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this))
});
$c_scm_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$3(this))
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this))
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some(x1$1.scm_HashMap$Node__f__value))
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : x1$1.scm_HashMap$Node__f__value)
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1)
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get((hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? default$1.apply__O() : nd.scm_HashMap$Node__f__value)
  }
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false)
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, elem._1__O(), elem._2__O(), false);
  return this
});
$c_scm_HashMap.prototype.subtractOne__O__scm_HashMap = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0)
});
$c_scm_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  var len = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  var i = 0;
  while ((i < len)) {
    var n = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.get(i);
    if ((n !== null)) {
      n.foreachEntry__F2__V(f)
    };
    i = ((1 + i) | 0)
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$()
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap"
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed)
  }
});
$c_scm_HashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_HashMap(elem)
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap($as_T2(elem))
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_HashMap(xs)
});
function $as_scm_HashMap(obj) {
  return (((obj instanceof $c_scm_HashMap) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.HashMap"))
}
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)))
}
function $asArrayOf_scm_HashMap(obj, depth) {
  return (($isArrayOf_scm_HashMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.HashMap;", depth))
}
var $d_scm_HashMap = new $TypeData().initClass({
  scm_HashMap: 0
}, false, "scala.collection.mutable.HashMap", {
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_HashMap.prototype.$classData = $d_scm_HashMap;
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz
}
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0
}
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
  /*<skip>*/
}
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $$x1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    $$x1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - ((a < 0) ? ((-a) | 0) : a)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0)
  }
});
function $as_sci_BigVector(obj) {
  return (((obj instanceof $c_sci_BigVector) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BigVector"))
}
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)))
}
function $asArrayOf_sci_BigVector(obj, depth) {
  return (($isArrayOf_sci_BigVector(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BigVector;", depth))
}
/** @constructor */
function $c_sci_Queue$EmptyQueue$() {
  this.sci_Queue__f_in = null;
  this.sci_Queue__f_out = null;
  $ct_sci_Queue__sci_List__sci_List__(this, $m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Queue$EmptyQueue$.prototype = new $h_sci_Queue();
$c_sci_Queue$EmptyQueue$.prototype.constructor = $c_sci_Queue$EmptyQueue$;
/** @constructor */
function $h_sci_Queue$EmptyQueue$() {
  /*<skip>*/
}
$h_sci_Queue$EmptyQueue$.prototype = $c_sci_Queue$EmptyQueue$.prototype;
var $d_sci_Queue$EmptyQueue$ = new $TypeData().initClass({
  sci_Queue$EmptyQueue$: 0
}, false, "scala.collection.immutable.Queue$EmptyQueue$", {
  sci_Queue$EmptyQueue$: 1,
  sci_Queue: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Queue$EmptyQueue$.prototype.$classData = $d_sci_Queue$EmptyQueue$;
var $n_sci_Queue$EmptyQueue$;
function $m_sci_Queue$EmptyQueue$() {
  if ((!$n_sci_Queue$EmptyQueue$)) {
    $n_sci_Queue$EmptyQueue$ = new $c_sci_Queue$EmptyQueue$()
  };
  return $n_sci_Queue$EmptyQueue$
}
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1)
}
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
  /*<skip>*/
}
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.get(index)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var a1c = a1.clone__O();
    a1c.set(index, elem);
    return new $c_sci_Vector1(a1c)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem))
  } else {
    var $$x2 = this.sci_Vector__f_prefix1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2($$x2, 32, $$x1, a, 33)
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1))
  } else {
    var a = new $ac_O(1);
    a.set(0, elem);
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0))
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f))
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi))
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 1)) {
    return $m_sci_Vector0$()
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to))
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k))
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.get(index)
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector1(obj) {
  return (((obj instanceof $c_sci_Vector1) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector1"))
}
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)))
}
function $asArrayOf_sci_Vector1(obj, depth) {
  return (($isArrayOf_sci_Vector1(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector1;", depth))
}
var $d_sci_Vector1 = new $TypeData().initClass({
  sci_Vector1: 0
}, false, "scala.collection.immutable.Vector1", {
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector1.prototype.$classData = $d_sci_Vector1;
/** @constructor */
function $c_Lcats_instances_OptionInstances$$anon$1() {
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = null;
  this.Lcats_instances_OptionInstances$$anon$1__f_someUnit = new $c_s_Some((void 0))
}
$c_Lcats_instances_OptionInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_OptionInstances$$anon$1.prototype.constructor = $c_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_OptionInstances$$anon$1() {
  /*<skip>*/
}
$h_Lcats_instances_OptionInstances$$anon$1.prototype = $c_Lcats_instances_OptionInstances$$anon$1.prototype;
$c_Lcats_instances_OptionInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse___O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverse___O__F1__Lcats_Applicative__O(this, fa, f, G)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unorderedTraverse__O__F1__Lcats_CommutativeApplicative__O = (function(sa, f, evidence$5) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(sa), f, evidence$5)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.attempt__O__O = (function(fa) {
  return $f_Lcats_ApplicativeError__attempt__O__O(this, fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__s_Option = (function(a, f) {
  var this$ = this;
  var a$tailLocal1 = a;
  while (true) {
    var x4 = $as_s_Option(f.apply__O__O(a$tailLocal1));
    var x = $m_s_None$();
    if ((x === x4)) {
      return $m_s_None$()
    };
    if ((x4 instanceof $c_s_Some)) {
      var x10 = $as_s_util_Either($as_s_Some(x4).s_Some__f_value);
      if ((x10 instanceof $c_s_util_Left)) {
        var a1 = $as_s_util_Left(x10).s_util_Left__f_value;
        var \u03b4this$tmp1 = this$;
        this$ = \u03b4this$tmp1;
        a$tailLocal1 = a1;
        continue
      };
      if ((x10 instanceof $c_s_util_Right)) {
        var b = $as_s_util_Right(x10).s_util_Right__f_value;
        return new $c_s_Some(b)
      }
    };
    throw new $c_s_MatchError(x4)
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__s_Option__s_Option__F2__s_Option = (function(fa, fb, f) {
  if (((!fa.isEmpty__Z()) && (!fb.isEmpty__Z()))) {
    var value = f.apply__O__O__O(fa.get__O(), fb.get__O());
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__s_Option__s_Option__s_Option = (function(fa, fb) {
  if (((!fa.isEmpty__Z()) && (!fb.isEmpty__Z()))) {
    var _1 = fa.get__O();
    var _2 = fb.get__O();
    var value = new $c_T2(_1, _2);
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__s_Option__s_Option__s_Option = (function(fa, fb) {
  return ((!fa.isEmpty__Z()) ? fb : $m_s_None$())
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__s_Option__s_Option__s_Option = (function(fa, fb) {
  return ((!fb.isEmpty__Z()) ? fa : $m_s_None$())
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.ap__s_Option__s_Option__s_Option = (function(f, fa) {
  if (((!f.isEmpty__Z()) && (!fa.isEmpty__Z()))) {
    var value = $as_F1(f.get__O()).apply__O__O(fa.get__O());
    return new $c_s_Some(value)
  } else {
    return $m_s_None$()
  }
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    var value = $m_s_None$();
    return new $c_Lcats_Now(value)
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1(((f$2, a$2) => ((x$1) => {
      var x$1$1 = $as_s_Option(x$1);
      if ((x$1$1 instanceof $c_s_Some)) {
        var b = $as_s_Some(x$1$1).s_Some__f_value;
        var value$1 = f$2.apply__O__O__O(a$2, b);
        return new $c_s_Some(value$1)
      };
      var x$2 = $m_s_None$();
      if ((x$2 === x$1$1)) {
        return $m_s_None$()
      };
      throw new $c_s_MatchError(x$1$1)
    }))(f, a)))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldLeft__s_Option__O__F2__O = (function(fa, b, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return b
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return f.apply__O__O__O(b, a)
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return lb
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return $as_Lcats_Eval(f.apply__O__O__O(a, lb))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__s_Option__F1__s_Option = (function(fa, f) {
  return (fa.isEmpty__Z() ? $as_s_Option(f.apply__O__O((void 0))) : fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__s_Option__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  var x = $m_s_None$();
  if ((x === fa)) {
    return evidence$1.pure__O__O($m_s_None$())
  };
  if ((fa instanceof $c_s_Some)) {
    var a = $as_s_Some(fa).s_Some__f_value;
    return evidence$1.map__O__F1__O(f.apply__O__O(a), new $c_sjsr_AnonFunction1(((_$2) => new $c_s_Some(_$2))))
  };
  throw new $c_s_MatchError(fa)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__s_Option__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return (fa.isEmpty__Z() ? B.empty__O() : f.apply__O__O(fa.get__O()))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__s_Option__s_Option = (function(oa) {
  return ((!oa.isEmpty__Z()) ? this.Lcats_instances_OptionInstances$$anon$1__f_someUnit : $m_s_None$())
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_s_Some(x)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  return (fa$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(fa$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = $as_s_Option(fa);
  return (fa$1.isEmpty__Z() ? $m_s_None$() : $as_s_Option(f.apply__O__O(fa$1.get__O())))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_Option(a, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__s_Option__s_Option__F2__s_Option($as_s_Option(fa), $as_s_Option(fb), f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productR__O__O__O = (function(fa, fb) {
  return this.productR__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return this.productL__s_Option__s_Option__s_Option($as_s_Option(fa), $as_s_Option(fb))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__s_Option__s_Option__s_Option($as_s_Option(ff), $as_s_Option(fa))
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), fb, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_Option__O__F2__O($as_s_Option(fa), b, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_Option__Lcats_Eval__F2__Lcats_Eval($as_s_Option(fa), lb, f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.raiseError__O__O = (function(e) {
  $as_jl_Void(e);
  return $m_s_None$()
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_Option__F1__s_Option($as_s_Option(fa), f)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_Option__F1__Lcats_Applicative__O($as_s_Option(fa), f, evidence$1)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_Option__F1__Lcats_kernel_Monoid__O($as_s_Option(fa), f, B)
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_OptionInstances$$anon$1__f_someUnit
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__s_Option__s_Option($as_s_Option(fa))
});
var $d_Lcats_instances_OptionInstances$$anon$1 = new $TypeData().initClass({
  Lcats_instances_OptionInstances$$anon$1: 0
}, false, "cats.instances.OptionInstances$$anon$1", {
  Lcats_instances_OptionInstances$$anon$1: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
});
$c_Lcats_instances_OptionInstances$$anon$1.prototype.$classData = $d_Lcats_instances_OptionInstances$$anon$1;
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next
}
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
  /*<skip>*/
}
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::"
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1)
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next
});
$c_sci_$colon$colon.prototype.headOption__s_Option = (function() {
  return new $c_s_Some(this.sci_$colon$colon__f_head)
});
function $as_sci_$colon$colon(obj) {
  return (((obj instanceof $c_sci_$colon$colon) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.$colon$colon"))
}
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)))
}
function $asArrayOf_sci_$colon$colon(obj, depth) {
  return (($isArrayOf_sci_$colon$colon(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.$colon$colon;", depth))
}
var $d_sci_$colon$colon = new $TypeData().initClass({
  sci_$colon$colon: 0
}, false, "scala.collection.immutable.$colon$colon", {
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_$colon$colon.prototype.$classData = $d_sci_$colon$colon;
/** @constructor */
function $c_sci_Nil$() {
  this.sci_Nil$__f_EmptyUnzip = null;
  $n_sci_Nil$ = this;
  this.sci_Nil$__f_EmptyUnzip = new $c_T2($m_sci_Nil$(), $m_sci_Nil$())
}
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
  /*<skip>*/
}
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list")
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list")
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list")
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil"
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1)
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this)
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E()
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E()
});
$c_sci_Nil$.prototype.headOption__s_Option = (function() {
  return $m_s_None$()
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E()
});
var $d_sci_Nil$ = new $TypeData().initClass({
  sci_Nil$: 0
}, false, "scala.collection.immutable.Nil$", {
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
});
$c_sci_Nil$.prototype.$classData = $d_sci_Nil$;
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$()
  };
  return $n_sci_Nil$
}
function $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet($thiz, t) {
  return ((t === $thiz.sci_TreeSet__f_tree) ? $thiz : $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), t, $thiz.sci_TreeSet__f_ordering))
}
function $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, tree, ordering) {
  $thiz.sci_TreeSet__f_tree = tree;
  $thiz.sci_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null")
  };
  return $thiz
}
function $ct_sci_TreeSet__s_math_Ordering__($thiz, ordering) {
  $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__($thiz, null, ordering);
  return $thiz
}
/** @constructor */
function $c_sci_TreeSet() {
  this.sci_TreeSet__f_tree = null;
  this.sci_TreeSet__f_ordering = null
}
$c_sci_TreeSet.prototype = new $h_sci_AbstractSet();
$c_sci_TreeSet.prototype.constructor = $c_sci_TreeSet;
/** @constructor */
function $h_sci_TreeSet() {
  /*<skip>*/
}
$h_sci_TreeSet.prototype = $c_sci_TreeSet.prototype;
$c_sci_TreeSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_TreeSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev)
});
$c_sci_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_sci_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.sci_TreeSet__f_ordering
});
$c_sci_TreeSet.prototype.size__I = (function() {
  return $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree)
});
$c_sci_TreeSet.prototype.isEmpty__Z = (function() {
  return ($m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree) === 0)
});
$c_sci_TreeSet.prototype.head__O = (function() {
  var this$1 = $m_sci_RedBlackTree$().smallest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
$c_sci_TreeSet.prototype.last__O = (function() {
  var this$1 = $m_sci_RedBlackTree$().greatest__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree);
  return this$1.sci_RedBlackTree$Tree__f_scala$collection$immutable$RedBlackTree$Tree$$_key
});
$c_sci_TreeSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return (((ord === this.sci_TreeSet__f_ordering) && (!this.isEmpty__Z())) ? this.last__O() : $f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord))
});
$c_sci_TreeSet.prototype.drop__I__sci_TreeSet = (function(n) {
  if ((n <= 0)) {
    return this
  } else if ((n >= $m_sci_RedBlackTree$().count__sci_RedBlackTree$Tree__I(this.sci_TreeSet__f_tree))) {
    var evidence$6 = this.sci_TreeSet__f_ordering;
    return $ct_sci_TreeSet__s_math_Ordering__(new $c_sci_TreeSet(), evidence$6)
  } else {
    return $ct_sci_TreeSet__sci_RedBlackTree$Tree__s_math_Ordering__(new $c_sci_TreeSet(), $m_sci_RedBlackTree$().drop__sci_RedBlackTree$Tree__I__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, n, this.sci_TreeSet__f_ordering), this.sci_TreeSet__f_ordering)
  }
});
$c_sci_TreeSet.prototype.foreach__F1__V = (function(f) {
  $m_sci_RedBlackTree$().foreachKey__sci_RedBlackTree$Tree__F1__V(this.sci_TreeSet__f_tree, f)
});
$c_sci_TreeSet.prototype.iterator__sc_Iterator = (function() {
  $m_sci_RedBlackTree$();
  var tree = this.sci_TreeSet__f_tree;
  $m_sci_RedBlackTree$();
  var start = $m_s_None$();
  var evidence$17 = this.sci_TreeSet__f_ordering;
  return new $c_sci_RedBlackTree$KeysIterator(tree, start, evidence$17)
});
$c_sci_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_sci_RedBlackTree$().contains__sci_RedBlackTree$Tree__O__s_math_Ordering__Z(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering)
});
$c_sci_TreeSet.prototype.incl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, null, false, this.sci_TreeSet__f_ordering))
});
$c_sci_TreeSet.prototype.excl__O__sci_TreeSet = (function(elem) {
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, $m_sci_RedBlackTree$().delete__sci_RedBlackTree$Tree__O__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, elem, this.sci_TreeSet__f_ordering))
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sci_TreeSet = (function(that) {
  matchEnd4: {
    var t$2;
    if ((that instanceof $c_sci_TreeSet)) {
      var x2 = $as_sci_TreeSet(that);
      var x = this.sci_TreeSet__f_ordering;
      var x$2 = x2.sci_TreeSet__f_ordering;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var t$2 = $m_sci_RedBlackTree$().union__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__sci_RedBlackTree$Tree(this.sci_TreeSet__f_tree, x2.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering);
        break matchEnd4
      }
    };
    var it = that.iterator__sc_Iterator();
    var t = this.sci_TreeSet__f_tree;
    while (it.hasNext__Z()) {
      t = $m_sci_RedBlackTree$().update__sci_RedBlackTree$Tree__O__O__Z__s_math_Ordering__sci_RedBlackTree$Tree(t, it.next__O(), null, false, this.sci_TreeSet__f_ordering)
    };
    var t$2 = t
  };
  return $p_sci_TreeSet__newSetOrSelf__sci_RedBlackTree$Tree__sci_TreeSet(this, t$2)
});
$c_sci_TreeSet.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_sci_TreeSet)) {
    var x2 = $as_sci_TreeSet(obj);
    var x = this.sci_TreeSet__f_ordering;
    var x$2 = x2.sci_TreeSet__f_ordering;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $m_sci_RedBlackTree$().keysEqual__sci_RedBlackTree$Tree__sci_RedBlackTree$Tree__s_math_Ordering__Z(this.sci_TreeSet__f_tree, x2.sci_TreeSet__f_tree, this.sci_TreeSet__f_ordering)
    }
  };
  return $f_sc_SortedSet__equals__O__Z(this, obj)
});
$c_sci_TreeSet.prototype.className__T = (function() {
  return "TreeSet"
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5)
});
$c_sci_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_TreeSet$();
  var evidence$5 = this.sci_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__sci_TreeSet(coll, evidence$5)
});
$c_sci_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_TreeSet(that)
});
$c_sci_TreeSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_TreeSet(elem)
});
$c_sci_TreeSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_TreeSet(elem)
});
$c_sci_TreeSet.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_TreeSet(n)
});
$c_sci_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_TreeSet$()
});
function $as_sci_TreeSet(obj) {
  return (((obj instanceof $c_sci_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeSet"))
}
function $isArrayOf_sci_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSet)))
}
function $asArrayOf_sci_TreeSet(obj, depth) {
  return (($isArrayOf_sci_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeSet;", depth))
}
var $d_sci_TreeSet = new $TypeData().initClass({
  sci_TreeSet: 0
}, false, "scala.collection.immutable.TreeSet", {
  sci_TreeSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_TreeSet.prototype.$classData = $d_sci_TreeSet;
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0)
}
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
  /*<skip>*/
}
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index)
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index)
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.set(0, elem);
  return new $c_sci_Vector1(a)
});
$c_sci_Vector0$.prototype.map__F1__sci_Vector = (function(f) {
  return this
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail")
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)))
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix)
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"))
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E($uI(v1))
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i)
});
var $d_sci_Vector0$ = new $TypeData().initClass({
  sci_Vector0$: 0
}, false, "scala.collection.immutable.Vector0$", {
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector0$.prototype.$classData = $d_sci_Vector0$;
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$()
  };
  return $n_sci_Vector0$
}
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
  /*<skip>*/
}
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get((31 & io)))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < this.sci_Vector2__f_data2.u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5)
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10)
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var a1c$2 = a1$2.clone__O();
      a1c$2.set(index, elem);
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2)
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var x$6 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8)
  } else {
    var $$x5 = this.sci_Vector__f_prefix1;
    var $$x4 = this.sci_Vector2__f_len1;
    var $$x3 = this.sci_Vector2__f_data2;
    var $$x2 = this.sci_Vector2__f_len1;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$1.set(0, x);
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    return new $c_sci_Vector3($$x5, $$x4, $$x3, ((960 + $$x2) | 0), $$x1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$8 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2), 2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9)
  } else {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f), 2);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5)
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector2__f_len1) | 0);
    var x$3 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get((31 & io)))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector2(obj) {
  return (((obj instanceof $c_sci_Vector2) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector2"))
}
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)))
}
function $asArrayOf_sci_Vector2(obj, depth) {
  return (($isArrayOf_sci_Vector2(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector2;", depth))
}
var $d_sci_Vector2 = new $TypeData().initClass({
  sci_Vector2: 0
}, false, "scala.collection.immutable.Vector2", {
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector2.prototype.$classData = $d_sci_Vector2;
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
  /*<skip>*/
}
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.get(((io$2 >>> 5) | 0)).get((31 & io$2))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < this.sci_Vector3__f_data3.u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8)
      } else if ((i2 < this.sci_Vector3__f_suffix2.u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16)
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24)
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var a2c$2 = a2$2.clone__O();
      var a1$3 = a2c$2.get(idx2);
      var a1c$3 = a1$3.clone__O();
      a1c$3.set(idx1, elem);
      a2c$2.set(idx2, a1c$3);
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32)
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var a1c$4 = a1$4.clone__O();
      a1c$4.set(index, elem);
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2)
  } else if ((this.sci_Vector3__f_suffix2.u.length < 31)) {
    var x$9 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11)
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20)
  } else {
    var $$x8 = this.sci_Vector__f_prefix1;
    var $$x7 = this.sci_Vector3__f_len1;
    var $$x6 = this.sci_Vector3__f_prefix2;
    var $$x5 = this.sci_Vector3__f_len12;
    var $$x4 = this.sci_Vector3__f_data3;
    var $$x3 = this.sci_Vector3__f_len12;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$2.set(0, x);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    return new $c_sci_Vector4($$x8, $$x7, $$x6, $$x5, $$x4, ((30720 + $$x3) | 0), $$x2, a$2, $$x1, a$3, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$11 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13)
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3), 3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22)
  } else {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), 2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    return new $c_sci_Vector4(a$2, 1, $$x1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f), 2);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8)
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector3__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector3__f_len12) | 0);
    var x$4 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.get(((io$2 >>> 5) | 0)).get((31 & io$2))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector3(obj) {
  return (((obj instanceof $c_sci_Vector3) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector3"))
}
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)))
}
function $asArrayOf_sci_Vector3(obj, depth) {
  return (($isArrayOf_sci_Vector3(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector3;", depth))
}
var $d_sci_Vector3 = new $TypeData().initClass({
  sci_Vector3: 0
}, false, "scala.collection.immutable.Vector3", {
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector3.prototype.$classData = $d_sci_Vector3;
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
  /*<skip>*/
}
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.get(((io$2 >>> 10) | 0)).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.get(((io$3 >>> 5) | 0)).get((31 & io$3))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < this.sci_Vector4__f_data4.u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11)
      } else if ((i3 < this.sci_Vector4__f_suffix3.u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22)
      } else if ((i2 < this.sci_Vector4__f_suffix2.u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33)
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44)
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a3c$2 = a3$2.clone__O();
      var a2$3 = a3c$2.get(idx3);
      var a2c$3 = a2$3.clone__O();
      var a1$4 = a2c$3.get(idx2);
      var a1c$4 = a1$4.clone__O();
      a1c$4.set(idx1, elem);
      a2c$3.set(idx2, a1c$4);
      a3c$2.set(idx3, a2c$3);
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55)
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.get(idx2$1);
      var a1c$5 = a1$5.clone__O();
      a1c$5.set(idx1$1, elem);
      a2c$4.set(idx2$1, a1c$5);
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66)
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(index, elem);
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2)
  } else if ((this.sci_Vector4__f_suffix2.u.length < 31)) {
    var x$12 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14)
  } else if ((this.sci_Vector4__f_suffix3.u.length < 31)) {
    var x$23 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26)
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var x$34 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38)
  } else {
    var $$x11 = this.sci_Vector__f_prefix1;
    var $$x10 = this.sci_Vector4__f_len1;
    var $$x9 = this.sci_Vector4__f_prefix2;
    var $$x8 = this.sci_Vector4__f_len12;
    var $$x7 = this.sci_Vector4__f_prefix3;
    var $$x6 = this.sci_Vector4__f_len123;
    var $$x5 = this.sci_Vector4__f_data4;
    var $$x4 = this.sci_Vector4__f_len123;
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.set(0, x);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    return new $c_sci_Vector5($$x11, $$x10, $$x9, $$x8, $$x7, $$x6, $$x5, ((983040 + $$x4) | 0), $$x3, a$3, $$x2, $$x1, a$4, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$14 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), 2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17)
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29)
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4), 4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41)
  } else {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), 3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    return new $c_sci_Vector5(a$3, 1, $$x2, 1, $$x1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f), 3);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f), 2);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11)
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector4__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector4__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector4__f_len123) | 0);
    var x$5 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.get(((io$2 >>> 10) | 0)).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.get(((io$3 >>> 5) | 0)).get((31 & io$3))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector4(obj) {
  return (((obj instanceof $c_sci_Vector4) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector4"))
}
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)))
}
function $asArrayOf_sci_Vector4(obj, depth) {
  return (($isArrayOf_sci_Vector4(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector4;", depth))
}
var $d_sci_Vector4 = new $TypeData().initClass({
  sci_Vector4: 0
}, false, "scala.collection.immutable.Vector4", {
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector4.prototype.$classData = $d_sci_Vector4;
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
  /*<skip>*/
}
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.get(((io$2 >>> 15) | 0)).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.get(((io$3 >>> 10) | 0)).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.get(((io$4 >>> 5) | 0)).get((31 & io$4))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < this.sci_Vector5__f_data5.u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var a5c = a5.clone__O();
        var a4 = a5c.get(i5);
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14)
      } else if ((i4 < this.sci_Vector5__f_suffix4.u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.get(i4);
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28)
      } else if ((i3 < this.sci_Vector5__f_suffix3.u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.get(i3);
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42)
      } else if ((i2 < this.sci_Vector5__f_suffix2.u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.get(i2);
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56)
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var a1c$4 = a1$4.clone__O();
        a1c$4.set(i1, elem);
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70)
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a4c$2 = a4$2.clone__O();
      var a3$3 = a4c$2.get(idx4);
      var a3c$3 = a3$3.clone__O();
      var a2$4 = a3c$3.get(idx3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.get(idx2);
      var a1c$5 = a1$5.clone__O();
      a1c$5.set(idx1, elem);
      a2c$4.set(idx2, a1c$5);
      a3c$3.set(idx3, a2c$4);
      a4c$2.set(idx4, a3c$3);
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84)
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.get(idx3$1);
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.get(idx2$1);
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(idx1$1, elem);
      a2c$5.set(idx2$1, a1c$6);
      a3c$4.set(idx3$1, a2c$5);
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98)
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.get(idx2$2);
      var a1c$7 = a1$7.clone__O();
      a1c$7.set(idx1$2, elem);
      a2c$6.set(idx2$2, a1c$7);
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112)
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var a1c$8 = a1$8.clone__O();
      a1c$8.set(index, elem);
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2)
  } else if ((this.sci_Vector5__f_suffix2.u.length < 31)) {
    var x$15 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17)
  } else if ((this.sci_Vector5__f_suffix3.u.length < 31)) {
    var x$29 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32)
  } else if ((this.sci_Vector5__f_suffix4.u.length < 31)) {
    var x$43 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47)
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var x$57 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62)
  } else {
    var $$x14 = this.sci_Vector__f_prefix1;
    var $$x13 = this.sci_Vector5__f_len1;
    var $$x12 = this.sci_Vector5__f_prefix2;
    var $$x11 = this.sci_Vector5__f_len12;
    var $$x10 = this.sci_Vector5__f_prefix3;
    var $$x9 = this.sci_Vector5__f_len123;
    var $$x8 = this.sci_Vector5__f_prefix4;
    var $$x7 = this.sci_Vector5__f_len1234;
    var $$x6 = this.sci_Vector5__f_data5;
    var $$x5 = this.sci_Vector5__f_len1234;
    var $$x4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.set(0, x);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    a$5.set(0, elem);
    return new $c_sci_Vector6($$x14, $$x13, $$x12, $$x11, $$x10, $$x9, $$x8, $$x7, $$x6, ((31457280 + $$x5) | 0), $$x4, a$4, $$x3, $$x2, $$x1, a$5, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$17 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), 2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21)
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), 3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36)
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51)
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5), 5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66)
  } else {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var $$x3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $$x2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $$x1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), 4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$5.set(0, x);
    return new $c_sci_Vector6(a$4, 1, $$x3, 1, $$x2, 1, $$x1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0))
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f), 4);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f), 3);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f), 2);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14)
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector5__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector5__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector5__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector5__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1)))))
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.get(((io$2 >>> 15) | 0)).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.get(((io$3 >>> 10) | 0)).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.get(((io$4 >>> 5) | 0)).get((31 & io$4))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector5(obj) {
  return (((obj instanceof $c_sci_Vector5) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector5"))
}
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)))
}
function $asArrayOf_sci_Vector5(obj, depth) {
  return (($isArrayOf_sci_Vector5(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector5;", depth))
}
var $d_sci_Vector5 = new $TypeData().initClass({
  sci_Vector5: 0
}, false, "scala.collection.immutable.Vector5", {
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector5.prototype.$classData = $d_sci_Vector5;
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0)
}
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
  /*<skip>*/
}
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.get(i6).get(i5).get(i4).get(i3).get(i2).get(i1) : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.get(((io$2 >>> 20) | 0)).get((31 & ((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.get(((io$3 >>> 15) | 0)).get((31 & ((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.get(((io$4 >>> 10) | 0)).get((31 & ((io$4 >>> 5) | 0))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.get(((io$5 >>> 5) | 0)).get((31 & io$5))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < this.sci_Vector6__f_data6.u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var a6c = a6.clone__O();
        var a5 = a6c.get(i6);
        var a5c = a5.clone__O();
        var a4 = a5c.get(i5);
        var a4c = a4.clone__O();
        var a3 = a4c.get(i4);
        var a3c = a3.clone__O();
        var a2 = a3c.get(i3);
        var a2c = a2.clone__O();
        var a1 = a2c.get(i2);
        var a1c = a1.clone__O();
        a1c.set(i1, elem);
        a2c.set(i2, a1c);
        a3c.set(i3, a2c);
        a4c.set(i4, a3c);
        a5c.set(i5, a4c);
        a6c.set(i6, a5c);
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17)
      } else if ((i5 < this.sci_Vector6__f_suffix5.u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var a5c$1 = a5$1.clone__O();
        var a4$1 = a5c$1.get(i5);
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.get(i4);
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.get(i3);
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.get(i2);
        var a1c$1 = a1$1.clone__O();
        a1c$1.set(i1, elem);
        a2c$1.set(i2, a1c$1);
        a3c$1.set(i3, a2c$1);
        a4c$1.set(i4, a3c$1);
        a5c$1.set(i5, a4c$1);
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34)
      } else if ((i4 < this.sci_Vector6__f_suffix4.u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var a4c$2 = a4$2.clone__O();
        var a3$2 = a4c$2.get(i4);
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.get(i3);
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.get(i2);
        var a1c$2 = a1$2.clone__O();
        a1c$2.set(i1, elem);
        a2c$2.set(i2, a1c$2);
        a3c$2.set(i3, a2c$2);
        a4c$2.set(i4, a3c$2);
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51)
      } else if ((i3 < this.sci_Vector6__f_suffix3.u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var a3c$3 = a3$3.clone__O();
        var a2$3 = a3c$3.get(i3);
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.get(i2);
        var a1c$3 = a1$3.clone__O();
        a1c$3.set(i1, elem);
        a2c$3.set(i2, a1c$3);
        a3c$3.set(i3, a2c$3);
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68)
      } else if ((i2 < this.sci_Vector6__f_suffix2.u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var a2c$4 = a2$4.clone__O();
        var a1$4 = a2c$4.get(i2);
        var a1c$4 = a1$4.clone__O();
        a1c$4.set(i1, elem);
        a2c$4.set(i2, a1c$4);
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85)
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var a1c$5 = a1$5.clone__O();
        a1c$5.set(i1, elem);
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102)
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a5c$2 = a5$2.clone__O();
      var a4$3 = a5c$2.get(idx5);
      var a4c$3 = a4$3.clone__O();
      var a3$4 = a4c$3.get(idx4);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.get(idx3);
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.get(idx2);
      var a1c$6 = a1$6.clone__O();
      a1c$6.set(idx1, elem);
      a2c$5.set(idx2, a1c$6);
      a3c$4.set(idx3, a2c$5);
      a4c$3.set(idx4, a3c$4);
      a5c$2.set(idx5, a4c$3);
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119)
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a4c$4 = a4$4.clone__O();
      var a3$5 = a4c$4.get(idx4$1);
      var a3c$5 = a3$5.clone__O();
      var a2$6 = a3c$5.get(idx3$1);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.get(idx2$1);
      var a1c$7 = a1$7.clone__O();
      a1c$7.set(idx1$1, elem);
      a2c$6.set(idx2$1, a1c$7);
      a3c$5.set(idx3$1, a2c$6);
      a4c$4.set(idx4$1, a3c$5);
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136)
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var a3c$6 = a3$6.clone__O();
      var a2$7 = a3c$6.get(idx3$2);
      var a2c$7 = a2$7.clone__O();
      var a1$8 = a2c$7.get(idx2$2);
      var a1c$8 = a1$8.clone__O();
      a1c$8.set(idx1$2, elem);
      a2c$7.set(idx2$2, a1c$8);
      a3c$6.set(idx3$2, a2c$7);
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153)
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var a2c$8 = a2$8.clone__O();
      var a1$9 = a2c$8.get(idx2$3);
      var a1c$9 = a1$9.clone__O();
      a1c$9.set(idx1$3, elem);
      a2c$8.set(idx2$3, a1c$9);
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170)
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var a1c$10 = a1$10.clone__O();
      a1c$10.set(index, elem);
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2)
  } else if ((this.sci_Vector6__f_suffix2.u.length < 31)) {
    var x$18 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1), 2);
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20)
  } else if ((this.sci_Vector6__f_suffix3.u.length < 31)) {
    var x$35 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)), 3);
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38)
  } else if ((this.sci_Vector6__f_suffix4.u.length < 31)) {
    var x$52 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))), 4);
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56)
  } else if ((this.sci_Vector6__f_suffix5.u.length < 31)) {
    var x$69 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))), 5);
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74)
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var x$86 = $asArrayOf_O($m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))))), 6);
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.set(0, elem);
    var x$20 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), 2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25)
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.set(0, elem);
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), 3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43)
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.set(0, elem);
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), 4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61)
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.set(0, elem);
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), 5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79)
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.set(0, elem);
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $asArrayOf_O($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6), 6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97)
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException())
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f), 2);
  var x$3 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f), 3);
  var x$4 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f), 4);
  var x$5 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f), 5);
  var x$6 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f), 6);
  var x$7 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f), 5);
  var x$8 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f), 4);
  var x$9 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f), 3);
  var x$10 = $asArrayOf_O($m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f), 2);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17)
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector()
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector6__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector6__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector6__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector6__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_Vector6__f_len12345) | 0);
    var x$7 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7)
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0)
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break
    }
    default: {
      throw new $c_s_MatchError(idx)
    }
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2)
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k)
  }
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector()
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f)
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.get(i6).get(i5).get(i4).get(i3).get(i2).get(i1) : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.get(i5).get(i4).get(i3).get(i2).get(i1) : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.get(i4).get(i3).get(i2).get(i1) : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.get(i3).get(i2).get(i1) : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.get(i2).get(i1) : this.sci_BigVector__f_suffix1.get(i1))))))
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.get(((io$2 >>> 20) | 0)).get((31 & ((io$2 >>> 15) | 0))).get((31 & ((io$2 >>> 10) | 0))).get((31 & ((io$2 >>> 5) | 0))).get((31 & io$2))
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.get(((io$3 >>> 15) | 0)).get((31 & ((io$3 >>> 10) | 0))).get((31 & ((io$3 >>> 5) | 0))).get((31 & io$3))
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.get(((io$4 >>> 10) | 0)).get((31 & ((io$4 >>> 5) | 0))).get((31 & io$4))
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.get(((io$5 >>> 5) | 0)).get((31 & io$5))
    } else {
      return this.sci_Vector__f_prefix1.get(index)
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index)
  }
});
function $as_sci_Vector6(obj) {
  return (((obj instanceof $c_sci_Vector6) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.Vector6"))
}
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)))
}
function $asArrayOf_sci_Vector6(obj, depth) {
  return (($isArrayOf_sci_Vector6(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.Vector6;", depth))
}
var $d_sci_Vector6 = new $TypeData().initClass({
  sci_Vector6: 0
}, false, "scala.collection.immutable.Vector6", {
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_sci_Vector6.prototype.$classData = $d_sci_Vector6;
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz
}
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz
}
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz
}
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null
}
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
  /*<skip>*/
}
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_scm_StringBuilder.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_StringBuilder.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(0))
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_StringBuilder__f_underlying.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs)
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()))
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I()
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I()
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.addAll__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var x2 = $as_sci_WrappedString(xs);
    var this$3 = this.scm_StringBuilder__f_underlying;
    $m_sci_WrappedString$();
    var str = x2.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str)
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    var x3 = $as_scm_ArraySeq$ofChar(xs);
    this.scm_StringBuilder__f_underlying.append__AC__jl_StringBuilder(x3.scm_ArraySeq$ofChar__f_array)
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var x4 = $as_scm_StringBuilder(xs);
    var this$4 = this.scm_StringBuilder__f_underlying;
    var s = x4.scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s)
  } else {
    var ks = xs.knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        b.length__I()
      };
      var it = xs.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var c = $uC(it.next__O());
        var str$1 = $as_T(String.fromCharCode(c));
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1)
      }
    }
  };
  return this
});
$c_scm_StringBuilder.prototype.append__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = $as_T(String.fromCharCode(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return (this.scm_StringBuilder__f_underlying.length__I() === 0)
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$()
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem))
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll)
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i))
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i))
});
function $as_scm_StringBuilder(obj) {
  return (((obj instanceof $c_scm_StringBuilder) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.StringBuilder"))
}
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)))
}
function $asArrayOf_scm_StringBuilder(obj, depth) {
  return (($isArrayOf_scm_StringBuilder(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.StringBuilder;", depth))
}
var $d_scm_StringBuilder = new $TypeData().initClass({
  scm_StringBuilder: 0
}, false, "scala.collection.mutable.StringBuilder", {
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
});
$c_scm_StringBuilder.prototype.$classData = $d_scm_StringBuilder;
/** @constructor */
function $c_sci_BitSet() {
  /*<skip>*/
}
$c_sci_BitSet.prototype = new $h_sci_AbstractSet();
$c_sci_BitSet.prototype.constructor = $c_sci_BitSet;
/** @constructor */
function $h_sci_BitSet() {
  /*<skip>*/
}
$h_sci_BitSet.prototype = $c_sci_BitSet.prototype;
$c_sci_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet"
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$max__s_math_Ordering__I = (function(ord) {
  return $uI($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord))
});
$c_sci_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  return $as_sc_BitSet($f_sci_StrictOptimizedSetOps__concat__sc_IterableOnce__sci_SetOps(this, that))
});
$c_sci_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$()
});
$c_sci_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0)
});
$c_sci_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this)
});
$c_sci_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this)
});
$c_sci_BitSet.prototype.foreach__F1__V = (function(f) {
  $f_sc_BitSetOps__foreach__F1__V(this, f)
});
$c_sci_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_sci_SortedSet$()
});
$c_sci_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_sci_BitSet.prototype.incl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0")
  };
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    return this
  } else {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$2.RTLong__f_lo | lo);
    var hi$1 = (this$2.RTLong__f_hi | hi);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$1, hi$1))
  }
});
$c_sci_BitSet.prototype.excl__I__sci_BitSet = (function(elem) {
  var requirement = (elem >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bitset element must be >= 0")
  };
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$2 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$2.RTLong__f_lo & lo$1);
    var hi$2 = (this$2.RTLong__f_hi & hi$1);
    return this.updateWord__I__J__sci_BitSet(idx, new $c_RTLong(lo$2, hi$2))
  } else {
    return this
  }
});
$c_sci_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that)
});
$c_sci_BitSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord)
});
$c_sci_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1)
});
$c_sci_BitSet.prototype.flatMap__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__flatMap__F1__s_math_Ordering__sc_SortedSet(this, f, ev))
});
$c_sci_BitSet.prototype.map__F1__s_math_Ordering__sc_SortedSet = (function(f, ev) {
  return $as_sci_SortedSet($f_sc_StrictOptimizedSortedSetOps__map__F1__s_math_Ordering__sc_SortedSet(this, f, ev))
});
$c_sci_BitSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__I__sci_BitSet($uI(elem))
});
$c_sci_BitSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__I__sci_BitSet($uI(elem))
});
$c_sci_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll)
});
$c_sci_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_BitSet$().fromSpecific__sc_IterableOnce__sci_BitSet(coll)
});
function $as_sci_BitSet(obj) {
  return (((obj instanceof $c_sci_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.BitSet"))
}
function $isArrayOf_sci_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitSet)))
}
function $asArrayOf_sci_BitSet(obj, depth) {
  return (($isArrayOf_sci_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.BitSet;", depth))
}
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = buf.scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = buf.scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false
}
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz)
  }
}
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0
}
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
  /*<skip>*/
}
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_scm_ListBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ListBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator(this.scm_ListBuffer__f_first.iterator__sc_Iterator(), new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.scm_ListBuffer__f_mutationCount))(this)))
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$()
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0)
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1
  } else {
    this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = last1
  };
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this
});
$c_scm_ListBuffer.prototype.scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
    this.scm_ListBuffer__f_first = last0;
    while (it.hasNext__Z()) {
      var last1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      last0.sci_$colon$colon__f_next = last1;
      last0 = last1;
      len = ((1 + len) | 0)
    };
    this.scm_ListBuffer__f_len = len;
    this.scm_ListBuffer__f_last0 = last0
  };
  return this
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var fresh = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.scm_ListBuffer__f_len === 0)) {
      this.scm_ListBuffer__f_first = fresh.scm_ListBuffer__f_first
    } else {
      this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = fresh.scm_ListBuffer__f_first
    };
    this.scm_ListBuffer__f_last0 = fresh.scm_ListBuffer__f_last0;
    this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len + fresh.scm_ListBuffer__f_len) | 0)
  };
  return this
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer"
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(xs)
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem)
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List()
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = $uI(v1);
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i)
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$()
});
function $as_scm_ListBuffer(obj) {
  return (((obj instanceof $c_scm_ListBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ListBuffer"))
}
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)))
}
function $asArrayOf_scm_ListBuffer(obj, depth) {
  return (($isArrayOf_scm_ListBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ListBuffer;", depth))
}
var $d_scm_ListBuffer = new $TypeData().initClass({
  scm_ListBuffer: 0
}, false, "scala.collection.mutable.ListBuffer", {
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ListBuffer.prototype.$classData = $d_scm_ListBuffer;
/** @constructor */
function $c_sci_BitSet$BitSet1(elems) {
  this.sci_BitSet$BitSet1__f_elems = $L0;
  this.sci_BitSet$BitSet1__f_elems = elems
}
$c_sci_BitSet$BitSet1.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet1.prototype.constructor = $c_sci_BitSet$BitSet1;
/** @constructor */
function $h_sci_BitSet$BitSet1() {
  /*<skip>*/
}
$h_sci_BitSet$BitSet1.prototype = $c_sci_BitSet$BitSet1.prototype;
$c_sci_BitSet$BitSet1.prototype.nwords__I = (function() {
  return 1
});
$c_sci_BitSet$BitSet1.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet1__f_elems : $L0)
});
$c_sci_BitSet$BitSet1.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet1(w)
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet1__f_elems, w)
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet1__f_elems]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
  }
});
var $d_sci_BitSet$BitSet1 = new $TypeData().initClass({
  sci_BitSet$BitSet1: 0
}, false, "scala.collection.immutable.BitSet$BitSet1", {
  sci_BitSet$BitSet1: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSet1.prototype.$classData = $d_sci_BitSet$BitSet1;
/** @constructor */
function $c_sci_BitSet$BitSet2(elems0, elems1) {
  this.sci_BitSet$BitSet2__f_elems0 = $L0;
  this.sci_BitSet$BitSet2__f_elems1 = $L0;
  this.sci_BitSet$BitSet2__f_elems0 = elems0;
  this.sci_BitSet$BitSet2__f_elems1 = elems1
}
$c_sci_BitSet$BitSet2.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSet2.prototype.constructor = $c_sci_BitSet$BitSet2;
/** @constructor */
function $h_sci_BitSet$BitSet2() {
  /*<skip>*/
}
$h_sci_BitSet$BitSet2.prototype = $c_sci_BitSet$BitSet2.prototype;
$c_sci_BitSet$BitSet2.prototype.nwords__I = (function() {
  return 2
});
$c_sci_BitSet$BitSet2.prototype.word__I__J = (function(idx) {
  return ((idx === 0) ? this.sci_BitSet$BitSet2__f_elems0 : ((idx === 1) ? this.sci_BitSet$BitSet2__f_elems1 : $L0))
});
$c_sci_BitSet$BitSet2.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  if ((idx === 0)) {
    return new $c_sci_BitSet$BitSet2(w, this.sci_BitSet$BitSet2__f_elems1)
  } else if ((idx === 1)) {
    return $m_sci_BitSet$().scala$collection$immutable$BitSet$$createSmall__J__J__sci_BitSet(this.sci_BitSet$BitSet2__f_elems0, w)
  } else {
    var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(new $ac_J([this.sci_BitSet$BitSet2__f_elems0, this.sci_BitSet$BitSet2__f_elems1]), idx, w);
    return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
  }
});
var $d_sci_BitSet$BitSet2 = new $TypeData().initClass({
  sci_BitSet$BitSet2: 0
}, false, "scala.collection.immutable.BitSet$BitSet2", {
  sci_BitSet$BitSet2: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSet2.prototype.$classData = $d_sci_BitSet$BitSet2;
/** @constructor */
function $c_sci_BitSet$BitSetN(elems) {
  this.sci_BitSet$BitSetN__f_elems = null;
  this.sci_BitSet$BitSetN__f_elems = elems
}
$c_sci_BitSet$BitSetN.prototype = new $h_sci_BitSet();
$c_sci_BitSet$BitSetN.prototype.constructor = $c_sci_BitSet$BitSetN;
/** @constructor */
function $h_sci_BitSet$BitSetN() {
  /*<skip>*/
}
$h_sci_BitSet$BitSetN.prototype = $c_sci_BitSet$BitSetN.prototype;
$c_sci_BitSet$BitSetN.prototype.nwords__I = (function() {
  return this.sci_BitSet$BitSetN__f_elems.u.length
});
$c_sci_BitSet$BitSetN.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? this.sci_BitSet$BitSetN__f_elems.get(idx) : $L0)
});
$c_sci_BitSet$BitSetN.prototype.updateWord__I__J__sci_BitSet = (function(idx, w) {
  var elems = $m_sc_BitSetOps$().updateArray__AJ__I__J__AJ(this.sci_BitSet$BitSetN__f_elems, idx, w);
  return $m_sci_BitSet$().fromBitMaskNoCopy__AJ__sci_BitSet(elems)
});
var $d_sci_BitSet$BitSetN = new $TypeData().initClass({
  sci_BitSet$BitSetN: 0
}, false, "scala.collection.immutable.BitSet$BitSetN", {
  sci_BitSet$BitSetN: 1,
  sci_BitSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  sci_SortedSetOps: 1,
  sci_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_sci_BitSet$BitSetN.prototype.$classData = $d_sci_BitSet$BitSetN;
function $as_sci_TreeMap(obj) {
  return ((false || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.immutable.TreeMap"))
}
function $isArrayOf_sci_TreeMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeMap)))
}
function $asArrayOf_sci_TreeMap(obj, depth) {
  return (($isArrayOf_sci_TreeMap(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.immutable.TreeMap;", depth))
}
function $ct_Lcats_effect_kernel_ResourceAsync__($thiz) {
  $f_Lcats_effect_kernel_Sync__$init$__V($thiz);
  return $thiz
}
/** @constructor */
function $c_Lcats_effect_kernel_ResourceAsync() {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$InterruptibleOnce = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$InterruptibleMany = null
}
$c_Lcats_effect_kernel_ResourceAsync.prototype = new $h_Lcats_effect_kernel_ResourceConcurrent();
$c_Lcats_effect_kernel_ResourceAsync.prototype.constructor = $c_Lcats_effect_kernel_ResourceAsync;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceAsync() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceAsync.prototype = $c_Lcats_effect_kernel_ResourceAsync.prototype;
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = x$0
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking = x$0
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$InterruptibleOnce = x$0
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$InterruptibleMany = x$0
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay;
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.async__F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async__F1__O(this, k)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.async___F1__O = (function(k) {
  return $f_Lcats_effect_kernel_Async__async___F1__O(this, k)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.unique__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1;
  var fa = F.unique__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.never__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1;
  var fa = F.never__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.cont__Lcats_effect_kernel_Cont__O = (function(body) {
  return $m_Lcats_effect_kernel_Resource$().cont__Lcats_effect_kernel_Cont__Lcats_effect_kernel_Async__Lcats_effect_kernel_Resource(body, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.executionContext__O = (function() {
  var F = this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1;
  var fa = F.executionContext__O();
  return new $c_Lcats_effect_kernel_Resource$Eval(fa)
});
$c_Lcats_effect_kernel_ResourceAsync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return $m_Lcats_effect_kernel_Resource$().suspend__Lcats_effect_kernel_Sync$Type__F0__Lcats_effect_kernel_Sync__Lcats_effect_kernel_Resource(hint, thunk, this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1)
});
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_mutationCount = 0;
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz
}
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz
}
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_mutationCount = 0;
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0
}
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
  /*<skip>*/
}
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  return this.view__scm_ArrayBufferView().iterator__sc_Iterator()
});
$c_scm_ArrayBuffer.prototype.reverseIterator__sc_Iterator = (function() {
  return this.view__scm_ArrayBufferView().reverseIterator__sc_Iterator()
});
$c_scm_ArrayBuffer.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  this.scm_ArrayBuffer__f_array = $m_scm_ArrayBuffer$().scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, n)
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  return this.scm_ArrayBuffer__f_array.get(n)
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((((((-1) + hi) | 0) + " is out of bounds (min 0, max ") + (((-1) + this.scm_ArrayBuffer__f_size0) | 0)) + ")"))
  };
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  this.scm_ArrayBuffer__f_array.set(index, elem)
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0
});
$c_scm_ArrayBuffer.prototype.view__scm_ArrayBufferView = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sjsr_AnonFunction0(((this$1) => (() => this$1.scm_ArrayBuffer__f_mutationCount))(this)))
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  var oldSize = this.scm_ArrayBuffer__f_size0;
  this.ensureSize__I__V(((1 + oldSize) | 0));
  this.scm_ArrayBuffer__f_size0 = ((1 + oldSize) | 0);
  this.update__I__O__V(oldSize, elem);
  return this
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var x2 = $as_scm_ArrayBuffer(elems);
    var elemsLength = x2.scm_ArrayBuffer__f_size0;
    if ((elemsLength > 0)) {
      this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
      this.ensureSize__I__V(((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0));
      $m_s_Array$().copy__O__I__O__I__I__V(x2.scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, elemsLength);
      this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0)
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems)
  };
  return this
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer"
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(xs);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - start) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied)
  };
  return copied
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(xs)
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem)
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$()
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
function $as_scm_ArrayBuffer(obj) {
  return (((obj instanceof $c_scm_ArrayBuffer) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayBuffer"))
}
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)))
}
function $asArrayOf_scm_ArrayBuffer(obj, depth) {
  return (($isArrayOf_scm_ArrayBuffer(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayBuffer;", depth))
}
var $d_scm_ArrayBuffer = new $TypeData().initClass({
  scm_ArrayBuffer: 0
}, false, "scala.collection.mutable.ArrayBuffer", {
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayBuffer.prototype.$classData = $d_scm_ArrayBuffer;
/** @constructor */
function $c_scm_TreeSet(tree, ordering) {
  this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = null;
  this.scm_TreeSet__f_ordering = null;
  this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree = tree;
  this.scm_TreeSet__f_ordering = ordering;
  if ((ordering === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "ordering must not be null")
  }
}
$c_scm_TreeSet.prototype = new $h_scm_AbstractSet();
$c_scm_TreeSet.prototype.constructor = $c_scm_TreeSet;
/** @constructor */
function $h_scm_TreeSet() {
  /*<skip>*/
}
$h_scm_TreeSet.prototype = $c_scm_TreeSet.prototype;
$c_scm_TreeSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var evidence$12 = this.scm_TreeSet__f_ordering;
  var b = new $c_scm_TreeSet$$anon$1(evidence$12);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, this);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(b, that);
  return b.result__scm_TreeSet()
});
$c_scm_TreeSet.prototype.stringPrefix__T = (function() {
  return "SortedSet"
});
$c_scm_TreeSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_scm_TreeSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord)
});
$c_scm_TreeSet.prototype.ordering__s_math_Ordering = (function() {
  return this.scm_TreeSet__f_ordering
});
$c_scm_TreeSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_TreeSet$()
});
$c_scm_TreeSet.prototype.iterator__sc_Iterator = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  var start = $m_s_None$();
  var end = $m_s_None$();
  var evidence$4 = this.scm_TreeSet__f_ordering;
  return new $c_scm_RedBlackTree$KeysIterator(tree, start, end, evidence$4)
});
$c_scm_TreeSet.prototype.addOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().insert__scm_RedBlackTree$Tree__O__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, null, this.scm_TreeSet__f_ordering);
  return this
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_TreeSet = (function(elem) {
  $m_scm_RedBlackTree$().delete__scm_RedBlackTree$Tree__O__s_math_Ordering__V(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering);
  return this
});
$c_scm_TreeSet.prototype.contains__O__Z = (function(elem) {
  return $m_scm_RedBlackTree$().contains__scm_RedBlackTree$Tree__O__s_math_Ordering__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree, elem, this.scm_TreeSet__f_ordering)
});
$c_scm_TreeSet.prototype.className__T = (function() {
  return "TreeSet"
});
$c_scm_TreeSet.prototype.size__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return tree.scm_RedBlackTree$Tree__f_size
});
$c_scm_TreeSet.prototype.knownSize__I = (function() {
  var tree = this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree;
  return tree.scm_RedBlackTree$Tree__f_size
});
$c_scm_TreeSet.prototype.isEmpty__Z = (function() {
  return $m_scm_RedBlackTree$().isEmpty__scm_RedBlackTree$Tree__Z(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree)
});
$c_scm_TreeSet.prototype.head__O = (function() {
  return $m_scm_RedBlackTree$().minKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree).get__O()
});
$c_scm_TreeSet.prototype.last__O = (function() {
  return $m_scm_RedBlackTree$().maxKey__scm_RedBlackTree$Tree__s_Option(this.scm_TreeSet__f_scala$collection$mutable$TreeSet$$tree).get__O()
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5)
});
$c_scm_TreeSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_scm_TreeSet$();
  var evidence$5 = this.scm_TreeSet__f_ordering;
  return this$1.from__sc_IterableOnce__s_math_Ordering__scm_TreeSet(coll, evidence$5)
});
$c_scm_TreeSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_TreeSet(elem)
});
$c_scm_TreeSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_TreeSet(elem)
});
function $as_scm_TreeSet(obj) {
  return (((obj instanceof $c_scm_TreeSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.TreeSet"))
}
function $isArrayOf_scm_TreeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_TreeSet)))
}
function $asArrayOf_scm_TreeSet(obj, depth) {
  return (($isArrayOf_scm_TreeSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.TreeSet;", depth))
}
var $d_scm_TreeSet = new $TypeData().initClass({
  scm_TreeSet: 0
}, false, "scala.collection.mutable.TreeSet", {
  scm_TreeSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_TreeSet.prototype.$classData = $d_scm_TreeSet;
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz
}
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz
}
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null
}
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
  /*<skip>*/
}
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
  /*<skip>*/
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq"
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_sjs_js_WrappedArray.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_sjs_js_WrappedArray.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[0]
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_sjs_js_WrappedArray.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_sjs_js_WrappedArray.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return $uI(this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length)
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray"
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = $uI(v1);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index]
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$()
});
function $as_sjs_js_WrappedArray(obj) {
  return (((obj instanceof $c_sjs_js_WrappedArray) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.scalajs.js.WrappedArray"))
}
function $isArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_WrappedArray)))
}
function $asArrayOf_sjs_js_WrappedArray(obj, depth) {
  return (($isArrayOf_sjs_js_WrappedArray(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.scalajs.js.WrappedArray;", depth))
}
var $d_sjs_js_WrappedArray = new $TypeData().initClass({
  sjs_js_WrappedArray: 0
}, false, "scala.scalajs.js.WrappedArray", {
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
});
$c_sjs_js_WrappedArray.prototype.$classData = $d_sjs_js_WrappedArray;
/** @constructor */
function $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1(F0$12) {
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$Blocking = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$InterruptibleOnce = null;
  this.Lcats_effect_kernel_ResourceAsync__f_cats$effect$kernel$Sync$$InterruptibleMany = null;
  this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1 = null;
  this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1 = F0$12;
  $ct_Lcats_effect_kernel_ResourceAsync__(this)
}
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype = new $h_Lcats_effect_kernel_ResourceAsync();
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_ResourceHOInstances0$$anon$1() {
  /*<skip>*/
}
$h_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype = $c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype;
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype.F__Lcats_effect_kernel_MonadCancel = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1
});
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype.F__Lcats_MonadError = (function() {
  return this.Lcats_effect_kernel_ResourceHOInstances0$$anon$1__f_F0$1
});
var $d_Lcats_effect_kernel_ResourceHOInstances0$$anon$1 = new $TypeData().initClass({
  Lcats_effect_kernel_ResourceHOInstances0$$anon$1: 0
}, false, "cats.effect.kernel.ResourceHOInstances0$$anon$1", {
  Lcats_effect_kernel_ResourceHOInstances0$$anon$1: 1,
  Lcats_effect_kernel_ResourceAsync: 1,
  Lcats_effect_kernel_ResourceConcurrent: 1,
  Lcats_effect_kernel_ResourceMonadCancel: 1,
  Lcats_effect_kernel_ResourceMonadError: 1,
  Lcats_effect_kernel_ResourceMonad: 1,
  O: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_ApplicativeError: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_effect_kernel_GenSpawn: 1,
  Lcats_effect_kernel_GenConcurrent: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_ResourceClock: 1,
  Lcats_effect_kernel_GenTemporal: 1,
  Lcats_effect_kernel_ResourceTemporal: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_effect_kernel_ResourceSync: 1,
  Lcats_effect_kernel_AsyncPlatform: 1,
  Lcats_effect_kernel_Async: 1
});
$c_Lcats_effect_kernel_ResourceHOInstances0$$anon$1.prototype.$classData = $d_Lcats_effect_kernel_ResourceHOInstances0$$anon$1;
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  var assertion = ((array.u.length & (((-1) + array.u.length) | 0)) === 0);
  if ((!assertion)) {
    throw new $c_jl_AssertionError("assertion failed: Array.length must be power of 2")
  };
  var until = array.u.length;
  if (((start < 0) || (start >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((start + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
  };
  var until$1 = array.u.length;
  if (((end < 0) || (end >= until$1))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((end + " is out of bounds (min 0, max ") + (((-1) + until$1) | 0)) + ")"))
  };
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end
}
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.scm_ArrayDeque__f_array, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
  return $thiz
}
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().alloc__I__AO(initialSize), 0, 0);
  return $thiz
}
/** @constructor */
function $c_scm_ArrayDeque() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0
}
$c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayDeque.prototype.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
  /*<skip>*/
}
$h_scm_ArrayDeque.prototype = $c_scm_ArrayDeque.prototype;
$c_scm_ArrayDeque.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f)
});
$c_scm_ArrayDeque.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix)
});
$c_scm_ArrayDeque.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f)
});
$c_scm_ArrayDeque.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1)
});
$c_scm_ArrayDeque.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1)
});
$c_scm_ArrayDeque.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_IndexedSeqView$Reverse(this)
});
$c_scm_ArrayDeque.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n)
});
$c_scm_ArrayDeque.prototype.head__O = (function() {
  return this.apply__I__O(0)
});
$c_scm_ArrayDeque.prototype.lengthCompare__I__I = (function(len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var x = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1))
});
$c_scm_ArrayDeque.prototype.knownSize__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))
});
$c_scm_ArrayDeque.prototype.apply__I__O = (function(idx) {
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + until) | 0)) + ")"))
  };
  return this.scm_ArrayDeque__f_array.get((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0)))
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_ArrayDeque = (function(elem) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var hint = ((1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) | 0);
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) && (hint >= this.scm_ArrayDeque__f_array.u.length))) {
    this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint)
  };
  this.scm_ArrayDeque__f_array.set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, elem);
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  return this
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_ArrayDeque = (function(elems) {
  var x1 = elems.knownSize__I();
  if ((x1 > 0)) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var hint = ((x1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) | 0);
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) && (hint >= this.scm_ArrayDeque__f_array.u.length))) {
      this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint)
    };
    var this$1 = elems.iterator__sc_Iterator();
    while (this$1.hasNext__Z()) {
      var arg1 = this$1.next__O();
      this.scm_ArrayDeque__f_array.set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end, arg1);
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))
    }
  } else {
    var this$2 = elems.iterator__sc_Iterator();
    while (this$2.hasNext__Z()) {
      var arg1$1 = this$2.next__O();
      this.addOne__O__scm_ArrayDeque(arg1$1)
    }
  };
  return this
});
$c_scm_ArrayDeque.prototype.removeHead__Z__O = (function(resizeInternalRepr) {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection")
  } else {
    var elem = this.scm_ArrayDeque__f_array.get(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start);
    this.scm_ArrayDeque__f_array.set(this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, null);
    this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    if (resizeInternalRepr) {
      var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      this.scala$collection$mutable$ArrayDeque$$resize__I__V((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0)))
    };
    return elem
  }
});
$c_scm_ArrayDeque.prototype.length__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))
});
$c_scm_ArrayDeque.prototype.isEmpty__Z = (function() {
  return (this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start === this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end)
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayDeque$()
});
$c_scm_ArrayDeque.prototype.copyToArray__O__I__I__I = (function(dest, destStart, len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var srcLen = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  var destLen = $m_sr_ScalaRunTime$().array_length__O__I(dest);
  var x = ((len < srcLen) ? len : srcLen);
  var y = ((destLen - destStart) | 0);
  var x$1 = ((x < y) ? x : y);
  var copied = ((x$1 > 0) ? x$1 : 0);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len)
  };
  return copied
});
$c_scm_ArrayDeque.prototype.scala$collection$mutable$ArrayDeque$$resize__I__V = (function(len) {
  if (((len >= this.scm_ArrayDeque__f_array.u.length) || ((this.scm_ArrayDeque__f_array.u.length > 16) && (((this.scm_ArrayDeque__f_array.u.length - len) | 0) > len)))) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    var dest = $m_scm_ArrayDeque$().alloc__I__AO(len);
    var array2 = $asArrayOf_O($f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, n), 1);
    $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, n)
  }
});
$c_scm_ArrayDeque.prototype.stringPrefix__T = (function() {
  return "ArrayDeque"
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_IterableFactory = (function() {
  return this.iterableFactory__sc_SeqFactory()
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayDeque(xs)
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayDeque(elem)
});
$c_scm_ArrayDeque.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O($uI(v1))
});
function $as_scm_ArrayDeque(obj) {
  return (((obj instanceof $c_scm_ArrayDeque) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.ArrayDeque"))
}
function $isArrayOf_scm_ArrayDeque(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayDeque)))
}
function $asArrayOf_scm_ArrayDeque(obj, depth) {
  return (($isArrayOf_scm_ArrayDeque(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.ArrayDeque;", depth))
}
var $d_scm_ArrayDeque = new $TypeData().initClass({
  scm_ArrayDeque: 0
}, false, "scala.collection.mutable.ArrayDeque", {
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_ArrayDeque.prototype.$classData = $d_scm_ArrayDeque;
function $ct_scm_BitSet__AJ__($thiz, elems) {
  $thiz.scm_BitSet__f_elems = elems;
  return $thiz
}
function $ct_scm_BitSet__I__($thiz, initSize) {
  var x = (((63 + initSize) | 0) >> 6);
  $ct_scm_BitSet__AJ__($thiz, new $ac_J(((x > 1) ? x : 1)));
  return $thiz
}
function $ct_scm_BitSet__($thiz) {
  $ct_scm_BitSet__I__($thiz, 0);
  return $thiz
}
/** @constructor */
function $c_scm_BitSet() {
  this.scm_BitSet__f_elems = null
}
$c_scm_BitSet.prototype = new $h_scm_AbstractSet();
$c_scm_BitSet.prototype.constructor = $c_scm_BitSet;
/** @constructor */
function $h_scm_BitSet() {
  /*<skip>*/
}
$h_scm_BitSet.prototype = $c_scm_BitSet.prototype;
$c_scm_BitSet.prototype.stringPrefix__T = (function() {
  return "BitSet"
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$max__s_math_Ordering__I = (function(ord) {
  return $uI($f_sc_SortedSetOps__max__s_math_Ordering__O(this, ord))
});
$c_scm_BitSet.prototype.scala$collection$BitSetOps$$super$concat__sc_IterableOnce__sc_BitSet = (function(that) {
  var b = $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_BitSet__(new $c_scm_BitSet()));
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return $as_sc_BitSet($as_sc_SetOps(b.scm_GrowableBuilder__f_elems))
});
$c_scm_BitSet.prototype.ordering__s_math_Ordering = (function() {
  return $m_s_math_Ordering$Int$()
});
$c_scm_BitSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_BitSetOps$$anon$1(this, 0)
});
$c_scm_BitSet.prototype.size__I = (function() {
  return $f_sc_BitSetOps__size__I(this)
});
$c_scm_BitSet.prototype.isEmpty__Z = (function() {
  return $f_sc_BitSetOps__isEmpty__Z(this)
});
$c_scm_BitSet.prototype.sortedIterableFactory__sc_SortedIterableFactory = (function() {
  return $m_scm_SortedSet$()
});
$c_scm_BitSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_SortedSet__equals__O__Z(this, that)
});
$c_scm_BitSet.prototype.nwords__I = (function() {
  return this.scm_BitSet__f_elems.u.length
});
$c_scm_BitSet.prototype.word__I__J = (function(idx) {
  return ((idx < this.nwords__I()) ? this.scm_BitSet__f_elems.get(idx) : $L0)
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__scm_BitSet = (function(elems) {
  return ((elems.u.length === 0) ? $ct_scm_BitSet__(new $c_scm_BitSet()) : $ct_scm_BitSet__AJ__(new $c_scm_BitSet(), elems))
});
$c_scm_BitSet.prototype.addOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ((!$f_sc_BitSetOps__contains__I__Z(this, elem))) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (this$1.RTLong__f_lo | lo);
    var hi$1 = (this$1.RTLong__f_hi | hi);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$1, hi$1))
  };
  return this
});
$c_scm_BitSet.prototype.subtractOne__I__scm_BitSet = (function(elem) {
  $m_s_Predef$().require__Z__V((elem >= 0));
  if ($f_sc_BitSetOps__contains__I__Z(this, elem)) {
    var idx = (elem >> 6);
    var this$1 = this.word__I__J(idx);
    var lo = (((32 & elem) === 0) ? (1 << elem) : 0);
    var hi = (((32 & elem) === 0) ? 0 : (1 << elem));
    var lo$1 = (~lo);
    var hi$1 = (~hi);
    var lo$2 = (this$1.RTLong__f_lo & lo$1);
    var hi$2 = (this$1.RTLong__f_hi & hi$1);
    this.updateWord__I__J__V(idx, new $c_RTLong(lo$2, hi$2))
  };
  return this
});
$c_scm_BitSet.prototype.updateWord__I__J__V = (function(idx, w) {
  this.ensureCapacity__I__V(idx);
  this.scm_BitSet__f_elems.set(idx, w)
});
$c_scm_BitSet.prototype.ensureCapacity__I__V = (function(idx) {
  $m_s_Predef$().require__Z__V((idx < 33554432));
  if ((idx >= this.nwords__I())) {
    var newlen = this.nwords__I();
    while ((idx >= newlen)) {
      var x = (newlen << 1);
      newlen = ((x < 33554432) ? x : 33554432)
    };
    var elems1 = new $ac_J(newlen);
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_BitSet__f_elems, 0, elems1, 0, this.nwords__I());
    this.scm_BitSet__f_elems = elems1
  }
});
$c_scm_BitSet.prototype.$bar$eq__sc_BitSet__scm_BitSet = (function(other) {
  this.ensureCapacity__I__V((((-1) + other.nwords__I()) | 0));
  var i = 0;
  var othernwords = other.nwords__I();
  while ((i < othernwords)) {
    var $$x2 = this.scm_BitSet__f_elems;
    var $$x1 = i;
    var this$1 = this.scm_BitSet__f_elems.get(i);
    var b = other.word__I__J(i);
    var lo = (this$1.RTLong__f_lo | b.RTLong__f_lo);
    var hi = (this$1.RTLong__f_hi | b.RTLong__f_hi);
    $$x2.set($$x1, new $c_RTLong(lo, hi));
    i = ((1 + i) | 0)
  };
  return this
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_BitSet = (function(xs) {
  if ($is_sc_BitSet(xs)) {
    var x2 = $as_sc_BitSet(xs);
    return this.$bar$eq__sc_BitSet__scm_BitSet(x2)
  } else if (false) {
    var x3 = $as_sci_Range(xs);
    if ((!x3.sci_Range__f_isEmpty)) {
      var start = x3.min__s_math_Ordering__I($m_s_math_Ordering$Int$());
      if ((start >= 0)) {
        var end = x3.max__s_math_Ordering__I($m_s_math_Ordering$Int$());
        var endIdx = (end >> 6);
        this.ensureCapacity__I__V(endIdx);
        if (((x3.sci_Range__f_step === 1) || (x3.sci_Range__f_step === (-1)))) {
          var startIdx = (start >> 6);
          var wordStart = (startIdx << 6);
          var n = ((start - wordStart) | 0);
          var lo = (((32 & n) === 0) ? ((-1) << n) : 0);
          var hi = (((32 & n) === 0) ? (((2147483647 >>> ((31 - n) | 0)) | 0) | ((-1) << n)) : ((-1) << n));
          if ((endIdx > startIdx)) {
            var ev$1 = this.scm_BitSet__f_elems;
            var this$1 = ev$1.get(startIdx);
            var lo$1 = (this$1.RTLong__f_lo | lo);
            var hi$1 = (this$1.RTLong__f_hi | hi);
            ev$1.set(startIdx, new $c_RTLong(lo$1, hi$1));
            var a = this.scm_BitSet__f_elems;
            var fromIndex = ((1 + startIdx) | 0);
            $m_ju_Arrays$().fill__AJ__I__I__J__V(a, fromIndex, endIdx, new $c_RTLong((-1), (-1)));
            var ev$2 = this.scm_BitSet__f_elems;
            var this$2 = ev$2.get(endIdx);
            var n$1 = ((63 - ((end - (endIdx << 6)) | 0)) | 0);
            var lo$2 = (((32 & n$1) === 0) ? ((((-1) >>> n$1) | 0) | ((-2) << ((31 - n$1) | 0))) : (((-1) >>> n$1) | 0));
            var hi$2 = (((32 & n$1) === 0) ? (((-1) >>> n$1) | 0) : 0);
            var lo$3 = (this$2.RTLong__f_lo | lo$2);
            var hi$3 = (this$2.RTLong__f_hi | hi$2);
            ev$2.set(endIdx, new $c_RTLong(lo$3, hi$3))
          } else {
            var ev$3 = this.scm_BitSet__f_elems;
            var this$3 = ev$3.get(endIdx);
            var n$2 = ((63 - ((end - wordStart) | 0)) | 0);
            var lo$4 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << ((31 - n$2) | 0))) : (((-1) >>> n$2) | 0));
            var hi$4 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
            var lo$5 = (lo & lo$4);
            var hi$5 = (hi & hi$4);
            var lo$6 = (this$3.RTLong__f_lo | lo$5);
            var hi$6 = (this$3.RTLong__f_hi | hi$5);
            ev$3.set(endIdx, new $c_RTLong(lo$6, hi$6))
          }
        } else {
          $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3)
        }
      } else {
        $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, x3)
      }
    };
    return this
  } else if ($is_sc_SortedSet(xs)) {
    var x4 = $as_sc_SortedSet(xs);
    if ((!x4.isEmpty__Z())) {
      var ord = x4.ordering__s_math_Ordering();
      if ((ord === $m_s_math_Ordering$Int$())) {
        this.ensureCapacity__I__V(($uI(x4.last__O()) >> 6))
      } else {
        var this$4 = $m_s_math_Ordering$Int$();
        if ((ord === this$4.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse)) {
          this.ensureCapacity__I__V(($uI(x4.head__O()) >> 6))
        }
      };
      var iter = x4.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        this.addOne__I__scm_BitSet($uI(iter.next__O()))
      }
    };
    return this
  } else {
    return $as_scm_BitSet($f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs))
  }
});
$c_scm_BitSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  if ($is_sc_BitSet(that)) {
    var x2 = $as_sc_BitSet(that);
    var thisnwords = this.nwords__I();
    var bsnwords = x2.nwords__I();
    var minWords = ((thisnwords < bsnwords) ? thisnwords : bsnwords);
    var i = bsnwords;
    while ((i < thisnwords)) {
      var this$2 = this.word__I__J(i);
      if ((!((this$2.RTLong__f_lo === 0) && (this$2.RTLong__f_hi === 0)))) {
        return false
      };
      i = ((1 + i) | 0)
    };
    var j = 0;
    while ((j < minWords)) {
      var this$3 = this.word__I__J(j);
      var b = x2.word__I__J(j);
      var lo = (~b.RTLong__f_lo);
      var hi = (~b.RTLong__f_hi);
      var lo$1 = (this$3.RTLong__f_lo & lo);
      var hi$1 = (this$3.RTLong__f_hi & hi);
      if ((!((lo$1 === 0) && (hi$1 === 0)))) {
        return false
      };
      j = ((1 + j) | 0)
    };
    return true
  } else {
    return $f_sc_IterableOnceOps__forall__F1__Z(this, that)
  }
});
$c_scm_BitSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_BitSetOps__concat__sc_IterableOnce__sc_BitSet(this, that)
});
$c_scm_BitSet.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_BitSetOps__max__s_math_Ordering__I(this, ord)
});
$c_scm_BitSet.prototype.contains__O__Z = (function(elem) {
  var elem$1 = $uI(elem);
  return $f_sc_BitSetOps__contains__I__Z(this, elem$1)
});
$c_scm_BitSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_BitSet(xs)
});
$c_scm_BitSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__I__scm_BitSet($uI(elem))
});
$c_scm_BitSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__I__scm_BitSet($uI(elem))
});
$c_scm_BitSet.prototype.fromBitMaskNoCopy__AJ__sc_BitSet = (function(elems) {
  return this.fromBitMaskNoCopy__AJ__scm_BitSet(elems)
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll)
});
$c_scm_BitSet.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var empty = $ct_scm_BitSet__(new $c_scm_BitSet());
  return empty.addAll__sc_IterableOnce__scm_BitSet(coll)
});
function $as_scm_BitSet(obj) {
  return (((obj instanceof $c_scm_BitSet) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.BitSet"))
}
function $isArrayOf_scm_BitSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_BitSet)))
}
function $asArrayOf_scm_BitSet(obj, depth) {
  return (($isArrayOf_scm_BitSet(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.BitSet;", depth))
}
var $d_scm_BitSet = new $TypeData().initClass({
  scm_BitSet: 0
}, false, "scala.collection.mutable.BitSet", {
  scm_BitSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SortedSet: 1,
  sc_SortedSet: 1,
  sc_SortedSetOps: 1,
  sc_SortedOps: 1,
  sc_SortedSetFactoryDefaults: 1,
  scm_SortedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedSortedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_BitSet: 1,
  sc_BitSetOps: 1,
  Ljava_io_Serializable: 1
});
$c_scm_BitSet.prototype.$classData = $d_scm_BitSet;
/** @constructor */
function $c_scm_Queue(initialSize) {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
  var array = $m_scm_ArrayDeque$().alloc__I__AO(initialSize);
  $ct_scm_ArrayDeque__AO__I__I__(this, array, 0, 0)
}
$c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$c_scm_Queue.prototype.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
  /*<skip>*/
}
$h_scm_Queue.prototype = $c_scm_Queue.prototype;
$c_scm_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_Queue$()
});
$c_scm_Queue.prototype.stringPrefix__T = (function() {
  return "Queue"
});
$c_scm_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Queue$()
});
function $as_scm_Queue(obj) {
  return (((obj instanceof $c_scm_Queue) || (obj === null)) ? obj : $throwClassCastException(obj, "scala.collection.mutable.Queue"))
}
function $isArrayOf_scm_Queue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Queue)))
}
function $asArrayOf_scm_Queue(obj, depth) {
  return (($isArrayOf_scm_Queue(obj, depth) || (obj === null)) ? obj : $throwArrayCastException(obj, "Lscala.collection.mutable.Queue;", depth))
}
var $d_scm_Queue = new $TypeData().initClass({
  scm_Queue: 0
}, false, "scala.collection.mutable.Queue", {
  scm_Queue: 1,
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  O: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
});
$c_scm_Queue.prototype.$classData = $d_scm_Queue;
/** @constructor */
function $c_Lcats_implicits$() {
  this.Lcats_implicits$__f_catsKernelStdOrderForInt = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForInt = null;
  this.Lcats_implicits$__f_catsStdShowForInt = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForByte = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForByte = null;
  this.Lcats_implicits$__f_catsStdShowForByte = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForChar = null;
  this.Lcats_implicits$__f_catsStdShowForChar = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForLong = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForLong = null;
  this.Lcats_implicits$__f_catsStdShowForLong = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForShort = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForShort = null;
  this.Lcats_implicits$__f_catsStdShowForShort = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForFloat = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForFloat = null;
  this.Lcats_implicits$__f_catsStdShowForFloat = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForDouble = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForDouble = null;
  this.Lcats_implicits$__f_catsStdShowForDouble = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBoolean = null;
  this.Lcats_implicits$__f_catsStdShowForBoolean = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForUnit = null;
  this.Lcats_implicits$__f_catsKernelStdAlgebraForUnit = null;
  this.Lcats_implicits$__f_catsStdShowForUnit = null;
  this.Lcats_implicits$__f_catsStdBitraverseForTuple2 = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBigInt = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForBigInt = null;
  this.Lcats_implicits$__f_catsStdShowForBigInt = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBigDecimal = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForBigDecimal = null;
  this.Lcats_implicits$__f_catsStdShowForBigDecimal = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForBitSet = null;
  this.Lcats_implicits$__f_catsKernelStdSemilatticeForBitSet = null;
  this.Lcats_implicits$__f_catsStdBitraverseForEither = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForEq = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForEquiv = null;
  this.Lcats_implicits$__f_catsStdBimonadForFunction0 = null;
  this.Lcats_implicits$__f_catsStdInstancesForFunction1 = null;
  this.Lcats_implicits$__f_catsStdMonoidKForFunction1 = null;
  this.Lcats_implicits$__f_catsContravariantForHash = null;
  this.Lcats_implicits$__f_catsInvariantMonoidalSemigroup = null;
  this.Lcats_implicits$__f_catsInvariantMonoidalCommutativeSemigroup = null;
  this.Lcats_implicits$__f_catsStdInstancesForLazyList = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForLazyList = null;
  this.Lcats_implicits$__f_catsStdInstancesForList = null;
  this.Lcats_implicits$__f_catsStdInstancesForOption = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrder = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrdering = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrder = null;
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrdering = null;
  this.Lcats_implicits$__f_catsStdInstancesForQueue = null;
  this.Lcats_implicits$__f_catsStdInstancesForSet = null;
  this.Lcats_implicits$__f_catsStdInstancesForSortedSet = null;
  this.Lcats_implicits$__f_catsStdInstancesForStream = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForString = null;
  this.Lcats_implicits$__f_catsKernelStdMonoidForString = null;
  this.Lcats_implicits$__f_catsStdShowForString = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForSymbol = null;
  this.Lcats_implicits$__f_catsStdShowForSymbol = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForUUID = null;
  this.Lcats_implicits$__f_catsStdShowForUUID = null;
  this.Lcats_implicits$__f_catsStdInstancesForVector = null;
  this.Lcats_implicits$__f_catsSddDeferForFunction0 = null;
  this.Lcats_implicits$__f_catsDataFunctorForPair = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForOption = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForList = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForVector = null;
  this.Lcats_implicits$__f_catsStdTraverseFilterForStream = null;
  this.Lcats_implicits$__f_catsStdComposeForMap = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForDuration = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForDuration = null;
  this.Lcats_implicits$__f_catsKernelStdOrderForFiniteDuration = null;
  this.Lcats_implicits$__f_catsKernelStdGroupForFiniteDuration = null;
  this.Lcats_implicits$__f_catsStdShowForDurationUnambiguous = null;
  this.Lcats_implicits$__f_catsStdShowForFiniteDurationUnambiguous = null;
  this.Lcats_implicits$__f_catsStdSemigroupalForSortedSet = null;
  $n_Lcats_implicits$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForInt = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_ByteInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForByte = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForChar = new $c_Lcats_kernel_instances_CharOrder();
  this.Lcats_implicits$__f_catsStdShowForChar = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForLong = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_ShortInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForShort = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_FloatInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForFloat = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_DoubleInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForDouble = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForBoolean = new $c_Lcats_kernel_instances_BooleanOrder();
  this.Lcats_implicits$__f_catsStdShowForBoolean = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_UnitInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForUnit = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdBitraverseForTuple2 = new $c_Lcats_instances_Tuple2Instances$$anon$1();
  $f_Lcats_kernel_instances_BigIntInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForBigInt = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_BigDecimalInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForBigDecimal = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  $f_Lcats_kernel_instances_BitSetInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdBitraverseForEither = new $c_Lcats_instances_EitherInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForEq = new $c_Lcats_instances_EqInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForEquiv = new $c_Lcats_instances_EquivInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdBimonadForFunction0 = new $c_Lcats_instances_Function0Instances$$anon$1();
  $f_Lcats_instances_Function1Instances__$init$__V(this);
  this.Lcats_implicits$__f_catsContravariantForHash = new $c_Lcats_instances_HashInstances$$anon$1();
  $f_Lcats_instances_InvariantMonoidalInstances__$init$__V(this);
  $f_Lcats_instances_LazyListInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForOption = new $c_Lcats_instances_OptionInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrder = new $c_Lcats_instances_OrderInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForOrdering = new $c_Lcats_instances_OrderingInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrder = new $c_Lcats_instances_PartialOrderInstances$$anon$1();
  this.Lcats_implicits$__f_catsContravariantMonoidalForPartialOrdering = new $c_Lcats_instances_PartialOrderingInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForQueue = new $c_Lcats_instances_QueueInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForSet = new $c_Lcats_instances_SetInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForSortedSet = new $c_Lcats_instances_SortedSetInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdInstancesForStream = new $c_Lcats_instances_StreamInstances$$anon$1();
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForString = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForSymbol = new $c_Lcats_kernel_instances_SymbolOrder();
  this.Lcats_implicits$__f_catsStdShowForSymbol = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsKernelStdOrderForUUID = new $c_Lcats_kernel_instances_UUIDInstances$$anon$1();
  this.Lcats_implicits$__f_catsStdShowForUUID = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  this.Lcats_implicits$__f_catsSddDeferForFunction0 = new $c_Lcats_instances_FunctionInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsDataFunctorForPair = new $c_Lcats_instances_Tuple2InstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForOption = new $c_Lcats_instances_OptionInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForList = new $c_Lcats_instances_ListInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForVector = new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdTraverseFilterForStream = new $c_Lcats_instances_StreamInstancesBinCompat0$$anon$1();
  this.Lcats_implicits$__f_catsStdComposeForMap = new $c_Lcats_instances_MapInstancesBinCompat0$$anon$1();
  $f_Lcats_kernel_instances_DurationInstances__$init$__V(this);
  $f_Lcats_kernel_instances_FiniteDurationInstances__$init$__V(this);
  this.Lcats_implicits$__f_catsStdShowForDurationUnambiguous = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdShowForFiniteDurationUnambiguous = ($m_Lcats_Show$(), new $c_Lcats_Show$$anon$4());
  this.Lcats_implicits$__f_catsStdSemigroupalForSortedSet = new $c_Lcats_instances_SortedSetInstancesBinCompat0$$anon$1()
}
$c_Lcats_implicits$.prototype = new $h_O();
$c_Lcats_implicits$.prototype.constructor = $c_Lcats_implicits$;
/** @constructor */
function $h_Lcats_implicits$() {
  /*<skip>*/
}
$h_Lcats_implicits$.prototype = $c_Lcats_implicits$.prototype;
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdOrderForLong = x$0
});
$c_Lcats_implicits$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_implicits$__f_catsKernelStdGroupForLong = x$0
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_implicits$__f_catsInvariantMonoidalSemigroup = x$0
});
$c_Lcats_implicits$.prototype.cats$instances$InvariantMonoidalInstances$_setter_$catsInvariantMonoidalCommutativeSemigroup_$eq__Lcats_InvariantMonoidal__V = (function(x$0) {
  this.Lcats_implicits$__f_catsInvariantMonoidalCommutativeSemigroup = x$0
});
var $d_Lcats_implicits$ = new $TypeData().initClass({
  Lcats_implicits$: 0
}, false, "cats.implicits$", {
  Lcats_implicits$: 1,
  O: 1,
  Lcats_syntax_AlternativeSyntax: 1,
  Lcats_syntax_NonEmptyAlternativeSyntax: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align$ToAlignOps: 1,
  Lcats_syntax_AlignSyntax: 1,
  Lcats_syntax_ApplicativeSyntax: 1,
  Lcats_syntax_ApplicativeErrorSyntax: 1,
  Lcats_syntax_TupleSemigroupalSyntax: 1,
  Lcats_syntax_ApplySyntax: 1,
  Lcats_arrow_Arrow$ToArrowOps: 1,
  Lcats_syntax_ArrowSyntax: 1,
  Lcats_arrow_ArrowChoice$ToArrowChoiceOps: 1,
  Lcats_syntax_ArrowChoiceSyntax: 1,
  Lcats_Bifunctor$ToBifunctorOps: 1,
  Lcats_syntax_BifunctorSyntax: 1,
  Lcats_Bifoldable$ToBifoldableOps: 1,
  Lcats_syntax_BifoldableSyntax: 1,
  Lcats_syntax_BitraverseSyntax1: 1,
  Lcats_syntax_BitraverseSyntax: 1,
  Lcats_syntax_SemigroupalSyntax: 1,
  Lcats_CoflatMap$ToCoflatMapOps: 1,
  Lcats_syntax_CoflatMapSyntax: 1,
  Lcats_Comonad$ToComonadOps: 1,
  Lcats_syntax_ComonadSyntax: 1,
  Lcats_arrow_Compose$ToComposeOps: 1,
  Lcats_syntax_ComposeSyntax: 1,
  Lcats_Contravariant$ToContravariantOps: 1,
  Lcats_syntax_ContravariantSyntax: 1,
  Lcats_Distributive$ToDistributiveOps: 1,
  Lcats_syntax_DistributiveSyntax: 1,
  Lcats_syntax_ContravariantMonoidalSyntax: 1,
  Lcats_syntax_ContravariantSemigroupalSyntax: 1,
  Lcats_syntax_EitherKSyntax: 1,
  Lcats_syntax_EitherSyntax: 1,
  Lcats_syntax_EqSyntax: 1,
  Lcats_FlatMap$ToFlatMapOps: 1,
  Lcats_syntax_FlatMapSyntax: 1,
  Lcats_Foldable$ToFoldableOps: 1,
  Lcats_UnorderedFoldable$ToUnorderedFoldableOps: 1,
  Lcats_syntax_FoldableSyntax: 1,
  Lcats_Functor$ToFunctorOps: 1,
  Lcats_syntax_FunctorSyntax: 1,
  Lcats_syntax_SemigroupSyntax: 1,
  Lcats_syntax_GroupSyntax: 1,
  Lcats_syntax_HashSyntax: 1,
  Lcats_Invariant$ToInvariantOps: 1,
  Lcats_syntax_InvariantSyntax: 1,
  Lcats_syntax_IorSyntax: 1,
  Lcats_syntax_ListSyntax: 1,
  Lcats_syntax_MonadErrorSyntax: 1,
  Lcats_syntax_MonadSyntax: 1,
  Lcats_syntax_MonoidSyntax: 1,
  Lcats_syntax_OptionSyntax: 1,
  Lcats_syntax_PartialOrderSyntax: 1,
  Lcats_syntax_OrderSyntax: 1,
  Lcats_syntax_TupleParallelSyntax: 1,
  Lcats_syntax_ParallelSyntax: 1,
  Lcats_arrow_Profunctor$ToProfunctorOps: 1,
  Lcats_syntax_ProfunctorSyntax: 1,
  Lcats_Reducible$ToReducibleOps: 1,
  Lcats_syntax_ReducibleSyntax: 1,
  Lcats_SemigroupK$ToSemigroupKOps: 1,
  Lcats_syntax_SemigroupKSyntax: 1,
  Lcats_Show$ToShowOps: 1,
  Lcats_syntax_ShowSyntax: 1,
  Lcats_arrow_Strong$ToStrongOps: 1,
  Lcats_syntax_StrongSyntax: 1,
  Lcats_Traverse$ToTraverseOps: 1,
  Lcats_syntax_TraverseSyntax: 1,
  Lcats_NonEmptyTraverse$ToNonEmptyTraverseOps: 1,
  Lcats_syntax_NonEmptyTraverseSyntax: 1,
  Lcats_syntax_ValidatedSyntax: 1,
  Lcats_syntax_VectorSyntax: 1,
  Lcats_syntax_WriterSyntax: 1,
  Lcats_syntax_ParallelFoldMapASyntax: 1,
  Lcats_syntax_ParallelTraverseFilterSyntax: 1,
  Lcats_syntax_ParallelReduceMapASyntax: 1,
  Lcats_syntax_AllSyntax: 1,
  Lcats_UnorderedTraverse$ToUnorderedTraverseOps: 1,
  Lcats_syntax_UnorderedTraverseSyntax: 1,
  Lcats_syntax_ApplicativeErrorExtension: 1,
  Lcats_syntax_TrySyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat0: 1,
  Lcats_syntax_FlatMapOptionSyntax: 1,
  Lcats_arrow_Choice$ToChoiceOps: 1,
  Lcats_syntax_ChoiceSyntax: 1,
  Lcats_syntax_NestedSyntax: 1,
  Lcats_syntax_BinestedSyntax: 1,
  Lcats_syntax_ParallelFlatSyntax: 1,
  Lcats_syntax_SetSyntax: 1,
  Lcats_syntax_ValidatedExtensionSyntax: 1,
  Lcats_syntax_RepresentableSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat1: 1,
  Lcats_syntax_ParallelTraverseSyntax: 1,
  Lcats_TraverseFilter$ToTraverseFilterOps: 1,
  Lcats_syntax_TraverseFilterSyntax: 1,
  Lcats_FunctorFilter$ToFunctorFilterOps: 1,
  Lcats_syntax_FunctorFilterSyntax: 1,
  Lcats_syntax_EitherSyntaxBinCompat0: 1,
  Lcats_syntax_ListSyntaxBinCompat0: 1,
  Lcats_syntax_ValidatedSyntaxBincompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat2: 1,
  Lcats_syntax_UnorderedFoldableSyntax: 1,
  Lcats_syntax_Function1Syntax: 1,
  Lcats_syntax_AllSyntaxBinCompat3: 1,
  Lcats_syntax_TraverseFilterSyntaxBinCompat0: 1,
  Lcats_syntax_ApplySyntaxBinCompat0: 1,
  Lcats_syntax_ParallelApplySyntax: 1,
  Lcats_syntax_FoldableSyntaxBinCompat0: 1,
  Lcats_syntax_ReducibleSyntaxBinCompat0: 1,
  Lcats_syntax_FoldableSyntaxBinCompat1: 1,
  Lcats_syntax_BitraverseSyntaxBinCompat0: 1,
  Lcats_syntax_AllSyntaxBinCompat4: 1,
  Lcats_syntax_ParallelBitraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat5: 1,
  Lcats_syntax_ParallelUnorderedTraverseSyntax: 1,
  Lcats_syntax_AllSyntaxBinCompat6: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1,
  Lcats_kernel_instances_ByteInstances: 1,
  Lcats_instances_ByteInstances: 1,
  Lcats_kernel_instances_CharInstances: 1,
  Lcats_instances_CharInstances: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1,
  Lcats_kernel_instances_ShortInstances: 1,
  Lcats_instances_ShortInstances: 1,
  Lcats_kernel_instances_FloatInstances: 1,
  Lcats_instances_FloatInstances: 1,
  Lcats_kernel_instances_DoubleInstances: 1,
  Lcats_instances_DoubleInstances: 1,
  Lcats_kernel_instances_BooleanInstances: 1,
  Lcats_instances_BooleanInstances: 1,
  Lcats_kernel_instances_UnitInstances: 1,
  Lcats_instances_UnitInstances: 1,
  Lcats_instances_Tuple2Instances4: 1,
  Lcats_instances_Tuple2Instances3: 1,
  Lcats_instances_Tuple2Instances2: 1,
  Lcats_instances_Tuple2Instances1: 1,
  Lcats_instances_Tuple2Instances: 1,
  Lcats_kernel_instances_TupleInstances3: 1,
  Lcats_kernel_instances_TupleInstances2: 1,
  Lcats_kernel_instances_TupleInstances1: 1,
  Lcats_kernel_instances_TupleInstances: 1,
  Lcats_instances_TupleInstances: 1,
  Lcats_instances_AnyValInstances: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances2: 1,
  Lcats_kernel_instances_ArraySeqInstances$ArraySeqInstances1: 1,
  Lcats_kernel_instances_ArraySeqInstances: 1,
  Lcats_instances_ArraySeqInstances: 1,
  Lcats_kernel_instances_BigIntInstances: 1,
  Lcats_instances_BigIntInstances: 1,
  Lcats_kernel_instances_BigDecimalInstances: 1,
  Lcats_instances_BigDecimalInstances: 1,
  Lcats_kernel_instances_BitSetInstances: 1,
  Lcats_instances_BitSetInstances: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_instances_EqInstances: 1,
  Lcats_instances_EqInstances: 1,
  Lcats_instances_EquivInstances: 1,
  Lcats_kernel_instances_FunctionInstances4: 1,
  Lcats_kernel_instances_FunctionInstances3: 1,
  Lcats_kernel_instances_FunctionInstances2: 1,
  Lcats_kernel_instances_FunctionInstances1: 1,
  Lcats_kernel_instances_FunctionInstances0: 1,
  Lcats_kernel_instances_FunctionInstances: 1,
  Lcats_instances_Function0Instances0: 1,
  Lcats_instances_Function0Instances: 1,
  Lcats_instances_Function1Instances0: 1,
  Lcats_instances_Function1Instances: 1,
  Lcats_instances_FunctionInstances: 1,
  Lcats_instances_FutureInstances2: 1,
  Lcats_instances_FutureInstances1: 1,
  Lcats_instances_FutureInstances: 1,
  Lcats_kernel_HashToHashingConversion: 1,
  Lcats_kernel_instances_HashInstances: 1,
  Lcats_instances_HashInstances: 1,
  Lcats_instances_InvariantMonoidalInstances: 1,
  Lcats_kernel_instances_LazyListInstances2: 1,
  Lcats_kernel_instances_LazyListInstances1: 1,
  Lcats_kernel_instances_LazyListInstances: 1,
  Lcats_instances_LazyListInstances: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_kernel_instances_MapInstances1: 1,
  Lcats_kernel_instances_MapInstances: 1,
  Lcats_instances_MapInstances: 1,
  Lcats_kernel_instances_OptionInstances2: 1,
  Lcats_kernel_instances_OptionInstances1: 1,
  Lcats_kernel_instances_OptionInstances0: 1,
  Lcats_kernel_instances_OptionInstances: 1,
  Lcats_instances_OptionInstances: 1,
  Lcats_kernel_OrderToOrderingConversion: 1,
  Lcats_kernel_instances_OrderInstances: 1,
  Lcats_instances_OrderInstances: 1,
  Lcats_instances_OrderingInstances: 1,
  Lcats_instances_ParallelInstances1: 1,
  Lcats_instances_ParallelInstances: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1,
  Lcats_kernel_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderInstances: 1,
  Lcats_instances_PartialOrderingInstances: 1,
  Lcats_kernel_instances_QueueInstances2: 1,
  Lcats_kernel_instances_QueueInstances1: 1,
  Lcats_kernel_instances_QueueInstances: 1,
  Lcats_instances_QueueInstances: 1,
  Lcats_kernel_instances_SetInstances1: 1,
  Lcats_kernel_instances_SetInstances: 1,
  Lcats_instances_SetInstances: 1,
  Lcats_instances_SortedMapInstances1: 1,
  Lcats_instances_SortedMapInstances2: 1,
  Lcats_instances_SortedMapInstances: 1,
  Lcats_instances_SortedSetInstances1: 1,
  Lcats_instances_SortedSetInstances: 1,
  Lcats_kernel_instances_StreamInstances2: 1,
  Lcats_kernel_instances_StreamInstances1: 1,
  Lcats_kernel_instances_StreamInstances: 1,
  Lcats_instances_StreamInstances: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1,
  Lcats_kernel_instances_SymbolInstances: 1,
  Lcats_instances_SymbolInstances: 1,
  Lcats_instances_TailRecInstances: 1,
  Lcats_instances_TryInstances2: 1,
  Lcats_instances_TryInstances1: 1,
  Lcats_instances_TryInstances: 1,
  Lcats_kernel_instances_UUIDInstances: 1,
  Lcats_instances_UUIDInstances: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_PartialFunctionInstances: 1,
  Lcats_instances_AllInstances: 1,
  Lcats_instances_FunctionInstancesBinCompat0: 1,
  Lcats_instances_Tuple2InstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat0: 1,
  Lcats_instances_OptionInstancesBinCompat0: 1,
  Lcats_instances_ListInstancesBinCompat0: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1,
  Lcats_instances_StreamInstancesBinCompat0: 1,
  Lcats_instances_MapInstancesBinCompat0: 1,
  Lcats_instances_SortedMapInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat1: 1,
  Lcats_kernel_instances_DurationInstances: 1,
  Lcats_instances_DurationInstances: 1,
  Lcats_kernel_instances_FiniteDurationInstances: 1,
  Lcats_instances_FiniteDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat2: 1,
  Lcats_instances_CoreDurationInstances: 1,
  Lcats_instances_CoreFiniteDurationInstances: 1,
  Lcats_instances_AllCoreDurationInstances: 1,
  Lcats_instances_AllInstancesBinCompat3: 1,
  Lcats_instances_SortedMapInstancesBinCompat1: 1,
  Lcats_instances_MapInstancesBinCompat1: 1,
  Lcats_instances_AllInstancesBinCompat4: 1,
  Lcats_instances_SortedSetInstancesBinCompat0: 1,
  Lcats_instances_AllInstancesBinCompat5: 1,
  Lcats_kernel_instances_SortedSetInstances1: 1,
  Lcats_kernel_instances_SortedSetInstances: 1,
  Lcats_instances_LowPrioritySortedSetInstancesBinCompat1: 1,
  Lcats_instances_SortedSetInstancesBinCompat1: 1,
  Lcats_kernel_instances_SortedMapInstances1: 1,
  Lcats_kernel_instances_SortedMapInstances2: 1,
  Lcats_kernel_instances_SortedMapInstances: 1,
  Lcats_instances_SortedMapInstancesBinCompat2: 1,
  Lcats_instances_AllInstancesBinCompat6: 1
});
$c_Lcats_implicits$.prototype.$classData = $d_Lcats_implicits$;
var $n_Lcats_implicits$;
function $m_Lcats_implicits$() {
  if ((!$n_Lcats_implicits$)) {
    $n_Lcats_implicits$ = new $c_Lcats_implicits$()
  };
  return $n_Lcats_implicits$
}
$L0 = new $c_RTLong(0, 0);
$d_J.zero = $L0;
var $t_Lnet_andimiller_Msg$__AddOneHundred = null;
var $t_Lnet_andimiller_Msg$__Clear = null;
var $t_Lnet_andimiller_Msg$__EnterInput = null;
var $t_Lnet_andimiller_Msg$__NoOp = null;
exports.TyrianApp = $m_Lnet_andimiller_ProbabilisticPlayground$();
//# sourceMappingURL=probabilisticplayground-fastopt.js.map
